// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"91UBy":[function(require,module,exports,__globalThis) {
require("9c2599f9f72ccdb0").register(require("625686d99efb46d3").getBundleURL('4qQCm'), JSON.parse("[\"4qQCm\",\"index.fd0f485b.js\",\"kGWQr\",\"katex.bf742df3.js\",\"2A1Ed\",\"c4Diagram-3d4e48cf.f95e8018.js\",\"7X6bZ\",\"flowDiagram-66a62f08.0fb69c2e.js\",\"03laf\",\"flowDiagram-66a62f08.17fadc14.js\",\"fwxBT\",\"flowDiagram-66a62f08.3a34afcd.js\",\"52haI\",\"flowDiagram-66a62f08.5151a16b.js\",\"16dux\",\"flowDiagram-66a62f08.f6c40e61.js\",\"dodf4\",\"flowDiagram-66a62f08.909fb815.js\",\"ue9p7\",\"flowDiagram-66a62f08.6ccc237d.js\",\"5JGKy\",\"flowDiagram-v2-96b9c2cf.8ea930a6.js\",\"6bhfu\",\"erDiagram-9861fffd.63bfd0e6.js\",\"cbmiS\",\"gitGraphDiagram-72cf32ee.47625a79.js\",\"dnuuZ\",\"ganttDiagram-c361ad54.08c51b9e.js\",\"k1Rxv\",\"infoDiagram-f8f76790.bb162470.js\",\"gxpVo\",\"pieDiagram-8a3498a8.4c5d5383.js\",\"cEKMF\",\"quadrantDiagram-120e2f19.f7514ab4.js\",\"9NcRT\",\"xychartDiagram-e933f94c.efa200e6.js\",\"kBILH\",\"requirementDiagram-deff3bca.31af5688.js\",\"bGoN2\",\"sequenceDiagram-704730f1.882dcebb.js\",\"fscn8\",\"classDiagram-70f12bd4.177b05cb.js\",\"gsHsw\",\"classDiagram-70f12bd4.cf041a2d.js\",\"HCiQQ\",\"classDiagram-v2-f2320105.24fe20b0.js\",\"hY17g\",\"stateDiagram-587899a1.7c6e42a2.js\",\"dmVc6\",\"stateDiagram-587899a1.f5026085.js\",\"dHrDz\",\"stateDiagram-v2-d93cdb3a.08ec36eb.js\",\"3qaDE\",\"journeyDiagram-49397b02.b7fa58da.js\",\"e5hsg\",\"flowchart-elk-definition-4a651766.c0afce78.js\",\"8qEpA\",\"timeline-definition-85554ec2.baf13e2a.js\",\"5RTCw\",\"mindmap-definition-fc14e90a.db2e9c5a.js\",\"kFBvY\",\"sankeyDiagram-04a897e0.dd663f78.js\",\"jJqae\",\"blockDiagram-38ab4fdb.93e481f2.js\",\"aB0MP\",\"index.bab6583f.css\"]"));

},{"9c2599f9f72ccdb0":"fyJL2","625686d99efb46d3":"c7Tr5"}],"fyJL2":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"c7Tr5":[function(require,module,exports,__globalThis) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"5pMYn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("react-dom/client");
var _appTsx = require("./App.tsx");
var _appTsxDefault = parcelHelpers.interopDefault(_appTsx);
var _indexCss = require("./index.css");
(0, _client.createRoot)(document.getElementById('root')).render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.StrictMode), {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appTsxDefault.default), {})
}));

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom/client":"5ccwt","./App.tsx":"dXcTy","./index.css":"fW8RG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaGEj":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"kbpKW"}],"kbpKW":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"6uln9"}],"6uln9":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"8n7Eb"}],"8n7Eb":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"5ccwt":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"b8T3j"}],"b8T3j":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"bO0Ia"}],"bO0Ia":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"6uln9","ece50e903283a22f":"jNZm8"}],"jNZm8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"izQ2Z"}],"izQ2Z":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"dXcTy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _lucideReact = require("lucide-react"); // Import engine icon
var _audioUploader = require("./components/AudioUploader");
var _audioUploaderDefault = parcelHelpers.interopDefault(_audioUploader);
var _mermaidDiagram = require("./components/MermaidDiagram");
var _mermaidDiagramDefault = parcelHelpers.interopDefault(_mermaidDiagram);
var _resizeHandle = require("./components/ResizeHandle");
var _resizeHandleDefault = parcelHelpers.interopDefault(_resizeHandle);
var _agenticFlow = require("./AgenticFlow");
var _textUploader = require("./components/TextUploader");
var _textUploaderDefault = parcelHelpers.interopDefault(_textUploader);
var _appContext = require("./AppContext");
var _progressModal = require("./components/ProgressModal");
var _textView = require("./components/TextView");
var _textViewDefault = parcelHelpers.interopDefault(_textView);
var _settingsPanel = require("./components/SettingsPanel");
var _settingsPanelDefault = parcelHelpers.interopDefault(_settingsPanel);
var _switchButton = require("./components/SwitchButton");
var _switchButtonDefault = parcelHelpers.interopDefault(_switchButton);
function App() {
    const [leftPanelWidth, setLeftPanelWidth] = (0, _react.useState)(50); // percentage
    const [input, setInput] = (0, _react.useState)("");
    const [isModalVisible, setIsModalVisible] = (0, _react.useState)(false);
    const [progressLabel, setProgressLabel] = (0, _react.useState)("Processing...");
    const [activeMenu, setActiveMenu] = (0, _react.useState)('Main'); // State for left menu navigation
    const [mindmap, setMindmap] = (0, _react.useState)(`graph TD`);
    const [summary, setSummary] = (0, _react.useState)('');
    const [openAIApiKey, setOpenAIApiKey] = (0, _react.useState)("");
    const [assemblyAIApiKey, setAssemblyAIApiKey] = (0, _react.useState)("");
    const handleResize = (0, _react.useCallback)((newWidth)=>{
        const constrainedWidth = Math.min(Math.max(newWidth, 20), 50); // Constrain the width
        setLeftPanelWidth(constrainedWidth);
    }, []);
    const handleProcessClick = async ()=>{
        try {
            setIsModalVisible(true);
            setProgressLabel("Processing request...");
            console.log("process");
            const graph = (0, _agenticFlow.buildGraph)({
                openAIApiKey,
                assemblyAIApiKey
            });
            const app = graph.compile();
            const res = await app.stream({
                input,
                progress: (label)=>setProgressLabel(label)
            }, {
                streamMode: 'values'
            });
            for await (const chunk of res){
                console.dir(chunk);
                if (chunk.summary) setSummary(chunk.summary);
                if (chunk.mindmap) setMindmap(chunk.mindmap);
            }
        } catch (error) {
            setProgressLabel("Error occurred. Please try again." + error);
        } finally{
            setTimeout(()=>setIsModalVisible(false), 1000); // Close modal after delay
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appContext.AppContext).Provider, {
        value: {
            input,
            setInput,
            openAIApiKey,
            setOpenAIApiKey,
            assemblyAIApiKey,
            setAssemblyAIApiKey
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "min-h-screen flex flex-col relative",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressModal.ProgressModal), {
                    visible: isModalVisible,
                    progress: progressLabel
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    id: "main-container",
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "w-16 bg-gray-800 text-white flex flex-col items-center py-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `mb-4 p-4 ${activeMenu === 'Main' ? 'bg-gray-600 rounded' : ''}`,
                                    onClick: ()=>setActiveMenu('Main'),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Home), {
                                        size: 24
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `mb-4 p-4 ${activeMenu === 'Settings' ? 'bg-gray-600 rounded' : ''}`,
                                    onClick: ()=>setActiveMenu('Settings'),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Settings), {
                                        size: 24
                                    })
                                })
                            ]
                        }),
                        activeMenu === 'Main' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            id: "main",
                            className: "flex-1 flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeftPanel, {
                                            leftPanelWidth: leftPanelWidth
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resizeHandleDefault.default), {
                                            onResize: handleResize
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(RightPanel, {
                                            leftPanelWidth: leftPanelWidth,
                                            mindmap: mindmap,
                                            summary: summary
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    id: "process",
                                    className: "flex justify-center items-center h-12 bg-gray-200",
                                    style: {
                                        marginTop: '-16px'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProcessButton, {
                                        handleProcessClick: handleProcessClick,
                                        input: input,
                                        openAIApiKey: openAIApiKey,
                                        assemblyAIApiKey: assemblyAIApiKey
                                    })
                                })
                            ]
                        }),
                        activeMenu === 'Settings' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            id: "settings",
                            className: "flex flex-1 items-center justify-center min-h-screen bg-gray-100",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsPanelDefault.default), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusBar, {})
            ]
        })
    });
}
function ProcessButton({ handleProcessClick, input, openAIApiKey, assemblyAIApiKey }) {
    // Check if all required values are provided
    const isEnabled = input && openAIApiKey && assemblyAIApiKey;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        className: `px-4 py-2 ${isEnabled ? 'bg-blue-600' : 'bg-gray-400'} text-white rounded`,
        onClick: handleProcessClick,
        disabled: !isEnabled,
        children: "Process"
    });
}
function LeftPanel({ leftPanelWidth }) {
    const [activeTabL, setActiveTabL] = (0, _react.useState)('Audio'); // State for tabs
    const [activeSwitches, setActiveSwitches] = (0, _react.useState)([
        true,
        false,
        false,
        false
    ]); // State for switch buttons
    const handleSwitchClick = (index, value)=>{
        setActiveSwitches((prev)=>{
            const updated = [
                ...prev
            ];
            updated[index] = value;
            return updated;
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex-shrink-0 bg-gray-100",
            style: {
                height: `calc(100vh - 4rem)`,
                width: `${leftPanelWidth}%`
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex justify-around items-center h-10 bg-gray-200 border-b px-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchButtonDefault.default), {
                            index: 0,
                            label: "Key Points",
                            active: activeSwitches[0],
                            onClick: handleSwitchClick,
                            disabled: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchButtonDefault.default), {
                            index: 1,
                            label: "Problem Solution",
                            active: activeSwitches[1],
                            onClick: handleSwitchClick,
                            disabled: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchButtonDefault.default), {
                            index: 2,
                            label: "Questions & Answers",
                            active: activeSwitches[2],
                            onClick: handleSwitchClick,
                            disabled: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switchButtonDefault.default), {
                            index: 3,
                            label: "Topics & Subtopic",
                            active: activeSwitches[3],
                            onClick: handleSwitchClick,
                            disabled: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex border-b",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `mx-6 my-1 h-10 w-1/2 ${activeTabL === 'Text' ? 'bg-blue-500 text-white rounded-t-xl' : 'bg-white'}`,
                            onClick: ()=>setActiveTabL('Text'),
                            children: "\uD83D\uDCAC Transcript"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `mx-6 my-1 h-10 w-1/2 ${activeTabL === 'Audio' ? 'bg-blue-500 text-white rounded-t-xl' : 'bg-white'}`,
                            onClick: ()=>setActiveTabL('Audio'),
                            children: "\uD83D\uDD0A Audio"
                        })
                    ]
                }),
                activeTabL === 'Text' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textUploaderDefault.default), {}),
                activeTabL === 'Audio' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _audioUploaderDefault.default), {})
            ]
        })
    });
}
function RightPanel({ leftPanelWidth, mindmap, summary }) {
    const [activeTabR, setActiveTabR] = (0, _react.useState)('Diagram'); // State for tabs
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex-1",
            style: {
                height: `calc(100vh - 4rem)`,
                width: `${100 - leftPanelWidth}%`
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex border-b",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `mx-6 my-1 h-10 w-1/2 ${activeTabR === 'Diagram' ? 'bg-blue-500 text-white rounded-t-xl' : 'bg-white'}`,
                            onClick: ()=>setActiveTabR('Diagram'),
                            children: "\uD83E\uDDE0 Mind Map \uD83D\uDDFA\uFE0F"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `mx-6 my-1 h-10 w-1/2 ${activeTabR === 'Summary' ? 'bg-blue-500 text-white rounded-t-xl' : 'bg-white'}`,
                            onClick: ()=>setActiveTabR('Summary'),
                            children: "\uD83D\uDCAC Summary"
                        })
                    ]
                }),
                activeTabR === 'Diagram' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mermaidDiagramDefault.default), {
                    diagram: mindmap
                }),
                activeTabR === 'Summary' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textViewDefault.default), {
                    text: summary
                })
            ]
        })
    });
}
function StatusBar() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "fixed bottom-0 w-full h-8 bg-gray-800 text-white flex justify-between items-center px-4 text-sm",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    "Version: ",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-yellow-400",
                        children: "0.2.2" ?? ''
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    "Powered by:",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "https://github.com/bsorrentino",
                        target: "new",
                        rel: "noopener noreferrer",
                        className: "text-blue-400 hover:underline",
                        children: "bsorrentino"
                    })
                ]
            })
        ]
    });
}
exports.default = App;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","lucide-react":"62Bzb","./components/AudioUploader":"dHWq4","./components/MermaidDiagram":"k8fhc","./components/ResizeHandle":"7VgM2","./AgenticFlow":"6QvPG","./components/TextUploader":"yJT1d","./AppContext":"fiPIn","./components/ProgressModal":"iHwsN","./components/TextView":"jOnKa","./components/SettingsPanel":"c6iN7","./components/SwitchButton":"dgic7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"62Bzb":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AArrowDown", ()=>(0, _aArrowDownJsDefault.default));
parcelHelpers.export(exports, "AArrowDownIcon", ()=>(0, _aArrowDownJsDefault.default));
parcelHelpers.export(exports, "LucideAArrowDown", ()=>(0, _aArrowDownJsDefault.default));
parcelHelpers.export(exports, "AArrowUp", ()=>(0, _aArrowUpJsDefault.default));
parcelHelpers.export(exports, "AArrowUpIcon", ()=>(0, _aArrowUpJsDefault.default));
parcelHelpers.export(exports, "LucideAArrowUp", ()=>(0, _aArrowUpJsDefault.default));
parcelHelpers.export(exports, "ALargeSmall", ()=>(0, _aLargeSmallJsDefault.default));
parcelHelpers.export(exports, "ALargeSmallIcon", ()=>(0, _aLargeSmallJsDefault.default));
parcelHelpers.export(exports, "LucideALargeSmall", ()=>(0, _aLargeSmallJsDefault.default));
parcelHelpers.export(exports, "Accessibility", ()=>(0, _accessibilityJsDefault.default));
parcelHelpers.export(exports, "AccessibilityIcon", ()=>(0, _accessibilityJsDefault.default));
parcelHelpers.export(exports, "LucideAccessibility", ()=>(0, _accessibilityJsDefault.default));
parcelHelpers.export(exports, "ActivitySquare", ()=>(0, _activitySquareJsDefault.default));
parcelHelpers.export(exports, "ActivitySquareIcon", ()=>(0, _activitySquareJsDefault.default));
parcelHelpers.export(exports, "LucideActivitySquare", ()=>(0, _activitySquareJsDefault.default));
parcelHelpers.export(exports, "Activity", ()=>(0, _activityJsDefault.default));
parcelHelpers.export(exports, "ActivityIcon", ()=>(0, _activityJsDefault.default));
parcelHelpers.export(exports, "LucideActivity", ()=>(0, _activityJsDefault.default));
parcelHelpers.export(exports, "AirVent", ()=>(0, _airVentJsDefault.default));
parcelHelpers.export(exports, "AirVentIcon", ()=>(0, _airVentJsDefault.default));
parcelHelpers.export(exports, "LucideAirVent", ()=>(0, _airVentJsDefault.default));
parcelHelpers.export(exports, "Airplay", ()=>(0, _airplayJsDefault.default));
parcelHelpers.export(exports, "AirplayIcon", ()=>(0, _airplayJsDefault.default));
parcelHelpers.export(exports, "LucideAirplay", ()=>(0, _airplayJsDefault.default));
parcelHelpers.export(exports, "AlarmClockOff", ()=>(0, _alarmClockOffJsDefault.default));
parcelHelpers.export(exports, "AlarmClockOffIcon", ()=>(0, _alarmClockOffJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmClockOff", ()=>(0, _alarmClockOffJsDefault.default));
parcelHelpers.export(exports, "AlarmClock", ()=>(0, _alarmClockJsDefault.default));
parcelHelpers.export(exports, "AlarmClockIcon", ()=>(0, _alarmClockJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmClock", ()=>(0, _alarmClockJsDefault.default));
parcelHelpers.export(exports, "AlarmSmoke", ()=>(0, _alarmSmokeJsDefault.default));
parcelHelpers.export(exports, "AlarmSmokeIcon", ()=>(0, _alarmSmokeJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmSmoke", ()=>(0, _alarmSmokeJsDefault.default));
parcelHelpers.export(exports, "Album", ()=>(0, _albumJsDefault.default));
parcelHelpers.export(exports, "AlbumIcon", ()=>(0, _albumJsDefault.default));
parcelHelpers.export(exports, "LucideAlbum", ()=>(0, _albumJsDefault.default));
parcelHelpers.export(exports, "AlertCircle", ()=>(0, _alertCircleJsDefault.default));
parcelHelpers.export(exports, "AlertCircleIcon", ()=>(0, _alertCircleJsDefault.default));
parcelHelpers.export(exports, "LucideAlertCircle", ()=>(0, _alertCircleJsDefault.default));
parcelHelpers.export(exports, "AlertOctagon", ()=>(0, _alertOctagonJsDefault.default));
parcelHelpers.export(exports, "AlertOctagonIcon", ()=>(0, _alertOctagonJsDefault.default));
parcelHelpers.export(exports, "LucideAlertOctagon", ()=>(0, _alertOctagonJsDefault.default));
parcelHelpers.export(exports, "AlertTriangle", ()=>(0, _alertTriangleJsDefault.default));
parcelHelpers.export(exports, "AlertTriangleIcon", ()=>(0, _alertTriangleJsDefault.default));
parcelHelpers.export(exports, "LucideAlertTriangle", ()=>(0, _alertTriangleJsDefault.default));
parcelHelpers.export(exports, "AlignCenterHorizontal", ()=>(0, _alignCenterHorizontalJsDefault.default));
parcelHelpers.export(exports, "AlignCenterHorizontalIcon", ()=>(0, _alignCenterHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideAlignCenterHorizontal", ()=>(0, _alignCenterHorizontalJsDefault.default));
parcelHelpers.export(exports, "AlignCenterVertical", ()=>(0, _alignCenterVerticalJsDefault.default));
parcelHelpers.export(exports, "AlignCenterVerticalIcon", ()=>(0, _alignCenterVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideAlignCenterVertical", ()=>(0, _alignCenterVerticalJsDefault.default));
parcelHelpers.export(exports, "AlignCenter", ()=>(0, _alignCenterJsDefault.default));
parcelHelpers.export(exports, "AlignCenterIcon", ()=>(0, _alignCenterJsDefault.default));
parcelHelpers.export(exports, "LucideAlignCenter", ()=>(0, _alignCenterJsDefault.default));
parcelHelpers.export(exports, "AlignEndHorizontal", ()=>(0, _alignEndHorizontalJsDefault.default));
parcelHelpers.export(exports, "AlignEndHorizontalIcon", ()=>(0, _alignEndHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideAlignEndHorizontal", ()=>(0, _alignEndHorizontalJsDefault.default));
parcelHelpers.export(exports, "AlignEndVertical", ()=>(0, _alignEndVerticalJsDefault.default));
parcelHelpers.export(exports, "AlignEndVerticalIcon", ()=>(0, _alignEndVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideAlignEndVertical", ()=>(0, _alignEndVerticalJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalDistributeCenter", ()=>(0, _alignHorizontalDistributeCenterJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalDistributeCenterIcon", ()=>(0, _alignHorizontalDistributeCenterJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalDistributeCenter", ()=>(0, _alignHorizontalDistributeCenterJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalDistributeEnd", ()=>(0, _alignHorizontalDistributeEndJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalDistributeEndIcon", ()=>(0, _alignHorizontalDistributeEndJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalDistributeEnd", ()=>(0, _alignHorizontalDistributeEndJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalDistributeStart", ()=>(0, _alignHorizontalDistributeStartJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalDistributeStartIcon", ()=>(0, _alignHorizontalDistributeStartJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalDistributeStart", ()=>(0, _alignHorizontalDistributeStartJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalJustifyCenter", ()=>(0, _alignHorizontalJustifyCenterJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalJustifyCenterIcon", ()=>(0, _alignHorizontalJustifyCenterJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalJustifyCenter", ()=>(0, _alignHorizontalJustifyCenterJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalJustifyEnd", ()=>(0, _alignHorizontalJustifyEndJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalJustifyEndIcon", ()=>(0, _alignHorizontalJustifyEndJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalJustifyEnd", ()=>(0, _alignHorizontalJustifyEndJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalJustifyStart", ()=>(0, _alignHorizontalJustifyStartJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalJustifyStartIcon", ()=>(0, _alignHorizontalJustifyStartJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalJustifyStart", ()=>(0, _alignHorizontalJustifyStartJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalSpaceAround", ()=>(0, _alignHorizontalSpaceAroundJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalSpaceAroundIcon", ()=>(0, _alignHorizontalSpaceAroundJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalSpaceAround", ()=>(0, _alignHorizontalSpaceAroundJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalSpaceBetween", ()=>(0, _alignHorizontalSpaceBetweenJsDefault.default));
parcelHelpers.export(exports, "AlignHorizontalSpaceBetweenIcon", ()=>(0, _alignHorizontalSpaceBetweenJsDefault.default));
parcelHelpers.export(exports, "LucideAlignHorizontalSpaceBetween", ()=>(0, _alignHorizontalSpaceBetweenJsDefault.default));
parcelHelpers.export(exports, "AlignJustify", ()=>(0, _alignJustifyJsDefault.default));
parcelHelpers.export(exports, "AlignJustifyIcon", ()=>(0, _alignJustifyJsDefault.default));
parcelHelpers.export(exports, "LucideAlignJustify", ()=>(0, _alignJustifyJsDefault.default));
parcelHelpers.export(exports, "AlignLeft", ()=>(0, _alignLeftJsDefault.default));
parcelHelpers.export(exports, "AlignLeftIcon", ()=>(0, _alignLeftJsDefault.default));
parcelHelpers.export(exports, "LucideAlignLeft", ()=>(0, _alignLeftJsDefault.default));
parcelHelpers.export(exports, "AlignRight", ()=>(0, _alignRightJsDefault.default));
parcelHelpers.export(exports, "AlignRightIcon", ()=>(0, _alignRightJsDefault.default));
parcelHelpers.export(exports, "LucideAlignRight", ()=>(0, _alignRightJsDefault.default));
parcelHelpers.export(exports, "AlignStartHorizontal", ()=>(0, _alignStartHorizontalJsDefault.default));
parcelHelpers.export(exports, "AlignStartHorizontalIcon", ()=>(0, _alignStartHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideAlignStartHorizontal", ()=>(0, _alignStartHorizontalJsDefault.default));
parcelHelpers.export(exports, "AlignStartVertical", ()=>(0, _alignStartVerticalJsDefault.default));
parcelHelpers.export(exports, "AlignStartVerticalIcon", ()=>(0, _alignStartVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideAlignStartVertical", ()=>(0, _alignStartVerticalJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalDistributeCenter", ()=>(0, _alignVerticalDistributeCenterJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalDistributeCenterIcon", ()=>(0, _alignVerticalDistributeCenterJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalDistributeCenter", ()=>(0, _alignVerticalDistributeCenterJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalDistributeEnd", ()=>(0, _alignVerticalDistributeEndJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalDistributeEndIcon", ()=>(0, _alignVerticalDistributeEndJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalDistributeEnd", ()=>(0, _alignVerticalDistributeEndJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalDistributeStart", ()=>(0, _alignVerticalDistributeStartJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalDistributeStartIcon", ()=>(0, _alignVerticalDistributeStartJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalDistributeStart", ()=>(0, _alignVerticalDistributeStartJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalJustifyCenter", ()=>(0, _alignVerticalJustifyCenterJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalJustifyCenterIcon", ()=>(0, _alignVerticalJustifyCenterJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalJustifyCenter", ()=>(0, _alignVerticalJustifyCenterJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalJustifyEnd", ()=>(0, _alignVerticalJustifyEndJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalJustifyEndIcon", ()=>(0, _alignVerticalJustifyEndJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalJustifyEnd", ()=>(0, _alignVerticalJustifyEndJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalJustifyStart", ()=>(0, _alignVerticalJustifyStartJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalJustifyStartIcon", ()=>(0, _alignVerticalJustifyStartJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalJustifyStart", ()=>(0, _alignVerticalJustifyStartJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalSpaceAround", ()=>(0, _alignVerticalSpaceAroundJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalSpaceAroundIcon", ()=>(0, _alignVerticalSpaceAroundJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalSpaceAround", ()=>(0, _alignVerticalSpaceAroundJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalSpaceBetween", ()=>(0, _alignVerticalSpaceBetweenJsDefault.default));
parcelHelpers.export(exports, "AlignVerticalSpaceBetweenIcon", ()=>(0, _alignVerticalSpaceBetweenJsDefault.default));
parcelHelpers.export(exports, "LucideAlignVerticalSpaceBetween", ()=>(0, _alignVerticalSpaceBetweenJsDefault.default));
parcelHelpers.export(exports, "Ambulance", ()=>(0, _ambulanceJsDefault.default));
parcelHelpers.export(exports, "AmbulanceIcon", ()=>(0, _ambulanceJsDefault.default));
parcelHelpers.export(exports, "LucideAmbulance", ()=>(0, _ambulanceJsDefault.default));
parcelHelpers.export(exports, "Ampersand", ()=>(0, _ampersandJsDefault.default));
parcelHelpers.export(exports, "AmpersandIcon", ()=>(0, _ampersandJsDefault.default));
parcelHelpers.export(exports, "LucideAmpersand", ()=>(0, _ampersandJsDefault.default));
parcelHelpers.export(exports, "Ampersands", ()=>(0, _ampersandsJsDefault.default));
parcelHelpers.export(exports, "AmpersandsIcon", ()=>(0, _ampersandsJsDefault.default));
parcelHelpers.export(exports, "LucideAmpersands", ()=>(0, _ampersandsJsDefault.default));
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchorJsDefault.default));
parcelHelpers.export(exports, "AnchorIcon", ()=>(0, _anchorJsDefault.default));
parcelHelpers.export(exports, "LucideAnchor", ()=>(0, _anchorJsDefault.default));
parcelHelpers.export(exports, "Angry", ()=>(0, _angryJsDefault.default));
parcelHelpers.export(exports, "AngryIcon", ()=>(0, _angryJsDefault.default));
parcelHelpers.export(exports, "LucideAngry", ()=>(0, _angryJsDefault.default));
parcelHelpers.export(exports, "Annoyed", ()=>(0, _annoyedJsDefault.default));
parcelHelpers.export(exports, "AnnoyedIcon", ()=>(0, _annoyedJsDefault.default));
parcelHelpers.export(exports, "LucideAnnoyed", ()=>(0, _annoyedJsDefault.default));
parcelHelpers.export(exports, "Antenna", ()=>(0, _antennaJsDefault.default));
parcelHelpers.export(exports, "AntennaIcon", ()=>(0, _antennaJsDefault.default));
parcelHelpers.export(exports, "LucideAntenna", ()=>(0, _antennaJsDefault.default));
parcelHelpers.export(exports, "Anvil", ()=>(0, _anvilJsDefault.default));
parcelHelpers.export(exports, "AnvilIcon", ()=>(0, _anvilJsDefault.default));
parcelHelpers.export(exports, "LucideAnvil", ()=>(0, _anvilJsDefault.default));
parcelHelpers.export(exports, "Aperture", ()=>(0, _apertureJsDefault.default));
parcelHelpers.export(exports, "ApertureIcon", ()=>(0, _apertureJsDefault.default));
parcelHelpers.export(exports, "LucideAperture", ()=>(0, _apertureJsDefault.default));
parcelHelpers.export(exports, "AppWindow", ()=>(0, _appWindowJsDefault.default));
parcelHelpers.export(exports, "AppWindowIcon", ()=>(0, _appWindowJsDefault.default));
parcelHelpers.export(exports, "LucideAppWindow", ()=>(0, _appWindowJsDefault.default));
parcelHelpers.export(exports, "Apple", ()=>(0, _appleJsDefault.default));
parcelHelpers.export(exports, "AppleIcon", ()=>(0, _appleJsDefault.default));
parcelHelpers.export(exports, "LucideApple", ()=>(0, _appleJsDefault.default));
parcelHelpers.export(exports, "ArchiveRestore", ()=>(0, _archiveRestoreJsDefault.default));
parcelHelpers.export(exports, "ArchiveRestoreIcon", ()=>(0, _archiveRestoreJsDefault.default));
parcelHelpers.export(exports, "LucideArchiveRestore", ()=>(0, _archiveRestoreJsDefault.default));
parcelHelpers.export(exports, "ArchiveX", ()=>(0, _archiveXJsDefault.default));
parcelHelpers.export(exports, "ArchiveXIcon", ()=>(0, _archiveXJsDefault.default));
parcelHelpers.export(exports, "LucideArchiveX", ()=>(0, _archiveXJsDefault.default));
parcelHelpers.export(exports, "Archive", ()=>(0, _archiveJsDefault.default));
parcelHelpers.export(exports, "ArchiveIcon", ()=>(0, _archiveJsDefault.default));
parcelHelpers.export(exports, "LucideArchive", ()=>(0, _archiveJsDefault.default));
parcelHelpers.export(exports, "AreaChart", ()=>(0, _areaChartJsDefault.default));
parcelHelpers.export(exports, "AreaChartIcon", ()=>(0, _areaChartJsDefault.default));
parcelHelpers.export(exports, "LucideAreaChart", ()=>(0, _areaChartJsDefault.default));
parcelHelpers.export(exports, "Armchair", ()=>(0, _armchairJsDefault.default));
parcelHelpers.export(exports, "ArmchairIcon", ()=>(0, _armchairJsDefault.default));
parcelHelpers.export(exports, "LucideArmchair", ()=>(0, _armchairJsDefault.default));
parcelHelpers.export(exports, "ArrowBigDownDash", ()=>(0, _arrowBigDownDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigDownDashIcon", ()=>(0, _arrowBigDownDashJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigDownDash", ()=>(0, _arrowBigDownDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigDown", ()=>(0, _arrowBigDownJsDefault.default));
parcelHelpers.export(exports, "ArrowBigDownIcon", ()=>(0, _arrowBigDownJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigDown", ()=>(0, _arrowBigDownJsDefault.default));
parcelHelpers.export(exports, "ArrowBigLeftDash", ()=>(0, _arrowBigLeftDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigLeftDashIcon", ()=>(0, _arrowBigLeftDashJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigLeftDash", ()=>(0, _arrowBigLeftDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigLeft", ()=>(0, _arrowBigLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowBigLeftIcon", ()=>(0, _arrowBigLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigLeft", ()=>(0, _arrowBigLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowBigRightDash", ()=>(0, _arrowBigRightDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigRightDashIcon", ()=>(0, _arrowBigRightDashJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigRightDash", ()=>(0, _arrowBigRightDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigRight", ()=>(0, _arrowBigRightJsDefault.default));
parcelHelpers.export(exports, "ArrowBigRightIcon", ()=>(0, _arrowBigRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigRight", ()=>(0, _arrowBigRightJsDefault.default));
parcelHelpers.export(exports, "ArrowBigUpDash", ()=>(0, _arrowBigUpDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigUpDashIcon", ()=>(0, _arrowBigUpDashJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigUpDash", ()=>(0, _arrowBigUpDashJsDefault.default));
parcelHelpers.export(exports, "ArrowBigUp", ()=>(0, _arrowBigUpJsDefault.default));
parcelHelpers.export(exports, "ArrowBigUpIcon", ()=>(0, _arrowBigUpJsDefault.default));
parcelHelpers.export(exports, "LucideArrowBigUp", ()=>(0, _arrowBigUpJsDefault.default));
parcelHelpers.export(exports, "ArrowDownCircle", ()=>(0, _arrowDownCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowDownCircleIcon", ()=>(0, _arrowDownCircleJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownCircle", ()=>(0, _arrowDownCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowDownFromLine", ()=>(0, _arrowDownFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowDownFromLineIcon", ()=>(0, _arrowDownFromLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownFromLine", ()=>(0, _arrowDownFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftFromCircle", ()=>(0, _arrowDownLeftFromCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftFromCircleIcon", ()=>(0, _arrowDownLeftFromCircleJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownLeftFromCircle", ()=>(0, _arrowDownLeftFromCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftFromSquare", ()=>(0, _arrowDownLeftFromSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftFromSquareIcon", ()=>(0, _arrowDownLeftFromSquareJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownLeftFromSquare", ()=>(0, _arrowDownLeftFromSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftSquare", ()=>(0, _arrowDownLeftSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftSquareIcon", ()=>(0, _arrowDownLeftSquareJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownLeftSquare", ()=>(0, _arrowDownLeftSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeft", ()=>(0, _arrowDownLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftIcon", ()=>(0, _arrowDownLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownLeft", ()=>(0, _arrowDownLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowDownNarrowWide", ()=>(0, _arrowDownNarrowWideJsDefault.default));
parcelHelpers.export(exports, "ArrowDownNarrowWideIcon", ()=>(0, _arrowDownNarrowWideJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownNarrowWide", ()=>(0, _arrowDownNarrowWideJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightFromCircle", ()=>(0, _arrowDownRightFromCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightFromCircleIcon", ()=>(0, _arrowDownRightFromCircleJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownRightFromCircle", ()=>(0, _arrowDownRightFromCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightFromSquare", ()=>(0, _arrowDownRightFromSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightFromSquareIcon", ()=>(0, _arrowDownRightFromSquareJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownRightFromSquare", ()=>(0, _arrowDownRightFromSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightSquare", ()=>(0, _arrowDownRightSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightSquareIcon", ()=>(0, _arrowDownRightSquareJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownRightSquare", ()=>(0, _arrowDownRightSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRight", ()=>(0, _arrowDownRightJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightIcon", ()=>(0, _arrowDownRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownRight", ()=>(0, _arrowDownRightJsDefault.default));
parcelHelpers.export(exports, "ArrowDownSquare", ()=>(0, _arrowDownSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowDownSquareIcon", ()=>(0, _arrowDownSquareJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownSquare", ()=>(0, _arrowDownSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowDownToDot", ()=>(0, _arrowDownToDotJsDefault.default));
parcelHelpers.export(exports, "ArrowDownToDotIcon", ()=>(0, _arrowDownToDotJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownToDot", ()=>(0, _arrowDownToDotJsDefault.default));
parcelHelpers.export(exports, "ArrowDownToLine", ()=>(0, _arrowDownToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowDownToLineIcon", ()=>(0, _arrowDownToLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownToLine", ()=>(0, _arrowDownToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowDownUp", ()=>(0, _arrowDownUpJsDefault.default));
parcelHelpers.export(exports, "ArrowDownUpIcon", ()=>(0, _arrowDownUpJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownUp", ()=>(0, _arrowDownUpJsDefault.default));
parcelHelpers.export(exports, "ArrowDown", ()=>(0, _arrowDownJsDefault.default));
parcelHelpers.export(exports, "ArrowDownIcon", ()=>(0, _arrowDownJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDown", ()=>(0, _arrowDownJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftCircle", ()=>(0, _arrowLeftCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftCircleIcon", ()=>(0, _arrowLeftCircleJsDefault.default));
parcelHelpers.export(exports, "LucideArrowLeftCircle", ()=>(0, _arrowLeftCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftFromLine", ()=>(0, _arrowLeftFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftFromLineIcon", ()=>(0, _arrowLeftFromLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowLeftFromLine", ()=>(0, _arrowLeftFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftRight", ()=>(0, _arrowLeftRightJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftRightIcon", ()=>(0, _arrowLeftRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowLeftRight", ()=>(0, _arrowLeftRightJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftSquare", ()=>(0, _arrowLeftSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftSquareIcon", ()=>(0, _arrowLeftSquareJsDefault.default));
parcelHelpers.export(exports, "LucideArrowLeftSquare", ()=>(0, _arrowLeftSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftToLine", ()=>(0, _arrowLeftToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftToLineIcon", ()=>(0, _arrowLeftToLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowLeftToLine", ()=>(0, _arrowLeftToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowLeft", ()=>(0, _arrowLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftIcon", ()=>(0, _arrowLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowLeft", ()=>(0, _arrowLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowRightCircle", ()=>(0, _arrowRightCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowRightCircleIcon", ()=>(0, _arrowRightCircleJsDefault.default));
parcelHelpers.export(exports, "LucideArrowRightCircle", ()=>(0, _arrowRightCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowRightFromLine", ()=>(0, _arrowRightFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowRightFromLineIcon", ()=>(0, _arrowRightFromLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowRightFromLine", ()=>(0, _arrowRightFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowRightLeft", ()=>(0, _arrowRightLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowRightLeftIcon", ()=>(0, _arrowRightLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowRightLeft", ()=>(0, _arrowRightLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowRightSquare", ()=>(0, _arrowRightSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowRightSquareIcon", ()=>(0, _arrowRightSquareJsDefault.default));
parcelHelpers.export(exports, "LucideArrowRightSquare", ()=>(0, _arrowRightSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowRightToLine", ()=>(0, _arrowRightToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowRightToLineIcon", ()=>(0, _arrowRightToLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowRightToLine", ()=>(0, _arrowRightToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowRight", ()=>(0, _arrowRightJsDefault.default));
parcelHelpers.export(exports, "ArrowRightIcon", ()=>(0, _arrowRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowRight", ()=>(0, _arrowRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpCircle", ()=>(0, _arrowUpCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowUpCircleIcon", ()=>(0, _arrowUpCircleJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpCircle", ()=>(0, _arrowUpCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowUpDown", ()=>(0, _arrowUpDownJsDefault.default));
parcelHelpers.export(exports, "ArrowUpDownIcon", ()=>(0, _arrowUpDownJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpDown", ()=>(0, _arrowUpDownJsDefault.default));
parcelHelpers.export(exports, "ArrowUpFromDot", ()=>(0, _arrowUpFromDotJsDefault.default));
parcelHelpers.export(exports, "ArrowUpFromDotIcon", ()=>(0, _arrowUpFromDotJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpFromDot", ()=>(0, _arrowUpFromDotJsDefault.default));
parcelHelpers.export(exports, "ArrowUpFromLine", ()=>(0, _arrowUpFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowUpFromLineIcon", ()=>(0, _arrowUpFromLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpFromLine", ()=>(0, _arrowUpFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftFromCircle", ()=>(0, _arrowUpLeftFromCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftFromCircleIcon", ()=>(0, _arrowUpLeftFromCircleJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpLeftFromCircle", ()=>(0, _arrowUpLeftFromCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftFromSquare", ()=>(0, _arrowUpLeftFromSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftFromSquareIcon", ()=>(0, _arrowUpLeftFromSquareJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpLeftFromSquare", ()=>(0, _arrowUpLeftFromSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftSquare", ()=>(0, _arrowUpLeftSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftSquareIcon", ()=>(0, _arrowUpLeftSquareJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpLeftSquare", ()=>(0, _arrowUpLeftSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeft", ()=>(0, _arrowUpLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftIcon", ()=>(0, _arrowUpLeftJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpLeft", ()=>(0, _arrowUpLeftJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightFromCircle", ()=>(0, _arrowUpRightFromCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightFromCircleIcon", ()=>(0, _arrowUpRightFromCircleJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpRightFromCircle", ()=>(0, _arrowUpRightFromCircleJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightFromSquare", ()=>(0, _arrowUpRightFromSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightFromSquareIcon", ()=>(0, _arrowUpRightFromSquareJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpRightFromSquare", ()=>(0, _arrowUpRightFromSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightSquare", ()=>(0, _arrowUpRightSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightSquareIcon", ()=>(0, _arrowUpRightSquareJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpRightSquare", ()=>(0, _arrowUpRightSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRight", ()=>(0, _arrowUpRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightIcon", ()=>(0, _arrowUpRightJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpRight", ()=>(0, _arrowUpRightJsDefault.default));
parcelHelpers.export(exports, "ArrowUpSquare", ()=>(0, _arrowUpSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowUpSquareIcon", ()=>(0, _arrowUpSquareJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpSquare", ()=>(0, _arrowUpSquareJsDefault.default));
parcelHelpers.export(exports, "ArrowUpToLine", ()=>(0, _arrowUpToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowUpToLineIcon", ()=>(0, _arrowUpToLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpToLine", ()=>(0, _arrowUpToLineJsDefault.default));
parcelHelpers.export(exports, "ArrowUpWideNarrow", ()=>(0, _arrowUpWideNarrowJsDefault.default));
parcelHelpers.export(exports, "ArrowUpWideNarrowIcon", ()=>(0, _arrowUpWideNarrowJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpWideNarrow", ()=>(0, _arrowUpWideNarrowJsDefault.default));
parcelHelpers.export(exports, "ArrowUp", ()=>(0, _arrowUpJsDefault.default));
parcelHelpers.export(exports, "ArrowUpIcon", ()=>(0, _arrowUpJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUp", ()=>(0, _arrowUpJsDefault.default));
parcelHelpers.export(exports, "ArrowsUpFromLine", ()=>(0, _arrowsUpFromLineJsDefault.default));
parcelHelpers.export(exports, "ArrowsUpFromLineIcon", ()=>(0, _arrowsUpFromLineJsDefault.default));
parcelHelpers.export(exports, "LucideArrowsUpFromLine", ()=>(0, _arrowsUpFromLineJsDefault.default));
parcelHelpers.export(exports, "Asterisk", ()=>(0, _asteriskJsDefault.default));
parcelHelpers.export(exports, "AsteriskIcon", ()=>(0, _asteriskJsDefault.default));
parcelHelpers.export(exports, "LucideAsterisk", ()=>(0, _asteriskJsDefault.default));
parcelHelpers.export(exports, "AtSign", ()=>(0, _atSignJsDefault.default));
parcelHelpers.export(exports, "AtSignIcon", ()=>(0, _atSignJsDefault.default));
parcelHelpers.export(exports, "LucideAtSign", ()=>(0, _atSignJsDefault.default));
parcelHelpers.export(exports, "Atom", ()=>(0, _atomJsDefault.default));
parcelHelpers.export(exports, "AtomIcon", ()=>(0, _atomJsDefault.default));
parcelHelpers.export(exports, "LucideAtom", ()=>(0, _atomJsDefault.default));
parcelHelpers.export(exports, "AudioLines", ()=>(0, _audioLinesJsDefault.default));
parcelHelpers.export(exports, "AudioLinesIcon", ()=>(0, _audioLinesJsDefault.default));
parcelHelpers.export(exports, "LucideAudioLines", ()=>(0, _audioLinesJsDefault.default));
parcelHelpers.export(exports, "AudioWaveform", ()=>(0, _audioWaveformJsDefault.default));
parcelHelpers.export(exports, "AudioWaveformIcon", ()=>(0, _audioWaveformJsDefault.default));
parcelHelpers.export(exports, "LucideAudioWaveform", ()=>(0, _audioWaveformJsDefault.default));
parcelHelpers.export(exports, "Award", ()=>(0, _awardJsDefault.default));
parcelHelpers.export(exports, "AwardIcon", ()=>(0, _awardJsDefault.default));
parcelHelpers.export(exports, "LucideAward", ()=>(0, _awardJsDefault.default));
parcelHelpers.export(exports, "Axe", ()=>(0, _axeJsDefault.default));
parcelHelpers.export(exports, "AxeIcon", ()=>(0, _axeJsDefault.default));
parcelHelpers.export(exports, "LucideAxe", ()=>(0, _axeJsDefault.default));
parcelHelpers.export(exports, "Baby", ()=>(0, _babyJsDefault.default));
parcelHelpers.export(exports, "BabyIcon", ()=>(0, _babyJsDefault.default));
parcelHelpers.export(exports, "LucideBaby", ()=>(0, _babyJsDefault.default));
parcelHelpers.export(exports, "Backpack", ()=>(0, _backpackJsDefault.default));
parcelHelpers.export(exports, "BackpackIcon", ()=>(0, _backpackJsDefault.default));
parcelHelpers.export(exports, "LucideBackpack", ()=>(0, _backpackJsDefault.default));
parcelHelpers.export(exports, "BadgeAlert", ()=>(0, _badgeAlertJsDefault.default));
parcelHelpers.export(exports, "BadgeAlertIcon", ()=>(0, _badgeAlertJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeAlert", ()=>(0, _badgeAlertJsDefault.default));
parcelHelpers.export(exports, "BadgeCent", ()=>(0, _badgeCentJsDefault.default));
parcelHelpers.export(exports, "BadgeCentIcon", ()=>(0, _badgeCentJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeCent", ()=>(0, _badgeCentJsDefault.default));
parcelHelpers.export(exports, "BadgeDollarSign", ()=>(0, _badgeDollarSignJsDefault.default));
parcelHelpers.export(exports, "BadgeDollarSignIcon", ()=>(0, _badgeDollarSignJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeDollarSign", ()=>(0, _badgeDollarSignJsDefault.default));
parcelHelpers.export(exports, "BadgeEuro", ()=>(0, _badgeEuroJsDefault.default));
parcelHelpers.export(exports, "BadgeEuroIcon", ()=>(0, _badgeEuroJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeEuro", ()=>(0, _badgeEuroJsDefault.default));
parcelHelpers.export(exports, "BadgeHelp", ()=>(0, _badgeHelpJsDefault.default));
parcelHelpers.export(exports, "BadgeHelpIcon", ()=>(0, _badgeHelpJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeHelp", ()=>(0, _badgeHelpJsDefault.default));
parcelHelpers.export(exports, "BadgeIndianRupee", ()=>(0, _badgeIndianRupeeJsDefault.default));
parcelHelpers.export(exports, "BadgeIndianRupeeIcon", ()=>(0, _badgeIndianRupeeJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeIndianRupee", ()=>(0, _badgeIndianRupeeJsDefault.default));
parcelHelpers.export(exports, "BadgeInfo", ()=>(0, _badgeInfoJsDefault.default));
parcelHelpers.export(exports, "BadgeInfoIcon", ()=>(0, _badgeInfoJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeInfo", ()=>(0, _badgeInfoJsDefault.default));
parcelHelpers.export(exports, "BadgeJapaneseYen", ()=>(0, _badgeJapaneseYenJsDefault.default));
parcelHelpers.export(exports, "BadgeJapaneseYenIcon", ()=>(0, _badgeJapaneseYenJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeJapaneseYen", ()=>(0, _badgeJapaneseYenJsDefault.default));
parcelHelpers.export(exports, "BadgeMinus", ()=>(0, _badgeMinusJsDefault.default));
parcelHelpers.export(exports, "BadgeMinusIcon", ()=>(0, _badgeMinusJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeMinus", ()=>(0, _badgeMinusJsDefault.default));
parcelHelpers.export(exports, "BadgePercent", ()=>(0, _badgePercentJsDefault.default));
parcelHelpers.export(exports, "BadgePercentIcon", ()=>(0, _badgePercentJsDefault.default));
parcelHelpers.export(exports, "LucideBadgePercent", ()=>(0, _badgePercentJsDefault.default));
parcelHelpers.export(exports, "BadgePlus", ()=>(0, _badgePlusJsDefault.default));
parcelHelpers.export(exports, "BadgePlusIcon", ()=>(0, _badgePlusJsDefault.default));
parcelHelpers.export(exports, "LucideBadgePlus", ()=>(0, _badgePlusJsDefault.default));
parcelHelpers.export(exports, "BadgePoundSterling", ()=>(0, _badgePoundSterlingJsDefault.default));
parcelHelpers.export(exports, "BadgePoundSterlingIcon", ()=>(0, _badgePoundSterlingJsDefault.default));
parcelHelpers.export(exports, "LucideBadgePoundSterling", ()=>(0, _badgePoundSterlingJsDefault.default));
parcelHelpers.export(exports, "BadgeRussianRuble", ()=>(0, _badgeRussianRubleJsDefault.default));
parcelHelpers.export(exports, "BadgeRussianRubleIcon", ()=>(0, _badgeRussianRubleJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeRussianRuble", ()=>(0, _badgeRussianRubleJsDefault.default));
parcelHelpers.export(exports, "BadgeSwissFranc", ()=>(0, _badgeSwissFrancJsDefault.default));
parcelHelpers.export(exports, "BadgeSwissFrancIcon", ()=>(0, _badgeSwissFrancJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeSwissFranc", ()=>(0, _badgeSwissFrancJsDefault.default));
parcelHelpers.export(exports, "BadgeX", ()=>(0, _badgeXJsDefault.default));
parcelHelpers.export(exports, "BadgeXIcon", ()=>(0, _badgeXJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeX", ()=>(0, _badgeXJsDefault.default));
parcelHelpers.export(exports, "Badge", ()=>(0, _badgeJsDefault.default));
parcelHelpers.export(exports, "BadgeIcon", ()=>(0, _badgeJsDefault.default));
parcelHelpers.export(exports, "LucideBadge", ()=>(0, _badgeJsDefault.default));
parcelHelpers.export(exports, "BaggageClaim", ()=>(0, _baggageClaimJsDefault.default));
parcelHelpers.export(exports, "BaggageClaimIcon", ()=>(0, _baggageClaimJsDefault.default));
parcelHelpers.export(exports, "LucideBaggageClaim", ()=>(0, _baggageClaimJsDefault.default));
parcelHelpers.export(exports, "Ban", ()=>(0, _banJsDefault.default));
parcelHelpers.export(exports, "BanIcon", ()=>(0, _banJsDefault.default));
parcelHelpers.export(exports, "LucideBan", ()=>(0, _banJsDefault.default));
parcelHelpers.export(exports, "Banana", ()=>(0, _bananaJsDefault.default));
parcelHelpers.export(exports, "BananaIcon", ()=>(0, _bananaJsDefault.default));
parcelHelpers.export(exports, "LucideBanana", ()=>(0, _bananaJsDefault.default));
parcelHelpers.export(exports, "Banknote", ()=>(0, _banknoteJsDefault.default));
parcelHelpers.export(exports, "BanknoteIcon", ()=>(0, _banknoteJsDefault.default));
parcelHelpers.export(exports, "LucideBanknote", ()=>(0, _banknoteJsDefault.default));
parcelHelpers.export(exports, "BarChart2", ()=>(0, _barChart2JsDefault.default));
parcelHelpers.export(exports, "BarChart2Icon", ()=>(0, _barChart2JsDefault.default));
parcelHelpers.export(exports, "LucideBarChart2", ()=>(0, _barChart2JsDefault.default));
parcelHelpers.export(exports, "BarChart3", ()=>(0, _barChart3JsDefault.default));
parcelHelpers.export(exports, "BarChart3Icon", ()=>(0, _barChart3JsDefault.default));
parcelHelpers.export(exports, "LucideBarChart3", ()=>(0, _barChart3JsDefault.default));
parcelHelpers.export(exports, "BarChart4", ()=>(0, _barChart4JsDefault.default));
parcelHelpers.export(exports, "BarChart4Icon", ()=>(0, _barChart4JsDefault.default));
parcelHelpers.export(exports, "LucideBarChart4", ()=>(0, _barChart4JsDefault.default));
parcelHelpers.export(exports, "BarChartBig", ()=>(0, _barChartBigJsDefault.default));
parcelHelpers.export(exports, "BarChartBigIcon", ()=>(0, _barChartBigJsDefault.default));
parcelHelpers.export(exports, "LucideBarChartBig", ()=>(0, _barChartBigJsDefault.default));
parcelHelpers.export(exports, "BarChartHorizontalBig", ()=>(0, _barChartHorizontalBigJsDefault.default));
parcelHelpers.export(exports, "BarChartHorizontalBigIcon", ()=>(0, _barChartHorizontalBigJsDefault.default));
parcelHelpers.export(exports, "LucideBarChartHorizontalBig", ()=>(0, _barChartHorizontalBigJsDefault.default));
parcelHelpers.export(exports, "BarChartHorizontal", ()=>(0, _barChartHorizontalJsDefault.default));
parcelHelpers.export(exports, "BarChartHorizontalIcon", ()=>(0, _barChartHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideBarChartHorizontal", ()=>(0, _barChartHorizontalJsDefault.default));
parcelHelpers.export(exports, "BarChart", ()=>(0, _barChartJsDefault.default));
parcelHelpers.export(exports, "BarChartIcon", ()=>(0, _barChartJsDefault.default));
parcelHelpers.export(exports, "LucideBarChart", ()=>(0, _barChartJsDefault.default));
parcelHelpers.export(exports, "Barcode", ()=>(0, _barcodeJsDefault.default));
parcelHelpers.export(exports, "BarcodeIcon", ()=>(0, _barcodeJsDefault.default));
parcelHelpers.export(exports, "LucideBarcode", ()=>(0, _barcodeJsDefault.default));
parcelHelpers.export(exports, "Baseline", ()=>(0, _baselineJsDefault.default));
parcelHelpers.export(exports, "BaselineIcon", ()=>(0, _baselineJsDefault.default));
parcelHelpers.export(exports, "LucideBaseline", ()=>(0, _baselineJsDefault.default));
parcelHelpers.export(exports, "Bath", ()=>(0, _bathJsDefault.default));
parcelHelpers.export(exports, "BathIcon", ()=>(0, _bathJsDefault.default));
parcelHelpers.export(exports, "LucideBath", ()=>(0, _bathJsDefault.default));
parcelHelpers.export(exports, "BatteryCharging", ()=>(0, _batteryChargingJsDefault.default));
parcelHelpers.export(exports, "BatteryChargingIcon", ()=>(0, _batteryChargingJsDefault.default));
parcelHelpers.export(exports, "LucideBatteryCharging", ()=>(0, _batteryChargingJsDefault.default));
parcelHelpers.export(exports, "BatteryFull", ()=>(0, _batteryFullJsDefault.default));
parcelHelpers.export(exports, "BatteryFullIcon", ()=>(0, _batteryFullJsDefault.default));
parcelHelpers.export(exports, "LucideBatteryFull", ()=>(0, _batteryFullJsDefault.default));
parcelHelpers.export(exports, "BatteryLow", ()=>(0, _batteryLowJsDefault.default));
parcelHelpers.export(exports, "BatteryLowIcon", ()=>(0, _batteryLowJsDefault.default));
parcelHelpers.export(exports, "LucideBatteryLow", ()=>(0, _batteryLowJsDefault.default));
parcelHelpers.export(exports, "BatteryMedium", ()=>(0, _batteryMediumJsDefault.default));
parcelHelpers.export(exports, "BatteryMediumIcon", ()=>(0, _batteryMediumJsDefault.default));
parcelHelpers.export(exports, "LucideBatteryMedium", ()=>(0, _batteryMediumJsDefault.default));
parcelHelpers.export(exports, "BatteryWarning", ()=>(0, _batteryWarningJsDefault.default));
parcelHelpers.export(exports, "BatteryWarningIcon", ()=>(0, _batteryWarningJsDefault.default));
parcelHelpers.export(exports, "LucideBatteryWarning", ()=>(0, _batteryWarningJsDefault.default));
parcelHelpers.export(exports, "Battery", ()=>(0, _batteryJsDefault.default));
parcelHelpers.export(exports, "BatteryIcon", ()=>(0, _batteryJsDefault.default));
parcelHelpers.export(exports, "LucideBattery", ()=>(0, _batteryJsDefault.default));
parcelHelpers.export(exports, "Beaker", ()=>(0, _beakerJsDefault.default));
parcelHelpers.export(exports, "BeakerIcon", ()=>(0, _beakerJsDefault.default));
parcelHelpers.export(exports, "LucideBeaker", ()=>(0, _beakerJsDefault.default));
parcelHelpers.export(exports, "BeanOff", ()=>(0, _beanOffJsDefault.default));
parcelHelpers.export(exports, "BeanOffIcon", ()=>(0, _beanOffJsDefault.default));
parcelHelpers.export(exports, "LucideBeanOff", ()=>(0, _beanOffJsDefault.default));
parcelHelpers.export(exports, "Bean", ()=>(0, _beanJsDefault.default));
parcelHelpers.export(exports, "BeanIcon", ()=>(0, _beanJsDefault.default));
parcelHelpers.export(exports, "LucideBean", ()=>(0, _beanJsDefault.default));
parcelHelpers.export(exports, "BedDouble", ()=>(0, _bedDoubleJsDefault.default));
parcelHelpers.export(exports, "BedDoubleIcon", ()=>(0, _bedDoubleJsDefault.default));
parcelHelpers.export(exports, "LucideBedDouble", ()=>(0, _bedDoubleJsDefault.default));
parcelHelpers.export(exports, "BedSingle", ()=>(0, _bedSingleJsDefault.default));
parcelHelpers.export(exports, "BedSingleIcon", ()=>(0, _bedSingleJsDefault.default));
parcelHelpers.export(exports, "LucideBedSingle", ()=>(0, _bedSingleJsDefault.default));
parcelHelpers.export(exports, "Bed", ()=>(0, _bedJsDefault.default));
parcelHelpers.export(exports, "BedIcon", ()=>(0, _bedJsDefault.default));
parcelHelpers.export(exports, "LucideBed", ()=>(0, _bedJsDefault.default));
parcelHelpers.export(exports, "Beef", ()=>(0, _beefJsDefault.default));
parcelHelpers.export(exports, "BeefIcon", ()=>(0, _beefJsDefault.default));
parcelHelpers.export(exports, "LucideBeef", ()=>(0, _beefJsDefault.default));
parcelHelpers.export(exports, "Beer", ()=>(0, _beerJsDefault.default));
parcelHelpers.export(exports, "BeerIcon", ()=>(0, _beerJsDefault.default));
parcelHelpers.export(exports, "LucideBeer", ()=>(0, _beerJsDefault.default));
parcelHelpers.export(exports, "BellDot", ()=>(0, _bellDotJsDefault.default));
parcelHelpers.export(exports, "BellDotIcon", ()=>(0, _bellDotJsDefault.default));
parcelHelpers.export(exports, "LucideBellDot", ()=>(0, _bellDotJsDefault.default));
parcelHelpers.export(exports, "BellElectric", ()=>(0, _bellElectricJsDefault.default));
parcelHelpers.export(exports, "BellElectricIcon", ()=>(0, _bellElectricJsDefault.default));
parcelHelpers.export(exports, "LucideBellElectric", ()=>(0, _bellElectricJsDefault.default));
parcelHelpers.export(exports, "BellMinus", ()=>(0, _bellMinusJsDefault.default));
parcelHelpers.export(exports, "BellMinusIcon", ()=>(0, _bellMinusJsDefault.default));
parcelHelpers.export(exports, "LucideBellMinus", ()=>(0, _bellMinusJsDefault.default));
parcelHelpers.export(exports, "BellOff", ()=>(0, _bellOffJsDefault.default));
parcelHelpers.export(exports, "BellOffIcon", ()=>(0, _bellOffJsDefault.default));
parcelHelpers.export(exports, "LucideBellOff", ()=>(0, _bellOffJsDefault.default));
parcelHelpers.export(exports, "BellPlus", ()=>(0, _bellPlusJsDefault.default));
parcelHelpers.export(exports, "BellPlusIcon", ()=>(0, _bellPlusJsDefault.default));
parcelHelpers.export(exports, "LucideBellPlus", ()=>(0, _bellPlusJsDefault.default));
parcelHelpers.export(exports, "BellRing", ()=>(0, _bellRingJsDefault.default));
parcelHelpers.export(exports, "BellRingIcon", ()=>(0, _bellRingJsDefault.default));
parcelHelpers.export(exports, "LucideBellRing", ()=>(0, _bellRingJsDefault.default));
parcelHelpers.export(exports, "Bell", ()=>(0, _bellJsDefault.default));
parcelHelpers.export(exports, "BellIcon", ()=>(0, _bellJsDefault.default));
parcelHelpers.export(exports, "LucideBell", ()=>(0, _bellJsDefault.default));
parcelHelpers.export(exports, "BetweenVerticalEnd", ()=>(0, _betweenVerticalEndJsDefault.default));
parcelHelpers.export(exports, "BetweenVerticalEndIcon", ()=>(0, _betweenVerticalEndJsDefault.default));
parcelHelpers.export(exports, "LucideBetweenVerticalEnd", ()=>(0, _betweenVerticalEndJsDefault.default));
parcelHelpers.export(exports, "BetweenVerticalStart", ()=>(0, _betweenVerticalStartJsDefault.default));
parcelHelpers.export(exports, "BetweenVerticalStartIcon", ()=>(0, _betweenVerticalStartJsDefault.default));
parcelHelpers.export(exports, "LucideBetweenVerticalStart", ()=>(0, _betweenVerticalStartJsDefault.default));
parcelHelpers.export(exports, "Bike", ()=>(0, _bikeJsDefault.default));
parcelHelpers.export(exports, "BikeIcon", ()=>(0, _bikeJsDefault.default));
parcelHelpers.export(exports, "LucideBike", ()=>(0, _bikeJsDefault.default));
parcelHelpers.export(exports, "Binary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "BinaryIcon", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "LucideBinary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "Biohazard", ()=>(0, _biohazardJsDefault.default));
parcelHelpers.export(exports, "BiohazardIcon", ()=>(0, _biohazardJsDefault.default));
parcelHelpers.export(exports, "LucideBiohazard", ()=>(0, _biohazardJsDefault.default));
parcelHelpers.export(exports, "Bird", ()=>(0, _birdJsDefault.default));
parcelHelpers.export(exports, "BirdIcon", ()=>(0, _birdJsDefault.default));
parcelHelpers.export(exports, "LucideBird", ()=>(0, _birdJsDefault.default));
parcelHelpers.export(exports, "Bitcoin", ()=>(0, _bitcoinJsDefault.default));
parcelHelpers.export(exports, "BitcoinIcon", ()=>(0, _bitcoinJsDefault.default));
parcelHelpers.export(exports, "LucideBitcoin", ()=>(0, _bitcoinJsDefault.default));
parcelHelpers.export(exports, "Blend", ()=>(0, _blendJsDefault.default));
parcelHelpers.export(exports, "BlendIcon", ()=>(0, _blendJsDefault.default));
parcelHelpers.export(exports, "LucideBlend", ()=>(0, _blendJsDefault.default));
parcelHelpers.export(exports, "Blinds", ()=>(0, _blindsJsDefault.default));
parcelHelpers.export(exports, "BlindsIcon", ()=>(0, _blindsJsDefault.default));
parcelHelpers.export(exports, "LucideBlinds", ()=>(0, _blindsJsDefault.default));
parcelHelpers.export(exports, "Blocks", ()=>(0, _blocksJsDefault.default));
parcelHelpers.export(exports, "BlocksIcon", ()=>(0, _blocksJsDefault.default));
parcelHelpers.export(exports, "LucideBlocks", ()=>(0, _blocksJsDefault.default));
parcelHelpers.export(exports, "BluetoothConnected", ()=>(0, _bluetoothConnectedJsDefault.default));
parcelHelpers.export(exports, "BluetoothConnectedIcon", ()=>(0, _bluetoothConnectedJsDefault.default));
parcelHelpers.export(exports, "LucideBluetoothConnected", ()=>(0, _bluetoothConnectedJsDefault.default));
parcelHelpers.export(exports, "BluetoothOff", ()=>(0, _bluetoothOffJsDefault.default));
parcelHelpers.export(exports, "BluetoothOffIcon", ()=>(0, _bluetoothOffJsDefault.default));
parcelHelpers.export(exports, "LucideBluetoothOff", ()=>(0, _bluetoothOffJsDefault.default));
parcelHelpers.export(exports, "BluetoothSearching", ()=>(0, _bluetoothSearchingJsDefault.default));
parcelHelpers.export(exports, "BluetoothSearchingIcon", ()=>(0, _bluetoothSearchingJsDefault.default));
parcelHelpers.export(exports, "LucideBluetoothSearching", ()=>(0, _bluetoothSearchingJsDefault.default));
parcelHelpers.export(exports, "Bluetooth", ()=>(0, _bluetoothJsDefault.default));
parcelHelpers.export(exports, "BluetoothIcon", ()=>(0, _bluetoothJsDefault.default));
parcelHelpers.export(exports, "LucideBluetooth", ()=>(0, _bluetoothJsDefault.default));
parcelHelpers.export(exports, "Bold", ()=>(0, _boldJsDefault.default));
parcelHelpers.export(exports, "BoldIcon", ()=>(0, _boldJsDefault.default));
parcelHelpers.export(exports, "LucideBold", ()=>(0, _boldJsDefault.default));
parcelHelpers.export(exports, "Bolt", ()=>(0, _boltJsDefault.default));
parcelHelpers.export(exports, "BoltIcon", ()=>(0, _boltJsDefault.default));
parcelHelpers.export(exports, "LucideBolt", ()=>(0, _boltJsDefault.default));
parcelHelpers.export(exports, "Bomb", ()=>(0, _bombJsDefault.default));
parcelHelpers.export(exports, "BombIcon", ()=>(0, _bombJsDefault.default));
parcelHelpers.export(exports, "LucideBomb", ()=>(0, _bombJsDefault.default));
parcelHelpers.export(exports, "Bone", ()=>(0, _boneJsDefault.default));
parcelHelpers.export(exports, "BoneIcon", ()=>(0, _boneJsDefault.default));
parcelHelpers.export(exports, "LucideBone", ()=>(0, _boneJsDefault.default));
parcelHelpers.export(exports, "BookA", ()=>(0, _bookAJsDefault.default));
parcelHelpers.export(exports, "BookAIcon", ()=>(0, _bookAJsDefault.default));
parcelHelpers.export(exports, "LucideBookA", ()=>(0, _bookAJsDefault.default));
parcelHelpers.export(exports, "BookAudio", ()=>(0, _bookAudioJsDefault.default));
parcelHelpers.export(exports, "BookAudioIcon", ()=>(0, _bookAudioJsDefault.default));
parcelHelpers.export(exports, "LucideBookAudio", ()=>(0, _bookAudioJsDefault.default));
parcelHelpers.export(exports, "BookCheck", ()=>(0, _bookCheckJsDefault.default));
parcelHelpers.export(exports, "BookCheckIcon", ()=>(0, _bookCheckJsDefault.default));
parcelHelpers.export(exports, "LucideBookCheck", ()=>(0, _bookCheckJsDefault.default));
parcelHelpers.export(exports, "BookCopy", ()=>(0, _bookCopyJsDefault.default));
parcelHelpers.export(exports, "BookCopyIcon", ()=>(0, _bookCopyJsDefault.default));
parcelHelpers.export(exports, "LucideBookCopy", ()=>(0, _bookCopyJsDefault.default));
parcelHelpers.export(exports, "BookDown", ()=>(0, _bookDownJsDefault.default));
parcelHelpers.export(exports, "BookDownIcon", ()=>(0, _bookDownJsDefault.default));
parcelHelpers.export(exports, "LucideBookDown", ()=>(0, _bookDownJsDefault.default));
parcelHelpers.export(exports, "BookHeadphones", ()=>(0, _bookHeadphonesJsDefault.default));
parcelHelpers.export(exports, "BookHeadphonesIcon", ()=>(0, _bookHeadphonesJsDefault.default));
parcelHelpers.export(exports, "LucideBookHeadphones", ()=>(0, _bookHeadphonesJsDefault.default));
parcelHelpers.export(exports, "BookHeart", ()=>(0, _bookHeartJsDefault.default));
parcelHelpers.export(exports, "BookHeartIcon", ()=>(0, _bookHeartJsDefault.default));
parcelHelpers.export(exports, "LucideBookHeart", ()=>(0, _bookHeartJsDefault.default));
parcelHelpers.export(exports, "BookImage", ()=>(0, _bookImageJsDefault.default));
parcelHelpers.export(exports, "BookImageIcon", ()=>(0, _bookImageJsDefault.default));
parcelHelpers.export(exports, "LucideBookImage", ()=>(0, _bookImageJsDefault.default));
parcelHelpers.export(exports, "BookKey", ()=>(0, _bookKeyJsDefault.default));
parcelHelpers.export(exports, "BookKeyIcon", ()=>(0, _bookKeyJsDefault.default));
parcelHelpers.export(exports, "LucideBookKey", ()=>(0, _bookKeyJsDefault.default));
parcelHelpers.export(exports, "BookLock", ()=>(0, _bookLockJsDefault.default));
parcelHelpers.export(exports, "BookLockIcon", ()=>(0, _bookLockJsDefault.default));
parcelHelpers.export(exports, "LucideBookLock", ()=>(0, _bookLockJsDefault.default));
parcelHelpers.export(exports, "BookMarked", ()=>(0, _bookMarkedJsDefault.default));
parcelHelpers.export(exports, "BookMarkedIcon", ()=>(0, _bookMarkedJsDefault.default));
parcelHelpers.export(exports, "LucideBookMarked", ()=>(0, _bookMarkedJsDefault.default));
parcelHelpers.export(exports, "BookMinus", ()=>(0, _bookMinusJsDefault.default));
parcelHelpers.export(exports, "BookMinusIcon", ()=>(0, _bookMinusJsDefault.default));
parcelHelpers.export(exports, "LucideBookMinus", ()=>(0, _bookMinusJsDefault.default));
parcelHelpers.export(exports, "BookOpenCheck", ()=>(0, _bookOpenCheckJsDefault.default));
parcelHelpers.export(exports, "BookOpenCheckIcon", ()=>(0, _bookOpenCheckJsDefault.default));
parcelHelpers.export(exports, "LucideBookOpenCheck", ()=>(0, _bookOpenCheckJsDefault.default));
parcelHelpers.export(exports, "BookOpenText", ()=>(0, _bookOpenTextJsDefault.default));
parcelHelpers.export(exports, "BookOpenTextIcon", ()=>(0, _bookOpenTextJsDefault.default));
parcelHelpers.export(exports, "LucideBookOpenText", ()=>(0, _bookOpenTextJsDefault.default));
parcelHelpers.export(exports, "BookOpen", ()=>(0, _bookOpenJsDefault.default));
parcelHelpers.export(exports, "BookOpenIcon", ()=>(0, _bookOpenJsDefault.default));
parcelHelpers.export(exports, "LucideBookOpen", ()=>(0, _bookOpenJsDefault.default));
parcelHelpers.export(exports, "BookPlus", ()=>(0, _bookPlusJsDefault.default));
parcelHelpers.export(exports, "BookPlusIcon", ()=>(0, _bookPlusJsDefault.default));
parcelHelpers.export(exports, "LucideBookPlus", ()=>(0, _bookPlusJsDefault.default));
parcelHelpers.export(exports, "BookText", ()=>(0, _bookTextJsDefault.default));
parcelHelpers.export(exports, "BookTextIcon", ()=>(0, _bookTextJsDefault.default));
parcelHelpers.export(exports, "LucideBookText", ()=>(0, _bookTextJsDefault.default));
parcelHelpers.export(exports, "BookType", ()=>(0, _bookTypeJsDefault.default));
parcelHelpers.export(exports, "BookTypeIcon", ()=>(0, _bookTypeJsDefault.default));
parcelHelpers.export(exports, "LucideBookType", ()=>(0, _bookTypeJsDefault.default));
parcelHelpers.export(exports, "BookUp2", ()=>(0, _bookUp2JsDefault.default));
parcelHelpers.export(exports, "BookUp2Icon", ()=>(0, _bookUp2JsDefault.default));
parcelHelpers.export(exports, "LucideBookUp2", ()=>(0, _bookUp2JsDefault.default));
parcelHelpers.export(exports, "BookUp", ()=>(0, _bookUpJsDefault.default));
parcelHelpers.export(exports, "BookUpIcon", ()=>(0, _bookUpJsDefault.default));
parcelHelpers.export(exports, "LucideBookUp", ()=>(0, _bookUpJsDefault.default));
parcelHelpers.export(exports, "BookUser", ()=>(0, _bookUserJsDefault.default));
parcelHelpers.export(exports, "BookUserIcon", ()=>(0, _bookUserJsDefault.default));
parcelHelpers.export(exports, "LucideBookUser", ()=>(0, _bookUserJsDefault.default));
parcelHelpers.export(exports, "BookX", ()=>(0, _bookXJsDefault.default));
parcelHelpers.export(exports, "BookXIcon", ()=>(0, _bookXJsDefault.default));
parcelHelpers.export(exports, "LucideBookX", ()=>(0, _bookXJsDefault.default));
parcelHelpers.export(exports, "Book", ()=>(0, _bookJsDefault.default));
parcelHelpers.export(exports, "BookIcon", ()=>(0, _bookJsDefault.default));
parcelHelpers.export(exports, "LucideBook", ()=>(0, _bookJsDefault.default));
parcelHelpers.export(exports, "BookmarkCheck", ()=>(0, _bookmarkCheckJsDefault.default));
parcelHelpers.export(exports, "BookmarkCheckIcon", ()=>(0, _bookmarkCheckJsDefault.default));
parcelHelpers.export(exports, "LucideBookmarkCheck", ()=>(0, _bookmarkCheckJsDefault.default));
parcelHelpers.export(exports, "BookmarkMinus", ()=>(0, _bookmarkMinusJsDefault.default));
parcelHelpers.export(exports, "BookmarkMinusIcon", ()=>(0, _bookmarkMinusJsDefault.default));
parcelHelpers.export(exports, "LucideBookmarkMinus", ()=>(0, _bookmarkMinusJsDefault.default));
parcelHelpers.export(exports, "BookmarkPlus", ()=>(0, _bookmarkPlusJsDefault.default));
parcelHelpers.export(exports, "BookmarkPlusIcon", ()=>(0, _bookmarkPlusJsDefault.default));
parcelHelpers.export(exports, "LucideBookmarkPlus", ()=>(0, _bookmarkPlusJsDefault.default));
parcelHelpers.export(exports, "BookmarkX", ()=>(0, _bookmarkXJsDefault.default));
parcelHelpers.export(exports, "BookmarkXIcon", ()=>(0, _bookmarkXJsDefault.default));
parcelHelpers.export(exports, "LucideBookmarkX", ()=>(0, _bookmarkXJsDefault.default));
parcelHelpers.export(exports, "Bookmark", ()=>(0, _bookmarkJsDefault.default));
parcelHelpers.export(exports, "BookmarkIcon", ()=>(0, _bookmarkJsDefault.default));
parcelHelpers.export(exports, "LucideBookmark", ()=>(0, _bookmarkJsDefault.default));
parcelHelpers.export(exports, "BoomBox", ()=>(0, _boomBoxJsDefault.default));
parcelHelpers.export(exports, "BoomBoxIcon", ()=>(0, _boomBoxJsDefault.default));
parcelHelpers.export(exports, "LucideBoomBox", ()=>(0, _boomBoxJsDefault.default));
parcelHelpers.export(exports, "BotMessageSquare", ()=>(0, _botMessageSquareJsDefault.default));
parcelHelpers.export(exports, "BotMessageSquareIcon", ()=>(0, _botMessageSquareJsDefault.default));
parcelHelpers.export(exports, "LucideBotMessageSquare", ()=>(0, _botMessageSquareJsDefault.default));
parcelHelpers.export(exports, "Bot", ()=>(0, _botJsDefault.default));
parcelHelpers.export(exports, "BotIcon", ()=>(0, _botJsDefault.default));
parcelHelpers.export(exports, "LucideBot", ()=>(0, _botJsDefault.default));
parcelHelpers.export(exports, "BoxSelect", ()=>(0, _boxSelectJsDefault.default));
parcelHelpers.export(exports, "BoxSelectIcon", ()=>(0, _boxSelectJsDefault.default));
parcelHelpers.export(exports, "LucideBoxSelect", ()=>(0, _boxSelectJsDefault.default));
parcelHelpers.export(exports, "Box", ()=>(0, _boxJsDefault.default));
parcelHelpers.export(exports, "BoxIcon", ()=>(0, _boxJsDefault.default));
parcelHelpers.export(exports, "LucideBox", ()=>(0, _boxJsDefault.default));
parcelHelpers.export(exports, "Boxes", ()=>(0, _boxesJsDefault.default));
parcelHelpers.export(exports, "BoxesIcon", ()=>(0, _boxesJsDefault.default));
parcelHelpers.export(exports, "LucideBoxes", ()=>(0, _boxesJsDefault.default));
parcelHelpers.export(exports, "Brackets", ()=>(0, _bracketsJsDefault.default));
parcelHelpers.export(exports, "BracketsIcon", ()=>(0, _bracketsJsDefault.default));
parcelHelpers.export(exports, "LucideBrackets", ()=>(0, _bracketsJsDefault.default));
parcelHelpers.export(exports, "BrainCircuit", ()=>(0, _brainCircuitJsDefault.default));
parcelHelpers.export(exports, "BrainCircuitIcon", ()=>(0, _brainCircuitJsDefault.default));
parcelHelpers.export(exports, "LucideBrainCircuit", ()=>(0, _brainCircuitJsDefault.default));
parcelHelpers.export(exports, "BrainCog", ()=>(0, _brainCogJsDefault.default));
parcelHelpers.export(exports, "BrainCogIcon", ()=>(0, _brainCogJsDefault.default));
parcelHelpers.export(exports, "LucideBrainCog", ()=>(0, _brainCogJsDefault.default));
parcelHelpers.export(exports, "Brain", ()=>(0, _brainJsDefault.default));
parcelHelpers.export(exports, "BrainIcon", ()=>(0, _brainJsDefault.default));
parcelHelpers.export(exports, "LucideBrain", ()=>(0, _brainJsDefault.default));
parcelHelpers.export(exports, "BrickWall", ()=>(0, _brickWallJsDefault.default));
parcelHelpers.export(exports, "BrickWallIcon", ()=>(0, _brickWallJsDefault.default));
parcelHelpers.export(exports, "LucideBrickWall", ()=>(0, _brickWallJsDefault.default));
parcelHelpers.export(exports, "Briefcase", ()=>(0, _briefcaseJsDefault.default));
parcelHelpers.export(exports, "BriefcaseIcon", ()=>(0, _briefcaseJsDefault.default));
parcelHelpers.export(exports, "LucideBriefcase", ()=>(0, _briefcaseJsDefault.default));
parcelHelpers.export(exports, "BringToFront", ()=>(0, _bringToFrontJsDefault.default));
parcelHelpers.export(exports, "BringToFrontIcon", ()=>(0, _bringToFrontJsDefault.default));
parcelHelpers.export(exports, "LucideBringToFront", ()=>(0, _bringToFrontJsDefault.default));
parcelHelpers.export(exports, "Brush", ()=>(0, _brushJsDefault.default));
parcelHelpers.export(exports, "BrushIcon", ()=>(0, _brushJsDefault.default));
parcelHelpers.export(exports, "LucideBrush", ()=>(0, _brushJsDefault.default));
parcelHelpers.export(exports, "BugOff", ()=>(0, _bugOffJsDefault.default));
parcelHelpers.export(exports, "BugOffIcon", ()=>(0, _bugOffJsDefault.default));
parcelHelpers.export(exports, "LucideBugOff", ()=>(0, _bugOffJsDefault.default));
parcelHelpers.export(exports, "BugPlay", ()=>(0, _bugPlayJsDefault.default));
parcelHelpers.export(exports, "BugPlayIcon", ()=>(0, _bugPlayJsDefault.default));
parcelHelpers.export(exports, "LucideBugPlay", ()=>(0, _bugPlayJsDefault.default));
parcelHelpers.export(exports, "Bug", ()=>(0, _bugJsDefault.default));
parcelHelpers.export(exports, "BugIcon", ()=>(0, _bugJsDefault.default));
parcelHelpers.export(exports, "LucideBug", ()=>(0, _bugJsDefault.default));
parcelHelpers.export(exports, "Building2", ()=>(0, _building2JsDefault.default));
parcelHelpers.export(exports, "Building2Icon", ()=>(0, _building2JsDefault.default));
parcelHelpers.export(exports, "LucideBuilding2", ()=>(0, _building2JsDefault.default));
parcelHelpers.export(exports, "Building", ()=>(0, _buildingJsDefault.default));
parcelHelpers.export(exports, "BuildingIcon", ()=>(0, _buildingJsDefault.default));
parcelHelpers.export(exports, "LucideBuilding", ()=>(0, _buildingJsDefault.default));
parcelHelpers.export(exports, "BusFront", ()=>(0, _busFrontJsDefault.default));
parcelHelpers.export(exports, "BusFrontIcon", ()=>(0, _busFrontJsDefault.default));
parcelHelpers.export(exports, "LucideBusFront", ()=>(0, _busFrontJsDefault.default));
parcelHelpers.export(exports, "Bus", ()=>(0, _busJsDefault.default));
parcelHelpers.export(exports, "BusIcon", ()=>(0, _busJsDefault.default));
parcelHelpers.export(exports, "LucideBus", ()=>(0, _busJsDefault.default));
parcelHelpers.export(exports, "CableCar", ()=>(0, _cableCarJsDefault.default));
parcelHelpers.export(exports, "CableCarIcon", ()=>(0, _cableCarJsDefault.default));
parcelHelpers.export(exports, "LucideCableCar", ()=>(0, _cableCarJsDefault.default));
parcelHelpers.export(exports, "Cable", ()=>(0, _cableJsDefault.default));
parcelHelpers.export(exports, "CableIcon", ()=>(0, _cableJsDefault.default));
parcelHelpers.export(exports, "LucideCable", ()=>(0, _cableJsDefault.default));
parcelHelpers.export(exports, "CakeSlice", ()=>(0, _cakeSliceJsDefault.default));
parcelHelpers.export(exports, "CakeSliceIcon", ()=>(0, _cakeSliceJsDefault.default));
parcelHelpers.export(exports, "LucideCakeSlice", ()=>(0, _cakeSliceJsDefault.default));
parcelHelpers.export(exports, "Cake", ()=>(0, _cakeJsDefault.default));
parcelHelpers.export(exports, "CakeIcon", ()=>(0, _cakeJsDefault.default));
parcelHelpers.export(exports, "LucideCake", ()=>(0, _cakeJsDefault.default));
parcelHelpers.export(exports, "Calculator", ()=>(0, _calculatorJsDefault.default));
parcelHelpers.export(exports, "CalculatorIcon", ()=>(0, _calculatorJsDefault.default));
parcelHelpers.export(exports, "LucideCalculator", ()=>(0, _calculatorJsDefault.default));
parcelHelpers.export(exports, "CalendarCheck2", ()=>(0, _calendarCheck2JsDefault.default));
parcelHelpers.export(exports, "CalendarCheck2Icon", ()=>(0, _calendarCheck2JsDefault.default));
parcelHelpers.export(exports, "LucideCalendarCheck2", ()=>(0, _calendarCheck2JsDefault.default));
parcelHelpers.export(exports, "CalendarCheck", ()=>(0, _calendarCheckJsDefault.default));
parcelHelpers.export(exports, "CalendarCheckIcon", ()=>(0, _calendarCheckJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarCheck", ()=>(0, _calendarCheckJsDefault.default));
parcelHelpers.export(exports, "CalendarClock", ()=>(0, _calendarClockJsDefault.default));
parcelHelpers.export(exports, "CalendarClockIcon", ()=>(0, _calendarClockJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarClock", ()=>(0, _calendarClockJsDefault.default));
parcelHelpers.export(exports, "CalendarDays", ()=>(0, _calendarDaysJsDefault.default));
parcelHelpers.export(exports, "CalendarDaysIcon", ()=>(0, _calendarDaysJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarDays", ()=>(0, _calendarDaysJsDefault.default));
parcelHelpers.export(exports, "CalendarFold", ()=>(0, _calendarFoldJsDefault.default));
parcelHelpers.export(exports, "CalendarFoldIcon", ()=>(0, _calendarFoldJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarFold", ()=>(0, _calendarFoldJsDefault.default));
parcelHelpers.export(exports, "CalendarHeart", ()=>(0, _calendarHeartJsDefault.default));
parcelHelpers.export(exports, "CalendarHeartIcon", ()=>(0, _calendarHeartJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarHeart", ()=>(0, _calendarHeartJsDefault.default));
parcelHelpers.export(exports, "CalendarMinus2", ()=>(0, _calendarMinus2JsDefault.default));
parcelHelpers.export(exports, "CalendarMinus2Icon", ()=>(0, _calendarMinus2JsDefault.default));
parcelHelpers.export(exports, "LucideCalendarMinus2", ()=>(0, _calendarMinus2JsDefault.default));
parcelHelpers.export(exports, "CalendarMinus", ()=>(0, _calendarMinusJsDefault.default));
parcelHelpers.export(exports, "CalendarMinusIcon", ()=>(0, _calendarMinusJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarMinus", ()=>(0, _calendarMinusJsDefault.default));
parcelHelpers.export(exports, "CalendarOff", ()=>(0, _calendarOffJsDefault.default));
parcelHelpers.export(exports, "CalendarOffIcon", ()=>(0, _calendarOffJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarOff", ()=>(0, _calendarOffJsDefault.default));
parcelHelpers.export(exports, "CalendarPlus2", ()=>(0, _calendarPlus2JsDefault.default));
parcelHelpers.export(exports, "CalendarPlus2Icon", ()=>(0, _calendarPlus2JsDefault.default));
parcelHelpers.export(exports, "LucideCalendarPlus2", ()=>(0, _calendarPlus2JsDefault.default));
parcelHelpers.export(exports, "CalendarPlus", ()=>(0, _calendarPlusJsDefault.default));
parcelHelpers.export(exports, "CalendarPlusIcon", ()=>(0, _calendarPlusJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarPlus", ()=>(0, _calendarPlusJsDefault.default));
parcelHelpers.export(exports, "CalendarRange", ()=>(0, _calendarRangeJsDefault.default));
parcelHelpers.export(exports, "CalendarRangeIcon", ()=>(0, _calendarRangeJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarRange", ()=>(0, _calendarRangeJsDefault.default));
parcelHelpers.export(exports, "CalendarSearch", ()=>(0, _calendarSearchJsDefault.default));
parcelHelpers.export(exports, "CalendarSearchIcon", ()=>(0, _calendarSearchJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarSearch", ()=>(0, _calendarSearchJsDefault.default));
parcelHelpers.export(exports, "CalendarX2", ()=>(0, _calendarX2JsDefault.default));
parcelHelpers.export(exports, "CalendarX2Icon", ()=>(0, _calendarX2JsDefault.default));
parcelHelpers.export(exports, "LucideCalendarX2", ()=>(0, _calendarX2JsDefault.default));
parcelHelpers.export(exports, "CalendarX", ()=>(0, _calendarXJsDefault.default));
parcelHelpers.export(exports, "CalendarXIcon", ()=>(0, _calendarXJsDefault.default));
parcelHelpers.export(exports, "LucideCalendarX", ()=>(0, _calendarXJsDefault.default));
parcelHelpers.export(exports, "Calendar", ()=>(0, _calendarJsDefault.default));
parcelHelpers.export(exports, "CalendarIcon", ()=>(0, _calendarJsDefault.default));
parcelHelpers.export(exports, "LucideCalendar", ()=>(0, _calendarJsDefault.default));
parcelHelpers.export(exports, "CameraOff", ()=>(0, _cameraOffJsDefault.default));
parcelHelpers.export(exports, "CameraOffIcon", ()=>(0, _cameraOffJsDefault.default));
parcelHelpers.export(exports, "LucideCameraOff", ()=>(0, _cameraOffJsDefault.default));
parcelHelpers.export(exports, "Camera", ()=>(0, _cameraJsDefault.default));
parcelHelpers.export(exports, "CameraIcon", ()=>(0, _cameraJsDefault.default));
parcelHelpers.export(exports, "LucideCamera", ()=>(0, _cameraJsDefault.default));
parcelHelpers.export(exports, "CandlestickChart", ()=>(0, _candlestickChartJsDefault.default));
parcelHelpers.export(exports, "CandlestickChartIcon", ()=>(0, _candlestickChartJsDefault.default));
parcelHelpers.export(exports, "LucideCandlestickChart", ()=>(0, _candlestickChartJsDefault.default));
parcelHelpers.export(exports, "CandyCane", ()=>(0, _candyCaneJsDefault.default));
parcelHelpers.export(exports, "CandyCaneIcon", ()=>(0, _candyCaneJsDefault.default));
parcelHelpers.export(exports, "LucideCandyCane", ()=>(0, _candyCaneJsDefault.default));
parcelHelpers.export(exports, "CandyOff", ()=>(0, _candyOffJsDefault.default));
parcelHelpers.export(exports, "CandyOffIcon", ()=>(0, _candyOffJsDefault.default));
parcelHelpers.export(exports, "LucideCandyOff", ()=>(0, _candyOffJsDefault.default));
parcelHelpers.export(exports, "Candy", ()=>(0, _candyJsDefault.default));
parcelHelpers.export(exports, "CandyIcon", ()=>(0, _candyJsDefault.default));
parcelHelpers.export(exports, "LucideCandy", ()=>(0, _candyJsDefault.default));
parcelHelpers.export(exports, "CaptionsOff", ()=>(0, _captionsOffJsDefault.default));
parcelHelpers.export(exports, "CaptionsOffIcon", ()=>(0, _captionsOffJsDefault.default));
parcelHelpers.export(exports, "LucideCaptionsOff", ()=>(0, _captionsOffJsDefault.default));
parcelHelpers.export(exports, "CarFront", ()=>(0, _carFrontJsDefault.default));
parcelHelpers.export(exports, "CarFrontIcon", ()=>(0, _carFrontJsDefault.default));
parcelHelpers.export(exports, "LucideCarFront", ()=>(0, _carFrontJsDefault.default));
parcelHelpers.export(exports, "CarTaxiFront", ()=>(0, _carTaxiFrontJsDefault.default));
parcelHelpers.export(exports, "CarTaxiFrontIcon", ()=>(0, _carTaxiFrontJsDefault.default));
parcelHelpers.export(exports, "LucideCarTaxiFront", ()=>(0, _carTaxiFrontJsDefault.default));
parcelHelpers.export(exports, "Car", ()=>(0, _carJsDefault.default));
parcelHelpers.export(exports, "CarIcon", ()=>(0, _carJsDefault.default));
parcelHelpers.export(exports, "LucideCar", ()=>(0, _carJsDefault.default));
parcelHelpers.export(exports, "Caravan", ()=>(0, _caravanJsDefault.default));
parcelHelpers.export(exports, "CaravanIcon", ()=>(0, _caravanJsDefault.default));
parcelHelpers.export(exports, "LucideCaravan", ()=>(0, _caravanJsDefault.default));
parcelHelpers.export(exports, "Carrot", ()=>(0, _carrotJsDefault.default));
parcelHelpers.export(exports, "CarrotIcon", ()=>(0, _carrotJsDefault.default));
parcelHelpers.export(exports, "LucideCarrot", ()=>(0, _carrotJsDefault.default));
parcelHelpers.export(exports, "CaseLower", ()=>(0, _caseLowerJsDefault.default));
parcelHelpers.export(exports, "CaseLowerIcon", ()=>(0, _caseLowerJsDefault.default));
parcelHelpers.export(exports, "LucideCaseLower", ()=>(0, _caseLowerJsDefault.default));
parcelHelpers.export(exports, "CaseSensitive", ()=>(0, _caseSensitiveJsDefault.default));
parcelHelpers.export(exports, "CaseSensitiveIcon", ()=>(0, _caseSensitiveJsDefault.default));
parcelHelpers.export(exports, "LucideCaseSensitive", ()=>(0, _caseSensitiveJsDefault.default));
parcelHelpers.export(exports, "CaseUpper", ()=>(0, _caseUpperJsDefault.default));
parcelHelpers.export(exports, "CaseUpperIcon", ()=>(0, _caseUpperJsDefault.default));
parcelHelpers.export(exports, "LucideCaseUpper", ()=>(0, _caseUpperJsDefault.default));
parcelHelpers.export(exports, "CassetteTape", ()=>(0, _cassetteTapeJsDefault.default));
parcelHelpers.export(exports, "CassetteTapeIcon", ()=>(0, _cassetteTapeJsDefault.default));
parcelHelpers.export(exports, "LucideCassetteTape", ()=>(0, _cassetteTapeJsDefault.default));
parcelHelpers.export(exports, "Cast", ()=>(0, _castJsDefault.default));
parcelHelpers.export(exports, "CastIcon", ()=>(0, _castJsDefault.default));
parcelHelpers.export(exports, "LucideCast", ()=>(0, _castJsDefault.default));
parcelHelpers.export(exports, "Castle", ()=>(0, _castleJsDefault.default));
parcelHelpers.export(exports, "CastleIcon", ()=>(0, _castleJsDefault.default));
parcelHelpers.export(exports, "LucideCastle", ()=>(0, _castleJsDefault.default));
parcelHelpers.export(exports, "Cat", ()=>(0, _catJsDefault.default));
parcelHelpers.export(exports, "CatIcon", ()=>(0, _catJsDefault.default));
parcelHelpers.export(exports, "LucideCat", ()=>(0, _catJsDefault.default));
parcelHelpers.export(exports, "Cctv", ()=>(0, _cctvJsDefault.default));
parcelHelpers.export(exports, "CctvIcon", ()=>(0, _cctvJsDefault.default));
parcelHelpers.export(exports, "LucideCctv", ()=>(0, _cctvJsDefault.default));
parcelHelpers.export(exports, "CheckCheck", ()=>(0, _checkCheckJsDefault.default));
parcelHelpers.export(exports, "CheckCheckIcon", ()=>(0, _checkCheckJsDefault.default));
parcelHelpers.export(exports, "LucideCheckCheck", ()=>(0, _checkCheckJsDefault.default));
parcelHelpers.export(exports, "CheckCircle2", ()=>(0, _checkCircle2JsDefault.default));
parcelHelpers.export(exports, "CheckCircle2Icon", ()=>(0, _checkCircle2JsDefault.default));
parcelHelpers.export(exports, "LucideCheckCircle2", ()=>(0, _checkCircle2JsDefault.default));
parcelHelpers.export(exports, "CheckCircle", ()=>(0, _checkCircleJsDefault.default));
parcelHelpers.export(exports, "CheckCircleIcon", ()=>(0, _checkCircleJsDefault.default));
parcelHelpers.export(exports, "LucideCheckCircle", ()=>(0, _checkCircleJsDefault.default));
parcelHelpers.export(exports, "CheckSquare2", ()=>(0, _checkSquare2JsDefault.default));
parcelHelpers.export(exports, "CheckSquare2Icon", ()=>(0, _checkSquare2JsDefault.default));
parcelHelpers.export(exports, "LucideCheckSquare2", ()=>(0, _checkSquare2JsDefault.default));
parcelHelpers.export(exports, "CheckSquare", ()=>(0, _checkSquareJsDefault.default));
parcelHelpers.export(exports, "CheckSquareIcon", ()=>(0, _checkSquareJsDefault.default));
parcelHelpers.export(exports, "LucideCheckSquare", ()=>(0, _checkSquareJsDefault.default));
parcelHelpers.export(exports, "Check", ()=>(0, _checkJsDefault.default));
parcelHelpers.export(exports, "CheckIcon", ()=>(0, _checkJsDefault.default));
parcelHelpers.export(exports, "LucideCheck", ()=>(0, _checkJsDefault.default));
parcelHelpers.export(exports, "ChefHat", ()=>(0, _chefHatJsDefault.default));
parcelHelpers.export(exports, "ChefHatIcon", ()=>(0, _chefHatJsDefault.default));
parcelHelpers.export(exports, "LucideChefHat", ()=>(0, _chefHatJsDefault.default));
parcelHelpers.export(exports, "Cherry", ()=>(0, _cherryJsDefault.default));
parcelHelpers.export(exports, "CherryIcon", ()=>(0, _cherryJsDefault.default));
parcelHelpers.export(exports, "LucideCherry", ()=>(0, _cherryJsDefault.default));
parcelHelpers.export(exports, "ChevronDownCircle", ()=>(0, _chevronDownCircleJsDefault.default));
parcelHelpers.export(exports, "ChevronDownCircleIcon", ()=>(0, _chevronDownCircleJsDefault.default));
parcelHelpers.export(exports, "LucideChevronDownCircle", ()=>(0, _chevronDownCircleJsDefault.default));
parcelHelpers.export(exports, "ChevronDownSquare", ()=>(0, _chevronDownSquareJsDefault.default));
parcelHelpers.export(exports, "ChevronDownSquareIcon", ()=>(0, _chevronDownSquareJsDefault.default));
parcelHelpers.export(exports, "LucideChevronDownSquare", ()=>(0, _chevronDownSquareJsDefault.default));
parcelHelpers.export(exports, "ChevronDown", ()=>(0, _chevronDownJsDefault.default));
parcelHelpers.export(exports, "ChevronDownIcon", ()=>(0, _chevronDownJsDefault.default));
parcelHelpers.export(exports, "LucideChevronDown", ()=>(0, _chevronDownJsDefault.default));
parcelHelpers.export(exports, "ChevronFirst", ()=>(0, _chevronFirstJsDefault.default));
parcelHelpers.export(exports, "ChevronFirstIcon", ()=>(0, _chevronFirstJsDefault.default));
parcelHelpers.export(exports, "LucideChevronFirst", ()=>(0, _chevronFirstJsDefault.default));
parcelHelpers.export(exports, "ChevronLast", ()=>(0, _chevronLastJsDefault.default));
parcelHelpers.export(exports, "ChevronLastIcon", ()=>(0, _chevronLastJsDefault.default));
parcelHelpers.export(exports, "LucideChevronLast", ()=>(0, _chevronLastJsDefault.default));
parcelHelpers.export(exports, "ChevronLeftCircle", ()=>(0, _chevronLeftCircleJsDefault.default));
parcelHelpers.export(exports, "ChevronLeftCircleIcon", ()=>(0, _chevronLeftCircleJsDefault.default));
parcelHelpers.export(exports, "LucideChevronLeftCircle", ()=>(0, _chevronLeftCircleJsDefault.default));
parcelHelpers.export(exports, "ChevronLeftSquare", ()=>(0, _chevronLeftSquareJsDefault.default));
parcelHelpers.export(exports, "ChevronLeftSquareIcon", ()=>(0, _chevronLeftSquareJsDefault.default));
parcelHelpers.export(exports, "LucideChevronLeftSquare", ()=>(0, _chevronLeftSquareJsDefault.default));
parcelHelpers.export(exports, "ChevronLeft", ()=>(0, _chevronLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronLeftIcon", ()=>(0, _chevronLeftJsDefault.default));
parcelHelpers.export(exports, "LucideChevronLeft", ()=>(0, _chevronLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronRightCircle", ()=>(0, _chevronRightCircleJsDefault.default));
parcelHelpers.export(exports, "ChevronRightCircleIcon", ()=>(0, _chevronRightCircleJsDefault.default));
parcelHelpers.export(exports, "LucideChevronRightCircle", ()=>(0, _chevronRightCircleJsDefault.default));
parcelHelpers.export(exports, "ChevronRightSquare", ()=>(0, _chevronRightSquareJsDefault.default));
parcelHelpers.export(exports, "ChevronRightSquareIcon", ()=>(0, _chevronRightSquareJsDefault.default));
parcelHelpers.export(exports, "LucideChevronRightSquare", ()=>(0, _chevronRightSquareJsDefault.default));
parcelHelpers.export(exports, "ChevronRight", ()=>(0, _chevronRightJsDefault.default));
parcelHelpers.export(exports, "ChevronRightIcon", ()=>(0, _chevronRightJsDefault.default));
parcelHelpers.export(exports, "LucideChevronRight", ()=>(0, _chevronRightJsDefault.default));
parcelHelpers.export(exports, "ChevronUpCircle", ()=>(0, _chevronUpCircleJsDefault.default));
parcelHelpers.export(exports, "ChevronUpCircleIcon", ()=>(0, _chevronUpCircleJsDefault.default));
parcelHelpers.export(exports, "LucideChevronUpCircle", ()=>(0, _chevronUpCircleJsDefault.default));
parcelHelpers.export(exports, "ChevronUpSquare", ()=>(0, _chevronUpSquareJsDefault.default));
parcelHelpers.export(exports, "ChevronUpSquareIcon", ()=>(0, _chevronUpSquareJsDefault.default));
parcelHelpers.export(exports, "LucideChevronUpSquare", ()=>(0, _chevronUpSquareJsDefault.default));
parcelHelpers.export(exports, "ChevronUp", ()=>(0, _chevronUpJsDefault.default));
parcelHelpers.export(exports, "ChevronUpIcon", ()=>(0, _chevronUpJsDefault.default));
parcelHelpers.export(exports, "LucideChevronUp", ()=>(0, _chevronUpJsDefault.default));
parcelHelpers.export(exports, "ChevronsDownUp", ()=>(0, _chevronsDownUpJsDefault.default));
parcelHelpers.export(exports, "ChevronsDownUpIcon", ()=>(0, _chevronsDownUpJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsDownUp", ()=>(0, _chevronsDownUpJsDefault.default));
parcelHelpers.export(exports, "ChevronsDown", ()=>(0, _chevronsDownJsDefault.default));
parcelHelpers.export(exports, "ChevronsDownIcon", ()=>(0, _chevronsDownJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsDown", ()=>(0, _chevronsDownJsDefault.default));
parcelHelpers.export(exports, "ChevronsLeftRight", ()=>(0, _chevronsLeftRightJsDefault.default));
parcelHelpers.export(exports, "ChevronsLeftRightIcon", ()=>(0, _chevronsLeftRightJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsLeftRight", ()=>(0, _chevronsLeftRightJsDefault.default));
parcelHelpers.export(exports, "ChevronsLeft", ()=>(0, _chevronsLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronsLeftIcon", ()=>(0, _chevronsLeftJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsLeft", ()=>(0, _chevronsLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronsRightLeft", ()=>(0, _chevronsRightLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronsRightLeftIcon", ()=>(0, _chevronsRightLeftJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsRightLeft", ()=>(0, _chevronsRightLeftJsDefault.default));
parcelHelpers.export(exports, "ChevronsRight", ()=>(0, _chevronsRightJsDefault.default));
parcelHelpers.export(exports, "ChevronsRightIcon", ()=>(0, _chevronsRightJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsRight", ()=>(0, _chevronsRightJsDefault.default));
parcelHelpers.export(exports, "ChevronsUpDown", ()=>(0, _chevronsUpDownJsDefault.default));
parcelHelpers.export(exports, "ChevronsUpDownIcon", ()=>(0, _chevronsUpDownJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsUpDown", ()=>(0, _chevronsUpDownJsDefault.default));
parcelHelpers.export(exports, "ChevronsUp", ()=>(0, _chevronsUpJsDefault.default));
parcelHelpers.export(exports, "ChevronsUpIcon", ()=>(0, _chevronsUpJsDefault.default));
parcelHelpers.export(exports, "LucideChevronsUp", ()=>(0, _chevronsUpJsDefault.default));
parcelHelpers.export(exports, "Chrome", ()=>(0, _chromeJsDefault.default));
parcelHelpers.export(exports, "ChromeIcon", ()=>(0, _chromeJsDefault.default));
parcelHelpers.export(exports, "LucideChrome", ()=>(0, _chromeJsDefault.default));
parcelHelpers.export(exports, "Church", ()=>(0, _churchJsDefault.default));
parcelHelpers.export(exports, "ChurchIcon", ()=>(0, _churchJsDefault.default));
parcelHelpers.export(exports, "LucideChurch", ()=>(0, _churchJsDefault.default));
parcelHelpers.export(exports, "CigaretteOff", ()=>(0, _cigaretteOffJsDefault.default));
parcelHelpers.export(exports, "CigaretteOffIcon", ()=>(0, _cigaretteOffJsDefault.default));
parcelHelpers.export(exports, "LucideCigaretteOff", ()=>(0, _cigaretteOffJsDefault.default));
parcelHelpers.export(exports, "Cigarette", ()=>(0, _cigaretteJsDefault.default));
parcelHelpers.export(exports, "CigaretteIcon", ()=>(0, _cigaretteJsDefault.default));
parcelHelpers.export(exports, "LucideCigarette", ()=>(0, _cigaretteJsDefault.default));
parcelHelpers.export(exports, "CircleDashed", ()=>(0, _circleDashedJsDefault.default));
parcelHelpers.export(exports, "CircleDashedIcon", ()=>(0, _circleDashedJsDefault.default));
parcelHelpers.export(exports, "LucideCircleDashed", ()=>(0, _circleDashedJsDefault.default));
parcelHelpers.export(exports, "CircleDollarSign", ()=>(0, _circleDollarSignJsDefault.default));
parcelHelpers.export(exports, "CircleDollarSignIcon", ()=>(0, _circleDollarSignJsDefault.default));
parcelHelpers.export(exports, "LucideCircleDollarSign", ()=>(0, _circleDollarSignJsDefault.default));
parcelHelpers.export(exports, "CircleDotDashed", ()=>(0, _circleDotDashedJsDefault.default));
parcelHelpers.export(exports, "CircleDotDashedIcon", ()=>(0, _circleDotDashedJsDefault.default));
parcelHelpers.export(exports, "LucideCircleDotDashed", ()=>(0, _circleDotDashedJsDefault.default));
parcelHelpers.export(exports, "CircleDot", ()=>(0, _circleDotJsDefault.default));
parcelHelpers.export(exports, "CircleDotIcon", ()=>(0, _circleDotJsDefault.default));
parcelHelpers.export(exports, "LucideCircleDot", ()=>(0, _circleDotJsDefault.default));
parcelHelpers.export(exports, "CircleEllipsis", ()=>(0, _circleEllipsisJsDefault.default));
parcelHelpers.export(exports, "CircleEllipsisIcon", ()=>(0, _circleEllipsisJsDefault.default));
parcelHelpers.export(exports, "LucideCircleEllipsis", ()=>(0, _circleEllipsisJsDefault.default));
parcelHelpers.export(exports, "CircleEqual", ()=>(0, _circleEqualJsDefault.default));
parcelHelpers.export(exports, "CircleEqualIcon", ()=>(0, _circleEqualJsDefault.default));
parcelHelpers.export(exports, "LucideCircleEqual", ()=>(0, _circleEqualJsDefault.default));
parcelHelpers.export(exports, "CircleFadingPlus", ()=>(0, _circleFadingPlusJsDefault.default));
parcelHelpers.export(exports, "CircleFadingPlusIcon", ()=>(0, _circleFadingPlusJsDefault.default));
parcelHelpers.export(exports, "LucideCircleFadingPlus", ()=>(0, _circleFadingPlusJsDefault.default));
parcelHelpers.export(exports, "CircleOff", ()=>(0, _circleOffJsDefault.default));
parcelHelpers.export(exports, "CircleOffIcon", ()=>(0, _circleOffJsDefault.default));
parcelHelpers.export(exports, "LucideCircleOff", ()=>(0, _circleOffJsDefault.default));
parcelHelpers.export(exports, "CircleSlash", ()=>(0, _circleSlashJsDefault.default));
parcelHelpers.export(exports, "CircleSlashIcon", ()=>(0, _circleSlashJsDefault.default));
parcelHelpers.export(exports, "LucideCircleSlash", ()=>(0, _circleSlashJsDefault.default));
parcelHelpers.export(exports, "Circle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "CircleIcon", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "LucideCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "CircuitBoard", ()=>(0, _circuitBoardJsDefault.default));
parcelHelpers.export(exports, "CircuitBoardIcon", ()=>(0, _circuitBoardJsDefault.default));
parcelHelpers.export(exports, "LucideCircuitBoard", ()=>(0, _circuitBoardJsDefault.default));
parcelHelpers.export(exports, "Citrus", ()=>(0, _citrusJsDefault.default));
parcelHelpers.export(exports, "CitrusIcon", ()=>(0, _citrusJsDefault.default));
parcelHelpers.export(exports, "LucideCitrus", ()=>(0, _citrusJsDefault.default));
parcelHelpers.export(exports, "Clapperboard", ()=>(0, _clapperboardJsDefault.default));
parcelHelpers.export(exports, "ClapperboardIcon", ()=>(0, _clapperboardJsDefault.default));
parcelHelpers.export(exports, "LucideClapperboard", ()=>(0, _clapperboardJsDefault.default));
parcelHelpers.export(exports, "ClipboardCheck", ()=>(0, _clipboardCheckJsDefault.default));
parcelHelpers.export(exports, "ClipboardCheckIcon", ()=>(0, _clipboardCheckJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardCheck", ()=>(0, _clipboardCheckJsDefault.default));
parcelHelpers.export(exports, "ClipboardCopy", ()=>(0, _clipboardCopyJsDefault.default));
parcelHelpers.export(exports, "ClipboardCopyIcon", ()=>(0, _clipboardCopyJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardCopy", ()=>(0, _clipboardCopyJsDefault.default));
parcelHelpers.export(exports, "ClipboardList", ()=>(0, _clipboardListJsDefault.default));
parcelHelpers.export(exports, "ClipboardListIcon", ()=>(0, _clipboardListJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardList", ()=>(0, _clipboardListJsDefault.default));
parcelHelpers.export(exports, "ClipboardMinus", ()=>(0, _clipboardMinusJsDefault.default));
parcelHelpers.export(exports, "ClipboardMinusIcon", ()=>(0, _clipboardMinusJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardMinus", ()=>(0, _clipboardMinusJsDefault.default));
parcelHelpers.export(exports, "ClipboardPaste", ()=>(0, _clipboardPasteJsDefault.default));
parcelHelpers.export(exports, "ClipboardPasteIcon", ()=>(0, _clipboardPasteJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardPaste", ()=>(0, _clipboardPasteJsDefault.default));
parcelHelpers.export(exports, "ClipboardPlus", ()=>(0, _clipboardPlusJsDefault.default));
parcelHelpers.export(exports, "ClipboardPlusIcon", ()=>(0, _clipboardPlusJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardPlus", ()=>(0, _clipboardPlusJsDefault.default));
parcelHelpers.export(exports, "ClipboardType", ()=>(0, _clipboardTypeJsDefault.default));
parcelHelpers.export(exports, "ClipboardTypeIcon", ()=>(0, _clipboardTypeJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardType", ()=>(0, _clipboardTypeJsDefault.default));
parcelHelpers.export(exports, "ClipboardX", ()=>(0, _clipboardXJsDefault.default));
parcelHelpers.export(exports, "ClipboardXIcon", ()=>(0, _clipboardXJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardX", ()=>(0, _clipboardXJsDefault.default));
parcelHelpers.export(exports, "Clipboard", ()=>(0, _clipboardJsDefault.default));
parcelHelpers.export(exports, "ClipboardIcon", ()=>(0, _clipboardJsDefault.default));
parcelHelpers.export(exports, "LucideClipboard", ()=>(0, _clipboardJsDefault.default));
parcelHelpers.export(exports, "Clock1", ()=>(0, _clock1JsDefault.default));
parcelHelpers.export(exports, "Clock1Icon", ()=>(0, _clock1JsDefault.default));
parcelHelpers.export(exports, "LucideClock1", ()=>(0, _clock1JsDefault.default));
parcelHelpers.export(exports, "Clock10", ()=>(0, _clock10JsDefault.default));
parcelHelpers.export(exports, "Clock10Icon", ()=>(0, _clock10JsDefault.default));
parcelHelpers.export(exports, "LucideClock10", ()=>(0, _clock10JsDefault.default));
parcelHelpers.export(exports, "Clock11", ()=>(0, _clock11JsDefault.default));
parcelHelpers.export(exports, "Clock11Icon", ()=>(0, _clock11JsDefault.default));
parcelHelpers.export(exports, "LucideClock11", ()=>(0, _clock11JsDefault.default));
parcelHelpers.export(exports, "Clock12", ()=>(0, _clock12JsDefault.default));
parcelHelpers.export(exports, "Clock12Icon", ()=>(0, _clock12JsDefault.default));
parcelHelpers.export(exports, "LucideClock12", ()=>(0, _clock12JsDefault.default));
parcelHelpers.export(exports, "Clock2", ()=>(0, _clock2JsDefault.default));
parcelHelpers.export(exports, "Clock2Icon", ()=>(0, _clock2JsDefault.default));
parcelHelpers.export(exports, "LucideClock2", ()=>(0, _clock2JsDefault.default));
parcelHelpers.export(exports, "Clock3", ()=>(0, _clock3JsDefault.default));
parcelHelpers.export(exports, "Clock3Icon", ()=>(0, _clock3JsDefault.default));
parcelHelpers.export(exports, "LucideClock3", ()=>(0, _clock3JsDefault.default));
parcelHelpers.export(exports, "Clock4", ()=>(0, _clock4JsDefault.default));
parcelHelpers.export(exports, "Clock4Icon", ()=>(0, _clock4JsDefault.default));
parcelHelpers.export(exports, "LucideClock4", ()=>(0, _clock4JsDefault.default));
parcelHelpers.export(exports, "Clock5", ()=>(0, _clock5JsDefault.default));
parcelHelpers.export(exports, "Clock5Icon", ()=>(0, _clock5JsDefault.default));
parcelHelpers.export(exports, "LucideClock5", ()=>(0, _clock5JsDefault.default));
parcelHelpers.export(exports, "Clock6", ()=>(0, _clock6JsDefault.default));
parcelHelpers.export(exports, "Clock6Icon", ()=>(0, _clock6JsDefault.default));
parcelHelpers.export(exports, "LucideClock6", ()=>(0, _clock6JsDefault.default));
parcelHelpers.export(exports, "Clock7", ()=>(0, _clock7JsDefault.default));
parcelHelpers.export(exports, "Clock7Icon", ()=>(0, _clock7JsDefault.default));
parcelHelpers.export(exports, "LucideClock7", ()=>(0, _clock7JsDefault.default));
parcelHelpers.export(exports, "Clock8", ()=>(0, _clock8JsDefault.default));
parcelHelpers.export(exports, "Clock8Icon", ()=>(0, _clock8JsDefault.default));
parcelHelpers.export(exports, "LucideClock8", ()=>(0, _clock8JsDefault.default));
parcelHelpers.export(exports, "Clock9", ()=>(0, _clock9JsDefault.default));
parcelHelpers.export(exports, "Clock9Icon", ()=>(0, _clock9JsDefault.default));
parcelHelpers.export(exports, "LucideClock9", ()=>(0, _clock9JsDefault.default));
parcelHelpers.export(exports, "Clock", ()=>(0, _clockJsDefault.default));
parcelHelpers.export(exports, "ClockIcon", ()=>(0, _clockJsDefault.default));
parcelHelpers.export(exports, "LucideClock", ()=>(0, _clockJsDefault.default));
parcelHelpers.export(exports, "CloudCog", ()=>(0, _cloudCogJsDefault.default));
parcelHelpers.export(exports, "CloudCogIcon", ()=>(0, _cloudCogJsDefault.default));
parcelHelpers.export(exports, "LucideCloudCog", ()=>(0, _cloudCogJsDefault.default));
parcelHelpers.export(exports, "CloudDrizzle", ()=>(0, _cloudDrizzleJsDefault.default));
parcelHelpers.export(exports, "CloudDrizzleIcon", ()=>(0, _cloudDrizzleJsDefault.default));
parcelHelpers.export(exports, "LucideCloudDrizzle", ()=>(0, _cloudDrizzleJsDefault.default));
parcelHelpers.export(exports, "CloudFog", ()=>(0, _cloudFogJsDefault.default));
parcelHelpers.export(exports, "CloudFogIcon", ()=>(0, _cloudFogJsDefault.default));
parcelHelpers.export(exports, "LucideCloudFog", ()=>(0, _cloudFogJsDefault.default));
parcelHelpers.export(exports, "CloudHail", ()=>(0, _cloudHailJsDefault.default));
parcelHelpers.export(exports, "CloudHailIcon", ()=>(0, _cloudHailJsDefault.default));
parcelHelpers.export(exports, "LucideCloudHail", ()=>(0, _cloudHailJsDefault.default));
parcelHelpers.export(exports, "CloudLightning", ()=>(0, _cloudLightningJsDefault.default));
parcelHelpers.export(exports, "CloudLightningIcon", ()=>(0, _cloudLightningJsDefault.default));
parcelHelpers.export(exports, "LucideCloudLightning", ()=>(0, _cloudLightningJsDefault.default));
parcelHelpers.export(exports, "CloudMoonRain", ()=>(0, _cloudMoonRainJsDefault.default));
parcelHelpers.export(exports, "CloudMoonRainIcon", ()=>(0, _cloudMoonRainJsDefault.default));
parcelHelpers.export(exports, "LucideCloudMoonRain", ()=>(0, _cloudMoonRainJsDefault.default));
parcelHelpers.export(exports, "CloudMoon", ()=>(0, _cloudMoonJsDefault.default));
parcelHelpers.export(exports, "CloudMoonIcon", ()=>(0, _cloudMoonJsDefault.default));
parcelHelpers.export(exports, "LucideCloudMoon", ()=>(0, _cloudMoonJsDefault.default));
parcelHelpers.export(exports, "CloudOff", ()=>(0, _cloudOffJsDefault.default));
parcelHelpers.export(exports, "CloudOffIcon", ()=>(0, _cloudOffJsDefault.default));
parcelHelpers.export(exports, "LucideCloudOff", ()=>(0, _cloudOffJsDefault.default));
parcelHelpers.export(exports, "CloudRainWind", ()=>(0, _cloudRainWindJsDefault.default));
parcelHelpers.export(exports, "CloudRainWindIcon", ()=>(0, _cloudRainWindJsDefault.default));
parcelHelpers.export(exports, "LucideCloudRainWind", ()=>(0, _cloudRainWindJsDefault.default));
parcelHelpers.export(exports, "CloudRain", ()=>(0, _cloudRainJsDefault.default));
parcelHelpers.export(exports, "CloudRainIcon", ()=>(0, _cloudRainJsDefault.default));
parcelHelpers.export(exports, "LucideCloudRain", ()=>(0, _cloudRainJsDefault.default));
parcelHelpers.export(exports, "CloudSnow", ()=>(0, _cloudSnowJsDefault.default));
parcelHelpers.export(exports, "CloudSnowIcon", ()=>(0, _cloudSnowJsDefault.default));
parcelHelpers.export(exports, "LucideCloudSnow", ()=>(0, _cloudSnowJsDefault.default));
parcelHelpers.export(exports, "CloudSunRain", ()=>(0, _cloudSunRainJsDefault.default));
parcelHelpers.export(exports, "CloudSunRainIcon", ()=>(0, _cloudSunRainJsDefault.default));
parcelHelpers.export(exports, "LucideCloudSunRain", ()=>(0, _cloudSunRainJsDefault.default));
parcelHelpers.export(exports, "CloudSun", ()=>(0, _cloudSunJsDefault.default));
parcelHelpers.export(exports, "CloudSunIcon", ()=>(0, _cloudSunJsDefault.default));
parcelHelpers.export(exports, "LucideCloudSun", ()=>(0, _cloudSunJsDefault.default));
parcelHelpers.export(exports, "Cloud", ()=>(0, _cloudJsDefault.default));
parcelHelpers.export(exports, "CloudIcon", ()=>(0, _cloudJsDefault.default));
parcelHelpers.export(exports, "LucideCloud", ()=>(0, _cloudJsDefault.default));
parcelHelpers.export(exports, "Cloudy", ()=>(0, _cloudyJsDefault.default));
parcelHelpers.export(exports, "CloudyIcon", ()=>(0, _cloudyJsDefault.default));
parcelHelpers.export(exports, "LucideCloudy", ()=>(0, _cloudyJsDefault.default));
parcelHelpers.export(exports, "Clover", ()=>(0, _cloverJsDefault.default));
parcelHelpers.export(exports, "CloverIcon", ()=>(0, _cloverJsDefault.default));
parcelHelpers.export(exports, "LucideClover", ()=>(0, _cloverJsDefault.default));
parcelHelpers.export(exports, "Club", ()=>(0, _clubJsDefault.default));
parcelHelpers.export(exports, "ClubIcon", ()=>(0, _clubJsDefault.default));
parcelHelpers.export(exports, "LucideClub", ()=>(0, _clubJsDefault.default));
parcelHelpers.export(exports, "Code2", ()=>(0, _code2JsDefault.default));
parcelHelpers.export(exports, "Code2Icon", ()=>(0, _code2JsDefault.default));
parcelHelpers.export(exports, "LucideCode2", ()=>(0, _code2JsDefault.default));
parcelHelpers.export(exports, "Code", ()=>(0, _codeJsDefault.default));
parcelHelpers.export(exports, "CodeIcon", ()=>(0, _codeJsDefault.default));
parcelHelpers.export(exports, "LucideCode", ()=>(0, _codeJsDefault.default));
parcelHelpers.export(exports, "Codepen", ()=>(0, _codepenJsDefault.default));
parcelHelpers.export(exports, "CodepenIcon", ()=>(0, _codepenJsDefault.default));
parcelHelpers.export(exports, "LucideCodepen", ()=>(0, _codepenJsDefault.default));
parcelHelpers.export(exports, "Codesandbox", ()=>(0, _codesandboxJsDefault.default));
parcelHelpers.export(exports, "CodesandboxIcon", ()=>(0, _codesandboxJsDefault.default));
parcelHelpers.export(exports, "LucideCodesandbox", ()=>(0, _codesandboxJsDefault.default));
parcelHelpers.export(exports, "Coffee", ()=>(0, _coffeeJsDefault.default));
parcelHelpers.export(exports, "CoffeeIcon", ()=>(0, _coffeeJsDefault.default));
parcelHelpers.export(exports, "LucideCoffee", ()=>(0, _coffeeJsDefault.default));
parcelHelpers.export(exports, "Cog", ()=>(0, _cogJsDefault.default));
parcelHelpers.export(exports, "CogIcon", ()=>(0, _cogJsDefault.default));
parcelHelpers.export(exports, "LucideCog", ()=>(0, _cogJsDefault.default));
parcelHelpers.export(exports, "Coins", ()=>(0, _coinsJsDefault.default));
parcelHelpers.export(exports, "CoinsIcon", ()=>(0, _coinsJsDefault.default));
parcelHelpers.export(exports, "LucideCoins", ()=>(0, _coinsJsDefault.default));
parcelHelpers.export(exports, "Columns4", ()=>(0, _columns4JsDefault.default));
parcelHelpers.export(exports, "Columns4Icon", ()=>(0, _columns4JsDefault.default));
parcelHelpers.export(exports, "LucideColumns4", ()=>(0, _columns4JsDefault.default));
parcelHelpers.export(exports, "Combine", ()=>(0, _combineJsDefault.default));
parcelHelpers.export(exports, "CombineIcon", ()=>(0, _combineJsDefault.default));
parcelHelpers.export(exports, "LucideCombine", ()=>(0, _combineJsDefault.default));
parcelHelpers.export(exports, "Command", ()=>(0, _commandJsDefault.default));
parcelHelpers.export(exports, "CommandIcon", ()=>(0, _commandJsDefault.default));
parcelHelpers.export(exports, "LucideCommand", ()=>(0, _commandJsDefault.default));
parcelHelpers.export(exports, "Compass", ()=>(0, _compassJsDefault.default));
parcelHelpers.export(exports, "CompassIcon", ()=>(0, _compassJsDefault.default));
parcelHelpers.export(exports, "LucideCompass", ()=>(0, _compassJsDefault.default));
parcelHelpers.export(exports, "Component", ()=>(0, _componentJsDefault.default));
parcelHelpers.export(exports, "ComponentIcon", ()=>(0, _componentJsDefault.default));
parcelHelpers.export(exports, "LucideComponent", ()=>(0, _componentJsDefault.default));
parcelHelpers.export(exports, "Computer", ()=>(0, _computerJsDefault.default));
parcelHelpers.export(exports, "ComputerIcon", ()=>(0, _computerJsDefault.default));
parcelHelpers.export(exports, "LucideComputer", ()=>(0, _computerJsDefault.default));
parcelHelpers.export(exports, "ConciergeBell", ()=>(0, _conciergeBellJsDefault.default));
parcelHelpers.export(exports, "ConciergeBellIcon", ()=>(0, _conciergeBellJsDefault.default));
parcelHelpers.export(exports, "LucideConciergeBell", ()=>(0, _conciergeBellJsDefault.default));
parcelHelpers.export(exports, "Cone", ()=>(0, _coneJsDefault.default));
parcelHelpers.export(exports, "ConeIcon", ()=>(0, _coneJsDefault.default));
parcelHelpers.export(exports, "LucideCone", ()=>(0, _coneJsDefault.default));
parcelHelpers.export(exports, "Construction", ()=>(0, _constructionJsDefault.default));
parcelHelpers.export(exports, "ConstructionIcon", ()=>(0, _constructionJsDefault.default));
parcelHelpers.export(exports, "LucideConstruction", ()=>(0, _constructionJsDefault.default));
parcelHelpers.export(exports, "Contact2", ()=>(0, _contact2JsDefault.default));
parcelHelpers.export(exports, "Contact2Icon", ()=>(0, _contact2JsDefault.default));
parcelHelpers.export(exports, "LucideContact2", ()=>(0, _contact2JsDefault.default));
parcelHelpers.export(exports, "Contact", ()=>(0, _contactJsDefault.default));
parcelHelpers.export(exports, "ContactIcon", ()=>(0, _contactJsDefault.default));
parcelHelpers.export(exports, "LucideContact", ()=>(0, _contactJsDefault.default));
parcelHelpers.export(exports, "Container", ()=>(0, _containerJsDefault.default));
parcelHelpers.export(exports, "ContainerIcon", ()=>(0, _containerJsDefault.default));
parcelHelpers.export(exports, "LucideContainer", ()=>(0, _containerJsDefault.default));
parcelHelpers.export(exports, "Contrast", ()=>(0, _contrastJsDefault.default));
parcelHelpers.export(exports, "ContrastIcon", ()=>(0, _contrastJsDefault.default));
parcelHelpers.export(exports, "LucideContrast", ()=>(0, _contrastJsDefault.default));
parcelHelpers.export(exports, "Cookie", ()=>(0, _cookieJsDefault.default));
parcelHelpers.export(exports, "CookieIcon", ()=>(0, _cookieJsDefault.default));
parcelHelpers.export(exports, "LucideCookie", ()=>(0, _cookieJsDefault.default));
parcelHelpers.export(exports, "CookingPot", ()=>(0, _cookingPotJsDefault.default));
parcelHelpers.export(exports, "CookingPotIcon", ()=>(0, _cookingPotJsDefault.default));
parcelHelpers.export(exports, "LucideCookingPot", ()=>(0, _cookingPotJsDefault.default));
parcelHelpers.export(exports, "CopyCheck", ()=>(0, _copyCheckJsDefault.default));
parcelHelpers.export(exports, "CopyCheckIcon", ()=>(0, _copyCheckJsDefault.default));
parcelHelpers.export(exports, "LucideCopyCheck", ()=>(0, _copyCheckJsDefault.default));
parcelHelpers.export(exports, "CopyMinus", ()=>(0, _copyMinusJsDefault.default));
parcelHelpers.export(exports, "CopyMinusIcon", ()=>(0, _copyMinusJsDefault.default));
parcelHelpers.export(exports, "LucideCopyMinus", ()=>(0, _copyMinusJsDefault.default));
parcelHelpers.export(exports, "CopyPlus", ()=>(0, _copyPlusJsDefault.default));
parcelHelpers.export(exports, "CopyPlusIcon", ()=>(0, _copyPlusJsDefault.default));
parcelHelpers.export(exports, "LucideCopyPlus", ()=>(0, _copyPlusJsDefault.default));
parcelHelpers.export(exports, "CopySlash", ()=>(0, _copySlashJsDefault.default));
parcelHelpers.export(exports, "CopySlashIcon", ()=>(0, _copySlashJsDefault.default));
parcelHelpers.export(exports, "LucideCopySlash", ()=>(0, _copySlashJsDefault.default));
parcelHelpers.export(exports, "CopyX", ()=>(0, _copyXJsDefault.default));
parcelHelpers.export(exports, "CopyXIcon", ()=>(0, _copyXJsDefault.default));
parcelHelpers.export(exports, "LucideCopyX", ()=>(0, _copyXJsDefault.default));
parcelHelpers.export(exports, "Copy", ()=>(0, _copyJsDefault.default));
parcelHelpers.export(exports, "CopyIcon", ()=>(0, _copyJsDefault.default));
parcelHelpers.export(exports, "LucideCopy", ()=>(0, _copyJsDefault.default));
parcelHelpers.export(exports, "Copyleft", ()=>(0, _copyleftJsDefault.default));
parcelHelpers.export(exports, "CopyleftIcon", ()=>(0, _copyleftJsDefault.default));
parcelHelpers.export(exports, "LucideCopyleft", ()=>(0, _copyleftJsDefault.default));
parcelHelpers.export(exports, "Copyright", ()=>(0, _copyrightJsDefault.default));
parcelHelpers.export(exports, "CopyrightIcon", ()=>(0, _copyrightJsDefault.default));
parcelHelpers.export(exports, "LucideCopyright", ()=>(0, _copyrightJsDefault.default));
parcelHelpers.export(exports, "CornerDownLeft", ()=>(0, _cornerDownLeftJsDefault.default));
parcelHelpers.export(exports, "CornerDownLeftIcon", ()=>(0, _cornerDownLeftJsDefault.default));
parcelHelpers.export(exports, "LucideCornerDownLeft", ()=>(0, _cornerDownLeftJsDefault.default));
parcelHelpers.export(exports, "CornerDownRight", ()=>(0, _cornerDownRightJsDefault.default));
parcelHelpers.export(exports, "CornerDownRightIcon", ()=>(0, _cornerDownRightJsDefault.default));
parcelHelpers.export(exports, "LucideCornerDownRight", ()=>(0, _cornerDownRightJsDefault.default));
parcelHelpers.export(exports, "CornerLeftDown", ()=>(0, _cornerLeftDownJsDefault.default));
parcelHelpers.export(exports, "CornerLeftDownIcon", ()=>(0, _cornerLeftDownJsDefault.default));
parcelHelpers.export(exports, "LucideCornerLeftDown", ()=>(0, _cornerLeftDownJsDefault.default));
parcelHelpers.export(exports, "CornerLeftUp", ()=>(0, _cornerLeftUpJsDefault.default));
parcelHelpers.export(exports, "CornerLeftUpIcon", ()=>(0, _cornerLeftUpJsDefault.default));
parcelHelpers.export(exports, "LucideCornerLeftUp", ()=>(0, _cornerLeftUpJsDefault.default));
parcelHelpers.export(exports, "CornerRightDown", ()=>(0, _cornerRightDownJsDefault.default));
parcelHelpers.export(exports, "CornerRightDownIcon", ()=>(0, _cornerRightDownJsDefault.default));
parcelHelpers.export(exports, "LucideCornerRightDown", ()=>(0, _cornerRightDownJsDefault.default));
parcelHelpers.export(exports, "CornerRightUp", ()=>(0, _cornerRightUpJsDefault.default));
parcelHelpers.export(exports, "CornerRightUpIcon", ()=>(0, _cornerRightUpJsDefault.default));
parcelHelpers.export(exports, "LucideCornerRightUp", ()=>(0, _cornerRightUpJsDefault.default));
parcelHelpers.export(exports, "CornerUpLeft", ()=>(0, _cornerUpLeftJsDefault.default));
parcelHelpers.export(exports, "CornerUpLeftIcon", ()=>(0, _cornerUpLeftJsDefault.default));
parcelHelpers.export(exports, "LucideCornerUpLeft", ()=>(0, _cornerUpLeftJsDefault.default));
parcelHelpers.export(exports, "CornerUpRight", ()=>(0, _cornerUpRightJsDefault.default));
parcelHelpers.export(exports, "CornerUpRightIcon", ()=>(0, _cornerUpRightJsDefault.default));
parcelHelpers.export(exports, "LucideCornerUpRight", ()=>(0, _cornerUpRightJsDefault.default));
parcelHelpers.export(exports, "Cpu", ()=>(0, _cpuJsDefault.default));
parcelHelpers.export(exports, "CpuIcon", ()=>(0, _cpuJsDefault.default));
parcelHelpers.export(exports, "LucideCpu", ()=>(0, _cpuJsDefault.default));
parcelHelpers.export(exports, "CreativeCommons", ()=>(0, _creativeCommonsJsDefault.default));
parcelHelpers.export(exports, "CreativeCommonsIcon", ()=>(0, _creativeCommonsJsDefault.default));
parcelHelpers.export(exports, "LucideCreativeCommons", ()=>(0, _creativeCommonsJsDefault.default));
parcelHelpers.export(exports, "CreditCard", ()=>(0, _creditCardJsDefault.default));
parcelHelpers.export(exports, "CreditCardIcon", ()=>(0, _creditCardJsDefault.default));
parcelHelpers.export(exports, "LucideCreditCard", ()=>(0, _creditCardJsDefault.default));
parcelHelpers.export(exports, "Croissant", ()=>(0, _croissantJsDefault.default));
parcelHelpers.export(exports, "CroissantIcon", ()=>(0, _croissantJsDefault.default));
parcelHelpers.export(exports, "LucideCroissant", ()=>(0, _croissantJsDefault.default));
parcelHelpers.export(exports, "Crop", ()=>(0, _cropJsDefault.default));
parcelHelpers.export(exports, "CropIcon", ()=>(0, _cropJsDefault.default));
parcelHelpers.export(exports, "LucideCrop", ()=>(0, _cropJsDefault.default));
parcelHelpers.export(exports, "Cross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "CrossIcon", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "LucideCross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "Crosshair", ()=>(0, _crosshairJsDefault.default));
parcelHelpers.export(exports, "CrosshairIcon", ()=>(0, _crosshairJsDefault.default));
parcelHelpers.export(exports, "LucideCrosshair", ()=>(0, _crosshairJsDefault.default));
parcelHelpers.export(exports, "Crown", ()=>(0, _crownJsDefault.default));
parcelHelpers.export(exports, "CrownIcon", ()=>(0, _crownJsDefault.default));
parcelHelpers.export(exports, "LucideCrown", ()=>(0, _crownJsDefault.default));
parcelHelpers.export(exports, "Cuboid", ()=>(0, _cuboidJsDefault.default));
parcelHelpers.export(exports, "CuboidIcon", ()=>(0, _cuboidJsDefault.default));
parcelHelpers.export(exports, "LucideCuboid", ()=>(0, _cuboidJsDefault.default));
parcelHelpers.export(exports, "CupSoda", ()=>(0, _cupSodaJsDefault.default));
parcelHelpers.export(exports, "CupSodaIcon", ()=>(0, _cupSodaJsDefault.default));
parcelHelpers.export(exports, "LucideCupSoda", ()=>(0, _cupSodaJsDefault.default));
parcelHelpers.export(exports, "Currency", ()=>(0, _currencyJsDefault.default));
parcelHelpers.export(exports, "CurrencyIcon", ()=>(0, _currencyJsDefault.default));
parcelHelpers.export(exports, "LucideCurrency", ()=>(0, _currencyJsDefault.default));
parcelHelpers.export(exports, "Cylinder", ()=>(0, _cylinderJsDefault.default));
parcelHelpers.export(exports, "CylinderIcon", ()=>(0, _cylinderJsDefault.default));
parcelHelpers.export(exports, "LucideCylinder", ()=>(0, _cylinderJsDefault.default));
parcelHelpers.export(exports, "DatabaseBackup", ()=>(0, _databaseBackupJsDefault.default));
parcelHelpers.export(exports, "DatabaseBackupIcon", ()=>(0, _databaseBackupJsDefault.default));
parcelHelpers.export(exports, "LucideDatabaseBackup", ()=>(0, _databaseBackupJsDefault.default));
parcelHelpers.export(exports, "DatabaseZap", ()=>(0, _databaseZapJsDefault.default));
parcelHelpers.export(exports, "DatabaseZapIcon", ()=>(0, _databaseZapJsDefault.default));
parcelHelpers.export(exports, "LucideDatabaseZap", ()=>(0, _databaseZapJsDefault.default));
parcelHelpers.export(exports, "Database", ()=>(0, _databaseJsDefault.default));
parcelHelpers.export(exports, "DatabaseIcon", ()=>(0, _databaseJsDefault.default));
parcelHelpers.export(exports, "LucideDatabase", ()=>(0, _databaseJsDefault.default));
parcelHelpers.export(exports, "Delete", ()=>(0, _deleteJsDefault.default));
parcelHelpers.export(exports, "DeleteIcon", ()=>(0, _deleteJsDefault.default));
parcelHelpers.export(exports, "LucideDelete", ()=>(0, _deleteJsDefault.default));
parcelHelpers.export(exports, "Dessert", ()=>(0, _dessertJsDefault.default));
parcelHelpers.export(exports, "DessertIcon", ()=>(0, _dessertJsDefault.default));
parcelHelpers.export(exports, "LucideDessert", ()=>(0, _dessertJsDefault.default));
parcelHelpers.export(exports, "Diameter", ()=>(0, _diameterJsDefault.default));
parcelHelpers.export(exports, "DiameterIcon", ()=>(0, _diameterJsDefault.default));
parcelHelpers.export(exports, "LucideDiameter", ()=>(0, _diameterJsDefault.default));
parcelHelpers.export(exports, "Diamond", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "DiamondIcon", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "LucideDiamond", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "Dice1", ()=>(0, _dice1JsDefault.default));
parcelHelpers.export(exports, "Dice1Icon", ()=>(0, _dice1JsDefault.default));
parcelHelpers.export(exports, "LucideDice1", ()=>(0, _dice1JsDefault.default));
parcelHelpers.export(exports, "Dice2", ()=>(0, _dice2JsDefault.default));
parcelHelpers.export(exports, "Dice2Icon", ()=>(0, _dice2JsDefault.default));
parcelHelpers.export(exports, "LucideDice2", ()=>(0, _dice2JsDefault.default));
parcelHelpers.export(exports, "Dice3", ()=>(0, _dice3JsDefault.default));
parcelHelpers.export(exports, "Dice3Icon", ()=>(0, _dice3JsDefault.default));
parcelHelpers.export(exports, "LucideDice3", ()=>(0, _dice3JsDefault.default));
parcelHelpers.export(exports, "Dice4", ()=>(0, _dice4JsDefault.default));
parcelHelpers.export(exports, "Dice4Icon", ()=>(0, _dice4JsDefault.default));
parcelHelpers.export(exports, "LucideDice4", ()=>(0, _dice4JsDefault.default));
parcelHelpers.export(exports, "Dice5", ()=>(0, _dice5JsDefault.default));
parcelHelpers.export(exports, "Dice5Icon", ()=>(0, _dice5JsDefault.default));
parcelHelpers.export(exports, "LucideDice5", ()=>(0, _dice5JsDefault.default));
parcelHelpers.export(exports, "Dice6", ()=>(0, _dice6JsDefault.default));
parcelHelpers.export(exports, "Dice6Icon", ()=>(0, _dice6JsDefault.default));
parcelHelpers.export(exports, "LucideDice6", ()=>(0, _dice6JsDefault.default));
parcelHelpers.export(exports, "Dices", ()=>(0, _dicesJsDefault.default));
parcelHelpers.export(exports, "DicesIcon", ()=>(0, _dicesJsDefault.default));
parcelHelpers.export(exports, "LucideDices", ()=>(0, _dicesJsDefault.default));
parcelHelpers.export(exports, "Diff", ()=>(0, _diffJsDefault.default));
parcelHelpers.export(exports, "DiffIcon", ()=>(0, _diffJsDefault.default));
parcelHelpers.export(exports, "LucideDiff", ()=>(0, _diffJsDefault.default));
parcelHelpers.export(exports, "Disc2", ()=>(0, _disc2JsDefault.default));
parcelHelpers.export(exports, "Disc2Icon", ()=>(0, _disc2JsDefault.default));
parcelHelpers.export(exports, "LucideDisc2", ()=>(0, _disc2JsDefault.default));
parcelHelpers.export(exports, "Disc3", ()=>(0, _disc3JsDefault.default));
parcelHelpers.export(exports, "Disc3Icon", ()=>(0, _disc3JsDefault.default));
parcelHelpers.export(exports, "LucideDisc3", ()=>(0, _disc3JsDefault.default));
parcelHelpers.export(exports, "DiscAlbum", ()=>(0, _discAlbumJsDefault.default));
parcelHelpers.export(exports, "DiscAlbumIcon", ()=>(0, _discAlbumJsDefault.default));
parcelHelpers.export(exports, "LucideDiscAlbum", ()=>(0, _discAlbumJsDefault.default));
parcelHelpers.export(exports, "Disc", ()=>(0, _discJsDefault.default));
parcelHelpers.export(exports, "DiscIcon", ()=>(0, _discJsDefault.default));
parcelHelpers.export(exports, "LucideDisc", ()=>(0, _discJsDefault.default));
parcelHelpers.export(exports, "DivideCircle", ()=>(0, _divideCircleJsDefault.default));
parcelHelpers.export(exports, "DivideCircleIcon", ()=>(0, _divideCircleJsDefault.default));
parcelHelpers.export(exports, "LucideDivideCircle", ()=>(0, _divideCircleJsDefault.default));
parcelHelpers.export(exports, "DivideSquare", ()=>(0, _divideSquareJsDefault.default));
parcelHelpers.export(exports, "DivideSquareIcon", ()=>(0, _divideSquareJsDefault.default));
parcelHelpers.export(exports, "LucideDivideSquare", ()=>(0, _divideSquareJsDefault.default));
parcelHelpers.export(exports, "Divide", ()=>(0, _divideJsDefault.default));
parcelHelpers.export(exports, "DivideIcon", ()=>(0, _divideJsDefault.default));
parcelHelpers.export(exports, "LucideDivide", ()=>(0, _divideJsDefault.default));
parcelHelpers.export(exports, "DnaOff", ()=>(0, _dnaOffJsDefault.default));
parcelHelpers.export(exports, "DnaOffIcon", ()=>(0, _dnaOffJsDefault.default));
parcelHelpers.export(exports, "LucideDnaOff", ()=>(0, _dnaOffJsDefault.default));
parcelHelpers.export(exports, "Dna", ()=>(0, _dnaJsDefault.default));
parcelHelpers.export(exports, "DnaIcon", ()=>(0, _dnaJsDefault.default));
parcelHelpers.export(exports, "LucideDna", ()=>(0, _dnaJsDefault.default));
parcelHelpers.export(exports, "Dog", ()=>(0, _dogJsDefault.default));
parcelHelpers.export(exports, "DogIcon", ()=>(0, _dogJsDefault.default));
parcelHelpers.export(exports, "LucideDog", ()=>(0, _dogJsDefault.default));
parcelHelpers.export(exports, "DollarSign", ()=>(0, _dollarSignJsDefault.default));
parcelHelpers.export(exports, "DollarSignIcon", ()=>(0, _dollarSignJsDefault.default));
parcelHelpers.export(exports, "LucideDollarSign", ()=>(0, _dollarSignJsDefault.default));
parcelHelpers.export(exports, "Donut", ()=>(0, _donutJsDefault.default));
parcelHelpers.export(exports, "DonutIcon", ()=>(0, _donutJsDefault.default));
parcelHelpers.export(exports, "LucideDonut", ()=>(0, _donutJsDefault.default));
parcelHelpers.export(exports, "DoorClosed", ()=>(0, _doorClosedJsDefault.default));
parcelHelpers.export(exports, "DoorClosedIcon", ()=>(0, _doorClosedJsDefault.default));
parcelHelpers.export(exports, "LucideDoorClosed", ()=>(0, _doorClosedJsDefault.default));
parcelHelpers.export(exports, "DoorOpen", ()=>(0, _doorOpenJsDefault.default));
parcelHelpers.export(exports, "DoorOpenIcon", ()=>(0, _doorOpenJsDefault.default));
parcelHelpers.export(exports, "LucideDoorOpen", ()=>(0, _doorOpenJsDefault.default));
parcelHelpers.export(exports, "Dot", ()=>(0, _dotJsDefault.default));
parcelHelpers.export(exports, "DotIcon", ()=>(0, _dotJsDefault.default));
parcelHelpers.export(exports, "LucideDot", ()=>(0, _dotJsDefault.default));
parcelHelpers.export(exports, "DownloadCloud", ()=>(0, _downloadCloudJsDefault.default));
parcelHelpers.export(exports, "DownloadCloudIcon", ()=>(0, _downloadCloudJsDefault.default));
parcelHelpers.export(exports, "LucideDownloadCloud", ()=>(0, _downloadCloudJsDefault.default));
parcelHelpers.export(exports, "Download", ()=>(0, _downloadJsDefault.default));
parcelHelpers.export(exports, "DownloadIcon", ()=>(0, _downloadJsDefault.default));
parcelHelpers.export(exports, "LucideDownload", ()=>(0, _downloadJsDefault.default));
parcelHelpers.export(exports, "DraftingCompass", ()=>(0, _draftingCompassJsDefault.default));
parcelHelpers.export(exports, "DraftingCompassIcon", ()=>(0, _draftingCompassJsDefault.default));
parcelHelpers.export(exports, "LucideDraftingCompass", ()=>(0, _draftingCompassJsDefault.default));
parcelHelpers.export(exports, "Drama", ()=>(0, _dramaJsDefault.default));
parcelHelpers.export(exports, "DramaIcon", ()=>(0, _dramaJsDefault.default));
parcelHelpers.export(exports, "LucideDrama", ()=>(0, _dramaJsDefault.default));
parcelHelpers.export(exports, "Dribbble", ()=>(0, _dribbbleJsDefault.default));
parcelHelpers.export(exports, "DribbbleIcon", ()=>(0, _dribbbleJsDefault.default));
parcelHelpers.export(exports, "LucideDribbble", ()=>(0, _dribbbleJsDefault.default));
parcelHelpers.export(exports, "Drill", ()=>(0, _drillJsDefault.default));
parcelHelpers.export(exports, "DrillIcon", ()=>(0, _drillJsDefault.default));
parcelHelpers.export(exports, "LucideDrill", ()=>(0, _drillJsDefault.default));
parcelHelpers.export(exports, "Droplet", ()=>(0, _dropletJsDefault.default));
parcelHelpers.export(exports, "DropletIcon", ()=>(0, _dropletJsDefault.default));
parcelHelpers.export(exports, "LucideDroplet", ()=>(0, _dropletJsDefault.default));
parcelHelpers.export(exports, "Droplets", ()=>(0, _dropletsJsDefault.default));
parcelHelpers.export(exports, "DropletsIcon", ()=>(0, _dropletsJsDefault.default));
parcelHelpers.export(exports, "LucideDroplets", ()=>(0, _dropletsJsDefault.default));
parcelHelpers.export(exports, "Drum", ()=>(0, _drumJsDefault.default));
parcelHelpers.export(exports, "DrumIcon", ()=>(0, _drumJsDefault.default));
parcelHelpers.export(exports, "LucideDrum", ()=>(0, _drumJsDefault.default));
parcelHelpers.export(exports, "Drumstick", ()=>(0, _drumstickJsDefault.default));
parcelHelpers.export(exports, "DrumstickIcon", ()=>(0, _drumstickJsDefault.default));
parcelHelpers.export(exports, "LucideDrumstick", ()=>(0, _drumstickJsDefault.default));
parcelHelpers.export(exports, "Dumbbell", ()=>(0, _dumbbellJsDefault.default));
parcelHelpers.export(exports, "DumbbellIcon", ()=>(0, _dumbbellJsDefault.default));
parcelHelpers.export(exports, "LucideDumbbell", ()=>(0, _dumbbellJsDefault.default));
parcelHelpers.export(exports, "EarOff", ()=>(0, _earOffJsDefault.default));
parcelHelpers.export(exports, "EarOffIcon", ()=>(0, _earOffJsDefault.default));
parcelHelpers.export(exports, "LucideEarOff", ()=>(0, _earOffJsDefault.default));
parcelHelpers.export(exports, "Ear", ()=>(0, _earJsDefault.default));
parcelHelpers.export(exports, "EarIcon", ()=>(0, _earJsDefault.default));
parcelHelpers.export(exports, "LucideEar", ()=>(0, _earJsDefault.default));
parcelHelpers.export(exports, "EarthLock", ()=>(0, _earthLockJsDefault.default));
parcelHelpers.export(exports, "EarthLockIcon", ()=>(0, _earthLockJsDefault.default));
parcelHelpers.export(exports, "LucideEarthLock", ()=>(0, _earthLockJsDefault.default));
parcelHelpers.export(exports, "Eclipse", ()=>(0, _eclipseJsDefault.default));
parcelHelpers.export(exports, "EclipseIcon", ()=>(0, _eclipseJsDefault.default));
parcelHelpers.export(exports, "LucideEclipse", ()=>(0, _eclipseJsDefault.default));
parcelHelpers.export(exports, "EggFried", ()=>(0, _eggFriedJsDefault.default));
parcelHelpers.export(exports, "EggFriedIcon", ()=>(0, _eggFriedJsDefault.default));
parcelHelpers.export(exports, "LucideEggFried", ()=>(0, _eggFriedJsDefault.default));
parcelHelpers.export(exports, "EggOff", ()=>(0, _eggOffJsDefault.default));
parcelHelpers.export(exports, "EggOffIcon", ()=>(0, _eggOffJsDefault.default));
parcelHelpers.export(exports, "LucideEggOff", ()=>(0, _eggOffJsDefault.default));
parcelHelpers.export(exports, "Egg", ()=>(0, _eggJsDefault.default));
parcelHelpers.export(exports, "EggIcon", ()=>(0, _eggJsDefault.default));
parcelHelpers.export(exports, "LucideEgg", ()=>(0, _eggJsDefault.default));
parcelHelpers.export(exports, "EqualNot", ()=>(0, _equalNotJsDefault.default));
parcelHelpers.export(exports, "EqualNotIcon", ()=>(0, _equalNotJsDefault.default));
parcelHelpers.export(exports, "LucideEqualNot", ()=>(0, _equalNotJsDefault.default));
parcelHelpers.export(exports, "Equal", ()=>(0, _equalJsDefault.default));
parcelHelpers.export(exports, "EqualIcon", ()=>(0, _equalJsDefault.default));
parcelHelpers.export(exports, "LucideEqual", ()=>(0, _equalJsDefault.default));
parcelHelpers.export(exports, "Eraser", ()=>(0, _eraserJsDefault.default));
parcelHelpers.export(exports, "EraserIcon", ()=>(0, _eraserJsDefault.default));
parcelHelpers.export(exports, "LucideEraser", ()=>(0, _eraserJsDefault.default));
parcelHelpers.export(exports, "Euro", ()=>(0, _euroJsDefault.default));
parcelHelpers.export(exports, "EuroIcon", ()=>(0, _euroJsDefault.default));
parcelHelpers.export(exports, "LucideEuro", ()=>(0, _euroJsDefault.default));
parcelHelpers.export(exports, "Expand", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "ExpandIcon", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "LucideExpand", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "ExternalLink", ()=>(0, _externalLinkJsDefault.default));
parcelHelpers.export(exports, "ExternalLinkIcon", ()=>(0, _externalLinkJsDefault.default));
parcelHelpers.export(exports, "LucideExternalLink", ()=>(0, _externalLinkJsDefault.default));
parcelHelpers.export(exports, "EyeOff", ()=>(0, _eyeOffJsDefault.default));
parcelHelpers.export(exports, "EyeOffIcon", ()=>(0, _eyeOffJsDefault.default));
parcelHelpers.export(exports, "LucideEyeOff", ()=>(0, _eyeOffJsDefault.default));
parcelHelpers.export(exports, "Eye", ()=>(0, _eyeJsDefault.default));
parcelHelpers.export(exports, "EyeIcon", ()=>(0, _eyeJsDefault.default));
parcelHelpers.export(exports, "LucideEye", ()=>(0, _eyeJsDefault.default));
parcelHelpers.export(exports, "Facebook", ()=>(0, _facebookJsDefault.default));
parcelHelpers.export(exports, "FacebookIcon", ()=>(0, _facebookJsDefault.default));
parcelHelpers.export(exports, "LucideFacebook", ()=>(0, _facebookJsDefault.default));
parcelHelpers.export(exports, "Factory", ()=>(0, _factoryJsDefault.default));
parcelHelpers.export(exports, "FactoryIcon", ()=>(0, _factoryJsDefault.default));
parcelHelpers.export(exports, "LucideFactory", ()=>(0, _factoryJsDefault.default));
parcelHelpers.export(exports, "Fan", ()=>(0, _fanJsDefault.default));
parcelHelpers.export(exports, "FanIcon", ()=>(0, _fanJsDefault.default));
parcelHelpers.export(exports, "LucideFan", ()=>(0, _fanJsDefault.default));
parcelHelpers.export(exports, "FastForward", ()=>(0, _fastForwardJsDefault.default));
parcelHelpers.export(exports, "FastForwardIcon", ()=>(0, _fastForwardJsDefault.default));
parcelHelpers.export(exports, "LucideFastForward", ()=>(0, _fastForwardJsDefault.default));
parcelHelpers.export(exports, "Feather", ()=>(0, _featherJsDefault.default));
parcelHelpers.export(exports, "FeatherIcon", ()=>(0, _featherJsDefault.default));
parcelHelpers.export(exports, "LucideFeather", ()=>(0, _featherJsDefault.default));
parcelHelpers.export(exports, "Fence", ()=>(0, _fenceJsDefault.default));
parcelHelpers.export(exports, "FenceIcon", ()=>(0, _fenceJsDefault.default));
parcelHelpers.export(exports, "LucideFence", ()=>(0, _fenceJsDefault.default));
parcelHelpers.export(exports, "FerrisWheel", ()=>(0, _ferrisWheelJsDefault.default));
parcelHelpers.export(exports, "FerrisWheelIcon", ()=>(0, _ferrisWheelJsDefault.default));
parcelHelpers.export(exports, "LucideFerrisWheel", ()=>(0, _ferrisWheelJsDefault.default));
parcelHelpers.export(exports, "Figma", ()=>(0, _figmaJsDefault.default));
parcelHelpers.export(exports, "FigmaIcon", ()=>(0, _figmaJsDefault.default));
parcelHelpers.export(exports, "LucideFigma", ()=>(0, _figmaJsDefault.default));
parcelHelpers.export(exports, "FileArchive", ()=>(0, _fileArchiveJsDefault.default));
parcelHelpers.export(exports, "FileArchiveIcon", ()=>(0, _fileArchiveJsDefault.default));
parcelHelpers.export(exports, "LucideFileArchive", ()=>(0, _fileArchiveJsDefault.default));
parcelHelpers.export(exports, "FileAudio2", ()=>(0, _fileAudio2JsDefault.default));
parcelHelpers.export(exports, "FileAudio2Icon", ()=>(0, _fileAudio2JsDefault.default));
parcelHelpers.export(exports, "LucideFileAudio2", ()=>(0, _fileAudio2JsDefault.default));
parcelHelpers.export(exports, "FileAudio", ()=>(0, _fileAudioJsDefault.default));
parcelHelpers.export(exports, "FileAudioIcon", ()=>(0, _fileAudioJsDefault.default));
parcelHelpers.export(exports, "LucideFileAudio", ()=>(0, _fileAudioJsDefault.default));
parcelHelpers.export(exports, "FileBadge2", ()=>(0, _fileBadge2JsDefault.default));
parcelHelpers.export(exports, "FileBadge2Icon", ()=>(0, _fileBadge2JsDefault.default));
parcelHelpers.export(exports, "LucideFileBadge2", ()=>(0, _fileBadge2JsDefault.default));
parcelHelpers.export(exports, "FileBadge", ()=>(0, _fileBadgeJsDefault.default));
parcelHelpers.export(exports, "FileBadgeIcon", ()=>(0, _fileBadgeJsDefault.default));
parcelHelpers.export(exports, "LucideFileBadge", ()=>(0, _fileBadgeJsDefault.default));
parcelHelpers.export(exports, "FileBarChart2", ()=>(0, _fileBarChart2JsDefault.default));
parcelHelpers.export(exports, "FileBarChart2Icon", ()=>(0, _fileBarChart2JsDefault.default));
parcelHelpers.export(exports, "LucideFileBarChart2", ()=>(0, _fileBarChart2JsDefault.default));
parcelHelpers.export(exports, "FileBarChart", ()=>(0, _fileBarChartJsDefault.default));
parcelHelpers.export(exports, "FileBarChartIcon", ()=>(0, _fileBarChartJsDefault.default));
parcelHelpers.export(exports, "LucideFileBarChart", ()=>(0, _fileBarChartJsDefault.default));
parcelHelpers.export(exports, "FileBox", ()=>(0, _fileBoxJsDefault.default));
parcelHelpers.export(exports, "FileBoxIcon", ()=>(0, _fileBoxJsDefault.default));
parcelHelpers.export(exports, "LucideFileBox", ()=>(0, _fileBoxJsDefault.default));
parcelHelpers.export(exports, "FileCheck2", ()=>(0, _fileCheck2JsDefault.default));
parcelHelpers.export(exports, "FileCheck2Icon", ()=>(0, _fileCheck2JsDefault.default));
parcelHelpers.export(exports, "LucideFileCheck2", ()=>(0, _fileCheck2JsDefault.default));
parcelHelpers.export(exports, "FileCheck", ()=>(0, _fileCheckJsDefault.default));
parcelHelpers.export(exports, "FileCheckIcon", ()=>(0, _fileCheckJsDefault.default));
parcelHelpers.export(exports, "LucideFileCheck", ()=>(0, _fileCheckJsDefault.default));
parcelHelpers.export(exports, "FileClock", ()=>(0, _fileClockJsDefault.default));
parcelHelpers.export(exports, "FileClockIcon", ()=>(0, _fileClockJsDefault.default));
parcelHelpers.export(exports, "LucideFileClock", ()=>(0, _fileClockJsDefault.default));
parcelHelpers.export(exports, "FileCode2", ()=>(0, _fileCode2JsDefault.default));
parcelHelpers.export(exports, "FileCode2Icon", ()=>(0, _fileCode2JsDefault.default));
parcelHelpers.export(exports, "LucideFileCode2", ()=>(0, _fileCode2JsDefault.default));
parcelHelpers.export(exports, "FileCode", ()=>(0, _fileCodeJsDefault.default));
parcelHelpers.export(exports, "FileCodeIcon", ()=>(0, _fileCodeJsDefault.default));
parcelHelpers.export(exports, "LucideFileCode", ()=>(0, _fileCodeJsDefault.default));
parcelHelpers.export(exports, "FileDiff", ()=>(0, _fileDiffJsDefault.default));
parcelHelpers.export(exports, "FileDiffIcon", ()=>(0, _fileDiffJsDefault.default));
parcelHelpers.export(exports, "LucideFileDiff", ()=>(0, _fileDiffJsDefault.default));
parcelHelpers.export(exports, "FileDigit", ()=>(0, _fileDigitJsDefault.default));
parcelHelpers.export(exports, "FileDigitIcon", ()=>(0, _fileDigitJsDefault.default));
parcelHelpers.export(exports, "LucideFileDigit", ()=>(0, _fileDigitJsDefault.default));
parcelHelpers.export(exports, "FileDown", ()=>(0, _fileDownJsDefault.default));
parcelHelpers.export(exports, "FileDownIcon", ()=>(0, _fileDownJsDefault.default));
parcelHelpers.export(exports, "LucideFileDown", ()=>(0, _fileDownJsDefault.default));
parcelHelpers.export(exports, "FileHeart", ()=>(0, _fileHeartJsDefault.default));
parcelHelpers.export(exports, "FileHeartIcon", ()=>(0, _fileHeartJsDefault.default));
parcelHelpers.export(exports, "LucideFileHeart", ()=>(0, _fileHeartJsDefault.default));
parcelHelpers.export(exports, "FileImage", ()=>(0, _fileImageJsDefault.default));
parcelHelpers.export(exports, "FileImageIcon", ()=>(0, _fileImageJsDefault.default));
parcelHelpers.export(exports, "LucideFileImage", ()=>(0, _fileImageJsDefault.default));
parcelHelpers.export(exports, "FileInput", ()=>(0, _fileInputJsDefault.default));
parcelHelpers.export(exports, "FileInputIcon", ()=>(0, _fileInputJsDefault.default));
parcelHelpers.export(exports, "LucideFileInput", ()=>(0, _fileInputJsDefault.default));
parcelHelpers.export(exports, "FileJson2", ()=>(0, _fileJson2JsDefault.default));
parcelHelpers.export(exports, "FileJson2Icon", ()=>(0, _fileJson2JsDefault.default));
parcelHelpers.export(exports, "LucideFileJson2", ()=>(0, _fileJson2JsDefault.default));
parcelHelpers.export(exports, "FileJson", ()=>(0, _fileJsonJsDefault.default));
parcelHelpers.export(exports, "FileJsonIcon", ()=>(0, _fileJsonJsDefault.default));
parcelHelpers.export(exports, "LucideFileJson", ()=>(0, _fileJsonJsDefault.default));
parcelHelpers.export(exports, "FileKey2", ()=>(0, _fileKey2JsDefault.default));
parcelHelpers.export(exports, "FileKey2Icon", ()=>(0, _fileKey2JsDefault.default));
parcelHelpers.export(exports, "LucideFileKey2", ()=>(0, _fileKey2JsDefault.default));
parcelHelpers.export(exports, "FileKey", ()=>(0, _fileKeyJsDefault.default));
parcelHelpers.export(exports, "FileKeyIcon", ()=>(0, _fileKeyJsDefault.default));
parcelHelpers.export(exports, "LucideFileKey", ()=>(0, _fileKeyJsDefault.default));
parcelHelpers.export(exports, "FileLineChart", ()=>(0, _fileLineChartJsDefault.default));
parcelHelpers.export(exports, "FileLineChartIcon", ()=>(0, _fileLineChartJsDefault.default));
parcelHelpers.export(exports, "LucideFileLineChart", ()=>(0, _fileLineChartJsDefault.default));
parcelHelpers.export(exports, "FileLock2", ()=>(0, _fileLock2JsDefault.default));
parcelHelpers.export(exports, "FileLock2Icon", ()=>(0, _fileLock2JsDefault.default));
parcelHelpers.export(exports, "LucideFileLock2", ()=>(0, _fileLock2JsDefault.default));
parcelHelpers.export(exports, "FileLock", ()=>(0, _fileLockJsDefault.default));
parcelHelpers.export(exports, "FileLockIcon", ()=>(0, _fileLockJsDefault.default));
parcelHelpers.export(exports, "LucideFileLock", ()=>(0, _fileLockJsDefault.default));
parcelHelpers.export(exports, "FileMinus2", ()=>(0, _fileMinus2JsDefault.default));
parcelHelpers.export(exports, "FileMinus2Icon", ()=>(0, _fileMinus2JsDefault.default));
parcelHelpers.export(exports, "LucideFileMinus2", ()=>(0, _fileMinus2JsDefault.default));
parcelHelpers.export(exports, "FileMinus", ()=>(0, _fileMinusJsDefault.default));
parcelHelpers.export(exports, "FileMinusIcon", ()=>(0, _fileMinusJsDefault.default));
parcelHelpers.export(exports, "LucideFileMinus", ()=>(0, _fileMinusJsDefault.default));
parcelHelpers.export(exports, "FileMusic", ()=>(0, _fileMusicJsDefault.default));
parcelHelpers.export(exports, "FileMusicIcon", ()=>(0, _fileMusicJsDefault.default));
parcelHelpers.export(exports, "LucideFileMusic", ()=>(0, _fileMusicJsDefault.default));
parcelHelpers.export(exports, "FileOutput", ()=>(0, _fileOutputJsDefault.default));
parcelHelpers.export(exports, "FileOutputIcon", ()=>(0, _fileOutputJsDefault.default));
parcelHelpers.export(exports, "LucideFileOutput", ()=>(0, _fileOutputJsDefault.default));
parcelHelpers.export(exports, "FilePieChart", ()=>(0, _filePieChartJsDefault.default));
parcelHelpers.export(exports, "FilePieChartIcon", ()=>(0, _filePieChartJsDefault.default));
parcelHelpers.export(exports, "LucideFilePieChart", ()=>(0, _filePieChartJsDefault.default));
parcelHelpers.export(exports, "FilePlus2", ()=>(0, _filePlus2JsDefault.default));
parcelHelpers.export(exports, "FilePlus2Icon", ()=>(0, _filePlus2JsDefault.default));
parcelHelpers.export(exports, "LucideFilePlus2", ()=>(0, _filePlus2JsDefault.default));
parcelHelpers.export(exports, "FilePlus", ()=>(0, _filePlusJsDefault.default));
parcelHelpers.export(exports, "FilePlusIcon", ()=>(0, _filePlusJsDefault.default));
parcelHelpers.export(exports, "LucideFilePlus", ()=>(0, _filePlusJsDefault.default));
parcelHelpers.export(exports, "FileQuestion", ()=>(0, _fileQuestionJsDefault.default));
parcelHelpers.export(exports, "FileQuestionIcon", ()=>(0, _fileQuestionJsDefault.default));
parcelHelpers.export(exports, "LucideFileQuestion", ()=>(0, _fileQuestionJsDefault.default));
parcelHelpers.export(exports, "FileScan", ()=>(0, _fileScanJsDefault.default));
parcelHelpers.export(exports, "FileScanIcon", ()=>(0, _fileScanJsDefault.default));
parcelHelpers.export(exports, "LucideFileScan", ()=>(0, _fileScanJsDefault.default));
parcelHelpers.export(exports, "FileSearch2", ()=>(0, _fileSearch2JsDefault.default));
parcelHelpers.export(exports, "FileSearch2Icon", ()=>(0, _fileSearch2JsDefault.default));
parcelHelpers.export(exports, "LucideFileSearch2", ()=>(0, _fileSearch2JsDefault.default));
parcelHelpers.export(exports, "FileSearch", ()=>(0, _fileSearchJsDefault.default));
parcelHelpers.export(exports, "FileSearchIcon", ()=>(0, _fileSearchJsDefault.default));
parcelHelpers.export(exports, "LucideFileSearch", ()=>(0, _fileSearchJsDefault.default));
parcelHelpers.export(exports, "FileSliders", ()=>(0, _fileSlidersJsDefault.default));
parcelHelpers.export(exports, "FileSlidersIcon", ()=>(0, _fileSlidersJsDefault.default));
parcelHelpers.export(exports, "LucideFileSliders", ()=>(0, _fileSlidersJsDefault.default));
parcelHelpers.export(exports, "FileSpreadsheet", ()=>(0, _fileSpreadsheetJsDefault.default));
parcelHelpers.export(exports, "FileSpreadsheetIcon", ()=>(0, _fileSpreadsheetJsDefault.default));
parcelHelpers.export(exports, "LucideFileSpreadsheet", ()=>(0, _fileSpreadsheetJsDefault.default));
parcelHelpers.export(exports, "FileStack", ()=>(0, _fileStackJsDefault.default));
parcelHelpers.export(exports, "FileStackIcon", ()=>(0, _fileStackJsDefault.default));
parcelHelpers.export(exports, "LucideFileStack", ()=>(0, _fileStackJsDefault.default));
parcelHelpers.export(exports, "FileSymlink", ()=>(0, _fileSymlinkJsDefault.default));
parcelHelpers.export(exports, "FileSymlinkIcon", ()=>(0, _fileSymlinkJsDefault.default));
parcelHelpers.export(exports, "LucideFileSymlink", ()=>(0, _fileSymlinkJsDefault.default));
parcelHelpers.export(exports, "FileTerminal", ()=>(0, _fileTerminalJsDefault.default));
parcelHelpers.export(exports, "FileTerminalIcon", ()=>(0, _fileTerminalJsDefault.default));
parcelHelpers.export(exports, "LucideFileTerminal", ()=>(0, _fileTerminalJsDefault.default));
parcelHelpers.export(exports, "FileText", ()=>(0, _fileTextJsDefault.default));
parcelHelpers.export(exports, "FileTextIcon", ()=>(0, _fileTextJsDefault.default));
parcelHelpers.export(exports, "LucideFileText", ()=>(0, _fileTextJsDefault.default));
parcelHelpers.export(exports, "FileType2", ()=>(0, _fileType2JsDefault.default));
parcelHelpers.export(exports, "FileType2Icon", ()=>(0, _fileType2JsDefault.default));
parcelHelpers.export(exports, "LucideFileType2", ()=>(0, _fileType2JsDefault.default));
parcelHelpers.export(exports, "FileType", ()=>(0, _fileTypeJsDefault.default));
parcelHelpers.export(exports, "FileTypeIcon", ()=>(0, _fileTypeJsDefault.default));
parcelHelpers.export(exports, "LucideFileType", ()=>(0, _fileTypeJsDefault.default));
parcelHelpers.export(exports, "FileUp", ()=>(0, _fileUpJsDefault.default));
parcelHelpers.export(exports, "FileUpIcon", ()=>(0, _fileUpJsDefault.default));
parcelHelpers.export(exports, "LucideFileUp", ()=>(0, _fileUpJsDefault.default));
parcelHelpers.export(exports, "FileVideo2", ()=>(0, _fileVideo2JsDefault.default));
parcelHelpers.export(exports, "FileVideo2Icon", ()=>(0, _fileVideo2JsDefault.default));
parcelHelpers.export(exports, "LucideFileVideo2", ()=>(0, _fileVideo2JsDefault.default));
parcelHelpers.export(exports, "FileVideo", ()=>(0, _fileVideoJsDefault.default));
parcelHelpers.export(exports, "FileVideoIcon", ()=>(0, _fileVideoJsDefault.default));
parcelHelpers.export(exports, "LucideFileVideo", ()=>(0, _fileVideoJsDefault.default));
parcelHelpers.export(exports, "FileVolume2", ()=>(0, _fileVolume2JsDefault.default));
parcelHelpers.export(exports, "FileVolume2Icon", ()=>(0, _fileVolume2JsDefault.default));
parcelHelpers.export(exports, "LucideFileVolume2", ()=>(0, _fileVolume2JsDefault.default));
parcelHelpers.export(exports, "FileVolume", ()=>(0, _fileVolumeJsDefault.default));
parcelHelpers.export(exports, "FileVolumeIcon", ()=>(0, _fileVolumeJsDefault.default));
parcelHelpers.export(exports, "LucideFileVolume", ()=>(0, _fileVolumeJsDefault.default));
parcelHelpers.export(exports, "FileWarning", ()=>(0, _fileWarningJsDefault.default));
parcelHelpers.export(exports, "FileWarningIcon", ()=>(0, _fileWarningJsDefault.default));
parcelHelpers.export(exports, "LucideFileWarning", ()=>(0, _fileWarningJsDefault.default));
parcelHelpers.export(exports, "FileX2", ()=>(0, _fileX2JsDefault.default));
parcelHelpers.export(exports, "FileX2Icon", ()=>(0, _fileX2JsDefault.default));
parcelHelpers.export(exports, "LucideFileX2", ()=>(0, _fileX2JsDefault.default));
parcelHelpers.export(exports, "FileX", ()=>(0, _fileXJsDefault.default));
parcelHelpers.export(exports, "FileXIcon", ()=>(0, _fileXJsDefault.default));
parcelHelpers.export(exports, "LucideFileX", ()=>(0, _fileXJsDefault.default));
parcelHelpers.export(exports, "File", ()=>(0, _fileJsDefault.default));
parcelHelpers.export(exports, "FileIcon", ()=>(0, _fileJsDefault.default));
parcelHelpers.export(exports, "LucideFile", ()=>(0, _fileJsDefault.default));
parcelHelpers.export(exports, "Files", ()=>(0, _filesJsDefault.default));
parcelHelpers.export(exports, "FilesIcon", ()=>(0, _filesJsDefault.default));
parcelHelpers.export(exports, "LucideFiles", ()=>(0, _filesJsDefault.default));
parcelHelpers.export(exports, "Film", ()=>(0, _filmJsDefault.default));
parcelHelpers.export(exports, "FilmIcon", ()=>(0, _filmJsDefault.default));
parcelHelpers.export(exports, "LucideFilm", ()=>(0, _filmJsDefault.default));
parcelHelpers.export(exports, "FilterX", ()=>(0, _filterXJsDefault.default));
parcelHelpers.export(exports, "FilterXIcon", ()=>(0, _filterXJsDefault.default));
parcelHelpers.export(exports, "LucideFilterX", ()=>(0, _filterXJsDefault.default));
parcelHelpers.export(exports, "Filter", ()=>(0, _filterJsDefault.default));
parcelHelpers.export(exports, "FilterIcon", ()=>(0, _filterJsDefault.default));
parcelHelpers.export(exports, "LucideFilter", ()=>(0, _filterJsDefault.default));
parcelHelpers.export(exports, "Fingerprint", ()=>(0, _fingerprintJsDefault.default));
parcelHelpers.export(exports, "FingerprintIcon", ()=>(0, _fingerprintJsDefault.default));
parcelHelpers.export(exports, "LucideFingerprint", ()=>(0, _fingerprintJsDefault.default));
parcelHelpers.export(exports, "FireExtinguisher", ()=>(0, _fireExtinguisherJsDefault.default));
parcelHelpers.export(exports, "FireExtinguisherIcon", ()=>(0, _fireExtinguisherJsDefault.default));
parcelHelpers.export(exports, "LucideFireExtinguisher", ()=>(0, _fireExtinguisherJsDefault.default));
parcelHelpers.export(exports, "FishOff", ()=>(0, _fishOffJsDefault.default));
parcelHelpers.export(exports, "FishOffIcon", ()=>(0, _fishOffJsDefault.default));
parcelHelpers.export(exports, "LucideFishOff", ()=>(0, _fishOffJsDefault.default));
parcelHelpers.export(exports, "FishSymbol", ()=>(0, _fishSymbolJsDefault.default));
parcelHelpers.export(exports, "FishSymbolIcon", ()=>(0, _fishSymbolJsDefault.default));
parcelHelpers.export(exports, "LucideFishSymbol", ()=>(0, _fishSymbolJsDefault.default));
parcelHelpers.export(exports, "Fish", ()=>(0, _fishJsDefault.default));
parcelHelpers.export(exports, "FishIcon", ()=>(0, _fishJsDefault.default));
parcelHelpers.export(exports, "LucideFish", ()=>(0, _fishJsDefault.default));
parcelHelpers.export(exports, "FlagOff", ()=>(0, _flagOffJsDefault.default));
parcelHelpers.export(exports, "FlagOffIcon", ()=>(0, _flagOffJsDefault.default));
parcelHelpers.export(exports, "LucideFlagOff", ()=>(0, _flagOffJsDefault.default));
parcelHelpers.export(exports, "FlagTriangleLeft", ()=>(0, _flagTriangleLeftJsDefault.default));
parcelHelpers.export(exports, "FlagTriangleLeftIcon", ()=>(0, _flagTriangleLeftJsDefault.default));
parcelHelpers.export(exports, "LucideFlagTriangleLeft", ()=>(0, _flagTriangleLeftJsDefault.default));
parcelHelpers.export(exports, "FlagTriangleRight", ()=>(0, _flagTriangleRightJsDefault.default));
parcelHelpers.export(exports, "FlagTriangleRightIcon", ()=>(0, _flagTriangleRightJsDefault.default));
parcelHelpers.export(exports, "LucideFlagTriangleRight", ()=>(0, _flagTriangleRightJsDefault.default));
parcelHelpers.export(exports, "Flag", ()=>(0, _flagJsDefault.default));
parcelHelpers.export(exports, "FlagIcon", ()=>(0, _flagJsDefault.default));
parcelHelpers.export(exports, "LucideFlag", ()=>(0, _flagJsDefault.default));
parcelHelpers.export(exports, "FlameKindling", ()=>(0, _flameKindlingJsDefault.default));
parcelHelpers.export(exports, "FlameKindlingIcon", ()=>(0, _flameKindlingJsDefault.default));
parcelHelpers.export(exports, "LucideFlameKindling", ()=>(0, _flameKindlingJsDefault.default));
parcelHelpers.export(exports, "Flame", ()=>(0, _flameJsDefault.default));
parcelHelpers.export(exports, "FlameIcon", ()=>(0, _flameJsDefault.default));
parcelHelpers.export(exports, "LucideFlame", ()=>(0, _flameJsDefault.default));
parcelHelpers.export(exports, "FlashlightOff", ()=>(0, _flashlightOffJsDefault.default));
parcelHelpers.export(exports, "FlashlightOffIcon", ()=>(0, _flashlightOffJsDefault.default));
parcelHelpers.export(exports, "LucideFlashlightOff", ()=>(0, _flashlightOffJsDefault.default));
parcelHelpers.export(exports, "Flashlight", ()=>(0, _flashlightJsDefault.default));
parcelHelpers.export(exports, "FlashlightIcon", ()=>(0, _flashlightJsDefault.default));
parcelHelpers.export(exports, "LucideFlashlight", ()=>(0, _flashlightJsDefault.default));
parcelHelpers.export(exports, "FlaskConicalOff", ()=>(0, _flaskConicalOffJsDefault.default));
parcelHelpers.export(exports, "FlaskConicalOffIcon", ()=>(0, _flaskConicalOffJsDefault.default));
parcelHelpers.export(exports, "LucideFlaskConicalOff", ()=>(0, _flaskConicalOffJsDefault.default));
parcelHelpers.export(exports, "FlaskConical", ()=>(0, _flaskConicalJsDefault.default));
parcelHelpers.export(exports, "FlaskConicalIcon", ()=>(0, _flaskConicalJsDefault.default));
parcelHelpers.export(exports, "LucideFlaskConical", ()=>(0, _flaskConicalJsDefault.default));
parcelHelpers.export(exports, "FlaskRound", ()=>(0, _flaskRoundJsDefault.default));
parcelHelpers.export(exports, "FlaskRoundIcon", ()=>(0, _flaskRoundJsDefault.default));
parcelHelpers.export(exports, "LucideFlaskRound", ()=>(0, _flaskRoundJsDefault.default));
parcelHelpers.export(exports, "FlipHorizontal2", ()=>(0, _flipHorizontal2JsDefault.default));
parcelHelpers.export(exports, "FlipHorizontal2Icon", ()=>(0, _flipHorizontal2JsDefault.default));
parcelHelpers.export(exports, "LucideFlipHorizontal2", ()=>(0, _flipHorizontal2JsDefault.default));
parcelHelpers.export(exports, "FlipHorizontal", ()=>(0, _flipHorizontalJsDefault.default));
parcelHelpers.export(exports, "FlipHorizontalIcon", ()=>(0, _flipHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideFlipHorizontal", ()=>(0, _flipHorizontalJsDefault.default));
parcelHelpers.export(exports, "FlipVertical2", ()=>(0, _flipVertical2JsDefault.default));
parcelHelpers.export(exports, "FlipVertical2Icon", ()=>(0, _flipVertical2JsDefault.default));
parcelHelpers.export(exports, "LucideFlipVertical2", ()=>(0, _flipVertical2JsDefault.default));
parcelHelpers.export(exports, "FlipVertical", ()=>(0, _flipVerticalJsDefault.default));
parcelHelpers.export(exports, "FlipVerticalIcon", ()=>(0, _flipVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideFlipVertical", ()=>(0, _flipVerticalJsDefault.default));
parcelHelpers.export(exports, "Flower2", ()=>(0, _flower2JsDefault.default));
parcelHelpers.export(exports, "Flower2Icon", ()=>(0, _flower2JsDefault.default));
parcelHelpers.export(exports, "LucideFlower2", ()=>(0, _flower2JsDefault.default));
parcelHelpers.export(exports, "Flower", ()=>(0, _flowerJsDefault.default));
parcelHelpers.export(exports, "FlowerIcon", ()=>(0, _flowerJsDefault.default));
parcelHelpers.export(exports, "LucideFlower", ()=>(0, _flowerJsDefault.default));
parcelHelpers.export(exports, "Focus", ()=>(0, _focusJsDefault.default));
parcelHelpers.export(exports, "FocusIcon", ()=>(0, _focusJsDefault.default));
parcelHelpers.export(exports, "LucideFocus", ()=>(0, _focusJsDefault.default));
parcelHelpers.export(exports, "FoldHorizontal", ()=>(0, _foldHorizontalJsDefault.default));
parcelHelpers.export(exports, "FoldHorizontalIcon", ()=>(0, _foldHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideFoldHorizontal", ()=>(0, _foldHorizontalJsDefault.default));
parcelHelpers.export(exports, "FoldVertical", ()=>(0, _foldVerticalJsDefault.default));
parcelHelpers.export(exports, "FoldVerticalIcon", ()=>(0, _foldVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideFoldVertical", ()=>(0, _foldVerticalJsDefault.default));
parcelHelpers.export(exports, "FolderArchive", ()=>(0, _folderArchiveJsDefault.default));
parcelHelpers.export(exports, "FolderArchiveIcon", ()=>(0, _folderArchiveJsDefault.default));
parcelHelpers.export(exports, "LucideFolderArchive", ()=>(0, _folderArchiveJsDefault.default));
parcelHelpers.export(exports, "FolderCheck", ()=>(0, _folderCheckJsDefault.default));
parcelHelpers.export(exports, "FolderCheckIcon", ()=>(0, _folderCheckJsDefault.default));
parcelHelpers.export(exports, "LucideFolderCheck", ()=>(0, _folderCheckJsDefault.default));
parcelHelpers.export(exports, "FolderClock", ()=>(0, _folderClockJsDefault.default));
parcelHelpers.export(exports, "FolderClockIcon", ()=>(0, _folderClockJsDefault.default));
parcelHelpers.export(exports, "LucideFolderClock", ()=>(0, _folderClockJsDefault.default));
parcelHelpers.export(exports, "FolderClosed", ()=>(0, _folderClosedJsDefault.default));
parcelHelpers.export(exports, "FolderClosedIcon", ()=>(0, _folderClosedJsDefault.default));
parcelHelpers.export(exports, "LucideFolderClosed", ()=>(0, _folderClosedJsDefault.default));
parcelHelpers.export(exports, "FolderDot", ()=>(0, _folderDotJsDefault.default));
parcelHelpers.export(exports, "FolderDotIcon", ()=>(0, _folderDotJsDefault.default));
parcelHelpers.export(exports, "LucideFolderDot", ()=>(0, _folderDotJsDefault.default));
parcelHelpers.export(exports, "FolderDown", ()=>(0, _folderDownJsDefault.default));
parcelHelpers.export(exports, "FolderDownIcon", ()=>(0, _folderDownJsDefault.default));
parcelHelpers.export(exports, "LucideFolderDown", ()=>(0, _folderDownJsDefault.default));
parcelHelpers.export(exports, "FolderGit2", ()=>(0, _folderGit2JsDefault.default));
parcelHelpers.export(exports, "FolderGit2Icon", ()=>(0, _folderGit2JsDefault.default));
parcelHelpers.export(exports, "LucideFolderGit2", ()=>(0, _folderGit2JsDefault.default));
parcelHelpers.export(exports, "FolderGit", ()=>(0, _folderGitJsDefault.default));
parcelHelpers.export(exports, "FolderGitIcon", ()=>(0, _folderGitJsDefault.default));
parcelHelpers.export(exports, "LucideFolderGit", ()=>(0, _folderGitJsDefault.default));
parcelHelpers.export(exports, "FolderHeart", ()=>(0, _folderHeartJsDefault.default));
parcelHelpers.export(exports, "FolderHeartIcon", ()=>(0, _folderHeartJsDefault.default));
parcelHelpers.export(exports, "LucideFolderHeart", ()=>(0, _folderHeartJsDefault.default));
parcelHelpers.export(exports, "FolderInput", ()=>(0, _folderInputJsDefault.default));
parcelHelpers.export(exports, "FolderInputIcon", ()=>(0, _folderInputJsDefault.default));
parcelHelpers.export(exports, "LucideFolderInput", ()=>(0, _folderInputJsDefault.default));
parcelHelpers.export(exports, "FolderKanban", ()=>(0, _folderKanbanJsDefault.default));
parcelHelpers.export(exports, "FolderKanbanIcon", ()=>(0, _folderKanbanJsDefault.default));
parcelHelpers.export(exports, "LucideFolderKanban", ()=>(0, _folderKanbanJsDefault.default));
parcelHelpers.export(exports, "FolderKey", ()=>(0, _folderKeyJsDefault.default));
parcelHelpers.export(exports, "FolderKeyIcon", ()=>(0, _folderKeyJsDefault.default));
parcelHelpers.export(exports, "LucideFolderKey", ()=>(0, _folderKeyJsDefault.default));
parcelHelpers.export(exports, "FolderLock", ()=>(0, _folderLockJsDefault.default));
parcelHelpers.export(exports, "FolderLockIcon", ()=>(0, _folderLockJsDefault.default));
parcelHelpers.export(exports, "LucideFolderLock", ()=>(0, _folderLockJsDefault.default));
parcelHelpers.export(exports, "FolderMinus", ()=>(0, _folderMinusJsDefault.default));
parcelHelpers.export(exports, "FolderMinusIcon", ()=>(0, _folderMinusJsDefault.default));
parcelHelpers.export(exports, "LucideFolderMinus", ()=>(0, _folderMinusJsDefault.default));
parcelHelpers.export(exports, "FolderOpenDot", ()=>(0, _folderOpenDotJsDefault.default));
parcelHelpers.export(exports, "FolderOpenDotIcon", ()=>(0, _folderOpenDotJsDefault.default));
parcelHelpers.export(exports, "LucideFolderOpenDot", ()=>(0, _folderOpenDotJsDefault.default));
parcelHelpers.export(exports, "FolderOpen", ()=>(0, _folderOpenJsDefault.default));
parcelHelpers.export(exports, "FolderOpenIcon", ()=>(0, _folderOpenJsDefault.default));
parcelHelpers.export(exports, "LucideFolderOpen", ()=>(0, _folderOpenJsDefault.default));
parcelHelpers.export(exports, "FolderOutput", ()=>(0, _folderOutputJsDefault.default));
parcelHelpers.export(exports, "FolderOutputIcon", ()=>(0, _folderOutputJsDefault.default));
parcelHelpers.export(exports, "LucideFolderOutput", ()=>(0, _folderOutputJsDefault.default));
parcelHelpers.export(exports, "FolderPlus", ()=>(0, _folderPlusJsDefault.default));
parcelHelpers.export(exports, "FolderPlusIcon", ()=>(0, _folderPlusJsDefault.default));
parcelHelpers.export(exports, "LucideFolderPlus", ()=>(0, _folderPlusJsDefault.default));
parcelHelpers.export(exports, "FolderRoot", ()=>(0, _folderRootJsDefault.default));
parcelHelpers.export(exports, "FolderRootIcon", ()=>(0, _folderRootJsDefault.default));
parcelHelpers.export(exports, "LucideFolderRoot", ()=>(0, _folderRootJsDefault.default));
parcelHelpers.export(exports, "FolderSearch2", ()=>(0, _folderSearch2JsDefault.default));
parcelHelpers.export(exports, "FolderSearch2Icon", ()=>(0, _folderSearch2JsDefault.default));
parcelHelpers.export(exports, "LucideFolderSearch2", ()=>(0, _folderSearch2JsDefault.default));
parcelHelpers.export(exports, "FolderSearch", ()=>(0, _folderSearchJsDefault.default));
parcelHelpers.export(exports, "FolderSearchIcon", ()=>(0, _folderSearchJsDefault.default));
parcelHelpers.export(exports, "LucideFolderSearch", ()=>(0, _folderSearchJsDefault.default));
parcelHelpers.export(exports, "FolderSymlink", ()=>(0, _folderSymlinkJsDefault.default));
parcelHelpers.export(exports, "FolderSymlinkIcon", ()=>(0, _folderSymlinkJsDefault.default));
parcelHelpers.export(exports, "LucideFolderSymlink", ()=>(0, _folderSymlinkJsDefault.default));
parcelHelpers.export(exports, "FolderSync", ()=>(0, _folderSyncJsDefault.default));
parcelHelpers.export(exports, "FolderSyncIcon", ()=>(0, _folderSyncJsDefault.default));
parcelHelpers.export(exports, "LucideFolderSync", ()=>(0, _folderSyncJsDefault.default));
parcelHelpers.export(exports, "FolderTree", ()=>(0, _folderTreeJsDefault.default));
parcelHelpers.export(exports, "FolderTreeIcon", ()=>(0, _folderTreeJsDefault.default));
parcelHelpers.export(exports, "LucideFolderTree", ()=>(0, _folderTreeJsDefault.default));
parcelHelpers.export(exports, "FolderUp", ()=>(0, _folderUpJsDefault.default));
parcelHelpers.export(exports, "FolderUpIcon", ()=>(0, _folderUpJsDefault.default));
parcelHelpers.export(exports, "LucideFolderUp", ()=>(0, _folderUpJsDefault.default));
parcelHelpers.export(exports, "FolderX", ()=>(0, _folderXJsDefault.default));
parcelHelpers.export(exports, "FolderXIcon", ()=>(0, _folderXJsDefault.default));
parcelHelpers.export(exports, "LucideFolderX", ()=>(0, _folderXJsDefault.default));
parcelHelpers.export(exports, "Folder", ()=>(0, _folderJsDefault.default));
parcelHelpers.export(exports, "FolderIcon", ()=>(0, _folderJsDefault.default));
parcelHelpers.export(exports, "LucideFolder", ()=>(0, _folderJsDefault.default));
parcelHelpers.export(exports, "Folders", ()=>(0, _foldersJsDefault.default));
parcelHelpers.export(exports, "FoldersIcon", ()=>(0, _foldersJsDefault.default));
parcelHelpers.export(exports, "LucideFolders", ()=>(0, _foldersJsDefault.default));
parcelHelpers.export(exports, "Footprints", ()=>(0, _footprintsJsDefault.default));
parcelHelpers.export(exports, "FootprintsIcon", ()=>(0, _footprintsJsDefault.default));
parcelHelpers.export(exports, "LucideFootprints", ()=>(0, _footprintsJsDefault.default));
parcelHelpers.export(exports, "Forklift", ()=>(0, _forkliftJsDefault.default));
parcelHelpers.export(exports, "ForkliftIcon", ()=>(0, _forkliftJsDefault.default));
parcelHelpers.export(exports, "LucideForklift", ()=>(0, _forkliftJsDefault.default));
parcelHelpers.export(exports, "FormInput", ()=>(0, _formInputJsDefault.default));
parcelHelpers.export(exports, "FormInputIcon", ()=>(0, _formInputJsDefault.default));
parcelHelpers.export(exports, "LucideFormInput", ()=>(0, _formInputJsDefault.default));
parcelHelpers.export(exports, "Forward", ()=>(0, _forwardJsDefault.default));
parcelHelpers.export(exports, "ForwardIcon", ()=>(0, _forwardJsDefault.default));
parcelHelpers.export(exports, "LucideForward", ()=>(0, _forwardJsDefault.default));
parcelHelpers.export(exports, "Frame", ()=>(0, _frameJsDefault.default));
parcelHelpers.export(exports, "FrameIcon", ()=>(0, _frameJsDefault.default));
parcelHelpers.export(exports, "LucideFrame", ()=>(0, _frameJsDefault.default));
parcelHelpers.export(exports, "Framer", ()=>(0, _framerJsDefault.default));
parcelHelpers.export(exports, "FramerIcon", ()=>(0, _framerJsDefault.default));
parcelHelpers.export(exports, "LucideFramer", ()=>(0, _framerJsDefault.default));
parcelHelpers.export(exports, "Frown", ()=>(0, _frownJsDefault.default));
parcelHelpers.export(exports, "FrownIcon", ()=>(0, _frownJsDefault.default));
parcelHelpers.export(exports, "LucideFrown", ()=>(0, _frownJsDefault.default));
parcelHelpers.export(exports, "Fuel", ()=>(0, _fuelJsDefault.default));
parcelHelpers.export(exports, "FuelIcon", ()=>(0, _fuelJsDefault.default));
parcelHelpers.export(exports, "LucideFuel", ()=>(0, _fuelJsDefault.default));
parcelHelpers.export(exports, "Fullscreen", ()=>(0, _fullscreenJsDefault.default));
parcelHelpers.export(exports, "FullscreenIcon", ()=>(0, _fullscreenJsDefault.default));
parcelHelpers.export(exports, "LucideFullscreen", ()=>(0, _fullscreenJsDefault.default));
parcelHelpers.export(exports, "FunctionSquare", ()=>(0, _functionSquareJsDefault.default));
parcelHelpers.export(exports, "FunctionSquareIcon", ()=>(0, _functionSquareJsDefault.default));
parcelHelpers.export(exports, "LucideFunctionSquare", ()=>(0, _functionSquareJsDefault.default));
parcelHelpers.export(exports, "GalleryHorizontalEnd", ()=>(0, _galleryHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "GalleryHorizontalEndIcon", ()=>(0, _galleryHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "LucideGalleryHorizontalEnd", ()=>(0, _galleryHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "GalleryHorizontal", ()=>(0, _galleryHorizontalJsDefault.default));
parcelHelpers.export(exports, "GalleryHorizontalIcon", ()=>(0, _galleryHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideGalleryHorizontal", ()=>(0, _galleryHorizontalJsDefault.default));
parcelHelpers.export(exports, "GalleryThumbnails", ()=>(0, _galleryThumbnailsJsDefault.default));
parcelHelpers.export(exports, "GalleryThumbnailsIcon", ()=>(0, _galleryThumbnailsJsDefault.default));
parcelHelpers.export(exports, "LucideGalleryThumbnails", ()=>(0, _galleryThumbnailsJsDefault.default));
parcelHelpers.export(exports, "GalleryVerticalEnd", ()=>(0, _galleryVerticalEndJsDefault.default));
parcelHelpers.export(exports, "GalleryVerticalEndIcon", ()=>(0, _galleryVerticalEndJsDefault.default));
parcelHelpers.export(exports, "LucideGalleryVerticalEnd", ()=>(0, _galleryVerticalEndJsDefault.default));
parcelHelpers.export(exports, "GalleryVertical", ()=>(0, _galleryVerticalJsDefault.default));
parcelHelpers.export(exports, "GalleryVerticalIcon", ()=>(0, _galleryVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideGalleryVertical", ()=>(0, _galleryVerticalJsDefault.default));
parcelHelpers.export(exports, "Gamepad2", ()=>(0, _gamepad2JsDefault.default));
parcelHelpers.export(exports, "Gamepad2Icon", ()=>(0, _gamepad2JsDefault.default));
parcelHelpers.export(exports, "LucideGamepad2", ()=>(0, _gamepad2JsDefault.default));
parcelHelpers.export(exports, "Gamepad", ()=>(0, _gamepadJsDefault.default));
parcelHelpers.export(exports, "GamepadIcon", ()=>(0, _gamepadJsDefault.default));
parcelHelpers.export(exports, "LucideGamepad", ()=>(0, _gamepadJsDefault.default));
parcelHelpers.export(exports, "GanttChart", ()=>(0, _ganttChartJsDefault.default));
parcelHelpers.export(exports, "GanttChartIcon", ()=>(0, _ganttChartJsDefault.default));
parcelHelpers.export(exports, "LucideGanttChart", ()=>(0, _ganttChartJsDefault.default));
parcelHelpers.export(exports, "GaugeCircle", ()=>(0, _gaugeCircleJsDefault.default));
parcelHelpers.export(exports, "GaugeCircleIcon", ()=>(0, _gaugeCircleJsDefault.default));
parcelHelpers.export(exports, "LucideGaugeCircle", ()=>(0, _gaugeCircleJsDefault.default));
parcelHelpers.export(exports, "Gauge", ()=>(0, _gaugeJsDefault.default));
parcelHelpers.export(exports, "GaugeIcon", ()=>(0, _gaugeJsDefault.default));
parcelHelpers.export(exports, "LucideGauge", ()=>(0, _gaugeJsDefault.default));
parcelHelpers.export(exports, "Gavel", ()=>(0, _gavelJsDefault.default));
parcelHelpers.export(exports, "GavelIcon", ()=>(0, _gavelJsDefault.default));
parcelHelpers.export(exports, "LucideGavel", ()=>(0, _gavelJsDefault.default));
parcelHelpers.export(exports, "Gem", ()=>(0, _gemJsDefault.default));
parcelHelpers.export(exports, "GemIcon", ()=>(0, _gemJsDefault.default));
parcelHelpers.export(exports, "LucideGem", ()=>(0, _gemJsDefault.default));
parcelHelpers.export(exports, "Ghost", ()=>(0, _ghostJsDefault.default));
parcelHelpers.export(exports, "GhostIcon", ()=>(0, _ghostJsDefault.default));
parcelHelpers.export(exports, "LucideGhost", ()=>(0, _ghostJsDefault.default));
parcelHelpers.export(exports, "Gift", ()=>(0, _giftJsDefault.default));
parcelHelpers.export(exports, "GiftIcon", ()=>(0, _giftJsDefault.default));
parcelHelpers.export(exports, "LucideGift", ()=>(0, _giftJsDefault.default));
parcelHelpers.export(exports, "GitBranchPlus", ()=>(0, _gitBranchPlusJsDefault.default));
parcelHelpers.export(exports, "GitBranchPlusIcon", ()=>(0, _gitBranchPlusJsDefault.default));
parcelHelpers.export(exports, "LucideGitBranchPlus", ()=>(0, _gitBranchPlusJsDefault.default));
parcelHelpers.export(exports, "GitBranch", ()=>(0, _gitBranchJsDefault.default));
parcelHelpers.export(exports, "GitBranchIcon", ()=>(0, _gitBranchJsDefault.default));
parcelHelpers.export(exports, "LucideGitBranch", ()=>(0, _gitBranchJsDefault.default));
parcelHelpers.export(exports, "GitCommitVertical", ()=>(0, _gitCommitVerticalJsDefault.default));
parcelHelpers.export(exports, "GitCommitVerticalIcon", ()=>(0, _gitCommitVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideGitCommitVertical", ()=>(0, _gitCommitVerticalJsDefault.default));
parcelHelpers.export(exports, "GitCompareArrows", ()=>(0, _gitCompareArrowsJsDefault.default));
parcelHelpers.export(exports, "GitCompareArrowsIcon", ()=>(0, _gitCompareArrowsJsDefault.default));
parcelHelpers.export(exports, "LucideGitCompareArrows", ()=>(0, _gitCompareArrowsJsDefault.default));
parcelHelpers.export(exports, "GitCompare", ()=>(0, _gitCompareJsDefault.default));
parcelHelpers.export(exports, "GitCompareIcon", ()=>(0, _gitCompareJsDefault.default));
parcelHelpers.export(exports, "LucideGitCompare", ()=>(0, _gitCompareJsDefault.default));
parcelHelpers.export(exports, "GitFork", ()=>(0, _gitForkJsDefault.default));
parcelHelpers.export(exports, "GitForkIcon", ()=>(0, _gitForkJsDefault.default));
parcelHelpers.export(exports, "LucideGitFork", ()=>(0, _gitForkJsDefault.default));
parcelHelpers.export(exports, "GitGraph", ()=>(0, _gitGraphJsDefault.default));
parcelHelpers.export(exports, "GitGraphIcon", ()=>(0, _gitGraphJsDefault.default));
parcelHelpers.export(exports, "LucideGitGraph", ()=>(0, _gitGraphJsDefault.default));
parcelHelpers.export(exports, "GitMerge", ()=>(0, _gitMergeJsDefault.default));
parcelHelpers.export(exports, "GitMergeIcon", ()=>(0, _gitMergeJsDefault.default));
parcelHelpers.export(exports, "LucideGitMerge", ()=>(0, _gitMergeJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestArrow", ()=>(0, _gitPullRequestArrowJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestArrowIcon", ()=>(0, _gitPullRequestArrowJsDefault.default));
parcelHelpers.export(exports, "LucideGitPullRequestArrow", ()=>(0, _gitPullRequestArrowJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestClosed", ()=>(0, _gitPullRequestClosedJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestClosedIcon", ()=>(0, _gitPullRequestClosedJsDefault.default));
parcelHelpers.export(exports, "LucideGitPullRequestClosed", ()=>(0, _gitPullRequestClosedJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestCreateArrow", ()=>(0, _gitPullRequestCreateArrowJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestCreateArrowIcon", ()=>(0, _gitPullRequestCreateArrowJsDefault.default));
parcelHelpers.export(exports, "LucideGitPullRequestCreateArrow", ()=>(0, _gitPullRequestCreateArrowJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestCreate", ()=>(0, _gitPullRequestCreateJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestCreateIcon", ()=>(0, _gitPullRequestCreateJsDefault.default));
parcelHelpers.export(exports, "LucideGitPullRequestCreate", ()=>(0, _gitPullRequestCreateJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestDraft", ()=>(0, _gitPullRequestDraftJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestDraftIcon", ()=>(0, _gitPullRequestDraftJsDefault.default));
parcelHelpers.export(exports, "LucideGitPullRequestDraft", ()=>(0, _gitPullRequestDraftJsDefault.default));
parcelHelpers.export(exports, "GitPullRequest", ()=>(0, _gitPullRequestJsDefault.default));
parcelHelpers.export(exports, "GitPullRequestIcon", ()=>(0, _gitPullRequestJsDefault.default));
parcelHelpers.export(exports, "LucideGitPullRequest", ()=>(0, _gitPullRequestJsDefault.default));
parcelHelpers.export(exports, "Github", ()=>(0, _githubJsDefault.default));
parcelHelpers.export(exports, "GithubIcon", ()=>(0, _githubJsDefault.default));
parcelHelpers.export(exports, "LucideGithub", ()=>(0, _githubJsDefault.default));
parcelHelpers.export(exports, "Gitlab", ()=>(0, _gitlabJsDefault.default));
parcelHelpers.export(exports, "GitlabIcon", ()=>(0, _gitlabJsDefault.default));
parcelHelpers.export(exports, "LucideGitlab", ()=>(0, _gitlabJsDefault.default));
parcelHelpers.export(exports, "GlassWater", ()=>(0, _glassWaterJsDefault.default));
parcelHelpers.export(exports, "GlassWaterIcon", ()=>(0, _glassWaterJsDefault.default));
parcelHelpers.export(exports, "LucideGlassWater", ()=>(0, _glassWaterJsDefault.default));
parcelHelpers.export(exports, "Glasses", ()=>(0, _glassesJsDefault.default));
parcelHelpers.export(exports, "GlassesIcon", ()=>(0, _glassesJsDefault.default));
parcelHelpers.export(exports, "LucideGlasses", ()=>(0, _glassesJsDefault.default));
parcelHelpers.export(exports, "GlobeLock", ()=>(0, _globeLockJsDefault.default));
parcelHelpers.export(exports, "GlobeLockIcon", ()=>(0, _globeLockJsDefault.default));
parcelHelpers.export(exports, "LucideGlobeLock", ()=>(0, _globeLockJsDefault.default));
parcelHelpers.export(exports, "Globe", ()=>(0, _globeJsDefault.default));
parcelHelpers.export(exports, "GlobeIcon", ()=>(0, _globeJsDefault.default));
parcelHelpers.export(exports, "LucideGlobe", ()=>(0, _globeJsDefault.default));
parcelHelpers.export(exports, "Goal", ()=>(0, _goalJsDefault.default));
parcelHelpers.export(exports, "GoalIcon", ()=>(0, _goalJsDefault.default));
parcelHelpers.export(exports, "LucideGoal", ()=>(0, _goalJsDefault.default));
parcelHelpers.export(exports, "Grab", ()=>(0, _grabJsDefault.default));
parcelHelpers.export(exports, "GrabIcon", ()=>(0, _grabJsDefault.default));
parcelHelpers.export(exports, "LucideGrab", ()=>(0, _grabJsDefault.default));
parcelHelpers.export(exports, "GraduationCap", ()=>(0, _graduationCapJsDefault.default));
parcelHelpers.export(exports, "GraduationCapIcon", ()=>(0, _graduationCapJsDefault.default));
parcelHelpers.export(exports, "LucideGraduationCap", ()=>(0, _graduationCapJsDefault.default));
parcelHelpers.export(exports, "Grape", ()=>(0, _grapeJsDefault.default));
parcelHelpers.export(exports, "GrapeIcon", ()=>(0, _grapeJsDefault.default));
parcelHelpers.export(exports, "LucideGrape", ()=>(0, _grapeJsDefault.default));
parcelHelpers.export(exports, "GripHorizontal", ()=>(0, _gripHorizontalJsDefault.default));
parcelHelpers.export(exports, "GripHorizontalIcon", ()=>(0, _gripHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideGripHorizontal", ()=>(0, _gripHorizontalJsDefault.default));
parcelHelpers.export(exports, "GripVertical", ()=>(0, _gripVerticalJsDefault.default));
parcelHelpers.export(exports, "GripVerticalIcon", ()=>(0, _gripVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideGripVertical", ()=>(0, _gripVerticalJsDefault.default));
parcelHelpers.export(exports, "Grip", ()=>(0, _gripJsDefault.default));
parcelHelpers.export(exports, "GripIcon", ()=>(0, _gripJsDefault.default));
parcelHelpers.export(exports, "LucideGrip", ()=>(0, _gripJsDefault.default));
parcelHelpers.export(exports, "Group", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "GroupIcon", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "LucideGroup", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "Guitar", ()=>(0, _guitarJsDefault.default));
parcelHelpers.export(exports, "GuitarIcon", ()=>(0, _guitarJsDefault.default));
parcelHelpers.export(exports, "LucideGuitar", ()=>(0, _guitarJsDefault.default));
parcelHelpers.export(exports, "Hammer", ()=>(0, _hammerJsDefault.default));
parcelHelpers.export(exports, "HammerIcon", ()=>(0, _hammerJsDefault.default));
parcelHelpers.export(exports, "LucideHammer", ()=>(0, _hammerJsDefault.default));
parcelHelpers.export(exports, "HandCoins", ()=>(0, _handCoinsJsDefault.default));
parcelHelpers.export(exports, "HandCoinsIcon", ()=>(0, _handCoinsJsDefault.default));
parcelHelpers.export(exports, "LucideHandCoins", ()=>(0, _handCoinsJsDefault.default));
parcelHelpers.export(exports, "HandHeart", ()=>(0, _handHeartJsDefault.default));
parcelHelpers.export(exports, "HandHeartIcon", ()=>(0, _handHeartJsDefault.default));
parcelHelpers.export(exports, "LucideHandHeart", ()=>(0, _handHeartJsDefault.default));
parcelHelpers.export(exports, "HandMetal", ()=>(0, _handMetalJsDefault.default));
parcelHelpers.export(exports, "HandMetalIcon", ()=>(0, _handMetalJsDefault.default));
parcelHelpers.export(exports, "LucideHandMetal", ()=>(0, _handMetalJsDefault.default));
parcelHelpers.export(exports, "HandPlatter", ()=>(0, _handPlatterJsDefault.default));
parcelHelpers.export(exports, "HandPlatterIcon", ()=>(0, _handPlatterJsDefault.default));
parcelHelpers.export(exports, "LucideHandPlatter", ()=>(0, _handPlatterJsDefault.default));
parcelHelpers.export(exports, "Hand", ()=>(0, _handJsDefault.default));
parcelHelpers.export(exports, "HandIcon", ()=>(0, _handJsDefault.default));
parcelHelpers.export(exports, "LucideHand", ()=>(0, _handJsDefault.default));
parcelHelpers.export(exports, "Handshake", ()=>(0, _handshakeJsDefault.default));
parcelHelpers.export(exports, "HandshakeIcon", ()=>(0, _handshakeJsDefault.default));
parcelHelpers.export(exports, "LucideHandshake", ()=>(0, _handshakeJsDefault.default));
parcelHelpers.export(exports, "HardDriveDownload", ()=>(0, _hardDriveDownloadJsDefault.default));
parcelHelpers.export(exports, "HardDriveDownloadIcon", ()=>(0, _hardDriveDownloadJsDefault.default));
parcelHelpers.export(exports, "LucideHardDriveDownload", ()=>(0, _hardDriveDownloadJsDefault.default));
parcelHelpers.export(exports, "HardDriveUpload", ()=>(0, _hardDriveUploadJsDefault.default));
parcelHelpers.export(exports, "HardDriveUploadIcon", ()=>(0, _hardDriveUploadJsDefault.default));
parcelHelpers.export(exports, "LucideHardDriveUpload", ()=>(0, _hardDriveUploadJsDefault.default));
parcelHelpers.export(exports, "HardDrive", ()=>(0, _hardDriveJsDefault.default));
parcelHelpers.export(exports, "HardDriveIcon", ()=>(0, _hardDriveJsDefault.default));
parcelHelpers.export(exports, "LucideHardDrive", ()=>(0, _hardDriveJsDefault.default));
parcelHelpers.export(exports, "HardHat", ()=>(0, _hardHatJsDefault.default));
parcelHelpers.export(exports, "HardHatIcon", ()=>(0, _hardHatJsDefault.default));
parcelHelpers.export(exports, "LucideHardHat", ()=>(0, _hardHatJsDefault.default));
parcelHelpers.export(exports, "Hash", ()=>(0, _hashJsDefault.default));
parcelHelpers.export(exports, "HashIcon", ()=>(0, _hashJsDefault.default));
parcelHelpers.export(exports, "LucideHash", ()=>(0, _hashJsDefault.default));
parcelHelpers.export(exports, "Haze", ()=>(0, _hazeJsDefault.default));
parcelHelpers.export(exports, "HazeIcon", ()=>(0, _hazeJsDefault.default));
parcelHelpers.export(exports, "LucideHaze", ()=>(0, _hazeJsDefault.default));
parcelHelpers.export(exports, "HdmiPort", ()=>(0, _hdmiPortJsDefault.default));
parcelHelpers.export(exports, "HdmiPortIcon", ()=>(0, _hdmiPortJsDefault.default));
parcelHelpers.export(exports, "LucideHdmiPort", ()=>(0, _hdmiPortJsDefault.default));
parcelHelpers.export(exports, "Heading1", ()=>(0, _heading1JsDefault.default));
parcelHelpers.export(exports, "Heading1Icon", ()=>(0, _heading1JsDefault.default));
parcelHelpers.export(exports, "LucideHeading1", ()=>(0, _heading1JsDefault.default));
parcelHelpers.export(exports, "Heading2", ()=>(0, _heading2JsDefault.default));
parcelHelpers.export(exports, "Heading2Icon", ()=>(0, _heading2JsDefault.default));
parcelHelpers.export(exports, "LucideHeading2", ()=>(0, _heading2JsDefault.default));
parcelHelpers.export(exports, "Heading3", ()=>(0, _heading3JsDefault.default));
parcelHelpers.export(exports, "Heading3Icon", ()=>(0, _heading3JsDefault.default));
parcelHelpers.export(exports, "LucideHeading3", ()=>(0, _heading3JsDefault.default));
parcelHelpers.export(exports, "Heading4", ()=>(0, _heading4JsDefault.default));
parcelHelpers.export(exports, "Heading4Icon", ()=>(0, _heading4JsDefault.default));
parcelHelpers.export(exports, "LucideHeading4", ()=>(0, _heading4JsDefault.default));
parcelHelpers.export(exports, "Heading5", ()=>(0, _heading5JsDefault.default));
parcelHelpers.export(exports, "Heading5Icon", ()=>(0, _heading5JsDefault.default));
parcelHelpers.export(exports, "LucideHeading5", ()=>(0, _heading5JsDefault.default));
parcelHelpers.export(exports, "Heading6", ()=>(0, _heading6JsDefault.default));
parcelHelpers.export(exports, "Heading6Icon", ()=>(0, _heading6JsDefault.default));
parcelHelpers.export(exports, "LucideHeading6", ()=>(0, _heading6JsDefault.default));
parcelHelpers.export(exports, "Heading", ()=>(0, _headingJsDefault.default));
parcelHelpers.export(exports, "HeadingIcon", ()=>(0, _headingJsDefault.default));
parcelHelpers.export(exports, "LucideHeading", ()=>(0, _headingJsDefault.default));
parcelHelpers.export(exports, "Headphones", ()=>(0, _headphonesJsDefault.default));
parcelHelpers.export(exports, "HeadphonesIcon", ()=>(0, _headphonesJsDefault.default));
parcelHelpers.export(exports, "LucideHeadphones", ()=>(0, _headphonesJsDefault.default));
parcelHelpers.export(exports, "Headset", ()=>(0, _headsetJsDefault.default));
parcelHelpers.export(exports, "HeadsetIcon", ()=>(0, _headsetJsDefault.default));
parcelHelpers.export(exports, "LucideHeadset", ()=>(0, _headsetJsDefault.default));
parcelHelpers.export(exports, "HeartCrack", ()=>(0, _heartCrackJsDefault.default));
parcelHelpers.export(exports, "HeartCrackIcon", ()=>(0, _heartCrackJsDefault.default));
parcelHelpers.export(exports, "LucideHeartCrack", ()=>(0, _heartCrackJsDefault.default));
parcelHelpers.export(exports, "HeartHandshake", ()=>(0, _heartHandshakeJsDefault.default));
parcelHelpers.export(exports, "HeartHandshakeIcon", ()=>(0, _heartHandshakeJsDefault.default));
parcelHelpers.export(exports, "LucideHeartHandshake", ()=>(0, _heartHandshakeJsDefault.default));
parcelHelpers.export(exports, "HeartOff", ()=>(0, _heartOffJsDefault.default));
parcelHelpers.export(exports, "HeartOffIcon", ()=>(0, _heartOffJsDefault.default));
parcelHelpers.export(exports, "LucideHeartOff", ()=>(0, _heartOffJsDefault.default));
parcelHelpers.export(exports, "HeartPulse", ()=>(0, _heartPulseJsDefault.default));
parcelHelpers.export(exports, "HeartPulseIcon", ()=>(0, _heartPulseJsDefault.default));
parcelHelpers.export(exports, "LucideHeartPulse", ()=>(0, _heartPulseJsDefault.default));
parcelHelpers.export(exports, "Heart", ()=>(0, _heartJsDefault.default));
parcelHelpers.export(exports, "HeartIcon", ()=>(0, _heartJsDefault.default));
parcelHelpers.export(exports, "LucideHeart", ()=>(0, _heartJsDefault.default));
parcelHelpers.export(exports, "Heater", ()=>(0, _heaterJsDefault.default));
parcelHelpers.export(exports, "HeaterIcon", ()=>(0, _heaterJsDefault.default));
parcelHelpers.export(exports, "LucideHeater", ()=>(0, _heaterJsDefault.default));
parcelHelpers.export(exports, "HelpCircle", ()=>(0, _helpCircleJsDefault.default));
parcelHelpers.export(exports, "HelpCircleIcon", ()=>(0, _helpCircleJsDefault.default));
parcelHelpers.export(exports, "LucideHelpCircle", ()=>(0, _helpCircleJsDefault.default));
parcelHelpers.export(exports, "Hexagon", ()=>(0, _hexagonJsDefault.default));
parcelHelpers.export(exports, "HexagonIcon", ()=>(0, _hexagonJsDefault.default));
parcelHelpers.export(exports, "LucideHexagon", ()=>(0, _hexagonJsDefault.default));
parcelHelpers.export(exports, "Highlighter", ()=>(0, _highlighterJsDefault.default));
parcelHelpers.export(exports, "HighlighterIcon", ()=>(0, _highlighterJsDefault.default));
parcelHelpers.export(exports, "LucideHighlighter", ()=>(0, _highlighterJsDefault.default));
parcelHelpers.export(exports, "History", ()=>(0, _historyJsDefault.default));
parcelHelpers.export(exports, "HistoryIcon", ()=>(0, _historyJsDefault.default));
parcelHelpers.export(exports, "LucideHistory", ()=>(0, _historyJsDefault.default));
parcelHelpers.export(exports, "Home", ()=>(0, _homeJsDefault.default));
parcelHelpers.export(exports, "HomeIcon", ()=>(0, _homeJsDefault.default));
parcelHelpers.export(exports, "LucideHome", ()=>(0, _homeJsDefault.default));
parcelHelpers.export(exports, "HopOff", ()=>(0, _hopOffJsDefault.default));
parcelHelpers.export(exports, "HopOffIcon", ()=>(0, _hopOffJsDefault.default));
parcelHelpers.export(exports, "LucideHopOff", ()=>(0, _hopOffJsDefault.default));
parcelHelpers.export(exports, "Hop", ()=>(0, _hopJsDefault.default));
parcelHelpers.export(exports, "HopIcon", ()=>(0, _hopJsDefault.default));
parcelHelpers.export(exports, "LucideHop", ()=>(0, _hopJsDefault.default));
parcelHelpers.export(exports, "Hotel", ()=>(0, _hotelJsDefault.default));
parcelHelpers.export(exports, "HotelIcon", ()=>(0, _hotelJsDefault.default));
parcelHelpers.export(exports, "LucideHotel", ()=>(0, _hotelJsDefault.default));
parcelHelpers.export(exports, "Hourglass", ()=>(0, _hourglassJsDefault.default));
parcelHelpers.export(exports, "HourglassIcon", ()=>(0, _hourglassJsDefault.default));
parcelHelpers.export(exports, "LucideHourglass", ()=>(0, _hourglassJsDefault.default));
parcelHelpers.export(exports, "IceCream2", ()=>(0, _iceCream2JsDefault.default));
parcelHelpers.export(exports, "IceCream2Icon", ()=>(0, _iceCream2JsDefault.default));
parcelHelpers.export(exports, "LucideIceCream2", ()=>(0, _iceCream2JsDefault.default));
parcelHelpers.export(exports, "IceCream", ()=>(0, _iceCreamJsDefault.default));
parcelHelpers.export(exports, "IceCreamIcon", ()=>(0, _iceCreamJsDefault.default));
parcelHelpers.export(exports, "LucideIceCream", ()=>(0, _iceCreamJsDefault.default));
parcelHelpers.export(exports, "ImageDown", ()=>(0, _imageDownJsDefault.default));
parcelHelpers.export(exports, "ImageDownIcon", ()=>(0, _imageDownJsDefault.default));
parcelHelpers.export(exports, "LucideImageDown", ()=>(0, _imageDownJsDefault.default));
parcelHelpers.export(exports, "ImageMinus", ()=>(0, _imageMinusJsDefault.default));
parcelHelpers.export(exports, "ImageMinusIcon", ()=>(0, _imageMinusJsDefault.default));
parcelHelpers.export(exports, "LucideImageMinus", ()=>(0, _imageMinusJsDefault.default));
parcelHelpers.export(exports, "ImageOff", ()=>(0, _imageOffJsDefault.default));
parcelHelpers.export(exports, "ImageOffIcon", ()=>(0, _imageOffJsDefault.default));
parcelHelpers.export(exports, "LucideImageOff", ()=>(0, _imageOffJsDefault.default));
parcelHelpers.export(exports, "ImagePlus", ()=>(0, _imagePlusJsDefault.default));
parcelHelpers.export(exports, "ImagePlusIcon", ()=>(0, _imagePlusJsDefault.default));
parcelHelpers.export(exports, "LucideImagePlus", ()=>(0, _imagePlusJsDefault.default));
parcelHelpers.export(exports, "ImageUp", ()=>(0, _imageUpJsDefault.default));
parcelHelpers.export(exports, "ImageUpIcon", ()=>(0, _imageUpJsDefault.default));
parcelHelpers.export(exports, "LucideImageUp", ()=>(0, _imageUpJsDefault.default));
parcelHelpers.export(exports, "Image", ()=>(0, _imageJsDefault.default));
parcelHelpers.export(exports, "ImageIcon", ()=>(0, _imageJsDefault.default));
parcelHelpers.export(exports, "LucideImage", ()=>(0, _imageJsDefault.default));
parcelHelpers.export(exports, "Images", ()=>(0, _imagesJsDefault.default));
parcelHelpers.export(exports, "ImagesIcon", ()=>(0, _imagesJsDefault.default));
parcelHelpers.export(exports, "LucideImages", ()=>(0, _imagesJsDefault.default));
parcelHelpers.export(exports, "Import", ()=>(0, _importJsDefault.default));
parcelHelpers.export(exports, "ImportIcon", ()=>(0, _importJsDefault.default));
parcelHelpers.export(exports, "LucideImport", ()=>(0, _importJsDefault.default));
parcelHelpers.export(exports, "Inbox", ()=>(0, _inboxJsDefault.default));
parcelHelpers.export(exports, "InboxIcon", ()=>(0, _inboxJsDefault.default));
parcelHelpers.export(exports, "LucideInbox", ()=>(0, _inboxJsDefault.default));
parcelHelpers.export(exports, "Indent", ()=>(0, _indentJsDefault.default));
parcelHelpers.export(exports, "IndentIcon", ()=>(0, _indentJsDefault.default));
parcelHelpers.export(exports, "LucideIndent", ()=>(0, _indentJsDefault.default));
parcelHelpers.export(exports, "IndianRupee", ()=>(0, _indianRupeeJsDefault.default));
parcelHelpers.export(exports, "IndianRupeeIcon", ()=>(0, _indianRupeeJsDefault.default));
parcelHelpers.export(exports, "LucideIndianRupee", ()=>(0, _indianRupeeJsDefault.default));
parcelHelpers.export(exports, "Infinity", ()=>(0, _infinityJsDefault.default));
parcelHelpers.export(exports, "InfinityIcon", ()=>(0, _infinityJsDefault.default));
parcelHelpers.export(exports, "LucideInfinity", ()=>(0, _infinityJsDefault.default));
parcelHelpers.export(exports, "Info", ()=>(0, _infoJsDefault.default));
parcelHelpers.export(exports, "InfoIcon", ()=>(0, _infoJsDefault.default));
parcelHelpers.export(exports, "LucideInfo", ()=>(0, _infoJsDefault.default));
parcelHelpers.export(exports, "InspectionPanel", ()=>(0, _inspectionPanelJsDefault.default));
parcelHelpers.export(exports, "InspectionPanelIcon", ()=>(0, _inspectionPanelJsDefault.default));
parcelHelpers.export(exports, "LucideInspectionPanel", ()=>(0, _inspectionPanelJsDefault.default));
parcelHelpers.export(exports, "Instagram", ()=>(0, _instagramJsDefault.default));
parcelHelpers.export(exports, "InstagramIcon", ()=>(0, _instagramJsDefault.default));
parcelHelpers.export(exports, "LucideInstagram", ()=>(0, _instagramJsDefault.default));
parcelHelpers.export(exports, "Italic", ()=>(0, _italicJsDefault.default));
parcelHelpers.export(exports, "ItalicIcon", ()=>(0, _italicJsDefault.default));
parcelHelpers.export(exports, "LucideItalic", ()=>(0, _italicJsDefault.default));
parcelHelpers.export(exports, "IterationCcw", ()=>(0, _iterationCcwJsDefault.default));
parcelHelpers.export(exports, "IterationCcwIcon", ()=>(0, _iterationCcwJsDefault.default));
parcelHelpers.export(exports, "LucideIterationCcw", ()=>(0, _iterationCcwJsDefault.default));
parcelHelpers.export(exports, "IterationCw", ()=>(0, _iterationCwJsDefault.default));
parcelHelpers.export(exports, "IterationCwIcon", ()=>(0, _iterationCwJsDefault.default));
parcelHelpers.export(exports, "LucideIterationCw", ()=>(0, _iterationCwJsDefault.default));
parcelHelpers.export(exports, "JapaneseYen", ()=>(0, _japaneseYenJsDefault.default));
parcelHelpers.export(exports, "JapaneseYenIcon", ()=>(0, _japaneseYenJsDefault.default));
parcelHelpers.export(exports, "LucideJapaneseYen", ()=>(0, _japaneseYenJsDefault.default));
parcelHelpers.export(exports, "Joystick", ()=>(0, _joystickJsDefault.default));
parcelHelpers.export(exports, "JoystickIcon", ()=>(0, _joystickJsDefault.default));
parcelHelpers.export(exports, "LucideJoystick", ()=>(0, _joystickJsDefault.default));
parcelHelpers.export(exports, "Kanban", ()=>(0, _kanbanJsDefault.default));
parcelHelpers.export(exports, "KanbanIcon", ()=>(0, _kanbanJsDefault.default));
parcelHelpers.export(exports, "LucideKanban", ()=>(0, _kanbanJsDefault.default));
parcelHelpers.export(exports, "KeyRound", ()=>(0, _keyRoundJsDefault.default));
parcelHelpers.export(exports, "KeyRoundIcon", ()=>(0, _keyRoundJsDefault.default));
parcelHelpers.export(exports, "LucideKeyRound", ()=>(0, _keyRoundJsDefault.default));
parcelHelpers.export(exports, "KeySquare", ()=>(0, _keySquareJsDefault.default));
parcelHelpers.export(exports, "KeySquareIcon", ()=>(0, _keySquareJsDefault.default));
parcelHelpers.export(exports, "LucideKeySquare", ()=>(0, _keySquareJsDefault.default));
parcelHelpers.export(exports, "Key", ()=>(0, _keyJsDefault.default));
parcelHelpers.export(exports, "KeyIcon", ()=>(0, _keyJsDefault.default));
parcelHelpers.export(exports, "LucideKey", ()=>(0, _keyJsDefault.default));
parcelHelpers.export(exports, "KeyboardMusic", ()=>(0, _keyboardMusicJsDefault.default));
parcelHelpers.export(exports, "KeyboardMusicIcon", ()=>(0, _keyboardMusicJsDefault.default));
parcelHelpers.export(exports, "LucideKeyboardMusic", ()=>(0, _keyboardMusicJsDefault.default));
parcelHelpers.export(exports, "Keyboard", ()=>(0, _keyboardJsDefault.default));
parcelHelpers.export(exports, "KeyboardIcon", ()=>(0, _keyboardJsDefault.default));
parcelHelpers.export(exports, "LucideKeyboard", ()=>(0, _keyboardJsDefault.default));
parcelHelpers.export(exports, "LampCeiling", ()=>(0, _lampCeilingJsDefault.default));
parcelHelpers.export(exports, "LampCeilingIcon", ()=>(0, _lampCeilingJsDefault.default));
parcelHelpers.export(exports, "LucideLampCeiling", ()=>(0, _lampCeilingJsDefault.default));
parcelHelpers.export(exports, "LampDesk", ()=>(0, _lampDeskJsDefault.default));
parcelHelpers.export(exports, "LampDeskIcon", ()=>(0, _lampDeskJsDefault.default));
parcelHelpers.export(exports, "LucideLampDesk", ()=>(0, _lampDeskJsDefault.default));
parcelHelpers.export(exports, "LampFloor", ()=>(0, _lampFloorJsDefault.default));
parcelHelpers.export(exports, "LampFloorIcon", ()=>(0, _lampFloorJsDefault.default));
parcelHelpers.export(exports, "LucideLampFloor", ()=>(0, _lampFloorJsDefault.default));
parcelHelpers.export(exports, "LampWallDown", ()=>(0, _lampWallDownJsDefault.default));
parcelHelpers.export(exports, "LampWallDownIcon", ()=>(0, _lampWallDownJsDefault.default));
parcelHelpers.export(exports, "LucideLampWallDown", ()=>(0, _lampWallDownJsDefault.default));
parcelHelpers.export(exports, "LampWallUp", ()=>(0, _lampWallUpJsDefault.default));
parcelHelpers.export(exports, "LampWallUpIcon", ()=>(0, _lampWallUpJsDefault.default));
parcelHelpers.export(exports, "LucideLampWallUp", ()=>(0, _lampWallUpJsDefault.default));
parcelHelpers.export(exports, "Lamp", ()=>(0, _lampJsDefault.default));
parcelHelpers.export(exports, "LampIcon", ()=>(0, _lampJsDefault.default));
parcelHelpers.export(exports, "LucideLamp", ()=>(0, _lampJsDefault.default));
parcelHelpers.export(exports, "LandPlot", ()=>(0, _landPlotJsDefault.default));
parcelHelpers.export(exports, "LandPlotIcon", ()=>(0, _landPlotJsDefault.default));
parcelHelpers.export(exports, "LucideLandPlot", ()=>(0, _landPlotJsDefault.default));
parcelHelpers.export(exports, "Landmark", ()=>(0, _landmarkJsDefault.default));
parcelHelpers.export(exports, "LandmarkIcon", ()=>(0, _landmarkJsDefault.default));
parcelHelpers.export(exports, "LucideLandmark", ()=>(0, _landmarkJsDefault.default));
parcelHelpers.export(exports, "Languages", ()=>(0, _languagesJsDefault.default));
parcelHelpers.export(exports, "LanguagesIcon", ()=>(0, _languagesJsDefault.default));
parcelHelpers.export(exports, "LucideLanguages", ()=>(0, _languagesJsDefault.default));
parcelHelpers.export(exports, "Laptop2", ()=>(0, _laptop2JsDefault.default));
parcelHelpers.export(exports, "Laptop2Icon", ()=>(0, _laptop2JsDefault.default));
parcelHelpers.export(exports, "LucideLaptop2", ()=>(0, _laptop2JsDefault.default));
parcelHelpers.export(exports, "Laptop", ()=>(0, _laptopJsDefault.default));
parcelHelpers.export(exports, "LaptopIcon", ()=>(0, _laptopJsDefault.default));
parcelHelpers.export(exports, "LucideLaptop", ()=>(0, _laptopJsDefault.default));
parcelHelpers.export(exports, "LassoSelect", ()=>(0, _lassoSelectJsDefault.default));
parcelHelpers.export(exports, "LassoSelectIcon", ()=>(0, _lassoSelectJsDefault.default));
parcelHelpers.export(exports, "LucideLassoSelect", ()=>(0, _lassoSelectJsDefault.default));
parcelHelpers.export(exports, "Lasso", ()=>(0, _lassoJsDefault.default));
parcelHelpers.export(exports, "LassoIcon", ()=>(0, _lassoJsDefault.default));
parcelHelpers.export(exports, "LucideLasso", ()=>(0, _lassoJsDefault.default));
parcelHelpers.export(exports, "Laugh", ()=>(0, _laughJsDefault.default));
parcelHelpers.export(exports, "LaughIcon", ()=>(0, _laughJsDefault.default));
parcelHelpers.export(exports, "LucideLaugh", ()=>(0, _laughJsDefault.default));
parcelHelpers.export(exports, "Layers2", ()=>(0, _layers2JsDefault.default));
parcelHelpers.export(exports, "Layers2Icon", ()=>(0, _layers2JsDefault.default));
parcelHelpers.export(exports, "LucideLayers2", ()=>(0, _layers2JsDefault.default));
parcelHelpers.export(exports, "Layers3", ()=>(0, _layers3JsDefault.default));
parcelHelpers.export(exports, "Layers3Icon", ()=>(0, _layers3JsDefault.default));
parcelHelpers.export(exports, "LucideLayers3", ()=>(0, _layers3JsDefault.default));
parcelHelpers.export(exports, "Layers", ()=>(0, _layersJsDefault.default));
parcelHelpers.export(exports, "LayersIcon", ()=>(0, _layersJsDefault.default));
parcelHelpers.export(exports, "LucideLayers", ()=>(0, _layersJsDefault.default));
parcelHelpers.export(exports, "LayoutDashboard", ()=>(0, _layoutDashboardJsDefault.default));
parcelHelpers.export(exports, "LayoutDashboardIcon", ()=>(0, _layoutDashboardJsDefault.default));
parcelHelpers.export(exports, "LucideLayoutDashboard", ()=>(0, _layoutDashboardJsDefault.default));
parcelHelpers.export(exports, "LayoutGrid", ()=>(0, _layoutGridJsDefault.default));
parcelHelpers.export(exports, "LayoutGridIcon", ()=>(0, _layoutGridJsDefault.default));
parcelHelpers.export(exports, "LucideLayoutGrid", ()=>(0, _layoutGridJsDefault.default));
parcelHelpers.export(exports, "LayoutList", ()=>(0, _layoutListJsDefault.default));
parcelHelpers.export(exports, "LayoutListIcon", ()=>(0, _layoutListJsDefault.default));
parcelHelpers.export(exports, "LucideLayoutList", ()=>(0, _layoutListJsDefault.default));
parcelHelpers.export(exports, "LayoutPanelLeft", ()=>(0, _layoutPanelLeftJsDefault.default));
parcelHelpers.export(exports, "LayoutPanelLeftIcon", ()=>(0, _layoutPanelLeftJsDefault.default));
parcelHelpers.export(exports, "LucideLayoutPanelLeft", ()=>(0, _layoutPanelLeftJsDefault.default));
parcelHelpers.export(exports, "LayoutPanelTop", ()=>(0, _layoutPanelTopJsDefault.default));
parcelHelpers.export(exports, "LayoutPanelTopIcon", ()=>(0, _layoutPanelTopJsDefault.default));
parcelHelpers.export(exports, "LucideLayoutPanelTop", ()=>(0, _layoutPanelTopJsDefault.default));
parcelHelpers.export(exports, "LayoutTemplate", ()=>(0, _layoutTemplateJsDefault.default));
parcelHelpers.export(exports, "LayoutTemplateIcon", ()=>(0, _layoutTemplateJsDefault.default));
parcelHelpers.export(exports, "LucideLayoutTemplate", ()=>(0, _layoutTemplateJsDefault.default));
parcelHelpers.export(exports, "Leaf", ()=>(0, _leafJsDefault.default));
parcelHelpers.export(exports, "LeafIcon", ()=>(0, _leafJsDefault.default));
parcelHelpers.export(exports, "LucideLeaf", ()=>(0, _leafJsDefault.default));
parcelHelpers.export(exports, "LeafyGreen", ()=>(0, _leafyGreenJsDefault.default));
parcelHelpers.export(exports, "LeafyGreenIcon", ()=>(0, _leafyGreenJsDefault.default));
parcelHelpers.export(exports, "LucideLeafyGreen", ()=>(0, _leafyGreenJsDefault.default));
parcelHelpers.export(exports, "LibraryBig", ()=>(0, _libraryBigJsDefault.default));
parcelHelpers.export(exports, "LibraryBigIcon", ()=>(0, _libraryBigJsDefault.default));
parcelHelpers.export(exports, "LucideLibraryBig", ()=>(0, _libraryBigJsDefault.default));
parcelHelpers.export(exports, "LibrarySquare", ()=>(0, _librarySquareJsDefault.default));
parcelHelpers.export(exports, "LibrarySquareIcon", ()=>(0, _librarySquareJsDefault.default));
parcelHelpers.export(exports, "LucideLibrarySquare", ()=>(0, _librarySquareJsDefault.default));
parcelHelpers.export(exports, "Library", ()=>(0, _libraryJsDefault.default));
parcelHelpers.export(exports, "LibraryIcon", ()=>(0, _libraryJsDefault.default));
parcelHelpers.export(exports, "LucideLibrary", ()=>(0, _libraryJsDefault.default));
parcelHelpers.export(exports, "LifeBuoy", ()=>(0, _lifeBuoyJsDefault.default));
parcelHelpers.export(exports, "LifeBuoyIcon", ()=>(0, _lifeBuoyJsDefault.default));
parcelHelpers.export(exports, "LucideLifeBuoy", ()=>(0, _lifeBuoyJsDefault.default));
parcelHelpers.export(exports, "Ligature", ()=>(0, _ligatureJsDefault.default));
parcelHelpers.export(exports, "LigatureIcon", ()=>(0, _ligatureJsDefault.default));
parcelHelpers.export(exports, "LucideLigature", ()=>(0, _ligatureJsDefault.default));
parcelHelpers.export(exports, "LightbulbOff", ()=>(0, _lightbulbOffJsDefault.default));
parcelHelpers.export(exports, "LightbulbOffIcon", ()=>(0, _lightbulbOffJsDefault.default));
parcelHelpers.export(exports, "LucideLightbulbOff", ()=>(0, _lightbulbOffJsDefault.default));
parcelHelpers.export(exports, "Lightbulb", ()=>(0, _lightbulbJsDefault.default));
parcelHelpers.export(exports, "LightbulbIcon", ()=>(0, _lightbulbJsDefault.default));
parcelHelpers.export(exports, "LucideLightbulb", ()=>(0, _lightbulbJsDefault.default));
parcelHelpers.export(exports, "LineChart", ()=>(0, _lineChartJsDefault.default));
parcelHelpers.export(exports, "LineChartIcon", ()=>(0, _lineChartJsDefault.default));
parcelHelpers.export(exports, "LucideLineChart", ()=>(0, _lineChartJsDefault.default));
parcelHelpers.export(exports, "Link2Off", ()=>(0, _link2OffJsDefault.default));
parcelHelpers.export(exports, "Link2OffIcon", ()=>(0, _link2OffJsDefault.default));
parcelHelpers.export(exports, "LucideLink2Off", ()=>(0, _link2OffJsDefault.default));
parcelHelpers.export(exports, "Link2", ()=>(0, _link2JsDefault.default));
parcelHelpers.export(exports, "Link2Icon", ()=>(0, _link2JsDefault.default));
parcelHelpers.export(exports, "LucideLink2", ()=>(0, _link2JsDefault.default));
parcelHelpers.export(exports, "Link", ()=>(0, _linkJsDefault.default));
parcelHelpers.export(exports, "LinkIcon", ()=>(0, _linkJsDefault.default));
parcelHelpers.export(exports, "LucideLink", ()=>(0, _linkJsDefault.default));
parcelHelpers.export(exports, "Linkedin", ()=>(0, _linkedinJsDefault.default));
parcelHelpers.export(exports, "LinkedinIcon", ()=>(0, _linkedinJsDefault.default));
parcelHelpers.export(exports, "LucideLinkedin", ()=>(0, _linkedinJsDefault.default));
parcelHelpers.export(exports, "ListChecks", ()=>(0, _listChecksJsDefault.default));
parcelHelpers.export(exports, "ListChecksIcon", ()=>(0, _listChecksJsDefault.default));
parcelHelpers.export(exports, "LucideListChecks", ()=>(0, _listChecksJsDefault.default));
parcelHelpers.export(exports, "ListCollapse", ()=>(0, _listCollapseJsDefault.default));
parcelHelpers.export(exports, "ListCollapseIcon", ()=>(0, _listCollapseJsDefault.default));
parcelHelpers.export(exports, "LucideListCollapse", ()=>(0, _listCollapseJsDefault.default));
parcelHelpers.export(exports, "ListEnd", ()=>(0, _listEndJsDefault.default));
parcelHelpers.export(exports, "ListEndIcon", ()=>(0, _listEndJsDefault.default));
parcelHelpers.export(exports, "LucideListEnd", ()=>(0, _listEndJsDefault.default));
parcelHelpers.export(exports, "ListFilter", ()=>(0, _listFilterJsDefault.default));
parcelHelpers.export(exports, "ListFilterIcon", ()=>(0, _listFilterJsDefault.default));
parcelHelpers.export(exports, "LucideListFilter", ()=>(0, _listFilterJsDefault.default));
parcelHelpers.export(exports, "ListMinus", ()=>(0, _listMinusJsDefault.default));
parcelHelpers.export(exports, "ListMinusIcon", ()=>(0, _listMinusJsDefault.default));
parcelHelpers.export(exports, "LucideListMinus", ()=>(0, _listMinusJsDefault.default));
parcelHelpers.export(exports, "ListMusic", ()=>(0, _listMusicJsDefault.default));
parcelHelpers.export(exports, "ListMusicIcon", ()=>(0, _listMusicJsDefault.default));
parcelHelpers.export(exports, "LucideListMusic", ()=>(0, _listMusicJsDefault.default));
parcelHelpers.export(exports, "ListOrdered", ()=>(0, _listOrderedJsDefault.default));
parcelHelpers.export(exports, "ListOrderedIcon", ()=>(0, _listOrderedJsDefault.default));
parcelHelpers.export(exports, "LucideListOrdered", ()=>(0, _listOrderedJsDefault.default));
parcelHelpers.export(exports, "ListPlus", ()=>(0, _listPlusJsDefault.default));
parcelHelpers.export(exports, "ListPlusIcon", ()=>(0, _listPlusJsDefault.default));
parcelHelpers.export(exports, "LucideListPlus", ()=>(0, _listPlusJsDefault.default));
parcelHelpers.export(exports, "ListRestart", ()=>(0, _listRestartJsDefault.default));
parcelHelpers.export(exports, "ListRestartIcon", ()=>(0, _listRestartJsDefault.default));
parcelHelpers.export(exports, "LucideListRestart", ()=>(0, _listRestartJsDefault.default));
parcelHelpers.export(exports, "ListStart", ()=>(0, _listStartJsDefault.default));
parcelHelpers.export(exports, "ListStartIcon", ()=>(0, _listStartJsDefault.default));
parcelHelpers.export(exports, "LucideListStart", ()=>(0, _listStartJsDefault.default));
parcelHelpers.export(exports, "ListTodo", ()=>(0, _listTodoJsDefault.default));
parcelHelpers.export(exports, "ListTodoIcon", ()=>(0, _listTodoJsDefault.default));
parcelHelpers.export(exports, "LucideListTodo", ()=>(0, _listTodoJsDefault.default));
parcelHelpers.export(exports, "ListTree", ()=>(0, _listTreeJsDefault.default));
parcelHelpers.export(exports, "ListTreeIcon", ()=>(0, _listTreeJsDefault.default));
parcelHelpers.export(exports, "LucideListTree", ()=>(0, _listTreeJsDefault.default));
parcelHelpers.export(exports, "ListVideo", ()=>(0, _listVideoJsDefault.default));
parcelHelpers.export(exports, "ListVideoIcon", ()=>(0, _listVideoJsDefault.default));
parcelHelpers.export(exports, "LucideListVideo", ()=>(0, _listVideoJsDefault.default));
parcelHelpers.export(exports, "ListX", ()=>(0, _listXJsDefault.default));
parcelHelpers.export(exports, "ListXIcon", ()=>(0, _listXJsDefault.default));
parcelHelpers.export(exports, "LucideListX", ()=>(0, _listXJsDefault.default));
parcelHelpers.export(exports, "List", ()=>(0, _listJsDefault.default));
parcelHelpers.export(exports, "ListIcon", ()=>(0, _listJsDefault.default));
parcelHelpers.export(exports, "LucideList", ()=>(0, _listJsDefault.default));
parcelHelpers.export(exports, "Loader2", ()=>(0, _loader2JsDefault.default));
parcelHelpers.export(exports, "Loader2Icon", ()=>(0, _loader2JsDefault.default));
parcelHelpers.export(exports, "LucideLoader2", ()=>(0, _loader2JsDefault.default));
parcelHelpers.export(exports, "Loader", ()=>(0, _loaderJsDefault.default));
parcelHelpers.export(exports, "LoaderIcon", ()=>(0, _loaderJsDefault.default));
parcelHelpers.export(exports, "LucideLoader", ()=>(0, _loaderJsDefault.default));
parcelHelpers.export(exports, "LocateFixed", ()=>(0, _locateFixedJsDefault.default));
parcelHelpers.export(exports, "LocateFixedIcon", ()=>(0, _locateFixedJsDefault.default));
parcelHelpers.export(exports, "LucideLocateFixed", ()=>(0, _locateFixedJsDefault.default));
parcelHelpers.export(exports, "LocateOff", ()=>(0, _locateOffJsDefault.default));
parcelHelpers.export(exports, "LocateOffIcon", ()=>(0, _locateOffJsDefault.default));
parcelHelpers.export(exports, "LucideLocateOff", ()=>(0, _locateOffJsDefault.default));
parcelHelpers.export(exports, "Locate", ()=>(0, _locateJsDefault.default));
parcelHelpers.export(exports, "LocateIcon", ()=>(0, _locateJsDefault.default));
parcelHelpers.export(exports, "LucideLocate", ()=>(0, _locateJsDefault.default));
parcelHelpers.export(exports, "LockKeyhole", ()=>(0, _lockKeyholeJsDefault.default));
parcelHelpers.export(exports, "LockKeyholeIcon", ()=>(0, _lockKeyholeJsDefault.default));
parcelHelpers.export(exports, "LucideLockKeyhole", ()=>(0, _lockKeyholeJsDefault.default));
parcelHelpers.export(exports, "Lock", ()=>(0, _lockJsDefault.default));
parcelHelpers.export(exports, "LockIcon", ()=>(0, _lockJsDefault.default));
parcelHelpers.export(exports, "LucideLock", ()=>(0, _lockJsDefault.default));
parcelHelpers.export(exports, "LogIn", ()=>(0, _logInJsDefault.default));
parcelHelpers.export(exports, "LogInIcon", ()=>(0, _logInJsDefault.default));
parcelHelpers.export(exports, "LucideLogIn", ()=>(0, _logInJsDefault.default));
parcelHelpers.export(exports, "LogOut", ()=>(0, _logOutJsDefault.default));
parcelHelpers.export(exports, "LogOutIcon", ()=>(0, _logOutJsDefault.default));
parcelHelpers.export(exports, "LucideLogOut", ()=>(0, _logOutJsDefault.default));
parcelHelpers.export(exports, "Lollipop", ()=>(0, _lollipopJsDefault.default));
parcelHelpers.export(exports, "LollipopIcon", ()=>(0, _lollipopJsDefault.default));
parcelHelpers.export(exports, "LucideLollipop", ()=>(0, _lollipopJsDefault.default));
parcelHelpers.export(exports, "LucideLuggage", ()=>(0, _luggageJsDefault.default));
parcelHelpers.export(exports, "Luggage", ()=>(0, _luggageJsDefault.default));
parcelHelpers.export(exports, "LuggageIcon", ()=>(0, _luggageJsDefault.default));
parcelHelpers.export(exports, "LucideMSquare", ()=>(0, _mSquareJsDefault.default));
parcelHelpers.export(exports, "MSquare", ()=>(0, _mSquareJsDefault.default));
parcelHelpers.export(exports, "MSquareIcon", ()=>(0, _mSquareJsDefault.default));
parcelHelpers.export(exports, "LucideMagnet", ()=>(0, _magnetJsDefault.default));
parcelHelpers.export(exports, "Magnet", ()=>(0, _magnetJsDefault.default));
parcelHelpers.export(exports, "MagnetIcon", ()=>(0, _magnetJsDefault.default));
parcelHelpers.export(exports, "LucideMailCheck", ()=>(0, _mailCheckJsDefault.default));
parcelHelpers.export(exports, "MailCheck", ()=>(0, _mailCheckJsDefault.default));
parcelHelpers.export(exports, "MailCheckIcon", ()=>(0, _mailCheckJsDefault.default));
parcelHelpers.export(exports, "LucideMailMinus", ()=>(0, _mailMinusJsDefault.default));
parcelHelpers.export(exports, "MailMinus", ()=>(0, _mailMinusJsDefault.default));
parcelHelpers.export(exports, "MailMinusIcon", ()=>(0, _mailMinusJsDefault.default));
parcelHelpers.export(exports, "LucideMailOpen", ()=>(0, _mailOpenJsDefault.default));
parcelHelpers.export(exports, "MailOpen", ()=>(0, _mailOpenJsDefault.default));
parcelHelpers.export(exports, "MailOpenIcon", ()=>(0, _mailOpenJsDefault.default));
parcelHelpers.export(exports, "LucideMailPlus", ()=>(0, _mailPlusJsDefault.default));
parcelHelpers.export(exports, "MailPlus", ()=>(0, _mailPlusJsDefault.default));
parcelHelpers.export(exports, "MailPlusIcon", ()=>(0, _mailPlusJsDefault.default));
parcelHelpers.export(exports, "LucideMailQuestion", ()=>(0, _mailQuestionJsDefault.default));
parcelHelpers.export(exports, "MailQuestion", ()=>(0, _mailQuestionJsDefault.default));
parcelHelpers.export(exports, "MailQuestionIcon", ()=>(0, _mailQuestionJsDefault.default));
parcelHelpers.export(exports, "LucideMailSearch", ()=>(0, _mailSearchJsDefault.default));
parcelHelpers.export(exports, "MailSearch", ()=>(0, _mailSearchJsDefault.default));
parcelHelpers.export(exports, "MailSearchIcon", ()=>(0, _mailSearchJsDefault.default));
parcelHelpers.export(exports, "LucideMailWarning", ()=>(0, _mailWarningJsDefault.default));
parcelHelpers.export(exports, "MailWarning", ()=>(0, _mailWarningJsDefault.default));
parcelHelpers.export(exports, "MailWarningIcon", ()=>(0, _mailWarningJsDefault.default));
parcelHelpers.export(exports, "LucideMailX", ()=>(0, _mailXJsDefault.default));
parcelHelpers.export(exports, "MailX", ()=>(0, _mailXJsDefault.default));
parcelHelpers.export(exports, "MailXIcon", ()=>(0, _mailXJsDefault.default));
parcelHelpers.export(exports, "LucideMail", ()=>(0, _mailJsDefault.default));
parcelHelpers.export(exports, "Mail", ()=>(0, _mailJsDefault.default));
parcelHelpers.export(exports, "MailIcon", ()=>(0, _mailJsDefault.default));
parcelHelpers.export(exports, "LucideMailbox", ()=>(0, _mailboxJsDefault.default));
parcelHelpers.export(exports, "Mailbox", ()=>(0, _mailboxJsDefault.default));
parcelHelpers.export(exports, "MailboxIcon", ()=>(0, _mailboxJsDefault.default));
parcelHelpers.export(exports, "LucideMails", ()=>(0, _mailsJsDefault.default));
parcelHelpers.export(exports, "Mails", ()=>(0, _mailsJsDefault.default));
parcelHelpers.export(exports, "MailsIcon", ()=>(0, _mailsJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinOff", ()=>(0, _mapPinOffJsDefault.default));
parcelHelpers.export(exports, "MapPinOff", ()=>(0, _mapPinOffJsDefault.default));
parcelHelpers.export(exports, "MapPinOffIcon", ()=>(0, _mapPinOffJsDefault.default));
parcelHelpers.export(exports, "LucideMapPin", ()=>(0, _mapPinJsDefault.default));
parcelHelpers.export(exports, "MapPin", ()=>(0, _mapPinJsDefault.default));
parcelHelpers.export(exports, "MapPinIcon", ()=>(0, _mapPinJsDefault.default));
parcelHelpers.export(exports, "LucideMapPinned", ()=>(0, _mapPinnedJsDefault.default));
parcelHelpers.export(exports, "MapPinned", ()=>(0, _mapPinnedJsDefault.default));
parcelHelpers.export(exports, "MapPinnedIcon", ()=>(0, _mapPinnedJsDefault.default));
parcelHelpers.export(exports, "LucideMap", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "Map", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "MapIcon", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "LucideMartini", ()=>(0, _martiniJsDefault.default));
parcelHelpers.export(exports, "Martini", ()=>(0, _martiniJsDefault.default));
parcelHelpers.export(exports, "MartiniIcon", ()=>(0, _martiniJsDefault.default));
parcelHelpers.export(exports, "LucideMaximize2", ()=>(0, _maximize2JsDefault.default));
parcelHelpers.export(exports, "Maximize2", ()=>(0, _maximize2JsDefault.default));
parcelHelpers.export(exports, "Maximize2Icon", ()=>(0, _maximize2JsDefault.default));
parcelHelpers.export(exports, "LucideMaximize", ()=>(0, _maximizeJsDefault.default));
parcelHelpers.export(exports, "Maximize", ()=>(0, _maximizeJsDefault.default));
parcelHelpers.export(exports, "MaximizeIcon", ()=>(0, _maximizeJsDefault.default));
parcelHelpers.export(exports, "LucideMedal", ()=>(0, _medalJsDefault.default));
parcelHelpers.export(exports, "Medal", ()=>(0, _medalJsDefault.default));
parcelHelpers.export(exports, "MedalIcon", ()=>(0, _medalJsDefault.default));
parcelHelpers.export(exports, "LucideMegaphoneOff", ()=>(0, _megaphoneOffJsDefault.default));
parcelHelpers.export(exports, "MegaphoneOff", ()=>(0, _megaphoneOffJsDefault.default));
parcelHelpers.export(exports, "MegaphoneOffIcon", ()=>(0, _megaphoneOffJsDefault.default));
parcelHelpers.export(exports, "LucideMegaphone", ()=>(0, _megaphoneJsDefault.default));
parcelHelpers.export(exports, "Megaphone", ()=>(0, _megaphoneJsDefault.default));
parcelHelpers.export(exports, "MegaphoneIcon", ()=>(0, _megaphoneJsDefault.default));
parcelHelpers.export(exports, "LucideMeh", ()=>(0, _mehJsDefault.default));
parcelHelpers.export(exports, "Meh", ()=>(0, _mehJsDefault.default));
parcelHelpers.export(exports, "MehIcon", ()=>(0, _mehJsDefault.default));
parcelHelpers.export(exports, "LucideMemoryStick", ()=>(0, _memoryStickJsDefault.default));
parcelHelpers.export(exports, "MemoryStick", ()=>(0, _memoryStickJsDefault.default));
parcelHelpers.export(exports, "MemoryStickIcon", ()=>(0, _memoryStickJsDefault.default));
parcelHelpers.export(exports, "LucideMenuSquare", ()=>(0, _menuSquareJsDefault.default));
parcelHelpers.export(exports, "MenuSquare", ()=>(0, _menuSquareJsDefault.default));
parcelHelpers.export(exports, "MenuSquareIcon", ()=>(0, _menuSquareJsDefault.default));
parcelHelpers.export(exports, "LucideMenu", ()=>(0, _menuJsDefault.default));
parcelHelpers.export(exports, "Menu", ()=>(0, _menuJsDefault.default));
parcelHelpers.export(exports, "MenuIcon", ()=>(0, _menuJsDefault.default));
parcelHelpers.export(exports, "LucideMerge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "Merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "MergeIcon", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleCode", ()=>(0, _messageCircleCodeJsDefault.default));
parcelHelpers.export(exports, "MessageCircleCode", ()=>(0, _messageCircleCodeJsDefault.default));
parcelHelpers.export(exports, "MessageCircleCodeIcon", ()=>(0, _messageCircleCodeJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleDashed", ()=>(0, _messageCircleDashedJsDefault.default));
parcelHelpers.export(exports, "MessageCircleDashed", ()=>(0, _messageCircleDashedJsDefault.default));
parcelHelpers.export(exports, "MessageCircleDashedIcon", ()=>(0, _messageCircleDashedJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleHeart", ()=>(0, _messageCircleHeartJsDefault.default));
parcelHelpers.export(exports, "MessageCircleHeart", ()=>(0, _messageCircleHeartJsDefault.default));
parcelHelpers.export(exports, "MessageCircleHeartIcon", ()=>(0, _messageCircleHeartJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleMore", ()=>(0, _messageCircleMoreJsDefault.default));
parcelHelpers.export(exports, "MessageCircleMore", ()=>(0, _messageCircleMoreJsDefault.default));
parcelHelpers.export(exports, "MessageCircleMoreIcon", ()=>(0, _messageCircleMoreJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleOff", ()=>(0, _messageCircleOffJsDefault.default));
parcelHelpers.export(exports, "MessageCircleOff", ()=>(0, _messageCircleOffJsDefault.default));
parcelHelpers.export(exports, "MessageCircleOffIcon", ()=>(0, _messageCircleOffJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCirclePlus", ()=>(0, _messageCirclePlusJsDefault.default));
parcelHelpers.export(exports, "MessageCirclePlus", ()=>(0, _messageCirclePlusJsDefault.default));
parcelHelpers.export(exports, "MessageCirclePlusIcon", ()=>(0, _messageCirclePlusJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleQuestion", ()=>(0, _messageCircleQuestionJsDefault.default));
parcelHelpers.export(exports, "MessageCircleQuestion", ()=>(0, _messageCircleQuestionJsDefault.default));
parcelHelpers.export(exports, "MessageCircleQuestionIcon", ()=>(0, _messageCircleQuestionJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleReply", ()=>(0, _messageCircleReplyJsDefault.default));
parcelHelpers.export(exports, "MessageCircleReply", ()=>(0, _messageCircleReplyJsDefault.default));
parcelHelpers.export(exports, "MessageCircleReplyIcon", ()=>(0, _messageCircleReplyJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleWarning", ()=>(0, _messageCircleWarningJsDefault.default));
parcelHelpers.export(exports, "MessageCircleWarning", ()=>(0, _messageCircleWarningJsDefault.default));
parcelHelpers.export(exports, "MessageCircleWarningIcon", ()=>(0, _messageCircleWarningJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircleX", ()=>(0, _messageCircleXJsDefault.default));
parcelHelpers.export(exports, "MessageCircleX", ()=>(0, _messageCircleXJsDefault.default));
parcelHelpers.export(exports, "MessageCircleXIcon", ()=>(0, _messageCircleXJsDefault.default));
parcelHelpers.export(exports, "LucideMessageCircle", ()=>(0, _messageCircleJsDefault.default));
parcelHelpers.export(exports, "MessageCircle", ()=>(0, _messageCircleJsDefault.default));
parcelHelpers.export(exports, "MessageCircleIcon", ()=>(0, _messageCircleJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareCode", ()=>(0, _messageSquareCodeJsDefault.default));
parcelHelpers.export(exports, "MessageSquareCode", ()=>(0, _messageSquareCodeJsDefault.default));
parcelHelpers.export(exports, "MessageSquareCodeIcon", ()=>(0, _messageSquareCodeJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareDashed", ()=>(0, _messageSquareDashedJsDefault.default));
parcelHelpers.export(exports, "MessageSquareDashed", ()=>(0, _messageSquareDashedJsDefault.default));
parcelHelpers.export(exports, "MessageSquareDashedIcon", ()=>(0, _messageSquareDashedJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareDiff", ()=>(0, _messageSquareDiffJsDefault.default));
parcelHelpers.export(exports, "MessageSquareDiff", ()=>(0, _messageSquareDiffJsDefault.default));
parcelHelpers.export(exports, "MessageSquareDiffIcon", ()=>(0, _messageSquareDiffJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareDot", ()=>(0, _messageSquareDotJsDefault.default));
parcelHelpers.export(exports, "MessageSquareDot", ()=>(0, _messageSquareDotJsDefault.default));
parcelHelpers.export(exports, "MessageSquareDotIcon", ()=>(0, _messageSquareDotJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareHeart", ()=>(0, _messageSquareHeartJsDefault.default));
parcelHelpers.export(exports, "MessageSquareHeart", ()=>(0, _messageSquareHeartJsDefault.default));
parcelHelpers.export(exports, "MessageSquareHeartIcon", ()=>(0, _messageSquareHeartJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareMore", ()=>(0, _messageSquareMoreJsDefault.default));
parcelHelpers.export(exports, "MessageSquareMore", ()=>(0, _messageSquareMoreJsDefault.default));
parcelHelpers.export(exports, "MessageSquareMoreIcon", ()=>(0, _messageSquareMoreJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareOff", ()=>(0, _messageSquareOffJsDefault.default));
parcelHelpers.export(exports, "MessageSquareOff", ()=>(0, _messageSquareOffJsDefault.default));
parcelHelpers.export(exports, "MessageSquareOffIcon", ()=>(0, _messageSquareOffJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquarePlus", ()=>(0, _messageSquarePlusJsDefault.default));
parcelHelpers.export(exports, "MessageSquarePlus", ()=>(0, _messageSquarePlusJsDefault.default));
parcelHelpers.export(exports, "MessageSquarePlusIcon", ()=>(0, _messageSquarePlusJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareQuote", ()=>(0, _messageSquareQuoteJsDefault.default));
parcelHelpers.export(exports, "MessageSquareQuote", ()=>(0, _messageSquareQuoteJsDefault.default));
parcelHelpers.export(exports, "MessageSquareQuoteIcon", ()=>(0, _messageSquareQuoteJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareReply", ()=>(0, _messageSquareReplyJsDefault.default));
parcelHelpers.export(exports, "MessageSquareReply", ()=>(0, _messageSquareReplyJsDefault.default));
parcelHelpers.export(exports, "MessageSquareReplyIcon", ()=>(0, _messageSquareReplyJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareShare", ()=>(0, _messageSquareShareJsDefault.default));
parcelHelpers.export(exports, "MessageSquareShare", ()=>(0, _messageSquareShareJsDefault.default));
parcelHelpers.export(exports, "MessageSquareShareIcon", ()=>(0, _messageSquareShareJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareText", ()=>(0, _messageSquareTextJsDefault.default));
parcelHelpers.export(exports, "MessageSquareText", ()=>(0, _messageSquareTextJsDefault.default));
parcelHelpers.export(exports, "MessageSquareTextIcon", ()=>(0, _messageSquareTextJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareWarning", ()=>(0, _messageSquareWarningJsDefault.default));
parcelHelpers.export(exports, "MessageSquareWarning", ()=>(0, _messageSquareWarningJsDefault.default));
parcelHelpers.export(exports, "MessageSquareWarningIcon", ()=>(0, _messageSquareWarningJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquareX", ()=>(0, _messageSquareXJsDefault.default));
parcelHelpers.export(exports, "MessageSquareX", ()=>(0, _messageSquareXJsDefault.default));
parcelHelpers.export(exports, "MessageSquareXIcon", ()=>(0, _messageSquareXJsDefault.default));
parcelHelpers.export(exports, "LucideMessageSquare", ()=>(0, _messageSquareJsDefault.default));
parcelHelpers.export(exports, "MessageSquare", ()=>(0, _messageSquareJsDefault.default));
parcelHelpers.export(exports, "MessageSquareIcon", ()=>(0, _messageSquareJsDefault.default));
parcelHelpers.export(exports, "LucideMessagesSquare", ()=>(0, _messagesSquareJsDefault.default));
parcelHelpers.export(exports, "MessagesSquare", ()=>(0, _messagesSquareJsDefault.default));
parcelHelpers.export(exports, "MessagesSquareIcon", ()=>(0, _messagesSquareJsDefault.default));
parcelHelpers.export(exports, "LucideMic2", ()=>(0, _mic2JsDefault.default));
parcelHelpers.export(exports, "Mic2", ()=>(0, _mic2JsDefault.default));
parcelHelpers.export(exports, "Mic2Icon", ()=>(0, _mic2JsDefault.default));
parcelHelpers.export(exports, "LucideMicOff", ()=>(0, _micOffJsDefault.default));
parcelHelpers.export(exports, "MicOff", ()=>(0, _micOffJsDefault.default));
parcelHelpers.export(exports, "MicOffIcon", ()=>(0, _micOffJsDefault.default));
parcelHelpers.export(exports, "LucideMic", ()=>(0, _micJsDefault.default));
parcelHelpers.export(exports, "Mic", ()=>(0, _micJsDefault.default));
parcelHelpers.export(exports, "MicIcon", ()=>(0, _micJsDefault.default));
parcelHelpers.export(exports, "LucideMicroscope", ()=>(0, _microscopeJsDefault.default));
parcelHelpers.export(exports, "Microscope", ()=>(0, _microscopeJsDefault.default));
parcelHelpers.export(exports, "MicroscopeIcon", ()=>(0, _microscopeJsDefault.default));
parcelHelpers.export(exports, "LucideMicrowave", ()=>(0, _microwaveJsDefault.default));
parcelHelpers.export(exports, "Microwave", ()=>(0, _microwaveJsDefault.default));
parcelHelpers.export(exports, "MicrowaveIcon", ()=>(0, _microwaveJsDefault.default));
parcelHelpers.export(exports, "LucideMilestone", ()=>(0, _milestoneJsDefault.default));
parcelHelpers.export(exports, "Milestone", ()=>(0, _milestoneJsDefault.default));
parcelHelpers.export(exports, "MilestoneIcon", ()=>(0, _milestoneJsDefault.default));
parcelHelpers.export(exports, "LucideMilkOff", ()=>(0, _milkOffJsDefault.default));
parcelHelpers.export(exports, "MilkOff", ()=>(0, _milkOffJsDefault.default));
parcelHelpers.export(exports, "MilkOffIcon", ()=>(0, _milkOffJsDefault.default));
parcelHelpers.export(exports, "LucideMilk", ()=>(0, _milkJsDefault.default));
parcelHelpers.export(exports, "Milk", ()=>(0, _milkJsDefault.default));
parcelHelpers.export(exports, "MilkIcon", ()=>(0, _milkJsDefault.default));
parcelHelpers.export(exports, "LucideMinimize2", ()=>(0, _minimize2JsDefault.default));
parcelHelpers.export(exports, "Minimize2", ()=>(0, _minimize2JsDefault.default));
parcelHelpers.export(exports, "Minimize2Icon", ()=>(0, _minimize2JsDefault.default));
parcelHelpers.export(exports, "LucideMinimize", ()=>(0, _minimizeJsDefault.default));
parcelHelpers.export(exports, "Minimize", ()=>(0, _minimizeJsDefault.default));
parcelHelpers.export(exports, "MinimizeIcon", ()=>(0, _minimizeJsDefault.default));
parcelHelpers.export(exports, "LucideMinusCircle", ()=>(0, _minusCircleJsDefault.default));
parcelHelpers.export(exports, "MinusCircle", ()=>(0, _minusCircleJsDefault.default));
parcelHelpers.export(exports, "MinusCircleIcon", ()=>(0, _minusCircleJsDefault.default));
parcelHelpers.export(exports, "LucideMinusSquare", ()=>(0, _minusSquareJsDefault.default));
parcelHelpers.export(exports, "MinusSquare", ()=>(0, _minusSquareJsDefault.default));
parcelHelpers.export(exports, "MinusSquareIcon", ()=>(0, _minusSquareJsDefault.default));
parcelHelpers.export(exports, "LucideMinus", ()=>(0, _minusJsDefault.default));
parcelHelpers.export(exports, "Minus", ()=>(0, _minusJsDefault.default));
parcelHelpers.export(exports, "MinusIcon", ()=>(0, _minusJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorCheck", ()=>(0, _monitorCheckJsDefault.default));
parcelHelpers.export(exports, "MonitorCheck", ()=>(0, _monitorCheckJsDefault.default));
parcelHelpers.export(exports, "MonitorCheckIcon", ()=>(0, _monitorCheckJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorDot", ()=>(0, _monitorDotJsDefault.default));
parcelHelpers.export(exports, "MonitorDot", ()=>(0, _monitorDotJsDefault.default));
parcelHelpers.export(exports, "MonitorDotIcon", ()=>(0, _monitorDotJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorDown", ()=>(0, _monitorDownJsDefault.default));
parcelHelpers.export(exports, "MonitorDown", ()=>(0, _monitorDownJsDefault.default));
parcelHelpers.export(exports, "MonitorDownIcon", ()=>(0, _monitorDownJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorOff", ()=>(0, _monitorOffJsDefault.default));
parcelHelpers.export(exports, "MonitorOff", ()=>(0, _monitorOffJsDefault.default));
parcelHelpers.export(exports, "MonitorOffIcon", ()=>(0, _monitorOffJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorPause", ()=>(0, _monitorPauseJsDefault.default));
parcelHelpers.export(exports, "MonitorPause", ()=>(0, _monitorPauseJsDefault.default));
parcelHelpers.export(exports, "MonitorPauseIcon", ()=>(0, _monitorPauseJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorPlay", ()=>(0, _monitorPlayJsDefault.default));
parcelHelpers.export(exports, "MonitorPlay", ()=>(0, _monitorPlayJsDefault.default));
parcelHelpers.export(exports, "MonitorPlayIcon", ()=>(0, _monitorPlayJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorSmartphone", ()=>(0, _monitorSmartphoneJsDefault.default));
parcelHelpers.export(exports, "MonitorSmartphone", ()=>(0, _monitorSmartphoneJsDefault.default));
parcelHelpers.export(exports, "MonitorSmartphoneIcon", ()=>(0, _monitorSmartphoneJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorSpeaker", ()=>(0, _monitorSpeakerJsDefault.default));
parcelHelpers.export(exports, "MonitorSpeaker", ()=>(0, _monitorSpeakerJsDefault.default));
parcelHelpers.export(exports, "MonitorSpeakerIcon", ()=>(0, _monitorSpeakerJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorStop", ()=>(0, _monitorStopJsDefault.default));
parcelHelpers.export(exports, "MonitorStop", ()=>(0, _monitorStopJsDefault.default));
parcelHelpers.export(exports, "MonitorStopIcon", ()=>(0, _monitorStopJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorUp", ()=>(0, _monitorUpJsDefault.default));
parcelHelpers.export(exports, "MonitorUp", ()=>(0, _monitorUpJsDefault.default));
parcelHelpers.export(exports, "MonitorUpIcon", ()=>(0, _monitorUpJsDefault.default));
parcelHelpers.export(exports, "LucideMonitorX", ()=>(0, _monitorXJsDefault.default));
parcelHelpers.export(exports, "MonitorX", ()=>(0, _monitorXJsDefault.default));
parcelHelpers.export(exports, "MonitorXIcon", ()=>(0, _monitorXJsDefault.default));
parcelHelpers.export(exports, "LucideMonitor", ()=>(0, _monitorJsDefault.default));
parcelHelpers.export(exports, "Monitor", ()=>(0, _monitorJsDefault.default));
parcelHelpers.export(exports, "MonitorIcon", ()=>(0, _monitorJsDefault.default));
parcelHelpers.export(exports, "LucideMoonStar", ()=>(0, _moonStarJsDefault.default));
parcelHelpers.export(exports, "MoonStar", ()=>(0, _moonStarJsDefault.default));
parcelHelpers.export(exports, "MoonStarIcon", ()=>(0, _moonStarJsDefault.default));
parcelHelpers.export(exports, "LucideMoon", ()=>(0, _moonJsDefault.default));
parcelHelpers.export(exports, "Moon", ()=>(0, _moonJsDefault.default));
parcelHelpers.export(exports, "MoonIcon", ()=>(0, _moonJsDefault.default));
parcelHelpers.export(exports, "LucideMoreHorizontal", ()=>(0, _moreHorizontalJsDefault.default));
parcelHelpers.export(exports, "MoreHorizontal", ()=>(0, _moreHorizontalJsDefault.default));
parcelHelpers.export(exports, "MoreHorizontalIcon", ()=>(0, _moreHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideMoreVertical", ()=>(0, _moreVerticalJsDefault.default));
parcelHelpers.export(exports, "MoreVertical", ()=>(0, _moreVerticalJsDefault.default));
parcelHelpers.export(exports, "MoreVerticalIcon", ()=>(0, _moreVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideMountainSnow", ()=>(0, _mountainSnowJsDefault.default));
parcelHelpers.export(exports, "MountainSnow", ()=>(0, _mountainSnowJsDefault.default));
parcelHelpers.export(exports, "MountainSnowIcon", ()=>(0, _mountainSnowJsDefault.default));
parcelHelpers.export(exports, "LucideMountain", ()=>(0, _mountainJsDefault.default));
parcelHelpers.export(exports, "Mountain", ()=>(0, _mountainJsDefault.default));
parcelHelpers.export(exports, "MountainIcon", ()=>(0, _mountainJsDefault.default));
parcelHelpers.export(exports, "LucideMousePointer2", ()=>(0, _mousePointer2JsDefault.default));
parcelHelpers.export(exports, "MousePointer2", ()=>(0, _mousePointer2JsDefault.default));
parcelHelpers.export(exports, "MousePointer2Icon", ()=>(0, _mousePointer2JsDefault.default));
parcelHelpers.export(exports, "LucideMousePointerClick", ()=>(0, _mousePointerClickJsDefault.default));
parcelHelpers.export(exports, "MousePointerClick", ()=>(0, _mousePointerClickJsDefault.default));
parcelHelpers.export(exports, "MousePointerClickIcon", ()=>(0, _mousePointerClickJsDefault.default));
parcelHelpers.export(exports, "LucideMousePointerSquareDashed", ()=>(0, _mousePointerSquareDashedJsDefault.default));
parcelHelpers.export(exports, "MousePointerSquareDashed", ()=>(0, _mousePointerSquareDashedJsDefault.default));
parcelHelpers.export(exports, "MousePointerSquareDashedIcon", ()=>(0, _mousePointerSquareDashedJsDefault.default));
parcelHelpers.export(exports, "LucideMousePointer", ()=>(0, _mousePointerJsDefault.default));
parcelHelpers.export(exports, "MousePointer", ()=>(0, _mousePointerJsDefault.default));
parcelHelpers.export(exports, "MousePointerIcon", ()=>(0, _mousePointerJsDefault.default));
parcelHelpers.export(exports, "LucideMouse", ()=>(0, _mouseJsDefault.default));
parcelHelpers.export(exports, "Mouse", ()=>(0, _mouseJsDefault.default));
parcelHelpers.export(exports, "MouseIcon", ()=>(0, _mouseJsDefault.default));
parcelHelpers.export(exports, "LucideMoveDiagonal2", ()=>(0, _moveDiagonal2JsDefault.default));
parcelHelpers.export(exports, "MoveDiagonal2", ()=>(0, _moveDiagonal2JsDefault.default));
parcelHelpers.export(exports, "MoveDiagonal2Icon", ()=>(0, _moveDiagonal2JsDefault.default));
parcelHelpers.export(exports, "LucideMoveDiagonal", ()=>(0, _moveDiagonalJsDefault.default));
parcelHelpers.export(exports, "MoveDiagonal", ()=>(0, _moveDiagonalJsDefault.default));
parcelHelpers.export(exports, "MoveDiagonalIcon", ()=>(0, _moveDiagonalJsDefault.default));
parcelHelpers.export(exports, "LucideMoveDownLeft", ()=>(0, _moveDownLeftJsDefault.default));
parcelHelpers.export(exports, "MoveDownLeft", ()=>(0, _moveDownLeftJsDefault.default));
parcelHelpers.export(exports, "MoveDownLeftIcon", ()=>(0, _moveDownLeftJsDefault.default));
parcelHelpers.export(exports, "LucideMoveDownRight", ()=>(0, _moveDownRightJsDefault.default));
parcelHelpers.export(exports, "MoveDownRight", ()=>(0, _moveDownRightJsDefault.default));
parcelHelpers.export(exports, "MoveDownRightIcon", ()=>(0, _moveDownRightJsDefault.default));
parcelHelpers.export(exports, "LucideMoveDown", ()=>(0, _moveDownJsDefault.default));
parcelHelpers.export(exports, "MoveDown", ()=>(0, _moveDownJsDefault.default));
parcelHelpers.export(exports, "MoveDownIcon", ()=>(0, _moveDownJsDefault.default));
parcelHelpers.export(exports, "LucideMoveHorizontal", ()=>(0, _moveHorizontalJsDefault.default));
parcelHelpers.export(exports, "MoveHorizontal", ()=>(0, _moveHorizontalJsDefault.default));
parcelHelpers.export(exports, "MoveHorizontalIcon", ()=>(0, _moveHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideMoveLeft", ()=>(0, _moveLeftJsDefault.default));
parcelHelpers.export(exports, "MoveLeft", ()=>(0, _moveLeftJsDefault.default));
parcelHelpers.export(exports, "MoveLeftIcon", ()=>(0, _moveLeftJsDefault.default));
parcelHelpers.export(exports, "LucideMoveRight", ()=>(0, _moveRightJsDefault.default));
parcelHelpers.export(exports, "MoveRight", ()=>(0, _moveRightJsDefault.default));
parcelHelpers.export(exports, "MoveRightIcon", ()=>(0, _moveRightJsDefault.default));
parcelHelpers.export(exports, "LucideMoveUpLeft", ()=>(0, _moveUpLeftJsDefault.default));
parcelHelpers.export(exports, "MoveUpLeft", ()=>(0, _moveUpLeftJsDefault.default));
parcelHelpers.export(exports, "MoveUpLeftIcon", ()=>(0, _moveUpLeftJsDefault.default));
parcelHelpers.export(exports, "LucideMoveUpRight", ()=>(0, _moveUpRightJsDefault.default));
parcelHelpers.export(exports, "MoveUpRight", ()=>(0, _moveUpRightJsDefault.default));
parcelHelpers.export(exports, "MoveUpRightIcon", ()=>(0, _moveUpRightJsDefault.default));
parcelHelpers.export(exports, "LucideMoveUp", ()=>(0, _moveUpJsDefault.default));
parcelHelpers.export(exports, "MoveUp", ()=>(0, _moveUpJsDefault.default));
parcelHelpers.export(exports, "MoveUpIcon", ()=>(0, _moveUpJsDefault.default));
parcelHelpers.export(exports, "LucideMoveVertical", ()=>(0, _moveVerticalJsDefault.default));
parcelHelpers.export(exports, "MoveVertical", ()=>(0, _moveVerticalJsDefault.default));
parcelHelpers.export(exports, "MoveVerticalIcon", ()=>(0, _moveVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideMove", ()=>(0, _moveJsDefault.default));
parcelHelpers.export(exports, "Move", ()=>(0, _moveJsDefault.default));
parcelHelpers.export(exports, "MoveIcon", ()=>(0, _moveJsDefault.default));
parcelHelpers.export(exports, "LucideMusic2", ()=>(0, _music2JsDefault.default));
parcelHelpers.export(exports, "Music2", ()=>(0, _music2JsDefault.default));
parcelHelpers.export(exports, "Music2Icon", ()=>(0, _music2JsDefault.default));
parcelHelpers.export(exports, "LucideMusic3", ()=>(0, _music3JsDefault.default));
parcelHelpers.export(exports, "Music3", ()=>(0, _music3JsDefault.default));
parcelHelpers.export(exports, "Music3Icon", ()=>(0, _music3JsDefault.default));
parcelHelpers.export(exports, "LucideMusic4", ()=>(0, _music4JsDefault.default));
parcelHelpers.export(exports, "Music4", ()=>(0, _music4JsDefault.default));
parcelHelpers.export(exports, "Music4Icon", ()=>(0, _music4JsDefault.default));
parcelHelpers.export(exports, "LucideMusic", ()=>(0, _musicJsDefault.default));
parcelHelpers.export(exports, "Music", ()=>(0, _musicJsDefault.default));
parcelHelpers.export(exports, "MusicIcon", ()=>(0, _musicJsDefault.default));
parcelHelpers.export(exports, "LucideNavigation2Off", ()=>(0, _navigation2OffJsDefault.default));
parcelHelpers.export(exports, "Navigation2Off", ()=>(0, _navigation2OffJsDefault.default));
parcelHelpers.export(exports, "Navigation2OffIcon", ()=>(0, _navigation2OffJsDefault.default));
parcelHelpers.export(exports, "LucideNavigation2", ()=>(0, _navigation2JsDefault.default));
parcelHelpers.export(exports, "Navigation2", ()=>(0, _navigation2JsDefault.default));
parcelHelpers.export(exports, "Navigation2Icon", ()=>(0, _navigation2JsDefault.default));
parcelHelpers.export(exports, "LucideNavigationOff", ()=>(0, _navigationOffJsDefault.default));
parcelHelpers.export(exports, "NavigationOff", ()=>(0, _navigationOffJsDefault.default));
parcelHelpers.export(exports, "NavigationOffIcon", ()=>(0, _navigationOffJsDefault.default));
parcelHelpers.export(exports, "LucideNavigation", ()=>(0, _navigationJsDefault.default));
parcelHelpers.export(exports, "Navigation", ()=>(0, _navigationJsDefault.default));
parcelHelpers.export(exports, "NavigationIcon", ()=>(0, _navigationJsDefault.default));
parcelHelpers.export(exports, "LucideNetwork", ()=>(0, _networkJsDefault.default));
parcelHelpers.export(exports, "Network", ()=>(0, _networkJsDefault.default));
parcelHelpers.export(exports, "NetworkIcon", ()=>(0, _networkJsDefault.default));
parcelHelpers.export(exports, "LucideNewspaper", ()=>(0, _newspaperJsDefault.default));
parcelHelpers.export(exports, "Newspaper", ()=>(0, _newspaperJsDefault.default));
parcelHelpers.export(exports, "NewspaperIcon", ()=>(0, _newspaperJsDefault.default));
parcelHelpers.export(exports, "LucideNfc", ()=>(0, _nfcJsDefault.default));
parcelHelpers.export(exports, "Nfc", ()=>(0, _nfcJsDefault.default));
parcelHelpers.export(exports, "NfcIcon", ()=>(0, _nfcJsDefault.default));
parcelHelpers.export(exports, "LucideNotebookPen", ()=>(0, _notebookPenJsDefault.default));
parcelHelpers.export(exports, "NotebookPen", ()=>(0, _notebookPenJsDefault.default));
parcelHelpers.export(exports, "NotebookPenIcon", ()=>(0, _notebookPenJsDefault.default));
parcelHelpers.export(exports, "LucideNotebookTabs", ()=>(0, _notebookTabsJsDefault.default));
parcelHelpers.export(exports, "NotebookTabs", ()=>(0, _notebookTabsJsDefault.default));
parcelHelpers.export(exports, "NotebookTabsIcon", ()=>(0, _notebookTabsJsDefault.default));
parcelHelpers.export(exports, "LucideNotebookText", ()=>(0, _notebookTextJsDefault.default));
parcelHelpers.export(exports, "NotebookText", ()=>(0, _notebookTextJsDefault.default));
parcelHelpers.export(exports, "NotebookTextIcon", ()=>(0, _notebookTextJsDefault.default));
parcelHelpers.export(exports, "LucideNotebook", ()=>(0, _notebookJsDefault.default));
parcelHelpers.export(exports, "Notebook", ()=>(0, _notebookJsDefault.default));
parcelHelpers.export(exports, "NotebookIcon", ()=>(0, _notebookJsDefault.default));
parcelHelpers.export(exports, "LucideNotepadTextDashed", ()=>(0, _notepadTextDashedJsDefault.default));
parcelHelpers.export(exports, "NotepadTextDashed", ()=>(0, _notepadTextDashedJsDefault.default));
parcelHelpers.export(exports, "NotepadTextDashedIcon", ()=>(0, _notepadTextDashedJsDefault.default));
parcelHelpers.export(exports, "LucideNotepadText", ()=>(0, _notepadTextJsDefault.default));
parcelHelpers.export(exports, "NotepadText", ()=>(0, _notepadTextJsDefault.default));
parcelHelpers.export(exports, "NotepadTextIcon", ()=>(0, _notepadTextJsDefault.default));
parcelHelpers.export(exports, "LucideNutOff", ()=>(0, _nutOffJsDefault.default));
parcelHelpers.export(exports, "NutOff", ()=>(0, _nutOffJsDefault.default));
parcelHelpers.export(exports, "NutOffIcon", ()=>(0, _nutOffJsDefault.default));
parcelHelpers.export(exports, "LucideNut", ()=>(0, _nutJsDefault.default));
parcelHelpers.export(exports, "Nut", ()=>(0, _nutJsDefault.default));
parcelHelpers.export(exports, "NutIcon", ()=>(0, _nutJsDefault.default));
parcelHelpers.export(exports, "LucideOctagon", ()=>(0, _octagonJsDefault.default));
parcelHelpers.export(exports, "Octagon", ()=>(0, _octagonJsDefault.default));
parcelHelpers.export(exports, "OctagonIcon", ()=>(0, _octagonJsDefault.default));
parcelHelpers.export(exports, "LucideOption", ()=>(0, _optionJsDefault.default));
parcelHelpers.export(exports, "Option", ()=>(0, _optionJsDefault.default));
parcelHelpers.export(exports, "OptionIcon", ()=>(0, _optionJsDefault.default));
parcelHelpers.export(exports, "LucideOrbit", ()=>(0, _orbitJsDefault.default));
parcelHelpers.export(exports, "Orbit", ()=>(0, _orbitJsDefault.default));
parcelHelpers.export(exports, "OrbitIcon", ()=>(0, _orbitJsDefault.default));
parcelHelpers.export(exports, "LucideOutdent", ()=>(0, _outdentJsDefault.default));
parcelHelpers.export(exports, "Outdent", ()=>(0, _outdentJsDefault.default));
parcelHelpers.export(exports, "OutdentIcon", ()=>(0, _outdentJsDefault.default));
parcelHelpers.export(exports, "LucidePackage2", ()=>(0, _package2JsDefault.default));
parcelHelpers.export(exports, "Package2", ()=>(0, _package2JsDefault.default));
parcelHelpers.export(exports, "Package2Icon", ()=>(0, _package2JsDefault.default));
parcelHelpers.export(exports, "LucidePackageCheck", ()=>(0, _packageCheckJsDefault.default));
parcelHelpers.export(exports, "PackageCheck", ()=>(0, _packageCheckJsDefault.default));
parcelHelpers.export(exports, "PackageCheckIcon", ()=>(0, _packageCheckJsDefault.default));
parcelHelpers.export(exports, "LucidePackageMinus", ()=>(0, _packageMinusJsDefault.default));
parcelHelpers.export(exports, "PackageMinus", ()=>(0, _packageMinusJsDefault.default));
parcelHelpers.export(exports, "PackageMinusIcon", ()=>(0, _packageMinusJsDefault.default));
parcelHelpers.export(exports, "LucidePackageOpen", ()=>(0, _packageOpenJsDefault.default));
parcelHelpers.export(exports, "PackageOpen", ()=>(0, _packageOpenJsDefault.default));
parcelHelpers.export(exports, "PackageOpenIcon", ()=>(0, _packageOpenJsDefault.default));
parcelHelpers.export(exports, "LucidePackagePlus", ()=>(0, _packagePlusJsDefault.default));
parcelHelpers.export(exports, "PackagePlus", ()=>(0, _packagePlusJsDefault.default));
parcelHelpers.export(exports, "PackagePlusIcon", ()=>(0, _packagePlusJsDefault.default));
parcelHelpers.export(exports, "LucidePackageSearch", ()=>(0, _packageSearchJsDefault.default));
parcelHelpers.export(exports, "PackageSearch", ()=>(0, _packageSearchJsDefault.default));
parcelHelpers.export(exports, "PackageSearchIcon", ()=>(0, _packageSearchJsDefault.default));
parcelHelpers.export(exports, "LucidePackageX", ()=>(0, _packageXJsDefault.default));
parcelHelpers.export(exports, "PackageX", ()=>(0, _packageXJsDefault.default));
parcelHelpers.export(exports, "PackageXIcon", ()=>(0, _packageXJsDefault.default));
parcelHelpers.export(exports, "LucidePackage", ()=>(0, _packageJsDefault.default));
parcelHelpers.export(exports, "Package", ()=>(0, _packageJsDefault.default));
parcelHelpers.export(exports, "PackageIcon", ()=>(0, _packageJsDefault.default));
parcelHelpers.export(exports, "LucidePaintBucket", ()=>(0, _paintBucketJsDefault.default));
parcelHelpers.export(exports, "PaintBucket", ()=>(0, _paintBucketJsDefault.default));
parcelHelpers.export(exports, "PaintBucketIcon", ()=>(0, _paintBucketJsDefault.default));
parcelHelpers.export(exports, "LucidePaintRoller", ()=>(0, _paintRollerJsDefault.default));
parcelHelpers.export(exports, "PaintRoller", ()=>(0, _paintRollerJsDefault.default));
parcelHelpers.export(exports, "PaintRollerIcon", ()=>(0, _paintRollerJsDefault.default));
parcelHelpers.export(exports, "LucidePaintbrush2", ()=>(0, _paintbrush2JsDefault.default));
parcelHelpers.export(exports, "Paintbrush2", ()=>(0, _paintbrush2JsDefault.default));
parcelHelpers.export(exports, "Paintbrush2Icon", ()=>(0, _paintbrush2JsDefault.default));
parcelHelpers.export(exports, "LucidePaintbrush", ()=>(0, _paintbrushJsDefault.default));
parcelHelpers.export(exports, "Paintbrush", ()=>(0, _paintbrushJsDefault.default));
parcelHelpers.export(exports, "PaintbrushIcon", ()=>(0, _paintbrushJsDefault.default));
parcelHelpers.export(exports, "LucidePalette", ()=>(0, _paletteJsDefault.default));
parcelHelpers.export(exports, "Palette", ()=>(0, _paletteJsDefault.default));
parcelHelpers.export(exports, "PaletteIcon", ()=>(0, _paletteJsDefault.default));
parcelHelpers.export(exports, "LucidePalmtree", ()=>(0, _palmtreeJsDefault.default));
parcelHelpers.export(exports, "Palmtree", ()=>(0, _palmtreeJsDefault.default));
parcelHelpers.export(exports, "PalmtreeIcon", ()=>(0, _palmtreeJsDefault.default));
parcelHelpers.export(exports, "LucidePanelBottomClose", ()=>(0, _panelBottomCloseJsDefault.default));
parcelHelpers.export(exports, "PanelBottomClose", ()=>(0, _panelBottomCloseJsDefault.default));
parcelHelpers.export(exports, "PanelBottomCloseIcon", ()=>(0, _panelBottomCloseJsDefault.default));
parcelHelpers.export(exports, "LucidePanelBottomOpen", ()=>(0, _panelBottomOpenJsDefault.default));
parcelHelpers.export(exports, "PanelBottomOpen", ()=>(0, _panelBottomOpenJsDefault.default));
parcelHelpers.export(exports, "PanelBottomOpenIcon", ()=>(0, _panelBottomOpenJsDefault.default));
parcelHelpers.export(exports, "LucidePanelBottom", ()=>(0, _panelBottomJsDefault.default));
parcelHelpers.export(exports, "PanelBottom", ()=>(0, _panelBottomJsDefault.default));
parcelHelpers.export(exports, "PanelBottomIcon", ()=>(0, _panelBottomJsDefault.default));
parcelHelpers.export(exports, "LucidePanelRightClose", ()=>(0, _panelRightCloseJsDefault.default));
parcelHelpers.export(exports, "PanelRightClose", ()=>(0, _panelRightCloseJsDefault.default));
parcelHelpers.export(exports, "PanelRightCloseIcon", ()=>(0, _panelRightCloseJsDefault.default));
parcelHelpers.export(exports, "LucidePanelRightOpen", ()=>(0, _panelRightOpenJsDefault.default));
parcelHelpers.export(exports, "PanelRightOpen", ()=>(0, _panelRightOpenJsDefault.default));
parcelHelpers.export(exports, "PanelRightOpenIcon", ()=>(0, _panelRightOpenJsDefault.default));
parcelHelpers.export(exports, "LucidePanelRight", ()=>(0, _panelRightJsDefault.default));
parcelHelpers.export(exports, "PanelRight", ()=>(0, _panelRightJsDefault.default));
parcelHelpers.export(exports, "PanelRightIcon", ()=>(0, _panelRightJsDefault.default));
parcelHelpers.export(exports, "LucidePanelTopClose", ()=>(0, _panelTopCloseJsDefault.default));
parcelHelpers.export(exports, "PanelTopClose", ()=>(0, _panelTopCloseJsDefault.default));
parcelHelpers.export(exports, "PanelTopCloseIcon", ()=>(0, _panelTopCloseJsDefault.default));
parcelHelpers.export(exports, "LucidePanelTopOpen", ()=>(0, _panelTopOpenJsDefault.default));
parcelHelpers.export(exports, "PanelTopOpen", ()=>(0, _panelTopOpenJsDefault.default));
parcelHelpers.export(exports, "PanelTopOpenIcon", ()=>(0, _panelTopOpenJsDefault.default));
parcelHelpers.export(exports, "LucidePanelTop", ()=>(0, _panelTopJsDefault.default));
parcelHelpers.export(exports, "PanelTop", ()=>(0, _panelTopJsDefault.default));
parcelHelpers.export(exports, "PanelTopIcon", ()=>(0, _panelTopJsDefault.default));
parcelHelpers.export(exports, "LucidePanelsLeftBottom", ()=>(0, _panelsLeftBottomJsDefault.default));
parcelHelpers.export(exports, "PanelsLeftBottom", ()=>(0, _panelsLeftBottomJsDefault.default));
parcelHelpers.export(exports, "PanelsLeftBottomIcon", ()=>(0, _panelsLeftBottomJsDefault.default));
parcelHelpers.export(exports, "LucidePanelsRightBottom", ()=>(0, _panelsRightBottomJsDefault.default));
parcelHelpers.export(exports, "PanelsRightBottom", ()=>(0, _panelsRightBottomJsDefault.default));
parcelHelpers.export(exports, "PanelsRightBottomIcon", ()=>(0, _panelsRightBottomJsDefault.default));
parcelHelpers.export(exports, "LucidePaperclip", ()=>(0, _paperclipJsDefault.default));
parcelHelpers.export(exports, "Paperclip", ()=>(0, _paperclipJsDefault.default));
parcelHelpers.export(exports, "PaperclipIcon", ()=>(0, _paperclipJsDefault.default));
parcelHelpers.export(exports, "LucideParentheses", ()=>(0, _parenthesesJsDefault.default));
parcelHelpers.export(exports, "Parentheses", ()=>(0, _parenthesesJsDefault.default));
parcelHelpers.export(exports, "ParenthesesIcon", ()=>(0, _parenthesesJsDefault.default));
parcelHelpers.export(exports, "LucideParkingCircleOff", ()=>(0, _parkingCircleOffJsDefault.default));
parcelHelpers.export(exports, "ParkingCircleOff", ()=>(0, _parkingCircleOffJsDefault.default));
parcelHelpers.export(exports, "ParkingCircleOffIcon", ()=>(0, _parkingCircleOffJsDefault.default));
parcelHelpers.export(exports, "LucideParkingCircle", ()=>(0, _parkingCircleJsDefault.default));
parcelHelpers.export(exports, "ParkingCircle", ()=>(0, _parkingCircleJsDefault.default));
parcelHelpers.export(exports, "ParkingCircleIcon", ()=>(0, _parkingCircleJsDefault.default));
parcelHelpers.export(exports, "LucideParkingMeter", ()=>(0, _parkingMeterJsDefault.default));
parcelHelpers.export(exports, "ParkingMeter", ()=>(0, _parkingMeterJsDefault.default));
parcelHelpers.export(exports, "ParkingMeterIcon", ()=>(0, _parkingMeterJsDefault.default));
parcelHelpers.export(exports, "LucideParkingSquareOff", ()=>(0, _parkingSquareOffJsDefault.default));
parcelHelpers.export(exports, "ParkingSquareOff", ()=>(0, _parkingSquareOffJsDefault.default));
parcelHelpers.export(exports, "ParkingSquareOffIcon", ()=>(0, _parkingSquareOffJsDefault.default));
parcelHelpers.export(exports, "LucideParkingSquare", ()=>(0, _parkingSquareJsDefault.default));
parcelHelpers.export(exports, "ParkingSquare", ()=>(0, _parkingSquareJsDefault.default));
parcelHelpers.export(exports, "ParkingSquareIcon", ()=>(0, _parkingSquareJsDefault.default));
parcelHelpers.export(exports, "LucidePartyPopper", ()=>(0, _partyPopperJsDefault.default));
parcelHelpers.export(exports, "PartyPopper", ()=>(0, _partyPopperJsDefault.default));
parcelHelpers.export(exports, "PartyPopperIcon", ()=>(0, _partyPopperJsDefault.default));
parcelHelpers.export(exports, "LucidePauseCircle", ()=>(0, _pauseCircleJsDefault.default));
parcelHelpers.export(exports, "PauseCircle", ()=>(0, _pauseCircleJsDefault.default));
parcelHelpers.export(exports, "PauseCircleIcon", ()=>(0, _pauseCircleJsDefault.default));
parcelHelpers.export(exports, "LucidePauseOctagon", ()=>(0, _pauseOctagonJsDefault.default));
parcelHelpers.export(exports, "PauseOctagon", ()=>(0, _pauseOctagonJsDefault.default));
parcelHelpers.export(exports, "PauseOctagonIcon", ()=>(0, _pauseOctagonJsDefault.default));
parcelHelpers.export(exports, "LucidePause", ()=>(0, _pauseJsDefault.default));
parcelHelpers.export(exports, "Pause", ()=>(0, _pauseJsDefault.default));
parcelHelpers.export(exports, "PauseIcon", ()=>(0, _pauseJsDefault.default));
parcelHelpers.export(exports, "LucidePawPrint", ()=>(0, _pawPrintJsDefault.default));
parcelHelpers.export(exports, "PawPrint", ()=>(0, _pawPrintJsDefault.default));
parcelHelpers.export(exports, "PawPrintIcon", ()=>(0, _pawPrintJsDefault.default));
parcelHelpers.export(exports, "LucidePcCase", ()=>(0, _pcCaseJsDefault.default));
parcelHelpers.export(exports, "PcCase", ()=>(0, _pcCaseJsDefault.default));
parcelHelpers.export(exports, "PcCaseIcon", ()=>(0, _pcCaseJsDefault.default));
parcelHelpers.export(exports, "LucidePenTool", ()=>(0, _penToolJsDefault.default));
parcelHelpers.export(exports, "PenTool", ()=>(0, _penToolJsDefault.default));
parcelHelpers.export(exports, "PenToolIcon", ()=>(0, _penToolJsDefault.default));
parcelHelpers.export(exports, "LucidePencilLine", ()=>(0, _pencilLineJsDefault.default));
parcelHelpers.export(exports, "PencilLine", ()=>(0, _pencilLineJsDefault.default));
parcelHelpers.export(exports, "PencilLineIcon", ()=>(0, _pencilLineJsDefault.default));
parcelHelpers.export(exports, "LucidePencilRuler", ()=>(0, _pencilRulerJsDefault.default));
parcelHelpers.export(exports, "PencilRuler", ()=>(0, _pencilRulerJsDefault.default));
parcelHelpers.export(exports, "PencilRulerIcon", ()=>(0, _pencilRulerJsDefault.default));
parcelHelpers.export(exports, "LucidePencil", ()=>(0, _pencilJsDefault.default));
parcelHelpers.export(exports, "Pencil", ()=>(0, _pencilJsDefault.default));
parcelHelpers.export(exports, "PencilIcon", ()=>(0, _pencilJsDefault.default));
parcelHelpers.export(exports, "LucidePentagon", ()=>(0, _pentagonJsDefault.default));
parcelHelpers.export(exports, "Pentagon", ()=>(0, _pentagonJsDefault.default));
parcelHelpers.export(exports, "PentagonIcon", ()=>(0, _pentagonJsDefault.default));
parcelHelpers.export(exports, "LucidePercentCircle", ()=>(0, _percentCircleJsDefault.default));
parcelHelpers.export(exports, "PercentCircle", ()=>(0, _percentCircleJsDefault.default));
parcelHelpers.export(exports, "PercentCircleIcon", ()=>(0, _percentCircleJsDefault.default));
parcelHelpers.export(exports, "LucidePercentDiamond", ()=>(0, _percentDiamondJsDefault.default));
parcelHelpers.export(exports, "PercentDiamond", ()=>(0, _percentDiamondJsDefault.default));
parcelHelpers.export(exports, "PercentDiamondIcon", ()=>(0, _percentDiamondJsDefault.default));
parcelHelpers.export(exports, "LucidePercentSquare", ()=>(0, _percentSquareJsDefault.default));
parcelHelpers.export(exports, "PercentSquare", ()=>(0, _percentSquareJsDefault.default));
parcelHelpers.export(exports, "PercentSquareIcon", ()=>(0, _percentSquareJsDefault.default));
parcelHelpers.export(exports, "LucidePercent", ()=>(0, _percentJsDefault.default));
parcelHelpers.export(exports, "Percent", ()=>(0, _percentJsDefault.default));
parcelHelpers.export(exports, "PercentIcon", ()=>(0, _percentJsDefault.default));
parcelHelpers.export(exports, "LucidePersonStanding", ()=>(0, _personStandingJsDefault.default));
parcelHelpers.export(exports, "PersonStanding", ()=>(0, _personStandingJsDefault.default));
parcelHelpers.export(exports, "PersonStandingIcon", ()=>(0, _personStandingJsDefault.default));
parcelHelpers.export(exports, "LucidePhoneCall", ()=>(0, _phoneCallJsDefault.default));
parcelHelpers.export(exports, "PhoneCall", ()=>(0, _phoneCallJsDefault.default));
parcelHelpers.export(exports, "PhoneCallIcon", ()=>(0, _phoneCallJsDefault.default));
parcelHelpers.export(exports, "LucidePhoneForwarded", ()=>(0, _phoneForwardedJsDefault.default));
parcelHelpers.export(exports, "PhoneForwarded", ()=>(0, _phoneForwardedJsDefault.default));
parcelHelpers.export(exports, "PhoneForwardedIcon", ()=>(0, _phoneForwardedJsDefault.default));
parcelHelpers.export(exports, "LucidePhoneIncoming", ()=>(0, _phoneIncomingJsDefault.default));
parcelHelpers.export(exports, "PhoneIncoming", ()=>(0, _phoneIncomingJsDefault.default));
parcelHelpers.export(exports, "PhoneIncomingIcon", ()=>(0, _phoneIncomingJsDefault.default));
parcelHelpers.export(exports, "LucidePhoneMissed", ()=>(0, _phoneMissedJsDefault.default));
parcelHelpers.export(exports, "PhoneMissed", ()=>(0, _phoneMissedJsDefault.default));
parcelHelpers.export(exports, "PhoneMissedIcon", ()=>(0, _phoneMissedJsDefault.default));
parcelHelpers.export(exports, "LucidePhoneOff", ()=>(0, _phoneOffJsDefault.default));
parcelHelpers.export(exports, "PhoneOff", ()=>(0, _phoneOffJsDefault.default));
parcelHelpers.export(exports, "PhoneOffIcon", ()=>(0, _phoneOffJsDefault.default));
parcelHelpers.export(exports, "LucidePhoneOutgoing", ()=>(0, _phoneOutgoingJsDefault.default));
parcelHelpers.export(exports, "PhoneOutgoing", ()=>(0, _phoneOutgoingJsDefault.default));
parcelHelpers.export(exports, "PhoneOutgoingIcon", ()=>(0, _phoneOutgoingJsDefault.default));
parcelHelpers.export(exports, "LucidePhone", ()=>(0, _phoneJsDefault.default));
parcelHelpers.export(exports, "Phone", ()=>(0, _phoneJsDefault.default));
parcelHelpers.export(exports, "PhoneIcon", ()=>(0, _phoneJsDefault.default));
parcelHelpers.export(exports, "LucidePiSquare", ()=>(0, _piSquareJsDefault.default));
parcelHelpers.export(exports, "PiSquare", ()=>(0, _piSquareJsDefault.default));
parcelHelpers.export(exports, "PiSquareIcon", ()=>(0, _piSquareJsDefault.default));
parcelHelpers.export(exports, "LucidePi", ()=>(0, _piJsDefault.default));
parcelHelpers.export(exports, "Pi", ()=>(0, _piJsDefault.default));
parcelHelpers.export(exports, "PiIcon", ()=>(0, _piJsDefault.default));
parcelHelpers.export(exports, "LucidePiano", ()=>(0, _pianoJsDefault.default));
parcelHelpers.export(exports, "Piano", ()=>(0, _pianoJsDefault.default));
parcelHelpers.export(exports, "PianoIcon", ()=>(0, _pianoJsDefault.default));
parcelHelpers.export(exports, "LucidePickaxe", ()=>(0, _pickaxeJsDefault.default));
parcelHelpers.export(exports, "Pickaxe", ()=>(0, _pickaxeJsDefault.default));
parcelHelpers.export(exports, "PickaxeIcon", ()=>(0, _pickaxeJsDefault.default));
parcelHelpers.export(exports, "LucidePictureInPicture2", ()=>(0, _pictureInPicture2JsDefault.default));
parcelHelpers.export(exports, "PictureInPicture2", ()=>(0, _pictureInPicture2JsDefault.default));
parcelHelpers.export(exports, "PictureInPicture2Icon", ()=>(0, _pictureInPicture2JsDefault.default));
parcelHelpers.export(exports, "LucidePictureInPicture", ()=>(0, _pictureInPictureJsDefault.default));
parcelHelpers.export(exports, "PictureInPicture", ()=>(0, _pictureInPictureJsDefault.default));
parcelHelpers.export(exports, "PictureInPictureIcon", ()=>(0, _pictureInPictureJsDefault.default));
parcelHelpers.export(exports, "LucidePieChart", ()=>(0, _pieChartJsDefault.default));
parcelHelpers.export(exports, "PieChart", ()=>(0, _pieChartJsDefault.default));
parcelHelpers.export(exports, "PieChartIcon", ()=>(0, _pieChartJsDefault.default));
parcelHelpers.export(exports, "LucidePiggyBank", ()=>(0, _piggyBankJsDefault.default));
parcelHelpers.export(exports, "PiggyBank", ()=>(0, _piggyBankJsDefault.default));
parcelHelpers.export(exports, "PiggyBankIcon", ()=>(0, _piggyBankJsDefault.default));
parcelHelpers.export(exports, "LucidePilcrowSquare", ()=>(0, _pilcrowSquareJsDefault.default));
parcelHelpers.export(exports, "PilcrowSquare", ()=>(0, _pilcrowSquareJsDefault.default));
parcelHelpers.export(exports, "PilcrowSquareIcon", ()=>(0, _pilcrowSquareJsDefault.default));
parcelHelpers.export(exports, "LucidePilcrow", ()=>(0, _pilcrowJsDefault.default));
parcelHelpers.export(exports, "Pilcrow", ()=>(0, _pilcrowJsDefault.default));
parcelHelpers.export(exports, "PilcrowIcon", ()=>(0, _pilcrowJsDefault.default));
parcelHelpers.export(exports, "LucidePill", ()=>(0, _pillJsDefault.default));
parcelHelpers.export(exports, "Pill", ()=>(0, _pillJsDefault.default));
parcelHelpers.export(exports, "PillIcon", ()=>(0, _pillJsDefault.default));
parcelHelpers.export(exports, "LucidePinOff", ()=>(0, _pinOffJsDefault.default));
parcelHelpers.export(exports, "PinOff", ()=>(0, _pinOffJsDefault.default));
parcelHelpers.export(exports, "PinOffIcon", ()=>(0, _pinOffJsDefault.default));
parcelHelpers.export(exports, "LucidePin", ()=>(0, _pinJsDefault.default));
parcelHelpers.export(exports, "Pin", ()=>(0, _pinJsDefault.default));
parcelHelpers.export(exports, "PinIcon", ()=>(0, _pinJsDefault.default));
parcelHelpers.export(exports, "LucidePipette", ()=>(0, _pipetteJsDefault.default));
parcelHelpers.export(exports, "Pipette", ()=>(0, _pipetteJsDefault.default));
parcelHelpers.export(exports, "PipetteIcon", ()=>(0, _pipetteJsDefault.default));
parcelHelpers.export(exports, "LucidePizza", ()=>(0, _pizzaJsDefault.default));
parcelHelpers.export(exports, "Pizza", ()=>(0, _pizzaJsDefault.default));
parcelHelpers.export(exports, "PizzaIcon", ()=>(0, _pizzaJsDefault.default));
parcelHelpers.export(exports, "LucidePlaneLanding", ()=>(0, _planeLandingJsDefault.default));
parcelHelpers.export(exports, "PlaneLanding", ()=>(0, _planeLandingJsDefault.default));
parcelHelpers.export(exports, "PlaneLandingIcon", ()=>(0, _planeLandingJsDefault.default));
parcelHelpers.export(exports, "LucidePlaneTakeoff", ()=>(0, _planeTakeoffJsDefault.default));
parcelHelpers.export(exports, "PlaneTakeoff", ()=>(0, _planeTakeoffJsDefault.default));
parcelHelpers.export(exports, "PlaneTakeoffIcon", ()=>(0, _planeTakeoffJsDefault.default));
parcelHelpers.export(exports, "LucidePlane", ()=>(0, _planeJsDefault.default));
parcelHelpers.export(exports, "Plane", ()=>(0, _planeJsDefault.default));
parcelHelpers.export(exports, "PlaneIcon", ()=>(0, _planeJsDefault.default));
parcelHelpers.export(exports, "LucidePlayCircle", ()=>(0, _playCircleJsDefault.default));
parcelHelpers.export(exports, "PlayCircle", ()=>(0, _playCircleJsDefault.default));
parcelHelpers.export(exports, "PlayCircleIcon", ()=>(0, _playCircleJsDefault.default));
parcelHelpers.export(exports, "LucidePlaySquare", ()=>(0, _playSquareJsDefault.default));
parcelHelpers.export(exports, "PlaySquare", ()=>(0, _playSquareJsDefault.default));
parcelHelpers.export(exports, "PlaySquareIcon", ()=>(0, _playSquareJsDefault.default));
parcelHelpers.export(exports, "LucidePlay", ()=>(0, _playJsDefault.default));
parcelHelpers.export(exports, "Play", ()=>(0, _playJsDefault.default));
parcelHelpers.export(exports, "PlayIcon", ()=>(0, _playJsDefault.default));
parcelHelpers.export(exports, "LucidePlug2", ()=>(0, _plug2JsDefault.default));
parcelHelpers.export(exports, "Plug2", ()=>(0, _plug2JsDefault.default));
parcelHelpers.export(exports, "Plug2Icon", ()=>(0, _plug2JsDefault.default));
parcelHelpers.export(exports, "LucidePlugZap2", ()=>(0, _plugZap2JsDefault.default));
parcelHelpers.export(exports, "PlugZap2", ()=>(0, _plugZap2JsDefault.default));
parcelHelpers.export(exports, "PlugZap2Icon", ()=>(0, _plugZap2JsDefault.default));
parcelHelpers.export(exports, "LucidePlugZap", ()=>(0, _plugZapJsDefault.default));
parcelHelpers.export(exports, "PlugZap", ()=>(0, _plugZapJsDefault.default));
parcelHelpers.export(exports, "PlugZapIcon", ()=>(0, _plugZapJsDefault.default));
parcelHelpers.export(exports, "LucidePlug", ()=>(0, _plugJsDefault.default));
parcelHelpers.export(exports, "Plug", ()=>(0, _plugJsDefault.default));
parcelHelpers.export(exports, "PlugIcon", ()=>(0, _plugJsDefault.default));
parcelHelpers.export(exports, "LucidePlusCircle", ()=>(0, _plusCircleJsDefault.default));
parcelHelpers.export(exports, "PlusCircle", ()=>(0, _plusCircleJsDefault.default));
parcelHelpers.export(exports, "PlusCircleIcon", ()=>(0, _plusCircleJsDefault.default));
parcelHelpers.export(exports, "LucidePlusSquare", ()=>(0, _plusSquareJsDefault.default));
parcelHelpers.export(exports, "PlusSquare", ()=>(0, _plusSquareJsDefault.default));
parcelHelpers.export(exports, "PlusSquareIcon", ()=>(0, _plusSquareJsDefault.default));
parcelHelpers.export(exports, "LucidePlus", ()=>(0, _plusJsDefault.default));
parcelHelpers.export(exports, "Plus", ()=>(0, _plusJsDefault.default));
parcelHelpers.export(exports, "PlusIcon", ()=>(0, _plusJsDefault.default));
parcelHelpers.export(exports, "LucidePocketKnife", ()=>(0, _pocketKnifeJsDefault.default));
parcelHelpers.export(exports, "PocketKnife", ()=>(0, _pocketKnifeJsDefault.default));
parcelHelpers.export(exports, "PocketKnifeIcon", ()=>(0, _pocketKnifeJsDefault.default));
parcelHelpers.export(exports, "LucidePocket", ()=>(0, _pocketJsDefault.default));
parcelHelpers.export(exports, "Pocket", ()=>(0, _pocketJsDefault.default));
parcelHelpers.export(exports, "PocketIcon", ()=>(0, _pocketJsDefault.default));
parcelHelpers.export(exports, "LucidePodcast", ()=>(0, _podcastJsDefault.default));
parcelHelpers.export(exports, "Podcast", ()=>(0, _podcastJsDefault.default));
parcelHelpers.export(exports, "PodcastIcon", ()=>(0, _podcastJsDefault.default));
parcelHelpers.export(exports, "LucidePointerOff", ()=>(0, _pointerOffJsDefault.default));
parcelHelpers.export(exports, "PointerOff", ()=>(0, _pointerOffJsDefault.default));
parcelHelpers.export(exports, "PointerOffIcon", ()=>(0, _pointerOffJsDefault.default));
parcelHelpers.export(exports, "LucidePointer", ()=>(0, _pointerJsDefault.default));
parcelHelpers.export(exports, "Pointer", ()=>(0, _pointerJsDefault.default));
parcelHelpers.export(exports, "PointerIcon", ()=>(0, _pointerJsDefault.default));
parcelHelpers.export(exports, "LucidePopcorn", ()=>(0, _popcornJsDefault.default));
parcelHelpers.export(exports, "Popcorn", ()=>(0, _popcornJsDefault.default));
parcelHelpers.export(exports, "PopcornIcon", ()=>(0, _popcornJsDefault.default));
parcelHelpers.export(exports, "LucidePopsicle", ()=>(0, _popsicleJsDefault.default));
parcelHelpers.export(exports, "Popsicle", ()=>(0, _popsicleJsDefault.default));
parcelHelpers.export(exports, "PopsicleIcon", ()=>(0, _popsicleJsDefault.default));
parcelHelpers.export(exports, "LucidePoundSterling", ()=>(0, _poundSterlingJsDefault.default));
parcelHelpers.export(exports, "PoundSterling", ()=>(0, _poundSterlingJsDefault.default));
parcelHelpers.export(exports, "PoundSterlingIcon", ()=>(0, _poundSterlingJsDefault.default));
parcelHelpers.export(exports, "LucidePowerCircle", ()=>(0, _powerCircleJsDefault.default));
parcelHelpers.export(exports, "PowerCircle", ()=>(0, _powerCircleJsDefault.default));
parcelHelpers.export(exports, "PowerCircleIcon", ()=>(0, _powerCircleJsDefault.default));
parcelHelpers.export(exports, "LucidePowerOff", ()=>(0, _powerOffJsDefault.default));
parcelHelpers.export(exports, "PowerOff", ()=>(0, _powerOffJsDefault.default));
parcelHelpers.export(exports, "PowerOffIcon", ()=>(0, _powerOffJsDefault.default));
parcelHelpers.export(exports, "LucidePowerSquare", ()=>(0, _powerSquareJsDefault.default));
parcelHelpers.export(exports, "PowerSquare", ()=>(0, _powerSquareJsDefault.default));
parcelHelpers.export(exports, "PowerSquareIcon", ()=>(0, _powerSquareJsDefault.default));
parcelHelpers.export(exports, "LucidePower", ()=>(0, _powerJsDefault.default));
parcelHelpers.export(exports, "Power", ()=>(0, _powerJsDefault.default));
parcelHelpers.export(exports, "PowerIcon", ()=>(0, _powerJsDefault.default));
parcelHelpers.export(exports, "LucidePresentation", ()=>(0, _presentationJsDefault.default));
parcelHelpers.export(exports, "Presentation", ()=>(0, _presentationJsDefault.default));
parcelHelpers.export(exports, "PresentationIcon", ()=>(0, _presentationJsDefault.default));
parcelHelpers.export(exports, "LucidePrinter", ()=>(0, _printerJsDefault.default));
parcelHelpers.export(exports, "Printer", ()=>(0, _printerJsDefault.default));
parcelHelpers.export(exports, "PrinterIcon", ()=>(0, _printerJsDefault.default));
parcelHelpers.export(exports, "LucideProjector", ()=>(0, _projectorJsDefault.default));
parcelHelpers.export(exports, "Projector", ()=>(0, _projectorJsDefault.default));
parcelHelpers.export(exports, "ProjectorIcon", ()=>(0, _projectorJsDefault.default));
parcelHelpers.export(exports, "LucidePuzzle", ()=>(0, _puzzleJsDefault.default));
parcelHelpers.export(exports, "Puzzle", ()=>(0, _puzzleJsDefault.default));
parcelHelpers.export(exports, "PuzzleIcon", ()=>(0, _puzzleJsDefault.default));
parcelHelpers.export(exports, "LucidePyramid", ()=>(0, _pyramidJsDefault.default));
parcelHelpers.export(exports, "Pyramid", ()=>(0, _pyramidJsDefault.default));
parcelHelpers.export(exports, "PyramidIcon", ()=>(0, _pyramidJsDefault.default));
parcelHelpers.export(exports, "LucideQrCode", ()=>(0, _qrCodeJsDefault.default));
parcelHelpers.export(exports, "QrCode", ()=>(0, _qrCodeJsDefault.default));
parcelHelpers.export(exports, "QrCodeIcon", ()=>(0, _qrCodeJsDefault.default));
parcelHelpers.export(exports, "LucideQuote", ()=>(0, _quoteJsDefault.default));
parcelHelpers.export(exports, "Quote", ()=>(0, _quoteJsDefault.default));
parcelHelpers.export(exports, "QuoteIcon", ()=>(0, _quoteJsDefault.default));
parcelHelpers.export(exports, "LucideRabbit", ()=>(0, _rabbitJsDefault.default));
parcelHelpers.export(exports, "Rabbit", ()=>(0, _rabbitJsDefault.default));
parcelHelpers.export(exports, "RabbitIcon", ()=>(0, _rabbitJsDefault.default));
parcelHelpers.export(exports, "LucideRadar", ()=>(0, _radarJsDefault.default));
parcelHelpers.export(exports, "Radar", ()=>(0, _radarJsDefault.default));
parcelHelpers.export(exports, "RadarIcon", ()=>(0, _radarJsDefault.default));
parcelHelpers.export(exports, "LucideRadiation", ()=>(0, _radiationJsDefault.default));
parcelHelpers.export(exports, "Radiation", ()=>(0, _radiationJsDefault.default));
parcelHelpers.export(exports, "RadiationIcon", ()=>(0, _radiationJsDefault.default));
parcelHelpers.export(exports, "LucideRadical", ()=>(0, _radicalJsDefault.default));
parcelHelpers.export(exports, "Radical", ()=>(0, _radicalJsDefault.default));
parcelHelpers.export(exports, "RadicalIcon", ()=>(0, _radicalJsDefault.default));
parcelHelpers.export(exports, "LucideRadioReceiver", ()=>(0, _radioReceiverJsDefault.default));
parcelHelpers.export(exports, "RadioReceiver", ()=>(0, _radioReceiverJsDefault.default));
parcelHelpers.export(exports, "RadioReceiverIcon", ()=>(0, _radioReceiverJsDefault.default));
parcelHelpers.export(exports, "LucideRadioTower", ()=>(0, _radioTowerJsDefault.default));
parcelHelpers.export(exports, "RadioTower", ()=>(0, _radioTowerJsDefault.default));
parcelHelpers.export(exports, "RadioTowerIcon", ()=>(0, _radioTowerJsDefault.default));
parcelHelpers.export(exports, "LucideRadio", ()=>(0, _radioJsDefault.default));
parcelHelpers.export(exports, "Radio", ()=>(0, _radioJsDefault.default));
parcelHelpers.export(exports, "RadioIcon", ()=>(0, _radioJsDefault.default));
parcelHelpers.export(exports, "LucideRadius", ()=>(0, _radiusJsDefault.default));
parcelHelpers.export(exports, "Radius", ()=>(0, _radiusJsDefault.default));
parcelHelpers.export(exports, "RadiusIcon", ()=>(0, _radiusJsDefault.default));
parcelHelpers.export(exports, "LucideRailSymbol", ()=>(0, _railSymbolJsDefault.default));
parcelHelpers.export(exports, "RailSymbol", ()=>(0, _railSymbolJsDefault.default));
parcelHelpers.export(exports, "RailSymbolIcon", ()=>(0, _railSymbolJsDefault.default));
parcelHelpers.export(exports, "LucideRainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "Rainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "RainbowIcon", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "LucideRat", ()=>(0, _ratJsDefault.default));
parcelHelpers.export(exports, "Rat", ()=>(0, _ratJsDefault.default));
parcelHelpers.export(exports, "RatIcon", ()=>(0, _ratJsDefault.default));
parcelHelpers.export(exports, "LucideRatio", ()=>(0, _ratioJsDefault.default));
parcelHelpers.export(exports, "Ratio", ()=>(0, _ratioJsDefault.default));
parcelHelpers.export(exports, "RatioIcon", ()=>(0, _ratioJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptCent", ()=>(0, _receiptCentJsDefault.default));
parcelHelpers.export(exports, "ReceiptCent", ()=>(0, _receiptCentJsDefault.default));
parcelHelpers.export(exports, "ReceiptCentIcon", ()=>(0, _receiptCentJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptEuro", ()=>(0, _receiptEuroJsDefault.default));
parcelHelpers.export(exports, "ReceiptEuro", ()=>(0, _receiptEuroJsDefault.default));
parcelHelpers.export(exports, "ReceiptEuroIcon", ()=>(0, _receiptEuroJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptIndianRupee", ()=>(0, _receiptIndianRupeeJsDefault.default));
parcelHelpers.export(exports, "ReceiptIndianRupee", ()=>(0, _receiptIndianRupeeJsDefault.default));
parcelHelpers.export(exports, "ReceiptIndianRupeeIcon", ()=>(0, _receiptIndianRupeeJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptJapaneseYen", ()=>(0, _receiptJapaneseYenJsDefault.default));
parcelHelpers.export(exports, "ReceiptJapaneseYen", ()=>(0, _receiptJapaneseYenJsDefault.default));
parcelHelpers.export(exports, "ReceiptJapaneseYenIcon", ()=>(0, _receiptJapaneseYenJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptPoundSterling", ()=>(0, _receiptPoundSterlingJsDefault.default));
parcelHelpers.export(exports, "ReceiptPoundSterling", ()=>(0, _receiptPoundSterlingJsDefault.default));
parcelHelpers.export(exports, "ReceiptPoundSterlingIcon", ()=>(0, _receiptPoundSterlingJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptRussianRuble", ()=>(0, _receiptRussianRubleJsDefault.default));
parcelHelpers.export(exports, "ReceiptRussianRuble", ()=>(0, _receiptRussianRubleJsDefault.default));
parcelHelpers.export(exports, "ReceiptRussianRubleIcon", ()=>(0, _receiptRussianRubleJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptSwissFranc", ()=>(0, _receiptSwissFrancJsDefault.default));
parcelHelpers.export(exports, "ReceiptSwissFranc", ()=>(0, _receiptSwissFrancJsDefault.default));
parcelHelpers.export(exports, "ReceiptSwissFrancIcon", ()=>(0, _receiptSwissFrancJsDefault.default));
parcelHelpers.export(exports, "LucideReceiptText", ()=>(0, _receiptTextJsDefault.default));
parcelHelpers.export(exports, "ReceiptText", ()=>(0, _receiptTextJsDefault.default));
parcelHelpers.export(exports, "ReceiptTextIcon", ()=>(0, _receiptTextJsDefault.default));
parcelHelpers.export(exports, "LucideReceipt", ()=>(0, _receiptJsDefault.default));
parcelHelpers.export(exports, "Receipt", ()=>(0, _receiptJsDefault.default));
parcelHelpers.export(exports, "ReceiptIcon", ()=>(0, _receiptJsDefault.default));
parcelHelpers.export(exports, "LucideRectangleHorizontal", ()=>(0, _rectangleHorizontalJsDefault.default));
parcelHelpers.export(exports, "RectangleHorizontal", ()=>(0, _rectangleHorizontalJsDefault.default));
parcelHelpers.export(exports, "RectangleHorizontalIcon", ()=>(0, _rectangleHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideRectangleVertical", ()=>(0, _rectangleVerticalJsDefault.default));
parcelHelpers.export(exports, "RectangleVertical", ()=>(0, _rectangleVerticalJsDefault.default));
parcelHelpers.export(exports, "RectangleVerticalIcon", ()=>(0, _rectangleVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideRecycle", ()=>(0, _recycleJsDefault.default));
parcelHelpers.export(exports, "Recycle", ()=>(0, _recycleJsDefault.default));
parcelHelpers.export(exports, "RecycleIcon", ()=>(0, _recycleJsDefault.default));
parcelHelpers.export(exports, "LucideRedo2", ()=>(0, _redo2JsDefault.default));
parcelHelpers.export(exports, "Redo2", ()=>(0, _redo2JsDefault.default));
parcelHelpers.export(exports, "Redo2Icon", ()=>(0, _redo2JsDefault.default));
parcelHelpers.export(exports, "LucideRedoDot", ()=>(0, _redoDotJsDefault.default));
parcelHelpers.export(exports, "RedoDot", ()=>(0, _redoDotJsDefault.default));
parcelHelpers.export(exports, "RedoDotIcon", ()=>(0, _redoDotJsDefault.default));
parcelHelpers.export(exports, "LucideRedo", ()=>(0, _redoJsDefault.default));
parcelHelpers.export(exports, "Redo", ()=>(0, _redoJsDefault.default));
parcelHelpers.export(exports, "RedoIcon", ()=>(0, _redoJsDefault.default));
parcelHelpers.export(exports, "LucideRefreshCcwDot", ()=>(0, _refreshCcwDotJsDefault.default));
parcelHelpers.export(exports, "RefreshCcwDot", ()=>(0, _refreshCcwDotJsDefault.default));
parcelHelpers.export(exports, "RefreshCcwDotIcon", ()=>(0, _refreshCcwDotJsDefault.default));
parcelHelpers.export(exports, "LucideRefreshCcw", ()=>(0, _refreshCcwJsDefault.default));
parcelHelpers.export(exports, "RefreshCcw", ()=>(0, _refreshCcwJsDefault.default));
parcelHelpers.export(exports, "RefreshCcwIcon", ()=>(0, _refreshCcwJsDefault.default));
parcelHelpers.export(exports, "LucideRefreshCwOff", ()=>(0, _refreshCwOffJsDefault.default));
parcelHelpers.export(exports, "RefreshCwOff", ()=>(0, _refreshCwOffJsDefault.default));
parcelHelpers.export(exports, "RefreshCwOffIcon", ()=>(0, _refreshCwOffJsDefault.default));
parcelHelpers.export(exports, "LucideRefreshCw", ()=>(0, _refreshCwJsDefault.default));
parcelHelpers.export(exports, "RefreshCw", ()=>(0, _refreshCwJsDefault.default));
parcelHelpers.export(exports, "RefreshCwIcon", ()=>(0, _refreshCwJsDefault.default));
parcelHelpers.export(exports, "LucideRefrigerator", ()=>(0, _refrigeratorJsDefault.default));
parcelHelpers.export(exports, "Refrigerator", ()=>(0, _refrigeratorJsDefault.default));
parcelHelpers.export(exports, "RefrigeratorIcon", ()=>(0, _refrigeratorJsDefault.default));
parcelHelpers.export(exports, "LucideRegex", ()=>(0, _regexJsDefault.default));
parcelHelpers.export(exports, "Regex", ()=>(0, _regexJsDefault.default));
parcelHelpers.export(exports, "RegexIcon", ()=>(0, _regexJsDefault.default));
parcelHelpers.export(exports, "LucideRemoveFormatting", ()=>(0, _removeFormattingJsDefault.default));
parcelHelpers.export(exports, "RemoveFormatting", ()=>(0, _removeFormattingJsDefault.default));
parcelHelpers.export(exports, "RemoveFormattingIcon", ()=>(0, _removeFormattingJsDefault.default));
parcelHelpers.export(exports, "LucideRepeat1", ()=>(0, _repeat1JsDefault.default));
parcelHelpers.export(exports, "Repeat1", ()=>(0, _repeat1JsDefault.default));
parcelHelpers.export(exports, "Repeat1Icon", ()=>(0, _repeat1JsDefault.default));
parcelHelpers.export(exports, "LucideRepeat2", ()=>(0, _repeat2JsDefault.default));
parcelHelpers.export(exports, "Repeat2", ()=>(0, _repeat2JsDefault.default));
parcelHelpers.export(exports, "Repeat2Icon", ()=>(0, _repeat2JsDefault.default));
parcelHelpers.export(exports, "LucideRepeat", ()=>(0, _repeatJsDefault.default));
parcelHelpers.export(exports, "Repeat", ()=>(0, _repeatJsDefault.default));
parcelHelpers.export(exports, "RepeatIcon", ()=>(0, _repeatJsDefault.default));
parcelHelpers.export(exports, "LucideReplaceAll", ()=>(0, _replaceAllJsDefault.default));
parcelHelpers.export(exports, "ReplaceAll", ()=>(0, _replaceAllJsDefault.default));
parcelHelpers.export(exports, "ReplaceAllIcon", ()=>(0, _replaceAllJsDefault.default));
parcelHelpers.export(exports, "LucideReplace", ()=>(0, _replaceJsDefault.default));
parcelHelpers.export(exports, "Replace", ()=>(0, _replaceJsDefault.default));
parcelHelpers.export(exports, "ReplaceIcon", ()=>(0, _replaceJsDefault.default));
parcelHelpers.export(exports, "LucideReplyAll", ()=>(0, _replyAllJsDefault.default));
parcelHelpers.export(exports, "ReplyAll", ()=>(0, _replyAllJsDefault.default));
parcelHelpers.export(exports, "ReplyAllIcon", ()=>(0, _replyAllJsDefault.default));
parcelHelpers.export(exports, "LucideReply", ()=>(0, _replyJsDefault.default));
parcelHelpers.export(exports, "Reply", ()=>(0, _replyJsDefault.default));
parcelHelpers.export(exports, "ReplyIcon", ()=>(0, _replyJsDefault.default));
parcelHelpers.export(exports, "LucideRewind", ()=>(0, _rewindJsDefault.default));
parcelHelpers.export(exports, "Rewind", ()=>(0, _rewindJsDefault.default));
parcelHelpers.export(exports, "RewindIcon", ()=>(0, _rewindJsDefault.default));
parcelHelpers.export(exports, "LucideRibbon", ()=>(0, _ribbonJsDefault.default));
parcelHelpers.export(exports, "Ribbon", ()=>(0, _ribbonJsDefault.default));
parcelHelpers.export(exports, "RibbonIcon", ()=>(0, _ribbonJsDefault.default));
parcelHelpers.export(exports, "LucideRocket", ()=>(0, _rocketJsDefault.default));
parcelHelpers.export(exports, "Rocket", ()=>(0, _rocketJsDefault.default));
parcelHelpers.export(exports, "RocketIcon", ()=>(0, _rocketJsDefault.default));
parcelHelpers.export(exports, "LucideRockingChair", ()=>(0, _rockingChairJsDefault.default));
parcelHelpers.export(exports, "RockingChair", ()=>(0, _rockingChairJsDefault.default));
parcelHelpers.export(exports, "RockingChairIcon", ()=>(0, _rockingChairJsDefault.default));
parcelHelpers.export(exports, "LucideRollerCoaster", ()=>(0, _rollerCoasterJsDefault.default));
parcelHelpers.export(exports, "RollerCoaster", ()=>(0, _rollerCoasterJsDefault.default));
parcelHelpers.export(exports, "RollerCoasterIcon", ()=>(0, _rollerCoasterJsDefault.default));
parcelHelpers.export(exports, "LucideRotateCcw", ()=>(0, _rotateCcwJsDefault.default));
parcelHelpers.export(exports, "RotateCcw", ()=>(0, _rotateCcwJsDefault.default));
parcelHelpers.export(exports, "RotateCcwIcon", ()=>(0, _rotateCcwJsDefault.default));
parcelHelpers.export(exports, "LucideRotateCw", ()=>(0, _rotateCwJsDefault.default));
parcelHelpers.export(exports, "RotateCw", ()=>(0, _rotateCwJsDefault.default));
parcelHelpers.export(exports, "RotateCwIcon", ()=>(0, _rotateCwJsDefault.default));
parcelHelpers.export(exports, "LucideRouteOff", ()=>(0, _routeOffJsDefault.default));
parcelHelpers.export(exports, "RouteOff", ()=>(0, _routeOffJsDefault.default));
parcelHelpers.export(exports, "RouteOffIcon", ()=>(0, _routeOffJsDefault.default));
parcelHelpers.export(exports, "LucideRoute", ()=>(0, _routeJsDefault.default));
parcelHelpers.export(exports, "Route", ()=>(0, _routeJsDefault.default));
parcelHelpers.export(exports, "RouteIcon", ()=>(0, _routeJsDefault.default));
parcelHelpers.export(exports, "LucideRouter", ()=>(0, _routerJsDefault.default));
parcelHelpers.export(exports, "Router", ()=>(0, _routerJsDefault.default));
parcelHelpers.export(exports, "RouterIcon", ()=>(0, _routerJsDefault.default));
parcelHelpers.export(exports, "LucideRows4", ()=>(0, _rows4JsDefault.default));
parcelHelpers.export(exports, "Rows4", ()=>(0, _rows4JsDefault.default));
parcelHelpers.export(exports, "Rows4Icon", ()=>(0, _rows4JsDefault.default));
parcelHelpers.export(exports, "LucideRss", ()=>(0, _rssJsDefault.default));
parcelHelpers.export(exports, "Rss", ()=>(0, _rssJsDefault.default));
parcelHelpers.export(exports, "RssIcon", ()=>(0, _rssJsDefault.default));
parcelHelpers.export(exports, "LucideRuler", ()=>(0, _rulerJsDefault.default));
parcelHelpers.export(exports, "Ruler", ()=>(0, _rulerJsDefault.default));
parcelHelpers.export(exports, "RulerIcon", ()=>(0, _rulerJsDefault.default));
parcelHelpers.export(exports, "LucideRussianRuble", ()=>(0, _russianRubleJsDefault.default));
parcelHelpers.export(exports, "RussianRuble", ()=>(0, _russianRubleJsDefault.default));
parcelHelpers.export(exports, "RussianRubleIcon", ()=>(0, _russianRubleJsDefault.default));
parcelHelpers.export(exports, "LucideSailboat", ()=>(0, _sailboatJsDefault.default));
parcelHelpers.export(exports, "Sailboat", ()=>(0, _sailboatJsDefault.default));
parcelHelpers.export(exports, "SailboatIcon", ()=>(0, _sailboatJsDefault.default));
parcelHelpers.export(exports, "LucideSalad", ()=>(0, _saladJsDefault.default));
parcelHelpers.export(exports, "Salad", ()=>(0, _saladJsDefault.default));
parcelHelpers.export(exports, "SaladIcon", ()=>(0, _saladJsDefault.default));
parcelHelpers.export(exports, "LucideSandwich", ()=>(0, _sandwichJsDefault.default));
parcelHelpers.export(exports, "Sandwich", ()=>(0, _sandwichJsDefault.default));
parcelHelpers.export(exports, "SandwichIcon", ()=>(0, _sandwichJsDefault.default));
parcelHelpers.export(exports, "LucideSatelliteDish", ()=>(0, _satelliteDishJsDefault.default));
parcelHelpers.export(exports, "SatelliteDish", ()=>(0, _satelliteDishJsDefault.default));
parcelHelpers.export(exports, "SatelliteDishIcon", ()=>(0, _satelliteDishJsDefault.default));
parcelHelpers.export(exports, "LucideSatellite", ()=>(0, _satelliteJsDefault.default));
parcelHelpers.export(exports, "Satellite", ()=>(0, _satelliteJsDefault.default));
parcelHelpers.export(exports, "SatelliteIcon", ()=>(0, _satelliteJsDefault.default));
parcelHelpers.export(exports, "LucideSaveAll", ()=>(0, _saveAllJsDefault.default));
parcelHelpers.export(exports, "SaveAll", ()=>(0, _saveAllJsDefault.default));
parcelHelpers.export(exports, "SaveAllIcon", ()=>(0, _saveAllJsDefault.default));
parcelHelpers.export(exports, "LucideSave", ()=>(0, _saveJsDefault.default));
parcelHelpers.export(exports, "Save", ()=>(0, _saveJsDefault.default));
parcelHelpers.export(exports, "SaveIcon", ()=>(0, _saveJsDefault.default));
parcelHelpers.export(exports, "LucideScale", ()=>(0, _scaleJsDefault.default));
parcelHelpers.export(exports, "Scale", ()=>(0, _scaleJsDefault.default));
parcelHelpers.export(exports, "ScaleIcon", ()=>(0, _scaleJsDefault.default));
parcelHelpers.export(exports, "LucideScaling", ()=>(0, _scalingJsDefault.default));
parcelHelpers.export(exports, "Scaling", ()=>(0, _scalingJsDefault.default));
parcelHelpers.export(exports, "ScalingIcon", ()=>(0, _scalingJsDefault.default));
parcelHelpers.export(exports, "LucideScanBarcode", ()=>(0, _scanBarcodeJsDefault.default));
parcelHelpers.export(exports, "ScanBarcode", ()=>(0, _scanBarcodeJsDefault.default));
parcelHelpers.export(exports, "ScanBarcodeIcon", ()=>(0, _scanBarcodeJsDefault.default));
parcelHelpers.export(exports, "LucideScanEye", ()=>(0, _scanEyeJsDefault.default));
parcelHelpers.export(exports, "ScanEye", ()=>(0, _scanEyeJsDefault.default));
parcelHelpers.export(exports, "ScanEyeIcon", ()=>(0, _scanEyeJsDefault.default));
parcelHelpers.export(exports, "LucideScanFace", ()=>(0, _scanFaceJsDefault.default));
parcelHelpers.export(exports, "ScanFace", ()=>(0, _scanFaceJsDefault.default));
parcelHelpers.export(exports, "ScanFaceIcon", ()=>(0, _scanFaceJsDefault.default));
parcelHelpers.export(exports, "LucideScanLine", ()=>(0, _scanLineJsDefault.default));
parcelHelpers.export(exports, "ScanLine", ()=>(0, _scanLineJsDefault.default));
parcelHelpers.export(exports, "ScanLineIcon", ()=>(0, _scanLineJsDefault.default));
parcelHelpers.export(exports, "LucideScanSearch", ()=>(0, _scanSearchJsDefault.default));
parcelHelpers.export(exports, "ScanSearch", ()=>(0, _scanSearchJsDefault.default));
parcelHelpers.export(exports, "ScanSearchIcon", ()=>(0, _scanSearchJsDefault.default));
parcelHelpers.export(exports, "LucideScanText", ()=>(0, _scanTextJsDefault.default));
parcelHelpers.export(exports, "ScanText", ()=>(0, _scanTextJsDefault.default));
parcelHelpers.export(exports, "ScanTextIcon", ()=>(0, _scanTextJsDefault.default));
parcelHelpers.export(exports, "LucideScan", ()=>(0, _scanJsDefault.default));
parcelHelpers.export(exports, "Scan", ()=>(0, _scanJsDefault.default));
parcelHelpers.export(exports, "ScanIcon", ()=>(0, _scanJsDefault.default));
parcelHelpers.export(exports, "LucideScatterChart", ()=>(0, _scatterChartJsDefault.default));
parcelHelpers.export(exports, "ScatterChart", ()=>(0, _scatterChartJsDefault.default));
parcelHelpers.export(exports, "ScatterChartIcon", ()=>(0, _scatterChartJsDefault.default));
parcelHelpers.export(exports, "LucideSchool2", ()=>(0, _school2JsDefault.default));
parcelHelpers.export(exports, "School2", ()=>(0, _school2JsDefault.default));
parcelHelpers.export(exports, "School2Icon", ()=>(0, _school2JsDefault.default));
parcelHelpers.export(exports, "LucideSchool", ()=>(0, _schoolJsDefault.default));
parcelHelpers.export(exports, "School", ()=>(0, _schoolJsDefault.default));
parcelHelpers.export(exports, "SchoolIcon", ()=>(0, _schoolJsDefault.default));
parcelHelpers.export(exports, "LucideScissorsLineDashed", ()=>(0, _scissorsLineDashedJsDefault.default));
parcelHelpers.export(exports, "ScissorsLineDashed", ()=>(0, _scissorsLineDashedJsDefault.default));
parcelHelpers.export(exports, "ScissorsLineDashedIcon", ()=>(0, _scissorsLineDashedJsDefault.default));
parcelHelpers.export(exports, "LucideScissorsSquareDashedBottom", ()=>(0, _scissorsSquareDashedBottomJsDefault.default));
parcelHelpers.export(exports, "ScissorsSquareDashedBottom", ()=>(0, _scissorsSquareDashedBottomJsDefault.default));
parcelHelpers.export(exports, "ScissorsSquareDashedBottomIcon", ()=>(0, _scissorsSquareDashedBottomJsDefault.default));
parcelHelpers.export(exports, "LucideScissorsSquare", ()=>(0, _scissorsSquareJsDefault.default));
parcelHelpers.export(exports, "ScissorsSquare", ()=>(0, _scissorsSquareJsDefault.default));
parcelHelpers.export(exports, "ScissorsSquareIcon", ()=>(0, _scissorsSquareJsDefault.default));
parcelHelpers.export(exports, "LucideScissors", ()=>(0, _scissorsJsDefault.default));
parcelHelpers.export(exports, "Scissors", ()=>(0, _scissorsJsDefault.default));
parcelHelpers.export(exports, "ScissorsIcon", ()=>(0, _scissorsJsDefault.default));
parcelHelpers.export(exports, "LucideScreenShareOff", ()=>(0, _screenShareOffJsDefault.default));
parcelHelpers.export(exports, "ScreenShareOff", ()=>(0, _screenShareOffJsDefault.default));
parcelHelpers.export(exports, "ScreenShareOffIcon", ()=>(0, _screenShareOffJsDefault.default));
parcelHelpers.export(exports, "LucideScreenShare", ()=>(0, _screenShareJsDefault.default));
parcelHelpers.export(exports, "ScreenShare", ()=>(0, _screenShareJsDefault.default));
parcelHelpers.export(exports, "ScreenShareIcon", ()=>(0, _screenShareJsDefault.default));
parcelHelpers.export(exports, "LucideScrollText", ()=>(0, _scrollTextJsDefault.default));
parcelHelpers.export(exports, "ScrollText", ()=>(0, _scrollTextJsDefault.default));
parcelHelpers.export(exports, "ScrollTextIcon", ()=>(0, _scrollTextJsDefault.default));
parcelHelpers.export(exports, "LucideScroll", ()=>(0, _scrollJsDefault.default));
parcelHelpers.export(exports, "Scroll", ()=>(0, _scrollJsDefault.default));
parcelHelpers.export(exports, "ScrollIcon", ()=>(0, _scrollJsDefault.default));
parcelHelpers.export(exports, "LucideSearchCheck", ()=>(0, _searchCheckJsDefault.default));
parcelHelpers.export(exports, "SearchCheck", ()=>(0, _searchCheckJsDefault.default));
parcelHelpers.export(exports, "SearchCheckIcon", ()=>(0, _searchCheckJsDefault.default));
parcelHelpers.export(exports, "LucideSearchCode", ()=>(0, _searchCodeJsDefault.default));
parcelHelpers.export(exports, "SearchCode", ()=>(0, _searchCodeJsDefault.default));
parcelHelpers.export(exports, "SearchCodeIcon", ()=>(0, _searchCodeJsDefault.default));
parcelHelpers.export(exports, "LucideSearchSlash", ()=>(0, _searchSlashJsDefault.default));
parcelHelpers.export(exports, "SearchSlash", ()=>(0, _searchSlashJsDefault.default));
parcelHelpers.export(exports, "SearchSlashIcon", ()=>(0, _searchSlashJsDefault.default));
parcelHelpers.export(exports, "LucideSearchX", ()=>(0, _searchXJsDefault.default));
parcelHelpers.export(exports, "SearchX", ()=>(0, _searchXJsDefault.default));
parcelHelpers.export(exports, "SearchXIcon", ()=>(0, _searchXJsDefault.default));
parcelHelpers.export(exports, "LucideSearch", ()=>(0, _searchJsDefault.default));
parcelHelpers.export(exports, "Search", ()=>(0, _searchJsDefault.default));
parcelHelpers.export(exports, "SearchIcon", ()=>(0, _searchJsDefault.default));
parcelHelpers.export(exports, "LucideSendToBack", ()=>(0, _sendToBackJsDefault.default));
parcelHelpers.export(exports, "SendToBack", ()=>(0, _sendToBackJsDefault.default));
parcelHelpers.export(exports, "SendToBackIcon", ()=>(0, _sendToBackJsDefault.default));
parcelHelpers.export(exports, "LucideSend", ()=>(0, _sendJsDefault.default));
parcelHelpers.export(exports, "Send", ()=>(0, _sendJsDefault.default));
parcelHelpers.export(exports, "SendIcon", ()=>(0, _sendJsDefault.default));
parcelHelpers.export(exports, "LucideSeparatorHorizontal", ()=>(0, _separatorHorizontalJsDefault.default));
parcelHelpers.export(exports, "SeparatorHorizontal", ()=>(0, _separatorHorizontalJsDefault.default));
parcelHelpers.export(exports, "SeparatorHorizontalIcon", ()=>(0, _separatorHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideSeparatorVertical", ()=>(0, _separatorVerticalJsDefault.default));
parcelHelpers.export(exports, "SeparatorVertical", ()=>(0, _separatorVerticalJsDefault.default));
parcelHelpers.export(exports, "SeparatorVerticalIcon", ()=>(0, _separatorVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideServerCog", ()=>(0, _serverCogJsDefault.default));
parcelHelpers.export(exports, "ServerCog", ()=>(0, _serverCogJsDefault.default));
parcelHelpers.export(exports, "ServerCogIcon", ()=>(0, _serverCogJsDefault.default));
parcelHelpers.export(exports, "LucideServerCrash", ()=>(0, _serverCrashJsDefault.default));
parcelHelpers.export(exports, "ServerCrash", ()=>(0, _serverCrashJsDefault.default));
parcelHelpers.export(exports, "ServerCrashIcon", ()=>(0, _serverCrashJsDefault.default));
parcelHelpers.export(exports, "LucideServerOff", ()=>(0, _serverOffJsDefault.default));
parcelHelpers.export(exports, "ServerOff", ()=>(0, _serverOffJsDefault.default));
parcelHelpers.export(exports, "ServerOffIcon", ()=>(0, _serverOffJsDefault.default));
parcelHelpers.export(exports, "LucideServer", ()=>(0, _serverJsDefault.default));
parcelHelpers.export(exports, "Server", ()=>(0, _serverJsDefault.default));
parcelHelpers.export(exports, "ServerIcon", ()=>(0, _serverJsDefault.default));
parcelHelpers.export(exports, "LucideSettings2", ()=>(0, _settings2JsDefault.default));
parcelHelpers.export(exports, "Settings2", ()=>(0, _settings2JsDefault.default));
parcelHelpers.export(exports, "Settings2Icon", ()=>(0, _settings2JsDefault.default));
parcelHelpers.export(exports, "LucideSettings", ()=>(0, _settingsJsDefault.default));
parcelHelpers.export(exports, "Settings", ()=>(0, _settingsJsDefault.default));
parcelHelpers.export(exports, "SettingsIcon", ()=>(0, _settingsJsDefault.default));
parcelHelpers.export(exports, "LucideShapes", ()=>(0, _shapesJsDefault.default));
parcelHelpers.export(exports, "Shapes", ()=>(0, _shapesJsDefault.default));
parcelHelpers.export(exports, "ShapesIcon", ()=>(0, _shapesJsDefault.default));
parcelHelpers.export(exports, "LucideShare2", ()=>(0, _share2JsDefault.default));
parcelHelpers.export(exports, "Share2", ()=>(0, _share2JsDefault.default));
parcelHelpers.export(exports, "Share2Icon", ()=>(0, _share2JsDefault.default));
parcelHelpers.export(exports, "LucideShare", ()=>(0, _shareJsDefault.default));
parcelHelpers.export(exports, "Share", ()=>(0, _shareJsDefault.default));
parcelHelpers.export(exports, "ShareIcon", ()=>(0, _shareJsDefault.default));
parcelHelpers.export(exports, "LucideSheet", ()=>(0, _sheetJsDefault.default));
parcelHelpers.export(exports, "Sheet", ()=>(0, _sheetJsDefault.default));
parcelHelpers.export(exports, "SheetIcon", ()=>(0, _sheetJsDefault.default));
parcelHelpers.export(exports, "LucideShell", ()=>(0, _shellJsDefault.default));
parcelHelpers.export(exports, "Shell", ()=>(0, _shellJsDefault.default));
parcelHelpers.export(exports, "ShellIcon", ()=>(0, _shellJsDefault.default));
parcelHelpers.export(exports, "LucideShieldAlert", ()=>(0, _shieldAlertJsDefault.default));
parcelHelpers.export(exports, "ShieldAlert", ()=>(0, _shieldAlertJsDefault.default));
parcelHelpers.export(exports, "ShieldAlertIcon", ()=>(0, _shieldAlertJsDefault.default));
parcelHelpers.export(exports, "LucideShieldBan", ()=>(0, _shieldBanJsDefault.default));
parcelHelpers.export(exports, "ShieldBan", ()=>(0, _shieldBanJsDefault.default));
parcelHelpers.export(exports, "ShieldBanIcon", ()=>(0, _shieldBanJsDefault.default));
parcelHelpers.export(exports, "LucideShieldCheck", ()=>(0, _shieldCheckJsDefault.default));
parcelHelpers.export(exports, "ShieldCheck", ()=>(0, _shieldCheckJsDefault.default));
parcelHelpers.export(exports, "ShieldCheckIcon", ()=>(0, _shieldCheckJsDefault.default));
parcelHelpers.export(exports, "LucideShieldEllipsis", ()=>(0, _shieldEllipsisJsDefault.default));
parcelHelpers.export(exports, "ShieldEllipsis", ()=>(0, _shieldEllipsisJsDefault.default));
parcelHelpers.export(exports, "ShieldEllipsisIcon", ()=>(0, _shieldEllipsisJsDefault.default));
parcelHelpers.export(exports, "LucideShieldHalf", ()=>(0, _shieldHalfJsDefault.default));
parcelHelpers.export(exports, "ShieldHalf", ()=>(0, _shieldHalfJsDefault.default));
parcelHelpers.export(exports, "ShieldHalfIcon", ()=>(0, _shieldHalfJsDefault.default));
parcelHelpers.export(exports, "LucideShieldMinus", ()=>(0, _shieldMinusJsDefault.default));
parcelHelpers.export(exports, "ShieldMinus", ()=>(0, _shieldMinusJsDefault.default));
parcelHelpers.export(exports, "ShieldMinusIcon", ()=>(0, _shieldMinusJsDefault.default));
parcelHelpers.export(exports, "LucideShieldOff", ()=>(0, _shieldOffJsDefault.default));
parcelHelpers.export(exports, "ShieldOff", ()=>(0, _shieldOffJsDefault.default));
parcelHelpers.export(exports, "ShieldOffIcon", ()=>(0, _shieldOffJsDefault.default));
parcelHelpers.export(exports, "LucideShieldPlus", ()=>(0, _shieldPlusJsDefault.default));
parcelHelpers.export(exports, "ShieldPlus", ()=>(0, _shieldPlusJsDefault.default));
parcelHelpers.export(exports, "ShieldPlusIcon", ()=>(0, _shieldPlusJsDefault.default));
parcelHelpers.export(exports, "LucideShieldQuestion", ()=>(0, _shieldQuestionJsDefault.default));
parcelHelpers.export(exports, "ShieldQuestion", ()=>(0, _shieldQuestionJsDefault.default));
parcelHelpers.export(exports, "ShieldQuestionIcon", ()=>(0, _shieldQuestionJsDefault.default));
parcelHelpers.export(exports, "LucideShield", ()=>(0, _shieldJsDefault.default));
parcelHelpers.export(exports, "Shield", ()=>(0, _shieldJsDefault.default));
parcelHelpers.export(exports, "ShieldIcon", ()=>(0, _shieldJsDefault.default));
parcelHelpers.export(exports, "LucideShipWheel", ()=>(0, _shipWheelJsDefault.default));
parcelHelpers.export(exports, "ShipWheel", ()=>(0, _shipWheelJsDefault.default));
parcelHelpers.export(exports, "ShipWheelIcon", ()=>(0, _shipWheelJsDefault.default));
parcelHelpers.export(exports, "LucideShip", ()=>(0, _shipJsDefault.default));
parcelHelpers.export(exports, "Ship", ()=>(0, _shipJsDefault.default));
parcelHelpers.export(exports, "ShipIcon", ()=>(0, _shipJsDefault.default));
parcelHelpers.export(exports, "LucideShirt", ()=>(0, _shirtJsDefault.default));
parcelHelpers.export(exports, "Shirt", ()=>(0, _shirtJsDefault.default));
parcelHelpers.export(exports, "ShirtIcon", ()=>(0, _shirtJsDefault.default));
parcelHelpers.export(exports, "LucideShoppingBag", ()=>(0, _shoppingBagJsDefault.default));
parcelHelpers.export(exports, "ShoppingBag", ()=>(0, _shoppingBagJsDefault.default));
parcelHelpers.export(exports, "ShoppingBagIcon", ()=>(0, _shoppingBagJsDefault.default));
parcelHelpers.export(exports, "LucideShoppingBasket", ()=>(0, _shoppingBasketJsDefault.default));
parcelHelpers.export(exports, "ShoppingBasket", ()=>(0, _shoppingBasketJsDefault.default));
parcelHelpers.export(exports, "ShoppingBasketIcon", ()=>(0, _shoppingBasketJsDefault.default));
parcelHelpers.export(exports, "LucideShoppingCart", ()=>(0, _shoppingCartJsDefault.default));
parcelHelpers.export(exports, "ShoppingCart", ()=>(0, _shoppingCartJsDefault.default));
parcelHelpers.export(exports, "ShoppingCartIcon", ()=>(0, _shoppingCartJsDefault.default));
parcelHelpers.export(exports, "LucideShovel", ()=>(0, _shovelJsDefault.default));
parcelHelpers.export(exports, "Shovel", ()=>(0, _shovelJsDefault.default));
parcelHelpers.export(exports, "ShovelIcon", ()=>(0, _shovelJsDefault.default));
parcelHelpers.export(exports, "LucideShowerHead", ()=>(0, _showerHeadJsDefault.default));
parcelHelpers.export(exports, "ShowerHead", ()=>(0, _showerHeadJsDefault.default));
parcelHelpers.export(exports, "ShowerHeadIcon", ()=>(0, _showerHeadJsDefault.default));
parcelHelpers.export(exports, "LucideShrink", ()=>(0, _shrinkJsDefault.default));
parcelHelpers.export(exports, "Shrink", ()=>(0, _shrinkJsDefault.default));
parcelHelpers.export(exports, "ShrinkIcon", ()=>(0, _shrinkJsDefault.default));
parcelHelpers.export(exports, "LucideShrub", ()=>(0, _shrubJsDefault.default));
parcelHelpers.export(exports, "Shrub", ()=>(0, _shrubJsDefault.default));
parcelHelpers.export(exports, "ShrubIcon", ()=>(0, _shrubJsDefault.default));
parcelHelpers.export(exports, "LucideShuffle", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "Shuffle", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "ShuffleIcon", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "LucideSigmaSquare", ()=>(0, _sigmaSquareJsDefault.default));
parcelHelpers.export(exports, "SigmaSquare", ()=>(0, _sigmaSquareJsDefault.default));
parcelHelpers.export(exports, "SigmaSquareIcon", ()=>(0, _sigmaSquareJsDefault.default));
parcelHelpers.export(exports, "LucideSigma", ()=>(0, _sigmaJsDefault.default));
parcelHelpers.export(exports, "Sigma", ()=>(0, _sigmaJsDefault.default));
parcelHelpers.export(exports, "SigmaIcon", ()=>(0, _sigmaJsDefault.default));
parcelHelpers.export(exports, "LucideSignalHigh", ()=>(0, _signalHighJsDefault.default));
parcelHelpers.export(exports, "SignalHigh", ()=>(0, _signalHighJsDefault.default));
parcelHelpers.export(exports, "SignalHighIcon", ()=>(0, _signalHighJsDefault.default));
parcelHelpers.export(exports, "LucideSignalLow", ()=>(0, _signalLowJsDefault.default));
parcelHelpers.export(exports, "SignalLow", ()=>(0, _signalLowJsDefault.default));
parcelHelpers.export(exports, "SignalLowIcon", ()=>(0, _signalLowJsDefault.default));
parcelHelpers.export(exports, "LucideSignalMedium", ()=>(0, _signalMediumJsDefault.default));
parcelHelpers.export(exports, "SignalMedium", ()=>(0, _signalMediumJsDefault.default));
parcelHelpers.export(exports, "SignalMediumIcon", ()=>(0, _signalMediumJsDefault.default));
parcelHelpers.export(exports, "LucideSignalZero", ()=>(0, _signalZeroJsDefault.default));
parcelHelpers.export(exports, "SignalZero", ()=>(0, _signalZeroJsDefault.default));
parcelHelpers.export(exports, "SignalZeroIcon", ()=>(0, _signalZeroJsDefault.default));
parcelHelpers.export(exports, "LucideSignal", ()=>(0, _signalJsDefault.default));
parcelHelpers.export(exports, "Signal", ()=>(0, _signalJsDefault.default));
parcelHelpers.export(exports, "SignalIcon", ()=>(0, _signalJsDefault.default));
parcelHelpers.export(exports, "LucideSignpostBig", ()=>(0, _signpostBigJsDefault.default));
parcelHelpers.export(exports, "SignpostBig", ()=>(0, _signpostBigJsDefault.default));
parcelHelpers.export(exports, "SignpostBigIcon", ()=>(0, _signpostBigJsDefault.default));
parcelHelpers.export(exports, "LucideSignpost", ()=>(0, _signpostJsDefault.default));
parcelHelpers.export(exports, "Signpost", ()=>(0, _signpostJsDefault.default));
parcelHelpers.export(exports, "SignpostIcon", ()=>(0, _signpostJsDefault.default));
parcelHelpers.export(exports, "LucideSiren", ()=>(0, _sirenJsDefault.default));
parcelHelpers.export(exports, "Siren", ()=>(0, _sirenJsDefault.default));
parcelHelpers.export(exports, "SirenIcon", ()=>(0, _sirenJsDefault.default));
parcelHelpers.export(exports, "LucideSkipBack", ()=>(0, _skipBackJsDefault.default));
parcelHelpers.export(exports, "SkipBack", ()=>(0, _skipBackJsDefault.default));
parcelHelpers.export(exports, "SkipBackIcon", ()=>(0, _skipBackJsDefault.default));
parcelHelpers.export(exports, "LucideSkipForward", ()=>(0, _skipForwardJsDefault.default));
parcelHelpers.export(exports, "SkipForward", ()=>(0, _skipForwardJsDefault.default));
parcelHelpers.export(exports, "SkipForwardIcon", ()=>(0, _skipForwardJsDefault.default));
parcelHelpers.export(exports, "LucideSkull", ()=>(0, _skullJsDefault.default));
parcelHelpers.export(exports, "Skull", ()=>(0, _skullJsDefault.default));
parcelHelpers.export(exports, "SkullIcon", ()=>(0, _skullJsDefault.default));
parcelHelpers.export(exports, "LucideSlack", ()=>(0, _slackJsDefault.default));
parcelHelpers.export(exports, "Slack", ()=>(0, _slackJsDefault.default));
parcelHelpers.export(exports, "SlackIcon", ()=>(0, _slackJsDefault.default));
parcelHelpers.export(exports, "LucideSlash", ()=>(0, _slashJsDefault.default));
parcelHelpers.export(exports, "Slash", ()=>(0, _slashJsDefault.default));
parcelHelpers.export(exports, "SlashIcon", ()=>(0, _slashJsDefault.default));
parcelHelpers.export(exports, "LucideSlice", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "Slice", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "SliceIcon", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "LucideSlidersHorizontal", ()=>(0, _slidersHorizontalJsDefault.default));
parcelHelpers.export(exports, "SlidersHorizontal", ()=>(0, _slidersHorizontalJsDefault.default));
parcelHelpers.export(exports, "SlidersHorizontalIcon", ()=>(0, _slidersHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideSliders", ()=>(0, _slidersJsDefault.default));
parcelHelpers.export(exports, "Sliders", ()=>(0, _slidersJsDefault.default));
parcelHelpers.export(exports, "SlidersIcon", ()=>(0, _slidersJsDefault.default));
parcelHelpers.export(exports, "LucideSmartphoneCharging", ()=>(0, _smartphoneChargingJsDefault.default));
parcelHelpers.export(exports, "SmartphoneCharging", ()=>(0, _smartphoneChargingJsDefault.default));
parcelHelpers.export(exports, "SmartphoneChargingIcon", ()=>(0, _smartphoneChargingJsDefault.default));
parcelHelpers.export(exports, "LucideSmartphoneNfc", ()=>(0, _smartphoneNfcJsDefault.default));
parcelHelpers.export(exports, "SmartphoneNfc", ()=>(0, _smartphoneNfcJsDefault.default));
parcelHelpers.export(exports, "SmartphoneNfcIcon", ()=>(0, _smartphoneNfcJsDefault.default));
parcelHelpers.export(exports, "LucideSmartphone", ()=>(0, _smartphoneJsDefault.default));
parcelHelpers.export(exports, "Smartphone", ()=>(0, _smartphoneJsDefault.default));
parcelHelpers.export(exports, "SmartphoneIcon", ()=>(0, _smartphoneJsDefault.default));
parcelHelpers.export(exports, "LucideSmilePlus", ()=>(0, _smilePlusJsDefault.default));
parcelHelpers.export(exports, "SmilePlus", ()=>(0, _smilePlusJsDefault.default));
parcelHelpers.export(exports, "SmilePlusIcon", ()=>(0, _smilePlusJsDefault.default));
parcelHelpers.export(exports, "LucideSmile", ()=>(0, _smileJsDefault.default));
parcelHelpers.export(exports, "Smile", ()=>(0, _smileJsDefault.default));
parcelHelpers.export(exports, "SmileIcon", ()=>(0, _smileJsDefault.default));
parcelHelpers.export(exports, "LucideSnail", ()=>(0, _snailJsDefault.default));
parcelHelpers.export(exports, "Snail", ()=>(0, _snailJsDefault.default));
parcelHelpers.export(exports, "SnailIcon", ()=>(0, _snailJsDefault.default));
parcelHelpers.export(exports, "LucideSnowflake", ()=>(0, _snowflakeJsDefault.default));
parcelHelpers.export(exports, "Snowflake", ()=>(0, _snowflakeJsDefault.default));
parcelHelpers.export(exports, "SnowflakeIcon", ()=>(0, _snowflakeJsDefault.default));
parcelHelpers.export(exports, "LucideSofa", ()=>(0, _sofaJsDefault.default));
parcelHelpers.export(exports, "Sofa", ()=>(0, _sofaJsDefault.default));
parcelHelpers.export(exports, "SofaIcon", ()=>(0, _sofaJsDefault.default));
parcelHelpers.export(exports, "LucideSoup", ()=>(0, _soupJsDefault.default));
parcelHelpers.export(exports, "Soup", ()=>(0, _soupJsDefault.default));
parcelHelpers.export(exports, "SoupIcon", ()=>(0, _soupJsDefault.default));
parcelHelpers.export(exports, "LucideSpace", ()=>(0, _spaceJsDefault.default));
parcelHelpers.export(exports, "Space", ()=>(0, _spaceJsDefault.default));
parcelHelpers.export(exports, "SpaceIcon", ()=>(0, _spaceJsDefault.default));
parcelHelpers.export(exports, "LucideSpade", ()=>(0, _spadeJsDefault.default));
parcelHelpers.export(exports, "Spade", ()=>(0, _spadeJsDefault.default));
parcelHelpers.export(exports, "SpadeIcon", ()=>(0, _spadeJsDefault.default));
parcelHelpers.export(exports, "LucideSparkle", ()=>(0, _sparkleJsDefault.default));
parcelHelpers.export(exports, "Sparkle", ()=>(0, _sparkleJsDefault.default));
parcelHelpers.export(exports, "SparkleIcon", ()=>(0, _sparkleJsDefault.default));
parcelHelpers.export(exports, "LucideSpeaker", ()=>(0, _speakerJsDefault.default));
parcelHelpers.export(exports, "Speaker", ()=>(0, _speakerJsDefault.default));
parcelHelpers.export(exports, "SpeakerIcon", ()=>(0, _speakerJsDefault.default));
parcelHelpers.export(exports, "LucideSpeech", ()=>(0, _speechJsDefault.default));
parcelHelpers.export(exports, "Speech", ()=>(0, _speechJsDefault.default));
parcelHelpers.export(exports, "SpeechIcon", ()=>(0, _speechJsDefault.default));
parcelHelpers.export(exports, "LucideSpellCheck2", ()=>(0, _spellCheck2JsDefault.default));
parcelHelpers.export(exports, "SpellCheck2", ()=>(0, _spellCheck2JsDefault.default));
parcelHelpers.export(exports, "SpellCheck2Icon", ()=>(0, _spellCheck2JsDefault.default));
parcelHelpers.export(exports, "LucideSpellCheck", ()=>(0, _spellCheckJsDefault.default));
parcelHelpers.export(exports, "SpellCheck", ()=>(0, _spellCheckJsDefault.default));
parcelHelpers.export(exports, "SpellCheckIcon", ()=>(0, _spellCheckJsDefault.default));
parcelHelpers.export(exports, "LucideSpline", ()=>(0, _splineJsDefault.default));
parcelHelpers.export(exports, "Spline", ()=>(0, _splineJsDefault.default));
parcelHelpers.export(exports, "SplineIcon", ()=>(0, _splineJsDefault.default));
parcelHelpers.export(exports, "LucideSplitSquareHorizontal", ()=>(0, _splitSquareHorizontalJsDefault.default));
parcelHelpers.export(exports, "SplitSquareHorizontal", ()=>(0, _splitSquareHorizontalJsDefault.default));
parcelHelpers.export(exports, "SplitSquareHorizontalIcon", ()=>(0, _splitSquareHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideSplitSquareVertical", ()=>(0, _splitSquareVerticalJsDefault.default));
parcelHelpers.export(exports, "SplitSquareVertical", ()=>(0, _splitSquareVerticalJsDefault.default));
parcelHelpers.export(exports, "SplitSquareVerticalIcon", ()=>(0, _splitSquareVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideSplit", ()=>(0, _splitJsDefault.default));
parcelHelpers.export(exports, "Split", ()=>(0, _splitJsDefault.default));
parcelHelpers.export(exports, "SplitIcon", ()=>(0, _splitJsDefault.default));
parcelHelpers.export(exports, "LucideSprayCan", ()=>(0, _sprayCanJsDefault.default));
parcelHelpers.export(exports, "SprayCan", ()=>(0, _sprayCanJsDefault.default));
parcelHelpers.export(exports, "SprayCanIcon", ()=>(0, _sprayCanJsDefault.default));
parcelHelpers.export(exports, "LucideSprout", ()=>(0, _sproutJsDefault.default));
parcelHelpers.export(exports, "Sprout", ()=>(0, _sproutJsDefault.default));
parcelHelpers.export(exports, "SproutIcon", ()=>(0, _sproutJsDefault.default));
parcelHelpers.export(exports, "LucideSquareDashedBottomCode", ()=>(0, _squareDashedBottomCodeJsDefault.default));
parcelHelpers.export(exports, "SquareDashedBottomCode", ()=>(0, _squareDashedBottomCodeJsDefault.default));
parcelHelpers.export(exports, "SquareDashedBottomCodeIcon", ()=>(0, _squareDashedBottomCodeJsDefault.default));
parcelHelpers.export(exports, "LucideSquareDashedBottom", ()=>(0, _squareDashedBottomJsDefault.default));
parcelHelpers.export(exports, "SquareDashedBottom", ()=>(0, _squareDashedBottomJsDefault.default));
parcelHelpers.export(exports, "SquareDashedBottomIcon", ()=>(0, _squareDashedBottomJsDefault.default));
parcelHelpers.export(exports, "LucideSquareRadical", ()=>(0, _squareRadicalJsDefault.default));
parcelHelpers.export(exports, "SquareRadical", ()=>(0, _squareRadicalJsDefault.default));
parcelHelpers.export(exports, "SquareRadicalIcon", ()=>(0, _squareRadicalJsDefault.default));
parcelHelpers.export(exports, "LucideSquareStack", ()=>(0, _squareStackJsDefault.default));
parcelHelpers.export(exports, "SquareStack", ()=>(0, _squareStackJsDefault.default));
parcelHelpers.export(exports, "SquareStackIcon", ()=>(0, _squareStackJsDefault.default));
parcelHelpers.export(exports, "LucideSquare", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "Square", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "SquareIcon", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "LucideSquircle", ()=>(0, _squircleJsDefault.default));
parcelHelpers.export(exports, "Squircle", ()=>(0, _squircleJsDefault.default));
parcelHelpers.export(exports, "SquircleIcon", ()=>(0, _squircleJsDefault.default));
parcelHelpers.export(exports, "LucideSquirrel", ()=>(0, _squirrelJsDefault.default));
parcelHelpers.export(exports, "Squirrel", ()=>(0, _squirrelJsDefault.default));
parcelHelpers.export(exports, "SquirrelIcon", ()=>(0, _squirrelJsDefault.default));
parcelHelpers.export(exports, "LucideStamp", ()=>(0, _stampJsDefault.default));
parcelHelpers.export(exports, "Stamp", ()=>(0, _stampJsDefault.default));
parcelHelpers.export(exports, "StampIcon", ()=>(0, _stampJsDefault.default));
parcelHelpers.export(exports, "LucideStarHalf", ()=>(0, _starHalfJsDefault.default));
parcelHelpers.export(exports, "StarHalf", ()=>(0, _starHalfJsDefault.default));
parcelHelpers.export(exports, "StarHalfIcon", ()=>(0, _starHalfJsDefault.default));
parcelHelpers.export(exports, "LucideStarOff", ()=>(0, _starOffJsDefault.default));
parcelHelpers.export(exports, "StarOff", ()=>(0, _starOffJsDefault.default));
parcelHelpers.export(exports, "StarOffIcon", ()=>(0, _starOffJsDefault.default));
parcelHelpers.export(exports, "LucideStar", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "Star", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "StarIcon", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "LucideStepBack", ()=>(0, _stepBackJsDefault.default));
parcelHelpers.export(exports, "StepBack", ()=>(0, _stepBackJsDefault.default));
parcelHelpers.export(exports, "StepBackIcon", ()=>(0, _stepBackJsDefault.default));
parcelHelpers.export(exports, "LucideStepForward", ()=>(0, _stepForwardJsDefault.default));
parcelHelpers.export(exports, "StepForward", ()=>(0, _stepForwardJsDefault.default));
parcelHelpers.export(exports, "StepForwardIcon", ()=>(0, _stepForwardJsDefault.default));
parcelHelpers.export(exports, "LucideStethoscope", ()=>(0, _stethoscopeJsDefault.default));
parcelHelpers.export(exports, "Stethoscope", ()=>(0, _stethoscopeJsDefault.default));
parcelHelpers.export(exports, "StethoscopeIcon", ()=>(0, _stethoscopeJsDefault.default));
parcelHelpers.export(exports, "LucideSticker", ()=>(0, _stickerJsDefault.default));
parcelHelpers.export(exports, "Sticker", ()=>(0, _stickerJsDefault.default));
parcelHelpers.export(exports, "StickerIcon", ()=>(0, _stickerJsDefault.default));
parcelHelpers.export(exports, "LucideStickyNote", ()=>(0, _stickyNoteJsDefault.default));
parcelHelpers.export(exports, "StickyNote", ()=>(0, _stickyNoteJsDefault.default));
parcelHelpers.export(exports, "StickyNoteIcon", ()=>(0, _stickyNoteJsDefault.default));
parcelHelpers.export(exports, "LucideStopCircle", ()=>(0, _stopCircleJsDefault.default));
parcelHelpers.export(exports, "StopCircle", ()=>(0, _stopCircleJsDefault.default));
parcelHelpers.export(exports, "StopCircleIcon", ()=>(0, _stopCircleJsDefault.default));
parcelHelpers.export(exports, "LucideStore", ()=>(0, _storeJsDefault.default));
parcelHelpers.export(exports, "Store", ()=>(0, _storeJsDefault.default));
parcelHelpers.export(exports, "StoreIcon", ()=>(0, _storeJsDefault.default));
parcelHelpers.export(exports, "LucideStretchHorizontal", ()=>(0, _stretchHorizontalJsDefault.default));
parcelHelpers.export(exports, "StretchHorizontal", ()=>(0, _stretchHorizontalJsDefault.default));
parcelHelpers.export(exports, "StretchHorizontalIcon", ()=>(0, _stretchHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideStretchVertical", ()=>(0, _stretchVerticalJsDefault.default));
parcelHelpers.export(exports, "StretchVertical", ()=>(0, _stretchVerticalJsDefault.default));
parcelHelpers.export(exports, "StretchVerticalIcon", ()=>(0, _stretchVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideStrikethrough", ()=>(0, _strikethroughJsDefault.default));
parcelHelpers.export(exports, "Strikethrough", ()=>(0, _strikethroughJsDefault.default));
parcelHelpers.export(exports, "StrikethroughIcon", ()=>(0, _strikethroughJsDefault.default));
parcelHelpers.export(exports, "LucideSubscript", ()=>(0, _subscriptJsDefault.default));
parcelHelpers.export(exports, "Subscript", ()=>(0, _subscriptJsDefault.default));
parcelHelpers.export(exports, "SubscriptIcon", ()=>(0, _subscriptJsDefault.default));
parcelHelpers.export(exports, "LucideSunDim", ()=>(0, _sunDimJsDefault.default));
parcelHelpers.export(exports, "SunDim", ()=>(0, _sunDimJsDefault.default));
parcelHelpers.export(exports, "SunDimIcon", ()=>(0, _sunDimJsDefault.default));
parcelHelpers.export(exports, "LucideSunMedium", ()=>(0, _sunMediumJsDefault.default));
parcelHelpers.export(exports, "SunMedium", ()=>(0, _sunMediumJsDefault.default));
parcelHelpers.export(exports, "SunMediumIcon", ()=>(0, _sunMediumJsDefault.default));
parcelHelpers.export(exports, "LucideSunMoon", ()=>(0, _sunMoonJsDefault.default));
parcelHelpers.export(exports, "SunMoon", ()=>(0, _sunMoonJsDefault.default));
parcelHelpers.export(exports, "SunMoonIcon", ()=>(0, _sunMoonJsDefault.default));
parcelHelpers.export(exports, "LucideSunSnow", ()=>(0, _sunSnowJsDefault.default));
parcelHelpers.export(exports, "SunSnow", ()=>(0, _sunSnowJsDefault.default));
parcelHelpers.export(exports, "SunSnowIcon", ()=>(0, _sunSnowJsDefault.default));
parcelHelpers.export(exports, "LucideSun", ()=>(0, _sunJsDefault.default));
parcelHelpers.export(exports, "Sun", ()=>(0, _sunJsDefault.default));
parcelHelpers.export(exports, "SunIcon", ()=>(0, _sunJsDefault.default));
parcelHelpers.export(exports, "LucideSunrise", ()=>(0, _sunriseJsDefault.default));
parcelHelpers.export(exports, "Sunrise", ()=>(0, _sunriseJsDefault.default));
parcelHelpers.export(exports, "SunriseIcon", ()=>(0, _sunriseJsDefault.default));
parcelHelpers.export(exports, "LucideSunset", ()=>(0, _sunsetJsDefault.default));
parcelHelpers.export(exports, "Sunset", ()=>(0, _sunsetJsDefault.default));
parcelHelpers.export(exports, "SunsetIcon", ()=>(0, _sunsetJsDefault.default));
parcelHelpers.export(exports, "LucideSuperscript", ()=>(0, _superscriptJsDefault.default));
parcelHelpers.export(exports, "Superscript", ()=>(0, _superscriptJsDefault.default));
parcelHelpers.export(exports, "SuperscriptIcon", ()=>(0, _superscriptJsDefault.default));
parcelHelpers.export(exports, "LucideSwatchBook", ()=>(0, _swatchBookJsDefault.default));
parcelHelpers.export(exports, "SwatchBook", ()=>(0, _swatchBookJsDefault.default));
parcelHelpers.export(exports, "SwatchBookIcon", ()=>(0, _swatchBookJsDefault.default));
parcelHelpers.export(exports, "LucideSwissFranc", ()=>(0, _swissFrancJsDefault.default));
parcelHelpers.export(exports, "SwissFranc", ()=>(0, _swissFrancJsDefault.default));
parcelHelpers.export(exports, "SwissFrancIcon", ()=>(0, _swissFrancJsDefault.default));
parcelHelpers.export(exports, "LucideSwitchCamera", ()=>(0, _switchCameraJsDefault.default));
parcelHelpers.export(exports, "SwitchCamera", ()=>(0, _switchCameraJsDefault.default));
parcelHelpers.export(exports, "SwitchCameraIcon", ()=>(0, _switchCameraJsDefault.default));
parcelHelpers.export(exports, "LucideSword", ()=>(0, _swordJsDefault.default));
parcelHelpers.export(exports, "Sword", ()=>(0, _swordJsDefault.default));
parcelHelpers.export(exports, "SwordIcon", ()=>(0, _swordJsDefault.default));
parcelHelpers.export(exports, "LucideSwords", ()=>(0, _swordsJsDefault.default));
parcelHelpers.export(exports, "Swords", ()=>(0, _swordsJsDefault.default));
parcelHelpers.export(exports, "SwordsIcon", ()=>(0, _swordsJsDefault.default));
parcelHelpers.export(exports, "LucideSyringe", ()=>(0, _syringeJsDefault.default));
parcelHelpers.export(exports, "Syringe", ()=>(0, _syringeJsDefault.default));
parcelHelpers.export(exports, "SyringeIcon", ()=>(0, _syringeJsDefault.default));
parcelHelpers.export(exports, "LucideTable2", ()=>(0, _table2JsDefault.default));
parcelHelpers.export(exports, "Table2", ()=>(0, _table2JsDefault.default));
parcelHelpers.export(exports, "Table2Icon", ()=>(0, _table2JsDefault.default));
parcelHelpers.export(exports, "LucideTableCellsMerge", ()=>(0, _tableCellsMergeJsDefault.default));
parcelHelpers.export(exports, "TableCellsMerge", ()=>(0, _tableCellsMergeJsDefault.default));
parcelHelpers.export(exports, "TableCellsMergeIcon", ()=>(0, _tableCellsMergeJsDefault.default));
parcelHelpers.export(exports, "LucideTableCellsSplit", ()=>(0, _tableCellsSplitJsDefault.default));
parcelHelpers.export(exports, "TableCellsSplit", ()=>(0, _tableCellsSplitJsDefault.default));
parcelHelpers.export(exports, "TableCellsSplitIcon", ()=>(0, _tableCellsSplitJsDefault.default));
parcelHelpers.export(exports, "LucideTableColumnsSplit", ()=>(0, _tableColumnsSplitJsDefault.default));
parcelHelpers.export(exports, "TableColumnsSplit", ()=>(0, _tableColumnsSplitJsDefault.default));
parcelHelpers.export(exports, "TableColumnsSplitIcon", ()=>(0, _tableColumnsSplitJsDefault.default));
parcelHelpers.export(exports, "LucideTableProperties", ()=>(0, _tablePropertiesJsDefault.default));
parcelHelpers.export(exports, "TableProperties", ()=>(0, _tablePropertiesJsDefault.default));
parcelHelpers.export(exports, "TablePropertiesIcon", ()=>(0, _tablePropertiesJsDefault.default));
parcelHelpers.export(exports, "LucideTableRowsSplit", ()=>(0, _tableRowsSplitJsDefault.default));
parcelHelpers.export(exports, "TableRowsSplit", ()=>(0, _tableRowsSplitJsDefault.default));
parcelHelpers.export(exports, "TableRowsSplitIcon", ()=>(0, _tableRowsSplitJsDefault.default));
parcelHelpers.export(exports, "LucideTable", ()=>(0, _tableJsDefault.default));
parcelHelpers.export(exports, "Table", ()=>(0, _tableJsDefault.default));
parcelHelpers.export(exports, "TableIcon", ()=>(0, _tableJsDefault.default));
parcelHelpers.export(exports, "LucideTabletSmartphone", ()=>(0, _tabletSmartphoneJsDefault.default));
parcelHelpers.export(exports, "TabletSmartphone", ()=>(0, _tabletSmartphoneJsDefault.default));
parcelHelpers.export(exports, "TabletSmartphoneIcon", ()=>(0, _tabletSmartphoneJsDefault.default));
parcelHelpers.export(exports, "LucideTablet", ()=>(0, _tabletJsDefault.default));
parcelHelpers.export(exports, "Tablet", ()=>(0, _tabletJsDefault.default));
parcelHelpers.export(exports, "TabletIcon", ()=>(0, _tabletJsDefault.default));
parcelHelpers.export(exports, "LucideTablets", ()=>(0, _tabletsJsDefault.default));
parcelHelpers.export(exports, "Tablets", ()=>(0, _tabletsJsDefault.default));
parcelHelpers.export(exports, "TabletsIcon", ()=>(0, _tabletsJsDefault.default));
parcelHelpers.export(exports, "LucideTag", ()=>(0, _tagJsDefault.default));
parcelHelpers.export(exports, "Tag", ()=>(0, _tagJsDefault.default));
parcelHelpers.export(exports, "TagIcon", ()=>(0, _tagJsDefault.default));
parcelHelpers.export(exports, "LucideTags", ()=>(0, _tagsJsDefault.default));
parcelHelpers.export(exports, "Tags", ()=>(0, _tagsJsDefault.default));
parcelHelpers.export(exports, "TagsIcon", ()=>(0, _tagsJsDefault.default));
parcelHelpers.export(exports, "LucideTally1", ()=>(0, _tally1JsDefault.default));
parcelHelpers.export(exports, "Tally1", ()=>(0, _tally1JsDefault.default));
parcelHelpers.export(exports, "Tally1Icon", ()=>(0, _tally1JsDefault.default));
parcelHelpers.export(exports, "LucideTally2", ()=>(0, _tally2JsDefault.default));
parcelHelpers.export(exports, "Tally2", ()=>(0, _tally2JsDefault.default));
parcelHelpers.export(exports, "Tally2Icon", ()=>(0, _tally2JsDefault.default));
parcelHelpers.export(exports, "LucideTally3", ()=>(0, _tally3JsDefault.default));
parcelHelpers.export(exports, "Tally3", ()=>(0, _tally3JsDefault.default));
parcelHelpers.export(exports, "Tally3Icon", ()=>(0, _tally3JsDefault.default));
parcelHelpers.export(exports, "LucideTally4", ()=>(0, _tally4JsDefault.default));
parcelHelpers.export(exports, "Tally4", ()=>(0, _tally4JsDefault.default));
parcelHelpers.export(exports, "Tally4Icon", ()=>(0, _tally4JsDefault.default));
parcelHelpers.export(exports, "LucideTally5", ()=>(0, _tally5JsDefault.default));
parcelHelpers.export(exports, "Tally5", ()=>(0, _tally5JsDefault.default));
parcelHelpers.export(exports, "Tally5Icon", ()=>(0, _tally5JsDefault.default));
parcelHelpers.export(exports, "LucideTangent", ()=>(0, _tangentJsDefault.default));
parcelHelpers.export(exports, "Tangent", ()=>(0, _tangentJsDefault.default));
parcelHelpers.export(exports, "TangentIcon", ()=>(0, _tangentJsDefault.default));
parcelHelpers.export(exports, "LucideTarget", ()=>(0, _targetJsDefault.default));
parcelHelpers.export(exports, "Target", ()=>(0, _targetJsDefault.default));
parcelHelpers.export(exports, "TargetIcon", ()=>(0, _targetJsDefault.default));
parcelHelpers.export(exports, "LucideTelescope", ()=>(0, _telescopeJsDefault.default));
parcelHelpers.export(exports, "Telescope", ()=>(0, _telescopeJsDefault.default));
parcelHelpers.export(exports, "TelescopeIcon", ()=>(0, _telescopeJsDefault.default));
parcelHelpers.export(exports, "LucideTentTree", ()=>(0, _tentTreeJsDefault.default));
parcelHelpers.export(exports, "TentTree", ()=>(0, _tentTreeJsDefault.default));
parcelHelpers.export(exports, "TentTreeIcon", ()=>(0, _tentTreeJsDefault.default));
parcelHelpers.export(exports, "LucideTent", ()=>(0, _tentJsDefault.default));
parcelHelpers.export(exports, "Tent", ()=>(0, _tentJsDefault.default));
parcelHelpers.export(exports, "TentIcon", ()=>(0, _tentJsDefault.default));
parcelHelpers.export(exports, "LucideTerminalSquare", ()=>(0, _terminalSquareJsDefault.default));
parcelHelpers.export(exports, "TerminalSquare", ()=>(0, _terminalSquareJsDefault.default));
parcelHelpers.export(exports, "TerminalSquareIcon", ()=>(0, _terminalSquareJsDefault.default));
parcelHelpers.export(exports, "LucideTerminal", ()=>(0, _terminalJsDefault.default));
parcelHelpers.export(exports, "Terminal", ()=>(0, _terminalJsDefault.default));
parcelHelpers.export(exports, "TerminalIcon", ()=>(0, _terminalJsDefault.default));
parcelHelpers.export(exports, "LucideTestTube2", ()=>(0, _testTube2JsDefault.default));
parcelHelpers.export(exports, "TestTube2", ()=>(0, _testTube2JsDefault.default));
parcelHelpers.export(exports, "TestTube2Icon", ()=>(0, _testTube2JsDefault.default));
parcelHelpers.export(exports, "LucideTestTube", ()=>(0, _testTubeJsDefault.default));
parcelHelpers.export(exports, "TestTube", ()=>(0, _testTubeJsDefault.default));
parcelHelpers.export(exports, "TestTubeIcon", ()=>(0, _testTubeJsDefault.default));
parcelHelpers.export(exports, "LucideTestTubes", ()=>(0, _testTubesJsDefault.default));
parcelHelpers.export(exports, "TestTubes", ()=>(0, _testTubesJsDefault.default));
parcelHelpers.export(exports, "TestTubesIcon", ()=>(0, _testTubesJsDefault.default));
parcelHelpers.export(exports, "LucideTextCursorInput", ()=>(0, _textCursorInputJsDefault.default));
parcelHelpers.export(exports, "TextCursorInput", ()=>(0, _textCursorInputJsDefault.default));
parcelHelpers.export(exports, "TextCursorInputIcon", ()=>(0, _textCursorInputJsDefault.default));
parcelHelpers.export(exports, "LucideTextCursor", ()=>(0, _textCursorJsDefault.default));
parcelHelpers.export(exports, "TextCursor", ()=>(0, _textCursorJsDefault.default));
parcelHelpers.export(exports, "TextCursorIcon", ()=>(0, _textCursorJsDefault.default));
parcelHelpers.export(exports, "LucideTextQuote", ()=>(0, _textQuoteJsDefault.default));
parcelHelpers.export(exports, "TextQuote", ()=>(0, _textQuoteJsDefault.default));
parcelHelpers.export(exports, "TextQuoteIcon", ()=>(0, _textQuoteJsDefault.default));
parcelHelpers.export(exports, "LucideTextSearch", ()=>(0, _textSearchJsDefault.default));
parcelHelpers.export(exports, "TextSearch", ()=>(0, _textSearchJsDefault.default));
parcelHelpers.export(exports, "TextSearchIcon", ()=>(0, _textSearchJsDefault.default));
parcelHelpers.export(exports, "LucideText", ()=>(0, _textJsDefault.default));
parcelHelpers.export(exports, "Text", ()=>(0, _textJsDefault.default));
parcelHelpers.export(exports, "TextIcon", ()=>(0, _textJsDefault.default));
parcelHelpers.export(exports, "LucideTheater", ()=>(0, _theaterJsDefault.default));
parcelHelpers.export(exports, "Theater", ()=>(0, _theaterJsDefault.default));
parcelHelpers.export(exports, "TheaterIcon", ()=>(0, _theaterJsDefault.default));
parcelHelpers.export(exports, "LucideThermometerSnowflake", ()=>(0, _thermometerSnowflakeJsDefault.default));
parcelHelpers.export(exports, "ThermometerSnowflake", ()=>(0, _thermometerSnowflakeJsDefault.default));
parcelHelpers.export(exports, "ThermometerSnowflakeIcon", ()=>(0, _thermometerSnowflakeJsDefault.default));
parcelHelpers.export(exports, "LucideThermometerSun", ()=>(0, _thermometerSunJsDefault.default));
parcelHelpers.export(exports, "ThermometerSun", ()=>(0, _thermometerSunJsDefault.default));
parcelHelpers.export(exports, "ThermometerSunIcon", ()=>(0, _thermometerSunJsDefault.default));
parcelHelpers.export(exports, "LucideThermometer", ()=>(0, _thermometerJsDefault.default));
parcelHelpers.export(exports, "Thermometer", ()=>(0, _thermometerJsDefault.default));
parcelHelpers.export(exports, "ThermometerIcon", ()=>(0, _thermometerJsDefault.default));
parcelHelpers.export(exports, "LucideThumbsDown", ()=>(0, _thumbsDownJsDefault.default));
parcelHelpers.export(exports, "ThumbsDown", ()=>(0, _thumbsDownJsDefault.default));
parcelHelpers.export(exports, "ThumbsDownIcon", ()=>(0, _thumbsDownJsDefault.default));
parcelHelpers.export(exports, "LucideThumbsUp", ()=>(0, _thumbsUpJsDefault.default));
parcelHelpers.export(exports, "ThumbsUp", ()=>(0, _thumbsUpJsDefault.default));
parcelHelpers.export(exports, "ThumbsUpIcon", ()=>(0, _thumbsUpJsDefault.default));
parcelHelpers.export(exports, "LucideTicketCheck", ()=>(0, _ticketCheckJsDefault.default));
parcelHelpers.export(exports, "TicketCheck", ()=>(0, _ticketCheckJsDefault.default));
parcelHelpers.export(exports, "TicketCheckIcon", ()=>(0, _ticketCheckJsDefault.default));
parcelHelpers.export(exports, "LucideTicketMinus", ()=>(0, _ticketMinusJsDefault.default));
parcelHelpers.export(exports, "TicketMinus", ()=>(0, _ticketMinusJsDefault.default));
parcelHelpers.export(exports, "TicketMinusIcon", ()=>(0, _ticketMinusJsDefault.default));
parcelHelpers.export(exports, "LucideTicketPercent", ()=>(0, _ticketPercentJsDefault.default));
parcelHelpers.export(exports, "TicketPercent", ()=>(0, _ticketPercentJsDefault.default));
parcelHelpers.export(exports, "TicketPercentIcon", ()=>(0, _ticketPercentJsDefault.default));
parcelHelpers.export(exports, "LucideTicketPlus", ()=>(0, _ticketPlusJsDefault.default));
parcelHelpers.export(exports, "TicketPlus", ()=>(0, _ticketPlusJsDefault.default));
parcelHelpers.export(exports, "TicketPlusIcon", ()=>(0, _ticketPlusJsDefault.default));
parcelHelpers.export(exports, "LucideTicketSlash", ()=>(0, _ticketSlashJsDefault.default));
parcelHelpers.export(exports, "TicketSlash", ()=>(0, _ticketSlashJsDefault.default));
parcelHelpers.export(exports, "TicketSlashIcon", ()=>(0, _ticketSlashJsDefault.default));
parcelHelpers.export(exports, "LucideTicketX", ()=>(0, _ticketXJsDefault.default));
parcelHelpers.export(exports, "TicketX", ()=>(0, _ticketXJsDefault.default));
parcelHelpers.export(exports, "TicketXIcon", ()=>(0, _ticketXJsDefault.default));
parcelHelpers.export(exports, "LucideTicket", ()=>(0, _ticketJsDefault.default));
parcelHelpers.export(exports, "Ticket", ()=>(0, _ticketJsDefault.default));
parcelHelpers.export(exports, "TicketIcon", ()=>(0, _ticketJsDefault.default));
parcelHelpers.export(exports, "LucideTimerOff", ()=>(0, _timerOffJsDefault.default));
parcelHelpers.export(exports, "TimerOff", ()=>(0, _timerOffJsDefault.default));
parcelHelpers.export(exports, "TimerOffIcon", ()=>(0, _timerOffJsDefault.default));
parcelHelpers.export(exports, "LucideTimerReset", ()=>(0, _timerResetJsDefault.default));
parcelHelpers.export(exports, "TimerReset", ()=>(0, _timerResetJsDefault.default));
parcelHelpers.export(exports, "TimerResetIcon", ()=>(0, _timerResetJsDefault.default));
parcelHelpers.export(exports, "LucideTimer", ()=>(0, _timerJsDefault.default));
parcelHelpers.export(exports, "Timer", ()=>(0, _timerJsDefault.default));
parcelHelpers.export(exports, "TimerIcon", ()=>(0, _timerJsDefault.default));
parcelHelpers.export(exports, "LucideToggleLeft", ()=>(0, _toggleLeftJsDefault.default));
parcelHelpers.export(exports, "ToggleLeft", ()=>(0, _toggleLeftJsDefault.default));
parcelHelpers.export(exports, "ToggleLeftIcon", ()=>(0, _toggleLeftJsDefault.default));
parcelHelpers.export(exports, "LucideToggleRight", ()=>(0, _toggleRightJsDefault.default));
parcelHelpers.export(exports, "ToggleRight", ()=>(0, _toggleRightJsDefault.default));
parcelHelpers.export(exports, "ToggleRightIcon", ()=>(0, _toggleRightJsDefault.default));
parcelHelpers.export(exports, "LucideTornado", ()=>(0, _tornadoJsDefault.default));
parcelHelpers.export(exports, "Tornado", ()=>(0, _tornadoJsDefault.default));
parcelHelpers.export(exports, "TornadoIcon", ()=>(0, _tornadoJsDefault.default));
parcelHelpers.export(exports, "LucideTorus", ()=>(0, _torusJsDefault.default));
parcelHelpers.export(exports, "Torus", ()=>(0, _torusJsDefault.default));
parcelHelpers.export(exports, "TorusIcon", ()=>(0, _torusJsDefault.default));
parcelHelpers.export(exports, "LucideTouchpadOff", ()=>(0, _touchpadOffJsDefault.default));
parcelHelpers.export(exports, "TouchpadOff", ()=>(0, _touchpadOffJsDefault.default));
parcelHelpers.export(exports, "TouchpadOffIcon", ()=>(0, _touchpadOffJsDefault.default));
parcelHelpers.export(exports, "LucideTouchpad", ()=>(0, _touchpadJsDefault.default));
parcelHelpers.export(exports, "Touchpad", ()=>(0, _touchpadJsDefault.default));
parcelHelpers.export(exports, "TouchpadIcon", ()=>(0, _touchpadJsDefault.default));
parcelHelpers.export(exports, "LucideTowerControl", ()=>(0, _towerControlJsDefault.default));
parcelHelpers.export(exports, "TowerControl", ()=>(0, _towerControlJsDefault.default));
parcelHelpers.export(exports, "TowerControlIcon", ()=>(0, _towerControlJsDefault.default));
parcelHelpers.export(exports, "LucideToyBrick", ()=>(0, _toyBrickJsDefault.default));
parcelHelpers.export(exports, "ToyBrick", ()=>(0, _toyBrickJsDefault.default));
parcelHelpers.export(exports, "ToyBrickIcon", ()=>(0, _toyBrickJsDefault.default));
parcelHelpers.export(exports, "LucideTractor", ()=>(0, _tractorJsDefault.default));
parcelHelpers.export(exports, "Tractor", ()=>(0, _tractorJsDefault.default));
parcelHelpers.export(exports, "TractorIcon", ()=>(0, _tractorJsDefault.default));
parcelHelpers.export(exports, "LucideTrafficCone", ()=>(0, _trafficConeJsDefault.default));
parcelHelpers.export(exports, "TrafficCone", ()=>(0, _trafficConeJsDefault.default));
parcelHelpers.export(exports, "TrafficConeIcon", ()=>(0, _trafficConeJsDefault.default));
parcelHelpers.export(exports, "LucideTrainFrontTunnel", ()=>(0, _trainFrontTunnelJsDefault.default));
parcelHelpers.export(exports, "TrainFrontTunnel", ()=>(0, _trainFrontTunnelJsDefault.default));
parcelHelpers.export(exports, "TrainFrontTunnelIcon", ()=>(0, _trainFrontTunnelJsDefault.default));
parcelHelpers.export(exports, "LucideTrainFront", ()=>(0, _trainFrontJsDefault.default));
parcelHelpers.export(exports, "TrainFront", ()=>(0, _trainFrontJsDefault.default));
parcelHelpers.export(exports, "TrainFrontIcon", ()=>(0, _trainFrontJsDefault.default));
parcelHelpers.export(exports, "LucideTrainTrack", ()=>(0, _trainTrackJsDefault.default));
parcelHelpers.export(exports, "TrainTrack", ()=>(0, _trainTrackJsDefault.default));
parcelHelpers.export(exports, "TrainTrackIcon", ()=>(0, _trainTrackJsDefault.default));
parcelHelpers.export(exports, "LucideTrash2", ()=>(0, _trash2JsDefault.default));
parcelHelpers.export(exports, "Trash2", ()=>(0, _trash2JsDefault.default));
parcelHelpers.export(exports, "Trash2Icon", ()=>(0, _trash2JsDefault.default));
parcelHelpers.export(exports, "LucideTrash", ()=>(0, _trashJsDefault.default));
parcelHelpers.export(exports, "Trash", ()=>(0, _trashJsDefault.default));
parcelHelpers.export(exports, "TrashIcon", ()=>(0, _trashJsDefault.default));
parcelHelpers.export(exports, "LucideTreeDeciduous", ()=>(0, _treeDeciduousJsDefault.default));
parcelHelpers.export(exports, "TreeDeciduous", ()=>(0, _treeDeciduousJsDefault.default));
parcelHelpers.export(exports, "TreeDeciduousIcon", ()=>(0, _treeDeciduousJsDefault.default));
parcelHelpers.export(exports, "LucideTreePine", ()=>(0, _treePineJsDefault.default));
parcelHelpers.export(exports, "TreePine", ()=>(0, _treePineJsDefault.default));
parcelHelpers.export(exports, "TreePineIcon", ()=>(0, _treePineJsDefault.default));
parcelHelpers.export(exports, "LucideTrees", ()=>(0, _treesJsDefault.default));
parcelHelpers.export(exports, "Trees", ()=>(0, _treesJsDefault.default));
parcelHelpers.export(exports, "TreesIcon", ()=>(0, _treesJsDefault.default));
parcelHelpers.export(exports, "LucideTrello", ()=>(0, _trelloJsDefault.default));
parcelHelpers.export(exports, "Trello", ()=>(0, _trelloJsDefault.default));
parcelHelpers.export(exports, "TrelloIcon", ()=>(0, _trelloJsDefault.default));
parcelHelpers.export(exports, "LucideTrendingDown", ()=>(0, _trendingDownJsDefault.default));
parcelHelpers.export(exports, "TrendingDown", ()=>(0, _trendingDownJsDefault.default));
parcelHelpers.export(exports, "TrendingDownIcon", ()=>(0, _trendingDownJsDefault.default));
parcelHelpers.export(exports, "LucideTrendingUp", ()=>(0, _trendingUpJsDefault.default));
parcelHelpers.export(exports, "TrendingUp", ()=>(0, _trendingUpJsDefault.default));
parcelHelpers.export(exports, "TrendingUpIcon", ()=>(0, _trendingUpJsDefault.default));
parcelHelpers.export(exports, "LucideTriangleRight", ()=>(0, _triangleRightJsDefault.default));
parcelHelpers.export(exports, "TriangleRight", ()=>(0, _triangleRightJsDefault.default));
parcelHelpers.export(exports, "TriangleRightIcon", ()=>(0, _triangleRightJsDefault.default));
parcelHelpers.export(exports, "LucideTriangle", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "Triangle", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "TriangleIcon", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "LucideTrophy", ()=>(0, _trophyJsDefault.default));
parcelHelpers.export(exports, "Trophy", ()=>(0, _trophyJsDefault.default));
parcelHelpers.export(exports, "TrophyIcon", ()=>(0, _trophyJsDefault.default));
parcelHelpers.export(exports, "LucideTruck", ()=>(0, _truckJsDefault.default));
parcelHelpers.export(exports, "Truck", ()=>(0, _truckJsDefault.default));
parcelHelpers.export(exports, "TruckIcon", ()=>(0, _truckJsDefault.default));
parcelHelpers.export(exports, "LucideTurtle", ()=>(0, _turtleJsDefault.default));
parcelHelpers.export(exports, "Turtle", ()=>(0, _turtleJsDefault.default));
parcelHelpers.export(exports, "TurtleIcon", ()=>(0, _turtleJsDefault.default));
parcelHelpers.export(exports, "LucideTv2", ()=>(0, _tv2JsDefault.default));
parcelHelpers.export(exports, "Tv2", ()=>(0, _tv2JsDefault.default));
parcelHelpers.export(exports, "Tv2Icon", ()=>(0, _tv2JsDefault.default));
parcelHelpers.export(exports, "LucideTv", ()=>(0, _tvJsDefault.default));
parcelHelpers.export(exports, "Tv", ()=>(0, _tvJsDefault.default));
parcelHelpers.export(exports, "TvIcon", ()=>(0, _tvJsDefault.default));
parcelHelpers.export(exports, "LucideTwitch", ()=>(0, _twitchJsDefault.default));
parcelHelpers.export(exports, "Twitch", ()=>(0, _twitchJsDefault.default));
parcelHelpers.export(exports, "TwitchIcon", ()=>(0, _twitchJsDefault.default));
parcelHelpers.export(exports, "LucideTwitter", ()=>(0, _twitterJsDefault.default));
parcelHelpers.export(exports, "Twitter", ()=>(0, _twitterJsDefault.default));
parcelHelpers.export(exports, "TwitterIcon", ()=>(0, _twitterJsDefault.default));
parcelHelpers.export(exports, "LucideType", ()=>(0, _typeJsDefault.default));
parcelHelpers.export(exports, "Type", ()=>(0, _typeJsDefault.default));
parcelHelpers.export(exports, "TypeIcon", ()=>(0, _typeJsDefault.default));
parcelHelpers.export(exports, "LucideUmbrellaOff", ()=>(0, _umbrellaOffJsDefault.default));
parcelHelpers.export(exports, "UmbrellaOff", ()=>(0, _umbrellaOffJsDefault.default));
parcelHelpers.export(exports, "UmbrellaOffIcon", ()=>(0, _umbrellaOffJsDefault.default));
parcelHelpers.export(exports, "LucideUmbrella", ()=>(0, _umbrellaJsDefault.default));
parcelHelpers.export(exports, "Umbrella", ()=>(0, _umbrellaJsDefault.default));
parcelHelpers.export(exports, "UmbrellaIcon", ()=>(0, _umbrellaJsDefault.default));
parcelHelpers.export(exports, "LucideUnderline", ()=>(0, _underlineJsDefault.default));
parcelHelpers.export(exports, "Underline", ()=>(0, _underlineJsDefault.default));
parcelHelpers.export(exports, "UnderlineIcon", ()=>(0, _underlineJsDefault.default));
parcelHelpers.export(exports, "LucideUndo2", ()=>(0, _undo2JsDefault.default));
parcelHelpers.export(exports, "Undo2", ()=>(0, _undo2JsDefault.default));
parcelHelpers.export(exports, "Undo2Icon", ()=>(0, _undo2JsDefault.default));
parcelHelpers.export(exports, "LucideUndoDot", ()=>(0, _undoDotJsDefault.default));
parcelHelpers.export(exports, "UndoDot", ()=>(0, _undoDotJsDefault.default));
parcelHelpers.export(exports, "UndoDotIcon", ()=>(0, _undoDotJsDefault.default));
parcelHelpers.export(exports, "LucideUndo", ()=>(0, _undoJsDefault.default));
parcelHelpers.export(exports, "Undo", ()=>(0, _undoJsDefault.default));
parcelHelpers.export(exports, "UndoIcon", ()=>(0, _undoJsDefault.default));
parcelHelpers.export(exports, "LucideUnfoldHorizontal", ()=>(0, _unfoldHorizontalJsDefault.default));
parcelHelpers.export(exports, "UnfoldHorizontal", ()=>(0, _unfoldHorizontalJsDefault.default));
parcelHelpers.export(exports, "UnfoldHorizontalIcon", ()=>(0, _unfoldHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideUnfoldVertical", ()=>(0, _unfoldVerticalJsDefault.default));
parcelHelpers.export(exports, "UnfoldVertical", ()=>(0, _unfoldVerticalJsDefault.default));
parcelHelpers.export(exports, "UnfoldVerticalIcon", ()=>(0, _unfoldVerticalJsDefault.default));
parcelHelpers.export(exports, "LucideUngroup", ()=>(0, _ungroupJsDefault.default));
parcelHelpers.export(exports, "Ungroup", ()=>(0, _ungroupJsDefault.default));
parcelHelpers.export(exports, "UngroupIcon", ()=>(0, _ungroupJsDefault.default));
parcelHelpers.export(exports, "LucideUnlink2", ()=>(0, _unlink2JsDefault.default));
parcelHelpers.export(exports, "Unlink2", ()=>(0, _unlink2JsDefault.default));
parcelHelpers.export(exports, "Unlink2Icon", ()=>(0, _unlink2JsDefault.default));
parcelHelpers.export(exports, "LucideUnlink", ()=>(0, _unlinkJsDefault.default));
parcelHelpers.export(exports, "Unlink", ()=>(0, _unlinkJsDefault.default));
parcelHelpers.export(exports, "UnlinkIcon", ()=>(0, _unlinkJsDefault.default));
parcelHelpers.export(exports, "LucideUnlockKeyhole", ()=>(0, _unlockKeyholeJsDefault.default));
parcelHelpers.export(exports, "UnlockKeyhole", ()=>(0, _unlockKeyholeJsDefault.default));
parcelHelpers.export(exports, "UnlockKeyholeIcon", ()=>(0, _unlockKeyholeJsDefault.default));
parcelHelpers.export(exports, "LucideUnlock", ()=>(0, _unlockJsDefault.default));
parcelHelpers.export(exports, "Unlock", ()=>(0, _unlockJsDefault.default));
parcelHelpers.export(exports, "UnlockIcon", ()=>(0, _unlockJsDefault.default));
parcelHelpers.export(exports, "LucideUnplug", ()=>(0, _unplugJsDefault.default));
parcelHelpers.export(exports, "Unplug", ()=>(0, _unplugJsDefault.default));
parcelHelpers.export(exports, "UnplugIcon", ()=>(0, _unplugJsDefault.default));
parcelHelpers.export(exports, "LucideUploadCloud", ()=>(0, _uploadCloudJsDefault.default));
parcelHelpers.export(exports, "UploadCloud", ()=>(0, _uploadCloudJsDefault.default));
parcelHelpers.export(exports, "UploadCloudIcon", ()=>(0, _uploadCloudJsDefault.default));
parcelHelpers.export(exports, "LucideUpload", ()=>(0, _uploadJsDefault.default));
parcelHelpers.export(exports, "Upload", ()=>(0, _uploadJsDefault.default));
parcelHelpers.export(exports, "UploadIcon", ()=>(0, _uploadJsDefault.default));
parcelHelpers.export(exports, "LucideUsb", ()=>(0, _usbJsDefault.default));
parcelHelpers.export(exports, "Usb", ()=>(0, _usbJsDefault.default));
parcelHelpers.export(exports, "UsbIcon", ()=>(0, _usbJsDefault.default));
parcelHelpers.export(exports, "LucideUserCheck", ()=>(0, _userCheckJsDefault.default));
parcelHelpers.export(exports, "UserCheck", ()=>(0, _userCheckJsDefault.default));
parcelHelpers.export(exports, "UserCheckIcon", ()=>(0, _userCheckJsDefault.default));
parcelHelpers.export(exports, "LucideUserCog", ()=>(0, _userCogJsDefault.default));
parcelHelpers.export(exports, "UserCog", ()=>(0, _userCogJsDefault.default));
parcelHelpers.export(exports, "UserCogIcon", ()=>(0, _userCogJsDefault.default));
parcelHelpers.export(exports, "LucideUserMinus", ()=>(0, _userMinusJsDefault.default));
parcelHelpers.export(exports, "UserMinus", ()=>(0, _userMinusJsDefault.default));
parcelHelpers.export(exports, "UserMinusIcon", ()=>(0, _userMinusJsDefault.default));
parcelHelpers.export(exports, "LucideUserPlus", ()=>(0, _userPlusJsDefault.default));
parcelHelpers.export(exports, "UserPlus", ()=>(0, _userPlusJsDefault.default));
parcelHelpers.export(exports, "UserPlusIcon", ()=>(0, _userPlusJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundSearch", ()=>(0, _userRoundSearchJsDefault.default));
parcelHelpers.export(exports, "UserRoundSearch", ()=>(0, _userRoundSearchJsDefault.default));
parcelHelpers.export(exports, "UserRoundSearchIcon", ()=>(0, _userRoundSearchJsDefault.default));
parcelHelpers.export(exports, "LucideUserSearch", ()=>(0, _userSearchJsDefault.default));
parcelHelpers.export(exports, "UserSearch", ()=>(0, _userSearchJsDefault.default));
parcelHelpers.export(exports, "UserSearchIcon", ()=>(0, _userSearchJsDefault.default));
parcelHelpers.export(exports, "LucideUserX", ()=>(0, _userXJsDefault.default));
parcelHelpers.export(exports, "UserX", ()=>(0, _userXJsDefault.default));
parcelHelpers.export(exports, "UserXIcon", ()=>(0, _userXJsDefault.default));
parcelHelpers.export(exports, "LucideUser", ()=>(0, _userJsDefault.default));
parcelHelpers.export(exports, "User", ()=>(0, _userJsDefault.default));
parcelHelpers.export(exports, "UserIcon", ()=>(0, _userJsDefault.default));
parcelHelpers.export(exports, "LucideUsers", ()=>(0, _usersJsDefault.default));
parcelHelpers.export(exports, "Users", ()=>(0, _usersJsDefault.default));
parcelHelpers.export(exports, "UsersIcon", ()=>(0, _usersJsDefault.default));
parcelHelpers.export(exports, "LucideUtensilsCrossed", ()=>(0, _utensilsCrossedJsDefault.default));
parcelHelpers.export(exports, "UtensilsCrossed", ()=>(0, _utensilsCrossedJsDefault.default));
parcelHelpers.export(exports, "UtensilsCrossedIcon", ()=>(0, _utensilsCrossedJsDefault.default));
parcelHelpers.export(exports, "LucideUtensils", ()=>(0, _utensilsJsDefault.default));
parcelHelpers.export(exports, "Utensils", ()=>(0, _utensilsJsDefault.default));
parcelHelpers.export(exports, "UtensilsIcon", ()=>(0, _utensilsJsDefault.default));
parcelHelpers.export(exports, "LucideUtilityPole", ()=>(0, _utilityPoleJsDefault.default));
parcelHelpers.export(exports, "UtilityPole", ()=>(0, _utilityPoleJsDefault.default));
parcelHelpers.export(exports, "UtilityPoleIcon", ()=>(0, _utilityPoleJsDefault.default));
parcelHelpers.export(exports, "LucideVariable", ()=>(0, _variableJsDefault.default));
parcelHelpers.export(exports, "Variable", ()=>(0, _variableJsDefault.default));
parcelHelpers.export(exports, "VariableIcon", ()=>(0, _variableJsDefault.default));
parcelHelpers.export(exports, "LucideVault", ()=>(0, _vaultJsDefault.default));
parcelHelpers.export(exports, "Vault", ()=>(0, _vaultJsDefault.default));
parcelHelpers.export(exports, "VaultIcon", ()=>(0, _vaultJsDefault.default));
parcelHelpers.export(exports, "LucideVegan", ()=>(0, _veganJsDefault.default));
parcelHelpers.export(exports, "Vegan", ()=>(0, _veganJsDefault.default));
parcelHelpers.export(exports, "VeganIcon", ()=>(0, _veganJsDefault.default));
parcelHelpers.export(exports, "LucideVenetianMask", ()=>(0, _venetianMaskJsDefault.default));
parcelHelpers.export(exports, "VenetianMask", ()=>(0, _venetianMaskJsDefault.default));
parcelHelpers.export(exports, "VenetianMaskIcon", ()=>(0, _venetianMaskJsDefault.default));
parcelHelpers.export(exports, "LucideVibrateOff", ()=>(0, _vibrateOffJsDefault.default));
parcelHelpers.export(exports, "VibrateOff", ()=>(0, _vibrateOffJsDefault.default));
parcelHelpers.export(exports, "VibrateOffIcon", ()=>(0, _vibrateOffJsDefault.default));
parcelHelpers.export(exports, "LucideVibrate", ()=>(0, _vibrateJsDefault.default));
parcelHelpers.export(exports, "Vibrate", ()=>(0, _vibrateJsDefault.default));
parcelHelpers.export(exports, "VibrateIcon", ()=>(0, _vibrateJsDefault.default));
parcelHelpers.export(exports, "LucideVideoOff", ()=>(0, _videoOffJsDefault.default));
parcelHelpers.export(exports, "VideoOff", ()=>(0, _videoOffJsDefault.default));
parcelHelpers.export(exports, "VideoOffIcon", ()=>(0, _videoOffJsDefault.default));
parcelHelpers.export(exports, "LucideVideo", ()=>(0, _videoJsDefault.default));
parcelHelpers.export(exports, "Video", ()=>(0, _videoJsDefault.default));
parcelHelpers.export(exports, "VideoIcon", ()=>(0, _videoJsDefault.default));
parcelHelpers.export(exports, "LucideVideotape", ()=>(0, _videotapeJsDefault.default));
parcelHelpers.export(exports, "Videotape", ()=>(0, _videotapeJsDefault.default));
parcelHelpers.export(exports, "VideotapeIcon", ()=>(0, _videotapeJsDefault.default));
parcelHelpers.export(exports, "LucideView", ()=>(0, _viewJsDefault.default));
parcelHelpers.export(exports, "View", ()=>(0, _viewJsDefault.default));
parcelHelpers.export(exports, "ViewIcon", ()=>(0, _viewJsDefault.default));
parcelHelpers.export(exports, "LucideVoicemail", ()=>(0, _voicemailJsDefault.default));
parcelHelpers.export(exports, "Voicemail", ()=>(0, _voicemailJsDefault.default));
parcelHelpers.export(exports, "VoicemailIcon", ()=>(0, _voicemailJsDefault.default));
parcelHelpers.export(exports, "LucideVolume1", ()=>(0, _volume1JsDefault.default));
parcelHelpers.export(exports, "Volume1", ()=>(0, _volume1JsDefault.default));
parcelHelpers.export(exports, "Volume1Icon", ()=>(0, _volume1JsDefault.default));
parcelHelpers.export(exports, "LucideVolume2", ()=>(0, _volume2JsDefault.default));
parcelHelpers.export(exports, "Volume2", ()=>(0, _volume2JsDefault.default));
parcelHelpers.export(exports, "Volume2Icon", ()=>(0, _volume2JsDefault.default));
parcelHelpers.export(exports, "LucideVolumeX", ()=>(0, _volumeXJsDefault.default));
parcelHelpers.export(exports, "VolumeX", ()=>(0, _volumeXJsDefault.default));
parcelHelpers.export(exports, "VolumeXIcon", ()=>(0, _volumeXJsDefault.default));
parcelHelpers.export(exports, "LucideVolume", ()=>(0, _volumeJsDefault.default));
parcelHelpers.export(exports, "Volume", ()=>(0, _volumeJsDefault.default));
parcelHelpers.export(exports, "VolumeIcon", ()=>(0, _volumeJsDefault.default));
parcelHelpers.export(exports, "LucideVote", ()=>(0, _voteJsDefault.default));
parcelHelpers.export(exports, "Vote", ()=>(0, _voteJsDefault.default));
parcelHelpers.export(exports, "VoteIcon", ()=>(0, _voteJsDefault.default));
parcelHelpers.export(exports, "LucideWallet2", ()=>(0, _wallet2JsDefault.default));
parcelHelpers.export(exports, "Wallet2", ()=>(0, _wallet2JsDefault.default));
parcelHelpers.export(exports, "Wallet2Icon", ()=>(0, _wallet2JsDefault.default));
parcelHelpers.export(exports, "LucideWalletCards", ()=>(0, _walletCardsJsDefault.default));
parcelHelpers.export(exports, "WalletCards", ()=>(0, _walletCardsJsDefault.default));
parcelHelpers.export(exports, "WalletCardsIcon", ()=>(0, _walletCardsJsDefault.default));
parcelHelpers.export(exports, "LucideWallet", ()=>(0, _walletJsDefault.default));
parcelHelpers.export(exports, "Wallet", ()=>(0, _walletJsDefault.default));
parcelHelpers.export(exports, "WalletIcon", ()=>(0, _walletJsDefault.default));
parcelHelpers.export(exports, "LucideWallpaper", ()=>(0, _wallpaperJsDefault.default));
parcelHelpers.export(exports, "Wallpaper", ()=>(0, _wallpaperJsDefault.default));
parcelHelpers.export(exports, "WallpaperIcon", ()=>(0, _wallpaperJsDefault.default));
parcelHelpers.export(exports, "LucideWand2", ()=>(0, _wand2JsDefault.default));
parcelHelpers.export(exports, "Wand2", ()=>(0, _wand2JsDefault.default));
parcelHelpers.export(exports, "Wand2Icon", ()=>(0, _wand2JsDefault.default));
parcelHelpers.export(exports, "LucideWand", ()=>(0, _wandJsDefault.default));
parcelHelpers.export(exports, "Wand", ()=>(0, _wandJsDefault.default));
parcelHelpers.export(exports, "WandIcon", ()=>(0, _wandJsDefault.default));
parcelHelpers.export(exports, "LucideWarehouse", ()=>(0, _warehouseJsDefault.default));
parcelHelpers.export(exports, "Warehouse", ()=>(0, _warehouseJsDefault.default));
parcelHelpers.export(exports, "WarehouseIcon", ()=>(0, _warehouseJsDefault.default));
parcelHelpers.export(exports, "LucideWashingMachine", ()=>(0, _washingMachineJsDefault.default));
parcelHelpers.export(exports, "WashingMachine", ()=>(0, _washingMachineJsDefault.default));
parcelHelpers.export(exports, "WashingMachineIcon", ()=>(0, _washingMachineJsDefault.default));
parcelHelpers.export(exports, "LucideWatch", ()=>(0, _watchJsDefault.default));
parcelHelpers.export(exports, "Watch", ()=>(0, _watchJsDefault.default));
parcelHelpers.export(exports, "WatchIcon", ()=>(0, _watchJsDefault.default));
parcelHelpers.export(exports, "LucideWaves", ()=>(0, _wavesJsDefault.default));
parcelHelpers.export(exports, "Waves", ()=>(0, _wavesJsDefault.default));
parcelHelpers.export(exports, "WavesIcon", ()=>(0, _wavesJsDefault.default));
parcelHelpers.export(exports, "LucideWaypoints", ()=>(0, _waypointsJsDefault.default));
parcelHelpers.export(exports, "Waypoints", ()=>(0, _waypointsJsDefault.default));
parcelHelpers.export(exports, "WaypointsIcon", ()=>(0, _waypointsJsDefault.default));
parcelHelpers.export(exports, "LucideWebcam", ()=>(0, _webcamJsDefault.default));
parcelHelpers.export(exports, "Webcam", ()=>(0, _webcamJsDefault.default));
parcelHelpers.export(exports, "WebcamIcon", ()=>(0, _webcamJsDefault.default));
parcelHelpers.export(exports, "LucideWebhookOff", ()=>(0, _webhookOffJsDefault.default));
parcelHelpers.export(exports, "WebhookOff", ()=>(0, _webhookOffJsDefault.default));
parcelHelpers.export(exports, "WebhookOffIcon", ()=>(0, _webhookOffJsDefault.default));
parcelHelpers.export(exports, "LucideWebhook", ()=>(0, _webhookJsDefault.default));
parcelHelpers.export(exports, "Webhook", ()=>(0, _webhookJsDefault.default));
parcelHelpers.export(exports, "WebhookIcon", ()=>(0, _webhookJsDefault.default));
parcelHelpers.export(exports, "LucideWeight", ()=>(0, _weightJsDefault.default));
parcelHelpers.export(exports, "Weight", ()=>(0, _weightJsDefault.default));
parcelHelpers.export(exports, "WeightIcon", ()=>(0, _weightJsDefault.default));
parcelHelpers.export(exports, "LucideWheatOff", ()=>(0, _wheatOffJsDefault.default));
parcelHelpers.export(exports, "WheatOff", ()=>(0, _wheatOffJsDefault.default));
parcelHelpers.export(exports, "WheatOffIcon", ()=>(0, _wheatOffJsDefault.default));
parcelHelpers.export(exports, "LucideWheat", ()=>(0, _wheatJsDefault.default));
parcelHelpers.export(exports, "Wheat", ()=>(0, _wheatJsDefault.default));
parcelHelpers.export(exports, "WheatIcon", ()=>(0, _wheatJsDefault.default));
parcelHelpers.export(exports, "LucideWholeWord", ()=>(0, _wholeWordJsDefault.default));
parcelHelpers.export(exports, "WholeWord", ()=>(0, _wholeWordJsDefault.default));
parcelHelpers.export(exports, "WholeWordIcon", ()=>(0, _wholeWordJsDefault.default));
parcelHelpers.export(exports, "LucideWifiOff", ()=>(0, _wifiOffJsDefault.default));
parcelHelpers.export(exports, "WifiOff", ()=>(0, _wifiOffJsDefault.default));
parcelHelpers.export(exports, "WifiOffIcon", ()=>(0, _wifiOffJsDefault.default));
parcelHelpers.export(exports, "LucideWifi", ()=>(0, _wifiJsDefault.default));
parcelHelpers.export(exports, "Wifi", ()=>(0, _wifiJsDefault.default));
parcelHelpers.export(exports, "WifiIcon", ()=>(0, _wifiJsDefault.default));
parcelHelpers.export(exports, "LucideWind", ()=>(0, _windJsDefault.default));
parcelHelpers.export(exports, "Wind", ()=>(0, _windJsDefault.default));
parcelHelpers.export(exports, "WindIcon", ()=>(0, _windJsDefault.default));
parcelHelpers.export(exports, "LucideWineOff", ()=>(0, _wineOffJsDefault.default));
parcelHelpers.export(exports, "WineOff", ()=>(0, _wineOffJsDefault.default));
parcelHelpers.export(exports, "WineOffIcon", ()=>(0, _wineOffJsDefault.default));
parcelHelpers.export(exports, "LucideWine", ()=>(0, _wineJsDefault.default));
parcelHelpers.export(exports, "Wine", ()=>(0, _wineJsDefault.default));
parcelHelpers.export(exports, "WineIcon", ()=>(0, _wineJsDefault.default));
parcelHelpers.export(exports, "LucideWorkflow", ()=>(0, _workflowJsDefault.default));
parcelHelpers.export(exports, "Workflow", ()=>(0, _workflowJsDefault.default));
parcelHelpers.export(exports, "WorkflowIcon", ()=>(0, _workflowJsDefault.default));
parcelHelpers.export(exports, "LucideWrapText", ()=>(0, _wrapTextJsDefault.default));
parcelHelpers.export(exports, "WrapText", ()=>(0, _wrapTextJsDefault.default));
parcelHelpers.export(exports, "WrapTextIcon", ()=>(0, _wrapTextJsDefault.default));
parcelHelpers.export(exports, "LucideWrench", ()=>(0, _wrenchJsDefault.default));
parcelHelpers.export(exports, "Wrench", ()=>(0, _wrenchJsDefault.default));
parcelHelpers.export(exports, "WrenchIcon", ()=>(0, _wrenchJsDefault.default));
parcelHelpers.export(exports, "LucideXCircle", ()=>(0, _xCircleJsDefault.default));
parcelHelpers.export(exports, "XCircle", ()=>(0, _xCircleJsDefault.default));
parcelHelpers.export(exports, "XCircleIcon", ()=>(0, _xCircleJsDefault.default));
parcelHelpers.export(exports, "LucideXOctagon", ()=>(0, _xOctagonJsDefault.default));
parcelHelpers.export(exports, "XOctagon", ()=>(0, _xOctagonJsDefault.default));
parcelHelpers.export(exports, "XOctagonIcon", ()=>(0, _xOctagonJsDefault.default));
parcelHelpers.export(exports, "LucideXSquare", ()=>(0, _xSquareJsDefault.default));
parcelHelpers.export(exports, "XSquare", ()=>(0, _xSquareJsDefault.default));
parcelHelpers.export(exports, "XSquareIcon", ()=>(0, _xSquareJsDefault.default));
parcelHelpers.export(exports, "LucideX", ()=>(0, _xJsDefault.default));
parcelHelpers.export(exports, "X", ()=>(0, _xJsDefault.default));
parcelHelpers.export(exports, "XIcon", ()=>(0, _xJsDefault.default));
parcelHelpers.export(exports, "LucideYoutube", ()=>(0, _youtubeJsDefault.default));
parcelHelpers.export(exports, "Youtube", ()=>(0, _youtubeJsDefault.default));
parcelHelpers.export(exports, "YoutubeIcon", ()=>(0, _youtubeJsDefault.default));
parcelHelpers.export(exports, "LucideZapOff", ()=>(0, _zapOffJsDefault.default));
parcelHelpers.export(exports, "ZapOff", ()=>(0, _zapOffJsDefault.default));
parcelHelpers.export(exports, "ZapOffIcon", ()=>(0, _zapOffJsDefault.default));
parcelHelpers.export(exports, "LucideZap", ()=>(0, _zapJsDefault.default));
parcelHelpers.export(exports, "Zap", ()=>(0, _zapJsDefault.default));
parcelHelpers.export(exports, "ZapIcon", ()=>(0, _zapJsDefault.default));
parcelHelpers.export(exports, "LucideZoomIn", ()=>(0, _zoomInJsDefault.default));
parcelHelpers.export(exports, "ZoomIn", ()=>(0, _zoomInJsDefault.default));
parcelHelpers.export(exports, "ZoomInIcon", ()=>(0, _zoomInJsDefault.default));
parcelHelpers.export(exports, "LucideZoomOut", ()=>(0, _zoomOutJsDefault.default));
parcelHelpers.export(exports, "ZoomOut", ()=>(0, _zoomOutJsDefault.default));
parcelHelpers.export(exports, "ZoomOutIcon", ()=>(0, _zoomOutJsDefault.default));
parcelHelpers.export(exports, "AlarmCheck", ()=>(0, _alarmClockCheckJsDefault.default));
parcelHelpers.export(exports, "AlarmCheckIcon", ()=>(0, _alarmClockCheckJsDefault.default));
parcelHelpers.export(exports, "AlarmClockCheck", ()=>(0, _alarmClockCheckJsDefault.default));
parcelHelpers.export(exports, "AlarmClockCheckIcon", ()=>(0, _alarmClockCheckJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmCheck", ()=>(0, _alarmClockCheckJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmClockCheck", ()=>(0, _alarmClockCheckJsDefault.default));
parcelHelpers.export(exports, "AlarmClockMinus", ()=>(0, _alarmClockMinusJsDefault.default));
parcelHelpers.export(exports, "AlarmClockMinusIcon", ()=>(0, _alarmClockMinusJsDefault.default));
parcelHelpers.export(exports, "AlarmMinus", ()=>(0, _alarmClockMinusJsDefault.default));
parcelHelpers.export(exports, "AlarmMinusIcon", ()=>(0, _alarmClockMinusJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmClockMinus", ()=>(0, _alarmClockMinusJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmMinus", ()=>(0, _alarmClockMinusJsDefault.default));
parcelHelpers.export(exports, "AlarmClockPlus", ()=>(0, _alarmClockPlusJsDefault.default));
parcelHelpers.export(exports, "AlarmClockPlusIcon", ()=>(0, _alarmClockPlusJsDefault.default));
parcelHelpers.export(exports, "AlarmPlus", ()=>(0, _alarmClockPlusJsDefault.default));
parcelHelpers.export(exports, "AlarmPlusIcon", ()=>(0, _alarmClockPlusJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmClockPlus", ()=>(0, _alarmClockPlusJsDefault.default));
parcelHelpers.export(exports, "LucideAlarmPlus", ()=>(0, _alarmClockPlusJsDefault.default));
parcelHelpers.export(exports, "ArrowDown01", ()=>(0, _arrowDown01JsDefault.default));
parcelHelpers.export(exports, "ArrowDown01Icon", ()=>(0, _arrowDown01JsDefault.default));
parcelHelpers.export(exports, "LucideArrowDown01", ()=>(0, _arrowDown01JsDefault.default));
parcelHelpers.export(exports, "ArrowDown10", ()=>(0, _arrowDown10JsDefault.default));
parcelHelpers.export(exports, "ArrowDown10Icon", ()=>(0, _arrowDown10JsDefault.default));
parcelHelpers.export(exports, "LucideArrowDown10", ()=>(0, _arrowDown10JsDefault.default));
parcelHelpers.export(exports, "ArrowDownAZ", ()=>(0, _arrowDownAZJsDefault.default));
parcelHelpers.export(exports, "ArrowDownAZIcon", ()=>(0, _arrowDownAZJsDefault.default));
parcelHelpers.export(exports, "ArrowDownAz", ()=>(0, _arrowDownAZJsDefault.default));
parcelHelpers.export(exports, "ArrowDownAzIcon", ()=>(0, _arrowDownAZJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownAZ", ()=>(0, _arrowDownAZJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownAz", ()=>(0, _arrowDownAZJsDefault.default));
parcelHelpers.export(exports, "ArrowDownWideNarrow", ()=>(0, _arrowDownWideNarrowJsDefault.default));
parcelHelpers.export(exports, "ArrowDownWideNarrowIcon", ()=>(0, _arrowDownWideNarrowJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownWideNarrow", ()=>(0, _arrowDownWideNarrowJsDefault.default));
parcelHelpers.export(exports, "LucideSortDesc", ()=>(0, _arrowDownWideNarrowJsDefault.default));
parcelHelpers.export(exports, "SortDesc", ()=>(0, _arrowDownWideNarrowJsDefault.default));
parcelHelpers.export(exports, "SortDescIcon", ()=>(0, _arrowDownWideNarrowJsDefault.default));
parcelHelpers.export(exports, "ArrowDownZA", ()=>(0, _arrowDownZAJsDefault.default));
parcelHelpers.export(exports, "ArrowDownZAIcon", ()=>(0, _arrowDownZAJsDefault.default));
parcelHelpers.export(exports, "ArrowDownZa", ()=>(0, _arrowDownZAJsDefault.default));
parcelHelpers.export(exports, "ArrowDownZaIcon", ()=>(0, _arrowDownZAJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownZA", ()=>(0, _arrowDownZAJsDefault.default));
parcelHelpers.export(exports, "LucideArrowDownZa", ()=>(0, _arrowDownZAJsDefault.default));
parcelHelpers.export(exports, "ArrowUp01", ()=>(0, _arrowUp01JsDefault.default));
parcelHelpers.export(exports, "ArrowUp01Icon", ()=>(0, _arrowUp01JsDefault.default));
parcelHelpers.export(exports, "LucideArrowUp01", ()=>(0, _arrowUp01JsDefault.default));
parcelHelpers.export(exports, "ArrowUp10", ()=>(0, _arrowUp10JsDefault.default));
parcelHelpers.export(exports, "ArrowUp10Icon", ()=>(0, _arrowUp10JsDefault.default));
parcelHelpers.export(exports, "LucideArrowUp10", ()=>(0, _arrowUp10JsDefault.default));
parcelHelpers.export(exports, "ArrowUpAZ", ()=>(0, _arrowUpAZJsDefault.default));
parcelHelpers.export(exports, "ArrowUpAZIcon", ()=>(0, _arrowUpAZJsDefault.default));
parcelHelpers.export(exports, "ArrowUpAz", ()=>(0, _arrowUpAZJsDefault.default));
parcelHelpers.export(exports, "ArrowUpAzIcon", ()=>(0, _arrowUpAZJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpAZ", ()=>(0, _arrowUpAZJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpAz", ()=>(0, _arrowUpAZJsDefault.default));
parcelHelpers.export(exports, "ArrowUpNarrowWide", ()=>(0, _arrowUpNarrowWideJsDefault.default));
parcelHelpers.export(exports, "ArrowUpNarrowWideIcon", ()=>(0, _arrowUpNarrowWideJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpNarrowWide", ()=>(0, _arrowUpNarrowWideJsDefault.default));
parcelHelpers.export(exports, "LucideSortAsc", ()=>(0, _arrowUpNarrowWideJsDefault.default));
parcelHelpers.export(exports, "SortAsc", ()=>(0, _arrowUpNarrowWideJsDefault.default));
parcelHelpers.export(exports, "SortAscIcon", ()=>(0, _arrowUpNarrowWideJsDefault.default));
parcelHelpers.export(exports, "ArrowUpZA", ()=>(0, _arrowUpZAJsDefault.default));
parcelHelpers.export(exports, "ArrowUpZAIcon", ()=>(0, _arrowUpZAJsDefault.default));
parcelHelpers.export(exports, "ArrowUpZa", ()=>(0, _arrowUpZAJsDefault.default));
parcelHelpers.export(exports, "ArrowUpZaIcon", ()=>(0, _arrowUpZAJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpZA", ()=>(0, _arrowUpZAJsDefault.default));
parcelHelpers.export(exports, "LucideArrowUpZa", ()=>(0, _arrowUpZAJsDefault.default));
parcelHelpers.export(exports, "AsteriskSquare", ()=>(0, _asteriskSquareJsDefault.default));
parcelHelpers.export(exports, "AsteriskSquareIcon", ()=>(0, _asteriskSquareJsDefault.default));
parcelHelpers.export(exports, "LucideAsteriskSquare", ()=>(0, _asteriskSquareJsDefault.default));
parcelHelpers.export(exports, "LucideSquareAsterisk", ()=>(0, _asteriskSquareJsDefault.default));
parcelHelpers.export(exports, "SquareAsterisk", ()=>(0, _asteriskSquareJsDefault.default));
parcelHelpers.export(exports, "SquareAsteriskIcon", ()=>(0, _asteriskSquareJsDefault.default));
parcelHelpers.export(exports, "BadgeCheck", ()=>(0, _badgeCheckJsDefault.default));
parcelHelpers.export(exports, "BadgeCheckIcon", ()=>(0, _badgeCheckJsDefault.default));
parcelHelpers.export(exports, "LucideBadgeCheck", ()=>(0, _badgeCheckJsDefault.default));
parcelHelpers.export(exports, "LucideVerified", ()=>(0, _badgeCheckJsDefault.default));
parcelHelpers.export(exports, "Verified", ()=>(0, _badgeCheckJsDefault.default));
parcelHelpers.export(exports, "VerifiedIcon", ()=>(0, _badgeCheckJsDefault.default));
parcelHelpers.export(exports, "Axis3D", ()=>(0, _axis3DJsDefault.default));
parcelHelpers.export(exports, "Axis3DIcon", ()=>(0, _axis3DJsDefault.default));
parcelHelpers.export(exports, "Axis3d", ()=>(0, _axis3DJsDefault.default));
parcelHelpers.export(exports, "Axis3dIcon", ()=>(0, _axis3DJsDefault.default));
parcelHelpers.export(exports, "LucideAxis3D", ()=>(0, _axis3DJsDefault.default));
parcelHelpers.export(exports, "LucideAxis3d", ()=>(0, _axis3DJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizonalEnd", ()=>(0, _betweenHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizonalEndIcon", ()=>(0, _betweenHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizontalEnd", ()=>(0, _betweenHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizontalEndIcon", ()=>(0, _betweenHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "LucideBetweenHorizonalEnd", ()=>(0, _betweenHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "LucideBetweenHorizontalEnd", ()=>(0, _betweenHorizontalEndJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizonalStart", ()=>(0, _betweenHorizontalStartJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizonalStartIcon", ()=>(0, _betweenHorizontalStartJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizontalStart", ()=>(0, _betweenHorizontalStartJsDefault.default));
parcelHelpers.export(exports, "BetweenHorizontalStartIcon", ()=>(0, _betweenHorizontalStartJsDefault.default));
parcelHelpers.export(exports, "LucideBetweenHorizonalStart", ()=>(0, _betweenHorizontalStartJsDefault.default));
parcelHelpers.export(exports, "LucideBetweenHorizontalStart", ()=>(0, _betweenHorizontalStartJsDefault.default));
parcelHelpers.export(exports, "BookDashed", ()=>(0, _bookDashedJsDefault.default));
parcelHelpers.export(exports, "BookDashedIcon", ()=>(0, _bookDashedJsDefault.default));
parcelHelpers.export(exports, "BookTemplate", ()=>(0, _bookDashedJsDefault.default));
parcelHelpers.export(exports, "BookTemplateIcon", ()=>(0, _bookDashedJsDefault.default));
parcelHelpers.export(exports, "LucideBookDashed", ()=>(0, _bookDashedJsDefault.default));
parcelHelpers.export(exports, "LucideBookTemplate", ()=>(0, _bookDashedJsDefault.default));
parcelHelpers.export(exports, "Braces", ()=>(0, _bracesJsDefault.default));
parcelHelpers.export(exports, "BracesIcon", ()=>(0, _bracesJsDefault.default));
parcelHelpers.export(exports, "CurlyBraces", ()=>(0, _bracesJsDefault.default));
parcelHelpers.export(exports, "CurlyBracesIcon", ()=>(0, _bracesJsDefault.default));
parcelHelpers.export(exports, "LucideBraces", ()=>(0, _bracesJsDefault.default));
parcelHelpers.export(exports, "LucideCurlyBraces", ()=>(0, _bracesJsDefault.default));
parcelHelpers.export(exports, "Captions", ()=>(0, _captionsJsDefault.default));
parcelHelpers.export(exports, "CaptionsIcon", ()=>(0, _captionsJsDefault.default));
parcelHelpers.export(exports, "LucideCaptions", ()=>(0, _captionsJsDefault.default));
parcelHelpers.export(exports, "LucideSubtitles", ()=>(0, _captionsJsDefault.default));
parcelHelpers.export(exports, "Subtitles", ()=>(0, _captionsJsDefault.default));
parcelHelpers.export(exports, "SubtitlesIcon", ()=>(0, _captionsJsDefault.default));
parcelHelpers.export(exports, "CircleSlash2", ()=>(0, _circleSlash2JsDefault.default));
parcelHelpers.export(exports, "CircleSlash2Icon", ()=>(0, _circleSlash2JsDefault.default));
parcelHelpers.export(exports, "CircleSlashed", ()=>(0, _circleSlash2JsDefault.default));
parcelHelpers.export(exports, "CircleSlashedIcon", ()=>(0, _circleSlash2JsDefault.default));
parcelHelpers.export(exports, "LucideCircleSlash2", ()=>(0, _circleSlash2JsDefault.default));
parcelHelpers.export(exports, "LucideCircleSlashed", ()=>(0, _circleSlash2JsDefault.default));
parcelHelpers.export(exports, "CircleUserRound", ()=>(0, _circleUserRoundJsDefault.default));
parcelHelpers.export(exports, "CircleUserRoundIcon", ()=>(0, _circleUserRoundJsDefault.default));
parcelHelpers.export(exports, "LucideCircleUserRound", ()=>(0, _circleUserRoundJsDefault.default));
parcelHelpers.export(exports, "LucideUserCircle2", ()=>(0, _circleUserRoundJsDefault.default));
parcelHelpers.export(exports, "UserCircle2", ()=>(0, _circleUserRoundJsDefault.default));
parcelHelpers.export(exports, "UserCircle2Icon", ()=>(0, _circleUserRoundJsDefault.default));
parcelHelpers.export(exports, "CircleUser", ()=>(0, _circleUserJsDefault.default));
parcelHelpers.export(exports, "CircleUserIcon", ()=>(0, _circleUserJsDefault.default));
parcelHelpers.export(exports, "LucideCircleUser", ()=>(0, _circleUserJsDefault.default));
parcelHelpers.export(exports, "LucideUserCircle", ()=>(0, _circleUserJsDefault.default));
parcelHelpers.export(exports, "UserCircle", ()=>(0, _circleUserJsDefault.default));
parcelHelpers.export(exports, "UserCircleIcon", ()=>(0, _circleUserJsDefault.default));
parcelHelpers.export(exports, "ClipboardPenLine", ()=>(0, _clipboardPenLineJsDefault.default));
parcelHelpers.export(exports, "ClipboardPenLineIcon", ()=>(0, _clipboardPenLineJsDefault.default));
parcelHelpers.export(exports, "ClipboardSignature", ()=>(0, _clipboardPenLineJsDefault.default));
parcelHelpers.export(exports, "ClipboardSignatureIcon", ()=>(0, _clipboardPenLineJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardPenLine", ()=>(0, _clipboardPenLineJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardSignature", ()=>(0, _clipboardPenLineJsDefault.default));
parcelHelpers.export(exports, "ClipboardEdit", ()=>(0, _clipboardPenJsDefault.default));
parcelHelpers.export(exports, "ClipboardEditIcon", ()=>(0, _clipboardPenJsDefault.default));
parcelHelpers.export(exports, "ClipboardPen", ()=>(0, _clipboardPenJsDefault.default));
parcelHelpers.export(exports, "ClipboardPenIcon", ()=>(0, _clipboardPenJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardEdit", ()=>(0, _clipboardPenJsDefault.default));
parcelHelpers.export(exports, "LucideClipboardPen", ()=>(0, _clipboardPenJsDefault.default));
parcelHelpers.export(exports, "CodeSquare", ()=>(0, _codeSquareJsDefault.default));
parcelHelpers.export(exports, "CodeSquareIcon", ()=>(0, _codeSquareJsDefault.default));
parcelHelpers.export(exports, "LucideCodeSquare", ()=>(0, _codeSquareJsDefault.default));
parcelHelpers.export(exports, "LucideSquareCode", ()=>(0, _codeSquareJsDefault.default));
parcelHelpers.export(exports, "SquareCode", ()=>(0, _codeSquareJsDefault.default));
parcelHelpers.export(exports, "SquareCodeIcon", ()=>(0, _codeSquareJsDefault.default));
parcelHelpers.export(exports, "Columns", ()=>(0, _columns2JsDefault.default));
parcelHelpers.export(exports, "Columns2", ()=>(0, _columns2JsDefault.default));
parcelHelpers.export(exports, "Columns2Icon", ()=>(0, _columns2JsDefault.default));
parcelHelpers.export(exports, "ColumnsIcon", ()=>(0, _columns2JsDefault.default));
parcelHelpers.export(exports, "LucideColumns", ()=>(0, _columns2JsDefault.default));
parcelHelpers.export(exports, "LucideColumns2", ()=>(0, _columns2JsDefault.default));
parcelHelpers.export(exports, "Columns3", ()=>(0, _columns3JsDefault.default));
parcelHelpers.export(exports, "Columns3Icon", ()=>(0, _columns3JsDefault.default));
parcelHelpers.export(exports, "LucideColumns3", ()=>(0, _columns3JsDefault.default));
parcelHelpers.export(exports, "LucidePanelsLeftRight", ()=>(0, _columns3JsDefault.default));
parcelHelpers.export(exports, "PanelsLeftRight", ()=>(0, _columns3JsDefault.default));
parcelHelpers.export(exports, "PanelsLeftRightIcon", ()=>(0, _columns3JsDefault.default));
parcelHelpers.export(exports, "DotSquare", ()=>(0, _dotSquareJsDefault.default));
parcelHelpers.export(exports, "DotSquareIcon", ()=>(0, _dotSquareJsDefault.default));
parcelHelpers.export(exports, "LucideDotSquare", ()=>(0, _dotSquareJsDefault.default));
parcelHelpers.export(exports, "LucideSquareDot", ()=>(0, _dotSquareJsDefault.default));
parcelHelpers.export(exports, "SquareDot", ()=>(0, _dotSquareJsDefault.default));
parcelHelpers.export(exports, "SquareDotIcon", ()=>(0, _dotSquareJsDefault.default));
parcelHelpers.export(exports, "Earth", ()=>(0, _earthJsDefault.default));
parcelHelpers.export(exports, "EarthIcon", ()=>(0, _earthJsDefault.default));
parcelHelpers.export(exports, "Globe2", ()=>(0, _earthJsDefault.default));
parcelHelpers.export(exports, "Globe2Icon", ()=>(0, _earthJsDefault.default));
parcelHelpers.export(exports, "LucideEarth", ()=>(0, _earthJsDefault.default));
parcelHelpers.export(exports, "LucideGlobe2", ()=>(0, _earthJsDefault.default));
parcelHelpers.export(exports, "FileAxis3D", ()=>(0, _fileAxis3DJsDefault.default));
parcelHelpers.export(exports, "FileAxis3DIcon", ()=>(0, _fileAxis3DJsDefault.default));
parcelHelpers.export(exports, "FileAxis3d", ()=>(0, _fileAxis3DJsDefault.default));
parcelHelpers.export(exports, "FileAxis3dIcon", ()=>(0, _fileAxis3DJsDefault.default));
parcelHelpers.export(exports, "LucideFileAxis3D", ()=>(0, _fileAxis3DJsDefault.default));
parcelHelpers.export(exports, "LucideFileAxis3d", ()=>(0, _fileAxis3DJsDefault.default));
parcelHelpers.export(exports, "FileCog", ()=>(0, _fileCogJsDefault.default));
parcelHelpers.export(exports, "FileCog2", ()=>(0, _fileCogJsDefault.default));
parcelHelpers.export(exports, "FileCog2Icon", ()=>(0, _fileCogJsDefault.default));
parcelHelpers.export(exports, "FileCogIcon", ()=>(0, _fileCogJsDefault.default));
parcelHelpers.export(exports, "LucideFileCog", ()=>(0, _fileCogJsDefault.default));
parcelHelpers.export(exports, "LucideFileCog2", ()=>(0, _fileCogJsDefault.default));
parcelHelpers.export(exports, "EqualSquare", ()=>(0, _equalSquareJsDefault.default));
parcelHelpers.export(exports, "EqualSquareIcon", ()=>(0, _equalSquareJsDefault.default));
parcelHelpers.export(exports, "LucideEqualSquare", ()=>(0, _equalSquareJsDefault.default));
parcelHelpers.export(exports, "LucideSquareEqual", ()=>(0, _equalSquareJsDefault.default));
parcelHelpers.export(exports, "SquareEqual", ()=>(0, _equalSquareJsDefault.default));
parcelHelpers.export(exports, "SquareEqualIcon", ()=>(0, _equalSquareJsDefault.default));
parcelHelpers.export(exports, "FilePenLine", ()=>(0, _filePenLineJsDefault.default));
parcelHelpers.export(exports, "FilePenLineIcon", ()=>(0, _filePenLineJsDefault.default));
parcelHelpers.export(exports, "FileSignature", ()=>(0, _filePenLineJsDefault.default));
parcelHelpers.export(exports, "FileSignatureIcon", ()=>(0, _filePenLineJsDefault.default));
parcelHelpers.export(exports, "LucideFilePenLine", ()=>(0, _filePenLineJsDefault.default));
parcelHelpers.export(exports, "LucideFileSignature", ()=>(0, _filePenLineJsDefault.default));
parcelHelpers.export(exports, "FileEdit", ()=>(0, _filePenJsDefault.default));
parcelHelpers.export(exports, "FileEditIcon", ()=>(0, _filePenJsDefault.default));
parcelHelpers.export(exports, "FilePen", ()=>(0, _filePenJsDefault.default));
parcelHelpers.export(exports, "FilePenIcon", ()=>(0, _filePenJsDefault.default));
parcelHelpers.export(exports, "LucideFileEdit", ()=>(0, _filePenJsDefault.default));
parcelHelpers.export(exports, "LucideFilePen", ()=>(0, _filePenJsDefault.default));
parcelHelpers.export(exports, "FolderCog", ()=>(0, _folderCogJsDefault.default));
parcelHelpers.export(exports, "FolderCog2", ()=>(0, _folderCogJsDefault.default));
parcelHelpers.export(exports, "FolderCog2Icon", ()=>(0, _folderCogJsDefault.default));
parcelHelpers.export(exports, "FolderCogIcon", ()=>(0, _folderCogJsDefault.default));
parcelHelpers.export(exports, "LucideFolderCog", ()=>(0, _folderCogJsDefault.default));
parcelHelpers.export(exports, "LucideFolderCog2", ()=>(0, _folderCogJsDefault.default));
parcelHelpers.export(exports, "FolderEdit", ()=>(0, _folderPenJsDefault.default));
parcelHelpers.export(exports, "FolderEditIcon", ()=>(0, _folderPenJsDefault.default));
parcelHelpers.export(exports, "FolderPen", ()=>(0, _folderPenJsDefault.default));
parcelHelpers.export(exports, "FolderPenIcon", ()=>(0, _folderPenJsDefault.default));
parcelHelpers.export(exports, "LucideFolderEdit", ()=>(0, _folderPenJsDefault.default));
parcelHelpers.export(exports, "LucideFolderPen", ()=>(0, _folderPenJsDefault.default));
parcelHelpers.export(exports, "GanttChartSquare", ()=>(0, _ganttChartSquareJsDefault.default));
parcelHelpers.export(exports, "GanttChartSquareIcon", ()=>(0, _ganttChartSquareJsDefault.default));
parcelHelpers.export(exports, "GanttSquare", ()=>(0, _ganttChartSquareJsDefault.default));
parcelHelpers.export(exports, "GanttSquareIcon", ()=>(0, _ganttChartSquareJsDefault.default));
parcelHelpers.export(exports, "LucideGanttChartSquare", ()=>(0, _ganttChartSquareJsDefault.default));
parcelHelpers.export(exports, "LucideGanttSquare", ()=>(0, _ganttChartSquareJsDefault.default));
parcelHelpers.export(exports, "LucideSquareGantt", ()=>(0, _ganttChartSquareJsDefault.default));
parcelHelpers.export(exports, "SquareGantt", ()=>(0, _ganttChartSquareJsDefault.default));
parcelHelpers.export(exports, "SquareGanttIcon", ()=>(0, _ganttChartSquareJsDefault.default));
parcelHelpers.export(exports, "GitCommit", ()=>(0, _gitCommitHorizontalJsDefault.default));
parcelHelpers.export(exports, "GitCommitHorizontal", ()=>(0, _gitCommitHorizontalJsDefault.default));
parcelHelpers.export(exports, "GitCommitHorizontalIcon", ()=>(0, _gitCommitHorizontalJsDefault.default));
parcelHelpers.export(exports, "GitCommitIcon", ()=>(0, _gitCommitHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideGitCommit", ()=>(0, _gitCommitHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideGitCommitHorizontal", ()=>(0, _gitCommitHorizontalJsDefault.default));
parcelHelpers.export(exports, "Grid2X2", ()=>(0, _grid2X2JsDefault.default));
parcelHelpers.export(exports, "Grid2X2Icon", ()=>(0, _grid2X2JsDefault.default));
parcelHelpers.export(exports, "Grid2x2", ()=>(0, _grid2X2JsDefault.default));
parcelHelpers.export(exports, "Grid2x2Icon", ()=>(0, _grid2X2JsDefault.default));
parcelHelpers.export(exports, "LucideGrid2X2", ()=>(0, _grid2X2JsDefault.default));
parcelHelpers.export(exports, "LucideGrid2x2", ()=>(0, _grid2X2JsDefault.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "Grid3X3", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "Grid3X3Icon", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "Grid3x3", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "Grid3x3Icon", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "GridIcon", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "LucideGrid", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "LucideGrid3X3", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "LucideGrid3x3", ()=>(0, _grid3X3JsDefault.default));
parcelHelpers.export(exports, "HandHelping", ()=>(0, _handHelpingJsDefault.default));
parcelHelpers.export(exports, "HandHelpingIcon", ()=>(0, _handHelpingJsDefault.default));
parcelHelpers.export(exports, "HelpingHand", ()=>(0, _handHelpingJsDefault.default));
parcelHelpers.export(exports, "HelpingHandIcon", ()=>(0, _handHelpingJsDefault.default));
parcelHelpers.export(exports, "LucideHandHelping", ()=>(0, _handHelpingJsDefault.default));
parcelHelpers.export(exports, "LucideHelpingHand", ()=>(0, _handHelpingJsDefault.default));
parcelHelpers.export(exports, "KanbanSquareDashed", ()=>(0, _kanbanSquareDashedJsDefault.default));
parcelHelpers.export(exports, "KanbanSquareDashedIcon", ()=>(0, _kanbanSquareDashedJsDefault.default));
parcelHelpers.export(exports, "LucideKanbanSquareDashed", ()=>(0, _kanbanSquareDashedJsDefault.default));
parcelHelpers.export(exports, "LucideSquareKanbanDashed", ()=>(0, _kanbanSquareDashedJsDefault.default));
parcelHelpers.export(exports, "SquareKanbanDashed", ()=>(0, _kanbanSquareDashedJsDefault.default));
parcelHelpers.export(exports, "SquareKanbanDashedIcon", ()=>(0, _kanbanSquareDashedJsDefault.default));
parcelHelpers.export(exports, "KanbanSquare", ()=>(0, _kanbanSquareJsDefault.default));
parcelHelpers.export(exports, "KanbanSquareIcon", ()=>(0, _kanbanSquareJsDefault.default));
parcelHelpers.export(exports, "LucideKanbanSquare", ()=>(0, _kanbanSquareJsDefault.default));
parcelHelpers.export(exports, "LucideSquareKanban", ()=>(0, _kanbanSquareJsDefault.default));
parcelHelpers.export(exports, "SquareKanban", ()=>(0, _kanbanSquareJsDefault.default));
parcelHelpers.export(exports, "SquareKanbanIcon", ()=>(0, _kanbanSquareJsDefault.default));
parcelHelpers.export(exports, "Inspect", ()=>(0, _mousePointerSquareJsDefault.default));
parcelHelpers.export(exports, "InspectIcon", ()=>(0, _mousePointerSquareJsDefault.default));
parcelHelpers.export(exports, "LucideInspect", ()=>(0, _mousePointerSquareJsDefault.default));
parcelHelpers.export(exports, "LucideMousePointerSquare", ()=>(0, _mousePointerSquareJsDefault.default));
parcelHelpers.export(exports, "MousePointerSquare", ()=>(0, _mousePointerSquareJsDefault.default));
parcelHelpers.export(exports, "MousePointerSquareIcon", ()=>(0, _mousePointerSquareJsDefault.default));
parcelHelpers.export(exports, "LucideMove3D", ()=>(0, _move3DJsDefault.default));
parcelHelpers.export(exports, "LucideMove3d", ()=>(0, _move3DJsDefault.default));
parcelHelpers.export(exports, "Move3D", ()=>(0, _move3DJsDefault.default));
parcelHelpers.export(exports, "Move3DIcon", ()=>(0, _move3DJsDefault.default));
parcelHelpers.export(exports, "Move3d", ()=>(0, _move3DJsDefault.default));
parcelHelpers.export(exports, "Move3dIcon", ()=>(0, _move3DJsDefault.default));
parcelHelpers.export(exports, "LucidePanelLeftClose", ()=>(0, _panelLeftCloseJsDefault.default));
parcelHelpers.export(exports, "LucideSidebarClose", ()=>(0, _panelLeftCloseJsDefault.default));
parcelHelpers.export(exports, "PanelLeftClose", ()=>(0, _panelLeftCloseJsDefault.default));
parcelHelpers.export(exports, "PanelLeftCloseIcon", ()=>(0, _panelLeftCloseJsDefault.default));
parcelHelpers.export(exports, "SidebarClose", ()=>(0, _panelLeftCloseJsDefault.default));
parcelHelpers.export(exports, "SidebarCloseIcon", ()=>(0, _panelLeftCloseJsDefault.default));
parcelHelpers.export(exports, "LucidePanelBottomDashed", ()=>(0, _panelBottomDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelBottomInactive", ()=>(0, _panelBottomDashedJsDefault.default));
parcelHelpers.export(exports, "PanelBottomDashed", ()=>(0, _panelBottomDashedJsDefault.default));
parcelHelpers.export(exports, "PanelBottomDashedIcon", ()=>(0, _panelBottomDashedJsDefault.default));
parcelHelpers.export(exports, "PanelBottomInactive", ()=>(0, _panelBottomDashedJsDefault.default));
parcelHelpers.export(exports, "PanelBottomInactiveIcon", ()=>(0, _panelBottomDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelLeftDashed", ()=>(0, _panelLeftDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelLeftInactive", ()=>(0, _panelLeftDashedJsDefault.default));
parcelHelpers.export(exports, "PanelLeftDashed", ()=>(0, _panelLeftDashedJsDefault.default));
parcelHelpers.export(exports, "PanelLeftDashedIcon", ()=>(0, _panelLeftDashedJsDefault.default));
parcelHelpers.export(exports, "PanelLeftInactive", ()=>(0, _panelLeftDashedJsDefault.default));
parcelHelpers.export(exports, "PanelLeftInactiveIcon", ()=>(0, _panelLeftDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelLeftOpen", ()=>(0, _panelLeftOpenJsDefault.default));
parcelHelpers.export(exports, "LucideSidebarOpen", ()=>(0, _panelLeftOpenJsDefault.default));
parcelHelpers.export(exports, "PanelLeftOpen", ()=>(0, _panelLeftOpenJsDefault.default));
parcelHelpers.export(exports, "PanelLeftOpenIcon", ()=>(0, _panelLeftOpenJsDefault.default));
parcelHelpers.export(exports, "SidebarOpen", ()=>(0, _panelLeftOpenJsDefault.default));
parcelHelpers.export(exports, "SidebarOpenIcon", ()=>(0, _panelLeftOpenJsDefault.default));
parcelHelpers.export(exports, "LucidePanelLeft", ()=>(0, _panelLeftJsDefault.default));
parcelHelpers.export(exports, "LucideSidebar", ()=>(0, _panelLeftJsDefault.default));
parcelHelpers.export(exports, "PanelLeft", ()=>(0, _panelLeftJsDefault.default));
parcelHelpers.export(exports, "PanelLeftIcon", ()=>(0, _panelLeftJsDefault.default));
parcelHelpers.export(exports, "Sidebar", ()=>(0, _panelLeftJsDefault.default));
parcelHelpers.export(exports, "SidebarIcon", ()=>(0, _panelLeftJsDefault.default));
parcelHelpers.export(exports, "LucidePanelRightDashed", ()=>(0, _panelRightDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelRightInactive", ()=>(0, _panelRightDashedJsDefault.default));
parcelHelpers.export(exports, "PanelRightDashed", ()=>(0, _panelRightDashedJsDefault.default));
parcelHelpers.export(exports, "PanelRightDashedIcon", ()=>(0, _panelRightDashedJsDefault.default));
parcelHelpers.export(exports, "PanelRightInactive", ()=>(0, _panelRightDashedJsDefault.default));
parcelHelpers.export(exports, "PanelRightInactiveIcon", ()=>(0, _panelRightDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelTopDashed", ()=>(0, _panelTopDashedJsDefault.default));
parcelHelpers.export(exports, "LucidePanelTopInactive", ()=>(0, _panelTopDashedJsDefault.default));
parcelHelpers.export(exports, "PanelTopDashed", ()=>(0, _panelTopDashedJsDefault.default));
parcelHelpers.export(exports, "PanelTopDashedIcon", ()=>(0, _panelTopDashedJsDefault.default));
parcelHelpers.export(exports, "PanelTopInactive", ()=>(0, _panelTopDashedJsDefault.default));
parcelHelpers.export(exports, "PanelTopInactiveIcon", ()=>(0, _panelTopDashedJsDefault.default));
parcelHelpers.export(exports, "Layout", ()=>(0, _panelsTopLeftJsDefault.default));
parcelHelpers.export(exports, "LayoutIcon", ()=>(0, _panelsTopLeftJsDefault.default));
parcelHelpers.export(exports, "LucideLayout", ()=>(0, _panelsTopLeftJsDefault.default));
parcelHelpers.export(exports, "LucidePanelsTopLeft", ()=>(0, _panelsTopLeftJsDefault.default));
parcelHelpers.export(exports, "PanelsTopLeft", ()=>(0, _panelsTopLeftJsDefault.default));
parcelHelpers.export(exports, "PanelsTopLeftIcon", ()=>(0, _panelsTopLeftJsDefault.default));
parcelHelpers.export(exports, "Edit3", ()=>(0, _penLineJsDefault.default));
parcelHelpers.export(exports, "Edit3Icon", ()=>(0, _penLineJsDefault.default));
parcelHelpers.export(exports, "LucideEdit3", ()=>(0, _penLineJsDefault.default));
parcelHelpers.export(exports, "LucidePenLine", ()=>(0, _penLineJsDefault.default));
parcelHelpers.export(exports, "PenLine", ()=>(0, _penLineJsDefault.default));
parcelHelpers.export(exports, "PenLineIcon", ()=>(0, _penLineJsDefault.default));
parcelHelpers.export(exports, "Edit2", ()=>(0, _penJsDefault.default));
parcelHelpers.export(exports, "Edit2Icon", ()=>(0, _penJsDefault.default));
parcelHelpers.export(exports, "LucideEdit2", ()=>(0, _penJsDefault.default));
parcelHelpers.export(exports, "LucidePen", ()=>(0, _penJsDefault.default));
parcelHelpers.export(exports, "Pen", ()=>(0, _penJsDefault.default));
parcelHelpers.export(exports, "PenIcon", ()=>(0, _penJsDefault.default));
parcelHelpers.export(exports, "LucideRotate3D", ()=>(0, _rotate3DJsDefault.default));
parcelHelpers.export(exports, "LucideRotate3d", ()=>(0, _rotate3DJsDefault.default));
parcelHelpers.export(exports, "Rotate3D", ()=>(0, _rotate3DJsDefault.default));
parcelHelpers.export(exports, "Rotate3DIcon", ()=>(0, _rotate3DJsDefault.default));
parcelHelpers.export(exports, "Rotate3d", ()=>(0, _rotate3DJsDefault.default));
parcelHelpers.export(exports, "Rotate3dIcon", ()=>(0, _rotate3DJsDefault.default));
parcelHelpers.export(exports, "LucideRows", ()=>(0, _rows2JsDefault.default));
parcelHelpers.export(exports, "LucideRows2", ()=>(0, _rows2JsDefault.default));
parcelHelpers.export(exports, "Rows", ()=>(0, _rows2JsDefault.default));
parcelHelpers.export(exports, "Rows2", ()=>(0, _rows2JsDefault.default));
parcelHelpers.export(exports, "Rows2Icon", ()=>(0, _rows2JsDefault.default));
parcelHelpers.export(exports, "RowsIcon", ()=>(0, _rows2JsDefault.default));
parcelHelpers.export(exports, "LucidePanelsTopBottom", ()=>(0, _rows3JsDefault.default));
parcelHelpers.export(exports, "LucideRows3", ()=>(0, _rows3JsDefault.default));
parcelHelpers.export(exports, "PanelsTopBottom", ()=>(0, _rows3JsDefault.default));
parcelHelpers.export(exports, "PanelsTopBottomIcon", ()=>(0, _rows3JsDefault.default));
parcelHelpers.export(exports, "Rows3", ()=>(0, _rows3JsDefault.default));
parcelHelpers.export(exports, "Rows3Icon", ()=>(0, _rows3JsDefault.default));
parcelHelpers.export(exports, "LucideScale3D", ()=>(0, _scale3DJsDefault.default));
parcelHelpers.export(exports, "LucideScale3d", ()=>(0, _scale3DJsDefault.default));
parcelHelpers.export(exports, "Scale3D", ()=>(0, _scale3DJsDefault.default));
parcelHelpers.export(exports, "Scale3DIcon", ()=>(0, _scale3DJsDefault.default));
parcelHelpers.export(exports, "Scale3d", ()=>(0, _scale3DJsDefault.default));
parcelHelpers.export(exports, "Scale3dIcon", ()=>(0, _scale3DJsDefault.default));
parcelHelpers.export(exports, "LucideSendHorizonal", ()=>(0, _sendHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideSendHorizontal", ()=>(0, _sendHorizontalJsDefault.default));
parcelHelpers.export(exports, "SendHorizonal", ()=>(0, _sendHorizontalJsDefault.default));
parcelHelpers.export(exports, "SendHorizonalIcon", ()=>(0, _sendHorizontalJsDefault.default));
parcelHelpers.export(exports, "SendHorizontal", ()=>(0, _sendHorizontalJsDefault.default));
parcelHelpers.export(exports, "SendHorizontalIcon", ()=>(0, _sendHorizontalJsDefault.default));
parcelHelpers.export(exports, "LucideShieldClose", ()=>(0, _shieldXJsDefault.default));
parcelHelpers.export(exports, "LucideShieldX", ()=>(0, _shieldXJsDefault.default));
parcelHelpers.export(exports, "ShieldClose", ()=>(0, _shieldXJsDefault.default));
parcelHelpers.export(exports, "ShieldCloseIcon", ()=>(0, _shieldXJsDefault.default));
parcelHelpers.export(exports, "ShieldX", ()=>(0, _shieldXJsDefault.default));
parcelHelpers.export(exports, "ShieldXIcon", ()=>(0, _shieldXJsDefault.default));
parcelHelpers.export(exports, "LucideSparkles", ()=>(0, _sparklesJsDefault.default));
parcelHelpers.export(exports, "LucideStars", ()=>(0, _sparklesJsDefault.default));
parcelHelpers.export(exports, "Sparkles", ()=>(0, _sparklesJsDefault.default));
parcelHelpers.export(exports, "SparklesIcon", ()=>(0, _sparklesJsDefault.default));
parcelHelpers.export(exports, "Stars", ()=>(0, _sparklesJsDefault.default));
parcelHelpers.export(exports, "StarsIcon", ()=>(0, _sparklesJsDefault.default));
parcelHelpers.export(exports, "LucideSlashSquare", ()=>(0, _slashSquareJsDefault.default));
parcelHelpers.export(exports, "LucideSquareSlash", ()=>(0, _slashSquareJsDefault.default));
parcelHelpers.export(exports, "SlashSquare", ()=>(0, _slashSquareJsDefault.default));
parcelHelpers.export(exports, "SlashSquareIcon", ()=>(0, _slashSquareJsDefault.default));
parcelHelpers.export(exports, "SquareSlash", ()=>(0, _slashSquareJsDefault.default));
parcelHelpers.export(exports, "SquareSlashIcon", ()=>(0, _slashSquareJsDefault.default));
parcelHelpers.export(exports, "Edit", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "EditIcon", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "LucideEdit", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "LucidePenBox", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "LucidePenSquare", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "LucideSquarePen", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "PenBox", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "PenBoxIcon", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "PenSquare", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "PenSquareIcon", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "SquarePen", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "SquarePenIcon", ()=>(0, _squarePenJsDefault.default));
parcelHelpers.export(exports, "LucideSquareUserRound", ()=>(0, _squareUserRoundJsDefault.default));
parcelHelpers.export(exports, "LucideUserSquare2", ()=>(0, _squareUserRoundJsDefault.default));
parcelHelpers.export(exports, "SquareUserRound", ()=>(0, _squareUserRoundJsDefault.default));
parcelHelpers.export(exports, "SquareUserRoundIcon", ()=>(0, _squareUserRoundJsDefault.default));
parcelHelpers.export(exports, "UserSquare2", ()=>(0, _squareUserRoundJsDefault.default));
parcelHelpers.export(exports, "UserSquare2Icon", ()=>(0, _squareUserRoundJsDefault.default));
parcelHelpers.export(exports, "LucideSquareUser", ()=>(0, _squareUserJsDefault.default));
parcelHelpers.export(exports, "LucideUserSquare", ()=>(0, _squareUserJsDefault.default));
parcelHelpers.export(exports, "SquareUser", ()=>(0, _squareUserJsDefault.default));
parcelHelpers.export(exports, "SquareUserIcon", ()=>(0, _squareUserJsDefault.default));
parcelHelpers.export(exports, "UserSquare", ()=>(0, _squareUserJsDefault.default));
parcelHelpers.export(exports, "UserSquareIcon", ()=>(0, _squareUserJsDefault.default));
parcelHelpers.export(exports, "LucideTextSelect", ()=>(0, _textSelectJsDefault.default));
parcelHelpers.export(exports, "LucideTextSelection", ()=>(0, _textSelectJsDefault.default));
parcelHelpers.export(exports, "TextSelect", ()=>(0, _textSelectJsDefault.default));
parcelHelpers.export(exports, "TextSelectIcon", ()=>(0, _textSelectJsDefault.default));
parcelHelpers.export(exports, "TextSelection", ()=>(0, _textSelectJsDefault.default));
parcelHelpers.export(exports, "TextSelectionIcon", ()=>(0, _textSelectJsDefault.default));
parcelHelpers.export(exports, "LucideTrain", ()=>(0, _tramFrontJsDefault.default));
parcelHelpers.export(exports, "LucideTramFront", ()=>(0, _tramFrontJsDefault.default));
parcelHelpers.export(exports, "Train", ()=>(0, _tramFrontJsDefault.default));
parcelHelpers.export(exports, "TrainIcon", ()=>(0, _tramFrontJsDefault.default));
parcelHelpers.export(exports, "TramFront", ()=>(0, _tramFrontJsDefault.default));
parcelHelpers.export(exports, "TramFrontIcon", ()=>(0, _tramFrontJsDefault.default));
parcelHelpers.export(exports, "LucideUserCheck2", ()=>(0, _userRoundCheckJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundCheck", ()=>(0, _userRoundCheckJsDefault.default));
parcelHelpers.export(exports, "UserCheck2", ()=>(0, _userRoundCheckJsDefault.default));
parcelHelpers.export(exports, "UserCheck2Icon", ()=>(0, _userRoundCheckJsDefault.default));
parcelHelpers.export(exports, "UserRoundCheck", ()=>(0, _userRoundCheckJsDefault.default));
parcelHelpers.export(exports, "UserRoundCheckIcon", ()=>(0, _userRoundCheckJsDefault.default));
parcelHelpers.export(exports, "LucideUserCog2", ()=>(0, _userRoundCogJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundCog", ()=>(0, _userRoundCogJsDefault.default));
parcelHelpers.export(exports, "UserCog2", ()=>(0, _userRoundCogJsDefault.default));
parcelHelpers.export(exports, "UserCog2Icon", ()=>(0, _userRoundCogJsDefault.default));
parcelHelpers.export(exports, "UserRoundCog", ()=>(0, _userRoundCogJsDefault.default));
parcelHelpers.export(exports, "UserRoundCogIcon", ()=>(0, _userRoundCogJsDefault.default));
parcelHelpers.export(exports, "LucideUserMinus2", ()=>(0, _userRoundMinusJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundMinus", ()=>(0, _userRoundMinusJsDefault.default));
parcelHelpers.export(exports, "UserMinus2", ()=>(0, _userRoundMinusJsDefault.default));
parcelHelpers.export(exports, "UserMinus2Icon", ()=>(0, _userRoundMinusJsDefault.default));
parcelHelpers.export(exports, "UserRoundMinus", ()=>(0, _userRoundMinusJsDefault.default));
parcelHelpers.export(exports, "UserRoundMinusIcon", ()=>(0, _userRoundMinusJsDefault.default));
parcelHelpers.export(exports, "LucideUserPlus2", ()=>(0, _userRoundPlusJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundPlus", ()=>(0, _userRoundPlusJsDefault.default));
parcelHelpers.export(exports, "UserPlus2", ()=>(0, _userRoundPlusJsDefault.default));
parcelHelpers.export(exports, "UserPlus2Icon", ()=>(0, _userRoundPlusJsDefault.default));
parcelHelpers.export(exports, "UserRoundPlus", ()=>(0, _userRoundPlusJsDefault.default));
parcelHelpers.export(exports, "UserRoundPlusIcon", ()=>(0, _userRoundPlusJsDefault.default));
parcelHelpers.export(exports, "LucideUserRoundX", ()=>(0, _userRoundXJsDefault.default));
parcelHelpers.export(exports, "LucideUserX2", ()=>(0, _userRoundXJsDefault.default));
parcelHelpers.export(exports, "UserRoundX", ()=>(0, _userRoundXJsDefault.default));
parcelHelpers.export(exports, "UserRoundXIcon", ()=>(0, _userRoundXJsDefault.default));
parcelHelpers.export(exports, "UserX2", ()=>(0, _userRoundXJsDefault.default));
parcelHelpers.export(exports, "UserX2Icon", ()=>(0, _userRoundXJsDefault.default));
parcelHelpers.export(exports, "LucideUser2", ()=>(0, _userRoundJsDefault.default));
parcelHelpers.export(exports, "LucideUserRound", ()=>(0, _userRoundJsDefault.default));
parcelHelpers.export(exports, "User2", ()=>(0, _userRoundJsDefault.default));
parcelHelpers.export(exports, "User2Icon", ()=>(0, _userRoundJsDefault.default));
parcelHelpers.export(exports, "UserRound", ()=>(0, _userRoundJsDefault.default));
parcelHelpers.export(exports, "UserRoundIcon", ()=>(0, _userRoundJsDefault.default));
parcelHelpers.export(exports, "LucideUsers2", ()=>(0, _usersRoundJsDefault.default));
parcelHelpers.export(exports, "LucideUsersRound", ()=>(0, _usersRoundJsDefault.default));
parcelHelpers.export(exports, "Users2", ()=>(0, _usersRoundJsDefault.default));
parcelHelpers.export(exports, "Users2Icon", ()=>(0, _usersRoundJsDefault.default));
parcelHelpers.export(exports, "UsersRound", ()=>(0, _usersRoundJsDefault.default));
parcelHelpers.export(exports, "UsersRoundIcon", ()=>(0, _usersRoundJsDefault.default));
parcelHelpers.export(exports, "createLucideIcon", ()=>(0, _createLucideIconJsDefault.default));
parcelHelpers.export(exports, "icons", ()=>_indexJs);
var _indexJs = require("./icons/index.js");
var _aArrowDownJs = require("./icons/a-arrow-down.js");
var _aArrowDownJsDefault = parcelHelpers.interopDefault(_aArrowDownJs);
var _aArrowUpJs = require("./icons/a-arrow-up.js");
var _aArrowUpJsDefault = parcelHelpers.interopDefault(_aArrowUpJs);
var _aLargeSmallJs = require("./icons/a-large-small.js");
var _aLargeSmallJsDefault = parcelHelpers.interopDefault(_aLargeSmallJs);
var _accessibilityJs = require("./icons/accessibility.js");
var _accessibilityJsDefault = parcelHelpers.interopDefault(_accessibilityJs);
var _activitySquareJs = require("./icons/activity-square.js");
var _activitySquareJsDefault = parcelHelpers.interopDefault(_activitySquareJs);
var _activityJs = require("./icons/activity.js");
var _activityJsDefault = parcelHelpers.interopDefault(_activityJs);
var _airVentJs = require("./icons/air-vent.js");
var _airVentJsDefault = parcelHelpers.interopDefault(_airVentJs);
var _airplayJs = require("./icons/airplay.js");
var _airplayJsDefault = parcelHelpers.interopDefault(_airplayJs);
var _alarmClockOffJs = require("./icons/alarm-clock-off.js");
var _alarmClockOffJsDefault = parcelHelpers.interopDefault(_alarmClockOffJs);
var _alarmClockJs = require("./icons/alarm-clock.js");
var _alarmClockJsDefault = parcelHelpers.interopDefault(_alarmClockJs);
var _alarmSmokeJs = require("./icons/alarm-smoke.js");
var _alarmSmokeJsDefault = parcelHelpers.interopDefault(_alarmSmokeJs);
var _albumJs = require("./icons/album.js");
var _albumJsDefault = parcelHelpers.interopDefault(_albumJs);
var _alertCircleJs = require("./icons/alert-circle.js");
var _alertCircleJsDefault = parcelHelpers.interopDefault(_alertCircleJs);
var _alertOctagonJs = require("./icons/alert-octagon.js");
var _alertOctagonJsDefault = parcelHelpers.interopDefault(_alertOctagonJs);
var _alertTriangleJs = require("./icons/alert-triangle.js");
var _alertTriangleJsDefault = parcelHelpers.interopDefault(_alertTriangleJs);
var _alignCenterHorizontalJs = require("./icons/align-center-horizontal.js");
var _alignCenterHorizontalJsDefault = parcelHelpers.interopDefault(_alignCenterHorizontalJs);
var _alignCenterVerticalJs = require("./icons/align-center-vertical.js");
var _alignCenterVerticalJsDefault = parcelHelpers.interopDefault(_alignCenterVerticalJs);
var _alignCenterJs = require("./icons/align-center.js");
var _alignCenterJsDefault = parcelHelpers.interopDefault(_alignCenterJs);
var _alignEndHorizontalJs = require("./icons/align-end-horizontal.js");
var _alignEndHorizontalJsDefault = parcelHelpers.interopDefault(_alignEndHorizontalJs);
var _alignEndVerticalJs = require("./icons/align-end-vertical.js");
var _alignEndVerticalJsDefault = parcelHelpers.interopDefault(_alignEndVerticalJs);
var _alignHorizontalDistributeCenterJs = require("./icons/align-horizontal-distribute-center.js");
var _alignHorizontalDistributeCenterJsDefault = parcelHelpers.interopDefault(_alignHorizontalDistributeCenterJs);
var _alignHorizontalDistributeEndJs = require("./icons/align-horizontal-distribute-end.js");
var _alignHorizontalDistributeEndJsDefault = parcelHelpers.interopDefault(_alignHorizontalDistributeEndJs);
var _alignHorizontalDistributeStartJs = require("./icons/align-horizontal-distribute-start.js");
var _alignHorizontalDistributeStartJsDefault = parcelHelpers.interopDefault(_alignHorizontalDistributeStartJs);
var _alignHorizontalJustifyCenterJs = require("./icons/align-horizontal-justify-center.js");
var _alignHorizontalJustifyCenterJsDefault = parcelHelpers.interopDefault(_alignHorizontalJustifyCenterJs);
var _alignHorizontalJustifyEndJs = require("./icons/align-horizontal-justify-end.js");
var _alignHorizontalJustifyEndJsDefault = parcelHelpers.interopDefault(_alignHorizontalJustifyEndJs);
var _alignHorizontalJustifyStartJs = require("./icons/align-horizontal-justify-start.js");
var _alignHorizontalJustifyStartJsDefault = parcelHelpers.interopDefault(_alignHorizontalJustifyStartJs);
var _alignHorizontalSpaceAroundJs = require("./icons/align-horizontal-space-around.js");
var _alignHorizontalSpaceAroundJsDefault = parcelHelpers.interopDefault(_alignHorizontalSpaceAroundJs);
var _alignHorizontalSpaceBetweenJs = require("./icons/align-horizontal-space-between.js");
var _alignHorizontalSpaceBetweenJsDefault = parcelHelpers.interopDefault(_alignHorizontalSpaceBetweenJs);
var _alignJustifyJs = require("./icons/align-justify.js");
var _alignJustifyJsDefault = parcelHelpers.interopDefault(_alignJustifyJs);
var _alignLeftJs = require("./icons/align-left.js");
var _alignLeftJsDefault = parcelHelpers.interopDefault(_alignLeftJs);
var _alignRightJs = require("./icons/align-right.js");
var _alignRightJsDefault = parcelHelpers.interopDefault(_alignRightJs);
var _alignStartHorizontalJs = require("./icons/align-start-horizontal.js");
var _alignStartHorizontalJsDefault = parcelHelpers.interopDefault(_alignStartHorizontalJs);
var _alignStartVerticalJs = require("./icons/align-start-vertical.js");
var _alignStartVerticalJsDefault = parcelHelpers.interopDefault(_alignStartVerticalJs);
var _alignVerticalDistributeCenterJs = require("./icons/align-vertical-distribute-center.js");
var _alignVerticalDistributeCenterJsDefault = parcelHelpers.interopDefault(_alignVerticalDistributeCenterJs);
var _alignVerticalDistributeEndJs = require("./icons/align-vertical-distribute-end.js");
var _alignVerticalDistributeEndJsDefault = parcelHelpers.interopDefault(_alignVerticalDistributeEndJs);
var _alignVerticalDistributeStartJs = require("./icons/align-vertical-distribute-start.js");
var _alignVerticalDistributeStartJsDefault = parcelHelpers.interopDefault(_alignVerticalDistributeStartJs);
var _alignVerticalJustifyCenterJs = require("./icons/align-vertical-justify-center.js");
var _alignVerticalJustifyCenterJsDefault = parcelHelpers.interopDefault(_alignVerticalJustifyCenterJs);
var _alignVerticalJustifyEndJs = require("./icons/align-vertical-justify-end.js");
var _alignVerticalJustifyEndJsDefault = parcelHelpers.interopDefault(_alignVerticalJustifyEndJs);
var _alignVerticalJustifyStartJs = require("./icons/align-vertical-justify-start.js");
var _alignVerticalJustifyStartJsDefault = parcelHelpers.interopDefault(_alignVerticalJustifyStartJs);
var _alignVerticalSpaceAroundJs = require("./icons/align-vertical-space-around.js");
var _alignVerticalSpaceAroundJsDefault = parcelHelpers.interopDefault(_alignVerticalSpaceAroundJs);
var _alignVerticalSpaceBetweenJs = require("./icons/align-vertical-space-between.js");
var _alignVerticalSpaceBetweenJsDefault = parcelHelpers.interopDefault(_alignVerticalSpaceBetweenJs);
var _ambulanceJs = require("./icons/ambulance.js");
var _ambulanceJsDefault = parcelHelpers.interopDefault(_ambulanceJs);
var _ampersandJs = require("./icons/ampersand.js");
var _ampersandJsDefault = parcelHelpers.interopDefault(_ampersandJs);
var _ampersandsJs = require("./icons/ampersands.js");
var _ampersandsJsDefault = parcelHelpers.interopDefault(_ampersandsJs);
var _anchorJs = require("./icons/anchor.js");
var _anchorJsDefault = parcelHelpers.interopDefault(_anchorJs);
var _angryJs = require("./icons/angry.js");
var _angryJsDefault = parcelHelpers.interopDefault(_angryJs);
var _annoyedJs = require("./icons/annoyed.js");
var _annoyedJsDefault = parcelHelpers.interopDefault(_annoyedJs);
var _antennaJs = require("./icons/antenna.js");
var _antennaJsDefault = parcelHelpers.interopDefault(_antennaJs);
var _anvilJs = require("./icons/anvil.js");
var _anvilJsDefault = parcelHelpers.interopDefault(_anvilJs);
var _apertureJs = require("./icons/aperture.js");
var _apertureJsDefault = parcelHelpers.interopDefault(_apertureJs);
var _appWindowJs = require("./icons/app-window.js");
var _appWindowJsDefault = parcelHelpers.interopDefault(_appWindowJs);
var _appleJs = require("./icons/apple.js");
var _appleJsDefault = parcelHelpers.interopDefault(_appleJs);
var _archiveRestoreJs = require("./icons/archive-restore.js");
var _archiveRestoreJsDefault = parcelHelpers.interopDefault(_archiveRestoreJs);
var _archiveXJs = require("./icons/archive-x.js");
var _archiveXJsDefault = parcelHelpers.interopDefault(_archiveXJs);
var _archiveJs = require("./icons/archive.js");
var _archiveJsDefault = parcelHelpers.interopDefault(_archiveJs);
var _areaChartJs = require("./icons/area-chart.js");
var _areaChartJsDefault = parcelHelpers.interopDefault(_areaChartJs);
var _armchairJs = require("./icons/armchair.js");
var _armchairJsDefault = parcelHelpers.interopDefault(_armchairJs);
var _arrowBigDownDashJs = require("./icons/arrow-big-down-dash.js");
var _arrowBigDownDashJsDefault = parcelHelpers.interopDefault(_arrowBigDownDashJs);
var _arrowBigDownJs = require("./icons/arrow-big-down.js");
var _arrowBigDownJsDefault = parcelHelpers.interopDefault(_arrowBigDownJs);
var _arrowBigLeftDashJs = require("./icons/arrow-big-left-dash.js");
var _arrowBigLeftDashJsDefault = parcelHelpers.interopDefault(_arrowBigLeftDashJs);
var _arrowBigLeftJs = require("./icons/arrow-big-left.js");
var _arrowBigLeftJsDefault = parcelHelpers.interopDefault(_arrowBigLeftJs);
var _arrowBigRightDashJs = require("./icons/arrow-big-right-dash.js");
var _arrowBigRightDashJsDefault = parcelHelpers.interopDefault(_arrowBigRightDashJs);
var _arrowBigRightJs = require("./icons/arrow-big-right.js");
var _arrowBigRightJsDefault = parcelHelpers.interopDefault(_arrowBigRightJs);
var _arrowBigUpDashJs = require("./icons/arrow-big-up-dash.js");
var _arrowBigUpDashJsDefault = parcelHelpers.interopDefault(_arrowBigUpDashJs);
var _arrowBigUpJs = require("./icons/arrow-big-up.js");
var _arrowBigUpJsDefault = parcelHelpers.interopDefault(_arrowBigUpJs);
var _arrowDownCircleJs = require("./icons/arrow-down-circle.js");
var _arrowDownCircleJsDefault = parcelHelpers.interopDefault(_arrowDownCircleJs);
var _arrowDownFromLineJs = require("./icons/arrow-down-from-line.js");
var _arrowDownFromLineJsDefault = parcelHelpers.interopDefault(_arrowDownFromLineJs);
var _arrowDownLeftFromCircleJs = require("./icons/arrow-down-left-from-circle.js");
var _arrowDownLeftFromCircleJsDefault = parcelHelpers.interopDefault(_arrowDownLeftFromCircleJs);
var _arrowDownLeftFromSquareJs = require("./icons/arrow-down-left-from-square.js");
var _arrowDownLeftFromSquareJsDefault = parcelHelpers.interopDefault(_arrowDownLeftFromSquareJs);
var _arrowDownLeftSquareJs = require("./icons/arrow-down-left-square.js");
var _arrowDownLeftSquareJsDefault = parcelHelpers.interopDefault(_arrowDownLeftSquareJs);
var _arrowDownLeftJs = require("./icons/arrow-down-left.js");
var _arrowDownLeftJsDefault = parcelHelpers.interopDefault(_arrowDownLeftJs);
var _arrowDownNarrowWideJs = require("./icons/arrow-down-narrow-wide.js");
var _arrowDownNarrowWideJsDefault = parcelHelpers.interopDefault(_arrowDownNarrowWideJs);
var _arrowDownRightFromCircleJs = require("./icons/arrow-down-right-from-circle.js");
var _arrowDownRightFromCircleJsDefault = parcelHelpers.interopDefault(_arrowDownRightFromCircleJs);
var _arrowDownRightFromSquareJs = require("./icons/arrow-down-right-from-square.js");
var _arrowDownRightFromSquareJsDefault = parcelHelpers.interopDefault(_arrowDownRightFromSquareJs);
var _arrowDownRightSquareJs = require("./icons/arrow-down-right-square.js");
var _arrowDownRightSquareJsDefault = parcelHelpers.interopDefault(_arrowDownRightSquareJs);
var _arrowDownRightJs = require("./icons/arrow-down-right.js");
var _arrowDownRightJsDefault = parcelHelpers.interopDefault(_arrowDownRightJs);
var _arrowDownSquareJs = require("./icons/arrow-down-square.js");
var _arrowDownSquareJsDefault = parcelHelpers.interopDefault(_arrowDownSquareJs);
var _arrowDownToDotJs = require("./icons/arrow-down-to-dot.js");
var _arrowDownToDotJsDefault = parcelHelpers.interopDefault(_arrowDownToDotJs);
var _arrowDownToLineJs = require("./icons/arrow-down-to-line.js");
var _arrowDownToLineJsDefault = parcelHelpers.interopDefault(_arrowDownToLineJs);
var _arrowDownUpJs = require("./icons/arrow-down-up.js");
var _arrowDownUpJsDefault = parcelHelpers.interopDefault(_arrowDownUpJs);
var _arrowDownJs = require("./icons/arrow-down.js");
var _arrowDownJsDefault = parcelHelpers.interopDefault(_arrowDownJs);
var _arrowLeftCircleJs = require("./icons/arrow-left-circle.js");
var _arrowLeftCircleJsDefault = parcelHelpers.interopDefault(_arrowLeftCircleJs);
var _arrowLeftFromLineJs = require("./icons/arrow-left-from-line.js");
var _arrowLeftFromLineJsDefault = parcelHelpers.interopDefault(_arrowLeftFromLineJs);
var _arrowLeftRightJs = require("./icons/arrow-left-right.js");
var _arrowLeftRightJsDefault = parcelHelpers.interopDefault(_arrowLeftRightJs);
var _arrowLeftSquareJs = require("./icons/arrow-left-square.js");
var _arrowLeftSquareJsDefault = parcelHelpers.interopDefault(_arrowLeftSquareJs);
var _arrowLeftToLineJs = require("./icons/arrow-left-to-line.js");
var _arrowLeftToLineJsDefault = parcelHelpers.interopDefault(_arrowLeftToLineJs);
var _arrowLeftJs = require("./icons/arrow-left.js");
var _arrowLeftJsDefault = parcelHelpers.interopDefault(_arrowLeftJs);
var _arrowRightCircleJs = require("./icons/arrow-right-circle.js");
var _arrowRightCircleJsDefault = parcelHelpers.interopDefault(_arrowRightCircleJs);
var _arrowRightFromLineJs = require("./icons/arrow-right-from-line.js");
var _arrowRightFromLineJsDefault = parcelHelpers.interopDefault(_arrowRightFromLineJs);
var _arrowRightLeftJs = require("./icons/arrow-right-left.js");
var _arrowRightLeftJsDefault = parcelHelpers.interopDefault(_arrowRightLeftJs);
var _arrowRightSquareJs = require("./icons/arrow-right-square.js");
var _arrowRightSquareJsDefault = parcelHelpers.interopDefault(_arrowRightSquareJs);
var _arrowRightToLineJs = require("./icons/arrow-right-to-line.js");
var _arrowRightToLineJsDefault = parcelHelpers.interopDefault(_arrowRightToLineJs);
var _arrowRightJs = require("./icons/arrow-right.js");
var _arrowRightJsDefault = parcelHelpers.interopDefault(_arrowRightJs);
var _arrowUpCircleJs = require("./icons/arrow-up-circle.js");
var _arrowUpCircleJsDefault = parcelHelpers.interopDefault(_arrowUpCircleJs);
var _arrowUpDownJs = require("./icons/arrow-up-down.js");
var _arrowUpDownJsDefault = parcelHelpers.interopDefault(_arrowUpDownJs);
var _arrowUpFromDotJs = require("./icons/arrow-up-from-dot.js");
var _arrowUpFromDotJsDefault = parcelHelpers.interopDefault(_arrowUpFromDotJs);
var _arrowUpFromLineJs = require("./icons/arrow-up-from-line.js");
var _arrowUpFromLineJsDefault = parcelHelpers.interopDefault(_arrowUpFromLineJs);
var _arrowUpLeftFromCircleJs = require("./icons/arrow-up-left-from-circle.js");
var _arrowUpLeftFromCircleJsDefault = parcelHelpers.interopDefault(_arrowUpLeftFromCircleJs);
var _arrowUpLeftFromSquareJs = require("./icons/arrow-up-left-from-square.js");
var _arrowUpLeftFromSquareJsDefault = parcelHelpers.interopDefault(_arrowUpLeftFromSquareJs);
var _arrowUpLeftSquareJs = require("./icons/arrow-up-left-square.js");
var _arrowUpLeftSquareJsDefault = parcelHelpers.interopDefault(_arrowUpLeftSquareJs);
var _arrowUpLeftJs = require("./icons/arrow-up-left.js");
var _arrowUpLeftJsDefault = parcelHelpers.interopDefault(_arrowUpLeftJs);
var _arrowUpRightFromCircleJs = require("./icons/arrow-up-right-from-circle.js");
var _arrowUpRightFromCircleJsDefault = parcelHelpers.interopDefault(_arrowUpRightFromCircleJs);
var _arrowUpRightFromSquareJs = require("./icons/arrow-up-right-from-square.js");
var _arrowUpRightFromSquareJsDefault = parcelHelpers.interopDefault(_arrowUpRightFromSquareJs);
var _arrowUpRightSquareJs = require("./icons/arrow-up-right-square.js");
var _arrowUpRightSquareJsDefault = parcelHelpers.interopDefault(_arrowUpRightSquareJs);
var _arrowUpRightJs = require("./icons/arrow-up-right.js");
var _arrowUpRightJsDefault = parcelHelpers.interopDefault(_arrowUpRightJs);
var _arrowUpSquareJs = require("./icons/arrow-up-square.js");
var _arrowUpSquareJsDefault = parcelHelpers.interopDefault(_arrowUpSquareJs);
var _arrowUpToLineJs = require("./icons/arrow-up-to-line.js");
var _arrowUpToLineJsDefault = parcelHelpers.interopDefault(_arrowUpToLineJs);
var _arrowUpWideNarrowJs = require("./icons/arrow-up-wide-narrow.js");
var _arrowUpWideNarrowJsDefault = parcelHelpers.interopDefault(_arrowUpWideNarrowJs);
var _arrowUpJs = require("./icons/arrow-up.js");
var _arrowUpJsDefault = parcelHelpers.interopDefault(_arrowUpJs);
var _arrowsUpFromLineJs = require("./icons/arrows-up-from-line.js");
var _arrowsUpFromLineJsDefault = parcelHelpers.interopDefault(_arrowsUpFromLineJs);
var _asteriskJs = require("./icons/asterisk.js");
var _asteriskJsDefault = parcelHelpers.interopDefault(_asteriskJs);
var _atSignJs = require("./icons/at-sign.js");
var _atSignJsDefault = parcelHelpers.interopDefault(_atSignJs);
var _atomJs = require("./icons/atom.js");
var _atomJsDefault = parcelHelpers.interopDefault(_atomJs);
var _audioLinesJs = require("./icons/audio-lines.js");
var _audioLinesJsDefault = parcelHelpers.interopDefault(_audioLinesJs);
var _audioWaveformJs = require("./icons/audio-waveform.js");
var _audioWaveformJsDefault = parcelHelpers.interopDefault(_audioWaveformJs);
var _awardJs = require("./icons/award.js");
var _awardJsDefault = parcelHelpers.interopDefault(_awardJs);
var _axeJs = require("./icons/axe.js");
var _axeJsDefault = parcelHelpers.interopDefault(_axeJs);
var _babyJs = require("./icons/baby.js");
var _babyJsDefault = parcelHelpers.interopDefault(_babyJs);
var _backpackJs = require("./icons/backpack.js");
var _backpackJsDefault = parcelHelpers.interopDefault(_backpackJs);
var _badgeAlertJs = require("./icons/badge-alert.js");
var _badgeAlertJsDefault = parcelHelpers.interopDefault(_badgeAlertJs);
var _badgeCentJs = require("./icons/badge-cent.js");
var _badgeCentJsDefault = parcelHelpers.interopDefault(_badgeCentJs);
var _badgeDollarSignJs = require("./icons/badge-dollar-sign.js");
var _badgeDollarSignJsDefault = parcelHelpers.interopDefault(_badgeDollarSignJs);
var _badgeEuroJs = require("./icons/badge-euro.js");
var _badgeEuroJsDefault = parcelHelpers.interopDefault(_badgeEuroJs);
var _badgeHelpJs = require("./icons/badge-help.js");
var _badgeHelpJsDefault = parcelHelpers.interopDefault(_badgeHelpJs);
var _badgeIndianRupeeJs = require("./icons/badge-indian-rupee.js");
var _badgeIndianRupeeJsDefault = parcelHelpers.interopDefault(_badgeIndianRupeeJs);
var _badgeInfoJs = require("./icons/badge-info.js");
var _badgeInfoJsDefault = parcelHelpers.interopDefault(_badgeInfoJs);
var _badgeJapaneseYenJs = require("./icons/badge-japanese-yen.js");
var _badgeJapaneseYenJsDefault = parcelHelpers.interopDefault(_badgeJapaneseYenJs);
var _badgeMinusJs = require("./icons/badge-minus.js");
var _badgeMinusJsDefault = parcelHelpers.interopDefault(_badgeMinusJs);
var _badgePercentJs = require("./icons/badge-percent.js");
var _badgePercentJsDefault = parcelHelpers.interopDefault(_badgePercentJs);
var _badgePlusJs = require("./icons/badge-plus.js");
var _badgePlusJsDefault = parcelHelpers.interopDefault(_badgePlusJs);
var _badgePoundSterlingJs = require("./icons/badge-pound-sterling.js");
var _badgePoundSterlingJsDefault = parcelHelpers.interopDefault(_badgePoundSterlingJs);
var _badgeRussianRubleJs = require("./icons/badge-russian-ruble.js");
var _badgeRussianRubleJsDefault = parcelHelpers.interopDefault(_badgeRussianRubleJs);
var _badgeSwissFrancJs = require("./icons/badge-swiss-franc.js");
var _badgeSwissFrancJsDefault = parcelHelpers.interopDefault(_badgeSwissFrancJs);
var _badgeXJs = require("./icons/badge-x.js");
var _badgeXJsDefault = parcelHelpers.interopDefault(_badgeXJs);
var _badgeJs = require("./icons/badge.js");
var _badgeJsDefault = parcelHelpers.interopDefault(_badgeJs);
var _baggageClaimJs = require("./icons/baggage-claim.js");
var _baggageClaimJsDefault = parcelHelpers.interopDefault(_baggageClaimJs);
var _banJs = require("./icons/ban.js");
var _banJsDefault = parcelHelpers.interopDefault(_banJs);
var _bananaJs = require("./icons/banana.js");
var _bananaJsDefault = parcelHelpers.interopDefault(_bananaJs);
var _banknoteJs = require("./icons/banknote.js");
var _banknoteJsDefault = parcelHelpers.interopDefault(_banknoteJs);
var _barChart2Js = require("./icons/bar-chart-2.js");
var _barChart2JsDefault = parcelHelpers.interopDefault(_barChart2Js);
var _barChart3Js = require("./icons/bar-chart-3.js");
var _barChart3JsDefault = parcelHelpers.interopDefault(_barChart3Js);
var _barChart4Js = require("./icons/bar-chart-4.js");
var _barChart4JsDefault = parcelHelpers.interopDefault(_barChart4Js);
var _barChartBigJs = require("./icons/bar-chart-big.js");
var _barChartBigJsDefault = parcelHelpers.interopDefault(_barChartBigJs);
var _barChartHorizontalBigJs = require("./icons/bar-chart-horizontal-big.js");
var _barChartHorizontalBigJsDefault = parcelHelpers.interopDefault(_barChartHorizontalBigJs);
var _barChartHorizontalJs = require("./icons/bar-chart-horizontal.js");
var _barChartHorizontalJsDefault = parcelHelpers.interopDefault(_barChartHorizontalJs);
var _barChartJs = require("./icons/bar-chart.js");
var _barChartJsDefault = parcelHelpers.interopDefault(_barChartJs);
var _barcodeJs = require("./icons/barcode.js");
var _barcodeJsDefault = parcelHelpers.interopDefault(_barcodeJs);
var _baselineJs = require("./icons/baseline.js");
var _baselineJsDefault = parcelHelpers.interopDefault(_baselineJs);
var _bathJs = require("./icons/bath.js");
var _bathJsDefault = parcelHelpers.interopDefault(_bathJs);
var _batteryChargingJs = require("./icons/battery-charging.js");
var _batteryChargingJsDefault = parcelHelpers.interopDefault(_batteryChargingJs);
var _batteryFullJs = require("./icons/battery-full.js");
var _batteryFullJsDefault = parcelHelpers.interopDefault(_batteryFullJs);
var _batteryLowJs = require("./icons/battery-low.js");
var _batteryLowJsDefault = parcelHelpers.interopDefault(_batteryLowJs);
var _batteryMediumJs = require("./icons/battery-medium.js");
var _batteryMediumJsDefault = parcelHelpers.interopDefault(_batteryMediumJs);
var _batteryWarningJs = require("./icons/battery-warning.js");
var _batteryWarningJsDefault = parcelHelpers.interopDefault(_batteryWarningJs);
var _batteryJs = require("./icons/battery.js");
var _batteryJsDefault = parcelHelpers.interopDefault(_batteryJs);
var _beakerJs = require("./icons/beaker.js");
var _beakerJsDefault = parcelHelpers.interopDefault(_beakerJs);
var _beanOffJs = require("./icons/bean-off.js");
var _beanOffJsDefault = parcelHelpers.interopDefault(_beanOffJs);
var _beanJs = require("./icons/bean.js");
var _beanJsDefault = parcelHelpers.interopDefault(_beanJs);
var _bedDoubleJs = require("./icons/bed-double.js");
var _bedDoubleJsDefault = parcelHelpers.interopDefault(_bedDoubleJs);
var _bedSingleJs = require("./icons/bed-single.js");
var _bedSingleJsDefault = parcelHelpers.interopDefault(_bedSingleJs);
var _bedJs = require("./icons/bed.js");
var _bedJsDefault = parcelHelpers.interopDefault(_bedJs);
var _beefJs = require("./icons/beef.js");
var _beefJsDefault = parcelHelpers.interopDefault(_beefJs);
var _beerJs = require("./icons/beer.js");
var _beerJsDefault = parcelHelpers.interopDefault(_beerJs);
var _bellDotJs = require("./icons/bell-dot.js");
var _bellDotJsDefault = parcelHelpers.interopDefault(_bellDotJs);
var _bellElectricJs = require("./icons/bell-electric.js");
var _bellElectricJsDefault = parcelHelpers.interopDefault(_bellElectricJs);
var _bellMinusJs = require("./icons/bell-minus.js");
var _bellMinusJsDefault = parcelHelpers.interopDefault(_bellMinusJs);
var _bellOffJs = require("./icons/bell-off.js");
var _bellOffJsDefault = parcelHelpers.interopDefault(_bellOffJs);
var _bellPlusJs = require("./icons/bell-plus.js");
var _bellPlusJsDefault = parcelHelpers.interopDefault(_bellPlusJs);
var _bellRingJs = require("./icons/bell-ring.js");
var _bellRingJsDefault = parcelHelpers.interopDefault(_bellRingJs);
var _bellJs = require("./icons/bell.js");
var _bellJsDefault = parcelHelpers.interopDefault(_bellJs);
var _betweenVerticalEndJs = require("./icons/between-vertical-end.js");
var _betweenVerticalEndJsDefault = parcelHelpers.interopDefault(_betweenVerticalEndJs);
var _betweenVerticalStartJs = require("./icons/between-vertical-start.js");
var _betweenVerticalStartJsDefault = parcelHelpers.interopDefault(_betweenVerticalStartJs);
var _bikeJs = require("./icons/bike.js");
var _bikeJsDefault = parcelHelpers.interopDefault(_bikeJs);
var _binaryJs = require("./icons/binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _biohazardJs = require("./icons/biohazard.js");
var _biohazardJsDefault = parcelHelpers.interopDefault(_biohazardJs);
var _birdJs = require("./icons/bird.js");
var _birdJsDefault = parcelHelpers.interopDefault(_birdJs);
var _bitcoinJs = require("./icons/bitcoin.js");
var _bitcoinJsDefault = parcelHelpers.interopDefault(_bitcoinJs);
var _blendJs = require("./icons/blend.js");
var _blendJsDefault = parcelHelpers.interopDefault(_blendJs);
var _blindsJs = require("./icons/blinds.js");
var _blindsJsDefault = parcelHelpers.interopDefault(_blindsJs);
var _blocksJs = require("./icons/blocks.js");
var _blocksJsDefault = parcelHelpers.interopDefault(_blocksJs);
var _bluetoothConnectedJs = require("./icons/bluetooth-connected.js");
var _bluetoothConnectedJsDefault = parcelHelpers.interopDefault(_bluetoothConnectedJs);
var _bluetoothOffJs = require("./icons/bluetooth-off.js");
var _bluetoothOffJsDefault = parcelHelpers.interopDefault(_bluetoothOffJs);
var _bluetoothSearchingJs = require("./icons/bluetooth-searching.js");
var _bluetoothSearchingJsDefault = parcelHelpers.interopDefault(_bluetoothSearchingJs);
var _bluetoothJs = require("./icons/bluetooth.js");
var _bluetoothJsDefault = parcelHelpers.interopDefault(_bluetoothJs);
var _boldJs = require("./icons/bold.js");
var _boldJsDefault = parcelHelpers.interopDefault(_boldJs);
var _boltJs = require("./icons/bolt.js");
var _boltJsDefault = parcelHelpers.interopDefault(_boltJs);
var _bombJs = require("./icons/bomb.js");
var _bombJsDefault = parcelHelpers.interopDefault(_bombJs);
var _boneJs = require("./icons/bone.js");
var _boneJsDefault = parcelHelpers.interopDefault(_boneJs);
var _bookAJs = require("./icons/book-a.js");
var _bookAJsDefault = parcelHelpers.interopDefault(_bookAJs);
var _bookAudioJs = require("./icons/book-audio.js");
var _bookAudioJsDefault = parcelHelpers.interopDefault(_bookAudioJs);
var _bookCheckJs = require("./icons/book-check.js");
var _bookCheckJsDefault = parcelHelpers.interopDefault(_bookCheckJs);
var _bookCopyJs = require("./icons/book-copy.js");
var _bookCopyJsDefault = parcelHelpers.interopDefault(_bookCopyJs);
var _bookDownJs = require("./icons/book-down.js");
var _bookDownJsDefault = parcelHelpers.interopDefault(_bookDownJs);
var _bookHeadphonesJs = require("./icons/book-headphones.js");
var _bookHeadphonesJsDefault = parcelHelpers.interopDefault(_bookHeadphonesJs);
var _bookHeartJs = require("./icons/book-heart.js");
var _bookHeartJsDefault = parcelHelpers.interopDefault(_bookHeartJs);
var _bookImageJs = require("./icons/book-image.js");
var _bookImageJsDefault = parcelHelpers.interopDefault(_bookImageJs);
var _bookKeyJs = require("./icons/book-key.js");
var _bookKeyJsDefault = parcelHelpers.interopDefault(_bookKeyJs);
var _bookLockJs = require("./icons/book-lock.js");
var _bookLockJsDefault = parcelHelpers.interopDefault(_bookLockJs);
var _bookMarkedJs = require("./icons/book-marked.js");
var _bookMarkedJsDefault = parcelHelpers.interopDefault(_bookMarkedJs);
var _bookMinusJs = require("./icons/book-minus.js");
var _bookMinusJsDefault = parcelHelpers.interopDefault(_bookMinusJs);
var _bookOpenCheckJs = require("./icons/book-open-check.js");
var _bookOpenCheckJsDefault = parcelHelpers.interopDefault(_bookOpenCheckJs);
var _bookOpenTextJs = require("./icons/book-open-text.js");
var _bookOpenTextJsDefault = parcelHelpers.interopDefault(_bookOpenTextJs);
var _bookOpenJs = require("./icons/book-open.js");
var _bookOpenJsDefault = parcelHelpers.interopDefault(_bookOpenJs);
var _bookPlusJs = require("./icons/book-plus.js");
var _bookPlusJsDefault = parcelHelpers.interopDefault(_bookPlusJs);
var _bookTextJs = require("./icons/book-text.js");
var _bookTextJsDefault = parcelHelpers.interopDefault(_bookTextJs);
var _bookTypeJs = require("./icons/book-type.js");
var _bookTypeJsDefault = parcelHelpers.interopDefault(_bookTypeJs);
var _bookUp2Js = require("./icons/book-up-2.js");
var _bookUp2JsDefault = parcelHelpers.interopDefault(_bookUp2Js);
var _bookUpJs = require("./icons/book-up.js");
var _bookUpJsDefault = parcelHelpers.interopDefault(_bookUpJs);
var _bookUserJs = require("./icons/book-user.js");
var _bookUserJsDefault = parcelHelpers.interopDefault(_bookUserJs);
var _bookXJs = require("./icons/book-x.js");
var _bookXJsDefault = parcelHelpers.interopDefault(_bookXJs);
var _bookJs = require("./icons/book.js");
var _bookJsDefault = parcelHelpers.interopDefault(_bookJs);
var _bookmarkCheckJs = require("./icons/bookmark-check.js");
var _bookmarkCheckJsDefault = parcelHelpers.interopDefault(_bookmarkCheckJs);
var _bookmarkMinusJs = require("./icons/bookmark-minus.js");
var _bookmarkMinusJsDefault = parcelHelpers.interopDefault(_bookmarkMinusJs);
var _bookmarkPlusJs = require("./icons/bookmark-plus.js");
var _bookmarkPlusJsDefault = parcelHelpers.interopDefault(_bookmarkPlusJs);
var _bookmarkXJs = require("./icons/bookmark-x.js");
var _bookmarkXJsDefault = parcelHelpers.interopDefault(_bookmarkXJs);
var _bookmarkJs = require("./icons/bookmark.js");
var _bookmarkJsDefault = parcelHelpers.interopDefault(_bookmarkJs);
var _boomBoxJs = require("./icons/boom-box.js");
var _boomBoxJsDefault = parcelHelpers.interopDefault(_boomBoxJs);
var _botMessageSquareJs = require("./icons/bot-message-square.js");
var _botMessageSquareJsDefault = parcelHelpers.interopDefault(_botMessageSquareJs);
var _botJs = require("./icons/bot.js");
var _botJsDefault = parcelHelpers.interopDefault(_botJs);
var _boxSelectJs = require("./icons/box-select.js");
var _boxSelectJsDefault = parcelHelpers.interopDefault(_boxSelectJs);
var _boxJs = require("./icons/box.js");
var _boxJsDefault = parcelHelpers.interopDefault(_boxJs);
var _boxesJs = require("./icons/boxes.js");
var _boxesJsDefault = parcelHelpers.interopDefault(_boxesJs);
var _bracketsJs = require("./icons/brackets.js");
var _bracketsJsDefault = parcelHelpers.interopDefault(_bracketsJs);
var _brainCircuitJs = require("./icons/brain-circuit.js");
var _brainCircuitJsDefault = parcelHelpers.interopDefault(_brainCircuitJs);
var _brainCogJs = require("./icons/brain-cog.js");
var _brainCogJsDefault = parcelHelpers.interopDefault(_brainCogJs);
var _brainJs = require("./icons/brain.js");
var _brainJsDefault = parcelHelpers.interopDefault(_brainJs);
var _brickWallJs = require("./icons/brick-wall.js");
var _brickWallJsDefault = parcelHelpers.interopDefault(_brickWallJs);
var _briefcaseJs = require("./icons/briefcase.js");
var _briefcaseJsDefault = parcelHelpers.interopDefault(_briefcaseJs);
var _bringToFrontJs = require("./icons/bring-to-front.js");
var _bringToFrontJsDefault = parcelHelpers.interopDefault(_bringToFrontJs);
var _brushJs = require("./icons/brush.js");
var _brushJsDefault = parcelHelpers.interopDefault(_brushJs);
var _bugOffJs = require("./icons/bug-off.js");
var _bugOffJsDefault = parcelHelpers.interopDefault(_bugOffJs);
var _bugPlayJs = require("./icons/bug-play.js");
var _bugPlayJsDefault = parcelHelpers.interopDefault(_bugPlayJs);
var _bugJs = require("./icons/bug.js");
var _bugJsDefault = parcelHelpers.interopDefault(_bugJs);
var _building2Js = require("./icons/building-2.js");
var _building2JsDefault = parcelHelpers.interopDefault(_building2Js);
var _buildingJs = require("./icons/building.js");
var _buildingJsDefault = parcelHelpers.interopDefault(_buildingJs);
var _busFrontJs = require("./icons/bus-front.js");
var _busFrontJsDefault = parcelHelpers.interopDefault(_busFrontJs);
var _busJs = require("./icons/bus.js");
var _busJsDefault = parcelHelpers.interopDefault(_busJs);
var _cableCarJs = require("./icons/cable-car.js");
var _cableCarJsDefault = parcelHelpers.interopDefault(_cableCarJs);
var _cableJs = require("./icons/cable.js");
var _cableJsDefault = parcelHelpers.interopDefault(_cableJs);
var _cakeSliceJs = require("./icons/cake-slice.js");
var _cakeSliceJsDefault = parcelHelpers.interopDefault(_cakeSliceJs);
var _cakeJs = require("./icons/cake.js");
var _cakeJsDefault = parcelHelpers.interopDefault(_cakeJs);
var _calculatorJs = require("./icons/calculator.js");
var _calculatorJsDefault = parcelHelpers.interopDefault(_calculatorJs);
var _calendarCheck2Js = require("./icons/calendar-check-2.js");
var _calendarCheck2JsDefault = parcelHelpers.interopDefault(_calendarCheck2Js);
var _calendarCheckJs = require("./icons/calendar-check.js");
var _calendarCheckJsDefault = parcelHelpers.interopDefault(_calendarCheckJs);
var _calendarClockJs = require("./icons/calendar-clock.js");
var _calendarClockJsDefault = parcelHelpers.interopDefault(_calendarClockJs);
var _calendarDaysJs = require("./icons/calendar-days.js");
var _calendarDaysJsDefault = parcelHelpers.interopDefault(_calendarDaysJs);
var _calendarFoldJs = require("./icons/calendar-fold.js");
var _calendarFoldJsDefault = parcelHelpers.interopDefault(_calendarFoldJs);
var _calendarHeartJs = require("./icons/calendar-heart.js");
var _calendarHeartJsDefault = parcelHelpers.interopDefault(_calendarHeartJs);
var _calendarMinus2Js = require("./icons/calendar-minus-2.js");
var _calendarMinus2JsDefault = parcelHelpers.interopDefault(_calendarMinus2Js);
var _calendarMinusJs = require("./icons/calendar-minus.js");
var _calendarMinusJsDefault = parcelHelpers.interopDefault(_calendarMinusJs);
var _calendarOffJs = require("./icons/calendar-off.js");
var _calendarOffJsDefault = parcelHelpers.interopDefault(_calendarOffJs);
var _calendarPlus2Js = require("./icons/calendar-plus-2.js");
var _calendarPlus2JsDefault = parcelHelpers.interopDefault(_calendarPlus2Js);
var _calendarPlusJs = require("./icons/calendar-plus.js");
var _calendarPlusJsDefault = parcelHelpers.interopDefault(_calendarPlusJs);
var _calendarRangeJs = require("./icons/calendar-range.js");
var _calendarRangeJsDefault = parcelHelpers.interopDefault(_calendarRangeJs);
var _calendarSearchJs = require("./icons/calendar-search.js");
var _calendarSearchJsDefault = parcelHelpers.interopDefault(_calendarSearchJs);
var _calendarX2Js = require("./icons/calendar-x-2.js");
var _calendarX2JsDefault = parcelHelpers.interopDefault(_calendarX2Js);
var _calendarXJs = require("./icons/calendar-x.js");
var _calendarXJsDefault = parcelHelpers.interopDefault(_calendarXJs);
var _calendarJs = require("./icons/calendar.js");
var _calendarJsDefault = parcelHelpers.interopDefault(_calendarJs);
var _cameraOffJs = require("./icons/camera-off.js");
var _cameraOffJsDefault = parcelHelpers.interopDefault(_cameraOffJs);
var _cameraJs = require("./icons/camera.js");
var _cameraJsDefault = parcelHelpers.interopDefault(_cameraJs);
var _candlestickChartJs = require("./icons/candlestick-chart.js");
var _candlestickChartJsDefault = parcelHelpers.interopDefault(_candlestickChartJs);
var _candyCaneJs = require("./icons/candy-cane.js");
var _candyCaneJsDefault = parcelHelpers.interopDefault(_candyCaneJs);
var _candyOffJs = require("./icons/candy-off.js");
var _candyOffJsDefault = parcelHelpers.interopDefault(_candyOffJs);
var _candyJs = require("./icons/candy.js");
var _candyJsDefault = parcelHelpers.interopDefault(_candyJs);
var _captionsOffJs = require("./icons/captions-off.js");
var _captionsOffJsDefault = parcelHelpers.interopDefault(_captionsOffJs);
var _carFrontJs = require("./icons/car-front.js");
var _carFrontJsDefault = parcelHelpers.interopDefault(_carFrontJs);
var _carTaxiFrontJs = require("./icons/car-taxi-front.js");
var _carTaxiFrontJsDefault = parcelHelpers.interopDefault(_carTaxiFrontJs);
var _carJs = require("./icons/car.js");
var _carJsDefault = parcelHelpers.interopDefault(_carJs);
var _caravanJs = require("./icons/caravan.js");
var _caravanJsDefault = parcelHelpers.interopDefault(_caravanJs);
var _carrotJs = require("./icons/carrot.js");
var _carrotJsDefault = parcelHelpers.interopDefault(_carrotJs);
var _caseLowerJs = require("./icons/case-lower.js");
var _caseLowerJsDefault = parcelHelpers.interopDefault(_caseLowerJs);
var _caseSensitiveJs = require("./icons/case-sensitive.js");
var _caseSensitiveJsDefault = parcelHelpers.interopDefault(_caseSensitiveJs);
var _caseUpperJs = require("./icons/case-upper.js");
var _caseUpperJsDefault = parcelHelpers.interopDefault(_caseUpperJs);
var _cassetteTapeJs = require("./icons/cassette-tape.js");
var _cassetteTapeJsDefault = parcelHelpers.interopDefault(_cassetteTapeJs);
var _castJs = require("./icons/cast.js");
var _castJsDefault = parcelHelpers.interopDefault(_castJs);
var _castleJs = require("./icons/castle.js");
var _castleJsDefault = parcelHelpers.interopDefault(_castleJs);
var _catJs = require("./icons/cat.js");
var _catJsDefault = parcelHelpers.interopDefault(_catJs);
var _cctvJs = require("./icons/cctv.js");
var _cctvJsDefault = parcelHelpers.interopDefault(_cctvJs);
var _checkCheckJs = require("./icons/check-check.js");
var _checkCheckJsDefault = parcelHelpers.interopDefault(_checkCheckJs);
var _checkCircle2Js = require("./icons/check-circle-2.js");
var _checkCircle2JsDefault = parcelHelpers.interopDefault(_checkCircle2Js);
var _checkCircleJs = require("./icons/check-circle.js");
var _checkCircleJsDefault = parcelHelpers.interopDefault(_checkCircleJs);
var _checkSquare2Js = require("./icons/check-square-2.js");
var _checkSquare2JsDefault = parcelHelpers.interopDefault(_checkSquare2Js);
var _checkSquareJs = require("./icons/check-square.js");
var _checkSquareJsDefault = parcelHelpers.interopDefault(_checkSquareJs);
var _checkJs = require("./icons/check.js");
var _checkJsDefault = parcelHelpers.interopDefault(_checkJs);
var _chefHatJs = require("./icons/chef-hat.js");
var _chefHatJsDefault = parcelHelpers.interopDefault(_chefHatJs);
var _cherryJs = require("./icons/cherry.js");
var _cherryJsDefault = parcelHelpers.interopDefault(_cherryJs);
var _chevronDownCircleJs = require("./icons/chevron-down-circle.js");
var _chevronDownCircleJsDefault = parcelHelpers.interopDefault(_chevronDownCircleJs);
var _chevronDownSquareJs = require("./icons/chevron-down-square.js");
var _chevronDownSquareJsDefault = parcelHelpers.interopDefault(_chevronDownSquareJs);
var _chevronDownJs = require("./icons/chevron-down.js");
var _chevronDownJsDefault = parcelHelpers.interopDefault(_chevronDownJs);
var _chevronFirstJs = require("./icons/chevron-first.js");
var _chevronFirstJsDefault = parcelHelpers.interopDefault(_chevronFirstJs);
var _chevronLastJs = require("./icons/chevron-last.js");
var _chevronLastJsDefault = parcelHelpers.interopDefault(_chevronLastJs);
var _chevronLeftCircleJs = require("./icons/chevron-left-circle.js");
var _chevronLeftCircleJsDefault = parcelHelpers.interopDefault(_chevronLeftCircleJs);
var _chevronLeftSquareJs = require("./icons/chevron-left-square.js");
var _chevronLeftSquareJsDefault = parcelHelpers.interopDefault(_chevronLeftSquareJs);
var _chevronLeftJs = require("./icons/chevron-left.js");
var _chevronLeftJsDefault = parcelHelpers.interopDefault(_chevronLeftJs);
var _chevronRightCircleJs = require("./icons/chevron-right-circle.js");
var _chevronRightCircleJsDefault = parcelHelpers.interopDefault(_chevronRightCircleJs);
var _chevronRightSquareJs = require("./icons/chevron-right-square.js");
var _chevronRightSquareJsDefault = parcelHelpers.interopDefault(_chevronRightSquareJs);
var _chevronRightJs = require("./icons/chevron-right.js");
var _chevronRightJsDefault = parcelHelpers.interopDefault(_chevronRightJs);
var _chevronUpCircleJs = require("./icons/chevron-up-circle.js");
var _chevronUpCircleJsDefault = parcelHelpers.interopDefault(_chevronUpCircleJs);
var _chevronUpSquareJs = require("./icons/chevron-up-square.js");
var _chevronUpSquareJsDefault = parcelHelpers.interopDefault(_chevronUpSquareJs);
var _chevronUpJs = require("./icons/chevron-up.js");
var _chevronUpJsDefault = parcelHelpers.interopDefault(_chevronUpJs);
var _chevronsDownUpJs = require("./icons/chevrons-down-up.js");
var _chevronsDownUpJsDefault = parcelHelpers.interopDefault(_chevronsDownUpJs);
var _chevronsDownJs = require("./icons/chevrons-down.js");
var _chevronsDownJsDefault = parcelHelpers.interopDefault(_chevronsDownJs);
var _chevronsLeftRightJs = require("./icons/chevrons-left-right.js");
var _chevronsLeftRightJsDefault = parcelHelpers.interopDefault(_chevronsLeftRightJs);
var _chevronsLeftJs = require("./icons/chevrons-left.js");
var _chevronsLeftJsDefault = parcelHelpers.interopDefault(_chevronsLeftJs);
var _chevronsRightLeftJs = require("./icons/chevrons-right-left.js");
var _chevronsRightLeftJsDefault = parcelHelpers.interopDefault(_chevronsRightLeftJs);
var _chevronsRightJs = require("./icons/chevrons-right.js");
var _chevronsRightJsDefault = parcelHelpers.interopDefault(_chevronsRightJs);
var _chevronsUpDownJs = require("./icons/chevrons-up-down.js");
var _chevronsUpDownJsDefault = parcelHelpers.interopDefault(_chevronsUpDownJs);
var _chevronsUpJs = require("./icons/chevrons-up.js");
var _chevronsUpJsDefault = parcelHelpers.interopDefault(_chevronsUpJs);
var _chromeJs = require("./icons/chrome.js");
var _chromeJsDefault = parcelHelpers.interopDefault(_chromeJs);
var _churchJs = require("./icons/church.js");
var _churchJsDefault = parcelHelpers.interopDefault(_churchJs);
var _cigaretteOffJs = require("./icons/cigarette-off.js");
var _cigaretteOffJsDefault = parcelHelpers.interopDefault(_cigaretteOffJs);
var _cigaretteJs = require("./icons/cigarette.js");
var _cigaretteJsDefault = parcelHelpers.interopDefault(_cigaretteJs);
var _circleDashedJs = require("./icons/circle-dashed.js");
var _circleDashedJsDefault = parcelHelpers.interopDefault(_circleDashedJs);
var _circleDollarSignJs = require("./icons/circle-dollar-sign.js");
var _circleDollarSignJsDefault = parcelHelpers.interopDefault(_circleDollarSignJs);
var _circleDotDashedJs = require("./icons/circle-dot-dashed.js");
var _circleDotDashedJsDefault = parcelHelpers.interopDefault(_circleDotDashedJs);
var _circleDotJs = require("./icons/circle-dot.js");
var _circleDotJsDefault = parcelHelpers.interopDefault(_circleDotJs);
var _circleEllipsisJs = require("./icons/circle-ellipsis.js");
var _circleEllipsisJsDefault = parcelHelpers.interopDefault(_circleEllipsisJs);
var _circleEqualJs = require("./icons/circle-equal.js");
var _circleEqualJsDefault = parcelHelpers.interopDefault(_circleEqualJs);
var _circleFadingPlusJs = require("./icons/circle-fading-plus.js");
var _circleFadingPlusJsDefault = parcelHelpers.interopDefault(_circleFadingPlusJs);
var _circleOffJs = require("./icons/circle-off.js");
var _circleOffJsDefault = parcelHelpers.interopDefault(_circleOffJs);
var _circleSlashJs = require("./icons/circle-slash.js");
var _circleSlashJsDefault = parcelHelpers.interopDefault(_circleSlashJs);
var _circleJs = require("./icons/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _circuitBoardJs = require("./icons/circuit-board.js");
var _circuitBoardJsDefault = parcelHelpers.interopDefault(_circuitBoardJs);
var _citrusJs = require("./icons/citrus.js");
var _citrusJsDefault = parcelHelpers.interopDefault(_citrusJs);
var _clapperboardJs = require("./icons/clapperboard.js");
var _clapperboardJsDefault = parcelHelpers.interopDefault(_clapperboardJs);
var _clipboardCheckJs = require("./icons/clipboard-check.js");
var _clipboardCheckJsDefault = parcelHelpers.interopDefault(_clipboardCheckJs);
var _clipboardCopyJs = require("./icons/clipboard-copy.js");
var _clipboardCopyJsDefault = parcelHelpers.interopDefault(_clipboardCopyJs);
var _clipboardListJs = require("./icons/clipboard-list.js");
var _clipboardListJsDefault = parcelHelpers.interopDefault(_clipboardListJs);
var _clipboardMinusJs = require("./icons/clipboard-minus.js");
var _clipboardMinusJsDefault = parcelHelpers.interopDefault(_clipboardMinusJs);
var _clipboardPasteJs = require("./icons/clipboard-paste.js");
var _clipboardPasteJsDefault = parcelHelpers.interopDefault(_clipboardPasteJs);
var _clipboardPlusJs = require("./icons/clipboard-plus.js");
var _clipboardPlusJsDefault = parcelHelpers.interopDefault(_clipboardPlusJs);
var _clipboardTypeJs = require("./icons/clipboard-type.js");
var _clipboardTypeJsDefault = parcelHelpers.interopDefault(_clipboardTypeJs);
var _clipboardXJs = require("./icons/clipboard-x.js");
var _clipboardXJsDefault = parcelHelpers.interopDefault(_clipboardXJs);
var _clipboardJs = require("./icons/clipboard.js");
var _clipboardJsDefault = parcelHelpers.interopDefault(_clipboardJs);
var _clock1Js = require("./icons/clock-1.js");
var _clock1JsDefault = parcelHelpers.interopDefault(_clock1Js);
var _clock10Js = require("./icons/clock-10.js");
var _clock10JsDefault = parcelHelpers.interopDefault(_clock10Js);
var _clock11Js = require("./icons/clock-11.js");
var _clock11JsDefault = parcelHelpers.interopDefault(_clock11Js);
var _clock12Js = require("./icons/clock-12.js");
var _clock12JsDefault = parcelHelpers.interopDefault(_clock12Js);
var _clock2Js = require("./icons/clock-2.js");
var _clock2JsDefault = parcelHelpers.interopDefault(_clock2Js);
var _clock3Js = require("./icons/clock-3.js");
var _clock3JsDefault = parcelHelpers.interopDefault(_clock3Js);
var _clock4Js = require("./icons/clock-4.js");
var _clock4JsDefault = parcelHelpers.interopDefault(_clock4Js);
var _clock5Js = require("./icons/clock-5.js");
var _clock5JsDefault = parcelHelpers.interopDefault(_clock5Js);
var _clock6Js = require("./icons/clock-6.js");
var _clock6JsDefault = parcelHelpers.interopDefault(_clock6Js);
var _clock7Js = require("./icons/clock-7.js");
var _clock7JsDefault = parcelHelpers.interopDefault(_clock7Js);
var _clock8Js = require("./icons/clock-8.js");
var _clock8JsDefault = parcelHelpers.interopDefault(_clock8Js);
var _clock9Js = require("./icons/clock-9.js");
var _clock9JsDefault = parcelHelpers.interopDefault(_clock9Js);
var _clockJs = require("./icons/clock.js");
var _clockJsDefault = parcelHelpers.interopDefault(_clockJs);
var _cloudCogJs = require("./icons/cloud-cog.js");
var _cloudCogJsDefault = parcelHelpers.interopDefault(_cloudCogJs);
var _cloudDrizzleJs = require("./icons/cloud-drizzle.js");
var _cloudDrizzleJsDefault = parcelHelpers.interopDefault(_cloudDrizzleJs);
var _cloudFogJs = require("./icons/cloud-fog.js");
var _cloudFogJsDefault = parcelHelpers.interopDefault(_cloudFogJs);
var _cloudHailJs = require("./icons/cloud-hail.js");
var _cloudHailJsDefault = parcelHelpers.interopDefault(_cloudHailJs);
var _cloudLightningJs = require("./icons/cloud-lightning.js");
var _cloudLightningJsDefault = parcelHelpers.interopDefault(_cloudLightningJs);
var _cloudMoonRainJs = require("./icons/cloud-moon-rain.js");
var _cloudMoonRainJsDefault = parcelHelpers.interopDefault(_cloudMoonRainJs);
var _cloudMoonJs = require("./icons/cloud-moon.js");
var _cloudMoonJsDefault = parcelHelpers.interopDefault(_cloudMoonJs);
var _cloudOffJs = require("./icons/cloud-off.js");
var _cloudOffJsDefault = parcelHelpers.interopDefault(_cloudOffJs);
var _cloudRainWindJs = require("./icons/cloud-rain-wind.js");
var _cloudRainWindJsDefault = parcelHelpers.interopDefault(_cloudRainWindJs);
var _cloudRainJs = require("./icons/cloud-rain.js");
var _cloudRainJsDefault = parcelHelpers.interopDefault(_cloudRainJs);
var _cloudSnowJs = require("./icons/cloud-snow.js");
var _cloudSnowJsDefault = parcelHelpers.interopDefault(_cloudSnowJs);
var _cloudSunRainJs = require("./icons/cloud-sun-rain.js");
var _cloudSunRainJsDefault = parcelHelpers.interopDefault(_cloudSunRainJs);
var _cloudSunJs = require("./icons/cloud-sun.js");
var _cloudSunJsDefault = parcelHelpers.interopDefault(_cloudSunJs);
var _cloudJs = require("./icons/cloud.js");
var _cloudJsDefault = parcelHelpers.interopDefault(_cloudJs);
var _cloudyJs = require("./icons/cloudy.js");
var _cloudyJsDefault = parcelHelpers.interopDefault(_cloudyJs);
var _cloverJs = require("./icons/clover.js");
var _cloverJsDefault = parcelHelpers.interopDefault(_cloverJs);
var _clubJs = require("./icons/club.js");
var _clubJsDefault = parcelHelpers.interopDefault(_clubJs);
var _code2Js = require("./icons/code-2.js");
var _code2JsDefault = parcelHelpers.interopDefault(_code2Js);
var _codeJs = require("./icons/code.js");
var _codeJsDefault = parcelHelpers.interopDefault(_codeJs);
var _codepenJs = require("./icons/codepen.js");
var _codepenJsDefault = parcelHelpers.interopDefault(_codepenJs);
var _codesandboxJs = require("./icons/codesandbox.js");
var _codesandboxJsDefault = parcelHelpers.interopDefault(_codesandboxJs);
var _coffeeJs = require("./icons/coffee.js");
var _coffeeJsDefault = parcelHelpers.interopDefault(_coffeeJs);
var _cogJs = require("./icons/cog.js");
var _cogJsDefault = parcelHelpers.interopDefault(_cogJs);
var _coinsJs = require("./icons/coins.js");
var _coinsJsDefault = parcelHelpers.interopDefault(_coinsJs);
var _columns4Js = require("./icons/columns-4.js");
var _columns4JsDefault = parcelHelpers.interopDefault(_columns4Js);
var _combineJs = require("./icons/combine.js");
var _combineJsDefault = parcelHelpers.interopDefault(_combineJs);
var _commandJs = require("./icons/command.js");
var _commandJsDefault = parcelHelpers.interopDefault(_commandJs);
var _compassJs = require("./icons/compass.js");
var _compassJsDefault = parcelHelpers.interopDefault(_compassJs);
var _componentJs = require("./icons/component.js");
var _componentJsDefault = parcelHelpers.interopDefault(_componentJs);
var _computerJs = require("./icons/computer.js");
var _computerJsDefault = parcelHelpers.interopDefault(_computerJs);
var _conciergeBellJs = require("./icons/concierge-bell.js");
var _conciergeBellJsDefault = parcelHelpers.interopDefault(_conciergeBellJs);
var _coneJs = require("./icons/cone.js");
var _coneJsDefault = parcelHelpers.interopDefault(_coneJs);
var _constructionJs = require("./icons/construction.js");
var _constructionJsDefault = parcelHelpers.interopDefault(_constructionJs);
var _contact2Js = require("./icons/contact-2.js");
var _contact2JsDefault = parcelHelpers.interopDefault(_contact2Js);
var _contactJs = require("./icons/contact.js");
var _contactJsDefault = parcelHelpers.interopDefault(_contactJs);
var _containerJs = require("./icons/container.js");
var _containerJsDefault = parcelHelpers.interopDefault(_containerJs);
var _contrastJs = require("./icons/contrast.js");
var _contrastJsDefault = parcelHelpers.interopDefault(_contrastJs);
var _cookieJs = require("./icons/cookie.js");
var _cookieJsDefault = parcelHelpers.interopDefault(_cookieJs);
var _cookingPotJs = require("./icons/cooking-pot.js");
var _cookingPotJsDefault = parcelHelpers.interopDefault(_cookingPotJs);
var _copyCheckJs = require("./icons/copy-check.js");
var _copyCheckJsDefault = parcelHelpers.interopDefault(_copyCheckJs);
var _copyMinusJs = require("./icons/copy-minus.js");
var _copyMinusJsDefault = parcelHelpers.interopDefault(_copyMinusJs);
var _copyPlusJs = require("./icons/copy-plus.js");
var _copyPlusJsDefault = parcelHelpers.interopDefault(_copyPlusJs);
var _copySlashJs = require("./icons/copy-slash.js");
var _copySlashJsDefault = parcelHelpers.interopDefault(_copySlashJs);
var _copyXJs = require("./icons/copy-x.js");
var _copyXJsDefault = parcelHelpers.interopDefault(_copyXJs);
var _copyJs = require("./icons/copy.js");
var _copyJsDefault = parcelHelpers.interopDefault(_copyJs);
var _copyleftJs = require("./icons/copyleft.js");
var _copyleftJsDefault = parcelHelpers.interopDefault(_copyleftJs);
var _copyrightJs = require("./icons/copyright.js");
var _copyrightJsDefault = parcelHelpers.interopDefault(_copyrightJs);
var _cornerDownLeftJs = require("./icons/corner-down-left.js");
var _cornerDownLeftJsDefault = parcelHelpers.interopDefault(_cornerDownLeftJs);
var _cornerDownRightJs = require("./icons/corner-down-right.js");
var _cornerDownRightJsDefault = parcelHelpers.interopDefault(_cornerDownRightJs);
var _cornerLeftDownJs = require("./icons/corner-left-down.js");
var _cornerLeftDownJsDefault = parcelHelpers.interopDefault(_cornerLeftDownJs);
var _cornerLeftUpJs = require("./icons/corner-left-up.js");
var _cornerLeftUpJsDefault = parcelHelpers.interopDefault(_cornerLeftUpJs);
var _cornerRightDownJs = require("./icons/corner-right-down.js");
var _cornerRightDownJsDefault = parcelHelpers.interopDefault(_cornerRightDownJs);
var _cornerRightUpJs = require("./icons/corner-right-up.js");
var _cornerRightUpJsDefault = parcelHelpers.interopDefault(_cornerRightUpJs);
var _cornerUpLeftJs = require("./icons/corner-up-left.js");
var _cornerUpLeftJsDefault = parcelHelpers.interopDefault(_cornerUpLeftJs);
var _cornerUpRightJs = require("./icons/corner-up-right.js");
var _cornerUpRightJsDefault = parcelHelpers.interopDefault(_cornerUpRightJs);
var _cpuJs = require("./icons/cpu.js");
var _cpuJsDefault = parcelHelpers.interopDefault(_cpuJs);
var _creativeCommonsJs = require("./icons/creative-commons.js");
var _creativeCommonsJsDefault = parcelHelpers.interopDefault(_creativeCommonsJs);
var _creditCardJs = require("./icons/credit-card.js");
var _creditCardJsDefault = parcelHelpers.interopDefault(_creditCardJs);
var _croissantJs = require("./icons/croissant.js");
var _croissantJsDefault = parcelHelpers.interopDefault(_croissantJs);
var _cropJs = require("./icons/crop.js");
var _cropJsDefault = parcelHelpers.interopDefault(_cropJs);
var _crossJs = require("./icons/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _crosshairJs = require("./icons/crosshair.js");
var _crosshairJsDefault = parcelHelpers.interopDefault(_crosshairJs);
var _crownJs = require("./icons/crown.js");
var _crownJsDefault = parcelHelpers.interopDefault(_crownJs);
var _cuboidJs = require("./icons/cuboid.js");
var _cuboidJsDefault = parcelHelpers.interopDefault(_cuboidJs);
var _cupSodaJs = require("./icons/cup-soda.js");
var _cupSodaJsDefault = parcelHelpers.interopDefault(_cupSodaJs);
var _currencyJs = require("./icons/currency.js");
var _currencyJsDefault = parcelHelpers.interopDefault(_currencyJs);
var _cylinderJs = require("./icons/cylinder.js");
var _cylinderJsDefault = parcelHelpers.interopDefault(_cylinderJs);
var _databaseBackupJs = require("./icons/database-backup.js");
var _databaseBackupJsDefault = parcelHelpers.interopDefault(_databaseBackupJs);
var _databaseZapJs = require("./icons/database-zap.js");
var _databaseZapJsDefault = parcelHelpers.interopDefault(_databaseZapJs);
var _databaseJs = require("./icons/database.js");
var _databaseJsDefault = parcelHelpers.interopDefault(_databaseJs);
var _deleteJs = require("./icons/delete.js");
var _deleteJsDefault = parcelHelpers.interopDefault(_deleteJs);
var _dessertJs = require("./icons/dessert.js");
var _dessertJsDefault = parcelHelpers.interopDefault(_dessertJs);
var _diameterJs = require("./icons/diameter.js");
var _diameterJsDefault = parcelHelpers.interopDefault(_diameterJs);
var _diamondJs = require("./icons/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _dice1Js = require("./icons/dice-1.js");
var _dice1JsDefault = parcelHelpers.interopDefault(_dice1Js);
var _dice2Js = require("./icons/dice-2.js");
var _dice2JsDefault = parcelHelpers.interopDefault(_dice2Js);
var _dice3Js = require("./icons/dice-3.js");
var _dice3JsDefault = parcelHelpers.interopDefault(_dice3Js);
var _dice4Js = require("./icons/dice-4.js");
var _dice4JsDefault = parcelHelpers.interopDefault(_dice4Js);
var _dice5Js = require("./icons/dice-5.js");
var _dice5JsDefault = parcelHelpers.interopDefault(_dice5Js);
var _dice6Js = require("./icons/dice-6.js");
var _dice6JsDefault = parcelHelpers.interopDefault(_dice6Js);
var _dicesJs = require("./icons/dices.js");
var _dicesJsDefault = parcelHelpers.interopDefault(_dicesJs);
var _diffJs = require("./icons/diff.js");
var _diffJsDefault = parcelHelpers.interopDefault(_diffJs);
var _disc2Js = require("./icons/disc-2.js");
var _disc2JsDefault = parcelHelpers.interopDefault(_disc2Js);
var _disc3Js = require("./icons/disc-3.js");
var _disc3JsDefault = parcelHelpers.interopDefault(_disc3Js);
var _discAlbumJs = require("./icons/disc-album.js");
var _discAlbumJsDefault = parcelHelpers.interopDefault(_discAlbumJs);
var _discJs = require("./icons/disc.js");
var _discJsDefault = parcelHelpers.interopDefault(_discJs);
var _divideCircleJs = require("./icons/divide-circle.js");
var _divideCircleJsDefault = parcelHelpers.interopDefault(_divideCircleJs);
var _divideSquareJs = require("./icons/divide-square.js");
var _divideSquareJsDefault = parcelHelpers.interopDefault(_divideSquareJs);
var _divideJs = require("./icons/divide.js");
var _divideJsDefault = parcelHelpers.interopDefault(_divideJs);
var _dnaOffJs = require("./icons/dna-off.js");
var _dnaOffJsDefault = parcelHelpers.interopDefault(_dnaOffJs);
var _dnaJs = require("./icons/dna.js");
var _dnaJsDefault = parcelHelpers.interopDefault(_dnaJs);
var _dogJs = require("./icons/dog.js");
var _dogJsDefault = parcelHelpers.interopDefault(_dogJs);
var _dollarSignJs = require("./icons/dollar-sign.js");
var _dollarSignJsDefault = parcelHelpers.interopDefault(_dollarSignJs);
var _donutJs = require("./icons/donut.js");
var _donutJsDefault = parcelHelpers.interopDefault(_donutJs);
var _doorClosedJs = require("./icons/door-closed.js");
var _doorClosedJsDefault = parcelHelpers.interopDefault(_doorClosedJs);
var _doorOpenJs = require("./icons/door-open.js");
var _doorOpenJsDefault = parcelHelpers.interopDefault(_doorOpenJs);
var _dotJs = require("./icons/dot.js");
var _dotJsDefault = parcelHelpers.interopDefault(_dotJs);
var _downloadCloudJs = require("./icons/download-cloud.js");
var _downloadCloudJsDefault = parcelHelpers.interopDefault(_downloadCloudJs);
var _downloadJs = require("./icons/download.js");
var _downloadJsDefault = parcelHelpers.interopDefault(_downloadJs);
var _draftingCompassJs = require("./icons/drafting-compass.js");
var _draftingCompassJsDefault = parcelHelpers.interopDefault(_draftingCompassJs);
var _dramaJs = require("./icons/drama.js");
var _dramaJsDefault = parcelHelpers.interopDefault(_dramaJs);
var _dribbbleJs = require("./icons/dribbble.js");
var _dribbbleJsDefault = parcelHelpers.interopDefault(_dribbbleJs);
var _drillJs = require("./icons/drill.js");
var _drillJsDefault = parcelHelpers.interopDefault(_drillJs);
var _dropletJs = require("./icons/droplet.js");
var _dropletJsDefault = parcelHelpers.interopDefault(_dropletJs);
var _dropletsJs = require("./icons/droplets.js");
var _dropletsJsDefault = parcelHelpers.interopDefault(_dropletsJs);
var _drumJs = require("./icons/drum.js");
var _drumJsDefault = parcelHelpers.interopDefault(_drumJs);
var _drumstickJs = require("./icons/drumstick.js");
var _drumstickJsDefault = parcelHelpers.interopDefault(_drumstickJs);
var _dumbbellJs = require("./icons/dumbbell.js");
var _dumbbellJsDefault = parcelHelpers.interopDefault(_dumbbellJs);
var _earOffJs = require("./icons/ear-off.js");
var _earOffJsDefault = parcelHelpers.interopDefault(_earOffJs);
var _earJs = require("./icons/ear.js");
var _earJsDefault = parcelHelpers.interopDefault(_earJs);
var _earthLockJs = require("./icons/earth-lock.js");
var _earthLockJsDefault = parcelHelpers.interopDefault(_earthLockJs);
var _eclipseJs = require("./icons/eclipse.js");
var _eclipseJsDefault = parcelHelpers.interopDefault(_eclipseJs);
var _eggFriedJs = require("./icons/egg-fried.js");
var _eggFriedJsDefault = parcelHelpers.interopDefault(_eggFriedJs);
var _eggOffJs = require("./icons/egg-off.js");
var _eggOffJsDefault = parcelHelpers.interopDefault(_eggOffJs);
var _eggJs = require("./icons/egg.js");
var _eggJsDefault = parcelHelpers.interopDefault(_eggJs);
var _equalNotJs = require("./icons/equal-not.js");
var _equalNotJsDefault = parcelHelpers.interopDefault(_equalNotJs);
var _equalJs = require("./icons/equal.js");
var _equalJsDefault = parcelHelpers.interopDefault(_equalJs);
var _eraserJs = require("./icons/eraser.js");
var _eraserJsDefault = parcelHelpers.interopDefault(_eraserJs);
var _euroJs = require("./icons/euro.js");
var _euroJsDefault = parcelHelpers.interopDefault(_euroJs);
var _expandJs = require("./icons/expand.js");
var _expandJsDefault = parcelHelpers.interopDefault(_expandJs);
var _externalLinkJs = require("./icons/external-link.js");
var _externalLinkJsDefault = parcelHelpers.interopDefault(_externalLinkJs);
var _eyeOffJs = require("./icons/eye-off.js");
var _eyeOffJsDefault = parcelHelpers.interopDefault(_eyeOffJs);
var _eyeJs = require("./icons/eye.js");
var _eyeJsDefault = parcelHelpers.interopDefault(_eyeJs);
var _facebookJs = require("./icons/facebook.js");
var _facebookJsDefault = parcelHelpers.interopDefault(_facebookJs);
var _factoryJs = require("./icons/factory.js");
var _factoryJsDefault = parcelHelpers.interopDefault(_factoryJs);
var _fanJs = require("./icons/fan.js");
var _fanJsDefault = parcelHelpers.interopDefault(_fanJs);
var _fastForwardJs = require("./icons/fast-forward.js");
var _fastForwardJsDefault = parcelHelpers.interopDefault(_fastForwardJs);
var _featherJs = require("./icons/feather.js");
var _featherJsDefault = parcelHelpers.interopDefault(_featherJs);
var _fenceJs = require("./icons/fence.js");
var _fenceJsDefault = parcelHelpers.interopDefault(_fenceJs);
var _ferrisWheelJs = require("./icons/ferris-wheel.js");
var _ferrisWheelJsDefault = parcelHelpers.interopDefault(_ferrisWheelJs);
var _figmaJs = require("./icons/figma.js");
var _figmaJsDefault = parcelHelpers.interopDefault(_figmaJs);
var _fileArchiveJs = require("./icons/file-archive.js");
var _fileArchiveJsDefault = parcelHelpers.interopDefault(_fileArchiveJs);
var _fileAudio2Js = require("./icons/file-audio-2.js");
var _fileAudio2JsDefault = parcelHelpers.interopDefault(_fileAudio2Js);
var _fileAudioJs = require("./icons/file-audio.js");
var _fileAudioJsDefault = parcelHelpers.interopDefault(_fileAudioJs);
var _fileBadge2Js = require("./icons/file-badge-2.js");
var _fileBadge2JsDefault = parcelHelpers.interopDefault(_fileBadge2Js);
var _fileBadgeJs = require("./icons/file-badge.js");
var _fileBadgeJsDefault = parcelHelpers.interopDefault(_fileBadgeJs);
var _fileBarChart2Js = require("./icons/file-bar-chart-2.js");
var _fileBarChart2JsDefault = parcelHelpers.interopDefault(_fileBarChart2Js);
var _fileBarChartJs = require("./icons/file-bar-chart.js");
var _fileBarChartJsDefault = parcelHelpers.interopDefault(_fileBarChartJs);
var _fileBoxJs = require("./icons/file-box.js");
var _fileBoxJsDefault = parcelHelpers.interopDefault(_fileBoxJs);
var _fileCheck2Js = require("./icons/file-check-2.js");
var _fileCheck2JsDefault = parcelHelpers.interopDefault(_fileCheck2Js);
var _fileCheckJs = require("./icons/file-check.js");
var _fileCheckJsDefault = parcelHelpers.interopDefault(_fileCheckJs);
var _fileClockJs = require("./icons/file-clock.js");
var _fileClockJsDefault = parcelHelpers.interopDefault(_fileClockJs);
var _fileCode2Js = require("./icons/file-code-2.js");
var _fileCode2JsDefault = parcelHelpers.interopDefault(_fileCode2Js);
var _fileCodeJs = require("./icons/file-code.js");
var _fileCodeJsDefault = parcelHelpers.interopDefault(_fileCodeJs);
var _fileDiffJs = require("./icons/file-diff.js");
var _fileDiffJsDefault = parcelHelpers.interopDefault(_fileDiffJs);
var _fileDigitJs = require("./icons/file-digit.js");
var _fileDigitJsDefault = parcelHelpers.interopDefault(_fileDigitJs);
var _fileDownJs = require("./icons/file-down.js");
var _fileDownJsDefault = parcelHelpers.interopDefault(_fileDownJs);
var _fileHeartJs = require("./icons/file-heart.js");
var _fileHeartJsDefault = parcelHelpers.interopDefault(_fileHeartJs);
var _fileImageJs = require("./icons/file-image.js");
var _fileImageJsDefault = parcelHelpers.interopDefault(_fileImageJs);
var _fileInputJs = require("./icons/file-input.js");
var _fileInputJsDefault = parcelHelpers.interopDefault(_fileInputJs);
var _fileJson2Js = require("./icons/file-json-2.js");
var _fileJson2JsDefault = parcelHelpers.interopDefault(_fileJson2Js);
var _fileJsonJs = require("./icons/file-json.js");
var _fileJsonJsDefault = parcelHelpers.interopDefault(_fileJsonJs);
var _fileKey2Js = require("./icons/file-key-2.js");
var _fileKey2JsDefault = parcelHelpers.interopDefault(_fileKey2Js);
var _fileKeyJs = require("./icons/file-key.js");
var _fileKeyJsDefault = parcelHelpers.interopDefault(_fileKeyJs);
var _fileLineChartJs = require("./icons/file-line-chart.js");
var _fileLineChartJsDefault = parcelHelpers.interopDefault(_fileLineChartJs);
var _fileLock2Js = require("./icons/file-lock-2.js");
var _fileLock2JsDefault = parcelHelpers.interopDefault(_fileLock2Js);
var _fileLockJs = require("./icons/file-lock.js");
var _fileLockJsDefault = parcelHelpers.interopDefault(_fileLockJs);
var _fileMinus2Js = require("./icons/file-minus-2.js");
var _fileMinus2JsDefault = parcelHelpers.interopDefault(_fileMinus2Js);
var _fileMinusJs = require("./icons/file-minus.js");
var _fileMinusJsDefault = parcelHelpers.interopDefault(_fileMinusJs);
var _fileMusicJs = require("./icons/file-music.js");
var _fileMusicJsDefault = parcelHelpers.interopDefault(_fileMusicJs);
var _fileOutputJs = require("./icons/file-output.js");
var _fileOutputJsDefault = parcelHelpers.interopDefault(_fileOutputJs);
var _filePieChartJs = require("./icons/file-pie-chart.js");
var _filePieChartJsDefault = parcelHelpers.interopDefault(_filePieChartJs);
var _filePlus2Js = require("./icons/file-plus-2.js");
var _filePlus2JsDefault = parcelHelpers.interopDefault(_filePlus2Js);
var _filePlusJs = require("./icons/file-plus.js");
var _filePlusJsDefault = parcelHelpers.interopDefault(_filePlusJs);
var _fileQuestionJs = require("./icons/file-question.js");
var _fileQuestionJsDefault = parcelHelpers.interopDefault(_fileQuestionJs);
var _fileScanJs = require("./icons/file-scan.js");
var _fileScanJsDefault = parcelHelpers.interopDefault(_fileScanJs);
var _fileSearch2Js = require("./icons/file-search-2.js");
var _fileSearch2JsDefault = parcelHelpers.interopDefault(_fileSearch2Js);
var _fileSearchJs = require("./icons/file-search.js");
var _fileSearchJsDefault = parcelHelpers.interopDefault(_fileSearchJs);
var _fileSlidersJs = require("./icons/file-sliders.js");
var _fileSlidersJsDefault = parcelHelpers.interopDefault(_fileSlidersJs);
var _fileSpreadsheetJs = require("./icons/file-spreadsheet.js");
var _fileSpreadsheetJsDefault = parcelHelpers.interopDefault(_fileSpreadsheetJs);
var _fileStackJs = require("./icons/file-stack.js");
var _fileStackJsDefault = parcelHelpers.interopDefault(_fileStackJs);
var _fileSymlinkJs = require("./icons/file-symlink.js");
var _fileSymlinkJsDefault = parcelHelpers.interopDefault(_fileSymlinkJs);
var _fileTerminalJs = require("./icons/file-terminal.js");
var _fileTerminalJsDefault = parcelHelpers.interopDefault(_fileTerminalJs);
var _fileTextJs = require("./icons/file-text.js");
var _fileTextJsDefault = parcelHelpers.interopDefault(_fileTextJs);
var _fileType2Js = require("./icons/file-type-2.js");
var _fileType2JsDefault = parcelHelpers.interopDefault(_fileType2Js);
var _fileTypeJs = require("./icons/file-type.js");
var _fileTypeJsDefault = parcelHelpers.interopDefault(_fileTypeJs);
var _fileUpJs = require("./icons/file-up.js");
var _fileUpJsDefault = parcelHelpers.interopDefault(_fileUpJs);
var _fileVideo2Js = require("./icons/file-video-2.js");
var _fileVideo2JsDefault = parcelHelpers.interopDefault(_fileVideo2Js);
var _fileVideoJs = require("./icons/file-video.js");
var _fileVideoJsDefault = parcelHelpers.interopDefault(_fileVideoJs);
var _fileVolume2Js = require("./icons/file-volume-2.js");
var _fileVolume2JsDefault = parcelHelpers.interopDefault(_fileVolume2Js);
var _fileVolumeJs = require("./icons/file-volume.js");
var _fileVolumeJsDefault = parcelHelpers.interopDefault(_fileVolumeJs);
var _fileWarningJs = require("./icons/file-warning.js");
var _fileWarningJsDefault = parcelHelpers.interopDefault(_fileWarningJs);
var _fileX2Js = require("./icons/file-x-2.js");
var _fileX2JsDefault = parcelHelpers.interopDefault(_fileX2Js);
var _fileXJs = require("./icons/file-x.js");
var _fileXJsDefault = parcelHelpers.interopDefault(_fileXJs);
var _fileJs = require("./icons/file.js");
var _fileJsDefault = parcelHelpers.interopDefault(_fileJs);
var _filesJs = require("./icons/files.js");
var _filesJsDefault = parcelHelpers.interopDefault(_filesJs);
var _filmJs = require("./icons/film.js");
var _filmJsDefault = parcelHelpers.interopDefault(_filmJs);
var _filterXJs = require("./icons/filter-x.js");
var _filterXJsDefault = parcelHelpers.interopDefault(_filterXJs);
var _filterJs = require("./icons/filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _fingerprintJs = require("./icons/fingerprint.js");
var _fingerprintJsDefault = parcelHelpers.interopDefault(_fingerprintJs);
var _fireExtinguisherJs = require("./icons/fire-extinguisher.js");
var _fireExtinguisherJsDefault = parcelHelpers.interopDefault(_fireExtinguisherJs);
var _fishOffJs = require("./icons/fish-off.js");
var _fishOffJsDefault = parcelHelpers.interopDefault(_fishOffJs);
var _fishSymbolJs = require("./icons/fish-symbol.js");
var _fishSymbolJsDefault = parcelHelpers.interopDefault(_fishSymbolJs);
var _fishJs = require("./icons/fish.js");
var _fishJsDefault = parcelHelpers.interopDefault(_fishJs);
var _flagOffJs = require("./icons/flag-off.js");
var _flagOffJsDefault = parcelHelpers.interopDefault(_flagOffJs);
var _flagTriangleLeftJs = require("./icons/flag-triangle-left.js");
var _flagTriangleLeftJsDefault = parcelHelpers.interopDefault(_flagTriangleLeftJs);
var _flagTriangleRightJs = require("./icons/flag-triangle-right.js");
var _flagTriangleRightJsDefault = parcelHelpers.interopDefault(_flagTriangleRightJs);
var _flagJs = require("./icons/flag.js");
var _flagJsDefault = parcelHelpers.interopDefault(_flagJs);
var _flameKindlingJs = require("./icons/flame-kindling.js");
var _flameKindlingJsDefault = parcelHelpers.interopDefault(_flameKindlingJs);
var _flameJs = require("./icons/flame.js");
var _flameJsDefault = parcelHelpers.interopDefault(_flameJs);
var _flashlightOffJs = require("./icons/flashlight-off.js");
var _flashlightOffJsDefault = parcelHelpers.interopDefault(_flashlightOffJs);
var _flashlightJs = require("./icons/flashlight.js");
var _flashlightJsDefault = parcelHelpers.interopDefault(_flashlightJs);
var _flaskConicalOffJs = require("./icons/flask-conical-off.js");
var _flaskConicalOffJsDefault = parcelHelpers.interopDefault(_flaskConicalOffJs);
var _flaskConicalJs = require("./icons/flask-conical.js");
var _flaskConicalJsDefault = parcelHelpers.interopDefault(_flaskConicalJs);
var _flaskRoundJs = require("./icons/flask-round.js");
var _flaskRoundJsDefault = parcelHelpers.interopDefault(_flaskRoundJs);
var _flipHorizontal2Js = require("./icons/flip-horizontal-2.js");
var _flipHorizontal2JsDefault = parcelHelpers.interopDefault(_flipHorizontal2Js);
var _flipHorizontalJs = require("./icons/flip-horizontal.js");
var _flipHorizontalJsDefault = parcelHelpers.interopDefault(_flipHorizontalJs);
var _flipVertical2Js = require("./icons/flip-vertical-2.js");
var _flipVertical2JsDefault = parcelHelpers.interopDefault(_flipVertical2Js);
var _flipVerticalJs = require("./icons/flip-vertical.js");
var _flipVerticalJsDefault = parcelHelpers.interopDefault(_flipVerticalJs);
var _flower2Js = require("./icons/flower-2.js");
var _flower2JsDefault = parcelHelpers.interopDefault(_flower2Js);
var _flowerJs = require("./icons/flower.js");
var _flowerJsDefault = parcelHelpers.interopDefault(_flowerJs);
var _focusJs = require("./icons/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _foldHorizontalJs = require("./icons/fold-horizontal.js");
var _foldHorizontalJsDefault = parcelHelpers.interopDefault(_foldHorizontalJs);
var _foldVerticalJs = require("./icons/fold-vertical.js");
var _foldVerticalJsDefault = parcelHelpers.interopDefault(_foldVerticalJs);
var _folderArchiveJs = require("./icons/folder-archive.js");
var _folderArchiveJsDefault = parcelHelpers.interopDefault(_folderArchiveJs);
var _folderCheckJs = require("./icons/folder-check.js");
var _folderCheckJsDefault = parcelHelpers.interopDefault(_folderCheckJs);
var _folderClockJs = require("./icons/folder-clock.js");
var _folderClockJsDefault = parcelHelpers.interopDefault(_folderClockJs);
var _folderClosedJs = require("./icons/folder-closed.js");
var _folderClosedJsDefault = parcelHelpers.interopDefault(_folderClosedJs);
var _folderDotJs = require("./icons/folder-dot.js");
var _folderDotJsDefault = parcelHelpers.interopDefault(_folderDotJs);
var _folderDownJs = require("./icons/folder-down.js");
var _folderDownJsDefault = parcelHelpers.interopDefault(_folderDownJs);
var _folderGit2Js = require("./icons/folder-git-2.js");
var _folderGit2JsDefault = parcelHelpers.interopDefault(_folderGit2Js);
var _folderGitJs = require("./icons/folder-git.js");
var _folderGitJsDefault = parcelHelpers.interopDefault(_folderGitJs);
var _folderHeartJs = require("./icons/folder-heart.js");
var _folderHeartJsDefault = parcelHelpers.interopDefault(_folderHeartJs);
var _folderInputJs = require("./icons/folder-input.js");
var _folderInputJsDefault = parcelHelpers.interopDefault(_folderInputJs);
var _folderKanbanJs = require("./icons/folder-kanban.js");
var _folderKanbanJsDefault = parcelHelpers.interopDefault(_folderKanbanJs);
var _folderKeyJs = require("./icons/folder-key.js");
var _folderKeyJsDefault = parcelHelpers.interopDefault(_folderKeyJs);
var _folderLockJs = require("./icons/folder-lock.js");
var _folderLockJsDefault = parcelHelpers.interopDefault(_folderLockJs);
var _folderMinusJs = require("./icons/folder-minus.js");
var _folderMinusJsDefault = parcelHelpers.interopDefault(_folderMinusJs);
var _folderOpenDotJs = require("./icons/folder-open-dot.js");
var _folderOpenDotJsDefault = parcelHelpers.interopDefault(_folderOpenDotJs);
var _folderOpenJs = require("./icons/folder-open.js");
var _folderOpenJsDefault = parcelHelpers.interopDefault(_folderOpenJs);
var _folderOutputJs = require("./icons/folder-output.js");
var _folderOutputJsDefault = parcelHelpers.interopDefault(_folderOutputJs);
var _folderPlusJs = require("./icons/folder-plus.js");
var _folderPlusJsDefault = parcelHelpers.interopDefault(_folderPlusJs);
var _folderRootJs = require("./icons/folder-root.js");
var _folderRootJsDefault = parcelHelpers.interopDefault(_folderRootJs);
var _folderSearch2Js = require("./icons/folder-search-2.js");
var _folderSearch2JsDefault = parcelHelpers.interopDefault(_folderSearch2Js);
var _folderSearchJs = require("./icons/folder-search.js");
var _folderSearchJsDefault = parcelHelpers.interopDefault(_folderSearchJs);
var _folderSymlinkJs = require("./icons/folder-symlink.js");
var _folderSymlinkJsDefault = parcelHelpers.interopDefault(_folderSymlinkJs);
var _folderSyncJs = require("./icons/folder-sync.js");
var _folderSyncJsDefault = parcelHelpers.interopDefault(_folderSyncJs);
var _folderTreeJs = require("./icons/folder-tree.js");
var _folderTreeJsDefault = parcelHelpers.interopDefault(_folderTreeJs);
var _folderUpJs = require("./icons/folder-up.js");
var _folderUpJsDefault = parcelHelpers.interopDefault(_folderUpJs);
var _folderXJs = require("./icons/folder-x.js");
var _folderXJsDefault = parcelHelpers.interopDefault(_folderXJs);
var _folderJs = require("./icons/folder.js");
var _folderJsDefault = parcelHelpers.interopDefault(_folderJs);
var _foldersJs = require("./icons/folders.js");
var _foldersJsDefault = parcelHelpers.interopDefault(_foldersJs);
var _footprintsJs = require("./icons/footprints.js");
var _footprintsJsDefault = parcelHelpers.interopDefault(_footprintsJs);
var _forkliftJs = require("./icons/forklift.js");
var _forkliftJsDefault = parcelHelpers.interopDefault(_forkliftJs);
var _formInputJs = require("./icons/form-input.js");
var _formInputJsDefault = parcelHelpers.interopDefault(_formInputJs);
var _forwardJs = require("./icons/forward.js");
var _forwardJsDefault = parcelHelpers.interopDefault(_forwardJs);
var _frameJs = require("./icons/frame.js");
var _frameJsDefault = parcelHelpers.interopDefault(_frameJs);
var _framerJs = require("./icons/framer.js");
var _framerJsDefault = parcelHelpers.interopDefault(_framerJs);
var _frownJs = require("./icons/frown.js");
var _frownJsDefault = parcelHelpers.interopDefault(_frownJs);
var _fuelJs = require("./icons/fuel.js");
var _fuelJsDefault = parcelHelpers.interopDefault(_fuelJs);
var _fullscreenJs = require("./icons/fullscreen.js");
var _fullscreenJsDefault = parcelHelpers.interopDefault(_fullscreenJs);
var _functionSquareJs = require("./icons/function-square.js");
var _functionSquareJsDefault = parcelHelpers.interopDefault(_functionSquareJs);
var _galleryHorizontalEndJs = require("./icons/gallery-horizontal-end.js");
var _galleryHorizontalEndJsDefault = parcelHelpers.interopDefault(_galleryHorizontalEndJs);
var _galleryHorizontalJs = require("./icons/gallery-horizontal.js");
var _galleryHorizontalJsDefault = parcelHelpers.interopDefault(_galleryHorizontalJs);
var _galleryThumbnailsJs = require("./icons/gallery-thumbnails.js");
var _galleryThumbnailsJsDefault = parcelHelpers.interopDefault(_galleryThumbnailsJs);
var _galleryVerticalEndJs = require("./icons/gallery-vertical-end.js");
var _galleryVerticalEndJsDefault = parcelHelpers.interopDefault(_galleryVerticalEndJs);
var _galleryVerticalJs = require("./icons/gallery-vertical.js");
var _galleryVerticalJsDefault = parcelHelpers.interopDefault(_galleryVerticalJs);
var _gamepad2Js = require("./icons/gamepad-2.js");
var _gamepad2JsDefault = parcelHelpers.interopDefault(_gamepad2Js);
var _gamepadJs = require("./icons/gamepad.js");
var _gamepadJsDefault = parcelHelpers.interopDefault(_gamepadJs);
var _ganttChartJs = require("./icons/gantt-chart.js");
var _ganttChartJsDefault = parcelHelpers.interopDefault(_ganttChartJs);
var _gaugeCircleJs = require("./icons/gauge-circle.js");
var _gaugeCircleJsDefault = parcelHelpers.interopDefault(_gaugeCircleJs);
var _gaugeJs = require("./icons/gauge.js");
var _gaugeJsDefault = parcelHelpers.interopDefault(_gaugeJs);
var _gavelJs = require("./icons/gavel.js");
var _gavelJsDefault = parcelHelpers.interopDefault(_gavelJs);
var _gemJs = require("./icons/gem.js");
var _gemJsDefault = parcelHelpers.interopDefault(_gemJs);
var _ghostJs = require("./icons/ghost.js");
var _ghostJsDefault = parcelHelpers.interopDefault(_ghostJs);
var _giftJs = require("./icons/gift.js");
var _giftJsDefault = parcelHelpers.interopDefault(_giftJs);
var _gitBranchPlusJs = require("./icons/git-branch-plus.js");
var _gitBranchPlusJsDefault = parcelHelpers.interopDefault(_gitBranchPlusJs);
var _gitBranchJs = require("./icons/git-branch.js");
var _gitBranchJsDefault = parcelHelpers.interopDefault(_gitBranchJs);
var _gitCommitVerticalJs = require("./icons/git-commit-vertical.js");
var _gitCommitVerticalJsDefault = parcelHelpers.interopDefault(_gitCommitVerticalJs);
var _gitCompareArrowsJs = require("./icons/git-compare-arrows.js");
var _gitCompareArrowsJsDefault = parcelHelpers.interopDefault(_gitCompareArrowsJs);
var _gitCompareJs = require("./icons/git-compare.js");
var _gitCompareJsDefault = parcelHelpers.interopDefault(_gitCompareJs);
var _gitForkJs = require("./icons/git-fork.js");
var _gitForkJsDefault = parcelHelpers.interopDefault(_gitForkJs);
var _gitGraphJs = require("./icons/git-graph.js");
var _gitGraphJsDefault = parcelHelpers.interopDefault(_gitGraphJs);
var _gitMergeJs = require("./icons/git-merge.js");
var _gitMergeJsDefault = parcelHelpers.interopDefault(_gitMergeJs);
var _gitPullRequestArrowJs = require("./icons/git-pull-request-arrow.js");
var _gitPullRequestArrowJsDefault = parcelHelpers.interopDefault(_gitPullRequestArrowJs);
var _gitPullRequestClosedJs = require("./icons/git-pull-request-closed.js");
var _gitPullRequestClosedJsDefault = parcelHelpers.interopDefault(_gitPullRequestClosedJs);
var _gitPullRequestCreateArrowJs = require("./icons/git-pull-request-create-arrow.js");
var _gitPullRequestCreateArrowJsDefault = parcelHelpers.interopDefault(_gitPullRequestCreateArrowJs);
var _gitPullRequestCreateJs = require("./icons/git-pull-request-create.js");
var _gitPullRequestCreateJsDefault = parcelHelpers.interopDefault(_gitPullRequestCreateJs);
var _gitPullRequestDraftJs = require("./icons/git-pull-request-draft.js");
var _gitPullRequestDraftJsDefault = parcelHelpers.interopDefault(_gitPullRequestDraftJs);
var _gitPullRequestJs = require("./icons/git-pull-request.js");
var _gitPullRequestJsDefault = parcelHelpers.interopDefault(_gitPullRequestJs);
var _githubJs = require("./icons/github.js");
var _githubJsDefault = parcelHelpers.interopDefault(_githubJs);
var _gitlabJs = require("./icons/gitlab.js");
var _gitlabJsDefault = parcelHelpers.interopDefault(_gitlabJs);
var _glassWaterJs = require("./icons/glass-water.js");
var _glassWaterJsDefault = parcelHelpers.interopDefault(_glassWaterJs);
var _glassesJs = require("./icons/glasses.js");
var _glassesJsDefault = parcelHelpers.interopDefault(_glassesJs);
var _globeLockJs = require("./icons/globe-lock.js");
var _globeLockJsDefault = parcelHelpers.interopDefault(_globeLockJs);
var _globeJs = require("./icons/globe.js");
var _globeJsDefault = parcelHelpers.interopDefault(_globeJs);
var _goalJs = require("./icons/goal.js");
var _goalJsDefault = parcelHelpers.interopDefault(_goalJs);
var _grabJs = require("./icons/grab.js");
var _grabJsDefault = parcelHelpers.interopDefault(_grabJs);
var _graduationCapJs = require("./icons/graduation-cap.js");
var _graduationCapJsDefault = parcelHelpers.interopDefault(_graduationCapJs);
var _grapeJs = require("./icons/grape.js");
var _grapeJsDefault = parcelHelpers.interopDefault(_grapeJs);
var _gripHorizontalJs = require("./icons/grip-horizontal.js");
var _gripHorizontalJsDefault = parcelHelpers.interopDefault(_gripHorizontalJs);
var _gripVerticalJs = require("./icons/grip-vertical.js");
var _gripVerticalJsDefault = parcelHelpers.interopDefault(_gripVerticalJs);
var _gripJs = require("./icons/grip.js");
var _gripJsDefault = parcelHelpers.interopDefault(_gripJs);
var _groupJs = require("./icons/group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _guitarJs = require("./icons/guitar.js");
var _guitarJsDefault = parcelHelpers.interopDefault(_guitarJs);
var _hammerJs = require("./icons/hammer.js");
var _hammerJsDefault = parcelHelpers.interopDefault(_hammerJs);
var _handCoinsJs = require("./icons/hand-coins.js");
var _handCoinsJsDefault = parcelHelpers.interopDefault(_handCoinsJs);
var _handHeartJs = require("./icons/hand-heart.js");
var _handHeartJsDefault = parcelHelpers.interopDefault(_handHeartJs);
var _handMetalJs = require("./icons/hand-metal.js");
var _handMetalJsDefault = parcelHelpers.interopDefault(_handMetalJs);
var _handPlatterJs = require("./icons/hand-platter.js");
var _handPlatterJsDefault = parcelHelpers.interopDefault(_handPlatterJs);
var _handJs = require("./icons/hand.js");
var _handJsDefault = parcelHelpers.interopDefault(_handJs);
var _handshakeJs = require("./icons/handshake.js");
var _handshakeJsDefault = parcelHelpers.interopDefault(_handshakeJs);
var _hardDriveDownloadJs = require("./icons/hard-drive-download.js");
var _hardDriveDownloadJsDefault = parcelHelpers.interopDefault(_hardDriveDownloadJs);
var _hardDriveUploadJs = require("./icons/hard-drive-upload.js");
var _hardDriveUploadJsDefault = parcelHelpers.interopDefault(_hardDriveUploadJs);
var _hardDriveJs = require("./icons/hard-drive.js");
var _hardDriveJsDefault = parcelHelpers.interopDefault(_hardDriveJs);
var _hardHatJs = require("./icons/hard-hat.js");
var _hardHatJsDefault = parcelHelpers.interopDefault(_hardHatJs);
var _hashJs = require("./icons/hash.js");
var _hashJsDefault = parcelHelpers.interopDefault(_hashJs);
var _hazeJs = require("./icons/haze.js");
var _hazeJsDefault = parcelHelpers.interopDefault(_hazeJs);
var _hdmiPortJs = require("./icons/hdmi-port.js");
var _hdmiPortJsDefault = parcelHelpers.interopDefault(_hdmiPortJs);
var _heading1Js = require("./icons/heading-1.js");
var _heading1JsDefault = parcelHelpers.interopDefault(_heading1Js);
var _heading2Js = require("./icons/heading-2.js");
var _heading2JsDefault = parcelHelpers.interopDefault(_heading2Js);
var _heading3Js = require("./icons/heading-3.js");
var _heading3JsDefault = parcelHelpers.interopDefault(_heading3Js);
var _heading4Js = require("./icons/heading-4.js");
var _heading4JsDefault = parcelHelpers.interopDefault(_heading4Js);
var _heading5Js = require("./icons/heading-5.js");
var _heading5JsDefault = parcelHelpers.interopDefault(_heading5Js);
var _heading6Js = require("./icons/heading-6.js");
var _heading6JsDefault = parcelHelpers.interopDefault(_heading6Js);
var _headingJs = require("./icons/heading.js");
var _headingJsDefault = parcelHelpers.interopDefault(_headingJs);
var _headphonesJs = require("./icons/headphones.js");
var _headphonesJsDefault = parcelHelpers.interopDefault(_headphonesJs);
var _headsetJs = require("./icons/headset.js");
var _headsetJsDefault = parcelHelpers.interopDefault(_headsetJs);
var _heartCrackJs = require("./icons/heart-crack.js");
var _heartCrackJsDefault = parcelHelpers.interopDefault(_heartCrackJs);
var _heartHandshakeJs = require("./icons/heart-handshake.js");
var _heartHandshakeJsDefault = parcelHelpers.interopDefault(_heartHandshakeJs);
var _heartOffJs = require("./icons/heart-off.js");
var _heartOffJsDefault = parcelHelpers.interopDefault(_heartOffJs);
var _heartPulseJs = require("./icons/heart-pulse.js");
var _heartPulseJsDefault = parcelHelpers.interopDefault(_heartPulseJs);
var _heartJs = require("./icons/heart.js");
var _heartJsDefault = parcelHelpers.interopDefault(_heartJs);
var _heaterJs = require("./icons/heater.js");
var _heaterJsDefault = parcelHelpers.interopDefault(_heaterJs);
var _helpCircleJs = require("./icons/help-circle.js");
var _helpCircleJsDefault = parcelHelpers.interopDefault(_helpCircleJs);
var _hexagonJs = require("./icons/hexagon.js");
var _hexagonJsDefault = parcelHelpers.interopDefault(_hexagonJs);
var _highlighterJs = require("./icons/highlighter.js");
var _highlighterJsDefault = parcelHelpers.interopDefault(_highlighterJs);
var _historyJs = require("./icons/history.js");
var _historyJsDefault = parcelHelpers.interopDefault(_historyJs);
var _homeJs = require("./icons/home.js");
var _homeJsDefault = parcelHelpers.interopDefault(_homeJs);
var _hopOffJs = require("./icons/hop-off.js");
var _hopOffJsDefault = parcelHelpers.interopDefault(_hopOffJs);
var _hopJs = require("./icons/hop.js");
var _hopJsDefault = parcelHelpers.interopDefault(_hopJs);
var _hotelJs = require("./icons/hotel.js");
var _hotelJsDefault = parcelHelpers.interopDefault(_hotelJs);
var _hourglassJs = require("./icons/hourglass.js");
var _hourglassJsDefault = parcelHelpers.interopDefault(_hourglassJs);
var _iceCream2Js = require("./icons/ice-cream-2.js");
var _iceCream2JsDefault = parcelHelpers.interopDefault(_iceCream2Js);
var _iceCreamJs = require("./icons/ice-cream.js");
var _iceCreamJsDefault = parcelHelpers.interopDefault(_iceCreamJs);
var _imageDownJs = require("./icons/image-down.js");
var _imageDownJsDefault = parcelHelpers.interopDefault(_imageDownJs);
var _imageMinusJs = require("./icons/image-minus.js");
var _imageMinusJsDefault = parcelHelpers.interopDefault(_imageMinusJs);
var _imageOffJs = require("./icons/image-off.js");
var _imageOffJsDefault = parcelHelpers.interopDefault(_imageOffJs);
var _imagePlusJs = require("./icons/image-plus.js");
var _imagePlusJsDefault = parcelHelpers.interopDefault(_imagePlusJs);
var _imageUpJs = require("./icons/image-up.js");
var _imageUpJsDefault = parcelHelpers.interopDefault(_imageUpJs);
var _imageJs = require("./icons/image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs);
var _imagesJs = require("./icons/images.js");
var _imagesJsDefault = parcelHelpers.interopDefault(_imagesJs);
var _importJs = require("./icons/import.js");
var _importJsDefault = parcelHelpers.interopDefault(_importJs);
var _inboxJs = require("./icons/inbox.js");
var _inboxJsDefault = parcelHelpers.interopDefault(_inboxJs);
var _indentJs = require("./icons/indent.js");
var _indentJsDefault = parcelHelpers.interopDefault(_indentJs);
var _indianRupeeJs = require("./icons/indian-rupee.js");
var _indianRupeeJsDefault = parcelHelpers.interopDefault(_indianRupeeJs);
var _infinityJs = require("./icons/infinity.js");
var _infinityJsDefault = parcelHelpers.interopDefault(_infinityJs);
var _infoJs = require("./icons/info.js");
var _infoJsDefault = parcelHelpers.interopDefault(_infoJs);
var _inspectionPanelJs = require("./icons/inspection-panel.js");
var _inspectionPanelJsDefault = parcelHelpers.interopDefault(_inspectionPanelJs);
var _instagramJs = require("./icons/instagram.js");
var _instagramJsDefault = parcelHelpers.interopDefault(_instagramJs);
var _italicJs = require("./icons/italic.js");
var _italicJsDefault = parcelHelpers.interopDefault(_italicJs);
var _iterationCcwJs = require("./icons/iteration-ccw.js");
var _iterationCcwJsDefault = parcelHelpers.interopDefault(_iterationCcwJs);
var _iterationCwJs = require("./icons/iteration-cw.js");
var _iterationCwJsDefault = parcelHelpers.interopDefault(_iterationCwJs);
var _japaneseYenJs = require("./icons/japanese-yen.js");
var _japaneseYenJsDefault = parcelHelpers.interopDefault(_japaneseYenJs);
var _joystickJs = require("./icons/joystick.js");
var _joystickJsDefault = parcelHelpers.interopDefault(_joystickJs);
var _kanbanJs = require("./icons/kanban.js");
var _kanbanJsDefault = parcelHelpers.interopDefault(_kanbanJs);
var _keyRoundJs = require("./icons/key-round.js");
var _keyRoundJsDefault = parcelHelpers.interopDefault(_keyRoundJs);
var _keySquareJs = require("./icons/key-square.js");
var _keySquareJsDefault = parcelHelpers.interopDefault(_keySquareJs);
var _keyJs = require("./icons/key.js");
var _keyJsDefault = parcelHelpers.interopDefault(_keyJs);
var _keyboardMusicJs = require("./icons/keyboard-music.js");
var _keyboardMusicJsDefault = parcelHelpers.interopDefault(_keyboardMusicJs);
var _keyboardJs = require("./icons/keyboard.js");
var _keyboardJsDefault = parcelHelpers.interopDefault(_keyboardJs);
var _lampCeilingJs = require("./icons/lamp-ceiling.js");
var _lampCeilingJsDefault = parcelHelpers.interopDefault(_lampCeilingJs);
var _lampDeskJs = require("./icons/lamp-desk.js");
var _lampDeskJsDefault = parcelHelpers.interopDefault(_lampDeskJs);
var _lampFloorJs = require("./icons/lamp-floor.js");
var _lampFloorJsDefault = parcelHelpers.interopDefault(_lampFloorJs);
var _lampWallDownJs = require("./icons/lamp-wall-down.js");
var _lampWallDownJsDefault = parcelHelpers.interopDefault(_lampWallDownJs);
var _lampWallUpJs = require("./icons/lamp-wall-up.js");
var _lampWallUpJsDefault = parcelHelpers.interopDefault(_lampWallUpJs);
var _lampJs = require("./icons/lamp.js");
var _lampJsDefault = parcelHelpers.interopDefault(_lampJs);
var _landPlotJs = require("./icons/land-plot.js");
var _landPlotJsDefault = parcelHelpers.interopDefault(_landPlotJs);
var _landmarkJs = require("./icons/landmark.js");
var _landmarkJsDefault = parcelHelpers.interopDefault(_landmarkJs);
var _languagesJs = require("./icons/languages.js");
var _languagesJsDefault = parcelHelpers.interopDefault(_languagesJs);
var _laptop2Js = require("./icons/laptop-2.js");
var _laptop2JsDefault = parcelHelpers.interopDefault(_laptop2Js);
var _laptopJs = require("./icons/laptop.js");
var _laptopJsDefault = parcelHelpers.interopDefault(_laptopJs);
var _lassoSelectJs = require("./icons/lasso-select.js");
var _lassoSelectJsDefault = parcelHelpers.interopDefault(_lassoSelectJs);
var _lassoJs = require("./icons/lasso.js");
var _lassoJsDefault = parcelHelpers.interopDefault(_lassoJs);
var _laughJs = require("./icons/laugh.js");
var _laughJsDefault = parcelHelpers.interopDefault(_laughJs);
var _layers2Js = require("./icons/layers-2.js");
var _layers2JsDefault = parcelHelpers.interopDefault(_layers2Js);
var _layers3Js = require("./icons/layers-3.js");
var _layers3JsDefault = parcelHelpers.interopDefault(_layers3Js);
var _layersJs = require("./icons/layers.js");
var _layersJsDefault = parcelHelpers.interopDefault(_layersJs);
var _layoutDashboardJs = require("./icons/layout-dashboard.js");
var _layoutDashboardJsDefault = parcelHelpers.interopDefault(_layoutDashboardJs);
var _layoutGridJs = require("./icons/layout-grid.js");
var _layoutGridJsDefault = parcelHelpers.interopDefault(_layoutGridJs);
var _layoutListJs = require("./icons/layout-list.js");
var _layoutListJsDefault = parcelHelpers.interopDefault(_layoutListJs);
var _layoutPanelLeftJs = require("./icons/layout-panel-left.js");
var _layoutPanelLeftJsDefault = parcelHelpers.interopDefault(_layoutPanelLeftJs);
var _layoutPanelTopJs = require("./icons/layout-panel-top.js");
var _layoutPanelTopJsDefault = parcelHelpers.interopDefault(_layoutPanelTopJs);
var _layoutTemplateJs = require("./icons/layout-template.js");
var _layoutTemplateJsDefault = parcelHelpers.interopDefault(_layoutTemplateJs);
var _leafJs = require("./icons/leaf.js");
var _leafJsDefault = parcelHelpers.interopDefault(_leafJs);
var _leafyGreenJs = require("./icons/leafy-green.js");
var _leafyGreenJsDefault = parcelHelpers.interopDefault(_leafyGreenJs);
var _libraryBigJs = require("./icons/library-big.js");
var _libraryBigJsDefault = parcelHelpers.interopDefault(_libraryBigJs);
var _librarySquareJs = require("./icons/library-square.js");
var _librarySquareJsDefault = parcelHelpers.interopDefault(_librarySquareJs);
var _libraryJs = require("./icons/library.js");
var _libraryJsDefault = parcelHelpers.interopDefault(_libraryJs);
var _lifeBuoyJs = require("./icons/life-buoy.js");
var _lifeBuoyJsDefault = parcelHelpers.interopDefault(_lifeBuoyJs);
var _ligatureJs = require("./icons/ligature.js");
var _ligatureJsDefault = parcelHelpers.interopDefault(_ligatureJs);
var _lightbulbOffJs = require("./icons/lightbulb-off.js");
var _lightbulbOffJsDefault = parcelHelpers.interopDefault(_lightbulbOffJs);
var _lightbulbJs = require("./icons/lightbulb.js");
var _lightbulbJsDefault = parcelHelpers.interopDefault(_lightbulbJs);
var _lineChartJs = require("./icons/line-chart.js");
var _lineChartJsDefault = parcelHelpers.interopDefault(_lineChartJs);
var _link2OffJs = require("./icons/link-2-off.js");
var _link2OffJsDefault = parcelHelpers.interopDefault(_link2OffJs);
var _link2Js = require("./icons/link-2.js");
var _link2JsDefault = parcelHelpers.interopDefault(_link2Js);
var _linkJs = require("./icons/link.js");
var _linkJsDefault = parcelHelpers.interopDefault(_linkJs);
var _linkedinJs = require("./icons/linkedin.js");
var _linkedinJsDefault = parcelHelpers.interopDefault(_linkedinJs);
var _listChecksJs = require("./icons/list-checks.js");
var _listChecksJsDefault = parcelHelpers.interopDefault(_listChecksJs);
var _listCollapseJs = require("./icons/list-collapse.js");
var _listCollapseJsDefault = parcelHelpers.interopDefault(_listCollapseJs);
var _listEndJs = require("./icons/list-end.js");
var _listEndJsDefault = parcelHelpers.interopDefault(_listEndJs);
var _listFilterJs = require("./icons/list-filter.js");
var _listFilterJsDefault = parcelHelpers.interopDefault(_listFilterJs);
var _listMinusJs = require("./icons/list-minus.js");
var _listMinusJsDefault = parcelHelpers.interopDefault(_listMinusJs);
var _listMusicJs = require("./icons/list-music.js");
var _listMusicJsDefault = parcelHelpers.interopDefault(_listMusicJs);
var _listOrderedJs = require("./icons/list-ordered.js");
var _listOrderedJsDefault = parcelHelpers.interopDefault(_listOrderedJs);
var _listPlusJs = require("./icons/list-plus.js");
var _listPlusJsDefault = parcelHelpers.interopDefault(_listPlusJs);
var _listRestartJs = require("./icons/list-restart.js");
var _listRestartJsDefault = parcelHelpers.interopDefault(_listRestartJs);
var _listStartJs = require("./icons/list-start.js");
var _listStartJsDefault = parcelHelpers.interopDefault(_listStartJs);
var _listTodoJs = require("./icons/list-todo.js");
var _listTodoJsDefault = parcelHelpers.interopDefault(_listTodoJs);
var _listTreeJs = require("./icons/list-tree.js");
var _listTreeJsDefault = parcelHelpers.interopDefault(_listTreeJs);
var _listVideoJs = require("./icons/list-video.js");
var _listVideoJsDefault = parcelHelpers.interopDefault(_listVideoJs);
var _listXJs = require("./icons/list-x.js");
var _listXJsDefault = parcelHelpers.interopDefault(_listXJs);
var _listJs = require("./icons/list.js");
var _listJsDefault = parcelHelpers.interopDefault(_listJs);
var _loader2Js = require("./icons/loader-2.js");
var _loader2JsDefault = parcelHelpers.interopDefault(_loader2Js);
var _loaderJs = require("./icons/loader.js");
var _loaderJsDefault = parcelHelpers.interopDefault(_loaderJs);
var _locateFixedJs = require("./icons/locate-fixed.js");
var _locateFixedJsDefault = parcelHelpers.interopDefault(_locateFixedJs);
var _locateOffJs = require("./icons/locate-off.js");
var _locateOffJsDefault = parcelHelpers.interopDefault(_locateOffJs);
var _locateJs = require("./icons/locate.js");
var _locateJsDefault = parcelHelpers.interopDefault(_locateJs);
var _lockKeyholeJs = require("./icons/lock-keyhole.js");
var _lockKeyholeJsDefault = parcelHelpers.interopDefault(_lockKeyholeJs);
var _lockJs = require("./icons/lock.js");
var _lockJsDefault = parcelHelpers.interopDefault(_lockJs);
var _logInJs = require("./icons/log-in.js");
var _logInJsDefault = parcelHelpers.interopDefault(_logInJs);
var _logOutJs = require("./icons/log-out.js");
var _logOutJsDefault = parcelHelpers.interopDefault(_logOutJs);
var _lollipopJs = require("./icons/lollipop.js");
var _lollipopJsDefault = parcelHelpers.interopDefault(_lollipopJs);
var _luggageJs = require("./icons/luggage.js");
var _luggageJsDefault = parcelHelpers.interopDefault(_luggageJs);
var _mSquareJs = require("./icons/m-square.js");
var _mSquareJsDefault = parcelHelpers.interopDefault(_mSquareJs);
var _magnetJs = require("./icons/magnet.js");
var _magnetJsDefault = parcelHelpers.interopDefault(_magnetJs);
var _mailCheckJs = require("./icons/mail-check.js");
var _mailCheckJsDefault = parcelHelpers.interopDefault(_mailCheckJs);
var _mailMinusJs = require("./icons/mail-minus.js");
var _mailMinusJsDefault = parcelHelpers.interopDefault(_mailMinusJs);
var _mailOpenJs = require("./icons/mail-open.js");
var _mailOpenJsDefault = parcelHelpers.interopDefault(_mailOpenJs);
var _mailPlusJs = require("./icons/mail-plus.js");
var _mailPlusJsDefault = parcelHelpers.interopDefault(_mailPlusJs);
var _mailQuestionJs = require("./icons/mail-question.js");
var _mailQuestionJsDefault = parcelHelpers.interopDefault(_mailQuestionJs);
var _mailSearchJs = require("./icons/mail-search.js");
var _mailSearchJsDefault = parcelHelpers.interopDefault(_mailSearchJs);
var _mailWarningJs = require("./icons/mail-warning.js");
var _mailWarningJsDefault = parcelHelpers.interopDefault(_mailWarningJs);
var _mailXJs = require("./icons/mail-x.js");
var _mailXJsDefault = parcelHelpers.interopDefault(_mailXJs);
var _mailJs = require("./icons/mail.js");
var _mailJsDefault = parcelHelpers.interopDefault(_mailJs);
var _mailboxJs = require("./icons/mailbox.js");
var _mailboxJsDefault = parcelHelpers.interopDefault(_mailboxJs);
var _mailsJs = require("./icons/mails.js");
var _mailsJsDefault = parcelHelpers.interopDefault(_mailsJs);
var _mapPinOffJs = require("./icons/map-pin-off.js");
var _mapPinOffJsDefault = parcelHelpers.interopDefault(_mapPinOffJs);
var _mapPinJs = require("./icons/map-pin.js");
var _mapPinJsDefault = parcelHelpers.interopDefault(_mapPinJs);
var _mapPinnedJs = require("./icons/map-pinned.js");
var _mapPinnedJsDefault = parcelHelpers.interopDefault(_mapPinnedJs);
var _mapJs = require("./icons/map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _martiniJs = require("./icons/martini.js");
var _martiniJsDefault = parcelHelpers.interopDefault(_martiniJs);
var _maximize2Js = require("./icons/maximize-2.js");
var _maximize2JsDefault = parcelHelpers.interopDefault(_maximize2Js);
var _maximizeJs = require("./icons/maximize.js");
var _maximizeJsDefault = parcelHelpers.interopDefault(_maximizeJs);
var _medalJs = require("./icons/medal.js");
var _medalJsDefault = parcelHelpers.interopDefault(_medalJs);
var _megaphoneOffJs = require("./icons/megaphone-off.js");
var _megaphoneOffJsDefault = parcelHelpers.interopDefault(_megaphoneOffJs);
var _megaphoneJs = require("./icons/megaphone.js");
var _megaphoneJsDefault = parcelHelpers.interopDefault(_megaphoneJs);
var _mehJs = require("./icons/meh.js");
var _mehJsDefault = parcelHelpers.interopDefault(_mehJs);
var _memoryStickJs = require("./icons/memory-stick.js");
var _memoryStickJsDefault = parcelHelpers.interopDefault(_memoryStickJs);
var _menuSquareJs = require("./icons/menu-square.js");
var _menuSquareJsDefault = parcelHelpers.interopDefault(_menuSquareJs);
var _menuJs = require("./icons/menu.js");
var _menuJsDefault = parcelHelpers.interopDefault(_menuJs);
var _mergeJs = require("./icons/merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _messageCircleCodeJs = require("./icons/message-circle-code.js");
var _messageCircleCodeJsDefault = parcelHelpers.interopDefault(_messageCircleCodeJs);
var _messageCircleDashedJs = require("./icons/message-circle-dashed.js");
var _messageCircleDashedJsDefault = parcelHelpers.interopDefault(_messageCircleDashedJs);
var _messageCircleHeartJs = require("./icons/message-circle-heart.js");
var _messageCircleHeartJsDefault = parcelHelpers.interopDefault(_messageCircleHeartJs);
var _messageCircleMoreJs = require("./icons/message-circle-more.js");
var _messageCircleMoreJsDefault = parcelHelpers.interopDefault(_messageCircleMoreJs);
var _messageCircleOffJs = require("./icons/message-circle-off.js");
var _messageCircleOffJsDefault = parcelHelpers.interopDefault(_messageCircleOffJs);
var _messageCirclePlusJs = require("./icons/message-circle-plus.js");
var _messageCirclePlusJsDefault = parcelHelpers.interopDefault(_messageCirclePlusJs);
var _messageCircleQuestionJs = require("./icons/message-circle-question.js");
var _messageCircleQuestionJsDefault = parcelHelpers.interopDefault(_messageCircleQuestionJs);
var _messageCircleReplyJs = require("./icons/message-circle-reply.js");
var _messageCircleReplyJsDefault = parcelHelpers.interopDefault(_messageCircleReplyJs);
var _messageCircleWarningJs = require("./icons/message-circle-warning.js");
var _messageCircleWarningJsDefault = parcelHelpers.interopDefault(_messageCircleWarningJs);
var _messageCircleXJs = require("./icons/message-circle-x.js");
var _messageCircleXJsDefault = parcelHelpers.interopDefault(_messageCircleXJs);
var _messageCircleJs = require("./icons/message-circle.js");
var _messageCircleJsDefault = parcelHelpers.interopDefault(_messageCircleJs);
var _messageSquareCodeJs = require("./icons/message-square-code.js");
var _messageSquareCodeJsDefault = parcelHelpers.interopDefault(_messageSquareCodeJs);
var _messageSquareDashedJs = require("./icons/message-square-dashed.js");
var _messageSquareDashedJsDefault = parcelHelpers.interopDefault(_messageSquareDashedJs);
var _messageSquareDiffJs = require("./icons/message-square-diff.js");
var _messageSquareDiffJsDefault = parcelHelpers.interopDefault(_messageSquareDiffJs);
var _messageSquareDotJs = require("./icons/message-square-dot.js");
var _messageSquareDotJsDefault = parcelHelpers.interopDefault(_messageSquareDotJs);
var _messageSquareHeartJs = require("./icons/message-square-heart.js");
var _messageSquareHeartJsDefault = parcelHelpers.interopDefault(_messageSquareHeartJs);
var _messageSquareMoreJs = require("./icons/message-square-more.js");
var _messageSquareMoreJsDefault = parcelHelpers.interopDefault(_messageSquareMoreJs);
var _messageSquareOffJs = require("./icons/message-square-off.js");
var _messageSquareOffJsDefault = parcelHelpers.interopDefault(_messageSquareOffJs);
var _messageSquarePlusJs = require("./icons/message-square-plus.js");
var _messageSquarePlusJsDefault = parcelHelpers.interopDefault(_messageSquarePlusJs);
var _messageSquareQuoteJs = require("./icons/message-square-quote.js");
var _messageSquareQuoteJsDefault = parcelHelpers.interopDefault(_messageSquareQuoteJs);
var _messageSquareReplyJs = require("./icons/message-square-reply.js");
var _messageSquareReplyJsDefault = parcelHelpers.interopDefault(_messageSquareReplyJs);
var _messageSquareShareJs = require("./icons/message-square-share.js");
var _messageSquareShareJsDefault = parcelHelpers.interopDefault(_messageSquareShareJs);
var _messageSquareTextJs = require("./icons/message-square-text.js");
var _messageSquareTextJsDefault = parcelHelpers.interopDefault(_messageSquareTextJs);
var _messageSquareWarningJs = require("./icons/message-square-warning.js");
var _messageSquareWarningJsDefault = parcelHelpers.interopDefault(_messageSquareWarningJs);
var _messageSquareXJs = require("./icons/message-square-x.js");
var _messageSquareXJsDefault = parcelHelpers.interopDefault(_messageSquareXJs);
var _messageSquareJs = require("./icons/message-square.js");
var _messageSquareJsDefault = parcelHelpers.interopDefault(_messageSquareJs);
var _messagesSquareJs = require("./icons/messages-square.js");
var _messagesSquareJsDefault = parcelHelpers.interopDefault(_messagesSquareJs);
var _mic2Js = require("./icons/mic-2.js");
var _mic2JsDefault = parcelHelpers.interopDefault(_mic2Js);
var _micOffJs = require("./icons/mic-off.js");
var _micOffJsDefault = parcelHelpers.interopDefault(_micOffJs);
var _micJs = require("./icons/mic.js");
var _micJsDefault = parcelHelpers.interopDefault(_micJs);
var _microscopeJs = require("./icons/microscope.js");
var _microscopeJsDefault = parcelHelpers.interopDefault(_microscopeJs);
var _microwaveJs = require("./icons/microwave.js");
var _microwaveJsDefault = parcelHelpers.interopDefault(_microwaveJs);
var _milestoneJs = require("./icons/milestone.js");
var _milestoneJsDefault = parcelHelpers.interopDefault(_milestoneJs);
var _milkOffJs = require("./icons/milk-off.js");
var _milkOffJsDefault = parcelHelpers.interopDefault(_milkOffJs);
var _milkJs = require("./icons/milk.js");
var _milkJsDefault = parcelHelpers.interopDefault(_milkJs);
var _minimize2Js = require("./icons/minimize-2.js");
var _minimize2JsDefault = parcelHelpers.interopDefault(_minimize2Js);
var _minimizeJs = require("./icons/minimize.js");
var _minimizeJsDefault = parcelHelpers.interopDefault(_minimizeJs);
var _minusCircleJs = require("./icons/minus-circle.js");
var _minusCircleJsDefault = parcelHelpers.interopDefault(_minusCircleJs);
var _minusSquareJs = require("./icons/minus-square.js");
var _minusSquareJsDefault = parcelHelpers.interopDefault(_minusSquareJs);
var _minusJs = require("./icons/minus.js");
var _minusJsDefault = parcelHelpers.interopDefault(_minusJs);
var _monitorCheckJs = require("./icons/monitor-check.js");
var _monitorCheckJsDefault = parcelHelpers.interopDefault(_monitorCheckJs);
var _monitorDotJs = require("./icons/monitor-dot.js");
var _monitorDotJsDefault = parcelHelpers.interopDefault(_monitorDotJs);
var _monitorDownJs = require("./icons/monitor-down.js");
var _monitorDownJsDefault = parcelHelpers.interopDefault(_monitorDownJs);
var _monitorOffJs = require("./icons/monitor-off.js");
var _monitorOffJsDefault = parcelHelpers.interopDefault(_monitorOffJs);
var _monitorPauseJs = require("./icons/monitor-pause.js");
var _monitorPauseJsDefault = parcelHelpers.interopDefault(_monitorPauseJs);
var _monitorPlayJs = require("./icons/monitor-play.js");
var _monitorPlayJsDefault = parcelHelpers.interopDefault(_monitorPlayJs);
var _monitorSmartphoneJs = require("./icons/monitor-smartphone.js");
var _monitorSmartphoneJsDefault = parcelHelpers.interopDefault(_monitorSmartphoneJs);
var _monitorSpeakerJs = require("./icons/monitor-speaker.js");
var _monitorSpeakerJsDefault = parcelHelpers.interopDefault(_monitorSpeakerJs);
var _monitorStopJs = require("./icons/monitor-stop.js");
var _monitorStopJsDefault = parcelHelpers.interopDefault(_monitorStopJs);
var _monitorUpJs = require("./icons/monitor-up.js");
var _monitorUpJsDefault = parcelHelpers.interopDefault(_monitorUpJs);
var _monitorXJs = require("./icons/monitor-x.js");
var _monitorXJsDefault = parcelHelpers.interopDefault(_monitorXJs);
var _monitorJs = require("./icons/monitor.js");
var _monitorJsDefault = parcelHelpers.interopDefault(_monitorJs);
var _moonStarJs = require("./icons/moon-star.js");
var _moonStarJsDefault = parcelHelpers.interopDefault(_moonStarJs);
var _moonJs = require("./icons/moon.js");
var _moonJsDefault = parcelHelpers.interopDefault(_moonJs);
var _moreHorizontalJs = require("./icons/more-horizontal.js");
var _moreHorizontalJsDefault = parcelHelpers.interopDefault(_moreHorizontalJs);
var _moreVerticalJs = require("./icons/more-vertical.js");
var _moreVerticalJsDefault = parcelHelpers.interopDefault(_moreVerticalJs);
var _mountainSnowJs = require("./icons/mountain-snow.js");
var _mountainSnowJsDefault = parcelHelpers.interopDefault(_mountainSnowJs);
var _mountainJs = require("./icons/mountain.js");
var _mountainJsDefault = parcelHelpers.interopDefault(_mountainJs);
var _mousePointer2Js = require("./icons/mouse-pointer-2.js");
var _mousePointer2JsDefault = parcelHelpers.interopDefault(_mousePointer2Js);
var _mousePointerClickJs = require("./icons/mouse-pointer-click.js");
var _mousePointerClickJsDefault = parcelHelpers.interopDefault(_mousePointerClickJs);
var _mousePointerSquareDashedJs = require("./icons/mouse-pointer-square-dashed.js");
var _mousePointerSquareDashedJsDefault = parcelHelpers.interopDefault(_mousePointerSquareDashedJs);
var _mousePointerJs = require("./icons/mouse-pointer.js");
var _mousePointerJsDefault = parcelHelpers.interopDefault(_mousePointerJs);
var _mouseJs = require("./icons/mouse.js");
var _mouseJsDefault = parcelHelpers.interopDefault(_mouseJs);
var _moveDiagonal2Js = require("./icons/move-diagonal-2.js");
var _moveDiagonal2JsDefault = parcelHelpers.interopDefault(_moveDiagonal2Js);
var _moveDiagonalJs = require("./icons/move-diagonal.js");
var _moveDiagonalJsDefault = parcelHelpers.interopDefault(_moveDiagonalJs);
var _moveDownLeftJs = require("./icons/move-down-left.js");
var _moveDownLeftJsDefault = parcelHelpers.interopDefault(_moveDownLeftJs);
var _moveDownRightJs = require("./icons/move-down-right.js");
var _moveDownRightJsDefault = parcelHelpers.interopDefault(_moveDownRightJs);
var _moveDownJs = require("./icons/move-down.js");
var _moveDownJsDefault = parcelHelpers.interopDefault(_moveDownJs);
var _moveHorizontalJs = require("./icons/move-horizontal.js");
var _moveHorizontalJsDefault = parcelHelpers.interopDefault(_moveHorizontalJs);
var _moveLeftJs = require("./icons/move-left.js");
var _moveLeftJsDefault = parcelHelpers.interopDefault(_moveLeftJs);
var _moveRightJs = require("./icons/move-right.js");
var _moveRightJsDefault = parcelHelpers.interopDefault(_moveRightJs);
var _moveUpLeftJs = require("./icons/move-up-left.js");
var _moveUpLeftJsDefault = parcelHelpers.interopDefault(_moveUpLeftJs);
var _moveUpRightJs = require("./icons/move-up-right.js");
var _moveUpRightJsDefault = parcelHelpers.interopDefault(_moveUpRightJs);
var _moveUpJs = require("./icons/move-up.js");
var _moveUpJsDefault = parcelHelpers.interopDefault(_moveUpJs);
var _moveVerticalJs = require("./icons/move-vertical.js");
var _moveVerticalJsDefault = parcelHelpers.interopDefault(_moveVerticalJs);
var _moveJs = require("./icons/move.js");
var _moveJsDefault = parcelHelpers.interopDefault(_moveJs);
var _music2Js = require("./icons/music-2.js");
var _music2JsDefault = parcelHelpers.interopDefault(_music2Js);
var _music3Js = require("./icons/music-3.js");
var _music3JsDefault = parcelHelpers.interopDefault(_music3Js);
var _music4Js = require("./icons/music-4.js");
var _music4JsDefault = parcelHelpers.interopDefault(_music4Js);
var _musicJs = require("./icons/music.js");
var _musicJsDefault = parcelHelpers.interopDefault(_musicJs);
var _navigation2OffJs = require("./icons/navigation-2-off.js");
var _navigation2OffJsDefault = parcelHelpers.interopDefault(_navigation2OffJs);
var _navigation2Js = require("./icons/navigation-2.js");
var _navigation2JsDefault = parcelHelpers.interopDefault(_navigation2Js);
var _navigationOffJs = require("./icons/navigation-off.js");
var _navigationOffJsDefault = parcelHelpers.interopDefault(_navigationOffJs);
var _navigationJs = require("./icons/navigation.js");
var _navigationJsDefault = parcelHelpers.interopDefault(_navigationJs);
var _networkJs = require("./icons/network.js");
var _networkJsDefault = parcelHelpers.interopDefault(_networkJs);
var _newspaperJs = require("./icons/newspaper.js");
var _newspaperJsDefault = parcelHelpers.interopDefault(_newspaperJs);
var _nfcJs = require("./icons/nfc.js");
var _nfcJsDefault = parcelHelpers.interopDefault(_nfcJs);
var _notebookPenJs = require("./icons/notebook-pen.js");
var _notebookPenJsDefault = parcelHelpers.interopDefault(_notebookPenJs);
var _notebookTabsJs = require("./icons/notebook-tabs.js");
var _notebookTabsJsDefault = parcelHelpers.interopDefault(_notebookTabsJs);
var _notebookTextJs = require("./icons/notebook-text.js");
var _notebookTextJsDefault = parcelHelpers.interopDefault(_notebookTextJs);
var _notebookJs = require("./icons/notebook.js");
var _notebookJsDefault = parcelHelpers.interopDefault(_notebookJs);
var _notepadTextDashedJs = require("./icons/notepad-text-dashed.js");
var _notepadTextDashedJsDefault = parcelHelpers.interopDefault(_notepadTextDashedJs);
var _notepadTextJs = require("./icons/notepad-text.js");
var _notepadTextJsDefault = parcelHelpers.interopDefault(_notepadTextJs);
var _nutOffJs = require("./icons/nut-off.js");
var _nutOffJsDefault = parcelHelpers.interopDefault(_nutOffJs);
var _nutJs = require("./icons/nut.js");
var _nutJsDefault = parcelHelpers.interopDefault(_nutJs);
var _octagonJs = require("./icons/octagon.js");
var _octagonJsDefault = parcelHelpers.interopDefault(_octagonJs);
var _optionJs = require("./icons/option.js");
var _optionJsDefault = parcelHelpers.interopDefault(_optionJs);
var _orbitJs = require("./icons/orbit.js");
var _orbitJsDefault = parcelHelpers.interopDefault(_orbitJs);
var _outdentJs = require("./icons/outdent.js");
var _outdentJsDefault = parcelHelpers.interopDefault(_outdentJs);
var _package2Js = require("./icons/package-2.js");
var _package2JsDefault = parcelHelpers.interopDefault(_package2Js);
var _packageCheckJs = require("./icons/package-check.js");
var _packageCheckJsDefault = parcelHelpers.interopDefault(_packageCheckJs);
var _packageMinusJs = require("./icons/package-minus.js");
var _packageMinusJsDefault = parcelHelpers.interopDefault(_packageMinusJs);
var _packageOpenJs = require("./icons/package-open.js");
var _packageOpenJsDefault = parcelHelpers.interopDefault(_packageOpenJs);
var _packagePlusJs = require("./icons/package-plus.js");
var _packagePlusJsDefault = parcelHelpers.interopDefault(_packagePlusJs);
var _packageSearchJs = require("./icons/package-search.js");
var _packageSearchJsDefault = parcelHelpers.interopDefault(_packageSearchJs);
var _packageXJs = require("./icons/package-x.js");
var _packageXJsDefault = parcelHelpers.interopDefault(_packageXJs);
var _packageJs = require("./icons/package.js");
var _packageJsDefault = parcelHelpers.interopDefault(_packageJs);
var _paintBucketJs = require("./icons/paint-bucket.js");
var _paintBucketJsDefault = parcelHelpers.interopDefault(_paintBucketJs);
var _paintRollerJs = require("./icons/paint-roller.js");
var _paintRollerJsDefault = parcelHelpers.interopDefault(_paintRollerJs);
var _paintbrush2Js = require("./icons/paintbrush-2.js");
var _paintbrush2JsDefault = parcelHelpers.interopDefault(_paintbrush2Js);
var _paintbrushJs = require("./icons/paintbrush.js");
var _paintbrushJsDefault = parcelHelpers.interopDefault(_paintbrushJs);
var _paletteJs = require("./icons/palette.js");
var _paletteJsDefault = parcelHelpers.interopDefault(_paletteJs);
var _palmtreeJs = require("./icons/palmtree.js");
var _palmtreeJsDefault = parcelHelpers.interopDefault(_palmtreeJs);
var _panelBottomCloseJs = require("./icons/panel-bottom-close.js");
var _panelBottomCloseJsDefault = parcelHelpers.interopDefault(_panelBottomCloseJs);
var _panelBottomOpenJs = require("./icons/panel-bottom-open.js");
var _panelBottomOpenJsDefault = parcelHelpers.interopDefault(_panelBottomOpenJs);
var _panelBottomJs = require("./icons/panel-bottom.js");
var _panelBottomJsDefault = parcelHelpers.interopDefault(_panelBottomJs);
var _panelRightCloseJs = require("./icons/panel-right-close.js");
var _panelRightCloseJsDefault = parcelHelpers.interopDefault(_panelRightCloseJs);
var _panelRightOpenJs = require("./icons/panel-right-open.js");
var _panelRightOpenJsDefault = parcelHelpers.interopDefault(_panelRightOpenJs);
var _panelRightJs = require("./icons/panel-right.js");
var _panelRightJsDefault = parcelHelpers.interopDefault(_panelRightJs);
var _panelTopCloseJs = require("./icons/panel-top-close.js");
var _panelTopCloseJsDefault = parcelHelpers.interopDefault(_panelTopCloseJs);
var _panelTopOpenJs = require("./icons/panel-top-open.js");
var _panelTopOpenJsDefault = parcelHelpers.interopDefault(_panelTopOpenJs);
var _panelTopJs = require("./icons/panel-top.js");
var _panelTopJsDefault = parcelHelpers.interopDefault(_panelTopJs);
var _panelsLeftBottomJs = require("./icons/panels-left-bottom.js");
var _panelsLeftBottomJsDefault = parcelHelpers.interopDefault(_panelsLeftBottomJs);
var _panelsRightBottomJs = require("./icons/panels-right-bottom.js");
var _panelsRightBottomJsDefault = parcelHelpers.interopDefault(_panelsRightBottomJs);
var _paperclipJs = require("./icons/paperclip.js");
var _paperclipJsDefault = parcelHelpers.interopDefault(_paperclipJs);
var _parenthesesJs = require("./icons/parentheses.js");
var _parenthesesJsDefault = parcelHelpers.interopDefault(_parenthesesJs);
var _parkingCircleOffJs = require("./icons/parking-circle-off.js");
var _parkingCircleOffJsDefault = parcelHelpers.interopDefault(_parkingCircleOffJs);
var _parkingCircleJs = require("./icons/parking-circle.js");
var _parkingCircleJsDefault = parcelHelpers.interopDefault(_parkingCircleJs);
var _parkingMeterJs = require("./icons/parking-meter.js");
var _parkingMeterJsDefault = parcelHelpers.interopDefault(_parkingMeterJs);
var _parkingSquareOffJs = require("./icons/parking-square-off.js");
var _parkingSquareOffJsDefault = parcelHelpers.interopDefault(_parkingSquareOffJs);
var _parkingSquareJs = require("./icons/parking-square.js");
var _parkingSquareJsDefault = parcelHelpers.interopDefault(_parkingSquareJs);
var _partyPopperJs = require("./icons/party-popper.js");
var _partyPopperJsDefault = parcelHelpers.interopDefault(_partyPopperJs);
var _pauseCircleJs = require("./icons/pause-circle.js");
var _pauseCircleJsDefault = parcelHelpers.interopDefault(_pauseCircleJs);
var _pauseOctagonJs = require("./icons/pause-octagon.js");
var _pauseOctagonJsDefault = parcelHelpers.interopDefault(_pauseOctagonJs);
var _pauseJs = require("./icons/pause.js");
var _pauseJsDefault = parcelHelpers.interopDefault(_pauseJs);
var _pawPrintJs = require("./icons/paw-print.js");
var _pawPrintJsDefault = parcelHelpers.interopDefault(_pawPrintJs);
var _pcCaseJs = require("./icons/pc-case.js");
var _pcCaseJsDefault = parcelHelpers.interopDefault(_pcCaseJs);
var _penToolJs = require("./icons/pen-tool.js");
var _penToolJsDefault = parcelHelpers.interopDefault(_penToolJs);
var _pencilLineJs = require("./icons/pencil-line.js");
var _pencilLineJsDefault = parcelHelpers.interopDefault(_pencilLineJs);
var _pencilRulerJs = require("./icons/pencil-ruler.js");
var _pencilRulerJsDefault = parcelHelpers.interopDefault(_pencilRulerJs);
var _pencilJs = require("./icons/pencil.js");
var _pencilJsDefault = parcelHelpers.interopDefault(_pencilJs);
var _pentagonJs = require("./icons/pentagon.js");
var _pentagonJsDefault = parcelHelpers.interopDefault(_pentagonJs);
var _percentCircleJs = require("./icons/percent-circle.js");
var _percentCircleJsDefault = parcelHelpers.interopDefault(_percentCircleJs);
var _percentDiamondJs = require("./icons/percent-diamond.js");
var _percentDiamondJsDefault = parcelHelpers.interopDefault(_percentDiamondJs);
var _percentSquareJs = require("./icons/percent-square.js");
var _percentSquareJsDefault = parcelHelpers.interopDefault(_percentSquareJs);
var _percentJs = require("./icons/percent.js");
var _percentJsDefault = parcelHelpers.interopDefault(_percentJs);
var _personStandingJs = require("./icons/person-standing.js");
var _personStandingJsDefault = parcelHelpers.interopDefault(_personStandingJs);
var _phoneCallJs = require("./icons/phone-call.js");
var _phoneCallJsDefault = parcelHelpers.interopDefault(_phoneCallJs);
var _phoneForwardedJs = require("./icons/phone-forwarded.js");
var _phoneForwardedJsDefault = parcelHelpers.interopDefault(_phoneForwardedJs);
var _phoneIncomingJs = require("./icons/phone-incoming.js");
var _phoneIncomingJsDefault = parcelHelpers.interopDefault(_phoneIncomingJs);
var _phoneMissedJs = require("./icons/phone-missed.js");
var _phoneMissedJsDefault = parcelHelpers.interopDefault(_phoneMissedJs);
var _phoneOffJs = require("./icons/phone-off.js");
var _phoneOffJsDefault = parcelHelpers.interopDefault(_phoneOffJs);
var _phoneOutgoingJs = require("./icons/phone-outgoing.js");
var _phoneOutgoingJsDefault = parcelHelpers.interopDefault(_phoneOutgoingJs);
var _phoneJs = require("./icons/phone.js");
var _phoneJsDefault = parcelHelpers.interopDefault(_phoneJs);
var _piSquareJs = require("./icons/pi-square.js");
var _piSquareJsDefault = parcelHelpers.interopDefault(_piSquareJs);
var _piJs = require("./icons/pi.js");
var _piJsDefault = parcelHelpers.interopDefault(_piJs);
var _pianoJs = require("./icons/piano.js");
var _pianoJsDefault = parcelHelpers.interopDefault(_pianoJs);
var _pickaxeJs = require("./icons/pickaxe.js");
var _pickaxeJsDefault = parcelHelpers.interopDefault(_pickaxeJs);
var _pictureInPicture2Js = require("./icons/picture-in-picture-2.js");
var _pictureInPicture2JsDefault = parcelHelpers.interopDefault(_pictureInPicture2Js);
var _pictureInPictureJs = require("./icons/picture-in-picture.js");
var _pictureInPictureJsDefault = parcelHelpers.interopDefault(_pictureInPictureJs);
var _pieChartJs = require("./icons/pie-chart.js");
var _pieChartJsDefault = parcelHelpers.interopDefault(_pieChartJs);
var _piggyBankJs = require("./icons/piggy-bank.js");
var _piggyBankJsDefault = parcelHelpers.interopDefault(_piggyBankJs);
var _pilcrowSquareJs = require("./icons/pilcrow-square.js");
var _pilcrowSquareJsDefault = parcelHelpers.interopDefault(_pilcrowSquareJs);
var _pilcrowJs = require("./icons/pilcrow.js");
var _pilcrowJsDefault = parcelHelpers.interopDefault(_pilcrowJs);
var _pillJs = require("./icons/pill.js");
var _pillJsDefault = parcelHelpers.interopDefault(_pillJs);
var _pinOffJs = require("./icons/pin-off.js");
var _pinOffJsDefault = parcelHelpers.interopDefault(_pinOffJs);
var _pinJs = require("./icons/pin.js");
var _pinJsDefault = parcelHelpers.interopDefault(_pinJs);
var _pipetteJs = require("./icons/pipette.js");
var _pipetteJsDefault = parcelHelpers.interopDefault(_pipetteJs);
var _pizzaJs = require("./icons/pizza.js");
var _pizzaJsDefault = parcelHelpers.interopDefault(_pizzaJs);
var _planeLandingJs = require("./icons/plane-landing.js");
var _planeLandingJsDefault = parcelHelpers.interopDefault(_planeLandingJs);
var _planeTakeoffJs = require("./icons/plane-takeoff.js");
var _planeTakeoffJsDefault = parcelHelpers.interopDefault(_planeTakeoffJs);
var _planeJs = require("./icons/plane.js");
var _planeJsDefault = parcelHelpers.interopDefault(_planeJs);
var _playCircleJs = require("./icons/play-circle.js");
var _playCircleJsDefault = parcelHelpers.interopDefault(_playCircleJs);
var _playSquareJs = require("./icons/play-square.js");
var _playSquareJsDefault = parcelHelpers.interopDefault(_playSquareJs);
var _playJs = require("./icons/play.js");
var _playJsDefault = parcelHelpers.interopDefault(_playJs);
var _plug2Js = require("./icons/plug-2.js");
var _plug2JsDefault = parcelHelpers.interopDefault(_plug2Js);
var _plugZap2Js = require("./icons/plug-zap-2.js");
var _plugZap2JsDefault = parcelHelpers.interopDefault(_plugZap2Js);
var _plugZapJs = require("./icons/plug-zap.js");
var _plugZapJsDefault = parcelHelpers.interopDefault(_plugZapJs);
var _plugJs = require("./icons/plug.js");
var _plugJsDefault = parcelHelpers.interopDefault(_plugJs);
var _plusCircleJs = require("./icons/plus-circle.js");
var _plusCircleJsDefault = parcelHelpers.interopDefault(_plusCircleJs);
var _plusSquareJs = require("./icons/plus-square.js");
var _plusSquareJsDefault = parcelHelpers.interopDefault(_plusSquareJs);
var _plusJs = require("./icons/plus.js");
var _plusJsDefault = parcelHelpers.interopDefault(_plusJs);
var _pocketKnifeJs = require("./icons/pocket-knife.js");
var _pocketKnifeJsDefault = parcelHelpers.interopDefault(_pocketKnifeJs);
var _pocketJs = require("./icons/pocket.js");
var _pocketJsDefault = parcelHelpers.interopDefault(_pocketJs);
var _podcastJs = require("./icons/podcast.js");
var _podcastJsDefault = parcelHelpers.interopDefault(_podcastJs);
var _pointerOffJs = require("./icons/pointer-off.js");
var _pointerOffJsDefault = parcelHelpers.interopDefault(_pointerOffJs);
var _pointerJs = require("./icons/pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _popcornJs = require("./icons/popcorn.js");
var _popcornJsDefault = parcelHelpers.interopDefault(_popcornJs);
var _popsicleJs = require("./icons/popsicle.js");
var _popsicleJsDefault = parcelHelpers.interopDefault(_popsicleJs);
var _poundSterlingJs = require("./icons/pound-sterling.js");
var _poundSterlingJsDefault = parcelHelpers.interopDefault(_poundSterlingJs);
var _powerCircleJs = require("./icons/power-circle.js");
var _powerCircleJsDefault = parcelHelpers.interopDefault(_powerCircleJs);
var _powerOffJs = require("./icons/power-off.js");
var _powerOffJsDefault = parcelHelpers.interopDefault(_powerOffJs);
var _powerSquareJs = require("./icons/power-square.js");
var _powerSquareJsDefault = parcelHelpers.interopDefault(_powerSquareJs);
var _powerJs = require("./icons/power.js");
var _powerJsDefault = parcelHelpers.interopDefault(_powerJs);
var _presentationJs = require("./icons/presentation.js");
var _presentationJsDefault = parcelHelpers.interopDefault(_presentationJs);
var _printerJs = require("./icons/printer.js");
var _printerJsDefault = parcelHelpers.interopDefault(_printerJs);
var _projectorJs = require("./icons/projector.js");
var _projectorJsDefault = parcelHelpers.interopDefault(_projectorJs);
var _puzzleJs = require("./icons/puzzle.js");
var _puzzleJsDefault = parcelHelpers.interopDefault(_puzzleJs);
var _pyramidJs = require("./icons/pyramid.js");
var _pyramidJsDefault = parcelHelpers.interopDefault(_pyramidJs);
var _qrCodeJs = require("./icons/qr-code.js");
var _qrCodeJsDefault = parcelHelpers.interopDefault(_qrCodeJs);
var _quoteJs = require("./icons/quote.js");
var _quoteJsDefault = parcelHelpers.interopDefault(_quoteJs);
var _rabbitJs = require("./icons/rabbit.js");
var _rabbitJsDefault = parcelHelpers.interopDefault(_rabbitJs);
var _radarJs = require("./icons/radar.js");
var _radarJsDefault = parcelHelpers.interopDefault(_radarJs);
var _radiationJs = require("./icons/radiation.js");
var _radiationJsDefault = parcelHelpers.interopDefault(_radiationJs);
var _radicalJs = require("./icons/radical.js");
var _radicalJsDefault = parcelHelpers.interopDefault(_radicalJs);
var _radioReceiverJs = require("./icons/radio-receiver.js");
var _radioReceiverJsDefault = parcelHelpers.interopDefault(_radioReceiverJs);
var _radioTowerJs = require("./icons/radio-tower.js");
var _radioTowerJsDefault = parcelHelpers.interopDefault(_radioTowerJs);
var _radioJs = require("./icons/radio.js");
var _radioJsDefault = parcelHelpers.interopDefault(_radioJs);
var _radiusJs = require("./icons/radius.js");
var _radiusJsDefault = parcelHelpers.interopDefault(_radiusJs);
var _railSymbolJs = require("./icons/rail-symbol.js");
var _railSymbolJsDefault = parcelHelpers.interopDefault(_railSymbolJs);
var _rainbowJs = require("./icons/rainbow.js");
var _rainbowJsDefault = parcelHelpers.interopDefault(_rainbowJs);
var _ratJs = require("./icons/rat.js");
var _ratJsDefault = parcelHelpers.interopDefault(_ratJs);
var _ratioJs = require("./icons/ratio.js");
var _ratioJsDefault = parcelHelpers.interopDefault(_ratioJs);
var _receiptCentJs = require("./icons/receipt-cent.js");
var _receiptCentJsDefault = parcelHelpers.interopDefault(_receiptCentJs);
var _receiptEuroJs = require("./icons/receipt-euro.js");
var _receiptEuroJsDefault = parcelHelpers.interopDefault(_receiptEuroJs);
var _receiptIndianRupeeJs = require("./icons/receipt-indian-rupee.js");
var _receiptIndianRupeeJsDefault = parcelHelpers.interopDefault(_receiptIndianRupeeJs);
var _receiptJapaneseYenJs = require("./icons/receipt-japanese-yen.js");
var _receiptJapaneseYenJsDefault = parcelHelpers.interopDefault(_receiptJapaneseYenJs);
var _receiptPoundSterlingJs = require("./icons/receipt-pound-sterling.js");
var _receiptPoundSterlingJsDefault = parcelHelpers.interopDefault(_receiptPoundSterlingJs);
var _receiptRussianRubleJs = require("./icons/receipt-russian-ruble.js");
var _receiptRussianRubleJsDefault = parcelHelpers.interopDefault(_receiptRussianRubleJs);
var _receiptSwissFrancJs = require("./icons/receipt-swiss-franc.js");
var _receiptSwissFrancJsDefault = parcelHelpers.interopDefault(_receiptSwissFrancJs);
var _receiptTextJs = require("./icons/receipt-text.js");
var _receiptTextJsDefault = parcelHelpers.interopDefault(_receiptTextJs);
var _receiptJs = require("./icons/receipt.js");
var _receiptJsDefault = parcelHelpers.interopDefault(_receiptJs);
var _rectangleHorizontalJs = require("./icons/rectangle-horizontal.js");
var _rectangleHorizontalJsDefault = parcelHelpers.interopDefault(_rectangleHorizontalJs);
var _rectangleVerticalJs = require("./icons/rectangle-vertical.js");
var _rectangleVerticalJsDefault = parcelHelpers.interopDefault(_rectangleVerticalJs);
var _recycleJs = require("./icons/recycle.js");
var _recycleJsDefault = parcelHelpers.interopDefault(_recycleJs);
var _redo2Js = require("./icons/redo-2.js");
var _redo2JsDefault = parcelHelpers.interopDefault(_redo2Js);
var _redoDotJs = require("./icons/redo-dot.js");
var _redoDotJsDefault = parcelHelpers.interopDefault(_redoDotJs);
var _redoJs = require("./icons/redo.js");
var _redoJsDefault = parcelHelpers.interopDefault(_redoJs);
var _refreshCcwDotJs = require("./icons/refresh-ccw-dot.js");
var _refreshCcwDotJsDefault = parcelHelpers.interopDefault(_refreshCcwDotJs);
var _refreshCcwJs = require("./icons/refresh-ccw.js");
var _refreshCcwJsDefault = parcelHelpers.interopDefault(_refreshCcwJs);
var _refreshCwOffJs = require("./icons/refresh-cw-off.js");
var _refreshCwOffJsDefault = parcelHelpers.interopDefault(_refreshCwOffJs);
var _refreshCwJs = require("./icons/refresh-cw.js");
var _refreshCwJsDefault = parcelHelpers.interopDefault(_refreshCwJs);
var _refrigeratorJs = require("./icons/refrigerator.js");
var _refrigeratorJsDefault = parcelHelpers.interopDefault(_refrigeratorJs);
var _regexJs = require("./icons/regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
var _removeFormattingJs = require("./icons/remove-formatting.js");
var _removeFormattingJsDefault = parcelHelpers.interopDefault(_removeFormattingJs);
var _repeat1Js = require("./icons/repeat-1.js");
var _repeat1JsDefault = parcelHelpers.interopDefault(_repeat1Js);
var _repeat2Js = require("./icons/repeat-2.js");
var _repeat2JsDefault = parcelHelpers.interopDefault(_repeat2Js);
var _repeatJs = require("./icons/repeat.js");
var _repeatJsDefault = parcelHelpers.interopDefault(_repeatJs);
var _replaceAllJs = require("./icons/replace-all.js");
var _replaceAllJsDefault = parcelHelpers.interopDefault(_replaceAllJs);
var _replaceJs = require("./icons/replace.js");
var _replaceJsDefault = parcelHelpers.interopDefault(_replaceJs);
var _replyAllJs = require("./icons/reply-all.js");
var _replyAllJsDefault = parcelHelpers.interopDefault(_replyAllJs);
var _replyJs = require("./icons/reply.js");
var _replyJsDefault = parcelHelpers.interopDefault(_replyJs);
var _rewindJs = require("./icons/rewind.js");
var _rewindJsDefault = parcelHelpers.interopDefault(_rewindJs);
var _ribbonJs = require("./icons/ribbon.js");
var _ribbonJsDefault = parcelHelpers.interopDefault(_ribbonJs);
var _rocketJs = require("./icons/rocket.js");
var _rocketJsDefault = parcelHelpers.interopDefault(_rocketJs);
var _rockingChairJs = require("./icons/rocking-chair.js");
var _rockingChairJsDefault = parcelHelpers.interopDefault(_rockingChairJs);
var _rollerCoasterJs = require("./icons/roller-coaster.js");
var _rollerCoasterJsDefault = parcelHelpers.interopDefault(_rollerCoasterJs);
var _rotateCcwJs = require("./icons/rotate-ccw.js");
var _rotateCcwJsDefault = parcelHelpers.interopDefault(_rotateCcwJs);
var _rotateCwJs = require("./icons/rotate-cw.js");
var _rotateCwJsDefault = parcelHelpers.interopDefault(_rotateCwJs);
var _routeOffJs = require("./icons/route-off.js");
var _routeOffJsDefault = parcelHelpers.interopDefault(_routeOffJs);
var _routeJs = require("./icons/route.js");
var _routeJsDefault = parcelHelpers.interopDefault(_routeJs);
var _routerJs = require("./icons/router.js");
var _routerJsDefault = parcelHelpers.interopDefault(_routerJs);
var _rows4Js = require("./icons/rows-4.js");
var _rows4JsDefault = parcelHelpers.interopDefault(_rows4Js);
var _rssJs = require("./icons/rss.js");
var _rssJsDefault = parcelHelpers.interopDefault(_rssJs);
var _rulerJs = require("./icons/ruler.js");
var _rulerJsDefault = parcelHelpers.interopDefault(_rulerJs);
var _russianRubleJs = require("./icons/russian-ruble.js");
var _russianRubleJsDefault = parcelHelpers.interopDefault(_russianRubleJs);
var _sailboatJs = require("./icons/sailboat.js");
var _sailboatJsDefault = parcelHelpers.interopDefault(_sailboatJs);
var _saladJs = require("./icons/salad.js");
var _saladJsDefault = parcelHelpers.interopDefault(_saladJs);
var _sandwichJs = require("./icons/sandwich.js");
var _sandwichJsDefault = parcelHelpers.interopDefault(_sandwichJs);
var _satelliteDishJs = require("./icons/satellite-dish.js");
var _satelliteDishJsDefault = parcelHelpers.interopDefault(_satelliteDishJs);
var _satelliteJs = require("./icons/satellite.js");
var _satelliteJsDefault = parcelHelpers.interopDefault(_satelliteJs);
var _saveAllJs = require("./icons/save-all.js");
var _saveAllJsDefault = parcelHelpers.interopDefault(_saveAllJs);
var _saveJs = require("./icons/save.js");
var _saveJsDefault = parcelHelpers.interopDefault(_saveJs);
var _scaleJs = require("./icons/scale.js");
var _scaleJsDefault = parcelHelpers.interopDefault(_scaleJs);
var _scalingJs = require("./icons/scaling.js");
var _scalingJsDefault = parcelHelpers.interopDefault(_scalingJs);
var _scanBarcodeJs = require("./icons/scan-barcode.js");
var _scanBarcodeJsDefault = parcelHelpers.interopDefault(_scanBarcodeJs);
var _scanEyeJs = require("./icons/scan-eye.js");
var _scanEyeJsDefault = parcelHelpers.interopDefault(_scanEyeJs);
var _scanFaceJs = require("./icons/scan-face.js");
var _scanFaceJsDefault = parcelHelpers.interopDefault(_scanFaceJs);
var _scanLineJs = require("./icons/scan-line.js");
var _scanLineJsDefault = parcelHelpers.interopDefault(_scanLineJs);
var _scanSearchJs = require("./icons/scan-search.js");
var _scanSearchJsDefault = parcelHelpers.interopDefault(_scanSearchJs);
var _scanTextJs = require("./icons/scan-text.js");
var _scanTextJsDefault = parcelHelpers.interopDefault(_scanTextJs);
var _scanJs = require("./icons/scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _scatterChartJs = require("./icons/scatter-chart.js");
var _scatterChartJsDefault = parcelHelpers.interopDefault(_scatterChartJs);
var _school2Js = require("./icons/school-2.js");
var _school2JsDefault = parcelHelpers.interopDefault(_school2Js);
var _schoolJs = require("./icons/school.js");
var _schoolJsDefault = parcelHelpers.interopDefault(_schoolJs);
var _scissorsLineDashedJs = require("./icons/scissors-line-dashed.js");
var _scissorsLineDashedJsDefault = parcelHelpers.interopDefault(_scissorsLineDashedJs);
var _scissorsSquareDashedBottomJs = require("./icons/scissors-square-dashed-bottom.js");
var _scissorsSquareDashedBottomJsDefault = parcelHelpers.interopDefault(_scissorsSquareDashedBottomJs);
var _scissorsSquareJs = require("./icons/scissors-square.js");
var _scissorsSquareJsDefault = parcelHelpers.interopDefault(_scissorsSquareJs);
var _scissorsJs = require("./icons/scissors.js");
var _scissorsJsDefault = parcelHelpers.interopDefault(_scissorsJs);
var _screenShareOffJs = require("./icons/screen-share-off.js");
var _screenShareOffJsDefault = parcelHelpers.interopDefault(_screenShareOffJs);
var _screenShareJs = require("./icons/screen-share.js");
var _screenShareJsDefault = parcelHelpers.interopDefault(_screenShareJs);
var _scrollTextJs = require("./icons/scroll-text.js");
var _scrollTextJsDefault = parcelHelpers.interopDefault(_scrollTextJs);
var _scrollJs = require("./icons/scroll.js");
var _scrollJsDefault = parcelHelpers.interopDefault(_scrollJs);
var _searchCheckJs = require("./icons/search-check.js");
var _searchCheckJsDefault = parcelHelpers.interopDefault(_searchCheckJs);
var _searchCodeJs = require("./icons/search-code.js");
var _searchCodeJsDefault = parcelHelpers.interopDefault(_searchCodeJs);
var _searchSlashJs = require("./icons/search-slash.js");
var _searchSlashJsDefault = parcelHelpers.interopDefault(_searchSlashJs);
var _searchXJs = require("./icons/search-x.js");
var _searchXJsDefault = parcelHelpers.interopDefault(_searchXJs);
var _searchJs = require("./icons/search.js");
var _searchJsDefault = parcelHelpers.interopDefault(_searchJs);
var _sendToBackJs = require("./icons/send-to-back.js");
var _sendToBackJsDefault = parcelHelpers.interopDefault(_sendToBackJs);
var _sendJs = require("./icons/send.js");
var _sendJsDefault = parcelHelpers.interopDefault(_sendJs);
var _separatorHorizontalJs = require("./icons/separator-horizontal.js");
var _separatorHorizontalJsDefault = parcelHelpers.interopDefault(_separatorHorizontalJs);
var _separatorVerticalJs = require("./icons/separator-vertical.js");
var _separatorVerticalJsDefault = parcelHelpers.interopDefault(_separatorVerticalJs);
var _serverCogJs = require("./icons/server-cog.js");
var _serverCogJsDefault = parcelHelpers.interopDefault(_serverCogJs);
var _serverCrashJs = require("./icons/server-crash.js");
var _serverCrashJsDefault = parcelHelpers.interopDefault(_serverCrashJs);
var _serverOffJs = require("./icons/server-off.js");
var _serverOffJsDefault = parcelHelpers.interopDefault(_serverOffJs);
var _serverJs = require("./icons/server.js");
var _serverJsDefault = parcelHelpers.interopDefault(_serverJs);
var _settings2Js = require("./icons/settings-2.js");
var _settings2JsDefault = parcelHelpers.interopDefault(_settings2Js);
var _settingsJs = require("./icons/settings.js");
var _settingsJsDefault = parcelHelpers.interopDefault(_settingsJs);
var _shapesJs = require("./icons/shapes.js");
var _shapesJsDefault = parcelHelpers.interopDefault(_shapesJs);
var _share2Js = require("./icons/share-2.js");
var _share2JsDefault = parcelHelpers.interopDefault(_share2Js);
var _shareJs = require("./icons/share.js");
var _shareJsDefault = parcelHelpers.interopDefault(_shareJs);
var _sheetJs = require("./icons/sheet.js");
var _sheetJsDefault = parcelHelpers.interopDefault(_sheetJs);
var _shellJs = require("./icons/shell.js");
var _shellJsDefault = parcelHelpers.interopDefault(_shellJs);
var _shieldAlertJs = require("./icons/shield-alert.js");
var _shieldAlertJsDefault = parcelHelpers.interopDefault(_shieldAlertJs);
var _shieldBanJs = require("./icons/shield-ban.js");
var _shieldBanJsDefault = parcelHelpers.interopDefault(_shieldBanJs);
var _shieldCheckJs = require("./icons/shield-check.js");
var _shieldCheckJsDefault = parcelHelpers.interopDefault(_shieldCheckJs);
var _shieldEllipsisJs = require("./icons/shield-ellipsis.js");
var _shieldEllipsisJsDefault = parcelHelpers.interopDefault(_shieldEllipsisJs);
var _shieldHalfJs = require("./icons/shield-half.js");
var _shieldHalfJsDefault = parcelHelpers.interopDefault(_shieldHalfJs);
var _shieldMinusJs = require("./icons/shield-minus.js");
var _shieldMinusJsDefault = parcelHelpers.interopDefault(_shieldMinusJs);
var _shieldOffJs = require("./icons/shield-off.js");
var _shieldOffJsDefault = parcelHelpers.interopDefault(_shieldOffJs);
var _shieldPlusJs = require("./icons/shield-plus.js");
var _shieldPlusJsDefault = parcelHelpers.interopDefault(_shieldPlusJs);
var _shieldQuestionJs = require("./icons/shield-question.js");
var _shieldQuestionJsDefault = parcelHelpers.interopDefault(_shieldQuestionJs);
var _shieldJs = require("./icons/shield.js");
var _shieldJsDefault = parcelHelpers.interopDefault(_shieldJs);
var _shipWheelJs = require("./icons/ship-wheel.js");
var _shipWheelJsDefault = parcelHelpers.interopDefault(_shipWheelJs);
var _shipJs = require("./icons/ship.js");
var _shipJsDefault = parcelHelpers.interopDefault(_shipJs);
var _shirtJs = require("./icons/shirt.js");
var _shirtJsDefault = parcelHelpers.interopDefault(_shirtJs);
var _shoppingBagJs = require("./icons/shopping-bag.js");
var _shoppingBagJsDefault = parcelHelpers.interopDefault(_shoppingBagJs);
var _shoppingBasketJs = require("./icons/shopping-basket.js");
var _shoppingBasketJsDefault = parcelHelpers.interopDefault(_shoppingBasketJs);
var _shoppingCartJs = require("./icons/shopping-cart.js");
var _shoppingCartJsDefault = parcelHelpers.interopDefault(_shoppingCartJs);
var _shovelJs = require("./icons/shovel.js");
var _shovelJsDefault = parcelHelpers.interopDefault(_shovelJs);
var _showerHeadJs = require("./icons/shower-head.js");
var _showerHeadJsDefault = parcelHelpers.interopDefault(_showerHeadJs);
var _shrinkJs = require("./icons/shrink.js");
var _shrinkJsDefault = parcelHelpers.interopDefault(_shrinkJs);
var _shrubJs = require("./icons/shrub.js");
var _shrubJsDefault = parcelHelpers.interopDefault(_shrubJs);
var _shuffleJs = require("./icons/shuffle.js");
var _shuffleJsDefault = parcelHelpers.interopDefault(_shuffleJs);
var _sigmaSquareJs = require("./icons/sigma-square.js");
var _sigmaSquareJsDefault = parcelHelpers.interopDefault(_sigmaSquareJs);
var _sigmaJs = require("./icons/sigma.js");
var _sigmaJsDefault = parcelHelpers.interopDefault(_sigmaJs);
var _signalHighJs = require("./icons/signal-high.js");
var _signalHighJsDefault = parcelHelpers.interopDefault(_signalHighJs);
var _signalLowJs = require("./icons/signal-low.js");
var _signalLowJsDefault = parcelHelpers.interopDefault(_signalLowJs);
var _signalMediumJs = require("./icons/signal-medium.js");
var _signalMediumJsDefault = parcelHelpers.interopDefault(_signalMediumJs);
var _signalZeroJs = require("./icons/signal-zero.js");
var _signalZeroJsDefault = parcelHelpers.interopDefault(_signalZeroJs);
var _signalJs = require("./icons/signal.js");
var _signalJsDefault = parcelHelpers.interopDefault(_signalJs);
var _signpostBigJs = require("./icons/signpost-big.js");
var _signpostBigJsDefault = parcelHelpers.interopDefault(_signpostBigJs);
var _signpostJs = require("./icons/signpost.js");
var _signpostJsDefault = parcelHelpers.interopDefault(_signpostJs);
var _sirenJs = require("./icons/siren.js");
var _sirenJsDefault = parcelHelpers.interopDefault(_sirenJs);
var _skipBackJs = require("./icons/skip-back.js");
var _skipBackJsDefault = parcelHelpers.interopDefault(_skipBackJs);
var _skipForwardJs = require("./icons/skip-forward.js");
var _skipForwardJsDefault = parcelHelpers.interopDefault(_skipForwardJs);
var _skullJs = require("./icons/skull.js");
var _skullJsDefault = parcelHelpers.interopDefault(_skullJs);
var _slackJs = require("./icons/slack.js");
var _slackJsDefault = parcelHelpers.interopDefault(_slackJs);
var _slashJs = require("./icons/slash.js");
var _slashJsDefault = parcelHelpers.interopDefault(_slashJs);
var _sliceJs = require("./icons/slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _slidersHorizontalJs = require("./icons/sliders-horizontal.js");
var _slidersHorizontalJsDefault = parcelHelpers.interopDefault(_slidersHorizontalJs);
var _slidersJs = require("./icons/sliders.js");
var _slidersJsDefault = parcelHelpers.interopDefault(_slidersJs);
var _smartphoneChargingJs = require("./icons/smartphone-charging.js");
var _smartphoneChargingJsDefault = parcelHelpers.interopDefault(_smartphoneChargingJs);
var _smartphoneNfcJs = require("./icons/smartphone-nfc.js");
var _smartphoneNfcJsDefault = parcelHelpers.interopDefault(_smartphoneNfcJs);
var _smartphoneJs = require("./icons/smartphone.js");
var _smartphoneJsDefault = parcelHelpers.interopDefault(_smartphoneJs);
var _smilePlusJs = require("./icons/smile-plus.js");
var _smilePlusJsDefault = parcelHelpers.interopDefault(_smilePlusJs);
var _smileJs = require("./icons/smile.js");
var _smileJsDefault = parcelHelpers.interopDefault(_smileJs);
var _snailJs = require("./icons/snail.js");
var _snailJsDefault = parcelHelpers.interopDefault(_snailJs);
var _snowflakeJs = require("./icons/snowflake.js");
var _snowflakeJsDefault = parcelHelpers.interopDefault(_snowflakeJs);
var _sofaJs = require("./icons/sofa.js");
var _sofaJsDefault = parcelHelpers.interopDefault(_sofaJs);
var _soupJs = require("./icons/soup.js");
var _soupJsDefault = parcelHelpers.interopDefault(_soupJs);
var _spaceJs = require("./icons/space.js");
var _spaceJsDefault = parcelHelpers.interopDefault(_spaceJs);
var _spadeJs = require("./icons/spade.js");
var _spadeJsDefault = parcelHelpers.interopDefault(_spadeJs);
var _sparkleJs = require("./icons/sparkle.js");
var _sparkleJsDefault = parcelHelpers.interopDefault(_sparkleJs);
var _speakerJs = require("./icons/speaker.js");
var _speakerJsDefault = parcelHelpers.interopDefault(_speakerJs);
var _speechJs = require("./icons/speech.js");
var _speechJsDefault = parcelHelpers.interopDefault(_speechJs);
var _spellCheck2Js = require("./icons/spell-check-2.js");
var _spellCheck2JsDefault = parcelHelpers.interopDefault(_spellCheck2Js);
var _spellCheckJs = require("./icons/spell-check.js");
var _spellCheckJsDefault = parcelHelpers.interopDefault(_spellCheckJs);
var _splineJs = require("./icons/spline.js");
var _splineJsDefault = parcelHelpers.interopDefault(_splineJs);
var _splitSquareHorizontalJs = require("./icons/split-square-horizontal.js");
var _splitSquareHorizontalJsDefault = parcelHelpers.interopDefault(_splitSquareHorizontalJs);
var _splitSquareVerticalJs = require("./icons/split-square-vertical.js");
var _splitSquareVerticalJsDefault = parcelHelpers.interopDefault(_splitSquareVerticalJs);
var _splitJs = require("./icons/split.js");
var _splitJsDefault = parcelHelpers.interopDefault(_splitJs);
var _sprayCanJs = require("./icons/spray-can.js");
var _sprayCanJsDefault = parcelHelpers.interopDefault(_sprayCanJs);
var _sproutJs = require("./icons/sprout.js");
var _sproutJsDefault = parcelHelpers.interopDefault(_sproutJs);
var _squareDashedBottomCodeJs = require("./icons/square-dashed-bottom-code.js");
var _squareDashedBottomCodeJsDefault = parcelHelpers.interopDefault(_squareDashedBottomCodeJs);
var _squareDashedBottomJs = require("./icons/square-dashed-bottom.js");
var _squareDashedBottomJsDefault = parcelHelpers.interopDefault(_squareDashedBottomJs);
var _squareRadicalJs = require("./icons/square-radical.js");
var _squareRadicalJsDefault = parcelHelpers.interopDefault(_squareRadicalJs);
var _squareStackJs = require("./icons/square-stack.js");
var _squareStackJsDefault = parcelHelpers.interopDefault(_squareStackJs);
var _squareJs = require("./icons/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _squircleJs = require("./icons/squircle.js");
var _squircleJsDefault = parcelHelpers.interopDefault(_squircleJs);
var _squirrelJs = require("./icons/squirrel.js");
var _squirrelJsDefault = parcelHelpers.interopDefault(_squirrelJs);
var _stampJs = require("./icons/stamp.js");
var _stampJsDefault = parcelHelpers.interopDefault(_stampJs);
var _starHalfJs = require("./icons/star-half.js");
var _starHalfJsDefault = parcelHelpers.interopDefault(_starHalfJs);
var _starOffJs = require("./icons/star-off.js");
var _starOffJsDefault = parcelHelpers.interopDefault(_starOffJs);
var _starJs = require("./icons/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _stepBackJs = require("./icons/step-back.js");
var _stepBackJsDefault = parcelHelpers.interopDefault(_stepBackJs);
var _stepForwardJs = require("./icons/step-forward.js");
var _stepForwardJsDefault = parcelHelpers.interopDefault(_stepForwardJs);
var _stethoscopeJs = require("./icons/stethoscope.js");
var _stethoscopeJsDefault = parcelHelpers.interopDefault(_stethoscopeJs);
var _stickerJs = require("./icons/sticker.js");
var _stickerJsDefault = parcelHelpers.interopDefault(_stickerJs);
var _stickyNoteJs = require("./icons/sticky-note.js");
var _stickyNoteJsDefault = parcelHelpers.interopDefault(_stickyNoteJs);
var _stopCircleJs = require("./icons/stop-circle.js");
var _stopCircleJsDefault = parcelHelpers.interopDefault(_stopCircleJs);
var _storeJs = require("./icons/store.js");
var _storeJsDefault = parcelHelpers.interopDefault(_storeJs);
var _stretchHorizontalJs = require("./icons/stretch-horizontal.js");
var _stretchHorizontalJsDefault = parcelHelpers.interopDefault(_stretchHorizontalJs);
var _stretchVerticalJs = require("./icons/stretch-vertical.js");
var _stretchVerticalJsDefault = parcelHelpers.interopDefault(_stretchVerticalJs);
var _strikethroughJs = require("./icons/strikethrough.js");
var _strikethroughJsDefault = parcelHelpers.interopDefault(_strikethroughJs);
var _subscriptJs = require("./icons/subscript.js");
var _subscriptJsDefault = parcelHelpers.interopDefault(_subscriptJs);
var _sunDimJs = require("./icons/sun-dim.js");
var _sunDimJsDefault = parcelHelpers.interopDefault(_sunDimJs);
var _sunMediumJs = require("./icons/sun-medium.js");
var _sunMediumJsDefault = parcelHelpers.interopDefault(_sunMediumJs);
var _sunMoonJs = require("./icons/sun-moon.js");
var _sunMoonJsDefault = parcelHelpers.interopDefault(_sunMoonJs);
var _sunSnowJs = require("./icons/sun-snow.js");
var _sunSnowJsDefault = parcelHelpers.interopDefault(_sunSnowJs);
var _sunJs = require("./icons/sun.js");
var _sunJsDefault = parcelHelpers.interopDefault(_sunJs);
var _sunriseJs = require("./icons/sunrise.js");
var _sunriseJsDefault = parcelHelpers.interopDefault(_sunriseJs);
var _sunsetJs = require("./icons/sunset.js");
var _sunsetJsDefault = parcelHelpers.interopDefault(_sunsetJs);
var _superscriptJs = require("./icons/superscript.js");
var _superscriptJsDefault = parcelHelpers.interopDefault(_superscriptJs);
var _swatchBookJs = require("./icons/swatch-book.js");
var _swatchBookJsDefault = parcelHelpers.interopDefault(_swatchBookJs);
var _swissFrancJs = require("./icons/swiss-franc.js");
var _swissFrancJsDefault = parcelHelpers.interopDefault(_swissFrancJs);
var _switchCameraJs = require("./icons/switch-camera.js");
var _switchCameraJsDefault = parcelHelpers.interopDefault(_switchCameraJs);
var _swordJs = require("./icons/sword.js");
var _swordJsDefault = parcelHelpers.interopDefault(_swordJs);
var _swordsJs = require("./icons/swords.js");
var _swordsJsDefault = parcelHelpers.interopDefault(_swordsJs);
var _syringeJs = require("./icons/syringe.js");
var _syringeJsDefault = parcelHelpers.interopDefault(_syringeJs);
var _table2Js = require("./icons/table-2.js");
var _table2JsDefault = parcelHelpers.interopDefault(_table2Js);
var _tableCellsMergeJs = require("./icons/table-cells-merge.js");
var _tableCellsMergeJsDefault = parcelHelpers.interopDefault(_tableCellsMergeJs);
var _tableCellsSplitJs = require("./icons/table-cells-split.js");
var _tableCellsSplitJsDefault = parcelHelpers.interopDefault(_tableCellsSplitJs);
var _tableColumnsSplitJs = require("./icons/table-columns-split.js");
var _tableColumnsSplitJsDefault = parcelHelpers.interopDefault(_tableColumnsSplitJs);
var _tablePropertiesJs = require("./icons/table-properties.js");
var _tablePropertiesJsDefault = parcelHelpers.interopDefault(_tablePropertiesJs);
var _tableRowsSplitJs = require("./icons/table-rows-split.js");
var _tableRowsSplitJsDefault = parcelHelpers.interopDefault(_tableRowsSplitJs);
var _tableJs = require("./icons/table.js");
var _tableJsDefault = parcelHelpers.interopDefault(_tableJs);
var _tabletSmartphoneJs = require("./icons/tablet-smartphone.js");
var _tabletSmartphoneJsDefault = parcelHelpers.interopDefault(_tabletSmartphoneJs);
var _tabletJs = require("./icons/tablet.js");
var _tabletJsDefault = parcelHelpers.interopDefault(_tabletJs);
var _tabletsJs = require("./icons/tablets.js");
var _tabletsJsDefault = parcelHelpers.interopDefault(_tabletsJs);
var _tagJs = require("./icons/tag.js");
var _tagJsDefault = parcelHelpers.interopDefault(_tagJs);
var _tagsJs = require("./icons/tags.js");
var _tagsJsDefault = parcelHelpers.interopDefault(_tagsJs);
var _tally1Js = require("./icons/tally-1.js");
var _tally1JsDefault = parcelHelpers.interopDefault(_tally1Js);
var _tally2Js = require("./icons/tally-2.js");
var _tally2JsDefault = parcelHelpers.interopDefault(_tally2Js);
var _tally3Js = require("./icons/tally-3.js");
var _tally3JsDefault = parcelHelpers.interopDefault(_tally3Js);
var _tally4Js = require("./icons/tally-4.js");
var _tally4JsDefault = parcelHelpers.interopDefault(_tally4Js);
var _tally5Js = require("./icons/tally-5.js");
var _tally5JsDefault = parcelHelpers.interopDefault(_tally5Js);
var _tangentJs = require("./icons/tangent.js");
var _tangentJsDefault = parcelHelpers.interopDefault(_tangentJs);
var _targetJs = require("./icons/target.js");
var _targetJsDefault = parcelHelpers.interopDefault(_targetJs);
var _telescopeJs = require("./icons/telescope.js");
var _telescopeJsDefault = parcelHelpers.interopDefault(_telescopeJs);
var _tentTreeJs = require("./icons/tent-tree.js");
var _tentTreeJsDefault = parcelHelpers.interopDefault(_tentTreeJs);
var _tentJs = require("./icons/tent.js");
var _tentJsDefault = parcelHelpers.interopDefault(_tentJs);
var _terminalSquareJs = require("./icons/terminal-square.js");
var _terminalSquareJsDefault = parcelHelpers.interopDefault(_terminalSquareJs);
var _terminalJs = require("./icons/terminal.js");
var _terminalJsDefault = parcelHelpers.interopDefault(_terminalJs);
var _testTube2Js = require("./icons/test-tube-2.js");
var _testTube2JsDefault = parcelHelpers.interopDefault(_testTube2Js);
var _testTubeJs = require("./icons/test-tube.js");
var _testTubeJsDefault = parcelHelpers.interopDefault(_testTubeJs);
var _testTubesJs = require("./icons/test-tubes.js");
var _testTubesJsDefault = parcelHelpers.interopDefault(_testTubesJs);
var _textCursorInputJs = require("./icons/text-cursor-input.js");
var _textCursorInputJsDefault = parcelHelpers.interopDefault(_textCursorInputJs);
var _textCursorJs = require("./icons/text-cursor.js");
var _textCursorJsDefault = parcelHelpers.interopDefault(_textCursorJs);
var _textQuoteJs = require("./icons/text-quote.js");
var _textQuoteJsDefault = parcelHelpers.interopDefault(_textQuoteJs);
var _textSearchJs = require("./icons/text-search.js");
var _textSearchJsDefault = parcelHelpers.interopDefault(_textSearchJs);
var _textJs = require("./icons/text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _theaterJs = require("./icons/theater.js");
var _theaterJsDefault = parcelHelpers.interopDefault(_theaterJs);
var _thermometerSnowflakeJs = require("./icons/thermometer-snowflake.js");
var _thermometerSnowflakeJsDefault = parcelHelpers.interopDefault(_thermometerSnowflakeJs);
var _thermometerSunJs = require("./icons/thermometer-sun.js");
var _thermometerSunJsDefault = parcelHelpers.interopDefault(_thermometerSunJs);
var _thermometerJs = require("./icons/thermometer.js");
var _thermometerJsDefault = parcelHelpers.interopDefault(_thermometerJs);
var _thumbsDownJs = require("./icons/thumbs-down.js");
var _thumbsDownJsDefault = parcelHelpers.interopDefault(_thumbsDownJs);
var _thumbsUpJs = require("./icons/thumbs-up.js");
var _thumbsUpJsDefault = parcelHelpers.interopDefault(_thumbsUpJs);
var _ticketCheckJs = require("./icons/ticket-check.js");
var _ticketCheckJsDefault = parcelHelpers.interopDefault(_ticketCheckJs);
var _ticketMinusJs = require("./icons/ticket-minus.js");
var _ticketMinusJsDefault = parcelHelpers.interopDefault(_ticketMinusJs);
var _ticketPercentJs = require("./icons/ticket-percent.js");
var _ticketPercentJsDefault = parcelHelpers.interopDefault(_ticketPercentJs);
var _ticketPlusJs = require("./icons/ticket-plus.js");
var _ticketPlusJsDefault = parcelHelpers.interopDefault(_ticketPlusJs);
var _ticketSlashJs = require("./icons/ticket-slash.js");
var _ticketSlashJsDefault = parcelHelpers.interopDefault(_ticketSlashJs);
var _ticketXJs = require("./icons/ticket-x.js");
var _ticketXJsDefault = parcelHelpers.interopDefault(_ticketXJs);
var _ticketJs = require("./icons/ticket.js");
var _ticketJsDefault = parcelHelpers.interopDefault(_ticketJs);
var _timerOffJs = require("./icons/timer-off.js");
var _timerOffJsDefault = parcelHelpers.interopDefault(_timerOffJs);
var _timerResetJs = require("./icons/timer-reset.js");
var _timerResetJsDefault = parcelHelpers.interopDefault(_timerResetJs);
var _timerJs = require("./icons/timer.js");
var _timerJsDefault = parcelHelpers.interopDefault(_timerJs);
var _toggleLeftJs = require("./icons/toggle-left.js");
var _toggleLeftJsDefault = parcelHelpers.interopDefault(_toggleLeftJs);
var _toggleRightJs = require("./icons/toggle-right.js");
var _toggleRightJsDefault = parcelHelpers.interopDefault(_toggleRightJs);
var _tornadoJs = require("./icons/tornado.js");
var _tornadoJsDefault = parcelHelpers.interopDefault(_tornadoJs);
var _torusJs = require("./icons/torus.js");
var _torusJsDefault = parcelHelpers.interopDefault(_torusJs);
var _touchpadOffJs = require("./icons/touchpad-off.js");
var _touchpadOffJsDefault = parcelHelpers.interopDefault(_touchpadOffJs);
var _touchpadJs = require("./icons/touchpad.js");
var _touchpadJsDefault = parcelHelpers.interopDefault(_touchpadJs);
var _towerControlJs = require("./icons/tower-control.js");
var _towerControlJsDefault = parcelHelpers.interopDefault(_towerControlJs);
var _toyBrickJs = require("./icons/toy-brick.js");
var _toyBrickJsDefault = parcelHelpers.interopDefault(_toyBrickJs);
var _tractorJs = require("./icons/tractor.js");
var _tractorJsDefault = parcelHelpers.interopDefault(_tractorJs);
var _trafficConeJs = require("./icons/traffic-cone.js");
var _trafficConeJsDefault = parcelHelpers.interopDefault(_trafficConeJs);
var _trainFrontTunnelJs = require("./icons/train-front-tunnel.js");
var _trainFrontTunnelJsDefault = parcelHelpers.interopDefault(_trainFrontTunnelJs);
var _trainFrontJs = require("./icons/train-front.js");
var _trainFrontJsDefault = parcelHelpers.interopDefault(_trainFrontJs);
var _trainTrackJs = require("./icons/train-track.js");
var _trainTrackJsDefault = parcelHelpers.interopDefault(_trainTrackJs);
var _trash2Js = require("./icons/trash-2.js");
var _trash2JsDefault = parcelHelpers.interopDefault(_trash2Js);
var _trashJs = require("./icons/trash.js");
var _trashJsDefault = parcelHelpers.interopDefault(_trashJs);
var _treeDeciduousJs = require("./icons/tree-deciduous.js");
var _treeDeciduousJsDefault = parcelHelpers.interopDefault(_treeDeciduousJs);
var _treePineJs = require("./icons/tree-pine.js");
var _treePineJsDefault = parcelHelpers.interopDefault(_treePineJs);
var _treesJs = require("./icons/trees.js");
var _treesJsDefault = parcelHelpers.interopDefault(_treesJs);
var _trelloJs = require("./icons/trello.js");
var _trelloJsDefault = parcelHelpers.interopDefault(_trelloJs);
var _trendingDownJs = require("./icons/trending-down.js");
var _trendingDownJsDefault = parcelHelpers.interopDefault(_trendingDownJs);
var _trendingUpJs = require("./icons/trending-up.js");
var _trendingUpJsDefault = parcelHelpers.interopDefault(_trendingUpJs);
var _triangleRightJs = require("./icons/triangle-right.js");
var _triangleRightJsDefault = parcelHelpers.interopDefault(_triangleRightJs);
var _triangleJs = require("./icons/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _trophyJs = require("./icons/trophy.js");
var _trophyJsDefault = parcelHelpers.interopDefault(_trophyJs);
var _truckJs = require("./icons/truck.js");
var _truckJsDefault = parcelHelpers.interopDefault(_truckJs);
var _turtleJs = require("./icons/turtle.js");
var _turtleJsDefault = parcelHelpers.interopDefault(_turtleJs);
var _tv2Js = require("./icons/tv-2.js");
var _tv2JsDefault = parcelHelpers.interopDefault(_tv2Js);
var _tvJs = require("./icons/tv.js");
var _tvJsDefault = parcelHelpers.interopDefault(_tvJs);
var _twitchJs = require("./icons/twitch.js");
var _twitchJsDefault = parcelHelpers.interopDefault(_twitchJs);
var _twitterJs = require("./icons/twitter.js");
var _twitterJsDefault = parcelHelpers.interopDefault(_twitterJs);
var _typeJs = require("./icons/type.js");
var _typeJsDefault = parcelHelpers.interopDefault(_typeJs);
var _umbrellaOffJs = require("./icons/umbrella-off.js");
var _umbrellaOffJsDefault = parcelHelpers.interopDefault(_umbrellaOffJs);
var _umbrellaJs = require("./icons/umbrella.js");
var _umbrellaJsDefault = parcelHelpers.interopDefault(_umbrellaJs);
var _underlineJs = require("./icons/underline.js");
var _underlineJsDefault = parcelHelpers.interopDefault(_underlineJs);
var _undo2Js = require("./icons/undo-2.js");
var _undo2JsDefault = parcelHelpers.interopDefault(_undo2Js);
var _undoDotJs = require("./icons/undo-dot.js");
var _undoDotJsDefault = parcelHelpers.interopDefault(_undoDotJs);
var _undoJs = require("./icons/undo.js");
var _undoJsDefault = parcelHelpers.interopDefault(_undoJs);
var _unfoldHorizontalJs = require("./icons/unfold-horizontal.js");
var _unfoldHorizontalJsDefault = parcelHelpers.interopDefault(_unfoldHorizontalJs);
var _unfoldVerticalJs = require("./icons/unfold-vertical.js");
var _unfoldVerticalJsDefault = parcelHelpers.interopDefault(_unfoldVerticalJs);
var _ungroupJs = require("./icons/ungroup.js");
var _ungroupJsDefault = parcelHelpers.interopDefault(_ungroupJs);
var _unlink2Js = require("./icons/unlink-2.js");
var _unlink2JsDefault = parcelHelpers.interopDefault(_unlink2Js);
var _unlinkJs = require("./icons/unlink.js");
var _unlinkJsDefault = parcelHelpers.interopDefault(_unlinkJs);
var _unlockKeyholeJs = require("./icons/unlock-keyhole.js");
var _unlockKeyholeJsDefault = parcelHelpers.interopDefault(_unlockKeyholeJs);
var _unlockJs = require("./icons/unlock.js");
var _unlockJsDefault = parcelHelpers.interopDefault(_unlockJs);
var _unplugJs = require("./icons/unplug.js");
var _unplugJsDefault = parcelHelpers.interopDefault(_unplugJs);
var _uploadCloudJs = require("./icons/upload-cloud.js");
var _uploadCloudJsDefault = parcelHelpers.interopDefault(_uploadCloudJs);
var _uploadJs = require("./icons/upload.js");
var _uploadJsDefault = parcelHelpers.interopDefault(_uploadJs);
var _usbJs = require("./icons/usb.js");
var _usbJsDefault = parcelHelpers.interopDefault(_usbJs);
var _userCheckJs = require("./icons/user-check.js");
var _userCheckJsDefault = parcelHelpers.interopDefault(_userCheckJs);
var _userCogJs = require("./icons/user-cog.js");
var _userCogJsDefault = parcelHelpers.interopDefault(_userCogJs);
var _userMinusJs = require("./icons/user-minus.js");
var _userMinusJsDefault = parcelHelpers.interopDefault(_userMinusJs);
var _userPlusJs = require("./icons/user-plus.js");
var _userPlusJsDefault = parcelHelpers.interopDefault(_userPlusJs);
var _userRoundSearchJs = require("./icons/user-round-search.js");
var _userRoundSearchJsDefault = parcelHelpers.interopDefault(_userRoundSearchJs);
var _userSearchJs = require("./icons/user-search.js");
var _userSearchJsDefault = parcelHelpers.interopDefault(_userSearchJs);
var _userXJs = require("./icons/user-x.js");
var _userXJsDefault = parcelHelpers.interopDefault(_userXJs);
var _userJs = require("./icons/user.js");
var _userJsDefault = parcelHelpers.interopDefault(_userJs);
var _usersJs = require("./icons/users.js");
var _usersJsDefault = parcelHelpers.interopDefault(_usersJs);
var _utensilsCrossedJs = require("./icons/utensils-crossed.js");
var _utensilsCrossedJsDefault = parcelHelpers.interopDefault(_utensilsCrossedJs);
var _utensilsJs = require("./icons/utensils.js");
var _utensilsJsDefault = parcelHelpers.interopDefault(_utensilsJs);
var _utilityPoleJs = require("./icons/utility-pole.js");
var _utilityPoleJsDefault = parcelHelpers.interopDefault(_utilityPoleJs);
var _variableJs = require("./icons/variable.js");
var _variableJsDefault = parcelHelpers.interopDefault(_variableJs);
var _vaultJs = require("./icons/vault.js");
var _vaultJsDefault = parcelHelpers.interopDefault(_vaultJs);
var _veganJs = require("./icons/vegan.js");
var _veganJsDefault = parcelHelpers.interopDefault(_veganJs);
var _venetianMaskJs = require("./icons/venetian-mask.js");
var _venetianMaskJsDefault = parcelHelpers.interopDefault(_venetianMaskJs);
var _vibrateOffJs = require("./icons/vibrate-off.js");
var _vibrateOffJsDefault = parcelHelpers.interopDefault(_vibrateOffJs);
var _vibrateJs = require("./icons/vibrate.js");
var _vibrateJsDefault = parcelHelpers.interopDefault(_vibrateJs);
var _videoOffJs = require("./icons/video-off.js");
var _videoOffJsDefault = parcelHelpers.interopDefault(_videoOffJs);
var _videoJs = require("./icons/video.js");
var _videoJsDefault = parcelHelpers.interopDefault(_videoJs);
var _videotapeJs = require("./icons/videotape.js");
var _videotapeJsDefault = parcelHelpers.interopDefault(_videotapeJs);
var _viewJs = require("./icons/view.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _voicemailJs = require("./icons/voicemail.js");
var _voicemailJsDefault = parcelHelpers.interopDefault(_voicemailJs);
var _volume1Js = require("./icons/volume-1.js");
var _volume1JsDefault = parcelHelpers.interopDefault(_volume1Js);
var _volume2Js = require("./icons/volume-2.js");
var _volume2JsDefault = parcelHelpers.interopDefault(_volume2Js);
var _volumeXJs = require("./icons/volume-x.js");
var _volumeXJsDefault = parcelHelpers.interopDefault(_volumeXJs);
var _volumeJs = require("./icons/volume.js");
var _volumeJsDefault = parcelHelpers.interopDefault(_volumeJs);
var _voteJs = require("./icons/vote.js");
var _voteJsDefault = parcelHelpers.interopDefault(_voteJs);
var _wallet2Js = require("./icons/wallet-2.js");
var _wallet2JsDefault = parcelHelpers.interopDefault(_wallet2Js);
var _walletCardsJs = require("./icons/wallet-cards.js");
var _walletCardsJsDefault = parcelHelpers.interopDefault(_walletCardsJs);
var _walletJs = require("./icons/wallet.js");
var _walletJsDefault = parcelHelpers.interopDefault(_walletJs);
var _wallpaperJs = require("./icons/wallpaper.js");
var _wallpaperJsDefault = parcelHelpers.interopDefault(_wallpaperJs);
var _wand2Js = require("./icons/wand-2.js");
var _wand2JsDefault = parcelHelpers.interopDefault(_wand2Js);
var _wandJs = require("./icons/wand.js");
var _wandJsDefault = parcelHelpers.interopDefault(_wandJs);
var _warehouseJs = require("./icons/warehouse.js");
var _warehouseJsDefault = parcelHelpers.interopDefault(_warehouseJs);
var _washingMachineJs = require("./icons/washing-machine.js");
var _washingMachineJsDefault = parcelHelpers.interopDefault(_washingMachineJs);
var _watchJs = require("./icons/watch.js");
var _watchJsDefault = parcelHelpers.interopDefault(_watchJs);
var _wavesJs = require("./icons/waves.js");
var _wavesJsDefault = parcelHelpers.interopDefault(_wavesJs);
var _waypointsJs = require("./icons/waypoints.js");
var _waypointsJsDefault = parcelHelpers.interopDefault(_waypointsJs);
var _webcamJs = require("./icons/webcam.js");
var _webcamJsDefault = parcelHelpers.interopDefault(_webcamJs);
var _webhookOffJs = require("./icons/webhook-off.js");
var _webhookOffJsDefault = parcelHelpers.interopDefault(_webhookOffJs);
var _webhookJs = require("./icons/webhook.js");
var _webhookJsDefault = parcelHelpers.interopDefault(_webhookJs);
var _weightJs = require("./icons/weight.js");
var _weightJsDefault = parcelHelpers.interopDefault(_weightJs);
var _wheatOffJs = require("./icons/wheat-off.js");
var _wheatOffJsDefault = parcelHelpers.interopDefault(_wheatOffJs);
var _wheatJs = require("./icons/wheat.js");
var _wheatJsDefault = parcelHelpers.interopDefault(_wheatJs);
var _wholeWordJs = require("./icons/whole-word.js");
var _wholeWordJsDefault = parcelHelpers.interopDefault(_wholeWordJs);
var _wifiOffJs = require("./icons/wifi-off.js");
var _wifiOffJsDefault = parcelHelpers.interopDefault(_wifiOffJs);
var _wifiJs = require("./icons/wifi.js");
var _wifiJsDefault = parcelHelpers.interopDefault(_wifiJs);
var _windJs = require("./icons/wind.js");
var _windJsDefault = parcelHelpers.interopDefault(_windJs);
var _wineOffJs = require("./icons/wine-off.js");
var _wineOffJsDefault = parcelHelpers.interopDefault(_wineOffJs);
var _wineJs = require("./icons/wine.js");
var _wineJsDefault = parcelHelpers.interopDefault(_wineJs);
var _workflowJs = require("./icons/workflow.js");
var _workflowJsDefault = parcelHelpers.interopDefault(_workflowJs);
var _wrapTextJs = require("./icons/wrap-text.js");
var _wrapTextJsDefault = parcelHelpers.interopDefault(_wrapTextJs);
var _wrenchJs = require("./icons/wrench.js");
var _wrenchJsDefault = parcelHelpers.interopDefault(_wrenchJs);
var _xCircleJs = require("./icons/x-circle.js");
var _xCircleJsDefault = parcelHelpers.interopDefault(_xCircleJs);
var _xOctagonJs = require("./icons/x-octagon.js");
var _xOctagonJsDefault = parcelHelpers.interopDefault(_xOctagonJs);
var _xSquareJs = require("./icons/x-square.js");
var _xSquareJsDefault = parcelHelpers.interopDefault(_xSquareJs);
var _xJs = require("./icons/x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _youtubeJs = require("./icons/youtube.js");
var _youtubeJsDefault = parcelHelpers.interopDefault(_youtubeJs);
var _zapOffJs = require("./icons/zap-off.js");
var _zapOffJsDefault = parcelHelpers.interopDefault(_zapOffJs);
var _zapJs = require("./icons/zap.js");
var _zapJsDefault = parcelHelpers.interopDefault(_zapJs);
var _zoomInJs = require("./icons/zoom-in.js");
var _zoomInJsDefault = parcelHelpers.interopDefault(_zoomInJs);
var _zoomOutJs = require("./icons/zoom-out.js");
var _zoomOutJsDefault = parcelHelpers.interopDefault(_zoomOutJs);
var _alarmClockCheckJs = require("./icons/alarm-clock-check.js");
var _alarmClockCheckJsDefault = parcelHelpers.interopDefault(_alarmClockCheckJs);
var _alarmClockMinusJs = require("./icons/alarm-clock-minus.js");
var _alarmClockMinusJsDefault = parcelHelpers.interopDefault(_alarmClockMinusJs);
var _alarmClockPlusJs = require("./icons/alarm-clock-plus.js");
var _alarmClockPlusJsDefault = parcelHelpers.interopDefault(_alarmClockPlusJs);
var _arrowDown01Js = require("./icons/arrow-down-0-1.js");
var _arrowDown01JsDefault = parcelHelpers.interopDefault(_arrowDown01Js);
var _arrowDown10Js = require("./icons/arrow-down-1-0.js");
var _arrowDown10JsDefault = parcelHelpers.interopDefault(_arrowDown10Js);
var _arrowDownAZJs = require("./icons/arrow-down-a-z.js");
var _arrowDownAZJsDefault = parcelHelpers.interopDefault(_arrowDownAZJs);
var _arrowDownWideNarrowJs = require("./icons/arrow-down-wide-narrow.js");
var _arrowDownWideNarrowJsDefault = parcelHelpers.interopDefault(_arrowDownWideNarrowJs);
var _arrowDownZAJs = require("./icons/arrow-down-z-a.js");
var _arrowDownZAJsDefault = parcelHelpers.interopDefault(_arrowDownZAJs);
var _arrowUp01Js = require("./icons/arrow-up-0-1.js");
var _arrowUp01JsDefault = parcelHelpers.interopDefault(_arrowUp01Js);
var _arrowUp10Js = require("./icons/arrow-up-1-0.js");
var _arrowUp10JsDefault = parcelHelpers.interopDefault(_arrowUp10Js);
var _arrowUpAZJs = require("./icons/arrow-up-a-z.js");
var _arrowUpAZJsDefault = parcelHelpers.interopDefault(_arrowUpAZJs);
var _arrowUpNarrowWideJs = require("./icons/arrow-up-narrow-wide.js");
var _arrowUpNarrowWideJsDefault = parcelHelpers.interopDefault(_arrowUpNarrowWideJs);
var _arrowUpZAJs = require("./icons/arrow-up-z-a.js");
var _arrowUpZAJsDefault = parcelHelpers.interopDefault(_arrowUpZAJs);
var _asteriskSquareJs = require("./icons/asterisk-square.js");
var _asteriskSquareJsDefault = parcelHelpers.interopDefault(_asteriskSquareJs);
var _badgeCheckJs = require("./icons/badge-check.js");
var _badgeCheckJsDefault = parcelHelpers.interopDefault(_badgeCheckJs);
var _axis3DJs = require("./icons/axis-3d.js");
var _axis3DJsDefault = parcelHelpers.interopDefault(_axis3DJs);
var _betweenHorizontalEndJs = require("./icons/between-horizontal-end.js");
var _betweenHorizontalEndJsDefault = parcelHelpers.interopDefault(_betweenHorizontalEndJs);
var _betweenHorizontalStartJs = require("./icons/between-horizontal-start.js");
var _betweenHorizontalStartJsDefault = parcelHelpers.interopDefault(_betweenHorizontalStartJs);
var _bookDashedJs = require("./icons/book-dashed.js");
var _bookDashedJsDefault = parcelHelpers.interopDefault(_bookDashedJs);
var _bracesJs = require("./icons/braces.js");
var _bracesJsDefault = parcelHelpers.interopDefault(_bracesJs);
var _captionsJs = require("./icons/captions.js");
var _captionsJsDefault = parcelHelpers.interopDefault(_captionsJs);
var _circleSlash2Js = require("./icons/circle-slash-2.js");
var _circleSlash2JsDefault = parcelHelpers.interopDefault(_circleSlash2Js);
var _circleUserRoundJs = require("./icons/circle-user-round.js");
var _circleUserRoundJsDefault = parcelHelpers.interopDefault(_circleUserRoundJs);
var _circleUserJs = require("./icons/circle-user.js");
var _circleUserJsDefault = parcelHelpers.interopDefault(_circleUserJs);
var _clipboardPenLineJs = require("./icons/clipboard-pen-line.js");
var _clipboardPenLineJsDefault = parcelHelpers.interopDefault(_clipboardPenLineJs);
var _clipboardPenJs = require("./icons/clipboard-pen.js");
var _clipboardPenJsDefault = parcelHelpers.interopDefault(_clipboardPenJs);
var _codeSquareJs = require("./icons/code-square.js");
var _codeSquareJsDefault = parcelHelpers.interopDefault(_codeSquareJs);
var _columns2Js = require("./icons/columns-2.js");
var _columns2JsDefault = parcelHelpers.interopDefault(_columns2Js);
var _columns3Js = require("./icons/columns-3.js");
var _columns3JsDefault = parcelHelpers.interopDefault(_columns3Js);
var _dotSquareJs = require("./icons/dot-square.js");
var _dotSquareJsDefault = parcelHelpers.interopDefault(_dotSquareJs);
var _earthJs = require("./icons/earth.js");
var _earthJsDefault = parcelHelpers.interopDefault(_earthJs);
var _fileAxis3DJs = require("./icons/file-axis-3d.js");
var _fileAxis3DJsDefault = parcelHelpers.interopDefault(_fileAxis3DJs);
var _fileCogJs = require("./icons/file-cog.js");
var _fileCogJsDefault = parcelHelpers.interopDefault(_fileCogJs);
var _equalSquareJs = require("./icons/equal-square.js");
var _equalSquareJsDefault = parcelHelpers.interopDefault(_equalSquareJs);
var _filePenLineJs = require("./icons/file-pen-line.js");
var _filePenLineJsDefault = parcelHelpers.interopDefault(_filePenLineJs);
var _filePenJs = require("./icons/file-pen.js");
var _filePenJsDefault = parcelHelpers.interopDefault(_filePenJs);
var _folderCogJs = require("./icons/folder-cog.js");
var _folderCogJsDefault = parcelHelpers.interopDefault(_folderCogJs);
var _folderPenJs = require("./icons/folder-pen.js");
var _folderPenJsDefault = parcelHelpers.interopDefault(_folderPenJs);
var _ganttChartSquareJs = require("./icons/gantt-chart-square.js");
var _ganttChartSquareJsDefault = parcelHelpers.interopDefault(_ganttChartSquareJs);
var _gitCommitHorizontalJs = require("./icons/git-commit-horizontal.js");
var _gitCommitHorizontalJsDefault = parcelHelpers.interopDefault(_gitCommitHorizontalJs);
var _grid2X2Js = require("./icons/grid-2x2.js");
var _grid2X2JsDefault = parcelHelpers.interopDefault(_grid2X2Js);
var _grid3X3Js = require("./icons/grid-3x3.js");
var _grid3X3JsDefault = parcelHelpers.interopDefault(_grid3X3Js);
var _handHelpingJs = require("./icons/hand-helping.js");
var _handHelpingJsDefault = parcelHelpers.interopDefault(_handHelpingJs);
var _kanbanSquareDashedJs = require("./icons/kanban-square-dashed.js");
var _kanbanSquareDashedJsDefault = parcelHelpers.interopDefault(_kanbanSquareDashedJs);
var _kanbanSquareJs = require("./icons/kanban-square.js");
var _kanbanSquareJsDefault = parcelHelpers.interopDefault(_kanbanSquareJs);
var _mousePointerSquareJs = require("./icons/mouse-pointer-square.js");
var _mousePointerSquareJsDefault = parcelHelpers.interopDefault(_mousePointerSquareJs);
var _move3DJs = require("./icons/move-3d.js");
var _move3DJsDefault = parcelHelpers.interopDefault(_move3DJs);
var _panelLeftCloseJs = require("./icons/panel-left-close.js");
var _panelLeftCloseJsDefault = parcelHelpers.interopDefault(_panelLeftCloseJs);
var _panelBottomDashedJs = require("./icons/panel-bottom-dashed.js");
var _panelBottomDashedJsDefault = parcelHelpers.interopDefault(_panelBottomDashedJs);
var _panelLeftDashedJs = require("./icons/panel-left-dashed.js");
var _panelLeftDashedJsDefault = parcelHelpers.interopDefault(_panelLeftDashedJs);
var _panelLeftOpenJs = require("./icons/panel-left-open.js");
var _panelLeftOpenJsDefault = parcelHelpers.interopDefault(_panelLeftOpenJs);
var _panelLeftJs = require("./icons/panel-left.js");
var _panelLeftJsDefault = parcelHelpers.interopDefault(_panelLeftJs);
var _panelRightDashedJs = require("./icons/panel-right-dashed.js");
var _panelRightDashedJsDefault = parcelHelpers.interopDefault(_panelRightDashedJs);
var _panelTopDashedJs = require("./icons/panel-top-dashed.js");
var _panelTopDashedJsDefault = parcelHelpers.interopDefault(_panelTopDashedJs);
var _panelsTopLeftJs = require("./icons/panels-top-left.js");
var _panelsTopLeftJsDefault = parcelHelpers.interopDefault(_panelsTopLeftJs);
var _penLineJs = require("./icons/pen-line.js");
var _penLineJsDefault = parcelHelpers.interopDefault(_penLineJs);
var _penJs = require("./icons/pen.js");
var _penJsDefault = parcelHelpers.interopDefault(_penJs);
var _rotate3DJs = require("./icons/rotate-3d.js");
var _rotate3DJsDefault = parcelHelpers.interopDefault(_rotate3DJs);
var _rows2Js = require("./icons/rows-2.js");
var _rows2JsDefault = parcelHelpers.interopDefault(_rows2Js);
var _rows3Js = require("./icons/rows-3.js");
var _rows3JsDefault = parcelHelpers.interopDefault(_rows3Js);
var _scale3DJs = require("./icons/scale-3d.js");
var _scale3DJsDefault = parcelHelpers.interopDefault(_scale3DJs);
var _sendHorizontalJs = require("./icons/send-horizontal.js");
var _sendHorizontalJsDefault = parcelHelpers.interopDefault(_sendHorizontalJs);
var _shieldXJs = require("./icons/shield-x.js");
var _shieldXJsDefault = parcelHelpers.interopDefault(_shieldXJs);
var _sparklesJs = require("./icons/sparkles.js");
var _sparklesJsDefault = parcelHelpers.interopDefault(_sparklesJs);
var _slashSquareJs = require("./icons/slash-square.js");
var _slashSquareJsDefault = parcelHelpers.interopDefault(_slashSquareJs);
var _squarePenJs = require("./icons/square-pen.js");
var _squarePenJsDefault = parcelHelpers.interopDefault(_squarePenJs);
var _squareUserRoundJs = require("./icons/square-user-round.js");
var _squareUserRoundJsDefault = parcelHelpers.interopDefault(_squareUserRoundJs);
var _squareUserJs = require("./icons/square-user.js");
var _squareUserJsDefault = parcelHelpers.interopDefault(_squareUserJs);
var _textSelectJs = require("./icons/text-select.js");
var _textSelectJsDefault = parcelHelpers.interopDefault(_textSelectJs);
var _tramFrontJs = require("./icons/tram-front.js");
var _tramFrontJsDefault = parcelHelpers.interopDefault(_tramFrontJs);
var _userRoundCheckJs = require("./icons/user-round-check.js");
var _userRoundCheckJsDefault = parcelHelpers.interopDefault(_userRoundCheckJs);
var _userRoundCogJs = require("./icons/user-round-cog.js");
var _userRoundCogJsDefault = parcelHelpers.interopDefault(_userRoundCogJs);
var _userRoundMinusJs = require("./icons/user-round-minus.js");
var _userRoundMinusJsDefault = parcelHelpers.interopDefault(_userRoundMinusJs);
var _userRoundPlusJs = require("./icons/user-round-plus.js");
var _userRoundPlusJsDefault = parcelHelpers.interopDefault(_userRoundPlusJs);
var _userRoundXJs = require("./icons/user-round-x.js");
var _userRoundXJsDefault = parcelHelpers.interopDefault(_userRoundXJs);
var _userRoundJs = require("./icons/user-round.js");
var _userRoundJsDefault = parcelHelpers.interopDefault(_userRoundJs);
var _usersRoundJs = require("./icons/users-round.js");
var _usersRoundJsDefault = parcelHelpers.interopDefault(_usersRoundJs);
var _createLucideIconJs = require("./createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);

},{"./icons/index.js":false,"./icons/a-arrow-down.js":false,"./icons/a-arrow-up.js":false,"./icons/a-large-small.js":false,"./icons/accessibility.js":false,"./icons/activity-square.js":false,"./icons/activity.js":false,"./icons/air-vent.js":false,"./icons/airplay.js":false,"./icons/alarm-clock-off.js":false,"./icons/alarm-clock.js":false,"./icons/alarm-smoke.js":false,"./icons/album.js":false,"./icons/alert-circle.js":false,"./icons/alert-octagon.js":false,"./icons/alert-triangle.js":false,"./icons/align-center-horizontal.js":false,"./icons/align-center-vertical.js":false,"./icons/align-center.js":false,"./icons/align-end-horizontal.js":false,"./icons/align-end-vertical.js":false,"./icons/align-horizontal-distribute-center.js":false,"./icons/align-horizontal-distribute-end.js":false,"./icons/align-horizontal-distribute-start.js":false,"./icons/align-horizontal-justify-center.js":false,"./icons/align-horizontal-justify-end.js":false,"./icons/align-horizontal-justify-start.js":false,"./icons/align-horizontal-space-around.js":false,"./icons/align-horizontal-space-between.js":false,"./icons/align-justify.js":false,"./icons/align-left.js":false,"./icons/align-right.js":false,"./icons/align-start-horizontal.js":false,"./icons/align-start-vertical.js":false,"./icons/align-vertical-distribute-center.js":false,"./icons/align-vertical-distribute-end.js":false,"./icons/align-vertical-distribute-start.js":false,"./icons/align-vertical-justify-center.js":false,"./icons/align-vertical-justify-end.js":false,"./icons/align-vertical-justify-start.js":false,"./icons/align-vertical-space-around.js":false,"./icons/align-vertical-space-between.js":false,"./icons/ambulance.js":false,"./icons/ampersand.js":false,"./icons/ampersands.js":false,"./icons/anchor.js":false,"./icons/angry.js":false,"./icons/annoyed.js":false,"./icons/antenna.js":false,"./icons/anvil.js":false,"./icons/aperture.js":false,"./icons/app-window.js":false,"./icons/apple.js":false,"./icons/archive-restore.js":false,"./icons/archive-x.js":false,"./icons/archive.js":false,"./icons/area-chart.js":false,"./icons/armchair.js":false,"./icons/arrow-big-down-dash.js":false,"./icons/arrow-big-down.js":false,"./icons/arrow-big-left-dash.js":false,"./icons/arrow-big-left.js":false,"./icons/arrow-big-right-dash.js":false,"./icons/arrow-big-right.js":false,"./icons/arrow-big-up-dash.js":false,"./icons/arrow-big-up.js":false,"./icons/arrow-down-circle.js":false,"./icons/arrow-down-from-line.js":false,"./icons/arrow-down-left-from-circle.js":false,"./icons/arrow-down-left-from-square.js":false,"./icons/arrow-down-left-square.js":false,"./icons/arrow-down-left.js":false,"./icons/arrow-down-narrow-wide.js":false,"./icons/arrow-down-right-from-circle.js":false,"./icons/arrow-down-right-from-square.js":false,"./icons/arrow-down-right-square.js":false,"./icons/arrow-down-right.js":false,"./icons/arrow-down-square.js":false,"./icons/arrow-down-to-dot.js":false,"./icons/arrow-down-to-line.js":false,"./icons/arrow-down-up.js":false,"./icons/arrow-down.js":false,"./icons/arrow-left-circle.js":false,"./icons/arrow-left-from-line.js":false,"./icons/arrow-left-right.js":false,"./icons/arrow-left-square.js":false,"./icons/arrow-left-to-line.js":false,"./icons/arrow-left.js":false,"./icons/arrow-right-circle.js":false,"./icons/arrow-right-from-line.js":false,"./icons/arrow-right-left.js":false,"./icons/arrow-right-square.js":false,"./icons/arrow-right-to-line.js":false,"./icons/arrow-right.js":false,"./icons/arrow-up-circle.js":false,"./icons/arrow-up-down.js":false,"./icons/arrow-up-from-dot.js":false,"./icons/arrow-up-from-line.js":false,"./icons/arrow-up-left-from-circle.js":false,"./icons/arrow-up-left-from-square.js":false,"./icons/arrow-up-left-square.js":false,"./icons/arrow-up-left.js":false,"./icons/arrow-up-right-from-circle.js":false,"./icons/arrow-up-right-from-square.js":false,"./icons/arrow-up-right-square.js":false,"./icons/arrow-up-right.js":false,"./icons/arrow-up-square.js":false,"./icons/arrow-up-to-line.js":false,"./icons/arrow-up-wide-narrow.js":false,"./icons/arrow-up.js":false,"./icons/arrows-up-from-line.js":false,"./icons/asterisk.js":false,"./icons/at-sign.js":false,"./icons/atom.js":false,"./icons/audio-lines.js":false,"./icons/audio-waveform.js":false,"./icons/award.js":false,"./icons/axe.js":false,"./icons/baby.js":false,"./icons/backpack.js":false,"./icons/badge-alert.js":false,"./icons/badge-cent.js":false,"./icons/badge-dollar-sign.js":false,"./icons/badge-euro.js":false,"./icons/badge-help.js":false,"./icons/badge-indian-rupee.js":false,"./icons/badge-info.js":false,"./icons/badge-japanese-yen.js":false,"./icons/badge-minus.js":false,"./icons/badge-percent.js":false,"./icons/badge-plus.js":false,"./icons/badge-pound-sterling.js":false,"./icons/badge-russian-ruble.js":false,"./icons/badge-swiss-franc.js":false,"./icons/badge-x.js":false,"./icons/badge.js":false,"./icons/baggage-claim.js":false,"./icons/ban.js":false,"./icons/banana.js":false,"./icons/banknote.js":false,"./icons/bar-chart-2.js":false,"./icons/bar-chart-3.js":false,"./icons/bar-chart-4.js":false,"./icons/bar-chart-big.js":false,"./icons/bar-chart-horizontal-big.js":false,"./icons/bar-chart-horizontal.js":false,"./icons/bar-chart.js":false,"./icons/barcode.js":false,"./icons/baseline.js":false,"./icons/bath.js":false,"./icons/battery-charging.js":false,"./icons/battery-full.js":false,"./icons/battery-low.js":false,"./icons/battery-medium.js":false,"./icons/battery-warning.js":false,"./icons/battery.js":false,"./icons/beaker.js":false,"./icons/bean-off.js":false,"./icons/bean.js":false,"./icons/bed-double.js":false,"./icons/bed-single.js":false,"./icons/bed.js":false,"./icons/beef.js":false,"./icons/beer.js":false,"./icons/bell-dot.js":false,"./icons/bell-electric.js":false,"./icons/bell-minus.js":false,"./icons/bell-off.js":false,"./icons/bell-plus.js":false,"./icons/bell-ring.js":false,"./icons/bell.js":false,"./icons/between-vertical-end.js":false,"./icons/between-vertical-start.js":false,"./icons/bike.js":false,"./icons/binary.js":false,"./icons/biohazard.js":false,"./icons/bird.js":false,"./icons/bitcoin.js":false,"./icons/blend.js":false,"./icons/blinds.js":false,"./icons/blocks.js":false,"./icons/bluetooth-connected.js":false,"./icons/bluetooth-off.js":false,"./icons/bluetooth-searching.js":false,"./icons/bluetooth.js":false,"./icons/bold.js":false,"./icons/bolt.js":false,"./icons/bomb.js":false,"./icons/bone.js":false,"./icons/book-a.js":false,"./icons/book-audio.js":false,"./icons/book-check.js":false,"./icons/book-copy.js":false,"./icons/book-down.js":false,"./icons/book-headphones.js":false,"./icons/book-heart.js":false,"./icons/book-image.js":false,"./icons/book-key.js":false,"./icons/book-lock.js":false,"./icons/book-marked.js":false,"./icons/book-minus.js":false,"./icons/book-open-check.js":false,"./icons/book-open-text.js":false,"./icons/book-open.js":false,"./icons/book-plus.js":false,"./icons/book-text.js":false,"./icons/book-type.js":false,"./icons/book-up-2.js":false,"./icons/book-up.js":false,"./icons/book-user.js":false,"./icons/book-x.js":false,"./icons/book.js":false,"./icons/bookmark-check.js":false,"./icons/bookmark-minus.js":false,"./icons/bookmark-plus.js":false,"./icons/bookmark-x.js":false,"./icons/bookmark.js":false,"./icons/boom-box.js":false,"./icons/bot-message-square.js":false,"./icons/bot.js":false,"./icons/box-select.js":false,"./icons/box.js":false,"./icons/boxes.js":false,"./icons/brackets.js":false,"./icons/brain-circuit.js":false,"./icons/brain-cog.js":false,"./icons/brain.js":false,"./icons/brick-wall.js":false,"./icons/briefcase.js":false,"./icons/bring-to-front.js":false,"./icons/brush.js":false,"./icons/bug-off.js":false,"./icons/bug-play.js":false,"./icons/bug.js":false,"./icons/building-2.js":false,"./icons/building.js":false,"./icons/bus-front.js":false,"./icons/bus.js":false,"./icons/cable-car.js":false,"./icons/cable.js":false,"./icons/cake-slice.js":false,"./icons/cake.js":false,"./icons/calculator.js":false,"./icons/calendar-check-2.js":false,"./icons/calendar-check.js":false,"./icons/calendar-clock.js":false,"./icons/calendar-days.js":false,"./icons/calendar-fold.js":false,"./icons/calendar-heart.js":false,"./icons/calendar-minus-2.js":false,"./icons/calendar-minus.js":false,"./icons/calendar-off.js":false,"./icons/calendar-plus-2.js":false,"./icons/calendar-plus.js":false,"./icons/calendar-range.js":false,"./icons/calendar-search.js":false,"./icons/calendar-x-2.js":false,"./icons/calendar-x.js":false,"./icons/calendar.js":false,"./icons/camera-off.js":false,"./icons/camera.js":false,"./icons/candlestick-chart.js":false,"./icons/candy-cane.js":false,"./icons/candy-off.js":false,"./icons/candy.js":false,"./icons/captions-off.js":false,"./icons/car-front.js":false,"./icons/car-taxi-front.js":false,"./icons/car.js":false,"./icons/caravan.js":false,"./icons/carrot.js":false,"./icons/case-lower.js":false,"./icons/case-sensitive.js":false,"./icons/case-upper.js":false,"./icons/cassette-tape.js":false,"./icons/cast.js":false,"./icons/castle.js":false,"./icons/cat.js":false,"./icons/cctv.js":false,"./icons/check-check.js":false,"./icons/check-circle-2.js":false,"./icons/check-circle.js":false,"./icons/check-square-2.js":false,"./icons/check-square.js":false,"./icons/check.js":false,"./icons/chef-hat.js":false,"./icons/cherry.js":false,"./icons/chevron-down-circle.js":false,"./icons/chevron-down-square.js":false,"./icons/chevron-down.js":false,"./icons/chevron-first.js":false,"./icons/chevron-last.js":false,"./icons/chevron-left-circle.js":false,"./icons/chevron-left-square.js":false,"./icons/chevron-left.js":false,"./icons/chevron-right-circle.js":false,"./icons/chevron-right-square.js":false,"./icons/chevron-right.js":false,"./icons/chevron-up-circle.js":false,"./icons/chevron-up-square.js":false,"./icons/chevron-up.js":false,"./icons/chevrons-down-up.js":false,"./icons/chevrons-down.js":false,"./icons/chevrons-left-right.js":false,"./icons/chevrons-left.js":false,"./icons/chevrons-right-left.js":false,"./icons/chevrons-right.js":false,"./icons/chevrons-up-down.js":false,"./icons/chevrons-up.js":false,"./icons/chrome.js":false,"./icons/church.js":false,"./icons/cigarette-off.js":false,"./icons/cigarette.js":false,"./icons/circle-dashed.js":false,"./icons/circle-dollar-sign.js":false,"./icons/circle-dot-dashed.js":false,"./icons/circle-dot.js":false,"./icons/circle-ellipsis.js":false,"./icons/circle-equal.js":false,"./icons/circle-fading-plus.js":false,"./icons/circle-off.js":false,"./icons/circle-slash.js":false,"./icons/circle.js":false,"./icons/circuit-board.js":false,"./icons/citrus.js":false,"./icons/clapperboard.js":false,"./icons/clipboard-check.js":false,"./icons/clipboard-copy.js":false,"./icons/clipboard-list.js":false,"./icons/clipboard-minus.js":false,"./icons/clipboard-paste.js":false,"./icons/clipboard-plus.js":false,"./icons/clipboard-type.js":false,"./icons/clipboard-x.js":false,"./icons/clipboard.js":false,"./icons/clock-1.js":false,"./icons/clock-10.js":false,"./icons/clock-11.js":false,"./icons/clock-12.js":false,"./icons/clock-2.js":false,"./icons/clock-3.js":false,"./icons/clock-4.js":false,"./icons/clock-5.js":false,"./icons/clock-6.js":false,"./icons/clock-7.js":false,"./icons/clock-8.js":false,"./icons/clock-9.js":false,"./icons/clock.js":false,"./icons/cloud-cog.js":false,"./icons/cloud-drizzle.js":false,"./icons/cloud-fog.js":false,"./icons/cloud-hail.js":false,"./icons/cloud-lightning.js":false,"./icons/cloud-moon-rain.js":false,"./icons/cloud-moon.js":false,"./icons/cloud-off.js":false,"./icons/cloud-rain-wind.js":false,"./icons/cloud-rain.js":false,"./icons/cloud-snow.js":false,"./icons/cloud-sun-rain.js":false,"./icons/cloud-sun.js":false,"./icons/cloud.js":false,"./icons/cloudy.js":false,"./icons/clover.js":false,"./icons/club.js":false,"./icons/code-2.js":false,"./icons/code.js":false,"./icons/codepen.js":false,"./icons/codesandbox.js":false,"./icons/coffee.js":false,"./icons/cog.js":false,"./icons/coins.js":false,"./icons/columns-4.js":false,"./icons/combine.js":false,"./icons/command.js":false,"./icons/compass.js":false,"./icons/component.js":false,"./icons/computer.js":false,"./icons/concierge-bell.js":false,"./icons/cone.js":false,"./icons/construction.js":false,"./icons/contact-2.js":false,"./icons/contact.js":false,"./icons/container.js":false,"./icons/contrast.js":false,"./icons/cookie.js":false,"./icons/cooking-pot.js":false,"./icons/copy-check.js":false,"./icons/copy-minus.js":false,"./icons/copy-plus.js":false,"./icons/copy-slash.js":false,"./icons/copy-x.js":false,"./icons/copy.js":false,"./icons/copyleft.js":false,"./icons/copyright.js":false,"./icons/corner-down-left.js":false,"./icons/corner-down-right.js":false,"./icons/corner-left-down.js":false,"./icons/corner-left-up.js":false,"./icons/corner-right-down.js":false,"./icons/corner-right-up.js":false,"./icons/corner-up-left.js":false,"./icons/corner-up-right.js":false,"./icons/cpu.js":false,"./icons/creative-commons.js":false,"./icons/credit-card.js":false,"./icons/croissant.js":false,"./icons/crop.js":false,"./icons/cross.js":false,"./icons/crosshair.js":false,"./icons/crown.js":false,"./icons/cuboid.js":false,"./icons/cup-soda.js":false,"./icons/currency.js":false,"./icons/cylinder.js":false,"./icons/database-backup.js":false,"./icons/database-zap.js":false,"./icons/database.js":false,"./icons/delete.js":false,"./icons/dessert.js":false,"./icons/diameter.js":false,"./icons/diamond.js":false,"./icons/dice-1.js":false,"./icons/dice-2.js":false,"./icons/dice-3.js":false,"./icons/dice-4.js":false,"./icons/dice-5.js":false,"./icons/dice-6.js":false,"./icons/dices.js":false,"./icons/diff.js":false,"./icons/disc-2.js":false,"./icons/disc-3.js":false,"./icons/disc-album.js":false,"./icons/disc.js":false,"./icons/divide-circle.js":false,"./icons/divide-square.js":false,"./icons/divide.js":false,"./icons/dna-off.js":false,"./icons/dna.js":false,"./icons/dog.js":false,"./icons/dollar-sign.js":false,"./icons/donut.js":false,"./icons/door-closed.js":false,"./icons/door-open.js":false,"./icons/dot.js":false,"./icons/download-cloud.js":false,"./icons/download.js":false,"./icons/drafting-compass.js":false,"./icons/drama.js":false,"./icons/dribbble.js":false,"./icons/drill.js":false,"./icons/droplet.js":false,"./icons/droplets.js":false,"./icons/drum.js":false,"./icons/drumstick.js":false,"./icons/dumbbell.js":false,"./icons/ear-off.js":false,"./icons/ear.js":false,"./icons/earth-lock.js":false,"./icons/eclipse.js":false,"./icons/egg-fried.js":false,"./icons/egg-off.js":false,"./icons/egg.js":false,"./icons/equal-not.js":false,"./icons/equal.js":false,"./icons/eraser.js":false,"./icons/euro.js":false,"./icons/expand.js":false,"./icons/external-link.js":false,"./icons/eye-off.js":false,"./icons/eye.js":false,"./icons/facebook.js":false,"./icons/factory.js":false,"./icons/fan.js":false,"./icons/fast-forward.js":false,"./icons/feather.js":false,"./icons/fence.js":false,"./icons/ferris-wheel.js":false,"./icons/figma.js":false,"./icons/file-archive.js":false,"./icons/file-audio-2.js":false,"./icons/file-audio.js":false,"./icons/file-badge-2.js":false,"./icons/file-badge.js":false,"./icons/file-bar-chart-2.js":false,"./icons/file-bar-chart.js":false,"./icons/file-box.js":false,"./icons/file-check-2.js":false,"./icons/file-check.js":false,"./icons/file-clock.js":false,"./icons/file-code-2.js":false,"./icons/file-code.js":false,"./icons/file-diff.js":false,"./icons/file-digit.js":false,"./icons/file-down.js":false,"./icons/file-heart.js":false,"./icons/file-image.js":false,"./icons/file-input.js":false,"./icons/file-json-2.js":false,"./icons/file-json.js":false,"./icons/file-key-2.js":false,"./icons/file-key.js":false,"./icons/file-line-chart.js":false,"./icons/file-lock-2.js":false,"./icons/file-lock.js":false,"./icons/file-minus-2.js":false,"./icons/file-minus.js":false,"./icons/file-music.js":false,"./icons/file-output.js":false,"./icons/file-pie-chart.js":false,"./icons/file-plus-2.js":false,"./icons/file-plus.js":false,"./icons/file-question.js":false,"./icons/file-scan.js":false,"./icons/file-search-2.js":false,"./icons/file-search.js":false,"./icons/file-sliders.js":false,"./icons/file-spreadsheet.js":false,"./icons/file-stack.js":false,"./icons/file-symlink.js":false,"./icons/file-terminal.js":false,"./icons/file-text.js":"c56lO","./icons/file-type-2.js":false,"./icons/file-type.js":false,"./icons/file-up.js":false,"./icons/file-video-2.js":false,"./icons/file-video.js":false,"./icons/file-volume-2.js":false,"./icons/file-volume.js":false,"./icons/file-warning.js":false,"./icons/file-x-2.js":false,"./icons/file-x.js":false,"./icons/file.js":false,"./icons/files.js":false,"./icons/film.js":false,"./icons/filter-x.js":false,"./icons/filter.js":false,"./icons/fingerprint.js":false,"./icons/fire-extinguisher.js":false,"./icons/fish-off.js":false,"./icons/fish-symbol.js":false,"./icons/fish.js":false,"./icons/flag-off.js":false,"./icons/flag-triangle-left.js":false,"./icons/flag-triangle-right.js":false,"./icons/flag.js":false,"./icons/flame-kindling.js":false,"./icons/flame.js":false,"./icons/flashlight-off.js":false,"./icons/flashlight.js":false,"./icons/flask-conical-off.js":false,"./icons/flask-conical.js":false,"./icons/flask-round.js":false,"./icons/flip-horizontal-2.js":false,"./icons/flip-horizontal.js":false,"./icons/flip-vertical-2.js":false,"./icons/flip-vertical.js":false,"./icons/flower-2.js":false,"./icons/flower.js":false,"./icons/focus.js":false,"./icons/fold-horizontal.js":false,"./icons/fold-vertical.js":false,"./icons/folder-archive.js":false,"./icons/folder-check.js":false,"./icons/folder-clock.js":false,"./icons/folder-closed.js":false,"./icons/folder-dot.js":false,"./icons/folder-down.js":false,"./icons/folder-git-2.js":false,"./icons/folder-git.js":false,"./icons/folder-heart.js":false,"./icons/folder-input.js":false,"./icons/folder-kanban.js":false,"./icons/folder-key.js":false,"./icons/folder-lock.js":false,"./icons/folder-minus.js":false,"./icons/folder-open-dot.js":false,"./icons/folder-open.js":false,"./icons/folder-output.js":false,"./icons/folder-plus.js":false,"./icons/folder-root.js":false,"./icons/folder-search-2.js":false,"./icons/folder-search.js":false,"./icons/folder-symlink.js":false,"./icons/folder-sync.js":false,"./icons/folder-tree.js":false,"./icons/folder-up.js":false,"./icons/folder-x.js":false,"./icons/folder.js":false,"./icons/folders.js":false,"./icons/footprints.js":false,"./icons/forklift.js":false,"./icons/form-input.js":false,"./icons/forward.js":false,"./icons/frame.js":false,"./icons/framer.js":false,"./icons/frown.js":false,"./icons/fuel.js":false,"./icons/fullscreen.js":false,"./icons/function-square.js":false,"./icons/gallery-horizontal-end.js":false,"./icons/gallery-horizontal.js":false,"./icons/gallery-thumbnails.js":false,"./icons/gallery-vertical-end.js":false,"./icons/gallery-vertical.js":false,"./icons/gamepad-2.js":false,"./icons/gamepad.js":false,"./icons/gantt-chart.js":false,"./icons/gauge-circle.js":false,"./icons/gauge.js":false,"./icons/gavel.js":false,"./icons/gem.js":false,"./icons/ghost.js":false,"./icons/gift.js":false,"./icons/git-branch-plus.js":false,"./icons/git-branch.js":false,"./icons/git-commit-vertical.js":false,"./icons/git-compare-arrows.js":false,"./icons/git-compare.js":false,"./icons/git-fork.js":false,"./icons/git-graph.js":false,"./icons/git-merge.js":false,"./icons/git-pull-request-arrow.js":false,"./icons/git-pull-request-closed.js":false,"./icons/git-pull-request-create-arrow.js":false,"./icons/git-pull-request-create.js":false,"./icons/git-pull-request-draft.js":false,"./icons/git-pull-request.js":false,"./icons/github.js":false,"./icons/gitlab.js":false,"./icons/glass-water.js":false,"./icons/glasses.js":false,"./icons/globe-lock.js":false,"./icons/globe.js":false,"./icons/goal.js":false,"./icons/grab.js":false,"./icons/graduation-cap.js":false,"./icons/grape.js":false,"./icons/grip-horizontal.js":false,"./icons/grip-vertical.js":"f2SoA","./icons/grip.js":false,"./icons/group.js":false,"./icons/guitar.js":false,"./icons/hammer.js":false,"./icons/hand-coins.js":false,"./icons/hand-heart.js":false,"./icons/hand-metal.js":false,"./icons/hand-platter.js":false,"./icons/hand.js":false,"./icons/handshake.js":false,"./icons/hard-drive-download.js":false,"./icons/hard-drive-upload.js":false,"./icons/hard-drive.js":false,"./icons/hard-hat.js":false,"./icons/hash.js":false,"./icons/haze.js":false,"./icons/hdmi-port.js":false,"./icons/heading-1.js":false,"./icons/heading-2.js":false,"./icons/heading-3.js":false,"./icons/heading-4.js":false,"./icons/heading-5.js":false,"./icons/heading-6.js":false,"./icons/heading.js":false,"./icons/headphones.js":false,"./icons/headset.js":false,"./icons/heart-crack.js":false,"./icons/heart-handshake.js":false,"./icons/heart-off.js":false,"./icons/heart-pulse.js":false,"./icons/heart.js":false,"./icons/heater.js":false,"./icons/help-circle.js":false,"./icons/hexagon.js":false,"./icons/highlighter.js":false,"./icons/history.js":false,"./icons/home.js":"3Tb0e","./icons/hop-off.js":false,"./icons/hop.js":false,"./icons/hotel.js":false,"./icons/hourglass.js":false,"./icons/ice-cream-2.js":false,"./icons/ice-cream.js":false,"./icons/image-down.js":false,"./icons/image-minus.js":false,"./icons/image-off.js":false,"./icons/image-plus.js":false,"./icons/image-up.js":false,"./icons/image.js":false,"./icons/images.js":false,"./icons/import.js":false,"./icons/inbox.js":false,"./icons/indent.js":false,"./icons/indian-rupee.js":false,"./icons/infinity.js":false,"./icons/info.js":false,"./icons/inspection-panel.js":false,"./icons/instagram.js":false,"./icons/italic.js":false,"./icons/iteration-ccw.js":false,"./icons/iteration-cw.js":false,"./icons/japanese-yen.js":false,"./icons/joystick.js":false,"./icons/kanban.js":false,"./icons/key-round.js":false,"./icons/key-square.js":false,"./icons/key.js":false,"./icons/keyboard-music.js":false,"./icons/keyboard.js":false,"./icons/lamp-ceiling.js":false,"./icons/lamp-desk.js":false,"./icons/lamp-floor.js":false,"./icons/lamp-wall-down.js":false,"./icons/lamp-wall-up.js":false,"./icons/lamp.js":false,"./icons/land-plot.js":false,"./icons/landmark.js":false,"./icons/languages.js":false,"./icons/laptop-2.js":false,"./icons/laptop.js":false,"./icons/lasso-select.js":false,"./icons/lasso.js":false,"./icons/laugh.js":false,"./icons/layers-2.js":false,"./icons/layers-3.js":false,"./icons/layers.js":false,"./icons/layout-dashboard.js":false,"./icons/layout-grid.js":false,"./icons/layout-list.js":false,"./icons/layout-panel-left.js":false,"./icons/layout-panel-top.js":false,"./icons/layout-template.js":false,"./icons/leaf.js":false,"./icons/leafy-green.js":false,"./icons/library-big.js":false,"./icons/library-square.js":false,"./icons/library.js":false,"./icons/life-buoy.js":false,"./icons/ligature.js":false,"./icons/lightbulb-off.js":false,"./icons/lightbulb.js":false,"./icons/line-chart.js":false,"./icons/link-2-off.js":false,"./icons/link-2.js":false,"./icons/link.js":false,"./icons/linkedin.js":false,"./icons/list-checks.js":false,"./icons/list-collapse.js":false,"./icons/list-end.js":false,"./icons/list-filter.js":false,"./icons/list-minus.js":false,"./icons/list-music.js":false,"./icons/list-ordered.js":false,"./icons/list-plus.js":false,"./icons/list-restart.js":false,"./icons/list-start.js":false,"./icons/list-todo.js":false,"./icons/list-tree.js":false,"./icons/list-video.js":false,"./icons/list-x.js":false,"./icons/list.js":false,"./icons/loader-2.js":false,"./icons/loader.js":false,"./icons/locate-fixed.js":false,"./icons/locate-off.js":false,"./icons/locate.js":false,"./icons/lock-keyhole.js":false,"./icons/lock.js":false,"./icons/log-in.js":false,"./icons/log-out.js":false,"./icons/lollipop.js":false,"./icons/luggage.js":false,"./icons/m-square.js":false,"./icons/magnet.js":false,"./icons/mail-check.js":false,"./icons/mail-minus.js":false,"./icons/mail-open.js":false,"./icons/mail-plus.js":false,"./icons/mail-question.js":false,"./icons/mail-search.js":false,"./icons/mail-warning.js":false,"./icons/mail-x.js":false,"./icons/mail.js":false,"./icons/mailbox.js":false,"./icons/mails.js":false,"./icons/map-pin-off.js":false,"./icons/map-pin.js":false,"./icons/map-pinned.js":false,"./icons/map.js":false,"./icons/martini.js":false,"./icons/maximize-2.js":false,"./icons/maximize.js":false,"./icons/medal.js":false,"./icons/megaphone-off.js":false,"./icons/megaphone.js":false,"./icons/meh.js":false,"./icons/memory-stick.js":false,"./icons/menu-square.js":false,"./icons/menu.js":false,"./icons/merge.js":false,"./icons/message-circle-code.js":false,"./icons/message-circle-dashed.js":false,"./icons/message-circle-heart.js":false,"./icons/message-circle-more.js":false,"./icons/message-circle-off.js":false,"./icons/message-circle-plus.js":false,"./icons/message-circle-question.js":false,"./icons/message-circle-reply.js":false,"./icons/message-circle-warning.js":false,"./icons/message-circle-x.js":false,"./icons/message-circle.js":false,"./icons/message-square-code.js":false,"./icons/message-square-dashed.js":false,"./icons/message-square-diff.js":false,"./icons/message-square-dot.js":false,"./icons/message-square-heart.js":false,"./icons/message-square-more.js":false,"./icons/message-square-off.js":false,"./icons/message-square-plus.js":false,"./icons/message-square-quote.js":false,"./icons/message-square-reply.js":false,"./icons/message-square-share.js":false,"./icons/message-square-text.js":false,"./icons/message-square-warning.js":false,"./icons/message-square-x.js":false,"./icons/message-square.js":false,"./icons/messages-square.js":false,"./icons/mic-2.js":false,"./icons/mic-off.js":false,"./icons/mic.js":false,"./icons/microscope.js":false,"./icons/microwave.js":false,"./icons/milestone.js":false,"./icons/milk-off.js":false,"./icons/milk.js":false,"./icons/minimize-2.js":false,"./icons/minimize.js":false,"./icons/minus-circle.js":false,"./icons/minus-square.js":false,"./icons/minus.js":false,"./icons/monitor-check.js":false,"./icons/monitor-dot.js":false,"./icons/monitor-down.js":false,"./icons/monitor-off.js":false,"./icons/monitor-pause.js":false,"./icons/monitor-play.js":false,"./icons/monitor-smartphone.js":false,"./icons/monitor-speaker.js":false,"./icons/monitor-stop.js":false,"./icons/monitor-up.js":false,"./icons/monitor-x.js":false,"./icons/monitor.js":false,"./icons/moon-star.js":false,"./icons/moon.js":false,"./icons/more-horizontal.js":false,"./icons/more-vertical.js":false,"./icons/mountain-snow.js":false,"./icons/mountain.js":false,"./icons/mouse-pointer-2.js":false,"./icons/mouse-pointer-click.js":false,"./icons/mouse-pointer-square-dashed.js":false,"./icons/mouse-pointer.js":false,"./icons/mouse.js":false,"./icons/move-diagonal-2.js":false,"./icons/move-diagonal.js":false,"./icons/move-down-left.js":false,"./icons/move-down-right.js":false,"./icons/move-down.js":false,"./icons/move-horizontal.js":false,"./icons/move-left.js":false,"./icons/move-right.js":false,"./icons/move-up-left.js":false,"./icons/move-up-right.js":false,"./icons/move-up.js":false,"./icons/move-vertical.js":false,"./icons/move.js":false,"./icons/music-2.js":"d9mIJ","./icons/music-3.js":false,"./icons/music-4.js":false,"./icons/music.js":false,"./icons/navigation-2-off.js":false,"./icons/navigation-2.js":false,"./icons/navigation-off.js":false,"./icons/navigation.js":false,"./icons/network.js":false,"./icons/newspaper.js":false,"./icons/nfc.js":false,"./icons/notebook-pen.js":false,"./icons/notebook-tabs.js":false,"./icons/notebook-text.js":false,"./icons/notebook.js":false,"./icons/notepad-text-dashed.js":false,"./icons/notepad-text.js":false,"./icons/nut-off.js":false,"./icons/nut.js":false,"./icons/octagon.js":false,"./icons/option.js":false,"./icons/orbit.js":false,"./icons/outdent.js":false,"./icons/package-2.js":false,"./icons/package-check.js":false,"./icons/package-minus.js":false,"./icons/package-open.js":false,"./icons/package-plus.js":false,"./icons/package-search.js":false,"./icons/package-x.js":false,"./icons/package.js":false,"./icons/paint-bucket.js":false,"./icons/paint-roller.js":false,"./icons/paintbrush-2.js":false,"./icons/paintbrush.js":false,"./icons/palette.js":false,"./icons/palmtree.js":false,"./icons/panel-bottom-close.js":false,"./icons/panel-bottom-open.js":false,"./icons/panel-bottom.js":false,"./icons/panel-right-close.js":false,"./icons/panel-right-open.js":false,"./icons/panel-right.js":false,"./icons/panel-top-close.js":false,"./icons/panel-top-open.js":false,"./icons/panel-top.js":false,"./icons/panels-left-bottom.js":false,"./icons/panels-right-bottom.js":false,"./icons/paperclip.js":false,"./icons/parentheses.js":false,"./icons/parking-circle-off.js":false,"./icons/parking-circle.js":false,"./icons/parking-meter.js":false,"./icons/parking-square-off.js":false,"./icons/parking-square.js":false,"./icons/party-popper.js":false,"./icons/pause-circle.js":false,"./icons/pause-octagon.js":false,"./icons/pause.js":"lWBPz","./icons/paw-print.js":false,"./icons/pc-case.js":false,"./icons/pen-tool.js":false,"./icons/pencil-line.js":false,"./icons/pencil-ruler.js":false,"./icons/pencil.js":false,"./icons/pentagon.js":false,"./icons/percent-circle.js":false,"./icons/percent-diamond.js":false,"./icons/percent-square.js":false,"./icons/percent.js":false,"./icons/person-standing.js":false,"./icons/phone-call.js":false,"./icons/phone-forwarded.js":false,"./icons/phone-incoming.js":false,"./icons/phone-missed.js":false,"./icons/phone-off.js":false,"./icons/phone-outgoing.js":false,"./icons/phone.js":false,"./icons/pi-square.js":false,"./icons/pi.js":false,"./icons/piano.js":false,"./icons/pickaxe.js":false,"./icons/picture-in-picture-2.js":false,"./icons/picture-in-picture.js":false,"./icons/pie-chart.js":false,"./icons/piggy-bank.js":false,"./icons/pilcrow-square.js":false,"./icons/pilcrow.js":false,"./icons/pill.js":false,"./icons/pin-off.js":false,"./icons/pin.js":false,"./icons/pipette.js":false,"./icons/pizza.js":false,"./icons/plane-landing.js":false,"./icons/plane-takeoff.js":false,"./icons/plane.js":false,"./icons/play-circle.js":false,"./icons/play-square.js":false,"./icons/play.js":"kABIU","./icons/plug-2.js":false,"./icons/plug-zap-2.js":false,"./icons/plug-zap.js":false,"./icons/plug.js":false,"./icons/plus-circle.js":false,"./icons/plus-square.js":false,"./icons/plus.js":false,"./icons/pocket-knife.js":false,"./icons/pocket.js":false,"./icons/podcast.js":false,"./icons/pointer-off.js":false,"./icons/pointer.js":false,"./icons/popcorn.js":false,"./icons/popsicle.js":false,"./icons/pound-sterling.js":false,"./icons/power-circle.js":false,"./icons/power-off.js":false,"./icons/power-square.js":false,"./icons/power.js":false,"./icons/presentation.js":false,"./icons/printer.js":false,"./icons/projector.js":false,"./icons/puzzle.js":false,"./icons/pyramid.js":false,"./icons/qr-code.js":false,"./icons/quote.js":false,"./icons/rabbit.js":false,"./icons/radar.js":false,"./icons/radiation.js":false,"./icons/radical.js":false,"./icons/radio-receiver.js":false,"./icons/radio-tower.js":false,"./icons/radio.js":false,"./icons/radius.js":false,"./icons/rail-symbol.js":false,"./icons/rainbow.js":false,"./icons/rat.js":false,"./icons/ratio.js":false,"./icons/receipt-cent.js":false,"./icons/receipt-euro.js":false,"./icons/receipt-indian-rupee.js":false,"./icons/receipt-japanese-yen.js":false,"./icons/receipt-pound-sterling.js":false,"./icons/receipt-russian-ruble.js":false,"./icons/receipt-swiss-franc.js":false,"./icons/receipt-text.js":false,"./icons/receipt.js":false,"./icons/rectangle-horizontal.js":false,"./icons/rectangle-vertical.js":false,"./icons/recycle.js":false,"./icons/redo-2.js":false,"./icons/redo-dot.js":false,"./icons/redo.js":false,"./icons/refresh-ccw-dot.js":false,"./icons/refresh-ccw.js":false,"./icons/refresh-cw-off.js":false,"./icons/refresh-cw.js":false,"./icons/refrigerator.js":false,"./icons/regex.js":false,"./icons/remove-formatting.js":false,"./icons/repeat-1.js":false,"./icons/repeat-2.js":false,"./icons/repeat.js":false,"./icons/replace-all.js":false,"./icons/replace.js":false,"./icons/reply-all.js":false,"./icons/reply.js":false,"./icons/rewind.js":false,"./icons/ribbon.js":false,"./icons/rocket.js":false,"./icons/rocking-chair.js":false,"./icons/roller-coaster.js":false,"./icons/rotate-ccw.js":false,"./icons/rotate-cw.js":false,"./icons/route-off.js":false,"./icons/route.js":false,"./icons/router.js":false,"./icons/rows-4.js":false,"./icons/rss.js":false,"./icons/ruler.js":false,"./icons/russian-ruble.js":false,"./icons/sailboat.js":false,"./icons/salad.js":false,"./icons/sandwich.js":false,"./icons/satellite-dish.js":false,"./icons/satellite.js":false,"./icons/save-all.js":false,"./icons/save.js":false,"./icons/scale.js":false,"./icons/scaling.js":false,"./icons/scan-barcode.js":false,"./icons/scan-eye.js":false,"./icons/scan-face.js":false,"./icons/scan-line.js":false,"./icons/scan-search.js":false,"./icons/scan-text.js":false,"./icons/scan.js":false,"./icons/scatter-chart.js":false,"./icons/school-2.js":false,"./icons/school.js":false,"./icons/scissors-line-dashed.js":false,"./icons/scissors-square-dashed-bottom.js":false,"./icons/scissors-square.js":false,"./icons/scissors.js":false,"./icons/screen-share-off.js":false,"./icons/screen-share.js":false,"./icons/scroll-text.js":false,"./icons/scroll.js":false,"./icons/search-check.js":false,"./icons/search-code.js":false,"./icons/search-slash.js":false,"./icons/search-x.js":false,"./icons/search.js":false,"./icons/send-to-back.js":false,"./icons/send.js":false,"./icons/separator-horizontal.js":false,"./icons/separator-vertical.js":false,"./icons/server-cog.js":false,"./icons/server-crash.js":false,"./icons/server-off.js":false,"./icons/server.js":false,"./icons/settings-2.js":false,"./icons/settings.js":"e4EaB","./icons/shapes.js":false,"./icons/share-2.js":false,"./icons/share.js":false,"./icons/sheet.js":false,"./icons/shell.js":false,"./icons/shield-alert.js":false,"./icons/shield-ban.js":false,"./icons/shield-check.js":false,"./icons/shield-ellipsis.js":false,"./icons/shield-half.js":false,"./icons/shield-minus.js":false,"./icons/shield-off.js":false,"./icons/shield-plus.js":false,"./icons/shield-question.js":false,"./icons/shield.js":false,"./icons/ship-wheel.js":false,"./icons/ship.js":false,"./icons/shirt.js":false,"./icons/shopping-bag.js":false,"./icons/shopping-basket.js":false,"./icons/shopping-cart.js":false,"./icons/shovel.js":false,"./icons/shower-head.js":false,"./icons/shrink.js":false,"./icons/shrub.js":false,"./icons/shuffle.js":false,"./icons/sigma-square.js":false,"./icons/sigma.js":false,"./icons/signal-high.js":false,"./icons/signal-low.js":false,"./icons/signal-medium.js":false,"./icons/signal-zero.js":false,"./icons/signal.js":false,"./icons/signpost-big.js":false,"./icons/signpost.js":false,"./icons/siren.js":false,"./icons/skip-back.js":false,"./icons/skip-forward.js":false,"./icons/skull.js":false,"./icons/slack.js":false,"./icons/slash.js":false,"./icons/slice.js":false,"./icons/sliders-horizontal.js":false,"./icons/sliders.js":false,"./icons/smartphone-charging.js":false,"./icons/smartphone-nfc.js":false,"./icons/smartphone.js":false,"./icons/smile-plus.js":false,"./icons/smile.js":false,"./icons/snail.js":false,"./icons/snowflake.js":false,"./icons/sofa.js":false,"./icons/soup.js":false,"./icons/space.js":false,"./icons/spade.js":false,"./icons/sparkle.js":false,"./icons/speaker.js":false,"./icons/speech.js":false,"./icons/spell-check-2.js":false,"./icons/spell-check.js":false,"./icons/spline.js":false,"./icons/split-square-horizontal.js":false,"./icons/split-square-vertical.js":false,"./icons/split.js":false,"./icons/spray-can.js":false,"./icons/sprout.js":false,"./icons/square-dashed-bottom-code.js":false,"./icons/square-dashed-bottom.js":false,"./icons/square-radical.js":false,"./icons/square-stack.js":false,"./icons/square.js":false,"./icons/squircle.js":false,"./icons/squirrel.js":false,"./icons/stamp.js":false,"./icons/star-half.js":false,"./icons/star-off.js":false,"./icons/star.js":false,"./icons/step-back.js":false,"./icons/step-forward.js":false,"./icons/stethoscope.js":false,"./icons/sticker.js":false,"./icons/sticky-note.js":false,"./icons/stop-circle.js":false,"./icons/store.js":false,"./icons/stretch-horizontal.js":false,"./icons/stretch-vertical.js":false,"./icons/strikethrough.js":false,"./icons/subscript.js":false,"./icons/sun-dim.js":false,"./icons/sun-medium.js":false,"./icons/sun-moon.js":false,"./icons/sun-snow.js":false,"./icons/sun.js":false,"./icons/sunrise.js":false,"./icons/sunset.js":false,"./icons/superscript.js":false,"./icons/swatch-book.js":false,"./icons/swiss-franc.js":false,"./icons/switch-camera.js":false,"./icons/sword.js":false,"./icons/swords.js":false,"./icons/syringe.js":false,"./icons/table-2.js":false,"./icons/table-cells-merge.js":false,"./icons/table-cells-split.js":false,"./icons/table-columns-split.js":false,"./icons/table-properties.js":false,"./icons/table-rows-split.js":false,"./icons/table.js":false,"./icons/tablet-smartphone.js":false,"./icons/tablet.js":false,"./icons/tablets.js":false,"./icons/tag.js":false,"./icons/tags.js":false,"./icons/tally-1.js":false,"./icons/tally-2.js":false,"./icons/tally-3.js":false,"./icons/tally-4.js":false,"./icons/tally-5.js":false,"./icons/tangent.js":false,"./icons/target.js":false,"./icons/telescope.js":false,"./icons/tent-tree.js":false,"./icons/tent.js":false,"./icons/terminal-square.js":false,"./icons/terminal.js":false,"./icons/test-tube-2.js":false,"./icons/test-tube.js":false,"./icons/test-tubes.js":false,"./icons/text-cursor-input.js":false,"./icons/text-cursor.js":false,"./icons/text-quote.js":false,"./icons/text-search.js":false,"./icons/text.js":false,"./icons/theater.js":false,"./icons/thermometer-snowflake.js":false,"./icons/thermometer-sun.js":false,"./icons/thermometer.js":false,"./icons/thumbs-down.js":false,"./icons/thumbs-up.js":false,"./icons/ticket-check.js":false,"./icons/ticket-minus.js":false,"./icons/ticket-percent.js":false,"./icons/ticket-plus.js":false,"./icons/ticket-slash.js":false,"./icons/ticket-x.js":false,"./icons/ticket.js":false,"./icons/timer-off.js":false,"./icons/timer-reset.js":false,"./icons/timer.js":false,"./icons/toggle-left.js":false,"./icons/toggle-right.js":false,"./icons/tornado.js":false,"./icons/torus.js":false,"./icons/touchpad-off.js":false,"./icons/touchpad.js":false,"./icons/tower-control.js":false,"./icons/toy-brick.js":false,"./icons/tractor.js":false,"./icons/traffic-cone.js":false,"./icons/train-front-tunnel.js":false,"./icons/train-front.js":false,"./icons/train-track.js":false,"./icons/trash-2.js":false,"./icons/trash.js":false,"./icons/tree-deciduous.js":false,"./icons/tree-pine.js":false,"./icons/trees.js":false,"./icons/trello.js":false,"./icons/trending-down.js":false,"./icons/trending-up.js":false,"./icons/triangle-right.js":false,"./icons/triangle.js":false,"./icons/trophy.js":false,"./icons/truck.js":false,"./icons/turtle.js":false,"./icons/tv-2.js":false,"./icons/tv.js":false,"./icons/twitch.js":false,"./icons/twitter.js":false,"./icons/type.js":false,"./icons/umbrella-off.js":false,"./icons/umbrella.js":false,"./icons/underline.js":false,"./icons/undo-2.js":false,"./icons/undo-dot.js":false,"./icons/undo.js":false,"./icons/unfold-horizontal.js":false,"./icons/unfold-vertical.js":false,"./icons/ungroup.js":false,"./icons/unlink-2.js":false,"./icons/unlink.js":false,"./icons/unlock-keyhole.js":false,"./icons/unlock.js":false,"./icons/unplug.js":false,"./icons/upload-cloud.js":false,"./icons/upload.js":"uI7y1","./icons/usb.js":false,"./icons/user-check.js":false,"./icons/user-cog.js":false,"./icons/user-minus.js":false,"./icons/user-plus.js":false,"./icons/user-round-search.js":false,"./icons/user-search.js":false,"./icons/user-x.js":false,"./icons/user.js":false,"./icons/users.js":false,"./icons/utensils-crossed.js":false,"./icons/utensils.js":false,"./icons/utility-pole.js":false,"./icons/variable.js":false,"./icons/vault.js":false,"./icons/vegan.js":false,"./icons/venetian-mask.js":false,"./icons/vibrate-off.js":false,"./icons/vibrate.js":false,"./icons/video-off.js":false,"./icons/video.js":false,"./icons/videotape.js":false,"./icons/view.js":false,"./icons/voicemail.js":false,"./icons/volume-1.js":false,"./icons/volume-2.js":false,"./icons/volume-x.js":false,"./icons/volume.js":false,"./icons/vote.js":false,"./icons/wallet-2.js":false,"./icons/wallet-cards.js":false,"./icons/wallet.js":false,"./icons/wallpaper.js":false,"./icons/wand-2.js":false,"./icons/wand.js":false,"./icons/warehouse.js":false,"./icons/washing-machine.js":false,"./icons/watch.js":false,"./icons/waves.js":false,"./icons/waypoints.js":false,"./icons/webcam.js":false,"./icons/webhook-off.js":false,"./icons/webhook.js":false,"./icons/weight.js":false,"./icons/wheat-off.js":false,"./icons/wheat.js":false,"./icons/whole-word.js":false,"./icons/wifi-off.js":false,"./icons/wifi.js":false,"./icons/wind.js":false,"./icons/wine-off.js":false,"./icons/wine.js":false,"./icons/workflow.js":false,"./icons/wrap-text.js":false,"./icons/wrench.js":false,"./icons/x-circle.js":false,"./icons/x-octagon.js":false,"./icons/x-square.js":false,"./icons/x.js":false,"./icons/youtube.js":false,"./icons/zap-off.js":false,"./icons/zap.js":false,"./icons/zoom-in.js":false,"./icons/zoom-out.js":false,"./icons/alarm-clock-check.js":false,"./icons/alarm-clock-minus.js":false,"./icons/alarm-clock-plus.js":false,"./icons/arrow-down-0-1.js":false,"./icons/arrow-down-1-0.js":false,"./icons/arrow-down-a-z.js":false,"./icons/arrow-down-wide-narrow.js":false,"./icons/arrow-down-z-a.js":false,"./icons/arrow-up-0-1.js":false,"./icons/arrow-up-1-0.js":false,"./icons/arrow-up-a-z.js":false,"./icons/arrow-up-narrow-wide.js":false,"./icons/arrow-up-z-a.js":false,"./icons/asterisk-square.js":false,"./icons/badge-check.js":false,"./icons/axis-3d.js":false,"./icons/between-horizontal-end.js":false,"./icons/between-horizontal-start.js":false,"./icons/book-dashed.js":false,"./icons/braces.js":false,"./icons/captions.js":false,"./icons/circle-slash-2.js":false,"./icons/circle-user-round.js":false,"./icons/circle-user.js":false,"./icons/clipboard-pen-line.js":false,"./icons/clipboard-pen.js":false,"./icons/code-square.js":false,"./icons/columns-2.js":false,"./icons/columns-3.js":false,"./icons/dot-square.js":false,"./icons/earth.js":false,"./icons/file-axis-3d.js":false,"./icons/file-cog.js":false,"./icons/equal-square.js":false,"./icons/file-pen-line.js":false,"./icons/file-pen.js":false,"./icons/folder-cog.js":false,"./icons/folder-pen.js":false,"./icons/gantt-chart-square.js":false,"./icons/git-commit-horizontal.js":false,"./icons/grid-2x2.js":false,"./icons/grid-3x3.js":false,"./icons/hand-helping.js":false,"./icons/kanban-square-dashed.js":false,"./icons/kanban-square.js":false,"./icons/mouse-pointer-square.js":false,"./icons/move-3d.js":false,"./icons/panel-left-close.js":false,"./icons/panel-bottom-dashed.js":false,"./icons/panel-left-dashed.js":false,"./icons/panel-left-open.js":false,"./icons/panel-left.js":false,"./icons/panel-right-dashed.js":false,"./icons/panel-top-dashed.js":false,"./icons/panels-top-left.js":false,"./icons/pen-line.js":false,"./icons/pen.js":false,"./icons/rotate-3d.js":false,"./icons/rows-2.js":false,"./icons/rows-3.js":false,"./icons/scale-3d.js":false,"./icons/send-horizontal.js":false,"./icons/shield-x.js":false,"./icons/sparkles.js":false,"./icons/slash-square.js":false,"./icons/square-pen.js":false,"./icons/square-user-round.js":false,"./icons/square-user.js":false,"./icons/text-select.js":false,"./icons/tram-front.js":false,"./icons/user-round-check.js":false,"./icons/user-round-cog.js":false,"./icons/user-round-minus.js":false,"./icons/user-round-plus.js":false,"./icons/user-round-x.js":false,"./icons/user-round.js":false,"./icons/users-round.js":false,"./createLucideIcon.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c56lO":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FileText);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const FileText = (0, _createLucideIconJsDefault.default)("FileText", [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
]);

},{"../createLucideIcon.js":"gag9g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gag9g":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createLucideIcon);
parcelHelpers.export(exports, "toKebabCase", ()=>toKebabCase);
var _react = require("react");
var _defaultAttributesJs = require("./defaultAttributes.js");
var _defaultAttributesJsDefault = parcelHelpers.interopDefault(_defaultAttributesJs);
const toKebabCase = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase().trim();
const createLucideIcon = (iconName, iconNode)=>{
    const Component = (0, _react.forwardRef)(({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, ...rest }, ref)=>{
        return (0, _react.createElement)("svg", {
            ref,
            ...(0, _defaultAttributesJsDefault.default),
            width: size,
            height: size,
            stroke: color,
            strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
            className: [
                "lucide",
                `lucide-${toKebabCase(iconName)}`,
                className
            ].join(" "),
            ...rest
        }, [
            ...iconNode.map(([tag, attrs])=>(0, _react.createElement)(tag, attrs)),
            ...Array.isArray(children) ? children : [
                children
            ]
        ]);
    });
    Component.displayName = `${iconName}`;
    return Component;
};

},{"react":"6uln9","./defaultAttributes.js":"lfZ95","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lfZ95":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defaultAttributes);
var defaultAttributes = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"f2SoA":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GripVertical);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const GripVertical = (0, _createLucideIconJsDefault.default)("GripVertical", [
    [
        "circle",
        {
            cx: "9",
            cy: "12",
            r: "1",
            key: "1vctgf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "5",
            r: "1",
            key: "hp0tcf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "19",
            r: "1",
            key: "fkjjf6"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "12",
            r: "1",
            key: "1tmaij"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "5",
            r: "1",
            key: "19l28e"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "19",
            r: "1",
            key: "f4zoj3"
        }
    ]
]);

},{"../createLucideIcon.js":"gag9g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Tb0e":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Home);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const Home = (0, _createLucideIconJsDefault.default)("Home", [
    [
        "path",
        {
            d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
            key: "y5dka4"
        }
    ],
    [
        "polyline",
        {
            points: "9 22 9 12 15 12 15 22",
            key: "e2us08"
        }
    ]
]);

},{"../createLucideIcon.js":"gag9g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d9mIJ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Music2);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const Music2 = (0, _createLucideIconJsDefault.default)("Music2", [
    [
        "circle",
        {
            cx: "8",
            cy: "18",
            r: "4",
            key: "1fc0mg"
        }
    ],
    [
        "path",
        {
            d: "M12 18V2l7 4",
            key: "g04rme"
        }
    ]
]);

},{"../createLucideIcon.js":"gag9g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lWBPz":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Pause);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const Pause = (0, _createLucideIconJsDefault.default)("Pause", [
    [
        "rect",
        {
            width: "4",
            height: "16",
            x: "6",
            y: "4",
            key: "iffhe4"
        }
    ],
    [
        "rect",
        {
            width: "4",
            height: "16",
            x: "14",
            y: "4",
            key: "sjin7j"
        }
    ]
]);

},{"../createLucideIcon.js":"gag9g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kABIU":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Play);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const Play = (0, _createLucideIconJsDefault.default)("Play", [
    [
        "polygon",
        {
            points: "5 3 19 12 5 21 5 3",
            key: "191637"
        }
    ]
]);

},{"../createLucideIcon.js":"gag9g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e4EaB":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Settings);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const Settings = (0, _createLucideIconJsDefault.default)("Settings", [
    [
        "path",
        {
            d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
            key: "1qme2f"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
]);

},{"../createLucideIcon.js":"gag9g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"uI7y1":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Upload);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const Upload = (0, _createLucideIconJsDefault.default)("Upload", [
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "polyline",
        {
            points: "17 8 12 3 7 8",
            key: "t8dd8p"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "3",
            y2: "15",
            key: "widbto"
        }
    ]
]);

},{"../createLucideIcon.js":"gag9g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dHWq4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AudioUploader);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lucideReact = require("lucide-react");
var _appContext = require("../AppContext");
function AudioUploader() {
    const [isPlaying, setIsPlaying] = (0, _react.useState)(false);
    const audioRef = (0, _react.useRef)(null);
    const { input: audioFile, setInput: setAudioFile } = (0, _reactDefault.default).useContext((0, _appContext.AppContext));
    const handleFileChange = (event)=>{
        const file = event.target.files?.[0];
        if (file && file.type.startsWith('audio/')) setAudioFile(file);
    };
    const audioFileUrl = ()=>{
        let result;
        if (!audioFile) result = '';
        else result = URL.createObjectURL(audioFile);
        console.log('audio file url:', result);
        return result;
    };
    const togglePlay = ()=>{
        if (audioRef.current) {
            if (isPlaying) audioRef.current.pause();
            else audioRef.current.play();
            setIsPlaying(!isPlaying);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col items-center justify-center w-full h-full bg-gray-50 p-8",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "w-full max-w-md",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "mb-8 text-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "text-2xl font-bold text-gray-800 mb-2",
                            children: "Audio Upload"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-gray-600",
                            children: "Upload and play your audio files"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "bg-white rounded-lg shadow-md p-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            className: "flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col items-center justify-center pt-5 pb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Upload), {
                                            className: "w-10 h-10 mb-3 text-gray-400"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "mb-2 text-sm text-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-semibold",
                                                    children: "Click to upload"
                                                }),
                                                " or drag and drop"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-xs text-gray-500",
                                            children: "Audio files (MP3, WAV)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "file",
                                    className: "hidden",
                                    accept: "audio/*",
                                    onChange: handleFileChange
                                })
                            ]
                        }),
                        audioFile && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mt-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center justify-between bg-gray-100 p-4 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center space-x-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Music2), {
                                                    className: "w-5 h-5 text-gray-600"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-sm font-medium text-gray-700 truncate",
                                                    children: audioFile instanceof File && audioFile.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: togglePlay,
                                            className: "p-2 rounded-full hover:bg-gray-200 transition-colors",
                                            children: isPlaying ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Pause), {
                                                className: "w-5 h-5 text-gray-600"
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Play), {
                                                className: "w-5 h-5 text-gray-600"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("audio", {
                                    controls: true,
                                    ref: audioRef,
                                    className: "hidden",
                                    onEnded: ()=>setIsPlaying(false),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                                        src: audioFileUrl(),
                                        type: "audio/mp3"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","lucide-react":"62Bzb","../AppContext":"fiPIn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fiPIn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppContext", ()=>AppContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const AppContext = (0, _reactDefault.default).createContext({});

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k8fhc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MermaidDiagram);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _mermaid = require("mermaid");
var _mermaidDefault = parcelHelpers.interopDefault(_mermaid);
(0, _mermaidDefault.default).initialize({
    startOnLoad: false,
    theme: 'default',
    securityLevel: 'loose',
    flowchart: {
        htmlLabels: true,
        curve: 'basis'
    }
});
function MermaidDiagram({ diagram }) {
    const mermaidRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const renderMermaid = async ()=>{
            if (mermaidRef.current) // mermaidRef.current.innerHTML = '';
            try {
                const { svg } = await (0, _mermaidDefault.default).render('mermaid-diagram', diagram);
                console.log('render', diagram);
                // Inject the SVG into the container
                mermaidRef.current.innerHTML = svg;
            } catch (error) {
                console.error('Error rendering mermaid diagram:', error);
            }
        };
        setTimeout(renderMermaid, 100); // render fix
    }, [
        diagram
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col items-center justify-center w-full h-full bg-white p-8",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "w-full h-full flex flex-col",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex-1 bg-gray-50 rounded-lg shadow-md p-4 overflow-hidden",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    ref: mermaidRef,
                    className: "w-full h-full flex justify-center items-center overflow-auto"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","mermaid":"gqwIj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gqwIj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _mermaidB5860B54Js.N));
var _tsDedent = require("ts-dedent");
var _mermaidB5860B54Js = require("./mermaid-b5860b54.js");
var _dayjs = require("dayjs");
var _sanitizeUrl = require("@braintree/sanitize-url");
var _d3 = require("d3");
var _dompurify = require("dompurify");
var _khroma = require("khroma");
var _memoizeJs = require("lodash-es/memoize.js");
var _mergeJs = require("lodash-es/merge.js");
var _stylis = require("stylis");
var _isEmptyJs = require("lodash-es/isEmpty.js");

},{"ts-dedent":"azOLv","./mermaid-b5860b54.js":"2omMO","dayjs":"8F3kd","@braintree/sanitize-url":"eIPUt","d3":"ahWNw","dompurify":"5cPaM","khroma":false,"lodash-es/memoize.js":false,"lodash-es/merge.js":false,"stylis":false,"lodash-es/isEmpty.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"azOLv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dedent", ()=>dedent);
function dedent(templ) {
    var values = [];
    for(var _i = 1; _i < arguments.length; _i++)values[_i - 1] = arguments[_i];
    var strings = Array.from(typeof templ === 'string' ? [
        templ
    ] : templ);
    strings[strings.length - 1] = strings[strings.length - 1].replace(/\r?\n([\t ]*)$/, '');
    var indentLengths = strings.reduce(function(arr, str) {
        var matches = str.match(/\n([\t ]+|(?!\s).)/g);
        if (matches) return arr.concat(matches.map(function(match) {
            var _a, _b;
            return (_b = (_a = match.match(/[\t ]/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        }));
        return arr;
    }, []);
    if (indentLengths.length) {
        var pattern_1 = new RegExp("\n[\t ]{" + Math.min.apply(Math, indentLengths) + "}", 'g');
        strings = strings.map(function(str) {
            return str.replace(pattern_1, '\n');
        });
    }
    strings[0] = strings[0].replace(/^\r?\n/, '');
    var string = strings[0];
    values.forEach(function(value, i) {
        var endentations = string.match(/(?:^|\n)( *)$/);
        var endentation = endentations ? endentations[1] : '';
        var indentedValue = value;
        if (typeof value === 'string' && value.includes('\n')) indentedValue = String(value).split('\n').map(function(str, i) {
            return i === 0 ? str : "" + endentation + str;
        }).join('\n');
        string += indentedValue + strings[i + 1];
    });
    return string;
}
exports.default = dedent;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2omMO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "A", ()=>selectSvgElement);
parcelHelpers.export(exports, "B", ()=>defaultConfig$2);
parcelHelpers.export(exports, "C", ()=>cleanAndMerge);
parcelHelpers.export(exports, "D", ()=>parseFontSize);
parcelHelpers.export(exports, "E", ()=>getThemeVariables$2);
parcelHelpers.export(exports, "F", ()=>getConfig$1);
parcelHelpers.export(exports, "G", ()=>hasKatex);
parcelHelpers.export(exports, "H", ()=>calculateMathMLDimensions);
parcelHelpers.export(exports, "I", ()=>generateId);
parcelHelpers.export(exports, "J", ()=>lineBreakRegex);
parcelHelpers.export(exports, "K", ()=>defaultConfig);
parcelHelpers.export(exports, "L", ()=>commonDb);
parcelHelpers.export(exports, "M", ()=>decodeEntities);
parcelHelpers.export(exports, "N", ()=>mermaid);
parcelHelpers.export(exports, "Z", ()=>ZERO_WIDTH_SPACE);
parcelHelpers.export(exports, "a", ()=>getAccDescription);
parcelHelpers.export(exports, "b", ()=>setAccDescription);
parcelHelpers.export(exports, "c", ()=>getConfig);
parcelHelpers.export(exports, "d", ()=>sanitizeText$2);
parcelHelpers.export(exports, "e", ()=>common$1);
parcelHelpers.export(exports, "f", ()=>assignWithDepth$1);
parcelHelpers.export(exports, "g", ()=>getAccTitle);
parcelHelpers.export(exports, "h", ()=>calculateTextWidth);
parcelHelpers.export(exports, "i", ()=>configureSvgSize);
parcelHelpers.export(exports, "j", ()=>calculateTextHeight);
parcelHelpers.export(exports, "k", ()=>getStylesFromArray);
parcelHelpers.export(exports, "l", ()=>log$1);
parcelHelpers.export(exports, "m", ()=>evaluate);
parcelHelpers.export(exports, "n", ()=>interpolateToCurve);
parcelHelpers.export(exports, "o", ()=>setupGraphViewbox$1);
parcelHelpers.export(exports, "p", ()=>setConfig);
parcelHelpers.export(exports, "q", ()=>setDiagramTitle);
parcelHelpers.export(exports, "r", ()=>renderKatex);
parcelHelpers.export(exports, "s", ()=>setAccTitle);
parcelHelpers.export(exports, "t", ()=>getDiagramTitle);
parcelHelpers.export(exports, "u", ()=>utils);
parcelHelpers.export(exports, "v", ()=>clear);
parcelHelpers.export(exports, "w", ()=>wrapLabel);
parcelHelpers.export(exports, "x", ()=>parseGenericTypes);
parcelHelpers.export(exports, "y", ()=>random);
parcelHelpers.export(exports, "z", ()=>setupGraphViewbox);
var _tsDedent = require("ts-dedent");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _sanitizeUrl = require("@braintree/sanitize-url");
var _d3 = require("d3");
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
var _khroma = require("khroma");
var _memoizeJs = require("lodash-es/memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
var _mergeJs = require("lodash-es/merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _stylis = require("stylis");
var _isEmptyJs = require("lodash-es/isEmpty.js");
var _isEmptyJsDefault = parcelHelpers.interopDefault(_isEmptyJs);
const LEVELS = {
    trace: 0,
    debug: 1,
    info: 2,
    warn: 3,
    error: 4,
    fatal: 5
};
const log$1 = {
    trace: (..._args)=>{},
    debug: (..._args)=>{},
    info: (..._args)=>{},
    warn: (..._args)=>{},
    error: (..._args)=>{},
    fatal: (..._args)=>{}
};
const setLogLevel$1 = function(level = "fatal") {
    let numericLevel = LEVELS.fatal;
    if (typeof level === "string") {
        level = level.toLowerCase();
        if (level in LEVELS) numericLevel = LEVELS[level];
    } else if (typeof level === "number") numericLevel = level;
    log$1.trace = ()=>{};
    log$1.debug = ()=>{};
    log$1.info = ()=>{};
    log$1.warn = ()=>{};
    log$1.error = ()=>{};
    log$1.fatal = ()=>{};
    if (numericLevel <= LEVELS.fatal) log$1.fatal = console.error ? console.error.bind(console, format("FATAL"), "color: orange") : console.log.bind(console, "\x1B[35m", format("FATAL"));
    if (numericLevel <= LEVELS.error) log$1.error = console.error ? console.error.bind(console, format("ERROR"), "color: orange") : console.log.bind(console, "\x1B[31m", format("ERROR"));
    if (numericLevel <= LEVELS.warn) log$1.warn = console.warn ? console.warn.bind(console, format("WARN"), "color: orange") : console.log.bind(console, `\x1B[33m`, format("WARN"));
    if (numericLevel <= LEVELS.info) log$1.info = console.info ? console.info.bind(console, format("INFO"), "color: lightblue") : console.log.bind(console, "\x1B[34m", format("INFO"));
    if (numericLevel <= LEVELS.debug) log$1.debug = console.debug ? console.debug.bind(console, format("DEBUG"), "color: lightgreen") : console.log.bind(console, "\x1B[32m", format("DEBUG"));
    if (numericLevel <= LEVELS.trace) log$1.trace = console.debug ? console.debug.bind(console, format("TRACE"), "color: lightgreen") : console.log.bind(console, "\x1B[32m", format("TRACE"));
};
const format = (level)=>{
    const time = (0, _dayjsDefault.default)().format("ss.SSS");
    return `%c${time} : ${level} : `;
};
const lineBreakRegex = /<br\s*\/?>/gi;
const getRows = (s)=>{
    if (!s) return [
        ""
    ];
    const str2 = breakToPlaceholder(s).replace(/\\n/g, "#br#");
    return str2.split("#br#");
};
const setupDompurifyHooksIfNotSetup = (()=>{
    let setup = false;
    return ()=>{
        if (!setup) {
            setupDompurifyHooks();
            setup = true;
        }
    };
})();
function setupDompurifyHooks() {
    const TEMPORARY_ATTRIBUTE = "data-temp-href-target";
    (0, _dompurifyDefault.default).addHook("beforeSanitizeAttributes", (node)=>{
        if (node.tagName === "A" && node.hasAttribute("target")) node.setAttribute(TEMPORARY_ATTRIBUTE, node.getAttribute("target") || "");
    });
    (0, _dompurifyDefault.default).addHook("afterSanitizeAttributes", (node)=>{
        if (node.tagName === "A" && node.hasAttribute(TEMPORARY_ATTRIBUTE)) {
            node.setAttribute("target", node.getAttribute(TEMPORARY_ATTRIBUTE) || "");
            node.removeAttribute(TEMPORARY_ATTRIBUTE);
            if (node.getAttribute("target") === "_blank") node.setAttribute("rel", "noopener");
        }
    });
}
const removeScript = (txt)=>{
    setupDompurifyHooksIfNotSetup();
    const sanitizedText = (0, _dompurifyDefault.default).sanitize(txt);
    return sanitizedText;
};
const sanitizeMore = (text, config2)=>{
    var _a;
    if (((_a = config2.flowchart) == null ? void 0 : _a.htmlLabels) !== false) {
        const level = config2.securityLevel;
        if (level === "antiscript" || level === "strict") text = removeScript(text);
        else if (level !== "loose") {
            text = breakToPlaceholder(text);
            text = text.replace(/</g, "&lt;").replace(/>/g, "&gt;");
            text = text.replace(/=/g, "&equals;");
            text = placeholderToBreak(text);
        }
    }
    return text;
};
const sanitizeText$2 = (text, config2)=>{
    if (!text) return text;
    if (config2.dompurifyConfig) text = (0, _dompurifyDefault.default).sanitize(sanitizeMore(text, config2), config2.dompurifyConfig).toString();
    else text = (0, _dompurifyDefault.default).sanitize(sanitizeMore(text, config2), {
        FORBID_TAGS: [
            "style"
        ]
    }).toString();
    return text;
};
const sanitizeTextOrArray = (a, config2)=>{
    if (typeof a === "string") return sanitizeText$2(a, config2);
    return a.flat().map((x)=>sanitizeText$2(x, config2));
};
const hasBreaks = (text)=>{
    return lineBreakRegex.test(text);
};
const splitBreaks = (text)=>{
    return text.split(lineBreakRegex);
};
const placeholderToBreak = (s)=>{
    return s.replace(/#br#/g, "<br/>");
};
const breakToPlaceholder = (s)=>{
    return s.replace(lineBreakRegex, "#br#");
};
const getUrl = (useAbsolute)=>{
    let url = "";
    if (useAbsolute) {
        url = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search;
        url = url.replaceAll(/\(/g, "\\(");
        url = url.replaceAll(/\)/g, "\\)");
    }
    return url;
};
const evaluate = (val)=>val === false || [
        "false",
        "null",
        "0"
    ].includes(String(val).trim().toLowerCase()) ? false : true;
const getMax = function(...values) {
    const newValues = values.filter((value)=>{
        return !isNaN(value);
    });
    return Math.max(...newValues);
};
const getMin = function(...values) {
    const newValues = values.filter((value)=>{
        return !isNaN(value);
    });
    return Math.min(...newValues);
};
const parseGenericTypes = function(input) {
    const inputSets = input.split(/(,)/);
    const output = [];
    for(let i = 0; i < inputSets.length; i++){
        let thisSet = inputSets[i];
        if (thisSet === "," && i > 0 && i + 1 < inputSets.length) {
            const previousSet = inputSets[i - 1];
            const nextSet = inputSets[i + 1];
            if (shouldCombineSets(previousSet, nextSet)) {
                thisSet = previousSet + "," + nextSet;
                i++;
                output.pop();
            }
        }
        output.push(processSet(thisSet));
    }
    return output.join("");
};
const countOccurrence = (string, substring)=>{
    return Math.max(0, string.split(substring).length - 1);
};
const shouldCombineSets = (previousSet, nextSet)=>{
    const prevCount = countOccurrence(previousSet, "~");
    const nextCount = countOccurrence(nextSet, "~");
    return prevCount === 1 && nextCount === 1;
};
const processSet = (input)=>{
    const tildeCount = countOccurrence(input, "~");
    let hasStartingTilde = false;
    if (tildeCount <= 1) return input;
    if (tildeCount % 2 !== 0 && input.startsWith("~")) {
        input = input.substring(1);
        hasStartingTilde = true;
    }
    const chars = [
        ...input
    ];
    let first = chars.indexOf("~");
    let last = chars.lastIndexOf("~");
    while(first !== -1 && last !== -1 && first !== last){
        chars[first] = "<";
        chars[last] = ">";
        first = chars.indexOf("~");
        last = chars.lastIndexOf("~");
    }
    if (hasStartingTilde) chars.unshift("~");
    return chars.join("");
};
const isMathMLSupported = ()=>window.MathMLElement !== void 0;
const katexRegex = /\$\$(.*)\$\$/g;
const hasKatex = (text)=>{
    var _a;
    return (((_a = text.match(katexRegex)) == null ? void 0 : _a.length) ?? 0) > 0;
};
const calculateMathMLDimensions = async (text, config2)=>{
    text = await renderKatex(text, config2);
    const divElem = document.createElement("div");
    divElem.innerHTML = text;
    divElem.id = "katex-temp";
    divElem.style.visibility = "hidden";
    divElem.style.position = "absolute";
    divElem.style.top = "0";
    const body = document.querySelector("body");
    body == null || body.insertAdjacentElement("beforeend", divElem);
    const dim = {
        width: divElem.clientWidth,
        height: divElem.clientHeight
    };
    divElem.remove();
    return dim;
};
const renderKatex = async (text, config2)=>{
    if (!hasKatex(text)) return text;
    if (!isMathMLSupported() && !config2.legacyMathML) return text.replace(katexRegex, "MathML is unsupported in this environment.");
    const { default: katex } = await require("562e5fa709213015");
    return text.split(lineBreakRegex).map((line)=>hasKatex(line) ? `
            <div style="display: flex; align-items: center; justify-content: center; white-space: nowrap;">
              ${line}
            </div>
          ` : `<div>${line}</div>`).join("").replace(katexRegex, (_, c)=>katex.renderToString(c, {
            throwOnError: true,
            displayMode: true,
            output: isMathMLSupported() ? "mathml" : "htmlAndMathml"
        }).replace(/\n/g, " ").replace(/<annotation.*<\/annotation>/g, ""));
};
const common$1 = {
    getRows,
    sanitizeText: sanitizeText$2,
    sanitizeTextOrArray,
    hasBreaks,
    splitBreaks,
    lineBreakRegex,
    removeScript,
    getUrl,
    evaluate,
    getMax,
    getMin
};
const mkBorder = (col, darkMode)=>darkMode ? (0, _khroma.adjust)(col, {
        s: -40,
        l: 10
    }) : (0, _khroma.adjust)(col, {
        s: -40,
        l: -10
    });
const oldAttributeBackgroundColorOdd = "#ffffff";
const oldAttributeBackgroundColorEven = "#f2f2f2";
let Theme$4 = class Theme {
    constructor(){
        this.background = "#f4f4f4";
        this.primaryColor = "#fff4dd";
        this.noteBkgColor = "#fff5ad";
        this.noteTextColor = "#333";
        this.THEME_COLOR_LIMIT = 12;
        this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif';
        this.fontSize = "16px";
    }
    updateColors() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        this.primaryTextColor = this.primaryTextColor || (this.darkMode ? "#eee" : "#333");
        this.secondaryColor = this.secondaryColor || (0, _khroma.adjust)(this.primaryColor, {
            h: -120
        });
        this.tertiaryColor = this.tertiaryColor || (0, _khroma.adjust)(this.primaryColor, {
            h: 180,
            l: 5
        });
        this.primaryBorderColor = this.primaryBorderColor || mkBorder(this.primaryColor, this.darkMode);
        this.secondaryBorderColor = this.secondaryBorderColor || mkBorder(this.secondaryColor, this.darkMode);
        this.tertiaryBorderColor = this.tertiaryBorderColor || mkBorder(this.tertiaryColor, this.darkMode);
        this.noteBorderColor = this.noteBorderColor || mkBorder(this.noteBkgColor, this.darkMode);
        this.noteBkgColor = this.noteBkgColor || "#fff5ad";
        this.noteTextColor = this.noteTextColor || "#333";
        this.secondaryTextColor = this.secondaryTextColor || (0, _khroma.invert)(this.secondaryColor);
        this.tertiaryTextColor = this.tertiaryTextColor || (0, _khroma.invert)(this.tertiaryColor);
        this.lineColor = this.lineColor || (0, _khroma.invert)(this.background);
        this.arrowheadColor = this.arrowheadColor || (0, _khroma.invert)(this.background);
        this.textColor = this.textColor || this.primaryTextColor;
        this.border2 = this.border2 || this.tertiaryBorderColor;
        this.nodeBkg = this.nodeBkg || this.primaryColor;
        this.mainBkg = this.mainBkg || this.primaryColor;
        this.nodeBorder = this.nodeBorder || this.primaryBorderColor;
        this.clusterBkg = this.clusterBkg || this.tertiaryColor;
        this.clusterBorder = this.clusterBorder || this.tertiaryBorderColor;
        this.defaultLinkColor = this.defaultLinkColor || this.lineColor;
        this.titleColor = this.titleColor || this.tertiaryTextColor;
        this.edgeLabelBackground = this.edgeLabelBackground || (this.darkMode ? (0, _khroma.darken)(this.secondaryColor, 30) : this.secondaryColor);
        this.nodeTextColor = this.nodeTextColor || this.primaryTextColor;
        this.actorBorder = this.actorBorder || this.primaryBorderColor;
        this.actorBkg = this.actorBkg || this.mainBkg;
        this.actorTextColor = this.actorTextColor || this.primaryTextColor;
        this.actorLineColor = this.actorLineColor || "grey";
        this.labelBoxBkgColor = this.labelBoxBkgColor || this.actorBkg;
        this.signalColor = this.signalColor || this.textColor;
        this.signalTextColor = this.signalTextColor || this.textColor;
        this.labelBoxBorderColor = this.labelBoxBorderColor || this.actorBorder;
        this.labelTextColor = this.labelTextColor || this.actorTextColor;
        this.loopTextColor = this.loopTextColor || this.actorTextColor;
        this.activationBorderColor = this.activationBorderColor || (0, _khroma.darken)(this.secondaryColor, 10);
        this.activationBkgColor = this.activationBkgColor || this.secondaryColor;
        this.sequenceNumberColor = this.sequenceNumberColor || (0, _khroma.invert)(this.lineColor);
        this.sectionBkgColor = this.sectionBkgColor || this.tertiaryColor;
        this.altSectionBkgColor = this.altSectionBkgColor || "white";
        this.sectionBkgColor = this.sectionBkgColor || this.secondaryColor;
        this.sectionBkgColor2 = this.sectionBkgColor2 || this.primaryColor;
        this.excludeBkgColor = this.excludeBkgColor || "#eeeeee";
        this.taskBorderColor = this.taskBorderColor || this.primaryBorderColor;
        this.taskBkgColor = this.taskBkgColor || this.primaryColor;
        this.activeTaskBorderColor = this.activeTaskBorderColor || this.primaryColor;
        this.activeTaskBkgColor = this.activeTaskBkgColor || (0, _khroma.lighten)(this.primaryColor, 23);
        this.gridColor = this.gridColor || "lightgrey";
        this.doneTaskBkgColor = this.doneTaskBkgColor || "lightgrey";
        this.doneTaskBorderColor = this.doneTaskBorderColor || "grey";
        this.critBorderColor = this.critBorderColor || "#ff8888";
        this.critBkgColor = this.critBkgColor || "red";
        this.todayLineColor = this.todayLineColor || "red";
        this.taskTextColor = this.taskTextColor || this.textColor;
        this.taskTextOutsideColor = this.taskTextOutsideColor || this.textColor;
        this.taskTextLightColor = this.taskTextLightColor || this.textColor;
        this.taskTextColor = this.taskTextColor || this.primaryTextColor;
        this.taskTextDarkColor = this.taskTextDarkColor || this.textColor;
        this.taskTextClickableColor = this.taskTextClickableColor || "#003163";
        this.personBorder = this.personBorder || this.primaryBorderColor;
        this.personBkg = this.personBkg || this.mainBkg;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.transitionLabelColor = this.transitionLabelColor || this.textColor;
        this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor;
        this.stateBkg = this.stateBkg || this.mainBkg;
        this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg;
        this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor;
        this.altBackground = this.altBackground || this.tertiaryColor;
        this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg;
        this.compositeBorder = this.compositeBorder || this.nodeBorder;
        this.innerEndBackground = this.nodeBorder;
        this.errorBkgColor = this.errorBkgColor || this.tertiaryColor;
        this.errorTextColor = this.errorTextColor || this.tertiaryTextColor;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.specialStateColor = this.lineColor;
        this.cScale0 = this.cScale0 || this.primaryColor;
        this.cScale1 = this.cScale1 || this.secondaryColor;
        this.cScale2 = this.cScale2 || this.tertiaryColor;
        this.cScale3 = this.cScale3 || (0, _khroma.adjust)(this.primaryColor, {
            h: 30
        });
        this.cScale4 = this.cScale4 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60
        });
        this.cScale5 = this.cScale5 || (0, _khroma.adjust)(this.primaryColor, {
            h: 90
        });
        this.cScale6 = this.cScale6 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120
        });
        this.cScale7 = this.cScale7 || (0, _khroma.adjust)(this.primaryColor, {
            h: 150
        });
        this.cScale8 = this.cScale8 || (0, _khroma.adjust)(this.primaryColor, {
            h: 210,
            l: 150
        });
        this.cScale9 = this.cScale9 || (0, _khroma.adjust)(this.primaryColor, {
            h: 270
        });
        this.cScale10 = this.cScale10 || (0, _khroma.adjust)(this.primaryColor, {
            h: 300
        });
        this.cScale11 = this.cScale11 || (0, _khroma.adjust)(this.primaryColor, {
            h: 330
        });
        if (this.darkMode) for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScale" + i] = (0, _khroma.darken)(this["cScale" + i], 75);
        else for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScale" + i] = (0, _khroma.darken)(this["cScale" + i], 25);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleInv" + i] = this["cScaleInv" + i] || (0, _khroma.invert)(this["cScale" + i]);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)if (this.darkMode) this["cScalePeer" + i] = this["cScalePeer" + i] || (0, _khroma.lighten)(this["cScale" + i], 10);
        else this["cScalePeer" + i] = this["cScalePeer" + i] || (0, _khroma.darken)(this["cScale" + i], 10);
        this.scaleLabelColor = this.scaleLabelColor || this.labelTextColor;
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleLabel" + i] = this["cScaleLabel" + i] || this.scaleLabelColor;
        const multiplier = this.darkMode ? -4 : -1;
        for(let i = 0; i < 5; i++){
            this["surface" + i] = this["surface" + i] || (0, _khroma.adjust)(this.mainBkg, {
                h: 180,
                s: -15,
                l: multiplier * (5 + i * 3)
            });
            this["surfacePeer" + i] = this["surfacePeer" + i] || (0, _khroma.adjust)(this.mainBkg, {
                h: 180,
                s: -15,
                l: multiplier * (8 + i * 3)
            });
        }
        this.classText = this.classText || this.textColor;
        this.fillType0 = this.fillType0 || this.primaryColor;
        this.fillType1 = this.fillType1 || this.secondaryColor;
        this.fillType2 = this.fillType2 || (0, _khroma.adjust)(this.primaryColor, {
            h: 64
        });
        this.fillType3 = this.fillType3 || (0, _khroma.adjust)(this.secondaryColor, {
            h: 64
        });
        this.fillType4 = this.fillType4 || (0, _khroma.adjust)(this.primaryColor, {
            h: -64
        });
        this.fillType5 = this.fillType5 || (0, _khroma.adjust)(this.secondaryColor, {
            h: -64
        });
        this.fillType6 = this.fillType6 || (0, _khroma.adjust)(this.primaryColor, {
            h: 128
        });
        this.fillType7 = this.fillType7 || (0, _khroma.adjust)(this.secondaryColor, {
            h: 128
        });
        this.pie1 = this.pie1 || this.primaryColor;
        this.pie2 = this.pie2 || this.secondaryColor;
        this.pie3 = this.pie3 || this.tertiaryColor;
        this.pie4 = this.pie4 || (0, _khroma.adjust)(this.primaryColor, {
            l: -10
        });
        this.pie5 = this.pie5 || (0, _khroma.adjust)(this.secondaryColor, {
            l: -10
        });
        this.pie6 = this.pie6 || (0, _khroma.adjust)(this.tertiaryColor, {
            l: -10
        });
        this.pie7 = this.pie7 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60,
            l: -10
        });
        this.pie8 = this.pie8 || (0, _khroma.adjust)(this.primaryColor, {
            h: -60,
            l: -10
        });
        this.pie9 = this.pie9 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120,
            l: 0
        });
        this.pie10 = this.pie10 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60,
            l: -20
        });
        this.pie11 = this.pie11 || (0, _khroma.adjust)(this.primaryColor, {
            h: -60,
            l: -20
        });
        this.pie12 = this.pie12 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120,
            l: -10
        });
        this.pieTitleTextSize = this.pieTitleTextSize || "25px";
        this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor;
        this.pieSectionTextSize = this.pieSectionTextSize || "17px";
        this.pieSectionTextColor = this.pieSectionTextColor || this.textColor;
        this.pieLegendTextSize = this.pieLegendTextSize || "17px";
        this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor;
        this.pieStrokeColor = this.pieStrokeColor || "black";
        this.pieStrokeWidth = this.pieStrokeWidth || "2px";
        this.pieOuterStrokeWidth = this.pieOuterStrokeWidth || "2px";
        this.pieOuterStrokeColor = this.pieOuterStrokeColor || "black";
        this.pieOpacity = this.pieOpacity || "0.7";
        this.quadrant1Fill = this.quadrant1Fill || this.primaryColor;
        this.quadrant2Fill = this.quadrant2Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 5,
            g: 5,
            b: 5
        });
        this.quadrant3Fill = this.quadrant3Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 10,
            g: 10,
            b: 10
        });
        this.quadrant4Fill = this.quadrant4Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 15,
            g: 15,
            b: 15
        });
        this.quadrant1TextFill = this.quadrant1TextFill || this.primaryTextColor;
        this.quadrant2TextFill = this.quadrant2TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -5,
            g: -5,
            b: -5
        });
        this.quadrant3TextFill = this.quadrant3TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -10,
            g: -10,
            b: -10
        });
        this.quadrant4TextFill = this.quadrant4TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -15,
            g: -15,
            b: -15
        });
        this.quadrantPointFill = this.quadrantPointFill || (0, _khroma.isDark)(this.quadrant1Fill) ? (0, _khroma.lighten)(this.quadrant1Fill) : (0, _khroma.darken)(this.quadrant1Fill);
        this.quadrantPointTextFill = this.quadrantPointTextFill || this.primaryTextColor;
        this.quadrantXAxisTextFill = this.quadrantXAxisTextFill || this.primaryTextColor;
        this.quadrantYAxisTextFill = this.quadrantYAxisTextFill || this.primaryTextColor;
        this.quadrantInternalBorderStrokeFill = this.quadrantInternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantExternalBorderStrokeFill = this.quadrantExternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantTitleFill = this.quadrantTitleFill || this.primaryTextColor;
        this.xyChart = {
            backgroundColor: ((_a = this.xyChart) == null ? void 0 : _a.backgroundColor) || this.background,
            titleColor: ((_b = this.xyChart) == null ? void 0 : _b.titleColor) || this.primaryTextColor,
            xAxisTitleColor: ((_c = this.xyChart) == null ? void 0 : _c.xAxisTitleColor) || this.primaryTextColor,
            xAxisLabelColor: ((_d = this.xyChart) == null ? void 0 : _d.xAxisLabelColor) || this.primaryTextColor,
            xAxisTickColor: ((_e = this.xyChart) == null ? void 0 : _e.xAxisTickColor) || this.primaryTextColor,
            xAxisLineColor: ((_f = this.xyChart) == null ? void 0 : _f.xAxisLineColor) || this.primaryTextColor,
            yAxisTitleColor: ((_g = this.xyChart) == null ? void 0 : _g.yAxisTitleColor) || this.primaryTextColor,
            yAxisLabelColor: ((_h = this.xyChart) == null ? void 0 : _h.yAxisLabelColor) || this.primaryTextColor,
            yAxisTickColor: ((_i = this.xyChart) == null ? void 0 : _i.yAxisTickColor) || this.primaryTextColor,
            yAxisLineColor: ((_j = this.xyChart) == null ? void 0 : _j.yAxisLineColor) || this.primaryTextColor,
            plotColorPalette: ((_k = this.xyChart) == null ? void 0 : _k.plotColorPalette) || "#FFF4DD,#FFD8B1,#FFA07A,#ECEFF1,#D6DBDF,#C3E0A8,#FFB6A4,#FFD74D,#738FA7,#FFFFF0"
        };
        this.requirementBackground = this.requirementBackground || this.primaryColor;
        this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor;
        this.requirementBorderSize = this.requirementBorderSize || "1";
        this.requirementTextColor = this.requirementTextColor || this.primaryTextColor;
        this.relationColor = this.relationColor || this.lineColor;
        this.relationLabelBackground = this.relationLabelBackground || (this.darkMode ? (0, _khroma.darken)(this.secondaryColor, 30) : this.secondaryColor);
        this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        this.git0 = this.git0 || this.primaryColor;
        this.git1 = this.git1 || this.secondaryColor;
        this.git2 = this.git2 || this.tertiaryColor;
        this.git3 = this.git3 || (0, _khroma.adjust)(this.primaryColor, {
            h: -30
        });
        this.git4 = this.git4 || (0, _khroma.adjust)(this.primaryColor, {
            h: -60
        });
        this.git5 = this.git5 || (0, _khroma.adjust)(this.primaryColor, {
            h: -90
        });
        this.git6 = this.git6 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60
        });
        this.git7 = this.git7 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120
        });
        if (this.darkMode) {
            this.git0 = (0, _khroma.lighten)(this.git0, 25);
            this.git1 = (0, _khroma.lighten)(this.git1, 25);
            this.git2 = (0, _khroma.lighten)(this.git2, 25);
            this.git3 = (0, _khroma.lighten)(this.git3, 25);
            this.git4 = (0, _khroma.lighten)(this.git4, 25);
            this.git5 = (0, _khroma.lighten)(this.git5, 25);
            this.git6 = (0, _khroma.lighten)(this.git6, 25);
            this.git7 = (0, _khroma.lighten)(this.git7, 25);
        } else {
            this.git0 = (0, _khroma.darken)(this.git0, 25);
            this.git1 = (0, _khroma.darken)(this.git1, 25);
            this.git2 = (0, _khroma.darken)(this.git2, 25);
            this.git3 = (0, _khroma.darken)(this.git3, 25);
            this.git4 = (0, _khroma.darken)(this.git4, 25);
            this.git5 = (0, _khroma.darken)(this.git5, 25);
            this.git6 = (0, _khroma.darken)(this.git6, 25);
            this.git7 = (0, _khroma.darken)(this.git7, 25);
        }
        this.gitInv0 = this.gitInv0 || (0, _khroma.invert)(this.git0);
        this.gitInv1 = this.gitInv1 || (0, _khroma.invert)(this.git1);
        this.gitInv2 = this.gitInv2 || (0, _khroma.invert)(this.git2);
        this.gitInv3 = this.gitInv3 || (0, _khroma.invert)(this.git3);
        this.gitInv4 = this.gitInv4 || (0, _khroma.invert)(this.git4);
        this.gitInv5 = this.gitInv5 || (0, _khroma.invert)(this.git5);
        this.gitInv6 = this.gitInv6 || (0, _khroma.invert)(this.git6);
        this.gitInv7 = this.gitInv7 || (0, _khroma.invert)(this.git7);
        this.branchLabelColor = this.branchLabelColor || (this.darkMode ? "black" : this.labelTextColor);
        this.gitBranchLabel0 = this.gitBranchLabel0 || this.branchLabelColor;
        this.gitBranchLabel1 = this.gitBranchLabel1 || this.branchLabelColor;
        this.gitBranchLabel2 = this.gitBranchLabel2 || this.branchLabelColor;
        this.gitBranchLabel3 = this.gitBranchLabel3 || this.branchLabelColor;
        this.gitBranchLabel4 = this.gitBranchLabel4 || this.branchLabelColor;
        this.gitBranchLabel5 = this.gitBranchLabel5 || this.branchLabelColor;
        this.gitBranchLabel6 = this.gitBranchLabel6 || this.branchLabelColor;
        this.gitBranchLabel7 = this.gitBranchLabel7 || this.branchLabelColor;
        this.tagLabelColor = this.tagLabelColor || this.primaryTextColor;
        this.tagLabelBackground = this.tagLabelBackground || this.primaryColor;
        this.tagLabelBorder = this.tagBorder || this.primaryBorderColor;
        this.tagLabelFontSize = this.tagLabelFontSize || "10px";
        this.commitLabelColor = this.commitLabelColor || this.secondaryTextColor;
        this.commitLabelBackground = this.commitLabelBackground || this.secondaryColor;
        this.commitLabelFontSize = this.commitLabelFontSize || "10px";
        this.attributeBackgroundColorOdd = this.attributeBackgroundColorOdd || oldAttributeBackgroundColorOdd;
        this.attributeBackgroundColorEven = this.attributeBackgroundColorEven || oldAttributeBackgroundColorEven;
    }
    calculate(overrides) {
        if (typeof overrides !== "object") {
            this.updateColors();
            return;
        }
        const keys = Object.keys(overrides);
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
        this.updateColors();
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
    }
};
const getThemeVariables$4 = (userOverrides)=>{
    const theme2 = new Theme$4();
    theme2.calculate(userOverrides);
    return theme2;
};
let Theme$3 = class Theme2 {
    constructor(){
        this.background = "#333";
        this.primaryColor = "#1f2020";
        this.secondaryColor = (0, _khroma.lighten)(this.primaryColor, 16);
        this.tertiaryColor = (0, _khroma.adjust)(this.primaryColor, {
            h: -160
        });
        this.primaryBorderColor = (0, _khroma.invert)(this.background);
        this.secondaryBorderColor = mkBorder(this.secondaryColor, this.darkMode);
        this.tertiaryBorderColor = mkBorder(this.tertiaryColor, this.darkMode);
        this.primaryTextColor = (0, _khroma.invert)(this.primaryColor);
        this.secondaryTextColor = (0, _khroma.invert)(this.secondaryColor);
        this.tertiaryTextColor = (0, _khroma.invert)(this.tertiaryColor);
        this.lineColor = (0, _khroma.invert)(this.background);
        this.textColor = (0, _khroma.invert)(this.background);
        this.mainBkg = "#1f2020";
        this.secondBkg = "calculated";
        this.mainContrastColor = "lightgrey";
        this.darkTextColor = (0, _khroma.lighten)((0, _khroma.invert)("#323D47"), 10);
        this.lineColor = "calculated";
        this.border1 = "#81B1DB";
        this.border2 = (0, _khroma.rgba)(255, 255, 255, 0.25);
        this.arrowheadColor = "calculated";
        this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif';
        this.fontSize = "16px";
        this.labelBackground = "#181818";
        this.textColor = "#ccc";
        this.THEME_COLOR_LIMIT = 12;
        this.nodeBkg = "calculated";
        this.nodeBorder = "calculated";
        this.clusterBkg = "calculated";
        this.clusterBorder = "calculated";
        this.defaultLinkColor = "calculated";
        this.titleColor = "#F9FFFE";
        this.edgeLabelBackground = "calculated";
        this.actorBorder = "calculated";
        this.actorBkg = "calculated";
        this.actorTextColor = "calculated";
        this.actorLineColor = "calculated";
        this.signalColor = "calculated";
        this.signalTextColor = "calculated";
        this.labelBoxBkgColor = "calculated";
        this.labelBoxBorderColor = "calculated";
        this.labelTextColor = "calculated";
        this.loopTextColor = "calculated";
        this.noteBorderColor = "calculated";
        this.noteBkgColor = "#fff5ad";
        this.noteTextColor = "calculated";
        this.activationBorderColor = "calculated";
        this.activationBkgColor = "calculated";
        this.sequenceNumberColor = "black";
        this.sectionBkgColor = (0, _khroma.darken)("#EAE8D9", 30);
        this.altSectionBkgColor = "calculated";
        this.sectionBkgColor2 = "#EAE8D9";
        this.excludeBkgColor = (0, _khroma.darken)(this.sectionBkgColor, 10);
        this.taskBorderColor = (0, _khroma.rgba)(255, 255, 255, 70);
        this.taskBkgColor = "calculated";
        this.taskTextColor = "calculated";
        this.taskTextLightColor = "calculated";
        this.taskTextOutsideColor = "calculated";
        this.taskTextClickableColor = "#003163";
        this.activeTaskBorderColor = (0, _khroma.rgba)(255, 255, 255, 50);
        this.activeTaskBkgColor = "#81B1DB";
        this.gridColor = "calculated";
        this.doneTaskBkgColor = "calculated";
        this.doneTaskBorderColor = "grey";
        this.critBorderColor = "#E83737";
        this.critBkgColor = "#E83737";
        this.taskTextDarkColor = "calculated";
        this.todayLineColor = "#DB5757";
        this.personBorder = this.primaryBorderColor;
        this.personBkg = this.mainBkg;
        this.labelColor = "calculated";
        this.errorBkgColor = "#a44141";
        this.errorTextColor = "#ddd";
    }
    updateColors() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        this.secondBkg = (0, _khroma.lighten)(this.mainBkg, 16);
        this.lineColor = this.mainContrastColor;
        this.arrowheadColor = this.mainContrastColor;
        this.nodeBkg = this.mainBkg;
        this.nodeBorder = this.border1;
        this.clusterBkg = this.secondBkg;
        this.clusterBorder = this.border2;
        this.defaultLinkColor = this.lineColor;
        this.edgeLabelBackground = (0, _khroma.lighten)(this.labelBackground, 25);
        this.actorBorder = this.border1;
        this.actorBkg = this.mainBkg;
        this.actorTextColor = this.mainContrastColor;
        this.actorLineColor = this.mainContrastColor;
        this.signalColor = this.mainContrastColor;
        this.signalTextColor = this.mainContrastColor;
        this.labelBoxBkgColor = this.actorBkg;
        this.labelBoxBorderColor = this.actorBorder;
        this.labelTextColor = this.mainContrastColor;
        this.loopTextColor = this.mainContrastColor;
        this.noteBorderColor = this.secondaryBorderColor;
        this.noteBkgColor = this.secondBkg;
        this.noteTextColor = this.secondaryTextColor;
        this.activationBorderColor = this.border1;
        this.activationBkgColor = this.secondBkg;
        this.altSectionBkgColor = this.background;
        this.taskBkgColor = (0, _khroma.lighten)(this.mainBkg, 23);
        this.taskTextColor = this.darkTextColor;
        this.taskTextLightColor = this.mainContrastColor;
        this.taskTextOutsideColor = this.taskTextLightColor;
        this.gridColor = this.mainContrastColor;
        this.doneTaskBkgColor = this.mainContrastColor;
        this.taskTextDarkColor = this.darkTextColor;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.transitionLabelColor = this.transitionLabelColor || this.textColor;
        this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor;
        this.stateBkg = this.stateBkg || this.mainBkg;
        this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg;
        this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor;
        this.altBackground = this.altBackground || "#555";
        this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg;
        this.compositeBorder = this.compositeBorder || this.nodeBorder;
        this.innerEndBackground = this.primaryBorderColor;
        this.specialStateColor = "#f4f4f4";
        this.errorBkgColor = this.errorBkgColor || this.tertiaryColor;
        this.errorTextColor = this.errorTextColor || this.tertiaryTextColor;
        this.fillType0 = this.primaryColor;
        this.fillType1 = this.secondaryColor;
        this.fillType2 = (0, _khroma.adjust)(this.primaryColor, {
            h: 64
        });
        this.fillType3 = (0, _khroma.adjust)(this.secondaryColor, {
            h: 64
        });
        this.fillType4 = (0, _khroma.adjust)(this.primaryColor, {
            h: -64
        });
        this.fillType5 = (0, _khroma.adjust)(this.secondaryColor, {
            h: -64
        });
        this.fillType6 = (0, _khroma.adjust)(this.primaryColor, {
            h: 128
        });
        this.fillType7 = (0, _khroma.adjust)(this.secondaryColor, {
            h: 128
        });
        this.cScale1 = this.cScale1 || "#0b0000";
        this.cScale2 = this.cScale2 || "#4d1037";
        this.cScale3 = this.cScale3 || "#3f5258";
        this.cScale4 = this.cScale4 || "#4f2f1b";
        this.cScale5 = this.cScale5 || "#6e0a0a";
        this.cScale6 = this.cScale6 || "#3b0048";
        this.cScale7 = this.cScale7 || "#995a01";
        this.cScale8 = this.cScale8 || "#154706";
        this.cScale9 = this.cScale9 || "#161722";
        this.cScale10 = this.cScale10 || "#00296f";
        this.cScale11 = this.cScale11 || "#01629c";
        this.cScale12 = this.cScale12 || "#010029";
        this.cScale0 = this.cScale0 || this.primaryColor;
        this.cScale1 = this.cScale1 || this.secondaryColor;
        this.cScale2 = this.cScale2 || this.tertiaryColor;
        this.cScale3 = this.cScale3 || (0, _khroma.adjust)(this.primaryColor, {
            h: 30
        });
        this.cScale4 = this.cScale4 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60
        });
        this.cScale5 = this.cScale5 || (0, _khroma.adjust)(this.primaryColor, {
            h: 90
        });
        this.cScale6 = this.cScale6 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120
        });
        this.cScale7 = this.cScale7 || (0, _khroma.adjust)(this.primaryColor, {
            h: 150
        });
        this.cScale8 = this.cScale8 || (0, _khroma.adjust)(this.primaryColor, {
            h: 210
        });
        this.cScale9 = this.cScale9 || (0, _khroma.adjust)(this.primaryColor, {
            h: 270
        });
        this.cScale10 = this.cScale10 || (0, _khroma.adjust)(this.primaryColor, {
            h: 300
        });
        this.cScale11 = this.cScale11 || (0, _khroma.adjust)(this.primaryColor, {
            h: 330
        });
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleInv" + i] = this["cScaleInv" + i] || (0, _khroma.invert)(this["cScale" + i]);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScalePeer" + i] = this["cScalePeer" + i] || (0, _khroma.lighten)(this["cScale" + i], 10);
        for(let i = 0; i < 5; i++){
            this["surface" + i] = this["surface" + i] || (0, _khroma.adjust)(this.mainBkg, {
                h: 30,
                s: -30,
                l: -(-10 + i * 4)
            });
            this["surfacePeer" + i] = this["surfacePeer" + i] || (0, _khroma.adjust)(this.mainBkg, {
                h: 30,
                s: -30,
                l: -(-7 + i * 4)
            });
        }
        this.scaleLabelColor = this.scaleLabelColor || (this.darkMode ? "black" : this.labelTextColor);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleLabel" + i] = this["cScaleLabel" + i] || this.scaleLabelColor;
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["pie" + i] = this["cScale" + i];
        this.pieTitleTextSize = this.pieTitleTextSize || "25px";
        this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor;
        this.pieSectionTextSize = this.pieSectionTextSize || "17px";
        this.pieSectionTextColor = this.pieSectionTextColor || this.textColor;
        this.pieLegendTextSize = this.pieLegendTextSize || "17px";
        this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor;
        this.pieStrokeColor = this.pieStrokeColor || "black";
        this.pieStrokeWidth = this.pieStrokeWidth || "2px";
        this.pieOuterStrokeWidth = this.pieOuterStrokeWidth || "2px";
        this.pieOuterStrokeColor = this.pieOuterStrokeColor || "black";
        this.pieOpacity = this.pieOpacity || "0.7";
        this.quadrant1Fill = this.quadrant1Fill || this.primaryColor;
        this.quadrant2Fill = this.quadrant2Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 5,
            g: 5,
            b: 5
        });
        this.quadrant3Fill = this.quadrant3Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 10,
            g: 10,
            b: 10
        });
        this.quadrant4Fill = this.quadrant4Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 15,
            g: 15,
            b: 15
        });
        this.quadrant1TextFill = this.quadrant1TextFill || this.primaryTextColor;
        this.quadrant2TextFill = this.quadrant2TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -5,
            g: -5,
            b: -5
        });
        this.quadrant3TextFill = this.quadrant3TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -10,
            g: -10,
            b: -10
        });
        this.quadrant4TextFill = this.quadrant4TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -15,
            g: -15,
            b: -15
        });
        this.quadrantPointFill = this.quadrantPointFill || (0, _khroma.isDark)(this.quadrant1Fill) ? (0, _khroma.lighten)(this.quadrant1Fill) : (0, _khroma.darken)(this.quadrant1Fill);
        this.quadrantPointTextFill = this.quadrantPointTextFill || this.primaryTextColor;
        this.quadrantXAxisTextFill = this.quadrantXAxisTextFill || this.primaryTextColor;
        this.quadrantYAxisTextFill = this.quadrantYAxisTextFill || this.primaryTextColor;
        this.quadrantInternalBorderStrokeFill = this.quadrantInternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantExternalBorderStrokeFill = this.quadrantExternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantTitleFill = this.quadrantTitleFill || this.primaryTextColor;
        this.xyChart = {
            backgroundColor: ((_a = this.xyChart) == null ? void 0 : _a.backgroundColor) || this.background,
            titleColor: ((_b = this.xyChart) == null ? void 0 : _b.titleColor) || this.primaryTextColor,
            xAxisTitleColor: ((_c = this.xyChart) == null ? void 0 : _c.xAxisTitleColor) || this.primaryTextColor,
            xAxisLabelColor: ((_d = this.xyChart) == null ? void 0 : _d.xAxisLabelColor) || this.primaryTextColor,
            xAxisTickColor: ((_e = this.xyChart) == null ? void 0 : _e.xAxisTickColor) || this.primaryTextColor,
            xAxisLineColor: ((_f = this.xyChart) == null ? void 0 : _f.xAxisLineColor) || this.primaryTextColor,
            yAxisTitleColor: ((_g = this.xyChart) == null ? void 0 : _g.yAxisTitleColor) || this.primaryTextColor,
            yAxisLabelColor: ((_h = this.xyChart) == null ? void 0 : _h.yAxisLabelColor) || this.primaryTextColor,
            yAxisTickColor: ((_i = this.xyChart) == null ? void 0 : _i.yAxisTickColor) || this.primaryTextColor,
            yAxisLineColor: ((_j = this.xyChart) == null ? void 0 : _j.yAxisLineColor) || this.primaryTextColor,
            plotColorPalette: ((_k = this.xyChart) == null ? void 0 : _k.plotColorPalette) || "#3498db,#2ecc71,#e74c3c,#f1c40f,#bdc3c7,#ffffff,#34495e,#9b59b6,#1abc9c,#e67e22"
        };
        this.classText = this.primaryTextColor;
        this.requirementBackground = this.requirementBackground || this.primaryColor;
        this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor;
        this.requirementBorderSize = this.requirementBorderSize || "1";
        this.requirementTextColor = this.requirementTextColor || this.primaryTextColor;
        this.relationColor = this.relationColor || this.lineColor;
        this.relationLabelBackground = this.relationLabelBackground || (this.darkMode ? (0, _khroma.darken)(this.secondaryColor, 30) : this.secondaryColor);
        this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        this.git0 = (0, _khroma.lighten)(this.secondaryColor, 20);
        this.git1 = (0, _khroma.lighten)(this.pie2 || this.secondaryColor, 20);
        this.git2 = (0, _khroma.lighten)(this.pie3 || this.tertiaryColor, 20);
        this.git3 = (0, _khroma.lighten)(this.pie4 || (0, _khroma.adjust)(this.primaryColor, {
            h: -30
        }), 20);
        this.git4 = (0, _khroma.lighten)(this.pie5 || (0, _khroma.adjust)(this.primaryColor, {
            h: -60
        }), 20);
        this.git5 = (0, _khroma.lighten)(this.pie6 || (0, _khroma.adjust)(this.primaryColor, {
            h: -90
        }), 10);
        this.git6 = (0, _khroma.lighten)(this.pie7 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60
        }), 10);
        this.git7 = (0, _khroma.lighten)(this.pie8 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120
        }), 20);
        this.gitInv0 = this.gitInv0 || (0, _khroma.invert)(this.git0);
        this.gitInv1 = this.gitInv1 || (0, _khroma.invert)(this.git1);
        this.gitInv2 = this.gitInv2 || (0, _khroma.invert)(this.git2);
        this.gitInv3 = this.gitInv3 || (0, _khroma.invert)(this.git3);
        this.gitInv4 = this.gitInv4 || (0, _khroma.invert)(this.git4);
        this.gitInv5 = this.gitInv5 || (0, _khroma.invert)(this.git5);
        this.gitInv6 = this.gitInv6 || (0, _khroma.invert)(this.git6);
        this.gitInv7 = this.gitInv7 || (0, _khroma.invert)(this.git7);
        this.gitBranchLabel0 = this.gitBranchLabel0 || (0, _khroma.invert)(this.labelTextColor);
        this.gitBranchLabel1 = this.gitBranchLabel1 || this.labelTextColor;
        this.gitBranchLabel2 = this.gitBranchLabel2 || this.labelTextColor;
        this.gitBranchLabel3 = this.gitBranchLabel3 || (0, _khroma.invert)(this.labelTextColor);
        this.gitBranchLabel4 = this.gitBranchLabel4 || this.labelTextColor;
        this.gitBranchLabel5 = this.gitBranchLabel5 || this.labelTextColor;
        this.gitBranchLabel6 = this.gitBranchLabel6 || this.labelTextColor;
        this.gitBranchLabel7 = this.gitBranchLabel7 || this.labelTextColor;
        this.tagLabelColor = this.tagLabelColor || this.primaryTextColor;
        this.tagLabelBackground = this.tagLabelBackground || this.primaryColor;
        this.tagLabelBorder = this.tagBorder || this.primaryBorderColor;
        this.tagLabelFontSize = this.tagLabelFontSize || "10px";
        this.commitLabelColor = this.commitLabelColor || this.secondaryTextColor;
        this.commitLabelBackground = this.commitLabelBackground || this.secondaryColor;
        this.commitLabelFontSize = this.commitLabelFontSize || "10px";
        this.attributeBackgroundColorOdd = this.attributeBackgroundColorOdd || (0, _khroma.lighten)(this.background, 12);
        this.attributeBackgroundColorEven = this.attributeBackgroundColorEven || (0, _khroma.lighten)(this.background, 2);
    }
    calculate(overrides) {
        if (typeof overrides !== "object") {
            this.updateColors();
            return;
        }
        const keys = Object.keys(overrides);
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
        this.updateColors();
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
    }
};
const getThemeVariables$3 = (userOverrides)=>{
    const theme2 = new Theme$3();
    theme2.calculate(userOverrides);
    return theme2;
};
let Theme$2 = class Theme3 {
    constructor(){
        this.background = "#f4f4f4";
        this.primaryColor = "#ECECFF";
        this.secondaryColor = (0, _khroma.adjust)(this.primaryColor, {
            h: 120
        });
        this.secondaryColor = "#ffffde";
        this.tertiaryColor = (0, _khroma.adjust)(this.primaryColor, {
            h: -160
        });
        this.primaryBorderColor = mkBorder(this.primaryColor, this.darkMode);
        this.secondaryBorderColor = mkBorder(this.secondaryColor, this.darkMode);
        this.tertiaryBorderColor = mkBorder(this.tertiaryColor, this.darkMode);
        this.primaryTextColor = (0, _khroma.invert)(this.primaryColor);
        this.secondaryTextColor = (0, _khroma.invert)(this.secondaryColor);
        this.tertiaryTextColor = (0, _khroma.invert)(this.tertiaryColor);
        this.lineColor = (0, _khroma.invert)(this.background);
        this.textColor = (0, _khroma.invert)(this.background);
        this.background = "white";
        this.mainBkg = "#ECECFF";
        this.secondBkg = "#ffffde";
        this.lineColor = "#333333";
        this.border1 = "#9370DB";
        this.border2 = "#aaaa33";
        this.arrowheadColor = "#333333";
        this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif';
        this.fontSize = "16px";
        this.labelBackground = "#e8e8e8";
        this.textColor = "#333";
        this.THEME_COLOR_LIMIT = 12;
        this.nodeBkg = "calculated";
        this.nodeBorder = "calculated";
        this.clusterBkg = "calculated";
        this.clusterBorder = "calculated";
        this.defaultLinkColor = "calculated";
        this.titleColor = "calculated";
        this.edgeLabelBackground = "calculated";
        this.actorBorder = "calculated";
        this.actorBkg = "calculated";
        this.actorTextColor = "black";
        this.actorLineColor = "grey";
        this.signalColor = "calculated";
        this.signalTextColor = "calculated";
        this.labelBoxBkgColor = "calculated";
        this.labelBoxBorderColor = "calculated";
        this.labelTextColor = "calculated";
        this.loopTextColor = "calculated";
        this.noteBorderColor = "calculated";
        this.noteBkgColor = "#fff5ad";
        this.noteTextColor = "calculated";
        this.activationBorderColor = "#666";
        this.activationBkgColor = "#f4f4f4";
        this.sequenceNumberColor = "white";
        this.sectionBkgColor = "calculated";
        this.altSectionBkgColor = "calculated";
        this.sectionBkgColor2 = "calculated";
        this.excludeBkgColor = "#eeeeee";
        this.taskBorderColor = "calculated";
        this.taskBkgColor = "calculated";
        this.taskTextLightColor = "calculated";
        this.taskTextColor = this.taskTextLightColor;
        this.taskTextDarkColor = "calculated";
        this.taskTextOutsideColor = this.taskTextDarkColor;
        this.taskTextClickableColor = "calculated";
        this.activeTaskBorderColor = "calculated";
        this.activeTaskBkgColor = "calculated";
        this.gridColor = "calculated";
        this.doneTaskBkgColor = "calculated";
        this.doneTaskBorderColor = "calculated";
        this.critBorderColor = "calculated";
        this.critBkgColor = "calculated";
        this.todayLineColor = "calculated";
        this.sectionBkgColor = (0, _khroma.rgba)(102, 102, 255, 0.49);
        this.altSectionBkgColor = "white";
        this.sectionBkgColor2 = "#fff400";
        this.taskBorderColor = "#534fbc";
        this.taskBkgColor = "#8a90dd";
        this.taskTextLightColor = "white";
        this.taskTextColor = "calculated";
        this.taskTextDarkColor = "black";
        this.taskTextOutsideColor = "calculated";
        this.taskTextClickableColor = "#003163";
        this.activeTaskBorderColor = "#534fbc";
        this.activeTaskBkgColor = "#bfc7ff";
        this.gridColor = "lightgrey";
        this.doneTaskBkgColor = "lightgrey";
        this.doneTaskBorderColor = "grey";
        this.critBorderColor = "#ff8888";
        this.critBkgColor = "red";
        this.todayLineColor = "red";
        this.personBorder = this.primaryBorderColor;
        this.personBkg = this.mainBkg;
        this.labelColor = "black";
        this.errorBkgColor = "#552222";
        this.errorTextColor = "#552222";
        this.updateColors();
    }
    updateColors() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        this.cScale0 = this.cScale0 || this.primaryColor;
        this.cScale1 = this.cScale1 || this.secondaryColor;
        this.cScale2 = this.cScale2 || this.tertiaryColor;
        this.cScale3 = this.cScale3 || (0, _khroma.adjust)(this.primaryColor, {
            h: 30
        });
        this.cScale4 = this.cScale4 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60
        });
        this.cScale5 = this.cScale5 || (0, _khroma.adjust)(this.primaryColor, {
            h: 90
        });
        this.cScale6 = this.cScale6 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120
        });
        this.cScale7 = this.cScale7 || (0, _khroma.adjust)(this.primaryColor, {
            h: 150
        });
        this.cScale8 = this.cScale8 || (0, _khroma.adjust)(this.primaryColor, {
            h: 210
        });
        this.cScale9 = this.cScale9 || (0, _khroma.adjust)(this.primaryColor, {
            h: 270
        });
        this.cScale10 = this.cScale10 || (0, _khroma.adjust)(this.primaryColor, {
            h: 300
        });
        this.cScale11 = this.cScale11 || (0, _khroma.adjust)(this.primaryColor, {
            h: 330
        });
        this["cScalePeer1"] = this["cScalePeer1"] || (0, _khroma.darken)(this.secondaryColor, 45);
        this["cScalePeer2"] = this["cScalePeer2"] || (0, _khroma.darken)(this.tertiaryColor, 40);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++){
            this["cScale" + i] = (0, _khroma.darken)(this["cScale" + i], 10);
            this["cScalePeer" + i] = this["cScalePeer" + i] || (0, _khroma.darken)(this["cScale" + i], 25);
        }
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleInv" + i] = this["cScaleInv" + i] || (0, _khroma.adjust)(this["cScale" + i], {
            h: 180
        });
        for(let i = 0; i < 5; i++){
            this["surface" + i] = this["surface" + i] || (0, _khroma.adjust)(this.mainBkg, {
                h: 30,
                l: -(5 + i * 5)
            });
            this["surfacePeer" + i] = this["surfacePeer" + i] || (0, _khroma.adjust)(this.mainBkg, {
                h: 30,
                l: -(7 + i * 5)
            });
        }
        this.scaleLabelColor = this.scaleLabelColor !== "calculated" && this.scaleLabelColor ? this.scaleLabelColor : this.labelTextColor;
        if (this.labelTextColor !== "calculated") {
            this.cScaleLabel0 = this.cScaleLabel0 || (0, _khroma.invert)(this.labelTextColor);
            this.cScaleLabel3 = this.cScaleLabel3 || (0, _khroma.invert)(this.labelTextColor);
            for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleLabel" + i] = this["cScaleLabel" + i] || this.labelTextColor;
        }
        this.nodeBkg = this.mainBkg;
        this.nodeBorder = this.border1;
        this.clusterBkg = this.secondBkg;
        this.clusterBorder = this.border2;
        this.defaultLinkColor = this.lineColor;
        this.titleColor = this.textColor;
        this.edgeLabelBackground = this.labelBackground;
        this.actorBorder = (0, _khroma.lighten)(this.border1, 23);
        this.actorBkg = this.mainBkg;
        this.labelBoxBkgColor = this.actorBkg;
        this.signalColor = this.textColor;
        this.signalTextColor = this.textColor;
        this.labelBoxBorderColor = this.actorBorder;
        this.labelTextColor = this.actorTextColor;
        this.loopTextColor = this.actorTextColor;
        this.noteBorderColor = this.border2;
        this.noteTextColor = this.actorTextColor;
        this.taskTextColor = this.taskTextLightColor;
        this.taskTextOutsideColor = this.taskTextDarkColor;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.transitionLabelColor = this.transitionLabelColor || this.textColor;
        this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor;
        this.stateBkg = this.stateBkg || this.mainBkg;
        this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg;
        this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor;
        this.altBackground = this.altBackground || "#f0f0f0";
        this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg;
        this.compositeBorder = this.compositeBorder || this.nodeBorder;
        this.innerEndBackground = this.nodeBorder;
        this.specialStateColor = this.lineColor;
        this.errorBkgColor = this.errorBkgColor || this.tertiaryColor;
        this.errorTextColor = this.errorTextColor || this.tertiaryTextColor;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.classText = this.primaryTextColor;
        this.fillType0 = this.primaryColor;
        this.fillType1 = this.secondaryColor;
        this.fillType2 = (0, _khroma.adjust)(this.primaryColor, {
            h: 64
        });
        this.fillType3 = (0, _khroma.adjust)(this.secondaryColor, {
            h: 64
        });
        this.fillType4 = (0, _khroma.adjust)(this.primaryColor, {
            h: -64
        });
        this.fillType5 = (0, _khroma.adjust)(this.secondaryColor, {
            h: -64
        });
        this.fillType6 = (0, _khroma.adjust)(this.primaryColor, {
            h: 128
        });
        this.fillType7 = (0, _khroma.adjust)(this.secondaryColor, {
            h: 128
        });
        this.pie1 = this.pie1 || this.primaryColor;
        this.pie2 = this.pie2 || this.secondaryColor;
        this.pie3 = this.pie3 || (0, _khroma.adjust)(this.tertiaryColor, {
            l: -40
        });
        this.pie4 = this.pie4 || (0, _khroma.adjust)(this.primaryColor, {
            l: -10
        });
        this.pie5 = this.pie5 || (0, _khroma.adjust)(this.secondaryColor, {
            l: -30
        });
        this.pie6 = this.pie6 || (0, _khroma.adjust)(this.tertiaryColor, {
            l: -20
        });
        this.pie7 = this.pie7 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60,
            l: -20
        });
        this.pie8 = this.pie8 || (0, _khroma.adjust)(this.primaryColor, {
            h: -60,
            l: -40
        });
        this.pie9 = this.pie9 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120,
            l: -40
        });
        this.pie10 = this.pie10 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60,
            l: -40
        });
        this.pie11 = this.pie11 || (0, _khroma.adjust)(this.primaryColor, {
            h: -90,
            l: -40
        });
        this.pie12 = this.pie12 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120,
            l: -30
        });
        this.pieTitleTextSize = this.pieTitleTextSize || "25px";
        this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor;
        this.pieSectionTextSize = this.pieSectionTextSize || "17px";
        this.pieSectionTextColor = this.pieSectionTextColor || this.textColor;
        this.pieLegendTextSize = this.pieLegendTextSize || "17px";
        this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor;
        this.pieStrokeColor = this.pieStrokeColor || "black";
        this.pieStrokeWidth = this.pieStrokeWidth || "2px";
        this.pieOuterStrokeWidth = this.pieOuterStrokeWidth || "2px";
        this.pieOuterStrokeColor = this.pieOuterStrokeColor || "black";
        this.pieOpacity = this.pieOpacity || "0.7";
        this.quadrant1Fill = this.quadrant1Fill || this.primaryColor;
        this.quadrant2Fill = this.quadrant2Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 5,
            g: 5,
            b: 5
        });
        this.quadrant3Fill = this.quadrant3Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 10,
            g: 10,
            b: 10
        });
        this.quadrant4Fill = this.quadrant4Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 15,
            g: 15,
            b: 15
        });
        this.quadrant1TextFill = this.quadrant1TextFill || this.primaryTextColor;
        this.quadrant2TextFill = this.quadrant2TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -5,
            g: -5,
            b: -5
        });
        this.quadrant3TextFill = this.quadrant3TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -10,
            g: -10,
            b: -10
        });
        this.quadrant4TextFill = this.quadrant4TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -15,
            g: -15,
            b: -15
        });
        this.quadrantPointFill = this.quadrantPointFill || (0, _khroma.isDark)(this.quadrant1Fill) ? (0, _khroma.lighten)(this.quadrant1Fill) : (0, _khroma.darken)(this.quadrant1Fill);
        this.quadrantPointTextFill = this.quadrantPointTextFill || this.primaryTextColor;
        this.quadrantXAxisTextFill = this.quadrantXAxisTextFill || this.primaryTextColor;
        this.quadrantYAxisTextFill = this.quadrantYAxisTextFill || this.primaryTextColor;
        this.quadrantInternalBorderStrokeFill = this.quadrantInternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantExternalBorderStrokeFill = this.quadrantExternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantTitleFill = this.quadrantTitleFill || this.primaryTextColor;
        this.xyChart = {
            backgroundColor: ((_a = this.xyChart) == null ? void 0 : _a.backgroundColor) || this.background,
            titleColor: ((_b = this.xyChart) == null ? void 0 : _b.titleColor) || this.primaryTextColor,
            xAxisTitleColor: ((_c = this.xyChart) == null ? void 0 : _c.xAxisTitleColor) || this.primaryTextColor,
            xAxisLabelColor: ((_d = this.xyChart) == null ? void 0 : _d.xAxisLabelColor) || this.primaryTextColor,
            xAxisTickColor: ((_e = this.xyChart) == null ? void 0 : _e.xAxisTickColor) || this.primaryTextColor,
            xAxisLineColor: ((_f = this.xyChart) == null ? void 0 : _f.xAxisLineColor) || this.primaryTextColor,
            yAxisTitleColor: ((_g = this.xyChart) == null ? void 0 : _g.yAxisTitleColor) || this.primaryTextColor,
            yAxisLabelColor: ((_h = this.xyChart) == null ? void 0 : _h.yAxisLabelColor) || this.primaryTextColor,
            yAxisTickColor: ((_i = this.xyChart) == null ? void 0 : _i.yAxisTickColor) || this.primaryTextColor,
            yAxisLineColor: ((_j = this.xyChart) == null ? void 0 : _j.yAxisLineColor) || this.primaryTextColor,
            plotColorPalette: ((_k = this.xyChart) == null ? void 0 : _k.plotColorPalette) || "#ECECFF,#8493A6,#FFC3A0,#DCDDE1,#B8E994,#D1A36F,#C3CDE6,#FFB6C1,#496078,#F8F3E3"
        };
        this.requirementBackground = this.requirementBackground || this.primaryColor;
        this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor;
        this.requirementBorderSize = this.requirementBorderSize || "1";
        this.requirementTextColor = this.requirementTextColor || this.primaryTextColor;
        this.relationColor = this.relationColor || this.lineColor;
        this.relationLabelBackground = this.relationLabelBackground || this.labelBackground;
        this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        this.git0 = this.git0 || this.primaryColor;
        this.git1 = this.git1 || this.secondaryColor;
        this.git2 = this.git2 || this.tertiaryColor;
        this.git3 = this.git3 || (0, _khroma.adjust)(this.primaryColor, {
            h: -30
        });
        this.git4 = this.git4 || (0, _khroma.adjust)(this.primaryColor, {
            h: -60
        });
        this.git5 = this.git5 || (0, _khroma.adjust)(this.primaryColor, {
            h: -90
        });
        this.git6 = this.git6 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60
        });
        this.git7 = this.git7 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120
        });
        if (this.darkMode) {
            this.git0 = (0, _khroma.lighten)(this.git0, 25);
            this.git1 = (0, _khroma.lighten)(this.git1, 25);
            this.git2 = (0, _khroma.lighten)(this.git2, 25);
            this.git3 = (0, _khroma.lighten)(this.git3, 25);
            this.git4 = (0, _khroma.lighten)(this.git4, 25);
            this.git5 = (0, _khroma.lighten)(this.git5, 25);
            this.git6 = (0, _khroma.lighten)(this.git6, 25);
            this.git7 = (0, _khroma.lighten)(this.git7, 25);
        } else {
            this.git0 = (0, _khroma.darken)(this.git0, 25);
            this.git1 = (0, _khroma.darken)(this.git1, 25);
            this.git2 = (0, _khroma.darken)(this.git2, 25);
            this.git3 = (0, _khroma.darken)(this.git3, 25);
            this.git4 = (0, _khroma.darken)(this.git4, 25);
            this.git5 = (0, _khroma.darken)(this.git5, 25);
            this.git6 = (0, _khroma.darken)(this.git6, 25);
            this.git7 = (0, _khroma.darken)(this.git7, 25);
        }
        this.gitInv0 = this.gitInv0 || (0, _khroma.darken)((0, _khroma.invert)(this.git0), 25);
        this.gitInv1 = this.gitInv1 || (0, _khroma.invert)(this.git1);
        this.gitInv2 = this.gitInv2 || (0, _khroma.invert)(this.git2);
        this.gitInv3 = this.gitInv3 || (0, _khroma.invert)(this.git3);
        this.gitInv4 = this.gitInv4 || (0, _khroma.invert)(this.git4);
        this.gitInv5 = this.gitInv5 || (0, _khroma.invert)(this.git5);
        this.gitInv6 = this.gitInv6 || (0, _khroma.invert)(this.git6);
        this.gitInv7 = this.gitInv7 || (0, _khroma.invert)(this.git7);
        this.gitBranchLabel0 = this.gitBranchLabel0 || (0, _khroma.invert)(this.labelTextColor);
        this.gitBranchLabel1 = this.gitBranchLabel1 || this.labelTextColor;
        this.gitBranchLabel2 = this.gitBranchLabel2 || this.labelTextColor;
        this.gitBranchLabel3 = this.gitBranchLabel3 || (0, _khroma.invert)(this.labelTextColor);
        this.gitBranchLabel4 = this.gitBranchLabel4 || this.labelTextColor;
        this.gitBranchLabel5 = this.gitBranchLabel5 || this.labelTextColor;
        this.gitBranchLabel6 = this.gitBranchLabel6 || this.labelTextColor;
        this.gitBranchLabel7 = this.gitBranchLabel7 || this.labelTextColor;
        this.tagLabelColor = this.tagLabelColor || this.primaryTextColor;
        this.tagLabelBackground = this.tagLabelBackground || this.primaryColor;
        this.tagLabelBorder = this.tagBorder || this.primaryBorderColor;
        this.tagLabelFontSize = this.tagLabelFontSize || "10px";
        this.commitLabelColor = this.commitLabelColor || this.secondaryTextColor;
        this.commitLabelBackground = this.commitLabelBackground || this.secondaryColor;
        this.commitLabelFontSize = this.commitLabelFontSize || "10px";
        this.attributeBackgroundColorOdd = this.attributeBackgroundColorOdd || oldAttributeBackgroundColorOdd;
        this.attributeBackgroundColorEven = this.attributeBackgroundColorEven || oldAttributeBackgroundColorEven;
    }
    calculate(overrides) {
        if (typeof overrides !== "object") {
            this.updateColors();
            return;
        }
        const keys = Object.keys(overrides);
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
        this.updateColors();
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
    }
};
const getThemeVariables$2 = (userOverrides)=>{
    const theme2 = new Theme$2();
    theme2.calculate(userOverrides);
    return theme2;
};
let Theme$1 = class Theme4 {
    constructor(){
        this.background = "#f4f4f4";
        this.primaryColor = "#cde498";
        this.secondaryColor = "#cdffb2";
        this.background = "white";
        this.mainBkg = "#cde498";
        this.secondBkg = "#cdffb2";
        this.lineColor = "green";
        this.border1 = "#13540c";
        this.border2 = "#6eaa49";
        this.arrowheadColor = "green";
        this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif';
        this.fontSize = "16px";
        this.tertiaryColor = (0, _khroma.lighten)("#cde498", 10);
        this.primaryBorderColor = mkBorder(this.primaryColor, this.darkMode);
        this.secondaryBorderColor = mkBorder(this.secondaryColor, this.darkMode);
        this.tertiaryBorderColor = mkBorder(this.tertiaryColor, this.darkMode);
        this.primaryTextColor = (0, _khroma.invert)(this.primaryColor);
        this.secondaryTextColor = (0, _khroma.invert)(this.secondaryColor);
        this.tertiaryTextColor = (0, _khroma.invert)(this.primaryColor);
        this.lineColor = (0, _khroma.invert)(this.background);
        this.textColor = (0, _khroma.invert)(this.background);
        this.THEME_COLOR_LIMIT = 12;
        this.nodeBkg = "calculated";
        this.nodeBorder = "calculated";
        this.clusterBkg = "calculated";
        this.clusterBorder = "calculated";
        this.defaultLinkColor = "calculated";
        this.titleColor = "#333";
        this.edgeLabelBackground = "#e8e8e8";
        this.actorBorder = "calculated";
        this.actorBkg = "calculated";
        this.actorTextColor = "black";
        this.actorLineColor = "grey";
        this.signalColor = "#333";
        this.signalTextColor = "#333";
        this.labelBoxBkgColor = "calculated";
        this.labelBoxBorderColor = "#326932";
        this.labelTextColor = "calculated";
        this.loopTextColor = "calculated";
        this.noteBorderColor = "calculated";
        this.noteBkgColor = "#fff5ad";
        this.noteTextColor = "calculated";
        this.activationBorderColor = "#666";
        this.activationBkgColor = "#f4f4f4";
        this.sequenceNumberColor = "white";
        this.sectionBkgColor = "#6eaa49";
        this.altSectionBkgColor = "white";
        this.sectionBkgColor2 = "#6eaa49";
        this.excludeBkgColor = "#eeeeee";
        this.taskBorderColor = "calculated";
        this.taskBkgColor = "#487e3a";
        this.taskTextLightColor = "white";
        this.taskTextColor = "calculated";
        this.taskTextDarkColor = "black";
        this.taskTextOutsideColor = "calculated";
        this.taskTextClickableColor = "#003163";
        this.activeTaskBorderColor = "calculated";
        this.activeTaskBkgColor = "calculated";
        this.gridColor = "lightgrey";
        this.doneTaskBkgColor = "lightgrey";
        this.doneTaskBorderColor = "grey";
        this.critBorderColor = "#ff8888";
        this.critBkgColor = "red";
        this.todayLineColor = "red";
        this.personBorder = this.primaryBorderColor;
        this.personBkg = this.mainBkg;
        this.labelColor = "black";
        this.errorBkgColor = "#552222";
        this.errorTextColor = "#552222";
    }
    updateColors() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        this.actorBorder = (0, _khroma.darken)(this.mainBkg, 20);
        this.actorBkg = this.mainBkg;
        this.labelBoxBkgColor = this.actorBkg;
        this.labelTextColor = this.actorTextColor;
        this.loopTextColor = this.actorTextColor;
        this.noteBorderColor = this.border2;
        this.noteTextColor = this.actorTextColor;
        this.cScale0 = this.cScale0 || this.primaryColor;
        this.cScale1 = this.cScale1 || this.secondaryColor;
        this.cScale2 = this.cScale2 || this.tertiaryColor;
        this.cScale3 = this.cScale3 || (0, _khroma.adjust)(this.primaryColor, {
            h: 30
        });
        this.cScale4 = this.cScale4 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60
        });
        this.cScale5 = this.cScale5 || (0, _khroma.adjust)(this.primaryColor, {
            h: 90
        });
        this.cScale6 = this.cScale6 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120
        });
        this.cScale7 = this.cScale7 || (0, _khroma.adjust)(this.primaryColor, {
            h: 150
        });
        this.cScale8 = this.cScale8 || (0, _khroma.adjust)(this.primaryColor, {
            h: 210
        });
        this.cScale9 = this.cScale9 || (0, _khroma.adjust)(this.primaryColor, {
            h: 270
        });
        this.cScale10 = this.cScale10 || (0, _khroma.adjust)(this.primaryColor, {
            h: 300
        });
        this.cScale11 = this.cScale11 || (0, _khroma.adjust)(this.primaryColor, {
            h: 330
        });
        this["cScalePeer1"] = this["cScalePeer1"] || (0, _khroma.darken)(this.secondaryColor, 45);
        this["cScalePeer2"] = this["cScalePeer2"] || (0, _khroma.darken)(this.tertiaryColor, 40);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++){
            this["cScale" + i] = (0, _khroma.darken)(this["cScale" + i], 10);
            this["cScalePeer" + i] = this["cScalePeer" + i] || (0, _khroma.darken)(this["cScale" + i], 25);
        }
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleInv" + i] = this["cScaleInv" + i] || (0, _khroma.adjust)(this["cScale" + i], {
            h: 180
        });
        this.scaleLabelColor = this.scaleLabelColor !== "calculated" && this.scaleLabelColor ? this.scaleLabelColor : this.labelTextColor;
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleLabel" + i] = this["cScaleLabel" + i] || this.scaleLabelColor;
        for(let i = 0; i < 5; i++){
            this["surface" + i] = this["surface" + i] || (0, _khroma.adjust)(this.mainBkg, {
                h: 30,
                s: -30,
                l: -(5 + i * 5)
            });
            this["surfacePeer" + i] = this["surfacePeer" + i] || (0, _khroma.adjust)(this.mainBkg, {
                h: 30,
                s: -30,
                l: -(8 + i * 5)
            });
        }
        this.nodeBkg = this.mainBkg;
        this.nodeBorder = this.border1;
        this.clusterBkg = this.secondBkg;
        this.clusterBorder = this.border2;
        this.defaultLinkColor = this.lineColor;
        this.taskBorderColor = this.border1;
        this.taskTextColor = this.taskTextLightColor;
        this.taskTextOutsideColor = this.taskTextDarkColor;
        this.activeTaskBorderColor = this.taskBorderColor;
        this.activeTaskBkgColor = this.mainBkg;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.transitionLabelColor = this.transitionLabelColor || this.textColor;
        this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor;
        this.stateBkg = this.stateBkg || this.mainBkg;
        this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg;
        this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor;
        this.altBackground = this.altBackground || "#f0f0f0";
        this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg;
        this.compositeBorder = this.compositeBorder || this.nodeBorder;
        this.innerEndBackground = this.primaryBorderColor;
        this.specialStateColor = this.lineColor;
        this.errorBkgColor = this.errorBkgColor || this.tertiaryColor;
        this.errorTextColor = this.errorTextColor || this.tertiaryTextColor;
        this.transitionColor = this.transitionColor || this.lineColor;
        this.classText = this.primaryTextColor;
        this.fillType0 = this.primaryColor;
        this.fillType1 = this.secondaryColor;
        this.fillType2 = (0, _khroma.adjust)(this.primaryColor, {
            h: 64
        });
        this.fillType3 = (0, _khroma.adjust)(this.secondaryColor, {
            h: 64
        });
        this.fillType4 = (0, _khroma.adjust)(this.primaryColor, {
            h: -64
        });
        this.fillType5 = (0, _khroma.adjust)(this.secondaryColor, {
            h: -64
        });
        this.fillType6 = (0, _khroma.adjust)(this.primaryColor, {
            h: 128
        });
        this.fillType7 = (0, _khroma.adjust)(this.secondaryColor, {
            h: 128
        });
        this.pie1 = this.pie1 || this.primaryColor;
        this.pie2 = this.pie2 || this.secondaryColor;
        this.pie3 = this.pie3 || this.tertiaryColor;
        this.pie4 = this.pie4 || (0, _khroma.adjust)(this.primaryColor, {
            l: -30
        });
        this.pie5 = this.pie5 || (0, _khroma.adjust)(this.secondaryColor, {
            l: -30
        });
        this.pie6 = this.pie6 || (0, _khroma.adjust)(this.tertiaryColor, {
            h: 40,
            l: -40
        });
        this.pie7 = this.pie7 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60,
            l: -10
        });
        this.pie8 = this.pie8 || (0, _khroma.adjust)(this.primaryColor, {
            h: -60,
            l: -10
        });
        this.pie9 = this.pie9 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120,
            l: 0
        });
        this.pie10 = this.pie10 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60,
            l: -50
        });
        this.pie11 = this.pie11 || (0, _khroma.adjust)(this.primaryColor, {
            h: -60,
            l: -50
        });
        this.pie12 = this.pie12 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120,
            l: -50
        });
        this.pieTitleTextSize = this.pieTitleTextSize || "25px";
        this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor;
        this.pieSectionTextSize = this.pieSectionTextSize || "17px";
        this.pieSectionTextColor = this.pieSectionTextColor || this.textColor;
        this.pieLegendTextSize = this.pieLegendTextSize || "17px";
        this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor;
        this.pieStrokeColor = this.pieStrokeColor || "black";
        this.pieStrokeWidth = this.pieStrokeWidth || "2px";
        this.pieOuterStrokeWidth = this.pieOuterStrokeWidth || "2px";
        this.pieOuterStrokeColor = this.pieOuterStrokeColor || "black";
        this.pieOpacity = this.pieOpacity || "0.7";
        this.quadrant1Fill = this.quadrant1Fill || this.primaryColor;
        this.quadrant2Fill = this.quadrant2Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 5,
            g: 5,
            b: 5
        });
        this.quadrant3Fill = this.quadrant3Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 10,
            g: 10,
            b: 10
        });
        this.quadrant4Fill = this.quadrant4Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 15,
            g: 15,
            b: 15
        });
        this.quadrant1TextFill = this.quadrant1TextFill || this.primaryTextColor;
        this.quadrant2TextFill = this.quadrant2TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -5,
            g: -5,
            b: -5
        });
        this.quadrant3TextFill = this.quadrant3TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -10,
            g: -10,
            b: -10
        });
        this.quadrant4TextFill = this.quadrant4TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -15,
            g: -15,
            b: -15
        });
        this.quadrantPointFill = this.quadrantPointFill || (0, _khroma.isDark)(this.quadrant1Fill) ? (0, _khroma.lighten)(this.quadrant1Fill) : (0, _khroma.darken)(this.quadrant1Fill);
        this.quadrantPointTextFill = this.quadrantPointTextFill || this.primaryTextColor;
        this.quadrantXAxisTextFill = this.quadrantXAxisTextFill || this.primaryTextColor;
        this.quadrantYAxisTextFill = this.quadrantYAxisTextFill || this.primaryTextColor;
        this.quadrantInternalBorderStrokeFill = this.quadrantInternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantExternalBorderStrokeFill = this.quadrantExternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantTitleFill = this.quadrantTitleFill || this.primaryTextColor;
        this.xyChart = {
            backgroundColor: ((_a = this.xyChart) == null ? void 0 : _a.backgroundColor) || this.background,
            titleColor: ((_b = this.xyChart) == null ? void 0 : _b.titleColor) || this.primaryTextColor,
            xAxisTitleColor: ((_c = this.xyChart) == null ? void 0 : _c.xAxisTitleColor) || this.primaryTextColor,
            xAxisLabelColor: ((_d = this.xyChart) == null ? void 0 : _d.xAxisLabelColor) || this.primaryTextColor,
            xAxisTickColor: ((_e = this.xyChart) == null ? void 0 : _e.xAxisTickColor) || this.primaryTextColor,
            xAxisLineColor: ((_f = this.xyChart) == null ? void 0 : _f.xAxisLineColor) || this.primaryTextColor,
            yAxisTitleColor: ((_g = this.xyChart) == null ? void 0 : _g.yAxisTitleColor) || this.primaryTextColor,
            yAxisLabelColor: ((_h = this.xyChart) == null ? void 0 : _h.yAxisLabelColor) || this.primaryTextColor,
            yAxisTickColor: ((_i = this.xyChart) == null ? void 0 : _i.yAxisTickColor) || this.primaryTextColor,
            yAxisLineColor: ((_j = this.xyChart) == null ? void 0 : _j.yAxisLineColor) || this.primaryTextColor,
            plotColorPalette: ((_k = this.xyChart) == null ? void 0 : _k.plotColorPalette) || "#CDE498,#FF6B6B,#A0D2DB,#D7BDE2,#F0F0F0,#FFC3A0,#7FD8BE,#FF9A8B,#FAF3E0,#FFF176"
        };
        this.requirementBackground = this.requirementBackground || this.primaryColor;
        this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor;
        this.requirementBorderSize = this.requirementBorderSize || "1";
        this.requirementTextColor = this.requirementTextColor || this.primaryTextColor;
        this.relationColor = this.relationColor || this.lineColor;
        this.relationLabelBackground = this.relationLabelBackground || this.edgeLabelBackground;
        this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        this.git0 = this.git0 || this.primaryColor;
        this.git1 = this.git1 || this.secondaryColor;
        this.git2 = this.git2 || this.tertiaryColor;
        this.git3 = this.git3 || (0, _khroma.adjust)(this.primaryColor, {
            h: -30
        });
        this.git4 = this.git4 || (0, _khroma.adjust)(this.primaryColor, {
            h: -60
        });
        this.git5 = this.git5 || (0, _khroma.adjust)(this.primaryColor, {
            h: -90
        });
        this.git6 = this.git6 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60
        });
        this.git7 = this.git7 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120
        });
        if (this.darkMode) {
            this.git0 = (0, _khroma.lighten)(this.git0, 25);
            this.git1 = (0, _khroma.lighten)(this.git1, 25);
            this.git2 = (0, _khroma.lighten)(this.git2, 25);
            this.git3 = (0, _khroma.lighten)(this.git3, 25);
            this.git4 = (0, _khroma.lighten)(this.git4, 25);
            this.git5 = (0, _khroma.lighten)(this.git5, 25);
            this.git6 = (0, _khroma.lighten)(this.git6, 25);
            this.git7 = (0, _khroma.lighten)(this.git7, 25);
        } else {
            this.git0 = (0, _khroma.darken)(this.git0, 25);
            this.git1 = (0, _khroma.darken)(this.git1, 25);
            this.git2 = (0, _khroma.darken)(this.git2, 25);
            this.git3 = (0, _khroma.darken)(this.git3, 25);
            this.git4 = (0, _khroma.darken)(this.git4, 25);
            this.git5 = (0, _khroma.darken)(this.git5, 25);
            this.git6 = (0, _khroma.darken)(this.git6, 25);
            this.git7 = (0, _khroma.darken)(this.git7, 25);
        }
        this.gitInv0 = this.gitInv0 || (0, _khroma.invert)(this.git0);
        this.gitInv1 = this.gitInv1 || (0, _khroma.invert)(this.git1);
        this.gitInv2 = this.gitInv2 || (0, _khroma.invert)(this.git2);
        this.gitInv3 = this.gitInv3 || (0, _khroma.invert)(this.git3);
        this.gitInv4 = this.gitInv4 || (0, _khroma.invert)(this.git4);
        this.gitInv5 = this.gitInv5 || (0, _khroma.invert)(this.git5);
        this.gitInv6 = this.gitInv6 || (0, _khroma.invert)(this.git6);
        this.gitInv7 = this.gitInv7 || (0, _khroma.invert)(this.git7);
        this.gitBranchLabel0 = this.gitBranchLabel0 || (0, _khroma.invert)(this.labelTextColor);
        this.gitBranchLabel1 = this.gitBranchLabel1 || this.labelTextColor;
        this.gitBranchLabel2 = this.gitBranchLabel2 || this.labelTextColor;
        this.gitBranchLabel3 = this.gitBranchLabel3 || (0, _khroma.invert)(this.labelTextColor);
        this.gitBranchLabel4 = this.gitBranchLabel4 || this.labelTextColor;
        this.gitBranchLabel5 = this.gitBranchLabel5 || this.labelTextColor;
        this.gitBranchLabel6 = this.gitBranchLabel6 || this.labelTextColor;
        this.gitBranchLabel7 = this.gitBranchLabel7 || this.labelTextColor;
        this.tagLabelColor = this.tagLabelColor || this.primaryTextColor;
        this.tagLabelBackground = this.tagLabelBackground || this.primaryColor;
        this.tagLabelBorder = this.tagBorder || this.primaryBorderColor;
        this.tagLabelFontSize = this.tagLabelFontSize || "10px";
        this.commitLabelColor = this.commitLabelColor || this.secondaryTextColor;
        this.commitLabelBackground = this.commitLabelBackground || this.secondaryColor;
        this.commitLabelFontSize = this.commitLabelFontSize || "10px";
        this.attributeBackgroundColorOdd = this.attributeBackgroundColorOdd || oldAttributeBackgroundColorOdd;
        this.attributeBackgroundColorEven = this.attributeBackgroundColorEven || oldAttributeBackgroundColorEven;
    }
    calculate(overrides) {
        if (typeof overrides !== "object") {
            this.updateColors();
            return;
        }
        const keys = Object.keys(overrides);
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
        this.updateColors();
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
    }
};
const getThemeVariables$1 = (userOverrides)=>{
    const theme2 = new Theme$1();
    theme2.calculate(userOverrides);
    return theme2;
};
class Theme5 {
    constructor(){
        this.primaryColor = "#eee";
        this.contrast = "#707070";
        this.secondaryColor = (0, _khroma.lighten)(this.contrast, 55);
        this.background = "#ffffff";
        this.tertiaryColor = (0, _khroma.adjust)(this.primaryColor, {
            h: -160
        });
        this.primaryBorderColor = mkBorder(this.primaryColor, this.darkMode);
        this.secondaryBorderColor = mkBorder(this.secondaryColor, this.darkMode);
        this.tertiaryBorderColor = mkBorder(this.tertiaryColor, this.darkMode);
        this.primaryTextColor = (0, _khroma.invert)(this.primaryColor);
        this.secondaryTextColor = (0, _khroma.invert)(this.secondaryColor);
        this.tertiaryTextColor = (0, _khroma.invert)(this.tertiaryColor);
        this.lineColor = (0, _khroma.invert)(this.background);
        this.textColor = (0, _khroma.invert)(this.background);
        this.mainBkg = "#eee";
        this.secondBkg = "calculated";
        this.lineColor = "#666";
        this.border1 = "#999";
        this.border2 = "calculated";
        this.note = "#ffa";
        this.text = "#333";
        this.critical = "#d42";
        this.done = "#bbb";
        this.arrowheadColor = "#333333";
        this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif';
        this.fontSize = "16px";
        this.THEME_COLOR_LIMIT = 12;
        this.nodeBkg = "calculated";
        this.nodeBorder = "calculated";
        this.clusterBkg = "calculated";
        this.clusterBorder = "calculated";
        this.defaultLinkColor = "calculated";
        this.titleColor = "calculated";
        this.edgeLabelBackground = "white";
        this.actorBorder = "calculated";
        this.actorBkg = "calculated";
        this.actorTextColor = "calculated";
        this.actorLineColor = "calculated";
        this.signalColor = "calculated";
        this.signalTextColor = "calculated";
        this.labelBoxBkgColor = "calculated";
        this.labelBoxBorderColor = "calculated";
        this.labelTextColor = "calculated";
        this.loopTextColor = "calculated";
        this.noteBorderColor = "calculated";
        this.noteBkgColor = "calculated";
        this.noteTextColor = "calculated";
        this.activationBorderColor = "#666";
        this.activationBkgColor = "#f4f4f4";
        this.sequenceNumberColor = "white";
        this.sectionBkgColor = "calculated";
        this.altSectionBkgColor = "white";
        this.sectionBkgColor2 = "calculated";
        this.excludeBkgColor = "#eeeeee";
        this.taskBorderColor = "calculated";
        this.taskBkgColor = "calculated";
        this.taskTextLightColor = "white";
        this.taskTextColor = "calculated";
        this.taskTextDarkColor = "calculated";
        this.taskTextOutsideColor = "calculated";
        this.taskTextClickableColor = "#003163";
        this.activeTaskBorderColor = "calculated";
        this.activeTaskBkgColor = "calculated";
        this.gridColor = "calculated";
        this.doneTaskBkgColor = "calculated";
        this.doneTaskBorderColor = "calculated";
        this.critBkgColor = "calculated";
        this.critBorderColor = "calculated";
        this.todayLineColor = "calculated";
        this.personBorder = this.primaryBorderColor;
        this.personBkg = this.mainBkg;
        this.labelColor = "black";
        this.errorBkgColor = "#552222";
        this.errorTextColor = "#552222";
    }
    updateColors() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        this.secondBkg = (0, _khroma.lighten)(this.contrast, 55);
        this.border2 = this.contrast;
        this.actorBorder = (0, _khroma.lighten)(this.border1, 23);
        this.actorBkg = this.mainBkg;
        this.actorTextColor = this.text;
        this.actorLineColor = this.lineColor;
        this.signalColor = this.text;
        this.signalTextColor = this.text;
        this.labelBoxBkgColor = this.actorBkg;
        this.labelBoxBorderColor = this.actorBorder;
        this.labelTextColor = this.text;
        this.loopTextColor = this.text;
        this.noteBorderColor = "#999";
        this.noteBkgColor = "#666";
        this.noteTextColor = "#fff";
        this.cScale0 = this.cScale0 || "#555";
        this.cScale1 = this.cScale1 || "#F4F4F4";
        this.cScale2 = this.cScale2 || "#555";
        this.cScale3 = this.cScale3 || "#BBB";
        this.cScale4 = this.cScale4 || "#777";
        this.cScale5 = this.cScale5 || "#999";
        this.cScale6 = this.cScale6 || "#DDD";
        this.cScale7 = this.cScale7 || "#FFF";
        this.cScale8 = this.cScale8 || "#DDD";
        this.cScale9 = this.cScale9 || "#BBB";
        this.cScale10 = this.cScale10 || "#999";
        this.cScale11 = this.cScale11 || "#777";
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleInv" + i] = this["cScaleInv" + i] || (0, _khroma.invert)(this["cScale" + i]);
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)if (this.darkMode) this["cScalePeer" + i] = this["cScalePeer" + i] || (0, _khroma.lighten)(this["cScale" + i], 10);
        else this["cScalePeer" + i] = this["cScalePeer" + i] || (0, _khroma.darken)(this["cScale" + i], 10);
        this.scaleLabelColor = this.scaleLabelColor || (this.darkMode ? "black" : this.labelTextColor);
        this["cScaleLabel0"] = this["cScaleLabel0"] || this.cScale1;
        this["cScaleLabel2"] = this["cScaleLabel2"] || this.cScale1;
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["cScaleLabel" + i] = this["cScaleLabel" + i] || this.scaleLabelColor;
        for(let i = 0; i < 5; i++){
            this["surface" + i] = this["surface" + i] || (0, _khroma.adjust)(this.mainBkg, {
                l: -(5 + i * 5)
            });
            this["surfacePeer" + i] = this["surfacePeer" + i] || (0, _khroma.adjust)(this.mainBkg, {
                l: -(8 + i * 5)
            });
        }
        this.nodeBkg = this.mainBkg;
        this.nodeBorder = this.border1;
        this.clusterBkg = this.secondBkg;
        this.clusterBorder = this.border2;
        this.defaultLinkColor = this.lineColor;
        this.titleColor = this.text;
        this.sectionBkgColor = (0, _khroma.lighten)(this.contrast, 30);
        this.sectionBkgColor2 = (0, _khroma.lighten)(this.contrast, 30);
        this.taskBorderColor = (0, _khroma.darken)(this.contrast, 10);
        this.taskBkgColor = this.contrast;
        this.taskTextColor = this.taskTextLightColor;
        this.taskTextDarkColor = this.text;
        this.taskTextOutsideColor = this.taskTextDarkColor;
        this.activeTaskBorderColor = this.taskBorderColor;
        this.activeTaskBkgColor = this.mainBkg;
        this.gridColor = (0, _khroma.lighten)(this.border1, 30);
        this.doneTaskBkgColor = this.done;
        this.doneTaskBorderColor = this.lineColor;
        this.critBkgColor = this.critical;
        this.critBorderColor = (0, _khroma.darken)(this.critBkgColor, 10);
        this.todayLineColor = this.critBkgColor;
        this.transitionColor = this.transitionColor || "#000";
        this.transitionLabelColor = this.transitionLabelColor || this.textColor;
        this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor;
        this.stateBkg = this.stateBkg || this.mainBkg;
        this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg;
        this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor;
        this.altBackground = this.altBackground || "#f4f4f4";
        this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg;
        this.stateBorder = this.stateBorder || "#000";
        this.innerEndBackground = this.primaryBorderColor;
        this.specialStateColor = "#222";
        this.errorBkgColor = this.errorBkgColor || this.tertiaryColor;
        this.errorTextColor = this.errorTextColor || this.tertiaryTextColor;
        this.classText = this.primaryTextColor;
        this.fillType0 = this.primaryColor;
        this.fillType1 = this.secondaryColor;
        this.fillType2 = (0, _khroma.adjust)(this.primaryColor, {
            h: 64
        });
        this.fillType3 = (0, _khroma.adjust)(this.secondaryColor, {
            h: 64
        });
        this.fillType4 = (0, _khroma.adjust)(this.primaryColor, {
            h: -64
        });
        this.fillType5 = (0, _khroma.adjust)(this.secondaryColor, {
            h: -64
        });
        this.fillType6 = (0, _khroma.adjust)(this.primaryColor, {
            h: 128
        });
        this.fillType7 = (0, _khroma.adjust)(this.secondaryColor, {
            h: 128
        });
        for(let i = 0; i < this.THEME_COLOR_LIMIT; i++)this["pie" + i] = this["cScale" + i];
        this.pie12 = this.pie0;
        this.pieTitleTextSize = this.pieTitleTextSize || "25px";
        this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor;
        this.pieSectionTextSize = this.pieSectionTextSize || "17px";
        this.pieSectionTextColor = this.pieSectionTextColor || this.textColor;
        this.pieLegendTextSize = this.pieLegendTextSize || "17px";
        this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor;
        this.pieStrokeColor = this.pieStrokeColor || "black";
        this.pieStrokeWidth = this.pieStrokeWidth || "2px";
        this.pieOuterStrokeWidth = this.pieOuterStrokeWidth || "2px";
        this.pieOuterStrokeColor = this.pieOuterStrokeColor || "black";
        this.pieOpacity = this.pieOpacity || "0.7";
        this.quadrant1Fill = this.quadrant1Fill || this.primaryColor;
        this.quadrant2Fill = this.quadrant2Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 5,
            g: 5,
            b: 5
        });
        this.quadrant3Fill = this.quadrant3Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 10,
            g: 10,
            b: 10
        });
        this.quadrant4Fill = this.quadrant4Fill || (0, _khroma.adjust)(this.primaryColor, {
            r: 15,
            g: 15,
            b: 15
        });
        this.quadrant1TextFill = this.quadrant1TextFill || this.primaryTextColor;
        this.quadrant2TextFill = this.quadrant2TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -5,
            g: -5,
            b: -5
        });
        this.quadrant3TextFill = this.quadrant3TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -10,
            g: -10,
            b: -10
        });
        this.quadrant4TextFill = this.quadrant4TextFill || (0, _khroma.adjust)(this.primaryTextColor, {
            r: -15,
            g: -15,
            b: -15
        });
        this.quadrantPointFill = this.quadrantPointFill || (0, _khroma.isDark)(this.quadrant1Fill) ? (0, _khroma.lighten)(this.quadrant1Fill) : (0, _khroma.darken)(this.quadrant1Fill);
        this.quadrantPointTextFill = this.quadrantPointTextFill || this.primaryTextColor;
        this.quadrantXAxisTextFill = this.quadrantXAxisTextFill || this.primaryTextColor;
        this.quadrantYAxisTextFill = this.quadrantYAxisTextFill || this.primaryTextColor;
        this.quadrantInternalBorderStrokeFill = this.quadrantInternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantExternalBorderStrokeFill = this.quadrantExternalBorderStrokeFill || this.primaryBorderColor;
        this.quadrantTitleFill = this.quadrantTitleFill || this.primaryTextColor;
        this.xyChart = {
            backgroundColor: ((_a = this.xyChart) == null ? void 0 : _a.backgroundColor) || this.background,
            titleColor: ((_b = this.xyChart) == null ? void 0 : _b.titleColor) || this.primaryTextColor,
            xAxisTitleColor: ((_c = this.xyChart) == null ? void 0 : _c.xAxisTitleColor) || this.primaryTextColor,
            xAxisLabelColor: ((_d = this.xyChart) == null ? void 0 : _d.xAxisLabelColor) || this.primaryTextColor,
            xAxisTickColor: ((_e = this.xyChart) == null ? void 0 : _e.xAxisTickColor) || this.primaryTextColor,
            xAxisLineColor: ((_f = this.xyChart) == null ? void 0 : _f.xAxisLineColor) || this.primaryTextColor,
            yAxisTitleColor: ((_g = this.xyChart) == null ? void 0 : _g.yAxisTitleColor) || this.primaryTextColor,
            yAxisLabelColor: ((_h = this.xyChart) == null ? void 0 : _h.yAxisLabelColor) || this.primaryTextColor,
            yAxisTickColor: ((_i = this.xyChart) == null ? void 0 : _i.yAxisTickColor) || this.primaryTextColor,
            yAxisLineColor: ((_j = this.xyChart) == null ? void 0 : _j.yAxisLineColor) || this.primaryTextColor,
            plotColorPalette: ((_k = this.xyChart) == null ? void 0 : _k.plotColorPalette) || "#EEE,#6BB8E4,#8ACB88,#C7ACD6,#E8DCC2,#FFB2A8,#FFF380,#7E8D91,#FFD8B1,#FAF3E0"
        };
        this.requirementBackground = this.requirementBackground || this.primaryColor;
        this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor;
        this.requirementBorderSize = this.requirementBorderSize || "1";
        this.requirementTextColor = this.requirementTextColor || this.primaryTextColor;
        this.relationColor = this.relationColor || this.lineColor;
        this.relationLabelBackground = this.relationLabelBackground || this.edgeLabelBackground;
        this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
        this.git0 = (0, _khroma.darken)(this.pie1, 25) || this.primaryColor;
        this.git1 = this.pie2 || this.secondaryColor;
        this.git2 = this.pie3 || this.tertiaryColor;
        this.git3 = this.pie4 || (0, _khroma.adjust)(this.primaryColor, {
            h: -30
        });
        this.git4 = this.pie5 || (0, _khroma.adjust)(this.primaryColor, {
            h: -60
        });
        this.git5 = this.pie6 || (0, _khroma.adjust)(this.primaryColor, {
            h: -90
        });
        this.git6 = this.pie7 || (0, _khroma.adjust)(this.primaryColor, {
            h: 60
        });
        this.git7 = this.pie8 || (0, _khroma.adjust)(this.primaryColor, {
            h: 120
        });
        this.gitInv0 = this.gitInv0 || (0, _khroma.invert)(this.git0);
        this.gitInv1 = this.gitInv1 || (0, _khroma.invert)(this.git1);
        this.gitInv2 = this.gitInv2 || (0, _khroma.invert)(this.git2);
        this.gitInv3 = this.gitInv3 || (0, _khroma.invert)(this.git3);
        this.gitInv4 = this.gitInv4 || (0, _khroma.invert)(this.git4);
        this.gitInv5 = this.gitInv5 || (0, _khroma.invert)(this.git5);
        this.gitInv6 = this.gitInv6 || (0, _khroma.invert)(this.git6);
        this.gitInv7 = this.gitInv7 || (0, _khroma.invert)(this.git7);
        this.branchLabelColor = this.branchLabelColor || this.labelTextColor;
        this.gitBranchLabel0 = this.branchLabelColor;
        this.gitBranchLabel1 = "white";
        this.gitBranchLabel2 = this.branchLabelColor;
        this.gitBranchLabel3 = "white";
        this.gitBranchLabel4 = this.branchLabelColor;
        this.gitBranchLabel5 = this.branchLabelColor;
        this.gitBranchLabel6 = this.branchLabelColor;
        this.gitBranchLabel7 = this.branchLabelColor;
        this.tagLabelColor = this.tagLabelColor || this.primaryTextColor;
        this.tagLabelBackground = this.tagLabelBackground || this.primaryColor;
        this.tagLabelBorder = this.tagBorder || this.primaryBorderColor;
        this.tagLabelFontSize = this.tagLabelFontSize || "10px";
        this.commitLabelColor = this.commitLabelColor || this.secondaryTextColor;
        this.commitLabelBackground = this.commitLabelBackground || this.secondaryColor;
        this.commitLabelFontSize = this.commitLabelFontSize || "10px";
        this.attributeBackgroundColorOdd = this.attributeBackgroundColorOdd || oldAttributeBackgroundColorOdd;
        this.attributeBackgroundColorEven = this.attributeBackgroundColorEven || oldAttributeBackgroundColorEven;
    }
    calculate(overrides) {
        if (typeof overrides !== "object") {
            this.updateColors();
            return;
        }
        const keys = Object.keys(overrides);
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
        this.updateColors();
        keys.forEach((k)=>{
            this[k] = overrides[k];
        });
    }
}
const getThemeVariables = (userOverrides)=>{
    const theme2 = new Theme5();
    theme2.calculate(userOverrides);
    return theme2;
};
const theme = {
    base: {
        getThemeVariables: getThemeVariables$4
    },
    dark: {
        getThemeVariables: getThemeVariables$3
    },
    default: {
        getThemeVariables: getThemeVariables$2
    },
    forest: {
        getThemeVariables: getThemeVariables$1
    },
    neutral: {
        getThemeVariables
    }
};
const defaultConfigJson = {
    "flowchart": {
        "useMaxWidth": true,
        "titleTopMargin": 25,
        "subGraphTitleMargin": {
            "top": 0,
            "bottom": 0
        },
        "diagramPadding": 8,
        "htmlLabels": true,
        "nodeSpacing": 50,
        "rankSpacing": 50,
        "curve": "basis",
        "padding": 15,
        "defaultRenderer": "dagre-wrapper",
        "wrappingWidth": 200
    },
    "sequence": {
        "useMaxWidth": true,
        "hideUnusedParticipants": false,
        "activationWidth": 10,
        "diagramMarginX": 50,
        "diagramMarginY": 10,
        "actorMargin": 50,
        "width": 150,
        "height": 65,
        "boxMargin": 10,
        "boxTextMargin": 5,
        "noteMargin": 10,
        "messageMargin": 35,
        "messageAlign": "center",
        "mirrorActors": true,
        "forceMenus": false,
        "bottomMarginAdj": 1,
        "rightAngles": false,
        "showSequenceNumbers": false,
        "actorFontSize": 14,
        "actorFontFamily": '"Open Sans", sans-serif',
        "actorFontWeight": 400,
        "noteFontSize": 14,
        "noteFontFamily": '"trebuchet ms", verdana, arial, sans-serif',
        "noteFontWeight": 400,
        "noteAlign": "center",
        "messageFontSize": 16,
        "messageFontFamily": '"trebuchet ms", verdana, arial, sans-serif',
        "messageFontWeight": 400,
        "wrap": false,
        "wrapPadding": 10,
        "labelBoxWidth": 50,
        "labelBoxHeight": 20
    },
    "gantt": {
        "useMaxWidth": true,
        "titleTopMargin": 25,
        "barHeight": 20,
        "barGap": 4,
        "topPadding": 50,
        "rightPadding": 75,
        "leftPadding": 75,
        "gridLineStartPadding": 35,
        "fontSize": 11,
        "sectionFontSize": 11,
        "numberSectionStyles": 4,
        "axisFormat": "%Y-%m-%d",
        "topAxis": false,
        "displayMode": "",
        "weekday": "sunday"
    },
    "journey": {
        "useMaxWidth": true,
        "diagramMarginX": 50,
        "diagramMarginY": 10,
        "leftMargin": 150,
        "width": 150,
        "height": 50,
        "boxMargin": 10,
        "boxTextMargin": 5,
        "noteMargin": 10,
        "messageMargin": 35,
        "messageAlign": "center",
        "bottomMarginAdj": 1,
        "rightAngles": false,
        "taskFontSize": 14,
        "taskFontFamily": '"Open Sans", sans-serif',
        "taskMargin": 50,
        "activationWidth": 10,
        "textPlacement": "fo",
        "actorColours": [
            "#8FBC8F",
            "#7CFC00",
            "#00FFFF",
            "#20B2AA",
            "#B0E0E6",
            "#FFFFE0"
        ],
        "sectionFills": [
            "#191970",
            "#8B008B",
            "#4B0082",
            "#2F4F4F",
            "#800000",
            "#8B4513",
            "#00008B"
        ],
        "sectionColours": [
            "#fff"
        ]
    },
    "class": {
        "useMaxWidth": true,
        "titleTopMargin": 25,
        "arrowMarkerAbsolute": false,
        "dividerMargin": 10,
        "padding": 5,
        "textHeight": 10,
        "defaultRenderer": "dagre-wrapper",
        "htmlLabels": false
    },
    "state": {
        "useMaxWidth": true,
        "titleTopMargin": 25,
        "dividerMargin": 10,
        "sizeUnit": 5,
        "padding": 8,
        "textHeight": 10,
        "titleShift": -15,
        "noteMargin": 10,
        "forkWidth": 70,
        "forkHeight": 7,
        "miniPadding": 2,
        "fontSizeFactor": 5.02,
        "fontSize": 24,
        "labelHeight": 16,
        "edgeLengthFactor": "20",
        "compositTitleSize": 35,
        "radius": 5,
        "defaultRenderer": "dagre-wrapper"
    },
    "er": {
        "useMaxWidth": true,
        "titleTopMargin": 25,
        "diagramPadding": 20,
        "layoutDirection": "TB",
        "minEntityWidth": 100,
        "minEntityHeight": 75,
        "entityPadding": 15,
        "stroke": "gray",
        "fill": "honeydew",
        "fontSize": 12
    },
    "pie": {
        "useMaxWidth": true,
        "textPosition": 0.75
    },
    "quadrantChart": {
        "useMaxWidth": true,
        "chartWidth": 500,
        "chartHeight": 500,
        "titleFontSize": 20,
        "titlePadding": 10,
        "quadrantPadding": 5,
        "xAxisLabelPadding": 5,
        "yAxisLabelPadding": 5,
        "xAxisLabelFontSize": 16,
        "yAxisLabelFontSize": 16,
        "quadrantLabelFontSize": 16,
        "quadrantTextTopPadding": 5,
        "pointTextPadding": 5,
        "pointLabelFontSize": 12,
        "pointRadius": 5,
        "xAxisPosition": "top",
        "yAxisPosition": "left",
        "quadrantInternalBorderStrokeWidth": 1,
        "quadrantExternalBorderStrokeWidth": 2
    },
    "xyChart": {
        "useMaxWidth": true,
        "width": 700,
        "height": 500,
        "titleFontSize": 20,
        "titlePadding": 10,
        "showTitle": true,
        "xAxis": {
            "$ref": "#/$defs/XYChartAxisConfig",
            "showLabel": true,
            "labelFontSize": 14,
            "labelPadding": 5,
            "showTitle": true,
            "titleFontSize": 16,
            "titlePadding": 5,
            "showTick": true,
            "tickLength": 5,
            "tickWidth": 2,
            "showAxisLine": true,
            "axisLineWidth": 2
        },
        "yAxis": {
            "$ref": "#/$defs/XYChartAxisConfig",
            "showLabel": true,
            "labelFontSize": 14,
            "labelPadding": 5,
            "showTitle": true,
            "titleFontSize": 16,
            "titlePadding": 5,
            "showTick": true,
            "tickLength": 5,
            "tickWidth": 2,
            "showAxisLine": true,
            "axisLineWidth": 2
        },
        "chartOrientation": "vertical",
        "plotReservedSpacePercent": 50
    },
    "requirement": {
        "useMaxWidth": true,
        "rect_fill": "#f9f9f9",
        "text_color": "#333",
        "rect_border_size": "0.5px",
        "rect_border_color": "#bbb",
        "rect_min_width": 200,
        "rect_min_height": 200,
        "fontSize": 14,
        "rect_padding": 10,
        "line_height": 20
    },
    "mindmap": {
        "useMaxWidth": true,
        "padding": 10,
        "maxNodeWidth": 200
    },
    "timeline": {
        "useMaxWidth": true,
        "diagramMarginX": 50,
        "diagramMarginY": 10,
        "leftMargin": 150,
        "width": 150,
        "height": 50,
        "boxMargin": 10,
        "boxTextMargin": 5,
        "noteMargin": 10,
        "messageMargin": 35,
        "messageAlign": "center",
        "bottomMarginAdj": 1,
        "rightAngles": false,
        "taskFontSize": 14,
        "taskFontFamily": '"Open Sans", sans-serif',
        "taskMargin": 50,
        "activationWidth": 10,
        "textPlacement": "fo",
        "actorColours": [
            "#8FBC8F",
            "#7CFC00",
            "#00FFFF",
            "#20B2AA",
            "#B0E0E6",
            "#FFFFE0"
        ],
        "sectionFills": [
            "#191970",
            "#8B008B",
            "#4B0082",
            "#2F4F4F",
            "#800000",
            "#8B4513",
            "#00008B"
        ],
        "sectionColours": [
            "#fff"
        ],
        "disableMulticolor": false
    },
    "gitGraph": {
        "useMaxWidth": true,
        "titleTopMargin": 25,
        "diagramPadding": 8,
        "nodeLabel": {
            "width": 75,
            "height": 100,
            "x": -25,
            "y": 0
        },
        "mainBranchName": "main",
        "mainBranchOrder": 0,
        "showCommitLabel": true,
        "showBranches": true,
        "rotateCommitLabel": true,
        "parallelCommits": false,
        "arrowMarkerAbsolute": false
    },
    "c4": {
        "useMaxWidth": true,
        "diagramMarginX": 50,
        "diagramMarginY": 10,
        "c4ShapeMargin": 50,
        "c4ShapePadding": 20,
        "width": 216,
        "height": 60,
        "boxMargin": 10,
        "c4ShapeInRow": 4,
        "nextLinePaddingX": 0,
        "c4BoundaryInRow": 2,
        "personFontSize": 14,
        "personFontFamily": '"Open Sans", sans-serif',
        "personFontWeight": "normal",
        "external_personFontSize": 14,
        "external_personFontFamily": '"Open Sans", sans-serif',
        "external_personFontWeight": "normal",
        "systemFontSize": 14,
        "systemFontFamily": '"Open Sans", sans-serif',
        "systemFontWeight": "normal",
        "external_systemFontSize": 14,
        "external_systemFontFamily": '"Open Sans", sans-serif',
        "external_systemFontWeight": "normal",
        "system_dbFontSize": 14,
        "system_dbFontFamily": '"Open Sans", sans-serif',
        "system_dbFontWeight": "normal",
        "external_system_dbFontSize": 14,
        "external_system_dbFontFamily": '"Open Sans", sans-serif',
        "external_system_dbFontWeight": "normal",
        "system_queueFontSize": 14,
        "system_queueFontFamily": '"Open Sans", sans-serif',
        "system_queueFontWeight": "normal",
        "external_system_queueFontSize": 14,
        "external_system_queueFontFamily": '"Open Sans", sans-serif',
        "external_system_queueFontWeight": "normal",
        "boundaryFontSize": 14,
        "boundaryFontFamily": '"Open Sans", sans-serif',
        "boundaryFontWeight": "normal",
        "messageFontSize": 12,
        "messageFontFamily": '"Open Sans", sans-serif',
        "messageFontWeight": "normal",
        "containerFontSize": 14,
        "containerFontFamily": '"Open Sans", sans-serif',
        "containerFontWeight": "normal",
        "external_containerFontSize": 14,
        "external_containerFontFamily": '"Open Sans", sans-serif',
        "external_containerFontWeight": "normal",
        "container_dbFontSize": 14,
        "container_dbFontFamily": '"Open Sans", sans-serif',
        "container_dbFontWeight": "normal",
        "external_container_dbFontSize": 14,
        "external_container_dbFontFamily": '"Open Sans", sans-serif',
        "external_container_dbFontWeight": "normal",
        "container_queueFontSize": 14,
        "container_queueFontFamily": '"Open Sans", sans-serif',
        "container_queueFontWeight": "normal",
        "external_container_queueFontSize": 14,
        "external_container_queueFontFamily": '"Open Sans", sans-serif',
        "external_container_queueFontWeight": "normal",
        "componentFontSize": 14,
        "componentFontFamily": '"Open Sans", sans-serif',
        "componentFontWeight": "normal",
        "external_componentFontSize": 14,
        "external_componentFontFamily": '"Open Sans", sans-serif',
        "external_componentFontWeight": "normal",
        "component_dbFontSize": 14,
        "component_dbFontFamily": '"Open Sans", sans-serif',
        "component_dbFontWeight": "normal",
        "external_component_dbFontSize": 14,
        "external_component_dbFontFamily": '"Open Sans", sans-serif',
        "external_component_dbFontWeight": "normal",
        "component_queueFontSize": 14,
        "component_queueFontFamily": '"Open Sans", sans-serif',
        "component_queueFontWeight": "normal",
        "external_component_queueFontSize": 14,
        "external_component_queueFontFamily": '"Open Sans", sans-serif',
        "external_component_queueFontWeight": "normal",
        "wrap": true,
        "wrapPadding": 10,
        "person_bg_color": "#08427B",
        "person_border_color": "#073B6F",
        "external_person_bg_color": "#686868",
        "external_person_border_color": "#8A8A8A",
        "system_bg_color": "#1168BD",
        "system_border_color": "#3C7FC0",
        "system_db_bg_color": "#1168BD",
        "system_db_border_color": "#3C7FC0",
        "system_queue_bg_color": "#1168BD",
        "system_queue_border_color": "#3C7FC0",
        "external_system_bg_color": "#999999",
        "external_system_border_color": "#8A8A8A",
        "external_system_db_bg_color": "#999999",
        "external_system_db_border_color": "#8A8A8A",
        "external_system_queue_bg_color": "#999999",
        "external_system_queue_border_color": "#8A8A8A",
        "container_bg_color": "#438DD5",
        "container_border_color": "#3C7FC0",
        "container_db_bg_color": "#438DD5",
        "container_db_border_color": "#3C7FC0",
        "container_queue_bg_color": "#438DD5",
        "container_queue_border_color": "#3C7FC0",
        "external_container_bg_color": "#B3B3B3",
        "external_container_border_color": "#A6A6A6",
        "external_container_db_bg_color": "#B3B3B3",
        "external_container_db_border_color": "#A6A6A6",
        "external_container_queue_bg_color": "#B3B3B3",
        "external_container_queue_border_color": "#A6A6A6",
        "component_bg_color": "#85BBF0",
        "component_border_color": "#78A8D8",
        "component_db_bg_color": "#85BBF0",
        "component_db_border_color": "#78A8D8",
        "component_queue_bg_color": "#85BBF0",
        "component_queue_border_color": "#78A8D8",
        "external_component_bg_color": "#CCCCCC",
        "external_component_border_color": "#BFBFBF",
        "external_component_db_bg_color": "#CCCCCC",
        "external_component_db_border_color": "#BFBFBF",
        "external_component_queue_bg_color": "#CCCCCC",
        "external_component_queue_border_color": "#BFBFBF"
    },
    "sankey": {
        "useMaxWidth": true,
        "width": 600,
        "height": 400,
        "linkColor": "gradient",
        "nodeAlignment": "justify",
        "showValues": true,
        "prefix": "",
        "suffix": ""
    },
    "block": {
        "useMaxWidth": true,
        "padding": 8
    },
    "theme": "default",
    "maxTextSize": 5e4,
    "maxEdges": 500,
    "darkMode": false,
    "fontFamily": '"trebuchet ms", verdana, arial, sans-serif;',
    "logLevel": 5,
    "securityLevel": "strict",
    "startOnLoad": true,
    "arrowMarkerAbsolute": false,
    "secure": [
        "secure",
        "securityLevel",
        "startOnLoad",
        "maxTextSize",
        "maxEdges"
    ],
    "legacyMathML": false,
    "deterministicIds": false,
    "fontSize": 16
};
const config = {
    ...defaultConfigJson,
    // Set, even though they're `undefined` so that `configKeys` finds these keys
    // TODO: Should we replace these with `null` so that they can go in the JSON Schema?
    deterministicIDSeed: void 0,
    themeCSS: void 0,
    // add non-JSON default config values
    themeVariables: theme["default"].getThemeVariables(),
    sequence: {
        ...defaultConfigJson.sequence,
        messageFont: function() {
            return {
                fontFamily: this.messageFontFamily,
                fontSize: this.messageFontSize,
                fontWeight: this.messageFontWeight
            };
        },
        noteFont: function() {
            return {
                fontFamily: this.noteFontFamily,
                fontSize: this.noteFontSize,
                fontWeight: this.noteFontWeight
            };
        },
        actorFont: function() {
            return {
                fontFamily: this.actorFontFamily,
                fontSize: this.actorFontSize,
                fontWeight: this.actorFontWeight
            };
        }
    },
    gantt: {
        ...defaultConfigJson.gantt,
        tickInterval: void 0,
        useWidth: void 0
    },
    c4: {
        ...defaultConfigJson.c4,
        useWidth: void 0,
        personFont: function() {
            return {
                fontFamily: this.personFontFamily,
                fontSize: this.personFontSize,
                fontWeight: this.personFontWeight
            };
        },
        external_personFont: function() {
            return {
                fontFamily: this.external_personFontFamily,
                fontSize: this.external_personFontSize,
                fontWeight: this.external_personFontWeight
            };
        },
        systemFont: function() {
            return {
                fontFamily: this.systemFontFamily,
                fontSize: this.systemFontSize,
                fontWeight: this.systemFontWeight
            };
        },
        external_systemFont: function() {
            return {
                fontFamily: this.external_systemFontFamily,
                fontSize: this.external_systemFontSize,
                fontWeight: this.external_systemFontWeight
            };
        },
        system_dbFont: function() {
            return {
                fontFamily: this.system_dbFontFamily,
                fontSize: this.system_dbFontSize,
                fontWeight: this.system_dbFontWeight
            };
        },
        external_system_dbFont: function() {
            return {
                fontFamily: this.external_system_dbFontFamily,
                fontSize: this.external_system_dbFontSize,
                fontWeight: this.external_system_dbFontWeight
            };
        },
        system_queueFont: function() {
            return {
                fontFamily: this.system_queueFontFamily,
                fontSize: this.system_queueFontSize,
                fontWeight: this.system_queueFontWeight
            };
        },
        external_system_queueFont: function() {
            return {
                fontFamily: this.external_system_queueFontFamily,
                fontSize: this.external_system_queueFontSize,
                fontWeight: this.external_system_queueFontWeight
            };
        },
        containerFont: function() {
            return {
                fontFamily: this.containerFontFamily,
                fontSize: this.containerFontSize,
                fontWeight: this.containerFontWeight
            };
        },
        external_containerFont: function() {
            return {
                fontFamily: this.external_containerFontFamily,
                fontSize: this.external_containerFontSize,
                fontWeight: this.external_containerFontWeight
            };
        },
        container_dbFont: function() {
            return {
                fontFamily: this.container_dbFontFamily,
                fontSize: this.container_dbFontSize,
                fontWeight: this.container_dbFontWeight
            };
        },
        external_container_dbFont: function() {
            return {
                fontFamily: this.external_container_dbFontFamily,
                fontSize: this.external_container_dbFontSize,
                fontWeight: this.external_container_dbFontWeight
            };
        },
        container_queueFont: function() {
            return {
                fontFamily: this.container_queueFontFamily,
                fontSize: this.container_queueFontSize,
                fontWeight: this.container_queueFontWeight
            };
        },
        external_container_queueFont: function() {
            return {
                fontFamily: this.external_container_queueFontFamily,
                fontSize: this.external_container_queueFontSize,
                fontWeight: this.external_container_queueFontWeight
            };
        },
        componentFont: function() {
            return {
                fontFamily: this.componentFontFamily,
                fontSize: this.componentFontSize,
                fontWeight: this.componentFontWeight
            };
        },
        external_componentFont: function() {
            return {
                fontFamily: this.external_componentFontFamily,
                fontSize: this.external_componentFontSize,
                fontWeight: this.external_componentFontWeight
            };
        },
        component_dbFont: function() {
            return {
                fontFamily: this.component_dbFontFamily,
                fontSize: this.component_dbFontSize,
                fontWeight: this.component_dbFontWeight
            };
        },
        external_component_dbFont: function() {
            return {
                fontFamily: this.external_component_dbFontFamily,
                fontSize: this.external_component_dbFontSize,
                fontWeight: this.external_component_dbFontWeight
            };
        },
        component_queueFont: function() {
            return {
                fontFamily: this.component_queueFontFamily,
                fontSize: this.component_queueFontSize,
                fontWeight: this.component_queueFontWeight
            };
        },
        external_component_queueFont: function() {
            return {
                fontFamily: this.external_component_queueFontFamily,
                fontSize: this.external_component_queueFontSize,
                fontWeight: this.external_component_queueFontWeight
            };
        },
        boundaryFont: function() {
            return {
                fontFamily: this.boundaryFontFamily,
                fontSize: this.boundaryFontSize,
                fontWeight: this.boundaryFontWeight
            };
        },
        messageFont: function() {
            return {
                fontFamily: this.messageFontFamily,
                fontSize: this.messageFontSize,
                fontWeight: this.messageFontWeight
            };
        }
    },
    pie: {
        ...defaultConfigJson.pie,
        useWidth: 984
    },
    xyChart: {
        ...defaultConfigJson.xyChart,
        useWidth: void 0
    },
    requirement: {
        ...defaultConfigJson.requirement,
        useWidth: void 0
    },
    gitGraph: {
        ...defaultConfigJson.gitGraph,
        // TODO: This is a temporary override for `gitGraph`, since every other
        //       diagram does have `useMaxWidth`, but instead sets it to `true`.
        //       Should we set this to `true` instead?
        useMaxWidth: false
    },
    sankey: {
        ...defaultConfigJson.sankey,
        // this is false, unlike every other diagram (other than gitGraph)
        // TODO: can we make this default to `true` instead?
        useMaxWidth: false
    }
};
const keyify = (obj, prefix = "")=>Object.keys(obj).reduce((res, el)=>{
        if (Array.isArray(obj[el])) return res;
        else if (typeof obj[el] === "object" && obj[el] !== null) return [
            ...res,
            prefix + el,
            ...keyify(obj[el], "")
        ];
        return [
            ...res,
            prefix + el
        ];
    }, []);
const configKeys = new Set(keyify(config, ""));
const defaultConfig$2 = config;
const sanitizeDirective = (args)=>{
    log$1.debug("sanitizeDirective called with", args);
    if (typeof args !== "object" || args == null) return;
    if (Array.isArray(args)) {
        args.forEach((arg)=>sanitizeDirective(arg));
        return;
    }
    for (const key of Object.keys(args)){
        log$1.debug("Checking key", key);
        if (key.startsWith("__") || key.includes("proto") || key.includes("constr") || !configKeys.has(key) || args[key] == null) {
            log$1.debug("sanitize deleting key: ", key);
            delete args[key];
            continue;
        }
        if (typeof args[key] === "object") {
            log$1.debug("sanitizing object", key);
            sanitizeDirective(args[key]);
            continue;
        }
        const cssMatchers = [
            "themeCSS",
            "fontFamily",
            "altFontFamily"
        ];
        for (const cssKey of cssMatchers)if (key.includes(cssKey)) {
            log$1.debug("sanitizing css option", key);
            args[key] = sanitizeCss(args[key]);
        }
    }
    if (args.themeVariables) for (const k of Object.keys(args.themeVariables)){
        const val = args.themeVariables[k];
        if ((val == null ? void 0 : val.match) && !val.match(/^[\d "#%(),.;A-Za-z]+$/)) args.themeVariables[k] = "";
    }
    log$1.debug("After sanitization", args);
};
const sanitizeCss = (str2)=>{
    let startCnt = 0;
    let endCnt = 0;
    for (const element of str2){
        if (startCnt < endCnt) return "{ /* ERROR: Unbalanced CSS */ }";
        if (element === "{") startCnt++;
        else if (element === "}") endCnt++;
    }
    if (startCnt !== endCnt) return "{ /* ERROR: Unbalanced CSS */ }";
    return str2;
};
const frontMatterRegex = /^-{3}\s*[\n\r](.*?)[\n\r]-{3}\s*[\n\r]+/s;
const directiveRegex = /%{2}{\s*(?:(\w+)\s*:|(\w+))\s*(?:(\w+)|((?:(?!}%{2}).|\r?\n)*))?\s*(?:}%{2})?/gi;
const anyCommentRegex = /\s*%%.*\n/gm;
class UnknownDiagramError extends Error {
    constructor(message){
        super(message);
        this.name = "UnknownDiagramError";
    }
}
const detectors = {};
const detectType = function(text, config2) {
    text = text.replace(frontMatterRegex, "").replace(directiveRegex, "").replace(anyCommentRegex, "\n");
    for (const [key, { detector: detector2 }] of Object.entries(detectors)){
        const diagram2 = detector2(text, config2);
        if (diagram2) return key;
    }
    throw new UnknownDiagramError(`No diagram type detected matching given configuration for text: ${text}`);
};
const registerLazyLoadedDiagrams = (...diagrams2)=>{
    for (const { id: id2, detector: detector2, loader: loader2 } of diagrams2)addDetector(id2, detector2, loader2);
};
const addDetector = (key, detector2, loader2)=>{
    if (detectors[key]) log$1.error(`Detector with key ${key} already exists`);
    else detectors[key] = {
        detector: detector2,
        loader: loader2
    };
    log$1.debug(`Detector with key ${key} added${loader2 ? " with loader" : ""}`);
};
const getDiagramLoader = (key)=>{
    return detectors[key].loader;
};
const assignWithDepth = (dst, src, { depth = 2, clobber = false } = {})=>{
    const config2 = {
        depth,
        clobber
    };
    if (Array.isArray(src) && !Array.isArray(dst)) {
        src.forEach((s)=>assignWithDepth(dst, s, config2));
        return dst;
    } else if (Array.isArray(src) && Array.isArray(dst)) {
        src.forEach((s)=>{
            if (!dst.includes(s)) dst.push(s);
        });
        return dst;
    }
    if (dst === void 0 || depth <= 0) {
        if (dst !== void 0 && dst !== null && typeof dst === "object" && typeof src === "object") return Object.assign(dst, src);
        else return src;
    }
    if (src !== void 0 && typeof dst === "object" && typeof src === "object") Object.keys(src).forEach((key)=>{
        if (typeof src[key] === "object" && (dst[key] === void 0 || typeof dst[key] === "object")) {
            if (dst[key] === void 0) dst[key] = Array.isArray(src[key]) ? [] : {};
            dst[key] = assignWithDepth(dst[key], src[key], {
                depth: depth - 1,
                clobber
            });
        } else if (clobber || typeof dst[key] !== "object" && typeof src[key] !== "object") dst[key] = src[key];
    });
    return dst;
};
const assignWithDepth$1 = assignWithDepth;
const ZERO_WIDTH_SPACE = "\u200B";
const d3CurveTypes = {
    curveBasis: (0, _d3.curveBasis),
    curveBasisClosed: (0, _d3.curveBasisClosed),
    curveBasisOpen: (0, _d3.curveBasisOpen),
    curveBumpX: (0, _d3.curveBumpX),
    curveBumpY: (0, _d3.curveBumpY),
    curveBundle: (0, _d3.curveBundle),
    curveCardinalClosed: (0, _d3.curveCardinalClosed),
    curveCardinalOpen: (0, _d3.curveCardinalOpen),
    curveCardinal: (0, _d3.curveCardinal),
    curveCatmullRomClosed: (0, _d3.curveCatmullRomClosed),
    curveCatmullRomOpen: (0, _d3.curveCatmullRomOpen),
    curveCatmullRom: (0, _d3.curveCatmullRom),
    curveLinear: (0, _d3.curveLinear),
    curveLinearClosed: (0, _d3.curveLinearClosed),
    curveMonotoneX: (0, _d3.curveMonotoneX),
    curveMonotoneY: (0, _d3.curveMonotoneY),
    curveNatural: (0, _d3.curveNatural),
    curveStep: (0, _d3.curveStep),
    curveStepAfter: (0, _d3.curveStepAfter),
    curveStepBefore: (0, _d3.curveStepBefore)
};
const directiveWithoutOpen = /\s*(?:(\w+)(?=:):|(\w+))\s*(?:(\w+)|((?:(?!}%{2}).|\r?\n)*))?\s*(?:}%{2})?/gi;
const detectInit = function(text, config2) {
    const inits = detectDirective(text, /(?:init\b)|(?:initialize\b)/);
    let results = {};
    if (Array.isArray(inits)) {
        const args = inits.map((init2)=>init2.args);
        sanitizeDirective(args);
        results = assignWithDepth$1(results, [
            ...args
        ]);
    } else results = inits.args;
    if (!results) return;
    let type2 = detectType(text, config2);
    const prop = "config";
    if (results[prop] !== void 0) {
        if (type2 === "flowchart-v2") type2 = "flowchart";
        results[type2] = results[prop];
        delete results[prop];
    }
    return results;
};
const detectDirective = function(text, type2 = null) {
    try {
        const commentWithoutDirectives = new RegExp(`[%]{2}(?![{]${directiveWithoutOpen.source})(?=[}][%]{2}).*
`, "ig");
        text = text.trim().replace(commentWithoutDirectives, "").replace(/'/gm, '"');
        log$1.debug(`Detecting diagram directive${type2 !== null ? " type:" + type2 : ""} based on the text:${text}`);
        let match;
        const result = [];
        while((match = directiveRegex.exec(text)) !== null){
            if (match.index === directiveRegex.lastIndex) directiveRegex.lastIndex++;
            if (match && !type2 || type2 && match[1] && match[1].match(type2) || type2 && match[2] && match[2].match(type2)) {
                const type22 = match[1] ? match[1] : match[2];
                const args = match[3] ? match[3].trim() : match[4] ? JSON.parse(match[4].trim()) : null;
                result.push({
                    type: type22,
                    args
                });
            }
        }
        if (result.length === 0) return {
            type: text,
            args: null
        };
        return result.length === 1 ? result[0] : result;
    } catch (error) {
        log$1.error(`ERROR: ${error.message} - Unable to parse directive type: '${type2}' based on the text: '${text}'`);
        return {
            type: void 0,
            args: null
        };
    }
};
const removeDirectives = function(text) {
    return text.replace(directiveRegex, "");
};
const isSubstringInArray = function(str2, arr) {
    for (const [i, element] of arr.entries()){
        if (element.match(str2)) return i;
    }
    return -1;
};
function interpolateToCurve(interpolate, defaultCurve) {
    if (!interpolate) return defaultCurve;
    const curveName = `curve${interpolate.charAt(0).toUpperCase() + interpolate.slice(1)}`;
    return d3CurveTypes[curveName] ?? defaultCurve;
}
function formatUrl(linkStr, config2) {
    const url = linkStr.trim();
    if (!url) return void 0;
    if (config2.securityLevel !== "loose") return (0, _sanitizeUrl.sanitizeUrl)(url);
    return url;
}
const runFunc = (functionName, ...params)=>{
    const arrPaths = functionName.split(".");
    const len = arrPaths.length - 1;
    const fnName = arrPaths[len];
    let obj = window;
    for(let i = 0; i < len; i++){
        obj = obj[arrPaths[i]];
        if (!obj) {
            log$1.error(`Function name: ${functionName} not found in window`);
            return;
        }
    }
    obj[fnName](...params);
};
function distance(p1, p2) {
    if (!p1 || !p2) return 0;
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function traverseEdge(points) {
    let prevPoint;
    let totalDistance = 0;
    points.forEach((point)=>{
        totalDistance += distance(point, prevPoint);
        prevPoint = point;
    });
    const remainingDistance = totalDistance / 2;
    return calculatePoint(points, remainingDistance);
}
function calcLabelPosition(points) {
    if (points.length === 1) return points[0];
    return traverseEdge(points);
}
const roundNumber = (num, precision = 2)=>{
    const factor = Math.pow(10, precision);
    return Math.round(num * factor) / factor;
};
const calculatePoint = (points, distanceToTraverse)=>{
    let prevPoint = void 0;
    let remainingDistance = distanceToTraverse;
    for (const point of points){
        if (prevPoint) {
            const vectorDistance = distance(point, prevPoint);
            if (vectorDistance < remainingDistance) remainingDistance -= vectorDistance;
            else {
                const distanceRatio = remainingDistance / vectorDistance;
                if (distanceRatio <= 0) return prevPoint;
                if (distanceRatio >= 1) return {
                    x: point.x,
                    y: point.y
                };
                if (distanceRatio > 0 && distanceRatio < 1) return {
                    x: roundNumber((1 - distanceRatio) * prevPoint.x + distanceRatio * point.x, 5),
                    y: roundNumber((1 - distanceRatio) * prevPoint.y + distanceRatio * point.y, 5)
                };
            }
        }
        prevPoint = point;
    }
    throw new Error("Could not find a suitable point for the given distance");
};
const calcCardinalityPosition = (isRelationTypePresent, points, initialPosition)=>{
    log$1.info(`our points ${JSON.stringify(points)}`);
    if (points[0] !== initialPosition) points = points.reverse();
    const distanceToCardinalityPoint = 25;
    const center = calculatePoint(points, distanceToCardinalityPoint);
    const d = isRelationTypePresent ? 10 : 5;
    const angle = Math.atan2(points[0].y - center.y, points[0].x - center.x);
    const cardinalityPosition = {
        x: 0,
        y: 0
    };
    cardinalityPosition.x = Math.sin(angle) * d + (points[0].x + center.x) / 2;
    cardinalityPosition.y = -Math.cos(angle) * d + (points[0].y + center.y) / 2;
    return cardinalityPosition;
};
function calcTerminalLabelPosition(terminalMarkerSize, position, _points) {
    const points = structuredClone(_points);
    log$1.info("our points", points);
    if (position !== "start_left" && position !== "start_right") points.reverse();
    const distanceToCardinalityPoint = 25 + terminalMarkerSize;
    const center = calculatePoint(points, distanceToCardinalityPoint);
    const d = 10 + terminalMarkerSize * 0.5;
    const angle = Math.atan2(points[0].y - center.y, points[0].x - center.x);
    const cardinalityPosition = {
        x: 0,
        y: 0
    };
    if (position === "start_left") {
        cardinalityPosition.x = Math.sin(angle + Math.PI) * d + (points[0].x + center.x) / 2;
        cardinalityPosition.y = -Math.cos(angle + Math.PI) * d + (points[0].y + center.y) / 2;
    } else if (position === "end_right") {
        cardinalityPosition.x = Math.sin(angle - Math.PI) * d + (points[0].x + center.x) / 2 - 5;
        cardinalityPosition.y = -Math.cos(angle - Math.PI) * d + (points[0].y + center.y) / 2 - 5;
    } else if (position === "end_left") {
        cardinalityPosition.x = Math.sin(angle) * d + (points[0].x + center.x) / 2 - 5;
        cardinalityPosition.y = -Math.cos(angle) * d + (points[0].y + center.y) / 2 - 5;
    } else {
        cardinalityPosition.x = Math.sin(angle) * d + (points[0].x + center.x) / 2;
        cardinalityPosition.y = -Math.cos(angle) * d + (points[0].y + center.y) / 2;
    }
    return cardinalityPosition;
}
function getStylesFromArray(arr) {
    let style = "";
    let labelStyle = "";
    for (const element of arr)if (element !== void 0) {
        if (element.startsWith("color:") || element.startsWith("text-align:")) labelStyle = labelStyle + element + ";";
        else style = style + element + ";";
    }
    return {
        style,
        labelStyle
    };
}
let cnt = 0;
const generateId = ()=>{
    cnt++;
    return "id-" + Math.random().toString(36).substr(2, 12) + "-" + cnt;
};
function makeRandomHex(length) {
    let result = "";
    const characters = "0123456789abcdef";
    const charactersLength = characters.length;
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * charactersLength));
    return result;
}
const random = (options)=>{
    return makeRandomHex(options.length);
};
const getTextObj = function() {
    return {
        x: 0,
        y: 0,
        fill: void 0,
        anchor: "start",
        style: "#666",
        width: 100,
        height: 100,
        textMargin: 0,
        rx: 0,
        ry: 0,
        valign: void 0,
        text: ""
    };
};
const drawSimpleText = function(elem, textData) {
    const nText = textData.text.replace(common$1.lineBreakRegex, " ");
    const [, _fontSizePx] = parseFontSize(textData.fontSize);
    const textElem = elem.append("text");
    textElem.attr("x", textData.x);
    textElem.attr("y", textData.y);
    textElem.style("text-anchor", textData.anchor);
    textElem.style("font-family", textData.fontFamily);
    textElem.style("font-size", _fontSizePx);
    textElem.style("font-weight", textData.fontWeight);
    textElem.attr("fill", textData.fill);
    if (textData.class !== void 0) textElem.attr("class", textData.class);
    const span = textElem.append("tspan");
    span.attr("x", textData.x + textData.textMargin * 2);
    span.attr("fill", textData.fill);
    span.text(nText);
    return textElem;
};
const wrapLabel = (0, _memoizeJsDefault.default)((label, maxWidth, config2)=>{
    if (!label) return label;
    config2 = Object.assign({
        fontSize: 12,
        fontWeight: 400,
        fontFamily: "Arial",
        joinWith: "<br/>"
    }, config2);
    if (common$1.lineBreakRegex.test(label)) return label;
    const words = label.split(" ");
    const completedLines = [];
    let nextLine = "";
    words.forEach((word, index)=>{
        const wordLength = calculateTextWidth(`${word} `, config2);
        const nextLineLength = calculateTextWidth(nextLine, config2);
        if (wordLength > maxWidth) {
            const { hyphenatedStrings, remainingWord } = breakString(word, maxWidth, "-", config2);
            completedLines.push(nextLine, ...hyphenatedStrings);
            nextLine = remainingWord;
        } else if (nextLineLength + wordLength >= maxWidth) {
            completedLines.push(nextLine);
            nextLine = word;
        } else nextLine = [
            nextLine,
            word
        ].filter(Boolean).join(" ");
        const currentWord = index + 1;
        const isLastWord = currentWord === words.length;
        if (isLastWord) completedLines.push(nextLine);
    });
    return completedLines.filter((line)=>line !== "").join(config2.joinWith);
}, (label, maxWidth, config2)=>`${label}${maxWidth}${config2.fontSize}${config2.fontWeight}${config2.fontFamily}${config2.joinWith}`);
const breakString = (0, _memoizeJsDefault.default)((word, maxWidth, hyphenCharacter = "-", config2)=>{
    config2 = Object.assign({
        fontSize: 12,
        fontWeight: 400,
        fontFamily: "Arial",
        margin: 0
    }, config2);
    const characters = [
        ...word
    ];
    const lines = [];
    let currentLine = "";
    characters.forEach((character, index)=>{
        const nextLine = `${currentLine}${character}`;
        const lineWidth = calculateTextWidth(nextLine, config2);
        if (lineWidth >= maxWidth) {
            const currentCharacter = index + 1;
            const isLastLine = characters.length === currentCharacter;
            const hyphenatedNextLine = `${nextLine}${hyphenCharacter}`;
            lines.push(isLastLine ? nextLine : hyphenatedNextLine);
            currentLine = "";
        } else currentLine = nextLine;
    });
    return {
        hyphenatedStrings: lines,
        remainingWord: currentLine
    };
}, (word, maxWidth, hyphenCharacter = "-", config2)=>`${word}${maxWidth}${hyphenCharacter}${config2.fontSize}${config2.fontWeight}${config2.fontFamily}`);
function calculateTextHeight(text, config2) {
    return calculateTextDimensions(text, config2).height;
}
function calculateTextWidth(text, config2) {
    return calculateTextDimensions(text, config2).width;
}
const calculateTextDimensions = (0, _memoizeJsDefault.default)((text, config2)=>{
    const { fontSize = 12, fontFamily = "Arial", fontWeight = 400 } = config2;
    if (!text) return {
        width: 0,
        height: 0
    };
    const [, _fontSizePx] = parseFontSize(fontSize);
    const fontFamilies = [
        "sans-serif",
        fontFamily
    ];
    const lines = text.split(common$1.lineBreakRegex);
    const dims = [];
    const body = (0, _d3.select)("body");
    if (!body.remove) return {
        width: 0,
        height: 0,
        lineHeight: 0
    };
    const g = body.append("svg");
    for (const fontFamily2 of fontFamilies){
        let cHeight = 0;
        const dim = {
            width: 0,
            height: 0,
            lineHeight: 0
        };
        for (const line of lines){
            const textObj = getTextObj();
            textObj.text = line || ZERO_WIDTH_SPACE;
            const textElem = drawSimpleText(g, textObj).style("font-size", _fontSizePx).style("font-weight", fontWeight).style("font-family", fontFamily2);
            const bBox = (textElem._groups || textElem)[0][0].getBBox();
            if (bBox.width === 0 && bBox.height === 0) throw new Error("svg element not in render tree");
            dim.width = Math.round(Math.max(dim.width, bBox.width));
            cHeight = Math.round(bBox.height);
            dim.height += cHeight;
            dim.lineHeight = Math.round(Math.max(dim.lineHeight, cHeight));
        }
        dims.push(dim);
    }
    g.remove();
    const index = isNaN(dims[1].height) || isNaN(dims[1].width) || isNaN(dims[1].lineHeight) || dims[0].height > dims[1].height && dims[0].width > dims[1].width && dims[0].lineHeight > dims[1].lineHeight ? 0 : 1;
    return dims[index];
}, (text, config2)=>`${text}${config2.fontSize}${config2.fontWeight}${config2.fontFamily}`);
class InitIDGenerator {
    constructor(deterministic = false, seed){
        this.count = 0;
        this.count = seed ? seed.length : 0;
        this.next = deterministic ? ()=>this.count++ : ()=>Date.now();
    }
}
let decoder;
const entityDecode = function(html) {
    decoder = decoder || document.createElement("div");
    html = escape(html).replace(/%26/g, "&").replace(/%23/g, "#").replace(/%3B/g, ";");
    decoder.innerHTML = html;
    return unescape(decoder.textContent);
};
function isDetailedError(error) {
    return "str" in error;
}
const insertTitle = (parent, cssClass, titleTopMargin, title)=>{
    var _a;
    if (!title) return;
    const bounds = (_a = parent.node()) == null ? void 0 : _a.getBBox();
    if (!bounds) return;
    parent.append("text").text(title).attr("x", bounds.x + bounds.width / 2).attr("y", -titleTopMargin).attr("class", cssClass);
};
const parseFontSize = (fontSize)=>{
    if (typeof fontSize === "number") return [
        fontSize,
        fontSize + "px"
    ];
    const fontSizeNumber = parseInt(fontSize ?? "", 10);
    if (Number.isNaN(fontSizeNumber)) return [
        void 0,
        void 0
    ];
    else if (fontSize === String(fontSizeNumber)) return [
        fontSizeNumber,
        fontSize + "px"
    ];
    else return [
        fontSizeNumber,
        fontSize
    ];
};
function cleanAndMerge(defaultData, data) {
    return (0, _mergeJsDefault.default)({}, defaultData, data);
}
const utils = {
    assignWithDepth: assignWithDepth$1,
    wrapLabel,
    calculateTextHeight,
    calculateTextWidth,
    calculateTextDimensions,
    cleanAndMerge,
    detectInit,
    detectDirective,
    isSubstringInArray,
    interpolateToCurve,
    calcLabelPosition,
    calcCardinalityPosition,
    calcTerminalLabelPosition,
    formatUrl,
    getStylesFromArray,
    generateId,
    random,
    runFunc,
    entityDecode,
    insertTitle,
    parseFontSize,
    InitIDGenerator
};
const encodeEntities = function(text) {
    let txt = text;
    txt = txt.replace(/style.*:\S*#.*;/g, function(s) {
        return s.substring(0, s.length - 1);
    });
    txt = txt.replace(/classDef.*:\S*#.*;/g, function(s) {
        return s.substring(0, s.length - 1);
    });
    txt = txt.replace(/#\w+;/g, function(s) {
        const innerTxt = s.substring(1, s.length - 1);
        const isInt = /^\+?\d+$/.test(innerTxt);
        if (isInt) return "\uFB02\xb0\xb0" + innerTxt + "\xb6\xdf";
        else return "\uFB02\xb0" + innerTxt + "\xb6\xdf";
    });
    return txt;
};
const decodeEntities = function(text) {
    return text.replace(/ﬂ°°/g, "&#").replace(/ﬂ°/g, "&").replace(/¶ß/g, ";");
};
const version = "10.9.3";
const defaultConfig$1 = Object.freeze(defaultConfig$2);
let siteConfig = assignWithDepth$1({}, defaultConfig$1);
let configFromInitialize;
let directives = [];
let currentConfig = assignWithDepth$1({}, defaultConfig$1);
const updateCurrentConfig = (siteCfg, _directives)=>{
    let cfg = assignWithDepth$1({}, siteCfg);
    let sumOfDirectives = {};
    for (const d of _directives){
        sanitize(d);
        sumOfDirectives = assignWithDepth$1(sumOfDirectives, d);
    }
    cfg = assignWithDepth$1(cfg, sumOfDirectives);
    if (sumOfDirectives.theme && sumOfDirectives.theme in theme) {
        const tmpConfigFromInitialize = assignWithDepth$1({}, configFromInitialize);
        const themeVariables = assignWithDepth$1(tmpConfigFromInitialize.themeVariables || {}, sumOfDirectives.themeVariables);
        if (cfg.theme && cfg.theme in theme) cfg.themeVariables = theme[cfg.theme].getThemeVariables(themeVariables);
    }
    currentConfig = cfg;
    checkConfig(currentConfig);
    return currentConfig;
};
const setSiteConfig = (conf)=>{
    siteConfig = assignWithDepth$1({}, defaultConfig$1);
    siteConfig = assignWithDepth$1(siteConfig, conf);
    if (conf.theme && theme[conf.theme]) siteConfig.themeVariables = theme[conf.theme].getThemeVariables(conf.themeVariables);
    updateCurrentConfig(siteConfig, directives);
    return siteConfig;
};
const saveConfigFromInitialize = (conf)=>{
    configFromInitialize = assignWithDepth$1({}, conf);
};
const updateSiteConfig = (conf)=>{
    siteConfig = assignWithDepth$1(siteConfig, conf);
    updateCurrentConfig(siteConfig, directives);
    return siteConfig;
};
const getSiteConfig = ()=>{
    return assignWithDepth$1({}, siteConfig);
};
const setConfig$1 = (conf)=>{
    checkConfig(conf);
    assignWithDepth$1(currentConfig, conf);
    return getConfig$1();
};
const getConfig$1 = ()=>{
    return assignWithDepth$1({}, currentConfig);
};
const sanitize = (options)=>{
    if (!options) return;
    [
        "secure",
        ...siteConfig.secure ?? []
    ].forEach((key)=>{
        if (Object.hasOwn(options, key)) {
            log$1.debug(`Denied attempt to modify a secure key ${key}`, options[key]);
            delete options[key];
        }
    });
    Object.keys(options).forEach((key)=>{
        if (key.startsWith("__")) delete options[key];
    });
    Object.keys(options).forEach((key)=>{
        if (typeof options[key] === "string" && (options[key].includes("<") || options[key].includes(">") || options[key].includes("url(data:"))) delete options[key];
        if (typeof options[key] === "object") sanitize(options[key]);
    });
};
const addDirective = (directive)=>{
    sanitizeDirective(directive);
    if (directive.fontFamily && (!directive.themeVariables || !directive.themeVariables.fontFamily)) directive.themeVariables = {
        fontFamily: directive.fontFamily
    };
    directives.push(directive);
    updateCurrentConfig(siteConfig, directives);
};
const reset = (config2 = siteConfig)=>{
    directives = [];
    updateCurrentConfig(config2, directives);
};
const ConfigWarning = {
    LAZY_LOAD_DEPRECATED: "The configuration options lazyLoadedDiagrams and loadExternalDiagramsAtStartup are deprecated. Please use registerExternalDiagrams instead."
};
const issuedWarnings = {};
const issueWarning = (warning)=>{
    if (issuedWarnings[warning]) return;
    log$1.warn(ConfigWarning[warning]);
    issuedWarnings[warning] = true;
};
const checkConfig = (config2)=>{
    if (!config2) return;
    if (config2.lazyLoadedDiagrams || config2.loadExternalDiagramsAtStartup) issueWarning("LAZY_LOAD_DEPRECATED");
};
const id$l = "c4";
const detector$l = (txt)=>{
    return /^\s*C4Context|C4Container|C4Component|C4Dynamic|C4Deployment/.test(txt);
};
const loader$m = async ()=>{
    const { diagram: diagram2 } = await require("2ba1c829b89980ad");
    return {
        id: id$l,
        diagram: diagram2
    };
};
const plugin$j = {
    id: id$l,
    detector: detector$l,
    loader: loader$m
};
const c4 = plugin$j;
const id$k = "flowchart";
const detector$k = (txt, config2)=>{
    var _a, _b;
    if (((_a = config2 == null ? void 0 : config2.flowchart) == null ? void 0 : _a.defaultRenderer) === "dagre-wrapper" || ((_b = config2 == null ? void 0 : config2.flowchart) == null ? void 0 : _b.defaultRenderer) === "elk") return false;
    return /^\s*graph/.test(txt);
};
const loader$l = async ()=>{
    const { diagram: diagram2 } = await require("b9e6fce9c305611c");
    return {
        id: id$k,
        diagram: diagram2
    };
};
const plugin$i = {
    id: id$k,
    detector: detector$k,
    loader: loader$l
};
const flowchart = plugin$i;
const id$j = "flowchart-v2";
const detector$j = (txt, config2)=>{
    var _a, _b, _c;
    if (((_a = config2 == null ? void 0 : config2.flowchart) == null ? void 0 : _a.defaultRenderer) === "dagre-d3" || ((_b = config2 == null ? void 0 : config2.flowchart) == null ? void 0 : _b.defaultRenderer) === "elk") return false;
    if (/^\s*graph/.test(txt) && ((_c = config2 == null ? void 0 : config2.flowchart) == null ? void 0 : _c.defaultRenderer) === "dagre-wrapper") return true;
    return /^\s*flowchart/.test(txt);
};
const loader$k = async ()=>{
    const { diagram: diagram2 } = await require("9835076ac3952c1f");
    return {
        id: id$j,
        diagram: diagram2
    };
};
const plugin$h = {
    id: id$j,
    detector: detector$j,
    loader: loader$k
};
const flowchartV2 = plugin$h;
const id$i = "er";
const detector$i = (txt)=>{
    return /^\s*erDiagram/.test(txt);
};
const loader$j = async ()=>{
    const { diagram: diagram2 } = await require("8efbfa4fc5ae0f86");
    return {
        id: id$i,
        diagram: diagram2
    };
};
const plugin$g = {
    id: id$i,
    detector: detector$i,
    loader: loader$j
};
const er = plugin$g;
const id$h = "gitGraph";
const detector$h = (txt)=>{
    return /^\s*gitGraph/.test(txt);
};
const loader$i = async ()=>{
    const { diagram: diagram2 } = await require("478de527573b4ba3");
    return {
        id: id$h,
        diagram: diagram2
    };
};
const plugin$f = {
    id: id$h,
    detector: detector$h,
    loader: loader$i
};
const git = plugin$f;
const id$g = "gantt";
const detector$g = (txt)=>{
    return /^\s*gantt/.test(txt);
};
const loader$h = async ()=>{
    const { diagram: diagram2 } = await require("c443aa1a0f9f0a");
    return {
        id: id$g,
        diagram: diagram2
    };
};
const plugin$e = {
    id: id$g,
    detector: detector$g,
    loader: loader$h
};
const gantt = plugin$e;
const id$f = "info";
const detector$f = (txt)=>{
    return /^\s*info/.test(txt);
};
const loader$g = async ()=>{
    const { diagram: diagram2 } = await require("a8990e9ec7acfa0f");
    return {
        id: id$f,
        diagram: diagram2
    };
};
const info = {
    id: id$f,
    detector: detector$f,
    loader: loader$g
};
const id$e = "pie";
const detector$e = (txt)=>{
    return /^\s*pie/.test(txt);
};
const loader$f = async ()=>{
    const { diagram: diagram2 } = await require("b34e1a226107ff66");
    return {
        id: id$e,
        diagram: diagram2
    };
};
const pie = {
    id: id$e,
    detector: detector$e,
    loader: loader$f
};
const id$d = "quadrantChart";
const detector$d = (txt)=>{
    return /^\s*quadrantChart/.test(txt);
};
const loader$e = async ()=>{
    const { diagram: diagram2 } = await require("72ffc3b9aed712ff");
    return {
        id: id$d,
        diagram: diagram2
    };
};
const plugin$d = {
    id: id$d,
    detector: detector$d,
    loader: loader$e
};
const quadrantChart = plugin$d;
const id$c = "xychart";
const detector$c = (txt)=>{
    return /^\s*xychart-beta/.test(txt);
};
const loader$d = async ()=>{
    const { diagram: diagram2 } = await require("30affe5c561e0d8a");
    return {
        id: id$c,
        diagram: diagram2
    };
};
const plugin$c = {
    id: id$c,
    detector: detector$c,
    loader: loader$d
};
const xychart = plugin$c;
const id$b = "requirement";
const detector$b = (txt)=>{
    return /^\s*requirement(Diagram)?/.test(txt);
};
const loader$c = async ()=>{
    const { diagram: diagram2 } = await require("8201da67ab24ce17");
    return {
        id: id$b,
        diagram: diagram2
    };
};
const plugin$b = {
    id: id$b,
    detector: detector$b,
    loader: loader$c
};
const requirement = plugin$b;
const id$a = "sequence";
const detector$a = (txt)=>{
    return /^\s*sequenceDiagram/.test(txt);
};
const loader$b = async ()=>{
    const { diagram: diagram2 } = await require("61c1df035677149e");
    return {
        id: id$a,
        diagram: diagram2
    };
};
const plugin$a = {
    id: id$a,
    detector: detector$a,
    loader: loader$b
};
const sequence = plugin$a;
const id$9 = "class";
const detector$9 = (txt, config2)=>{
    var _a;
    if (((_a = config2 == null ? void 0 : config2.class) == null ? void 0 : _a.defaultRenderer) === "dagre-wrapper") return false;
    return /^\s*classDiagram/.test(txt);
};
const loader$a = async ()=>{
    const { diagram: diagram2 } = await require("cb4f872e22c08f4f");
    return {
        id: id$9,
        diagram: diagram2
    };
};
const plugin$9 = {
    id: id$9,
    detector: detector$9,
    loader: loader$a
};
const classDiagram = plugin$9;
const id$8 = "classDiagram";
const detector$8 = (txt, config2)=>{
    var _a;
    if (/^\s*classDiagram/.test(txt) && ((_a = config2 == null ? void 0 : config2.class) == null ? void 0 : _a.defaultRenderer) === "dagre-wrapper") return true;
    return /^\s*classDiagram-v2/.test(txt);
};
const loader$9 = async ()=>{
    const { diagram: diagram2 } = await require("afa89555aff2b477");
    return {
        id: id$8,
        diagram: diagram2
    };
};
const plugin$8 = {
    id: id$8,
    detector: detector$8,
    loader: loader$9
};
const classDiagramV2 = plugin$8;
const id$7 = "state";
const detector$7 = (txt, config2)=>{
    var _a;
    if (((_a = config2 == null ? void 0 : config2.state) == null ? void 0 : _a.defaultRenderer) === "dagre-wrapper") return false;
    return /^\s*stateDiagram/.test(txt);
};
const loader$8 = async ()=>{
    const { diagram: diagram2 } = await require("18f5f1dfcf3aa91");
    return {
        id: id$7,
        diagram: diagram2
    };
};
const plugin$7 = {
    id: id$7,
    detector: detector$7,
    loader: loader$8
};
const state = plugin$7;
const id$6 = "stateDiagram";
const detector$6 = (txt, config2)=>{
    var _a;
    if (/^\s*stateDiagram-v2/.test(txt)) return true;
    if (/^\s*stateDiagram/.test(txt) && ((_a = config2 == null ? void 0 : config2.state) == null ? void 0 : _a.defaultRenderer) === "dagre-wrapper") return true;
    return false;
};
const loader$7 = async ()=>{
    const { diagram: diagram2 } = await require("a05e17f8f4ce2c07");
    return {
        id: id$6,
        diagram: diagram2
    };
};
const plugin$6 = {
    id: id$6,
    detector: detector$6,
    loader: loader$7
};
const stateV2 = plugin$6;
const id$5 = "journey";
const detector$5 = (txt)=>{
    return /^\s*journey/.test(txt);
};
const loader$6 = async ()=>{
    const { diagram: diagram2 } = await require("18e8bcf1aa1aeef");
    return {
        id: id$5,
        diagram: diagram2
    };
};
const plugin$5 = {
    id: id$5,
    detector: detector$5,
    loader: loader$6
};
const journey = plugin$5;
const d3Attrs = function(d3Elem, attrs) {
    for (let attr of attrs)d3Elem.attr(attr[0], attr[1]);
};
const calculateSvgSizeAttrs = function(height, width, useMaxWidth) {
    let attrs = /* @__PURE__ */ new Map();
    if (useMaxWidth) {
        attrs.set("width", "100%");
        attrs.set("style", `max-width: ${width}px;`);
    } else {
        attrs.set("height", height);
        attrs.set("width", width);
    }
    return attrs;
};
const configureSvgSize = function(svgElem, height, width, useMaxWidth) {
    const attrs = calculateSvgSizeAttrs(height, width, useMaxWidth);
    d3Attrs(svgElem, attrs);
};
const setupGraphViewbox$1 = function(graph, svgElem, padding, useMaxWidth) {
    const svgBounds = svgElem.node().getBBox();
    const sWidth = svgBounds.width;
    const sHeight = svgBounds.height;
    log$1.info(`SVG bounds: ${sWidth}x${sHeight}`, svgBounds);
    let width = 0;
    let height = 0;
    log$1.info(`Graph bounds: ${width}x${height}`, graph);
    width = sWidth + padding * 2;
    height = sHeight + padding * 2;
    log$1.info(`Calculated bounds: ${width}x${height}`);
    configureSvgSize(svgElem, height, width, useMaxWidth);
    const vBox = `${svgBounds.x - padding} ${svgBounds.y - padding} ${svgBounds.width + 2 * padding} ${svgBounds.height + 2 * padding}`;
    svgElem.attr("viewBox", vBox);
};
const themes = {};
const getStyles = (type2, userStyles, options)=>{
    let diagramStyles = "";
    if (type2 in themes && themes[type2]) diagramStyles = themes[type2](options);
    else log$1.warn(`No theme found for ${type2}`);
    return ` & {
    font-family: ${options.fontFamily};
    font-size: ${options.fontSize};
    fill: ${options.textColor}
  }

  /* Classes common for multiple diagrams */

  & .error-icon {
    fill: ${options.errorBkgColor};
  }
  & .error-text {
    fill: ${options.errorTextColor};
    stroke: ${options.errorTextColor};
  }

  & .edge-thickness-normal {
    stroke-width: 2px;
  }
  & .edge-thickness-thick {
    stroke-width: 3.5px
  }
  & .edge-pattern-solid {
    stroke-dasharray: 0;
  }

  & .edge-pattern-dashed{
    stroke-dasharray: 3;
  }
  .edge-pattern-dotted {
    stroke-dasharray: 2;
  }

  & .marker {
    fill: ${options.lineColor};
    stroke: ${options.lineColor};
  }
  & .marker.cross {
    stroke: ${options.lineColor};
  }

  & svg {
    font-family: ${options.fontFamily};
    font-size: ${options.fontSize};
  }

  ${diagramStyles}

  ${userStyles}
`;
};
const addStylesForDiagram = (type2, diagramTheme)=>{
    if (diagramTheme !== void 0) themes[type2] = diagramTheme;
};
const getStyles$1 = getStyles;
let accTitle = "";
let diagramTitle = "";
let accDescription = "";
const sanitizeText$1 = (txt)=>sanitizeText$2(txt, getConfig$1());
const clear = ()=>{
    accTitle = "";
    accDescription = "";
    diagramTitle = "";
};
const setAccTitle = (txt)=>{
    accTitle = sanitizeText$1(txt).replace(/^\s+/g, "");
};
const getAccTitle = ()=>accTitle;
const setAccDescription = (txt)=>{
    accDescription = sanitizeText$1(txt).replace(/\n\s+/g, "\n");
};
const getAccDescription = ()=>accDescription;
const setDiagramTitle = (txt)=>{
    diagramTitle = sanitizeText$1(txt);
};
const getDiagramTitle = ()=>diagramTitle;
const commonDb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    clear,
    getAccDescription,
    getAccTitle,
    getDiagramTitle,
    setAccDescription,
    setAccTitle,
    setDiagramTitle
}, Symbol.toStringTag, {
    value: "Module"
}));
const log = log$1;
const setLogLevel = setLogLevel$1;
const getConfig = getConfig$1;
const setConfig = setConfig$1;
const defaultConfig = defaultConfig$1;
const sanitizeText = (text)=>sanitizeText$2(text, getConfig());
const setupGraphViewbox = setupGraphViewbox$1;
const getCommonDb = ()=>{
    return commonDb;
};
const diagrams = {};
const registerDiagram = (id2, diagram2, detector2)=>{
    var _a;
    if (diagrams[id2]) throw new Error(`Diagram ${id2} already registered.`);
    diagrams[id2] = diagram2;
    if (detector2) addDetector(id2, detector2);
    addStylesForDiagram(id2, diagram2.styles);
    (_a = diagram2.injectUtils) == null || _a.call(diagram2, log, setLogLevel, getConfig, sanitizeText, setupGraphViewbox, getCommonDb(), ()=>{});
};
const getDiagram = (name)=>{
    if (name in diagrams) return diagrams[name];
    throw new DiagramNotFoundError(name);
};
class DiagramNotFoundError extends Error {
    constructor(name){
        super(`Diagram ${name} not found.`);
    }
}
const selectSvgElement = (id2)=>{
    var _a;
    const { securityLevel } = getConfig();
    let root = (0, _d3.select)("body");
    if (securityLevel === "sandbox") {
        const sandboxElement = (0, _d3.select)(`#i${id2}`);
        const doc = ((_a = sandboxElement.node()) == null ? void 0 : _a.contentDocument) ?? document;
        root = (0, _d3.select)(doc.body);
    }
    const svg = root.select(`#${id2}`);
    return svg;
};
const draw = (_text, id2, version2)=>{
    log$1.debug("rendering svg for syntax error\n");
    const svg = selectSvgElement(id2);
    const g = svg.append("g");
    svg.attr("viewBox", "0 0 2412 512");
    configureSvgSize(svg, 100, 512, true);
    g.append("path").attr("class", "error-icon").attr("d", "m411.313,123.313c6.25-6.25 6.25-16.375 0-22.625s-16.375-6.25-22.625,0l-32,32-9.375,9.375-20.688-20.688c-12.484-12.5-32.766-12.5-45.25,0l-16,16c-1.261,1.261-2.304,2.648-3.31,4.051-21.739-8.561-45.324-13.426-70.065-13.426-105.867,0-192,86.133-192,192s86.133,192 192,192 192-86.133 192-192c0-24.741-4.864-48.327-13.426-70.065 1.402-1.007 2.79-2.049 4.051-3.31l16-16c12.5-12.492 12.5-32.758 0-45.25l-20.688-20.688 9.375-9.375 32.001-31.999zm-219.313,100.687c-52.938,0-96,43.063-96,96 0,8.836-7.164,16-16,16s-16-7.164-16-16c0-70.578 57.422-128 128-128 8.836,0 16,7.164 16,16s-7.164,16-16,16z");
    g.append("path").attr("class", "error-icon").attr("d", "m459.02,148.98c-6.25-6.25-16.375-6.25-22.625,0s-6.25,16.375 0,22.625l16,16c3.125,3.125 7.219,4.688 11.313,4.688 4.094,0 8.188-1.563 11.313-4.688 6.25-6.25 6.25-16.375 0-22.625l-16.001-16z");
    g.append("path").attr("class", "error-icon").attr("d", "m340.395,75.605c3.125,3.125 7.219,4.688 11.313,4.688 4.094,0 8.188-1.563 11.313-4.688 6.25-6.25 6.25-16.375 0-22.625l-16-16c-6.25-6.25-16.375-6.25-22.625,0s-6.25,16.375 0,22.625l15.999,16z");
    g.append("path").attr("class", "error-icon").attr("d", "m400,64c8.844,0 16-7.164 16-16v-32c0-8.836-7.156-16-16-16-8.844,0-16,7.164-16,16v32c0,8.836 7.156,16 16,16z");
    g.append("path").attr("class", "error-icon").attr("d", "m496,96.586h-32c-8.844,0-16,7.164-16,16 0,8.836 7.156,16 16,16h32c8.844,0 16-7.164 16-16 0-8.836-7.156-16-16-16z");
    g.append("path").attr("class", "error-icon").attr("d", "m436.98,75.605c3.125,3.125 7.219,4.688 11.313,4.688 4.094,0 8.188-1.563 11.313-4.688l32-32c6.25-6.25 6.25-16.375 0-22.625s-16.375-6.25-22.625,0l-32,32c-6.251,6.25-6.251,16.375-0.001,22.625z");
    g.append("text").attr("class", "error-text").attr("x", 1440).attr("y", 250).attr("font-size", "150px").style("text-anchor", "middle").text("Syntax error in text");
    g.append("text").attr("class", "error-text").attr("x", 1250).attr("y", 400).attr("font-size", "100px").style("text-anchor", "middle").text(`mermaid version ${version2}`);
};
const renderer = {
    draw
};
const errorRenderer = renderer;
const diagram = {
    db: {},
    renderer,
    parser: {
        parser: {
            yy: {}
        },
        parse: ()=>{
            return;
        }
    }
};
const errorDiagram = diagram;
const id$4 = "flowchart-elk";
const detector$4 = (txt, config2)=>{
    var _a;
    if (// If diagram explicitly states flowchart-elk
    /^\s*flowchart-elk/.test(txt) || // If a flowchart/graph diagram has their default renderer set to elk
    /^\s*flowchart|graph/.test(txt) && ((_a = config2 == null ? void 0 : config2.flowchart) == null ? void 0 : _a.defaultRenderer) === "elk") return true;
    return false;
};
const loader$5 = async ()=>{
    const { diagram: diagram2 } = await require("69c221d827f219bc");
    return {
        id: id$4,
        diagram: diagram2
    };
};
const plugin$4 = {
    id: id$4,
    detector: detector$4,
    loader: loader$5
};
const flowchartElk = plugin$4;
const id$3 = "timeline";
const detector$3 = (txt)=>{
    return /^\s*timeline/.test(txt);
};
const loader$4 = async ()=>{
    const { diagram: diagram2 } = await require("5a5dea4afe927698");
    return {
        id: id$3,
        diagram: diagram2
    };
};
const plugin$3 = {
    id: id$3,
    detector: detector$3,
    loader: loader$4
};
const timeline = plugin$3;
const id$2 = "mindmap";
const detector$2 = (txt)=>{
    return /^\s*mindmap/.test(txt);
};
const loader$3 = async ()=>{
    const { diagram: diagram2 } = await require("2f31654da013ca43");
    return {
        id: id$2,
        diagram: diagram2
    };
};
const plugin$2 = {
    id: id$2,
    detector: detector$2,
    loader: loader$3
};
const mindmap = plugin$2;
const id$1 = "sankey";
const detector$1 = (txt)=>{
    return /^\s*sankey-beta/.test(txt);
};
const loader$2 = async ()=>{
    const { diagram: diagram2 } = await require("e9b1986b5bf7f4ed");
    return {
        id: id$1,
        diagram: diagram2
    };
};
const plugin$1 = {
    id: id$1,
    detector: detector$1,
    loader: loader$2
};
const sankey = plugin$1;
const id = "block";
const detector = (txt)=>{
    return /^\s*block-beta/.test(txt);
};
const loader$1 = async ()=>{
    const { diagram: diagram2 } = await require("d84434f4f1a96467");
    return {
        id,
        diagram: diagram2
    };
};
const plugin = {
    id,
    detector,
    loader: loader$1
};
const block = plugin;
let hasLoadedDiagrams = false;
const addDiagrams = ()=>{
    if (hasLoadedDiagrams) return;
    hasLoadedDiagrams = true;
    registerDiagram("error", errorDiagram, (text)=>{
        return text.toLowerCase().trim() === "error";
    });
    registerDiagram("---", // --- diagram type may appear if YAML front-matter is not parsed correctly
    {
        db: {
            clear: ()=>{}
        },
        styles: {},
        // should never be used
        renderer: {
            draw: ()=>{}
        },
        parser: {
            parser: {
                yy: {}
            },
            parse: ()=>{
                throw new Error("Diagrams beginning with --- are not valid. If you were trying to use a YAML front-matter, please ensure that you've correctly opened and closed the YAML front-matter with un-indented `---` blocks");
            }
        },
        init: ()=>null
    }, (text)=>{
        return text.toLowerCase().trimStart().startsWith("---");
    });
    registerLazyLoadedDiagrams(c4, classDiagramV2, classDiagram, er, gantt, info, pie, requirement, sequence, flowchartElk, flowchartV2, flowchart, mindmap, timeline, git, stateV2, state, journey, quadrantChart, sankey, xychart, block);
};
class Diagram {
    constructor(text, metadata = {}){
        this.text = text;
        this.metadata = metadata;
        this.type = "graph";
        this.text = encodeEntities(text);
        this.text += "\n";
        const cnf = getConfig$1();
        try {
            this.type = detectType(text, cnf);
        } catch (e) {
            this.type = "error";
            this.detectError = e;
        }
        const diagram2 = getDiagram(this.type);
        log$1.debug("Type " + this.type);
        this.db = diagram2.db;
        this.renderer = diagram2.renderer;
        this.parser = diagram2.parser;
        this.parser.parser.yy = this.db;
        this.init = diagram2.init;
        this.parse();
    }
    parse() {
        var _a, _b, _c, _d, _e;
        if (this.detectError) throw this.detectError;
        (_b = (_a = this.db).clear) == null || _b.call(_a);
        const config2 = getConfig$1();
        (_c = this.init) == null || _c.call(this, config2);
        if (this.metadata.title) (_e = (_d = this.db).setDiagramTitle) == null || _e.call(_d, this.metadata.title);
        this.parser.parse(this.text);
    }
    async render(id2, version2) {
        await this.renderer.draw(this.text, id2, version2, this);
    }
    getParser() {
        return this.parser;
    }
    getType() {
        return this.type;
    }
}
const getDiagramFromText$1 = async (text, metadata = {})=>{
    const type2 = detectType(text, getConfig$1());
    try {
        getDiagram(type2);
    } catch (error) {
        const loader2 = getDiagramLoader(type2);
        if (!loader2) throw new UnknownDiagramError(`Diagram ${type2} not found.`);
        const { id: id2, diagram: diagram2 } = await loader2();
        registerDiagram(id2, diagram2);
    }
    return new Diagram(text, metadata);
};
let interactionFunctions = [];
const attachFunctions = ()=>{
    interactionFunctions.forEach((f)=>{
        f();
    });
    interactionFunctions = [];
};
const SVG_ROLE = "graphics-document document";
function setA11yDiagramInfo(svg, diagramType) {
    svg.attr("role", SVG_ROLE);
    if (diagramType !== "") svg.attr("aria-roledescription", diagramType);
}
function addSVGa11yTitleDescription(svg, a11yTitle, a11yDesc, baseId) {
    if (svg.insert === void 0) return;
    if (a11yDesc) {
        const descId = `chart-desc-${baseId}`;
        svg.attr("aria-describedby", descId);
        svg.insert("desc", ":first-child").attr("id", descId).text(a11yDesc);
    }
    if (a11yTitle) {
        const titleId = `chart-title-${baseId}`;
        svg.attr("aria-labelledby", titleId);
        svg.insert("title", ":first-child").attr("id", titleId).text(a11yTitle);
    }
}
const cleanupComments = (text)=>{
    return text.replace(/^\s*%%(?!{)[^\n]+\n?/gm, "").trimStart();
};
/*! js-yaml 4.1.0 https://github.com/nodeca/js-yaml @license MIT */ function isNothing(subject) {
    return typeof subject === "undefined" || subject === null;
}
function isObject(subject) {
    return typeof subject === "object" && subject !== null;
}
function toArray(sequence2) {
    if (Array.isArray(sequence2)) return sequence2;
    else if (isNothing(sequence2)) return [];
    return [
        sequence2
    ];
}
function extend(target, source) {
    var index, length, key, sourceKeys;
    if (source) {
        sourceKeys = Object.keys(source);
        for(index = 0, length = sourceKeys.length; index < length; index += 1){
            key = sourceKeys[index];
            target[key] = source[key];
        }
    }
    return target;
}
function repeat(string, count) {
    var result = "", cycle;
    for(cycle = 0; cycle < count; cycle += 1)result += string;
    return result;
}
function isNegativeZero(number) {
    return number === 0 && Number.NEGATIVE_INFINITY === 1 / number;
}
var isNothing_1 = isNothing;
var isObject_1 = isObject;
var toArray_1 = toArray;
var repeat_1 = repeat;
var isNegativeZero_1 = isNegativeZero;
var extend_1 = extend;
var common = {
    isNothing: isNothing_1,
    isObject: isObject_1,
    toArray: toArray_1,
    repeat: repeat_1,
    isNegativeZero: isNegativeZero_1,
    extend: extend_1
};
function formatError(exception2, compact) {
    var where = "", message = exception2.reason || "(unknown reason)";
    if (!exception2.mark) return message;
    if (exception2.mark.name) where += 'in "' + exception2.mark.name + '" ';
    where += "(" + (exception2.mark.line + 1) + ":" + (exception2.mark.column + 1) + ")";
    if (!compact && exception2.mark.snippet) where += "\n\n" + exception2.mark.snippet;
    return message + " " + where;
}
function YAMLException$1(reason, mark) {
    Error.call(this);
    this.name = "YAMLException";
    this.reason = reason;
    this.mark = mark;
    this.message = formatError(this, false);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack || "";
}
YAMLException$1.prototype = Object.create(Error.prototype);
YAMLException$1.prototype.constructor = YAMLException$1;
YAMLException$1.prototype.toString = function toString(compact) {
    return this.name + ": " + formatError(this, compact);
};
var exception = YAMLException$1;
function getLine(buffer, lineStart, lineEnd, position, maxLineLength) {
    var head = "";
    var tail = "";
    var maxHalfLength = Math.floor(maxLineLength / 2) - 1;
    if (position - lineStart > maxHalfLength) {
        head = " ... ";
        lineStart = position - maxHalfLength + head.length;
    }
    if (lineEnd - position > maxHalfLength) {
        tail = " ...";
        lineEnd = position + maxHalfLength - tail.length;
    }
    return {
        str: head + buffer.slice(lineStart, lineEnd).replace(/\t/g, "\u2192") + tail,
        pos: position - lineStart + head.length
    };
}
function padStart(string, max) {
    return common.repeat(" ", max - string.length) + string;
}
function makeSnippet(mark, options) {
    options = Object.create(options || null);
    if (!mark.buffer) return null;
    if (!options.maxLength) options.maxLength = 79;
    if (typeof options.indent !== "number") options.indent = 1;
    if (typeof options.linesBefore !== "number") options.linesBefore = 3;
    if (typeof options.linesAfter !== "number") options.linesAfter = 2;
    var re = /\r?\n|\r|\0/g;
    var lineStarts = [
        0
    ];
    var lineEnds = [];
    var match;
    var foundLineNo = -1;
    while(match = re.exec(mark.buffer)){
        lineEnds.push(match.index);
        lineStarts.push(match.index + match[0].length);
        if (mark.position <= match.index && foundLineNo < 0) foundLineNo = lineStarts.length - 2;
    }
    if (foundLineNo < 0) foundLineNo = lineStarts.length - 1;
    var result = "", i, line;
    var lineNoLength = Math.min(mark.line + options.linesAfter, lineEnds.length).toString().length;
    var maxLineLength = options.maxLength - (options.indent + lineNoLength + 3);
    for(i = 1; i <= options.linesBefore; i++){
        if (foundLineNo - i < 0) break;
        line = getLine(mark.buffer, lineStarts[foundLineNo - i], lineEnds[foundLineNo - i], mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo - i]), maxLineLength);
        result = common.repeat(" ", options.indent) + padStart((mark.line - i + 1).toString(), lineNoLength) + " | " + line.str + "\n" + result;
    }
    line = getLine(mark.buffer, lineStarts[foundLineNo], lineEnds[foundLineNo], mark.position, maxLineLength);
    result += common.repeat(" ", options.indent) + padStart((mark.line + 1).toString(), lineNoLength) + " | " + line.str + "\n";
    result += common.repeat("-", options.indent + lineNoLength + 3 + line.pos) + "^\n";
    for(i = 1; i <= options.linesAfter; i++){
        if (foundLineNo + i >= lineEnds.length) break;
        line = getLine(mark.buffer, lineStarts[foundLineNo + i], lineEnds[foundLineNo + i], mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo + i]), maxLineLength);
        result += common.repeat(" ", options.indent) + padStart((mark.line + i + 1).toString(), lineNoLength) + " | " + line.str + "\n";
    }
    return result.replace(/\n$/, "");
}
var snippet = makeSnippet;
var TYPE_CONSTRUCTOR_OPTIONS = [
    "kind",
    "multi",
    "resolve",
    "construct",
    "instanceOf",
    "predicate",
    "represent",
    "representName",
    "defaultStyle",
    "styleAliases"
];
var YAML_NODE_KINDS = [
    "scalar",
    "sequence",
    "mapping"
];
function compileStyleAliases(map2) {
    var result = {};
    if (map2 !== null) Object.keys(map2).forEach(function(style) {
        map2[style].forEach(function(alias) {
            result[String(alias)] = style;
        });
    });
    return result;
}
function Type$1(tag, options) {
    options = options || {};
    Object.keys(options).forEach(function(name) {
        if (TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) throw new exception('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
    });
    this.options = options;
    this.tag = tag;
    this.kind = options["kind"] || null;
    this.resolve = options["resolve"] || function() {
        return true;
    };
    this.construct = options["construct"] || function(data) {
        return data;
    };
    this.instanceOf = options["instanceOf"] || null;
    this.predicate = options["predicate"] || null;
    this.represent = options["represent"] || null;
    this.representName = options["representName"] || null;
    this.defaultStyle = options["defaultStyle"] || null;
    this.multi = options["multi"] || false;
    this.styleAliases = compileStyleAliases(options["styleAliases"] || null);
    if (YAML_NODE_KINDS.indexOf(this.kind) === -1) throw new exception('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
}
var type = Type$1;
function compileList(schema2, name) {
    var result = [];
    schema2[name].forEach(function(currentType) {
        var newIndex = result.length;
        result.forEach(function(previousType, previousIndex) {
            if (previousType.tag === currentType.tag && previousType.kind === currentType.kind && previousType.multi === currentType.multi) newIndex = previousIndex;
        });
        result[newIndex] = currentType;
    });
    return result;
}
function compileMap() {
    var result = {
        scalar: {},
        sequence: {},
        mapping: {},
        fallback: {},
        multi: {
            scalar: [],
            sequence: [],
            mapping: [],
            fallback: []
        }
    }, index, length;
    function collectType(type2) {
        if (type2.multi) {
            result.multi[type2.kind].push(type2);
            result.multi["fallback"].push(type2);
        } else result[type2.kind][type2.tag] = result["fallback"][type2.tag] = type2;
    }
    for(index = 0, length = arguments.length; index < length; index += 1)arguments[index].forEach(collectType);
    return result;
}
function Schema$1(definition) {
    return this.extend(definition);
}
Schema$1.prototype.extend = function extend2(definition) {
    var implicit = [];
    var explicit = [];
    if (definition instanceof type) explicit.push(definition);
    else if (Array.isArray(definition)) explicit = explicit.concat(definition);
    else if (definition && (Array.isArray(definition.implicit) || Array.isArray(definition.explicit))) {
        if (definition.implicit) implicit = implicit.concat(definition.implicit);
        if (definition.explicit) explicit = explicit.concat(definition.explicit);
    } else throw new exception("Schema.extend argument should be a Type, [ Type ], or a schema definition ({ implicit: [...], explicit: [...] })");
    implicit.forEach(function(type$1) {
        if (!(type$1 instanceof type)) throw new exception("Specified list of YAML types (or a single Type object) contains a non-Type object.");
        if (type$1.loadKind && type$1.loadKind !== "scalar") throw new exception("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
        if (type$1.multi) throw new exception("There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.");
    });
    explicit.forEach(function(type$1) {
        if (!(type$1 instanceof type)) throw new exception("Specified list of YAML types (or a single Type object) contains a non-Type object.");
    });
    var result = Object.create(Schema$1.prototype);
    result.implicit = (this.implicit || []).concat(implicit);
    result.explicit = (this.explicit || []).concat(explicit);
    result.compiledImplicit = compileList(result, "implicit");
    result.compiledExplicit = compileList(result, "explicit");
    result.compiledTypeMap = compileMap(result.compiledImplicit, result.compiledExplicit);
    return result;
};
var schema = Schema$1;
var str = new type("tag:yaml.org,2002:str", {
    kind: "scalar",
    construct: function(data) {
        return data !== null ? data : "";
    }
});
var seq = new type("tag:yaml.org,2002:seq", {
    kind: "sequence",
    construct: function(data) {
        return data !== null ? data : [];
    }
});
var map = new type("tag:yaml.org,2002:map", {
    kind: "mapping",
    construct: function(data) {
        return data !== null ? data : {};
    }
});
var failsafe = new schema({
    explicit: [
        str,
        seq,
        map
    ]
});
function resolveYamlNull(data) {
    if (data === null) return true;
    var max = data.length;
    return max === 1 && data === "~" || max === 4 && (data === "null" || data === "Null" || data === "NULL");
}
function constructYamlNull() {
    return null;
}
function isNull(object) {
    return object === null;
}
var _null = new type("tag:yaml.org,2002:null", {
    kind: "scalar",
    resolve: resolveYamlNull,
    construct: constructYamlNull,
    predicate: isNull,
    represent: {
        canonical: function() {
            return "~";
        },
        lowercase: function() {
            return "null";
        },
        uppercase: function() {
            return "NULL";
        },
        camelcase: function() {
            return "Null";
        },
        empty: function() {
            return "";
        }
    },
    defaultStyle: "lowercase"
});
function resolveYamlBoolean(data) {
    if (data === null) return false;
    var max = data.length;
    return max === 4 && (data === "true" || data === "True" || data === "TRUE") || max === 5 && (data === "false" || data === "False" || data === "FALSE");
}
function constructYamlBoolean(data) {
    return data === "true" || data === "True" || data === "TRUE";
}
function isBoolean(object) {
    return Object.prototype.toString.call(object) === "[object Boolean]";
}
var bool = new type("tag:yaml.org,2002:bool", {
    kind: "scalar",
    resolve: resolveYamlBoolean,
    construct: constructYamlBoolean,
    predicate: isBoolean,
    represent: {
        lowercase: function(object) {
            return object ? "true" : "false";
        },
        uppercase: function(object) {
            return object ? "TRUE" : "FALSE";
        },
        camelcase: function(object) {
            return object ? "True" : "False";
        }
    },
    defaultStyle: "lowercase"
});
function isHexCode(c) {
    return 48 <= c && c <= 57 || 65 <= c && c <= 70 || 97 <= c && c <= 102;
}
function isOctCode(c) {
    return 48 <= c && c <= 55;
}
function isDecCode(c) {
    return 48 <= c && c <= 57;
}
function resolveYamlInteger(data) {
    if (data === null) return false;
    var max = data.length, index = 0, hasDigits = false, ch;
    if (!max) return false;
    ch = data[index];
    if (ch === "-" || ch === "+") ch = data[++index];
    if (ch === "0") {
        if (index + 1 === max) return true;
        ch = data[++index];
        if (ch === "b") {
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === "_") continue;
                if (ch !== "0" && ch !== "1") return false;
                hasDigits = true;
            }
            return hasDigits && ch !== "_";
        }
        if (ch === "x") {
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === "_") continue;
                if (!isHexCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== "_";
        }
        if (ch === "o") {
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === "_") continue;
                if (!isOctCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== "_";
        }
    }
    if (ch === "_") return false;
    for(; index < max; index++){
        ch = data[index];
        if (ch === "_") continue;
        if (!isDecCode(data.charCodeAt(index))) return false;
        hasDigits = true;
    }
    if (!hasDigits || ch === "_") return false;
    return true;
}
function constructYamlInteger(data) {
    var value = data, sign = 1, ch;
    if (value.indexOf("_") !== -1) value = value.replace(/_/g, "");
    ch = value[0];
    if (ch === "-" || ch === "+") {
        if (ch === "-") sign = -1;
        value = value.slice(1);
        ch = value[0];
    }
    if (value === "0") return 0;
    if (ch === "0") {
        if (value[1] === "b") return sign * parseInt(value.slice(2), 2);
        if (value[1] === "x") return sign * parseInt(value.slice(2), 16);
        if (value[1] === "o") return sign * parseInt(value.slice(2), 8);
    }
    return sign * parseInt(value, 10);
}
function isInteger(object) {
    return Object.prototype.toString.call(object) === "[object Number]" && object % 1 === 0 && !common.isNegativeZero(object);
}
var int = new type("tag:yaml.org,2002:int", {
    kind: "scalar",
    resolve: resolveYamlInteger,
    construct: constructYamlInteger,
    predicate: isInteger,
    represent: {
        binary: function(obj) {
            return obj >= 0 ? "0b" + obj.toString(2) : "-0b" + obj.toString(2).slice(1);
        },
        octal: function(obj) {
            return obj >= 0 ? "0o" + obj.toString(8) : "-0o" + obj.toString(8).slice(1);
        },
        decimal: function(obj) {
            return obj.toString(10);
        },
        /* eslint-disable max-len */ hexadecimal: function(obj) {
            return obj >= 0 ? "0x" + obj.toString(16).toUpperCase() : "-0x" + obj.toString(16).toUpperCase().slice(1);
        }
    },
    defaultStyle: "decimal",
    styleAliases: {
        binary: [
            2,
            "bin"
        ],
        octal: [
            8,
            "oct"
        ],
        decimal: [
            10,
            "dec"
        ],
        hexadecimal: [
            16,
            "hex"
        ]
    }
});
var YAML_FLOAT_PATTERN = new RegExp(// 2.5e4, 2.5 and integers
"^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");
function resolveYamlFloat(data) {
    if (data === null) return false;
    if (!YAML_FLOAT_PATTERN.test(data) || // Quick hack to not allow integers end with `_`
    // Probably should update regexp & check speed
    data[data.length - 1] === "_") return false;
    return true;
}
function constructYamlFloat(data) {
    var value, sign;
    value = data.replace(/_/g, "").toLowerCase();
    sign = value[0] === "-" ? -1 : 1;
    if ("+-".indexOf(value[0]) >= 0) value = value.slice(1);
    if (value === ".inf") return sign === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
    else if (value === ".nan") return NaN;
    return sign * parseFloat(value, 10);
}
var SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;
function representYamlFloat(object, style) {
    var res;
    if (isNaN(object)) switch(style){
        case "lowercase":
            return ".nan";
        case "uppercase":
            return ".NAN";
        case "camelcase":
            return ".NaN";
    }
    else if (Number.POSITIVE_INFINITY === object) switch(style){
        case "lowercase":
            return ".inf";
        case "uppercase":
            return ".INF";
        case "camelcase":
            return ".Inf";
    }
    else if (Number.NEGATIVE_INFINITY === object) switch(style){
        case "lowercase":
            return "-.inf";
        case "uppercase":
            return "-.INF";
        case "camelcase":
            return "-.Inf";
    }
    else if (common.isNegativeZero(object)) return "-0.0";
    res = object.toString(10);
    return SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace("e", ".e") : res;
}
function isFloat(object) {
    return Object.prototype.toString.call(object) === "[object Number]" && (object % 1 !== 0 || common.isNegativeZero(object));
}
var float = new type("tag:yaml.org,2002:float", {
    kind: "scalar",
    resolve: resolveYamlFloat,
    construct: constructYamlFloat,
    predicate: isFloat,
    represent: representYamlFloat,
    defaultStyle: "lowercase"
});
var json = failsafe.extend({
    implicit: [
        _null,
        bool,
        int,
        float
    ]
});
var core = json;
var YAML_DATE_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$");
var YAML_TIMESTAMP_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$");
function resolveYamlTimestamp(data) {
    if (data === null) return false;
    if (YAML_DATE_REGEXP.exec(data) !== null) return true;
    if (YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true;
    return false;
}
function constructYamlTimestamp(data) {
    var match, year, month, day, hour, minute, second, fraction = 0, delta = null, tz_hour, tz_minute, date;
    match = YAML_DATE_REGEXP.exec(data);
    if (match === null) match = YAML_TIMESTAMP_REGEXP.exec(data);
    if (match === null) throw new Error("Date resolve error");
    year = +match[1];
    month = +match[2] - 1;
    day = +match[3];
    if (!match[4]) return new Date(Date.UTC(year, month, day));
    hour = +match[4];
    minute = +match[5];
    second = +match[6];
    if (match[7]) {
        fraction = match[7].slice(0, 3);
        while(fraction.length < 3)fraction += "0";
        fraction = +fraction;
    }
    if (match[9]) {
        tz_hour = +match[10];
        tz_minute = +(match[11] || 0);
        delta = (tz_hour * 60 + tz_minute) * 6e4;
        if (match[9] === "-") delta = -delta;
    }
    date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));
    if (delta) date.setTime(date.getTime() - delta);
    return date;
}
function representYamlTimestamp(object) {
    return object.toISOString();
}
var timestamp = new type("tag:yaml.org,2002:timestamp", {
    kind: "scalar",
    resolve: resolveYamlTimestamp,
    construct: constructYamlTimestamp,
    instanceOf: Date,
    represent: representYamlTimestamp
});
function resolveYamlMerge(data) {
    return data === "<<" || data === null;
}
var merge = new type("tag:yaml.org,2002:merge", {
    kind: "scalar",
    resolve: resolveYamlMerge
});
var BASE64_MAP = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r";
function resolveYamlBinary(data) {
    if (data === null) return false;
    var code, idx, bitlen = 0, max = data.length, map2 = BASE64_MAP;
    for(idx = 0; idx < max; idx++){
        code = map2.indexOf(data.charAt(idx));
        if (code > 64) continue;
        if (code < 0) return false;
        bitlen += 6;
    }
    return bitlen % 8 === 0;
}
function constructYamlBinary(data) {
    var idx, tailbits, input = data.replace(/[\r\n=]/g, ""), max = input.length, map2 = BASE64_MAP, bits = 0, result = [];
    for(idx = 0; idx < max; idx++){
        if (idx % 4 === 0 && idx) {
            result.push(bits >> 16 & 255);
            result.push(bits >> 8 & 255);
            result.push(bits & 255);
        }
        bits = bits << 6 | map2.indexOf(input.charAt(idx));
    }
    tailbits = max % 4 * 6;
    if (tailbits === 0) {
        result.push(bits >> 16 & 255);
        result.push(bits >> 8 & 255);
        result.push(bits & 255);
    } else if (tailbits === 18) {
        result.push(bits >> 10 & 255);
        result.push(bits >> 2 & 255);
    } else if (tailbits === 12) result.push(bits >> 4 & 255);
    return new Uint8Array(result);
}
function representYamlBinary(object) {
    var result = "", bits = 0, idx, tail, max = object.length, map2 = BASE64_MAP;
    for(idx = 0; idx < max; idx++){
        if (idx % 3 === 0 && idx) {
            result += map2[bits >> 18 & 63];
            result += map2[bits >> 12 & 63];
            result += map2[bits >> 6 & 63];
            result += map2[bits & 63];
        }
        bits = (bits << 8) + object[idx];
    }
    tail = max % 3;
    if (tail === 0) {
        result += map2[bits >> 18 & 63];
        result += map2[bits >> 12 & 63];
        result += map2[bits >> 6 & 63];
        result += map2[bits & 63];
    } else if (tail === 2) {
        result += map2[bits >> 10 & 63];
        result += map2[bits >> 4 & 63];
        result += map2[bits << 2 & 63];
        result += map2[64];
    } else if (tail === 1) {
        result += map2[bits >> 2 & 63];
        result += map2[bits << 4 & 63];
        result += map2[64];
        result += map2[64];
    }
    return result;
}
function isBinary(obj) {
    return Object.prototype.toString.call(obj) === "[object Uint8Array]";
}
var binary = new type("tag:yaml.org,2002:binary", {
    kind: "scalar",
    resolve: resolveYamlBinary,
    construct: constructYamlBinary,
    predicate: isBinary,
    represent: representYamlBinary
});
var _hasOwnProperty$3 = Object.prototype.hasOwnProperty;
var _toString$2 = Object.prototype.toString;
function resolveYamlOmap(data) {
    if (data === null) return true;
    var objectKeys = [], index, length, pair, pairKey, pairHasKey, object = data;
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        pairHasKey = false;
        if (_toString$2.call(pair) !== "[object Object]") return false;
        for(pairKey in pair)if (_hasOwnProperty$3.call(pair, pairKey)) {
            if (!pairHasKey) pairHasKey = true;
            else return false;
        }
        if (!pairHasKey) return false;
        if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey);
        else return false;
    }
    return true;
}
function constructYamlOmap(data) {
    return data !== null ? data : [];
}
var omap = new type("tag:yaml.org,2002:omap", {
    kind: "sequence",
    resolve: resolveYamlOmap,
    construct: constructYamlOmap
});
var _toString$1 = Object.prototype.toString;
function resolveYamlPairs(data) {
    if (data === null) return true;
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        if (_toString$1.call(pair) !== "[object Object]") return false;
        keys = Object.keys(pair);
        if (keys.length !== 1) return false;
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return true;
}
function constructYamlPairs(data) {
    if (data === null) return [];
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        keys = Object.keys(pair);
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return result;
}
var pairs = new type("tag:yaml.org,2002:pairs", {
    kind: "sequence",
    resolve: resolveYamlPairs,
    construct: constructYamlPairs
});
var _hasOwnProperty$2 = Object.prototype.hasOwnProperty;
function resolveYamlSet(data) {
    if (data === null) return true;
    var key, object = data;
    for(key in object)if (_hasOwnProperty$2.call(object, key)) {
        if (object[key] !== null) return false;
    }
    return true;
}
function constructYamlSet(data) {
    return data !== null ? data : {};
}
var set = new type("tag:yaml.org,2002:set", {
    kind: "mapping",
    resolve: resolveYamlSet,
    construct: constructYamlSet
});
var _default = core.extend({
    implicit: [
        timestamp,
        merge
    ],
    explicit: [
        binary,
        omap,
        pairs,
        set
    ]
});
var _hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var CONTEXT_FLOW_IN = 1;
var CONTEXT_FLOW_OUT = 2;
var CONTEXT_BLOCK_IN = 3;
var CONTEXT_BLOCK_OUT = 4;
var CHOMPING_CLIP = 1;
var CHOMPING_STRIP = 2;
var CHOMPING_KEEP = 3;
var PATTERN_NON_PRINTABLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
var PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
var PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/;
var PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i;
var PATTERN_TAG_URI = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
function _class(obj) {
    return Object.prototype.toString.call(obj);
}
function is_EOL(c) {
    return c === 10 || c === 13;
}
function is_WHITE_SPACE(c) {
    return c === 9 || c === 32;
}
function is_WS_OR_EOL(c) {
    return c === 9 || c === 32 || c === 10 || c === 13;
}
function is_FLOW_INDICATOR(c) {
    return c === 44 || c === 91 || c === 93 || c === 123 || c === 125;
}
function fromHexCode(c) {
    var lc;
    if (48 <= c && c <= 57) return c - 48;
    lc = c | 32;
    if (97 <= lc && lc <= 102) return lc - 97 + 10;
    return -1;
}
function escapedHexLen(c) {
    if (c === 120) return 2;
    if (c === 117) return 4;
    if (c === 85) return 8;
    return 0;
}
function fromDecimalCode(c) {
    if (48 <= c && c <= 57) return c - 48;
    return -1;
}
function simpleEscapeSequence(c) {
    return c === 48 ? "\0" : c === 97 ? "\x07" : c === 98 ? "\b" : c === 116 ? "	" : c === 9 ? "	" : c === 110 ? "\n" : c === 118 ? "\v" : c === 102 ? "\f" : c === 114 ? "\r" : c === 101 ? "\x1B" : c === 32 ? " " : c === 34 ? '"' : c === 47 ? "/" : c === 92 ? "\\" : c === 78 ? "\x85" : c === 95 ? "\xa0" : c === 76 ? "\u2028" : c === 80 ? "\u2029" : "";
}
function charFromCodepoint(c) {
    if (c <= 65535) return String.fromCharCode(c);
    return String.fromCharCode((c - 65536 >> 10) + 55296, (c - 65536 & 1023) + 56320);
}
var simpleEscapeCheck = new Array(256);
var simpleEscapeMap = new Array(256);
for(var i = 0; i < 256; i++){
    simpleEscapeCheck[i] = simpleEscapeSequence(i) ? 1 : 0;
    simpleEscapeMap[i] = simpleEscapeSequence(i);
}
function State$1(input, options) {
    this.input = input;
    this.filename = options["filename"] || null;
    this.schema = options["schema"] || _default;
    this.onWarning = options["onWarning"] || null;
    this.legacy = options["legacy"] || false;
    this.json = options["json"] || false;
    this.listener = options["listener"] || null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.typeMap = this.schema.compiledTypeMap;
    this.length = input.length;
    this.position = 0;
    this.line = 0;
    this.lineStart = 0;
    this.lineIndent = 0;
    this.firstTabInLine = -1;
    this.documents = [];
}
function generateError(state2, message) {
    var mark = {
        name: state2.filename,
        buffer: state2.input.slice(0, -1),
        // omit trailing \0
        position: state2.position,
        line: state2.line,
        column: state2.position - state2.lineStart
    };
    mark.snippet = snippet(mark);
    return new exception(message, mark);
}
function throwError(state2, message) {
    throw generateError(state2, message);
}
function throwWarning(state2, message) {
    if (state2.onWarning) state2.onWarning.call(null, generateError(state2, message));
}
var directiveHandlers = {
    YAML: function handleYamlDirective(state2, name, args) {
        var match, major, minor;
        if (state2.version !== null) throwError(state2, "duplication of %YAML directive");
        if (args.length !== 1) throwError(state2, "YAML directive accepts exactly one argument");
        match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);
        if (match === null) throwError(state2, "ill-formed argument of the YAML directive");
        major = parseInt(match[1], 10);
        minor = parseInt(match[2], 10);
        if (major !== 1) throwError(state2, "unacceptable YAML version of the document");
        state2.version = args[0];
        state2.checkLineBreaks = minor < 2;
        if (minor !== 1 && minor !== 2) throwWarning(state2, "unsupported YAML version of the document");
    },
    TAG: function handleTagDirective(state2, name, args) {
        var handle, prefix;
        if (args.length !== 2) throwError(state2, "TAG directive accepts exactly two arguments");
        handle = args[0];
        prefix = args[1];
        if (!PATTERN_TAG_HANDLE.test(handle)) throwError(state2, "ill-formed tag handle (first argument) of the TAG directive");
        if (_hasOwnProperty$1.call(state2.tagMap, handle)) throwError(state2, 'there is a previously declared suffix for "' + handle + '" tag handle');
        if (!PATTERN_TAG_URI.test(prefix)) throwError(state2, "ill-formed tag prefix (second argument) of the TAG directive");
        try {
            prefix = decodeURIComponent(prefix);
        } catch (err) {
            throwError(state2, "tag prefix is malformed: " + prefix);
        }
        state2.tagMap[handle] = prefix;
    }
};
function captureSegment(state2, start, end, checkJson) {
    var _position, _length, _character, _result;
    if (start < end) {
        _result = state2.input.slice(start, end);
        if (checkJson) for(_position = 0, _length = _result.length; _position < _length; _position += 1){
            _character = _result.charCodeAt(_position);
            if (!(_character === 9 || 32 <= _character && _character <= 1114111)) throwError(state2, "expected valid JSON character");
        }
        else if (PATTERN_NON_PRINTABLE.test(_result)) throwError(state2, "the stream contains non-printable characters");
        state2.result += _result;
    }
}
function mergeMappings(state2, destination, source, overridableKeys) {
    var sourceKeys, key, index, quantity;
    if (!common.isObject(source)) throwError(state2, "cannot merge mappings; the provided source object is unacceptable");
    sourceKeys = Object.keys(source);
    for(index = 0, quantity = sourceKeys.length; index < quantity; index += 1){
        key = sourceKeys[index];
        if (!_hasOwnProperty$1.call(destination, key)) {
            destination[key] = source[key];
            overridableKeys[key] = true;
        }
    }
}
function storeMappingPair(state2, _result, overridableKeys, keyTag, keyNode, valueNode, startLine, startLineStart, startPos) {
    var index, quantity;
    if (Array.isArray(keyNode)) {
        keyNode = Array.prototype.slice.call(keyNode);
        for(index = 0, quantity = keyNode.length; index < quantity; index += 1){
            if (Array.isArray(keyNode[index])) throwError(state2, "nested arrays are not supported inside keys");
            if (typeof keyNode === "object" && _class(keyNode[index]) === "[object Object]") keyNode[index] = "[object Object]";
        }
    }
    if (typeof keyNode === "object" && _class(keyNode) === "[object Object]") keyNode = "[object Object]";
    keyNode = String(keyNode);
    if (_result === null) _result = {};
    if (keyTag === "tag:yaml.org,2002:merge") {
        if (Array.isArray(valueNode)) for(index = 0, quantity = valueNode.length; index < quantity; index += 1)mergeMappings(state2, _result, valueNode[index], overridableKeys);
        else mergeMappings(state2, _result, valueNode, overridableKeys);
    } else {
        if (!state2.json && !_hasOwnProperty$1.call(overridableKeys, keyNode) && _hasOwnProperty$1.call(_result, keyNode)) {
            state2.line = startLine || state2.line;
            state2.lineStart = startLineStart || state2.lineStart;
            state2.position = startPos || state2.position;
            throwError(state2, "duplicated mapping key");
        }
        if (keyNode === "__proto__") Object.defineProperty(_result, keyNode, {
            configurable: true,
            enumerable: true,
            writable: true,
            value: valueNode
        });
        else _result[keyNode] = valueNode;
        delete overridableKeys[keyNode];
    }
    return _result;
}
function readLineBreak(state2) {
    var ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch === 10) state2.position++;
    else if (ch === 13) {
        state2.position++;
        if (state2.input.charCodeAt(state2.position) === 10) state2.position++;
    } else throwError(state2, "a line break is expected");
    state2.line += 1;
    state2.lineStart = state2.position;
    state2.firstTabInLine = -1;
}
function skipSeparationSpace(state2, allowComments, checkIndent) {
    var lineBreaks = 0, ch = state2.input.charCodeAt(state2.position);
    while(ch !== 0){
        while(is_WHITE_SPACE(ch)){
            if (ch === 9 && state2.firstTabInLine === -1) state2.firstTabInLine = state2.position;
            ch = state2.input.charCodeAt(++state2.position);
        }
        if (allowComments && ch === 35) do ch = state2.input.charCodeAt(++state2.position);
        while (ch !== 10 && ch !== 13 && ch !== 0);
        if (is_EOL(ch)) {
            readLineBreak(state2);
            ch = state2.input.charCodeAt(state2.position);
            lineBreaks++;
            state2.lineIndent = 0;
            while(ch === 32){
                state2.lineIndent++;
                ch = state2.input.charCodeAt(++state2.position);
            }
        } else break;
    }
    if (checkIndent !== -1 && lineBreaks !== 0 && state2.lineIndent < checkIndent) throwWarning(state2, "deficient indentation");
    return lineBreaks;
}
function testDocumentSeparator(state2) {
    var _position = state2.position, ch;
    ch = state2.input.charCodeAt(_position);
    if ((ch === 45 || ch === 46) && ch === state2.input.charCodeAt(_position + 1) && ch === state2.input.charCodeAt(_position + 2)) {
        _position += 3;
        ch = state2.input.charCodeAt(_position);
        if (ch === 0 || is_WS_OR_EOL(ch)) return true;
    }
    return false;
}
function writeFoldedLines(state2, count) {
    if (count === 1) state2.result += " ";
    else if (count > 1) state2.result += common.repeat("\n", count - 1);
}
function readPlainScalar(state2, nodeIndent, withinFlowCollection) {
    var preceding, following, captureStart, captureEnd, hasPendingContent, _line, _lineStart, _lineIndent, _kind = state2.kind, _result = state2.result, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (is_WS_OR_EOL(ch) || is_FLOW_INDICATOR(ch) || ch === 35 || ch === 38 || ch === 42 || ch === 33 || ch === 124 || ch === 62 || ch === 39 || ch === 34 || ch === 37 || ch === 64 || ch === 96) return false;
    if (ch === 63 || ch === 45) {
        following = state2.input.charCodeAt(state2.position + 1);
        if (is_WS_OR_EOL(following) || withinFlowCollection && is_FLOW_INDICATOR(following)) return false;
    }
    state2.kind = "scalar";
    state2.result = "";
    captureStart = captureEnd = state2.position;
    hasPendingContent = false;
    while(ch !== 0){
        if (ch === 58) {
            following = state2.input.charCodeAt(state2.position + 1);
            if (is_WS_OR_EOL(following) || withinFlowCollection && is_FLOW_INDICATOR(following)) break;
        } else if (ch === 35) {
            preceding = state2.input.charCodeAt(state2.position - 1);
            if (is_WS_OR_EOL(preceding)) break;
        } else if (state2.position === state2.lineStart && testDocumentSeparator(state2) || withinFlowCollection && is_FLOW_INDICATOR(ch)) break;
        else if (is_EOL(ch)) {
            _line = state2.line;
            _lineStart = state2.lineStart;
            _lineIndent = state2.lineIndent;
            skipSeparationSpace(state2, false, -1);
            if (state2.lineIndent >= nodeIndent) {
                hasPendingContent = true;
                ch = state2.input.charCodeAt(state2.position);
                continue;
            } else {
                state2.position = captureEnd;
                state2.line = _line;
                state2.lineStart = _lineStart;
                state2.lineIndent = _lineIndent;
                break;
            }
        }
        if (hasPendingContent) {
            captureSegment(state2, captureStart, captureEnd, false);
            writeFoldedLines(state2, state2.line - _line);
            captureStart = captureEnd = state2.position;
            hasPendingContent = false;
        }
        if (!is_WHITE_SPACE(ch)) captureEnd = state2.position + 1;
        ch = state2.input.charCodeAt(++state2.position);
    }
    captureSegment(state2, captureStart, captureEnd, false);
    if (state2.result) return true;
    state2.kind = _kind;
    state2.result = _result;
    return false;
}
function readSingleQuotedScalar(state2, nodeIndent) {
    var ch, captureStart, captureEnd;
    ch = state2.input.charCodeAt(state2.position);
    if (ch !== 39) return false;
    state2.kind = "scalar";
    state2.result = "";
    state2.position++;
    captureStart = captureEnd = state2.position;
    while((ch = state2.input.charCodeAt(state2.position)) !== 0){
        if (ch === 39) {
            captureSegment(state2, captureStart, state2.position, true);
            ch = state2.input.charCodeAt(++state2.position);
            if (ch === 39) {
                captureStart = state2.position;
                state2.position++;
                captureEnd = state2.position;
            } else return true;
        } else if (is_EOL(ch)) {
            captureSegment(state2, captureStart, captureEnd, true);
            writeFoldedLines(state2, skipSeparationSpace(state2, false, nodeIndent));
            captureStart = captureEnd = state2.position;
        } else if (state2.position === state2.lineStart && testDocumentSeparator(state2)) throwError(state2, "unexpected end of the document within a single quoted scalar");
        else {
            state2.position++;
            captureEnd = state2.position;
        }
    }
    throwError(state2, "unexpected end of the stream within a single quoted scalar");
}
function readDoubleQuotedScalar(state2, nodeIndent) {
    var captureStart, captureEnd, hexLength, hexResult, tmp, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch !== 34) return false;
    state2.kind = "scalar";
    state2.result = "";
    state2.position++;
    captureStart = captureEnd = state2.position;
    while((ch = state2.input.charCodeAt(state2.position)) !== 0){
        if (ch === 34) {
            captureSegment(state2, captureStart, state2.position, true);
            state2.position++;
            return true;
        } else if (ch === 92) {
            captureSegment(state2, captureStart, state2.position, true);
            ch = state2.input.charCodeAt(++state2.position);
            if (is_EOL(ch)) skipSeparationSpace(state2, false, nodeIndent);
            else if (ch < 256 && simpleEscapeCheck[ch]) {
                state2.result += simpleEscapeMap[ch];
                state2.position++;
            } else if ((tmp = escapedHexLen(ch)) > 0) {
                hexLength = tmp;
                hexResult = 0;
                for(; hexLength > 0; hexLength--){
                    ch = state2.input.charCodeAt(++state2.position);
                    if ((tmp = fromHexCode(ch)) >= 0) hexResult = (hexResult << 4) + tmp;
                    else throwError(state2, "expected hexadecimal character");
                }
                state2.result += charFromCodepoint(hexResult);
                state2.position++;
            } else throwError(state2, "unknown escape sequence");
            captureStart = captureEnd = state2.position;
        } else if (is_EOL(ch)) {
            captureSegment(state2, captureStart, captureEnd, true);
            writeFoldedLines(state2, skipSeparationSpace(state2, false, nodeIndent));
            captureStart = captureEnd = state2.position;
        } else if (state2.position === state2.lineStart && testDocumentSeparator(state2)) throwError(state2, "unexpected end of the document within a double quoted scalar");
        else {
            state2.position++;
            captureEnd = state2.position;
        }
    }
    throwError(state2, "unexpected end of the stream within a double quoted scalar");
}
function readFlowCollection(state2, nodeIndent) {
    var readNext = true, _line, _lineStart, _pos, _tag = state2.tag, _result, _anchor = state2.anchor, following, terminator, isPair, isExplicitPair, isMapping, overridableKeys = /* @__PURE__ */ Object.create(null), keyNode, keyTag, valueNode, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch === 91) {
        terminator = 93;
        isMapping = false;
        _result = [];
    } else if (ch === 123) {
        terminator = 125;
        isMapping = true;
        _result = {};
    } else return false;
    if (state2.anchor !== null) state2.anchorMap[state2.anchor] = _result;
    ch = state2.input.charCodeAt(++state2.position);
    while(ch !== 0){
        skipSeparationSpace(state2, true, nodeIndent);
        ch = state2.input.charCodeAt(state2.position);
        if (ch === terminator) {
            state2.position++;
            state2.tag = _tag;
            state2.anchor = _anchor;
            state2.kind = isMapping ? "mapping" : "sequence";
            state2.result = _result;
            return true;
        } else if (!readNext) throwError(state2, "missed comma between flow collection entries");
        else if (ch === 44) throwError(state2, "expected the node content, but found ','");
        keyTag = keyNode = valueNode = null;
        isPair = isExplicitPair = false;
        if (ch === 63) {
            following = state2.input.charCodeAt(state2.position + 1);
            if (is_WS_OR_EOL(following)) {
                isPair = isExplicitPair = true;
                state2.position++;
                skipSeparationSpace(state2, true, nodeIndent);
            }
        }
        _line = state2.line;
        _lineStart = state2.lineStart;
        _pos = state2.position;
        composeNode(state2, nodeIndent, CONTEXT_FLOW_IN, false, true);
        keyTag = state2.tag;
        keyNode = state2.result;
        skipSeparationSpace(state2, true, nodeIndent);
        ch = state2.input.charCodeAt(state2.position);
        if ((isExplicitPair || state2.line === _line) && ch === 58) {
            isPair = true;
            ch = state2.input.charCodeAt(++state2.position);
            skipSeparationSpace(state2, true, nodeIndent);
            composeNode(state2, nodeIndent, CONTEXT_FLOW_IN, false, true);
            valueNode = state2.result;
        }
        if (isMapping) storeMappingPair(state2, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos);
        else if (isPair) _result.push(storeMappingPair(state2, null, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos));
        else _result.push(keyNode);
        skipSeparationSpace(state2, true, nodeIndent);
        ch = state2.input.charCodeAt(state2.position);
        if (ch === 44) {
            readNext = true;
            ch = state2.input.charCodeAt(++state2.position);
        } else readNext = false;
    }
    throwError(state2, "unexpected end of the stream within a flow collection");
}
function readBlockScalar(state2, nodeIndent) {
    var captureStart, folding, chomping = CHOMPING_CLIP, didReadContent = false, detectedIndent = false, textIndent = nodeIndent, emptyLines = 0, atMoreIndented = false, tmp, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch === 124) folding = false;
    else if (ch === 62) folding = true;
    else return false;
    state2.kind = "scalar";
    state2.result = "";
    while(ch !== 0){
        ch = state2.input.charCodeAt(++state2.position);
        if (ch === 43 || ch === 45) {
            if (CHOMPING_CLIP === chomping) chomping = ch === 43 ? CHOMPING_KEEP : CHOMPING_STRIP;
            else throwError(state2, "repeat of a chomping mode identifier");
        } else if ((tmp = fromDecimalCode(ch)) >= 0) {
            if (tmp === 0) throwError(state2, "bad explicit indentation width of a block scalar; it cannot be less than one");
            else if (!detectedIndent) {
                textIndent = nodeIndent + tmp - 1;
                detectedIndent = true;
            } else throwError(state2, "repeat of an indentation width identifier");
        } else break;
    }
    if (is_WHITE_SPACE(ch)) {
        do ch = state2.input.charCodeAt(++state2.position);
        while (is_WHITE_SPACE(ch));
        if (ch === 35) do ch = state2.input.charCodeAt(++state2.position);
        while (!is_EOL(ch) && ch !== 0);
    }
    while(ch !== 0){
        readLineBreak(state2);
        state2.lineIndent = 0;
        ch = state2.input.charCodeAt(state2.position);
        while((!detectedIndent || state2.lineIndent < textIndent) && ch === 32){
            state2.lineIndent++;
            ch = state2.input.charCodeAt(++state2.position);
        }
        if (!detectedIndent && state2.lineIndent > textIndent) textIndent = state2.lineIndent;
        if (is_EOL(ch)) {
            emptyLines++;
            continue;
        }
        if (state2.lineIndent < textIndent) {
            if (chomping === CHOMPING_KEEP) state2.result += common.repeat("\n", didReadContent ? 1 + emptyLines : emptyLines);
            else if (chomping === CHOMPING_CLIP) {
                if (didReadContent) state2.result += "\n";
            }
            break;
        }
        if (folding) {
            if (is_WHITE_SPACE(ch)) {
                atMoreIndented = true;
                state2.result += common.repeat("\n", didReadContent ? 1 + emptyLines : emptyLines);
            } else if (atMoreIndented) {
                atMoreIndented = false;
                state2.result += common.repeat("\n", emptyLines + 1);
            } else if (emptyLines === 0) {
                if (didReadContent) state2.result += " ";
            } else state2.result += common.repeat("\n", emptyLines);
        } else state2.result += common.repeat("\n", didReadContent ? 1 + emptyLines : emptyLines);
        didReadContent = true;
        detectedIndent = true;
        emptyLines = 0;
        captureStart = state2.position;
        while(!is_EOL(ch) && ch !== 0)ch = state2.input.charCodeAt(++state2.position);
        captureSegment(state2, captureStart, state2.position, false);
    }
    return true;
}
function readBlockSequence(state2, nodeIndent) {
    var _line, _tag = state2.tag, _anchor = state2.anchor, _result = [], following, detected = false, ch;
    if (state2.firstTabInLine !== -1) return false;
    if (state2.anchor !== null) state2.anchorMap[state2.anchor] = _result;
    ch = state2.input.charCodeAt(state2.position);
    while(ch !== 0){
        if (state2.firstTabInLine !== -1) {
            state2.position = state2.firstTabInLine;
            throwError(state2, "tab characters must not be used in indentation");
        }
        if (ch !== 45) break;
        following = state2.input.charCodeAt(state2.position + 1);
        if (!is_WS_OR_EOL(following)) break;
        detected = true;
        state2.position++;
        if (skipSeparationSpace(state2, true, -1)) {
            if (state2.lineIndent <= nodeIndent) {
                _result.push(null);
                ch = state2.input.charCodeAt(state2.position);
                continue;
            }
        }
        _line = state2.line;
        composeNode(state2, nodeIndent, CONTEXT_BLOCK_IN, false, true);
        _result.push(state2.result);
        skipSeparationSpace(state2, true, -1);
        ch = state2.input.charCodeAt(state2.position);
        if ((state2.line === _line || state2.lineIndent > nodeIndent) && ch !== 0) throwError(state2, "bad indentation of a sequence entry");
        else if (state2.lineIndent < nodeIndent) break;
    }
    if (detected) {
        state2.tag = _tag;
        state2.anchor = _anchor;
        state2.kind = "sequence";
        state2.result = _result;
        return true;
    }
    return false;
}
function readBlockMapping(state2, nodeIndent, flowIndent) {
    var following, allowCompact, _line, _keyLine, _keyLineStart, _keyPos, _tag = state2.tag, _anchor = state2.anchor, _result = {}, overridableKeys = /* @__PURE__ */ Object.create(null), keyTag = null, keyNode = null, valueNode = null, atExplicitKey = false, detected = false, ch;
    if (state2.firstTabInLine !== -1) return false;
    if (state2.anchor !== null) state2.anchorMap[state2.anchor] = _result;
    ch = state2.input.charCodeAt(state2.position);
    while(ch !== 0){
        if (!atExplicitKey && state2.firstTabInLine !== -1) {
            state2.position = state2.firstTabInLine;
            throwError(state2, "tab characters must not be used in indentation");
        }
        following = state2.input.charCodeAt(state2.position + 1);
        _line = state2.line;
        if ((ch === 63 || ch === 58) && is_WS_OR_EOL(following)) {
            if (ch === 63) {
                if (atExplicitKey) {
                    storeMappingPair(state2, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
                    keyTag = keyNode = valueNode = null;
                }
                detected = true;
                atExplicitKey = true;
                allowCompact = true;
            } else if (atExplicitKey) {
                atExplicitKey = false;
                allowCompact = true;
            } else throwError(state2, "incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line");
            state2.position += 1;
            ch = following;
        } else {
            _keyLine = state2.line;
            _keyLineStart = state2.lineStart;
            _keyPos = state2.position;
            if (!composeNode(state2, flowIndent, CONTEXT_FLOW_OUT, false, true)) break;
            if (state2.line === _line) {
                ch = state2.input.charCodeAt(state2.position);
                while(is_WHITE_SPACE(ch))ch = state2.input.charCodeAt(++state2.position);
                if (ch === 58) {
                    ch = state2.input.charCodeAt(++state2.position);
                    if (!is_WS_OR_EOL(ch)) throwError(state2, "a whitespace character is expected after the key-value separator within a block mapping");
                    if (atExplicitKey) {
                        storeMappingPair(state2, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
                        keyTag = keyNode = valueNode = null;
                    }
                    detected = true;
                    atExplicitKey = false;
                    allowCompact = false;
                    keyTag = state2.tag;
                    keyNode = state2.result;
                } else if (detected) throwError(state2, "can not read an implicit mapping pair; a colon is missed");
                else {
                    state2.tag = _tag;
                    state2.anchor = _anchor;
                    return true;
                }
            } else if (detected) throwError(state2, "can not read a block mapping entry; a multiline key may not be an implicit key");
            else {
                state2.tag = _tag;
                state2.anchor = _anchor;
                return true;
            }
        }
        if (state2.line === _line || state2.lineIndent > nodeIndent) {
            if (atExplicitKey) {
                _keyLine = state2.line;
                _keyLineStart = state2.lineStart;
                _keyPos = state2.position;
            }
            if (composeNode(state2, nodeIndent, CONTEXT_BLOCK_OUT, true, allowCompact)) {
                if (atExplicitKey) keyNode = state2.result;
                else valueNode = state2.result;
            }
            if (!atExplicitKey) {
                storeMappingPair(state2, _result, overridableKeys, keyTag, keyNode, valueNode, _keyLine, _keyLineStart, _keyPos);
                keyTag = keyNode = valueNode = null;
            }
            skipSeparationSpace(state2, true, -1);
            ch = state2.input.charCodeAt(state2.position);
        }
        if ((state2.line === _line || state2.lineIndent > nodeIndent) && ch !== 0) throwError(state2, "bad indentation of a mapping entry");
        else if (state2.lineIndent < nodeIndent) break;
    }
    if (atExplicitKey) storeMappingPair(state2, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
    if (detected) {
        state2.tag = _tag;
        state2.anchor = _anchor;
        state2.kind = "mapping";
        state2.result = _result;
    }
    return detected;
}
function readTagProperty(state2) {
    var _position, isVerbatim = false, isNamed = false, tagHandle, tagName, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch !== 33) return false;
    if (state2.tag !== null) throwError(state2, "duplication of a tag property");
    ch = state2.input.charCodeAt(++state2.position);
    if (ch === 60) {
        isVerbatim = true;
        ch = state2.input.charCodeAt(++state2.position);
    } else if (ch === 33) {
        isNamed = true;
        tagHandle = "!!";
        ch = state2.input.charCodeAt(++state2.position);
    } else tagHandle = "!";
    _position = state2.position;
    if (isVerbatim) {
        do ch = state2.input.charCodeAt(++state2.position);
        while (ch !== 0 && ch !== 62);
        if (state2.position < state2.length) {
            tagName = state2.input.slice(_position, state2.position);
            ch = state2.input.charCodeAt(++state2.position);
        } else throwError(state2, "unexpected end of the stream within a verbatim tag");
    } else {
        while(ch !== 0 && !is_WS_OR_EOL(ch)){
            if (ch === 33) {
                if (!isNamed) {
                    tagHandle = state2.input.slice(_position - 1, state2.position + 1);
                    if (!PATTERN_TAG_HANDLE.test(tagHandle)) throwError(state2, "named tag handle cannot contain such characters");
                    isNamed = true;
                    _position = state2.position + 1;
                } else throwError(state2, "tag suffix cannot contain exclamation marks");
            }
            ch = state2.input.charCodeAt(++state2.position);
        }
        tagName = state2.input.slice(_position, state2.position);
        if (PATTERN_FLOW_INDICATORS.test(tagName)) throwError(state2, "tag suffix cannot contain flow indicator characters");
    }
    if (tagName && !PATTERN_TAG_URI.test(tagName)) throwError(state2, "tag name cannot contain such characters: " + tagName);
    try {
        tagName = decodeURIComponent(tagName);
    } catch (err) {
        throwError(state2, "tag name is malformed: " + tagName);
    }
    if (isVerbatim) state2.tag = tagName;
    else if (_hasOwnProperty$1.call(state2.tagMap, tagHandle)) state2.tag = state2.tagMap[tagHandle] + tagName;
    else if (tagHandle === "!") state2.tag = "!" + tagName;
    else if (tagHandle === "!!") state2.tag = "tag:yaml.org,2002:" + tagName;
    else throwError(state2, 'undeclared tag handle "' + tagHandle + '"');
    return true;
}
function readAnchorProperty(state2) {
    var _position, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch !== 38) return false;
    if (state2.anchor !== null) throwError(state2, "duplication of an anchor property");
    ch = state2.input.charCodeAt(++state2.position);
    _position = state2.position;
    while(ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch))ch = state2.input.charCodeAt(++state2.position);
    if (state2.position === _position) throwError(state2, "name of an anchor node must contain at least one character");
    state2.anchor = state2.input.slice(_position, state2.position);
    return true;
}
function readAlias(state2) {
    var _position, alias, ch;
    ch = state2.input.charCodeAt(state2.position);
    if (ch !== 42) return false;
    ch = state2.input.charCodeAt(++state2.position);
    _position = state2.position;
    while(ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch))ch = state2.input.charCodeAt(++state2.position);
    if (state2.position === _position) throwError(state2, "name of an alias node must contain at least one character");
    alias = state2.input.slice(_position, state2.position);
    if (!_hasOwnProperty$1.call(state2.anchorMap, alias)) throwError(state2, 'unidentified alias "' + alias + '"');
    state2.result = state2.anchorMap[alias];
    skipSeparationSpace(state2, true, -1);
    return true;
}
function composeNode(state2, parentIndent, nodeContext, allowToSeek, allowCompact) {
    var allowBlockStyles, allowBlockScalars, allowBlockCollections, indentStatus = 1, atNewLine = false, hasContent = false, typeIndex, typeQuantity, typeList, type2, flowIndent, blockIndent;
    if (state2.listener !== null) state2.listener("open", state2);
    state2.tag = null;
    state2.anchor = null;
    state2.kind = null;
    state2.result = null;
    allowBlockStyles = allowBlockScalars = allowBlockCollections = CONTEXT_BLOCK_OUT === nodeContext || CONTEXT_BLOCK_IN === nodeContext;
    if (allowToSeek) {
        if (skipSeparationSpace(state2, true, -1)) {
            atNewLine = true;
            if (state2.lineIndent > parentIndent) indentStatus = 1;
            else if (state2.lineIndent === parentIndent) indentStatus = 0;
            else if (state2.lineIndent < parentIndent) indentStatus = -1;
        }
    }
    if (indentStatus === 1) {
        while(readTagProperty(state2) || readAnchorProperty(state2))if (skipSeparationSpace(state2, true, -1)) {
            atNewLine = true;
            allowBlockCollections = allowBlockStyles;
            if (state2.lineIndent > parentIndent) indentStatus = 1;
            else if (state2.lineIndent === parentIndent) indentStatus = 0;
            else if (state2.lineIndent < parentIndent) indentStatus = -1;
        } else allowBlockCollections = false;
    }
    if (allowBlockCollections) allowBlockCollections = atNewLine || allowCompact;
    if (indentStatus === 1 || CONTEXT_BLOCK_OUT === nodeContext) {
        if (CONTEXT_FLOW_IN === nodeContext || CONTEXT_FLOW_OUT === nodeContext) flowIndent = parentIndent;
        else flowIndent = parentIndent + 1;
        blockIndent = state2.position - state2.lineStart;
        if (indentStatus === 1) {
            if (allowBlockCollections && (readBlockSequence(state2, blockIndent) || readBlockMapping(state2, blockIndent, flowIndent)) || readFlowCollection(state2, flowIndent)) hasContent = true;
            else {
                if (allowBlockScalars && readBlockScalar(state2, flowIndent) || readSingleQuotedScalar(state2, flowIndent) || readDoubleQuotedScalar(state2, flowIndent)) hasContent = true;
                else if (readAlias(state2)) {
                    hasContent = true;
                    if (state2.tag !== null || state2.anchor !== null) throwError(state2, "alias node should not have any properties");
                } else if (readPlainScalar(state2, flowIndent, CONTEXT_FLOW_IN === nodeContext)) {
                    hasContent = true;
                    if (state2.tag === null) state2.tag = "?";
                }
                if (state2.anchor !== null) state2.anchorMap[state2.anchor] = state2.result;
            }
        } else if (indentStatus === 0) hasContent = allowBlockCollections && readBlockSequence(state2, blockIndent);
    }
    if (state2.tag === null) {
        if (state2.anchor !== null) state2.anchorMap[state2.anchor] = state2.result;
    } else if (state2.tag === "?") {
        if (state2.result !== null && state2.kind !== "scalar") throwError(state2, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + state2.kind + '"');
        for(typeIndex = 0, typeQuantity = state2.implicitTypes.length; typeIndex < typeQuantity; typeIndex += 1){
            type2 = state2.implicitTypes[typeIndex];
            if (type2.resolve(state2.result)) {
                state2.result = type2.construct(state2.result);
                state2.tag = type2.tag;
                if (state2.anchor !== null) state2.anchorMap[state2.anchor] = state2.result;
                break;
            }
        }
    } else if (state2.tag !== "!") {
        if (_hasOwnProperty$1.call(state2.typeMap[state2.kind || "fallback"], state2.tag)) type2 = state2.typeMap[state2.kind || "fallback"][state2.tag];
        else {
            type2 = null;
            typeList = state2.typeMap.multi[state2.kind || "fallback"];
            for(typeIndex = 0, typeQuantity = typeList.length; typeIndex < typeQuantity; typeIndex += 1)if (state2.tag.slice(0, typeList[typeIndex].tag.length) === typeList[typeIndex].tag) {
                type2 = typeList[typeIndex];
                break;
            }
        }
        if (!type2) throwError(state2, "unknown tag !<" + state2.tag + ">");
        if (state2.result !== null && type2.kind !== state2.kind) throwError(state2, "unacceptable node kind for !<" + state2.tag + '> tag; it should be "' + type2.kind + '", not "' + state2.kind + '"');
        if (!type2.resolve(state2.result, state2.tag)) throwError(state2, "cannot resolve a node with !<" + state2.tag + "> explicit tag");
        else {
            state2.result = type2.construct(state2.result, state2.tag);
            if (state2.anchor !== null) state2.anchorMap[state2.anchor] = state2.result;
        }
    }
    if (state2.listener !== null) state2.listener("close", state2);
    return state2.tag !== null || state2.anchor !== null || hasContent;
}
function readDocument(state2) {
    var documentStart = state2.position, _position, directiveName, directiveArgs, hasDirectives = false, ch;
    state2.version = null;
    state2.checkLineBreaks = state2.legacy;
    state2.tagMap = /* @__PURE__ */ Object.create(null);
    state2.anchorMap = /* @__PURE__ */ Object.create(null);
    while((ch = state2.input.charCodeAt(state2.position)) !== 0){
        skipSeparationSpace(state2, true, -1);
        ch = state2.input.charCodeAt(state2.position);
        if (state2.lineIndent > 0 || ch !== 37) break;
        hasDirectives = true;
        ch = state2.input.charCodeAt(++state2.position);
        _position = state2.position;
        while(ch !== 0 && !is_WS_OR_EOL(ch))ch = state2.input.charCodeAt(++state2.position);
        directiveName = state2.input.slice(_position, state2.position);
        directiveArgs = [];
        if (directiveName.length < 1) throwError(state2, "directive name must not be less than one character in length");
        while(ch !== 0){
            while(is_WHITE_SPACE(ch))ch = state2.input.charCodeAt(++state2.position);
            if (ch === 35) {
                do ch = state2.input.charCodeAt(++state2.position);
                while (ch !== 0 && !is_EOL(ch));
                break;
            }
            if (is_EOL(ch)) break;
            _position = state2.position;
            while(ch !== 0 && !is_WS_OR_EOL(ch))ch = state2.input.charCodeAt(++state2.position);
            directiveArgs.push(state2.input.slice(_position, state2.position));
        }
        if (ch !== 0) readLineBreak(state2);
        if (_hasOwnProperty$1.call(directiveHandlers, directiveName)) directiveHandlers[directiveName](state2, directiveName, directiveArgs);
        else throwWarning(state2, 'unknown document directive "' + directiveName + '"');
    }
    skipSeparationSpace(state2, true, -1);
    if (state2.lineIndent === 0 && state2.input.charCodeAt(state2.position) === 45 && state2.input.charCodeAt(state2.position + 1) === 45 && state2.input.charCodeAt(state2.position + 2) === 45) {
        state2.position += 3;
        skipSeparationSpace(state2, true, -1);
    } else if (hasDirectives) throwError(state2, "directives end mark is expected");
    composeNode(state2, state2.lineIndent - 1, CONTEXT_BLOCK_OUT, false, true);
    skipSeparationSpace(state2, true, -1);
    if (state2.checkLineBreaks && PATTERN_NON_ASCII_LINE_BREAKS.test(state2.input.slice(documentStart, state2.position))) throwWarning(state2, "non-ASCII line breaks are interpreted as content");
    state2.documents.push(state2.result);
    if (state2.position === state2.lineStart && testDocumentSeparator(state2)) {
        if (state2.input.charCodeAt(state2.position) === 46) {
            state2.position += 3;
            skipSeparationSpace(state2, true, -1);
        }
        return;
    }
    if (state2.position < state2.length - 1) throwError(state2, "end of the stream or a document separator is expected");
    else return;
}
function loadDocuments(input, options) {
    input = String(input);
    options = options || {};
    if (input.length !== 0) {
        if (input.charCodeAt(input.length - 1) !== 10 && input.charCodeAt(input.length - 1) !== 13) input += "\n";
        if (input.charCodeAt(0) === 65279) input = input.slice(1);
    }
    var state2 = new State$1(input, options);
    var nullpos = input.indexOf("\0");
    if (nullpos !== -1) {
        state2.position = nullpos;
        throwError(state2, "null byte is not allowed in input");
    }
    state2.input += "\0";
    while(state2.input.charCodeAt(state2.position) === 32){
        state2.lineIndent += 1;
        state2.position += 1;
    }
    while(state2.position < state2.length - 1)readDocument(state2);
    return state2.documents;
}
function loadAll$1(input, iterator, options) {
    if (iterator !== null && typeof iterator === "object" && typeof options === "undefined") {
        options = iterator;
        iterator = null;
    }
    var documents = loadDocuments(input, options);
    if (typeof iterator !== "function") return documents;
    for(var index = 0, length = documents.length; index < length; index += 1)iterator(documents[index]);
}
function load$1(input, options) {
    var documents = loadDocuments(input, options);
    if (documents.length === 0) return void 0;
    else if (documents.length === 1) return documents[0];
    throw new exception("expected a single document in the stream, but found more");
}
var loadAll_1 = loadAll$1;
var load_1 = load$1;
var loader = {
    loadAll: loadAll_1,
    load: load_1
};
var JSON_SCHEMA = json;
var load = loader.load;
function extractFrontMatter(text) {
    const matches = text.match(frontMatterRegex);
    if (!matches) return {
        text,
        metadata: {}
    };
    let parsed = load(matches[1], {
        // To support config, we need JSON schema.
        // https://www.yaml.org/spec/1.2/spec.html#id2803231
        schema: JSON_SCHEMA
    }) ?? {};
    parsed = typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
    const metadata = {};
    if (parsed.displayMode) metadata.displayMode = parsed.displayMode.toString();
    if (parsed.title) metadata.title = parsed.title.toString();
    if (parsed.config) metadata.config = parsed.config;
    return {
        text: text.slice(matches[0].length),
        metadata
    };
}
const cleanupText = (code)=>{
    return code.replace(/\r\n?/g, "\n").replace(/<(\w+)([^>]*)>/g, (match, tag, attributes)=>"<" + tag + attributes.replace(/="([^"]*)"/g, "='$1'") + ">");
};
const processFrontmatter = (code)=>{
    const { text, metadata } = extractFrontMatter(code);
    const { displayMode, title, config: config2 = {} } = metadata;
    if (displayMode) {
        if (!config2.gantt) config2.gantt = {};
        config2.gantt.displayMode = displayMode;
    }
    return {
        title,
        config: config2,
        text
    };
};
const processDirectives = (code)=>{
    const initDirective = utils.detectInit(code) ?? {};
    const wrapDirectives = utils.detectDirective(code, "wrap");
    if (Array.isArray(wrapDirectives)) initDirective.wrap = wrapDirectives.some(({ type: type2 })=>{});
    else if ((wrapDirectives == null ? void 0 : wrapDirectives.type) === "wrap") initDirective.wrap = true;
    return {
        text: removeDirectives(code),
        directive: initDirective
    };
};
function preprocessDiagram(code) {
    const cleanedCode = cleanupText(code);
    const frontMatterResult = processFrontmatter(cleanedCode);
    const directiveResult = processDirectives(frontMatterResult.text);
    const config2 = cleanAndMerge(frontMatterResult.config, directiveResult.directive);
    code = cleanupComments(directiveResult.text);
    return {
        code,
        title: frontMatterResult.title,
        config: config2
    };
}
const MAX_TEXTLENGTH = 5e4;
const MAX_TEXTLENGTH_EXCEEDED_MSG = "graph TB;a[Maximum text size in diagram exceeded];style a fill:#faa";
const SECURITY_LVL_SANDBOX = "sandbox";
const SECURITY_LVL_LOOSE = "loose";
const XMLNS_SVG_STD = "http://www.w3.org/2000/svg";
const XMLNS_XLINK_STD = "http://www.w3.org/1999/xlink";
const XMLNS_XHTML_STD = "http://www.w3.org/1999/xhtml";
const IFRAME_WIDTH = "100%";
const IFRAME_HEIGHT = "100%";
const IFRAME_STYLES = "border:0;margin:0;";
const IFRAME_BODY_STYLE = "margin:0";
const IFRAME_SANDBOX_OPTS = "allow-top-navigation-by-user-activation allow-popups";
const IFRAME_NOT_SUPPORTED_MSG = 'The "iframe" tag is not supported by your browser.';
const DOMPURIFY_TAGS = [
    "foreignobject"
];
const DOMPURIFY_ATTR = [
    "dominant-baseline"
];
function processAndSetConfigs(text) {
    const processed = preprocessDiagram(text);
    reset();
    addDirective(processed.config ?? {});
    return processed;
}
async function parse$1(text, parseOptions) {
    addDiagrams();
    text = processAndSetConfigs(text).code;
    try {
        await getDiagramFromText(text);
    } catch (error) {
        if (parseOptions == null ? void 0 : parseOptions.suppressErrors) return false;
        throw error;
    }
    return true;
}
const cssImportantStyles = (cssClass, element, cssClasses = [])=>{
    return `
.${cssClass} ${element} { ${cssClasses.join(" !important; ")} !important; }`;
};
const createCssStyles = (config2, classDefs = {})=>{
    var _a;
    let cssStyles = "";
    if (config2.themeCSS !== void 0) cssStyles += `
${config2.themeCSS}`;
    if (config2.fontFamily !== void 0) cssStyles += `
:root { --mermaid-font-family: ${config2.fontFamily}}`;
    if (config2.altFontFamily !== void 0) cssStyles += `
:root { --mermaid-alt-font-family: ${config2.altFontFamily}}`;
    if (!(0, _isEmptyJsDefault.default)(classDefs)) {
        const htmlLabels = config2.htmlLabels || ((_a = config2.flowchart) == null ? void 0 : _a.htmlLabels);
        const cssHtmlElements = [
            "> *",
            "span"
        ];
        const cssShapeElements = [
            "rect",
            "polygon",
            "ellipse",
            "circle",
            "path"
        ];
        const cssElements = htmlLabels ? cssHtmlElements : cssShapeElements;
        for(const classId in classDefs){
            const styleClassDef = classDefs[classId];
            if (!(0, _isEmptyJsDefault.default)(styleClassDef.styles)) cssElements.forEach((cssElement)=>{
                cssStyles += cssImportantStyles(styleClassDef.id, cssElement, styleClassDef.styles);
            });
            if (!(0, _isEmptyJsDefault.default)(styleClassDef.textStyles)) cssStyles += cssImportantStyles(styleClassDef.id, "tspan", styleClassDef.textStyles);
        }
    }
    return cssStyles;
};
const createUserStyles = (config2, graphType, classDefs, svgId)=>{
    const userCSSstyles = createCssStyles(config2, classDefs);
    const allStyles = getStyles$1(graphType, userCSSstyles, config2.themeVariables);
    return (0, _stylis.serialize)((0, _stylis.compile)(`${svgId}{${allStyles}}`), (0, _stylis.stringify));
};
const cleanUpSvgCode = (svgCode = "", inSandboxMode, useArrowMarkerUrls)=>{
    let cleanedUpSvg = svgCode;
    if (!useArrowMarkerUrls && !inSandboxMode) cleanedUpSvg = cleanedUpSvg.replace(/marker-end="url\([\d+./:=?A-Za-z-]*?#/g, 'marker-end="url(#');
    cleanedUpSvg = decodeEntities(cleanedUpSvg);
    cleanedUpSvg = cleanedUpSvg.replace(/<br>/g, "<br/>");
    return cleanedUpSvg;
};
const putIntoIFrame = (svgCode = "", svgElement)=>{
    var _a, _b;
    const height = ((_b = (_a = svgElement == null ? void 0 : svgElement.viewBox) == null ? void 0 : _a.baseVal) == null ? void 0 : _b.height) ? svgElement.viewBox.baseVal.height + "px" : IFRAME_HEIGHT;
    const base64encodedSrc = btoa('<body style="' + IFRAME_BODY_STYLE + '">' + svgCode + "</body>");
    return `<iframe style="width:${IFRAME_WIDTH};height:${height};${IFRAME_STYLES}" src="data:text/html;base64,${base64encodedSrc}" sandbox="${IFRAME_SANDBOX_OPTS}">
  ${IFRAME_NOT_SUPPORTED_MSG}
</iframe>`;
};
const appendDivSvgG = (parentRoot, id2, enclosingDivId, divStyle, svgXlink)=>{
    const enclosingDiv = parentRoot.append("div");
    enclosingDiv.attr("id", enclosingDivId);
    if (divStyle) enclosingDiv.attr("style", divStyle);
    const svgNode = enclosingDiv.append("svg").attr("id", id2).attr("width", "100%").attr("xmlns", XMLNS_SVG_STD);
    if (svgXlink) svgNode.attr("xmlns:xlink", svgXlink);
    svgNode.append("g");
    return parentRoot;
};
function sandboxedIframe(parentNode, iFrameId) {
    return parentNode.append("iframe").attr("id", iFrameId).attr("style", "width: 100%; height: 100%;").attr("sandbox", "");
}
const removeExistingElements = (doc, id2, divId, iFrameId)=>{
    var _a, _b, _c;
    (_a = doc.getElementById(id2)) == null || _a.remove();
    (_b = doc.getElementById(divId)) == null || _b.remove();
    (_c = doc.getElementById(iFrameId)) == null || _c.remove();
};
const render$1 = async function(id2, text, svgContainingElement) {
    var _a, _b, _c, _d, _e, _f;
    addDiagrams();
    const processed = processAndSetConfigs(text);
    text = processed.code;
    const config2 = getConfig$1();
    log$1.debug(config2);
    if (text.length > ((config2 == null ? void 0 : config2.maxTextSize) ?? MAX_TEXTLENGTH)) text = MAX_TEXTLENGTH_EXCEEDED_MSG;
    const idSelector = "#" + id2;
    const iFrameID = "i" + id2;
    const iFrameID_selector = "#" + iFrameID;
    const enclosingDivID = "d" + id2;
    const enclosingDivID_selector = "#" + enclosingDivID;
    let root = (0, _d3.select)("body");
    const isSandboxed = config2.securityLevel === SECURITY_LVL_SANDBOX;
    const isLooseSecurityLevel = config2.securityLevel === SECURITY_LVL_LOOSE;
    const fontFamily = config2.fontFamily;
    if (svgContainingElement !== void 0) {
        if (svgContainingElement) svgContainingElement.innerHTML = "";
        if (isSandboxed) {
            const iframe = sandboxedIframe((0, _d3.select)(svgContainingElement), iFrameID);
            root = (0, _d3.select)(iframe.nodes()[0].contentDocument.body);
            root.node().style.margin = 0;
        } else root = (0, _d3.select)(svgContainingElement);
        appendDivSvgG(root, id2, enclosingDivID, `font-family: ${fontFamily}`, XMLNS_XLINK_STD);
    } else {
        removeExistingElements(document, id2, enclosingDivID, iFrameID);
        if (isSandboxed) {
            const iframe = sandboxedIframe((0, _d3.select)("body"), iFrameID);
            root = (0, _d3.select)(iframe.nodes()[0].contentDocument.body);
            root.node().style.margin = 0;
        } else root = (0, _d3.select)("body");
        appendDivSvgG(root, id2, enclosingDivID);
    }
    let diag;
    let parseEncounteredException;
    try {
        diag = await getDiagramFromText(text, {
            title: processed.title
        });
    } catch (error) {
        diag = new Diagram("error");
        parseEncounteredException = error;
    }
    const element = root.select(enclosingDivID_selector).node();
    const diagramType = diag.type;
    const svg = element.firstChild;
    const firstChild = svg.firstChild;
    const diagramClassDefs = (_b = (_a = diag.renderer).getClasses) == null ? void 0 : _b.call(_a, text, diag);
    const rules = createUserStyles(config2, diagramType, diagramClassDefs, idSelector);
    const style1 = document.createElement("style");
    style1.innerHTML = rules;
    svg.insertBefore(style1, firstChild);
    try {
        await diag.renderer.draw(text, id2, version, diag);
    } catch (e) {
        errorRenderer.draw(text, id2, version);
        throw e;
    }
    const svgNode = root.select(`${enclosingDivID_selector} svg`);
    const a11yTitle = (_d = (_c = diag.db).getAccTitle) == null ? void 0 : _d.call(_c);
    const a11yDescr = (_f = (_e = diag.db).getAccDescription) == null ? void 0 : _f.call(_e);
    addA11yInfo(diagramType, svgNode, a11yTitle, a11yDescr);
    root.select(`[id="${id2}"]`).selectAll("foreignobject > *").attr("xmlns", XMLNS_XHTML_STD);
    let svgCode = root.select(enclosingDivID_selector).node().innerHTML;
    log$1.debug("config.arrowMarkerAbsolute", config2.arrowMarkerAbsolute);
    svgCode = cleanUpSvgCode(svgCode, isSandboxed, evaluate(config2.arrowMarkerAbsolute));
    if (isSandboxed) {
        const svgEl = root.select(enclosingDivID_selector + " svg").node();
        svgCode = putIntoIFrame(svgCode, svgEl);
    } else if (!isLooseSecurityLevel) svgCode = (0, _dompurifyDefault.default).sanitize(svgCode, {
        ADD_TAGS: DOMPURIFY_TAGS,
        ADD_ATTR: DOMPURIFY_ATTR
    });
    attachFunctions();
    if (parseEncounteredException) throw parseEncounteredException;
    const tmpElementSelector = isSandboxed ? iFrameID_selector : enclosingDivID_selector;
    const node = (0, _d3.select)(tmpElementSelector).node();
    if (node && "remove" in node) node.remove();
    return {
        svg: svgCode,
        bindFunctions: diag.db.bindFunctions
    };
};
function initialize$1(options = {}) {
    var _a;
    if ((options == null ? void 0 : options.fontFamily) && !((_a = options.themeVariables) == null ? void 0 : _a.fontFamily)) {
        if (!options.themeVariables) options.themeVariables = {};
        options.themeVariables.fontFamily = options.fontFamily;
    }
    saveConfigFromInitialize(options);
    if ((options == null ? void 0 : options.theme) && options.theme in theme) options.themeVariables = theme[options.theme].getThemeVariables(options.themeVariables);
    else if (options) options.themeVariables = theme.default.getThemeVariables(options.themeVariables);
    const config2 = typeof options === "object" ? setSiteConfig(options) : getSiteConfig();
    setLogLevel$1(config2.logLevel);
    addDiagrams();
}
const getDiagramFromText = (text, metadata = {})=>{
    const { code } = preprocessDiagram(text);
    return getDiagramFromText$1(code, metadata);
};
function addA11yInfo(diagramType, svgNode, a11yTitle, a11yDescr) {
    setA11yDiagramInfo(svgNode, diagramType);
    addSVGa11yTitleDescription(svgNode, a11yTitle, a11yDescr, svgNode.attr("id"));
}
const mermaidAPI = Object.freeze({
    render: render$1,
    parse: parse$1,
    getDiagramFromText,
    initialize: initialize$1,
    getConfig: getConfig$1,
    setConfig: setConfig$1,
    getSiteConfig,
    updateSiteConfig,
    reset: ()=>{
        reset();
    },
    globalReset: ()=>{
        reset(defaultConfig$1);
    },
    defaultConfig: defaultConfig$1
});
setLogLevel$1(getConfig$1().logLevel);
reset(getConfig$1());
const loadRegisteredDiagrams = async ()=>{
    log$1.debug(`Loading registered diagrams`);
    const results = await Promise.allSettled(Object.entries(detectors).map(async ([key, { detector: detector2, loader: loader2 }])=>{
        if (loader2) try {
            getDiagram(key);
        } catch (error) {
            try {
                const { diagram: diagram2, id: id2 } = await loader2();
                registerDiagram(id2, diagram2, detector2);
            } catch (err) {
                log$1.error(`Failed to load external diagram with key ${key}. Removing from detectors.`);
                delete detectors[key];
                throw err;
            }
        }
    }));
    const failed = results.filter((result)=>result.status === "rejected");
    if (failed.length > 0) {
        log$1.error(`Failed to load ${failed.length} external diagrams`);
        for (const res of failed)log$1.error(res);
        throw new Error(`Failed to load ${failed.length} external diagrams`);
    }
};
const handleError = (error, errors, parseError)=>{
    log$1.warn(error);
    if (isDetailedError(error)) {
        if (parseError) parseError(error.str, error.hash);
        errors.push({
            ...error,
            message: error.str,
            error
        });
    } else {
        if (parseError) parseError(error);
        if (error instanceof Error) errors.push({
            str: error.message,
            message: error.message,
            hash: error.name,
            error
        });
    }
};
const run = async function(options = {
    querySelector: ".mermaid"
}) {
    try {
        await runThrowsErrors(options);
    } catch (e) {
        if (isDetailedError(e)) log$1.error(e.str);
        if (mermaid.parseError) mermaid.parseError(e);
        if (!options.suppressErrors) {
            log$1.error("Use the suppressErrors option to suppress these errors");
            throw e;
        }
    }
};
const runThrowsErrors = async function({ postRenderCallback, querySelector, nodes } = {
    querySelector: ".mermaid"
}) {
    const conf = mermaidAPI.getConfig();
    log$1.debug(`${!postRenderCallback ? "No " : ""}Callback function found`);
    let nodesToProcess;
    if (nodes) nodesToProcess = nodes;
    else if (querySelector) nodesToProcess = document.querySelectorAll(querySelector);
    else throw new Error("Nodes and querySelector are both undefined");
    log$1.debug(`Found ${nodesToProcess.length} diagrams`);
    if ((conf == null ? void 0 : conf.startOnLoad) !== void 0) {
        log$1.debug("Start On Load: " + (conf == null ? void 0 : conf.startOnLoad));
        mermaidAPI.updateSiteConfig({
            startOnLoad: conf == null ? void 0 : conf.startOnLoad
        });
    }
    const idGenerator = new utils.InitIDGenerator(conf.deterministicIds, conf.deterministicIDSeed);
    let txt;
    const errors = [];
    for (const element of Array.from(nodesToProcess)){
        log$1.info("Rendering diagram: " + element.id);
        /*! Check if previously processed */ if (element.getAttribute("data-processed")) continue;
        element.setAttribute("data-processed", "true");
        const id2 = `mermaid-${idGenerator.next()}`;
        txt = element.innerHTML;
        txt = (0, _tsDedent.dedent)(utils.entityDecode(txt)).trim().replace(/<br\s*\/?>/gi, "<br/>");
        const init2 = utils.detectInit(txt);
        if (init2) log$1.debug("Detected early reinit: ", init2);
        try {
            const { svg, bindFunctions } = await render(id2, txt, element);
            element.innerHTML = svg;
            if (postRenderCallback) await postRenderCallback(id2);
            if (bindFunctions) bindFunctions(element);
        } catch (error) {
            handleError(error, errors, mermaid.parseError);
        }
    }
    if (errors.length > 0) throw errors[0];
};
const initialize = function(config2) {
    mermaidAPI.initialize(config2);
};
const init = async function(config2, nodes, callback) {
    log$1.warn("mermaid.init is deprecated. Please use run instead.");
    if (config2) initialize(config2);
    const runOptions = {
        postRenderCallback: callback,
        querySelector: ".mermaid"
    };
    if (typeof nodes === "string") runOptions.querySelector = nodes;
    else if (nodes) {
        if (nodes instanceof HTMLElement) runOptions.nodes = [
            nodes
        ];
        else runOptions.nodes = nodes;
    }
    await run(runOptions);
};
const registerExternalDiagrams = async (diagrams2, { lazyLoad = true } = {})=>{
    registerLazyLoadedDiagrams(...diagrams2);
    if (lazyLoad === false) await loadRegisteredDiagrams();
};
const contentLoaded = function() {
    if (mermaid.startOnLoad) {
        const { startOnLoad } = mermaidAPI.getConfig();
        if (startOnLoad) mermaid.run().catch((err)=>log$1.error("Mermaid failed to initialize", err));
    }
};
if (typeof document !== "undefined") /*!
   * Wait for document loaded before starting the execution
   */ window.addEventListener("load", contentLoaded, false);
const setParseErrorHandler = function(parseErrorHandler) {
    mermaid.parseError = parseErrorHandler;
};
const executionQueue = [];
let executionQueueRunning = false;
const executeQueue = async ()=>{
    if (executionQueueRunning) return;
    executionQueueRunning = true;
    while(executionQueue.length > 0){
        const f = executionQueue.shift();
        if (f) try {
            await f();
        } catch (e) {
            log$1.error("Error executing queue", e);
        }
    }
    executionQueueRunning = false;
};
const parse = async (text, parseOptions)=>{
    return new Promise((resolve, reject)=>{
        const performCall = ()=>new Promise((res, rej)=>{
                mermaidAPI.parse(text, parseOptions).then((r)=>{
                    res(r);
                    resolve(r);
                }, (e)=>{
                    var _a;
                    log$1.error("Error parsing", e);
                    (_a = mermaid.parseError) == null || _a.call(mermaid, e);
                    rej(e);
                    reject(e);
                });
            });
        executionQueue.push(performCall);
        executeQueue().catch(reject);
    });
};
const render = (id2, text, container)=>{
    return new Promise((resolve, reject)=>{
        const performCall = ()=>new Promise((res, rej)=>{
                mermaidAPI.render(id2, text, container).then((r)=>{
                    res(r);
                    resolve(r);
                }, (e)=>{
                    var _a;
                    log$1.error("Error parsing", e);
                    (_a = mermaid.parseError) == null || _a.call(mermaid, e);
                    rej(e);
                    reject(e);
                });
            });
        executionQueue.push(performCall);
        executeQueue().catch(reject);
    });
};
const mermaid = {
    startOnLoad: true,
    mermaidAPI,
    parse,
    render,
    init,
    run,
    registerExternalDiagrams,
    initialize,
    parseError: void 0,
    contentLoaded,
    setParseErrorHandler,
    detectType
};

},{"ts-dedent":"azOLv","dayjs":"8F3kd","@braintree/sanitize-url":"eIPUt","d3":"ahWNw","dompurify":"5cPaM","khroma":"kb6Zw","lodash-es/memoize.js":"kSZfU","lodash-es/merge.js":"ije1P","stylis":"lfeQC","lodash-es/isEmpty.js":"941eg","562e5fa709213015":"1K0qS","2ba1c829b89980ad":"77gTB","b9e6fce9c305611c":"aHa1h","9835076ac3952c1f":"22J22","8efbfa4fc5ae0f86":"85Fyu","478de527573b4ba3":"6PSuR","c443aa1a0f9f0a":"fNAdV","a8990e9ec7acfa0f":"hEDJk","b34e1a226107ff66":"1mL96","72ffc3b9aed712ff":"gxMYj","30affe5c561e0d8a":"dpacc","8201da67ab24ce17":"bSwBL","61c1df035677149e":"hO4q3","cb4f872e22c08f4f":"hInfo","afa89555aff2b477":"l2J2A","18f5f1dfcf3aa91":"gfn2d","a05e17f8f4ce2c07":"gUKJf","18e8bcf1aa1aeef":"f5Y5V","69c221d827f219bc":"i9zIT","5a5dea4afe927698":"7im3Y","2f31654da013ca43":"fXREA","e9b1986b5bf7f4ed":"ensOo","d84434f4f1a96467":"aOhCD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8F3kd":[function(require,module,exports,__globalThis) {
!function(t, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

},{}],"eIPUt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sanitizeUrl = exports.BLANK_URL = void 0;
var invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
var htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
var htmlCtrlEntityRegex = /&(newline|tab);/gi;
var ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
var urlSchemeRegex = /^.+(:|&colon;)/gim;
var relativeFirstCharacters = [
    ".",
    "/"
];
exports.BLANK_URL = "about:blank";
function isRelativeUrlWithoutProtocol(url) {
    return relativeFirstCharacters.indexOf(url[0]) > -1;
}
// adapted from https://stackoverflow.com/a/29824550/2601552
function decodeHtmlCharacters(str) {
    var removedNullByte = str.replace(ctrlCharactersRegex, "");
    return removedNullByte.replace(htmlEntitiesRegex, function(match, dec) {
        return String.fromCharCode(dec);
    });
}
function sanitizeUrl(url) {
    if (!url) return exports.BLANK_URL;
    var sanitizedUrl = decodeHtmlCharacters(url).replace(htmlCtrlEntityRegex, "").replace(ctrlCharactersRegex, "").trim();
    if (!sanitizedUrl) return exports.BLANK_URL;
    if (isRelativeUrlWithoutProtocol(sanitizedUrl)) return sanitizedUrl;
    var urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
    if (!urlSchemeParseResults) return sanitizedUrl;
    var urlScheme = urlSchemeParseResults[0];
    if (invalidProtocolRegex.test(urlScheme)) return exports.BLANK_URL;
    return sanitizedUrl;
}
exports.sanitizeUrl = sanitizeUrl;

},{}],"ahWNw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Array = require("d3-array");
parcelHelpers.exportAll(_d3Array, exports);
var _d3Axis = require("d3-axis");
parcelHelpers.exportAll(_d3Axis, exports);
var _d3Brush = require("d3-brush");
parcelHelpers.exportAll(_d3Brush, exports);
var _d3Chord = require("d3-chord");
parcelHelpers.exportAll(_d3Chord, exports);
var _d3Color = require("d3-color");
parcelHelpers.exportAll(_d3Color, exports);
var _d3Contour = require("d3-contour");
parcelHelpers.exportAll(_d3Contour, exports);
var _d3Delaunay = require("d3-delaunay");
parcelHelpers.exportAll(_d3Delaunay, exports);
var _d3Dispatch = require("d3-dispatch");
parcelHelpers.exportAll(_d3Dispatch, exports);
var _d3Drag = require("d3-drag");
parcelHelpers.exportAll(_d3Drag, exports);
var _d3Dsv = require("d3-dsv");
parcelHelpers.exportAll(_d3Dsv, exports);
var _d3Ease = require("d3-ease");
parcelHelpers.exportAll(_d3Ease, exports);
var _d3Fetch = require("d3-fetch");
parcelHelpers.exportAll(_d3Fetch, exports);
var _d3Force = require("d3-force");
parcelHelpers.exportAll(_d3Force, exports);
var _d3Format = require("d3-format");
parcelHelpers.exportAll(_d3Format, exports);
var _d3Geo = require("d3-geo");
parcelHelpers.exportAll(_d3Geo, exports);
var _d3Hierarchy = require("d3-hierarchy");
parcelHelpers.exportAll(_d3Hierarchy, exports);
var _d3Interpolate = require("d3-interpolate");
parcelHelpers.exportAll(_d3Interpolate, exports);
var _d3Path = require("d3-path");
parcelHelpers.exportAll(_d3Path, exports);
var _d3Polygon = require("d3-polygon");
parcelHelpers.exportAll(_d3Polygon, exports);
var _d3Quadtree = require("d3-quadtree");
parcelHelpers.exportAll(_d3Quadtree, exports);
var _d3Random = require("d3-random");
parcelHelpers.exportAll(_d3Random, exports);
var _d3Scale = require("d3-scale");
parcelHelpers.exportAll(_d3Scale, exports);
var _d3ScaleChromatic = require("d3-scale-chromatic");
parcelHelpers.exportAll(_d3ScaleChromatic, exports);
var _d3Selection = require("d3-selection");
parcelHelpers.exportAll(_d3Selection, exports);
var _d3Shape = require("d3-shape");
parcelHelpers.exportAll(_d3Shape, exports);
var _d3Time = require("d3-time");
parcelHelpers.exportAll(_d3Time, exports);
var _d3TimeFormat = require("d3-time-format");
parcelHelpers.exportAll(_d3TimeFormat, exports);
var _d3Timer = require("d3-timer");
parcelHelpers.exportAll(_d3Timer, exports);
var _d3Transition = require("d3-transition");
parcelHelpers.exportAll(_d3Transition, exports);
var _d3Zoom = require("d3-zoom");
parcelHelpers.exportAll(_d3Zoom, exports);

},{"d3-array":"bmqp6","d3-axis":"iySGg","d3-brush":"45MMu","d3-chord":"eKd4K","d3-color":"euMEi","d3-contour":"9cRyX","d3-delaunay":"bzKr0","d3-dispatch":"3OarL","d3-drag":"8wlzb","d3-dsv":"5eFMk","d3-ease":"jsg3z","d3-fetch":"eiAqH","d3-force":"f2LSO","d3-format":"bpsrv","d3-geo":"c3tWY","d3-hierarchy":"5owG1","d3-interpolate":"6bUMz","d3-path":"gnRAQ","d3-polygon":"gEbap","d3-quadtree":"b3lga","d3-random":"g6DUG","d3-scale":"7BK9l","d3-scale-chromatic":"3BbmN","d3-selection":"4X1qO","d3-shape":"ba4g6","d3-time":"2sGu6","d3-time-format":"1JsiF","d3-timer":"9ST7W","d3-transition":"22YTW","d3-zoom":"f4ldt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bmqp6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisect", ()=>(0, _bisectJsDefault.default));
parcelHelpers.export(exports, "bisectRight", ()=>(0, _bisectJs.bisectRight));
parcelHelpers.export(exports, "bisectLeft", ()=>(0, _bisectJs.bisectLeft));
parcelHelpers.export(exports, "bisectCenter", ()=>(0, _bisectJs.bisectCenter));
parcelHelpers.export(exports, "ascending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "bisector", ()=>(0, _bisectorJsDefault.default));
parcelHelpers.export(exports, "blur", ()=>(0, _blurJs.blur));
parcelHelpers.export(exports, "blur2", ()=>(0, _blurJs.blur2));
parcelHelpers.export(exports, "blurImage", ()=>(0, _blurJs.blurImage));
parcelHelpers.export(exports, "count", ()=>(0, _countJsDefault.default));
parcelHelpers.export(exports, "cross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "cumsum", ()=>(0, _cumsumJsDefault.default));
parcelHelpers.export(exports, "descending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "deviation", ()=>(0, _deviationJsDefault.default));
parcelHelpers.export(exports, "extent", ()=>(0, _extentJsDefault.default));
parcelHelpers.export(exports, "Adder", ()=>(0, _fsumJs.Adder));
parcelHelpers.export(exports, "fsum", ()=>(0, _fsumJs.fsum));
parcelHelpers.export(exports, "fcumsum", ()=>(0, _fsumJs.fcumsum));
parcelHelpers.export(exports, "group", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "flatGroup", ()=>(0, _groupJs.flatGroup));
parcelHelpers.export(exports, "flatRollup", ()=>(0, _groupJs.flatRollup));
parcelHelpers.export(exports, "groups", ()=>(0, _groupJs.groups));
parcelHelpers.export(exports, "index", ()=>(0, _groupJs.index));
parcelHelpers.export(exports, "indexes", ()=>(0, _groupJs.indexes));
parcelHelpers.export(exports, "rollup", ()=>(0, _groupJs.rollup));
parcelHelpers.export(exports, "rollups", ()=>(0, _groupJs.rollups));
parcelHelpers.export(exports, "groupSort", ()=>(0, _groupSortJsDefault.default));
parcelHelpers.export(exports, "bin", ()=>(0, _binJsDefault.default)) // Deprecated; use bin.
;
parcelHelpers.export(exports, "histogram", ()=>(0, _binJsDefault.default));
parcelHelpers.export(exports, "thresholdFreedmanDiaconis", ()=>(0, _freedmanDiaconisJsDefault.default));
parcelHelpers.export(exports, "thresholdScott", ()=>(0, _scottJsDefault.default));
parcelHelpers.export(exports, "thresholdSturges", ()=>(0, _sturgesJsDefault.default));
parcelHelpers.export(exports, "max", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "maxIndex", ()=>(0, _maxIndexJsDefault.default));
parcelHelpers.export(exports, "mean", ()=>(0, _meanJsDefault.default));
parcelHelpers.export(exports, "median", ()=>(0, _medianJsDefault.default));
parcelHelpers.export(exports, "medianIndex", ()=>(0, _medianJs.medianIndex));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "min", ()=>(0, _minJsDefault.default));
parcelHelpers.export(exports, "minIndex", ()=>(0, _minIndexJsDefault.default));
parcelHelpers.export(exports, "mode", ()=>(0, _modeJsDefault.default));
parcelHelpers.export(exports, "nice", ()=>(0, _niceJsDefault.default));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairsJsDefault.default));
parcelHelpers.export(exports, "permute", ()=>(0, _permuteJsDefault.default));
parcelHelpers.export(exports, "quantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "quantileIndex", ()=>(0, _quantileJs.quantileIndex));
parcelHelpers.export(exports, "quantileSorted", ()=>(0, _quantileJs.quantileSorted));
parcelHelpers.export(exports, "quickselect", ()=>(0, _quickselectJsDefault.default));
parcelHelpers.export(exports, "range", ()=>(0, _rangeJsDefault.default));
parcelHelpers.export(exports, "rank", ()=>(0, _rankJsDefault.default));
parcelHelpers.export(exports, "least", ()=>(0, _leastJsDefault.default));
parcelHelpers.export(exports, "leastIndex", ()=>(0, _leastIndexJsDefault.default));
parcelHelpers.export(exports, "greatest", ()=>(0, _greatestJsDefault.default));
parcelHelpers.export(exports, "greatestIndex", ()=>(0, _greatestIndexJsDefault.default));
parcelHelpers.export(exports, "scan", ()=>(0, _scanJsDefault.default)) // Deprecated; use leastIndex.
;
parcelHelpers.export(exports, "shuffle", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "shuffler", ()=>(0, _shuffleJs.shuffler));
parcelHelpers.export(exports, "sum", ()=>(0, _sumJsDefault.default));
parcelHelpers.export(exports, "ticks", ()=>(0, _ticksJsDefault.default));
parcelHelpers.export(exports, "tickIncrement", ()=>(0, _ticksJs.tickIncrement));
parcelHelpers.export(exports, "tickStep", ()=>(0, _ticksJs.tickStep));
parcelHelpers.export(exports, "transpose", ()=>(0, _transposeJsDefault.default));
parcelHelpers.export(exports, "variance", ()=>(0, _varianceJsDefault.default));
parcelHelpers.export(exports, "zip", ()=>(0, _zipJsDefault.default));
parcelHelpers.export(exports, "every", ()=>(0, _everyJsDefault.default));
parcelHelpers.export(exports, "some", ()=>(0, _someJsDefault.default));
parcelHelpers.export(exports, "filter", ()=>(0, _filterJsDefault.default));
parcelHelpers.export(exports, "map", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduceJsDefault.default));
parcelHelpers.export(exports, "reverse", ()=>(0, _reverseJsDefault.default));
parcelHelpers.export(exports, "sort", ()=>(0, _sortJsDefault.default));
parcelHelpers.export(exports, "difference", ()=>(0, _differenceJsDefault.default));
parcelHelpers.export(exports, "disjoint", ()=>(0, _disjointJsDefault.default));
parcelHelpers.export(exports, "intersection", ()=>(0, _intersectionJsDefault.default));
parcelHelpers.export(exports, "subset", ()=>(0, _subsetJsDefault.default));
parcelHelpers.export(exports, "superset", ()=>(0, _supersetJsDefault.default));
parcelHelpers.export(exports, "union", ()=>(0, _unionJsDefault.default));
parcelHelpers.export(exports, "InternMap", ()=>(0, _internmap.InternMap));
parcelHelpers.export(exports, "InternSet", ()=>(0, _internmap.InternSet));
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _blurJs = require("./blur.js");
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _crossJs = require("./cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _cumsumJs = require("./cumsum.js");
var _cumsumJsDefault = parcelHelpers.interopDefault(_cumsumJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _deviationJs = require("./deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _fsumJs = require("./fsum.js");
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _groupSortJs = require("./groupSort.js");
var _groupSortJsDefault = parcelHelpers.interopDefault(_groupSortJs);
var _binJs = require("./bin.js");
var _binJsDefault = parcelHelpers.interopDefault(_binJs);
var _freedmanDiaconisJs = require("./threshold/freedmanDiaconis.js");
var _freedmanDiaconisJsDefault = parcelHelpers.interopDefault(_freedmanDiaconisJs);
var _scottJs = require("./threshold/scott.js");
var _scottJsDefault = parcelHelpers.interopDefault(_scottJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
var _medianJs = require("./median.js");
var _medianJsDefault = parcelHelpers.interopDefault(_medianJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _modeJs = require("./mode.js");
var _modeJsDefault = parcelHelpers.interopDefault(_modeJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _pairsJs = require("./pairs.js");
var _pairsJsDefault = parcelHelpers.interopDefault(_pairsJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _rangeJs = require("./range.js");
var _rangeJsDefault = parcelHelpers.interopDefault(_rangeJs);
var _rankJs = require("./rank.js");
var _rankJsDefault = parcelHelpers.interopDefault(_rankJs);
var _leastJs = require("./least.js");
var _leastJsDefault = parcelHelpers.interopDefault(_leastJs);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
var _greatestIndexJs = require("./greatestIndex.js");
var _greatestIndexJsDefault = parcelHelpers.interopDefault(_greatestIndexJs);
var _scanJs = require("./scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _shuffleJs = require("./shuffle.js");
var _shuffleJsDefault = parcelHelpers.interopDefault(_shuffleJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
var _zipJs = require("./zip.js");
var _zipJsDefault = parcelHelpers.interopDefault(_zipJs);
var _everyJs = require("./every.js");
var _everyJsDefault = parcelHelpers.interopDefault(_everyJs);
var _someJs = require("./some.js");
var _someJsDefault = parcelHelpers.interopDefault(_someJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
var _disjointJs = require("./disjoint.js");
var _disjointJsDefault = parcelHelpers.interopDefault(_disjointJs);
var _intersectionJs = require("./intersection.js");
var _intersectionJsDefault = parcelHelpers.interopDefault(_intersectionJs);
var _subsetJs = require("./subset.js");
var _subsetJsDefault = parcelHelpers.interopDefault(_subsetJs);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
var _unionJs = require("./union.js");
var _unionJsDefault = parcelHelpers.interopDefault(_unionJs);
var _internmap = require("internmap");

},{"./bisect.js":"6E3K1","./ascending.js":"fxpE9","./bisector.js":"gZxpz","./blur.js":"6MSys","./count.js":"bEr1m","./cross.js":"d7fnh","./cumsum.js":"2Kj7J","./descending.js":"eZNjL","./deviation.js":"63ogy","./extent.js":"kkkz7","./fsum.js":"5h9sS","./group.js":"dK75Z","./groupSort.js":"bd0HG","./bin.js":"fSCEd","./threshold/freedmanDiaconis.js":"ivGXE","./threshold/scott.js":"7aFxa","./threshold/sturges.js":"5VRgb","./max.js":"8VFj7","./maxIndex.js":"9TsNn","./mean.js":"lGLmc","./median.js":"4CtA1","./merge.js":"fZD2z","./min.js":"aV6tL","./minIndex.js":"4MZIY","./mode.js":"49bDg","./nice.js":"6opYb","./pairs.js":"3GyTU","./permute.js":"eLUwT","./quantile.js":"gtsMZ","./quickselect.js":"bjyfD","./range.js":"egnZn","./rank.js":"2fUwM","./least.js":"g2WOH","./leastIndex.js":"cdgca","./greatest.js":"ba9H2","./greatestIndex.js":"6pWs0","./scan.js":"3j2zL","./shuffle.js":"gHM4C","./sum.js":"7UDGD","./ticks.js":"hdIWy","./transpose.js":"f6Iqo","./variance.js":"4UZOK","./zip.js":"GnVPt","./every.js":"iMs3v","./some.js":"2SKDc","./filter.js":"lew24","./map.js":"6QMxP","./reduce.js":"fO6yJ","./reverse.js":"6VYWf","./sort.js":"hn4qB","./difference.js":"CzXyM","./disjoint.js":"jsBdg","./intersection.js":"XLnB1","./subset.js":"5pv38","./superset.js":"dQOGc","./union.js":"bPXjL","internmap":"lN5oE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6E3K1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisectRight", ()=>bisectRight);
parcelHelpers.export(exports, "bisectLeft", ()=>bisectLeft);
parcelHelpers.export(exports, "bisectCenter", ()=>bisectCenter);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
const ascendingBisect = (0, _bisectorJsDefault.default)((0, _ascendingJsDefault.default));
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = (0, _bisectorJsDefault.default)((0, _numberJsDefault.default)).center;
exports.default = bisectRight;

},{"./ascending.js":"fxpE9","./bisector.js":"gZxpz","./number.js":"cFSaj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fxpE9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ascending);
function ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gZxpz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bisector);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
function bisector(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, _ascendingJsDefault.default);
        compare2 = (d, x)=>(0, _ascendingJsDefault.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, _ascendingJsDefault.default) || f === (0, _descendingJsDefault.default) ? f : zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left,
        center,
        right
    };
}
function zero() {
    return 0;
}

},{"./ascending.js":"fxpE9","./descending.js":"eZNjL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eZNjL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>descending);
function descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cFSaj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
parcelHelpers.export(exports, "numbers", ()=>numbers);
function number(x) {
    return x === null ? NaN : +x;
}
function* numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6MSys":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blur", ()=>blur);
parcelHelpers.export(exports, "blur2", ()=>blur2);
parcelHelpers.export(exports, "blurImage", ()=>blurImage);
function blur(values, r) {
    if (!((r = +r) >= 0)) throw new RangeError("invalid r");
    let length = values.length;
    if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
    if (!length || !r) return values;
    const blur = blurf(r);
    const temp = values.slice();
    blur(values, temp, 0, length, 1);
    blur(temp, values, 0, length, 1);
    blur(values, temp, 0, length, 1);
    return values;
}
const blur2 = Blur2(blurf);
const blurImage = Blur2(blurfImage);
function Blur2(blur) {
    return function(data, rx, ry = rx) {
        if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
        if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
        let { data: values, width, height } = data;
        if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
        if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
        if (!width || !height || !rx && !ry) return data;
        const blurx = rx && blur(rx);
        const blury = ry && blur(ry);
        const temp = values.slice();
        if (blurx && blury) {
            blurh(blurx, temp, values, width, height);
            blurh(blurx, values, temp, width, height);
            blurh(blurx, temp, values, width, height);
            blurv(blury, values, temp, width, height);
            blurv(blury, temp, values, width, height);
            blurv(blury, values, temp, width, height);
        } else if (blurx) {
            blurh(blurx, values, temp, width, height);
            blurh(blurx, temp, values, width, height);
            blurh(blurx, values, temp, width, height);
        } else if (blury) {
            blurv(blury, values, temp, width, height);
            blurv(blury, temp, values, width, height);
            blurv(blury, values, temp, width, height);
        }
        return data;
    };
}
function blurh(blur, T, S, w, h) {
    for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
}
function blurv(blur, T, S, w, h) {
    for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
}
function blurfImage(radius) {
    const blur = blurf(radius);
    return (T, S, start, stop, step)=>{
        start <<= 2, stop <<= 2, step <<= 2;
        blur(T, S, start + 0, stop + 0, step);
        blur(T, S, start + 1, stop + 1, step);
        blur(T, S, start + 2, stop + 2, step);
        blur(T, S, start + 3, stop + 3, step);
    };
}
// Given a target array T, a source array S, sets each value T[i] to the average
// of {S[i - r], …, S[i], …, S[i + r]}, where r = ⌊radius⌋, start <= i < stop,
// for each i, i + step, i + 2 * step, etc., and where S[j] is clamped between
// S[start] (inclusive) and S[stop] (exclusive). If the given radius is not an
// integer, S[i - r - 1] and S[i + r + 1] are added to the sum, each weighted
// according to r - ⌊radius⌋.
function blurf(radius) {
    const radius0 = Math.floor(radius);
    if (radius0 === radius) return bluri(radius);
    const t = radius - radius0;
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius0 * S[start];
        const s0 = step * radius0;
        const s1 = s0 + step;
        for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s0)];
            T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
            sum -= S[Math.max(start, i - s0)];
        }
    };
}
// Like blurf, but optimized for integer radius.
function bluri(radius) {
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius * S[start];
        const s = step * radius;
        for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s)];
            T[i] = sum / w;
            sum -= S[Math.max(start, i - s)];
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bEr1m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>count);
function count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d7fnh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cross);
function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return (values)=>reduce(...values);
}
function cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    const lengths = values.map(length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some(empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Kj7J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cumsum);
function cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"63ogy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deviation);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
function deviation(values, valueof) {
    const v = (0, _varianceJsDefault.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

},{"./variance.js":"4UZOK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4UZOK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>variance);
function variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kkkz7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>extent);
function extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5h9sS":[function(require,module,exports,__globalThis) {
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Adder", ()=>Adder);
parcelHelpers.export(exports, "fsum", ()=>fsum);
parcelHelpers.export(exports, "fcumsum", ()=>fcumsum);
class Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function fsum(values, valueof) {
    const adder = new Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function fcumsum(values, valueof) {
    const adder = new Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dK75Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>group);
parcelHelpers.export(exports, "groups", ()=>groups);
parcelHelpers.export(exports, "flatGroup", ()=>flatGroup);
parcelHelpers.export(exports, "flatRollup", ()=>flatRollup);
parcelHelpers.export(exports, "rollup", ()=>rollup);
parcelHelpers.export(exports, "rollups", ()=>rollups);
parcelHelpers.export(exports, "index", ()=>index);
parcelHelpers.export(exports, "indexes", ()=>indexes);
var _internmap = require("internmap");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
function group(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), (0, _identityJsDefault.default), keys);
}
function groups(values, ...keys) {
    return nest(values, Array.from, (0, _identityJsDefault.default), keys);
}
function flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function flatGroup(values, ...keys) {
    return flatten(groups(values, ...keys), keys);
}
function flatRollup(values, reduce, ...keys) {
    return flatten(rollups(values, reduce, ...keys), keys);
}
function rollup(values, reduce, ...keys) {
    return nest(values, (0, _identityJsDefault.default), reduce, keys);
}
function rollups(values, reduce, ...keys) {
    return nest(values, Array.from, reduce, keys);
}
function index(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), unique, keys);
}
function indexes(values, ...keys) {
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, _internmap.InternMap)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

},{"internmap":"lN5oE","./identity.js":"fWWSu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lN5oE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternMap", ()=>InternMap);
parcelHelpers.export(exports, "InternSet", ()=>InternSet);
class InternMap extends Map {
    constructor(entries, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get(intern_get(this, key));
    }
    has(key) {
        return super.has(intern_get(this, key));
    }
    set(key, value) {
        return super.set(intern_set(this, key), value);
    }
    delete(key) {
        return super.delete(intern_delete(this, key));
    }
}
class InternSet extends Set {
    constructor(values, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has(intern_get(this, value));
    }
    add(value) {
        return super.add(intern_set(this, value));
    }
    delete(value) {
        return super.delete(intern_delete(this, value));
    }
}
function intern_get({ _intern, _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(value);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fWWSu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bd0HG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>groupSort);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
function groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, _sortJsDefault.default)((0, _groupJs.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, _ascendingJsDefault.default)(av, bv) || (0, _ascendingJsDefault.default)(ak, bk)) : (0, _sortJsDefault.default)((0, _groupJsDefault.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, _ascendingJsDefault.default)(ak, bk))).map(([key])=>key);
}

},{"./ascending.js":"fxpE9","./group.js":"dK75Z","./sort.js":"hn4qB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hn4qB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sort);
parcelHelpers.export(exports, "compareDefined", ()=>compareDefined);
parcelHelpers.export(exports, "ascendingDefined", ()=>ascendingDefined);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
function sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>ascendingDefined(f[i], f[j]));
        }
        return (0, _permuteJsDefault.default)(values, index);
    }
    return values.sort(compareDefined(f));
}
function compareDefined(compare = (0, _ascendingJsDefault.default)) {
    if (compare === (0, _ascendingJsDefault.default)) return ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

},{"./ascending.js":"fxpE9","./permute.js":"eLUwT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eLUwT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>permute);
function permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fSCEd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bin);
var _arrayJs = require("./array.js");
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
function bin() {
    var value = (0, _identityJsDefault.default), domain = (0, _extentJsDefault.default), threshold = (0, _sturgesJsDefault.default);
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === (0, _extentJsDefault.default)) [x0, x1] = (0, _niceJsDefault.default)(x0, x1, tn);
            tz = (0, _ticksJsDefault.default)(x0, x1, tn);
            // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, _ticksJs.tickIncrement)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === (0, _extentJsDefault.default)) {
                    const step = (0, _ticksJs.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        // Be careful not to mutate an array owned by the user!
        var m = tz.length, a = 0, b = m;
        while(tz[a] <= x0)++a;
        while(tz[b - 1] > x1)--b;
        if (a || b < m) tz = tz.slice(a, b), m = b - a;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, _bisectJsDefault.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.isArray(_) ? (0, _arrayJs.slice).call(_) : _), histogram) : threshold;
    };
    return histogram;
}

},{"./array.js":"aYFJZ","./bisect.js":"6E3K1","./constant.js":"a2vmN","./extent.js":"kkkz7","./identity.js":"fWWSu","./nice.js":"6opYb","./ticks.js":"hdIWy","./threshold/sturges.js":"5VRgb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aYFJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "map", ()=>map);
var array = Array.prototype;
var slice = array.slice;
var map = array.map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a2vmN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constant);
function constant(x) {
    return ()=>x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6opYb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
var _ticksJs = require("./ticks.js");
function nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, _ticksJs.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

},{"./ticks.js":"hdIWy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hdIWy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ticks);
parcelHelpers.export(exports, "tickIncrement", ()=>tickIncrement);
parcelHelpers.export(exports, "tickStep", ()=>tickStep);
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function ticks(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function tickIncrement(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return tickSpec(start, stop, count)[2];
}
function tickStep(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5VRgb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdSturges);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
function thresholdSturges(values) {
    return Math.max(1, Math.ceil(Math.log((0, _countJsDefault.default)(values)) / Math.LN2) + 1);
}

},{"../count.js":"bEr1m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ivGXE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdFreedmanDiaconis);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _quantileJs = require("../quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
function thresholdFreedmanDiaconis(values, min, max) {
    const c = (0, _countJsDefault.default)(values), d = (0, _quantileJsDefault.default)(values, 0.75) - (0, _quantileJsDefault.default)(values, 0.25);
    return c && d ? Math.ceil((max - min) / (2 * d * Math.pow(c, -1 / 3))) : 1;
}

},{"../count.js":"bEr1m","../quantile.js":"gtsMZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gtsMZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
parcelHelpers.export(exports, "quantileSorted", ()=>quantileSorted);
parcelHelpers.export(exports, "quantileIndex", ()=>quantileIndex);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _sortJs = require("./sort.js");
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
function quantile(values, p, valueof) {
    values = Float64Array.from((0, _numberJs.numbers)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, _minJsDefault.default)(values);
    if (p >= 1) return (0, _maxJsDefault.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, _maxJsDefault.default)((0, _quickselectJsDefault.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, _minJsDefault.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = (0, _numberJsDefault.default)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function quantileIndex(values, p, valueof = (0, _numberJsDefault.default)) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, _numberJsDefault.default)(valueof(values[i], i, values)));
    if (p <= 0) return (0, _minIndexJsDefault.default)(numbers);
    if (p >= 1) return (0, _maxIndexJsDefault.default)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, _quickselectJsDefault.default)(index, i, 0, j, (i, j)=>(0, _sortJs.ascendingDefined)(numbers[i], numbers[j]));
    i = (0, _greatestJsDefault.default)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}

},{"./max.js":"8VFj7","./maxIndex.js":"9TsNn","./min.js":"aV6tL","./minIndex.js":"4MZIY","./quickselect.js":"bjyfD","./number.js":"cFSaj","./sort.js":"hn4qB","./greatest.js":"ba9H2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8VFj7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
function max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9TsNn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>maxIndex);
function maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aV6tL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>min);
function min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4MZIY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>minIndex);
function minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bjyfD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quickselect);
var _sortJs = require("./sort.js");
function quickselect(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, _sortJs.ascendingDefined) : (0, _sortJs.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        swap(array, left, k);
        if (compare(array[right], t) > 0) swap(array, left, right);
        while(i < j){
            swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) swap(array, left, j);
        else ++j, swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

},{"./sort.js":"hn4qB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ba9H2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatest);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function greatest(values, compare = (0, _ascendingJsDefault.default)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, maxValue) > 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

},{"./ascending.js":"fxpE9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7aFxa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdScott);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _deviationJs = require("../deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
function thresholdScott(values, min, max) {
    const c = (0, _countJsDefault.default)(values), d = (0, _deviationJsDefault.default)(values);
    return c && d ? Math.ceil((max - min) * Math.cbrt(c) / (3.49 * d)) : 1;
}

},{"../count.js":"bEr1m","../deviation.js":"63ogy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lGLmc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mean);
function mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4CtA1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>median);
parcelHelpers.export(exports, "medianIndex", ()=>medianIndex);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
function median(values, valueof) {
    return (0, _quantileJsDefault.default)(values, 0.5, valueof);
}
function medianIndex(values, valueof) {
    return (0, _quantileJs.quantileIndex)(values, 0.5, valueof);
}

},{"./quantile.js":"gtsMZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fZD2z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>merge);
function* flatten(arrays) {
    for (const array of arrays)yield* array;
}
function merge(arrays) {
    return Array.from(flatten(arrays));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"49bDg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mode);
var _internmap = require("internmap");
function mode(values, valueof) {
    const counts = new (0, _internmap.InternMap)();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

},{"internmap":"lN5oE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3GyTU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pairs);
parcelHelpers.export(exports, "pair", ()=>pair);
function pairs(values, pairof = pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"egnZn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>range);
function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2fUwM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rank);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _sortJs = require("./sort.js");
function rank(values, valueof = (0, _ascendingJsDefault.default)) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = (0, _ascendingJsDefault.default);
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    values = Uint32Array.from(V, (_, i)=>i);
    // Risky chaining due to Safari 14 https://github.com/d3/d3-array/issues/123
    values.sort(valueof === (0, _ascendingJsDefault.default) ? (i, j)=>(0, _sortJs.ascendingDefined)(V[i], V[j]) : (0, _sortJs.compareDefined)(compareIndex));
    values.forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

},{"./ascending.js":"fxpE9","./sort.js":"hn4qB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g2WOH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>least);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function least(values, compare = (0, _ascendingJsDefault.default)) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, minValue) < 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

},{"./ascending.js":"fxpE9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cdgca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>leastIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
function leastIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _minIndexJsDefault.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

},{"./ascending.js":"fxpE9","./minIndex.js":"4MZIY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6pWs0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatestIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
function greatestIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _maxIndexJsDefault.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

},{"./ascending.js":"fxpE9","./maxIndex.js":"9TsNn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3j2zL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>scan);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
function scan(values, compare) {
    const index = (0, _leastIndexJsDefault.default)(values, compare);
    return index < 0 ? undefined : index;
}

},{"./leastIndex.js":"cdgca","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gHM4C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shuffler", ()=>shuffler);
exports.default = shuffler(Math.random);
function shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7UDGD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sum);
function sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f6Iqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transpose);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
function transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, _minJsDefault.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function length(d) {
    return d.length;
}

},{"./min.js":"aV6tL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"GnVPt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>zip);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
function zip() {
    return (0, _transposeJsDefault.default)(arguments);
}

},{"./transpose.js":"f6Iqo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iMs3v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>every);
function every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2SKDc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>some);
function some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lew24":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>filter);
function filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6QMxP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>map);
function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fO6yJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reduce);
function reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done, value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6VYWf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reverse);
function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"CzXyM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>difference);
var _internmap = require("internmap");
function difference(values, ...others) {
    values = new (0, _internmap.InternSet)(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

},{"internmap":"lN5oE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jsBdg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>disjoint);
var _internmap = require("internmap");
function disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new (0, _internmap.InternSet)();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

},{"internmap":"lN5oE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"XLnB1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>intersection);
var _internmap = require("internmap");
function intersection(values, ...others) {
    values = new (0, _internmap.InternSet)(values);
    others = others.map(set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function set(values) {
    return values instanceof (0, _internmap.InternSet) ? values : new (0, _internmap.InternSet)(values);
}

},{"internmap":"lN5oE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5pv38":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subset);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
function subset(values, other) {
    return (0, _supersetJsDefault.default)(other, values);
}

},{"./superset.js":"dQOGc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dQOGc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>superset);
function superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) return false;
            const ivalue = intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bPXjL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>union);
var _internmap = require("internmap");
function union(...others) {
    const set = new (0, _internmap.InternSet)();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

},{"internmap":"lN5oE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iySGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "axisTop", ()=>(0, _axisJs.axisTop));
parcelHelpers.export(exports, "axisRight", ()=>(0, _axisJs.axisRight));
parcelHelpers.export(exports, "axisBottom", ()=>(0, _axisJs.axisBottom));
parcelHelpers.export(exports, "axisLeft", ()=>(0, _axisJs.axisLeft));
var _axisJs = require("./axis.js");

},{"./axis.js":"aPlTU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aPlTU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "axisTop", ()=>axisTop);
parcelHelpers.export(exports, "axisRight", ()=>axisRight);
parcelHelpers.export(exports, "axisBottom", ()=>axisBottom);
parcelHelpers.export(exports, "axisLeft", ()=>axisLeft);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var top = 1, right = 2, bottom = 3, left = 4, epsilon = 1e-6;
function translateX(x) {
    return "translate(" + x + ",0)";
}
function translateY(y) {
    return "translate(0," + y + ")";
}
function number(scale) {
    return (d)=>+scale(d);
}
function center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function entering() {
    return !this.__axis;
}
function axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === top || orient === left ? -1 : 1, x = orient === left || orient === right ? "x" : "y", transform = orient === top || orient === bottom ? translateX : translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, _identityJsDefault.default) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? center : number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = Array.from(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function axisTop(scale) {
    return axis(top, scale);
}
function axisRight(scale) {
    return axis(right, scale);
}
function axisBottom(scale) {
    return axis(bottom, scale);
}
function axisLeft(scale) {
    return axis(left, scale);
}

},{"./identity.js":"l7JPd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l7JPd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"45MMu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "brush", ()=>(0, _brushJsDefault.default));
parcelHelpers.export(exports, "brushX", ()=>(0, _brushJs.brushX));
parcelHelpers.export(exports, "brushY", ()=>(0, _brushJs.brushY));
parcelHelpers.export(exports, "brushSelection", ()=>(0, _brushJs.brushSelection));
var _brushJs = require("./brush.js");
var _brushJsDefault = parcelHelpers.interopDefault(_brushJs);

},{"./brush.js":"jTwf2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jTwf2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "brushSelection", ()=>brushSelection);
parcelHelpers.export(exports, "brushX", ()=>brushX);
parcelHelpers.export(exports, "brushY", ()=>brushY);
parcelHelpers.export(exports, "default", ()=>function() {
        return brush(XY);
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Drag = require("d3-drag");
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _d3Transition = require("d3-transition");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
var MODE_DRAG = {
    name: "drag"
}, MODE_SPACE = {
    name: "space"
}, MODE_HANDLE = {
    name: "handle"
}, MODE_CENTER = {
    name: "center"
};
const { abs, max, min } = Math;
function number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function number2(e) {
    return [
        number1(e[0]),
        number1(e[1])
    ];
}
var X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map(type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map(type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map(type),
    input: function(xy) {
        return xy == null ? null : number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function brushSelection(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function brushX() {
    return brush(X);
}
function brushY() {
    return brush(Y);
}
function brush(dim) {
    var extent = defaultExtent, filter = defaultFilter, touchable = defaultTouchable, keys = true, listeners = (0, _d3Dispatch.dispatch)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function() {
            var extent = local(this).extent;
            (0, _d3Selection.select)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, _d3Interpolate.interpolate)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, _d3Transition.interrupt)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, _d3Selection.select)(this), selection = local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, _d3Selection.select)(this.that).datum();
            listeners.call(type, this.that, new (0, _eventJsDefault.default)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : keys && event.altKey ? MODE_CENTER : MODE_HANDLE, signX = dim === Y ? null : signsX[type], signY = dim === X ? null : signsY[type], state = local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, _d3Selection.pointer)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, _d3Transition.interrupt)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === Y ? W : min(pts[0][0], pts[1][0]),
                    n0 = dim === X ? N : min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === Y ? E : max(pts[0][0], pts[1][0]),
                    s0 = dim === X ? S : max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, _d3Selection.select)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, _d3Selection.select)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, _d3Drag.dragDisable)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, _d3Selection.pointer)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if (abs(point.cur[0] - point[0]) > abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, _noeventJsDefault.default)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case MODE_SPACE:
                case MODE_DRAG:
                    if (signX) dx = max(W - w0, min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = max(N - n0, min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = max(W, min(E, points[0][0])), e1 = max(W, min(E, points[1][0])), signX = 1;
                        if (signY) n1 = max(N, min(S, points[0][1])), s1 = max(N, min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = max(W - w0, min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = max(W - e0, min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = max(N - n0, min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = max(N - s0, min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case MODE_CENTER:
                    if (signX) w1 = max(W, min(E, w0 - dx * signX)), e1 = max(W, min(E, e0 + dx * signX));
                    if (signY) n1 = max(N, min(S, n0 - dy * signY)), s1 = max(N, min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, _noeventJs.nopropagation)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, _d3Drag.dragEnable)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if (empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === MODE_HANDLE || mode === MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = MODE_SPACE;
                        overlay.attr("cursor", cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, _noeventJsDefault.default)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = MODE_HANDLE;
                        }
                        overlay.attr("cursor", cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, _noeventJsDefault.default)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

},{"d3-dispatch":"3OarL","d3-drag":"8wlzb","d3-interpolate":"6bUMz","d3-selection":"4X1qO","d3-transition":"22YTW","./constant.js":"7AWXT","./event.js":"eRFHa","./noevent.js":"2f5dT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3OarL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dispatch", ()=>(0, _dispatchJsDefault.default));
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);

},{"./dispatch.js":"5auRZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5auRZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var noop = {
    value: ()=>{}
};
function dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new Dispatch(_);
}
function Dispatch(_) {
    this._ = _;
}
function parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
Dispatch.prototype = dispatch.prototype = {
    constructor: Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
exports.default = dispatch;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8wlzb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "drag", ()=>(0, _dragJsDefault.default));
parcelHelpers.export(exports, "dragDisable", ()=>(0, _nodragJsDefault.default));
parcelHelpers.export(exports, "dragEnable", ()=>(0, _nodragJs.yesdrag));
var _dragJs = require("./drag.js");
var _dragJsDefault = parcelHelpers.interopDefault(_dragJs);
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);

},{"./drag.js":"lHKbz","./nodrag.js":"kdOhy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lHKbz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable, gestures = {}, listeners = (0, _d3Dispatch.dispatch)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
        function drag(selection) {
            selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, (0, _noeventJs.nonpassive)).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        function mousedowned(event, d) {
            if (touchending || !filter.call(this, event, d)) return;
            var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
            if (!gesture) return;
            (0, _d3Selection.select)(event.view).on("mousemove.drag", mousemoved, (0, _noeventJs.nonpassivecapture)).on("mouseup.drag", mouseupped, (0, _noeventJs.nonpassivecapture));
            (0, _nodragJsDefault.default)(event.view);
            (0, _noeventJs.nopropagation)(event);
            mousemoving = false;
            mousedownx = event.clientX;
            mousedowny = event.clientY;
            gesture("start", event);
        }
        function mousemoved(event) {
            (0, _noeventJsDefault.default)(event);
            if (!mousemoving) {
                var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
                mousemoving = dx * dx + dy * dy > clickDistance2;
            }
            gestures.mouse("drag", event);
        }
        function mouseupped(event) {
            (0, _d3Selection.select)(event.view).on("mousemove.drag mouseup.drag", null);
            (0, _nodragJs.yesdrag)(event.view, mousemoving);
            (0, _noeventJsDefault.default)(event);
            gestures.mouse("end", event);
        }
        function touchstarted(event, d) {
            if (!filter.call(this, event, d)) return;
            var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
                (0, _noeventJs.nopropagation)(event);
                gesture("start", event, touches[i]);
            }
        }
        function touchmoved(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJsDefault.default)(event);
                gesture("drag", event, touches[i]);
            }
        }
        function touchended(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, 500); // Ghost clicks are delayed!
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJs.nopropagation)(event);
                gesture("end", event, touches[i]);
            }
        }
        function beforestart(that, container, event, d, identifier, touch) {
            var dispatch = listeners.copy(), p = (0, _d3Selection.pointer)(touch || event, container), dx, dy, s;
            if ((s = subject.call(that, new (0, _eventJsDefault.default)("beforestart", {
                sourceEvent: event,
                target: drag,
                identifier,
                active,
                x: p[0],
                y: p[1],
                dx: 0,
                dy: 0,
                dispatch
            }), d)) == null) return;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return function gesture(type, event, touch) {
                var p0 = p, n;
                switch(type){
                    case "start":
                        gestures[identifier] = gesture, n = active++;
                        break;
                    case "end":
                        delete gestures[identifier], --active; // falls through
                    case "drag":
                        p = (0, _d3Selection.pointer)(touch || event, container), n = active;
                        break;
                }
                dispatch.call(type, that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: event,
                    subject: s,
                    target: drag,
                    identifier,
                    active: n,
                    x: p[0] + dx,
                    y: p[1] + dy,
                    dx: p[0] - p0[0],
                    dy: p[1] - p0[1],
                    dispatch
                }), d);
            };
        }
        drag.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : filter;
        };
        drag.container = function(_) {
            return arguments.length ? (container = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : container;
        };
        drag.subject = function(_) {
            return arguments.length ? (subject = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : subject;
        };
        drag.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : touchable;
        };
        drag.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? drag : value;
        };
        drag.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
        };
        return drag;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Selection = require("d3-selection");
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function defaultContainer() {
    return this.parentNode;
}
function defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}

},{"d3-dispatch":"3OarL","d3-selection":"4X1qO","./nodrag.js":"kdOhy","./noevent.js":"ee8b9","./constant.js":"7QQHE","./event.js":"fLjxV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4X1qO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>(0, _createJsDefault.default));
parcelHelpers.export(exports, "creator", ()=>(0, _creatorJsDefault.default));
parcelHelpers.export(exports, "local", ()=>(0, _localJsDefault.default));
parcelHelpers.export(exports, "matcher", ()=>(0, _matcherJsDefault.default));
parcelHelpers.export(exports, "namespace", ()=>(0, _namespaceJsDefault.default));
parcelHelpers.export(exports, "namespaces", ()=>(0, _namespacesJsDefault.default));
parcelHelpers.export(exports, "pointer", ()=>(0, _pointerJsDefault.default));
parcelHelpers.export(exports, "pointers", ()=>(0, _pointersJsDefault.default));
parcelHelpers.export(exports, "select", ()=>(0, _selectJsDefault.default));
parcelHelpers.export(exports, "selectAll", ()=>(0, _selectAllJsDefault.default));
parcelHelpers.export(exports, "selection", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "selector", ()=>(0, _selectorJsDefault.default));
parcelHelpers.export(exports, "selectorAll", ()=>(0, _selectorAllJsDefault.default));
parcelHelpers.export(exports, "style", ()=>(0, _styleJs.styleValue));
parcelHelpers.export(exports, "window", ()=>(0, _windowJsDefault.default));
var _createJs = require("./create.js");
var _createJsDefault = parcelHelpers.interopDefault(_createJs);
var _creatorJs = require("./creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _localJs = require("./local.js");
var _localJsDefault = parcelHelpers.interopDefault(_localJs);
var _matcherJs = require("./matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);
var _pointerJs = require("./pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _pointersJs = require("./pointers.js");
var _pointersJsDefault = parcelHelpers.interopDefault(_pointersJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _indexJs = require("./selection/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _selectorJs = require("./selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
var _selectorAllJs = require("./selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
var _styleJs = require("./selection/style.js");
var _windowJs = require("./window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);

},{"./create.js":"3tKui","./creator.js":"ezoqt","./local.js":"ifnNk","./matcher.js":"lnw0I","./namespace.js":"cC2ib","./namespaces.js":"42Uc5","./pointer.js":"7Fz3k","./pointers.js":"8B499","./select.js":"9vZrP","./selectAll.js":"6ZtYY","./selection/index.js":"6Wrb9","./selector.js":"kuGZg","./selectorAll.js":"eZyUz","./selection/style.js":"bk8Rn","./window.js":"86qEZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3tKui":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        return (0, _selectJsDefault.default)((0, _creatorJsDefault.default)(name).call(document.documentElement));
    });
var _creatorJs = require("./creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);

},{"./creator.js":"ezoqt","./select.js":"9vZrP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ezoqt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        return (fullname.local ? creatorFixed : creatorInherit)(fullname);
    });
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
function creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, _namespacesJs.xhtml) && document.documentElement.namespaceURI === (0, _namespacesJs.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}

},{"./namespace.js":"cC2ib","./namespaces.js":"42Uc5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cC2ib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var prefix = name += "", i = prefix.indexOf(":");
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return (0, _namespacesJsDefault.default).hasOwnProperty(prefix) ? {
            space: (0, _namespacesJsDefault.default)[prefix],
            local: name
        } : name; // eslint-disable-line no-prototype-builtins
    });
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);

},{"./namespaces.js":"42Uc5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"42Uc5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xhtml", ()=>xhtml);
var xhtml = "http://www.w3.org/1999/xhtml";
exports.default = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: xhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9vZrP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _indexJs.Selection)([
            [
                document.querySelector(selector)
            ]
        ], [
            document.documentElement
        ]) : new (0, _indexJs.Selection)([
            [
                selector
            ]
        ], (0, _indexJs.root));
    });
var _indexJs = require("./selection/index.js");

},{"./selection/index.js":"6Wrb9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Wrb9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "root", ()=>root);
parcelHelpers.export(exports, "Selection", ()=>Selection);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectChildJs = require("./selectChild.js");
var _selectChildJsDefault = parcelHelpers.interopDefault(_selectChildJs);
var _selectChildrenJs = require("./selectChildren.js");
var _selectChildrenJsDefault = parcelHelpers.interopDefault(_selectChildrenJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _enterJs = require("./enter.js");
var _enterJsDefault = parcelHelpers.interopDefault(_enterJs);
var _exitJs = require("./exit.js");
var _exitJsDefault = parcelHelpers.interopDefault(_exitJs);
var _joinJs = require("./join.js");
var _joinJsDefault = parcelHelpers.interopDefault(_joinJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _orderJs = require("./order.js");
var _orderJsDefault = parcelHelpers.interopDefault(_orderJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _callJs = require("./call.js");
var _callJsDefault = parcelHelpers.interopDefault(_callJs);
var _nodesJs = require("./nodes.js");
var _nodesJsDefault = parcelHelpers.interopDefault(_nodesJs);
var _nodeJs = require("./node.js");
var _nodeJsDefault = parcelHelpers.interopDefault(_nodeJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _propertyJs = require("./property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
var _classedJs = require("./classed.js");
var _classedJsDefault = parcelHelpers.interopDefault(_classedJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _htmlJs = require("./html.js");
var _htmlJsDefault = parcelHelpers.interopDefault(_htmlJs);
var _raiseJs = require("./raise.js");
var _raiseJsDefault = parcelHelpers.interopDefault(_raiseJs);
var _lowerJs = require("./lower.js");
var _lowerJsDefault = parcelHelpers.interopDefault(_lowerJs);
var _appendJs = require("./append.js");
var _appendJsDefault = parcelHelpers.interopDefault(_appendJs);
var _insertJs = require("./insert.js");
var _insertJsDefault = parcelHelpers.interopDefault(_insertJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _cloneJs = require("./clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _datumJs = require("./datum.js");
var _datumJsDefault = parcelHelpers.interopDefault(_datumJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);
var _iteratorJs = require("./iterator.js");
var _iteratorJsDefault = parcelHelpers.interopDefault(_iteratorJs);
var root = [
    null
];
function Selection(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function selection() {
    return new Selection([
        [
            document.documentElement
        ]
    ], root);
}
function selection_selection() {
    return this;
}
Selection.prototype = selection.prototype = {
    constructor: Selection,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    selectChild: (0, _selectChildJsDefault.default),
    selectChildren: (0, _selectChildrenJsDefault.default),
    filter: (0, _filterJsDefault.default),
    data: (0, _dataJsDefault.default),
    enter: (0, _enterJsDefault.default),
    exit: (0, _exitJsDefault.default),
    join: (0, _joinJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: selection_selection,
    order: (0, _orderJsDefault.default),
    sort: (0, _sortJsDefault.default),
    call: (0, _callJsDefault.default),
    nodes: (0, _nodesJsDefault.default),
    node: (0, _nodeJsDefault.default),
    size: (0, _sizeJsDefault.default),
    empty: (0, _emptyJsDefault.default),
    each: (0, _eachJsDefault.default),
    attr: (0, _attrJsDefault.default),
    style: (0, _styleJsDefault.default),
    property: (0, _propertyJsDefault.default),
    classed: (0, _classedJsDefault.default),
    text: (0, _textJsDefault.default),
    html: (0, _htmlJsDefault.default),
    raise: (0, _raiseJsDefault.default),
    lower: (0, _lowerJsDefault.default),
    append: (0, _appendJsDefault.default),
    insert: (0, _insertJsDefault.default),
    remove: (0, _removeJsDefault.default),
    clone: (0, _cloneJsDefault.default),
    datum: (0, _datumJsDefault.default),
    on: (0, _onJsDefault.default),
    dispatch: (0, _dispatchJsDefault.default),
    [Symbol.iterator]: (0, _iteratorJsDefault.default)
};
exports.default = selection;

},{"./select.js":"2y6IC","./selectAll.js":"6oULT","./selectChild.js":"5Yrvb","./selectChildren.js":"6Yauw","./filter.js":"1LayI","./data.js":"fbkjq","./enter.js":"8GP02","./exit.js":"fkn3m","./join.js":"8S7gu","./merge.js":"57JiC","./order.js":"9T2Ba","./sort.js":"7zXTM","./call.js":"hYapj","./nodes.js":"hrizv","./node.js":"e6dE9","./size.js":"YZt5S","./empty.js":"bKXLz","./each.js":"2Mel9","./attr.js":"aczRU","./style.js":"bk8Rn","./property.js":"4LA3p","./classed.js":"1c3I4","./text.js":"82MlS","./html.js":"4XIzi","./raise.js":"4JI2g","./lower.js":"EHLd5","./append.js":"fd0pv","./insert.js":"8mQYg","./remove.js":"6W6Ys","./clone.js":"dpUFD","./datum.js":"1HWWL","./on.js":"5EZKk","./dispatch.js":"8HT4n","./iterator.js":"9b61j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2y6IC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select !== "function") select = (0, _selectorJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
            }
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);

},{"./index.js":"6Wrb9","../selector.js":"kuGZg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kuGZg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? none : function() {
            return this.querySelector(selector);
        };
    });
function none() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6oULT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select === "function") select = arrayAll(select);
        else select = (0, _selectorAllJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                subgroups.push(select.call(node, node.__data__, i, group));
                parents.push(node);
            }
        }
        return new (0, _indexJs.Selection)(subgroups, parents);
    });
var _indexJs = require("./index.js");
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _selectorAllJs = require("../selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
function arrayAll(select) {
    return function() {
        return (0, _arrayJsDefault.default)(select.apply(this, arguments));
    };
}

},{"./index.js":"6Wrb9","../array.js":"lBJaC","../selectorAll.js":"eZyUz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lBJaC":[function(require,module,exports,__globalThis) {
// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>array);
function array(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eZyUz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? empty : function() {
            return this.querySelectorAll(selector);
        };
    });
function empty() {
    return [];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Yrvb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var find = Array.prototype.find;
function childFind(match) {
    return function() {
        return find.call(this.children, match);
    };
}
function childFirst() {
    return this.firstElementChild;
}

},{"../matcher.js":"lnw0I","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lnw0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return function() {
            return this.matches(selector);
        };
    });
parcelHelpers.export(exports, "childMatcher", ()=>childMatcher);
function childMatcher(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Yauw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var filter = Array.prototype.filter;
function children() {
    return Array.from(this.children);
}
function childrenFilter(match) {
    return function() {
        return filter.call(this.children, match);
    };
}

},{"../matcher.js":"lnw0I","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1LayI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _matcherJsDefault.default)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _matcherJs = require("../matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);

},{"./index.js":"6Wrb9","../matcher.js":"lnw0I","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fbkjq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value, key) {
        if (!arguments.length) return Array.from(this, datum);
        var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
        if (typeof value !== "function") value = (0, _constantJsDefault.default)(value);
        for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
            var parent = parents[j], group = groups[j], groupLength = group.length, data = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
            bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
            // Now connect the enter nodes to their following update node, such that
            // appendChild can insert the materialized enter node before this node,
            // rather than at the end of the parent node.
            for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
                if (i0 >= i1) i1 = i0 + 1;
                while(!(next = updateGroup[i1]) && ++i1 < dataLength);
                previous._next = next || null;
            }
        }
        update = new (0, _indexJs.Selection)(update, parents);
        update._enter = enter;
        update._exit = exit;
        return update;
    });
var _indexJs = require("./index.js");
var _enterJs = require("./enter.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function datum(node) {
    return node.__data__;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}

},{"./index.js":"6Wrb9","./enter.js":"8GP02","../constant.js":"eeECh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8GP02":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._enter || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
parcelHelpers.export(exports, "EnterNode", ()=>EnterNode);
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");
function EnterNode(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
EnterNode.prototype = {
    constructor: EnterNode,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

},{"./sparse.js":"9Pcvu","./index.js":"6Wrb9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Pcvu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(update) {
        return new Array(update.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eeECh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fkn3m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._exit || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");

},{"./sparse.js":"9Pcvu","./index.js":"6Wrb9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8S7gu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(onenter, onupdate, onexit) {
        var enter = this.enter(), update = this, exit = this.exit();
        if (typeof onenter === "function") {
            enter = onenter(enter);
            if (enter) enter = enter.selection();
        } else enter = enter.append(onenter + "");
        if (onupdate != null) {
            update = onupdate(update);
            if (update) update = update.selection();
        }
        if (onexit == null) exit.remove();
        else onexit(exit);
        return enter && update ? enter.merge(update).order() : update;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"57JiC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        var selection = context.selection ? context.selection() : context;
        for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Selection)(merges, this._parents);
    });
var _indexJs = require("./index.js");

},{"./index.js":"6Wrb9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9T2Ba":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
            for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7zXTM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        if (!compare) compare = ascending;
        function compareNode(a, b) {
            return a && b ? compare(a.__data__, b.__data__) : !a - !b;
        }
        for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
            sortgroup.sort(compareNode);
        }
        return new (0, _indexJs.Selection)(sortgroups, this._parents).order();
    });
var _indexJs = require("./index.js");
function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"./index.js":"6Wrb9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hYapj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var callback = arguments[0];
        arguments[0] = this;
        callback.apply(null, arguments);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hrizv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Array.from(this);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e6dE9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
            var node = group[i];
            if (node) return node;
        }
        return null;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"YZt5S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let size = 0;
        for (const node of this)++size; // eslint-disable-line no-unused-vars
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bKXLz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return !this.node();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Mel9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aczRU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        if (arguments.length < 2) {
            var node = this.node();
            return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
        }
        return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
    });
var _namespaceJs = require("../namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}

},{"../namespace.js":"cC2ib","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bk8Rn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
    });
parcelHelpers.export(exports, "styleValue", ()=>styleValue);
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function styleValue(node, name) {
    return node.style.getPropertyValue(name) || (0, _windowJsDefault.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

},{"../window.js":"86qEZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"86qEZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
         || node.document && node // node is a Window
         || node.defaultView; // node is a Document
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4LA3p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
    });
function propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1c3I4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var names = classArray(name + "");
        if (arguments.length < 2) {
            var list = classList(this.node()), i = -1, n = names.length;
            while(++i < n)if (!list.contains(names[i])) return false;
            return true;
        }
        return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
    });
function classArray(string) {
    return string.trim().split(/^|\s+/);
}
function classList(node) {
    return node.classList || new ClassList(node);
}
function ClassList(node) {
    this._node = node;
    this._names = classArray(node.getAttribute("class") || "");
}
ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function classedAdd(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function classedRemove(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function classedTrue(names) {
    return function() {
        classedAdd(this, names);
    };
}
function classedFalse(names) {
    return function() {
        classedRemove(this, names);
    };
}
function classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"82MlS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
    });
function textRemove() {
    this.textContent = "";
}
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4XIzi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
    });
function htmlRemove() {
    this.innerHTML = "";
}
function htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4JI2g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(raise);
    });
function raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"EHLd5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(lower);
    });
function lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fd0pv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name);
        return this.select(function() {
            return this.appendChild(create.apply(this, arguments));
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);

},{"../creator.js":"ezoqt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8mQYg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, before) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name), select = before == null ? constantNull : typeof before === "function" ? before : (0, _selectorJsDefault.default)(before);
        return this.select(function() {
            return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
function constantNull() {
    return null;
}

},{"../creator.js":"ezoqt","../selector.js":"kuGZg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6W6Ys":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(remove);
    });
function remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dpUFD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(deep) {
        return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
    });
function selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1HWWL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.property("__data__", value) : this.node().__data__;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5EZKk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(typename, value, options) {
        var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
        if (arguments.length < 2) {
            var on = this.node().__on;
            if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
                if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
            }
            return;
        }
        on = value ? onAdd : onRemove;
        for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
        return this;
    });
function contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8HT4n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(type, params) {
        return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
    });
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function dispatchEvent(node, type, params) {
    var window = (0, _windowJsDefault.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function dispatchConstant(type, params) {
    return function() {
        return dispatchEvent(this, type, params);
    };
}
function dispatchFunction(type, params) {
    return function() {
        return dispatchEvent(this, type, params.apply(this, arguments));
    };
}

},{"../window.js":"86qEZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9b61j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function*() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ifnNk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>local);
var nextId = 0;
function local() {
    return new Local;
}
function Local() {
    this._ = "@" + (++nextId).toString(36);
}
Local.prototype = local.prototype = {
    constructor: Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Fz3k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event, node) {
        event = (0, _sourceEventJsDefault.default)(event);
        if (node === undefined) node = event.currentTarget;
        if (node) {
            var svg = node.ownerSVGElement || node;
            if (svg.createSVGPoint) {
                var point = svg.createSVGPoint();
                point.x = event.clientX, point.y = event.clientY;
                point = point.matrixTransform(node.getScreenCTM().inverse());
                return [
                    point.x,
                    point.y
                ];
            }
            if (node.getBoundingClientRect) {
                var rect = node.getBoundingClientRect();
                return [
                    event.clientX - rect.left - node.clientLeft,
                    event.clientY - rect.top - node.clientTop
                ];
            }
        }
        return [
            event.pageX,
            event.pageY
        ];
    });
var _sourceEventJs = require("./sourceEvent.js");
var _sourceEventJsDefault = parcelHelpers.interopDefault(_sourceEventJs);

},{"./sourceEvent.js":"6cJLu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6cJLu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event) {
        let sourceEvent;
        while(sourceEvent = event.sourceEvent)event = sourceEvent;
        return event;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8B499":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(events, node) {
        if (events.target) {
            events = (0, _sourceEventJsDefault.default)(events);
            if (node === undefined) node = events.currentTarget;
            events = events.touches || [
                events
            ];
        }
        return Array.from(events, (event)=>(0, _pointerJsDefault.default)(event, node));
    });
var _pointerJs = require("./pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _sourceEventJs = require("./sourceEvent.js");
var _sourceEventJsDefault = parcelHelpers.interopDefault(_sourceEventJs);

},{"./pointer.js":"7Fz3k","./sourceEvent.js":"6cJLu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ZtYY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _indexJs.Selection)([
            document.querySelectorAll(selector)
        ], [
            document.documentElement
        ]) : new (0, _indexJs.Selection)([
            (0, _arrayJsDefault.default)(selector)
        ], (0, _indexJs.root));
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _indexJs = require("./selection/index.js");

},{"./array.js":"lBJaC","./selection/index.js":"6Wrb9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kdOhy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(view) {
        var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        if ("onselectstart" in root) selection.on("selectstart.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        else {
            root.__noselect = root.style.MozUserSelect;
            root.style.MozUserSelect = "none";
        }
    });
parcelHelpers.export(exports, "yesdrag", ()=>yesdrag);
var _d3Selection = require("d3-selection");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
function yesdrag(view, noclick) {
    var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

},{"d3-selection":"4X1qO","./noevent.js":"ee8b9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ee8b9":[function(require,module,exports,__globalThis) {
// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nonpassive", ()=>nonpassive);
parcelHelpers.export(exports, "nonpassivecapture", ()=>nonpassivecapture);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
const nonpassive = {
    passive: false
};
const nonpassivecapture = {
    capture: true,
    passive: false
};
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7QQHE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fLjxV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DragEvent);
function DragEvent(type, { sourceEvent, subject, target, identifier, active, x, y, dx, dy, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
DragEvent.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6bUMz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>(0, _valueJsDefault.default));
parcelHelpers.export(exports, "interpolateArray", ()=>(0, _arrayJsDefault.default));
parcelHelpers.export(exports, "interpolateBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "interpolateBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "interpolateDate", ()=>(0, _dateJsDefault.default));
parcelHelpers.export(exports, "interpolateDiscrete", ()=>(0, _discreteJsDefault.default));
parcelHelpers.export(exports, "interpolateHue", ()=>(0, _hueJsDefault.default));
parcelHelpers.export(exports, "interpolateNumber", ()=>(0, _numberJsDefault.default));
parcelHelpers.export(exports, "interpolateNumberArray", ()=>(0, _numberArrayJsDefault.default));
parcelHelpers.export(exports, "interpolateObject", ()=>(0, _objectJsDefault.default));
parcelHelpers.export(exports, "interpolateRound", ()=>(0, _roundJsDefault.default));
parcelHelpers.export(exports, "interpolateString", ()=>(0, _stringJsDefault.default));
parcelHelpers.export(exports, "interpolateTransformCss", ()=>(0, _indexJs.interpolateTransformCss));
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>(0, _indexJs.interpolateTransformSvg));
parcelHelpers.export(exports, "interpolateZoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "interpolateRgb", ()=>(0, _rgbJsDefault.default));
parcelHelpers.export(exports, "interpolateRgbBasis", ()=>(0, _rgbJs.rgbBasis));
parcelHelpers.export(exports, "interpolateRgbBasisClosed", ()=>(0, _rgbJs.rgbBasisClosed));
parcelHelpers.export(exports, "interpolateHsl", ()=>(0, _hslJsDefault.default));
parcelHelpers.export(exports, "interpolateHslLong", ()=>(0, _hslJs.hslLong));
parcelHelpers.export(exports, "interpolateLab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "interpolateHcl", ()=>(0, _hclJsDefault.default));
parcelHelpers.export(exports, "interpolateHclLong", ()=>(0, _hclJs.hclLong));
parcelHelpers.export(exports, "interpolateCubehelix", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixLong", ()=>(0, _cubehelixJs.cubehelixLong));
parcelHelpers.export(exports, "piecewise", ()=>(0, _piecewiseJsDefault.default));
parcelHelpers.export(exports, "quantize", ()=>(0, _quantizeJsDefault.default));
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":"cwEse","./array.js":"lLjCm","./basis.js":"9reI8","./basisClosed.js":"aKD3P","./date.js":"flWxY","./discrete.js":"iBgXa","./hue.js":"3jcd6","./number.js":"9apRc","./numberArray.js":"dwDrC","./object.js":"4cdV8","./round.js":"3ityw","./string.js":"9GlJ4","./transform/index.js":"fp09F","./zoom.js":"8lTfP","./rgb.js":"hI9ZC","./hsl.js":"8xnkl","./lab.js":"iZ291","./hcl.js":"wNCDq","./cubehelix.js":"7lP4n","./piecewise.js":"aazor","./quantize.js":"l1Tsh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cwEse":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? (0, _constantJsDefault.default)(b) : (t === "number" ? (0, _numberJsDefault.default) : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgbJsDefault.default) : (0, _stringJsDefault.default) : b instanceof (0, _d3Color.color) ? (0, _rgbJsDefault.default) : b instanceof Date ? (0, _dateJsDefault.default) : (0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : Array.isArray(b) ? (0, _arrayJs.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, _objectJsDefault.default) : (0, _numberJsDefault.default))(a, b);
    });
var _d3Color = require("d3-color");
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _arrayJs = require("./array.js");
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);

},{"d3-color":"euMEi","./rgb.js":"hI9ZC","./array.js":"lLjCm","./date.js":"flWxY","./number.js":"9apRc","./object.js":"4cdV8","./string.js":"9GlJ4","./constant.js":"1LLXa","./numberArray.js":"dwDrC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"euMEi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>(0, _colorJsDefault.default));
parcelHelpers.export(exports, "rgb", ()=>(0, _colorJs.rgb));
parcelHelpers.export(exports, "hsl", ()=>(0, _colorJs.hsl));
parcelHelpers.export(exports, "lab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "hcl", ()=>(0, _labJs.hcl));
parcelHelpers.export(exports, "lch", ()=>(0, _labJs.lch));
parcelHelpers.export(exports, "gray", ()=>(0, _labJs.gray));
parcelHelpers.export(exports, "cubehelix", ()=>(0, _cubehelixJsDefault.default));
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);

},{"./color.js":"bKuhM","./lab.js":"19n2J","./cubehelix.js":"aeJEJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bKuhM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"dMzf8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMzf8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"19n2J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gray", ()=>gray);
parcelHelpers.export(exports, "default", ()=>lab);
parcelHelpers.export(exports, "Lab", ()=>Lab);
parcelHelpers.export(exports, "lch", ()=>lch);
parcelHelpers.export(exports, "hcl", ()=>hcl);
parcelHelpers.export(exports, "Hcl", ()=>Hcl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
// https://observablehq.com/@mbostock/lab-and-rgb
const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Lab, lab, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = Xn * lab2xyz(x);
        y = Yn * lab2xyz(y);
        z = Zn * lab2xyz(z);
        return new (0, _colorJs.Rgb)(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, _mathJs.degrees);
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * (0, _mathJs.radians);
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, _defineJsDefault.default)(Hcl, hcl, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return hcl2lab(this).rgb();
    }
}));

},{"./define.js":"dMzf8","./color.js":"bKuhM","./math.js":"bPhIW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bPhIW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "degrees", ()=>degrees);
const radians = Math.PI / 180;
const degrees = 180 / Math.PI;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aeJEJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cubehelix);
parcelHelpers.export(exports, "Cubehelix", ()=>Cubehelix);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, _mathJs.degrees) - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Cubehelix, cubehelix, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        k = k == null ? (0, _colorJs.brighter) : Math.pow((0, _colorJs.brighter), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, _colorJs.darker) : Math.pow((0, _colorJs.darker), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, _mathJs.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, _colorJs.Rgb)(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"./define.js":"dMzf8","./color.js":"bKuhM","./math.js":"bPhIW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hI9ZC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"euMEi","./basis.js":"9reI8","./basisClosed.js":"aKD3P","./color.js":"giYtf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9reI8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aKD3P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"9reI8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"giYtf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"1LLXa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1LLXa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lLjCm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return ((0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : genericArray)(a, b);
    });
parcelHelpers.export(exports, "genericArray", ()=>genericArray);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _valueJsDefault.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"./value.js":"cwEse","./numberArray.js":"dwDrC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dwDrC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    });
parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"flWxY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9apRc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4cdV8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, _valueJsDefault.default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    });
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);

},{"./value.js":"cwEse","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9GlJ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"9apRc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iBgXa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(range) {
        var n = range.length;
        return function(t) {
            return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3jcd6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = (0, _colorJs.hue)(+a, +b);
        return function(t) {
            var x = i(t);
            return x - 360 * Math.floor(x / 360);
        };
    });
var _colorJs = require("./color.js");

},{"./color.js":"giYtf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ityw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fp09F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolateTransformCss", ()=>interpolateTransformCss);
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>interpolateTransformSvg);
var _numberJs = require("../number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _parseJs = require("./parse.js");
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _numberJsDefault.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _numberJsDefault.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform((0, _parseJs.parseCss), "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform((0, _parseJs.parseSvg), ", ", ")", ")");

},{"../number.js":"9apRc","./parse.js":"7mmNL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7mmNL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable no-undef */ parcelHelpers.export(exports, "parseCss", ()=>parseCss);
parcelHelpers.export(exports, "parseSvg", ()=>parseSvg);
var _decomposeJs = require("./decompose.js");
var _decomposeJsDefault = parcelHelpers.interopDefault(_decomposeJs);
var svgNode;
function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, _decomposeJs.identity) : (0, _decomposeJsDefault.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return 0, _decomposeJs.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return 0, _decomposeJs.identity;
    value = value.matrix;
    return (0, _decomposeJsDefault.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"./decompose.js":"dRxfx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dRxfx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>function(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees,
            skewX: Math.atan(skewX) * degrees,
            scaleX: scaleX,
            scaleY: scaleY
        };
    });
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8lTfP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8xnkl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hslLong", ()=>hslLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hsl)(start)).h, (end = (0, _d3Color.hsl)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hsl((0, _colorJs.hue));
var hslLong = hsl((0, _colorJsDefault.default));

},{"d3-color":"euMEi","./color.js":"giYtf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iZ291":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>lab);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function lab(start, end) {
    var l = (0, _colorJsDefault.default)((start = (0, _d3Color.lab)(start)).l, (end = (0, _d3Color.lab)(end)).l), a = (0, _colorJsDefault.default)(start.a, end.a), b = (0, _colorJsDefault.default)(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

},{"d3-color":"euMEi","./color.js":"giYtf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"wNCDq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hclLong", ()=>hclLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hcl)(start)).h, (end = (0, _d3Color.hcl)(end)).h), c = (0, _colorJsDefault.default)(start.c, end.c), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hcl((0, _colorJs.hue));
var hclLong = hcl((0, _colorJsDefault.default));

},{"d3-color":"euMEi","./color.js":"giYtf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7lP4n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubehelixLong", ()=>cubehelixLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
exports.default = cubehelix((0, _colorJs.hue));
var cubehelixLong = cubehelix((0, _colorJsDefault.default));

},{"d3-color":"euMEi","./color.js":"giYtf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aazor":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>piecewise);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
function piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, _valueJsDefault.default);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

},{"./value.js":"cwEse","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l1Tsh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(interpolator, n) {
        var samples = new Array(n);
        for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
        return samples;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"22YTW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transition", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "active", ()=>(0, _activeJsDefault.default));
parcelHelpers.export(exports, "interrupt", ()=>(0, _interruptJsDefault.default));
var _indexJs = require("./selection/index.js");
var _indexJs1 = require("./transition/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _activeJs = require("./active.js");
var _activeJsDefault = parcelHelpers.interopDefault(_activeJs);
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"./selection/index.js":"cJ2TJ","./transition/index.js":"j6T08","./active.js":"leqIj","./interrupt.js":"i5Rhy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cJ2TJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _d3Selection = require("d3-selection");
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
(0, _d3Selection.selection).prototype.interrupt = (0, _interruptJsDefault.default);
(0, _d3Selection.selection).prototype.transition = (0, _transitionJsDefault.default);

},{"d3-selection":"4X1qO","./interrupt.js":"cScDw","./transition.js":"dmCwB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cScDw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        return this.each(function() {
            (0, _interruptJsDefault.default)(this, name);
        });
    });
var _interruptJs = require("../interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"../interrupt.js":"i5Rhy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i5Rhy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, name) {
        var schedules = node.__transition, schedule, active, empty = true, i;
        if (!schedules) return;
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).name !== name) {
                empty = false;
                continue;
            }
            active = schedule.state > (0, _scheduleJs.STARTING) && schedule.state < (0, _scheduleJs.ENDING);
            schedule.state = (0, _scheduleJs.ENDED);
            schedule.timer.stop();
            schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
            delete schedules[i];
        }
        if (empty) delete node.__transition;
    });
var _scheduleJs = require("./transition/schedule.js");

},{"./transition/schedule.js":"5oN6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5oN6D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CREATED", ()=>CREATED);
parcelHelpers.export(exports, "SCHEDULED", ()=>SCHEDULED);
parcelHelpers.export(exports, "STARTING", ()=>STARTING);
parcelHelpers.export(exports, "STARTED", ()=>STARTED);
parcelHelpers.export(exports, "RUNNING", ()=>RUNNING);
parcelHelpers.export(exports, "ENDING", ()=>ENDING);
parcelHelpers.export(exports, "ENDED", ()=>ENDED);
parcelHelpers.export(exports, "default", ()=>function(node, name, id, index, group, timing) {
        var schedules = node.__transition;
        if (!schedules) node.__transition = {};
        else if (id in schedules) return;
        create(node, id, {
            name: name,
            index: index,
            group: group,
            on: emptyOn,
            tween: emptyTween,
            time: timing.time,
            delay: timing.delay,
            duration: timing.duration,
            ease: timing.ease,
            timer: null,
            state: CREATED
        });
    });
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "get", ()=>get);
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var emptyOn = (0, _d3Dispatch.dispatch)("start", "end", "cancel", "interrupt");
var emptyTween = [];
var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;
function init(node, id) {
    var schedule = get(node, id);
    if (schedule.state > CREATED) throw new Error("too late; already scheduled");
    return schedule;
}
function set(node, id) {
    var schedule = get(node, id);
    if (schedule.state > STARTED) throw new Error("too late; already running");
    return schedule;
}
function get(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, _d3Timer.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = SCHEDULED;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== SCHEDULED) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === STARTED) return (0, _d3Timer.timeout)(start);
            // Interrupt the active transition, if any.
            if (o.state === RUNNING) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, _d3Timer.timeout)(function() {
            if (self.state === STARTED) {
                self.state = RUNNING;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = STARTING;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== STARTING) return; // interrupted
        self.state = STARTED;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === ENDING) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = ENDED;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

},{"d3-dispatch":"3OarL","d3-timer":"9ST7W","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ST7W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>(0, _timerJs.now));
parcelHelpers.export(exports, "timer", ()=>(0, _timerJs.timer));
parcelHelpers.export(exports, "timerFlush", ()=>(0, _timerJs.timerFlush));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeoutJsDefault.default));
parcelHelpers.export(exports, "interval", ()=>(0, _intervalJsDefault.default));
var _timerJs = require("./timer.js");
var _timeoutJs = require("./timeout.js");
var _timeoutJsDefault = parcelHelpers.interopDefault(_timeoutJs);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);

},{"./timer.js":"9kvEY","./timeout.js":"banRI","./interval.js":"boLPC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9kvEY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>now);
parcelHelpers.export(exports, "Timer", ()=>Timer);
parcelHelpers.export(exports, "timer", ()=>timer);
parcelHelpers.export(exports, "timerFlush", ()=>timerFlush);
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
    clockNow = 0;
}
function Timer() {
    this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
    constructor: Timer,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && taskTail !== this) {
            if (taskTail) taskTail._next = this;
            else taskHead = this;
            taskTail = this;
        }
        this._call = callback;
        this._time = time;
        sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            sleep();
        }
    }
};
function timer(callback, delay, time) {
    var t = new Timer;
    t.restart(callback, delay, time);
    return t;
}
function timerFlush() {
    now(); // Get the current time, if not already set.
    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = taskHead, e;
    while(t){
        if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --frame;
}
function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;
    try {
        timerFlush();
    } finally{
        frame = 0;
        nap();
        clockNow = 0;
    }
}
function poke() {
    var now = clock.now(), delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}
function nap() {
    var t0, t1 = taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
    taskTail = t0;
    sleep(time);
}
function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.
    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
        if (interval) interval = clearInterval(interval);
    } else {
        if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
        frame = 1, setFrame(wake);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"banRI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer);
        delay = delay == null ? 0 : +delay;
        t.restart((elapsed)=>{
            t.stop();
            callback(elapsed + delay);
        }, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"9kvEY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"boLPC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer), total = delay;
        if (delay == null) return t.restart(callback, delay, time), t;
        t._restart = t.restart;
        t.restart = function(callback, delay, time) {
            delay = +delay, time = time == null ? (0, _timerJs.now)() : +time;
            t._restart(function tick(elapsed) {
                elapsed += total;
                t._restart(tick, total += delay, time);
                callback(elapsed);
            }, delay, time);
        };
        t.restart(callback, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"9kvEY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dmCwB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var id, timing;
        if (name instanceof (0, _indexJs.Transition)) id = name._id, name = name._name;
        else id = (0, _indexJs.newId)(), (timing = defaultTiming).time = (0, _d3Timer.now)(), name = name == null ? null : name + "";
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, _scheduleJsDefault.default)(node, name, id, i, group, timing || inherit(node, id));
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id);
    });
var _indexJs = require("../transition/index.js");
var _scheduleJs = require("../transition/schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);
var _d3Ease = require("d3-ease");
var _d3Timer = require("d3-timer");
var defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, _d3Ease.easeCubicInOut)
};
function inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}

},{"../transition/index.js":"j6T08","../transition/schedule.js":"5oN6D","d3-ease":"jsg3z","d3-timer":"9ST7W","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j6T08":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "default", ()=>transition);
parcelHelpers.export(exports, "newId", ()=>newId);
var _d3Selection = require("d3-selection");
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _attrTweenJs = require("./attrTween.js");
var _attrTweenJsDefault = parcelHelpers.interopDefault(_attrTweenJs);
var _delayJs = require("./delay.js");
var _delayJsDefault = parcelHelpers.interopDefault(_delayJs);
var _durationJs = require("./duration.js");
var _durationJsDefault = parcelHelpers.interopDefault(_durationJs);
var _easeJs = require("./ease.js");
var _easeJsDefault = parcelHelpers.interopDefault(_easeJs);
var _easeVaryingJs = require("./easeVarying.js");
var _easeVaryingJsDefault = parcelHelpers.interopDefault(_easeVaryingJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectionJs = require("./selection.js");
var _selectionJsDefault = parcelHelpers.interopDefault(_selectionJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _styleTweenJs = require("./styleTween.js");
var _styleTweenJsDefault = parcelHelpers.interopDefault(_styleTweenJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _textTweenJs = require("./textTween.js");
var _textTweenJsDefault = parcelHelpers.interopDefault(_textTweenJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
var _tweenJs = require("./tween.js");
var _tweenJsDefault = parcelHelpers.interopDefault(_tweenJs);
var _endJs = require("./end.js");
var _endJsDefault = parcelHelpers.interopDefault(_endJs);
var id = 0;
function Transition(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function transition(name) {
    return (0, _d3Selection.selection)().transition(name);
}
function newId() {
    return ++id;
}
var selection_prototype = (0, _d3Selection.selection).prototype;
Transition.prototype = transition.prototype = {
    constructor: Transition,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    selectChild: selection_prototype.selectChild,
    selectChildren: selection_prototype.selectChildren,
    filter: (0, _filterJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: (0, _selectionJsDefault.default),
    transition: (0, _transitionJsDefault.default),
    call: selection_prototype.call,
    nodes: selection_prototype.nodes,
    node: selection_prototype.node,
    size: selection_prototype.size,
    empty: selection_prototype.empty,
    each: selection_prototype.each,
    on: (0, _onJsDefault.default),
    attr: (0, _attrJsDefault.default),
    attrTween: (0, _attrTweenJsDefault.default),
    style: (0, _styleJsDefault.default),
    styleTween: (0, _styleTweenJsDefault.default),
    text: (0, _textJsDefault.default),
    textTween: (0, _textTweenJsDefault.default),
    remove: (0, _removeJsDefault.default),
    tween: (0, _tweenJsDefault.default),
    delay: (0, _delayJsDefault.default),
    duration: (0, _durationJsDefault.default),
    ease: (0, _easeJsDefault.default),
    easeVarying: (0, _easeVaryingJsDefault.default),
    end: (0, _endJsDefault.default),
    [Symbol.iterator]: selection_prototype[Symbol.iterator]
};

},{"d3-selection":"4X1qO","./attr.js":"8PTsi","./attrTween.js":"6ag2X","./delay.js":"8AD7s","./duration.js":"kQlEg","./ease.js":"1SSJz","./easeVarying.js":"kplvT","./filter.js":"1VSJJ","./merge.js":"gfjbc","./on.js":"hUKvy","./remove.js":"aiWiK","./select.js":"fdVuj","./selectAll.js":"3rRUl","./selection.js":"il3nc","./style.js":"gPWbs","./styleTween.js":"fWpjy","./text.js":"eYQH3","./textTween.js":"huvM7","./transition.js":"cjeQ2","./tween.js":"8hpHl","./end.js":"kgdRs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8PTsi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _d3Selection.namespace)(name), i = fullname === "transform" ? (0, _d3Interpolate.interpolateTransformSvg) : (0, _interpolateJsDefault.default);
        return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, (0, _tweenJs.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}

},{"d3-interpolate":"6bUMz","d3-selection":"4X1qO","./tween.js":"8hpHl","./interpolate.js":"95WgE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8hpHl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var id = this._id;
        name += "";
        if (arguments.length < 2) {
            var tween = (0, _scheduleJs.get)(this.node(), id).tween;
            for(var i = 0, n = tween.length, t; i < n; ++i){
                if ((t = tween[i]).name === name) return t.value;
            }
            return null;
        }
        return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
    });
parcelHelpers.export(exports, "tweenValue", ()=>tweenValue);
var _scheduleJs = require("./schedule.js");
function tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function tweenValue(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, _scheduleJs.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, _scheduleJs.get)(node, id).value[name];
    };
}

},{"./schedule.js":"5oN6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"95WgE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var c;
        return (typeof b === "number" ? (0, _d3Interpolate.interpolateNumber) : b instanceof (0, _d3Color.color) ? (0, _d3Interpolate.interpolateRgb) : (c = (0, _d3Color.color)(b)) ? (b = c, _d3Interpolate.interpolateRgb) : (0, _d3Interpolate.interpolateString))(a, b);
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");

},{"d3-color":"euMEi","d3-interpolate":"6bUMz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ag2X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var key = "attr." + name;
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        var fullname = (0, _d3Selection.namespace)(name);
        return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
    });
var _d3Selection = require("d3-selection");
function attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"d3-selection":"4X1qO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8AD7s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).delay;
    });
var _scheduleJs = require("./schedule.js");
function delayFunction(id, value) {
    return function() {
        (0, _scheduleJs.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function delayConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.init)(this, id).delay = value;
    };
}

},{"./schedule.js":"5oN6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQlEg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).duration;
    });
var _scheduleJs = require("./schedule.js");
function durationFunction(id, value) {
    return function() {
        (0, _scheduleJs.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function durationConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.set)(this, id).duration = value;
    };
}

},{"./schedule.js":"5oN6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1SSJz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each(easeConstant(id, value)) : (0, _scheduleJs.get)(this.node(), id).ease;
    });
var _scheduleJs = require("./schedule.js");
function easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, _scheduleJs.set)(this, id).ease = value;
    };
}

},{"./schedule.js":"5oN6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kplvT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        if (typeof value !== "function") throw new Error;
        return this.each(easeVarying(this._id, value));
    });
var _scheduleJs = require("./schedule.js");
function easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, _scheduleJs.set)(this, id).ease = v;
    };
}

},{"./schedule.js":"5oN6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1VSJJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _d3Selection.matcher)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, this._name, this._id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");

},{"d3-selection":"4X1qO","./index.js":"j6T08","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gfjbc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(transition) {
        if (transition._id !== this._id) throw new Error;
        for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Transition)(merges, this._parents, this._name, this._id);
    });
var _indexJs = require("./index.js");

},{"./index.js":"j6T08","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUKvy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, listener) {
        var id = this._id;
        return arguments.length < 2 ? (0, _scheduleJs.get)(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
    });
var _scheduleJs = require("./schedule.js");
function start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function onFunction(id, name, listener) {
    var on0, on1, sit = start(name) ? (0, _scheduleJs.init) : (0, _scheduleJs.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}

},{"./schedule.js":"5oN6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aiWiK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.on("end.remove", removeFunction(this._id));
    });
function removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fdVuj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selector)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
                (0, _scheduleJsDefault.default)(subgroup[i], name, id, i, subgroup, (0, _scheduleJs.get)(node, id));
            }
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":"4X1qO","./index.js":"j6T08","./schedule.js":"5oN6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3rRUl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selectorAll)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, _scheduleJs.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, _scheduleJsDefault.default)(child, name, id, k, children, inherit);
                subgroups.push(children);
                parents.push(node);
            }
        }
        return new (0, _indexJs.Transition)(subgroups, parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":"4X1qO","./index.js":"j6T08","./schedule.js":"5oN6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"il3nc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new Selection(this._groups, this._parents);
    });
var _d3Selection = require("d3-selection");
var Selection = (0, _d3Selection.selection).prototype.constructor;

},{"d3-selection":"4X1qO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gPWbs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var i = (name += "") === "transform" ? (0, _d3Interpolate.interpolateTransformCss) : (0, _interpolateJsDefault.default);
        return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, (0, _tweenJs.tweenValue)(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _scheduleJs = require("./schedule.js");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), string1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}

},{"d3-interpolate":"6bUMz","d3-selection":"4X1qO","./schedule.js":"5oN6D","./tween.js":"8hpHl","./interpolate.js":"95WgE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fWpjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var key = "style." + (name += "");
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
    });
function styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eYQH3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.tween("text", typeof value === "function" ? textFunction((0, _tweenJs.tweenValue)(this, "text", value)) : textConstant(value == null ? "" : value + ""));
    });
var _tweenJs = require("./tween.js");
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}

},{"./tween.js":"8hpHl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"huvM7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var key = "text";
        if (arguments.length < 1) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, textTween(value));
    });
function textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cjeQ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var name = this._name, id0 = this._id, id1 = (0, _indexJs.newId)();
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                var inherit = (0, _scheduleJs.get)(node, id0);
                (0, _scheduleJsDefault.default)(node, name, id1, i, group, {
                    time: inherit.time + inherit.delay + inherit.duration,
                    delay: 0,
                    duration: inherit.duration,
                    ease: inherit.ease
                });
            }
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id1);
    });
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"./index.js":"j6T08","./schedule.js":"5oN6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kgdRs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var on0, on1, that = this, id = that._id, size = that.size();
        return new Promise(function(resolve, reject) {
            var cancel = {
                value: reject
            }, end = {
                value: function() {
                    if (--size === 0) resolve();
                }
            };
            that.each(function() {
                var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on;
                // If this node shared a dispatch with the previous node,
                // just assign the updated shared dispatch and we’re done!
                // Otherwise, copy-on-write.
                if (on !== on0) {
                    on1 = (on0 = on).copy();
                    on1._.cancel.push(cancel);
                    on1._.interrupt.push(cancel);
                    on1._.end.push(end);
                }
                schedule.on = on1;
            });
            // The selection was empty, resolve end immediately
            if (size === 0) resolve();
        });
    });
var _scheduleJs = require("./schedule.js");

},{"./schedule.js":"5oN6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jsg3z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeLinear", ()=>(0, _linearJs.linear));
parcelHelpers.export(exports, "easeQuad", ()=>(0, _quadJs.quadInOut));
parcelHelpers.export(exports, "easeQuadIn", ()=>(0, _quadJs.quadIn));
parcelHelpers.export(exports, "easeQuadOut", ()=>(0, _quadJs.quadOut));
parcelHelpers.export(exports, "easeQuadInOut", ()=>(0, _quadJs.quadInOut));
parcelHelpers.export(exports, "easeCubic", ()=>(0, _cubicJs.cubicInOut));
parcelHelpers.export(exports, "easeCubicIn", ()=>(0, _cubicJs.cubicIn));
parcelHelpers.export(exports, "easeCubicOut", ()=>(0, _cubicJs.cubicOut));
parcelHelpers.export(exports, "easeCubicInOut", ()=>(0, _cubicJs.cubicInOut));
parcelHelpers.export(exports, "easePoly", ()=>(0, _polyJs.polyInOut));
parcelHelpers.export(exports, "easePolyIn", ()=>(0, _polyJs.polyIn));
parcelHelpers.export(exports, "easePolyOut", ()=>(0, _polyJs.polyOut));
parcelHelpers.export(exports, "easePolyInOut", ()=>(0, _polyJs.polyInOut));
parcelHelpers.export(exports, "easeSin", ()=>(0, _sinJs.sinInOut));
parcelHelpers.export(exports, "easeSinIn", ()=>(0, _sinJs.sinIn));
parcelHelpers.export(exports, "easeSinOut", ()=>(0, _sinJs.sinOut));
parcelHelpers.export(exports, "easeSinInOut", ()=>(0, _sinJs.sinInOut));
parcelHelpers.export(exports, "easeExp", ()=>(0, _expJs.expInOut));
parcelHelpers.export(exports, "easeExpIn", ()=>(0, _expJs.expIn));
parcelHelpers.export(exports, "easeExpOut", ()=>(0, _expJs.expOut));
parcelHelpers.export(exports, "easeExpInOut", ()=>(0, _expJs.expInOut));
parcelHelpers.export(exports, "easeCircle", ()=>(0, _circleJs.circleInOut));
parcelHelpers.export(exports, "easeCircleIn", ()=>(0, _circleJs.circleIn));
parcelHelpers.export(exports, "easeCircleOut", ()=>(0, _circleJs.circleOut));
parcelHelpers.export(exports, "easeCircleInOut", ()=>(0, _circleJs.circleInOut));
parcelHelpers.export(exports, "easeBounce", ()=>(0, _bounceJs.bounceOut));
parcelHelpers.export(exports, "easeBounceIn", ()=>(0, _bounceJs.bounceIn));
parcelHelpers.export(exports, "easeBounceOut", ()=>(0, _bounceJs.bounceOut));
parcelHelpers.export(exports, "easeBounceInOut", ()=>(0, _bounceJs.bounceInOut));
parcelHelpers.export(exports, "easeBack", ()=>(0, _backJs.backInOut));
parcelHelpers.export(exports, "easeBackIn", ()=>(0, _backJs.backIn));
parcelHelpers.export(exports, "easeBackOut", ()=>(0, _backJs.backOut));
parcelHelpers.export(exports, "easeBackInOut", ()=>(0, _backJs.backInOut));
parcelHelpers.export(exports, "easeElastic", ()=>(0, _elasticJs.elasticOut));
parcelHelpers.export(exports, "easeElasticIn", ()=>(0, _elasticJs.elasticIn));
parcelHelpers.export(exports, "easeElasticOut", ()=>(0, _elasticJs.elasticOut));
parcelHelpers.export(exports, "easeElasticInOut", ()=>(0, _elasticJs.elasticInOut));
var _linearJs = require("./linear.js");
var _quadJs = require("./quad.js");
var _cubicJs = require("./cubic.js");
var _polyJs = require("./poly.js");
var _sinJs = require("./sin.js");
var _expJs = require("./exp.js");
var _circleJs = require("./circle.js");
var _bounceJs = require("./bounce.js");
var _backJs = require("./back.js");
var _elasticJs = require("./elastic.js");

},{"./linear.js":"f9q9L","./quad.js":"ezUl5","./cubic.js":"5ew2f","./poly.js":"bCDXT","./sin.js":"iQ5bD","./exp.js":"2CeCT","./circle.js":"3nxff","./bounce.js":"413Lc","./back.js":"8lwRV","./elastic.js":"eppr5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f9q9L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linear", ()=>linear);
const linear = (t)=>+t;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ezUl5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quadIn", ()=>quadIn);
parcelHelpers.export(exports, "quadOut", ()=>quadOut);
parcelHelpers.export(exports, "quadInOut", ()=>quadInOut);
function quadIn(t) {
    return t * t;
}
function quadOut(t) {
    return t * (2 - t);
}
function quadInOut(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ew2f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicIn", ()=>cubicIn);
parcelHelpers.export(exports, "cubicOut", ()=>cubicOut);
parcelHelpers.export(exports, "cubicInOut", ()=>cubicInOut);
function cubicIn(t) {
    return t * t * t;
}
function cubicOut(t) {
    return --t * t * t + 1;
}
function cubicInOut(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bCDXT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyIn", ()=>polyIn);
parcelHelpers.export(exports, "polyOut", ()=>polyOut);
parcelHelpers.export(exports, "polyInOut", ()=>polyInOut);
var exponent = 3;
var polyIn = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}(exponent);
var polyOut = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}(exponent);
var polyInOut = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}(exponent);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iQ5bD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sinIn", ()=>sinIn);
parcelHelpers.export(exports, "sinOut", ()=>sinOut);
parcelHelpers.export(exports, "sinInOut", ()=>sinInOut);
var pi = Math.PI, halfPi = pi / 2;
function sinIn(t) {
    return +t === 1 ? 1 : 1 - Math.cos(t * halfPi);
}
function sinOut(t) {
    return Math.sin(t * halfPi);
}
function sinInOut(t) {
    return (1 - Math.cos(pi * t)) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2CeCT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expIn", ()=>expIn);
parcelHelpers.export(exports, "expOut", ()=>expOut);
parcelHelpers.export(exports, "expInOut", ()=>expInOut);
var _mathJs = require("./math.js");
function expIn(t) {
    return (0, _mathJs.tpmt)(1 - +t);
}
function expOut(t) {
    return 1 - (0, _mathJs.tpmt)(t);
}
function expInOut(t) {
    return ((t *= 2) <= 1 ? (0, _mathJs.tpmt)(1 - t) : 2 - (0, _mathJs.tpmt)(t - 1)) / 2;
}

},{"./math.js":"j0biq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j0biq":[function(require,module,exports,__globalThis) {
// tpmt is two power minus ten times t scaled to [0,1]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tpmt", ()=>tpmt);
function tpmt(x) {
    return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3nxff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "circleIn", ()=>circleIn);
parcelHelpers.export(exports, "circleOut", ()=>circleOut);
parcelHelpers.export(exports, "circleInOut", ()=>circleInOut);
function circleIn(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function circleOut(t) {
    return Math.sqrt(1 - --t * t);
}
function circleInOut(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"413Lc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bounceIn", ()=>bounceIn);
parcelHelpers.export(exports, "bounceOut", ()=>bounceOut);
parcelHelpers.export(exports, "bounceInOut", ()=>bounceInOut);
var b1 = 4 / 11, b2 = 6 / 11, b3 = 8 / 11, b4 = 3 / 4, b5 = 9 / 11, b6 = 10 / 11, b7 = 15 / 16, b8 = 21 / 22, b9 = 63 / 64, b0 = 1 / b1 / b1;
function bounceIn(t) {
    return 1 - bounceOut(1 - t);
}
function bounceOut(t) {
    return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}
function bounceInOut(t) {
    return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8lwRV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "backIn", ()=>backIn);
parcelHelpers.export(exports, "backOut", ()=>backOut);
parcelHelpers.export(exports, "backInOut", ()=>backInOut);
var overshoot = 1.70158;
var backIn = function custom(s) {
    s = +s;
    function backIn(t) {
        return (t = +t) * t * (s * (t - 1) + t);
    }
    backIn.overshoot = custom;
    return backIn;
}(overshoot);
var backOut = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((t + 1) * s + t) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}(overshoot);
var backInOut = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}(overshoot);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eppr5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elasticIn", ()=>elasticIn);
parcelHelpers.export(exports, "elasticOut", ()=>elasticOut);
parcelHelpers.export(exports, "elasticInOut", ()=>elasticInOut);
var _mathJs = require("./math.js");
var tau = 2 * Math.PI, amplitude = 1, period = 0.3;
var elasticIn = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticIn(t) {
        return a * (0, _mathJs.tpmt)(- --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}(amplitude, period);
var elasticOut = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticOut(t) {
        return 1 - a * (0, _mathJs.tpmt)(t = +t) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}(amplitude, period);
var elasticInOut = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * (0, _mathJs.tpmt)(-t) * Math.sin((s - t) / p) : 2 - a * (0, _mathJs.tpmt)(t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}(amplitude, period);

},{"./math.js":"j0biq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"leqIj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, name) {
        var schedules = node.__transition, schedule, i;
        if (schedules) {
            name = name == null ? null : name + "";
            for(i in schedules){
                if ((schedule = schedules[i]).state > (0, _scheduleJs.SCHEDULED) && schedule.name === name) return new (0, _indexJs.Transition)([
                    [
                        node
                    ]
                ], root, name, +i);
            }
        }
        return null;
    });
var _indexJs = require("./transition/index.js");
var _scheduleJs = require("./transition/schedule.js");
var root = [
    null
];

},{"./transition/index.js":"j6T08","./transition/schedule.js":"5oN6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7AWXT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eRFHa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BrushEvent);
function BrushEvent(type, { sourceEvent, target, selection, mode, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2f5dT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eKd4K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chord", ()=>(0, _chordJsDefault.default));
parcelHelpers.export(exports, "chordTranspose", ()=>(0, _chordJs.chordTranspose));
parcelHelpers.export(exports, "chordDirected", ()=>(0, _chordJs.chordDirected));
parcelHelpers.export(exports, "ribbon", ()=>(0, _ribbonJsDefault.default));
parcelHelpers.export(exports, "ribbonArrow", ()=>(0, _ribbonJs.ribbonArrow));
var _chordJs = require("./chord.js");
var _chordJsDefault = parcelHelpers.interopDefault(_chordJs);
var _ribbonJs = require("./ribbon.js");
var _ribbonJsDefault = parcelHelpers.interopDefault(_ribbonJs);

},{"./chord.js":"chkxa","./ribbon.js":"i8lCw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"chkxa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return chord(false, false);
    });
parcelHelpers.export(exports, "chordTranspose", ()=>chordTranspose);
parcelHelpers.export(exports, "chordDirected", ()=>chordDirected);
var _mathJs = require("./math.js");
function range(i, j) {
    return Array.from({
        length: j - i
    }, (_, k)=>i + k);
}
function compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
function chordTranspose() {
    return chord(false, true);
}
function chordDirected() {
    return chord(true, false);
}
function chord(directed, transpose) {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = new Array(n), groupIndex = range(0, n), chords = new Array(n * n), groups = new Array(n), k = 0, dx;
        matrix = Float64Array.from({
            length: n * n
        }, transpose ? (_, i)=>matrix[i % n][i / n | 0] : (_, i)=>matrix[i / n | 0][i % n]);
        // Compute the scaling factor from value to angle in [0, 2pi].
        for(let i = 0; i < n; ++i){
            let x = 0;
            for(let j = 0; j < n; ++j)x += matrix[i * n + j] + directed * matrix[j * n + i];
            k += groupSums[i] = x;
        }
        k = (0, _mathJs.max)(0, (0, _mathJs.tau) - padAngle * n) / k;
        dx = k ? padAngle : (0, _mathJs.tau) / n;
        // Compute the angles for each group and constituent chord.
        {
            let x = 0;
            if (sortGroups) groupIndex.sort((a, b)=>sortGroups(groupSums[a], groupSums[b]));
            for (const i of groupIndex){
                const x0 = x;
                if (directed) {
                    const subgroupIndex = range(~n + 1, n).filter((j)=>j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
                    for (const j of subgroupIndex)if (j < 0) {
                        const chord = chords[~j * n + i] || (chords[~j * n + i] = {
                            source: null,
                            target: null
                        });
                        chord.target = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[~j * n + i] * k,
                            value: matrix[~j * n + i]
                        };
                    } else {
                        const chord = chords[i * n + j] || (chords[i * n + j] = {
                            source: null,
                            target: null
                        });
                        chord.source = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[i * n + j] * k,
                            value: matrix[i * n + j]
                        };
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                } else {
                    const subgroupIndex = range(0, n).filter((j)=>matrix[i * n + j] || matrix[j * n + i]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(matrix[i * n + a], matrix[i * n + b]));
                    for (const j of subgroupIndex){
                        let chord;
                        if (i < j) {
                            chord = chords[i * n + j] || (chords[i * n + j] = {
                                source: null,
                                target: null
                            });
                            chord.source = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                        } else {
                            chord = chords[j * n + i] || (chords[j * n + i] = {
                                source: null,
                                target: null
                            });
                            chord.target = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                            if (i === j) chord.source = chord.target;
                        }
                        if (chord.source && chord.target && chord.source.value < chord.target.value) {
                            const source = chord.source;
                            chord.source = chord.target;
                            chord.target = source;
                        }
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                }
                x += dx;
            }
        }
        // Remove empty chords.
        chords = Object.values(chords);
        chords.groups = groups;
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function(_) {
        return arguments.length ? (padAngle = (0, _mathJs.max)(0, _), chord) : padAngle;
    };
    chord.sortGroups = function(_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function(_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function(_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}

},{"./math.js":"cSdr3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cSdr3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
var abs = Math.abs;
var cos = Math.cos;
var sin = Math.sin;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = pi * 2;
var max = Math.max;
var epsilon = 1e-12;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i8lCw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return ribbon();
    });
parcelHelpers.export(exports, "ribbonArrow", ()=>ribbonArrow);
var _d3Path = require("d3-path");
var _arrayJs = require("./array.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
function defaultSource(d) {
    return d.source;
}
function defaultTarget(d) {
    return d.target;
}
function defaultRadius(d) {
    return d.radius;
}
function defaultStartAngle(d) {
    return d.startAngle;
}
function defaultEndAngle(d) {
    return d.endAngle;
}
function defaultPadAngle() {
    return 0;
}
function defaultArrowheadRadius() {
    return 10;
}
function ribbon(headRadius) {
    var source = defaultSource, target = defaultTarget, sourceRadius = defaultRadius, targetRadius = defaultRadius, startAngle = defaultStartAngle, endAngle = defaultEndAngle, padAngle = defaultPadAngle, context = null;
    function ribbon() {
        var buffer, s = source.apply(this, arguments), t = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = (0, _arrayJs.slice).call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, _mathJs.halfPi), sa1 = endAngle.apply(this, argv) - (0, _mathJs.halfPi), tr = +targetRadius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, _mathJs.halfPi), ta1 = endAngle.apply(this, argv) - (0, _mathJs.halfPi);
        if (!context) context = buffer = (0, _d3Path.path)();
        if (ap > (0, _mathJs.epsilon)) {
            if ((0, _mathJs.abs)(sa1 - sa0) > ap * 2 + (0, _mathJs.epsilon)) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
            else sa0 = sa1 = (sa0 + sa1) / 2;
            if ((0, _mathJs.abs)(ta1 - ta0) > ap * 2 + (0, _mathJs.epsilon)) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
            else ta0 = ta1 = (ta0 + ta1) / 2;
        }
        context.moveTo(sr * (0, _mathJs.cos)(sa0), sr * (0, _mathJs.sin)(sa0));
        context.arc(0, 0, sr, sa0, sa1);
        if (sa0 !== ta0 || sa1 !== ta1) {
            if (headRadius) {
                var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
                context.quadraticCurveTo(0, 0, tr2 * (0, _mathJs.cos)(ta0), tr2 * (0, _mathJs.sin)(ta0));
                context.lineTo(tr * (0, _mathJs.cos)(ta2), tr * (0, _mathJs.sin)(ta2));
                context.lineTo(tr2 * (0, _mathJs.cos)(ta1), tr2 * (0, _mathJs.sin)(ta1));
            } else {
                context.quadraticCurveTo(0, 0, tr * (0, _mathJs.cos)(ta0), tr * (0, _mathJs.sin)(ta0));
                context.arc(0, 0, tr, ta0, ta1);
            }
        }
        context.quadraticCurveTo(0, 0, sr * (0, _mathJs.cos)(sa0), sr * (0, _mathJs.sin)(sa0));
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    if (headRadius) ribbon.headRadius = function(_) {
        return arguments.length ? (headRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : headRadius;
    };
    ribbon.radius = function(_) {
        return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : sourceRadius;
    };
    ribbon.sourceRadius = function(_) {
        return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : sourceRadius;
    };
    ribbon.targetRadius = function(_) {
        return arguments.length ? (targetRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : targetRadius;
    };
    ribbon.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : startAngle;
    };
    ribbon.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : endAngle;
    };
    ribbon.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : padAngle;
    };
    ribbon.source = function(_) {
        return arguments.length ? (source = _, ribbon) : source;
    };
    ribbon.target = function(_) {
        return arguments.length ? (target = _, ribbon) : target;
    };
    ribbon.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
    };
    return ribbon;
}
function ribbonArrow() {
    return ribbon(defaultArrowheadRadius);
}

},{"d3-path":"gnRAQ","./array.js":"kE9XC","./constant.js":"4hVZX","./math.js":"cSdr3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gnRAQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Path", ()=>(0, _pathJs.Path));
parcelHelpers.export(exports, "path", ()=>(0, _pathJs.path));
parcelHelpers.export(exports, "pathRound", ()=>(0, _pathJs.pathRound));
var _pathJs = require("./path.js");

},{"./path.js":"3fsH9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3fsH9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Path", ()=>Path);
parcelHelpers.export(exports, "path", ()=>path);
parcelHelpers.export(exports, "pathRound", ()=>pathRound);
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class Path {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? append : appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > epsilon) this._append`A${r},${r},0,${+(da >= pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function path() {
    return new Path;
}
// Allow instanceof d3.path
path.prototype = Path.prototype;
function pathRound(digits = 3) {
    return new Path(+digits);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kE9XC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4hVZX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9cRyX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contours", ()=>(0, _contoursJsDefault.default));
parcelHelpers.export(exports, "contourDensity", ()=>(0, _densityJsDefault.default));
var _contoursJs = require("./contours.js");
var _contoursJsDefault = parcelHelpers.interopDefault(_contoursJs);
var _densityJs = require("./density.js");
var _densityJsDefault = parcelHelpers.interopDefault(_densityJs);

},{"./contours.js":"fKcKz","./density.js":"klpyX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fKcKz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var dx = 1, dy = 1, threshold = (0, _d3Array.thresholdSturges), smooth = smoothLinear;
        function contours(values) {
            var tz = threshold(values);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) {
                const e = (0, _d3Array.extent)(values, finite);
                tz = (0, _d3Array.ticks)(...(0, _d3Array.nice)(e[0], e[1], tz), tz);
                while(tz[tz.length - 1] >= e[1])tz.pop();
                while(tz[1] < e[0])tz.shift();
            } else tz = tz.slice().sort((0, _ascendingJsDefault.default));
            return tz.map((value)=>contour(values, value));
        }
        // Accumulate, smooth contour rings, assign holes to exterior rings.
        // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
        function contour(values, value) {
            const v = value == null ? NaN : +value;
            if (isNaN(v)) throw new Error(`invalid value: ${value}`);
            var polygons = [], holes = [];
            isorings(values, v, function(ring) {
                smooth(ring, values, v);
                if ((0, _areaJsDefault.default)(ring) > 0) polygons.push([
                    ring
                ]);
                else holes.push(ring);
            });
            holes.forEach(function(hole) {
                for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, _containsJsDefault.default)((polygon = polygons[i])[0], hole) !== -1) {
                    polygon.push(hole);
                    return;
                }
            });
            return {
                type: "MultiPolygon",
                value: value,
                coordinates: polygons
            };
        }
        // Marching squares with isolines stitched into rings.
        // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
        function isorings(values, value, callback) {
            var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
            // Special case for the first row (y = -1, t2 = t3 = 0).
            x = y = -1;
            t1 = above(values[0], value);
            cases[t1 << 1].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = above(values[x + 1], value);
                cases[t0 | t1 << 1].forEach(stitch);
            }
            cases[t1 << 0].forEach(stitch);
            // General case for the intermediate rows.
            while(++y < dy - 1){
                x = -1;
                t1 = above(values[y * dx + dx], value);
                t2 = above(values[y * dx], value);
                cases[t1 << 1 | t2 << 2].forEach(stitch);
                while(++x < dx - 1){
                    t0 = t1, t1 = above(values[y * dx + dx + x + 1], value);
                    t3 = t2, t2 = above(values[y * dx + x + 1], value);
                    cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
                }
                cases[t1 | t2 << 3].forEach(stitch);
            }
            // Special case for the last row (y = dy - 1, t0 = t1 = 0).
            x = -1;
            t2 = values[y * dx] >= value;
            cases[t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t3 = t2, t2 = above(values[y * dx + x + 1], value);
                cases[t2 << 2 | t3 << 3].forEach(stitch);
            }
            cases[t2 << 3].forEach(stitch);
            function stitch(line) {
                var start = [
                    line[0][0] + x,
                    line[0][1] + y
                ], end = [
                    line[1][0] + x,
                    line[1][1] + y
                ], startIndex = index(start), endIndex = index(end), f, g;
                if (f = fragmentByEnd[startIndex]) {
                    if (g = fragmentByStart[endIndex]) {
                        delete fragmentByEnd[f.end];
                        delete fragmentByStart[g.start];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                            start: f.start,
                            end: g.end,
                            ring: f.ring.concat(g.ring)
                        };
                    } else {
                        delete fragmentByEnd[f.end];
                        f.ring.push(end);
                        fragmentByEnd[f.end = endIndex] = f;
                    }
                } else if (f = fragmentByStart[endIndex]) {
                    if (g = fragmentByEnd[startIndex]) {
                        delete fragmentByStart[f.start];
                        delete fragmentByEnd[g.end];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                            start: g.start,
                            end: f.end,
                            ring: g.ring.concat(f.ring)
                        };
                    } else {
                        delete fragmentByStart[f.start];
                        f.ring.unshift(start);
                        fragmentByStart[f.start = startIndex] = f;
                    }
                } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                    start: startIndex,
                    end: endIndex,
                    ring: [
                        start,
                        end
                    ]
                };
            }
        }
        function index(point) {
            return point[0] * 2 + point[1] * (dx + 1) * 4;
        }
        function smoothLinear(ring, values, value) {
            ring.forEach(function(point) {
                var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v1 = valid(values[yt * dx + xt]);
                if (x > 0 && x < dx && xt === x) point[0] = smooth1(x, valid(values[yt * dx + xt - 1]), v1, value);
                if (y > 0 && y < dy && yt === y) point[1] = smooth1(y, valid(values[(yt - 1) * dx + xt]), v1, value);
            });
        }
        contours.contour = contour;
        contours.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
            if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, contours;
        };
        contours.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)) : (0, _constantJsDefault.default)(_), contours) : threshold;
        };
        contours.smooth = function(_) {
            return arguments.length ? (smooth = _ ? smoothLinear : (0, _noopJsDefault.default), contours) : smooth === smoothLinear;
        };
        return contours;
    });
var _d3Array = require("d3-array");
var _arrayJs = require("./array.js");
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
// When computing the extent, ignore infinite values (as well as invalid ones).
function finite(x) {
    return isFinite(x) ? x : NaN;
}
// Is the (possibly invalid) x greater than or equal to the (known valid) value?
// Treat any invalid value as below negative infinity.
function above(x, value) {
    return x == null ? false : +x >= value;
}
// During smoothing, treat any invalid value as negative infinity.
function valid(v) {
    return v == null || isNaN(v = +v) ? -Infinity : v;
}
function smooth1(x, v0, v1, value) {
    const a = value - v0;
    const b = v1 - v0;
    const d = isFinite(a) || isFinite(b) ? a / b : Math.sign(a) / Math.sign(b);
    return isNaN(d) ? x : x + d - 0.5;
}

},{"d3-array":"bmqp6","./array.js":"1hQ8t","./ascending.js":"6vncH","./area.js":"jxtRz","./constant.js":"7Hd7C","./contains.js":"lhL8S","./noop.js":"bOn13","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1hQ8t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
var array = Array.prototype;
var slice = array.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6vncH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a - b;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jxtRz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(ring) {
        var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
        while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
        return area;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Hd7C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lhL8S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(ring, hole) {
        var i = -1, n = hole.length, c;
        while(++i < n)if (c = ringContains(ring, hole[i])) return c;
        return 0;
    });
function ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if (segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function segmentContains(a, b, c) {
    var i;
    return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bOn13":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"klpyX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var x = defaultX, y = defaultY, weight = defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = (0, _constantJsDefault.default)(20);
        function grid(data) {
            var values = new Float32Array(n * m), pow2k = Math.pow(2, -k), i = -1;
            for (const d of data){
                var xi = (x(d, ++i, data) + o) * pow2k, yi = (y(d, i, data) + o) * pow2k, wi = +weight(d, i, data);
                if (wi && xi >= 0 && xi < n && yi >= 0 && yi < m) {
                    var x0 = Math.floor(xi), y0 = Math.floor(yi), xt = xi - x0 - 0.5, yt = yi - y0 - 0.5;
                    values[x0 + y0 * n] += (1 - xt) * (1 - yt) * wi;
                    values[x0 + 1 + y0 * n] += xt * (1 - yt) * wi;
                    values[x0 + 1 + (y0 + 1) * n] += xt * yt * wi;
                    values[x0 + (y0 + 1) * n] += (1 - xt) * yt * wi;
                }
            }
            (0, _d3Array.blur2)({
                data: values,
                width: n,
                height: m
            }, r * pow2k);
            return values;
        }
        function density(data) {
            var values = grid(data), tz = threshold(values), pow4k = Math.pow(2, 2 * k);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) tz = (0, _d3Array.ticks)(Number.MIN_VALUE, (0, _d3Array.max)(values) / pow4k, tz);
            return (0, _contoursJsDefault.default)().size([
                n,
                m
            ]).thresholds(tz.map((d)=>d * pow4k))(values).map((c, i)=>(c.value = +tz[i], transform(c)));
        }
        density.contours = function(data) {
            var values = grid(data), contours = (0, _contoursJsDefault.default)().size([
                n,
                m
            ]), pow4k = Math.pow(2, 2 * k), contour = (value)=>{
                value = +value;
                var c = transform(contours.contour(values, value * pow4k));
                c.value = value; // preserve exact threshold value
                return c;
            };
            Object.defineProperty(contour, "max", {
                get: ()=>(0, _d3Array.max)(values) / pow4k
            });
            return contour;
        };
        function transform(geometry) {
            geometry.coordinates.forEach(transformPolygon);
            return geometry;
        }
        function transformPolygon(coordinates) {
            coordinates.forEach(transformRing);
        }
        function transformRing(coordinates) {
            coordinates.forEach(transformPoint);
        }
        // TODO Optimize.
        function transformPoint(coordinates) {
            coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
            coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
        }
        function resize() {
            o = r * 3;
            n = dx + o * 2 >> k;
            m = dy + o * 2 >> k;
            return density;
        }
        density.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), density) : x;
        };
        density.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), density) : y;
        };
        density.weight = function(_) {
            return arguments.length ? (weight = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), density) : weight;
        };
        density.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = +_[0], _1 = +_[1];
            if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, resize();
        };
        density.cellSize = function(_) {
            if (!arguments.length) return 1 << k;
            if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
            return k = Math.floor(Math.log(_) / Math.LN2), resize();
        };
        density.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)) : (0, _constantJsDefault.default)(_), density) : threshold;
        };
        density.bandwidth = function(_) {
            if (!arguments.length) return Math.sqrt(r * (r + 1));
            if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
            return r = (Math.sqrt(4 * _ * _ + 1) - 1) / 2, resize();
        };
        return density;
    });
var _d3Array = require("d3-array");
var _arrayJs = require("./array.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _contoursJs = require("./contours.js");
var _contoursJsDefault = parcelHelpers.interopDefault(_contoursJs);
function defaultX(d) {
    return d[0];
}
function defaultY(d) {
    return d[1];
}
function defaultWeight() {
    return 1;
}

},{"d3-array":"bmqp6","./array.js":"1hQ8t","./constant.js":"7Hd7C","./contours.js":"fKcKz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzKr0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Delaunay", ()=>(0, _delaunayJsDefault.default));
parcelHelpers.export(exports, "Voronoi", ()=>(0, _voronoiJsDefault.default));
var _delaunayJs = require("./delaunay.js");
var _delaunayJsDefault = parcelHelpers.interopDefault(_delaunayJs);
var _voronoiJs = require("./voronoi.js");
var _voronoiJsDefault = parcelHelpers.interopDefault(_voronoiJs);

},{"./delaunay.js":"lFxg8","./voronoi.js":"gPQ9o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lFxg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _delaunator = require("delaunator");
var _delaunatorDefault = parcelHelpers.interopDefault(_delaunator);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _polygonJs = require("./polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _voronoiJs = require("./voronoi.js");
var _voronoiJsDefault = parcelHelpers.interopDefault(_voronoiJs);
const tau = 2 * Math.PI, pow = Math.pow;
function pointX(p) {
    return p[0];
}
function pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function collinear(d) {
    const { triangles, coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class Delaunay {
    static from(points, fx = pointX, fy = pointY, that) {
        return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
    }
    constructor(points){
        this._delaunator = new (0, _delaunatorDefault.default)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, _delaunatorDefault.default)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            inedges[hull[0]] = 1;
            if (hull.length === 2) {
                inedges[hull[1]] = 0;
                this.triangles[1] = hull[1];
                this.triangles[2] = hull[1];
            }
        }
    }
    voronoi(bounds) {
        return new (0, _voronoiJsDefault.default)(this, bounds);
    }
    *neighbors(i) {
        const { inedges, hull, _hullIndex, halfedges, triangles, collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges, hull, _hullIndex, halfedges, triangles, points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = pow(x - points[i * 2], 2) + pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = pow(x - points[t * 2], 2) + pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if (pow(x - points[e * 2], 2) + pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points, halfedges, triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r) {
        if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
        r = r == undefined ? 2 : +r;
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { hull, points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points, triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
}
exports.default = Delaunay;
function flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}

},{"delaunator":"8DmA1","./path.js":"5h4Se","./polygon.js":"aS9sW","./voronoi.js":"gPQ9o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8DmA1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _robustPredicates = require("robust-predicates");
const EPSILON = Math.pow(2, -52);
const EDGE_STACK = new Uint32Array(512);
class Delaunator {
    static from(points, getX = defaultGetX, getY = defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new Delaunator(coords);
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
    update() {
        const { coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0, minDist = Infinity; i < n; i++){
            const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        // find the point closest to the seed
        for(let i = 0, minDist = Infinity; i < n; i++){
            if (i === i0) continue;
            const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                const d = this._dists[id];
                if (d > d0) {
                    hull[j++] = id;
                    d0 = d;
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ((0, _robustPredicates.orient2d)(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], (0, _robustPredicates.orient2d)(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], (0, _robustPredicates.orient2d)(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], (0, _robustPredicates.orient2d)(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < EDGE_STACK.length) EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
}
exports.default = Delaunator;
// monotonically increases with real angle, but doesn't need expensive trigonometry
function pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
function inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x,
        y
    };
}
function quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            quicksort(ids, dists, i, right);
            quicksort(ids, dists, left, j - 1);
        } else {
            quicksort(ids, dists, left, j - 1);
            quicksort(ids, dists, i, right);
        }
    }
}
function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function defaultGetX(p) {
    return p[0];
}
function defaultGetY(p) {
    return p[1];
}

},{"robust-predicates":"fqLDZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fqLDZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient2d", ()=>(0, _orient2DJs.orient2d));
parcelHelpers.export(exports, "orient2dfast", ()=>(0, _orient2DJs.orient2dfast));
parcelHelpers.export(exports, "orient3d", ()=>(0, _orient3DJs.orient3d));
parcelHelpers.export(exports, "orient3dfast", ()=>(0, _orient3DJs.orient3dfast));
parcelHelpers.export(exports, "incircle", ()=>(0, _incircleJs.incircle));
parcelHelpers.export(exports, "incirclefast", ()=>(0, _incircleJs.incirclefast));
parcelHelpers.export(exports, "insphere", ()=>(0, _insphereJs.insphere));
parcelHelpers.export(exports, "inspherefast", ()=>(0, _insphereJs.inspherefast));
var _orient2DJs = require("./esm/orient2d.js");
var _orient3DJs = require("./esm/orient3d.js");
var _incircleJs = require("./esm/incircle.js");
var _insphereJs = require("./esm/insphere.js");

},{"./esm/orient2d.js":"7mY7p","./esm/orient3d.js":"bvx5M","./esm/incircle.js":"2300a","./esm/insphere.js":"lx5e5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7mY7p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient2d", ()=>orient2d);
parcelHelpers.export(exports, "orient2dfast", ()=>orient2dfast);
var _utilJs = require("./util.js");
const ccwerrboundA = (3 + 16 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const ccwerrboundB = (2 + 12 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const ccwerrboundC = (9 + 64 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const B = (0, _utilJs.vec)(4);
const C1 = (0, _utilJs.vec)(8);
const C2 = (0, _utilJs.vec)(12);
const D = (0, _utilJs.vec)(16);
const u = (0, _utilJs.vec)(4);
function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, _utilJs.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, _utilJs.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, _utilJs.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, _utilJs.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    B[3] = u3;
    let det = (0, _utilJs.estimate)(4, B);
    let errbound = ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = ccwerrboundC * detsum + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, _utilJs.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, _utilJs.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, _utilJs.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, _utilJs.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const C1len = (0, _utilJs.sum)(4, B, 4, u, C1);
    s1 = acx * bcytail;
    c = (0, _utilJs.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, _utilJs.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, _utilJs.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, _utilJs.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const C2len = (0, _utilJs.sum)(C1len, C1, 4, u, C2);
    s1 = acxtail * bcytail;
    c = (0, _utilJs.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, _utilJs.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, _utilJs.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, _utilJs.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const Dlen = (0, _utilJs.sum)(C2len, C2, 4, u, D);
    return D[Dlen - 1];
}
function orient2d(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= ccwerrboundA * detsum) return det;
    return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function orient2dfast(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}

},{"./util.js":"4o1Gr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4o1Gr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "splitter", ()=>splitter);
parcelHelpers.export(exports, "resulterrbound", ()=>resulterrbound);
// fast_expansion_sum_zeroelim routine from oritinal code
parcelHelpers.export(exports, "sum", ()=>sum);
parcelHelpers.export(exports, "sum_three", ()=>sum_three);
// scale_expansion_zeroelim routine from oritinal code
parcelHelpers.export(exports, "scale", ()=>scale);
parcelHelpers.export(exports, "negate", ()=>negate);
parcelHelpers.export(exports, "estimate", ()=>estimate);
parcelHelpers.export(exports, "vec", ()=>vec);
const epsilon = 1.1102230246251565e-16;
const splitter = 134217729;
const resulterrbound = (3 + 8 * epsilon) * epsilon;
function sum(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function sum_three(alen, a, blen, b, clen, c, tmp, out) {
    return sum(sum(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function scale(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = splitter * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = splitter * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = splitter * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function negate(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function estimate(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function vec(n) {
    return new Float64Array(n);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bvx5M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient3d", ()=>orient3d);
parcelHelpers.export(exports, "orient3dfast", ()=>orient3dfast);
var _utilJs = require("./util.js");
const o3derrboundA = (7 + 56 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const o3derrboundB = (3 + 28 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const o3derrboundC = (26 + 288 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const bc = (0, _utilJs.vec)(4);
const ca = (0, _utilJs.vec)(4);
const ab = (0, _utilJs.vec)(4);
const at_b = (0, _utilJs.vec)(4);
const at_c = (0, _utilJs.vec)(4);
const bt_c = (0, _utilJs.vec)(4);
const bt_a = (0, _utilJs.vec)(4);
const ct_a = (0, _utilJs.vec)(4);
const ct_b = (0, _utilJs.vec)(4);
const bct = (0, _utilJs.vec)(8);
const cat = (0, _utilJs.vec)(8);
const abt = (0, _utilJs.vec)(8);
const u = (0, _utilJs.vec)(4);
const _8 = (0, _utilJs.vec)(8);
const _8b = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(8);
const _12 = (0, _utilJs.vec)(12);
let fin = (0, _utilJs.vec)(192);
let fin2 = (0, _utilJs.vec)(192);
function finadd(finlen, alen, a) {
    finlen = (0, _utilJs.sum)(finlen, fin, alen, a, fin2);
    const tmp = fin;
    fin = fin2;
    fin2 = tmp;
    return finlen;
}
function tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        } else {
            negate = -ytail;
            s1 = negate * ax;
            c = (0, _utilJs.splitter) * negate;
            ahi = c - (c - negate);
            alo = negate - ahi;
            c = (0, _utilJs.splitter) * ax;
            bhi = c - (c - ax);
            blo = ax - bhi;
            a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            a[1] = s1;
            s1 = ytail * bx;
            c = (0, _utilJs.splitter) * ytail;
            ahi = c - (c - ytail);
            alo = ytail - ahi;
            c = (0, _utilJs.splitter) * bx;
            bhi = c - (c - bx);
            blo = bx - bhi;
            b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            b[1] = s1;
            return 2;
        }
    } else if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, _utilJs.splitter) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, _utilJs.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    } else {
        s1 = xtail * ay;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = ytail * ax;
        c = (0, _utilJs.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, _utilJs.splitter) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        a[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        a[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        a[2] = _j - (u3 - bvirt) + (_i - bvirt);
        a[3] = u3;
        s1 = ytail * bx;
        c = (0, _utilJs.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, _utilJs.splitter) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = xtail * by;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        b[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        b[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        b[2] = _j - (u3 - bvirt) + (_i - bvirt);
        b[3] = u3;
        return 4;
    }
}
function tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, _utilJs.splitter) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, _utilJs.splitter) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, _utilJs.splitter) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, _utilJs.splitter) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, _utilJs.splitter) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    u[2] = _k - (u3 - _j);
    u[3] = u3;
    finlen = finadd(finlen, 4, u);
    if (z !== 0) {
        c = (0, _utilJs.splitter) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, _utilJs.splitter) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, _utilJs.splitter) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        u[2] = _k - (u3 - _j);
        u[3] = u3;
        finlen = finadd(finlen, 4, u);
    }
    return finlen;
}
function orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cdx * ady;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ca[3] = u3;
    s1 = adx * bdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.scale)(4, bc, adz, _8), _8, (0, _utilJs.scale)(4, ca, bdz, _8b), _8b, _16), _16, (0, _utilJs.scale)(4, ab, cdz, _8), _8, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = o3derrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, at_b, at_c);
    const bt_len = tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, bt_c, bt_a);
    const ct_len = tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, ct_a, ct_b);
    const bctlen = (0, _utilJs.sum)(bt_len, bt_c, ct_len, ct_b, bct);
    finlen = finadd(finlen, (0, _utilJs.scale)(bctlen, bct, adz, _16), _16);
    const catlen = (0, _utilJs.sum)(ct_len, ct_a, at_len, at_c, cat);
    finlen = finadd(finlen, (0, _utilJs.scale)(catlen, cat, bdz, _16), _16);
    const abtlen = (0, _utilJs.sum)(at_len, at_b, bt_len, bt_a, abt);
    finlen = finadd(finlen, (0, _utilJs.scale)(abtlen, abt, cdz, _16), _16);
    if (adztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, bc, adztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(bctlen, bct, adztail, _16), _16);
    }
    if (bdztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, ca, bdztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(catlen, cat, bdztail, _16), _16);
    }
    if (cdztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, ab, cdztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(abtlen, abt, cdztail, _16), _16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return fin[finlen - 1];
}
function orient3d(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function orient3dfast(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}

},{"./util.js":"4o1Gr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2300a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "incircle", ()=>incircle);
parcelHelpers.export(exports, "incirclefast", ()=>incirclefast);
var _utilJs = require("./util.js");
const iccerrboundA = (10 + 96 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const iccerrboundB = (4 + 48 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const iccerrboundC = (44 + 576 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const bc = (0, _utilJs.vec)(4);
const ca = (0, _utilJs.vec)(4);
const ab = (0, _utilJs.vec)(4);
const aa = (0, _utilJs.vec)(4);
const bb = (0, _utilJs.vec)(4);
const cc = (0, _utilJs.vec)(4);
const u = (0, _utilJs.vec)(4);
const v = (0, _utilJs.vec)(4);
const axtbc = (0, _utilJs.vec)(8);
const aytbc = (0, _utilJs.vec)(8);
const bxtca = (0, _utilJs.vec)(8);
const bytca = (0, _utilJs.vec)(8);
const cxtab = (0, _utilJs.vec)(8);
const cytab = (0, _utilJs.vec)(8);
const abt = (0, _utilJs.vec)(8);
const bct = (0, _utilJs.vec)(8);
const cat = (0, _utilJs.vec)(8);
const abtt = (0, _utilJs.vec)(4);
const bctt = (0, _utilJs.vec)(4);
const catt = (0, _utilJs.vec)(4);
const _8 = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(16);
const _16b = (0, _utilJs.vec)(16);
const _16c = (0, _utilJs.vec)(16);
const _32 = (0, _utilJs.vec)(32);
const _32b = (0, _utilJs.vec)(32);
const _48 = (0, _utilJs.vec)(48);
const _64 = (0, _utilJs.vec)(64);
let fin = (0, _utilJs.vec)(1152);
let fin2 = (0, _utilJs.vec)(1152);
function finadd(finlen, a, alen) {
    finlen = (0, _utilJs.sum)(finlen, fin, a, alen, fin2);
    const tmp = fin;
    fin = fin2;
    fin2 = tmp;
    return finlen;
}
function incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cdx * ady;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ca[3] = u3;
    s1 = adx * bdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, bc, adx, _8), _8, adx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bc, ady, _8), _8, ady, _16b), _16b, _32), _32, (0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, ca, bdx, _8), _8, bdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, ca, bdy, _8), _8, bdy, _16b), _16b, _32b), _32b, _64), _64, (0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, ab, cdx, _8), _8, cdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, ab, cdy, _8), _8, cdy, _16b), _16b, _32), _32, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = iccerrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, _utilJs.splitter) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, _utilJs.splitter) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, _utilJs.splitter) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, _utilJs.splitter) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, _utilJs.splitter) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, _utilJs.splitter) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, _utilJs.scale)(4, bc, adxtail, axtbc);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(axtbclen, axtbc, 2 * adx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adxtail, _8), _8, bdy, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, adxtail, _8), _8, -cdy, _16c), _16c, _32, _48), _48);
    }
    if (adytail !== 0) {
        aytbclen = (0, _utilJs.scale)(4, bc, adytail, aytbc);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(aytbclen, aytbc, 2 * ady, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, adytail, _8), _8, cdx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adytail, _8), _8, -bdx, _16c), _16c, _32, _48), _48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, _utilJs.scale)(4, ca, bdxtail, bxtca);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(bxtcalen, bxtca, 2 * bdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdxtail, _8), _8, cdy, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, bdxtail, _8), _8, -ady, _16c), _16c, _32, _48), _48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, _utilJs.scale)(4, ca, bdytail, bytca);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(bytcalen, bytca, 2 * bdy, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, bdytail, _8), _8, adx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdytail, _8), _8, -cdx, _16c), _16c, _32, _48), _48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, _utilJs.scale)(4, ab, cdxtail, cxtab);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(cxtablen, cxtab, 2 * cdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdxtail, _8), _8, ady, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, cdxtail, _8), _8, -bdy, _16c), _16c, _32, _48), _48);
    }
    if (cdytail !== 0) {
        cytablen = (0, _utilJs.scale)(4, ab, cdytail, cytab);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(cytablen, cytab, 2 * cdy, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, cdytail, _8), _8, bdx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdytail, _8), _8, -adx, _16c), _16c, _32, _48), _48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, _utilJs.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, _utilJs.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, _utilJs.splitter) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            bctlen = (0, _utilJs.sum)(4, u, 4, v, bct);
            s1 = bdxtail * cdytail;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            bctt[3] = u3;
            bcttlen = 4;
        } else {
            bct[0] = 0;
            bctlen = 1;
            bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, _utilJs.scale)(bctlen, bct, adxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(axtbclen, axtbc, adxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * adx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(bcttlen, bctt, adxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * adx, _16), _16, (0, _utilJs.scale)(len2, _8, adxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, adxtail, _32), _32, _32b, _64), _64);
            if (bdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adxtail, _8), _8, bdytail, _16), _16);
            if (cdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, -adxtail, _8), _8, cdytail, _16), _16);
        }
        if (adytail !== 0) {
            const len = (0, _utilJs.scale)(bctlen, bct, adytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(aytbclen, aytbc, adytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * ady, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(bcttlen, bctt, adytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * ady, _16), _16, (0, _utilJs.scale)(len2, _8, adytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, adytail, _32), _32, _32b, _64), _64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, _utilJs.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, _utilJs.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, _utilJs.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            catlen = (0, _utilJs.sum)(4, u, 4, v, cat);
            s1 = cdxtail * adytail;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            catt[3] = u3;
            cattlen = 4;
        } else {
            cat[0] = 0;
            catlen = 1;
            catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, _utilJs.scale)(catlen, cat, bdxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(bxtcalen, bxtca, bdxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * bdx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(cattlen, catt, bdxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * bdx, _16), _16, (0, _utilJs.scale)(len2, _8, bdxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, bdxtail, _32), _32, _32b, _64), _64);
            if (cdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdxtail, _8), _8, cdytail, _16), _16);
            if (adytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, -bdxtail, _8), _8, adytail, _16), _16);
        }
        if (bdytail !== 0) {
            const len = (0, _utilJs.scale)(catlen, cat, bdytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(bytcalen, bytca, bdytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * bdy, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(cattlen, catt, bdytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * bdy, _16), _16, (0, _utilJs.scale)(len2, _8, bdytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, bdytail, _32), _32, _32b, _64), _64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, _utilJs.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, _utilJs.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, _utilJs.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            abtlen = (0, _utilJs.sum)(4, u, 4, v, abt);
            s1 = adxtail * bdytail;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            abtt[3] = u3;
            abttlen = 4;
        } else {
            abt[0] = 0;
            abtlen = 1;
            abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, _utilJs.scale)(abtlen, abt, cdxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(cxtablen, cxtab, cdxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * cdx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(abttlen, abtt, cdxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * cdx, _16), _16, (0, _utilJs.scale)(len2, _8, cdxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, cdxtail, _32), _32, _32b, _64), _64);
            if (adytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdxtail, _8), _8, adytail, _16), _16);
            if (bdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, -cdxtail, _8), _8, bdytail, _16), _16);
        }
        if (cdytail !== 0) {
            const len = (0, _utilJs.scale)(abtlen, abt, cdytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(cytablen, cytab, cdytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * cdy, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(abttlen, abtt, cdytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * cdy, _16), _16, (0, _utilJs.scale)(len2, _8, cdytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, cdytail, _32), _32, _32b, _64), _64);
        }
    }
    return fin[finlen - 1];
}
function incircle(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function incirclefast(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}

},{"./util.js":"4o1Gr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lx5e5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "insphere", ()=>insphere);
parcelHelpers.export(exports, "inspherefast", ()=>inspherefast);
var _utilJs = require("./util.js");
const isperrboundA = (16 + 224 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const isperrboundB = (5 + 72 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const isperrboundC = (71 + 1408 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const ab = (0, _utilJs.vec)(4);
const bc = (0, _utilJs.vec)(4);
const cd = (0, _utilJs.vec)(4);
const de = (0, _utilJs.vec)(4);
const ea = (0, _utilJs.vec)(4);
const ac = (0, _utilJs.vec)(4);
const bd = (0, _utilJs.vec)(4);
const ce = (0, _utilJs.vec)(4);
const da = (0, _utilJs.vec)(4);
const eb = (0, _utilJs.vec)(4);
const abc = (0, _utilJs.vec)(24);
const bcd = (0, _utilJs.vec)(24);
const cde = (0, _utilJs.vec)(24);
const dea = (0, _utilJs.vec)(24);
const eab = (0, _utilJs.vec)(24);
const abd = (0, _utilJs.vec)(24);
const bce = (0, _utilJs.vec)(24);
const cda = (0, _utilJs.vec)(24);
const deb = (0, _utilJs.vec)(24);
const eac = (0, _utilJs.vec)(24);
const adet = (0, _utilJs.vec)(1152);
const bdet = (0, _utilJs.vec)(1152);
const cdet = (0, _utilJs.vec)(1152);
const ddet = (0, _utilJs.vec)(1152);
const edet = (0, _utilJs.vec)(1152);
const abdet = (0, _utilJs.vec)(2304);
const cddet = (0, _utilJs.vec)(2304);
const cdedet = (0, _utilJs.vec)(3456);
const deter = (0, _utilJs.vec)(5760);
const _8 = (0, _utilJs.vec)(8);
const _8b = (0, _utilJs.vec)(8);
const _8c = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(16);
const _24 = (0, _utilJs.vec)(24);
const _48 = (0, _utilJs.vec)(48);
const _48b = (0, _utilJs.vec)(48);
const _96 = (0, _utilJs.vec)(96);
const _192 = (0, _utilJs.vec)(192);
const _384x = (0, _utilJs.vec)(384);
const _384y = (0, _utilJs.vec)(384);
const _384z = (0, _utilJs.vec)(384);
const _768 = (0, _utilJs.vec)(768);
function sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, _utilJs.sum_three)((0, _utilJs.scale)(4, a, az, _8), _8, (0, _utilJs.scale)(4, b, bz, _8b), _8b, (0, _utilJs.scale)(4, c, cz, _8c), _8c, _16, out);
}
function liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, _utilJs.sum)((0, _utilJs.sum)(alen, a, blen, b, _48), _48, (0, _utilJs.negate)((0, _utilJs.sum)(clen, c, dlen, d, _48b), _48b), _48b, _96);
    return (0, _utilJs.sum_three)((0, _utilJs.scale)((0, _utilJs.scale)(len, _96, x, _192), _192, x, _384x), _384x, (0, _utilJs.scale)((0, _utilJs.scale)(len, _96, y, _192), _192, y, _384y), _384y, (0, _utilJs.scale)((0, _utilJs.scale)(len, _96, z, _192), _192, z, _384z), _384z, _768, out);
}
function insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    s1 = bx * cy;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cx * dy;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    cd[3] = u3;
    s1 = dx * ey;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    de[3] = u3;
    s1 = ex * ay;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ea[3] = u3;
    s1 = ax * cy;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ac[3] = u3;
    s1 = bx * dy;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bd[3] = u3;
    s1 = cx * ey;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ce[3] = u3;
    s1 = dx * ay;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    da[3] = u3;
    s1 = ex * by;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    eb[3] = u3;
    const abclen = sum_three_scale(ab, bc, ac, cz, az, -bz, abc);
    const bcdlen = sum_three_scale(bc, cd, bd, dz, bz, -cz, bcd);
    const cdelen = sum_three_scale(cd, de, ce, ez, cz, -dz, cde);
    const dealen = sum_three_scale(de, ea, da, az, dz, -ez, dea);
    const eablen = sum_three_scale(ea, ab, eb, bz, ez, -az, eab);
    const abdlen = sum_three_scale(ab, bd, da, dz, az, bz, abd);
    const bcelen = sum_three_scale(bc, ce, eb, ez, bz, cz, bce);
    const cdalen = sum_three_scale(cd, da, ac, az, cz, dz, cda);
    const deblen = sum_three_scale(de, eb, bd, bz, dz, ez, deb);
    const eaclen = sum_three_scale(ea, ac, ce, cz, ez, az, eac);
    const deterlen = (0, _utilJs.sum_three)(liftexact(cdelen, cde, bcelen, bce, deblen, deb, bcdlen, bcd, ax, ay, az, adet), adet, liftexact(dealen, dea, cdalen, cda, eaclen, eac, cdelen, cde, bx, by, bz, bdet), bdet, (0, _utilJs.sum_three)(liftexact(eablen, eab, deblen, deb, abdlen, abd, dealen, dea, cx, cy, cz, cdet), cdet, liftexact(abclen, abc, eaclen, eac, bcelen, bce, eablen, eab, dx, dy, dz, ddet), ddet, liftexact(bcdlen, bcd, abdlen, abd, cdalen, cda, abclen, abc, ex, ey, ez, edet), edet, cddet, cdedet), cdedet, abdet, deter);
    return deter[deterlen - 1];
}
const xdet = (0, _utilJs.vec)(96);
const ydet = (0, _utilJs.vec)(96);
const zdet = (0, _utilJs.vec)(96);
const fin = (0, _utilJs.vec)(1152);
function liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = sum_three_scale(a, b, c, az, bz, cz, _24);
    return (0, _utilJs.sum_three)((0, _utilJs.scale)((0, _utilJs.scale)(len, _24, x, _48), _48, x, xdet), xdet, (0, _utilJs.scale)((0, _utilJs.scale)(len, _24, y, _48), _48, y, ydet), ydet, (0, _utilJs.scale)((0, _utilJs.scale)(len, _24, z, _48), _48, z, zdet), zdet, _192, out);
}
function insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    ab[3] = ab3;
    s1 = bex * cey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    bc[3] = bc3;
    s1 = cex * dey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    cd[3] = cd3;
    s1 = dex * aey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    da[3] = da3;
    s1 = aex * cey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    ac[3] = ac3;
    s1 = bex * dey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    bd[3] = bd3;
    const finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.negate)(liftadapt(bc, cd, bd, dez, bez, -cez, aex, aey, aez, adet), adet), adet, liftadapt(cd, da, ac, aez, cez, dez, bex, bey, bez, bdet), bdet, abdet), abdet, (0, _utilJs.sum)((0, _utilJs.negate)(liftadapt(da, ab, bd, bez, dez, aez, cex, cey, cez, cdet), cdet), cdet, liftadapt(ab, bc, ac, cez, aez, -bez, dex, dey, dez, ddet), ddet, cddet), cddet, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = isperrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function insphere(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab) + (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent = (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift + (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift + (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift + (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;
    const errbound = isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function inspherefast(pax, pay, paz, pbx, pby, pbz, pcx, pcy, pcz, pdx, pdy, pdz, pex, pey, pez) {
    const aex = pax - pex;
    const bex = pbx - pex;
    const cex = pcx - pex;
    const dex = pdx - pex;
    const aey = pay - pey;
    const bey = pby - pey;
    const cey = pcy - pey;
    const dey = pdy - pey;
    const aez = paz - pez;
    const bez = pbz - pez;
    const cez = pcz - pez;
    const dez = pdz - pez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}

},{"./util.js":"4o1Gr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5h4Se":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const epsilon = 1e-6;
class Path {
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
}
exports.default = Path;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aS9sW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Polygon {
    constructor(){
        this._ = [];
    }
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
}
exports.default = Polygon;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gPQ9o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _polygonJs = require("./polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
class Voronoi {
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points, hull, triangles }, vectors } = this;
        let bx, by; // lazily computed barycenter of the hull
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const ab = (dx * ey - dy * ex) * 2;
            if (Math.abs(ab) < 1e-9) {
                // For a degenerate triangle, the circumcenter is at the infinity, in a
                // direction orthogonal to the halfedge and away from the “center” of
                // the diagram <bx, by>, defined as the hull’s barycenter.
                if (bx === undefined) {
                    bx = by = 0;
                    for (const i of hull)bx += points[i * 2], by += points[i * 2 + 1];
                    bx /= hull.length, by /= hull.length;
                }
                const a = 1e9 * Math.sign((bx - x1) * ey - (by - y1) * ex);
                x = (x1 + x3) / 2 - a * ey;
                y = (y1 + y3) / 2 + a * ex;
            } else {
                const d = 1 / ab;
                const bl = dx * dx + dy * dy;
                const cl = ex * ex + ey * ey;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { delaunay: { halfedges, inedges, hull }, circumcenters, vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] === cj[aj] && ci[ai + 1] === cj[aj + 1] && ci[(ai + 2) % li] === cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] === cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters, delaunay: { inedges, halfedges, triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return this._simplify(V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points));
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1 = 0;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        // for more robustness, always consider the segment in the same order
        const flip = c0 < c1;
        if (flip) [x0, y0, x1, y1, c0, c1] = [
            x1,
            y1,
            x0,
            y0,
            c1,
            c0
        ];
        while(true){
            if (c0 === 0 && c1 === 0) return flip ? [
                x1,
                y1,
                x0,
                y0
            ] : [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
            // undefined, the conditional statement will be executed.
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
    _simplify(P) {
        if (P && P.length > 4) {
            for(let i = 0; i < P.length; i += 2){
                const j = (i + 2) % P.length, k = (i + 4) % P.length;
                if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
            }
            if (!P.length) P = null;
        }
        return P;
    }
}
exports.default = Voronoi;

},{"./path.js":"5h4Se","./polygon.js":"aS9sW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5eFMk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dsvFormat", ()=>(0, _dsvJsDefault.default));
parcelHelpers.export(exports, "csvParse", ()=>(0, _csvJs.csvParse));
parcelHelpers.export(exports, "csvParseRows", ()=>(0, _csvJs.csvParseRows));
parcelHelpers.export(exports, "csvFormat", ()=>(0, _csvJs.csvFormat));
parcelHelpers.export(exports, "csvFormatBody", ()=>(0, _csvJs.csvFormatBody));
parcelHelpers.export(exports, "csvFormatRows", ()=>(0, _csvJs.csvFormatRows));
parcelHelpers.export(exports, "csvFormatRow", ()=>(0, _csvJs.csvFormatRow));
parcelHelpers.export(exports, "csvFormatValue", ()=>(0, _csvJs.csvFormatValue));
parcelHelpers.export(exports, "tsvParse", ()=>(0, _tsvJs.tsvParse));
parcelHelpers.export(exports, "tsvParseRows", ()=>(0, _tsvJs.tsvParseRows));
parcelHelpers.export(exports, "tsvFormat", ()=>(0, _tsvJs.tsvFormat));
parcelHelpers.export(exports, "tsvFormatBody", ()=>(0, _tsvJs.tsvFormatBody));
parcelHelpers.export(exports, "tsvFormatRows", ()=>(0, _tsvJs.tsvFormatRows));
parcelHelpers.export(exports, "tsvFormatRow", ()=>(0, _tsvJs.tsvFormatRow));
parcelHelpers.export(exports, "tsvFormatValue", ()=>(0, _tsvJs.tsvFormatValue));
parcelHelpers.export(exports, "autoType", ()=>(0, _autoTypeJsDefault.default));
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var _csvJs = require("./csv.js");
var _tsvJs = require("./tsv.js");
var _autoTypeJs = require("./autoType.js");
var _autoTypeJsDefault = parcelHelpers.interopDefault(_autoTypeJs);

},{"./dsv.js":"gzXu1","./csv.js":"j03tR","./tsv.js":"7jiq8","./autoType.js":"4KUc4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gzXu1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(delimiter) {
        var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
        function parse(text, f) {
            var convert, columns, rows = parseRows(text, function(row, i) {
                if (convert) return convert(row, i - 1);
                columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
            });
            rows.columns = columns || [];
            return rows;
        }
        function parseRows(text, f) {
            var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
            // Strip the trailing newline.
            if (text.charCodeAt(N - 1) === NEWLINE) --N;
            if (text.charCodeAt(N - 1) === RETURN) --N;
            function token() {
                if (eof) return EOF;
                if (eol) return eol = false, EOL;
                // Unescape quotes.
                var i, j = I, c;
                if (text.charCodeAt(j) === QUOTE) {
                    while(I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
                    if ((i = I) >= N) eof = true;
                    else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    }
                    return text.slice(j + 1, i - 1).replace(/""/g, "\"");
                }
                // Find next delimiter or newline.
                while(I < N){
                    if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    } else if (c !== DELIMITER) continue;
                    return text.slice(j, i);
                }
                // Return last token before EOF.
                return eof = true, text.slice(j, N);
            }
            while((t = token()) !== EOF){
                var row = [];
                while(t !== EOL && t !== EOF)row.push(t), t = token();
                if (f && (row = f(row, n++)) == null) continue;
                rows.push(row);
            }
            return rows;
        }
        function preformatBody(rows, columns) {
            return rows.map(function(row) {
                return columns.map(function(column) {
                    return formatValue(row[column]);
                }).join(delimiter);
            });
        }
        function format(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return [
                columns.map(formatValue).join(delimiter)
            ].concat(preformatBody(rows, columns)).join("\n");
        }
        function formatBody(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return preformatBody(rows, columns).join("\n");
        }
        function formatRows(rows) {
            return rows.map(formatRow).join("\n");
        }
        function formatRow(row) {
            return row.map(formatValue).join(delimiter);
        }
        function formatValue(value) {
            return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
        }
        return {
            parse: parse,
            parseRows: parseRows,
            format: format,
            formatBody: formatBody,
            formatRows: formatRows,
            formatRow: formatRow,
            formatValue: formatValue
        };
    });
var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
function objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + "] || \"\"";
    }).join(",") + "}");
}
function customConverter(columns, f) {
    var object = objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function formatYear(year) {
    return year < 0 ? "-" + pad(-year, 6) : year > 9999 ? "+" + pad(year, 6) : pad(year, 4);
}
function formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : formatYear(date.getUTCFullYear(), 4) + "-" + pad(date.getUTCMonth() + 1, 2) + "-" + pad(date.getUTCDate(), 2) + (milliseconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "." + pad(milliseconds, 3) + "Z" : seconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "Z" : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z" : "");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j03tR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "csvParse", ()=>csvParse);
parcelHelpers.export(exports, "csvParseRows", ()=>csvParseRows);
parcelHelpers.export(exports, "csvFormat", ()=>csvFormat);
parcelHelpers.export(exports, "csvFormatBody", ()=>csvFormatBody);
parcelHelpers.export(exports, "csvFormatRows", ()=>csvFormatRows);
parcelHelpers.export(exports, "csvFormatRow", ()=>csvFormatRow);
parcelHelpers.export(exports, "csvFormatValue", ()=>csvFormatValue);
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var csv = (0, _dsvJsDefault.default)(",");
var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatBody = csv.formatBody;
var csvFormatRows = csv.formatRows;
var csvFormatRow = csv.formatRow;
var csvFormatValue = csv.formatValue;

},{"./dsv.js":"gzXu1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7jiq8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tsvParse", ()=>tsvParse);
parcelHelpers.export(exports, "tsvParseRows", ()=>tsvParseRows);
parcelHelpers.export(exports, "tsvFormat", ()=>tsvFormat);
parcelHelpers.export(exports, "tsvFormatBody", ()=>tsvFormatBody);
parcelHelpers.export(exports, "tsvFormatRows", ()=>tsvFormatRows);
parcelHelpers.export(exports, "tsvFormatRow", ()=>tsvFormatRow);
parcelHelpers.export(exports, "tsvFormatValue", ()=>tsvFormatValue);
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var tsv = (0, _dsvJsDefault.default)("\t");
var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatBody = tsv.formatBody;
var tsvFormatRows = tsv.formatRows;
var tsvFormatRow = tsv.formatRow;
var tsvFormatValue = tsv.formatValue;

},{"./dsv.js":"gzXu1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4KUc4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>autoType);
function autoType(object) {
    for(var key in object){
        var value = object[key].trim(), number, m;
        if (!value) value = null;
        else if (value === "true") value = true;
        else if (value === "false") value = false;
        else if (value === "NaN") value = NaN;
        else if (!isNaN(number = +value)) value = number;
        else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
            if (fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
            value = new Date(value);
        } else continue;
        object[key] = value;
    }
    return object;
}
// https://github.com/d3/d3-dsv/issues/45
const fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eiAqH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blob", ()=>(0, _blobJsDefault.default));
parcelHelpers.export(exports, "buffer", ()=>(0, _bufferJsDefault.default));
parcelHelpers.export(exports, "dsv", ()=>(0, _dsvJsDefault.default));
parcelHelpers.export(exports, "csv", ()=>(0, _dsvJs.csv));
parcelHelpers.export(exports, "tsv", ()=>(0, _dsvJs.tsv));
parcelHelpers.export(exports, "image", ()=>(0, _imageJsDefault.default));
parcelHelpers.export(exports, "json", ()=>(0, _jsonJsDefault.default));
parcelHelpers.export(exports, "text", ()=>(0, _textJsDefault.default));
parcelHelpers.export(exports, "xml", ()=>(0, _xmlJsDefault.default));
parcelHelpers.export(exports, "html", ()=>(0, _xmlJs.html));
parcelHelpers.export(exports, "svg", ()=>(0, _xmlJs.svg));
var _blobJs = require("./blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var _imageJs = require("./image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs);
var _jsonJs = require("./json.js");
var _jsonJsDefault = parcelHelpers.interopDefault(_jsonJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _xmlJs = require("./xml.js");
var _xmlJsDefault = parcelHelpers.interopDefault(_xmlJs);

},{"./blob.js":"58A5N","./buffer.js":"di6Iz","./dsv.js":"lhnGJ","./image.js":"5S6Yr","./json.js":"4qCJG","./text.js":"f9wJJ","./xml.js":"cDxJ3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"58A5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseBlob);
    });
function responseBlob(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.blob();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"di6Iz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseArrayBuffer);
    });
function responseArrayBuffer(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.arrayBuffer();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lhnGJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dsv);
parcelHelpers.export(exports, "csv", ()=>csv);
parcelHelpers.export(exports, "tsv", ()=>tsv);
var _d3Dsv = require("d3-dsv");
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
function dsvParse(parse) {
    return function(input, init, row) {
        if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
        return (0, _textJsDefault.default)(input, init).then(function(response) {
            return parse(response, row);
        });
    };
}
function dsv(delimiter, input, init, row) {
    if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
    var format = (0, _d3Dsv.dsvFormat)(delimiter);
    return (0, _textJsDefault.default)(input, init).then(function(response) {
        return format.parse(response, row);
    });
}
var csv = dsvParse((0, _d3Dsv.csvParse));
var tsv = dsvParse((0, _d3Dsv.tsvParse));

},{"d3-dsv":"5eFMk","./text.js":"f9wJJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f9wJJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseText);
    });
function responseText(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.text();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5S6Yr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return new Promise(function(resolve, reject) {
            var image = new Image;
            for(var key in init)image[key] = init[key];
            image.onerror = reject;
            image.onload = function() {
                resolve(image);
            };
            image.src = input;
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4qCJG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseJson);
    });
function responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cDxJ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "html", ()=>html);
parcelHelpers.export(exports, "svg", ()=>svg);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
function parser(type) {
    return (input, init)=>(0, _textJsDefault.default)(input, init).then((text)=>(new DOMParser).parseFromString(text, type));
}
exports.default = parser("application/xml");
var html = parser("text/html");
var svg = parser("image/svg+xml");

},{"./text.js":"f9wJJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f2LSO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceCenter", ()=>(0, _centerJsDefault.default));
parcelHelpers.export(exports, "forceCollide", ()=>(0, _collideJsDefault.default));
parcelHelpers.export(exports, "forceLink", ()=>(0, _linkJsDefault.default));
parcelHelpers.export(exports, "forceManyBody", ()=>(0, _manyBodyJsDefault.default));
parcelHelpers.export(exports, "forceRadial", ()=>(0, _radialJsDefault.default));
parcelHelpers.export(exports, "forceSimulation", ()=>(0, _simulationJsDefault.default));
parcelHelpers.export(exports, "forceX", ()=>(0, _xJsDefault.default));
parcelHelpers.export(exports, "forceY", ()=>(0, _yJsDefault.default));
var _centerJs = require("./center.js");
var _centerJsDefault = parcelHelpers.interopDefault(_centerJs);
var _collideJs = require("./collide.js");
var _collideJsDefault = parcelHelpers.interopDefault(_collideJs);
var _linkJs = require("./link.js");
var _linkJsDefault = parcelHelpers.interopDefault(_linkJs);
var _manyBodyJs = require("./manyBody.js");
var _manyBodyJsDefault = parcelHelpers.interopDefault(_manyBodyJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _simulationJs = require("./simulation.js");
var _simulationJsDefault = parcelHelpers.interopDefault(_simulationJs);
var _xJs = require("./x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _yJs = require("./y.js");
var _yJsDefault = parcelHelpers.interopDefault(_yJs);

},{"./center.js":"2SDRD","./collide.js":"kokgW","./link.js":"3tBx4","./manyBody.js":"w7hD4","./radial.js":"56ddU","./simulation.js":"bt3hN","./x.js":"4GCfW","./y.js":"c9Ug8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2SDRD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var nodes, strength = 1;
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force() {
            var i, n = nodes.length, node, sx = 0, sy = 0;
            for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
            for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
        }
        force.initialize = function(_) {
            nodes = _;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        return force;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kokgW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var nodes, radii, random, strength = 1, iterations = 1;
        if (typeof radius !== "function") radius = (0, _constantJsDefault.default)(radius == null ? 1 : +radius);
        function force() {
            var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
            for(var k = 0; k < iterations; ++k){
                tree = (0, _d3Quadtree.quadtree)(nodes, x, y).visitAfter(prepare);
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    ri = radii[node.index], ri2 = ri * ri;
                    xi = node.x + node.vx;
                    yi = node.y + node.vy;
                    tree.visit(apply);
                }
            }
            function apply(quad, x0, y0, x1, y1) {
                var data = quad.data, rj = quad.r, r = ri + rj;
                if (data) {
                    if (data.index > node.index) {
                        var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                        if (l < r * r) {
                            if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                            if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                            l = (r - (l = Math.sqrt(l))) / l * strength;
                            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                            node.vy += (y *= l) * r;
                            data.vx -= x * (r = 1 - r);
                            data.vy -= y * r;
                        }
                    }
                    return;
                }
                return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
            }
        }
        function prepare(quad) {
            if (quad.data) return quad.r = radii[quad.data.index];
            for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            radii = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : radius;
        };
        return force;
    });
var _d3Quadtree = require("d3-quadtree");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
function x(d) {
    return d.x + d.vx;
}
function y(d) {
    return d.y + d.vy;
}

},{"d3-quadtree":"b3lga","./constant.js":"a2TkJ","./jiggle.js":"dghSV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b3lga":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quadtree", ()=>(0, _quadtreeJsDefault.default));
var _quadtreeJs = require("./quadtree.js");
var _quadtreeJsDefault = parcelHelpers.interopDefault(_quadtreeJs);

},{"./quadtree.js":"cVFAy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cVFAy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quadtree);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _coverJs = require("./cover.js");
var _coverJsDefault = parcelHelpers.interopDefault(_coverJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _rootJs = require("./root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _visitJs = require("./visit.js");
var _visitJsDefault = parcelHelpers.interopDefault(_visitJs);
var _visitAfterJs = require("./visitAfter.js");
var _visitAfterJsDefault = parcelHelpers.interopDefault(_visitAfterJs);
var _xJs = require("./x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _yJs = require("./y.js");
var _yJsDefault = parcelHelpers.interopDefault(_yJs);
function quadtree(nodes, x, y) {
    var tree = new Quadtree(x == null ? (0, _xJs.defaultX) : x, y == null ? (0, _yJs.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var treeProto = quadtree.prototype = Quadtree.prototype;
treeProto.copy = function() {
    var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = leaf_copy(child);
        }
    }
    return copy;
};
treeProto.add = (0, _addJsDefault.default);
treeProto.addAll = (0, _addJs.addAll);
treeProto.cover = (0, _coverJsDefault.default);
treeProto.data = (0, _dataJsDefault.default);
treeProto.extent = (0, _extentJsDefault.default);
treeProto.find = (0, _findJsDefault.default);
treeProto.remove = (0, _removeJsDefault.default);
treeProto.removeAll = (0, _removeJs.removeAll);
treeProto.root = (0, _rootJsDefault.default);
treeProto.size = (0, _sizeJsDefault.default);
treeProto.visit = (0, _visitJsDefault.default);
treeProto.visitAfter = (0, _visitAfterJsDefault.default);
treeProto.x = (0, _xJsDefault.default);
treeProto.y = (0, _yJsDefault.default);

},{"./add.js":"iaUBs","./cover.js":"3sOIP","./data.js":"clKfK","./extent.js":"aKF4F","./find.js":"5sgjG","./remove.js":"59OSG","./root.js":"6QJ7y","./size.js":"bfgOO","./visit.js":"glMos","./visitAfter.js":"5MrkE","./x.js":"7sCrm","./y.js":"jOoUB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iaUBs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        const x = +this._x.call(null, d), y = +this._y.call(null, d);
        return add(this.cover(x, y), x, y, d);
    });
parcelHelpers.export(exports, "addAll", ()=>addAll);
function add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function addAll(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)add(this, xz[i], yz[i], data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3sOIP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
        var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
        // If the quadtree has no extent, initialize them.
        // Integer extent are necessary so that if we later double the extent,
        // the existing quadrant boundaries don’t change due to floating point error!
        if (isNaN(x0)) {
            x1 = (x0 = Math.floor(x)) + 1;
            y1 = (y0 = Math.floor(y)) + 1;
        } else {
            var z = x1 - x0 || 1, node = this._root, parent, i;
            while(x0 > x || x >= x1 || y0 > y || y >= y1){
                i = (y < y0) << 1 | x < x0;
                parent = new Array(4), parent[i] = node, node = parent, z *= 2;
                switch(i){
                    case 0:
                        x1 = x0 + z, y1 = y0 + z;
                        break;
                    case 1:
                        x0 = x1 - z, y1 = y0 + z;
                        break;
                    case 2:
                        x1 = x0 + z, y0 = y1 - z;
                        break;
                    case 3:
                        x0 = x1 - z, y0 = y1 - z;
                        break;
                }
            }
            if (this._root && this._root.length) this._root = node;
        }
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"clKfK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var data = [];
        this.visit(function(node) {
            if (!node.length) do data.push(node.data);
            while (node = node.next);
        });
        return data;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aKF4F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
            [
                this._x0,
                this._y0
            ],
            [
                this._x1,
                this._y1
            ]
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5sgjG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y, radius) {
        var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, x0, y0, x3, y3));
        if (radius == null) radius = Infinity;
        else {
            x0 = x - radius, y0 = y - radius;
            x3 = x + radius, y3 = y + radius;
            radius *= radius;
        }
        while(q = quads.pop()){
            // Stop searching if this quadrant can’t contain a closer node.
            if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
            // Bisect the current quadrant.
            if (node.length) {
                var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
                quads.push(new (0, _quadJsDefault.default)(node[3], xm, ym, x2, y2), new (0, _quadJsDefault.default)(node[2], x1, ym, xm, y2), new (0, _quadJsDefault.default)(node[1], xm, y1, x2, ym), new (0, _quadJsDefault.default)(node[0], x1, y1, xm, ym));
                // Visit the closest quadrant first.
                if (i = (y >= ym) << 1 | x >= xm) {
                    q = quads[quads.length - 1];
                    quads[quads.length - 1] = quads[quads.length - 1 - i];
                    quads[quads.length - 1 - i] = q;
                }
            } else {
                var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
                if (d2 < radius) {
                    var d = Math.sqrt(radius = d2);
                    x0 = x - d, y0 = y - d;
                    x3 = x + d, y3 = y + d;
                    data = node.data;
                }
            }
        }
        return data;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"1bnXw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1bnXw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, x0, y0, x1, y1) {
        this.node = node;
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"59OSG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
        var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return this;
        // Find the leaf node for the point.
        // While descending, also retain the deepest parent with a non-removed sibling.
        if (node.length) while(true){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
            if (!node.length) break;
            if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
        }
        // Find the point to remove.
        while(node.data !== d)if (!(previous = node, node = node.next)) return this;
        if (next = node.next) delete node.next;
        // If there are multiple coincident points, remove just the point.
        if (previous) return next ? previous.next = next : delete previous.next, this;
        // If this is the root point, remove it.
        if (!parent) return this._root = next, this;
        // Remove this leaf.
        next ? parent[i] = next : delete parent[i];
        // If the parent now contains exactly one leaf, collapse superfluous parents.
        if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
            if (retainer) retainer[j] = node;
            else this._root = node;
        }
        return this;
    });
parcelHelpers.export(exports, "removeAll", ()=>removeAll);
function removeAll(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6QJ7y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this._root;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bfgOO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var size = 0;
        this.visit(function(node) {
            if (!node.length) do ++size;
            while (node = node.next);
        });
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"glMos":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], q, node = this._root, child, x0, y0, x1, y1;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
            var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
            if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
            if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
        }
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"1bnXw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5MrkE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], next = [], q;
        if (this._root) quads.push(new (0, _quadJsDefault.default)(this._root, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop()){
            var node = q.node;
            if (node.length) {
                var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
                if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
                if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
                if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
                if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            }
            next.push(q);
        }
        while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"1bnXw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7sCrm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultX", ()=>defaultX);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._x = _, this) : this._x;
    });
function defaultX(d) {
    return d[0];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jOoUB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultY", ()=>defaultY);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._y = _, this) : this._y;
    });
function defaultY(d) {
    return d[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a2TkJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dghSV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(random) {
        return (random() - 0.5) * 1e-6;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3tBx4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(links) {
        var id = index, strength = defaultStrength, strengths, distance = (0, _constantJsDefault.default)(30), distances, nodes, count, bias, random, iterations = 1;
        if (links == null) links = [];
        function defaultStrength(link) {
            return 1 / Math.min(count[link.source.index], count[link.target.index]);
        }
        function force(alpha) {
            for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
                link = links[i], source = link.source, target = link.target;
                x = target.x + target.vx - source.x - source.vx || (0, _jiggleJsDefault.default)(random);
                y = target.y + target.vy - source.y - source.vy || (0, _jiggleJsDefault.default)(random);
                l = Math.sqrt(x * x + y * y);
                l = (l - distances[i]) / l * alpha * strengths[i];
                x *= l, y *= l;
                target.vx -= x * (b = bias[i]);
                target.vy -= y * b;
                source.vx += x * (b = 1 - b);
                source.vy += y * b;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                    id(d, i, nodes),
                    d
                ])), link;
            for(i = 0, count = new Array(n); i < m; ++i){
                link = links[i], link.index = i;
                if (typeof link.source !== "object") link.source = find(nodeById, link.source);
                if (typeof link.target !== "object") link.target = find(nodeById, link.target);
                count[link.source.index] = (count[link.source.index] || 0) + 1;
                count[link.target.index] = (count[link.target.index] || 0) + 1;
            }
            for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
            strengths = new Array(m), initializeStrength();
            distances = new Array(m), initializeDistance();
        }
        function initializeStrength() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
        }
        function initializeDistance() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.links = function(_) {
            return arguments.length ? (links = _, initialize(), force) : links;
        };
        force.id = function(_) {
            return arguments.length ? (id = _, force) : id;
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initializeStrength(), force) : strength;
        };
        force.distance = function(_) {
            return arguments.length ? (distance = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initializeDistance(), force) : distance;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
function index(d) {
    return d.index;
}
function find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}

},{"./constant.js":"a2TkJ","./jiggle.js":"dghSV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"w7hD4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var nodes, node, random, alpha, strength = (0, _constantJsDefault.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
        function force(_) {
            var i, n = nodes.length, tree = (0, _d3Quadtree.quadtree)(nodes, (0, _simulationJs.x), (0, _simulationJs.y)).visitAfter(accumulate);
            for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            strengths = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
        }
        function accumulate(quad) {
            var strength = 0, q, c, weight = 0, x, y, i;
            // For internal nodes, accumulate forces from child quadrants.
            if (quad.length) {
                for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
                quad.x = x / weight;
                quad.y = y / weight;
            } else {
                q = quad;
                q.x = q.data.x;
                q.y = q.data.y;
                do strength += strengths[q.data.index];
                while (q = q.next);
            }
            quad.value = strength;
        }
        function apply(quad, x1, _, x2) {
            if (!quad.value) return true;
            var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
            // Apply the Barnes-Hut approximation if possible.
            // Limit forces for very close nodes; randomize direction if coincident.
            if (w * w / theta2 < l) {
                if (l < distanceMax2) {
                    if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                    if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                    if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                    node.vx += x * quad.value * alpha / l;
                    node.vy += y * quad.value * alpha / l;
                }
                return true;
            } else if (quad.length || l >= distanceMax2) return;
            // Limit forces for very close nodes; randomize direction if coincident.
            if (quad.data !== node || quad.next) {
                if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
            }
            do if (quad.data !== node) {
                w = strengths[quad.data.index] * alpha / l;
                node.vx += x * w;
                node.vy += y * w;
            }
            while (quad = quad.next);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.distanceMin = function(_) {
            return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
        };
        force.distanceMax = function(_) {
            return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
        };
        force.theta = function(_) {
            return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
        };
        return force;
    });
var _d3Quadtree = require("d3-quadtree");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
var _simulationJs = require("./simulation.js");

},{"d3-quadtree":"b3lga","./constant.js":"a2TkJ","./jiggle.js":"dghSV","./simulation.js":"bt3hN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bt3hN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
parcelHelpers.export(exports, "default", ()=>function(nodes) {
        var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, _d3Timer.timer)(step), event = (0, _d3Dispatch.dispatch)("tick", "end"), random = (0, _lcgJsDefault.default)();
        if (nodes == null) nodes = [];
        function step() {
            tick();
            event.call("tick", simulation);
            if (alpha < alphaMin) {
                stepper.stop();
                event.call("end", simulation);
            }
        }
        function tick(iterations) {
            var i, n = nodes.length, node;
            if (iterations === undefined) iterations = 1;
            for(var k = 0; k < iterations; ++k){
                alpha += (alphaTarget - alpha) * alphaDecay;
                forces.forEach(function(force) {
                    force(alpha);
                });
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    if (node.fx == null) node.x += node.vx *= velocityDecay;
                    else node.x = node.fx, node.vx = 0;
                    if (node.fy == null) node.y += node.vy *= velocityDecay;
                    else node.y = node.fy, node.vy = 0;
                }
            }
            return simulation;
        }
        function initializeNodes() {
            for(var i = 0, n = nodes.length, node; i < n; ++i){
                node = nodes[i], node.index = i;
                if (node.fx != null) node.x = node.fx;
                if (node.fy != null) node.y = node.fy;
                if (isNaN(node.x) || isNaN(node.y)) {
                    var radius = initialRadius * Math.sqrt(0.5 + i), angle = i * initialAngle;
                    node.x = radius * Math.cos(angle);
                    node.y = radius * Math.sin(angle);
                }
                if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
            }
        }
        function initializeForce(force) {
            if (force.initialize) force.initialize(nodes, random);
            return force;
        }
        initializeNodes();
        return simulation = {
            tick: tick,
            restart: function() {
                return stepper.restart(step), simulation;
            },
            stop: function() {
                return stepper.stop(), simulation;
            },
            nodes: function(_) {
                return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
            },
            alpha: function(_) {
                return arguments.length ? (alpha = +_, simulation) : alpha;
            },
            alphaMin: function(_) {
                return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
            },
            alphaDecay: function(_) {
                return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
            },
            alphaTarget: function(_) {
                return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
            },
            velocityDecay: function(_) {
                return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
            },
            randomSource: function(_) {
                return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
            },
            force: function(name, _) {
                return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
            },
            find: function(x, y, radius) {
                var i = 0, n = nodes.length, dx, dy, d2, node, closest;
                if (radius == null) radius = Infinity;
                else radius *= radius;
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    dx = x - node.x;
                    dy = y - node.y;
                    d2 = dx * dx + dy * dy;
                    if (d2 < radius) closest = node, radius = d2;
                }
                return closest;
            },
            on: function(name, _) {
                return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
            }
        };
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var _lcgJs = require("./lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
function x(d) {
    return d.x;
}
function y(d) {
    return d.y;
}
var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));

},{"d3-dispatch":"3OarL","d3-timer":"9ST7W","./lcg.js":"gpXlD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gpXlD":[function(require,module,exports,__globalThis) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let s = 1;
        return ()=>(s = (a * s + c) % m) / m;
    });
const a = 1664525;
const c = 1013904223;
const m = 4294967296; // 2^32

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"56ddU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius, x, y) {
        var nodes, strength = (0, _constantJsDefault.default)(0.1), strengths, radiuses;
        if (typeof radius !== "function") radius = (0, _constantJsDefault.default)(+radius);
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force(alpha) {
            for(var i = 0, n = nodes.length; i < n; ++i){
                var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
                node.vx += dx * k;
                node.vy += dy * k;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            radiuses = new Array(n);
            for(i = 0; i < n; ++i){
                radiuses[i] = +radius(nodes[i], i, nodes);
                strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
            }
        }
        force.initialize = function(_) {
            nodes = _, initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : radius;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"a2TkJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4GCfW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        var strength = (0, _constantJsDefault.default)(0.1), nodes, strengths, xz;
        if (typeof x !== "function") x = (0, _constantJsDefault.default)(x == null ? 0 : +x);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            xz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : x;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"a2TkJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c9Ug8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(y) {
        var strength = (0, _constantJsDefault.default)(0.1), nodes, strengths, yz;
        if (typeof y !== "function") y = (0, _constantJsDefault.default)(y == null ? 0 : +y);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            yz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : y;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"a2TkJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bpsrv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "format", ()=>(0, _defaultLocaleJs.format));
parcelHelpers.export(exports, "formatPrefix", ()=>(0, _defaultLocaleJs.formatPrefix));
parcelHelpers.export(exports, "formatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "formatSpecifier", ()=>(0, _formatSpecifierJsDefault.default));
parcelHelpers.export(exports, "FormatSpecifier", ()=>(0, _formatSpecifierJs.FormatSpecifier));
parcelHelpers.export(exports, "precisionFixed", ()=>(0, _precisionFixedJsDefault.default));
parcelHelpers.export(exports, "precisionPrefix", ()=>(0, _precisionPrefixJsDefault.default));
parcelHelpers.export(exports, "precisionRound", ()=>(0, _precisionRoundJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _precisionFixedJs = require("./precisionFixed.js");
var _precisionFixedJsDefault = parcelHelpers.interopDefault(_precisionFixedJs);
var _precisionPrefixJs = require("./precisionPrefix.js");
var _precisionPrefixJsDefault = parcelHelpers.interopDefault(_precisionPrefixJs);
var _precisionRoundJs = require("./precisionRound.js");
var _precisionRoundJsDefault = parcelHelpers.interopDefault(_precisionRoundJs);

},{"./defaultLocale.js":"1PDW2","./locale.js":"jXvmo","./formatSpecifier.js":"h2qMJ","./precisionFixed.js":"bBVpf","./precisionPrefix.js":"fZb92","./precisionRound.js":"6KkXg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1PDW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formatPrefix", ()=>formatPrefix);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var format;
var formatPrefix;
defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
}

},{"./locale.js":"jXvmo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jXvmo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, _identityJsDefault.default) : (0, _formatGroupJsDefault.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, _identityJsDefault.default) : (0, _formatNumeralsJsDefault.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = (0, _formatSpecifierJsDefault.default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!(0, _formatTypesJsDefault.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = (0, _formatTypesJsDefault.default)[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = (0, _formatTrimJsDefault.default)(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + (0, _formatPrefixAutoJs.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = (0, _formatSpecifierJsDefault.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);
var _formatGroupJs = require("./formatGroup.js");
var _formatGroupJsDefault = parcelHelpers.interopDefault(_formatGroupJs);
var _formatNumeralsJs = require("./formatNumerals.js");
var _formatNumeralsJsDefault = parcelHelpers.interopDefault(_formatNumeralsJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _formatTrimJs = require("./formatTrim.js");
var _formatTrimJsDefault = parcelHelpers.interopDefault(_formatTrimJs);
var _formatTypesJs = require("./formatTypes.js");
var _formatTypesJsDefault = parcelHelpers.interopDefault(_formatTypesJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];

},{"./exponent.js":"iZKDx","./formatGroup.js":"8qiip","./formatNumerals.js":"7dxnh","./formatSpecifier.js":"h2qMJ","./formatTrim.js":"cfmz5","./formatTypes.js":"jV6Fn","./formatPrefixAuto.js":"hO2bO","./identity.js":"7vC28","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iZKDx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x = (0, _formatDecimalJs.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"fFGcX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fFGcX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    });
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
parcelHelpers.export(exports, "formatDecimalParts", ()=>formatDecimalParts);
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8qiip":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7dxnh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h2qMJ":[function(require,module,exports,__globalThis) {
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatSpecifier);
parcelHelpers.export(exports, "FormatSpecifier", ()=>FormatSpecifier);
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cfmz5":[function(require,module,exports,__globalThis) {
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jV6Fn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatDecimalJs = require("./formatDecimal.js");
var _formatDecimalJsDefault = parcelHelpers.interopDefault(_formatDecimalJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _formatPrefixAutoJsDefault = parcelHelpers.interopDefault(_formatPrefixAutoJs);
var _formatRoundedJs = require("./formatRounded.js");
var _formatRoundedJsDefault = parcelHelpers.interopDefault(_formatRoundedJs);
exports.default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, _formatDecimalJsDefault.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, _formatRoundedJsDefault.default)(x * 100, p),
    "r": (0, _formatRoundedJsDefault.default),
    "s": (0, _formatPrefixAutoJsDefault.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

},{"./formatDecimal.js":"fFGcX","./formatPrefixAuto.js":"hO2bO","./formatRounded.js":"3kgZT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hO2bO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixExponent", ()=>prefixExponent);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimalJs.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    });
var _formatDecimalJs = require("./formatDecimal.js");
var prefixExponent;

},{"./formatDecimal.js":"fFGcX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3kgZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"fFGcX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7vC28":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bBVpf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step) {
        return Math.max(0, -(0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"iZKDx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fZb92":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3 - (0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"iZKDx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6KkXg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, (0, _exponentJsDefault.default)(max) - (0, _exponentJsDefault.default)(step)) + 1;
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"iZKDx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c3tWY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "geoArea", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "geoBounds", ()=>(0, _boundsJsDefault.default));
parcelHelpers.export(exports, "geoCentroid", ()=>(0, _centroidJsDefault.default));
parcelHelpers.export(exports, "geoCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "geoClipAntimeridian", ()=>(0, _antimeridianJsDefault.default));
parcelHelpers.export(exports, "geoClipCircle", ()=>(0, _circleJsDefault1.default));
parcelHelpers.export(exports, "geoClipExtent", ()=>(0, _extentJsDefault.default)) // DEPRECATED! Use d3.geoIdentity().clipExtent(…).
;
parcelHelpers.export(exports, "geoClipRectangle", ()=>(0, _rectangleJsDefault.default));
parcelHelpers.export(exports, "geoContains", ()=>(0, _containsJsDefault.default));
parcelHelpers.export(exports, "geoDistance", ()=>(0, _distanceJsDefault.default));
parcelHelpers.export(exports, "geoGraticule", ()=>(0, _graticuleJsDefault.default));
parcelHelpers.export(exports, "geoGraticule10", ()=>(0, _graticuleJs.graticule10));
parcelHelpers.export(exports, "geoInterpolate", ()=>(0, _interpolateJsDefault.default));
parcelHelpers.export(exports, "geoLength", ()=>(0, _lengthJsDefault.default));
parcelHelpers.export(exports, "geoPath", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "geoAlbers", ()=>(0, _albersJsDefault.default));
parcelHelpers.export(exports, "geoAlbersUsa", ()=>(0, _albersUsaJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEqualArea", ()=>(0, _azimuthalEqualAreaJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEqualAreaRaw", ()=>(0, _azimuthalEqualAreaJs.azimuthalEqualAreaRaw));
parcelHelpers.export(exports, "geoAzimuthalEquidistant", ()=>(0, _azimuthalEquidistantJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEquidistantRaw", ()=>(0, _azimuthalEquidistantJs.azimuthalEquidistantRaw));
parcelHelpers.export(exports, "geoConicConformal", ()=>(0, _conicConformalJsDefault.default));
parcelHelpers.export(exports, "geoConicConformalRaw", ()=>(0, _conicConformalJs.conicConformalRaw));
parcelHelpers.export(exports, "geoConicEqualArea", ()=>(0, _conicEqualAreaJsDefault.default));
parcelHelpers.export(exports, "geoConicEqualAreaRaw", ()=>(0, _conicEqualAreaJs.conicEqualAreaRaw));
parcelHelpers.export(exports, "geoConicEquidistant", ()=>(0, _conicEquidistantJsDefault.default));
parcelHelpers.export(exports, "geoConicEquidistantRaw", ()=>(0, _conicEquidistantJs.conicEquidistantRaw));
parcelHelpers.export(exports, "geoEqualEarth", ()=>(0, _equalEarthJsDefault.default));
parcelHelpers.export(exports, "geoEqualEarthRaw", ()=>(0, _equalEarthJs.equalEarthRaw));
parcelHelpers.export(exports, "geoEquirectangular", ()=>(0, _equirectangularJsDefault.default));
parcelHelpers.export(exports, "geoEquirectangularRaw", ()=>(0, _equirectangularJs.equirectangularRaw));
parcelHelpers.export(exports, "geoGnomonic", ()=>(0, _gnomonicJsDefault.default));
parcelHelpers.export(exports, "geoGnomonicRaw", ()=>(0, _gnomonicJs.gnomonicRaw));
parcelHelpers.export(exports, "geoIdentity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "geoProjection", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "geoProjectionMutator", ()=>(0, _indexJs1.projectionMutator));
parcelHelpers.export(exports, "geoMercator", ()=>(0, _mercatorJsDefault.default));
parcelHelpers.export(exports, "geoMercatorRaw", ()=>(0, _mercatorJs.mercatorRaw));
parcelHelpers.export(exports, "geoNaturalEarth1", ()=>(0, _naturalEarth1JsDefault.default));
parcelHelpers.export(exports, "geoNaturalEarth1Raw", ()=>(0, _naturalEarth1Js.naturalEarth1Raw));
parcelHelpers.export(exports, "geoOrthographic", ()=>(0, _orthographicJsDefault.default));
parcelHelpers.export(exports, "geoOrthographicRaw", ()=>(0, _orthographicJs.orthographicRaw));
parcelHelpers.export(exports, "geoStereographic", ()=>(0, _stereographicJsDefault.default));
parcelHelpers.export(exports, "geoStereographicRaw", ()=>(0, _stereographicJs.stereographicRaw));
parcelHelpers.export(exports, "geoTransverseMercator", ()=>(0, _transverseMercatorJsDefault.default));
parcelHelpers.export(exports, "geoTransverseMercatorRaw", ()=>(0, _transverseMercatorJs.transverseMercatorRaw));
parcelHelpers.export(exports, "geoRotation", ()=>(0, _rotationJsDefault.default));
parcelHelpers.export(exports, "geoStream", ()=>(0, _streamJsDefault.default));
parcelHelpers.export(exports, "geoTransform", ()=>(0, _transformJsDefault.default));
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _boundsJs = require("./bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _circleJs = require("./circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _antimeridianJs = require("./clip/antimeridian.js");
var _antimeridianJsDefault = parcelHelpers.interopDefault(_antimeridianJs);
var _circleJs1 = require("./clip/circle.js");
var _circleJsDefault1 = parcelHelpers.interopDefault(_circleJs1);
var _extentJs = require("./clip/extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _rectangleJs = require("./clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _distanceJs = require("./distance.js");
var _distanceJsDefault = parcelHelpers.interopDefault(_distanceJs);
var _graticuleJs = require("./graticule.js");
var _graticuleJsDefault = parcelHelpers.interopDefault(_graticuleJs);
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var _indexJs = require("./path/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _albersJs = require("./projection/albers.js");
var _albersJsDefault = parcelHelpers.interopDefault(_albersJs);
var _albersUsaJs = require("./projection/albersUsa.js");
var _albersUsaJsDefault = parcelHelpers.interopDefault(_albersUsaJs);
var _azimuthalEqualAreaJs = require("./projection/azimuthalEqualArea.js");
var _azimuthalEqualAreaJsDefault = parcelHelpers.interopDefault(_azimuthalEqualAreaJs);
var _azimuthalEquidistantJs = require("./projection/azimuthalEquidistant.js");
var _azimuthalEquidistantJsDefault = parcelHelpers.interopDefault(_azimuthalEquidistantJs);
var _conicConformalJs = require("./projection/conicConformal.js");
var _conicConformalJsDefault = parcelHelpers.interopDefault(_conicConformalJs);
var _conicEqualAreaJs = require("./projection/conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);
var _conicEquidistantJs = require("./projection/conicEquidistant.js");
var _conicEquidistantJsDefault = parcelHelpers.interopDefault(_conicEquidistantJs);
var _equalEarthJs = require("./projection/equalEarth.js");
var _equalEarthJsDefault = parcelHelpers.interopDefault(_equalEarthJs);
var _equirectangularJs = require("./projection/equirectangular.js");
var _equirectangularJsDefault = parcelHelpers.interopDefault(_equirectangularJs);
var _gnomonicJs = require("./projection/gnomonic.js");
var _gnomonicJsDefault = parcelHelpers.interopDefault(_gnomonicJs);
var _identityJs = require("./projection/identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _indexJs1 = require("./projection/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _mercatorJs = require("./projection/mercator.js");
var _mercatorJsDefault = parcelHelpers.interopDefault(_mercatorJs);
var _naturalEarth1Js = require("./projection/naturalEarth1.js");
var _naturalEarth1JsDefault = parcelHelpers.interopDefault(_naturalEarth1Js);
var _orthographicJs = require("./projection/orthographic.js");
var _orthographicJsDefault = parcelHelpers.interopDefault(_orthographicJs);
var _stereographicJs = require("./projection/stereographic.js");
var _stereographicJsDefault = parcelHelpers.interopDefault(_stereographicJs);
var _transverseMercatorJs = require("./projection/transverseMercator.js");
var _transverseMercatorJsDefault = parcelHelpers.interopDefault(_transverseMercatorJs);
var _rotationJs = require("./rotation.js");
var _rotationJsDefault = parcelHelpers.interopDefault(_rotationJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./area.js":"dJjgA","./bounds.js":"alUgc","./centroid.js":"7RRL5","./circle.js":"90iwh","./clip/antimeridian.js":"fuEXF","./clip/circle.js":"8HabQ","./clip/extent.js":"jWzd1","./clip/rectangle.js":"5x0dZ","./contains.js":"eAnBz","./distance.js":"iax00","./graticule.js":"eIZw9","./interpolate.js":"96ddv","./length.js":"ljrGL","./path/index.js":"iqSAG","./projection/albers.js":"18ymJ","./projection/albersUsa.js":"Ztwow","./projection/azimuthalEqualArea.js":"aCfBB","./projection/azimuthalEquidistant.js":"217dH","./projection/conicConformal.js":"hiR31","./projection/conicEqualArea.js":"akzIX","./projection/conicEquidistant.js":"cCy8c","./projection/equalEarth.js":"amg4e","./projection/equirectangular.js":"eRR1r","./projection/gnomonic.js":"jmdCs","./projection/identity.js":"7G2qR","./projection/index.js":"cDT5m","./projection/mercator.js":"17h4e","./projection/naturalEarth1.js":"63KuJ","./projection/orthographic.js":"hDkXA","./projection/stereographic.js":"gM6Ku","./projection/transverseMercator.js":"a6I3i","./rotation.js":"7IUFJ","./stream.js":"hRAvu","./transform.js":"iiS5g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJjgA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areaRingSum", ()=>areaRingSum);
parcelHelpers.export(exports, "areaStream", ()=>areaStream);
parcelHelpers.export(exports, "default", ()=>function(object) {
        areaSum = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, areaStream);
        return areaSum * 2;
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var areaRingSum = new (0, _d3Array.Adder)();
// hello?
var areaSum = new (0, _d3Array.Adder)(), lambda00, phi00, lambda0, cosPhi0, sinPhi0;
var areaStream = {
    point: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: function() {
        areaRingSum = new (0, _d3Array.Adder)();
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +areaRingSum;
        areaSum.add(areaRing < 0 ? (0, _mathJs.tau) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, _noopJsDefault.default);
    },
    sphere: function() {
        areaSum.add((0, _mathJs.tau));
    }
};
function areaRingStart() {
    areaStream.point = areaPointFirst;
}
function areaRingEnd() {
    areaPoint(lambda00, phi00);
}
function areaPointFirst(lambda, phi) {
    areaStream.point = areaPoint;
    lambda00 = lambda, phi00 = phi;
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    lambda0 = lambda, cosPhi0 = (0, _mathJs.cos)(phi = phi / 2 + (0, _mathJs.quarterPi)), sinPhi0 = (0, _mathJs.sin)(phi);
}
function areaPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    phi = phi / 2 + (0, _mathJs.quarterPi); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, _mathJs.cos)(phi), sinPhi = (0, _mathJs.sin)(phi), k = sinPhi0 * sinPhi, u = cosPhi0 * cosPhi + k * (0, _mathJs.cos)(adLambda), v = k * sdLambda * (0, _mathJs.sin)(adLambda);
    areaRingSum.add((0, _mathJs.atan2)(v, u));
    // Advance the previous points.
    lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

},{"d3-array":"bmqp6","./math.js":"kr12S","./noop.js":"73qAO","./stream.js":"hRAvu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kr12S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "epsilon2", ()=>epsilon2);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "quarterPi", ()=>quarterPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan", ()=>atan);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "ceil", ()=>ceil);
parcelHelpers.export(exports, "exp", ()=>exp);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "hypot", ()=>hypot);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "pow", ()=>pow);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sign", ()=>sign);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "tan", ()=>tan);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
parcelHelpers.export(exports, "haversin", ()=>haversin);
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var hypot = Math.hypot;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var sqrt = Math.sqrt;
var tan = Math.tan;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}
function haversin(x) {
    return (x = sin(x / 2)) * x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"73qAO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>noop);
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hRAvu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object, stream) {
        if (object && streamObjectType.hasOwnProperty(object.type)) streamObjectType[object.type](object, stream);
        else streamGeometry(object, stream);
    });
function streamGeometry(geometry, stream) {
    if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) streamGeometryType[geometry.type](geometry, stream);
}
var streamObjectType = {
    Feature: function(object, stream) {
        streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)streamGeometry(features[i].geometry, stream);
    }
};
var streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)streamGeometry(geometries[i], stream);
    }
};
function streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"alUgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(feature) {
        var i, n, a, b, merged, deltaMax, delta;
        phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
        ranges = [];
        (0, _streamJsDefault.default)(feature, boundsStream);
        // First, sort ranges by their minimum longitudes.
        if (n = ranges.length) {
            ranges.sort(rangeCompare);
            // Then, merge any ranges that overlap.
            for(i = 1, a = ranges[0], merged = [
                a
            ]; i < n; ++i){
                b = ranges[i];
                if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
                    if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
                    if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
                } else merged.push(a = b);
            }
            // Finally, find the largest gap between the merged ranges.
            // The final bounding box will be the inverse of this gap.
            for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
                b = merged[i];
                if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
            }
        }
        ranges = range = null;
        return lambda0 === Infinity || phi0 === Infinity ? [
            [
                NaN,
                NaN
            ],
            [
                NaN,
                NaN
            ]
        ] : [
            [
                lambda0,
                phi0
            ],
            [
                lambda1,
                phi1
            ]
        ];
    });
var _d3Array = require("d3-array");
var _areaJs = require("./area.js");
var _cartesianJs = require("./cartesian.js");
var _mathJs = require("./math.js");
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var lambda0, phi0, lambda1, phi1, lambda2, lambda00, phi00, p0, deltaSum, ranges, range;
var boundsStream = {
    point: boundsPoint,
    lineStart: boundsLineStart,
    lineEnd: boundsLineEnd,
    polygonStart: function() {
        boundsStream.point = boundsRingPoint;
        boundsStream.lineStart = boundsRingStart;
        boundsStream.lineEnd = boundsRingEnd;
        deltaSum = new (0, _d3Array.Adder)();
        (0, _areaJs.areaStream).polygonStart();
    },
    polygonEnd: function() {
        (0, _areaJs.areaStream).polygonEnd();
        boundsStream.point = boundsPoint;
        boundsStream.lineStart = boundsLineStart;
        boundsStream.lineEnd = boundsLineEnd;
        if ((0, _areaJs.areaRingSum) < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
        else if (deltaSum > (0, _mathJs.epsilon)) phi1 = 90;
        else if (deltaSum < -(0, _mathJs.epsilon)) phi0 = -90;
        range[0] = lambda0, range[1] = lambda1;
    },
    sphere: function() {
        lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    }
};
function boundsPoint(lambda, phi) {
    ranges.push(range = [
        lambda0 = lambda,
        lambda1 = lambda
    ]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
}
function linePoint(lambda, phi) {
    var p = (0, _cartesianJs.cartesian)([
        lambda * (0, _mathJs.radians),
        phi * (0, _mathJs.radians)
    ]);
    if (p0) {
        var normal = (0, _cartesianJs.cartesianCross)(p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, _cartesianJs.cartesianCross)(equatorial, normal);
        (0, _cartesianJs.cartesianNormalizeInPlace)(inflection);
        inflection = (0, _cartesianJs.spherical)(inflection);
        var delta = lambda - lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, _mathJs.degrees) * sign, phii, antimeridian = (0, _mathJs.abs)(delta) > 180;
        if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, _mathJs.degrees);
            if (phii > phi1) phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, _mathJs.degrees);
            if (phii < phi0) phi0 = phii;
        } else {
            if (phi < phi0) phi0 = phi;
            if (phi > phi1) phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < lambda2) {
                if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
            } else if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        } else if (lambda1 >= lambda0) {
            if (lambda < lambda0) lambda0 = lambda;
            if (lambda > lambda1) lambda1 = lambda;
        } else {
            if (lambda > lambda2) {
                if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
            } else if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
    } else ranges.push(range = [
        lambda0 = lambda,
        lambda1 = lambda
    ]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
    p0 = p, lambda2 = lambda;
}
function boundsLineStart() {
    boundsStream.point = linePoint;
}
function boundsLineEnd() {
    range[0] = lambda0, range[1] = lambda1;
    boundsStream.point = boundsPoint;
    p0 = null;
}
function boundsRingPoint(lambda, phi) {
    if (p0) {
        var delta = lambda - lambda2;
        deltaSum.add((0, _mathJs.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else lambda00 = lambda, phi00 = phi;
    (0, _areaJs.areaStream).point(lambda, phi);
    linePoint(lambda, phi);
}
function boundsRingStart() {
    (0, _areaJs.areaStream).lineStart();
}
function boundsRingEnd() {
    boundsRingPoint(lambda00, phi00);
    (0, _areaJs.areaStream).lineEnd();
    if ((0, _mathJs.abs)(deltaSum) > (0, _mathJs.epsilon)) lambda0 = -(lambda1 = 180);
    range[0] = lambda0, range[1] = lambda1;
    p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function rangeCompare(a, b) {
    return a[0] - b[0];
}
function rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

},{"d3-array":"bmqp6","./area.js":"dJjgA","./cartesian.js":"2GO7u","./math.js":"kr12S","./stream.js":"hRAvu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2GO7u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spherical", ()=>spherical);
parcelHelpers.export(exports, "cartesian", ()=>cartesian);
parcelHelpers.export(exports, "cartesianDot", ()=>cartesianDot);
parcelHelpers.export(exports, "cartesianCross", ()=>cartesianCross);
// TODO return a
parcelHelpers.export(exports, "cartesianAddInPlace", ()=>cartesianAddInPlace);
parcelHelpers.export(exports, "cartesianScale", ()=>cartesianScale);
// TODO return d
parcelHelpers.export(exports, "cartesianNormalizeInPlace", ()=>cartesianNormalizeInPlace);
var _mathJs = require("./math.js");
function spherical(cartesian) {
    return [
        (0, _mathJs.atan2)(cartesian[1], cartesian[0]),
        (0, _mathJs.asin)(cartesian[2])
    ];
}
function cartesian(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, _mathJs.cos)(phi);
    return [
        cosPhi * (0, _mathJs.cos)(lambda),
        cosPhi * (0, _mathJs.sin)(lambda),
        (0, _mathJs.sin)(phi)
    ];
}
function cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function cartesianCross(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function cartesianAddInPlace(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function cartesianScale(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function cartesianNormalizeInPlace(d) {
    var l = (0, _mathJs.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}

},{"./math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7RRL5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object) {
        W0 = W1 = X0 = Y0 = Z0 = X1 = Y1 = Z1 = 0;
        X2 = new (0, _d3Array.Adder)();
        Y2 = new (0, _d3Array.Adder)();
        Z2 = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, centroidStream);
        var x = +X2, y = +Y2, z = +Z2, m = (0, _mathJs.hypot)(x, y, z);
        // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
        if (m < (0, _mathJs.epsilon2)) {
            x = X1, y = Y1, z = Z1;
            // If the feature has zero length, fall back to arithmetic mean of point vectors.
            if (W1 < (0, _mathJs.epsilon)) x = X0, y = Y0, z = Z0;
            m = (0, _mathJs.hypot)(x, y, z);
            // If the feature still has an undefined ccentroid, then return.
            if (m < (0, _mathJs.epsilon2)) return [
                NaN,
                NaN
            ];
        }
        return [
            (0, _mathJs.atan2)(y, x) * (0, _mathJs.degrees),
            (0, _mathJs.asin)(z / m) * (0, _mathJs.degrees)
        ];
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var W0, W1, X0, Y0, Z0, X1, Y1, Z1, X2, Y2, Z2, lambda00, phi00, x0, y0, z0; // previous point
var centroidStream = {
    sphere: (0, _noopJsDefault.default),
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function() {
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi);
    centroidPointCartesian(cosPhi * (0, _mathJs.cos)(lambda), cosPhi * (0, _mathJs.sin)(lambda), (0, _mathJs.sin)(phi));
}
function centroidPointCartesian(x, y, z) {
    ++W0;
    X0 += (x - X0) / W0;
    Y0 += (y - Y0) / W0;
    Z0 += (z - Z0) / W0;
}
function centroidLineStart() {
    centroidStream.point = centroidLinePointFirst;
}
function centroidLinePointFirst(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi);
    x0 = cosPhi * (0, _mathJs.cos)(lambda);
    y0 = cosPhi * (0, _mathJs.sin)(lambda);
    z0 = (0, _mathJs.sin)(phi);
    centroidStream.point = centroidLinePoint;
    centroidPointCartesian(x0, y0, z0);
}
function centroidLinePoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi), x = cosPhi * (0, _mathJs.cos)(lambda), y = cosPhi * (0, _mathJs.sin)(lambda), z = (0, _mathJs.sin)(phi), w = (0, _mathJs.atan2)((0, _mathJs.sqrt)((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
    W1 += w;
    X1 += w * (x0 + (x0 = x));
    Y1 += w * (y0 + (y0 = y));
    Z1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0, y0, z0);
}
function centroidLineEnd() {
    centroidStream.point = centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
    centroidStream.point = centroidRingPointFirst;
}
function centroidRingEnd() {
    centroidRingPoint(lambda00, phi00);
    centroidStream.point = centroidPoint;
}
function centroidRingPointFirst(lambda, phi) {
    lambda00 = lambda, phi00 = phi;
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    centroidStream.point = centroidRingPoint;
    var cosPhi = (0, _mathJs.cos)(phi);
    x0 = cosPhi * (0, _mathJs.cos)(lambda);
    y0 = cosPhi * (0, _mathJs.sin)(lambda);
    z0 = (0, _mathJs.sin)(phi);
    centroidPointCartesian(x0, y0, z0);
}
function centroidRingPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi), x = cosPhi * (0, _mathJs.cos)(lambda), y = cosPhi * (0, _mathJs.sin)(lambda), z = (0, _mathJs.sin)(phi), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = (0, _mathJs.hypot)(cx, cy, cz), w = (0, _mathJs.asin)(m), v = m && -w / m; // area weight multiplier
    X2.add(v * cx);
    Y2.add(v * cy);
    Z2.add(v * cz);
    W1 += w;
    X1 += w * (x0 + (x0 = x));
    Y1 += w * (y0 + (y0 = y));
    Z1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0, y0, z0);
}

},{"d3-array":"bmqp6","./math.js":"kr12S","./noop.js":"73qAO","./stream.js":"hRAvu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"90iwh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Generates a circle centered at [0°, 0°], with a given radius and precision.
parcelHelpers.export(exports, "circleStream", ()=>circleStream);
parcelHelpers.export(exports, "default", ()=>function() {
        var center = (0, _constantJsDefault.default)([
            0,
            0
        ]), radius = (0, _constantJsDefault.default)(90), precision = (0, _constantJsDefault.default)(2), ring, rotate, stream = {
            point: point
        };
        function point(x, y) {
            ring.push(x = rotate(x, y));
            x[0] *= (0, _mathJs.degrees), x[1] *= (0, _mathJs.degrees);
        }
        function circle() {
            var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, _mathJs.radians), p = precision.apply(this, arguments) * (0, _mathJs.radians);
            ring = [];
            rotate = (0, _rotationJs.rotateRadians)(-c[0] * (0, _mathJs.radians), -c[1] * (0, _mathJs.radians), 0).invert;
            circleStream(stream, r, p, 1);
            c = {
                type: "Polygon",
                coordinates: [
                    ring
                ]
            };
            ring = rotate = null;
            return c;
        }
        circle.center = function(_) {
            return arguments.length ? (center = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                +_[0],
                +_[1]
            ]), circle) : center;
        };
        circle.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), circle) : radius;
        };
        circle.precision = function(_) {
            return arguments.length ? (precision = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), circle) : precision;
        };
        return circle;
    });
var _cartesianJs = require("./cartesian.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
var _rotationJs = require("./rotation.js");
function circleStream(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, _mathJs.cos)(radius), sinRadius = (0, _mathJs.sin)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, _mathJs.tau);
        t1 = radius - step / 2;
    } else {
        t0 = circleRadius(cosRadius, t0);
        t1 = circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, _mathJs.tau);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, _cartesianJs.spherical)([
            cosRadius,
            -sinRadius * (0, _mathJs.cos)(t),
            -sinRadius * (0, _mathJs.sin)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
    point = (0, _cartesianJs.cartesian)(point), point[0] -= cosRadius;
    (0, _cartesianJs.cartesianNormalizeInPlace)(point);
    var radius = (0, _mathJs.acos)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, _mathJs.tau) - (0, _mathJs.epsilon)) % (0, _mathJs.tau);
}

},{"./cartesian.js":"2GO7u","./constant.js":"4mYRk","./math.js":"kr12S","./rotation.js":"7IUFJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4mYRk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7IUFJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rotateRadians", ()=>rotateRadians);
parcelHelpers.export(exports, "default", ()=>function(rotate) {
        rotate = rotateRadians(rotate[0] * (0, _mathJs.radians), rotate[1] * (0, _mathJs.radians), rotate.length > 2 ? rotate[2] * (0, _mathJs.radians) : 0);
        function forward(coordinates) {
            coordinates = rotate(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
            return coordinates[0] *= (0, _mathJs.degrees), coordinates[1] *= (0, _mathJs.degrees), coordinates;
        }
        forward.invert = function(coordinates) {
            coordinates = rotate.invert(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
            return coordinates[0] *= (0, _mathJs.degrees), coordinates[1] *= (0, _mathJs.degrees), coordinates;
        };
        return forward;
    });
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _mathJs = require("./math.js");
function rotationIdentity(lambda, phi) {
    if ((0, _mathJs.abs)(lambda) > (0, _mathJs.pi)) lambda -= Math.round(lambda / (0, _mathJs.tau)) * (0, _mathJs.tau);
    return [
        lambda,
        phi
    ];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, _mathJs.tau)) ? deltaPhi || deltaGamma ? (0, _composeJsDefault.default)(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        lambda += deltaLambda;
        if ((0, _mathJs.abs)(lambda) > (0, _mathJs.pi)) lambda -= Math.round(lambda / (0, _mathJs.tau)) * (0, _mathJs.tau);
        return [
            lambda,
            phi
        ];
    };
}
function rotationLambda(deltaLambda) {
    var rotation = forwardRotationLambda(deltaLambda);
    rotation.invert = forwardRotationLambda(-deltaLambda);
    return rotation;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, _mathJs.cos)(deltaPhi), sinDeltaPhi = (0, _mathJs.sin)(deltaPhi), cosDeltaGamma = (0, _mathJs.cos)(deltaGamma), sinDeltaGamma = (0, _mathJs.sin)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, _mathJs.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, _mathJs.asin)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, _mathJs.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, _mathJs.asin)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}

},{"./compose.js":"47XqF","./math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"47XqF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        function compose(x, y) {
            return x = a(x, y), b(x[0], x[1]);
        }
        if (a.invert && b.invert) compose.invert = function(x, y) {
            return x = b.invert(x, y), x && a.invert(x[0], x[1]);
        };
        return compose;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fuEXF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
exports.default = (0, _indexJsDefault.default)(function() {
    return true;
}, clipAntimeridianLine, clipAntimeridianInterpolate, [
    -(0, _mathJs.pi),
    -(0, _mathJs.halfPi)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi), delta = (0, _mathJs.abs)(lambda1 - lambda0);
            if ((0, _mathJs.abs)(delta - (0, _mathJs.pi)) < (0, _mathJs.epsilon)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, _mathJs.halfPi) : -(0, _mathJs.halfPi));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, _mathJs.pi)) {
                if ((0, _mathJs.abs)(lambda0 - sign0) < (0, _mathJs.epsilon)) lambda0 -= sign0 * (0, _mathJs.epsilon); // handle degeneracies
                if ((0, _mathJs.abs)(lambda1 - sign1) < (0, _mathJs.epsilon)) lambda1 -= sign1 * (0, _mathJs.epsilon);
                phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, _mathJs.sin)(lambda0 - lambda1);
    return (0, _mathJs.abs)(sinLambda0Lambda1) > (0, _mathJs.epsilon) ? (0, _mathJs.atan)(((0, _mathJs.sin)(phi0) * (cosPhi1 = (0, _mathJs.cos)(phi1)) * (0, _mathJs.sin)(lambda1) - (0, _mathJs.sin)(phi1) * (cosPhi0 = (0, _mathJs.cos)(phi0)) * (0, _mathJs.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, _mathJs.halfPi);
        stream.point(-(0, _mathJs.pi), phi);
        stream.point(0, phi);
        stream.point((0, _mathJs.pi), phi);
        stream.point((0, _mathJs.pi), 0);
        stream.point((0, _mathJs.pi), -phi);
        stream.point(0, -phi);
        stream.point(-(0, _mathJs.pi), -phi);
        stream.point(-(0, _mathJs.pi), 0);
        stream.point(-(0, _mathJs.pi), phi);
    } else if ((0, _mathJs.abs)(from[0] - to[0]) > (0, _mathJs.epsilon)) {
        var lambda = from[0] < to[0] ? (0, _mathJs.pi) : -(0, _mathJs.pi);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}

},{"./index.js":"9L9U1","../math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9L9U1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(pointVisible, clipLine, interpolate, start) {
        return function(sink) {
            var line = clipLine(sink), ringBuffer = (0, _bufferJsDefault.default)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    clip.point = pointRing;
                    clip.lineStart = ringStart;
                    clip.lineEnd = ringEnd;
                    segments = [];
                    polygon = [];
                },
                polygonEnd: function() {
                    clip.point = point;
                    clip.lineStart = lineStart;
                    clip.lineEnd = lineEnd;
                    segments = (0, _d3Array.merge)(segments);
                    var startInside = (0, _polygonContainsJsDefault.default)(polygon, start);
                    if (segments.length) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        (0, _rejoinJsDefault.default)(segments, compareIntersection, startInside, interpolate, sink);
                    } else if (startInside) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        interpolate(null, null, 1, sink);
                        sink.lineEnd();
                    }
                    if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                    segments = polygon = null;
                },
                sphere: function() {
                    sink.polygonStart();
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                    sink.polygonEnd();
                }
            };
            function point(lambda, phi) {
                if (pointVisible(lambda, phi)) sink.point(lambda, phi);
            }
            function pointLine(lambda, phi) {
                line.point(lambda, phi);
            }
            function lineStart() {
                clip.point = pointLine;
                line.lineStart();
            }
            function lineEnd() {
                clip.point = point;
                line.lineEnd();
            }
            function pointRing(lambda, phi) {
                ring.push([
                    lambda,
                    phi
                ]);
                ringSink.point(lambda, phi);
            }
            function ringStart() {
                ringSink.lineStart();
                ring = [];
            }
            function ringEnd() {
                pointRing(ring[0][0], ring[0][1]);
                ringSink.lineEnd();
                var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
                ring.pop();
                polygon.push(ring);
                ring = null;
                if (!n) return;
                // No intersections.
                if (clean & 1) {
                    segment = ringSegments[0];
                    if ((m = segment.length - 1) > 0) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                        sink.lineEnd();
                    }
                    return;
                }
                // Rejoin connected segments.
                // TODO reuse ringBuffer.rejoin()?
                if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
                segments.push(ringSegments.filter(validSegment));
            }
            return clip;
        };
    });
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _rejoinJs = require("./rejoin.js");
var _rejoinJsDefault = parcelHelpers.interopDefault(_rejoinJs);
var _mathJs = require("../math.js");
var _polygonContainsJs = require("../polygonContains.js");
var _polygonContainsJsDefault = parcelHelpers.interopDefault(_polygonContainsJs);
var _d3Array = require("d3-array");
function validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, _mathJs.halfPi) - (0, _mathJs.epsilon) : (0, _mathJs.halfPi) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, _mathJs.halfPi) - (0, _mathJs.epsilon) : (0, _mathJs.halfPi) - b[1]);
}

},{"./buffer.js":"cuO8R","./rejoin.js":"ifsLB","../math.js":"kr12S","../polygonContains.js":"1tllI","d3-array":"bmqp6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cuO8R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var lines = [], line;
        return {
            point: function(x, y, m) {
                line.push([
                    x,
                    y,
                    m
                ]);
            },
            lineStart: function() {
                lines.push(line = []);
            },
            lineEnd: (0, _noopJsDefault.default),
            rejoin: function() {
                if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
            },
            result: function() {
                var result = lines;
                lines = [];
                line = null;
                return result;
            }
        };
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);

},{"../noop.js":"73qAO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ifsLB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
parcelHelpers.export(exports, "default", ()=>function(segments, compareIntersection, startInside, interpolate, stream) {
        var subject = [], clip = [], i, n;
        segments.forEach(function(segment) {
            if ((n = segment.length - 1) <= 0) return;
            var n, p0 = segment[0], p1 = segment[n], x;
            if ((0, _pointEqualJsDefault.default)(p0, p1)) {
                if (!p0[2] && !p1[2]) {
                    stream.lineStart();
                    for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                    stream.lineEnd();
                    return;
                }
                // handle degenerate cases by moving the point
                p1[0] += 2 * (0, _mathJs.epsilon);
            }
            subject.push(x = new Intersection(p0, segment, null, true));
            clip.push(x.o = new Intersection(p0, null, x, false));
            subject.push(x = new Intersection(p1, segment, null, false));
            clip.push(x.o = new Intersection(p1, null, x, true));
        });
        if (!subject.length) return;
        clip.sort(compareIntersection);
        link(subject);
        link(clip);
        for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
        var start = subject[0], points, point;
        while(true){
            // Find first unvisited intersection.
            var current = start, isSubject = true;
            while(current.v)if ((current = current.n) === start) return;
            points = current.z;
            stream.lineStart();
            do {
                current.v = current.o.v = true;
                if (current.e) {
                    if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                    else interpolate(current.x, current.n.x, 1, stream);
                    current = current.n;
                } else {
                    if (isSubject) {
                        points = current.p.z;
                        for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                    } else interpolate(current.x, current.p.x, -1, stream);
                    current = current.p;
                }
                current = current.o;
                points = current.z;
                isSubject = !isSubject;
            }while (!current.v);
            stream.lineEnd();
        }
    });
var _pointEqualJs = require("../pointEqual.js");
var _pointEqualJsDefault = parcelHelpers.interopDefault(_pointEqualJs);
var _mathJs = require("../math.js");
function Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}

},{"../pointEqual.js":"sE4jE","../math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"sE4jE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return (0, _mathJs.abs)(a[0] - b[0]) < (0, _mathJs.epsilon) && (0, _mathJs.abs)(a[1] - b[1]) < (0, _mathJs.epsilon);
    });
var _mathJs = require("./math.js");

},{"./math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1tllI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon, point) {
        var lambda = longitude(point), phi = point[1], sinPhi = (0, _mathJs.sin)(phi), normal = [
            (0, _mathJs.sin)(lambda),
            -(0, _mathJs.cos)(lambda),
            0
        ], angle = 0, winding = 0;
        var sum = new (0, _d3Array.Adder)();
        if (sinPhi === 1) phi = (0, _mathJs.halfPi) + (0, _mathJs.epsilon);
        else if (sinPhi === -1) phi = -(0, _mathJs.halfPi) - (0, _mathJs.epsilon);
        for(var i = 0, n = polygon.length; i < n; ++i){
            if (!(m = (ring = polygon[i]).length)) continue;
            var ring, m, point0 = ring[m - 1], lambda0 = longitude(point0), phi0 = point0[1] / 2 + (0, _mathJs.quarterPi), sinPhi0 = (0, _mathJs.sin)(phi0), cosPhi0 = (0, _mathJs.cos)(phi0);
            for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
                var point1 = ring[j], lambda1 = longitude(point1), phi1 = point1[1] / 2 + (0, _mathJs.quarterPi), sinPhi1 = (0, _mathJs.sin)(phi1), cosPhi1 = (0, _mathJs.cos)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, _mathJs.pi), k = sinPhi0 * sinPhi1;
                sum.add((0, _mathJs.atan2)(k * sign * (0, _mathJs.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, _mathJs.cos)(absDelta)));
                angle += antimeridian ? delta + sign * (0, _mathJs.tau) : delta;
                // Are the longitudes either side of the point’s meridian (lambda),
                // and are the latitudes smaller than the parallel (phi)?
                if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                    var arc = (0, _cartesianJs.cartesianCross)((0, _cartesianJs.cartesian)(point0), (0, _cartesianJs.cartesian)(point1));
                    (0, _cartesianJs.cartesianNormalizeInPlace)(arc);
                    var intersection = (0, _cartesianJs.cartesianCross)(normal, arc);
                    (0, _cartesianJs.cartesianNormalizeInPlace)(intersection);
                    var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, _mathJs.asin)(intersection[2]);
                    if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
                }
            }
        }
        // First, determine whether the South pole is inside or outside:
        //
        // It is inside if:
        // * the polygon winds around it in a clockwise direction.
        // * the polygon does not (cumulatively) wind around it, but has a negative
        //   (counter-clockwise) area.
        //
        // Second, count the (signed) number of times a segment crosses a lambda
        // from the point to the South pole.  If it is zero, then the point is the
        // same side as the South pole.
        return (angle < -(0, _mathJs.epsilon) || angle < (0, _mathJs.epsilon) && sum < -(0, _mathJs.epsilon2)) ^ winding & 1;
    });
var _d3Array = require("d3-array");
var _cartesianJs = require("./cartesian.js");
var _mathJs = require("./math.js");
function longitude(point) {
    return (0, _mathJs.abs)(point[0]) <= (0, _mathJs.pi) ? point[0] : (0, _mathJs.sign)(point[0]) * (((0, _mathJs.abs)(point[0]) + (0, _mathJs.pi)) % (0, _mathJs.tau) - (0, _mathJs.pi));
}

},{"d3-array":"bmqp6","./cartesian.js":"2GO7u","./math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8HabQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var cr = (0, _mathJs.cos)(radius), delta = 2 * (0, _mathJs.radians), smallRadius = cr > 0, notHemisphere = (0, _mathJs.abs)(cr) > (0, _mathJs.epsilon); // TODO optimise for this common case
        function interpolate(from, to, direction, stream) {
            (0, _circleJs.circleStream)(stream, radius, delta, direction, from, to);
        }
        function visible(lambda, phi) {
            return (0, _mathJs.cos)(lambda) * (0, _mathJs.cos)(phi) > cr;
        }
        // Takes a line and cuts into visible segments. Return values used for polygon
        // clipping: 0 - there were intersections or the line was empty; 1 - no
        // intersections 2 - there were intersections, and the first and last segments
        // should be rejoined.
        function clipLine(stream) {
            var point0, c0, v0, v00, clean; // no intersections
            return {
                lineStart: function() {
                    v00 = v0 = false;
                    clean = 1;
                },
                point: function(lambda, phi) {
                    var point1 = [
                        lambda,
                        phi
                    ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi)), phi) : 0;
                    if (!point0 && (v00 = v0 = v)) stream.lineStart();
                    if (v !== v0) {
                        point2 = intersect(point0, point1);
                        if (!point2 || (0, _pointEqualJsDefault.default)(point0, point2) || (0, _pointEqualJsDefault.default)(point1, point2)) point1[2] = 1;
                    }
                    if (v !== v0) {
                        clean = 0;
                        if (v) {
                            // outside going in
                            stream.lineStart();
                            point2 = intersect(point1, point0);
                            stream.point(point2[0], point2[1]);
                        } else {
                            // inside going out
                            point2 = intersect(point0, point1);
                            stream.point(point2[0], point2[1], 2);
                            stream.lineEnd();
                        }
                        point0 = point2;
                    } else if (notHemisphere && point0 && smallRadius ^ v) {
                        var t;
                        // If the codes for two points are different, or are both zero,
                        // and there this segment intersects with the small circle.
                        if (!(c & c0) && (t = intersect(point1, point0, true))) {
                            clean = 0;
                            if (smallRadius) {
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1]);
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                            } else {
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1], 3);
                            }
                        }
                    }
                    if (v && (!point0 || !(0, _pointEqualJsDefault.default)(point0, point1))) stream.point(point1[0], point1[1]);
                    point0 = point1, v0 = v, c0 = c;
                },
                lineEnd: function() {
                    if (v0) stream.lineEnd();
                    point0 = null;
                },
                // Rejoin first and last segments if there were intersections and the first
                // and last points were visible.
                clean: function() {
                    return clean | (v00 && v0) << 1;
                }
            };
        }
        // Intersects the great circle between a and b with the clip circle.
        function intersect(a, b, two) {
            var pa = (0, _cartesianJs.cartesian)(a), pb = (0, _cartesianJs.cartesian)(b);
            // We have two planes, n1.p = d1 and n2.p = d2.
            // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
            var n1 = [
                1,
                0,
                0
            ], n2 = (0, _cartesianJs.cartesianCross)(pa, pb), n2n2 = (0, _cartesianJs.cartesianDot)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
            // Two polar points.
            if (!determinant) return !two && a;
            var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, _cartesianJs.cartesianCross)(n1, n2), A = (0, _cartesianJs.cartesianScale)(n1, c1), B = (0, _cartesianJs.cartesianScale)(n2, c2);
            (0, _cartesianJs.cartesianAddInPlace)(A, B);
            // Solve |p(t)|^2 = 1.
            var u = n1xn2, w = (0, _cartesianJs.cartesianDot)(A, u), uu = (0, _cartesianJs.cartesianDot)(u, u), t2 = w * w - uu * ((0, _cartesianJs.cartesianDot)(A, A) - 1);
            if (t2 < 0) return;
            var t = (0, _mathJs.sqrt)(t2), q = (0, _cartesianJs.cartesianScale)(u, (-w - t) / uu);
            (0, _cartesianJs.cartesianAddInPlace)(q, A);
            q = (0, _cartesianJs.spherical)(q);
            if (!two) return q;
            // Two intersection points.
            var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
            if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
            var delta = lambda1 - lambda0, polar = (0, _mathJs.abs)(delta - (0, _mathJs.pi)) < (0, _mathJs.epsilon), meridian = polar || delta < (0, _mathJs.epsilon);
            if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
            // Check that the first point is between a and b.
            if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, _mathJs.abs)(q[0] - lambda0) < (0, _mathJs.epsilon) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, _mathJs.pi) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
                var q1 = (0, _cartesianJs.cartesianScale)(u, (-w + t) / uu);
                (0, _cartesianJs.cartesianAddInPlace)(q1, A);
                return [
                    q,
                    (0, _cartesianJs.spherical)(q1)
                ];
            }
        }
        // Generates a 4-bit vector representing the location of a point relative to
        // the small circle's bounding box.
        function code(lambda, phi) {
            var r = smallRadius ? radius : (0, _mathJs.pi) - radius, code = 0;
            if (lambda < -r) code |= 1; // left
            else if (lambda > r) code |= 2; // right
            if (phi < -r) code |= 4; // below
            else if (phi > r) code |= 8; // above
            return code;
        }
        return (0, _indexJsDefault.default)(visible, clipLine, interpolate, smallRadius ? [
            0,
            -radius
        ] : [
            -(0, _mathJs.pi),
            radius - (0, _mathJs.pi)
        ]);
    });
var _cartesianJs = require("../cartesian.js");
var _circleJs = require("../circle.js");
var _mathJs = require("../math.js");
var _pointEqualJs = require("../pointEqual.js");
var _pointEqualJsDefault = parcelHelpers.interopDefault(_pointEqualJs);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);

},{"../cartesian.js":"2GO7u","../circle.js":"90iwh","../math.js":"kr12S","../pointEqual.js":"sE4jE","./index.js":"9L9U1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jWzd1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
        return clip = {
            stream: function(stream) {
                return cache && cacheStream === stream ? cache : cache = (0, _rectangleJsDefault.default)(x0, y0, x1, y1)(cacheStream = stream);
            },
            extent: function(_) {
                return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ];
            }
        };
    });
var _rectangleJs = require("./rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);

},{"./rectangle.js":"5x0dZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5x0dZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>clipRectangle);
var _mathJs = require("../math.js");
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _rejoinJs = require("./rejoin.js");
var _rejoinJsDefault = parcelHelpers.interopDefault(_rejoinJs);
var _d3Array = require("d3-array");
var clipMax = 1e9, clipMin = -clipMax;
function clipRectangle(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, _mathJs.abs)(p[0] - x0) < (0, _mathJs.epsilon) ? direction > 0 ? 0 : 3 : (0, _mathJs.abs)(p[0] - x1) < (0, _mathJs.epsilon) ? direction > 0 ? 2 : 1 : (0, _mathJs.abs)(p[1] - y0) < (0, _mathJs.epsilon) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, _bufferJsDefault.default)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, _d3Array.merge)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, _rejoinJsDefault.default)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max(clipMin, Math.min(clipMax, x_)),
                    y_ = Math.max(clipMin, Math.min(clipMax, y_))
                ], b = [
                    x = Math.max(clipMin, Math.min(clipMax, x)),
                    y = Math.max(clipMin, Math.min(clipMax, y))
                ];
                if ((0, _lineJsDefault.default)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}

},{"../math.js":"kr12S","./buffer.js":"cuO8R","./line.js":"h649v","./rejoin.js":"ifsLB","d3-array":"bmqp6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h649v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b, x0, y0, x1, y1) {
        var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
        r = x0 - ax;
        if (!dx && r > 0) return;
        r /= dx;
        if (dx < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dx > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = x1 - ax;
        if (!dx && r < 0) return;
        r /= dx;
        if (dx < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dx > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        r = y0 - ay;
        if (!dy && r > 0) return;
        r /= dy;
        if (dy < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dy > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = y1 - ay;
        if (!dy && r < 0) return;
        r /= dy;
        if (dy < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dy > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
        if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
        return true;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eAnBz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object, point) {
        return (object && containsObjectType.hasOwnProperty(object.type) ? containsObjectType[object.type] : containsGeometry)(object, point);
    });
var _polygonContainsJs = require("./polygonContains.js");
var _polygonContainsJsDefault = parcelHelpers.interopDefault(_polygonContainsJs);
var _distanceJs = require("./distance.js");
var _distanceJsDefault = parcelHelpers.interopDefault(_distanceJs);
var _mathJs = require("./math.js");
var containsObjectType = {
    Feature: function(object, point) {
        return containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if (containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if (containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if (containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if (containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if (containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function containsGeometry(geometry, point) {
    return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point) : false;
}
function containsPoint(coordinates, point) {
    return (0, _distanceJsDefault.default)(coordinates, point) === 0;
}
function containsLine(coordinates, point) {
    var ao, bo, ab;
    for(var i = 0, n = coordinates.length; i < n; i++){
        bo = (0, _distanceJsDefault.default)(coordinates[i], point);
        if (bo === 0) return true;
        if (i > 0) {
            ab = (0, _distanceJsDefault.default)(coordinates[i], coordinates[i - 1]);
            if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < (0, _mathJs.epsilon2) * ab) return true;
        }
        ao = bo;
    }
    return false;
}
function containsPolygon(coordinates, point) {
    return !!(0, _polygonContainsJsDefault.default)(coordinates.map(ringRadians), pointRadians(point));
}
function ringRadians(ring) {
    return ring = ring.map(pointRadians), ring.pop(), ring;
}
function pointRadians(point) {
    return [
        point[0] * (0, _mathJs.radians),
        point[1] * (0, _mathJs.radians)
    ];
}

},{"./polygonContains.js":"1tllI","./distance.js":"iax00","./math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iax00":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        coordinates[0] = a;
        coordinates[1] = b;
        return (0, _lengthJsDefault.default)(object);
    });
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var coordinates = [
    null,
    null
], object = {
    type: "LineString",
    coordinates: coordinates
};

},{"./length.js":"ljrGL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ljrGL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object) {
        lengthSum = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, lengthStream);
        return +lengthSum;
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var lengthSum, lambda0, sinPhi0, cosPhi0;
var lengthStream = {
    sphere: (0, _noopJsDefault.default),
    point: (0, _noopJsDefault.default),
    lineStart: lengthLineStart,
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: (0, _noopJsDefault.default),
    polygonEnd: (0, _noopJsDefault.default)
};
function lengthLineStart() {
    lengthStream.point = lengthPointFirst;
    lengthStream.lineEnd = lengthLineEnd;
}
function lengthLineEnd() {
    lengthStream.point = lengthStream.lineEnd = (0, _noopJsDefault.default);
}
function lengthPointFirst(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    lambda0 = lambda, sinPhi0 = (0, _mathJs.sin)(phi), cosPhi0 = (0, _mathJs.cos)(phi);
    lengthStream.point = lengthPoint;
}
function lengthPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var sinPhi = (0, _mathJs.sin)(phi), cosPhi = (0, _mathJs.cos)(phi), delta = (0, _mathJs.abs)(lambda - lambda0), cosDelta = (0, _mathJs.cos)(delta), sinDelta = (0, _mathJs.sin)(delta), x = cosPhi * sinDelta, y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta, z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
    lengthSum.add((0, _mathJs.atan2)((0, _mathJs.sqrt)(x * x + y * y), z));
    lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

},{"d3-array":"bmqp6","./math.js":"kr12S","./noop.js":"73qAO","./stream.js":"hRAvu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eIZw9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>graticule);
parcelHelpers.export(exports, "graticule10", ()=>graticule10);
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
function graticuleX(y0, y1, dy) {
    var y = (0, _d3Array.range)(y0, y1 - (0, _mathJs.epsilon), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function graticuleY(x0, x1, dx) {
    var x = (0, _d3Array.range)(x0, x1 - (0, _mathJs.epsilon), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function graticule() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, _d3Array.range)((0, _mathJs.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, _d3Array.range)((0, _mathJs.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, _d3Array.range)((0, _mathJs.ceil)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, _mathJs.abs)(x % DX) > (0, _mathJs.epsilon);
        }).map(x)).concat((0, _d3Array.range)((0, _mathJs.ceil)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, _mathJs.abs)(y % DY) > (0, _mathJs.epsilon);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = graticuleX(y0, y1, 90);
        y = graticuleY(x0, x1, precision);
        X = graticuleX(Y0, Y1, 90);
        Y = graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, _mathJs.epsilon)
        ],
        [
            180,
            90 - (0, _mathJs.epsilon)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, _mathJs.epsilon)
        ],
        [
            180,
            80 + (0, _mathJs.epsilon)
        ]
    ]);
}
function graticule10() {
    return graticule()();
}

},{"d3-array":"bmqp6","./math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"96ddv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var x0 = a[0] * (0, _mathJs.radians), y0 = a[1] * (0, _mathJs.radians), x1 = b[0] * (0, _mathJs.radians), y1 = b[1] * (0, _mathJs.radians), cy0 = (0, _mathJs.cos)(y0), sy0 = (0, _mathJs.sin)(y0), cy1 = (0, _mathJs.cos)(y1), sy1 = (0, _mathJs.sin)(y1), kx0 = cy0 * (0, _mathJs.cos)(x0), ky0 = cy0 * (0, _mathJs.sin)(x0), kx1 = cy1 * (0, _mathJs.cos)(x1), ky1 = cy1 * (0, _mathJs.sin)(x1), d = 2 * (0, _mathJs.asin)((0, _mathJs.sqrt)((0, _mathJs.haversin)(y1 - y0) + cy0 * cy1 * (0, _mathJs.haversin)(x1 - x0))), k = (0, _mathJs.sin)(d);
        var interpolate = d ? function(t) {
            var B = (0, _mathJs.sin)(t *= d) / k, A = (0, _mathJs.sin)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
            return [
                (0, _mathJs.atan2)(y, x) * (0, _mathJs.degrees),
                (0, _mathJs.atan2)(z, (0, _mathJs.sqrt)(x * x + y * y)) * (0, _mathJs.degrees)
            ];
        } : function() {
            return [
                x0 * (0, _mathJs.degrees),
                y0 * (0, _mathJs.degrees)
            ];
        };
        interpolate.distance = d;
        return interpolate;
    });
var _mathJs = require("./math.js");

},{"./math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iqSAG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(projection, context) {
        let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
        function path(object) {
            if (object) {
                if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
                (0, _streamJsDefault.default)(object, projectionStream(contextStream));
            }
            return contextStream.result();
        }
        path.area = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _areaJsDefault.default)));
            return (0, _areaJsDefault.default).result();
        };
        path.measure = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _measureJsDefault.default)));
            return (0, _measureJsDefault.default).result();
        };
        path.bounds = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _boundsJsDefault.default)));
            return (0, _boundsJsDefault.default).result();
        };
        path.centroid = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _centroidJsDefault.default)));
            return (0, _centroidJsDefault.default).result();
        };
        path.projection = function(_) {
            if (!arguments.length) return projection;
            projectionStream = _ == null ? (projection = null, _identityJsDefault.default) : (projection = _).stream;
            return path;
        };
        path.context = function(_) {
            if (!arguments.length) return context;
            contextStream = _ == null ? (context = null, new (0, _stringJsDefault.default)(digits)) : new (0, _contextJsDefault.default)(context = _);
            if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
            return path;
        };
        path.pointRadius = function(_) {
            if (!arguments.length) return pointRadius;
            pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
            return path;
        };
        path.digits = function(_) {
            if (!arguments.length) return digits;
            if (_ == null) digits = null;
            else {
                const d = Math.floor(_);
                if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
                digits = d;
            }
            if (context === null) contextStream = new (0, _stringJsDefault.default)(digits);
            return path;
        };
        return path.projection(projection).digits(digits).context(context);
    });
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _streamJs = require("../stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _boundsJs = require("./bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _contextJs = require("./context.js");
var _contextJsDefault = parcelHelpers.interopDefault(_contextJs);
var _measureJs = require("./measure.js");
var _measureJsDefault = parcelHelpers.interopDefault(_measureJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);

},{"../identity.js":"lrQy7","../stream.js":"hRAvu","./area.js":"2UdLh","./bounds.js":"2qkAm","./centroid.js":"hApbw","./context.js":"dZAUl","./measure.js":"bsVs3","./string.js":"jzlru","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lrQy7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2UdLh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Array = require("d3-array");
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var areaSum = new (0, _d3Array.Adder)(), areaRingSum = new (0, _d3Array.Adder)(), x00, y00, x0, y0;
var areaStream = {
    point: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: function() {
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function() {
        areaStream.lineStart = areaStream.lineEnd = areaStream.point = (0, _noopJsDefault.default);
        areaSum.add((0, _mathJs.abs)(areaRingSum));
        areaRingSum = new (0, _d3Array.Adder)();
    },
    result: function() {
        var area = areaSum / 2;
        areaSum = new (0, _d3Array.Adder)();
        return area;
    }
};
function areaRingStart() {
    areaStream.point = areaPointFirst;
}
function areaPointFirst(x, y) {
    areaStream.point = areaPoint;
    x00 = x0 = x, y00 = y0 = y;
}
function areaPoint(x, y) {
    areaRingSum.add(y0 * x - x0 * y);
    x0 = x, y0 = y;
}
function areaRingEnd() {
    areaPoint(x00, y00);
}
exports.default = areaStream;

},{"d3-array":"bmqp6","../math.js":"kr12S","../noop.js":"73qAO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2qkAm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var x0 = Infinity, y0 = x0, x1 = -x0, y1 = x1;
var boundsStream = {
    point: boundsPoint,
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: (0, _noopJsDefault.default),
    polygonEnd: (0, _noopJsDefault.default),
    result: function() {
        var bounds = [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x1 = y1 = -(y0 = x0 = Infinity);
        return bounds;
    }
};
function boundsPoint(x, y) {
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
}
exports.default = boundsStream;

},{"../noop.js":"73qAO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hApbw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
// TODO Enforce positive area for exterior, negative area for interior?
var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00, y00, x0, y0;
var centroidStream = {
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function() {
        centroidStream.point = centroidPoint;
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
    },
    result: function() {
        var centroid = Z2 ? [
            X2 / Z2,
            Y2 / Z2
        ] : Z1 ? [
            X1 / Z1,
            Y1 / Z1
        ] : Z0 ? [
            X0 / Z0,
            Y0 / Z0
        ] : [
            NaN,
            NaN
        ];
        X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
        return centroid;
    }
};
function centroidPoint(x, y) {
    X0 += x;
    Y0 += y;
    ++Z0;
}
function centroidLineStart() {
    centroidStream.point = centroidPointFirstLine;
}
function centroidPointFirstLine(x, y) {
    centroidStream.point = centroidPointLine;
    centroidPoint(x0 = x, y0 = y);
}
function centroidPointLine(x, y) {
    var dx = x - x0, dy = y - y0, z = (0, _mathJs.sqrt)(dx * dx + dy * dy);
    X1 += z * (x0 + x) / 2;
    Y1 += z * (y0 + y) / 2;
    Z1 += z;
    centroidPoint(x0 = x, y0 = y);
}
function centroidLineEnd() {
    centroidStream.point = centroidPoint;
}
function centroidRingStart() {
    centroidStream.point = centroidPointFirstRing;
}
function centroidRingEnd() {
    centroidPointRing(x00, y00);
}
function centroidPointFirstRing(x, y) {
    centroidStream.point = centroidPointRing;
    centroidPoint(x00 = x0 = x, y00 = y0 = y);
}
function centroidPointRing(x, y) {
    var dx = x - x0, dy = y - y0, z = (0, _mathJs.sqrt)(dx * dx + dy * dy);
    X1 += z * (x0 + x) / 2;
    Y1 += z * (y0 + y) / 2;
    Z1 += z;
    z = y0 * x - x0 * y;
    X2 += z * (x0 + x);
    Y2 += z * (y0 + y);
    Z2 += z * 3;
    centroidPoint(x0 = x, y0 = y);
}
exports.default = centroidStream;

},{"../math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dZAUl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PathContext);
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function PathContext(context) {
    this._context = context;
}
PathContext.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, _mathJs.tau));
                break;
        }
    },
    result: (0, _noopJsDefault.default)
};

},{"../math.js":"kr12S","../noop.js":"73qAO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bsVs3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Array = require("d3-array");
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var lengthSum = new (0, _d3Array.Adder)(), lengthRing, x00, y00, x0, y0;
var lengthStream = {
    point: (0, _noopJsDefault.default),
    lineStart: function() {
        lengthStream.point = lengthPointFirst;
    },
    lineEnd: function() {
        if (lengthRing) lengthPoint(x00, y00);
        lengthStream.point = (0, _noopJsDefault.default);
    },
    polygonStart: function() {
        lengthRing = true;
    },
    polygonEnd: function() {
        lengthRing = null;
    },
    result: function() {
        var length = +lengthSum;
        lengthSum = new (0, _d3Array.Adder)();
        return length;
    }
};
function lengthPointFirst(x, y) {
    lengthStream.point = lengthPoint;
    x00 = x0 = x, y00 = y0 = y;
}
function lengthPoint(x, y) {
    x0 -= x, y0 -= y;
    lengthSum.add((0, _mathJs.sqrt)(x0 * x0 + y0 * y0));
    x0 = x, y0 = y;
}
exports.default = lengthStream;

},{"d3-array":"bmqp6","../math.js":"kr12S","../noop.js":"73qAO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jzlru":[function(require,module,exports,__globalThis) {
// Simple caching for constant-radius points.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let cacheDigits, cacheAppend, cacheRadius, cacheCircle;
class PathString {
    constructor(digits){
        this._append = digits == null ? append : appendRound(digits);
        this._radius = 4.5;
        this._ = "";
    }
    pointRadius(_) {
        this._radius = +_;
        return this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
    }
    point(x, y) {
        switch(this._point){
            case 0:
                this._append`M${x},${y}`;
                this._point = 1;
                break;
            case 1:
                this._append`L${x},${y}`;
                break;
            default:
                this._append`M${x},${y}`;
                if (this._radius !== cacheRadius || this._append !== cacheAppend) {
                    const r = this._radius;
                    const s = this._;
                    this._ = ""; // stash the old string so we can cache the circle path fragment
                    this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
                    cacheRadius = r;
                    cacheAppend = this._append;
                    cacheCircle = this._;
                    this._ = s;
                }
                this._ += cacheCircle;
                break;
        }
    }
    result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
    }
}
exports.default = PathString;
function append(strings) {
    let i = 1;
    this._ += strings[0];
    for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
}
function appendRound(digits) {
    const d = Math.floor(digits);
    if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
    if (d > 15) return append;
    if (d !== cacheDigits) {
        const k = 10 ** d;
        cacheDigits = d;
        cacheAppend = function append(strings) {
            let i = 1;
            this._ += strings[0];
            for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    return cacheAppend;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"18ymJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicEqualAreaJsDefault.default)().parallels([
            29.5,
            45.5
        ]).scale(1070).translate([
            480,
            250
        ]).rotate([
            96,
            0
        ]).center([
            -0.6,
            38.7
        ]);
    });
var _conicEqualAreaJs = require("./conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);

},{"./conicEqualArea.js":"akzIX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"akzIX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicEqualAreaRaw", ()=>conicEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicEqualAreaRaw).scale(155.424).center([
            0,
            33.6442
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _cylindricalEqualAreaJs = require("./cylindricalEqualArea.js");
function conicEqualAreaRaw(y0, y1) {
    var sy0 = (0, _mathJs.sin)(y0), n = (sy0 + (0, _mathJs.sin)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, _mathJs.abs)(n) < (0, _mathJs.epsilon)) return (0, _cylindricalEqualAreaJs.cylindricalEqualAreaRaw)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, _mathJs.sqrt)(c) / n;
    function project(x, y) {
        var r = (0, _mathJs.sqrt)(c - 2 * n * (0, _mathJs.sin)(y)) / n;
        return [
            r * (0, _mathJs.sin)(x *= n),
            r0 - r * (0, _mathJs.cos)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(r0y)) * (0, _mathJs.sign)(r0y);
        if (r0y * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(r0y);
        return [
            l / n,
            (0, _mathJs.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}

},{"../math.js":"kr12S","./conic.js":"7JkzP","./cylindricalEqualArea.js":"kWvjJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7JkzP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicProjection", ()=>conicProjection);
var _mathJs = require("../math.js");
var _indexJs = require("./index.js");
function conicProjection(projectAt) {
    var phi0 = 0, phi1 = (0, _mathJs.pi) / 3, m = (0, _indexJs.projectionMutator)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, _mathJs.radians), phi1 = _[1] * (0, _mathJs.radians)) : [
            phi0 * (0, _mathJs.degrees),
            phi1 * (0, _mathJs.degrees)
        ];
    };
    return p;
}

},{"../math.js":"kr12S","./index.js":"cDT5m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cDT5m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>projection);
parcelHelpers.export(exports, "projectionMutator", ()=>projectionMutator);
var _antimeridianJs = require("../clip/antimeridian.js");
var _antimeridianJsDefault = parcelHelpers.interopDefault(_antimeridianJs);
var _circleJs = require("../clip/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _rectangleJs = require("../clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _composeJs = require("../compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("../math.js");
var _rotationJs = require("../rotation.js");
var _transformJs = require("../transform.js");
var _fitJs = require("./fit.js");
var _resampleJs = require("./resample.js");
var _resampleJsDefault = parcelHelpers.interopDefault(_resampleJs);
var transformRadians = (0, _transformJs.transformer)({
    point: function(x, y) {
        this.stream.point(x * (0, _mathJs.radians), y * (0, _mathJs.radians));
    }
});
function transformRotate(rotate) {
    return (0, _transformJs.transformer)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, _mathJs.cos)(alpha), sinAlpha = (0, _mathJs.sin)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function projection(project) {
    return projectionMutator(function() {
        return project;
    })();
}
function projectionMutator(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, _antimeridianJsDefault.default), x0 = null, y0, x1, y1, postclip = (0, _identityJsDefault.default), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, _mathJs.radians), point[1] * (0, _mathJs.radians));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, _mathJs.degrees),
            point[1] * (0, _mathJs.degrees)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, _circleJsDefault.default)(theta = _ * (0, _mathJs.radians)) : (theta = null, _antimeridianJsDefault.default), reset()) : theta * (0, _mathJs.degrees);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identityJsDefault.default) : (0, _rectangleJsDefault.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, _mathJs.radians), phi = _[1] % 360 * (0, _mathJs.radians), recenter()) : [
            lambda * (0, _mathJs.degrees),
            phi * (0, _mathJs.degrees)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, _mathJs.radians), deltaPhi = _[1] % 360 * (0, _mathJs.radians), deltaGamma = _.length > 2 ? _[2] % 360 * (0, _mathJs.radians) : 0, recenter()) : [
            deltaLambda * (0, _mathJs.degrees),
            deltaPhi * (0, _mathJs.degrees),
            deltaGamma * (0, _mathJs.degrees)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, _mathJs.radians), recenter()) : alpha * (0, _mathJs.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, _resampleJsDefault.default)(projectTransform, delta2 = _ * _), reset()) : (0, _mathJs.sqrt)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, _fitJs.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, _fitJs.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, _fitJs.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, _fitJs.fitHeight)(projection, height, object);
    };
    function recenter() {
        var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, _rotationJs.rotateRadians)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, _composeJsDefault.default)(project, transform);
        projectRotateTransform = (0, _composeJsDefault.default)(rotate, projectTransform);
        projectResample = (0, _resampleJsDefault.default)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}

},{"../clip/antimeridian.js":"fuEXF","../clip/circle.js":"8HabQ","../clip/rectangle.js":"5x0dZ","../compose.js":"47XqF","../identity.js":"lrQy7","../math.js":"kr12S","../rotation.js":"7IUFJ","../transform.js":"iiS5g","./fit.js":"8Gqey","./resample.js":"8ryn2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iiS5g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(methods) {
        return {
            stream: transformer(methods)
        };
    });
parcelHelpers.export(exports, "transformer", ()=>transformer);
function transformer(methods) {
    return function(stream) {
        var s = new TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function TransformStream() {}
TransformStream.prototype = {
    constructor: TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Gqey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fitExtent", ()=>fitExtent);
parcelHelpers.export(exports, "fitSize", ()=>fitSize);
parcelHelpers.export(exports, "fitWidth", ()=>fitWidth);
parcelHelpers.export(exports, "fitHeight", ()=>fitHeight);
var _streamJs = require("../stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _boundsJs = require("../path/bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
function fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, _streamJsDefault.default)(object, projection.stream((0, _boundsJsDefault.default)));
    fitBounds((0, _boundsJsDefault.default).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function fitExtent(projection, extent, object) {
    return fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function fitSize(projection, size, object) {
    return fitExtent(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function fitWidth(projection, width, object) {
    return fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function fitHeight(projection, height, object) {
    return fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}

},{"../stream.js":"hRAvu","../path/bounds.js":"2qkAm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8ryn2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(project, delta2) {
        return +delta2 ? resample(project, delta2) : resampleNone(project);
    });
var _cartesianJs = require("../cartesian.js");
var _mathJs = require("../math.js");
var _transformJs = require("../transform.js");
var maxDepth = 16, cosMinDistance = (0, _mathJs.cos)(30 * (0, _mathJs.radians)); // cos(minimum angular distance)
function resampleNone(project) {
    return (0, _transformJs.transformer)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, _mathJs.sqrt)(a * a + b * b + c * c), phi2 = (0, _mathJs.asin)(c /= m), lambda2 = (0, _mathJs.abs)((0, _mathJs.abs)(c) - 1) < (0, _mathJs.epsilon) || (0, _mathJs.abs)(lambda0 - lambda1) < (0, _mathJs.epsilon) ? (lambda0 + lambda1) / 2 : (0, _mathJs.atan2)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, _mathJs.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, _cartesianJs.cartesian)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}

},{"../cartesian.js":"2GO7u","../math.js":"kr12S","../transform.js":"iiS5g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kWvjJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cylindricalEqualAreaRaw", ()=>cylindricalEqualAreaRaw);
var _mathJs = require("../math.js");
function cylindricalEqualAreaRaw(phi0) {
    var cosPhi0 = (0, _mathJs.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, _mathJs.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, _mathJs.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

},{"../math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Ztwow":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
parcelHelpers.export(exports, "default", ()=>function() {
        var cache, cacheStream, lower48 = (0, _albersJsDefault.default)(), lower48Point, alaska = (0, _conicEqualAreaJsDefault.default)().rotate([
            154,
            0
        ]).center([
            -2,
            58.5
        ]).parallels([
            55,
            65
        ]), alaskaPoint, hawaii = (0, _conicEqualAreaJsDefault.default)().rotate([
            157,
            0
        ]).center([
            -3,
            19.9
        ]).parallels([
            8,
            18
        ]), hawaiiPoint, point, pointStream = {
            point: function(x, y) {
                point = [
                    x,
                    y
                ];
            }
        };
        function albersUsa(coordinates) {
            var x = coordinates[0], y = coordinates[1];
            return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
        }
        albersUsa.invert = function(coordinates) {
            var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
            return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
        };
        albersUsa.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = multiplex([
                lower48.stream(cacheStream = stream),
                alaska.stream(stream),
                hawaii.stream(stream)
            ]);
        };
        albersUsa.precision = function(_) {
            if (!arguments.length) return lower48.precision();
            lower48.precision(_), alaska.precision(_), hawaii.precision(_);
            return reset();
        };
        albersUsa.scale = function(_) {
            if (!arguments.length) return lower48.scale();
            lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
            return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function(_) {
            if (!arguments.length) return lower48.translate();
            var k = lower48.scale(), x = +_[0], y = +_[1];
            lower48Point = lower48.translate(_).clipExtent([
                [
                    x - 0.455 * k,
                    y - 0.238 * k
                ],
                [
                    x + 0.455 * k,
                    y + 0.238 * k
                ]
            ]).stream(pointStream);
            alaskaPoint = alaska.translate([
                x - 0.307 * k,
                y + 0.201 * k
            ]).clipExtent([
                [
                    x - 0.425 * k + (0, _mathJs.epsilon),
                    y + 0.120 * k + (0, _mathJs.epsilon)
                ],
                [
                    x - 0.214 * k - (0, _mathJs.epsilon),
                    y + 0.234 * k - (0, _mathJs.epsilon)
                ]
            ]).stream(pointStream);
            hawaiiPoint = hawaii.translate([
                x - 0.205 * k,
                y + 0.212 * k
            ]).clipExtent([
                [
                    x - 0.214 * k + (0, _mathJs.epsilon),
                    y + 0.166 * k + (0, _mathJs.epsilon)
                ],
                [
                    x - 0.115 * k - (0, _mathJs.epsilon),
                    y + 0.234 * k - (0, _mathJs.epsilon)
                ]
            ]).stream(pointStream);
            return reset();
        };
        albersUsa.fitExtent = function(extent, object) {
            return (0, _fitJs.fitExtent)(albersUsa, extent, object);
        };
        albersUsa.fitSize = function(size, object) {
            return (0, _fitJs.fitSize)(albersUsa, size, object);
        };
        albersUsa.fitWidth = function(width, object) {
            return (0, _fitJs.fitWidth)(albersUsa, width, object);
        };
        albersUsa.fitHeight = function(height, object) {
            return (0, _fitJs.fitHeight)(albersUsa, height, object);
        };
        function reset() {
            cache = cacheStream = null;
            return albersUsa;
        }
        return albersUsa.scale(1070);
    });
var _mathJs = require("../math.js");
var _albersJs = require("./albers.js");
var _albersJsDefault = parcelHelpers.interopDefault(_albersJs);
var _conicEqualAreaJs = require("./conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);
var _fitJs = require("./fit.js");
// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}

},{"../math.js":"kr12S","./albers.js":"18ymJ","./conicEqualArea.js":"akzIX","./fit.js":"8Gqey","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aCfBB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalEqualAreaRaw", ()=>azimuthalEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(azimuthalEqualAreaRaw).scale(124.75).clipAngle(179.999);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var azimuthalEqualAreaRaw = (0, _azimuthalJs.azimuthalRaw)(function(cxcy) {
    return (0, _mathJs.sqrt)(2 / (1 + cxcy));
});
azimuthalEqualAreaRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return 2 * (0, _mathJs.asin)(z / 2);
});

},{"../math.js":"kr12S","./azimuthal.js":"3zQwQ","./index.js":"cDT5m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3zQwQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalRaw", ()=>azimuthalRaw);
parcelHelpers.export(exports, "azimuthalInvert", ()=>azimuthalInvert);
var _mathJs = require("../math.js");
function azimuthalRaw(scale) {
    return function(x, y) {
        var cx = (0, _mathJs.cos)(x), cy = (0, _mathJs.cos)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, _mathJs.sin)(x),
            k * (0, _mathJs.sin)(y)
        ];
    };
}
function azimuthalInvert(angle) {
    return function(x, y) {
        var z = (0, _mathJs.sqrt)(x * x + y * y), c = angle(z), sc = (0, _mathJs.sin)(c), cc = (0, _mathJs.cos)(c);
        return [
            (0, _mathJs.atan2)(x * sc, z * cc),
            (0, _mathJs.asin)(z && y * sc / z)
        ];
    };
}

},{"../math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"217dH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalEquidistantRaw", ()=>azimuthalEquidistantRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(azimuthalEquidistantRaw).scale(79.4188).clipAngle(179.999);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var azimuthalEquidistantRaw = (0, _azimuthalJs.azimuthalRaw)(function(c) {
    return (c = (0, _mathJs.acos)(c)) && c / (0, _mathJs.sin)(c);
});
azimuthalEquidistantRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return z;
});

},{"../math.js":"kr12S","./azimuthal.js":"3zQwQ","./index.js":"cDT5m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hiR31":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicConformalRaw", ()=>conicConformalRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicConformalRaw).scale(109.5).parallels([
            30,
            30
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _mercatorJs = require("./mercator.js");
function tany(y) {
    return (0, _mathJs.tan)(((0, _mathJs.halfPi) + y) / 2);
}
function conicConformalRaw(y0, y1) {
    var cy0 = (0, _mathJs.cos)(y0), n = y0 === y1 ? (0, _mathJs.sin)(y0) : (0, _mathJs.log)(cy0 / (0, _mathJs.cos)(y1)) / (0, _mathJs.log)(tany(y1) / tany(y0)), f = cy0 * (0, _mathJs.pow)(tany(y0), n) / n;
    if (!n) return 0, _mercatorJs.mercatorRaw;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, _mathJs.halfPi) + (0, _mathJs.epsilon)) y = -(0, _mathJs.halfPi) + (0, _mathJs.epsilon);
        } else if (y > (0, _mathJs.halfPi) - (0, _mathJs.epsilon)) y = (0, _mathJs.halfPi) - (0, _mathJs.epsilon);
        var r = f / (0, _mathJs.pow)(tany(y), n);
        return [
            r * (0, _mathJs.sin)(n * x),
            f - r * (0, _mathJs.cos)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, _mathJs.sign)(n) * (0, _mathJs.sqrt)(x * x + fy * fy), l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(fy)) * (0, _mathJs.sign)(fy);
        if (fy * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(fy);
        return [
            l / n,
            2 * (0, _mathJs.atan)((0, _mathJs.pow)(f / r, 1 / n)) - (0, _mathJs.halfPi)
        ];
    };
    return project;
}

},{"../math.js":"kr12S","./conic.js":"7JkzP","./mercator.js":"17h4e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"17h4e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mercatorRaw", ()=>mercatorRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return mercatorProjection(mercatorRaw).scale(961 / (0, _mathJs.tau));
    });
parcelHelpers.export(exports, "mercatorProjection", ()=>mercatorProjection);
var _mathJs = require("../math.js");
var _rotationJs = require("../rotation.js");
var _rotationJsDefault = parcelHelpers.interopDefault(_rotationJs);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function mercatorRaw(lambda, phi) {
    return [
        lambda,
        (0, _mathJs.log)((0, _mathJs.tan)(((0, _mathJs.halfPi) + phi) / 2))
    ];
}
mercatorRaw.invert = function(x, y) {
    return [
        x,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(y)) - (0, _mathJs.halfPi)
    ];
};
function mercatorProjection(project) {
    var m = (0, _indexJsDefault.default)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, _mathJs.pi) * scale(), t = m((0, _rotationJsDefault.default)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === mercatorRaw ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}

},{"../math.js":"kr12S","../rotation.js":"7IUFJ","./index.js":"cDT5m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cCy8c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicEquidistantRaw", ()=>conicEquidistantRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicEquidistantRaw).scale(131.154).center([
            0,
            13.9389
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _equirectangularJs = require("./equirectangular.js");
function conicEquidistantRaw(y0, y1) {
    var cy0 = (0, _mathJs.cos)(y0), n = y0 === y1 ? (0, _mathJs.sin)(y0) : (cy0 - (0, _mathJs.cos)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, _mathJs.abs)(n) < (0, _mathJs.epsilon)) return 0, _equirectangularJs.equirectangularRaw;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, _mathJs.sin)(nx),
            g - gy * (0, _mathJs.cos)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(gy)) * (0, _mathJs.sign)(gy);
        if (gy * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(gy);
        return [
            l / n,
            g - (0, _mathJs.sign)(n) * (0, _mathJs.sqrt)(x * x + gy * gy)
        ];
    };
    return project;
}

},{"../math.js":"kr12S","./conic.js":"7JkzP","./equirectangular.js":"eRR1r","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eRR1r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equirectangularRaw", ()=>equirectangularRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(equirectangularRaw).scale(152.63);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function equirectangularRaw(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
equirectangularRaw.invert = equirectangularRaw;

},{"./index.js":"cDT5m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"amg4e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equalEarthRaw", ()=>equalEarthRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(equalEarthRaw).scale(177.158);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
var A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = (0, _mathJs.sqrt)(3) / 2, iterations = 12;
function equalEarthRaw(lambda, phi) {
    var l = (0, _mathJs.asin)(M * (0, _mathJs.sin)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, _mathJs.cos)(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
        l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
    ];
}
equalEarthRaw.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < iterations; ++i){
        fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
        fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, _mathJs.abs)(delta) < (0, _mathJs.epsilon2)) break;
    }
    return [
        M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / (0, _mathJs.cos)(l),
        (0, _mathJs.asin)((0, _mathJs.sin)(l) / M)
    ];
};

},{"./index.js":"cDT5m","../math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jmdCs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gnomonicRaw", ()=>gnomonicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(gnomonicRaw).scale(144.049).clipAngle(60);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function gnomonicRaw(x, y) {
    var cy = (0, _mathJs.cos)(y), k = (0, _mathJs.cos)(x) * cy;
    return [
        cy * (0, _mathJs.sin)(x) / k,
        (0, _mathJs.sin)(y) / k
    ];
}
gnomonicRaw.invert = (0, _azimuthalJs.azimuthalInvert)((0, _mathJs.atan));

},{"../math.js":"kr12S","./azimuthal.js":"3zQwQ","./index.js":"cDT5m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7G2qR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = (0, _transformJs.transformer)({
            point: function(x, y) {
                var p = projection([
                    x,
                    y
                ]);
                this.stream.point(p[0], p[1]);
            }
        }), postclip = (0, _identityJsDefault.default), cache, cacheStream;
        function reset() {
            kx = k * sx;
            ky = k * sy;
            cache = cacheStream = null;
            return projection;
        }
        function projection(p) {
            var x = p[0] * kx, y = p[1] * ky;
            if (alpha) {
                var t = y * ca - x * sa;
                x = x * ca + y * sa;
                y = t;
            }
            return [
                x + tx,
                y + ty
            ];
        }
        projection.invert = function(p) {
            var x = p[0] - tx, y = p[1] - ty;
            if (alpha) {
                var t = y * ca + x * sa;
                x = x * ca - y * sa;
                y = t;
            }
            return [
                x / kx,
                y / ky
            ];
        };
        projection.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
        };
        projection.postclip = function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        };
        projection.clipExtent = function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identityJsDefault.default) : (0, _rectangleJsDefault.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        projection.scale = function(_) {
            return arguments.length ? (k = +_, reset()) : k;
        };
        projection.translate = function(_) {
            return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
                tx,
                ty
            ];
        };
        projection.angle = function(_) {
            return arguments.length ? (alpha = _ % 360 * (0, _mathJs.radians), sa = (0, _mathJs.sin)(alpha), ca = (0, _mathJs.cos)(alpha), reset()) : alpha * (0, _mathJs.degrees);
        };
        projection.reflectX = function(_) {
            return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
        };
        projection.reflectY = function(_) {
            return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
        };
        projection.fitExtent = function(extent, object) {
            return (0, _fitJs.fitExtent)(projection, extent, object);
        };
        projection.fitSize = function(size, object) {
            return (0, _fitJs.fitSize)(projection, size, object);
        };
        projection.fitWidth = function(width, object) {
            return (0, _fitJs.fitWidth)(projection, width, object);
        };
        projection.fitHeight = function(height, object) {
            return (0, _fitJs.fitHeight)(projection, height, object);
        };
        return projection;
    });
var _rectangleJs = require("../clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _transformJs = require("../transform.js");
var _fitJs = require("./fit.js");
var _mathJs = require("../math.js");

},{"../clip/rectangle.js":"5x0dZ","../identity.js":"lrQy7","../transform.js":"iiS5g","./fit.js":"8Gqey","../math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"63KuJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "naturalEarth1Raw", ()=>naturalEarth1Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(naturalEarth1Raw).scale(175.295);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
function naturalEarth1Raw(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
naturalEarth1Raw.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};

},{"./index.js":"cDT5m","../math.js":"kr12S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hDkXA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orthographicRaw", ()=>orthographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(orthographicRaw).scale(249.5).clipAngle(90 + (0, _mathJs.epsilon));
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function orthographicRaw(x, y) {
    return [
        (0, _mathJs.cos)(y) * (0, _mathJs.sin)(x),
        (0, _mathJs.sin)(y)
    ];
}
orthographicRaw.invert = (0, _azimuthalJs.azimuthalInvert)((0, _mathJs.asin));

},{"../math.js":"kr12S","./azimuthal.js":"3zQwQ","./index.js":"cDT5m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gM6Ku":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stereographicRaw", ()=>stereographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(stereographicRaw).scale(250).clipAngle(142);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function stereographicRaw(x, y) {
    var cy = (0, _mathJs.cos)(y), k = 1 + (0, _mathJs.cos)(x) * cy;
    return [
        cy * (0, _mathJs.sin)(x) / k,
        (0, _mathJs.sin)(y) / k
    ];
}
stereographicRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return 2 * (0, _mathJs.atan)(z);
});

},{"../math.js":"kr12S","./azimuthal.js":"3zQwQ","./index.js":"cDT5m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a6I3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transverseMercatorRaw", ()=>transverseMercatorRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var m = (0, _mercatorJs.mercatorProjection)(transverseMercatorRaw), center = m.center, rotate = m.rotate;
        m.center = function(_) {
            return arguments.length ? center([
                -_[1],
                _[0]
            ]) : (_ = center(), [
                _[1],
                -_[0]
            ]);
        };
        m.rotate = function(_) {
            return arguments.length ? rotate([
                _[0],
                _[1],
                _.length > 2 ? _[2] + 90 : 90
            ]) : (_ = rotate(), [
                _[0],
                _[1],
                _[2] - 90
            ]);
        };
        return rotate([
            0,
            0,
            90
        ]).scale(159.155);
    });
var _mathJs = require("../math.js");
var _mercatorJs = require("./mercator.js");
function transverseMercatorRaw(lambda, phi) {
    return [
        (0, _mathJs.log)((0, _mathJs.tan)(((0, _mathJs.halfPi) + phi) / 2)),
        -lambda
    ];
}
transverseMercatorRaw.invert = function(x, y) {
    return [
        -y,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(x)) - (0, _mathJs.halfPi)
    ];
};

},{"../math.js":"kr12S","./mercator.js":"17h4e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5owG1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cluster", ()=>(0, _clusterJsDefault.default));
parcelHelpers.export(exports, "hierarchy", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "Node", ()=>(0, _indexJs.Node));
parcelHelpers.export(exports, "pack", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "packSiblings", ()=>(0, _siblingsJsDefault.default));
parcelHelpers.export(exports, "packEnclose", ()=>(0, _encloseJsDefault.default));
parcelHelpers.export(exports, "partition", ()=>(0, _partitionJsDefault.default));
parcelHelpers.export(exports, "stratify", ()=>(0, _stratifyJsDefault.default));
parcelHelpers.export(exports, "tree", ()=>(0, _treeJsDefault.default));
parcelHelpers.export(exports, "treemap", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "treemapBinary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "treemapDice", ()=>(0, _diceJsDefault.default));
parcelHelpers.export(exports, "treemapSlice", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "treemapSliceDice", ()=>(0, _sliceDiceJsDefault.default));
parcelHelpers.export(exports, "treemapSquarify", ()=>(0, _squarifyJsDefault.default));
parcelHelpers.export(exports, "treemapResquarify", ()=>(0, _resquarifyJsDefault.default));
var _clusterJs = require("./cluster.js");
var _clusterJsDefault = parcelHelpers.interopDefault(_clusterJs);
var _indexJs = require("./hierarchy/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./pack/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _siblingsJs = require("./pack/siblings.js");
var _siblingsJsDefault = parcelHelpers.interopDefault(_siblingsJs);
var _encloseJs = require("./pack/enclose.js");
var _encloseJsDefault = parcelHelpers.interopDefault(_encloseJs);
var _partitionJs = require("./partition.js");
var _partitionJsDefault = parcelHelpers.interopDefault(_partitionJs);
var _stratifyJs = require("./stratify.js");
var _stratifyJsDefault = parcelHelpers.interopDefault(_stratifyJs);
var _treeJs = require("./tree.js");
var _treeJsDefault = parcelHelpers.interopDefault(_treeJs);
var _indexJs2 = require("./treemap/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _binaryJs = require("./treemap/binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _diceJs = require("./treemap/dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./treemap/slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _sliceDiceJs = require("./treemap/sliceDice.js");
var _sliceDiceJsDefault = parcelHelpers.interopDefault(_sliceDiceJs);
var _squarifyJs = require("./treemap/squarify.js");
var _squarifyJsDefault = parcelHelpers.interopDefault(_squarifyJs);
var _resquarifyJs = require("./treemap/resquarify.js");
var _resquarifyJsDefault = parcelHelpers.interopDefault(_resquarifyJs);

},{"./cluster.js":"8rzqH","./hierarchy/index.js":"loEhi","./pack/index.js":"bQLhb","./pack/siblings.js":"1HtGt","./pack/enclose.js":"cVlay","./partition.js":"lfHeo","./stratify.js":"byyra","./tree.js":"2xSkz","./treemap/index.js":"21t2w","./treemap/binary.js":"2IxgB","./treemap/dice.js":"iVQdF","./treemap/slice.js":"aPoCq","./treemap/sliceDice.js":"50Fb3","./treemap/squarify.js":"latpq","./treemap/resquarify.js":"7i3PT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8rzqH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = false;
        function cluster(root) {
            var previousNode, x = 0;
            // First walk, computing the initial x & y values.
            root.eachAfter(function(node) {
                var children = node.children;
                if (children) {
                    node.x = meanX(children);
                    node.y = maxY(children);
                } else {
                    node.x = previousNode ? x += separation(node, previousNode) : 0;
                    node.y = 0;
                    previousNode = node;
                }
            });
            var left = leafLeft(root), right = leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
            // Second walk, normalizing x & y to the desired size.
            return root.eachAfter(nodeSize ? function(node) {
                node.x = (node.x - root.x) * dx;
                node.y = (root.y - node.y) * dy;
            } : function(node) {
                node.x = (node.x - x0) / (x1 - x0) * dx;
                node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
            });
        }
        cluster.separation = function(x) {
            return arguments.length ? (separation = x, cluster) : separation;
        };
        cluster.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        cluster.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return cluster;
    });
function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function meanX(children) {
    return children.reduce(meanXReduce, 0) / children.length;
}
function meanXReduce(x, c) {
    return x + c.x;
}
function maxY(children) {
    return 1 + children.reduce(maxYReduce, 0);
}
function maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"loEhi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hierarchy);
parcelHelpers.export(exports, "computeHeight", ()=>computeHeight);
parcelHelpers.export(exports, "Node", ()=>Node);
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _eachBeforeJs = require("./eachBefore.js");
var _eachBeforeJsDefault = parcelHelpers.interopDefault(_eachBeforeJs);
var _eachAfterJs = require("./eachAfter.js");
var _eachAfterJsDefault = parcelHelpers.interopDefault(_eachAfterJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _ancestorsJs = require("./ancestors.js");
var _ancestorsJsDefault = parcelHelpers.interopDefault(_ancestorsJs);
var _descendantsJs = require("./descendants.js");
var _descendantsJsDefault = parcelHelpers.interopDefault(_descendantsJs);
var _leavesJs = require("./leaves.js");
var _leavesJsDefault = parcelHelpers.interopDefault(_leavesJs);
var _linksJs = require("./links.js");
var _linksJsDefault = parcelHelpers.interopDefault(_linksJs);
var _iteratorJs = require("./iterator.js");
var _iteratorJsDefault = parcelHelpers.interopDefault(_iteratorJs);
function hierarchy(data, children) {
    if (data instanceof Map) {
        data = [
            undefined,
            data
        ];
        if (children === undefined) children = mapChildren;
    } else if (children === undefined) children = objectChildren;
    var root = new Node(data), node, nodes = [
        root
    ], child, childs, i, n;
    while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
        node.children = childs;
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = childs[i] = new Node(childs[i]));
            child.parent = node;
            child.depth = node.depth + 1;
        }
    }
    return root.eachBefore(computeHeight);
}
function node_copy() {
    return hierarchy(this).eachBefore(copyData);
}
function objectChildren(d) {
    return d.children;
}
function mapChildren(d) {
    return Array.isArray(d) ? d[1] : null;
}
function copyData(node) {
    if (node.data.value !== undefined) node.value = node.data.value;
    node.data = node.data.data;
}
function computeHeight(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function Node(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
Node.prototype = hierarchy.prototype = {
    constructor: Node,
    count: (0, _countJsDefault.default),
    each: (0, _eachJsDefault.default),
    eachAfter: (0, _eachAfterJsDefault.default),
    eachBefore: (0, _eachBeforeJsDefault.default),
    find: (0, _findJsDefault.default),
    sum: (0, _sumJsDefault.default),
    sort: (0, _sortJsDefault.default),
    path: (0, _pathJsDefault.default),
    ancestors: (0, _ancestorsJsDefault.default),
    descendants: (0, _descendantsJsDefault.default),
    leaves: (0, _leavesJsDefault.default),
    links: (0, _linksJsDefault.default),
    copy: node_copy,
    [Symbol.iterator]: (0, _iteratorJsDefault.default)
};

},{"./count.js":"hCbf6","./each.js":"i2Hm3","./eachBefore.js":"cu1Ga","./eachAfter.js":"f9pIX","./find.js":"1juN3","./sum.js":"cWGAi","./sort.js":"gnXkC","./path.js":"izerH","./ancestors.js":"7W4ol","./descendants.js":"j2Q9B","./leaves.js":"fFfdr","./links.js":"kbRaW","./iterator.js":"7yqQT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hCbf6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.eachAfter(count);
    });
function count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i2Hm3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        let index = -1;
        for (const node of this)callback.call(that, node, ++index, this);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cu1Ga":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        var node = this, nodes = [
            node
        ], children, i, index = -1;
        while(node = nodes.pop()){
            callback.call(that, node, ++index, this);
            if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f9pIX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        var node = this, nodes = [
            node
        ], next = [], children, i, n, index = -1;
        while(node = nodes.pop()){
            next.push(node);
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
        }
        while(node = next.pop())callback.call(that, node, ++index, this);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1juN3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        let index = -1;
        for (const node of this){
            if (callback.call(that, node, ++index, this)) return node;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cWGAi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.eachAfter(function(node) {
            var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
            while(--i >= 0)sum += children[i].value;
            node.value = sum;
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gnXkC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        return this.eachBefore(function(node) {
            if (node.children) node.children.sort(compare);
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"izerH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(end) {
        var start = this, ancestor = leastCommonAncestor(start, end), nodes = [
            start
        ];
        while(start !== ancestor){
            start = start.parent;
            nodes.push(start);
        }
        var k = nodes.length;
        while(end !== ancestor){
            nodes.splice(k, 0, end);
            end = end.parent;
        }
        return nodes;
    });
function leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7W4ol":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var node = this, nodes = [
            node
        ];
        while(node = node.parent)nodes.push(node);
        return nodes;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j2Q9B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Array.from(this);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fFfdr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var leaves = [];
        this.eachBefore(function(node) {
            if (!node.children) leaves.push(node);
        });
        return leaves;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kbRaW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var root = this, links = [];
        root.each(function(node) {
            if (node !== root) links.push({
                source: node.parent,
                target: node
            });
        });
        return links;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7yqQT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function*() {
        var node = this, current, next = [
            node
        ], children, i, n;
        do {
            current = next.reverse(), next = [];
            while(node = current.pop()){
                yield node;
                if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
            }
        }while (next.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bQLhb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var radius = null, dx = 1, dy = 1, padding = (0, _constantJs.constantZero);
        function pack(root) {
            const random = (0, _lcgJsDefault.default)();
            root.x = dx / 2, root.y = dy / 2;
            if (radius) root.eachBefore(radiusLeaf(radius)).eachAfter(packChildrenRandom(padding, 0.5, random)).eachBefore(translateChild(1));
            else root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildrenRandom((0, _constantJs.constantZero), 1, random)).eachAfter(packChildrenRandom(padding, root.r / Math.min(dx, dy), random)).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
            return root;
        }
        pack.radius = function(x) {
            return arguments.length ? (radius = (0, _accessorsJs.optional)(x), pack) : radius;
        };
        pack.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
                dx,
                dy
            ];
        };
        pack.padding = function(x) {
            return arguments.length ? (padding = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), pack) : padding;
        };
        return pack;
    });
var _accessorsJs = require("../accessors.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _lcgJs = require("../lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
var _siblingsJs = require("./siblings.js");
function defaultRadius(d) {
    return Math.sqrt(d.value);
}
function radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function packChildrenRandom(padding, k, random) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, _siblingsJs.packSiblingsRandom)(children, random);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}

},{"../accessors.js":"jPUrV","../constant.js":"kriEV","../lcg.js":"8XMsF","./siblings.js":"1HtGt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jPUrV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optional", ()=>optional);
parcelHelpers.export(exports, "required", ()=>required);
function optional(f) {
    return f == null ? null : required(f);
}
function required(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kriEV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constantZero", ()=>constantZero);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });
function constantZero() {
    return 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8XMsF":[function(require,module,exports,__globalThis) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let s = 1;
        return ()=>(s = (a * s + c) % m) / m;
    });
const a = 1664525;
const c = 1013904223;
const m = 4294967296; // 2^32

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1HtGt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "packSiblingsRandom", ()=>packSiblingsRandom);
parcelHelpers.export(exports, "default", ()=>function(circles) {
        packSiblingsRandom(circles, (0, _lcgJsDefault.default)());
        return circles;
    });
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _lcgJs = require("../lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
var _encloseJs = require("./enclose.js");
function place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function packSiblingsRandom(circles, random) {
    if (!(n = (circles = (0, _arrayJsDefault.default)(circles)).length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new Node(a), b = new Node(b), c = new Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        place(a._, b._, c = circles[i]), c = new Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if (intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if (intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = score(a);
        while((c = c.next) !== b)if ((ca = score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, _encloseJs.packEncloseRandom)(a, random);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}

},{"../array.js":"j5J9l","../lcg.js":"8XMsF","./enclose.js":"cVlay","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j5J9l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    });
parcelHelpers.export(exports, "shuffle", ()=>shuffle);
function shuffle(array, random) {
    let m = array.length, t, i;
    while(m){
        i = random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cVlay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(circles) {
        return packEncloseRandom(circles, (0, _lcgJsDefault.default)());
    });
parcelHelpers.export(exports, "packEncloseRandom", ()=>packEncloseRandom);
var _arrayJs = require("../array.js");
var _lcgJs = require("../lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
function packEncloseRandom(circles, random) {
    var i = 0, n = (circles = (0, _arrayJs.shuffle)(Array.from(circles), random)).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && enclosesWeak(e, p)) ++i;
        else e = encloseBasis(B = extendBasis(B, p)), i = 0;
    }
    return e;
}
function extendBasis(B, p) {
    var i, j;
    if (enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function enclosesWeak(a, b) {
    var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function encloseBasis(B) {
    switch(B.length){
        case 1:
            return encloseBasis1(B[0]);
        case 2:
            return encloseBasis2(B[0], B[1]);
        case 3:
            return encloseBasis3(B[0], B[1], B[2]);
    }
}
function encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(Math.abs(A) > 1e-6 ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}

},{"../array.js":"j5J9l","../lcg.js":"8XMsF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lfHeo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var dx = 1, dy = 1, padding = 0, round = false;
        function partition(root) {
            var n = root.height + 1;
            root.x0 = root.y0 = padding;
            root.x1 = dx;
            root.y1 = dy / n;
            root.eachBefore(positionNode(dy, n));
            if (round) root.eachBefore((0, _roundJsDefault.default));
            return root;
        }
        function positionNode(dy, n) {
            return function(node) {
                if (node.children) (0, _diceJsDefault.default)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
                var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                node.x0 = x0;
                node.y0 = y0;
                node.x1 = x1;
                node.y1 = y1;
            };
        }
        partition.round = function(x) {
            return arguments.length ? (round = !!x, partition) : round;
        };
        partition.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
                dx,
                dy
            ];
        };
        partition.padding = function(x) {
            return arguments.length ? (padding = +x, partition) : padding;
        };
        return partition;
    });
var _roundJs = require("./treemap/round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _diceJs = require("./treemap/dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);

},{"./treemap/round.js":"pDziX","./treemap/dice.js":"iVQdF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"pDziX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        node.x0 = Math.round(node.x0);
        node.y0 = Math.round(node.y0);
        node.x1 = Math.round(node.x1);
        node.y1 = Math.round(node.y1);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iVQdF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
        while(++i < n){
            node = nodes[i], node.y0 = y0, node.y1 = y1;
            node.x0 = x0, node.x1 = x0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"byyra":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var id = defaultId, parentId = defaultParentId, path;
        function stratify(data) {
            var nodes = Array.from(data), currentId = id, currentParentId = parentId, n, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
            if (path != null) {
                const I = nodes.map((d, i)=>normalize(path(d, i, data)));
                const P = I.map(parentof);
                const S = new Set(I).add("");
                for (const i of P)if (!S.has(i)) {
                    S.add(i);
                    I.push(i);
                    P.push(parentof(i));
                    nodes.push(imputed);
                }
                currentId = (_, i)=>I[i];
                currentParentId = (_, i)=>P[i];
            }
            for(i = 0, n = nodes.length; i < n; ++i){
                d = nodes[i], node = nodes[i] = new (0, _indexJs.Node)(d);
                if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
                    nodeKey = node.id = nodeId;
                    nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
                }
                if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
            }
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (nodeId = node.parent) {
                    parent = nodeByKey.get(nodeId);
                    if (!parent) throw new Error("missing: " + nodeId);
                    if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
                    if (parent.children) parent.children.push(node);
                    else parent.children = [
                        node
                    ];
                    node.parent = parent;
                } else {
                    if (root) throw new Error("multiple roots");
                    root = node;
                }
            }
            if (!root) throw new Error("no root");
            // When imputing internal nodes, only introduce roots if needed.
            // Then replace the imputed marker data with null.
            if (path != null) {
                while(root.data === imputed && root.children.length === 1)root = root.children[0], --n;
                for(let i = nodes.length - 1; i >= 0; --i){
                    node = nodes[i];
                    if (node.data !== imputed) break;
                    node.data = null;
                }
            }
            root.parent = preroot;
            root.eachBefore(function(node) {
                node.depth = node.parent.depth + 1;
                --n;
            }).eachBefore((0, _indexJs.computeHeight));
            root.parent = null;
            if (n > 0) throw new Error("cycle");
            return root;
        }
        stratify.id = function(x) {
            return arguments.length ? (id = (0, _accessorsJs.optional)(x), stratify) : id;
        };
        stratify.parentId = function(x) {
            return arguments.length ? (parentId = (0, _accessorsJs.optional)(x), stratify) : parentId;
        };
        stratify.path = function(x) {
            return arguments.length ? (path = (0, _accessorsJs.optional)(x), stratify) : path;
        };
        return stratify;
    });
var _accessorsJs = require("./accessors.js");
var _indexJs = require("./hierarchy/index.js");
var preroot = {
    depth: -1
}, ambiguous = {}, imputed = {};
function defaultId(d) {
    return d.id;
}
function defaultParentId(d) {
    return d.parentId;
}
// To normalize a path, we coerce to a string, strip the trailing slash if any
// (as long as the trailing slash is not immediately preceded by another slash),
// and add leading slash if missing.
function normalize(path) {
    path = `${path}`;
    let i = path.length;
    if (slash(path, i - 1) && !slash(path, i - 2)) path = path.slice(0, -1);
    return path[0] === "/" ? path : `/${path}`;
}
// Walk backwards to find the first slash that is not the leading slash, e.g.:
// "/foo/bar" ⇥ "/foo", "/foo" ⇥ "/", "/" ↦ "". (The root is special-cased
// because the id of the root must be a truthy value.)
function parentof(path) {
    let i = path.length;
    if (i < 2) return "";
    while(--i > 1)if (slash(path, i)) break;
    return path.slice(0, i);
}
// Slashes can be escaped; to determine whether a slash is a path delimiter, we
// count the number of preceding backslashes escaping the forward slash: an odd
// number indicates an escaped forward slash.
function slash(path, i) {
    if (path[i] === "/") {
        let k = 0;
        while(i > 0 && path[--i] === "\\")++k;
        if ((k & 1) === 0) return true;
    }
    return false;
}

},{"./accessors.js":"jPUrV","./hierarchy/index.js":"loEhi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2xSkz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
parcelHelpers.export(exports, "default", ()=>function() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = null;
        function tree(root) {
            var t = treeRoot(root);
            // Compute the layout using Buchheim et al.’s algorithm.
            t.eachAfter(firstWalk), t.parent.m = -t.z;
            t.eachBefore(secondWalk);
            // If a fixed node size is specified, scale x and y.
            if (nodeSize) root.eachBefore(sizeNode);
            else {
                var left = root, right = root, bottom = root;
                root.eachBefore(function(node) {
                    if (node.x < left.x) left = node;
                    if (node.x > right.x) right = node;
                    if (node.depth > bottom.depth) bottom = node;
                });
                var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
                root.eachBefore(function(node) {
                    node.x = (node.x + tx) * kx;
                    node.y = node.depth * ky;
                });
            }
            return root;
        }
        // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
        // applied recursively to the children of v, as well as the function
        // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
        // node v is placed to the midpoint of its outermost children.
        function firstWalk(v) {
            var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
            if (children) {
                executeShifts(v);
                var midpoint = (children[0].z + children[children.length - 1].z) / 2;
                if (w) {
                    v.z = w.z + separation(v._, w._);
                    v.m = v.z - midpoint;
                } else v.z = midpoint;
            } else if (w) v.z = w.z + separation(v._, w._);
            v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
        }
        // Computes all real x-coordinates by summing up the modifiers recursively.
        function secondWalk(v) {
            v._.x = v.z + v.parent.m;
            v.m += v.parent.m;
        }
        // The core of the algorithm. Here, a new subtree is combined with the
        // previous subtrees. Threads are used to traverse the inside and outside
        // contours of the left and right subtree up to the highest common level. The
        // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
        // superscript o means outside and i means inside, the subscript - means left
        // subtree and + means right subtree. For summing up the modifiers along the
        // contour, we use respective variables si+, si-, so-, and so+. Whenever two
        // nodes of the inside contours conflict, we compute the left one of the
        // greatest uncommon ancestors using the function ANCESTOR and call MOVE
        // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
        // Finally, we add a new thread (if necessary).
        function apportion(v, w, ancestor) {
            if (w) {
                var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
                while(vim = nextRight(vim), vip = nextLeft(vip), vim && vip){
                    vom = nextLeft(vom);
                    vop = nextRight(vop);
                    vop.a = v;
                    shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                    if (shift > 0) {
                        moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
                        sip += shift;
                        sop += shift;
                    }
                    sim += vim.m;
                    sip += vip.m;
                    som += vom.m;
                    sop += vop.m;
                }
                if (vim && !nextRight(vop)) {
                    vop.t = vim;
                    vop.m += sim - sop;
                }
                if (vip && !nextLeft(vom)) {
                    vom.t = vip;
                    vom.m += sip - som;
                    ancestor = v;
                }
            }
            return ancestor;
        }
        function sizeNode(node) {
            node.x *= dx;
            node.y = node.depth * dy;
        }
        tree.separation = function(x) {
            return arguments.length ? (separation = x, tree) : separation;
        };
        tree.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        tree.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return tree;
    });
var _indexJs = require("./hierarchy/index.js");
function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
TreeNode.prototype = Object.create((0, _indexJs.Node).prototype);
function treeRoot(root) {
    var tree = new TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}

},{"./hierarchy/index.js":"loEhi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"21t2w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var tile = (0, _squarifyJsDefault.default), round = false, dx = 1, dy = 1, paddingStack = [
            0
        ], paddingInner = (0, _constantJs.constantZero), paddingTop = (0, _constantJs.constantZero), paddingRight = (0, _constantJs.constantZero), paddingBottom = (0, _constantJs.constantZero), paddingLeft = (0, _constantJs.constantZero);
        function treemap(root) {
            root.x0 = root.y0 = 0;
            root.x1 = dx;
            root.y1 = dy;
            root.eachBefore(positionNode);
            paddingStack = [
                0
            ];
            if (round) root.eachBefore((0, _roundJsDefault.default));
            return root;
        }
        function positionNode(node) {
            var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
            if (node.children) {
                p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
                x0 += paddingLeft(node) - p;
                y0 += paddingTop(node) - p;
                x1 -= paddingRight(node) - p;
                y1 -= paddingBottom(node) - p;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                tile(node, x0, y0, x1, y1);
            }
        }
        treemap.round = function(x) {
            return arguments.length ? (round = !!x, treemap) : round;
        };
        treemap.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
                dx,
                dy
            ];
        };
        treemap.tile = function(x) {
            return arguments.length ? (tile = (0, _accessorsJs.required)(x), treemap) : tile;
        };
        treemap.padding = function(x) {
            return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
        };
        treemap.paddingInner = function(x) {
            return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingInner;
        };
        treemap.paddingOuter = function(x) {
            return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
        };
        treemap.paddingTop = function(x) {
            return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingTop;
        };
        treemap.paddingRight = function(x) {
            return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingRight;
        };
        treemap.paddingBottom = function(x) {
            return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingBottom;
        };
        treemap.paddingLeft = function(x) {
            return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingLeft;
        };
        return treemap;
    });
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _squarifyJs = require("./squarify.js");
var _squarifyJsDefault = parcelHelpers.interopDefault(_squarifyJs);
var _accessorsJs = require("../accessors.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./round.js":"pDziX","./squarify.js":"latpq","../accessors.js":"jPUrV","../constant.js":"kriEV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"latpq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "phi", ()=>phi);
parcelHelpers.export(exports, "squarifyRatio", ()=>squarifyRatio);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, _sliceJsDefault.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
exports.default = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        squarifyRatio(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}(phi);

},{"./dice.js":"iVQdF","./slice.js":"aPoCq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aPoCq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
        while(++i < n){
            node = nodes[i], node.x0 = x0, node.x1 = x1;
            node.y0 = y0, node.y1 = y0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2IxgB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
        for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
        partition(0, n, parent.value, x0, y0, x1, y1);
        function partition(i, j, value, x0, y0, x1, y1) {
            if (i >= j - 1) {
                var node = nodes[i];
                node.x0 = x0, node.y0 = y0;
                node.x1 = x1, node.y1 = y1;
                return;
            }
            var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
            while(k < hi){
                var mid = k + hi >>> 1;
                if (sums[mid] < valueTarget) k = mid + 1;
                else hi = mid;
            }
            if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
            var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
            if (x1 - x0 > y1 - y0) {
                var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
                partition(i, k, valueLeft, x0, y0, xk, y1);
                partition(k, j, valueRight, xk, y0, x1, y1);
            } else {
                var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
                partition(i, k, valueLeft, x0, y0, x1, yk);
                partition(k, j, valueRight, x0, yk, x1, y1);
            }
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"50Fb3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        (parent.depth & 1 ? (0, _sliceJsDefault.default) : (0, _diceJsDefault.default))(parent, x0, y0, x1, y1);
    });
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);

},{"./dice.js":"iVQdF","./slice.js":"aPoCq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7i3PT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _squarifyJs = require("./squarify.js");
exports.default = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                else (0, _sliceJsDefault.default)(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, _squarifyJs.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, _squarifyJs.phi));

},{"./dice.js":"iVQdF","./slice.js":"aPoCq","./squarify.js":"latpq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gEbap":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polygonArea", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "polygonCentroid", ()=>(0, _centroidJsDefault.default));
parcelHelpers.export(exports, "polygonHull", ()=>(0, _hullJsDefault.default));
parcelHelpers.export(exports, "polygonContains", ()=>(0, _containsJsDefault.default));
parcelHelpers.export(exports, "polygonLength", ()=>(0, _lengthJsDefault.default));
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _hullJs = require("./hull.js");
var _hullJsDefault = parcelHelpers.interopDefault(_hullJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);

},{"./area.js":"4BBWw","./centroid.js":"2I7kU","./hull.js":"kCNhP","./contains.js":"gMjon","./length.js":"hQveM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BBWw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon) {
        var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            area += a[1] * b[0] - a[0] * b[1];
        }
        return area / 2;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2I7kU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon) {
        var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            k += c = a[0] * b[1] - b[0] * a[1];
            x += (a[0] + b[0]) * c;
            y += (a[1] + b[1]) * c;
        }
        return k *= 3, [
            x / k,
            y / k
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kCNhP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(points) {
        if ((n = points.length) < 3) return null;
        var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
        for(i = 0; i < n; ++i)sortedPoints[i] = [
            +points[i][0],
            +points[i][1],
            i
        ];
        sortedPoints.sort(lexicographicOrder);
        for(i = 0; i < n; ++i)flippedPoints[i] = [
            sortedPoints[i][0],
            -sortedPoints[i][1]
        ];
        var upperIndexes = computeUpperHullIndexes(sortedPoints), lowerIndexes = computeUpperHullIndexes(flippedPoints);
        // Construct the hull polygon, removing possible duplicate endpoints.
        var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
        // Add upper hull in right-to-l order.
        // Then add lower hull in left-to-right order.
        for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
        for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
        return hull;
    });
var _crossJs = require("./cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
function lexicographicOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
}
// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
    const n = points.length, indexes = [
        0,
        1
    ];
    let size = 2, i;
    for(i = 2; i < n; ++i){
        while(size > 1 && (0, _crossJsDefault.default)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
        indexes[size++] = i;
    }
    return indexes.slice(0, size); // remove popped points
}

},{"./cross.js":"4fLjh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4fLjh":[function(require,module,exports,__globalThis) {
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b, c) {
        return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gMjon":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon, point) {
        var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
        for(var i = 0; i < n; ++i){
            p = polygon[i], x1 = p[0], y1 = p[1];
            if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
            x0 = x1, y0 = y1;
        }
        return inside;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hQveM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon) {
        var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
        while(++i < n){
            xa = xb;
            ya = yb;
            b = polygon[i];
            xb = b[0];
            yb = b[1];
            xa -= xb;
            ya -= yb;
            perimeter += Math.hypot(xa, ya);
        }
        return perimeter;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g6DUG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "randomUniform", ()=>(0, _uniformJsDefault.default));
parcelHelpers.export(exports, "randomInt", ()=>(0, _intJsDefault.default));
parcelHelpers.export(exports, "randomNormal", ()=>(0, _normalJsDefault.default));
parcelHelpers.export(exports, "randomLogNormal", ()=>(0, _logNormalJsDefault.default));
parcelHelpers.export(exports, "randomBates", ()=>(0, _batesJsDefault.default));
parcelHelpers.export(exports, "randomIrwinHall", ()=>(0, _irwinHallJsDefault.default));
parcelHelpers.export(exports, "randomExponential", ()=>(0, _exponentialJsDefault.default));
parcelHelpers.export(exports, "randomPareto", ()=>(0, _paretoJsDefault.default));
parcelHelpers.export(exports, "randomBernoulli", ()=>(0, _bernoulliJsDefault.default));
parcelHelpers.export(exports, "randomGeometric", ()=>(0, _geometricJsDefault.default));
parcelHelpers.export(exports, "randomBinomial", ()=>(0, _binomialJsDefault.default));
parcelHelpers.export(exports, "randomGamma", ()=>(0, _gammaJsDefault.default));
parcelHelpers.export(exports, "randomBeta", ()=>(0, _betaJsDefault.default));
parcelHelpers.export(exports, "randomWeibull", ()=>(0, _weibullJsDefault.default));
parcelHelpers.export(exports, "randomCauchy", ()=>(0, _cauchyJsDefault.default));
parcelHelpers.export(exports, "randomLogistic", ()=>(0, _logisticJsDefault.default));
parcelHelpers.export(exports, "randomPoisson", ()=>(0, _poissonJsDefault.default));
parcelHelpers.export(exports, "randomLcg", ()=>(0, _lcgJsDefault.default));
var _uniformJs = require("./uniform.js");
var _uniformJsDefault = parcelHelpers.interopDefault(_uniformJs);
var _intJs = require("./int.js");
var _intJsDefault = parcelHelpers.interopDefault(_intJs);
var _normalJs = require("./normal.js");
var _normalJsDefault = parcelHelpers.interopDefault(_normalJs);
var _logNormalJs = require("./logNormal.js");
var _logNormalJsDefault = parcelHelpers.interopDefault(_logNormalJs);
var _batesJs = require("./bates.js");
var _batesJsDefault = parcelHelpers.interopDefault(_batesJs);
var _irwinHallJs = require("./irwinHall.js");
var _irwinHallJsDefault = parcelHelpers.interopDefault(_irwinHallJs);
var _exponentialJs = require("./exponential.js");
var _exponentialJsDefault = parcelHelpers.interopDefault(_exponentialJs);
var _paretoJs = require("./pareto.js");
var _paretoJsDefault = parcelHelpers.interopDefault(_paretoJs);
var _bernoulliJs = require("./bernoulli.js");
var _bernoulliJsDefault = parcelHelpers.interopDefault(_bernoulliJs);
var _geometricJs = require("./geometric.js");
var _geometricJsDefault = parcelHelpers.interopDefault(_geometricJs);
var _binomialJs = require("./binomial.js");
var _binomialJsDefault = parcelHelpers.interopDefault(_binomialJs);
var _gammaJs = require("./gamma.js");
var _gammaJsDefault = parcelHelpers.interopDefault(_gammaJs);
var _betaJs = require("./beta.js");
var _betaJsDefault = parcelHelpers.interopDefault(_betaJs);
var _weibullJs = require("./weibull.js");
var _weibullJsDefault = parcelHelpers.interopDefault(_weibullJs);
var _cauchyJs = require("./cauchy.js");
var _cauchyJsDefault = parcelHelpers.interopDefault(_cauchyJs);
var _logisticJs = require("./logistic.js");
var _logisticJsDefault = parcelHelpers.interopDefault(_logisticJs);
var _poissonJs = require("./poisson.js");
var _poissonJsDefault = parcelHelpers.interopDefault(_poissonJs);
var _lcgJs = require("./lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);

},{"./uniform.js":"2PSIY","./int.js":"faaHV","./normal.js":"1mxih","./logNormal.js":"bJDij","./bates.js":"5mriX","./irwinHall.js":"9irEn","./exponential.js":"dSE1B","./pareto.js":"5Sqlr","./bernoulli.js":"1Q3X4","./geometric.js":"78Suw","./binomial.js":"2JCdb","./gamma.js":"4ab9m","./beta.js":"3OsRG","./weibull.js":"agkBq","./cauchy.js":"LMsGa","./logistic.js":"brLa6","./poisson.js":"2xMsg","./lcg.js":"lL0Ff","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2PSIY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dXOtl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = Math.random;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"faaHV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomInt(source) {
    function randomInt(min, max) {
        if (arguments.length < 2) max = min, min = 0;
        min = Math.floor(min);
        max = Math.floor(max) - min;
        return function() {
            return Math.floor(source() * max + min);
        };
    }
    randomInt.source = sourceRandomInt;
    return randomInt;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1mxih":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bJDij":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _normalJs = require("./normal.js");
var _normalJsDefault = parcelHelpers.interopDefault(_normalJs);
exports.default = function sourceRandomLogNormal(source) {
    var N = (0, _normalJsDefault.default).source(source);
    function randomLogNormal() {
        var randomNormal = N.apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","./normal.js":"1mxih","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5mriX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _irwinHallJs = require("./irwinHall.js");
var _irwinHallJsDefault = parcelHelpers.interopDefault(_irwinHallJs);
exports.default = function sourceRandomBates(source) {
    var I = (0, _irwinHallJsDefault.default).source(source);
    function randomBates(n) {
        // use limiting distribution at n === 0
        if ((n = +n) === 0) return source;
        var randomIrwinHall = I(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","./irwinHall.js":"9irEn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9irEn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        if ((n = +n) <= 0) return ()=>0;
        return function() {
            for(var sum = 0, i = n; i > 1; --i)sum += source();
            return sum + i * source();
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dSE1B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log1p(-source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Sqlr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomPareto(source) {
    function randomPareto(alpha) {
        if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
        alpha = 1 / -alpha;
        return function() {
            return Math.pow(1 - source(), alpha);
        };
    }
    randomPareto.source = sourceRandomPareto;
    return randomPareto;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Q3X4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomBernoulli(source) {
    function randomBernoulli(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        return function() {
            return Math.floor(source() + p);
        };
    }
    randomBernoulli.source = sourceRandomBernoulli;
    return randomBernoulli;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"78Suw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomGeometric(source) {
    function randomGeometric(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        if (p === 0) return ()=>Infinity;
        if (p === 1) return ()=>1;
        p = Math.log1p(-p);
        return function() {
            return 1 + Math.floor(Math.log1p(-source()) / p);
        };
    }
    randomGeometric.source = sourceRandomGeometric;
    return randomGeometric;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2JCdb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _betaJs = require("./beta.js");
var _betaJsDefault = parcelHelpers.interopDefault(_betaJs);
var _geometricJs = require("./geometric.js");
var _geometricJsDefault = parcelHelpers.interopDefault(_geometricJs);
exports.default = function sourceRandomBinomial(source) {
    var G = (0, _geometricJsDefault.default).source(source), B = (0, _betaJsDefault.default).source(source);
    function randomBinomial(n, p) {
        n = +n;
        if ((p = +p) >= 1) return ()=>n;
        if (p <= 0) return ()=>0;
        return function() {
            var acc = 0, nn = n, pp = p;
            while(nn * pp > 16 && nn * (1 - pp) > 16){
                var i = Math.floor((nn + 1) * pp), y = B(i, nn - i + 1)();
                if (y <= pp) {
                    acc += i;
                    nn -= i;
                    pp = (pp - y) / (1 - y);
                } else {
                    nn = i - 1;
                    pp /= y;
                }
            }
            var sign = pp < 0.5, pFinal = sign ? pp : 1 - pp, g = G(pFinal);
            for(var s = g(), k = 0; s <= nn; ++k)s += g();
            return acc + (sign ? k : nn - k);
        };
    }
    randomBinomial.source = sourceRandomBinomial;
    return randomBinomial;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","./beta.js":"3OsRG","./geometric.js":"78Suw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3OsRG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _gammaJs = require("./gamma.js");
var _gammaJsDefault = parcelHelpers.interopDefault(_gammaJs);
exports.default = function sourceRandomBeta(source) {
    var G = (0, _gammaJsDefault.default).source(source);
    function randomBeta(alpha, beta) {
        var X = G(alpha), Y = G(beta);
        return function() {
            var x = X();
            return x === 0 ? 0 : x / (x + Y());
        };
    }
    randomBeta.source = sourceRandomBeta;
    return randomBeta;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","./gamma.js":"4ab9m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ab9m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _normalJs = require("./normal.js");
var _normalJsDefault = parcelHelpers.interopDefault(_normalJs);
exports.default = function sourceRandomGamma(source) {
    var randomNormal = (0, _normalJsDefault.default).source(source)();
    function randomGamma(k, theta) {
        if ((k = +k) < 0) throw new RangeError("invalid k");
        // degenerate distribution if k === 0
        if (k === 0) return ()=>0;
        theta = theta == null ? 1 : +theta;
        // exponential distribution if k === 1
        if (k === 1) return ()=>-Math.log1p(-source()) * theta;
        var d = (k < 1 ? k + 1 : k) - 1 / 3, c = 1 / (3 * Math.sqrt(d)), multiplier = k < 1 ? ()=>Math.pow(source(), 1 / k) : ()=>1;
        return function() {
            do {
                do var x = randomNormal(), v = 1 + c * x;
                while (v <= 0);
                v *= v * v;
                var u = 1 - source();
            }while (u >= 1 - 0.0331 * x * x * x * x && Math.log(u) >= 0.5 * x * x + d * (1 - v + Math.log(v)));
            return d * v * multiplier() * theta;
        };
    }
    randomGamma.source = sourceRandomGamma;
    return randomGamma;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","./normal.js":"1mxih","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"agkBq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomWeibull(source) {
    function randomWeibull(k, a, b) {
        var outerFunc;
        if ((k = +k) === 0) outerFunc = (x)=>-Math.log(x);
        else {
            k = 1 / k;
            outerFunc = (x)=>Math.pow(x, k);
        }
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * outerFunc(-Math.log1p(-source()));
        };
    }
    randomWeibull.source = sourceRandomWeibull;
    return randomWeibull;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"LMsGa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomCauchy(source) {
    function randomCauchy(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * Math.tan(Math.PI * source());
        };
    }
    randomCauchy.source = sourceRandomCauchy;
    return randomCauchy;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"brLa6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomLogistic(source) {
    function randomLogistic(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            var u = source();
            return a + b * Math.log(u / (1 - u));
        };
    }
    randomLogistic.source = sourceRandomLogistic;
    return randomLogistic;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2xMsg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _binomialJs = require("./binomial.js");
var _binomialJsDefault = parcelHelpers.interopDefault(_binomialJs);
var _gammaJs = require("./gamma.js");
var _gammaJsDefault = parcelHelpers.interopDefault(_gammaJs);
exports.default = function sourceRandomPoisson(source) {
    var G = (0, _gammaJsDefault.default).source(source), B = (0, _binomialJsDefault.default).source(source);
    function randomPoisson(lambda) {
        return function() {
            var acc = 0, l = lambda;
            while(l > 16){
                var n = Math.floor(0.875 * l), t = G(n)();
                if (t > l) return acc + B(n - 1, l / t)();
                acc += n;
                l -= t;
            }
            for(var s = -Math.log1p(-source()), k = 0; s <= l; ++k)s -= Math.log1p(-source());
            return acc + k;
        };
    }
    randomPoisson.source = sourceRandomPoisson;
    return randomPoisson;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"dXOtl","./binomial.js":"2JCdb","./gamma.js":"4ab9m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lL0Ff":[function(require,module,exports,__globalThis) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>lcg);
const mul = 0x19660D;
const inc = 0x3C6EF35F;
const eps = 1 / 0x100000000;
function lcg(seed = Math.random()) {
    let state = (0 <= seed && seed < 1 ? seed / eps : Math.abs(seed)) | 0;
    return ()=>(state = mul * state + inc | 0, eps * (state >>> 0));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7BK9l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleBand", ()=>(0, _bandJsDefault.default));
parcelHelpers.export(exports, "scalePoint", ()=>(0, _bandJs.point));
parcelHelpers.export(exports, "scaleIdentity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "scaleLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "scaleLog", ()=>(0, _logJsDefault.default));
parcelHelpers.export(exports, "scaleSymlog", ()=>(0, _symlogJsDefault.default));
parcelHelpers.export(exports, "scaleOrdinal", ()=>(0, _ordinalJsDefault.default));
parcelHelpers.export(exports, "scaleImplicit", ()=>(0, _ordinalJs.implicit));
parcelHelpers.export(exports, "scalePow", ()=>(0, _powJsDefault.default));
parcelHelpers.export(exports, "scaleSqrt", ()=>(0, _powJs.sqrt));
parcelHelpers.export(exports, "scaleRadial", ()=>(0, _radialJsDefault.default));
parcelHelpers.export(exports, "scaleQuantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "scaleQuantize", ()=>(0, _quantizeJsDefault.default));
parcelHelpers.export(exports, "scaleThreshold", ()=>(0, _thresholdJsDefault.default));
parcelHelpers.export(exports, "scaleTime", ()=>(0, _timeJsDefault.default));
parcelHelpers.export(exports, "scaleUtc", ()=>(0, _utcTimeJsDefault.default));
parcelHelpers.export(exports, "scaleSequential", ()=>(0, _sequentialJsDefault.default));
parcelHelpers.export(exports, "scaleSequentialLog", ()=>(0, _sequentialJs.sequentialLog));
parcelHelpers.export(exports, "scaleSequentialPow", ()=>(0, _sequentialJs.sequentialPow));
parcelHelpers.export(exports, "scaleSequentialSqrt", ()=>(0, _sequentialJs.sequentialSqrt));
parcelHelpers.export(exports, "scaleSequentialSymlog", ()=>(0, _sequentialJs.sequentialSymlog));
parcelHelpers.export(exports, "scaleSequentialQuantile", ()=>(0, _sequentialQuantileJsDefault.default));
parcelHelpers.export(exports, "scaleDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "scaleDivergingLog", ()=>(0, _divergingJs.divergingLog));
parcelHelpers.export(exports, "scaleDivergingPow", ()=>(0, _divergingJs.divergingPow));
parcelHelpers.export(exports, "scaleDivergingSqrt", ()=>(0, _divergingJs.divergingSqrt));
parcelHelpers.export(exports, "scaleDivergingSymlog", ()=>(0, _divergingJs.divergingSymlog));
parcelHelpers.export(exports, "tickFormat", ()=>(0, _tickFormatJsDefault.default));
var _bandJs = require("./band.js");
var _bandJsDefault = parcelHelpers.interopDefault(_bandJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _logJs = require("./log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _symlogJs = require("./symlog.js");
var _symlogJsDefault = parcelHelpers.interopDefault(_symlogJs);
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
var _powJs = require("./pow.js");
var _powJsDefault = parcelHelpers.interopDefault(_powJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);
var _thresholdJs = require("./threshold.js");
var _thresholdJsDefault = parcelHelpers.interopDefault(_thresholdJs);
var _timeJs = require("./time.js");
var _timeJsDefault = parcelHelpers.interopDefault(_timeJs);
var _utcTimeJs = require("./utcTime.js");
var _utcTimeJsDefault = parcelHelpers.interopDefault(_utcTimeJs);
var _sequentialJs = require("./sequential.js");
var _sequentialJsDefault = parcelHelpers.interopDefault(_sequentialJs);
var _sequentialQuantileJs = require("./sequentialQuantile.js");
var _sequentialQuantileJsDefault = parcelHelpers.interopDefault(_sequentialQuantileJs);
var _divergingJs = require("./diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);

},{"./band.js":"5Q6GK","./identity.js":"2sUL1","./linear.js":"5y58A","./log.js":"ie2vG","./symlog.js":"3luv5","./ordinal.js":"9md62","./pow.js":"15HKe","./radial.js":"fpHiF","./quantile.js":"bQqSM","./quantize.js":"9QtkS","./threshold.js":"9TNT1","./time.js":"fNFf4","./utcTime.js":"98eKC","./sequential.js":"g41Hh","./sequentialQuantile.js":"6t48V","./diverging.js":"lGrfG","./tickFormat.js":"bMo77","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Q6GK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>band);
parcelHelpers.export(exports, "point", ()=>point);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
function band() {
    var scale = (0, _ordinalJsDefault.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _d3Array.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, _initJs.initRange).apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"d3-array":"bmqp6","./init.js":"MGGB7","./ordinal.js":"9md62","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"MGGB7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initRange", ()=>initRange);
parcelHelpers.export(exports, "initInterpolator", ()=>initInterpolator);
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9md62":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implicit", ()=>implicit);
parcelHelpers.export(exports, "default", ()=>ordinal);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
const implicit = Symbol("implicit");
function ordinal() {
    var index = new (0, _d3Array.InternMap)(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, _d3Array.InternMap)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":"bmqp6","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2sUL1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>identity);
var _linearJs = require("./linear.js");
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
function identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, _numberJsDefault.default)) : [
        0,
        1
    ];
    return (0, _linearJs.linearish)(scale);
}

},{"./linear.js":"5y58A","./number.js":"h8aXB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5y58A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearish", ()=>linearish);
parcelHelpers.export(exports, "default", ()=>linear);
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _d3Array.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormatJsDefault.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _d3Array.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuousJsDefault.default)();
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, linear());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return linearish(scale);
}

},{"d3-array":"bmqp6","./continuous.js":"kDIa7","./init.js":"MGGB7","./tickFormat.js":"bMo77","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kDIa7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "transformer", ()=>transformer);
parcelHelpers.export(exports, "default", ()=>continuous);
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constantJsDefault.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = (0, _d3Interpolate.interpolate), transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, _d3Interpolate.interpolateNumber))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, _d3Interpolate.interpolateRound), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"d3-array":"bmqp6","d3-interpolate":"6bUMz","./constant.js":"85Vbj","./number.js":"h8aXB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"85Vbj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constants);
function constants(x) {
    return function() {
        return x;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h8aXB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
function number(x) {
    return +x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bMo77":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tickFormat);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _d3Array.tickStep)(start, stop, count), precision;
    specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _d3Format.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _d3Format.format)(specifier);
}

},{"d3-array":"bmqp6","d3-format":"bpsrv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ie2vG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggish", ()=>loggish);
parcelHelpers.export(exports, "default", ()=>log);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function reflect(f) {
    return (x, k)=>-f(-x, k);
}
function loggish(transform) {
    const scale = transform(transformLog, transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _d3Array.ticks)(u, v, n);
        } else z = (0, _d3Array.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, _d3Format.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, _d3Format.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, _niceJsDefault.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function log() {
    const scale = loggish((0, _continuousJs.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, _continuousJs.copy)(scale, log()).base(scale.base());
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":"bmqp6","d3-format":"bpsrv","./nice.js":"fMpaN","./continuous.js":"kDIa7","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fMpaN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3luv5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symlogish", ()=>symlogish);
parcelHelpers.export(exports, "default", ()=>symlog);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linearJs.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, symlog()).constant(scale.constant());
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"./linear.js":"5y58A","./continuous.js":"kDIa7","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"15HKe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "powish", ()=>powish);
parcelHelpers.export(exports, "default", ()=>pow);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform((0, _continuousJs.identity), (0, _continuousJs.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, _continuousJs.identity), (0, _continuousJs.identity)) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linearJs.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, pow()).exponent(scale.exponent());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"./linear.js":"5y58A","./continuous.js":"kDIa7","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fpHiF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>radial);
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
function square(x) {
    return Math.sign(x) * x * x;
}
function unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function radial() {
    var squared = (0, _continuousJsDefault.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert(square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, _numberJsDefault.default))).map(square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return (0, _linearJs.linearish)(scale);
}

},{"./continuous.js":"kDIa7","./init.js":"MGGB7","./linear.js":"5y58A","./number.js":"h8aXB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bQqSM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
function quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _d3Array.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, _d3Array.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"d3-array":"bmqp6","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9QtkS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantize);
var _d3Array = require("d3-array");
var _linearJs = require("./linear.js");
var _initJs = require("./init.js");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply((0, _linearJs.linearish)(scale), arguments);
}

},{"d3-array":"bmqp6","./linear.js":"5y58A","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9TNT1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>threshold);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"d3-array":"bmqp6","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fNFf4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", ()=>calendar);
parcelHelpers.export(exports, "default", ()=>time);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, _continuousJsDefault.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, _niceJsDefault.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function time() {
    return (0, _initJs.initRange).apply(calendar((0, _d3Time.timeTicks), (0, _d3Time.timeTickInterval), (0, _d3Time.timeYear), (0, _d3Time.timeMonth), (0, _d3Time.timeWeek), (0, _d3Time.timeDay), (0, _d3Time.timeHour), (0, _d3Time.timeMinute), (0, _d3Time.timeSecond), (0, _d3TimeFormat.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":"2sGu6","d3-time-format":"1JsiF","./continuous.js":"kDIa7","./init.js":"MGGB7","./nice.js":"fMpaN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2sGu6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>(0, _intervalJs.timeInterval));
parcelHelpers.export(exports, "utcMillisecond", ()=>(0, _millisecondJs.millisecond));
parcelHelpers.export(exports, "utcMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "timeMillisecond", ()=>(0, _millisecondJs.millisecond));
parcelHelpers.export(exports, "timeMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "utcSecond", ()=>(0, _secondJs.second));
parcelHelpers.export(exports, "utcSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeSecond", ()=>(0, _secondJs.second));
parcelHelpers.export(exports, "timeSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeMinute", ()=>(0, _minuteJs.timeMinute));
parcelHelpers.export(exports, "timeMinutes", ()=>(0, _minuteJs.timeMinutes));
parcelHelpers.export(exports, "utcMinute", ()=>(0, _minuteJs.utcMinute));
parcelHelpers.export(exports, "utcMinutes", ()=>(0, _minuteJs.utcMinutes));
parcelHelpers.export(exports, "timeHour", ()=>(0, _hourJs.timeHour));
parcelHelpers.export(exports, "timeHours", ()=>(0, _hourJs.timeHours));
parcelHelpers.export(exports, "utcHour", ()=>(0, _hourJs.utcHour));
parcelHelpers.export(exports, "utcHours", ()=>(0, _hourJs.utcHours));
parcelHelpers.export(exports, "timeDay", ()=>(0, _dayJs.timeDay));
parcelHelpers.export(exports, "timeDays", ()=>(0, _dayJs.timeDays));
parcelHelpers.export(exports, "utcDay", ()=>(0, _dayJs.utcDay));
parcelHelpers.export(exports, "utcDays", ()=>(0, _dayJs.utcDays));
parcelHelpers.export(exports, "unixDay", ()=>(0, _dayJs.unixDay));
parcelHelpers.export(exports, "unixDays", ()=>(0, _dayJs.unixDays));
parcelHelpers.export(exports, "timeWeek", ()=>(0, _weekJs.timeSunday));
parcelHelpers.export(exports, "timeWeeks", ()=>(0, _weekJs.timeSundays));
parcelHelpers.export(exports, "timeSunday", ()=>(0, _weekJs.timeSunday));
parcelHelpers.export(exports, "timeSundays", ()=>(0, _weekJs.timeSundays));
parcelHelpers.export(exports, "timeMonday", ()=>(0, _weekJs.timeMonday));
parcelHelpers.export(exports, "timeMondays", ()=>(0, _weekJs.timeMondays));
parcelHelpers.export(exports, "timeTuesday", ()=>(0, _weekJs.timeTuesday));
parcelHelpers.export(exports, "timeTuesdays", ()=>(0, _weekJs.timeTuesdays));
parcelHelpers.export(exports, "timeWednesday", ()=>(0, _weekJs.timeWednesday));
parcelHelpers.export(exports, "timeWednesdays", ()=>(0, _weekJs.timeWednesdays));
parcelHelpers.export(exports, "timeThursday", ()=>(0, _weekJs.timeThursday));
parcelHelpers.export(exports, "timeThursdays", ()=>(0, _weekJs.timeThursdays));
parcelHelpers.export(exports, "timeFriday", ()=>(0, _weekJs.timeFriday));
parcelHelpers.export(exports, "timeFridays", ()=>(0, _weekJs.timeFridays));
parcelHelpers.export(exports, "timeSaturday", ()=>(0, _weekJs.timeSaturday));
parcelHelpers.export(exports, "timeSaturdays", ()=>(0, _weekJs.timeSaturdays));
parcelHelpers.export(exports, "utcWeek", ()=>(0, _weekJs.utcSunday));
parcelHelpers.export(exports, "utcWeeks", ()=>(0, _weekJs.utcSundays));
parcelHelpers.export(exports, "utcSunday", ()=>(0, _weekJs.utcSunday));
parcelHelpers.export(exports, "utcSundays", ()=>(0, _weekJs.utcSundays));
parcelHelpers.export(exports, "utcMonday", ()=>(0, _weekJs.utcMonday));
parcelHelpers.export(exports, "utcMondays", ()=>(0, _weekJs.utcMondays));
parcelHelpers.export(exports, "utcTuesday", ()=>(0, _weekJs.utcTuesday));
parcelHelpers.export(exports, "utcTuesdays", ()=>(0, _weekJs.utcTuesdays));
parcelHelpers.export(exports, "utcWednesday", ()=>(0, _weekJs.utcWednesday));
parcelHelpers.export(exports, "utcWednesdays", ()=>(0, _weekJs.utcWednesdays));
parcelHelpers.export(exports, "utcThursday", ()=>(0, _weekJs.utcThursday));
parcelHelpers.export(exports, "utcThursdays", ()=>(0, _weekJs.utcThursdays));
parcelHelpers.export(exports, "utcFriday", ()=>(0, _weekJs.utcFriday));
parcelHelpers.export(exports, "utcFridays", ()=>(0, _weekJs.utcFridays));
parcelHelpers.export(exports, "utcSaturday", ()=>(0, _weekJs.utcSaturday));
parcelHelpers.export(exports, "utcSaturdays", ()=>(0, _weekJs.utcSaturdays));
parcelHelpers.export(exports, "timeMonth", ()=>(0, _monthJs.timeMonth));
parcelHelpers.export(exports, "timeMonths", ()=>(0, _monthJs.timeMonths));
parcelHelpers.export(exports, "utcMonth", ()=>(0, _monthJs.utcMonth));
parcelHelpers.export(exports, "utcMonths", ()=>(0, _monthJs.utcMonths));
parcelHelpers.export(exports, "timeYear", ()=>(0, _yearJs.timeYear));
parcelHelpers.export(exports, "timeYears", ()=>(0, _yearJs.timeYears));
parcelHelpers.export(exports, "utcYear", ()=>(0, _yearJs.utcYear));
parcelHelpers.export(exports, "utcYears", ()=>(0, _yearJs.utcYears));
parcelHelpers.export(exports, "utcTicks", ()=>(0, _ticksJs.utcTicks));
parcelHelpers.export(exports, "utcTickInterval", ()=>(0, _ticksJs.utcTickInterval));
parcelHelpers.export(exports, "timeTicks", ()=>(0, _ticksJs.timeTicks));
parcelHelpers.export(exports, "timeTickInterval", ()=>(0, _ticksJs.timeTickInterval));
var _intervalJs = require("./interval.js");
var _millisecondJs = require("./millisecond.js");
var _secondJs = require("./second.js");
var _minuteJs = require("./minute.js");
var _hourJs = require("./hour.js");
var _dayJs = require("./day.js");
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _yearJs = require("./year.js");
var _ticksJs = require("./ticks.js");

},{"./interval.js":"5Ne2N","./millisecond.js":"b25OP","./second.js":"8Xc9m","./minute.js":"fvnSK","./hour.js":"aciVO","./day.js":"8aVya","./week.js":"g5HGY","./month.js":"9kzXt","./year.js":"e8dyM","./ticks.js":"8G4t0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Ne2N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>timeInterval);
const t0 = new Date, t1 = new Date;
function timeInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return timeInterval((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b25OP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "millisecond", ()=>millisecond);
parcelHelpers.export(exports, "milliseconds", ()=>milliseconds);
var _intervalJs = require("./interval.js");
const millisecond = (0, _intervalJs.timeInterval)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const milliseconds = millisecond.range;

},{"./interval.js":"5Ne2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Xc9m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "second", ()=>second);
parcelHelpers.export(exports, "seconds", ()=>seconds);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const second = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationSecond);
}, (date)=>{
    return date.getUTCSeconds();
});
const seconds = second.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hBt9s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", ()=>durationSecond);
parcelHelpers.export(exports, "durationMinute", ()=>durationMinute);
parcelHelpers.export(exports, "durationHour", ()=>durationHour);
parcelHelpers.export(exports, "durationDay", ()=>durationDay);
parcelHelpers.export(exports, "durationWeek", ()=>durationWeek);
parcelHelpers.export(exports, "durationMonth", ()=>durationMonth);
parcelHelpers.export(exports, "durationYear", ()=>durationYear);
const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fvnSK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeMinute", ()=>timeMinute);
parcelHelpers.export(exports, "timeMinutes", ()=>timeMinutes);
parcelHelpers.export(exports, "utcMinute", ()=>utcMinute);
parcelHelpers.export(exports, "utcMinutes", ()=>utcMinutes);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeMinute = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationMinute);
}, (date)=>{
    return date.getMinutes();
});
const timeMinutes = timeMinute.range;
const utcMinute = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationMinute);
}, (date)=>{
    return date.getUTCMinutes();
});
const utcMinutes = utcMinute.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aciVO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeHour", ()=>timeHour);
parcelHelpers.export(exports, "timeHours", ()=>timeHours);
parcelHelpers.export(exports, "utcHour", ()=>utcHour);
parcelHelpers.export(exports, "utcHours", ()=>utcHours);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeHour = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationHour);
}, (date)=>{
    return date.getHours();
});
const timeHours = timeHour.range;
const utcHour = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationHour);
}, (date)=>{
    return date.getUTCHours();
});
const utcHours = utcHour.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8aVya":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeDay", ()=>timeDay);
parcelHelpers.export(exports, "timeDays", ()=>timeDays);
parcelHelpers.export(exports, "utcDay", ()=>utcDay);
parcelHelpers.export(exports, "utcDays", ()=>utcDays);
parcelHelpers.export(exports, "unixDay", ()=>unixDay);
parcelHelpers.export(exports, "unixDays", ()=>unixDays);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeDay = (0, _intervalJs.timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay), (date)=>date.getDate() - 1);
const timeDays = timeDay.range;
const utcDay = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationDay);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const utcDays = utcDay.range;
const unixDay = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationDay);
}, (date)=>{
    return Math.floor(date / (0, _durationJs.durationDay));
});
const unixDays = unixDay.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g5HGY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeSunday", ()=>timeSunday);
parcelHelpers.export(exports, "timeMonday", ()=>timeMonday);
parcelHelpers.export(exports, "timeTuesday", ()=>timeTuesday);
parcelHelpers.export(exports, "timeWednesday", ()=>timeWednesday);
parcelHelpers.export(exports, "timeThursday", ()=>timeThursday);
parcelHelpers.export(exports, "timeFriday", ()=>timeFriday);
parcelHelpers.export(exports, "timeSaturday", ()=>timeSaturday);
parcelHelpers.export(exports, "timeSundays", ()=>timeSundays);
parcelHelpers.export(exports, "timeMondays", ()=>timeMondays);
parcelHelpers.export(exports, "timeTuesdays", ()=>timeTuesdays);
parcelHelpers.export(exports, "timeWednesdays", ()=>timeWednesdays);
parcelHelpers.export(exports, "timeThursdays", ()=>timeThursdays);
parcelHelpers.export(exports, "timeFridays", ()=>timeFridays);
parcelHelpers.export(exports, "timeSaturdays", ()=>timeSaturdays);
parcelHelpers.export(exports, "utcSunday", ()=>utcSunday);
parcelHelpers.export(exports, "utcMonday", ()=>utcMonday);
parcelHelpers.export(exports, "utcTuesday", ()=>utcTuesday);
parcelHelpers.export(exports, "utcWednesday", ()=>utcWednesday);
parcelHelpers.export(exports, "utcThursday", ()=>utcThursday);
parcelHelpers.export(exports, "utcFriday", ()=>utcFriday);
parcelHelpers.export(exports, "utcSaturday", ()=>utcSaturday);
parcelHelpers.export(exports, "utcSundays", ()=>utcSundays);
parcelHelpers.export(exports, "utcMondays", ()=>utcMondays);
parcelHelpers.export(exports, "utcTuesdays", ()=>utcTuesdays);
parcelHelpers.export(exports, "utcWednesdays", ()=>utcWednesdays);
parcelHelpers.export(exports, "utcThursdays", ()=>utcThursdays);
parcelHelpers.export(exports, "utcFridays", ()=>utcFridays);
parcelHelpers.export(exports, "utcSaturdays", ()=>utcSaturdays);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
function timeWeekday(i) {
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);
const timeSundays = timeSunday.range;
const timeMondays = timeMonday.range;
const timeTuesdays = timeTuesday.range;
const timeWednesdays = timeWednesday.range;
const timeThursdays = timeThursday.range;
const timeFridays = timeFriday.range;
const timeSaturdays = timeSaturday.range;
function utcWeekday(i) {
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);
const utcSundays = utcSunday.range;
const utcMondays = utcMonday.range;
const utcTuesdays = utcTuesday.range;
const utcWednesdays = utcWednesday.range;
const utcThursdays = utcThursday.range;
const utcFridays = utcFriday.range;
const utcSaturdays = utcSaturday.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9kzXt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeMonth", ()=>timeMonth);
parcelHelpers.export(exports, "timeMonths", ()=>timeMonths);
parcelHelpers.export(exports, "utcMonth", ()=>utcMonth);
parcelHelpers.export(exports, "utcMonths", ()=>utcMonths);
var _intervalJs = require("./interval.js");
const timeMonth = (0, _intervalJs.timeInterval)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const timeMonths = timeMonth.range;
const utcMonth = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const utcMonths = utcMonth.range;

},{"./interval.js":"5Ne2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e8dyM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeYear", ()=>timeYear);
parcelHelpers.export(exports, "timeYears", ()=>timeYears);
parcelHelpers.export(exports, "utcYear", ()=>utcYear);
parcelHelpers.export(exports, "utcYears", ()=>utcYears);
var _intervalJs = require("./interval.js");
const timeYear = (0, _intervalJs.timeInterval)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
timeYear.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJs.timeInterval)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const timeYears = timeYear.range;
const utcYear = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJs.timeInterval)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const utcYears = utcYear.range;

},{"./interval.js":"5Ne2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8G4t0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcTicks", ()=>utcTicks);
parcelHelpers.export(exports, "utcTickInterval", ()=>utcTickInterval);
parcelHelpers.export(exports, "timeTicks", ()=>timeTicks);
parcelHelpers.export(exports, "timeTickInterval", ()=>timeTickInterval);
var _d3Array = require("d3-array");
var _durationJs = require("./duration.js");
var _millisecondJs = require("./millisecond.js");
var _secondJs = require("./second.js");
var _minuteJs = require("./minute.js");
var _hourJs = require("./hour.js");
var _dayJs = require("./day.js");
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _yearJs = require("./year.js");
function ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, _secondJs.second),
            1,
            (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            5,
            5 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            15,
            15 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            30,
            30 * (0, _durationJs.durationSecond)
        ],
        [
            minute,
            1,
            (0, _durationJs.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, _durationJs.durationMinute)
        ],
        [
            hour,
            1,
            (0, _durationJs.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, _durationJs.durationHour)
        ],
        [
            day,
            1,
            (0, _durationJs.durationDay)
        ],
        [
            day,
            2,
            2 * (0, _durationJs.durationDay)
        ],
        [
            week,
            1,
            (0, _durationJs.durationWeek)
        ],
        [
            month,
            1,
            (0, _durationJs.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, _durationJs.durationMonth)
        ],
        [
            year,
            1,
            (0, _durationJs.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, _d3Array.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, _d3Array.tickStep)(start / (0, _durationJs.durationYear), stop / (0, _durationJs.durationYear), count));
        if (i === 0) return (0, _millisecondJs.millisecond).every(Math.max((0, _d3Array.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [utcTicks, utcTickInterval] = ticker((0, _yearJs.utcYear), (0, _monthJs.utcMonth), (0, _weekJs.utcSunday), (0, _dayJs.unixDay), (0, _hourJs.utcHour), (0, _minuteJs.utcMinute));
const [timeTicks, timeTickInterval] = ticker((0, _yearJs.timeYear), (0, _monthJs.timeMonth), (0, _weekJs.timeSunday), (0, _dayJs.timeDay), (0, _hourJs.timeHour), (0, _minuteJs.timeMinute));

},{"d3-array":"bmqp6","./duration.js":"hBt9s","./millisecond.js":"b25OP","./second.js":"8Xc9m","./minute.js":"fvnSK","./hour.js":"aciVO","./day.js":"8aVya","./week.js":"g5HGY","./month.js":"9kzXt","./year.js":"e8dyM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1JsiF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "timeFormat", ()=>(0, _defaultLocaleJs.timeFormat));
parcelHelpers.export(exports, "timeParse", ()=>(0, _defaultLocaleJs.timeParse));
parcelHelpers.export(exports, "utcFormat", ()=>(0, _defaultLocaleJs.utcFormat));
parcelHelpers.export(exports, "utcParse", ()=>(0, _defaultLocaleJs.utcParse));
parcelHelpers.export(exports, "timeFormatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "isoFormat", ()=>(0, _isoFormatJsDefault.default));
parcelHelpers.export(exports, "isoParse", ()=>(0, _isoParseJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _isoFormatJs = require("./isoFormat.js");
var _isoFormatJsDefault = parcelHelpers.interopDefault(_isoFormatJs);
var _isoParseJs = require("./isoParse.js");
var _isoParseJsDefault = parcelHelpers.interopDefault(_isoParseJs);

},{"./defaultLocale.js":"1i7Hq","./locale.js":"8B5N5","./isoFormat.js":"alpF3","./isoParse.js":"96BlO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1i7Hq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormat", ()=>timeFormat);
parcelHelpers.export(exports, "timeParse", ()=>timeParse);
parcelHelpers.export(exports, "utcFormat", ()=>utcFormat);
parcelHelpers.export(exports, "utcParse", ()=>utcParse);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    timeFormat = locale.format;
    timeParse = locale.parse;
    utcFormat = locale.utcFormat;
    utcParse = locale.utcParse;
    return locale;
}

},{"./locale.js":"8B5N5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8B5N5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatLocale);
var _d3Time = require("d3-time");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.utcMonday).ceil(week) : (0, _d3Time.utcMonday)(week);
                    week = (0, _d3Time.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.timeMonday).ceil(week) : (0, _d3Time.timeMonday)(week);
                    week = (0, _d3Time.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.timeDay).count((0, _d3Time.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad((0, _d3Time.timeSunday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad((0, _d3Time.timeThursday).count((0, _d3Time.timeYear)(d), d) + ((0, _d3Time.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad((0, _d3Time.timeMonday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.utcDay).count((0, _d3Time.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad((0, _d3Time.utcSunday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad((0, _d3Time.utcThursday).count((0, _d3Time.utcYear)(d), d) + ((0, _d3Time.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad((0, _d3Time.utcMonday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"d3-time":"2sGu6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"alpF3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isoSpecifier", ()=>isoSpecifier);
var _defaultLocaleJs = require("./defaultLocale.js");
var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
function formatIsoNative(date) {
    return date.toISOString();
}
var formatIso = Date.prototype.toISOString ? formatIsoNative : (0, _defaultLocaleJs.utcFormat)(isoSpecifier);
exports.default = formatIso;

},{"./defaultLocale.js":"1i7Hq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"96BlO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isoFormatJs = require("./isoFormat.js");
var _defaultLocaleJs = require("./defaultLocale.js");
function parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : (0, _defaultLocaleJs.utcParse)((0, _isoFormatJs.isoSpecifier));
exports.default = parseIso;

},{"./isoFormat.js":"alpF3","./defaultLocale.js":"1i7Hq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"98eKC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>utcTime);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _timeJs = require("./time.js");
var _initJs = require("./init.js");
function utcTime() {
    return (0, _initJs.initRange).apply((0, _timeJs.calendar)((0, _d3Time.utcTicks), (0, _d3Time.utcTickInterval), (0, _d3Time.utcYear), (0, _d3Time.utcMonth), (0, _d3Time.utcWeek), (0, _d3Time.utcDay), (0, _d3Time.utcHour), (0, _d3Time.utcMinute), (0, _d3Time.utcSecond), (0, _d3TimeFormat.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":"2sGu6","d3-time-format":"1JsiF","./time.js":"fNFf4","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g41Hh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "default", ()=>sequential);
parcelHelpers.export(exports, "sequentialLog", ()=>sequentialLog);
parcelHelpers.export(exports, "sequentialSymlog", ()=>sequentialSymlog);
parcelHelpers.export(exports, "sequentialPow", ()=>sequentialPow);
parcelHelpers.export(exports, "sequentialSqrt", ()=>sequentialSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, _continuousJs.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":"6bUMz","./continuous.js":"kDIa7","./init.js":"MGGB7","./linear.js":"5y58A","./log.js":"ie2vG","./symlog.js":"3luv5","./pow.js":"15HKe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6t48V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sequentialQuantile);
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function sequentialQuantile() {
    var domain = [], interpolator = (0, _continuousJs.identity);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, _d3Array.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, _d3Array.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return sequentialQuantile(interpolator).domain(domain);
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}

},{"d3-array":"bmqp6","./continuous.js":"kDIa7","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lGrfG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>diverging);
parcelHelpers.export(exports, "divergingLog", ()=>divergingLog);
parcelHelpers.export(exports, "divergingSymlog", ()=>divergingSymlog);
parcelHelpers.export(exports, "divergingPow", ()=>divergingPow);
parcelHelpers.export(exports, "divergingSqrt", ()=>divergingSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _sequentialJs = require("./sequential.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, _continuousJs.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, _d3Interpolate.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function diverging() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, diverging());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":"6bUMz","./continuous.js":"kDIa7","./init.js":"MGGB7","./linear.js":"5y58A","./log.js":"ie2vG","./sequential.js":"g41Hh","./symlog.js":"3luv5","./pow.js":"15HKe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3BbmN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemeCategory10", ()=>(0, _category10JsDefault.default));
parcelHelpers.export(exports, "schemeAccent", ()=>(0, _accentJsDefault.default));
parcelHelpers.export(exports, "schemeDark2", ()=>(0, _dark2JsDefault.default));
parcelHelpers.export(exports, "schemeObservable10", ()=>(0, _observable10JsDefault.default));
parcelHelpers.export(exports, "schemePaired", ()=>(0, _pairedJsDefault.default));
parcelHelpers.export(exports, "schemePastel1", ()=>(0, _pastel1JsDefault.default));
parcelHelpers.export(exports, "schemePastel2", ()=>(0, _pastel2JsDefault.default));
parcelHelpers.export(exports, "schemeSet1", ()=>(0, _set1JsDefault.default));
parcelHelpers.export(exports, "schemeSet2", ()=>(0, _set2JsDefault.default));
parcelHelpers.export(exports, "schemeSet3", ()=>(0, _set3JsDefault.default));
parcelHelpers.export(exports, "schemeTableau10", ()=>(0, _tableau10JsDefault.default));
parcelHelpers.export(exports, "interpolateBrBG", ()=>(0, _brBGJsDefault.default));
parcelHelpers.export(exports, "schemeBrBG", ()=>(0, _brBGJs.scheme));
parcelHelpers.export(exports, "interpolatePRGn", ()=>(0, _prgnJsDefault.default));
parcelHelpers.export(exports, "schemePRGn", ()=>(0, _prgnJs.scheme));
parcelHelpers.export(exports, "interpolatePiYG", ()=>(0, _piYGJsDefault.default));
parcelHelpers.export(exports, "schemePiYG", ()=>(0, _piYGJs.scheme));
parcelHelpers.export(exports, "interpolatePuOr", ()=>(0, _puOrJsDefault.default));
parcelHelpers.export(exports, "schemePuOr", ()=>(0, _puOrJs.scheme));
parcelHelpers.export(exports, "interpolateRdBu", ()=>(0, _rdBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdBu", ()=>(0, _rdBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdGy", ()=>(0, _rdGyJsDefault.default));
parcelHelpers.export(exports, "schemeRdGy", ()=>(0, _rdGyJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlBu", ()=>(0, _rdYlBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlBu", ()=>(0, _rdYlBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlGn", ()=>(0, _rdYlGnJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlGn", ()=>(0, _rdYlGnJs.scheme));
parcelHelpers.export(exports, "interpolateSpectral", ()=>(0, _spectralJsDefault.default));
parcelHelpers.export(exports, "schemeSpectral", ()=>(0, _spectralJs.scheme));
parcelHelpers.export(exports, "interpolateBuGn", ()=>(0, _buGnJsDefault.default));
parcelHelpers.export(exports, "schemeBuGn", ()=>(0, _buGnJs.scheme));
parcelHelpers.export(exports, "interpolateBuPu", ()=>(0, _buPuJsDefault.default));
parcelHelpers.export(exports, "schemeBuPu", ()=>(0, _buPuJs.scheme));
parcelHelpers.export(exports, "interpolateGnBu", ()=>(0, _gnBuJsDefault.default));
parcelHelpers.export(exports, "schemeGnBu", ()=>(0, _gnBuJs.scheme));
parcelHelpers.export(exports, "interpolateOrRd", ()=>(0, _orRdJsDefault.default));
parcelHelpers.export(exports, "schemeOrRd", ()=>(0, _orRdJs.scheme));
parcelHelpers.export(exports, "interpolatePuBuGn", ()=>(0, _puBuGnJsDefault.default));
parcelHelpers.export(exports, "schemePuBuGn", ()=>(0, _puBuGnJs.scheme));
parcelHelpers.export(exports, "interpolatePuBu", ()=>(0, _puBuJsDefault.default));
parcelHelpers.export(exports, "schemePuBu", ()=>(0, _puBuJs.scheme));
parcelHelpers.export(exports, "interpolatePuRd", ()=>(0, _puRdJsDefault.default));
parcelHelpers.export(exports, "schemePuRd", ()=>(0, _puRdJs.scheme));
parcelHelpers.export(exports, "interpolateRdPu", ()=>(0, _rdPuJsDefault.default));
parcelHelpers.export(exports, "schemeRdPu", ()=>(0, _rdPuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGnBu", ()=>(0, _ylGnBuJsDefault.default));
parcelHelpers.export(exports, "schemeYlGnBu", ()=>(0, _ylGnBuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGn", ()=>(0, _ylGnJsDefault.default));
parcelHelpers.export(exports, "schemeYlGn", ()=>(0, _ylGnJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrBr", ()=>(0, _ylOrBrJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrBr", ()=>(0, _ylOrBrJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrRd", ()=>(0, _ylOrRdJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrRd", ()=>(0, _ylOrRdJs.scheme));
parcelHelpers.export(exports, "interpolateBlues", ()=>(0, _bluesJsDefault.default));
parcelHelpers.export(exports, "schemeBlues", ()=>(0, _bluesJs.scheme));
parcelHelpers.export(exports, "interpolateGreens", ()=>(0, _greensJsDefault.default));
parcelHelpers.export(exports, "schemeGreens", ()=>(0, _greensJs.scheme));
parcelHelpers.export(exports, "interpolateGreys", ()=>(0, _greysJsDefault.default));
parcelHelpers.export(exports, "schemeGreys", ()=>(0, _greysJs.scheme));
parcelHelpers.export(exports, "interpolatePurples", ()=>(0, _purplesJsDefault.default));
parcelHelpers.export(exports, "schemePurples", ()=>(0, _purplesJs.scheme));
parcelHelpers.export(exports, "interpolateReds", ()=>(0, _redsJsDefault.default));
parcelHelpers.export(exports, "schemeReds", ()=>(0, _redsJs.scheme));
parcelHelpers.export(exports, "interpolateOranges", ()=>(0, _orangesJsDefault.default));
parcelHelpers.export(exports, "schemeOranges", ()=>(0, _orangesJs.scheme));
parcelHelpers.export(exports, "interpolateCividis", ()=>(0, _cividisJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixDefault", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateRainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "interpolateWarm", ()=>(0, _rainbowJs.warm));
parcelHelpers.export(exports, "interpolateCool", ()=>(0, _rainbowJs.cool));
parcelHelpers.export(exports, "interpolateSinebow", ()=>(0, _sinebowJsDefault.default));
parcelHelpers.export(exports, "interpolateTurbo", ()=>(0, _turboJsDefault.default));
parcelHelpers.export(exports, "interpolateViridis", ()=>(0, _viridisJsDefault.default));
parcelHelpers.export(exports, "interpolateMagma", ()=>(0, _viridisJs.magma));
parcelHelpers.export(exports, "interpolateInferno", ()=>(0, _viridisJs.inferno));
parcelHelpers.export(exports, "interpolatePlasma", ()=>(0, _viridisJs.plasma));
var _category10Js = require("./categorical/category10.js");
var _category10JsDefault = parcelHelpers.interopDefault(_category10Js);
var _accentJs = require("./categorical/Accent.js");
var _accentJsDefault = parcelHelpers.interopDefault(_accentJs);
var _dark2Js = require("./categorical/Dark2.js");
var _dark2JsDefault = parcelHelpers.interopDefault(_dark2Js);
var _observable10Js = require("./categorical/observable10.js");
var _observable10JsDefault = parcelHelpers.interopDefault(_observable10Js);
var _pairedJs = require("./categorical/Paired.js");
var _pairedJsDefault = parcelHelpers.interopDefault(_pairedJs);
var _pastel1Js = require("./categorical/Pastel1.js");
var _pastel1JsDefault = parcelHelpers.interopDefault(_pastel1Js);
var _pastel2Js = require("./categorical/Pastel2.js");
var _pastel2JsDefault = parcelHelpers.interopDefault(_pastel2Js);
var _set1Js = require("./categorical/Set1.js");
var _set1JsDefault = parcelHelpers.interopDefault(_set1Js);
var _set2Js = require("./categorical/Set2.js");
var _set2JsDefault = parcelHelpers.interopDefault(_set2Js);
var _set3Js = require("./categorical/Set3.js");
var _set3JsDefault = parcelHelpers.interopDefault(_set3Js);
var _tableau10Js = require("./categorical/Tableau10.js");
var _tableau10JsDefault = parcelHelpers.interopDefault(_tableau10Js);
var _brBGJs = require("./diverging/BrBG.js");
var _brBGJsDefault = parcelHelpers.interopDefault(_brBGJs);
var _prgnJs = require("./diverging/PRGn.js");
var _prgnJsDefault = parcelHelpers.interopDefault(_prgnJs);
var _piYGJs = require("./diverging/PiYG.js");
var _piYGJsDefault = parcelHelpers.interopDefault(_piYGJs);
var _puOrJs = require("./diverging/PuOr.js");
var _puOrJsDefault = parcelHelpers.interopDefault(_puOrJs);
var _rdBuJs = require("./diverging/RdBu.js");
var _rdBuJsDefault = parcelHelpers.interopDefault(_rdBuJs);
var _rdGyJs = require("./diverging/RdGy.js");
var _rdGyJsDefault = parcelHelpers.interopDefault(_rdGyJs);
var _rdYlBuJs = require("./diverging/RdYlBu.js");
var _rdYlBuJsDefault = parcelHelpers.interopDefault(_rdYlBuJs);
var _rdYlGnJs = require("./diverging/RdYlGn.js");
var _rdYlGnJsDefault = parcelHelpers.interopDefault(_rdYlGnJs);
var _spectralJs = require("./diverging/Spectral.js");
var _spectralJsDefault = parcelHelpers.interopDefault(_spectralJs);
var _buGnJs = require("./sequential-multi/BuGn.js");
var _buGnJsDefault = parcelHelpers.interopDefault(_buGnJs);
var _buPuJs = require("./sequential-multi/BuPu.js");
var _buPuJsDefault = parcelHelpers.interopDefault(_buPuJs);
var _gnBuJs = require("./sequential-multi/GnBu.js");
var _gnBuJsDefault = parcelHelpers.interopDefault(_gnBuJs);
var _orRdJs = require("./sequential-multi/OrRd.js");
var _orRdJsDefault = parcelHelpers.interopDefault(_orRdJs);
var _puBuGnJs = require("./sequential-multi/PuBuGn.js");
var _puBuGnJsDefault = parcelHelpers.interopDefault(_puBuGnJs);
var _puBuJs = require("./sequential-multi/PuBu.js");
var _puBuJsDefault = parcelHelpers.interopDefault(_puBuJs);
var _puRdJs = require("./sequential-multi/PuRd.js");
var _puRdJsDefault = parcelHelpers.interopDefault(_puRdJs);
var _rdPuJs = require("./sequential-multi/RdPu.js");
var _rdPuJsDefault = parcelHelpers.interopDefault(_rdPuJs);
var _ylGnBuJs = require("./sequential-multi/YlGnBu.js");
var _ylGnBuJsDefault = parcelHelpers.interopDefault(_ylGnBuJs);
var _ylGnJs = require("./sequential-multi/YlGn.js");
var _ylGnJsDefault = parcelHelpers.interopDefault(_ylGnJs);
var _ylOrBrJs = require("./sequential-multi/YlOrBr.js");
var _ylOrBrJsDefault = parcelHelpers.interopDefault(_ylOrBrJs);
var _ylOrRdJs = require("./sequential-multi/YlOrRd.js");
var _ylOrRdJsDefault = parcelHelpers.interopDefault(_ylOrRdJs);
var _bluesJs = require("./sequential-single/Blues.js");
var _bluesJsDefault = parcelHelpers.interopDefault(_bluesJs);
var _greensJs = require("./sequential-single/Greens.js");
var _greensJsDefault = parcelHelpers.interopDefault(_greensJs);
var _greysJs = require("./sequential-single/Greys.js");
var _greysJsDefault = parcelHelpers.interopDefault(_greysJs);
var _purplesJs = require("./sequential-single/Purples.js");
var _purplesJsDefault = parcelHelpers.interopDefault(_purplesJs);
var _redsJs = require("./sequential-single/Reds.js");
var _redsJsDefault = parcelHelpers.interopDefault(_redsJs);
var _orangesJs = require("./sequential-single/Oranges.js");
var _orangesJsDefault = parcelHelpers.interopDefault(_orangesJs);
var _cividisJs = require("./sequential-multi/cividis.js");
var _cividisJsDefault = parcelHelpers.interopDefault(_cividisJs);
var _cubehelixJs = require("./sequential-multi/cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _rainbowJs = require("./sequential-multi/rainbow.js");
var _rainbowJsDefault = parcelHelpers.interopDefault(_rainbowJs);
var _sinebowJs = require("./sequential-multi/sinebow.js");
var _sinebowJsDefault = parcelHelpers.interopDefault(_sinebowJs);
var _turboJs = require("./sequential-multi/turbo.js");
var _turboJsDefault = parcelHelpers.interopDefault(_turboJs);
var _viridisJs = require("./sequential-multi/viridis.js");
var _viridisJsDefault = parcelHelpers.interopDefault(_viridisJs);

},{"./categorical/category10.js":"1T8Lf","./categorical/Accent.js":"az1Ba","./categorical/Dark2.js":"hsCMX","./categorical/observable10.js":"kKfFC","./categorical/Paired.js":"lHUvi","./categorical/Pastel1.js":"7ODNA","./categorical/Pastel2.js":"fWbCt","./categorical/Set1.js":"ileVS","./categorical/Set2.js":"dTa0F","./categorical/Set3.js":"1nmER","./categorical/Tableau10.js":"iNodC","./diverging/BrBG.js":"loWV0","./diverging/PRGn.js":"30Rk0","./diverging/PiYG.js":"3lhEK","./diverging/PuOr.js":"ccKPq","./diverging/RdBu.js":"6Jhuk","./diverging/RdGy.js":"7Hhax","./diverging/RdYlBu.js":"7lbDT","./diverging/RdYlGn.js":"9FZGW","./diverging/Spectral.js":"4MCNh","./sequential-multi/BuGn.js":"1TwTg","./sequential-multi/BuPu.js":"j3jES","./sequential-multi/GnBu.js":"bySQe","./sequential-multi/OrRd.js":"8VZnN","./sequential-multi/PuBuGn.js":"2K5Ej","./sequential-multi/PuBu.js":"8fdCd","./sequential-multi/PuRd.js":"aJKkL","./sequential-multi/RdPu.js":"9ySTJ","./sequential-multi/YlGnBu.js":"2TcfG","./sequential-multi/YlGn.js":"hQXZ5","./sequential-multi/YlOrBr.js":"ch1eY","./sequential-multi/YlOrRd.js":"8MjbV","./sequential-single/Blues.js":"jVWkM","./sequential-single/Greens.js":"cfEkZ","./sequential-single/Greys.js":"1xVV2","./sequential-single/Purples.js":"lL1CO","./sequential-single/Reds.js":"kI8hE","./sequential-single/Oranges.js":"0579W","./sequential-multi/cividis.js":"gAYHh","./sequential-multi/cubehelix.js":"eM61s","./sequential-multi/rainbow.js":"gyM7b","./sequential-multi/sinebow.js":"fPIMT","./sequential-multi/turbo.js":"FXmo8","./sequential-multi/viridis.js":"74Dtg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1T8Lf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"29Jx6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"az1Ba":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hsCMX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kKfFC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("4269d0efb118ff725c6cc5b03ca951ff8ab7a463f297bbf59c6b4e9498a0");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lHUvi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ODNA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fWbCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ileVS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dTa0F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1nmER":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iNodC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"loWV0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3qYrI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Interpolate = require("d3-interpolate");
exports.default = (scheme)=>(0, _d3Interpolate.interpolateRgbBasis)(scheme[scheme.length - 1]);

},{"d3-interpolate":"6bUMz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"30Rk0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3lhEK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ccKPq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Jhuk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Hhax":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7lbDT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9FZGW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4MCNh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1TwTg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j3jES":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bySQe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8VZnN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2K5Ej":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8fdCd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aJKkL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ySTJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2TcfG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hQXZ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ch1eY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8MjbV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jVWkM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cfEkZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1xVV2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lL1CO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kI8hE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0579W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gAYHh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eM61s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
exports.default = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(300, 0.5, 0.0), (0, _d3Color.cubehelix)(-240, 0.5, 1.0));

},{"d3-color":"euMEi","d3-interpolate":"6bUMz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gyM7b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warm", ()=>warm);
parcelHelpers.export(exports, "cool", ()=>cool);
parcelHelpers.export(exports, "default", ()=>function(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        c.h = 360 * t - 100;
        c.s = 1.5 - 1.5 * ts;
        c.l = 0.8 - 0.9 * ts;
        return c + "";
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
var warm = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(-100, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var cool = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(260, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var c = (0, _d3Color.cubehelix)();

},{"d3-color":"euMEi","d3-interpolate":"6bUMz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fPIMT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        var x;
        t = (0.5 - t) * Math.PI;
        c.r = 255 * (x = Math.sin(t)) * x;
        c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
        c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
        return c + "";
    });
var _d3Color = require("d3-color");
var c = (0, _d3Color.rgb)(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;

},{"d3-color":"euMEi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"FXmo8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"74Dtg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "magma", ()=>magma);
parcelHelpers.export(exports, "inferno", ()=>inferno);
parcelHelpers.export(exports, "plasma", ()=>plasma);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
function ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
exports.default = ramp((0, _colorsJsDefault.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp((0, _colorsJsDefault.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ba4g6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arc", ()=>(0, _arcJsDefault.default));
parcelHelpers.export(exports, "area", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "line", ()=>(0, _lineJsDefault.default));
parcelHelpers.export(exports, "pie", ()=>(0, _pieJsDefault.default));
parcelHelpers.export(exports, "areaRadial", ()=>(0, _areaRadialJsDefault.default)) // Note: radialArea is deprecated!
;
parcelHelpers.export(exports, "radialArea", ()=>(0, _areaRadialJsDefault.default));
parcelHelpers.export(exports, "lineRadial", ()=>(0, _lineRadialJsDefault.default)) // Note: radialLine is deprecated!
;
parcelHelpers.export(exports, "radialLine", ()=>(0, _lineRadialJsDefault.default));
parcelHelpers.export(exports, "pointRadial", ()=>(0, _pointRadialJsDefault.default));
parcelHelpers.export(exports, "link", ()=>(0, _linkJs.link));
parcelHelpers.export(exports, "linkHorizontal", ()=>(0, _linkJs.linkHorizontal));
parcelHelpers.export(exports, "linkVertical", ()=>(0, _linkJs.linkVertical));
parcelHelpers.export(exports, "linkRadial", ()=>(0, _linkJs.linkRadial));
parcelHelpers.export(exports, "symbol", ()=>(0, _symbolJsDefault.default));
parcelHelpers.export(exports, "symbolsStroke", ()=>(0, _symbolJs.symbolsStroke));
parcelHelpers.export(exports, "symbolsFill", ()=>(0, _symbolJs.symbolsFill));
parcelHelpers.export(exports, "symbols", ()=>(0, _symbolJs.symbolsFill));
parcelHelpers.export(exports, "symbolAsterisk", ()=>(0, _asteriskJsDefault.default));
parcelHelpers.export(exports, "symbolCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "symbolCross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "symbolDiamond", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "symbolDiamond2", ()=>(0, _diamond2JsDefault.default));
parcelHelpers.export(exports, "symbolPlus", ()=>(0, _plusJsDefault.default));
parcelHelpers.export(exports, "symbolSquare", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "symbolSquare2", ()=>(0, _square2JsDefault.default));
parcelHelpers.export(exports, "symbolStar", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "symbolTriangle", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "symbolTriangle2", ()=>(0, _triangle2JsDefault.default));
parcelHelpers.export(exports, "symbolWye", ()=>(0, _wyeJsDefault.default));
parcelHelpers.export(exports, "symbolTimes", ()=>(0, _timesJsDefault.default));
parcelHelpers.export(exports, "symbolX", ()=>(0, _timesJsDefault.default));
parcelHelpers.export(exports, "curveBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "curveBasisOpen", ()=>(0, _basisOpenJsDefault.default));
parcelHelpers.export(exports, "curveBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "curveBumpX", ()=>(0, _bumpJs.bumpX));
parcelHelpers.export(exports, "curveBumpY", ()=>(0, _bumpJs.bumpY));
parcelHelpers.export(exports, "curveBundle", ()=>(0, _bundleJsDefault.default));
parcelHelpers.export(exports, "curveCardinalClosed", ()=>(0, _cardinalClosedJsDefault.default));
parcelHelpers.export(exports, "curveCardinalOpen", ()=>(0, _cardinalOpenJsDefault.default));
parcelHelpers.export(exports, "curveCardinal", ()=>(0, _cardinalJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomClosed", ()=>(0, _catmullRomClosedJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomOpen", ()=>(0, _catmullRomOpenJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRom", ()=>(0, _catmullRomJsDefault.default));
parcelHelpers.export(exports, "curveLinearClosed", ()=>(0, _linearClosedJsDefault.default));
parcelHelpers.export(exports, "curveLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "curveMonotoneX", ()=>(0, _monotoneJs.monotoneX));
parcelHelpers.export(exports, "curveMonotoneY", ()=>(0, _monotoneJs.monotoneY));
parcelHelpers.export(exports, "curveNatural", ()=>(0, _naturalJsDefault.default));
parcelHelpers.export(exports, "curveStep", ()=>(0, _stepJsDefault.default));
parcelHelpers.export(exports, "curveStepAfter", ()=>(0, _stepJs.stepAfter));
parcelHelpers.export(exports, "curveStepBefore", ()=>(0, _stepJs.stepBefore));
parcelHelpers.export(exports, "stack", ()=>(0, _stackJsDefault.default));
parcelHelpers.export(exports, "stackOffsetExpand", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "stackOffsetDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "stackOffsetNone", ()=>(0, _noneJsDefault.default));
parcelHelpers.export(exports, "stackOffsetSilhouette", ()=>(0, _silhouetteJsDefault.default));
parcelHelpers.export(exports, "stackOffsetWiggle", ()=>(0, _wiggleJsDefault.default));
parcelHelpers.export(exports, "stackOrderAppearance", ()=>(0, _appearanceJsDefault.default));
parcelHelpers.export(exports, "stackOrderAscending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderDescending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderInsideOut", ()=>(0, _insideOutJsDefault.default));
parcelHelpers.export(exports, "stackOrderNone", ()=>(0, _noneJsDefault1.default));
parcelHelpers.export(exports, "stackOrderReverse", ()=>(0, _reverseJsDefault.default));
var _arcJs = require("./arc.js");
var _arcJsDefault = parcelHelpers.interopDefault(_arcJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pieJs = require("./pie.js");
var _pieJsDefault = parcelHelpers.interopDefault(_pieJs);
var _areaRadialJs = require("./areaRadial.js");
var _areaRadialJsDefault = parcelHelpers.interopDefault(_areaRadialJs);
var _lineRadialJs = require("./lineRadial.js");
var _lineRadialJsDefault = parcelHelpers.interopDefault(_lineRadialJs);
var _pointRadialJs = require("./pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
var _linkJs = require("./link.js");
var _symbolJs = require("./symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _asteriskJs = require("./symbol/asterisk.js");
var _asteriskJsDefault = parcelHelpers.interopDefault(_asteriskJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _diamond2Js = require("./symbol/diamond2.js");
var _diamond2JsDefault = parcelHelpers.interopDefault(_diamond2Js);
var _plusJs = require("./symbol/plus.js");
var _plusJsDefault = parcelHelpers.interopDefault(_plusJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _square2Js = require("./symbol/square2.js");
var _square2JsDefault = parcelHelpers.interopDefault(_square2Js);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _triangle2Js = require("./symbol/triangle2.js");
var _triangle2JsDefault = parcelHelpers.interopDefault(_triangle2Js);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _timesJs = require("./symbol/times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
var _basisClosedJs = require("./curve/basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _basisOpenJs = require("./curve/basisOpen.js");
var _basisOpenJsDefault = parcelHelpers.interopDefault(_basisOpenJs);
var _basisJs = require("./curve/basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _bumpJs = require("./curve/bump.js");
var _bundleJs = require("./curve/bundle.js");
var _bundleJsDefault = parcelHelpers.interopDefault(_bundleJs);
var _cardinalClosedJs = require("./curve/cardinalClosed.js");
var _cardinalClosedJsDefault = parcelHelpers.interopDefault(_cardinalClosedJs);
var _cardinalOpenJs = require("./curve/cardinalOpen.js");
var _cardinalOpenJsDefault = parcelHelpers.interopDefault(_cardinalOpenJs);
var _cardinalJs = require("./curve/cardinal.js");
var _cardinalJsDefault = parcelHelpers.interopDefault(_cardinalJs);
var _catmullRomClosedJs = require("./curve/catmullRomClosed.js");
var _catmullRomClosedJsDefault = parcelHelpers.interopDefault(_catmullRomClosedJs);
var _catmullRomOpenJs = require("./curve/catmullRomOpen.js");
var _catmullRomOpenJsDefault = parcelHelpers.interopDefault(_catmullRomOpenJs);
var _catmullRomJs = require("./curve/catmullRom.js");
var _catmullRomJsDefault = parcelHelpers.interopDefault(_catmullRomJs);
var _linearClosedJs = require("./curve/linearClosed.js");
var _linearClosedJsDefault = parcelHelpers.interopDefault(_linearClosedJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _monotoneJs = require("./curve/monotone.js");
var _naturalJs = require("./curve/natural.js");
var _naturalJsDefault = parcelHelpers.interopDefault(_naturalJs);
var _stepJs = require("./curve/step.js");
var _stepJsDefault = parcelHelpers.interopDefault(_stepJs);
var _stackJs = require("./stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _expandJs = require("./offset/expand.js");
var _expandJsDefault = parcelHelpers.interopDefault(_expandJs);
var _divergingJs = require("./offset/diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _silhouetteJs = require("./offset/silhouette.js");
var _silhouetteJsDefault = parcelHelpers.interopDefault(_silhouetteJs);
var _wiggleJs = require("./offset/wiggle.js");
var _wiggleJsDefault = parcelHelpers.interopDefault(_wiggleJs);
var _appearanceJs = require("./order/appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./order/ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./order/descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _insideOutJs = require("./order/insideOut.js");
var _insideOutJsDefault = parcelHelpers.interopDefault(_insideOutJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
var _reverseJs = require("./order/reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);

},{"./arc.js":"9FtUx","./area.js":"chNqs","./line.js":"cajtE","./pie.js":"bGWh0","./areaRadial.js":"acrY1","./lineRadial.js":"8UDz0","./pointRadial.js":"cH1Yo","./link.js":"jA3TD","./symbol.js":"abAeo","./symbol/asterisk.js":"dfMbk","./symbol/circle.js":"icGZv","./symbol/cross.js":"iodqA","./symbol/diamond.js":"2ZQyp","./symbol/diamond2.js":"8iKjD","./symbol/plus.js":"4efvB","./symbol/square.js":"cJObK","./symbol/square2.js":"9CiVa","./symbol/star.js":"gWxzN","./symbol/triangle.js":"l1CUy","./symbol/triangle2.js":"btrg6","./symbol/wye.js":"dIwHO","./symbol/times.js":"8TsyV","./curve/basisClosed.js":"ijoiU","./curve/basisOpen.js":"g9pcb","./curve/basis.js":"4H0iE","./curve/bump.js":"64diA","./curve/bundle.js":"Q1NIm","./curve/cardinalClosed.js":"hEwXQ","./curve/cardinalOpen.js":"5UKJ2","./curve/cardinal.js":"dxG8N","./curve/catmullRomClosed.js":"91kOz","./curve/catmullRomOpen.js":"fymLo","./curve/catmullRom.js":"bdz6e","./curve/linearClosed.js":"dcgCm","./curve/linear.js":"2wPoR","./curve/monotone.js":"lmU2h","./curve/natural.js":"2QGlH","./curve/step.js":"ipHcF","./stack.js":"724K5","./offset/expand.js":"1GMo5","./offset/diverging.js":"gyAC2","./offset/none.js":"BSEuE","./offset/silhouette.js":"iSONX","./offset/wiggle.js":"95A1s","./order/appearance.js":"ahopc","./order/ascending.js":"amYoy","./order/descending.js":"5TXuD","./order/insideOut.js":"21iWT","./order/none.js":"heTyv","./order/reverse.js":"1cGWN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9FtUx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constantJsDefault.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null, path = (0, _pathJs.withPath)(arc);
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, _mathJs.halfPi), a1 = endAngle.apply(this, arguments) - (0, _mathJs.halfPi), da = (0, _mathJs.abs)(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = path();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > (0, _mathJs.epsilon))) context.moveTo(0, 0);
            else if (da > (0, _mathJs.tau) - (0, _mathJs.epsilon)) {
                context.moveTo(r1 * (0, _mathJs.cos)(a0), r1 * (0, _mathJs.sin)(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > (0, _mathJs.epsilon)) {
                    context.moveTo(r0 * (0, _mathJs.cos)(a1), r0 * (0, _mathJs.sin)(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, _mathJs.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, _mathJs.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _mathJs.min)((0, _mathJs.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > (0, _mathJs.epsilon)) {
                    var p0 = (0, _mathJs.asin)(rp / r0 * (0, _mathJs.sin)(ap)), p1 = (0, _mathJs.asin)(rp / r1 * (0, _mathJs.sin)(ap));
                    if ((da0 -= p0 * 2) > (0, _mathJs.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > (0, _mathJs.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * (0, _mathJs.cos)(a01), y01 = r1 * (0, _mathJs.sin)(a01), x10 = r0 * (0, _mathJs.cos)(a10), y10 = r0 * (0, _mathJs.sin)(a10);
                // Apply rounded corners?
                if (rc > (0, _mathJs.epsilon)) {
                    var x11 = r1 * (0, _mathJs.cos)(a11), y11 = r1 * (0, _mathJs.sin)(a11), x00 = r0 * (0, _mathJs.cos)(a00), y00 = r0 * (0, _mathJs.sin)(a00), oc;
                    // Restrict the corner radius according to the sector angle. If this
                    // intersection fails, it’s probably because the arc is too small, so
                    // disable the corner radius entirely.
                    if (da < (0, _mathJs.pi)) {
                        if (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _mathJs.sin)((0, _mathJs.acos)((ax * bx + ay * by) / ((0, _mathJs.sqrt)(ax * ax + ay * ay) * (0, _mathJs.sqrt)(bx * bx + by * by))) / 2), lc = (0, _mathJs.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                            rc0 = (0, _mathJs.min)(rc, (r0 - lc) / (kc - 1));
                            rc1 = (0, _mathJs.min)(rc, (r1 - lc) / (kc + 1));
                        } else rc0 = rc1 = 0;
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > (0, _mathJs.epsilon))) context.moveTo(x01, y01);
                else if (rc1 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > (0, _mathJs.epsilon)) || !(da0 > (0, _mathJs.epsilon))) context.lineTo(x10, y10);
                else if (rc0 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, _mathJs.pi) / 2;
            return [
                (0, _mathJs.cos)(a) * r,
                (0, _mathJs.sin)(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
var _pathJs = require("./path.js");
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, _mathJs.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _mathJs.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _mathJs.sqrt)((0, _mathJs.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}

},{"./constant.js":"dowtg","./math.js":"cVb0q","./path.js":"xrefU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dowtg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function constant() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cVb0q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
const abs = Math.abs;
const atan2 = Math.atan2;
const cos = Math.cos;
const max = Math.max;
const min = Math.min;
const sin = Math.sin;
const sqrt = Math.sqrt;
const epsilon = 1e-12;
const pi = Math.PI;
const halfPi = pi / 2;
const tau = 2 * pi;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"xrefU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withPath", ()=>withPath);
var _d3Path = require("d3-path");
function withPath(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, _d3Path.Path)(digits);
}

},{"d3-path":"gnRAQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"chNqs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x0, y0, y1) {
        var x1 = null, defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null, path = (0, _pathJs.withPath)(area);
        x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, _pointJs.x) : (0, _constantJsDefault.default)(+x0);
        y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, _constantJsDefault.default)(0) : (0, _constantJsDefault.default)(+y0);
        y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, _pointJs.y) : (0, _constantJsDefault.default)(+y1);
        function area(data) {
            var i, j, k, n = (data = (0, _arrayJsDefault.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) {
                        j = i;
                        output.areaStart();
                        output.lineStart();
                    } else {
                        output.lineEnd();
                        output.lineStart();
                        for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                        output.lineEnd();
                        output.areaEnd();
                    }
                }
                if (defined0) {
                    x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                    output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                }
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        function arealine() {
            return (0, _lineJsDefault.default)().defined(defined).curve(curve).context(context);
        }
        area.x = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), x1 = null, area) : x0;
        };
        area.x0 = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x0;
        };
        area.x1 = function(_) {
            return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x1;
        };
        area.y = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), y1 = null, area) : y0;
        };
        area.y0 = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y0;
        };
        area.y1 = function(_) {
            return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y1;
        };
        area.lineX0 = area.lineY0 = function() {
            return arealine().x(x0).y(y0);
        };
        area.lineY1 = function() {
            return arealine().x(x0).y(y1);
        };
        area.lineX1 = function() {
            return arealine().x(x1).y(y0);
        };
        area.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), area) : defined;
        };
        area.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
        };
        area.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
        };
        return area;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pathJs = require("./path.js");
var _pointJs = require("./point.js");

},{"./array.js":"7c3gb","./constant.js":"dowtg","./curve/linear.js":"2wPoR","./line.js":"cajtE","./path.js":"xrefU","./point.js":"8C5ZW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7c3gb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    });
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2wPoR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Linear(context);
    });
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cajtE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null, path = (0, _pathJs.withPath)(line);
        x = typeof x === "function" ? x : x === undefined ? (0, _pointJs.x) : (0, _constantJsDefault.default)(x);
        y = typeof y === "function" ? y : y === undefined ? (0, _pointJs.y) : (0, _constantJsDefault.default)(y);
        function line(data) {
            var i, n = (data = (0, _arrayJsDefault.default)(data)).length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x(d, i, data), +y(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : x;
        };
        line.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : y;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _pathJs = require("./path.js");
var _pointJs = require("./point.js");

},{"./array.js":"7c3gb","./constant.js":"dowtg","./curve/linear.js":"2wPoR","./path.js":"xrefU","./point.js":"8C5ZW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8C5ZW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bGWh0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var value = (0, _identityJsDefault.default), sortValues = (0, _descendingJsDefault.default), sort = null, startAngle = (0, _constantJsDefault.default)(0), endAngle = (0, _constantJsDefault.default)((0, _mathJs.tau)), padAngle = (0, _constantJsDefault.default)(0);
        function pie(data) {
            var i, n = (data = (0, _arrayJsDefault.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, _mathJs.tau), Math.max(-(0, _mathJs.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
            for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
            // Optionally sort the arcs by previously-computed values or by data.
            if (sortValues != null) index.sort(function(i, j) {
                return sortValues(arcs[i], arcs[j]);
            });
            else if (sort != null) index.sort(function(i, j) {
                return sort(data[i], data[j]);
            });
            // Compute the arcs! They are stored in the original data's order.
            for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
                data: data[j],
                index: i,
                value: v,
                startAngle: a0,
                endAngle: a1,
                padAngle: p
            };
            return arcs;
        }
        pie.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : value;
        };
        pie.sortValues = function(_) {
            return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
        };
        pie.sort = function(_) {
            return arguments.length ? (sort = _, sortValues = null, pie) : sort;
        };
        pie.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : startAngle;
        };
        pie.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : endAngle;
        };
        pie.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : padAngle;
        };
        return pie;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("./math.js");

},{"./array.js":"7c3gb","./constant.js":"dowtg","./descending.js":"gYyQA","./identity.js":"4iLVz","./math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gYyQA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iLVz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        return d;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"acrY1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var a = (0, _areaJsDefault.default)().curve((0, _radialJs.curveRadialLinear)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
        a.angle = a.x, delete a.x;
        a.startAngle = a.x0, delete a.x0;
        a.endAngle = a.x1, delete a.x1;
        a.radius = a.y, delete a.y;
        a.innerRadius = a.y0, delete a.y0;
        a.outerRadius = a.y1, delete a.y1;
        a.lineStartAngle = function() {
            return (0, _lineRadialJs.lineRadial)(x0());
        }, delete a.lineX0;
        a.lineEndAngle = function() {
            return (0, _lineRadialJs.lineRadial)(x1());
        }, delete a.lineX1;
        a.lineInnerRadius = function() {
            return (0, _lineRadialJs.lineRadial)(y0());
        }, delete a.lineY0;
        a.lineOuterRadius = function() {
            return (0, _lineRadialJs.lineRadial)(y1());
        }, delete a.lineY1;
        a.curve = function(_) {
            return arguments.length ? c((0, _radialJsDefault.default)(_)) : c()._curve;
        };
        return a;
    });
var _radialJs = require("./curve/radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineRadialJs = require("./lineRadial.js");

},{"./curve/radial.js":"1sPwa","./area.js":"chNqs","./lineRadial.js":"8UDz0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1sPwa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "curveRadialLinear", ()=>curveRadialLinear);
parcelHelpers.export(exports, "default", ()=>curveRadial);
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var curveRadialLinear = curveRadial((0, _linearJsDefault.default));
function Radial(curve) {
    this._curve = curve;
}
Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function curveRadial(curve) {
    function radial(context) {
        return new Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

},{"./linear.js":"2wPoR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8UDz0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lineRadial", ()=>lineRadial);
parcelHelpers.export(exports, "default", ()=>function() {
        return lineRadial((0, _lineJsDefault.default)().curve((0, _radialJs.curveRadialLinear)));
    });
var _radialJs = require("./curve/radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
function lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, _radialJsDefault.default)(_)) : c()._curve;
    };
    return l;
}

},{"./curve/radial.js":"1sPwa","./line.js":"cajtE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cH1Yo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        return [
            (y = +y) * Math.cos(x -= Math.PI / 2),
            y * Math.sin(x)
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jA3TD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "link", ()=>link);
parcelHelpers.export(exports, "linkHorizontal", ()=>linkHorizontal);
parcelHelpers.export(exports, "linkVertical", ()=>linkVertical);
parcelHelpers.export(exports, "linkRadial", ()=>linkRadial);
var _arrayJs = require("./array.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _bumpJs = require("./curve/bump.js");
var _pathJs = require("./path.js");
var _pointJs = require("./point.js");
function linkSource(d) {
    return d.source;
}
function linkTarget(d) {
    return d.target;
}
function link(curve) {
    let source = linkSource, target = linkTarget, x = (0, _pointJs.x), y = (0, _pointJs.y), context = null, output = null, path = (0, _pathJs.withPath)(link);
    function link() {
        let buffer;
        const argv = (0, _arrayJs.slice).call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = path());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function linkHorizontal() {
    return link((0, _bumpJs.bumpX));
}
function linkVertical() {
    return link((0, _bumpJs.bumpY));
}
function linkRadial() {
    const l = link((0, _bumpJs.bumpRadial));
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

},{"./array.js":"7c3gb","./constant.js":"dowtg","./curve/bump.js":"64diA","./path.js":"xrefU","./point.js":"8C5ZW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"64diA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bumpX", ()=>bumpX);
parcelHelpers.export(exports, "bumpY", ()=>bumpY);
parcelHelpers.export(exports, "bumpRadial", ()=>bumpRadial);
var _pointRadialJs = require("../pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
class Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point === 0) this._point = 1;
        else {
            const p0 = (0, _pointRadialJsDefault.default)(this._x0, this._y0);
            const p1 = (0, _pointRadialJsDefault.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, _pointRadialJsDefault.default)(x, this._y0);
            const p3 = (0, _pointRadialJsDefault.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
        this._x0 = x, this._y0 = y;
    }
}
function bumpX(context) {
    return new Bump(context, true);
}
function bumpY(context) {
    return new Bump(context, false);
}
function bumpRadial(context) {
    return new BumpRadial(context);
}

},{"../pointRadial.js":"cH1Yo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"abAeo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symbolsFill", ()=>symbolsFill);
parcelHelpers.export(exports, "symbolsStroke", ()=>symbolsStroke);
parcelHelpers.export(exports, "default", ()=>Symbol);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _pathJs = require("./path.js");
var _asteriskJs = require("./symbol/asterisk.js");
var _asteriskJsDefault = parcelHelpers.interopDefault(_asteriskJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _diamond2Js = require("./symbol/diamond2.js");
var _diamond2JsDefault = parcelHelpers.interopDefault(_diamond2Js);
var _plusJs = require("./symbol/plus.js");
var _plusJsDefault = parcelHelpers.interopDefault(_plusJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _square2Js = require("./symbol/square2.js");
var _square2JsDefault = parcelHelpers.interopDefault(_square2Js);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _triangle2Js = require("./symbol/triangle2.js");
var _triangle2JsDefault = parcelHelpers.interopDefault(_triangle2Js);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _timesJs = require("./symbol/times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
const symbolsFill = [
    (0, _circleJsDefault.default),
    (0, _crossJsDefault.default),
    (0, _diamondJsDefault.default),
    (0, _squareJsDefault.default),
    (0, _starJsDefault.default),
    (0, _triangleJsDefault.default),
    (0, _wyeJsDefault.default)
];
const symbolsStroke = [
    (0, _circleJsDefault.default),
    (0, _plusJsDefault.default),
    (0, _timesJsDefault.default),
    (0, _triangle2JsDefault.default),
    (0, _asteriskJsDefault.default),
    (0, _square2JsDefault.default),
    (0, _diamond2JsDefault.default)
];
function Symbol(type, size) {
    let context = null, path = (0, _pathJs.withPath)(symbol);
    type = typeof type === "function" ? type : (0, _constantJsDefault.default)(type || (0, _circleJsDefault.default));
    size = typeof size === "function" ? size : (0, _constantJsDefault.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

},{"./constant.js":"dowtg","./path.js":"xrefU","./symbol/asterisk.js":"dfMbk","./symbol/circle.js":"icGZv","./symbol/cross.js":"iodqA","./symbol/diamond.js":"2ZQyp","./symbol/diamond2.js":"8iKjD","./symbol/plus.js":"4efvB","./symbol/square.js":"cJObK","./symbol/square2.js":"9CiVa","./symbol/star.js":"gWxzN","./symbol/triangle.js":"l1CUy","./symbol/triangle2.js":"btrg6","./symbol/wye.js":"dIwHO","./symbol/times.js":"8TsyV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dfMbk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const sqrt3 = (0, _mathJs.sqrt)(3);
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size + (0, _mathJs.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"icGZv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size / (0, _mathJs.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, _mathJs.tau));
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iodqA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ZQyp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const tan30 = (0, _mathJs.sqrt)(1 / 3);
const tan30_2 = tan30 * 2;
exports.default = {
    draw (context, size) {
        const y = (0, _mathJs.sqrt)(size / tan30_2);
        const x = y * tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8iKjD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4efvB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size - (0, _mathJs.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cJObK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const w = (0, _mathJs.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9CiVa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gWxzN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const ka = 0.89081309152928522810;
const kr = (0, _mathJs.sin)((0, _mathJs.pi) / 10) / (0, _mathJs.sin)(7 * (0, _mathJs.pi) / 10);
const kx = (0, _mathJs.sin)((0, _mathJs.tau) / 10) * kr;
const ky = -(0, _mathJs.cos)((0, _mathJs.tau) / 10) * kr;
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size * ka);
        const x = kx * r;
        const y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, _mathJs.tau) * i / 5;
            const c = (0, _mathJs.cos)(a);
            const s = (0, _mathJs.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l1CUy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const sqrt3 = (0, _mathJs.sqrt)(3);
exports.default = {
    draw (context, size) {
        const y = -(0, _mathJs.sqrt)(size / (sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-sqrt3 * y, -y);
        context.lineTo(sqrt3 * y, -y);
        context.closePath();
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"btrg6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const sqrt3 = (0, _mathJs.sqrt)(3);
exports.default = {
    draw (context, size) {
        const s = (0, _mathJs.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dIwHO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const c = -0.5;
const s = (0, _mathJs.sqrt)(3) / 2;
const k = 1 / (0, _mathJs.sqrt)(12);
const a = (k / 2 + 1) * 3;
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size / a);
        const x0 = r / 2, y0 = r * k;
        const x1 = x0, y1 = r * k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8TsyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size - (0, _mathJs.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};

},{"../math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ijoiU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _basisJs = require("./basis.js");
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"../noop.js":"jKJtW","./basis.js":"4H0iE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jKJtW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4H0iE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Basis", ()=>Basis);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Basis(context);
    });
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g9pcb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisOpen(context);
    });
var _basisJs = require("./basis.js");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"./basis.js":"4H0iE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Q1NIm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basisJs = require("./basis.js");
function Bundle(context, beta) {
    this._basis = new (0, _basisJs.Basis)(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, _basisJs.Basis)(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

},{"./basis.js":"4H0iE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hEwXQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalClosed", ()=>CardinalClosed);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _cardinalJs = require("./cardinal.js");
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"../noop.js":"jKJtW","./cardinal.js":"dxG8N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dxG8N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Cardinal", ()=>Cardinal);
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5UKJ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalOpen", ()=>CardinalOpen);
var _cardinalJs = require("./cardinal.js");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"./cardinal.js":"dxG8N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"91kOz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalClosedJs = require("./cardinalClosed.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new (0, _cardinalClosedJs.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalClosed.js":"hEwXQ","../noop.js":"jKJtW","./catmullRom.js":"bdz6e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bdz6e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
var _mathJs = require("../math.js");
var _cardinalJs = require("./cardinal.js");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, _mathJs.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, _mathJs.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, _cardinalJs.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"../math.js":"cVb0q","./cardinal.js":"dxG8N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fymLo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalOpenJs = require("./cardinalOpen.js");
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new (0, _cardinalOpenJs.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalOpen.js":"5UKJ2","./catmullRom.js":"bdz6e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dcgCm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new LinearClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};

},{"../noop.js":"jKJtW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lmU2h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monotoneX", ()=>monotoneX);
parcelHelpers.export(exports, "monotoneY", ()=>monotoneY);
function sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2QGlH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Natural(context);
    });
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ipHcF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Step(context, 0.5);
    });
parcelHelpers.export(exports, "stepBefore", ()=>stepBefore);
parcelHelpers.export(exports, "stepAfter", ()=>stepAfter);
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"724K5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var keys = (0, _constantJsDefault.default)([]), order = (0, _noneJsDefault1.default), offset = (0, _noneJsDefault.default), value = stackValue;
        function stack(data) {
            var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
            for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
                0,
                +value(d, sz[i].key, j, data)
            ]).data = d;
            for(i = 0, oz = (0, _arrayJsDefault.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
            offset(sz, oz);
            return sz;
        }
        stack.keys = function(_) {
            return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.from(_)), stack) : keys;
        };
        stack.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), stack) : value;
        };
        stack.order = function(_) {
            return arguments.length ? (order = _ == null ? (0, _noneJsDefault1.default) : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.from(_)), stack) : order;
        };
        stack.offset = function(_) {
            return arguments.length ? (offset = _ == null ? (0, _noneJsDefault.default) : _, stack) : offset;
        };
        return stack;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
function stackValue(d, key) {
    return d[key];
}
function stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}

},{"./array.js":"7c3gb","./constant.js":"dowtg","./offset/none.js":"BSEuE","./order/none.js":"heTyv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"BSEuE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 1)) return;
        for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
            s0 = s1, s1 = series[order[i]];
            for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"heTyv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var n = series.length, o = new Array(n);
        while(--n >= 0)o[n] = n;
        return o;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1GMo5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
            for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
            if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
        }
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"BSEuE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gyAC2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
            if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
            else if (dy < 0) d[1] = yn, d[0] = yn += dy;
            else d[0] = 0, d[1] = dy;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iSONX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
            for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
            s0[j][1] += s0[j][0] = -y / 2;
        }
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"BSEuE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"95A1s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
        for(var y = 0, j = 1, s0, m, n; j < m; ++j){
            for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
                var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
                for(var k = 0; k < i; ++k){
                    var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                    s3 += skj0 - skj1;
                }
                s1 += sij0, s2 += s3 * sij0;
            }
            s0[j - 1][1] += s0[j - 1][0] = y;
            if (s1) y -= s2 / s1;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"BSEuE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ahopc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var peaks = series.map(peak);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return peaks[a] - peaks[b];
        });
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"./none.js":"heTyv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"amYoy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var sums = series.map(sum);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return sums[a] - sums[b];
        });
    });
parcelHelpers.export(exports, "sum", ()=>sum);
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"./none.js":"heTyv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5TXuD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        return (0, _ascendingJsDefault.default)(series).reverse();
    });
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);

},{"./ascending.js":"amYoy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"21iWT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var n = series.length, i, j, sums = series.map((0, _ascendingJs.sum)), order = (0, _appearanceJsDefault.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
        for(i = 0; i < n; ++i){
            j = order[i];
            if (top < bottom) {
                top += sums[j];
                tops.push(j);
            } else {
                bottom += sums[j];
                bottoms.push(j);
            }
        }
        return bottoms.reverse().concat(tops);
    });
var _appearanceJs = require("./appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./ascending.js");

},{"./appearance.js":"ahopc","./ascending.js":"amYoy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1cGWN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        return (0, _noneJsDefault.default)(series).reverse();
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"heTyv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f4ldt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "zoomTransform", ()=>(0, _transformJsDefault.default));
parcelHelpers.export(exports, "zoomIdentity", ()=>(0, _transformJs.identity));
parcelHelpers.export(exports, "ZoomTransform", ()=>(0, _transformJs.Transform));
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./zoom.js":"3Bcfd","./transform.js":"2cbzE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Bcfd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, extent = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [
            0,
            Infinity
        ], translateExtent = [
            [
                -Infinity,
                -Infinity
            ],
            [
                Infinity,
                Infinity
            ]
        ], duration = 250, interpolate = (0, _d3Interpolate.interpolateZoom), listeners = (0, _d3Dispatch.dispatch)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
        function zoom(selection) {
            selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled, {
                passive: false
            }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        zoom.transform = function(collection, transform, point, event) {
            var selection = collection.selection ? collection.selection() : collection;
            selection.property("__zoom", defaultTransform);
            if (collection !== selection) schedule(collection, transform, point, event);
            else selection.interrupt().each(function() {
                gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
            });
        };
        zoom.scaleBy = function(selection, k, p, event) {
            zoom.scaleTo(selection, function() {
                var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return k0 * k1;
            }, p, event);
        };
        zoom.scaleTo = function(selection, k, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
            }, p, event);
        };
        zoom.translateBy = function(selection, x, y, event) {
            zoom.transform(selection, function() {
                return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
            }, null, event);
        };
        zoom.translateTo = function(selection, x, y, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
                return constrain((0, _transformJs.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
            }, p, event);
        };
        function scale(transform, k) {
            k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
            return k === transform.k ? transform : new (0, _transformJs.Transform)(k, transform.x, transform.y);
        }
        function translate(transform, p0, p1) {
            var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
            return x === transform.x && y === transform.y ? transform : new (0, _transformJs.Transform)(transform.k, x, y);
        }
        function centroid(extent) {
            return [
                (+extent[0][0] + +extent[1][0]) / 2,
                (+extent[0][1] + +extent[1][1]) / 2
            ];
        }
        function schedule(transition, transform, point, event) {
            transition.on("start.zoom", function() {
                gesture(this, arguments).event(event).start();
            }).on("interrupt.zoom end.zoom", function() {
                gesture(this, arguments).event(event).end();
            }).tween("zoom", function() {
                var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
                return function(t) {
                    if (t === 1) t = b; // Avoid rounding error on end.
                    else {
                        var l = i(t), k = w / l[2];
                        t = new (0, _transformJs.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                    }
                    g.zoom(null, t);
                };
            });
        }
        function gesture(that, args, clean) {
            return !clean && that.__zooming || new Gesture(that, args);
        }
        function Gesture(that, args) {
            this.that = that;
            this.args = args;
            this.active = 0;
            this.sourceEvent = null;
            this.extent = extent.apply(that, args);
            this.taps = 0;
        }
        Gesture.prototype = {
            event: function(event) {
                if (event) this.sourceEvent = event;
                return this;
            },
            start: function() {
                if (++this.active === 1) {
                    this.that.__zooming = this;
                    this.emit("start");
                }
                return this;
            },
            zoom: function(key, transform) {
                if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
                if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
                if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
                this.that.__zoom = transform;
                this.emit("zoom");
                return this;
            },
            end: function() {
                if (--this.active === 0) {
                    delete this.that.__zooming;
                    this.emit("end");
                }
                return this;
            },
            emit: function(type) {
                var d = (0, _d3Selection.select)(this.that).datum();
                listeners.call(type, this.that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: this.sourceEvent,
                    target: zoom,
                    type,
                    transform: this.that.__zoom,
                    dispatch: listeners
                }), d);
            }
        };
        function wheeled(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, _d3Selection.pointer)(event);
            // If the mouse is in the same location as before, reuse it.
            // If there were recent wheel events, reset the wheel idle timeout.
            if (g.wheel) {
                if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
                clearTimeout(g.wheel);
            } else if (t.k === k) return;
            else {
                g.mouse = [
                    p,
                    t.invert(p)
                ];
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
            (0, _noeventJsDefault.default)(event);
            g.wheel = setTimeout(wheelidled, wheelDelay);
            g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
            function wheelidled() {
                g.wheel = null;
                g.end();
            }
        }
        function mousedowned(event, ...args) {
            if (touchending || !filter.apply(this, arguments)) return;
            var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, _d3Selection.select)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, _d3Selection.pointer)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
            (0, _d3Drag.dragDisable)(event.view);
            (0, _noeventJs.nopropagation)(event);
            g.mouse = [
                p,
                this.__zoom.invert(p)
            ];
            (0, _d3Transition.interrupt)(this);
            g.start();
            function mousemoved(event) {
                (0, _noeventJsDefault.default)(event);
                if (!g.moved) {
                    var dx = event.clientX - x0, dy = event.clientY - y0;
                    g.moved = dx * dx + dy * dy > clickDistance2;
                }
                g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, _d3Selection.pointer)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
            }
            function mouseupped(event) {
                v.on("mousemove.zoom mouseup.zoom", null);
                (0, _d3Drag.dragEnable)(event.view, g.moved);
                (0, _noeventJsDefault.default)(event);
                g.event(event).end();
            }
        }
        function dblclicked(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var t0 = this.__zoom, p0 = (0, _d3Selection.pointer)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
            (0, _noeventJsDefault.default)(event);
            if (duration > 0) (0, _d3Selection.select)(this).transition().duration(duration).call(schedule, t1, p0, event);
            else (0, _d3Selection.select)(this).call(zoom.transform, t1, p0, event);
        }
        function touchstarted(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
            (0, _noeventJs.nopropagation)(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.pointer)(t, this);
                p = [
                    p,
                    this.__zoom.invert(p),
                    t.identifier
                ];
                if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
                else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
            }
            if (touchstarting) touchstarting = clearTimeout(touchstarting);
            if (started) {
                if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                    touchstarting = null;
                }, touchDelay);
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
        }
        function touchmoved(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
            (0, _noeventJsDefault.default)(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.pointer)(t, this);
                if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
                else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
            }
            t = g.that.__zoom;
            if (g.touch1) {
                var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
                t = scale(t, Math.sqrt(dp / dl));
                p = [
                    (p0[0] + p1[0]) / 2,
                    (p0[1] + p1[1]) / 2
                ];
                l = [
                    (l0[0] + l1[0]) / 2,
                    (l0[1] + l1[1]) / 2
                ];
            } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
            else return;
            g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
        }
        function touchended(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
            (0, _noeventJs.nopropagation)(event);
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, touchDelay);
            for(i = 0; i < n; ++i){
                t = touches[i];
                if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
                else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
            }
            if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
            if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
            else {
                g.end();
                // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
                if (g.taps === 2) {
                    t = (0, _d3Selection.pointer)(t, this);
                    if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                        var p = (0, _d3Selection.select)(this).on("dblclick.zoom");
                        if (p) p.apply(this, arguments);
                    }
                }
            }
        }
        zoom.wheelDelta = function(_) {
            return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), zoom) : wheelDelta;
        };
        zoom.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : filter;
        };
        zoom.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : touchable;
        };
        zoom.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                [
                    +_[0][0],
                    +_[0][1]
                ],
                [
                    +_[1][0],
                    +_[1][1]
                ]
            ]), zoom) : extent;
        };
        zoom.scaleExtent = function(_) {
            return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
                scaleExtent[0],
                scaleExtent[1]
            ];
        };
        zoom.translateExtent = function(_) {
            return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
                [
                    translateExtent[0][0],
                    translateExtent[0][1]
                ],
                [
                    translateExtent[1][0],
                    translateExtent[1][1]
                ]
            ];
        };
        zoom.constrain = function(_) {
            return arguments.length ? (constrain = _, zoom) : constrain;
        };
        zoom.duration = function(_) {
            return arguments.length ? (duration = +_, zoom) : duration;
        };
        zoom.interpolate = function(_) {
            return arguments.length ? (interpolate = _, zoom) : interpolate;
        };
        zoom.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? zoom : value;
        };
        zoom.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
        };
        zoom.tapDistance = function(_) {
            return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
        };
        return zoom;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Drag = require("d3-drag");
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _d3Transition = require("d3-transition");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _transformJs = require("./transform.js");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function defaultTransform() {
    return this.__zoom || (0, _transformJs.identity);
}
function defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}

},{"d3-dispatch":"3OarL","d3-drag":"8wlzb","d3-interpolate":"6bUMz","d3-selection":"4X1qO","d3-transition":"22YTW","./constant.js":"bzTxM","./event.js":"2PWZt","./transform.js":"2cbzE","./noevent.js":"hgGve","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzTxM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2PWZt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ZoomEvent);
function ZoomEvent(type, { sourceEvent, target, transform, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2cbzE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transform", ()=>Transform);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>transform);
function Transform(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
Transform.prototype = {
    constructor: Transform,
    scale: function(k) {
        return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var identity = new Transform(1, 0, 0);
transform.prototype = Transform.prototype;
function transform(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return identity;
    return node.__zoom;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hgGve":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5cPaM":[function(require,module,exports,__globalThis) {
/*! @license DOMPurify 3.1.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.6/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    const { entries, setPrototypeOf, isFrozen, getPrototypeOf, getOwnPropertyDescriptor } = Object;
    let { freeze, seal, create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply, construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param {Function} func - The function to be wrapped and called.
   * @returns {Function} A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param {Function} func - The constructor function to be wrapped and called.
   * @returns {Function} A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param {Object} set - The set to which elements will be added.
   * @param {Array} array - The array containing elements to be added to the set.
   * @param {Function} transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns {Object} The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param {Array} array - The array to be cleaned.
   * @returns {Array} The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param {Object} object - The object to be cloned.
   * @returns {Object} A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param {Object} object - The object to look up the getter function in its prototype chain.
   * @param {String} prop - The property name for which to find the getter function.
   * @returns {Function} The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        ERB_EXPR: ERB_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR,
        DATA_ATTR: DATA_ATTR,
        ARIA_ATTR: ARIA_ATTR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        DOCTYPE_NAME: DOCTYPE_NAME,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT
    });
    // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {HTMLScriptElement} purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return {TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '3.1.6';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment, HTMLTemplateElement, Node, Element, NodeFilter, NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement, DOMParser, trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation, createNodeIterator, createDocumentFragment, getElementsByTagName } = document;
        const { importNode } = originalDocument;
        let hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR, DATA_ATTR, ARIA_ATTR, IS_SCRIPT_OR_DATA, ATTR_WHITESPACE, CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        const MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        const HTML_INTEGRATION_POINTS = addToSet({}, [
            'foreignobject',
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ const _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param  {Node} root The root element or node to start traversing on.
     * @return {NodeIterator} The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param  {Node} object object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ const _isNode = function _isNode(object) {
            return typeof Node === 'function' && object instanceof Node;
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ const _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param {string} tagName name of the tag of the node to sanitize
     * @returns {boolean} Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            const { attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name, namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === 'value' ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} cfg object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {String} tag Tag name of containing element.
     * @param  {String} attr Attribute name.
     * @param  {String} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

},{}],"kb6Zw":[function(require,module,exports,__globalThis) {
/* EXPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./methods/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"./methods/index.js":"8tLXp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8tLXp":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* EXPORT */ parcelHelpers.export(exports, "hex", ()=>/* CREATE */ (0, _rgbaJsDefault.default));
parcelHelpers.export(exports, "rgb", ()=>(0, _rgbaJsDefault.default));
parcelHelpers.export(exports, "rgba", ()=>(0, _rgbaJsDefault.default));
parcelHelpers.export(exports, "hsl", ()=>(0, _hslaJsDefault.default));
parcelHelpers.export(exports, "hsla", ()=>(0, _hslaJsDefault.default));
parcelHelpers.export(exports, "toKeyword", ()=>/* CONVERT */ (0, _toKeywordJsDefault.default));
parcelHelpers.export(exports, "toHex", ()=>(0, _toHexJsDefault.default));
parcelHelpers.export(exports, "toRgba", ()=>(0, _toRgbaJsDefault.default));
parcelHelpers.export(exports, "toHsla", ()=>(0, _toHslaJsDefault.default));
parcelHelpers.export(exports, "channel", ()=>/* GET - CHANNEL */ (0, _channelJsDefault.default));
parcelHelpers.export(exports, "red", ()=>(0, _redJsDefault.default));
parcelHelpers.export(exports, "green", ()=>(0, _greenJsDefault.default));
parcelHelpers.export(exports, "blue", ()=>(0, _blueJsDefault.default));
parcelHelpers.export(exports, "hue", ()=>(0, _hueJsDefault.default));
parcelHelpers.export(exports, "saturation", ()=>(0, _saturationJsDefault.default));
parcelHelpers.export(exports, "lightness", ()=>(0, _lightnessJsDefault.default));
parcelHelpers.export(exports, "alpha", ()=>(0, _alphaJsDefault.default));
parcelHelpers.export(exports, "opacity", ()=>(0, _alphaJsDefault.default));
parcelHelpers.export(exports, "contrast", ()=>/* GET - MORE */ (0, _contrastJsDefault.default));
parcelHelpers.export(exports, "luminance", ()=>(0, _luminanceJsDefault.default));
parcelHelpers.export(exports, "isDark", ()=>(0, _isDarkJsDefault.default));
parcelHelpers.export(exports, "isLight", ()=>(0, _isLightJsDefault.default));
parcelHelpers.export(exports, "isTransparent", ()=>(0, _isTransparentJsDefault.default));
parcelHelpers.export(exports, "isValid", ()=>(0, _isValidJsDefault.default));
parcelHelpers.export(exports, "saturate", ()=>/* EDIT - CHANNEL */ (0, _saturateJsDefault.default));
parcelHelpers.export(exports, "desaturate", ()=>(0, _desaturateJsDefault.default));
parcelHelpers.export(exports, "lighten", ()=>(0, _lightenJsDefault.default));
parcelHelpers.export(exports, "darken", ()=>(0, _darkenJsDefault.default));
parcelHelpers.export(exports, "opacify", ()=>(0, _opacifyJsDefault.default));
parcelHelpers.export(exports, "fadeIn", ()=>(0, _opacifyJsDefault.default));
parcelHelpers.export(exports, "transparentize", ()=>(0, _transparentizeJsDefault.default));
parcelHelpers.export(exports, "fadeOut", ()=>(0, _transparentizeJsDefault.default));
parcelHelpers.export(exports, "complement", ()=>(0, _complementJsDefault.default));
parcelHelpers.export(exports, "grayscale", ()=>(0, _grayscaleJsDefault.default));
parcelHelpers.export(exports, "adjust", ()=>/* EDIT - MORE */ (0, _adjustJsDefault.default));
parcelHelpers.export(exports, "change", ()=>(0, _changeJsDefault.default));
parcelHelpers.export(exports, "invert", ()=>(0, _invertJsDefault.default));
parcelHelpers.export(exports, "mix", ()=>(0, _mixJsDefault.default));
parcelHelpers.export(exports, "scale", ()=>(0, _scaleJsDefault.default));
var _rgbaJs = require("./rgba.js"); // Alias
var _rgbaJsDefault = parcelHelpers.interopDefault(_rgbaJs);
var _hslaJs = require("./hsla.js"); // Alias
var _hslaJsDefault = parcelHelpers.interopDefault(_hslaJs);
var _toKeywordJs = require("./to_keyword.js");
var _toKeywordJsDefault = parcelHelpers.interopDefault(_toKeywordJs);
var _toHexJs = require("./to_hex.js");
var _toHexJsDefault = parcelHelpers.interopDefault(_toHexJs);
var _toRgbaJs = require("./to_rgba.js");
var _toRgbaJsDefault = parcelHelpers.interopDefault(_toRgbaJs);
var _toHslaJs = require("./to_hsla.js");
var _toHslaJsDefault = parcelHelpers.interopDefault(_toHslaJs);
var _channelJs = require("./channel.js");
var _channelJsDefault = parcelHelpers.interopDefault(_channelJs);
var _redJs = require("./red.js");
var _redJsDefault = parcelHelpers.interopDefault(_redJs);
var _greenJs = require("./green.js");
var _greenJsDefault = parcelHelpers.interopDefault(_greenJs);
var _blueJs = require("./blue.js");
var _blueJsDefault = parcelHelpers.interopDefault(_blueJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _saturationJs = require("./saturation.js");
var _saturationJsDefault = parcelHelpers.interopDefault(_saturationJs);
var _lightnessJs = require("./lightness.js");
var _lightnessJsDefault = parcelHelpers.interopDefault(_lightnessJs);
var _alphaJs = require("./alpha.js");
var _alphaJsDefault = parcelHelpers.interopDefault(_alphaJs);
var _contrastJs = require("./contrast.js");
var _contrastJsDefault = parcelHelpers.interopDefault(_contrastJs);
var _luminanceJs = require("./luminance.js");
var _luminanceJsDefault = parcelHelpers.interopDefault(_luminanceJs);
var _isDarkJs = require("./is_dark.js");
var _isDarkJsDefault = parcelHelpers.interopDefault(_isDarkJs);
var _isLightJs = require("./is_light.js");
var _isLightJsDefault = parcelHelpers.interopDefault(_isLightJs);
var _isTransparentJs = require("./is_transparent.js");
var _isTransparentJsDefault = parcelHelpers.interopDefault(_isTransparentJs);
var _isValidJs = require("./is_valid.js");
var _isValidJsDefault = parcelHelpers.interopDefault(_isValidJs);
var _saturateJs = require("./saturate.js");
var _saturateJsDefault = parcelHelpers.interopDefault(_saturateJs);
var _desaturateJs = require("./desaturate.js");
var _desaturateJsDefault = parcelHelpers.interopDefault(_desaturateJs);
var _lightenJs = require("./lighten.js");
var _lightenJsDefault = parcelHelpers.interopDefault(_lightenJs);
var _darkenJs = require("./darken.js");
var _darkenJsDefault = parcelHelpers.interopDefault(_darkenJs);
var _opacifyJs = require("./opacify.js");
var _opacifyJsDefault = parcelHelpers.interopDefault(_opacifyJs);
var _transparentizeJs = require("./transparentize.js");
var _transparentizeJsDefault = parcelHelpers.interopDefault(_transparentizeJs);
var _complementJs = require("./complement.js");
var _complementJsDefault = parcelHelpers.interopDefault(_complementJs);
var _grayscaleJs = require("./grayscale.js");
var _grayscaleJsDefault = parcelHelpers.interopDefault(_grayscaleJs);
var _adjustJs = require("./adjust.js");
var _adjustJsDefault = parcelHelpers.interopDefault(_adjustJs);
var _changeJs = require("./change.js");
var _changeJsDefault = parcelHelpers.interopDefault(_changeJs);
var _invertJs = require("./invert.js");
var _invertJsDefault = parcelHelpers.interopDefault(_invertJs);
var _mixJs = require("./mix.js");
var _mixJsDefault = parcelHelpers.interopDefault(_mixJs);
var _scaleJs = require("./scale.js");
var _scaleJsDefault = parcelHelpers.interopDefault(_scaleJs);

},{"./rgba.js":"dvW2J","./hsla.js":"h3EQY","./to_keyword.js":"4ZtG0","./to_hex.js":"8e6kP","./to_rgba.js":"ly1C3","./to_hsla.js":"iOUBF","./channel.js":"9QwKN","./red.js":"5JmJZ","./green.js":"aF52R","./blue.js":"1v13q","./hue.js":"l3HdP","./saturation.js":"2nE02","./lightness.js":"cmWva","./alpha.js":"gGLW3","./contrast.js":"hvmzT","./luminance.js":"ckIa5","./is_dark.js":"aQqmA","./is_light.js":"2dGSi","./is_transparent.js":"lvVtq","./is_valid.js":"jF4RP","./saturate.js":"3ySUB","./desaturate.js":"24Kwt","./lighten.js":"aiypm","./darken.js":"cAup7","./opacify.js":"i0G8R","./transparentize.js":"29aVb","./complement.js":"bYjm9","./grayscale.js":"bevWV","./adjust.js":"fEbxT","./change.js":"j72hU","./invert.js":"6o6GH","./mix.js":"4wN8Y","./scale.js":"2EGTj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dvW2J":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _reusableJs = require("../channels/reusable.js");
var _reusableJsDefault = parcelHelpers.interopDefault(_reusableJs);
var _indexJs1 = require("../color/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _changeJs = require("./change.js");
var _changeJsDefault = parcelHelpers.interopDefault(_changeJs);
/* MAIN */ const rgba = (r, g, b = 0, a = 1)=>{
    if (typeof r !== 'number') return (0, _changeJsDefault.default)(r, {
        a: g
    });
    const channels = (0, _reusableJsDefault.default).set({
        r: (0, _indexJsDefault.default).channel.clamp.r(r),
        g: (0, _indexJsDefault.default).channel.clamp.g(g),
        b: (0, _indexJsDefault.default).channel.clamp.b(b),
        a: (0, _indexJsDefault.default).channel.clamp.a(a)
    });
    return (0, _indexJsDefault1.default).stringify(channels);
};
/* EXPORT */ exports.default = rgba;

},{"../utils/index.js":"hWnJo","../channels/reusable.js":"e3gx3","../color/index.js":"1ZzEz","./change.js":"j72hU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hWnJo":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _channelJs = require("./channel.js");
var _channelJsDefault = parcelHelpers.interopDefault(_channelJs);
var _langJs = require("./lang.js");
var _langJsDefault = parcelHelpers.interopDefault(_langJs);
var _unitJs = require("./unit.js");
var _unitJsDefault = parcelHelpers.interopDefault(_unitJs);
/* MAIN */ const Utils = {
    channel: (0, _channelJsDefault.default),
    lang: (0, _langJsDefault.default),
    unit: (0, _unitJsDefault.default)
};
/* EXPORT */ exports.default = Utils;

},{"./channel.js":"6zfnW","./lang.js":"5wLoA","./unit.js":"9V4by","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6zfnW":[function(require,module,exports,__globalThis) {
/* IMPORT */ /* MAIN */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const Channel = {
    /* CLAMP */ min: {
        r: 0,
        g: 0,
        b: 0,
        s: 0,
        l: 0,
        a: 0
    },
    max: {
        r: 255,
        g: 255,
        b: 255,
        h: 360,
        s: 100,
        l: 100,
        a: 1
    },
    clamp: {
        r: (r)=>r >= 255 ? 255 : r < 0 ? 0 : r,
        g: (g)=>g >= 255 ? 255 : g < 0 ? 0 : g,
        b: (b)=>b >= 255 ? 255 : b < 0 ? 0 : b,
        h: (h)=>h % 360,
        s: (s)=>s >= 100 ? 100 : s < 0 ? 0 : s,
        l: (l)=>l >= 100 ? 100 : l < 0 ? 0 : l,
        a: (a)=>a >= 1 ? 1 : a < 0 ? 0 : a
    },
    /* CONVERSION */ //SOURCE: https://planetcalc.com/7779
    toLinear: (c)=>{
        const n = c / 255;
        return c > .03928 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92;
    },
    //SOURCE: https://gist.github.com/mjackson/5311256
    hue2rgb: (p, q, t)=>{
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    },
    hsl2rgb: ({ h, s, l }, channel)=>{
        if (!s) return l * 2.55; // Achromatic
        h /= 360;
        s /= 100;
        l /= 100;
        const q = l < .5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        switch(channel){
            case 'r':
                return Channel.hue2rgb(p, q, h + 1 / 3) * 255;
            case 'g':
                return Channel.hue2rgb(p, q, h) * 255;
            case 'b':
                return Channel.hue2rgb(p, q, h - 1 / 3) * 255;
        }
    },
    rgb2hsl: ({ r, g, b }, channel)=>{
        r /= 255;
        g /= 255;
        b /= 255;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const l = (max + min) / 2;
        if (channel === 'l') return l * 100;
        if (max === min) return 0; // Achromatic
        const d = max - min;
        const s = l > .5 ? d / (2 - max - min) : d / (max + min);
        if (channel === 's') return s * 100;
        switch(max){
            case r:
                return ((g - b) / d + (g < b ? 6 : 0)) * 60;
            case g:
                return ((b - r) / d + 2) * 60;
            case b:
                return ((r - g) / d + 4) * 60;
            default:
                return -1; //TSC: TypeScript is stupid and complains if there isn't this useless default statement
        }
    }
};
/* EXPORT */ exports.default = Channel;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5wLoA":[function(require,module,exports,__globalThis) {
/* MAIN */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const Lang = {
    /* API */ clamp: (number, lower, upper)=>{
        if (lower > upper) return Math.min(lower, Math.max(upper, number));
        return Math.min(upper, Math.max(lower, number));
    },
    round: (number)=>{
        return Math.round(number * 10000000000) / 10000000000;
    }
};
/* EXPORT */ exports.default = Lang;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9V4by":[function(require,module,exports,__globalThis) {
/* MAIN */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const Unit = {
    /* API */ dec2hex: (dec)=>{
        const hex = Math.round(dec).toString(16);
        return hex.length > 1 ? hex : `0${hex}`;
    }
};
/* EXPORT */ exports.default = Unit;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e3gx3":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require(".//index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/* MAIN */ const channels = new (0, _indexJsDefault.default)({
    r: 0,
    g: 0,
    b: 0,
    a: 0
}, 'transparent');
/* EXPORT */ exports.default = channels;

},{".//index.js":"tNDxv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"tNDxv":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _typeJs = require("./type.js");
var _typeJsDefault = parcelHelpers.interopDefault(_typeJs);
var _constantsJs = require("../constants.js");
/* MAIN */ class Channels {
    /* CONSTRUCTOR */ constructor(data, color){
        this.color = color;
        this.changed = false;
        this.data = data; //TSC
        this.type = new (0, _typeJsDefault.default)();
    }
    /* API */ set(data, color) {
        this.color = color;
        this.changed = false;
        this.data = data; //TSC
        this.type.type = (0, _constantsJs.TYPE).ALL;
        return this;
    }
    /* HELPERS */ _ensureHSL() {
        const data = this.data;
        const { h, s, l } = data;
        if (h === undefined) data.h = (0, _indexJsDefault.default).channel.rgb2hsl(data, 'h');
        if (s === undefined) data.s = (0, _indexJsDefault.default).channel.rgb2hsl(data, 's');
        if (l === undefined) data.l = (0, _indexJsDefault.default).channel.rgb2hsl(data, 'l');
    }
    _ensureRGB() {
        const data = this.data;
        const { r, g, b } = data;
        if (r === undefined) data.r = (0, _indexJsDefault.default).channel.hsl2rgb(data, 'r');
        if (g === undefined) data.g = (0, _indexJsDefault.default).channel.hsl2rgb(data, 'g');
        if (b === undefined) data.b = (0, _indexJsDefault.default).channel.hsl2rgb(data, 'b');
    }
    /* GETTERS */ get r() {
        const data = this.data;
        const r = data.r;
        if (!this.type.is((0, _constantsJs.TYPE).HSL) && r !== undefined) return r;
        this._ensureHSL();
        return (0, _indexJsDefault.default).channel.hsl2rgb(data, 'r');
    }
    get g() {
        const data = this.data;
        const g = data.g;
        if (!this.type.is((0, _constantsJs.TYPE).HSL) && g !== undefined) return g;
        this._ensureHSL();
        return (0, _indexJsDefault.default).channel.hsl2rgb(data, 'g');
    }
    get b() {
        const data = this.data;
        const b = data.b;
        if (!this.type.is((0, _constantsJs.TYPE).HSL) && b !== undefined) return b;
        this._ensureHSL();
        return (0, _indexJsDefault.default).channel.hsl2rgb(data, 'b');
    }
    get h() {
        const data = this.data;
        const h = data.h;
        if (!this.type.is((0, _constantsJs.TYPE).RGB) && h !== undefined) return h;
        this._ensureRGB();
        return (0, _indexJsDefault.default).channel.rgb2hsl(data, 'h');
    }
    get s() {
        const data = this.data;
        const s = data.s;
        if (!this.type.is((0, _constantsJs.TYPE).RGB) && s !== undefined) return s;
        this._ensureRGB();
        return (0, _indexJsDefault.default).channel.rgb2hsl(data, 's');
    }
    get l() {
        const data = this.data;
        const l = data.l;
        if (!this.type.is((0, _constantsJs.TYPE).RGB) && l !== undefined) return l;
        this._ensureRGB();
        return (0, _indexJsDefault.default).channel.rgb2hsl(data, 'l');
    }
    get a() {
        return this.data.a;
    }
    /* SETTERS */ set r(r) {
        this.type.set((0, _constantsJs.TYPE).RGB);
        this.changed = true;
        this.data.r = r;
    }
    set g(g) {
        this.type.set((0, _constantsJs.TYPE).RGB);
        this.changed = true;
        this.data.g = g;
    }
    set b(b) {
        this.type.set((0, _constantsJs.TYPE).RGB);
        this.changed = true;
        this.data.b = b;
    }
    set h(h) {
        this.type.set((0, _constantsJs.TYPE).HSL);
        this.changed = true;
        this.data.h = h;
    }
    set s(s) {
        this.type.set((0, _constantsJs.TYPE).HSL);
        this.changed = true;
        this.data.s = s;
    }
    set l(l) {
        this.type.set((0, _constantsJs.TYPE).HSL);
        this.changed = true;
        this.data.l = l;
    }
    set a(a) {
        this.changed = true;
        this.data.a = a;
    }
}
/* EXPORT */ exports.default = Channels;

},{"../utils/index.js":"hWnJo","./type.js":"7SrsY","../constants.js":"7aKH5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7SrsY":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constantsJs = require("../constants.js");
/* MAIN */ class Type {
    constructor(){
        /* VARIABLES */ this.type = (0, _constantsJs.TYPE).ALL;
    }
    /* API */ get() {
        return this.type;
    }
    set(type) {
        if (this.type && this.type !== type) throw new Error('Cannot change both RGB and HSL channels at the same time');
        this.type = type;
    }
    reset() {
        this.type = (0, _constantsJs.TYPE).ALL;
    }
    is(type) {
        return this.type === type;
    }
}
/* EXPORT */ exports.default = Type;

},{"../constants.js":"7aKH5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7aKH5":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* EXPORT */ parcelHelpers.export(exports, "DEC2HEX", ()=>DEC2HEX);
parcelHelpers.export(exports, "TYPE", ()=>TYPE);
var _indexJs = require("./utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/* MAIN */ const DEC2HEX = {};
for(let i = 0; i <= 255; i++)DEC2HEX[i] = (0, _indexJsDefault.default).unit.dec2hex(i); // Populating dynamically, striking a balance between code size and performance
const TYPE = {
    ALL: 0,
    RGB: 1,
    HSL: 2
};

},{"./utils/index.js":"hWnJo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ZzEz":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _hexJs = require("./hex.js");
var _hexJsDefault = parcelHelpers.interopDefault(_hexJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _keywordJs = require("./keyword.js");
var _keywordJsDefault = parcelHelpers.interopDefault(_keywordJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _constantsJs = require("../constants.js");
/* MAIN */ const Color = {
    /* VARIABLES */ format: {
        keyword: (0, _keywordJsDefault.default),
        hex: (0, _hexJsDefault.default),
        rgb: (0, _rgbJsDefault.default),
        rgba: (0, _rgbJsDefault.default),
        hsl: (0, _hslJsDefault.default),
        hsla: (0, _hslJsDefault.default)
    },
    /* API */ parse: (color)=>{
        if (typeof color !== 'string') return color;
        const channels = (0, _hexJsDefault.default).parse(color) || (0, _rgbJsDefault.default).parse(color) || (0, _hslJsDefault.default).parse(color) || (0, _keywordJsDefault.default).parse(color); // Color providers ordered with performance in mind
        if (channels) return channels;
        throw new Error(`Unsupported color format: "${color}"`);
    },
    stringify: (channels)=>{
        // SASS returns a keyword if possible, but we avoid doing that as it's slower and doesn't really add any value
        if (!channels.changed && channels.color) return channels.color;
        if (channels.type.is((0, _constantsJs.TYPE).HSL) || channels.data.r === undefined) return (0, _hslJsDefault.default).stringify(channels);
        else if (channels.a < 1 || !Number.isInteger(channels.r) || !Number.isInteger(channels.g) || !Number.isInteger(channels.b)) return (0, _rgbJsDefault.default).stringify(channels);
        else return (0, _hexJsDefault.default).stringify(channels);
    }
};
/* EXPORT */ exports.default = Color;

},{"../utils/index.js":"hWnJo","./hex.js":"epCtZ","./hsl.js":"8IWii","./keyword.js":"7890M","./rgb.js":"XI059","../constants.js":"7aKH5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"epCtZ":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _reusableJs = require("../channels/reusable.js");
var _reusableJsDefault = parcelHelpers.interopDefault(_reusableJs);
var _constantsJs = require("../constants.js");
/* MAIN */ const Hex = {
    /* VARIABLES */ re: /^#((?:[a-f0-9]{2}){2,4}|[a-f0-9]{3})$/i,
    /* API */ parse: (color)=>{
        if (color.charCodeAt(0) !== 35) return; // '#'
        const match = color.match(Hex.re);
        if (!match) return;
        const hex = match[1];
        const dec = parseInt(hex, 16);
        const length = hex.length;
        const hasAlpha = length % 4 === 0;
        const isFullLength = length > 4;
        const multiplier = isFullLength ? 1 : 17;
        const bits = isFullLength ? 8 : 4;
        const bitsOffset = hasAlpha ? 0 : -1;
        const mask = isFullLength ? 255 : 15;
        return (0, _reusableJsDefault.default).set({
            r: (dec >> bits * (bitsOffset + 3) & mask) * multiplier,
            g: (dec >> bits * (bitsOffset + 2) & mask) * multiplier,
            b: (dec >> bits * (bitsOffset + 1) & mask) * multiplier,
            a: hasAlpha ? (dec & mask) * multiplier / 255 : 1
        }, color);
    },
    stringify: (channels)=>{
        const { r, g, b, a } = channels;
        if (a < 1) return `#${(0, _constantsJs.DEC2HEX)[Math.round(r)]}${(0, _constantsJs.DEC2HEX)[Math.round(g)]}${(0, _constantsJs.DEC2HEX)[Math.round(b)]}${(0, _constantsJs.DEC2HEX)[Math.round(a * 255)]}`;
        else return `#${(0, _constantsJs.DEC2HEX)[Math.round(r)]}${(0, _constantsJs.DEC2HEX)[Math.round(g)]}${(0, _constantsJs.DEC2HEX)[Math.round(b)]}`;
    }
};
/* EXPORT */ exports.default = Hex;

},{"../utils/index.js":"hWnJo","../channels/reusable.js":"e3gx3","../constants.js":"7aKH5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8IWii":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _reusableJs = require("../channels/reusable.js");
var _reusableJsDefault = parcelHelpers.interopDefault(_reusableJs);
/* MAIN */ const HSL = {
    /* VARIABLES */ re: /^hsla?\(\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?(?:deg|grad|rad|turn)?)\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?%)\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?%)(?:\s*?(?:,|\/)\s*?\+?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?(%)?))?\s*?\)$/i,
    hueRe: /^(.+?)(deg|grad|rad|turn)$/i,
    /* HELPERS */ _hue2deg: (hue)=>{
        const match = hue.match(HSL.hueRe);
        if (match) {
            const [, number, unit] = match;
            switch(unit){
                case 'grad':
                    return (0, _indexJsDefault.default).channel.clamp.h(parseFloat(number) * .9);
                case 'rad':
                    return (0, _indexJsDefault.default).channel.clamp.h(parseFloat(number) * 180 / Math.PI);
                case 'turn':
                    return (0, _indexJsDefault.default).channel.clamp.h(parseFloat(number) * 360);
            }
        }
        return (0, _indexJsDefault.default).channel.clamp.h(parseFloat(hue));
    },
    /* API */ parse: (color)=>{
        const charCode = color.charCodeAt(0);
        if (charCode !== 104 && charCode !== 72) return; // 'h'/'H'
        const match = color.match(HSL.re);
        if (!match) return;
        const [, h, s, l, a, isAlphaPercentage] = match;
        return (0, _reusableJsDefault.default).set({
            h: HSL._hue2deg(h),
            s: (0, _indexJsDefault.default).channel.clamp.s(parseFloat(s)),
            l: (0, _indexJsDefault.default).channel.clamp.l(parseFloat(l)),
            a: a ? (0, _indexJsDefault.default).channel.clamp.a(isAlphaPercentage ? parseFloat(a) / 100 : parseFloat(a)) : 1
        }, color);
    },
    stringify: (channels)=>{
        const { h, s, l, a } = channels;
        if (a < 1) return `hsla(${(0, _indexJsDefault.default).lang.round(h)}, ${(0, _indexJsDefault.default).lang.round(s)}%, ${(0, _indexJsDefault.default).lang.round(l)}%, ${a})`;
        else return `hsl(${(0, _indexJsDefault.default).lang.round(h)}, ${(0, _indexJsDefault.default).lang.round(s)}%, ${(0, _indexJsDefault.default).lang.round(l)}%)`;
    }
};
/* EXPORT */ exports.default = HSL;

},{"../utils/index.js":"hWnJo","../channels/reusable.js":"e3gx3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7890M":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hexJs = require("./hex.js");
var _hexJsDefault = parcelHelpers.interopDefault(_hexJs);
/* MAIN */ const Keyword = {
    /* VARIABLES */ colors: {
        aliceblue: '#f0f8ff',
        antiquewhite: '#faebd7',
        aqua: '#00ffff',
        aquamarine: '#7fffd4',
        azure: '#f0ffff',
        beige: '#f5f5dc',
        bisque: '#ffe4c4',
        black: '#000000',
        blanchedalmond: '#ffebcd',
        blue: '#0000ff',
        blueviolet: '#8a2be2',
        brown: '#a52a2a',
        burlywood: '#deb887',
        cadetblue: '#5f9ea0',
        chartreuse: '#7fff00',
        chocolate: '#d2691e',
        coral: '#ff7f50',
        cornflowerblue: '#6495ed',
        cornsilk: '#fff8dc',
        crimson: '#dc143c',
        cyanaqua: '#00ffff',
        darkblue: '#00008b',
        darkcyan: '#008b8b',
        darkgoldenrod: '#b8860b',
        darkgray: '#a9a9a9',
        darkgreen: '#006400',
        darkgrey: '#a9a9a9',
        darkkhaki: '#bdb76b',
        darkmagenta: '#8b008b',
        darkolivegreen: '#556b2f',
        darkorange: '#ff8c00',
        darkorchid: '#9932cc',
        darkred: '#8b0000',
        darksalmon: '#e9967a',
        darkseagreen: '#8fbc8f',
        darkslateblue: '#483d8b',
        darkslategray: '#2f4f4f',
        darkslategrey: '#2f4f4f',
        darkturquoise: '#00ced1',
        darkviolet: '#9400d3',
        deeppink: '#ff1493',
        deepskyblue: '#00bfff',
        dimgray: '#696969',
        dimgrey: '#696969',
        dodgerblue: '#1e90ff',
        firebrick: '#b22222',
        floralwhite: '#fffaf0',
        forestgreen: '#228b22',
        fuchsia: '#ff00ff',
        gainsboro: '#dcdcdc',
        ghostwhite: '#f8f8ff',
        gold: '#ffd700',
        goldenrod: '#daa520',
        gray: '#808080',
        green: '#008000',
        greenyellow: '#adff2f',
        grey: '#808080',
        honeydew: '#f0fff0',
        hotpink: '#ff69b4',
        indianred: '#cd5c5c',
        indigo: '#4b0082',
        ivory: '#fffff0',
        khaki: '#f0e68c',
        lavender: '#e6e6fa',
        lavenderblush: '#fff0f5',
        lawngreen: '#7cfc00',
        lemonchiffon: '#fffacd',
        lightblue: '#add8e6',
        lightcoral: '#f08080',
        lightcyan: '#e0ffff',
        lightgoldenrodyellow: '#fafad2',
        lightgray: '#d3d3d3',
        lightgreen: '#90ee90',
        lightgrey: '#d3d3d3',
        lightpink: '#ffb6c1',
        lightsalmon: '#ffa07a',
        lightseagreen: '#20b2aa',
        lightskyblue: '#87cefa',
        lightslategray: '#778899',
        lightslategrey: '#778899',
        lightsteelblue: '#b0c4de',
        lightyellow: '#ffffe0',
        lime: '#00ff00',
        limegreen: '#32cd32',
        linen: '#faf0e6',
        magenta: '#ff00ff',
        maroon: '#800000',
        mediumaquamarine: '#66cdaa',
        mediumblue: '#0000cd',
        mediumorchid: '#ba55d3',
        mediumpurple: '#9370db',
        mediumseagreen: '#3cb371',
        mediumslateblue: '#7b68ee',
        mediumspringgreen: '#00fa9a',
        mediumturquoise: '#48d1cc',
        mediumvioletred: '#c71585',
        midnightblue: '#191970',
        mintcream: '#f5fffa',
        mistyrose: '#ffe4e1',
        moccasin: '#ffe4b5',
        navajowhite: '#ffdead',
        navy: '#000080',
        oldlace: '#fdf5e6',
        olive: '#808000',
        olivedrab: '#6b8e23',
        orange: '#ffa500',
        orangered: '#ff4500',
        orchid: '#da70d6',
        palegoldenrod: '#eee8aa',
        palegreen: '#98fb98',
        paleturquoise: '#afeeee',
        palevioletred: '#db7093',
        papayawhip: '#ffefd5',
        peachpuff: '#ffdab9',
        peru: '#cd853f',
        pink: '#ffc0cb',
        plum: '#dda0dd',
        powderblue: '#b0e0e6',
        purple: '#800080',
        rebeccapurple: '#663399',
        red: '#ff0000',
        rosybrown: '#bc8f8f',
        royalblue: '#4169e1',
        saddlebrown: '#8b4513',
        salmon: '#fa8072',
        sandybrown: '#f4a460',
        seagreen: '#2e8b57',
        seashell: '#fff5ee',
        sienna: '#a0522d',
        silver: '#c0c0c0',
        skyblue: '#87ceeb',
        slateblue: '#6a5acd',
        slategray: '#708090',
        slategrey: '#708090',
        snow: '#fffafa',
        springgreen: '#00ff7f',
        tan: '#d2b48c',
        teal: '#008080',
        thistle: '#d8bfd8',
        transparent: '#00000000',
        turquoise: '#40e0d0',
        violet: '#ee82ee',
        wheat: '#f5deb3',
        white: '#ffffff',
        whitesmoke: '#f5f5f5',
        yellow: '#ffff00',
        yellowgreen: '#9acd32'
    },
    /* API */ parse: (color)=>{
        color = color.toLowerCase();
        const hex = Keyword.colors[color];
        if (!hex) return;
        return (0, _hexJsDefault.default).parse(hex);
    },
    stringify: (channels)=>{
        const hex = (0, _hexJsDefault.default).stringify(channels);
        for(const name in Keyword.colors){
            if (Keyword.colors[name] === hex) return name;
        }
        return;
    }
};
/* EXPORT */ exports.default = Keyword;

},{"./hex.js":"epCtZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"XI059":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _reusableJs = require("../channels/reusable.js");
var _reusableJsDefault = parcelHelpers.interopDefault(_reusableJs);
/* MAIN */ const RGB = {
    /* VARIABLES */ re: /^rgba?\(\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?))\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?))\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?))(?:\s*?(?:,|\/)\s*?\+?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?)))?\s*?\)$/i,
    /* API */ parse: (color)=>{
        const charCode = color.charCodeAt(0);
        if (charCode !== 114 && charCode !== 82) return; // 'r'/'R'
        const match = color.match(RGB.re);
        if (!match) return;
        const [, r, isRedPercentage, g, isGreenPercentage, b, isBluePercentage, a, isAlphaPercentage] = match;
        return (0, _reusableJsDefault.default).set({
            r: (0, _indexJsDefault.default).channel.clamp.r(isRedPercentage ? parseFloat(r) * 2.55 : parseFloat(r)),
            g: (0, _indexJsDefault.default).channel.clamp.g(isGreenPercentage ? parseFloat(g) * 2.55 : parseFloat(g)),
            b: (0, _indexJsDefault.default).channel.clamp.b(isBluePercentage ? parseFloat(b) * 2.55 : parseFloat(b)),
            a: a ? (0, _indexJsDefault.default).channel.clamp.a(isAlphaPercentage ? parseFloat(a) / 100 : parseFloat(a)) : 1
        }, color);
    },
    stringify: (channels)=>{
        const { r, g, b, a } = channels;
        if (a < 1) return `rgba(${(0, _indexJsDefault.default).lang.round(r)}, ${(0, _indexJsDefault.default).lang.round(g)}, ${(0, _indexJsDefault.default).lang.round(b)}, ${(0, _indexJsDefault.default).lang.round(a)})`;
        else return `rgb(${(0, _indexJsDefault.default).lang.round(r)}, ${(0, _indexJsDefault.default).lang.round(g)}, ${(0, _indexJsDefault.default).lang.round(b)})`;
    }
};
/* EXPORT */ exports.default = RGB;

},{"../utils/index.js":"hWnJo","../channels/reusable.js":"e3gx3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j72hU":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../color/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
/* MAIN */ const change = (color, channels)=>{
    const ch = (0, _indexJsDefault1.default).parse(color);
    for(const c in channels)ch[c] = (0, _indexJsDefault.default).channel.clamp[c](channels[c]);
    return (0, _indexJsDefault1.default).stringify(ch);
};
/* EXPORT */ exports.default = change;

},{"../utils/index.js":"hWnJo","../color/index.js":"1ZzEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h3EQY":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _reusableJs = require("../channels/reusable.js");
var _reusableJsDefault = parcelHelpers.interopDefault(_reusableJs);
var _indexJs1 = require("../color/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
/* MAIN */ const hsla = (h, s, l, a = 1)=>{
    const channels = (0, _reusableJsDefault.default).set({
        h: (0, _indexJsDefault.default).channel.clamp.h(h),
        s: (0, _indexJsDefault.default).channel.clamp.s(s),
        l: (0, _indexJsDefault.default).channel.clamp.l(l),
        a: (0, _indexJsDefault.default).channel.clamp.a(a)
    });
    return (0, _indexJsDefault1.default).stringify(channels);
};
/* EXPORT */ exports.default = hsla;

},{"../utils/index.js":"hWnJo","../channels/reusable.js":"e3gx3","../color/index.js":"1ZzEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ZtG0":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../color/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/* MAIN */ const toKeyword = (color)=>{
    return (0, _indexJsDefault.default).format.keyword.stringify((0, _indexJsDefault.default).parse(color));
};
/* EXPORT */ exports.default = toKeyword;

},{"../color/index.js":"1ZzEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8e6kP":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../color/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/* MAIN */ const toHex = (color)=>{
    return (0, _indexJsDefault.default).format.hex.stringify((0, _indexJsDefault.default).parse(color));
};
/* EXPORT */ exports.default = toHex;

},{"../color/index.js":"1ZzEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ly1C3":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../color/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/* MAIN */ const toRgba = (color)=>{
    return (0, _indexJsDefault.default).format.rgba.stringify((0, _indexJsDefault.default).parse(color));
};
/* EXPORT */ exports.default = toRgba;

},{"../color/index.js":"1ZzEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iOUBF":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../color/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/* MAIN */ const toHsla = (color)=>{
    return (0, _indexJsDefault.default).format.hsla.stringify((0, _indexJsDefault.default).parse(color));
};
/* EXPORT */ exports.default = toHsla;

},{"../color/index.js":"1ZzEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9QwKN":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../color/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
/* MAIN */ const channel = (color, channel)=>{
    return (0, _indexJsDefault.default).lang.round((0, _indexJsDefault1.default).parse(color)[channel]);
};
/* EXPORT */ exports.default = channel;

},{"../utils/index.js":"hWnJo","../color/index.js":"1ZzEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5JmJZ":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _channelJs = require("./channel.js");
var _channelJsDefault = parcelHelpers.interopDefault(_channelJs);
/* MAIN */ const red = (color)=>{
    return (0, _channelJsDefault.default)(color, 'r');
};
/* EXPORT */ exports.default = red;

},{"./channel.js":"9QwKN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aF52R":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _channelJs = require("./channel.js");
var _channelJsDefault = parcelHelpers.interopDefault(_channelJs);
/* MAIN */ const green = (color)=>{
    return (0, _channelJsDefault.default)(color, 'g');
};
/* EXPORT */ exports.default = green;

},{"./channel.js":"9QwKN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1v13q":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _channelJs = require("./channel.js");
var _channelJsDefault = parcelHelpers.interopDefault(_channelJs);
/* MAIN */ const blue = (color)=>{
    return (0, _channelJsDefault.default)(color, 'b');
};
/* EXPORT */ exports.default = blue;

},{"./channel.js":"9QwKN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l3HdP":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _channelJs = require("./channel.js");
var _channelJsDefault = parcelHelpers.interopDefault(_channelJs);
/* MAIN */ const hue = (color)=>{
    return (0, _channelJsDefault.default)(color, 'h');
};
/* EXPORT */ exports.default = hue;

},{"./channel.js":"9QwKN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2nE02":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _channelJs = require("./channel.js");
var _channelJsDefault = parcelHelpers.interopDefault(_channelJs);
/* MAIN */ const saturation = (color)=>{
    return (0, _channelJsDefault.default)(color, 's');
};
/* EXPORT */ exports.default = saturation;

},{"./channel.js":"9QwKN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cmWva":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _channelJs = require("./channel.js");
var _channelJsDefault = parcelHelpers.interopDefault(_channelJs);
/* MAIN */ const lightness = (color)=>{
    return (0, _channelJsDefault.default)(color, 'l');
};
/* EXPORT */ exports.default = lightness;

},{"./channel.js":"9QwKN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gGLW3":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _channelJs = require("./channel.js");
var _channelJsDefault = parcelHelpers.interopDefault(_channelJs);
/* MAIN */ const alpha = (color)=>{
    return (0, _channelJsDefault.default)(color, 'a');
};
/* EXPORT */ exports.default = alpha;

},{"./channel.js":"9QwKN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hvmzT":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _luminanceJs = require("./luminance.js");
var _luminanceJsDefault = parcelHelpers.interopDefault(_luminanceJs);
/* MAIN */ const contrast = (color1, color2)=>{
    const luminance1 = (0, _luminanceJsDefault.default)(color1);
    const luminance2 = (0, _luminanceJsDefault.default)(color2);
    const max = Math.max(luminance1, luminance2);
    const min = Math.min(luminance1, luminance2);
    const ratio = (max + Number.EPSILON) / (min + Number.EPSILON);
    return (0, _indexJsDefault.default).lang.round((0, _indexJsDefault.default).lang.clamp(ratio, 1, 10));
};
/* EXPORT */ exports.default = contrast;

},{"../utils/index.js":"hWnJo","./luminance.js":"ckIa5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ckIa5":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../color/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
/* MAIN */ //SOURCE: https://planetcalc.com/7779
const luminance = (color)=>{
    const { r, g, b } = (0, _indexJsDefault1.default).parse(color);
    const luminance = .2126 * (0, _indexJsDefault.default).channel.toLinear(r) + .7152 * (0, _indexJsDefault.default).channel.toLinear(g) + .0722 * (0, _indexJsDefault.default).channel.toLinear(b);
    return (0, _indexJsDefault.default).lang.round(luminance);
};
/* EXPORT */ exports.default = luminance;

},{"../utils/index.js":"hWnJo","../color/index.js":"1ZzEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aQqmA":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isLightJs = require("./is_light.js");
var _isLightJsDefault = parcelHelpers.interopDefault(_isLightJs);
/* MAIN */ const isDark = (color)=>{
    return !(0, _isLightJsDefault.default)(color);
};
/* EXPORT */ exports.default = isDark;

},{"./is_light.js":"2dGSi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2dGSi":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _luminanceJs = require("./luminance.js");
var _luminanceJsDefault = parcelHelpers.interopDefault(_luminanceJs);
/* MAIN */ const isLight = (color)=>{
    return (0, _luminanceJsDefault.default)(color) >= .5;
};
/* EXPORT */ exports.default = isLight;

},{"./luminance.js":"ckIa5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lvVtq":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _alphaJs = require("./alpha.js");
var _alphaJsDefault = parcelHelpers.interopDefault(_alphaJs);
/* MAIN */ const isTransparent = (color)=>{
    return !(0, _alphaJsDefault.default)(color);
};
/* EXPORT */ exports.default = isTransparent;

},{"./alpha.js":"gGLW3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jF4RP":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../color/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/* MAIN */ const isValid = (color)=>{
    try {
        (0, _indexJsDefault.default).parse(color);
        return true;
    } catch  {
        return false;
    }
};
/* EXPORT */ exports.default = isValid;

},{"../color/index.js":"1ZzEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ySUB":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adjustChannelJs = require("./adjust_channel.js");
var _adjustChannelJsDefault = parcelHelpers.interopDefault(_adjustChannelJs);
/* MAIN */ const saturate = (color, amount)=>{
    return (0, _adjustChannelJsDefault.default)(color, 's', amount);
};
/* EXPORT */ exports.default = saturate;

},{"./adjust_channel.js":"aoKFN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aoKFN":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../color/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
/* MAIN */ const adjustChannel = (color, channel, amount)=>{
    const channels = (0, _indexJsDefault1.default).parse(color);
    const amountCurrent = channels[channel];
    const amountNext = (0, _indexJsDefault.default).channel.clamp[channel](amountCurrent + amount);
    if (amountCurrent !== amountNext) channels[channel] = amountNext;
    return (0, _indexJsDefault1.default).stringify(channels);
};
/* EXPORT */ exports.default = adjustChannel;

},{"../utils/index.js":"hWnJo","../color/index.js":"1ZzEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"24Kwt":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adjustChannelJs = require("./adjust_channel.js");
var _adjustChannelJsDefault = parcelHelpers.interopDefault(_adjustChannelJs);
/* MAIN */ const desaturate = (color, amount)=>{
    return (0, _adjustChannelJsDefault.default)(color, 's', -amount);
};
/* EXPORT */ exports.default = desaturate;

},{"./adjust_channel.js":"aoKFN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aiypm":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adjustChannelJs = require("./adjust_channel.js");
var _adjustChannelJsDefault = parcelHelpers.interopDefault(_adjustChannelJs);
/* MAIN */ const lighten = (color, amount)=>{
    return (0, _adjustChannelJsDefault.default)(color, 'l', amount);
};
/* EXPORT */ exports.default = lighten;

},{"./adjust_channel.js":"aoKFN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cAup7":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adjustChannelJs = require("./adjust_channel.js");
var _adjustChannelJsDefault = parcelHelpers.interopDefault(_adjustChannelJs);
/* MAIN */ const darken = (color, amount)=>{
    return (0, _adjustChannelJsDefault.default)(color, 'l', -amount);
};
/* EXPORT */ exports.default = darken;

},{"./adjust_channel.js":"aoKFN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i0G8R":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adjustChannelJs = require("./adjust_channel.js");
var _adjustChannelJsDefault = parcelHelpers.interopDefault(_adjustChannelJs);
/* MAIN */ const opacify = (color, amount)=>{
    return (0, _adjustChannelJsDefault.default)(color, 'a', amount);
};
/* EXPORT */ exports.default = opacify;

},{"./adjust_channel.js":"aoKFN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"29aVb":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adjustChannelJs = require("./adjust_channel.js");
var _adjustChannelJsDefault = parcelHelpers.interopDefault(_adjustChannelJs);
/* MAIN */ const transparentize = (color, amount)=>{
    return (0, _adjustChannelJsDefault.default)(color, 'a', -amount);
};
/* EXPORT */ exports.default = transparentize;

},{"./adjust_channel.js":"aoKFN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bYjm9":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adjustChannelJs = require("./adjust_channel.js");
var _adjustChannelJsDefault = parcelHelpers.interopDefault(_adjustChannelJs);
/* MAIN */ const complement = (color)=>{
    return (0, _adjustChannelJsDefault.default)(color, 'h', 180);
};
/* EXPORT */ exports.default = complement;

},{"./adjust_channel.js":"aoKFN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bevWV":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _changeJs = require("./change.js");
var _changeJsDefault = parcelHelpers.interopDefault(_changeJs);
/* MAIN */ const grayscale = (color)=>{
    return (0, _changeJsDefault.default)(color, {
        s: 0
    });
};
/* EXPORT */ exports.default = grayscale;

},{"./change.js":"j72hU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fEbxT":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../color/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _changeJs = require("./change.js");
var _changeJsDefault = parcelHelpers.interopDefault(_changeJs);
/* MAIN */ const adjust = (color, channels)=>{
    const ch = (0, _indexJsDefault.default).parse(color);
    const changes = {};
    for(const c in channels){
        if (!channels[c]) continue;
        changes[c] = ch[c] + channels[c];
    }
    return (0, _changeJsDefault.default)(color, changes);
};
/* EXPORT */ exports.default = adjust;

},{"../color/index.js":"1ZzEz","./change.js":"j72hU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6o6GH":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../color/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mixJs = require("./mix.js");
var _mixJsDefault = parcelHelpers.interopDefault(_mixJs);
/* MAIN */ const invert = (color, weight = 100)=>{
    const inverse = (0, _indexJsDefault.default).parse(color);
    inverse.r = 255 - inverse.r;
    inverse.g = 255 - inverse.g;
    inverse.b = 255 - inverse.b;
    return (0, _mixJsDefault.default)(inverse, color, weight);
};
/* EXPORT */ exports.default = invert;

},{"../color/index.js":"1ZzEz","./mix.js":"4wN8Y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4wN8Y":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../color/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _rgbaJs = require("./rgba.js");
var _rgbaJsDefault = parcelHelpers.interopDefault(_rgbaJs);
/* MAIN */ //SOURCE: https://github.com/sass/dart-sass/blob/7457d2e9e7e623d9844ffd037a070cf32d39c348/lib/src/functions/color.dart#L718-L756
const mix = (color1, color2, weight = 50)=>{
    const { r: r1, g: g1, b: b1, a: a1 } = (0, _indexJsDefault.default).parse(color1);
    const { r: r2, g: g2, b: b2, a: a2 } = (0, _indexJsDefault.default).parse(color2);
    const weightScale = weight / 100;
    const weightNormalized = weightScale * 2 - 1;
    const alphaDelta = a1 - a2;
    const weight1combined = weightNormalized * alphaDelta === -1 ? weightNormalized : (weightNormalized + alphaDelta) / (1 + weightNormalized * alphaDelta);
    const weight1 = (weight1combined + 1) / 2;
    const weight2 = 1 - weight1;
    const r = r1 * weight1 + r2 * weight2;
    const g = g1 * weight1 + g2 * weight2;
    const b = b1 * weight1 + b2 * weight2;
    const a = a1 * weightScale + a2 * (1 - weightScale);
    return (0, _rgbaJsDefault.default)(r, g, b, a);
};
/* EXPORT */ exports.default = mix;

},{"../color/index.js":"1ZzEz","./rgba.js":"dvW2J","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2EGTj":[function(require,module,exports,__globalThis) {
/* IMPORT */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../utils/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../color/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _adjustJs = require("./adjust.js");
var _adjustJsDefault = parcelHelpers.interopDefault(_adjustJs);
/* MAIN */ const scale = (color, channels)=>{
    const ch = (0, _indexJsDefault1.default).parse(color);
    const adjustments = {};
    const delta = (amount, weight, max)=>weight > 0 ? (max - amount) * weight / 100 : amount * weight / 100;
    for(const c in channels)adjustments[c] = delta(ch[c], channels[c], (0, _indexJsDefault.default).channel.max[c]);
    return (0, _adjustJsDefault.default)(color, adjustments);
};
/* EXPORT */ exports.default = scale;

},{"../utils/index.js":"hWnJo","../color/index.js":"1ZzEz","./adjust.js":"fEbxT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kSZfU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || (0, _mapCacheJsDefault.default));
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = (0, _mapCacheJsDefault.default);
exports.default = memoize;

},{"./_MapCache.js":"8Hi07","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Hi07":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheClearJs = require("./_mapCacheClear.js");
var _mapCacheClearJsDefault = parcelHelpers.interopDefault(_mapCacheClearJs);
var _mapCacheDeleteJs = require("./_mapCacheDelete.js");
var _mapCacheDeleteJsDefault = parcelHelpers.interopDefault(_mapCacheDeleteJs);
var _mapCacheGetJs = require("./_mapCacheGet.js");
var _mapCacheGetJsDefault = parcelHelpers.interopDefault(_mapCacheGetJs);
var _mapCacheHasJs = require("./_mapCacheHas.js");
var _mapCacheHasJsDefault = parcelHelpers.interopDefault(_mapCacheHasJs);
var _mapCacheSetJs = require("./_mapCacheSet.js");
var _mapCacheSetJsDefault = parcelHelpers.interopDefault(_mapCacheSetJs);
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = (0, _mapCacheClearJsDefault.default);
MapCache.prototype['delete'] = (0, _mapCacheDeleteJsDefault.default);
MapCache.prototype.get = (0, _mapCacheGetJsDefault.default);
MapCache.prototype.has = (0, _mapCacheHasJsDefault.default);
MapCache.prototype.set = (0, _mapCacheSetJsDefault.default);
exports.default = MapCache;

},{"./_mapCacheClear.js":"4bONa","./_mapCacheDelete.js":"69i5D","./_mapCacheGet.js":"9E4Id","./_mapCacheHas.js":"MVfOy","./_mapCacheSet.js":"kkEsg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4bONa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashJs = require("./_Hash.js");
var _hashJsDefault = parcelHelpers.interopDefault(_hashJs);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, _hashJsDefault.default),
        'map': new ((0, _mapJsDefault.default) || (0, _listCacheJsDefault.default)),
        'string': new (0, _hashJsDefault.default)
    };
}
exports.default = mapCacheClear;

},{"./_Hash.js":"9hnnt","./_ListCache.js":"6ikFt","./_Map.js":"gBkLr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9hnnt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashClearJs = require("./_hashClear.js");
var _hashClearJsDefault = parcelHelpers.interopDefault(_hashClearJs);
var _hashDeleteJs = require("./_hashDelete.js");
var _hashDeleteJsDefault = parcelHelpers.interopDefault(_hashDeleteJs);
var _hashGetJs = require("./_hashGet.js");
var _hashGetJsDefault = parcelHelpers.interopDefault(_hashGetJs);
var _hashHasJs = require("./_hashHas.js");
var _hashHasJsDefault = parcelHelpers.interopDefault(_hashHasJs);
var _hashSetJs = require("./_hashSet.js");
var _hashSetJsDefault = parcelHelpers.interopDefault(_hashSetJs);
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = (0, _hashClearJsDefault.default);
Hash.prototype['delete'] = (0, _hashDeleteJsDefault.default);
Hash.prototype.get = (0, _hashGetJsDefault.default);
Hash.prototype.has = (0, _hashHasJsDefault.default);
Hash.prototype.set = (0, _hashSetJsDefault.default);
exports.default = Hash;

},{"./_hashClear.js":"6aMWM","./_hashDelete.js":"ipW9A","./_hashGet.js":"kGZuv","./_hashHas.js":"iIj7A","./_hashSet.js":"dLpOq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6aMWM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = (0, _nativeCreateJsDefault.default) ? (0, _nativeCreateJsDefault.default)(null) : {};
    this.size = 0;
}
exports.default = hashClear;

},{"./_nativeCreate.js":"e1Fvt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e1Fvt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
/* Built-in method references that are verified to be native. */ var nativeCreate = (0, _getNativeJsDefault.default)(Object, 'create');
exports.default = nativeCreate;

},{"./_getNative.js":"8XHOL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8XHOL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsNativeJs = require("./_baseIsNative.js");
var _baseIsNativeJsDefault = parcelHelpers.interopDefault(_baseIsNativeJs);
var _getValueJs = require("./_getValue.js");
var _getValueJsDefault = parcelHelpers.interopDefault(_getValueJs);
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = (0, _getValueJsDefault.default)(object, key);
    return (0, _baseIsNativeJsDefault.default)(value) ? value : undefined;
}
exports.default = getNative;

},{"./_baseIsNative.js":"b0YwX","./_getValue.js":"2a88e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b0YwX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isMaskedJs = require("./_isMasked.js");
var _isMaskedJsDefault = parcelHelpers.interopDefault(_isMaskedJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!(0, _isObjectJsDefault.default)(value) || (0, _isMaskedJsDefault.default)(value)) return false;
    var pattern = (0, _isFunctionJsDefault.default)(value) ? reIsNative : reIsHostCtor;
    return pattern.test((0, _toSourceJsDefault.default)(value));
}
exports.default = baseIsNative;

},{"./isFunction.js":"iuUS0","./_isMasked.js":"f3KVw","./isObject.js":"boUsC","./_toSource.js":"hV6pF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iuUS0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!(0, _isObjectJsDefault.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, _baseGetTagJsDefault.default)(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
exports.default = isFunction;

},{"./_baseGetTag.js":"cZgKC","./isObject.js":"boUsC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cZgKC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _getRawTagJs = require("./_getRawTag.js");
var _getRawTagJsDefault = parcelHelpers.interopDefault(_getRawTagJs);
var _objectToStringJs = require("./_objectToString.js");
var _objectToStringJsDefault = parcelHelpers.interopDefault(_objectToStringJs);
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? (0, _getRawTagJsDefault.default)(value) : (0, _objectToStringJsDefault.default)(value);
}
exports.default = baseGetTag;

},{"./_Symbol.js":"xSCm6","./_getRawTag.js":"bWJbh","./_objectToString.js":"fQVkR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"xSCm6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Symbol = (0, _rootJsDefault.default).Symbol;
exports.default = Symbol;

},{"./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cTEWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = (0, _freeGlobalJsDefault.default) || freeSelf || Function('return this')();
exports.default = root;

},{"./_freeGlobal.js":"39xL9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"39xL9":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
exports.default = freeGlobal;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bWJbh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
exports.default = getRawTag;

},{"./_Symbol.js":"xSCm6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fQVkR":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
exports.default = objectToString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"boUsC":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
exports.default = isObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f3KVw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coreJsDataJs = require("./_coreJsData.js");
var _coreJsDataJsDefault = parcelHelpers.interopDefault(_coreJsDataJs);
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, _coreJsDataJsDefault.default) && (0, _coreJsDataJsDefault.default).keys && (0, _coreJsDataJsDefault.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
exports.default = isMasked;

},{"./_coreJsData.js":"c45s2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c45s2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Used to detect overreaching core-js shims. */ var coreJsData = (0, _rootJsDefault.default)['__core-js_shared__'];
exports.default = coreJsData;

},{"./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hV6pF":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
exports.default = toSource;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2a88e":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getValue(object, key) {
    return object == null ? undefined : object[key];
}
exports.default = getValue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ipW9A":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = hashDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kGZuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (0, _nativeCreateJsDefault.default) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
exports.default = hashGet;

},{"./_nativeCreate.js":"e1Fvt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iIj7A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return (0, _nativeCreateJsDefault.default) ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
exports.default = hashHas;

},{"./_nativeCreate.js":"e1Fvt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dLpOq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, _nativeCreateJsDefault.default) && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
exports.default = hashSet;

},{"./_nativeCreate.js":"e1Fvt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ikFt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheClearJs = require("./_listCacheClear.js");
var _listCacheClearJsDefault = parcelHelpers.interopDefault(_listCacheClearJs);
var _listCacheDeleteJs = require("./_listCacheDelete.js");
var _listCacheDeleteJsDefault = parcelHelpers.interopDefault(_listCacheDeleteJs);
var _listCacheGetJs = require("./_listCacheGet.js");
var _listCacheGetJsDefault = parcelHelpers.interopDefault(_listCacheGetJs);
var _listCacheHasJs = require("./_listCacheHas.js");
var _listCacheHasJsDefault = parcelHelpers.interopDefault(_listCacheHasJs);
var _listCacheSetJs = require("./_listCacheSet.js");
var _listCacheSetJsDefault = parcelHelpers.interopDefault(_listCacheSetJs);
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = (0, _listCacheClearJsDefault.default);
ListCache.prototype['delete'] = (0, _listCacheDeleteJsDefault.default);
ListCache.prototype.get = (0, _listCacheGetJsDefault.default);
ListCache.prototype.has = (0, _listCacheHasJsDefault.default);
ListCache.prototype.set = (0, _listCacheSetJsDefault.default);
exports.default = ListCache;

},{"./_listCacheClear.js":"cCOs4","./_listCacheDelete.js":"lcGNm","./_listCacheGet.js":"hDVIr","./_listCacheHas.js":"knPom","./_listCacheSet.js":"9MfZu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cCOs4":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
exports.default = listCacheClear;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lcGNm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
exports.default = listCacheDelete;

},{"./_assocIndexOf.js":"fyoc9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fyoc9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, _eqJsDefault.default)(array[length][0], key)) return length;
    }
    return -1;
}
exports.default = assocIndexOf;

},{"./eq.js":"gA93x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gA93x":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function eq(value, other) {
    return value === other || value !== value && other !== other;
}
exports.default = eq;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hDVIr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
exports.default = listCacheGet;

},{"./_assocIndexOf.js":"fyoc9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"knPom":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return (0, _assocIndexOfJsDefault.default)(this.__data__, key) > -1;
}
exports.default = listCacheHas;

},{"./_assocIndexOf.js":"fyoc9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9MfZu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
exports.default = listCacheSet;

},{"./_assocIndexOf.js":"fyoc9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gBkLr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Map = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'Map');
exports.default = Map;

},{"./_getNative.js":"8XHOL","./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"69i5D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = (0, _getMapDataJsDefault.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = mapCacheDelete;

},{"./_getMapData.js":"aVkEX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aVkEX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isKeyableJs = require("./_isKeyable.js");
var _isKeyableJsDefault = parcelHelpers.interopDefault(_isKeyableJs);
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return (0, _isKeyableJsDefault.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
exports.default = getMapData;

},{"./_isKeyable.js":"lb0dj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lb0dj":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
exports.default = isKeyable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9E4Id":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return (0, _getMapDataJsDefault.default)(this, key).get(key);
}
exports.default = mapCacheGet;

},{"./_getMapData.js":"aVkEX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"MVfOy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return (0, _getMapDataJsDefault.default)(this, key).has(key);
}
exports.default = mapCacheHas;

},{"./_getMapData.js":"aVkEX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kkEsg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = (0, _getMapDataJsDefault.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
exports.default = mapCacheSet;

},{"./_getMapData.js":"aVkEX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ije1P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseMergeJs = require("./_baseMerge.js");
var _baseMergeJsDefault = parcelHelpers.interopDefault(_baseMergeJs);
var _createAssignerJs = require("./_createAssigner.js");
var _createAssignerJsDefault = parcelHelpers.interopDefault(_createAssignerJs);
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = (0, _createAssignerJsDefault.default)(function(object, source, srcIndex) {
    (0, _baseMergeJsDefault.default)(object, source, srcIndex);
});
exports.default = merge;

},{"./_baseMerge.js":"r4Ima","./_createAssigner.js":"7sBqj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"r4Ima":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _assignMergeValueJs = require("./_assignMergeValue.js");
var _assignMergeValueJsDefault = parcelHelpers.interopDefault(_assignMergeValueJs);
var _baseForJs = require("./_baseFor.js");
var _baseForJsDefault = parcelHelpers.interopDefault(_baseForJs);
var _baseMergeDeepJs = require("./_baseMergeDeep.js");
var _baseMergeDeepJsDefault = parcelHelpers.interopDefault(_baseMergeDeepJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
var _safeGetJs = require("./_safeGet.js");
var _safeGetJsDefault = parcelHelpers.interopDefault(_safeGetJs);
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, _baseForJsDefault.default)(source, function(srcValue, key) {
        stack || (stack = new (0, _stackJsDefault.default));
        if ((0, _isObjectJsDefault.default)(srcValue)) (0, _baseMergeDeepJsDefault.default)(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, _safeGetJsDefault.default)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, _assignMergeValueJsDefault.default)(object, key, newValue);
        }
    }, (0, _keysInJsDefault.default));
}
exports.default = baseMerge;

},{"./_Stack.js":"adQXu","./_assignMergeValue.js":"7hblC","./_baseFor.js":"aia4x","./_baseMergeDeep.js":"1RFnB","./isObject.js":"boUsC","./keysIn.js":"8m5FO","./_safeGet.js":"lRcHl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"adQXu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _stackClearJs = require("./_stackClear.js");
var _stackClearJsDefault = parcelHelpers.interopDefault(_stackClearJs);
var _stackDeleteJs = require("./_stackDelete.js");
var _stackDeleteJsDefault = parcelHelpers.interopDefault(_stackDeleteJs);
var _stackGetJs = require("./_stackGet.js");
var _stackGetJsDefault = parcelHelpers.interopDefault(_stackGetJs);
var _stackHasJs = require("./_stackHas.js");
var _stackHasJsDefault = parcelHelpers.interopDefault(_stackHasJs);
var _stackSetJs = require("./_stackSet.js");
var _stackSetJsDefault = parcelHelpers.interopDefault(_stackSetJs);
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new (0, _listCacheJsDefault.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = (0, _stackClearJsDefault.default);
Stack.prototype['delete'] = (0, _stackDeleteJsDefault.default);
Stack.prototype.get = (0, _stackGetJsDefault.default);
Stack.prototype.has = (0, _stackHasJsDefault.default);
Stack.prototype.set = (0, _stackSetJsDefault.default);
exports.default = Stack;

},{"./_ListCache.js":"6ikFt","./_stackClear.js":"kdQMj","./_stackDelete.js":"4o6KY","./_stackGet.js":"lO42i","./_stackHas.js":"9rrOp","./_stackSet.js":"3P9IL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kdQMj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new (0, _listCacheJsDefault.default);
    this.size = 0;
}
exports.default = stackClear;

},{"./_ListCache.js":"6ikFt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4o6KY":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
exports.default = stackDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lO42i":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackGet(key) {
    return this.__data__.get(key);
}
exports.default = stackGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9rrOp":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackHas(key) {
    return this.__data__.has(key);
}
exports.default = stackHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3P9IL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, _listCacheJsDefault.default)) {
        var pairs = data.__data__;
        if (!(0, _mapJsDefault.default) || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, _mapCacheJsDefault.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
exports.default = stackSet;

},{"./_ListCache.js":"6ikFt","./_Map.js":"gBkLr","./_MapCache.js":"8Hi07","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7hblC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, _eqJsDefault.default)(object[key], value) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignMergeValue;

},{"./_baseAssignValue.js":"k7RNM","./eq.js":"gA93x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k7RNM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, _definePropertyJsDefault.default)) (0, _definePropertyJsDefault.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
exports.default = baseAssignValue;

},{"./_defineProperty.js":"31EJg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"31EJg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var defineProperty = function() {
    try {
        var func = (0, _getNativeJsDefault.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
exports.default = defineProperty;

},{"./_getNative.js":"8XHOL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aia4x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createBaseForJs = require("./_createBaseFor.js");
var _createBaseForJsDefault = parcelHelpers.interopDefault(_createBaseForJs);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = (0, _createBaseForJsDefault.default)();
exports.default = baseFor;

},{"./_createBaseFor.js":"dyknQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dyknQ":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
exports.default = createBaseFor;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1RFnB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignMergeValueJs = require("./_assignMergeValue.js");
var _assignMergeValueJsDefault = parcelHelpers.interopDefault(_assignMergeValueJs);
var _cloneBufferJs = require("./_cloneBuffer.js");
var _cloneBufferJsDefault = parcelHelpers.interopDefault(_cloneBufferJs);
var _cloneTypedArrayJs = require("./_cloneTypedArray.js");
var _cloneTypedArrayJsDefault = parcelHelpers.interopDefault(_cloneTypedArrayJs);
var _copyArrayJs = require("./_copyArray.js");
var _copyArrayJsDefault = parcelHelpers.interopDefault(_copyArrayJs);
var _initCloneObjectJs = require("./_initCloneObject.js");
var _initCloneObjectJsDefault = parcelHelpers.interopDefault(_initCloneObjectJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isArrayLikeObjectJs = require("./isArrayLikeObject.js");
var _isArrayLikeObjectJsDefault = parcelHelpers.interopDefault(_isArrayLikeObjectJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPlainObjectJs = require("./isPlainObject.js");
var _isPlainObjectJsDefault = parcelHelpers.interopDefault(_isPlainObjectJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
var _safeGetJs = require("./_safeGet.js");
var _safeGetJsDefault = parcelHelpers.interopDefault(_safeGetJs);
var _toPlainObjectJs = require("./toPlainObject.js");
var _toPlainObjectJsDefault = parcelHelpers.interopDefault(_toPlainObjectJs);
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, _safeGetJsDefault.default)(object, key), srcValue = (0, _safeGetJsDefault.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, _assignMergeValueJsDefault.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, _isArrayJsDefault.default)(srcValue), isBuff = !isArr && (0, _isBufferJsDefault.default)(srcValue), isTyped = !isArr && !isBuff && (0, _isTypedArrayJsDefault.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, _isArrayJsDefault.default)(objValue)) newValue = objValue;
            else if ((0, _isArrayLikeObjectJsDefault.default)(objValue)) newValue = (0, _copyArrayJsDefault.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, _cloneBufferJsDefault.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, _cloneTypedArrayJsDefault.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, _isPlainObjectJsDefault.default)(srcValue) || (0, _isArgumentsJsDefault.default)(srcValue)) {
            newValue = objValue;
            if ((0, _isArgumentsJsDefault.default)(objValue)) newValue = (0, _toPlainObjectJsDefault.default)(objValue);
            else if (!(0, _isObjectJsDefault.default)(objValue) || (0, _isFunctionJsDefault.default)(objValue)) newValue = (0, _initCloneObjectJsDefault.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, _assignMergeValueJsDefault.default)(object, key, newValue);
}
exports.default = baseMergeDeep;

},{"./_assignMergeValue.js":"7hblC","./_cloneBuffer.js":"3oX4H","./_cloneTypedArray.js":"8IgLp","./_copyArray.js":"jFIQj","./_initCloneObject.js":"eNMyw","./isArguments.js":"dK8Bo","./isArray.js":"a5xfW","./isArrayLikeObject.js":"h8Mqu","./isBuffer.js":"b6M7J","./isFunction.js":"iuUS0","./isObject.js":"boUsC","./isPlainObject.js":"bWMRe","./isTypedArray.js":"11FzZ","./_safeGet.js":"lRcHl","./toPlainObject.js":"9qED0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3oX4H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
exports.default = cloneBuffer;

},{"./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8IgLp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneArrayBufferJs = require("./_cloneArrayBuffer.js");
var _cloneArrayBufferJsDefault = parcelHelpers.interopDefault(_cloneArrayBufferJs);
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, _cloneArrayBufferJsDefault.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
exports.default = cloneTypedArray;

},{"./_cloneArrayBuffer.js":"afcWq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"afcWq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, _uint8ArrayJsDefault.default)(result).set(new (0, _uint8ArrayJsDefault.default)(arrayBuffer));
    return result;
}
exports.default = cloneArrayBuffer;

},{"./_Uint8Array.js":"aLmL3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aLmL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Uint8Array = (0, _rootJsDefault.default).Uint8Array;
exports.default = Uint8Array;

},{"./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jFIQj":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
exports.default = copyArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eNMyw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseCreateJs = require("./_baseCreate.js");
var _baseCreateJsDefault = parcelHelpers.interopDefault(_baseCreateJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, _isPrototypeJsDefault.default)(object) ? (0, _baseCreateJsDefault.default)((0, _getPrototypeJsDefault.default)(object)) : {};
}
exports.default = initCloneObject;

},{"./_baseCreate.js":"6wqeu","./_getPrototype.js":"blDI2","./_isPrototype.js":"bwS2b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6wqeu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, _isObjectJsDefault.default)(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
exports.default = baseCreate;

},{"./isObject.js":"boUsC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"blDI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/** Built-in value references. */ var getPrototype = (0, _overArgJsDefault.default)(Object.getPrototypeOf, Object);
exports.default = getPrototype;

},{"./_overArg.js":"3VPN2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3VPN2":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
exports.default = overArg;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bwS2b":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
exports.default = isPrototype;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dK8Bo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsArgumentsJs = require("./_baseIsArguments.js");
var _baseIsArgumentsJsDefault = parcelHelpers.interopDefault(_baseIsArgumentsJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = (0, _baseIsArgumentsJsDefault.default)(function() {
    return arguments;
}()) ? (0, _baseIsArgumentsJsDefault.default) : function(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
exports.default = isArguments;

},{"./_baseIsArguments.js":"bDM1I","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bDM1I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == argsTag;
}
exports.default = baseIsArguments;

},{"./_baseGetTag.js":"cZgKC","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hcFFR":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
exports.default = isObjectLike;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a5xfW":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isArray = Array.isArray;
exports.default = isArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h8Mqu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isArrayLikeJsDefault.default)(value);
}
exports.default = isArrayLikeObject;

},{"./isArrayLike.js":"dGrFC","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dGrFC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && (0, _isLengthJsDefault.default)(value.length) && !(0, _isFunctionJsDefault.default)(value);
}
exports.default = isArrayLike;

},{"./isFunction.js":"iuUS0","./isLength.js":"b3AR7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b3AR7":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
exports.default = isLength;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b6M7J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _stubFalseJs = require("./stubFalse.js");
var _stubFalseJsDefault = parcelHelpers.interopDefault(_stubFalseJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, _stubFalseJsDefault.default);
exports.default = isBuffer;

},{"./_root.js":"cTEWZ","./stubFalse.js":"fIoLd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fIoLd":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubFalse() {
    return false;
}
exports.default = stubFalse;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bWMRe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!(0, _isObjectLikeJsDefault.default)(value) || (0, _baseGetTagJsDefault.default)(value) != objectTag) return false;
    var proto = (0, _getPrototypeJsDefault.default)(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
exports.default = isPlainObject;

},{"./_baseGetTag.js":"cZgKC","./_getPrototype.js":"blDI2","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"11FzZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsTypedArrayJs = require("./_baseIsTypedArray.js");
var _baseIsTypedArrayJsDefault = parcelHelpers.interopDefault(_baseIsTypedArrayJs);
var _baseUnaryJs = require("./_baseUnary.js");
var _baseUnaryJsDefault = parcelHelpers.interopDefault(_baseUnaryJs);
var _nodeUtilJs = require("./_nodeUtil.js");
var _nodeUtilJsDefault = parcelHelpers.interopDefault(_nodeUtilJs);
/* Node.js helper references. */ var nodeIsTypedArray = (0, _nodeUtilJsDefault.default) && (0, _nodeUtilJsDefault.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? (0, _baseUnaryJsDefault.default)(nodeIsTypedArray) : (0, _baseIsTypedArrayJsDefault.default);
exports.default = isTypedArray;

},{"./_baseIsTypedArray.js":"kDuWV","./_baseUnary.js":"fwcjM","./_nodeUtil.js":"gwvhS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kDuWV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isLengthJsDefault.default)(value.length) && !!typedArrayTags[(0, _baseGetTagJsDefault.default)(value)];
}
exports.default = baseIsTypedArray;

},{"./_baseGetTag.js":"cZgKC","./isLength.js":"b3AR7","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fwcjM":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
exports.default = baseUnary;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gwvhS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, _freeGlobalJsDefault.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
exports.default = nodeUtil;

},{"./_freeGlobal.js":"39xL9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lRcHl":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
exports.default = safeGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9qED0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return (0, _copyObjectJsDefault.default)(value, (0, _keysInJsDefault.default)(value));
}
exports.default = toPlainObject;

},{"./_copyObject.js":"9P6a2","./keysIn.js":"8m5FO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9P6a2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignValueJs = require("./_assignValue.js");
var _assignValueJsDefault = parcelHelpers.interopDefault(_assignValueJs);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, _baseAssignValueJsDefault.default)(object, key, newValue);
        else (0, _assignValueJsDefault.default)(object, key, newValue);
    }
    return object;
}
exports.default = copyObject;

},{"./_assignValue.js":"gXgNV","./_baseAssignValue.js":"k7RNM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gXgNV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && (0, _eqJsDefault.default)(objValue, value)) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignValue;

},{"./_baseAssignValue.js":"k7RNM","./eq.js":"gA93x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8m5FO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysInJs = require("./_baseKeysIn.js");
var _baseKeysInJsDefault = parcelHelpers.interopDefault(_baseKeysInJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object, true) : (0, _baseKeysInJsDefault.default)(object);
}
exports.default = keysIn;

},{"./_arrayLikeKeys.js":"2rSaZ","./_baseKeysIn.js":"bCuna","./isArrayLike.js":"dGrFC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2rSaZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTimesJs = require("./_baseTimes.js");
var _baseTimesJsDefault = parcelHelpers.interopDefault(_baseTimesJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = (0, _isArrayJsDefault.default)(value), isArg = !isArr && (0, _isArgumentsJsDefault.default)(value), isBuff = !isArr && !isArg && (0, _isBufferJsDefault.default)(value), isType = !isArr && !isArg && !isBuff && (0, _isTypedArrayJsDefault.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, _baseTimesJsDefault.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, _isIndexJsDefault.default)(key, length)))) result.push(key);
    return result;
}
exports.default = arrayLikeKeys;

},{"./_baseTimes.js":"gX3UG","./isArguments.js":"dK8Bo","./isArray.js":"a5xfW","./isBuffer.js":"b6M7J","./_isIndex.js":"3TBPo","./isTypedArray.js":"11FzZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gX3UG":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
exports.default = baseTimes;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3TBPo":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
exports.default = isIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bCuna":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysInJs = require("./_nativeKeysIn.js");
var _nativeKeysInJsDefault = parcelHelpers.interopDefault(_nativeKeysInJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!(0, _isObjectJsDefault.default)(object)) return (0, _nativeKeysInJsDefault.default)(object);
    var isProto = (0, _isPrototypeJsDefault.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
exports.default = baseKeysIn;

},{"./isObject.js":"boUsC","./_isPrototype.js":"bwS2b","./_nativeKeysIn.js":"fh6Rh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fh6Rh":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
exports.default = nativeKeysIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7sBqj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseRestJs = require("./_baseRest.js");
var _baseRestJsDefault = parcelHelpers.interopDefault(_baseRestJs);
var _isIterateeCallJs = require("./_isIterateeCall.js");
var _isIterateeCallJsDefault = parcelHelpers.interopDefault(_isIterateeCallJs);
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return (0, _baseRestJsDefault.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, _isIterateeCallJsDefault.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
exports.default = createAssigner;

},{"./_baseRest.js":"2dsAn","./_isIterateeCall.js":"12U0L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2dsAn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _overRestJs = require("./_overRest.js");
var _overRestJsDefault = parcelHelpers.interopDefault(_overRestJs);
var _setToStringJs = require("./_setToString.js");
var _setToStringJsDefault = parcelHelpers.interopDefault(_setToStringJs);
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return (0, _setToStringJsDefault.default)((0, _overRestJsDefault.default)(func, start, (0, _identityJsDefault.default)), func + '');
}
exports.default = baseRest;

},{"./identity.js":"fDK8o","./_overRest.js":"6AMx2","./_setToString.js":"axs8A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fDK8o":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function identity(value) {
    return value;
}
exports.default = identity;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6AMx2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _applyJs = require("./_apply.js");
var _applyJsDefault = parcelHelpers.interopDefault(_applyJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, _applyJsDefault.default)(func, this, otherArgs);
    };
}
exports.default = overRest;

},{"./_apply.js":"58ASY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"58ASY":[function(require,module,exports,__globalThis) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
exports.default = apply;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"axs8A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseSetToStringJs = require("./_baseSetToString.js");
var _baseSetToStringJsDefault = parcelHelpers.interopDefault(_baseSetToStringJs);
var _shortOutJs = require("./_shortOut.js");
var _shortOutJsDefault = parcelHelpers.interopDefault(_shortOutJs);
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = (0, _shortOutJsDefault.default)((0, _baseSetToStringJsDefault.default));
exports.default = setToString;

},{"./_baseSetToString.js":"3cKkl","./_shortOut.js":"9WPaG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3cKkl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !(0, _definePropertyJsDefault.default) ? (0, _identityJsDefault.default) : function(func, string) {
    return (0, _definePropertyJsDefault.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, _constantJsDefault.default)(string),
        'writable': true
    });
};
exports.default = baseSetToString;

},{"./constant.js":"3zNnl","./_defineProperty.js":"31EJg","./identity.js":"fDK8o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3zNnl":[function(require,module,exports,__globalThis) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function constant(value) {
    return function() {
        return value;
    };
}
exports.default = constant;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9WPaG":[function(require,module,exports,__globalThis) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
exports.default = shortOut;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"12U0L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!(0, _isObjectJsDefault.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, _isArrayLikeJsDefault.default)(object) && (0, _isIndexJsDefault.default)(index, object.length) : type == 'string' && index in object) return (0, _eqJsDefault.default)(object[index], value);
    return false;
}
exports.default = isIterateeCall;

},{"./eq.js":"gA93x","./isArrayLike.js":"dGrFC","./_isIndex.js":"3TBPo","./isObject.js":"boUsC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lfeQC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>p);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>g);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>v);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SCOPE", ()=>k);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>$);
parcelHelpers.export(exports, "alloc", ()=>Y);
parcelHelpers.export(exports, "append", ()=>B);
parcelHelpers.export(exports, "assign", ()=>x);
parcelHelpers.export(exports, "caret", ()=>V);
parcelHelpers.export(exports, "char", ()=>Q);
parcelHelpers.export(exports, "character", ()=>J);
parcelHelpers.export(exports, "characters", ()=>K);
parcelHelpers.export(exports, "charat", ()=>A);
parcelHelpers.export(exports, "column", ()=>G);
parcelHelpers.export(exports, "combine", ()=>D);
parcelHelpers.export(exports, "comment", ()=>oe);
parcelHelpers.export(exports, "commenter", ()=>se);
parcelHelpers.export(exports, "compile", ()=>ue);
parcelHelpers.export(exports, "copy", ()=>N);
parcelHelpers.export(exports, "dealloc", ()=>Z);
parcelHelpers.export(exports, "declaration", ()=>le);
parcelHelpers.export(exports, "delimit", ()=>_);
parcelHelpers.export(exports, "delimiter", ()=>ce);
parcelHelpers.export(exports, "escaping", ()=>ne);
parcelHelpers.export(exports, "filter", ()=>E);
parcelHelpers.export(exports, "from", ()=>m);
parcelHelpers.export(exports, "hash", ()=>y);
parcelHelpers.export(exports, "identifier", ()=>te);
parcelHelpers.export(exports, "indexof", ()=>O);
parcelHelpers.export(exports, "length", ()=>H);
parcelHelpers.export(exports, "lift", ()=>P);
parcelHelpers.export(exports, "line", ()=>F);
parcelHelpers.export(exports, "match", ()=>z);
parcelHelpers.export(exports, "middleware", ()=>be);
parcelHelpers.export(exports, "namespace", ()=>ge);
parcelHelpers.export(exports, "next", ()=>T);
parcelHelpers.export(exports, "node", ()=>L);
parcelHelpers.export(exports, "parse", ()=>ie);
parcelHelpers.export(exports, "peek", ()=>U);
parcelHelpers.export(exports, "position", ()=>I);
parcelHelpers.export(exports, "prefix", ()=>pe);
parcelHelpers.export(exports, "prefixer", ()=>de);
parcelHelpers.export(exports, "prev", ()=>R);
parcelHelpers.export(exports, "replace", ()=>C);
parcelHelpers.export(exports, "ruleset", ()=>fe);
parcelHelpers.export(exports, "rulesheet", ()=>we);
parcelHelpers.export(exports, "serialize", ()=>ve);
parcelHelpers.export(exports, "sizeof", ()=>q);
parcelHelpers.export(exports, "slice", ()=>W);
parcelHelpers.export(exports, "stringify", ()=>he);
parcelHelpers.export(exports, "strlen", ()=>S);
parcelHelpers.export(exports, "substr", ()=>M);
parcelHelpers.export(exports, "token", ()=>X);
parcelHelpers.export(exports, "tokenize", ()=>ee);
parcelHelpers.export(exports, "tokenizer", ()=>ae);
parcelHelpers.export(exports, "trim", ()=>j);
parcelHelpers.export(exports, "whitespace", ()=>re);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var p = "@document";
var v = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var g = "@layer";
var k = "@scope";
var $ = Math.abs;
var m = String.fromCharCode;
var x = Object.assign;
function y(e, r) {
    return A(e, 0) ^ 45 ? (((r << 2 ^ A(e, 0)) << 2 ^ A(e, 1)) << 2 ^ A(e, 2)) << 2 ^ A(e, 3) : 0;
}
function j(e) {
    return e.trim();
}
function z(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function C(e, r, a) {
    return e.replace(r, a);
}
function O(e, r, a) {
    return e.indexOf(r, a);
}
function A(e, r) {
    return e.charCodeAt(r) | 0;
}
function M(e, r, a) {
    return e.slice(r, a);
}
function S(e) {
    return e.length;
}
function q(e) {
    return e.length;
}
function B(e, r) {
    return r.push(e), e;
}
function D(e, r) {
    return e.map(r).join("");
}
function E(e, r) {
    return e.filter(function(e) {
        return !z(e, r);
    });
}
var F = 1;
var G = 1;
var H = 0;
var I = 0;
var J = 0;
var K = "";
function L(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: F,
        column: G,
        length: t,
        return: "",
        siblings: u
    };
}
function N(e, r) {
    return x(L("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function P(e) {
    while(e.root)e = N(e.root, {
        children: [
            e
        ]
    });
    B(e, e.siblings);
}
function Q() {
    return J;
}
function R() {
    J = I > 0 ? A(K, --I) : 0;
    if (G--, J === 10) G = 1, F--;
    return J;
}
function T() {
    J = I < H ? A(K, I++) : 0;
    if (G++, J === 10) G = 1, F++;
    return J;
}
function U() {
    return A(K, I);
}
function V() {
    return I;
}
function W(e, r) {
    return M(K, e, r);
}
function X(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function Y(e) {
    return F = G = 1, H = S(K = e), I = 0, [];
}
function Z(e) {
    return K = "", e;
}
function _(e) {
    return j(W(I - 1, ce(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function ee(e) {
    return Z(ae(Y(e)));
}
function re(e) {
    while(J = U())if (J < 33) T();
    else break;
    return X(e) > 2 || X(J) > 3 ? "" : " ";
}
function ae(e) {
    while(T())switch(X(J)){
        case 0:
            B(te(I - 1), e);
            break;
        case 2:
            B(_(J), e);
            break;
        default:
            B(m(J), e);
    }
    return e;
}
function ne(e, r) {
    while(--r && T())if (J < 48 || J > 102 || J > 57 && J < 65 || J > 70 && J < 97) break;
    return W(e, V() + (r < 6 && U() == 32 && T() == 32));
}
function ce(e) {
    while(T())switch(J){
        case e:
            return I;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) ce(J);
            break;
        case 40:
            if (e === 41) ce(e);
            break;
        case 92:
            T();
            break;
    }
    return I;
}
function se(e, r) {
    while(T())if (e + J === 57) break;
    else if (e + J === 84 && U() === 47) break;
    return "/*" + W(r, I - 1) + "*" + m(e === 47 ? e : T());
}
function te(e) {
    while(!X(U()))T();
    return W(e, I);
}
function ue(e) {
    return Z(ie("", null, null, null, [
        ""
    ], e = Y(e), 0, [
        0
    ], e));
}
function ie(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = T()){
        case 40:
            if (h != 108 && A(z, l - 1) == 58) {
                if (O(z += C(_(g), "&", "&\f"), "&\f", $(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += _(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += re(h);
            break;
        case 92:
            z += ne(V() - 1, 7);
            continue;
        case 47:
            switch(U()){
                case 42:
                case 47:
                    B(oe(se(T(), V()), r, a, i), i);
                    if ((X(h || 1) == 5 || X(U() || 1) == 5) && S(z) && M(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = S(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = C(z, /\f/g, "");
                    if (v > 0 && (S(z) - l || b === 0 && h === 47)) B(v > 32 ? le(z + ";", n, a, l - 1, i) : le(C(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    B(j = fe(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) ie(z, r, j, j, x, s, l, u, y);
                        else switch(p === 99 && A(z, 3) === 110 ? 100 : p){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                ie(e, j, j, n && B(fe(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                ie(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + S(z), v = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && R() == 125) continue;
            }
            switch(z += m(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = (S(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if (U() === 45) z += _(T());
                    p = U(), o = l = S(k = z += te(V())), g++;
                    break;
                case 45:
                    if (h === 45 && S(z) == 2) b = 0;
            }
    }
    return s;
}
function fe(e, r, a, n, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = q(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = M(e, v + 1, v = $(d = u[w])), x = e; k < b; ++k)if (x = j(d > 0 ? h[k] + " " + m : C(m, /&\f/g, h[k]))) f[g++] = x;
    return L(e, r, a, s === 0 ? c : i, f, o, l, p);
}
function oe(e, r, a, c) {
    return L(e, r, a, n, m(Q()), M(e, 2, -2), 0, c);
}
function le(e, r, a, n, c) {
    return L(e, r, a, s, M(e, 0, n), M(e, n + 1, -1), n, c);
}
function pe(n, c, s) {
    switch(y(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return a + n + n;
        case 4855:
            return a + n.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(A(n, c + 11)){
                case 114:
                    return a + n + e + C(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + C(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + C(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + C(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + C(n, /flex-|-self/g, "") + (!z(n, /flex-|baseline/) ? e + "grid-row-" + C(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + C(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + C(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + C(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + C(n, "-grow", "") + a + n + e + C(n, "grow", "positive") + n;
        case 4554:
            return a + C(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return C(C(C(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return C(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return C(C(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /space-between/, "justify") + a + n + n;
        case 4200:
            if (!z(n, /flex-|baseline/)) return e + "grid-column-align" + M(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + C(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, z(e.props, /grid-\w+-end/);
            })) return ~O(n + (s = s[c].value), "span", 0) ? n : e + C(n, "-start", "") + n + e + "grid-row-span:" + (~O(s, "span", 0) ? z(s, /\d+/) : +z(s, /\d+/) - +z(n, /\d+/)) + ";";
            return e + C(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return z(e.props, /grid-\w+-start/);
            }) ? n : e + C(C(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return C(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (S(n) - 1 - c > 6) switch(A(n, c + 1)){
                case 109:
                    if (A(n, c + 4) !== 45) break;
                case 102:
                    return C(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (A(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~O(n, "stretch", 0) ? pe(C(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return C(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (A(n, c + 6) === 121) return C(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(A(n, A(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return C(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (A(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return C(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return C(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function ve(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function he(e, r, a, t) {
    switch(e.type){
        case g:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + ve(e.children, t) + "}";
        case c:
            if (!S(e.value = e.props.join(","))) return "";
    }
    return S(a = ve(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function be(e) {
    var r = q(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function we(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function de(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = pe(n.value, n.length, u);
                return;
            case h:
                return ve([
                    N(n, {
                        value: C(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return D(u = n.props, function(c) {
                    switch(z(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            P(N(n, {
                                props: [
                                    C(c, /:(read-\w+)/, ":" + r + "$1")
                                ]
                            }));
                            P(N(n, {
                                props: [
                                    c
                                ]
                            }));
                            x(n, {
                                props: E(u, i)
                            });
                            break;
                        case "::placeholder":
                            P(N(n, {
                                props: [
                                    C(c, /:(plac\w+)/, ":" + a + "input-$1")
                                ]
                            }));
                            P(N(n, {
                                props: [
                                    C(c, /:(plac\w+)/, ":" + r + "$1")
                                ]
                            }));
                            P(N(n, {
                                props: [
                                    C(c, /:(plac\w+)/, e + "input-$1")
                                ]
                            }));
                            P(N(n, {
                                props: [
                                    c
                                ]
                            }));
                            x(n, {
                                props: E(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function ge(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return D(ee(r), function(r, a, n) {
                    switch(A(r, 0)){
                        case 12:
                            return M(r, 1, S(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + M(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return q(n) > 1 ? "" : r;
                                case a = q(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"941eg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseKeysJs = require("./_baseKeys.js");
var _baseKeysJsDefault = parcelHelpers.interopDefault(_baseKeysJs);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** `Object#toString` result references. */ var mapTag = '[object Map]', setTag = '[object Set]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if ((0, _isArrayLikeJsDefault.default)(value) && ((0, _isArrayJsDefault.default)(value) || typeof value == 'string' || typeof value.splice == 'function' || (0, _isBufferJsDefault.default)(value) || (0, _isTypedArrayJsDefault.default)(value) || (0, _isArgumentsJsDefault.default)(value))) return !value.length;
    var tag = (0, _getTagJsDefault.default)(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if ((0, _isPrototypeJsDefault.default)(value)) return !(0, _baseKeysJsDefault.default)(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
exports.default = isEmpty;

},{"./_baseKeys.js":"kaIqL","./_getTag.js":"k5EiA","./isArguments.js":"dK8Bo","./isArray.js":"a5xfW","./isArrayLike.js":"dGrFC","./isBuffer.js":"b6M7J","./_isPrototype.js":"bwS2b","./isTypedArray.js":"11FzZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kaIqL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysJs = require("./_nativeKeys.js");
var _nativeKeysJsDefault = parcelHelpers.interopDefault(_nativeKeysJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!(0, _isPrototypeJsDefault.default)(object)) return (0, _nativeKeysJsDefault.default)(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
exports.default = baseKeys;

},{"./_isPrototype.js":"bwS2b","./_nativeKeys.js":"7bDiH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7bDiH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = (0, _overArgJsDefault.default)(Object.keys, Object);
exports.default = nativeKeys;

},{"./_overArg.js":"3VPN2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k5EiA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataViewJs = require("./_DataView.js");
var _dataViewJsDefault = parcelHelpers.interopDefault(_dataViewJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _promiseJs = require("./_Promise.js");
var _promiseJsDefault = parcelHelpers.interopDefault(_promiseJs);
var _setJs = require("./_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _weakMapJs = require("./_WeakMap.js");
var _weakMapJsDefault = parcelHelpers.interopDefault(_weakMapJs);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = (0, _toSourceJsDefault.default)((0, _dataViewJsDefault.default)), mapCtorString = (0, _toSourceJsDefault.default)((0, _mapJsDefault.default)), promiseCtorString = (0, _toSourceJsDefault.default)((0, _promiseJsDefault.default)), setCtorString = (0, _toSourceJsDefault.default)((0, _setJsDefault.default)), weakMapCtorString = (0, _toSourceJsDefault.default)((0, _weakMapJsDefault.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = (0, _baseGetTagJsDefault.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, _dataViewJsDefault.default) && getTag(new (0, _dataViewJsDefault.default)(new ArrayBuffer(1))) != dataViewTag || (0, _mapJsDefault.default) && getTag(new (0, _mapJsDefault.default)) != mapTag || (0, _promiseJsDefault.default) && getTag((0, _promiseJsDefault.default).resolve()) != promiseTag || (0, _setJsDefault.default) && getTag(new (0, _setJsDefault.default)) != setTag || (0, _weakMapJsDefault.default) && getTag(new (0, _weakMapJsDefault.default)) != weakMapTag) getTag = function(value) {
    var result = (0, _baseGetTagJsDefault.default)(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, _toSourceJsDefault.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
exports.default = getTag;

},{"./_DataView.js":"czDUC","./_Map.js":"gBkLr","./_Promise.js":"8FXqC","./_Set.js":"ezpvh","./_WeakMap.js":"bo2vf","./_baseGetTag.js":"cZgKC","./_toSource.js":"hV6pF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"czDUC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var DataView = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'DataView');
exports.default = DataView;

},{"./_getNative.js":"8XHOL","./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8FXqC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Promise = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'Promise');
exports.default = Promise;

},{"./_getNative.js":"8XHOL","./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ezpvh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Set = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'Set');
exports.default = Set;

},{"./_getNative.js":"8XHOL","./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bo2vf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var WeakMap = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'WeakMap');
exports.default = WeakMap;

},{"./_getNative.js":"8XHOL","./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1K0qS":[function(require,module,exports,__globalThis) {
module.exports = require("26b7b46cd7dd9e23")(require("89faebf1845f7bed").resolve("kGWQr")).then(()=>module.bundle.root('6LO8h'));

},{"26b7b46cd7dd9e23":"hpx0h","89faebf1845f7bed":"fyJL2"}],"hpx0h":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"1uYxD"}],"1uYxD":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"77gTB":[function(require,module,exports,__globalThis) {
module.exports = require("867def400510a1fd")(require("4f2745a571bb95e").resolve("2A1Ed")).then(()=>module.bundle.root('gS5ju'));

},{"867def400510a1fd":"hpx0h","4f2745a571bb95e":"fyJL2"}],"aHa1h":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("7f60817152b26b16")(require("da8d928fc27c2fea").resolve("ue9p7")),
    require("7f60817152b26b16")(require("da8d928fc27c2fea").resolve("dodf4")),
    require("7f60817152b26b16")(require("da8d928fc27c2fea").resolve("16dux")),
    require("7f60817152b26b16")(require("da8d928fc27c2fea").resolve("52haI")),
    require("7f60817152b26b16")(require("da8d928fc27c2fea").resolve("fwxBT")),
    require("7f60817152b26b16")(require("da8d928fc27c2fea").resolve("03laf")),
    require("7f60817152b26b16")(require("da8d928fc27c2fea").resolve("7X6bZ"))
]).then(()=>module.bundle.root('c19HC'));

},{"7f60817152b26b16":"hpx0h","da8d928fc27c2fea":"fyJL2"}],"22J22":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("240f7990d3e224d6")(require("98437d01c11c6fe7").resolve("ue9p7")),
    require("240f7990d3e224d6")(require("98437d01c11c6fe7").resolve("dodf4")),
    require("240f7990d3e224d6")(require("98437d01c11c6fe7").resolve("16dux")),
    require("240f7990d3e224d6")(require("98437d01c11c6fe7").resolve("52haI")),
    require("240f7990d3e224d6")(require("98437d01c11c6fe7").resolve("fwxBT")),
    require("240f7990d3e224d6")(require("98437d01c11c6fe7").resolve("03laf")),
    require("240f7990d3e224d6")(require("98437d01c11c6fe7").resolve("5JGKy"))
]).then(()=>module.bundle.root('azdOx'));

},{"240f7990d3e224d6":"hpx0h","98437d01c11c6fe7":"fyJL2"}],"85Fyu":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("197a62c4273ec3f4")(require("8c085843b79c0871").resolve("52haI")),
    require("197a62c4273ec3f4")(require("8c085843b79c0871").resolve("fwxBT")),
    require("197a62c4273ec3f4")(require("8c085843b79c0871").resolve("6bhfu"))
]).then(()=>module.bundle.root('2uw2k'));

},{"197a62c4273ec3f4":"hpx0h","8c085843b79c0871":"fyJL2"}],"6PSuR":[function(require,module,exports,__globalThis) {
module.exports = require("86dfd9d6c24906c8")(require("5b846f11e7eb069c").resolve("cbmiS")).then(()=>module.bundle.root('64GBR'));

},{"86dfd9d6c24906c8":"hpx0h","5b846f11e7eb069c":"fyJL2"}],"fNAdV":[function(require,module,exports,__globalThis) {
module.exports = require("51eb25d6aae1ca38")(require("7d8d9e5adeb4e802").resolve("dnuuZ")).then(()=>module.bundle.root('kLNoS'));

},{"51eb25d6aae1ca38":"hpx0h","7d8d9e5adeb4e802":"fyJL2"}],"hEDJk":[function(require,module,exports,__globalThis) {
module.exports = require("7bdf7425003be401")(require("b7683c49ef6bb316").resolve("k1Rxv")).then(()=>module.bundle.root('aRgZc'));

},{"7bdf7425003be401":"hpx0h","b7683c49ef6bb316":"fyJL2"}],"1mL96":[function(require,module,exports,__globalThis) {
module.exports = require("c36660533bb0624d")(require("24356513c720645d").resolve("gxpVo")).then(()=>module.bundle.root('eaYGA'));

},{"c36660533bb0624d":"hpx0h","24356513c720645d":"fyJL2"}],"gxMYj":[function(require,module,exports,__globalThis) {
module.exports = require("9faf31ae5d7c6def")(require("de934cabe5fa271d").resolve("cEKMF")).then(()=>module.bundle.root('8ZYAE'));

},{"9faf31ae5d7c6def":"hpx0h","de934cabe5fa271d":"fyJL2"}],"dpacc":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("c4e2db6c936e073f")(require("38581657dc19fd73").resolve("ue9p7")),
    require("c4e2db6c936e073f")(require("38581657dc19fd73").resolve("9NcRT"))
]).then(()=>module.bundle.root('gqoEA'));

},{"c4e2db6c936e073f":"hpx0h","38581657dc19fd73":"fyJL2"}],"bSwBL":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("5c85405c4ee3a78d")(require("676328930b2f78f").resolve("52haI")),
    require("5c85405c4ee3a78d")(require("676328930b2f78f").resolve("fwxBT")),
    require("5c85405c4ee3a78d")(require("676328930b2f78f").resolve("kBILH"))
]).then(()=>module.bundle.root('cJyKE'));

},{"5c85405c4ee3a78d":"hpx0h","676328930b2f78f":"fyJL2"}],"hO4q3":[function(require,module,exports,__globalThis) {
module.exports = require("c9f9b8f055fa536d")(require("62543c7a67e58cba").resolve("bGoN2")).then(()=>module.bundle.root('65XXF'));

},{"c9f9b8f055fa536d":"hpx0h","62543c7a67e58cba":"fyJL2"}],"hInfo":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("1a1cc156b8473791")(require("8cb738b56324b660").resolve("gsHsw")),
    require("1a1cc156b8473791")(require("8cb738b56324b660").resolve("52haI")),
    require("1a1cc156b8473791")(require("8cb738b56324b660").resolve("fwxBT")),
    require("1a1cc156b8473791")(require("8cb738b56324b660").resolve("fscn8"))
]).then(()=>module.bundle.root('94LbP'));

},{"1a1cc156b8473791":"hpx0h","8cb738b56324b660":"fyJL2"}],"l2J2A":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("1106cf46b8a69d5")(require("b15946420a11d185").resolve("gsHsw")),
    require("1106cf46b8a69d5")(require("b15946420a11d185").resolve("ue9p7")),
    require("1106cf46b8a69d5")(require("b15946420a11d185").resolve("dodf4")),
    require("1106cf46b8a69d5")(require("b15946420a11d185").resolve("16dux")),
    require("1106cf46b8a69d5")(require("b15946420a11d185").resolve("52haI")),
    require("1106cf46b8a69d5")(require("b15946420a11d185").resolve("fwxBT")),
    require("1106cf46b8a69d5")(require("b15946420a11d185").resolve("HCiQQ"))
]).then(()=>module.bundle.root('fFBiN'));

},{"1106cf46b8a69d5":"hpx0h","b15946420a11d185":"fyJL2"}],"gfn2d":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("35fb3d172aff29b0")(require("d921a0502b28e43e").resolve("dmVc6")),
    require("35fb3d172aff29b0")(require("d921a0502b28e43e").resolve("52haI")),
    require("35fb3d172aff29b0")(require("d921a0502b28e43e").resolve("fwxBT")),
    require("35fb3d172aff29b0")(require("d921a0502b28e43e").resolve("hY17g"))
]).then(()=>module.bundle.root('ikdjD'));

},{"35fb3d172aff29b0":"hpx0h","d921a0502b28e43e":"fyJL2"}],"gUKJf":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("410c5e38b5d5f16c")(require("ca9b239c917b6a73").resolve("dmVc6")),
    require("410c5e38b5d5f16c")(require("ca9b239c917b6a73").resolve("ue9p7")),
    require("410c5e38b5d5f16c")(require("ca9b239c917b6a73").resolve("dodf4")),
    require("410c5e38b5d5f16c")(require("ca9b239c917b6a73").resolve("16dux")),
    require("410c5e38b5d5f16c")(require("ca9b239c917b6a73").resolve("52haI")),
    require("410c5e38b5d5f16c")(require("ca9b239c917b6a73").resolve("fwxBT")),
    require("410c5e38b5d5f16c")(require("ca9b239c917b6a73").resolve("dHrDz"))
]).then(()=>module.bundle.root('f8gmr'));

},{"410c5e38b5d5f16c":"hpx0h","ca9b239c917b6a73":"fyJL2"}],"f5Y5V":[function(require,module,exports,__globalThis) {
module.exports = require("88665ded5ca52440")(require("6ec493385a052e75").resolve("3qaDE")).then(()=>module.bundle.root('iARtO'));

},{"88665ded5ca52440":"hpx0h","6ec493385a052e75":"fyJL2"}],"i9zIT":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("b6262af7d1779b86")(require("9d66edeaac9d3001").resolve("ue9p7")),
    require("b6262af7d1779b86")(require("9d66edeaac9d3001").resolve("dodf4")),
    require("b6262af7d1779b86")(require("9d66edeaac9d3001").resolve("03laf")),
    require("b6262af7d1779b86")(require("9d66edeaac9d3001").resolve("e5hsg"))
]).then(()=>module.bundle.root('aGiU2'));

},{"b6262af7d1779b86":"hpx0h","9d66edeaac9d3001":"fyJL2"}],"7im3Y":[function(require,module,exports,__globalThis) {
module.exports = require("eb317ce2c4f5d739")(require("7a1cba2fc3d4f72d").resolve("8qEpA")).then(()=>module.bundle.root('4AKFu'));

},{"eb317ce2c4f5d739":"hpx0h","7a1cba2fc3d4f72d":"fyJL2"}],"fXREA":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("c4fe5d3b3a3b07b6")(require("832848102a80a2cf").resolve("ue9p7")),
    require("c4fe5d3b3a3b07b6")(require("832848102a80a2cf").resolve("5RTCw"))
]).then(()=>module.bundle.root('lD7Li'));

},{"c4fe5d3b3a3b07b6":"hpx0h","832848102a80a2cf":"fyJL2"}],"ensOo":[function(require,module,exports,__globalThis) {
module.exports = require("1a8bdfbe0a7f1439")(require("669b130d118bf373").resolve("kFBvY")).then(()=>module.bundle.root('8bo5t'));

},{"1a8bdfbe0a7f1439":"hpx0h","669b130d118bf373":"fyJL2"}],"aOhCD":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("38af6d507123ec00")(require("73951f37977641f7").resolve("ue9p7")),
    require("38af6d507123ec00")(require("73951f37977641f7").resolve("dodf4")),
    require("38af6d507123ec00")(require("73951f37977641f7").resolve("fwxBT")),
    require("38af6d507123ec00")(require("73951f37977641f7").resolve("jJqae"))
]).then(()=>module.bundle.root('aJ7gR'));

},{"38af6d507123ec00":"hpx0h","73951f37977641f7":"fyJL2"}],"7VgM2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResizeHandle);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lucideReact = require("lucide-react");
function ResizeHandle({ onResize }) {
    const [isDragging, setIsDragging] = (0, _react.useState)(false);
    const handleMouseDown = (0, _react.useCallback)((e)=>{
        e.preventDefault();
        setIsDragging(true);
    }, []);
    (0, _react.useEffect)(()=>{
        const handleMouseMove = (e)=>{
            if (!isDragging) return;
            const windowWidth = window.innerWidth;
            const newWidth = e.clientX / windowWidth * 100;
            onResize(newWidth);
        };
        const handleMouseUp = ()=>{
            setIsDragging(false);
        };
        if (isDragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }
        return ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [
        isDragging,
        onResize
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `w-4 h-full cursor-col-resize flex items-center justify-center
        hover:bg-gray-200 active:bg-gray-300 transition-colors
        ${isDragging ? 'bg-gray-300' : ''}
      `,
        style: {
            position: 'relative',
            margin: '0 -8px',
            zIndex: 10
        },
        onMouseDown: handleMouseDown,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "h-16 flex items-center justify-center",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.GripVertical), {
                className: "w-4 h-4 text-gray-400"
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","lucide-react":"62Bzb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6QvPG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildGraph", ()=>buildGraph);
var _web = require("@langchain/langgraph/web");
var _prompts = require("@langchain/core/prompts");
var _openai = require("@langchain/openai");
var _assemblyai = require("assemblyai");
var _promptKeypointsTxt = require("bundle-text:./res/prompt-keypoints.txt");
var _promptKeypointsTxtDefault = parcelHelpers.interopDefault(_promptKeypointsTxt);
var _promptKeypointsLemurTxt = require("bundle-text:./res/prompt-keypoints-lemur.txt");
var _promptKeypointsLemurTxtDefault = parcelHelpers.interopDefault(_promptKeypointsLemurTxt);
var _promptSummary2MermaidTxt = require("bundle-text:./res/prompt-summary2mermaid.txt");
var _promptSummary2MermaidTxtDefault = parcelHelpers.interopDefault(_promptSummary2MermaidTxt);
const StateAnnotation = (0, _web.Annotation).Root({
    input: (0, _web.Annotation),
    transcript: (0, _web.Annotation),
    summary: (0, _web.Annotation),
    mindmap: (0, _web.Annotation),
    progress: (0, _web.Annotation)
});
const transcribeFromAudio = (assemblyAIKey)=>async (state)=>{
        console.log('transcribeFromAudio');
        state.progress('Transcribe from audio ...');
        const { input: audio } = state;
        if (!audio) throw new Error("audio is invalid");
        const client = new (0, _assemblyai.AssemblyAI)({
            apiKey: assemblyAIKey
        });
        const response = await client.transcripts.transcribe({
            audio
        });
        if (response.status == 'error') throw new Error("Transcript error: " + response.error);
        const { text: transcript } = response;
        state.progress('Transcription completed!');
        return {
            transcript
        };
    };
const extractKeypointsFromAudioTranscript = (assemblyAIKey)=>async (state)=>{
        console.log('extractKeypointsFromAudiotTranscript');
        state.progress('Extract Keypoints from audio transcription ...');
        const { transcript } = state;
        if (!transcript) throw new Error("Transcript is empty");
        if (typeof transcript === 'string') throw new Error("Transcript is not valid Transcript object");
        if (!('audio_url' in transcript)) throw new Error("Transcript is not valif Transcript object");
        const client = new (0, _assemblyai.AssemblyAI)({
            apiKey: assemblyAIKey
        });
        const { response } = await client.lemur.task({
            transcript_ids: [
                transcript.id
            ],
            prompt: (0, _promptKeypointsLemurTxtDefault.default),
            final_model: 'anthropic/claude-3-5-sonnet'
        });
        state.progress('Keypoints extracted!');
        return {
            summary: response
        };
    };
const extractKeypointsFromTranscript = (openAIApiKey)=>async (state)=>{
        console.log('extractKeypointsFromTranscript');
        state.progress('Extract Keypoints from text transcription ...');
        let transcript = null;
        if (state.transcript && typeof state.transcript === 'string') transcript = state.transcript;
        else if (state.input && typeof state.input === 'string') transcript = state.input;
        if (!transcript || transcript === "") throw new Error("Transcript is empty");
        const promptTpl = (0, _prompts.PromptTemplate).fromTemplate((0, _promptKeypointsTxtDefault.default));
        const prompt = await promptTpl.invoke({
            transcript
        });
        const model = new (0, _openai.ChatOpenAI)({
            openAIApiKey: openAIApiKey,
            model: "gpt-4o-mini",
            temperature: 0
        });
        const response = await model.invoke(prompt);
        state.progress('Keypoints extracted!');
        return {
            summary: response.content
        };
    };
const transformSummaryToMindmap = (openAIApiKey)=>async (state)=>{
        console.log('transformSummaryToMindmap');
        state.progress('Generate mindmap from summary ...');
        const { summary } = state;
        if (!summary || summary === "") throw new Error("Summary is empty");
        const promptTpl = (0, _prompts.PromptTemplate).fromTemplate((0, _promptSummary2MermaidTxtDefault.default));
        const prompt = await promptTpl.invoke({
            summary
        });
        const model = new (0, _openai.ChatOpenAI)({
            openAIApiKey: openAIApiKey,
            model: "gpt-4o-mini",
            temperature: 0
        });
        const response = await model.invoke(prompt);
        state.progress('Mindmap generated!');
        return {
            mindmap: response.content
        };
    };
async function mindmapToMermaid(state) {
    console.log('mindmapToMermaid');
    state.progress('Convert mindmap to mermaid synatx ...');
    const { mindmap } = state;
    if (!mindmap || mindmap === "") throw new Error("Mindmap is empty");
    const mindmapUpdated = mindmap.replace(/^```(mermaid|html)\s*/, "").replace(/```$/, "").trim();
    console.log(mindmapUpdated);
    state.progress('Mmermaid diagram generated!');
    return {
        mindmap: mindmapUpdated
    };
}
function buildGraph({ openAIApiKey, assemblyAIApiKey }) {
    if (!openAIApiKey) throw new Error("OPENAI_API_KEY is not set");
    if (!assemblyAIApiKey) throw new Error("ASSEMBLYAI_API_KEY is not set");
    return new (0, _web.StateGraph)(StateAnnotation).addNode('transcribe-from-audio', transcribeFromAudio(assemblyAIApiKey)).addNode('keypoints-from-transcript', extractKeypointsFromTranscript(openAIApiKey)).addNode('keypoints-from-audio-transcript', extractKeypointsFromAudioTranscript(assemblyAIApiKey)).addNode('summary-to-mindmap', transformSummaryToMindmap(openAIApiKey)).addNode('mindmap-to-mermaid', mindmapToMermaid).addConditionalEdges((0, _web.START), (state)=>{
        if (typeof state.input === 'string') return 'keypoints-from-transcript';
        if (state.input instanceof Blob) return 'transcribe-from-audio';
        return 0, _web.END;
    })// .addEdge( 'transcribe-from-audio', 'keypoints-from-audio-transcript' )
    // .addEdge( 'keypoints-from-audio-transcript', 'summary-to-mindmap' )
    .addEdge('transcribe-from-audio', 'keypoints-from-transcript').addEdge('keypoints-from-transcript', 'summary-to-mindmap').addEdge('summary-to-mindmap', 'mindmap-to-mermaid').addEdge('mindmap-to-mermaid', (0, _web.END));
}

},{"@langchain/langgraph/web":"lFzoW","@langchain/core/prompts":"2qirM","@langchain/openai":"ilsHK","assemblyai":"9XZHq","bundle-text:./res/prompt-keypoints.txt":"lNf0p","bundle-text:./res/prompt-keypoints-lemur.txt":"fmkmc","bundle-text:./res/prompt-summary2mermaid.txt":"hZSyP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lFzoW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _webJs = require("./dist/web.js");
parcelHelpers.exportAll(_webJs, exports);

},{"./dist/web.js":"8rtD1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8rtD1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "END", ()=>(0, _indexJs.END));
parcelHelpers.export(exports, "Graph", ()=>(0, _indexJs.Graph));
parcelHelpers.export(exports, "START", ()=>(0, _indexJs.START));
parcelHelpers.export(exports, "StateGraph", ()=>(0, _indexJs.StateGraph));
parcelHelpers.export(exports, "CompiledStateGraph", ()=>(0, _indexJs.CompiledStateGraph));
parcelHelpers.export(exports, "MessageGraph", ()=>(0, _indexJs.MessageGraph));
parcelHelpers.export(exports, "messagesStateReducer", ()=>(0, _indexJs.messagesStateReducer));
parcelHelpers.export(exports, "Annotation", ()=>(0, _indexJs.Annotation));
parcelHelpers.export(exports, "BaseChannel", ()=>(0, _indexJs1.BaseChannel));
parcelHelpers.export(exports, "BinaryOperatorAggregate", ()=>(0, _indexJs1.BinaryOperatorAggregate));
parcelHelpers.export(exports, "Send", ()=>(0, _constantsJs.Send));
parcelHelpers.export(exports, "MemorySaver", ()=>(0, _langgraphCheckpoint.MemorySaver));
parcelHelpers.export(exports, "copyCheckpoint", ()=>(0, _langgraphCheckpoint.copyCheckpoint));
parcelHelpers.export(exports, "emptyCheckpoint", ()=>(0, _langgraphCheckpoint.emptyCheckpoint));
parcelHelpers.export(exports, "BaseCheckpointSaver", ()=>(0, _langgraphCheckpoint.BaseCheckpointSaver));
parcelHelpers.export(exports, "BaseStore", ()=>(0, _langgraphCheckpoint.BaseStore));
parcelHelpers.export(exports, "AsyncBatchedStore", ()=>(0, _langgraphCheckpoint.AsyncBatchedStore));
parcelHelpers.export(exports, "InMemoryStore", ()=>(0, _langgraphCheckpoint.InMemoryStore));
parcelHelpers.export(exports, "MessagesAnnotation", ()=>(0, _messagesAnnotationJs.MessagesAnnotation));
var _indexJs = require("./graph/index.js");
var _errorsJs = require("./errors.js");
parcelHelpers.exportAll(_errorsJs, exports);
var _indexJs1 = require("./channels/index.js");
var _constantsJs = require("./constants.js");
var _langgraphCheckpoint = require("@langchain/langgraph-checkpoint");
var _indexJs2 = require("./managed/index.js");
parcelHelpers.exportAll(_indexJs2, exports);
var _messagesAnnotationJs = require("./graph/messages_annotation.js");

},{"./graph/index.js":"asnlo","./errors.js":"jKiOM","./channels/index.js":"eNDfC","./constants.js":"1BFWS","@langchain/langgraph-checkpoint":"jLOBB","./managed/index.js":"1WGxa","./graph/messages_annotation.js":"7F7Og","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"asnlo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Annotation", ()=>(0, _annotationJs.Annotation));
parcelHelpers.export(exports, "AnnotationRoot", ()=>(0, _annotationJs.AnnotationRoot));
parcelHelpers.export(exports, "END", ()=>(0, _graphJs.END));
parcelHelpers.export(exports, "START", ()=>(0, _graphJs.START));
parcelHelpers.export(exports, "Graph", ()=>(0, _graphJs.Graph));
parcelHelpers.export(exports, "StateGraph", ()=>(0, _stateJs.StateGraph));
parcelHelpers.export(exports, "CompiledStateGraph", ()=>(0, _stateJs.CompiledStateGraph));
parcelHelpers.export(exports, "MessageGraph", ()=>(0, _messageJs.MessageGraph));
parcelHelpers.export(exports, "messagesStateReducer", ()=>(0, _messageJs.messagesStateReducer));
var _annotationJs = require("./annotation.js");
var _graphJs = require("./graph.js");
var _stateJs = require("./state.js");
var _messageJs = require("./message.js");

},{"./annotation.js":"kRFZA","./graph.js":"20bEW","./state.js":"l4IZ7","./message.js":"3KDDa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kRFZA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Should not be instantiated directly. See {@link Annotation}.
 * @internal
 */ parcelHelpers.export(exports, "AnnotationRoot", ()=>AnnotationRoot);
parcelHelpers.export(exports, "Annotation", ()=>Annotation);
parcelHelpers.export(exports, "getChannel", ()=>getChannel);
var _binopJs = require("../channels/binop.js");
var _lastValueJs = require("../channels/last_value.js");
var _baseJs = require("../managed/base.js");
class AnnotationRoot {
    constructor(s){
        Object.defineProperty(this, "lc_graph_name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AnnotationRoot"
        });
        Object.defineProperty(this, "spec", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.spec = s;
    }
}
const Annotation = function(annotation) {
    if ((0, _baseJs.isConfiguredManagedValue)(annotation)) return annotation;
    else if (annotation) return getChannel(annotation);
    else // @ts-expect-error - Annotation without reducer
    return new (0, _lastValueJs.LastValue)();
};
Annotation.Root = (sd)=>new AnnotationRoot(sd);
function getChannel(reducer) {
    if (typeof reducer === "object" && reducer && "reducer" in reducer && reducer.reducer) return new (0, _binopJs.BinaryOperatorAggregate)(reducer.reducer, reducer.default);
    if (typeof reducer === "object" && reducer && "value" in reducer && reducer.value) return new (0, _binopJs.BinaryOperatorAggregate)(reducer.value, reducer.default);
    // @ts-expect-error - Annotation without reducer
    return new (0, _lastValueJs.LastValue)();
}

},{"../channels/binop.js":"bYoJO","../channels/last_value.js":"kuySs","../managed/base.js":"4p0hG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bYoJO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Stores the result of applying a binary operator to the current value and each new value.
 */ parcelHelpers.export(exports, "BinaryOperatorAggregate", ()=>BinaryOperatorAggregate);
var _errorsJs = require("../errors.js");
var _baseJs = require("./base.js");
class BinaryOperatorAggregate extends (0, _baseJs.BaseChannel) {
    constructor(operator, initialValueFactory){
        super();
        Object.defineProperty(this, "lc_graph_name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BinaryOperatorAggregate"
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "operator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "initialValueFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.operator = operator;
        this.initialValueFactory = initialValueFactory;
        this.value = initialValueFactory?.();
    }
    fromCheckpoint(checkpoint) {
        const empty = new BinaryOperatorAggregate(this.operator, this.initialValueFactory);
        if (checkpoint) empty.value = checkpoint;
        return empty;
    }
    update(values) {
        let newValues = values;
        if (!newValues.length) return false;
        if (this.value === undefined) {
            [this.value] = newValues;
            newValues = newValues.slice(1);
        }
        for (const value of newValues)if (this.value !== undefined) this.value = this.operator(this.value, value);
        return true;
    }
    get() {
        if (this.value === undefined) throw new (0, _errorsJs.EmptyChannelError)();
        return this.value;
    }
    checkpoint() {
        if (this.value === undefined) throw new (0, _errorsJs.EmptyChannelError)();
        return this.value;
    }
}

},{"../errors.js":"jKiOM","./base.js":"UYQzM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jKiOM":[function(require,module,exports,__globalThis) {
// TODO: Merge with base LangChain error class when we drop support for core@0.2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseLangGraphError", ()=>BaseLangGraphError);
parcelHelpers.export(exports, "GraphRecursionError", ()=>GraphRecursionError);
parcelHelpers.export(exports, "GraphValueError", ()=>GraphValueError);
parcelHelpers.export(exports, "GraphInterrupt", ()=>GraphInterrupt);
/** Raised by a node to interrupt execution. */ parcelHelpers.export(exports, "NodeInterrupt", ()=>NodeInterrupt);
parcelHelpers.export(exports, "isGraphInterrupt", ()=>isGraphInterrupt);
parcelHelpers.export(exports, "EmptyInputError", ()=>EmptyInputError);
parcelHelpers.export(exports, "EmptyChannelError", ()=>EmptyChannelError);
parcelHelpers.export(exports, "InvalidUpdateError", ()=>InvalidUpdateError);
parcelHelpers.export(exports, "MultipleSubgraphsError", ()=>MultipleSubgraphsError);
/**
 * Exception raised when an error occurs in the remote graph.
 */ parcelHelpers.export(exports, "RemoteException", ()=>RemoteException);
parcelHelpers.export(exports, "getSubgraphsSeenSet", ()=>getSubgraphsSeenSet);
class BaseLangGraphError extends Error {
    constructor(message, fields){
        let finalMessage = message ?? "";
        if (fields?.lc_error_code) finalMessage = `${finalMessage}\n\nTroubleshooting URL: https://js.langchain.com/docs/troubleshooting/errors/${fields.lc_error_code}/\n`;
        super(finalMessage);
        Object.defineProperty(this, "lc_error_code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.lc_error_code = fields?.lc_error_code;
    }
}
class GraphRecursionError extends BaseLangGraphError {
    constructor(message, fields){
        super(message, fields);
        this.name = "GraphRecursionError";
    }
    static get unminifiable_name() {
        return "GraphRecursionError";
    }
}
class GraphValueError extends BaseLangGraphError {
    constructor(message, fields){
        super(message, fields);
        this.name = "GraphValueError";
    }
    static get unminifiable_name() {
        return "GraphValueError";
    }
}
class GraphInterrupt extends BaseLangGraphError {
    constructor(interrupts, fields){
        super(JSON.stringify(interrupts, null, 2), fields);
        Object.defineProperty(this, "interrupts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = "GraphInterrupt";
        this.interrupts = interrupts ?? [];
    }
    static get unminifiable_name() {
        return "GraphInterrupt";
    }
}
class NodeInterrupt extends GraphInterrupt {
    constructor(message, fields){
        super([
            {
                value: message,
                when: "during"
            }
        ], fields);
        this.name = "NodeInterrupt";
    }
    static get unminifiable_name() {
        return "NodeInterrupt";
    }
}
function isGraphInterrupt(e) {
    return e !== undefined && [
        GraphInterrupt.unminifiable_name,
        NodeInterrupt.unminifiable_name
    ].includes(e.name);
}
class EmptyInputError extends BaseLangGraphError {
    constructor(message, fields){
        super(message, fields);
        this.name = "EmptyInputError";
    }
    static get unminifiable_name() {
        return "EmptyInputError";
    }
}
class EmptyChannelError extends BaseLangGraphError {
    constructor(message, fields){
        super(message, fields);
        this.name = "EmptyChannelError";
    }
    static get unminifiable_name() {
        return "EmptyChannelError";
    }
}
class InvalidUpdateError extends BaseLangGraphError {
    constructor(message, fields){
        super(message, fields);
        this.name = "InvalidUpdateError";
    }
    static get unminifiable_name() {
        return "InvalidUpdateError";
    }
}
class MultipleSubgraphsError extends BaseLangGraphError {
    constructor(message, fields){
        super(message, fields);
        this.name = "MultipleSubgraphError";
    }
    static get unminifiable_name() {
        return "MultipleSubgraphError";
    }
}
class RemoteException extends BaseLangGraphError {
    constructor(message, fields){
        super(message, fields);
        this.name = "RemoteException";
    }
    static get unminifiable_name() {
        return "RemoteException";
    }
}
const getSubgraphsSeenSet = ()=>{
    if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
    globalThis[Symbol.for("LG_CHECKPOINT_SEEN_NS_SET")] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    globalThis[Symbol.for("LG_CHECKPOINT_SEEN_NS_SET")] = new Set();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return globalThis[Symbol.for("LG_CHECKPOINT_SEEN_NS_SET")];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"UYQzM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBaseChannel", ()=>isBaseChannel);
parcelHelpers.export(exports, "BaseChannel", ()=>BaseChannel);
parcelHelpers.export(exports, "emptyChannels", ()=>emptyChannels);
parcelHelpers.export(exports, "createCheckpoint", ()=>createCheckpoint);
var _langgraphCheckpoint = require("@langchain/langgraph-checkpoint");
var _errorsJs = require("../errors.js");
function isBaseChannel(obj) {
    return obj != null && obj.lg_is_channel === true;
}
class BaseChannel {
    constructor(){
        Object.defineProperty(this, "ValueType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "UpdateType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** @ignore */ Object.defineProperty(this, "lg_is_channel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
    }
    /**
     * Mark the current value of the channel as consumed. By default, no-op.
     * This is called by Pregel before the start of the next step, for all
     * channels that triggered a node. If the channel was updated, return true.
     */ consume() {
        return false;
    }
}
function emptyChannels(channels, checkpoint) {
    const filteredChannels = Object.fromEntries(Object.entries(channels).filter(([, value])=>isBaseChannel(value)));
    const newChannels = {};
    for(const k in filteredChannels)if (Object.prototype.hasOwnProperty.call(filteredChannels, k)) {
        const channelValue = checkpoint.channel_values[k];
        newChannels[k] = filteredChannels[k].fromCheckpoint(channelValue);
    }
    return newChannels;
}
function createCheckpoint(checkpoint, channels, step) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let values;
    if (channels === undefined) values = checkpoint.channel_values;
    else {
        values = {};
        for (const k of Object.keys(channels))try {
            values[k] = channels[k].checkpoint();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.name === (0, _errorsJs.EmptyChannelError).unminifiable_name) ;
            else throw error; // Rethrow unexpected errors
        }
    }
    return {
        v: 1,
        id: (0, _langgraphCheckpoint.uuid6)(step),
        ts: new Date().toISOString(),
        channel_values: values,
        channel_versions: {
            ...checkpoint.channel_versions
        },
        versions_seen: (0, _langgraphCheckpoint.deepCopy)(checkpoint.versions_seen),
        pending_sends: checkpoint.pending_sends ?? []
    };
}

},{"@langchain/langgraph-checkpoint":"jLOBB","../errors.js":"jKiOM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jLOBB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./dist/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"./dist/index.js":"9l6BP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9l6BP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemorySaver", ()=>(0, _memoryJs.MemorySaver));
var _memoryJs = require("./memory.js");
var _baseJs = require("./base.js");
parcelHelpers.exportAll(_baseJs, exports);
var _idJs = require("./id.js");
parcelHelpers.exportAll(_idJs, exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _baseJs1 = require("./serde/base.js");
parcelHelpers.exportAll(_baseJs1, exports);
var _typesJs1 = require("./serde/types.js");
parcelHelpers.exportAll(_typesJs1, exports);
var _indexJs = require("./store/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"./memory.js":"4szrb","./base.js":"ev3Q2","./id.js":"gO9AU","./types.js":"1DleB","./serde/base.js":"7VUFX","./serde/types.js":"dvtCD","./store/index.js":"c1Cbq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4szrb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemorySaver", ()=>MemorySaver);
var _baseJs = require("./base.js");
var _typesJs = require("./serde/types.js");
function _generateKey(threadId, checkpointNamespace, checkpointId) {
    return JSON.stringify([
        threadId,
        checkpointNamespace,
        checkpointId
    ]);
}
class MemorySaver extends (0, _baseJs.BaseCheckpointSaver) {
    constructor(serde){
        super(serde);
        // thread ID ->  checkpoint namespace -> checkpoint ID -> checkpoint mapping
        Object.defineProperty(this, "storage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "writes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
    }
    async _getPendingSends(threadId, checkpointNs, parentCheckpointId) {
        let pendingSends = [];
        if (parentCheckpointId !== undefined) pendingSends = await Promise.all(this.writes[_generateKey(threadId, checkpointNs, parentCheckpointId)]?.filter(([_taskId, channel])=>{
            return channel === (0, _typesJs.TASKS);
        }).map(([_taskId, _channel, writes])=>{
            return this.serde.loadsTyped("json", writes);
        }) ?? []);
        return pendingSends;
    }
    async getTuple(config) {
        const thread_id = config.configurable?.thread_id;
        const checkpoint_ns = config.configurable?.checkpoint_ns ?? "";
        let checkpoint_id = config.configurable?.checkpoint_id;
        if (checkpoint_id) {
            const saved = this.storage[thread_id]?.[checkpoint_ns]?.[checkpoint_id];
            if (saved !== undefined) {
                const [checkpoint, metadata, parentCheckpointId] = saved;
                const writes = this.writes[_generateKey(thread_id, checkpoint_ns, checkpoint_id)] ?? [];
                const pending_sends = await this._getPendingSends(thread_id, checkpoint_ns, parentCheckpointId);
                const deserializedCheckpoint = {
                    ...await this.serde.loadsTyped("json", checkpoint),
                    pending_sends
                };
                const pendingWrites = await Promise.all(writes.map(async ([taskId, channel, value])=>{
                    return [
                        taskId,
                        channel,
                        await this.serde.loadsTyped("json", value)
                    ];
                }));
                const checkpointTuple = {
                    config,
                    checkpoint: deserializedCheckpoint,
                    metadata: await this.serde.loadsTyped("json", metadata),
                    pendingWrites
                };
                if (parentCheckpointId !== undefined) checkpointTuple.parentConfig = {
                    configurable: {
                        thread_id,
                        checkpoint_ns,
                        checkpoint_id: parentCheckpointId
                    }
                };
                return checkpointTuple;
            }
        } else {
            const checkpoints = this.storage[thread_id]?.[checkpoint_ns];
            if (checkpoints !== undefined) {
                // eslint-disable-next-line prefer-destructuring
                checkpoint_id = Object.keys(checkpoints).sort((a, b)=>b.localeCompare(a))[0];
                const saved = checkpoints[checkpoint_id];
                const [checkpoint, metadata, parentCheckpointId] = saved;
                const writes = this.writes[_generateKey(thread_id, checkpoint_ns, checkpoint_id)] ?? [];
                const pending_sends = await this._getPendingSends(thread_id, checkpoint_ns, parentCheckpointId);
                const deserializedCheckpoint = {
                    ...await this.serde.loadsTyped("json", checkpoint),
                    pending_sends
                };
                const pendingWrites = await Promise.all(writes.map(async ([taskId, channel, value])=>{
                    return [
                        taskId,
                        channel,
                        await this.serde.loadsTyped("json", value)
                    ];
                }));
                const checkpointTuple = {
                    config: {
                        configurable: {
                            thread_id,
                            checkpoint_id,
                            checkpoint_ns
                        }
                    },
                    checkpoint: deserializedCheckpoint,
                    metadata: await this.serde.loadsTyped("json", metadata),
                    pendingWrites
                };
                if (parentCheckpointId !== undefined) checkpointTuple.parentConfig = {
                    configurable: {
                        thread_id,
                        checkpoint_ns,
                        checkpoint_id: parentCheckpointId
                    }
                };
                return checkpointTuple;
            }
        }
        return undefined;
    }
    async *list(config, options) {
        // eslint-disable-next-line prefer-const
        let { before, limit, filter } = options ?? {};
        const threadIds = config.configurable?.thread_id ? [
            config.configurable?.thread_id
        ] : Object.keys(this.storage);
        const configCheckpointNamespace = config.configurable?.checkpoint_ns;
        for (const threadId of threadIds)for (const checkpointNamespace of Object.keys(this.storage[threadId] ?? {})){
            if (configCheckpointNamespace !== undefined && checkpointNamespace !== configCheckpointNamespace) continue;
            const checkpoints = this.storage[threadId]?.[checkpointNamespace] ?? {};
            const sortedCheckpoints = Object.entries(checkpoints).sort((a, b)=>b[0].localeCompare(a[0]));
            for (const [checkpointId, [checkpoint, metadataStr, parentCheckpointId]] of sortedCheckpoints){
                // Filter by checkpoint ID
                if (before && before.configurable?.checkpoint_id && checkpointId >= before.configurable.checkpoint_id) continue;
                // Parse metadata
                const metadata = await this.serde.loadsTyped("json", metadataStr);
                if (filter && !Object.entries(filter).every(([key, value])=>metadata[key] === value)) continue;
                // Limit search results
                if (limit !== undefined) {
                    if (limit <= 0) break;
                    // eslint-disable-next-line no-param-reassign
                    limit -= 1;
                }
                const writes = this.writes[_generateKey(threadId, checkpointNamespace, checkpointId)] ?? [];
                const pending_sends = await this._getPendingSends(threadId, checkpointNamespace, parentCheckpointId);
                const pendingWrites = await Promise.all(writes.map(async ([taskId, channel, value])=>{
                    return [
                        taskId,
                        channel,
                        await this.serde.loadsTyped("json", value)
                    ];
                }));
                const deserializedCheckpoint = {
                    ...await this.serde.loadsTyped("json", checkpoint),
                    pending_sends
                };
                const checkpointTuple = {
                    config: {
                        configurable: {
                            thread_id: threadId,
                            checkpoint_ns: checkpointNamespace,
                            checkpoint_id: checkpointId
                        }
                    },
                    checkpoint: deserializedCheckpoint,
                    metadata,
                    pendingWrites
                };
                if (parentCheckpointId !== undefined) checkpointTuple.parentConfig = {
                    configurable: {
                        thread_id: threadId,
                        checkpoint_ns: checkpointNamespace,
                        checkpoint_id: parentCheckpointId
                    }
                };
                yield checkpointTuple;
            }
        }
    }
    async put(config, checkpoint, metadata) {
        const preparedCheckpoint = (0, _baseJs.copyCheckpoint)(checkpoint);
        delete preparedCheckpoint.pending_sends;
        const threadId = config.configurable?.thread_id;
        const checkpointNamespace = config.configurable?.checkpoint_ns;
        if (threadId === undefined) throw new Error(`Failed to put checkpoint. The passed RunnableConfig is missing a required "thread_id" field in its "configurable" property.`);
        if (checkpointNamespace === undefined) throw new Error(`Failed to put checkpoint. The passed RunnableConfig is missing a required "checkpoint_ns" field in its "configurable" property.`);
        if (!this.storage[threadId]) this.storage[threadId] = {};
        if (!this.storage[threadId][checkpointNamespace]) this.storage[threadId][checkpointNamespace] = {};
        const [, serializedCheckpoint] = this.serde.dumpsTyped(preparedCheckpoint);
        const [, serializedMetadata] = this.serde.dumpsTyped(metadata);
        this.storage[threadId][checkpointNamespace][checkpoint.id] = [
            serializedCheckpoint,
            serializedMetadata,
            config.configurable?.checkpoint_id
        ];
        return {
            configurable: {
                thread_id: threadId,
                checkpoint_ns: checkpointNamespace,
                checkpoint_id: checkpoint.id
            }
        };
    }
    async putWrites(config, writes, taskId) {
        const threadId = config.configurable?.thread_id;
        const checkpointNamespace = config.configurable?.checkpoint_ns;
        const checkpointId = config.configurable?.checkpoint_id;
        if (threadId === undefined) throw new Error(`Failed to put writes. The passed RunnableConfig is missing a required "thread_id" field in its "configurable" property`);
        if (checkpointId === undefined) throw new Error(`Failed to put writes. The passed RunnableConfig is missing a required "checkpoint_id" field in its "configurable" property.`);
        const key = _generateKey(threadId, checkpointNamespace, checkpointId);
        if (this.writes[key] === undefined) this.writes[key] = [];
        const pendingWrites = writes.map(([channel, value])=>{
            const [, serializedValue] = this.serde.dumpsTyped(value);
            return [
                taskId,
                channel,
                serializedValue
            ];
        });
        this.writes[key].push(...pendingWrites);
    }
}

},{"./base.js":"ev3Q2","./serde/types.js":"dvtCD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ev3Q2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepCopy", ()=>deepCopy);
/** @hidden */ parcelHelpers.export(exports, "emptyCheckpoint", ()=>emptyCheckpoint);
/** @hidden */ parcelHelpers.export(exports, "copyCheckpoint", ()=>copyCheckpoint);
parcelHelpers.export(exports, "BaseCheckpointSaver", ()=>BaseCheckpointSaver);
parcelHelpers.export(exports, "compareChannelVersions", ()=>compareChannelVersions);
parcelHelpers.export(exports, "maxChannelVersion", ()=>maxChannelVersion);
parcelHelpers.export(exports, "WRITES_IDX_MAP", ()=>WRITES_IDX_MAP);
var _idJs = require("./id.js");
var _typesJs = require("./serde/types.js");
var _jsonplusJs = require("./serde/jsonplus.js");
function deepCopy(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    const newObj = Array.isArray(obj) ? [] : {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = deepCopy(obj[key]);
    return newObj;
}
function emptyCheckpoint() {
    return {
        v: 1,
        id: (0, _idJs.uuid6)(-2),
        ts: new Date().toISOString(),
        channel_values: {},
        channel_versions: {},
        versions_seen: {},
        pending_sends: []
    };
}
function copyCheckpoint(checkpoint) {
    return {
        v: checkpoint.v,
        id: checkpoint.id,
        ts: checkpoint.ts,
        channel_values: {
            ...checkpoint.channel_values
        },
        channel_versions: {
            ...checkpoint.channel_versions
        },
        versions_seen: deepCopy(checkpoint.versions_seen),
        pending_sends: [
            ...checkpoint.pending_sends
        ]
    };
}
class BaseCheckpointSaver {
    constructor(serde){
        Object.defineProperty(this, "serde", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new (0, _jsonplusJs.JsonPlusSerializer)()
        });
        this.serde = serde || this.serde;
    }
    async get(config) {
        const value = await this.getTuple(config);
        return value ? value.checkpoint : undefined;
    }
    /**
     * Generate the next version ID for a channel.
     *
     * Default is to use integer versions, incrementing by 1. If you override, you can use str/int/float versions,
     * as long as they are monotonically increasing.
     */ getNextVersion(current, _channel) {
        if (typeof current === "string") throw new Error("Please override this method to use string versions.");
        return current !== undefined && typeof current === "number" ? current + 1 : 1;
    }
}
function compareChannelVersions(a, b) {
    if (typeof a === "number" && typeof b === "number") return Math.sign(a - b);
    return String(a).localeCompare(String(b));
}
function maxChannelVersion(...versions) {
    return versions.reduce((max, version, idx)=>{
        if (idx === 0) return version;
        return compareChannelVersions(max, version) >= 0 ? max : version;
    });
}
const WRITES_IDX_MAP = {
    [(0, _typesJs.ERROR)]: -1,
    [(0, _typesJs.SCHEDULED)]: -2
};

},{"./id.js":"gO9AU","./serde/types.js":"dvtCD","./serde/jsonplus.js":"7cLzd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gO9AU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uuid6", ()=>uuid6);
// Skip UUID validation check, since UUID6s
// generated with negative clockseq are not
// technically compliant, but still work.
// See: https://github.com/uuidjs/uuid/issues/511
parcelHelpers.export(exports, "uuid5", ()=>uuid5);
var _uuid = require("uuid");
function uuid6(clockseq) {
    return (0, _uuid.v6)({
        clockseq
    });
}
function uuid5(name, namespace) {
    const namespaceBytes = namespace.replace(/-/g, "").match(/.{2}/g).map((byte)=>parseInt(byte, 16));
    return (0, _uuid.v5)(name, new Uint8Array(namespaceBytes));
}

},{"uuid":"klst7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"klst7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v1ToV6", ()=>(0, _v1ToV6JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "v6", ()=>(0, _v6JsDefault.default));
parcelHelpers.export(exports, "v6ToV1", ()=>(0, _v6ToV1JsDefault.default));
parcelHelpers.export(exports, "v7", ()=>(0, _v7JsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v1ToV6Js = require("./v1ToV6.js");
var _v1ToV6JsDefault = parcelHelpers.interopDefault(_v1ToV6Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _v6Js = require("./v6.js");
var _v6JsDefault = parcelHelpers.interopDefault(_v6Js);
var _v6ToV1Js = require("./v6ToV1.js");
var _v6ToV1JsDefault = parcelHelpers.interopDefault(_v6ToV1Js);
var _v7Js = require("./v7.js");
var _v7JsDefault = parcelHelpers.interopDefault(_v7Js);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);

},{"./max.js":"jOZW1","./nil.js":"irn8t","./parse.js":"8aDS1","./stringify.js":"fHrI1","./v1.js":"fpS29","./v1ToV6.js":"b97Qv","./v3.js":"3Jmty","./v4.js":"fpA4M","./v5.js":"c3Ua0","./v6.js":"bf8rP","./v6ToV1.js":"2MJHQ","./v7.js":"hGvuv","./validate.js":"d35r5","./version.js":"1bLe6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jOZW1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = 'ffffffff-ffff-ffff-ffff-ffffffffffff';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"irn8t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '00000000-0000-0000-0000-000000000000';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8aDS1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
function parse(uuid) {
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Invalid UUID');
    var v;
    var arr = new Uint8Array(16);
    // Parse ########-....-....-....-............
    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
    arr[1] = v >>> 16 & 0xff;
    arr[2] = v >>> 8 & 0xff;
    arr[3] = v & 0xff;
    // Parse ........-####-....-....-............
    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
    arr[5] = v & 0xff;
    // Parse ........-....-####-....-............
    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
    arr[7] = v & 0xff;
    // Parse ........-....-....-####-............
    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
    arr[9] = v & 0xff;
    // Parse ........-....-....-....-############
    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
    arr[11] = v / 0x100000000 & 0xff;
    arr[12] = v >>> 24 & 0xff;
    arr[13] = v >>> 16 & 0xff;
    arr[14] = v >>> 8 & 0xff;
    arr[15] = v & 0xff;
    return arr;
}
exports.default = parse;

},{"./validate.js":"d35r5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d35r5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"agidw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"agidw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fHrI1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", ()=>unsafeStringify);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr, offset = 0) {
    var uuid = unsafeStringify(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"d35r5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fpS29":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq;
// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || new Array(16);
    options = options || {};
    var node = options.node;
    var clockseq = options.clockseq;
    // v1 only: Use cached `node` and `clockseq` values
    if (!options._v6) {
        if (!node) node = _nodeId;
        if (clockseq == null) clockseq = _clockseq;
    }
    // Handle cases where we need entropy.  We do this lazily to minimize issues
    // related to insufficient system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = options.random || (options.rng || (0, _rngJsDefault.default))();
        // Randomize node
        if (node == null) {
            node = [
                seedBytes[0],
                seedBytes[1],
                seedBytes[2],
                seedBytes[3],
                seedBytes[4],
                seedBytes[5]
            ];
            // v1 only: cache node value for reuse
            if (!_nodeId && !options._v6) {
                // per RFC4122 4.5: Set MAC multicast bit (v1 only)
                node[0] |= 0x01; // Set multicast bit
                _nodeId = node;
            }
        }
        // Randomize clockseq
        if (clockseq == null) {
            // Per 4.2.2, randomize (14 bit) clockseq
            clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
            if (_clockseq === undefined && !options._v6) _clockseq = clockseq;
        }
    }
    // v1 & v6 timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so time is
    // handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : Date.now();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf || (0, _stringifyJs.unsafeStringify)(b);
}
exports.default = v1;

},{"./rng.js":"lpvWd","./stringify.js":"fHrI1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lpvWd":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b97Qv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>v1ToV6);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
var _stringifyJs = require("./stringify.js");
function v1ToV6(uuid) {
    var v1Bytes = typeof uuid === 'string' ? (0, _parseJsDefault.default)(uuid) : uuid;
    var v6Bytes = _v1ToV6(v1Bytes);
    return typeof uuid === 'string' ? (0, _stringifyJs.unsafeStringify)(v6Bytes) : v6Bytes;
}
// Do the field transformation needed for v1 -> v6
function _v1ToV6(v1Bytes, randomize = false) {
    return Uint8Array.of((v1Bytes[6] & 0x0f) << 4 | v1Bytes[7] >> 4 & 0x0f, (v1Bytes[7] & 0x0f) << 4 | (v1Bytes[4] & 0xf0) >> 4, (v1Bytes[4] & 0x0f) << 4 | (v1Bytes[5] & 0xf0) >> 4, (v1Bytes[5] & 0x0f) << 4 | (v1Bytes[0] & 0xf0) >> 4, (v1Bytes[0] & 0x0f) << 4 | (v1Bytes[1] & 0xf0) >> 4, (v1Bytes[1] & 0x0f) << 4 | (v1Bytes[2] & 0xf0) >> 4, 0x60 | v1Bytes[2] & 0x0f, v1Bytes[3], v1Bytes[8], v1Bytes[9], v1Bytes[10], v1Bytes[11], v1Bytes[12], v1Bytes[13], v1Bytes[14], v1Bytes[15]);
}

},{"./parse.js":"8aDS1","./stringify.js":"fHrI1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Jmty":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _v35Js = require("./v35.js");
var _v35JsDefault = parcelHelpers.interopDefault(_v35Js);
var _md5Js = require("./md5.js");
var _md5JsDefault = parcelHelpers.interopDefault(_md5Js);
var v3 = (0, _v35JsDefault.default)('v3', 0x30, (0, _md5JsDefault.default));
exports.default = v3;

},{"./v35.js":"iutsq","./md5.js":"e3BBz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iutsq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DNS", ()=>DNS);
parcelHelpers.export(exports, "URL", ()=>URL);
parcelHelpers.export(exports, "default", ()=>v35);
var _stringifyJs = require("./stringify.js");
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
function stringToBytes(str) {
    str = unescape(encodeURIComponent(str)); // UTF8 escape
    var bytes = [];
    for(var i = 0; i < str.length; ++i)bytes.push(str.charCodeAt(i));
    return bytes;
}
var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
function v35(name, version, hashfunc) {
    function generateUUID(value, namespace, buf, offset) {
        var _namespace;
        if (typeof value === 'string') value = stringToBytes(value);
        if (typeof namespace === 'string') namespace = (0, _parseJsDefault.default)(namespace);
        if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
        // Compute hash of namespace and value, Per 4.3
        // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
        // hashfunc([...namespace, ... value])`
        var bytes = new Uint8Array(16 + value.length);
        bytes.set(namespace);
        bytes.set(value, namespace.length);
        bytes = hashfunc(bytes);
        bytes[6] = bytes[6] & 0x0f | version;
        bytes[8] = bytes[8] & 0x3f | 0x80;
        if (buf) {
            offset = offset || 0;
            for(var i = 0; i < 16; ++i)buf[offset + i] = bytes[i];
            return buf;
        }
        return (0, _stringifyJs.unsafeStringify)(bytes);
    }
    // Function#name is not settable on some platforms (#270)
    try {
        generateUUID.name = name;
    } catch (err) {}
    // For CommonJS default export support
    generateUUID.DNS = DNS;
    generateUUID.URL = URL;
    return generateUUID;
}

},{"./stringify.js":"fHrI1","./parse.js":"8aDS1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e3BBz":[function(require,module,exports,__globalThis) {
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function md5(bytes) {
    if (typeof bytes === 'string') {
        var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = new Uint8Array(msg.length);
        for(var i = 0; i < msg.length; ++i)bytes[i] = msg.charCodeAt(i);
    }
    return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */ function md5ToHexEncodedArray(input) {
    var output = [];
    var length32 = input.length * 32;
    var hexTab = '0123456789abcdef';
    for(var i = 0; i < length32; i += 8){
        var x = input[i >> 5] >>> i % 32 & 0xff;
        var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
        output.push(hex);
    }
    return output;
}
/**
 * Calculate output length with padding and bit length
 */ function getOutputLength(inputLength8) {
    return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */ function wordsToMd5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[getOutputLength(len) - 1] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for(var i = 0; i < x.length; i += 16){
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;
        a = md5ff(a, b, c, d, x[i], 7, -680876936);
        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5gg(b, c, d, a, x[i], 20, -373897302);
        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5hh(d, a, b, c, x[i], 11, -358537222);
        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5ii(a, b, c, d, x[i], 6, -198630844);
        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */ function bytesToWords(input) {
    if (input.length === 0) return [];
    var length8 = input.length * 8;
    var output = new Uint32Array(getOutputLength(length8));
    for(var i = 0; i < length8; i += 8)output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
    return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function safeAdd(x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function bitRotateLeft(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
    return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
    return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
exports.default = md5;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fpA4M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"2mj2P","./rng.js":"lpvWd","./stringify.js":"fHrI1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2mj2P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c3Ua0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _v35Js = require("./v35.js");
var _v35JsDefault = parcelHelpers.interopDefault(_v35Js);
var _sha1Js = require("./sha1.js");
var _sha1JsDefault = parcelHelpers.interopDefault(_sha1Js);
var v5 = (0, _v35JsDefault.default)('v5', 0x50, (0, _sha1JsDefault.default));
exports.default = v5;

},{"./v35.js":"iutsq","./sha1.js":"cLjRe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cLjRe":[function(require,module,exports,__globalThis) {
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function f(s, x, y, z) {
    switch(s){
        case 0:
            return x & y ^ ~x & z;
        case 1:
            return x ^ y ^ z;
        case 2:
            return x & y ^ x & z ^ y & z;
        case 3:
            return x ^ y ^ z;
    }
}
function ROTL(x, n) {
    return x << n | x >>> 32 - n;
}
function sha1(bytes) {
    var K = [
        0x5a827999,
        0x6ed9eba1,
        0x8f1bbcdc,
        0xca62c1d6
    ];
    var H = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    if (typeof bytes === 'string') {
        var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = [];
        for(var i = 0; i < msg.length; ++i)bytes.push(msg.charCodeAt(i));
    } else if (!Array.isArray(bytes)) // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
    bytes.push(0x80);
    var l = bytes.length / 4 + 2;
    var N = Math.ceil(l / 16);
    var M = new Array(N);
    for(var _i = 0; _i < N; ++_i){
        var arr = new Uint32Array(16);
        for(var j = 0; j < 16; ++j)arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
        M[_i] = arr;
    }
    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
    M[N - 1][14] = Math.floor(M[N - 1][14]);
    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
    for(var _i2 = 0; _i2 < N; ++_i2){
        var W = new Uint32Array(80);
        for(var t = 0; t < 16; ++t)W[t] = M[_i2][t];
        for(var _t = 16; _t < 80; ++_t)W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
        var a = H[0];
        var b = H[1];
        var c = H[2];
        var d = H[3];
        var e = H[4];
        for(var _t2 = 0; _t2 < 80; ++_t2){
            var s = Math.floor(_t2 / 20);
            var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
            e = d;
            d = c;
            c = ROTL(b, 30) >>> 0;
            b = a;
            a = T;
        }
        H[0] = H[0] + a >>> 0;
        H[1] = H[1] + b >>> 0;
        H[2] = H[2] + c >>> 0;
        H[3] = H[3] + d >>> 0;
        H[4] = H[4] + e >>> 0;
    }
    return [
        H[0] >> 24 & 0xff,
        H[0] >> 16 & 0xff,
        H[0] >> 8 & 0xff,
        H[0] & 0xff,
        H[1] >> 24 & 0xff,
        H[1] >> 16 & 0xff,
        H[1] >> 8 & 0xff,
        H[1] & 0xff,
        H[2] >> 24 & 0xff,
        H[2] >> 16 & 0xff,
        H[2] >> 8 & 0xff,
        H[2] & 0xff,
        H[3] >> 24 & 0xff,
        H[3] >> 16 & 0xff,
        H[3] >> 8 & 0xff,
        H[3] & 0xff,
        H[4] >> 24 & 0xff,
        H[4] >> 16 & 0xff,
        H[4] >> 8 & 0xff,
        H[4] & 0xff
    ];
}
exports.default = sha1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bf8rP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>v6);
var _stringifyJs = require("./stringify.js");
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v1ToV6Js = require("./v1ToV6.js");
var _v1ToV6JsDefault = parcelHelpers.interopDefault(_v1ToV6Js);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function v6(options = {}, buf, offset = 0) {
    // v6 is v1 with different field layout, so we start with a v1 UUID, albeit
    // with slightly different behavior around how the clock_seq and node fields
    // are randomized, which is why we call v1 with _v6: true.
    var bytes = (0, _v1JsDefault.default)(_objectSpread(_objectSpread({}, options), {}, {
        _v6: true
    }), new Uint8Array(16));
    // Reorder the fields to v6 layout.
    bytes = (0, _v1ToV6JsDefault.default)(bytes);
    // Return as a byte array if requested
    if (buf) {
        for(var i = 0; i < 16; i++)buf[offset + i] = bytes[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(bytes);
}

},{"./stringify.js":"fHrI1","./v1.js":"fpS29","./v1ToV6.js":"b97Qv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2MJHQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>v6ToV1);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
var _stringifyJs = require("./stringify.js");
function v6ToV1(uuid) {
    var v6Bytes = typeof uuid === 'string' ? (0, _parseJsDefault.default)(uuid) : uuid;
    var v1Bytes = _v6ToV1(v6Bytes);
    return typeof uuid === 'string' ? (0, _stringifyJs.unsafeStringify)(v1Bytes) : v1Bytes;
}
// Do the field transformation needed for v6 -> v1
function _v6ToV1(v6Bytes) {
    return Uint8Array.of((v6Bytes[3] & 0x0f) << 4 | v6Bytes[4] >> 4 & 0x0f, (v6Bytes[4] & 0x0f) << 4 | (v6Bytes[5] & 0xf0) >> 4, (v6Bytes[5] & 0x0f) << 4 | v6Bytes[6] & 0x0f, v6Bytes[7], (v6Bytes[1] & 0x0f) << 4 | (v6Bytes[2] & 0xf0) >> 4, (v6Bytes[2] & 0x0f) << 4 | (v6Bytes[3] & 0xf0) >> 4, 0x10 | (v6Bytes[0] & 0xf0) >> 4, (v6Bytes[0] & 0x0f) << 4 | (v6Bytes[1] & 0xf0) >> 4, v6Bytes[8], v6Bytes[9], v6Bytes[10], v6Bytes[11], v6Bytes[12], v6Bytes[13], v6Bytes[14], v6Bytes[15]);
}

},{"./parse.js":"8aDS1","./stringify.js":"fHrI1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hGvuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
/**
 * UUID V7 - Unix Epoch time-based UUID
 *
 * The IETF has published RFC9562, introducing 3 new UUID versions (6,7,8). This
 * implementation of V7 is based on the accepted, though not yet approved,
 * revisions.
 *
 * RFC 9562:https://www.rfc-editor.org/rfc/rfc9562.html Universally Unique
 * IDentifiers (UUIDs)

 *
 * Sample V7 value:
 * https://www.rfc-editor.org/rfc/rfc9562.html#name-example-of-a-uuidv7-value
 *
 * Monotonic Bit Layout: RFC rfc9562.6.2 Method 1, Dedicated Counter Bits ref:
 *     https://www.rfc-editor.org/rfc/rfc9562.html#section-6.2-5.1
 *
 *   0                   1                   2                   3 0 1 2 3 4 5 6
 *   7 8 9 0 1 2 3 4 5 6 7 8 9 0 1 2 3 4 5 6 7 8 9 0 1
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *  |                          unix_ts_ms                           |
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *  |          unix_ts_ms           |  ver  |        seq_hi         |
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *  |var|               seq_low               |        rand         |
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *  |                             rand                              |
 *  +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+
 *
 * seq is a 31 bit serialized counter; comprised of 12 bit seq_hi and 19 bit
 * seq_low, and randomly initialized upon timestamp change. 31 bit counter size
 * was selected as any bitwise operations in node are done as _signed_ 32 bit
 * ints. we exclude the sign bit.
 */ var _seqLow = null;
var _seqHigh = null;
var _msecs = 0;
function v7(options, buf, offset) {
    options = options || {};
    // initialize buffer and pointer
    var i = buf && offset || 0;
    var b = buf || new Uint8Array(16);
    // rnds is Uint8Array(16) filled with random bytes
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))();
    // milliseconds since unix epoch, 1970-01-01 00:00
    var msecs = options.msecs !== undefined ? options.msecs : Date.now();
    // seq is user provided 31 bit counter
    var seq = options.seq !== undefined ? options.seq : null;
    // initialize local seq high/low parts
    var seqHigh = _seqHigh;
    var seqLow = _seqLow;
    // check if clock has advanced and user has not provided msecs
    if (msecs > _msecs && options.msecs === undefined) {
        _msecs = msecs;
        // unless user provided seq, reset seq parts
        if (seq !== null) {
            seqHigh = null;
            seqLow = null;
        }
    }
    // if we have a user provided seq
    if (seq !== null) {
        // trim provided seq to 31 bits of value, avoiding overflow
        if (seq > 0x7fffffff) seq = 0x7fffffff;
        // split provided seq into high/low parts
        seqHigh = seq >>> 19 & 0xfff;
        seqLow = seq & 0x7ffff;
    }
    // randomly initialize seq
    if (seqHigh === null || seqLow === null) {
        seqHigh = rnds[6] & 0x7f;
        seqHigh = seqHigh << 8 | rnds[7];
        seqLow = rnds[8] & 0x3f; // pad for var
        seqLow = seqLow << 8 | rnds[9];
        seqLow = seqLow << 5 | rnds[10] >>> 3;
    }
    // increment seq if within msecs window
    if (msecs + 10000 > _msecs && seq === null) {
        if (++seqLow > 0x7ffff) {
            seqLow = 0;
            if (++seqHigh > 0xfff) {
                seqHigh = 0;
                // increment internal _msecs. this allows us to continue incrementing
                // while staying monotonic. Note, once we hit 10k milliseconds beyond system
                // clock, we will reset breaking monotonicity (after (2^31)*10000 generations)
                _msecs++;
            }
        }
    } else // resetting; we have advanced more than
    // 10k milliseconds beyond system clock
    _msecs = msecs;
    _seqHigh = seqHigh;
    _seqLow = seqLow;
    // [bytes 0-5] 48 bits of local timestamp
    b[i++] = _msecs / 0x10000000000 & 0xff;
    b[i++] = _msecs / 0x100000000 & 0xff;
    b[i++] = _msecs / 0x1000000 & 0xff;
    b[i++] = _msecs / 0x10000 & 0xff;
    b[i++] = _msecs / 0x100 & 0xff;
    b[i++] = _msecs & 0xff;
    // [byte 6] - set 4 bits of version (7) with first 4 bits seq_hi
    b[i++] = seqHigh >>> 4 & 0x0f | 0x70;
    // [byte 7] remaining 8 bits of seq_hi
    b[i++] = seqHigh & 0xff;
    // [byte 8] - variant (2 bits), first 6 bits seq_low
    b[i++] = seqLow >>> 13 & 0x3f | 0x80;
    // [byte 9] 8 bits seq_low
    b[i++] = seqLow >>> 5 & 0xff;
    // [byte 10] remaining 5 bits seq_low, 3 bits random
    b[i++] = seqLow << 3 & 0xff | rnds[10] & 0x07;
    // [bytes 11-15] always random
    b[i++] = rnds[11];
    b[i++] = rnds[12];
    b[i++] = rnds[13];
    b[i++] = rnds[14];
    b[i++] = rnds[15];
    return buf || (0, _stringifyJs.unsafeStringify)(b);
}
exports.default = v7;

},{"./rng.js":"lpvWd","./stringify.js":"fHrI1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1bLe6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
function version(uuid) {
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Invalid UUID');
    return parseInt(uuid.slice(14, 15), 16);
}
exports.default = version;

},{"./validate.js":"d35r5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dvtCD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TASKS", ()=>TASKS);
parcelHelpers.export(exports, "ERROR", ()=>ERROR);
parcelHelpers.export(exports, "SCHEDULED", ()=>SCHEDULED);
const TASKS = "__pregel_tasks";
const ERROR = "__error__";
const SCHEDULED = "__scheduled__";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7cLzd":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable no-instanceof/no-instanceof */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JsonPlusSerializer", ()=>JsonPlusSerializer);
var _load = require("@langchain/core/load");
var _indexJs = require("./utils/fast-safe-stringify/index.js");
function isLangChainSerializedObject(value) {
    return value !== null && value.lc === 1 && value.type === "constructor" && Array.isArray(value.id);
}
/**
 * The replacer in stringify does not allow delegation to built-in LangChain
 * serialization methods, and instead immediately calls `.toJSON()` and
 * continues to stringify subfields.
 *
 * We therefore must start from the most nested elements in the input and
 * deserialize upwards rather than top-down.
 */ async function _reviver(value) {
    if (value && typeof value === "object") {
        if (Array.isArray(value)) {
            const revivedArray = await Promise.all(value.map((item)=>_reviver(item)));
            return revivedArray;
        } else {
            const revivedObj = {};
            for (const [k, v] of Object.entries(value))revivedObj[k] = await _reviver(v);
            if (revivedObj.lc === 2 && revivedObj.type === "undefined") return undefined;
            else if (revivedObj.lc === 2 && revivedObj.type === "constructor" && Array.isArray(revivedObj.id)) try {
                const constructorName = revivedObj.id[revivedObj.id.length - 1];
                let constructor;
                switch(constructorName){
                    case "Set":
                        constructor = Set;
                        break;
                    case "Map":
                        constructor = Map;
                        break;
                    case "RegExp":
                        constructor = RegExp;
                        break;
                    case "Error":
                        constructor = Error;
                        break;
                    default:
                        return revivedObj;
                }
                if (revivedObj.method) return constructor[revivedObj.method](...revivedObj.args || []);
                else return new constructor(...revivedObj.args || []);
            } catch (error) {
                return revivedObj;
            }
            else if (isLangChainSerializedObject(revivedObj)) return (0, _load.load)(JSON.stringify(revivedObj));
            return revivedObj;
        }
    }
    return value;
}
function _encodeConstructorArgs(// eslint-disable-next-line @typescript-eslint/ban-types
constructor, method, args, kwargs) {
    return {
        lc: 2,
        type: "constructor",
        id: [
            constructor.name
        ],
        method: method ?? null,
        args: args ?? [],
        kwargs: kwargs ?? {}
    };
}
function _default(obj) {
    if (obj === undefined) return {
        lc: 2,
        type: "undefined"
    };
    else if (obj instanceof Set || obj instanceof Map) return _encodeConstructorArgs(obj.constructor, undefined, [
        Array.from(obj)
    ]);
    else if (obj instanceof RegExp) return _encodeConstructorArgs(RegExp, undefined, [
        obj.source,
        obj.flags
    ]);
    else if (obj instanceof Error) return _encodeConstructorArgs(obj.constructor, undefined, [
        obj.message
    ]);
    else if (obj?.lg_name === "Send") return {
        node: obj.node,
        args: obj.args
    };
    else return obj;
}
class JsonPlusSerializer {
    _dumps(obj) {
        const encoder = new TextEncoder();
        return encoder.encode((0, _indexJs.stringify)(obj, (_, value)=>{
            return _default(value);
        }));
    }
    dumpsTyped(obj) {
        if (obj instanceof Uint8Array) return [
            "bytes",
            obj
        ];
        else return [
            "json",
            this._dumps(obj)
        ];
    }
    async _loads(data) {
        const parsed = JSON.parse(data);
        return _reviver(parsed);
    }
    async loadsTyped(type, data) {
        if (type === "bytes") return typeof data === "string" ? new TextEncoder().encode(data) : data;
        else if (type === "json") return this._loads(typeof data === "string" ? data : new TextDecoder().decode(data));
        else throw new Error(`Unknown serialization type: ${type}`);
    }
}

},{"@langchain/core/load":"qQE5Q","./utils/fast-safe-stringify/index.js":"i4Ulm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"qQE5Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./dist/load/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"./dist/load/index.js":"dGGDM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dGGDM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "load", ()=>load);
var _serializableJs = require("./serializable.js");
var _importConstantsJs = require("./import_constants.js");
var _importMapJs = require("./import_map.js");
var _mapKeysJs = require("./map_keys.js");
var _envJs = require("../utils/env.js");
function combineAliasesAndInvert(constructor) {
    const aliases = {};
    for(// eslint-disable-next-line @typescript-eslint/no-this-alias
    let current = constructor; current && current.prototype; current = Object.getPrototypeOf(current))Object.assign(aliases, Reflect.get(current.prototype, "lc_aliases"));
    return Object.entries(aliases).reduce((acc, [key, value])=>{
        acc[value] = key;
        return acc;
    }, {});
}
async function reviver(value) {
    const { optionalImportsMap = {}, optionalImportEntrypoints = [], importMap = {}, secretsMap = {}, path = [
        "$"
    ] } = this;
    const pathStr = path.join(".");
    if (typeof value === "object" && value !== null && !Array.isArray(value) && "lc" in value && "type" in value && "id" in value && value.lc === 1 && value.type === "secret") {
        const serialized = value;
        const [key] = serialized.id;
        if (key in secretsMap) return secretsMap[key];
        else {
            const secretValueInEnv = (0, _envJs.getEnvironmentVariable)(key);
            if (secretValueInEnv) return secretValueInEnv;
            else throw new Error(`Missing key "${key}" for ${pathStr} in load(secretsMap={})`);
        }
    } else if (typeof value === "object" && value !== null && !Array.isArray(value) && "lc" in value && "type" in value && "id" in value && value.lc === 1 && value.type === "not_implemented") {
        const serialized = value;
        const str = JSON.stringify(serialized);
        throw new Error(`Trying to load an object that doesn't implement serialization: ${pathStr} -> ${str}`);
    } else if (typeof value === "object" && value !== null && !Array.isArray(value) && "lc" in value && "type" in value && "id" in value && "kwargs" in value && value.lc === 1) {
        const serialized = value;
        const str = JSON.stringify(serialized);
        const [name, ...namespaceReverse] = serialized.id.slice().reverse();
        const namespace = namespaceReverse.reverse();
        const importMaps = {
            langchain_core: _importMapJs,
            langchain: importMap
        };
        let module = null;
        const optionalImportNamespaceAliases = [
            namespace.join("/")
        ];
        if (namespace[0] === "langchain_community") optionalImportNamespaceAliases.push([
            "langchain",
            ...namespace.slice(1)
        ].join("/"));
        const matchingNamespaceAlias = optionalImportNamespaceAliases.find((alias)=>alias in optionalImportsMap);
        if ((0, _importConstantsJs.optionalImportEntrypoints).concat(optionalImportEntrypoints).includes(namespace.join("/")) || matchingNamespaceAlias) {
            if (matchingNamespaceAlias !== undefined) module = await optionalImportsMap[matchingNamespaceAlias];
            else throw new Error(`Missing key "${namespace.join("/")}" for ${pathStr} in load(optionalImportsMap={})`);
        } else {
            let finalImportMap;
            // Currently, we only support langchain and langchain_core imports.
            if (namespace[0] === "langchain" || namespace[0] === "langchain_core") {
                finalImportMap = importMaps[namespace[0]];
                namespace.shift();
            } else throw new Error(`Invalid namespace: ${pathStr} -> ${str}`);
            // The root namespace "langchain" is not a valid import.
            if (namespace.length === 0) throw new Error(`Invalid namespace: ${pathStr} -> ${str}`);
            // Find the longest matching namespace.
            let importMapKey;
            do {
                importMapKey = namespace.join("__");
                if (importMapKey in finalImportMap) break;
                else namespace.pop();
            }while (namespace.length > 0);
            // If no matching namespace is found, throw an error.
            if (importMapKey in finalImportMap) module = finalImportMap[importMapKey];
        }
        if (typeof module !== "object" || module === null) throw new Error(`Invalid namespace: ${pathStr} -> ${str}`);
        // Extract the builder from the import map.
        const builder = // look for a named export with the same name as the class
        module[name] ?? // look for an export with a lc_name property matching the class name
        // this is necessary for classes that are minified
        Object.values(module).find((v)=>typeof v === "function" && (0, _serializableJs.get_lc_unique_name)(v) === name);
        if (typeof builder !== "function") throw new Error(`Invalid identifer: ${pathStr} -> ${str}`);
        // Recurse on the arguments, which may be serialized objects themselves
        const kwargs = await reviver.call({
            ...this,
            path: [
                ...path,
                "kwargs"
            ]
        }, serialized.kwargs);
        // Construct the object
        if (serialized.type === "constructor") {
            // eslint-disable-next-line new-cap, @typescript-eslint/no-explicit-any
            const instance = new builder((0, _mapKeysJs.mapKeys)(kwargs, (0, _mapKeysJs.keyFromJson), combineAliasesAndInvert(builder)));
            // Minification in severless/edge runtimes will mange the
            // name of classes presented in traces. As the names in import map
            // are present as-is even with minification, use these names instead
            Object.defineProperty(instance.constructor, "name", {
                value: name
            });
            return instance;
        } else throw new Error(`Invalid type: ${pathStr} -> ${str}`);
    } else if (typeof value === "object" && value !== null) {
        if (Array.isArray(value)) return Promise.all(value.map((v, i)=>reviver.call({
                ...this,
                path: [
                    ...path,
                    `${i}`
                ]
            }, v)));
        else return Object.fromEntries(await Promise.all(Object.entries(value).map(async ([key, value])=>[
                key,
                await reviver.call({
                    ...this,
                    path: [
                        ...path,
                        key
                    ]
                }, value)
            ])));
    }
    return value;
}
async function load(text, mappings) {
    const json = JSON.parse(text);
    return reviver.call({
        ...mappings
    }, json);
}

},{"./serializable.js":"2n7FI","./import_constants.js":"7msyc","./import_map.js":"caUWS","./map_keys.js":"9zQm5","../utils/env.js":"4GIQu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2n7FI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get a unique name for the module, rather than parent class implementations.
 * Should not be subclassed, subclass lc_name above instead.
 */ parcelHelpers.export(exports, "get_lc_unique_name", ()=>get_lc_unique_name);
parcelHelpers.export(exports, "Serializable", ()=>Serializable);
var _mapKeysJs = require("./map_keys.js");
function shallowCopy(obj) {
    return Array.isArray(obj) ? [
        ...obj
    ] : {
        ...obj
    };
}
function replaceSecrets(root, secretsMap) {
    const result = shallowCopy(root);
    for (const [path, secretId] of Object.entries(secretsMap)){
        const [last, ...partsReverse] = path.split(".").reverse();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let current = result;
        for (const part of partsReverse.reverse()){
            if (current[part] === undefined) break;
            current[part] = shallowCopy(current[part]);
            current = current[part];
        }
        if (current[last] !== undefined) current[last] = {
            lc: 1,
            type: "secret",
            id: [
                secretId
            ]
        };
    }
    return result;
}
function get_lc_unique_name(// eslint-disable-next-line @typescript-eslint/no-use-before-define
serializableClass) {
    // "super" here would refer to the parent class of Serializable,
    // when we want the parent class of the module actually calling this method.
    const parentClass = Object.getPrototypeOf(serializableClass);
    const lcNameIsSubclassed = typeof serializableClass.lc_name === "function" && (typeof parentClass.lc_name !== "function" || serializableClass.lc_name() !== parentClass.lc_name());
    if (lcNameIsSubclassed) return serializableClass.lc_name();
    else return serializableClass.name;
}
class Serializable {
    /**
     * The name of the serializable. Override to provide an alias or
     * to preserve the serialized module name in minified environments.
     *
     * Implemented as a static method to support loading logic.
     */ static lc_name() {
        return this.name;
    }
    /**
     * The final serialized identifier for the module.
     */ get lc_id() {
        return [
            ...this.lc_namespace,
            get_lc_unique_name(this.constructor)
        ];
    }
    /**
     * A map of secrets, which will be omitted from serialization.
     * Keys are paths to the secret in constructor args, e.g. "foo.bar.baz".
     * Values are the secret ids, which will be used when deserializing.
     */ get lc_secrets() {
        return undefined;
    }
    /**
     * A map of additional attributes to merge with constructor args.
     * Keys are the attribute names, e.g. "foo".
     * Values are the attribute values, which will be serialized.
     * These attributes need to be accepted by the constructor as arguments.
     */ get lc_attributes() {
        return undefined;
    }
    /**
     * A map of aliases for constructor args.
     * Keys are the attribute names, e.g. "foo".
     * Values are the alias that will replace the key in serialization.
     * This is used to eg. make argument names match Python.
     */ get lc_aliases() {
        return undefined;
    }
    constructor(kwargs, ..._args){
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "lc_kwargs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.lc_kwargs = kwargs || {};
    }
    toJSON() {
        if (!this.lc_serializable) return this.toJSONNotImplemented();
        if (// eslint-disable-next-line no-instanceof/no-instanceof
        this.lc_kwargs instanceof Serializable || typeof this.lc_kwargs !== "object" || Array.isArray(this.lc_kwargs)) // We do not support serialization of classes with arg not a POJO
        // I'm aware the check above isn't as strict as it could be
        return this.toJSONNotImplemented();
        const aliases = {};
        const secrets = {};
        const kwargs = Object.keys(this.lc_kwargs).reduce((acc, key)=>{
            acc[key] = key in this ? this[key] : this.lc_kwargs[key];
            return acc;
        }, {});
        // get secrets, attributes and aliases from all superclasses
        for(// eslint-disable-next-line @typescript-eslint/no-this-alias
        let current = Object.getPrototypeOf(this); current; current = Object.getPrototypeOf(current)){
            Object.assign(aliases, Reflect.get(current, "lc_aliases", this));
            Object.assign(secrets, Reflect.get(current, "lc_secrets", this));
            Object.assign(kwargs, Reflect.get(current, "lc_attributes", this));
        }
        // include all secrets used, even if not in kwargs,
        // will be replaced with sentinel value in replaceSecrets
        Object.keys(secrets).forEach((keyPath)=>{
            // eslint-disable-next-line @typescript-eslint/no-this-alias, @typescript-eslint/no-explicit-any
            let read = this;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let write = kwargs;
            const [last, ...partsReverse] = keyPath.split(".").reverse();
            for (const key of partsReverse.reverse()){
                if (!(key in read) || read[key] === undefined) return;
                if (!(key in write) || write[key] === undefined) {
                    if (typeof read[key] === "object" && read[key] != null) write[key] = {};
                    else if (Array.isArray(read[key])) write[key] = [];
                }
                read = read[key];
                write = write[key];
            }
            if (last in read && read[last] !== undefined) write[last] = write[last] || read[last];
        });
        return {
            lc: 1,
            type: "constructor",
            id: this.lc_id,
            kwargs: (0, _mapKeysJs.mapKeys)(Object.keys(secrets).length ? replaceSecrets(kwargs, secrets) : kwargs, (0, _mapKeysJs.keyToJson), aliases)
        };
    }
    toJSONNotImplemented() {
        return {
            lc: 1,
            type: "not_implemented",
            id: this.lc_id
        };
    }
}

},{"./map_keys.js":"9zQm5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9zQm5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "keyToJson", ()=>keyToJson);
parcelHelpers.export(exports, "keyFromJson", ()=>keyFromJson);
parcelHelpers.export(exports, "mapKeys", ()=>mapKeys);
var _decamelize = require("decamelize");
var _decamelizeDefault = parcelHelpers.interopDefault(_decamelize);
var _camelcase = require("camelcase");
var _camelcaseDefault = parcelHelpers.interopDefault(_camelcase);
function keyToJson(key, map) {
    return map?.[key] || (0, _decamelizeDefault.default)(key);
}
function keyFromJson(key, map) {
    return map?.[key] || (0, _camelcaseDefault.default)(key);
}
function mapKeys(fields, mapper, map) {
    const mapped = {};
    for(const key in fields)if (Object.hasOwn(fields, key)) mapped[mapper(key, map)] = fields[key];
    return mapped;
}

},{"decamelize":"7Jg7T","camelcase":"ayipm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Jg7T":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(str, sep) {
    if (typeof str !== 'string') throw new TypeError('Expected a string');
    sep = typeof sep === 'undefined' ? '_' : sep;
    return str.replace(/([a-z\d])([A-Z])/g, '$1' + sep + '$2').replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + sep + '$2').toLowerCase();
};

},{}],"ayipm":[function(require,module,exports,__globalThis) {
'use strict';
const UPPERCASE = /[\p{Lu}]/u;
const LOWERCASE = /[\p{Ll}]/u;
const LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu;
const IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u;
const SEPARATORS = /[_.\- ]+/;
const LEADING_SEPARATORS = new RegExp('^' + SEPARATORS.source);
const SEPARATORS_AND_IDENTIFIER = new RegExp(SEPARATORS.source + IDENTIFIER.source, 'gu');
const NUMBERS_AND_IDENTIFIER = new RegExp('\\d+' + IDENTIFIER.source, 'gu');
const preserveCamelCase = (string, toLowerCase, toUpperCase)=>{
    let isLastCharLower = false;
    let isLastCharUpper = false;
    let isLastLastCharUpper = false;
    for(let i = 0; i < string.length; i++){
        const character = string[i];
        if (isLastCharLower && UPPERCASE.test(character)) {
            string = string.slice(0, i) + '-' + string.slice(i);
            isLastCharLower = false;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = true;
            i++;
        } else if (isLastCharUpper && isLastLastCharUpper && LOWERCASE.test(character)) {
            string = string.slice(0, i - 1) + '-' + string.slice(i - 1);
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = false;
            isLastCharLower = true;
        } else {
            isLastCharLower = toLowerCase(character) === character && toUpperCase(character) !== character;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = toUpperCase(character) === character && toLowerCase(character) !== character;
        }
    }
    return string;
};
const preserveConsecutiveUppercase = (input, toLowerCase)=>{
    LEADING_CAPITAL.lastIndex = 0;
    return input.replace(LEADING_CAPITAL, (m1)=>toLowerCase(m1));
};
const postProcess = (input, toUpperCase)=>{
    SEPARATORS_AND_IDENTIFIER.lastIndex = 0;
    NUMBERS_AND_IDENTIFIER.lastIndex = 0;
    return input.replace(SEPARATORS_AND_IDENTIFIER, (_, identifier)=>toUpperCase(identifier)).replace(NUMBERS_AND_IDENTIFIER, (m)=>toUpperCase(m));
};
const camelCase = (input, options)=>{
    if (!(typeof input === 'string' || Array.isArray(input))) throw new TypeError('Expected the input to be `string | string[]`');
    options = {
        pascalCase: false,
        preserveConsecutiveUppercase: false,
        ...options
    };
    if (Array.isArray(input)) input = input.map((x)=>x.trim()).filter((x)=>x.length).join('-');
    else input = input.trim();
    if (input.length === 0) return '';
    const toLowerCase = options.locale === false ? (string)=>string.toLowerCase() : (string)=>string.toLocaleLowerCase(options.locale);
    const toUpperCase = options.locale === false ? (string)=>string.toUpperCase() : (string)=>string.toLocaleUpperCase(options.locale);
    if (input.length === 1) return options.pascalCase ? toUpperCase(input) : toLowerCase(input);
    const hasUpperCase = input !== toLowerCase(input);
    if (hasUpperCase) input = preserveCamelCase(input, toLowerCase, toUpperCase);
    input = input.replace(LEADING_SEPARATORS, '');
    if (options.preserveConsecutiveUppercase) input = preserveConsecutiveUppercase(input, toLowerCase);
    else input = toLowerCase(input);
    if (options.pascalCase) input = toUpperCase(input.charAt(0)) + input.slice(1);
    return postProcess(input, toUpperCase);
};
module.exports = camelCase;
// TODO: Remove this for the next major release
module.exports.default = camelCase;

},{}],"7msyc":[function(require,module,exports,__globalThis) {
// Auto-generated by `scripts/create-entrypoints.js`. Do not edit manually.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optionalImportEntrypoints", ()=>optionalImportEntrypoints);
const optionalImportEntrypoints = [];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"caUWS":[function(require,module,exports,__globalThis) {
// Auto-generated by `scripts/create-entrypoints.js`. Do not edit manually.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "agents", ()=>_agentsJs);
parcelHelpers.export(exports, "caches", ()=>_baseJs);
parcelHelpers.export(exports, "callbacks__base", ()=>_baseJs1);
parcelHelpers.export(exports, "callbacks__manager", ()=>_managerJs);
parcelHelpers.export(exports, "callbacks__promises", ()=>_promisesJs);
parcelHelpers.export(exports, "chat_history", ()=>_chatHistoryJs);
parcelHelpers.export(exports, "documents", ()=>_indexJs);
parcelHelpers.export(exports, "embeddings", ()=>_embeddingsJs);
parcelHelpers.export(exports, "example_selectors", ()=>_indexJs1);
parcelHelpers.export(exports, "language_models__base", ()=>_baseJs2);
parcelHelpers.export(exports, "language_models__chat_models", ()=>_chatModelsJs);
parcelHelpers.export(exports, "language_models__llms", ()=>_llmsJs);
parcelHelpers.export(exports, "load__serializable", ()=>_serializableJs);
parcelHelpers.export(exports, "memory", ()=>_memoryJs);
parcelHelpers.export(exports, "messages", ()=>_indexJs2);
parcelHelpers.export(exports, "output_parsers", ()=>_indexJs3);
parcelHelpers.export(exports, "outputs", ()=>_outputsJs);
parcelHelpers.export(exports, "prompts", ()=>_indexJs4);
parcelHelpers.export(exports, "prompt_values", ()=>_promptValuesJs);
parcelHelpers.export(exports, "runnables", ()=>_indexJs5);
parcelHelpers.export(exports, "retrievers", ()=>_indexJs6);
parcelHelpers.export(exports, "stores", ()=>_storesJs);
parcelHelpers.export(exports, "tools", ()=>_indexJs7);
parcelHelpers.export(exports, "tracers__base", ()=>_baseJs3);
parcelHelpers.export(exports, "tracers__console", ()=>_consoleJs);
parcelHelpers.export(exports, "tracers__initialize", ()=>_initializeJs);
parcelHelpers.export(exports, "tracers__log_stream", ()=>_logStreamJs);
parcelHelpers.export(exports, "tracers__run_collector", ()=>_runCollectorJs);
parcelHelpers.export(exports, "tracers__tracer_langchain", ()=>_tracerLangchainJs);
parcelHelpers.export(exports, "tracers__tracer_langchain_v1", ()=>_tracerLangchainV1Js);
parcelHelpers.export(exports, "utils__async_caller", ()=>_asyncCallerJs);
parcelHelpers.export(exports, "utils__chunk_array", ()=>_chunkArrayJs);
parcelHelpers.export(exports, "utils__env", ()=>_envJs);
parcelHelpers.export(exports, "utils__function_calling", ()=>_functionCallingJs);
parcelHelpers.export(exports, "utils__hash", ()=>_hashJs);
parcelHelpers.export(exports, "utils__json_patch", ()=>_jsonPatchJs);
parcelHelpers.export(exports, "utils__json_schema", ()=>_jsonSchemaJs);
parcelHelpers.export(exports, "utils__math", ()=>_mathJs);
parcelHelpers.export(exports, "utils__stream", ()=>_streamJs);
parcelHelpers.export(exports, "utils__testing", ()=>_indexJs8);
parcelHelpers.export(exports, "utils__tiktoken", ()=>_tiktokenJs);
parcelHelpers.export(exports, "utils__types", ()=>_indexJs9);
parcelHelpers.export(exports, "vectorstores", ()=>_vectorstoresJs);
var _agentsJs = require("../agents.js");
var _baseJs = require("../caches/base.js");
var _baseJs1 = require("../callbacks/base.js");
var _managerJs = require("../callbacks/manager.js");
var _promisesJs = require("../callbacks/promises.js");
var _chatHistoryJs = require("../chat_history.js");
var _indexJs = require("../documents/index.js");
var _embeddingsJs = require("../embeddings.js");
var _indexJs1 = require("../example_selectors/index.js");
var _baseJs2 = require("../language_models/base.js");
var _chatModelsJs = require("../language_models/chat_models.js");
var _llmsJs = require("../language_models/llms.js");
var _serializableJs = require("../load/serializable.js");
var _memoryJs = require("../memory.js");
var _indexJs2 = require("../messages/index.js");
var _indexJs3 = require("../output_parsers/index.js");
var _outputsJs = require("../outputs.js");
var _indexJs4 = require("../prompts/index.js");
var _promptValuesJs = require("../prompt_values.js");
var _indexJs5 = require("../runnables/index.js");
var _indexJs6 = require("../retrievers/index.js");
var _storesJs = require("../stores.js");
var _indexJs7 = require("../tools/index.js");
var _baseJs3 = require("../tracers/base.js");
var _consoleJs = require("../tracers/console.js");
var _initializeJs = require("../tracers/initialize.js");
var _logStreamJs = require("../tracers/log_stream.js");
var _runCollectorJs = require("../tracers/run_collector.js");
var _tracerLangchainJs = require("../tracers/tracer_langchain.js");
var _tracerLangchainV1Js = require("../tracers/tracer_langchain_v1.js");
var _asyncCallerJs = require("../utils/async_caller.js");
var _chunkArrayJs = require("../utils/chunk_array.js");
var _envJs = require("../utils/env.js");
var _functionCallingJs = require("../utils/function_calling.js");
var _hashJs = require("../utils/hash.js");
var _jsonPatchJs = require("../utils/json_patch.js");
var _jsonSchemaJs = require("../utils/json_schema.js");
var _mathJs = require("../utils/math.js");
var _streamJs = require("../utils/stream.js");
var _indexJs8 = require("../utils/testing/index.js");
var _tiktokenJs = require("../utils/tiktoken.js");
var _indexJs9 = require("../utils/types/index.js");
var _vectorstoresJs = require("../vectorstores.js");

},{"../agents.js":"bhy5A","../caches/base.js":"dmyRR","../callbacks/base.js":"kirBb","../callbacks/manager.js":"bj69C","../callbacks/promises.js":"9XPYi","../chat_history.js":"1yk1a","../documents/index.js":"1rg9x","../embeddings.js":"iP48n","../example_selectors/index.js":"7i9vW","../language_models/base.js":"grvsA","../language_models/chat_models.js":"1XRQe","../language_models/llms.js":"4h08k","../load/serializable.js":"2n7FI","../memory.js":"cV7bQ","../messages/index.js":"7XzBK","../output_parsers/index.js":"9SzCh","../outputs.js":"4YkJk","../prompts/index.js":"bdjua","../prompt_values.js":"lY5Gs","../runnables/index.js":"cJ9j5","../retrievers/index.js":"czwif","../stores.js":"167ig","../tools/index.js":"bXVFj","../tracers/base.js":"5VkRj","../tracers/console.js":"ZpZ6z","../tracers/initialize.js":"71Hde","../tracers/log_stream.js":"icv9w","../tracers/run_collector.js":"26xlp","../tracers/tracer_langchain.js":"a7dBj","../tracers/tracer_langchain_v1.js":"2KZBB","../utils/async_caller.js":"9E8gp","../utils/chunk_array.js":"7oRM9","../utils/env.js":"4GIQu","../utils/function_calling.js":"aj2Xs","../utils/hash.js":"b0vm3","../utils/json_patch.js":"aSci2","../utils/json_schema.js":"43q9X","../utils/math.js":"bFJs7","../utils/stream.js":"kAAca","../utils/testing/index.js":"2FJMX","../utils/tiktoken.js":"bMqbG","../utils/types/index.js":"kUlzY","../vectorstores.js":"77SVX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bhy5A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dmyRR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCacheKey", ()=>getCacheKey);
parcelHelpers.export(exports, "deserializeStoredGeneration", ()=>deserializeStoredGeneration);
parcelHelpers.export(exports, "serializeGeneration", ()=>serializeGeneration);
/**
 * Base class for all caches. All caches should extend this class.
 */ parcelHelpers.export(exports, "BaseCache", ()=>BaseCache);
/**
 * A cache for storing LLM generations that stores data in memory.
 */ parcelHelpers.export(exports, "InMemoryCache", ()=>InMemoryCache);
var _hashJs = require("../utils/hash.js");
var _utilsJs = require("../messages/utils.js");
const getCacheKey = (...strings)=>(0, _hashJs.insecureHash)(strings.join("_"));
function deserializeStoredGeneration(storedGeneration) {
    if (storedGeneration.message !== undefined) return {
        text: storedGeneration.text,
        message: (0, _utilsJs.mapStoredMessageToChatMessage)(storedGeneration.message)
    };
    else return {
        text: storedGeneration.text
    };
}
function serializeGeneration(generation) {
    const serializedValue = {
        text: generation.text
    };
    if (generation.message !== undefined) serializedValue.message = generation.message.toDict();
    return serializedValue;
}
class BaseCache {
}
const GLOBAL_MAP = new Map();
class InMemoryCache extends BaseCache {
    constructor(map){
        super();
        Object.defineProperty(this, "cache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cache = map ?? new Map();
    }
    /**
     * Retrieves data from the cache using a prompt and an LLM key. If the
     * data is not found, it returns null.
     * @param prompt The prompt used to find the data.
     * @param llmKey The LLM key used to find the data.
     * @returns The data corresponding to the prompt and LLM key, or null if not found.
     */ lookup(prompt, llmKey) {
        return Promise.resolve(this.cache.get(getCacheKey(prompt, llmKey)) ?? null);
    }
    /**
     * Updates the cache with new data using a prompt and an LLM key.
     * @param prompt The prompt used to store the data.
     * @param llmKey The LLM key used to store the data.
     * @param value The data to be stored.
     */ async update(prompt, llmKey, value) {
        this.cache.set(getCacheKey(prompt, llmKey), value);
    }
    /**
     * Returns a global instance of InMemoryCache using a predefined global
     * map as the initial cache.
     * @returns A global instance of InMemoryCache.
     */ static global() {
        return new InMemoryCache(GLOBAL_MAP);
    }
}

},{"../utils/hash.js":"b0vm3","../messages/utils.js":"6vi0n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b0vm3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "insecureHash", ()=>(0, _hashJs.insecureHash));
var _hashJs = require("./js-sha1/hash.js");

},{"./js-sha1/hash.js":"aqcsJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aqcsJ":[function(require,module,exports,__globalThis) {
// @ts-nocheck
// Inlined to deal with portability issues with importing crypto module
/*
 * [js-sha1]{@link https://github.com/emn178/js-sha1}
 *
 * @version 0.6.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */ /*jslint bitwise: true */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "insecureHash", ()=>insecureHash);
"use strict";
var root = typeof window === "object" ? window : {};
var HEX_CHARS = "0123456789abcdef".split("");
var EXTRA = [
    -2147483648,
    8388608,
    32768,
    128
];
var SHIFT = [
    24,
    16,
    8,
    0
];
var OUTPUT_TYPES = [
    "hex",
    "array",
    "digest",
    "arrayBuffer"
];
var blocks = [];
function Sha1(sharedMemory) {
    if (sharedMemory) {
        blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        this.blocks = blocks;
    } else this.blocks = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    this.h0 = 0x67452301;
    this.h1 = 0xefcdab89;
    this.h2 = 0x98badcfe;
    this.h3 = 0x10325476;
    this.h4 = 0xc3d2e1f0;
    this.block = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
}
Sha1.prototype.update = function(message) {
    if (this.finalized) return;
    var notString = typeof message !== "string";
    if (notString && message.constructor === root.ArrayBuffer) message = new Uint8Array(message);
    var code, index = 0, i, length = message.length || 0, blocks = this.blocks;
    while(index < length){
        if (this.hashed) {
            this.hashed = false;
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        else for(i = this.start; index < length && i < 64; ++index){
            code = message.charCodeAt(index);
            if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
            else if (code < 0x800) {
                blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
            } else if (code < 0xd800 || code >= 0xe000) {
                blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
            } else {
                code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
            }
        }
        this.lastByteIndex = i;
        this.bytes += i - this.start;
        if (i >= 64) {
            this.block = blocks[16];
            this.start = i - 64;
            this.hash();
            this.hashed = true;
        } else this.start = i;
    }
    if (this.bytes > 4294967295) {
        this.hBytes += this.bytes / 4294967296 << 0;
        this.bytes = this.bytes % 4294967296;
    }
    return this;
};
Sha1.prototype.finalize = function() {
    if (this.finalized) return;
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[16] = this.block;
    blocks[i >> 2] |= EXTRA[i & 3];
    this.block = blocks[16];
    if (i >= 56) {
        if (!this.hashed) this.hash();
        blocks[0] = this.block;
        blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
    blocks[15] = this.bytes << 3;
    this.hash();
};
Sha1.prototype.hash = function() {
    var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4;
    var f, j, t, blocks = this.blocks;
    for(j = 16; j < 80; ++j){
        t = blocks[j - 3] ^ blocks[j - 8] ^ blocks[j - 14] ^ blocks[j - 16];
        blocks[j] = t << 1 | t >>> 31;
    }
    for(j = 0; j < 20; j += 5){
        f = b & c | ~b & d;
        t = a << 5 | a >>> 27;
        e = t + f + e + 1518500249 + blocks[j] << 0;
        b = b << 30 | b >>> 2;
        f = a & b | ~a & c;
        t = e << 5 | e >>> 27;
        d = t + f + d + 1518500249 + blocks[j + 1] << 0;
        a = a << 30 | a >>> 2;
        f = e & a | ~e & b;
        t = d << 5 | d >>> 27;
        c = t + f + c + 1518500249 + blocks[j + 2] << 0;
        e = e << 30 | e >>> 2;
        f = d & e | ~d & a;
        t = c << 5 | c >>> 27;
        b = t + f + b + 1518500249 + blocks[j + 3] << 0;
        d = d << 30 | d >>> 2;
        f = c & d | ~c & e;
        t = b << 5 | b >>> 27;
        a = t + f + a + 1518500249 + blocks[j + 4] << 0;
        c = c << 30 | c >>> 2;
    }
    for(; j < 40; j += 5){
        f = b ^ c ^ d;
        t = a << 5 | a >>> 27;
        e = t + f + e + 1859775393 + blocks[j] << 0;
        b = b << 30 | b >>> 2;
        f = a ^ b ^ c;
        t = e << 5 | e >>> 27;
        d = t + f + d + 1859775393 + blocks[j + 1] << 0;
        a = a << 30 | a >>> 2;
        f = e ^ a ^ b;
        t = d << 5 | d >>> 27;
        c = t + f + c + 1859775393 + blocks[j + 2] << 0;
        e = e << 30 | e >>> 2;
        f = d ^ e ^ a;
        t = c << 5 | c >>> 27;
        b = t + f + b + 1859775393 + blocks[j + 3] << 0;
        d = d << 30 | d >>> 2;
        f = c ^ d ^ e;
        t = b << 5 | b >>> 27;
        a = t + f + a + 1859775393 + blocks[j + 4] << 0;
        c = c << 30 | c >>> 2;
    }
    for(; j < 60; j += 5){
        f = b & c | b & d | c & d;
        t = a << 5 | a >>> 27;
        e = t + f + e - 1894007588 + blocks[j] << 0;
        b = b << 30 | b >>> 2;
        f = a & b | a & c | b & c;
        t = e << 5 | e >>> 27;
        d = t + f + d - 1894007588 + blocks[j + 1] << 0;
        a = a << 30 | a >>> 2;
        f = e & a | e & b | a & b;
        t = d << 5 | d >>> 27;
        c = t + f + c - 1894007588 + blocks[j + 2] << 0;
        e = e << 30 | e >>> 2;
        f = d & e | d & a | e & a;
        t = c << 5 | c >>> 27;
        b = t + f + b - 1894007588 + blocks[j + 3] << 0;
        d = d << 30 | d >>> 2;
        f = c & d | c & e | d & e;
        t = b << 5 | b >>> 27;
        a = t + f + a - 1894007588 + blocks[j + 4] << 0;
        c = c << 30 | c >>> 2;
    }
    for(; j < 80; j += 5){
        f = b ^ c ^ d;
        t = a << 5 | a >>> 27;
        e = t + f + e - 899497514 + blocks[j] << 0;
        b = b << 30 | b >>> 2;
        f = a ^ b ^ c;
        t = e << 5 | e >>> 27;
        d = t + f + d - 899497514 + blocks[j + 1] << 0;
        a = a << 30 | a >>> 2;
        f = e ^ a ^ b;
        t = d << 5 | d >>> 27;
        c = t + f + c - 899497514 + blocks[j + 2] << 0;
        e = e << 30 | e >>> 2;
        f = d ^ e ^ a;
        t = c << 5 | c >>> 27;
        b = t + f + b - 899497514 + blocks[j + 3] << 0;
        d = d << 30 | d >>> 2;
        f = c ^ d ^ e;
        t = b << 5 | b >>> 27;
        a = t + f + a - 899497514 + blocks[j + 4] << 0;
        c = c << 30 | c >>> 2;
    }
    this.h0 = this.h0 + a << 0;
    this.h1 = this.h1 + b << 0;
    this.h2 = this.h2 + c << 0;
    this.h3 = this.h3 + d << 0;
    this.h4 = this.h4 + e << 0;
};
Sha1.prototype.hex = function() {
    this.finalize();
    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4;
    return HEX_CHARS[h0 >> 28 & 0x0f] + HEX_CHARS[h0 >> 24 & 0x0f] + HEX_CHARS[h0 >> 20 & 0x0f] + HEX_CHARS[h0 >> 16 & 0x0f] + HEX_CHARS[h0 >> 12 & 0x0f] + HEX_CHARS[h0 >> 8 & 0x0f] + HEX_CHARS[h0 >> 4 & 0x0f] + HEX_CHARS[h0 & 0x0f] + HEX_CHARS[h1 >> 28 & 0x0f] + HEX_CHARS[h1 >> 24 & 0x0f] + HEX_CHARS[h1 >> 20 & 0x0f] + HEX_CHARS[h1 >> 16 & 0x0f] + HEX_CHARS[h1 >> 12 & 0x0f] + HEX_CHARS[h1 >> 8 & 0x0f] + HEX_CHARS[h1 >> 4 & 0x0f] + HEX_CHARS[h1 & 0x0f] + HEX_CHARS[h2 >> 28 & 0x0f] + HEX_CHARS[h2 >> 24 & 0x0f] + HEX_CHARS[h2 >> 20 & 0x0f] + HEX_CHARS[h2 >> 16 & 0x0f] + HEX_CHARS[h2 >> 12 & 0x0f] + HEX_CHARS[h2 >> 8 & 0x0f] + HEX_CHARS[h2 >> 4 & 0x0f] + HEX_CHARS[h2 & 0x0f] + HEX_CHARS[h3 >> 28 & 0x0f] + HEX_CHARS[h3 >> 24 & 0x0f] + HEX_CHARS[h3 >> 20 & 0x0f] + HEX_CHARS[h3 >> 16 & 0x0f] + HEX_CHARS[h3 >> 12 & 0x0f] + HEX_CHARS[h3 >> 8 & 0x0f] + HEX_CHARS[h3 >> 4 & 0x0f] + HEX_CHARS[h3 & 0x0f] + HEX_CHARS[h4 >> 28 & 0x0f] + HEX_CHARS[h4 >> 24 & 0x0f] + HEX_CHARS[h4 >> 20 & 0x0f] + HEX_CHARS[h4 >> 16 & 0x0f] + HEX_CHARS[h4 >> 12 & 0x0f] + HEX_CHARS[h4 >> 8 & 0x0f] + HEX_CHARS[h4 >> 4 & 0x0f] + HEX_CHARS[h4 & 0x0f];
};
Sha1.prototype.toString = Sha1.prototype.hex;
Sha1.prototype.digest = function() {
    this.finalize();
    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4;
    return [
        h0 >> 24 & 0xff,
        h0 >> 16 & 0xff,
        h0 >> 8 & 0xff,
        h0 & 0xff,
        h1 >> 24 & 0xff,
        h1 >> 16 & 0xff,
        h1 >> 8 & 0xff,
        h1 & 0xff,
        h2 >> 24 & 0xff,
        h2 >> 16 & 0xff,
        h2 >> 8 & 0xff,
        h2 & 0xff,
        h3 >> 24 & 0xff,
        h3 >> 16 & 0xff,
        h3 >> 8 & 0xff,
        h3 & 0xff,
        h4 >> 24 & 0xff,
        h4 >> 16 & 0xff,
        h4 >> 8 & 0xff,
        h4 & 0xff
    ];
};
Sha1.prototype.array = Sha1.prototype.digest;
Sha1.prototype.arrayBuffer = function() {
    this.finalize();
    var buffer = new ArrayBuffer(20);
    var dataView = new DataView(buffer);
    dataView.setUint32(0, this.h0);
    dataView.setUint32(4, this.h1);
    dataView.setUint32(8, this.h2);
    dataView.setUint32(12, this.h3);
    dataView.setUint32(16, this.h4);
    return buffer;
};
const insecureHash = (message)=>{
    return new Sha1(true).update(message)["hex"]();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6vi0n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "coerceMessageLikeToMessage", ()=>coerceMessageLikeToMessage);
/**
 * This function is used by memory classes to get a string representation
 * of the chat message history, based on the message content and role.
 */ parcelHelpers.export(exports, "getBufferString", ()=>getBufferString);
parcelHelpers.export(exports, "mapStoredMessageToChatMessage", ()=>mapStoredMessageToChatMessage);
/**
 * Transforms an array of `StoredMessage` instances into an array of
 * `BaseMessage` instances. It uses the `mapV1MessageToStoredMessage`
 * function to ensure all messages are in the `StoredMessage` format, then
 * creates new instances of the appropriate `BaseMessage` subclass based
 * on the type of each message. This function is used to prepare stored
 * messages for use in a chat context.
 */ parcelHelpers.export(exports, "mapStoredMessagesToChatMessages", ()=>mapStoredMessagesToChatMessages);
/**
 * Transforms an array of `BaseMessage` instances into an array of
 * `StoredMessage` instances. It does this by calling the `toDict` method
 * on each `BaseMessage`, which returns a `StoredMessage`. This function
 * is used to prepare chat messages for storage.
 */ parcelHelpers.export(exports, "mapChatMessagesToStoredMessages", ()=>mapChatMessagesToStoredMessages);
parcelHelpers.export(exports, "convertToChunk", ()=>convertToChunk);
var _indexJs = require("../errors/index.js");
var _utilsJs = require("../tools/utils.js");
var _aiJs = require("./ai.js");
var _baseJs = require("./base.js");
var _chatJs = require("./chat.js");
var _functionJs = require("./function.js");
var _humanJs = require("./human.js");
var _systemJs = require("./system.js");
var _toolJs = require("./tool.js");
function _coerceToolCall(toolCall) {
    if ((0, _utilsJs._isToolCall)(toolCall)) return toolCall;
    else if (typeof toolCall.id === "string" && toolCall.type === "function" && typeof toolCall.function === "object" && toolCall.function !== null && "arguments" in toolCall.function && typeof toolCall.function.arguments === "string" && "name" in toolCall.function && typeof toolCall.function.name === "string") // Handle OpenAI tool call format
    return {
        id: toolCall.id,
        args: JSON.parse(toolCall.function.arguments),
        name: toolCall.function.name,
        type: "tool_call"
    };
    else // TODO: Throw an error?
    return toolCall;
}
function isSerializedConstructor(x) {
    return typeof x === "object" && x != null && x.lc === 1 && Array.isArray(x.id) && x.kwargs != null && typeof x.kwargs === "object";
}
function _constructMessageFromParams(params) {
    let type;
    let rest;
    // Support serialized messages
    if (isSerializedConstructor(params)) {
        const className = params.id.at(-1);
        if (className === "HumanMessage" || className === "HumanMessageChunk") type = "user";
        else if (className === "AIMessage" || className === "AIMessageChunk") type = "assistant";
        else if (className === "SystemMessage" || className === "SystemMessageChunk") type = "system";
        else type = "unknown";
        rest = params.kwargs;
    } else {
        const { type: extractedType, ...otherParams } = params;
        type = extractedType;
        rest = otherParams;
    }
    if (type === "human" || type === "user") return new (0, _humanJs.HumanMessage)(rest);
    else if (type === "ai" || type === "assistant") {
        const { tool_calls: rawToolCalls, ...other } = rest;
        if (!Array.isArray(rawToolCalls)) return new (0, _aiJs.AIMessage)(rest);
        const tool_calls = rawToolCalls.map(_coerceToolCall);
        return new (0, _aiJs.AIMessage)({
            ...other,
            tool_calls
        });
    } else if (type === "system") return new (0, _systemJs.SystemMessage)(rest);
    else if (type === "tool" && "tool_call_id" in rest) return new (0, _toolJs.ToolMessage)({
        ...rest,
        content: rest.content,
        tool_call_id: rest.tool_call_id,
        name: rest.name
    });
    else {
        const error = (0, _indexJs.addLangChainErrorFields)(new Error(`Unable to coerce message from array: only human, AI, system, or tool message coercion is currently supported.\n\nReceived: ${JSON.stringify(params, null, 2)}`), "MESSAGE_COERCION_FAILURE");
        throw error;
    }
}
function coerceMessageLikeToMessage(messageLike) {
    if (typeof messageLike === "string") return new (0, _humanJs.HumanMessage)(messageLike);
    else if ((0, _baseJs.isBaseMessage)(messageLike)) return messageLike;
    if (Array.isArray(messageLike)) {
        const [type, content] = messageLike;
        return _constructMessageFromParams({
            type,
            content
        });
    } else if ((0, _baseJs._isMessageFieldWithRole)(messageLike)) {
        const { role: type, ...rest } = messageLike;
        return _constructMessageFromParams({
            ...rest,
            type
        });
    } else return _constructMessageFromParams(messageLike);
}
function getBufferString(messages, humanPrefix = "Human", aiPrefix = "AI") {
    const string_messages = [];
    for (const m of messages){
        let role;
        if (m._getType() === "human") role = humanPrefix;
        else if (m._getType() === "ai") role = aiPrefix;
        else if (m._getType() === "system") role = "System";
        else if (m._getType() === "function") role = "Function";
        else if (m._getType() === "tool") role = "Tool";
        else if (m._getType() === "generic") role = m.role;
        else throw new Error(`Got unsupported message type: ${m._getType()}`);
        const nameStr = m.name ? `${m.name}, ` : "";
        const readableContent = typeof m.content === "string" ? m.content : JSON.stringify(m.content, null, 2);
        string_messages.push(`${role}: ${nameStr}${readableContent}`);
    }
    return string_messages.join("\n");
}
/**
 * Maps messages from an older format (V1) to the current `StoredMessage`
 * format. If the message is already in the `StoredMessage` format, it is
 * returned as is. Otherwise, it transforms the V1 message into a
 * `StoredMessage`. This function is important for maintaining
 * compatibility with older message formats.
 */ function mapV1MessageToStoredMessage(message) {
    // TODO: Remove this mapper when we deprecate the old message format.
    if (message.data !== undefined) return message;
    else {
        const v1Message = message;
        return {
            type: v1Message.type,
            data: {
                content: v1Message.text,
                role: v1Message.role,
                name: undefined,
                tool_call_id: undefined
            }
        };
    }
}
function mapStoredMessageToChatMessage(message) {
    const storedMessage = mapV1MessageToStoredMessage(message);
    switch(storedMessage.type){
        case "human":
            return new (0, _humanJs.HumanMessage)(storedMessage.data);
        case "ai":
            return new (0, _aiJs.AIMessage)(storedMessage.data);
        case "system":
            return new (0, _systemJs.SystemMessage)(storedMessage.data);
        case "function":
            if (storedMessage.data.name === undefined) throw new Error("Name must be defined for function messages");
            return new (0, _functionJs.FunctionMessage)(storedMessage.data);
        case "tool":
            if (storedMessage.data.tool_call_id === undefined) throw new Error("Tool call ID must be defined for tool messages");
            return new (0, _toolJs.ToolMessage)(storedMessage.data);
        case "generic":
            if (storedMessage.data.role === undefined) throw new Error("Role must be defined for chat messages");
            return new (0, _chatJs.ChatMessage)(storedMessage.data);
        default:
            throw new Error(`Got unexpected type: ${storedMessage.type}`);
    }
}
function mapStoredMessagesToChatMessages(messages) {
    return messages.map(mapStoredMessageToChatMessage);
}
function mapChatMessagesToStoredMessages(messages) {
    return messages.map((message)=>message.toDict());
}
function convertToChunk(message) {
    const type = message._getType();
    if (type === "human") // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return new (0, _humanJs.HumanMessageChunk)({
        ...message
    });
    else if (type === "ai") {
        let aiChunkFields = {
            ...message
        };
        if ("tool_calls" in aiChunkFields) aiChunkFields = {
            ...aiChunkFields,
            tool_call_chunks: aiChunkFields.tool_calls?.map((tc)=>({
                    ...tc,
                    type: "tool_call_chunk",
                    index: undefined,
                    args: JSON.stringify(tc.args)
                }))
        };
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return new (0, _aiJs.AIMessageChunk)({
            ...aiChunkFields
        });
    } else if (type === "system") // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return new (0, _systemJs.SystemMessageChunk)({
        ...message
    });
    else if (type === "function") // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return new (0, _functionJs.FunctionMessageChunk)({
        ...message
    });
    else if ((0, _chatJs.ChatMessage).isInstance(message)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return new (0, _chatJs.ChatMessageChunk)({
        ...message
    });
    else throw new Error("Unknown message type.");
}

},{"../errors/index.js":"cgnw3","../tools/utils.js":"vJeFM","./ai.js":"lkFVb","./base.js":"bWcpl","./chat.js":"ih7Pn","./function.js":"bia1q","./human.js":"2YgBC","./system.js":"8i8IV","./tool.js":"04Rfb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cgnw3":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addLangChainErrorFields", ()=>addLangChainErrorFields);
function addLangChainErrorFields(error, lc_error_code) {
    error.lc_error_code = lc_error_code;
    error.message = `${error.message}\n\nTroubleshooting URL: https://js.langchain.com/docs/troubleshooting/errors/${lc_error_code}/\n`;
    return error;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"vJeFM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_isToolCall", ()=>_isToolCall);
/**
 * Custom error class used to handle exceptions related to tool input parsing.
 * It extends the built-in `Error` class and adds an optional `output`
 * property that can hold the output that caused the exception.
 */ parcelHelpers.export(exports, "ToolInputParsingException", ()=>ToolInputParsingException);
function _isToolCall(toolCall) {
    return !!(toolCall && typeof toolCall === "object" && "type" in toolCall && toolCall.type === "tool_call");
}
class ToolInputParsingException extends Error {
    constructor(message, output){
        super(message);
        Object.defineProperty(this, "output", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.output = output;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lkFVb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents an AI message in a conversation.
 */ parcelHelpers.export(exports, "AIMessage", ()=>AIMessage);
parcelHelpers.export(exports, "isAIMessage", ()=>isAIMessage);
parcelHelpers.export(exports, "isAIMessageChunk", ()=>isAIMessageChunk);
/**
 * Represents a chunk of an AI message, which can be concatenated with
 * other AI message chunks.
 */ parcelHelpers.export(exports, "AIMessageChunk", ()=>AIMessageChunk);
var _jsonJs = require("../utils/json.js");
var _baseJs = require("./base.js");
var _toolJs = require("./tool.js");
class AIMessage extends (0, _baseJs.BaseMessage) {
    get lc_aliases() {
        // exclude snake case conversion to pascal case
        return {
            ...super.lc_aliases,
            tool_calls: "tool_calls",
            invalid_tool_calls: "invalid_tool_calls"
        };
    }
    constructor(fields, /** @deprecated */ kwargs){
        let initParams;
        if (typeof fields === "string") initParams = {
            content: fields,
            tool_calls: [],
            invalid_tool_calls: [],
            additional_kwargs: kwargs ?? {}
        };
        else {
            initParams = fields;
            const rawToolCalls = initParams.additional_kwargs?.tool_calls;
            const toolCalls = initParams.tool_calls;
            if (!(rawToolCalls == null) && rawToolCalls.length > 0 && (toolCalls === undefined || toolCalls.length === 0)) console.warn([
                "New LangChain packages are available that more efficiently handle",
                "tool calling.\n\nPlease upgrade your packages to versions that set",
                "message tool calls. e.g., `yarn add @langchain/anthropic`,",
                "yarn add @langchain/openai`, etc."
            ].join(" "));
            try {
                if (!(rawToolCalls == null) && toolCalls === undefined) {
                    const [toolCalls, invalidToolCalls] = (0, _toolJs.defaultToolCallParser)(rawToolCalls);
                    initParams.tool_calls = toolCalls ?? [];
                    initParams.invalid_tool_calls = invalidToolCalls ?? [];
                } else {
                    initParams.tool_calls = initParams.tool_calls ?? [];
                    initParams.invalid_tool_calls = initParams.invalid_tool_calls ?? [];
                }
            } catch (e) {
                // Do nothing if parsing fails
                initParams.tool_calls = [];
                initParams.invalid_tool_calls = [];
            }
        }
        // Sadly, TypeScript only allows super() calls at root if the class has
        // properties with initializers, so we have to check types twice.
        super(initParams);
        // These are typed as optional to avoid breaking changes and allow for casting
        // from BaseMessage.
        Object.defineProperty(this, "tool_calls", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "invalid_tool_calls", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        /**
         * If provided, token usage information associated with the message.
         */ Object.defineProperty(this, "usage_metadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (typeof initParams !== "string") {
            this.tool_calls = initParams.tool_calls ?? this.tool_calls;
            this.invalid_tool_calls = initParams.invalid_tool_calls ?? this.invalid_tool_calls;
        }
        this.usage_metadata = initParams.usage_metadata;
    }
    static lc_name() {
        return "AIMessage";
    }
    _getType() {
        return "ai";
    }
    get _printableFields() {
        return {
            ...super._printableFields,
            tool_calls: this.tool_calls,
            invalid_tool_calls: this.invalid_tool_calls,
            usage_metadata: this.usage_metadata
        };
    }
}
function isAIMessage(x) {
    return x._getType() === "ai";
}
function isAIMessageChunk(x) {
    return x._getType() === "ai";
}
class AIMessageChunk extends (0, _baseJs.BaseMessageChunk) {
    constructor(fields){
        let initParams;
        if (typeof fields === "string") initParams = {
            content: fields,
            tool_calls: [],
            invalid_tool_calls: [],
            tool_call_chunks: []
        };
        else if (fields.tool_call_chunks === undefined) initParams = {
            ...fields,
            tool_calls: fields.tool_calls ?? [],
            invalid_tool_calls: [],
            tool_call_chunks: [],
            usage_metadata: fields.usage_metadata !== undefined ? fields.usage_metadata : undefined
        };
        else {
            const toolCalls = [];
            const invalidToolCalls = [];
            for (const toolCallChunk of fields.tool_call_chunks){
                let parsedArgs = {};
                try {
                    parsedArgs = (0, _jsonJs.parsePartialJson)(toolCallChunk.args || "{}");
                    if (parsedArgs === null || typeof parsedArgs !== "object" || Array.isArray(parsedArgs)) throw new Error("Malformed tool call chunk args.");
                    toolCalls.push({
                        name: toolCallChunk.name ?? "",
                        args: parsedArgs,
                        id: toolCallChunk.id,
                        type: "tool_call"
                    });
                } catch (e) {
                    invalidToolCalls.push({
                        name: toolCallChunk.name,
                        args: toolCallChunk.args,
                        id: toolCallChunk.id,
                        error: "Malformed args.",
                        type: "invalid_tool_call"
                    });
                }
            }
            initParams = {
                ...fields,
                tool_calls: toolCalls,
                invalid_tool_calls: invalidToolCalls,
                usage_metadata: fields.usage_metadata !== undefined ? fields.usage_metadata : undefined
            };
        }
        // Sadly, TypeScript only allows super() calls at root if the class has
        // properties with initializers, so we have to check types twice.
        super(initParams);
        // Must redeclare tool call fields since there is no multiple inheritance in JS.
        // These are typed as optional to avoid breaking changes and allow for casting
        // from BaseMessage.
        Object.defineProperty(this, "tool_calls", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "invalid_tool_calls", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "tool_call_chunks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        /**
         * If provided, token usage information associated with the message.
         */ Object.defineProperty(this, "usage_metadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.tool_call_chunks = initParams.tool_call_chunks ?? this.tool_call_chunks;
        this.tool_calls = initParams.tool_calls ?? this.tool_calls;
        this.invalid_tool_calls = initParams.invalid_tool_calls ?? this.invalid_tool_calls;
        this.usage_metadata = initParams.usage_metadata;
    }
    get lc_aliases() {
        // exclude snake case conversion to pascal case
        return {
            ...super.lc_aliases,
            tool_calls: "tool_calls",
            invalid_tool_calls: "invalid_tool_calls",
            tool_call_chunks: "tool_call_chunks"
        };
    }
    static lc_name() {
        return "AIMessageChunk";
    }
    _getType() {
        return "ai";
    }
    get _printableFields() {
        return {
            ...super._printableFields,
            tool_calls: this.tool_calls,
            tool_call_chunks: this.tool_call_chunks,
            invalid_tool_calls: this.invalid_tool_calls,
            usage_metadata: this.usage_metadata
        };
    }
    concat(chunk) {
        const combinedFields = {
            content: (0, _baseJs.mergeContent)(this.content, chunk.content),
            additional_kwargs: (0, _baseJs._mergeDicts)(this.additional_kwargs, chunk.additional_kwargs),
            response_metadata: (0, _baseJs._mergeDicts)(this.response_metadata, chunk.response_metadata),
            tool_call_chunks: [],
            id: this.id ?? chunk.id
        };
        if (this.tool_call_chunks !== undefined || chunk.tool_call_chunks !== undefined) {
            const rawToolCalls = (0, _baseJs._mergeLists)(this.tool_call_chunks, chunk.tool_call_chunks);
            if (rawToolCalls !== undefined && rawToolCalls.length > 0) combinedFields.tool_call_chunks = rawToolCalls;
        }
        if (this.usage_metadata !== undefined || chunk.usage_metadata !== undefined) {
            const inputTokenDetails = {
                ...(this.usage_metadata?.input_token_details?.audio !== undefined || chunk.usage_metadata?.input_token_details?.audio !== undefined) && {
                    audio: (this.usage_metadata?.input_token_details?.audio ?? 0) + (chunk.usage_metadata?.input_token_details?.audio ?? 0)
                },
                ...(this.usage_metadata?.input_token_details?.cache_read !== undefined || chunk.usage_metadata?.input_token_details?.cache_read !== undefined) && {
                    cache_read: (this.usage_metadata?.input_token_details?.cache_read ?? 0) + (chunk.usage_metadata?.input_token_details?.cache_read ?? 0)
                },
                ...(this.usage_metadata?.input_token_details?.cache_creation !== undefined || chunk.usage_metadata?.input_token_details?.cache_creation !== undefined) && {
                    cache_creation: (this.usage_metadata?.input_token_details?.cache_creation ?? 0) + (chunk.usage_metadata?.input_token_details?.cache_creation ?? 0)
                }
            };
            const outputTokenDetails = {
                ...(this.usage_metadata?.output_token_details?.audio !== undefined || chunk.usage_metadata?.output_token_details?.audio !== undefined) && {
                    audio: (this.usage_metadata?.output_token_details?.audio ?? 0) + (chunk.usage_metadata?.output_token_details?.audio ?? 0)
                },
                ...(this.usage_metadata?.output_token_details?.reasoning !== undefined || chunk.usage_metadata?.output_token_details?.reasoning !== undefined) && {
                    reasoning: (this.usage_metadata?.output_token_details?.reasoning ?? 0) + (chunk.usage_metadata?.output_token_details?.reasoning ?? 0)
                }
            };
            const left = this.usage_metadata ?? {
                input_tokens: 0,
                output_tokens: 0,
                total_tokens: 0
            };
            const right = chunk.usage_metadata ?? {
                input_tokens: 0,
                output_tokens: 0,
                total_tokens: 0
            };
            const usage_metadata = {
                input_tokens: left.input_tokens + right.input_tokens,
                output_tokens: left.output_tokens + right.output_tokens,
                total_tokens: left.total_tokens + right.total_tokens,
                // Do not include `input_token_details` / `output_token_details` keys in combined fields
                // unless their values are defined.
                ...Object.keys(inputTokenDetails).length > 0 && {
                    input_token_details: inputTokenDetails
                },
                ...Object.keys(outputTokenDetails).length > 0 && {
                    output_token_details: outputTokenDetails
                }
            };
            combinedFields.usage_metadata = usage_metadata;
        }
        return new AIMessageChunk(combinedFields);
    }
}

},{"../utils/json.js":"3dcBo","./base.js":"bWcpl","./tool.js":"04Rfb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3dcBo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseJsonMarkdown", ()=>parseJsonMarkdown);
// Adapted from https://github.com/KillianLucas/open-interpreter/blob/main/interpreter/core/llm/utils/parse_partial_json.py
// MIT License
parcelHelpers.export(exports, "parsePartialJson", ()=>parsePartialJson);
function parseJsonMarkdown(s, parser = parsePartialJson) {
    // eslint-disable-next-line no-param-reassign
    s = s.trim();
    const match = /```(json)?(.*)```/s.exec(s);
    if (!match) return parser(s);
    else return parser(match[2]);
}
function parsePartialJson(s) {
    // If the input is undefined, return null to indicate failure.
    if (typeof s === "undefined") return null;
    // Attempt to parse the string as-is.
    try {
        return JSON.parse(s);
    } catch (error) {
    // Pass
    }
    // Initialize variables.
    let new_s = "";
    const stack = [];
    let isInsideString = false;
    let escaped = false;
    // Process each character in the string one at a time.
    for (let char of s){
        if (isInsideString) {
            if (char === '"' && !escaped) isInsideString = false;
            else if (char === "\n" && !escaped) char = "\\n"; // Replace the newline character with the escape sequence.
            else if (char === "\\") escaped = !escaped;
            else escaped = false;
        } else {
            if (char === '"') {
                isInsideString = true;
                escaped = false;
            } else if (char === "{") stack.push("}");
            else if (char === "[") stack.push("]");
            else if (char === "}" || char === "]") {
                if (stack && stack[stack.length - 1] === char) stack.pop();
                else // Mismatched closing character; the input is malformed.
                return null;
            }
        }
        // Append the processed character to the new string.
        new_s += char;
    }
    // If we're still inside a string at the end of processing,
    // we need to close the string.
    if (isInsideString) new_s += '"';
    // Close any remaining open structures in the reverse order that they were opened.
    for(let i = stack.length - 1; i >= 0; i -= 1)new_s += stack[i];
    // Attempt to parse the modified string as JSON.
    try {
        return JSON.parse(new_s);
    } catch (error) {
        // If we still can't parse the string as JSON, return null to indicate failure.
        return null;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bWcpl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeContent", ()=>mergeContent);
/**
 * 'Merge' two statuses. If either value passed is 'error', it will return 'error'. Else
 * it will return 'success'.
 *
 * @param {"success" | "error" | undefined} left The existing value to 'merge' with the new value.
 * @param {"success" | "error" | undefined} right The new value to 'merge' with the existing value
 * @returns {"success" | "error"} The 'merged' value.
 */ parcelHelpers.export(exports, "_mergeStatus", ()=>_mergeStatus);
/**
 * Base class for all types of messages in a conversation. It includes
 * properties like `content`, `name`, and `additional_kwargs`. It also
 * includes methods like `toDict()` and `_getType()`.
 */ parcelHelpers.export(exports, "BaseMessage", ()=>BaseMessage);
parcelHelpers.export(exports, "isOpenAIToolCallArray", ()=>isOpenAIToolCallArray);
parcelHelpers.export(exports, "_mergeDicts", ()=>_mergeDicts);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "_mergeLists", ()=>_mergeLists);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "_mergeObj", ()=>_mergeObj);
/**
 * Represents a chunk of a message, which can be concatenated with other
 * message chunks. It includes a method `_merge_kwargs_dict()` for merging
 * additional keyword arguments from another `BaseMessageChunk` into this
 * one. It also overrides the `__add__()` method to support concatenation
 * of `BaseMessageChunk` instances.
 */ parcelHelpers.export(exports, "BaseMessageChunk", ()=>BaseMessageChunk);
parcelHelpers.export(exports, "_isMessageFieldWithRole", ()=>_isMessageFieldWithRole);
parcelHelpers.export(exports, "isBaseMessage", ()=>isBaseMessage);
parcelHelpers.export(exports, "isBaseMessageChunk", ()=>isBaseMessageChunk);
var _serializableJs = require("../load/serializable.js");
function mergeContent(firstContent, secondContent) {
    // If first content is a string
    if (typeof firstContent === "string") {
        if (typeof secondContent === "string") return firstContent + secondContent;
        else return [
            {
                type: "text",
                text: firstContent
            },
            ...secondContent
        ];
    // If both are arrays
    } else if (Array.isArray(secondContent)) return _mergeLists(firstContent, secondContent) ?? [
        ...firstContent,
        ...secondContent
    ];
    else // Otherwise, add the second content as a new element of the list
    return [
        ...firstContent,
        {
            type: "text",
            text: secondContent
        }
    ];
}
function _mergeStatus(left, right) {
    if (left === "error" || right === "error") return "error";
    return "success";
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function stringifyWithDepthLimit(obj, depthLimit) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function helper(obj, currentDepth) {
        if (typeof obj !== "object" || obj === null || obj === undefined) return obj;
        if (currentDepth >= depthLimit) {
            if (Array.isArray(obj)) return "[Array]";
            return "[Object]";
        }
        if (Array.isArray(obj)) return obj.map((item)=>helper(item, currentDepth + 1));
        const result = {};
        for (const key of Object.keys(obj))result[key] = helper(obj[key], currentDepth + 1);
        return result;
    }
    return JSON.stringify(helper(obj, 0), null, 2);
}
class BaseMessage extends (0, _serializableJs.Serializable) {
    get lc_aliases() {
        // exclude snake case conversion to pascal case
        return {
            additional_kwargs: "additional_kwargs",
            response_metadata: "response_metadata"
        };
    }
    /**
     * @deprecated
     * Use {@link BaseMessage.content} instead.
     */ get text() {
        return typeof this.content === "string" ? this.content : "";
    }
    /** The type of the message. */ getType() {
        return this._getType();
    }
    constructor(fields, /** @deprecated */ kwargs){
        if (typeof fields === "string") // eslint-disable-next-line no-param-reassign
        fields = {
            content: fields,
            additional_kwargs: kwargs,
            response_metadata: {}
        };
        // Make sure the default value for additional_kwargs is passed into super() for serialization
        if (!fields.additional_kwargs) // eslint-disable-next-line no-param-reassign
        fields.additional_kwargs = {};
        if (!fields.response_metadata) // eslint-disable-next-line no-param-reassign
        fields.response_metadata = {};
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "messages"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        /** The content of the message. */ Object.defineProperty(this, "content", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** The name of the message sender in a multi-user chat. */ Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** Additional keyword arguments */ Object.defineProperty(this, "additional_kwargs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** Response metadata. For example: response headers, logprobs, token counts. */ Object.defineProperty(this, "response_metadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * An optional unique identifier for the message. This should ideally be
         * provided by the provider/model which created the message.
         */ Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = fields.name;
        this.content = fields.content;
        this.additional_kwargs = fields.additional_kwargs;
        this.response_metadata = fields.response_metadata;
        this.id = fields.id;
    }
    toDict() {
        return {
            type: this._getType(),
            data: this.toJSON().kwargs
        };
    }
    static lc_name() {
        return "BaseMessage";
    }
    // Can't be protected for silly reasons
    get _printableFields() {
        return {
            id: this.id,
            content: this.content,
            name: this.name,
            additional_kwargs: this.additional_kwargs,
            response_metadata: this.response_metadata
        };
    }
    // this private method is used to update the ID for the runtime
    // value as well as in lc_kwargs for serialisation
    _updateId(value) {
        this.id = value;
        // lc_attributes wouldn't work here, because jest compares the
        // whole object
        this.lc_kwargs.id = value;
    }
    get [Symbol.toStringTag]() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.constructor.lc_name();
    }
    // Override the default behavior of console.log
    [Symbol.for("nodejs.util.inspect.custom")](depth) {
        if (depth === null) return this;
        const printable = stringifyWithDepthLimit(this._printableFields, Math.max(4, depth));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return `${this.constructor.lc_name()} ${printable}`;
    }
}
function isOpenAIToolCallArray(value) {
    return Array.isArray(value) && value.every((v)=>typeof v.index === "number");
}
function _mergeDicts(// eslint-disable-next-line @typescript-eslint/no-explicit-any
left, // eslint-disable-next-line @typescript-eslint/no-explicit-any
right) {
    const merged = {
        ...left
    };
    for (const [key, value] of Object.entries(right)){
        if (merged[key] == null) merged[key] = value;
        else if (value == null) continue;
        else if (typeof merged[key] !== typeof value || Array.isArray(merged[key]) !== Array.isArray(value)) throw new Error(`field[${key}] already exists in the message chunk, but with a different type.`);
        else if (typeof merged[key] === "string") {
            if (key === "type") continue;
            merged[key] += value;
        } else if (typeof merged[key] === "object" && !Array.isArray(merged[key])) merged[key] = _mergeDicts(merged[key], value);
        else if (Array.isArray(merged[key])) merged[key] = _mergeLists(merged[key], value);
        else if (merged[key] === value) continue;
        else console.warn(`field[${key}] already exists in this message chunk and value has unsupported type.`);
    }
    return merged;
}
function _mergeLists(left, right) {
    if (left === undefined && right === undefined) return undefined;
    else if (left === undefined || right === undefined) return left || right;
    else {
        const merged = [
            ...left
        ];
        for (const item of right){
            if (typeof item === "object" && "index" in item && typeof item.index === "number") {
                const toMerge = merged.findIndex((leftItem)=>leftItem.index === item.index);
                if (toMerge !== -1) merged[toMerge] = _mergeDicts(merged[toMerge], item);
                else merged.push(item);
            } else if (typeof item === "object" && "text" in item && item.text === "") continue;
            else merged.push(item);
        }
        return merged;
    }
}
function _mergeObj(left, right) {
    if (!left && !right) throw new Error("Cannot merge two undefined objects.");
    if (!left || !right) return left || right;
    else if (typeof left !== typeof right) throw new Error(`Cannot merge objects of different types.\nLeft ${typeof left}\nRight ${typeof right}`);
    else if (typeof left === "string" && typeof right === "string") return left + right;
    else if (Array.isArray(left) && Array.isArray(right)) return _mergeLists(left, right);
    else if (typeof left === "object" && typeof right === "object") return _mergeDicts(left, right);
    else if (left === right) return left;
    else throw new Error(`Can not merge objects of different types.\nLeft ${left}\nRight ${right}`);
}
class BaseMessageChunk extends BaseMessage {
}
function _isMessageFieldWithRole(x) {
    return typeof x.role === "string";
}
function isBaseMessage(messageLike) {
    return typeof messageLike?._getType === "function";
}
function isBaseMessageChunk(messageLike) {
    return isBaseMessage(messageLike) && typeof messageLike.concat === "function";
}

},{"../load/serializable.js":"2n7FI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"04Rfb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a tool message in a conversation.
 */ parcelHelpers.export(exports, "ToolMessage", ()=>ToolMessage);
/**
 * Represents a chunk of a tool message, which can be concatenated
 * with other tool message chunks.
 */ parcelHelpers.export(exports, "ToolMessageChunk", ()=>ToolMessageChunk);
parcelHelpers.export(exports, "defaultToolCallParser", ()=>defaultToolCallParser);
parcelHelpers.export(exports, "isToolMessage", ()=>isToolMessage);
parcelHelpers.export(exports, "isToolMessageChunk", ()=>isToolMessageChunk);
var _baseJs = require("./base.js");
class ToolMessage extends (0, _baseJs.BaseMessage) {
    static lc_name() {
        return "ToolMessage";
    }
    get lc_aliases() {
        // exclude snake case conversion to pascal case
        return {
            tool_call_id: "tool_call_id"
        };
    }
    constructor(fields, tool_call_id, name){
        if (typeof fields === "string") // eslint-disable-next-line no-param-reassign, @typescript-eslint/no-non-null-assertion
        fields = {
            content: fields,
            name,
            tool_call_id: tool_call_id
        };
        super(fields);
        /**
         * Status of the tool invocation.
         * @version 0.2.19
         */ Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tool_call_id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Artifact of the Tool execution which is not meant to be sent to the model.
         *
         * Should only be specified if it is different from the message content, e.g. if only
         * a subset of the full tool output is being passed as message content but the full
         * output is needed in other parts of the code.
         */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "artifact", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.tool_call_id = fields.tool_call_id;
        this.artifact = fields.artifact;
        this.status = fields.status;
    }
    _getType() {
        return "tool";
    }
    static isInstance(message) {
        return message._getType() === "tool";
    }
    get _printableFields() {
        return {
            ...super._printableFields,
            tool_call_id: this.tool_call_id,
            artifact: this.artifact
        };
    }
}
class ToolMessageChunk extends (0, _baseJs.BaseMessageChunk) {
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "tool_call_id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Status of the tool invocation.
         * @version 0.2.19
         */ Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Artifact of the Tool execution which is not meant to be sent to the model.
         *
         * Should only be specified if it is different from the message content, e.g. if only
         * a subset of the full tool output is being passed as message content but the full
         * output is needed in other parts of the code.
         */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "artifact", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.tool_call_id = fields.tool_call_id;
        this.artifact = fields.artifact;
        this.status = fields.status;
    }
    static lc_name() {
        return "ToolMessageChunk";
    }
    _getType() {
        return "tool";
    }
    concat(chunk) {
        return new ToolMessageChunk({
            content: (0, _baseJs.mergeContent)(this.content, chunk.content),
            additional_kwargs: (0, _baseJs._mergeDicts)(this.additional_kwargs, chunk.additional_kwargs),
            response_metadata: (0, _baseJs._mergeDicts)(this.response_metadata, chunk.response_metadata),
            artifact: (0, _baseJs._mergeObj)(this.artifact, chunk.artifact),
            tool_call_id: this.tool_call_id,
            id: this.id ?? chunk.id,
            status: (0, _baseJs._mergeStatus)(this.status, chunk.status)
        });
    }
    get _printableFields() {
        return {
            ...super._printableFields,
            tool_call_id: this.tool_call_id,
            artifact: this.artifact
        };
    }
}
function defaultToolCallParser(// eslint-disable-next-line @typescript-eslint/no-explicit-any
rawToolCalls) {
    const toolCalls = [];
    const invalidToolCalls = [];
    for (const toolCall of rawToolCalls){
        if (!toolCall.function) continue;
        else {
            const functionName = toolCall.function.name;
            try {
                const functionArgs = JSON.parse(toolCall.function.arguments);
                const parsed = {
                    name: functionName || "",
                    args: functionArgs || {},
                    id: toolCall.id
                };
                toolCalls.push(parsed);
            } catch (error) {
                invalidToolCalls.push({
                    name: functionName,
                    args: toolCall.function.arguments,
                    id: toolCall.id,
                    error: "Malformed args."
                });
            }
        }
    }
    return [
        toolCalls,
        invalidToolCalls
    ];
}
function isToolMessage(x) {
    return x._getType() === "tool";
}
function isToolMessageChunk(x) {
    return x._getType() === "tool";
}

},{"./base.js":"bWcpl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ih7Pn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a chat message in a conversation.
 */ parcelHelpers.export(exports, "ChatMessage", ()=>ChatMessage);
/**
 * Represents a chunk of a chat message, which can be concatenated with
 * other chat message chunks.
 */ parcelHelpers.export(exports, "ChatMessageChunk", ()=>ChatMessageChunk);
parcelHelpers.export(exports, "isChatMessage", ()=>isChatMessage);
parcelHelpers.export(exports, "isChatMessageChunk", ()=>isChatMessageChunk);
var _baseJs = require("./base.js");
class ChatMessage extends (0, _baseJs.BaseMessage) {
    static lc_name() {
        return "ChatMessage";
    }
    static _chatMessageClass() {
        return ChatMessage;
    }
    constructor(fields, role){
        if (typeof fields === "string") // eslint-disable-next-line no-param-reassign, @typescript-eslint/no-non-null-assertion
        fields = {
            content: fields,
            role: role
        };
        super(fields);
        Object.defineProperty(this, "role", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.role = fields.role;
    }
    _getType() {
        return "generic";
    }
    static isInstance(message) {
        return message._getType() === "generic";
    }
    get _printableFields() {
        return {
            ...super._printableFields,
            role: this.role
        };
    }
}
class ChatMessageChunk extends (0, _baseJs.BaseMessageChunk) {
    static lc_name() {
        return "ChatMessageChunk";
    }
    constructor(fields, role){
        if (typeof fields === "string") // eslint-disable-next-line no-param-reassign, @typescript-eslint/no-non-null-assertion
        fields = {
            content: fields,
            role: role
        };
        super(fields);
        Object.defineProperty(this, "role", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.role = fields.role;
    }
    _getType() {
        return "generic";
    }
    concat(chunk) {
        return new ChatMessageChunk({
            content: (0, _baseJs.mergeContent)(this.content, chunk.content),
            additional_kwargs: (0, _baseJs._mergeDicts)(this.additional_kwargs, chunk.additional_kwargs),
            response_metadata: (0, _baseJs._mergeDicts)(this.response_metadata, chunk.response_metadata),
            role: this.role,
            id: this.id ?? chunk.id
        });
    }
    get _printableFields() {
        return {
            ...super._printableFields,
            role: this.role
        };
    }
}
function isChatMessage(x) {
    return x._getType() === "generic";
}
function isChatMessageChunk(x) {
    return x._getType() === "generic";
}

},{"./base.js":"bWcpl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bia1q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a function message in a conversation.
 */ parcelHelpers.export(exports, "FunctionMessage", ()=>FunctionMessage);
/**
 * Represents a chunk of a function message, which can be concatenated
 * with other function message chunks.
 */ parcelHelpers.export(exports, "FunctionMessageChunk", ()=>FunctionMessageChunk);
parcelHelpers.export(exports, "isFunctionMessage", ()=>isFunctionMessage);
parcelHelpers.export(exports, "isFunctionMessageChunk", ()=>isFunctionMessageChunk);
var _baseJs = require("./base.js");
class FunctionMessage extends (0, _baseJs.BaseMessage) {
    static lc_name() {
        return "FunctionMessage";
    }
    constructor(fields, /** @deprecated */ name){
        if (typeof fields === "string") // eslint-disable-next-line no-param-reassign, @typescript-eslint/no-non-null-assertion
        fields = {
            content: fields,
            name: name
        };
        super(fields);
    }
    _getType() {
        return "function";
    }
}
class FunctionMessageChunk extends (0, _baseJs.BaseMessageChunk) {
    static lc_name() {
        return "FunctionMessageChunk";
    }
    _getType() {
        return "function";
    }
    concat(chunk) {
        return new FunctionMessageChunk({
            content: (0, _baseJs.mergeContent)(this.content, chunk.content),
            additional_kwargs: (0, _baseJs._mergeDicts)(this.additional_kwargs, chunk.additional_kwargs),
            response_metadata: (0, _baseJs._mergeDicts)(this.response_metadata, chunk.response_metadata),
            name: this.name ?? "",
            id: this.id ?? chunk.id
        });
    }
}
function isFunctionMessage(x) {
    return x._getType() === "function";
}
function isFunctionMessageChunk(x) {
    return x._getType() === "function";
}

},{"./base.js":"bWcpl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2YgBC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a human message in a conversation.
 */ parcelHelpers.export(exports, "HumanMessage", ()=>HumanMessage);
/**
 * Represents a chunk of a human message, which can be concatenated with
 * other human message chunks.
 */ parcelHelpers.export(exports, "HumanMessageChunk", ()=>HumanMessageChunk);
parcelHelpers.export(exports, "isHumanMessage", ()=>isHumanMessage);
parcelHelpers.export(exports, "isHumanMessageChunk", ()=>isHumanMessageChunk);
var _baseJs = require("./base.js");
class HumanMessage extends (0, _baseJs.BaseMessage) {
    static lc_name() {
        return "HumanMessage";
    }
    _getType() {
        return "human";
    }
}
class HumanMessageChunk extends (0, _baseJs.BaseMessageChunk) {
    static lc_name() {
        return "HumanMessageChunk";
    }
    _getType() {
        return "human";
    }
    concat(chunk) {
        return new HumanMessageChunk({
            content: (0, _baseJs.mergeContent)(this.content, chunk.content),
            additional_kwargs: (0, _baseJs._mergeDicts)(this.additional_kwargs, chunk.additional_kwargs),
            response_metadata: (0, _baseJs._mergeDicts)(this.response_metadata, chunk.response_metadata),
            id: this.id ?? chunk.id
        });
    }
}
function isHumanMessage(x) {
    return x.getType() === "human";
}
function isHumanMessageChunk(x) {
    return x.getType() === "human";
}

},{"./base.js":"bWcpl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8i8IV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a system message in a conversation.
 */ parcelHelpers.export(exports, "SystemMessage", ()=>SystemMessage);
/**
 * Represents a chunk of a system message, which can be concatenated with
 * other system message chunks.
 */ parcelHelpers.export(exports, "SystemMessageChunk", ()=>SystemMessageChunk);
parcelHelpers.export(exports, "isSystemMessage", ()=>isSystemMessage);
parcelHelpers.export(exports, "isSystemMessageChunk", ()=>isSystemMessageChunk);
var _baseJs = require("./base.js");
class SystemMessage extends (0, _baseJs.BaseMessage) {
    static lc_name() {
        return "SystemMessage";
    }
    _getType() {
        return "system";
    }
}
class SystemMessageChunk extends (0, _baseJs.BaseMessageChunk) {
    static lc_name() {
        return "SystemMessageChunk";
    }
    _getType() {
        return "system";
    }
    concat(chunk) {
        return new SystemMessageChunk({
            content: (0, _baseJs.mergeContent)(this.content, chunk.content),
            additional_kwargs: (0, _baseJs._mergeDicts)(this.additional_kwargs, chunk.additional_kwargs),
            response_metadata: (0, _baseJs._mergeDicts)(this.response_metadata, chunk.response_metadata),
            id: this.id ?? chunk.id
        });
    }
}
function isSystemMessage(x) {
    return x._getType() === "system";
}
function isSystemMessageChunk(x) {
    return x._getType() === "system";
}

},{"./base.js":"bWcpl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kirBb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Abstract base class for creating callback handlers in the LangChain
 * framework. It provides a set of optional methods that can be overridden
 * in derived classes to handle various events during the execution of a
 * LangChain application.
 */ parcelHelpers.export(exports, "BaseCallbackHandler", ()=>BaseCallbackHandler);
var _uuid = require("uuid");
var _serializableJs = require("../load/serializable.js");
var _envJs = require("../utils/env.js");
/**
 * Abstract class that provides a set of optional methods that can be
 * overridden in derived classes to handle various events during the
 * execution of a LangChain application.
 */ class BaseCallbackHandlerMethodsClass {
}
class BaseCallbackHandler extends BaseCallbackHandlerMethodsClass {
    get lc_namespace() {
        return [
            "langchain_core",
            "callbacks",
            this.name
        ];
    }
    get lc_secrets() {
        return undefined;
    }
    get lc_attributes() {
        return undefined;
    }
    get lc_aliases() {
        return undefined;
    }
    /**
     * The name of the serializable. Override to provide an alias or
     * to preserve the serialized module name in minified environments.
     *
     * Implemented as a static method to support loading logic.
     */ static lc_name() {
        return this.name;
    }
    /**
     * The final serialized identifier for the module.
     */ get lc_id() {
        return [
            ...this.lc_namespace,
            (0, _serializableJs.get_lc_unique_name)(this.constructor)
        ];
    }
    constructor(input){
        super();
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "lc_kwargs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ignoreLLM", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "ignoreChain", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "ignoreAgent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "ignoreRetriever", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "ignoreCustomEvent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "raiseError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "awaitHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, _envJs.getEnvironmentVariable)("LANGCHAIN_CALLBACKS_BACKGROUND") === "false"
        });
        this.lc_kwargs = input || {};
        if (input) {
            this.ignoreLLM = input.ignoreLLM ?? this.ignoreLLM;
            this.ignoreChain = input.ignoreChain ?? this.ignoreChain;
            this.ignoreAgent = input.ignoreAgent ?? this.ignoreAgent;
            this.ignoreRetriever = input.ignoreRetriever ?? this.ignoreRetriever;
            this.ignoreCustomEvent = input.ignoreCustomEvent ?? this.ignoreCustomEvent;
            this.raiseError = input.raiseError ?? this.raiseError;
            this.awaitHandlers = this.raiseError || (input._awaitHandler ?? this.awaitHandlers);
        }
    }
    copy() {
        return new this.constructor(this);
    }
    toJSON() {
        return (0, _serializableJs.Serializable).prototype.toJSON.call(this);
    }
    toJSONNotImplemented() {
        return (0, _serializableJs.Serializable).prototype.toJSONNotImplemented.call(this);
    }
    static fromMethods(methods) {
        class Handler extends BaseCallbackHandler {
            constructor(){
                super();
                Object.defineProperty(this, "name", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: _uuid.v4()
                });
                Object.assign(this, methods);
            }
        }
        return new Handler();
    }
}

},{"uuid":"klst7","../load/serializable.js":"2n7FI","../utils/env.js":"4GIQu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4GIQu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
parcelHelpers.export(exports, "isWebWorker", ()=>isWebWorker);
parcelHelpers.export(exports, "isJsDom", ()=>isJsDom);
parcelHelpers.export(exports, "isDeno", ()=>isDeno);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "getEnv", ()=>getEnv);
parcelHelpers.export(exports, "getRuntimeEnvironment", ()=>getRuntimeEnvironment);
parcelHelpers.export(exports, "getEnvironmentVariable", ()=>getEnvironmentVariable);
var process = require("d7d668f88b40f2c1");
const isBrowser = ()=>typeof window !== "undefined" && typeof window.document !== "undefined";
const isWebWorker = ()=>typeof globalThis === "object" && globalThis.constructor && globalThis.constructor.name === "DedicatedWorkerGlobalScope";
const isJsDom = ()=>typeof window !== "undefined" && window.name === "nodejs" || typeof navigator !== "undefined" && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom"));
const isDeno = ()=>typeof Deno !== "undefined";
const isNode = ()=>typeof process !== "undefined" && typeof process.versions !== "undefined" && typeof process.versions.node !== "undefined" && !isDeno();
const getEnv = ()=>{
    let env;
    if (isBrowser()) env = "browser";
    else if (isNode()) env = "node";
    else if (isWebWorker()) env = "webworker";
    else if (isJsDom()) env = "jsdom";
    else if (isDeno()) env = "deno";
    else env = "other";
    return env;
};
let runtimeEnvironment;
async function getRuntimeEnvironment() {
    if (runtimeEnvironment === undefined) {
        const env = getEnv();
        runtimeEnvironment = {
            library: "langchain-js",
            runtime: env
        };
    }
    return runtimeEnvironment;
}
function getEnvironmentVariable(name) {
    // Certain Deno setups will throw an error if you try to access environment variables
    // https://github.com/langchain-ai/langchainjs/issues/1412
    try {
        return typeof process !== "undefined" ? process.env?.[name] : undefined;
    } catch (e) {
        return undefined;
    }
}

},{"d7d668f88b40f2c1":"5QIF0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5QIF0":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"bj69C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseCallbackConfigArg", ()=>parseCallbackConfigArg);
/**
 * Manage callbacks from different components of LangChain.
 */ parcelHelpers.export(exports, "BaseCallbackManager", ()=>BaseCallbackManager);
/**
 * Base class for run manager in LangChain.
 */ parcelHelpers.export(exports, "BaseRunManager", ()=>BaseRunManager);
/**
 * Manages callbacks for retriever runs.
 */ parcelHelpers.export(exports, "CallbackManagerForRetrieverRun", ()=>CallbackManagerForRetrieverRun);
parcelHelpers.export(exports, "CallbackManagerForLLMRun", ()=>CallbackManagerForLLMRun);
parcelHelpers.export(exports, "CallbackManagerForChainRun", ()=>CallbackManagerForChainRun);
parcelHelpers.export(exports, "CallbackManagerForToolRun", ()=>CallbackManagerForToolRun);
/**
 * @example
 * ```typescript
 * const prompt = PromptTemplate.fromTemplate("What is the answer to {question}?");
 *
 * // Example of using LLMChain with OpenAI and a simple prompt
 * const chain = new LLMChain({
 *   llm: new ChatOpenAI({ temperature: 0.9 }),
 *   prompt,
 * });
 *
 * // Running the chain with a single question
 * const result = await chain.call({
 *   question: "What is the airspeed velocity of an unladen swallow?",
 * });
 * console.log("The answer is:", result);
 * ```
 */ parcelHelpers.export(exports, "CallbackManager", ()=>CallbackManager);
parcelHelpers.export(exports, "ensureHandler", ()=>ensureHandler);
/**
 * @deprecated Use [`traceable`](https://docs.smith.langchain.com/observability/how_to_guides/tracing/annotate_code)
 * from "langsmith" instead.
 */ parcelHelpers.export(exports, "TraceGroup", ()=>TraceGroup);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "traceAsGroup", ()=>traceAsGroup);
var _uuid = require("uuid");
var _baseJs = require("./base.js");
var _consoleJs = require("../tracers/console.js");
var _utilsJs = require("../messages/utils.js");
var _envJs = require("../utils/env.js");
var _tracerLangchainJs = require("../tracers/tracer_langchain.js");
var _promisesJs = require("./promises.js");
var _callbacksJs = require("../utils/callbacks.js");
var _baseJs1 = require("../tracers/base.js");
function parseCallbackConfigArg(arg) {
    if (!arg) return {};
    else if (Array.isArray(arg) || "name" in arg) return {
        callbacks: arg
    };
    else return arg;
}
class BaseCallbackManager {
    setHandler(handler) {
        return this.setHandlers([
            handler
        ]);
    }
}
class BaseRunManager {
    constructor(runId, handlers, inheritableHandlers, tags, inheritableTags, metadata, inheritableMetadata, _parentRunId){
        Object.defineProperty(this, "runId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: runId
        });
        Object.defineProperty(this, "handlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: handlers
        });
        Object.defineProperty(this, "inheritableHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: inheritableHandlers
        });
        Object.defineProperty(this, "tags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: tags
        });
        Object.defineProperty(this, "inheritableTags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: inheritableTags
        });
        Object.defineProperty(this, "metadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: metadata
        });
        Object.defineProperty(this, "inheritableMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: inheritableMetadata
        });
        Object.defineProperty(this, "_parentRunId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _parentRunId
        });
    }
    get parentRunId() {
        return this._parentRunId;
    }
    async handleText(text) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                try {
                    await handler.handleText?.(text, this.runId, this._parentRunId, this.tags);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleText: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
    async handleCustomEvent(eventName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data, _runId, _tags, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _metadata) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                try {
                    await handler.handleCustomEvent?.(eventName, data, this.runId, this.tags, this.metadata);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleCustomEvent: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
}
class CallbackManagerForRetrieverRun extends BaseRunManager {
    getChild(tag) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        const manager = new CallbackManager(this.runId);
        manager.setHandlers(this.inheritableHandlers);
        manager.addTags(this.inheritableTags);
        manager.addMetadata(this.inheritableMetadata);
        if (tag) manager.addTags([
            tag
        ], false);
        return manager;
    }
    async handleRetrieverEnd(documents) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                if (!handler.ignoreRetriever) try {
                    await handler.handleRetrieverEnd?.(documents, this.runId, this._parentRunId, this.tags);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleRetriever`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
    async handleRetrieverError(err) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                if (!handler.ignoreRetriever) try {
                    await handler.handleRetrieverError?.(err, this.runId, this._parentRunId, this.tags);
                } catch (error) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleRetrieverError: ${error}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
}
class CallbackManagerForLLMRun extends BaseRunManager {
    async handleLLMNewToken(token, idx, _runId, _parentRunId, _tags, fields) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                if (!handler.ignoreLLM) try {
                    await handler.handleLLMNewToken?.(token, idx ?? {
                        prompt: 0,
                        completion: 0
                    }, this.runId, this._parentRunId, this.tags, fields);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleLLMNewToken: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
    async handleLLMError(err) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                if (!handler.ignoreLLM) try {
                    await handler.handleLLMError?.(err, this.runId, this._parentRunId, this.tags);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleLLMError: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
    async handleLLMEnd(output) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                if (!handler.ignoreLLM) try {
                    await handler.handleLLMEnd?.(output, this.runId, this._parentRunId, this.tags);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleLLMEnd: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
}
class CallbackManagerForChainRun extends BaseRunManager {
    getChild(tag) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        const manager = new CallbackManager(this.runId);
        manager.setHandlers(this.inheritableHandlers);
        manager.addTags(this.inheritableTags);
        manager.addMetadata(this.inheritableMetadata);
        if (tag) manager.addTags([
            tag
        ], false);
        return manager;
    }
    async handleChainError(err, _runId, _parentRunId, _tags, kwargs) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                if (!handler.ignoreChain) try {
                    await handler.handleChainError?.(err, this.runId, this._parentRunId, this.tags, kwargs);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleChainError: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
    async handleChainEnd(output, _runId, _parentRunId, _tags, kwargs) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                if (!handler.ignoreChain) try {
                    await handler.handleChainEnd?.(output, this.runId, this._parentRunId, this.tags, kwargs);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleChainEnd: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
    async handleAgentAction(action) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                if (!handler.ignoreAgent) try {
                    await handler.handleAgentAction?.(action, this.runId, this._parentRunId, this.tags);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleAgentAction: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
    async handleAgentEnd(action) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                if (!handler.ignoreAgent) try {
                    await handler.handleAgentEnd?.(action, this.runId, this._parentRunId, this.tags);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleAgentEnd: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
}
class CallbackManagerForToolRun extends BaseRunManager {
    getChild(tag) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        const manager = new CallbackManager(this.runId);
        manager.setHandlers(this.inheritableHandlers);
        manager.addTags(this.inheritableTags);
        manager.addMetadata(this.inheritableMetadata);
        if (tag) manager.addTags([
            tag
        ], false);
        return manager;
    }
    async handleToolError(err) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                if (!handler.ignoreAgent) try {
                    await handler.handleToolError?.(err, this.runId, this._parentRunId, this.tags);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleToolError: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async handleToolEnd(output) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                if (!handler.ignoreAgent) try {
                    await handler.handleToolEnd?.(output, this.runId, this._parentRunId, this.tags);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleToolEnd: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
}
class CallbackManager extends BaseCallbackManager {
    constructor(parentRunId, options){
        super();
        Object.defineProperty(this, "handlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "inheritableHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "tags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "inheritableTags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "metadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "inheritableMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "callback_manager"
        });
        Object.defineProperty(this, "_parentRunId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.handlers = options?.handlers ?? this.handlers;
        this.inheritableHandlers = options?.inheritableHandlers ?? this.inheritableHandlers;
        this.tags = options?.tags ?? this.tags;
        this.inheritableTags = options?.inheritableTags ?? this.inheritableTags;
        this.metadata = options?.metadata ?? this.metadata;
        this.inheritableMetadata = options?.inheritableMetadata ?? this.inheritableMetadata;
        this._parentRunId = parentRunId;
    }
    /**
     * Gets the parent run ID, if any.
     *
     * @returns The parent run ID.
     */ getParentRunId() {
        return this._parentRunId;
    }
    async handleLLMStart(llm, prompts, runId, _parentRunId, extraParams, _tags, _metadata, runName) {
        return Promise.all(prompts.map(async (prompt, idx)=>{
            // Can't have duplicate runs with the same run ID (if provided)
            const runId_ = idx === 0 && runId ? runId : (0, _uuid.v4)();
            await Promise.all(this.handlers.map((handler)=>{
                if (handler.ignoreLLM) return;
                if ((0, _baseJs1.isBaseTracer)(handler)) // Create and add run to the run map.
                // We do this synchronously to avoid race conditions
                // when callbacks are backgrounded.
                handler._createRunForLLMStart(llm, [
                    prompt
                ], runId_, this._parentRunId, extraParams, this.tags, this.metadata, runName);
                return (0, _promisesJs.consumeCallback)(async ()=>{
                    try {
                        await handler.handleLLMStart?.(llm, [
                            prompt
                        ], runId_, this._parentRunId, extraParams, this.tags, this.metadata, runName);
                    } catch (err) {
                        const logFunction = handler.raiseError ? console.error : console.warn;
                        logFunction(`Error in handler ${handler.constructor.name}, handleLLMStart: ${err}`);
                        if (handler.raiseError) throw err;
                    }
                }, handler.awaitHandlers);
            }));
            return new CallbackManagerForLLMRun(runId_, this.handlers, this.inheritableHandlers, this.tags, this.inheritableTags, this.metadata, this.inheritableMetadata, this._parentRunId);
        }));
    }
    async handleChatModelStart(llm, messages, runId, _parentRunId, extraParams, _tags, _metadata, runName) {
        return Promise.all(messages.map(async (messageGroup, idx)=>{
            // Can't have duplicate runs with the same run ID (if provided)
            const runId_ = idx === 0 && runId ? runId : (0, _uuid.v4)();
            await Promise.all(this.handlers.map((handler)=>{
                if (handler.ignoreLLM) return;
                if ((0, _baseJs1.isBaseTracer)(handler)) // Create and add run to the run map.
                // We do this synchronously to avoid race conditions
                // when callbacks are backgrounded.
                handler._createRunForChatModelStart(llm, [
                    messageGroup
                ], runId_, this._parentRunId, extraParams, this.tags, this.metadata, runName);
                return (0, _promisesJs.consumeCallback)(async ()=>{
                    try {
                        if (handler.handleChatModelStart) await handler.handleChatModelStart?.(llm, [
                            messageGroup
                        ], runId_, this._parentRunId, extraParams, this.tags, this.metadata, runName);
                        else if (handler.handleLLMStart) {
                            const messageString = (0, _utilsJs.getBufferString)(messageGroup);
                            await handler.handleLLMStart?.(llm, [
                                messageString
                            ], runId_, this._parentRunId, extraParams, this.tags, this.metadata, runName);
                        }
                    } catch (err) {
                        const logFunction = handler.raiseError ? console.error : console.warn;
                        logFunction(`Error in handler ${handler.constructor.name}, handleLLMStart: ${err}`);
                        if (handler.raiseError) throw err;
                    }
                }, handler.awaitHandlers);
            }));
            return new CallbackManagerForLLMRun(runId_, this.handlers, this.inheritableHandlers, this.tags, this.inheritableTags, this.metadata, this.inheritableMetadata, this._parentRunId);
        }));
    }
    async handleChainStart(chain, inputs, runId = (0, _uuid.v4)(), runType, _tags, _metadata, runName) {
        await Promise.all(this.handlers.map((handler)=>{
            if (handler.ignoreChain) return;
            if ((0, _baseJs1.isBaseTracer)(handler)) // Create and add run to the run map.
            // We do this synchronously to avoid race conditions
            // when callbacks are backgrounded.
            handler._createRunForChainStart(chain, inputs, runId, this._parentRunId, this.tags, this.metadata, runType, runName);
            return (0, _promisesJs.consumeCallback)(async ()=>{
                try {
                    await handler.handleChainStart?.(chain, inputs, runId, this._parentRunId, this.tags, this.metadata, runType, runName);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleChainStart: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers);
        }));
        return new CallbackManagerForChainRun(runId, this.handlers, this.inheritableHandlers, this.tags, this.inheritableTags, this.metadata, this.inheritableMetadata, this._parentRunId);
    }
    async handleToolStart(tool, input, runId = (0, _uuid.v4)(), _parentRunId, _tags, _metadata, runName) {
        await Promise.all(this.handlers.map((handler)=>{
            if (handler.ignoreAgent) return;
            if ((0, _baseJs1.isBaseTracer)(handler)) // Create and add run to the run map.
            // We do this synchronously to avoid race conditions
            // when callbacks are backgrounded.
            handler._createRunForToolStart(tool, input, runId, this._parentRunId, this.tags, this.metadata, runName);
            return (0, _promisesJs.consumeCallback)(async ()=>{
                try {
                    await handler.handleToolStart?.(tool, input, runId, this._parentRunId, this.tags, this.metadata, runName);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleToolStart: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers);
        }));
        return new CallbackManagerForToolRun(runId, this.handlers, this.inheritableHandlers, this.tags, this.inheritableTags, this.metadata, this.inheritableMetadata, this._parentRunId);
    }
    async handleRetrieverStart(retriever, query, runId = (0, _uuid.v4)(), _parentRunId, _tags, _metadata, runName) {
        await Promise.all(this.handlers.map((handler)=>{
            if (handler.ignoreRetriever) return;
            if ((0, _baseJs1.isBaseTracer)(handler)) // Create and add run to the run map.
            // We do this synchronously to avoid race conditions
            // when callbacks are backgrounded.
            handler._createRunForRetrieverStart(retriever, query, runId, this._parentRunId, this.tags, this.metadata, runName);
            return (0, _promisesJs.consumeCallback)(async ()=>{
                try {
                    await handler.handleRetrieverStart?.(retriever, query, runId, this._parentRunId, this.tags, this.metadata, runName);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleRetrieverStart: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers);
        }));
        return new CallbackManagerForRetrieverRun(runId, this.handlers, this.inheritableHandlers, this.tags, this.inheritableTags, this.metadata, this.inheritableMetadata, this._parentRunId);
    }
    async handleCustomEvent(eventName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data, runId, _tags, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _metadata) {
        await Promise.all(this.handlers.map((handler)=>(0, _promisesJs.consumeCallback)(async ()=>{
                if (!handler.ignoreCustomEvent) try {
                    await handler.handleCustomEvent?.(eventName, data, runId, this.tags, this.metadata);
                } catch (err) {
                    const logFunction = handler.raiseError ? console.error : console.warn;
                    logFunction(`Error in handler ${handler.constructor.name}, handleCustomEvent: ${err}`);
                    if (handler.raiseError) throw err;
                }
            }, handler.awaitHandlers)));
    }
    addHandler(handler, inherit = true) {
        this.handlers.push(handler);
        if (inherit) this.inheritableHandlers.push(handler);
    }
    removeHandler(handler) {
        this.handlers = this.handlers.filter((_handler)=>_handler !== handler);
        this.inheritableHandlers = this.inheritableHandlers.filter((_handler)=>_handler !== handler);
    }
    setHandlers(handlers, inherit = true) {
        this.handlers = [];
        this.inheritableHandlers = [];
        for (const handler of handlers)this.addHandler(handler, inherit);
    }
    addTags(tags, inherit = true) {
        this.removeTags(tags); // Remove duplicates
        this.tags.push(...tags);
        if (inherit) this.inheritableTags.push(...tags);
    }
    removeTags(tags) {
        this.tags = this.tags.filter((tag)=>!tags.includes(tag));
        this.inheritableTags = this.inheritableTags.filter((tag)=>!tags.includes(tag));
    }
    addMetadata(metadata, inherit = true) {
        this.metadata = {
            ...this.metadata,
            ...metadata
        };
        if (inherit) this.inheritableMetadata = {
            ...this.inheritableMetadata,
            ...metadata
        };
    }
    removeMetadata(metadata) {
        for (const key of Object.keys(metadata)){
            delete this.metadata[key];
            delete this.inheritableMetadata[key];
        }
    }
    copy(additionalHandlers = [], inherit = true) {
        const manager = new CallbackManager(this._parentRunId);
        for (const handler of this.handlers){
            const inheritable = this.inheritableHandlers.includes(handler);
            manager.addHandler(handler, inheritable);
        }
        for (const tag of this.tags){
            const inheritable = this.inheritableTags.includes(tag);
            manager.addTags([
                tag
            ], inheritable);
        }
        for (const key of Object.keys(this.metadata)){
            const inheritable = Object.keys(this.inheritableMetadata).includes(key);
            manager.addMetadata({
                [key]: this.metadata[key]
            }, inheritable);
        }
        for (const handler of additionalHandlers){
            if (// Prevent multiple copies of console_callback_handler
            manager.handlers.filter((h)=>h.name === "console_callback_handler").some((h)=>h.name === handler.name)) continue;
            manager.addHandler(handler, inherit);
        }
        return manager;
    }
    static fromHandlers(handlers) {
        class Handler extends (0, _baseJs.BaseCallbackHandler) {
            constructor(){
                super();
                Object.defineProperty(this, "name", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: (0, _uuid.v4)()
                });
                Object.assign(this, handlers);
            }
        }
        const manager = new this();
        manager.addHandler(new Handler());
        return manager;
    }
    static configure(inheritableHandlers, localHandlers, inheritableTags, localTags, inheritableMetadata, localMetadata, options) {
        return this._configureSync(inheritableHandlers, localHandlers, inheritableTags, localTags, inheritableMetadata, localMetadata, options);
    }
    // TODO: Deprecate async method in favor of this one.
    static _configureSync(inheritableHandlers, localHandlers, inheritableTags, localTags, inheritableMetadata, localMetadata, options) {
        let callbackManager;
        if (inheritableHandlers || localHandlers) {
            if (Array.isArray(inheritableHandlers) || !inheritableHandlers) {
                callbackManager = new CallbackManager();
                callbackManager.setHandlers(inheritableHandlers?.map(ensureHandler) ?? [], true);
            } else callbackManager = inheritableHandlers;
            callbackManager = callbackManager.copy(Array.isArray(localHandlers) ? localHandlers.map(ensureHandler) : localHandlers?.handlers, false);
        }
        const verboseEnabled = (0, _envJs.getEnvironmentVariable)("LANGCHAIN_VERBOSE") === "true" || options?.verbose;
        const tracingV2Enabled = (0, _tracerLangchainJs.LangChainTracer).getTraceableRunTree()?.tracingEnabled || (0, _callbacksJs.isTracingEnabled)();
        const tracingEnabled = tracingV2Enabled || ((0, _envJs.getEnvironmentVariable)("LANGCHAIN_TRACING") ?? false);
        if (verboseEnabled || tracingEnabled) {
            if (!callbackManager) callbackManager = new CallbackManager();
            if (verboseEnabled && !callbackManager.handlers.some((handler)=>handler.name === (0, _consoleJs.ConsoleCallbackHandler).prototype.name)) {
                const consoleHandler = new (0, _consoleJs.ConsoleCallbackHandler)();
                callbackManager.addHandler(consoleHandler, true);
            }
            if (tracingEnabled && !callbackManager.handlers.some((handler)=>handler.name === "langchain_tracer")) {
                if (tracingV2Enabled) {
                    const tracerV2 = new (0, _tracerLangchainJs.LangChainTracer)();
                    callbackManager.addHandler(tracerV2, true);
                    // handoff between langchain and langsmith/traceable
                    // override the parent run ID
                    callbackManager._parentRunId = (0, _tracerLangchainJs.LangChainTracer).getTraceableRunTree()?.id ?? callbackManager._parentRunId;
                }
            }
        }
        if (inheritableTags || localTags) {
            if (callbackManager) {
                callbackManager.addTags(inheritableTags ?? []);
                callbackManager.addTags(localTags ?? [], false);
            }
        }
        if (inheritableMetadata || localMetadata) {
            if (callbackManager) {
                callbackManager.addMetadata(inheritableMetadata ?? {});
                callbackManager.addMetadata(localMetadata ?? {}, false);
            }
        }
        return callbackManager;
    }
}
function ensureHandler(handler) {
    if ("name" in handler) return handler;
    return (0, _baseJs.BaseCallbackHandler).fromMethods(handler);
}
class TraceGroup {
    constructor(groupName, options){
        Object.defineProperty(this, "groupName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: groupName
        });
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(this, "runManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    async getTraceGroupCallbackManager(group_name, inputs, options) {
        const cb = new (0, _tracerLangchainJs.LangChainTracer)(options);
        const cm = await CallbackManager.configure([
            cb
        ]);
        const runManager = await cm?.handleChainStart({
            lc: 1,
            type: "not_implemented",
            id: [
                "langchain",
                "callbacks",
                "groups",
                group_name
            ]
        }, inputs ?? {});
        if (!runManager) throw new Error("Failed to create run group callback manager.");
        return runManager;
    }
    async start(inputs) {
        if (!this.runManager) this.runManager = await this.getTraceGroupCallbackManager(this.groupName, inputs, this.options);
        return this.runManager.getChild();
    }
    async error(err) {
        if (this.runManager) {
            await this.runManager.handleChainError(err);
            this.runManager = undefined;
        }
    }
    async end(output) {
        if (this.runManager) {
            await this.runManager.handleChainEnd(output ?? {});
            this.runManager = undefined;
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _coerceToDict(value, defaultKey) {
    return value && !Array.isArray(value) && typeof value === "object" ? value : {
        [defaultKey]: value
    };
}
async function traceAsGroup(groupOptions, enclosedCode, ...args) {
    const traceGroup = new TraceGroup(groupOptions.name, groupOptions);
    const callbackManager = await traceGroup.start({
        ...args
    });
    try {
        const result = await enclosedCode(callbackManager, ...args);
        await traceGroup.end(_coerceToDict(result, "output"));
        return result;
    } catch (err) {
        await traceGroup.error(err);
        throw err;
    }
}

},{"uuid":"klst7","./base.js":"kirBb","../tracers/console.js":"ZpZ6z","../messages/utils.js":"6vi0n","../utils/env.js":"4GIQu","../tracers/tracer_langchain.js":"a7dBj","./promises.js":"9XPYi","../utils/callbacks.js":"57o33","../tracers/base.js":"5VkRj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ZpZ6z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A tracer that logs all events to the console. It extends from the
 * `BaseTracer` class and overrides its methods to provide custom logging
 * functionality.
 * @example
 * ```typescript
 *
 * const llm = new ChatAnthropic({
 *   temperature: 0,
 *   tags: ["example", "callbacks", "constructor"],
 *   callbacks: [new ConsoleCallbackHandler()],
 * });
 *
 * ```
 */ parcelHelpers.export(exports, "ConsoleCallbackHandler", ()=>ConsoleCallbackHandler);
var _ansiStyles = require("ansi-styles");
var _ansiStylesDefault = parcelHelpers.interopDefault(_ansiStyles);
var _baseJs = require("./base.js");
function wrap(style, text) {
    return `${style.open}${text}${style.close}`;
}
function tryJsonStringify(obj, fallback) {
    try {
        return JSON.stringify(obj, null, 2);
    } catch (err) {
        return fallback;
    }
}
function formatKVMapItem(value) {
    if (typeof value === "string") return value.trim();
    if (value === null || value === undefined) return value;
    return tryJsonStringify(value, value.toString());
}
function elapsed(run) {
    if (!run.end_time) return "";
    const elapsed = run.end_time - run.start_time;
    if (elapsed < 1000) return `${elapsed}ms`;
    return `${(elapsed / 1000).toFixed(2)}s`;
}
const { color } = (0, _ansiStylesDefault.default);
class ConsoleCallbackHandler extends (0, _baseJs.BaseTracer) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "console_callback_handler"
        });
    }
    /**
     * Method used to persist the run. In this case, it simply returns a
     * resolved promise as there's no persistence logic.
     * @param _run The run to persist.
     * @returns A resolved promise.
     */ persistRun(_run) {
        return Promise.resolve();
    }
    // utility methods
    /**
     * Method used to get all the parent runs of a given run.
     * @param run The run whose parents are to be retrieved.
     * @returns An array of parent runs.
     */ getParents(run) {
        const parents = [];
        let currentRun = run;
        while(currentRun.parent_run_id){
            const parent = this.runMap.get(currentRun.parent_run_id);
            if (parent) {
                parents.push(parent);
                currentRun = parent;
            } else break;
        }
        return parents;
    }
    /**
     * Method used to get a string representation of the run's lineage, which
     * is used in logging.
     * @param run The run whose lineage is to be retrieved.
     * @returns A string representation of the run's lineage.
     */ getBreadcrumbs(run) {
        const parents = this.getParents(run).reverse();
        const string = [
            ...parents,
            run
        ].map((parent, i, arr)=>{
            const name = `${parent.execution_order}:${parent.run_type}:${parent.name}`;
            return i === arr.length - 1 ? wrap((0, _ansiStylesDefault.default).bold, name) : name;
        }).join(" > ");
        return wrap(color.grey, string);
    }
    // logging methods
    /**
     * Method used to log the start of a chain run.
     * @param run The chain run that has started.
     * @returns void
     */ onChainStart(run) {
        const crumbs = this.getBreadcrumbs(run);
        console.log(`${wrap(color.green, "[chain/start]")} [${crumbs}] Entering Chain run with input: ${tryJsonStringify(run.inputs, "[inputs]")}`);
    }
    /**
     * Method used to log the end of a chain run.
     * @param run The chain run that has ended.
     * @returns void
     */ onChainEnd(run) {
        const crumbs = this.getBreadcrumbs(run);
        console.log(`${wrap(color.cyan, "[chain/end]")} [${crumbs}] [${elapsed(run)}] Exiting Chain run with output: ${tryJsonStringify(run.outputs, "[outputs]")}`);
    }
    /**
     * Method used to log any errors of a chain run.
     * @param run The chain run that has errored.
     * @returns void
     */ onChainError(run) {
        const crumbs = this.getBreadcrumbs(run);
        console.log(`${wrap(color.red, "[chain/error]")} [${crumbs}] [${elapsed(run)}] Chain run errored with error: ${tryJsonStringify(run.error, "[error]")}`);
    }
    /**
     * Method used to log the start of an LLM run.
     * @param run The LLM run that has started.
     * @returns void
     */ onLLMStart(run) {
        const crumbs = this.getBreadcrumbs(run);
        const inputs = "prompts" in run.inputs ? {
            prompts: run.inputs.prompts.map((p)=>p.trim())
        } : run.inputs;
        console.log(`${wrap(color.green, "[llm/start]")} [${crumbs}] Entering LLM run with input: ${tryJsonStringify(inputs, "[inputs]")}`);
    }
    /**
     * Method used to log the end of an LLM run.
     * @param run The LLM run that has ended.
     * @returns void
     */ onLLMEnd(run) {
        const crumbs = this.getBreadcrumbs(run);
        console.log(`${wrap(color.cyan, "[llm/end]")} [${crumbs}] [${elapsed(run)}] Exiting LLM run with output: ${tryJsonStringify(run.outputs, "[response]")}`);
    }
    /**
     * Method used to log any errors of an LLM run.
     * @param run The LLM run that has errored.
     * @returns void
     */ onLLMError(run) {
        const crumbs = this.getBreadcrumbs(run);
        console.log(`${wrap(color.red, "[llm/error]")} [${crumbs}] [${elapsed(run)}] LLM run errored with error: ${tryJsonStringify(run.error, "[error]")}`);
    }
    /**
     * Method used to log the start of a tool run.
     * @param run The tool run that has started.
     * @returns void
     */ onToolStart(run) {
        const crumbs = this.getBreadcrumbs(run);
        console.log(`${wrap(color.green, "[tool/start]")} [${crumbs}] Entering Tool run with input: "${formatKVMapItem(run.inputs.input)}"`);
    }
    /**
     * Method used to log the end of a tool run.
     * @param run The tool run that has ended.
     * @returns void
     */ onToolEnd(run) {
        const crumbs = this.getBreadcrumbs(run);
        console.log(`${wrap(color.cyan, "[tool/end]")} [${crumbs}] [${elapsed(run)}] Exiting Tool run with output: "${formatKVMapItem(run.outputs?.output)}"`);
    }
    /**
     * Method used to log any errors of a tool run.
     * @param run The tool run that has errored.
     * @returns void
     */ onToolError(run) {
        const crumbs = this.getBreadcrumbs(run);
        console.log(`${wrap(color.red, "[tool/error]")} [${crumbs}] [${elapsed(run)}] Tool run errored with error: ${tryJsonStringify(run.error, "[error]")}`);
    }
    /**
     * Method used to log the start of a retriever run.
     * @param run The retriever run that has started.
     * @returns void
     */ onRetrieverStart(run) {
        const crumbs = this.getBreadcrumbs(run);
        console.log(`${wrap(color.green, "[retriever/start]")} [${crumbs}] Entering Retriever run with input: ${tryJsonStringify(run.inputs, "[inputs]")}`);
    }
    /**
     * Method used to log the end of a retriever run.
     * @param run The retriever run that has ended.
     * @returns void
     */ onRetrieverEnd(run) {
        const crumbs = this.getBreadcrumbs(run);
        console.log(`${wrap(color.cyan, "[retriever/end]")} [${crumbs}] [${elapsed(run)}] Exiting Retriever run with output: ${tryJsonStringify(run.outputs, "[outputs]")}`);
    }
    /**
     * Method used to log any errors of a retriever run.
     * @param run The retriever run that has errored.
     * @returns void
     */ onRetrieverError(run) {
        const crumbs = this.getBreadcrumbs(run);
        console.log(`${wrap(color.red, "[retriever/error]")} [${crumbs}] [${elapsed(run)}] Retriever run errored with error: ${tryJsonStringify(run.error, "[error]")}`);
    }
    /**
     * Method used to log the action selected by the agent.
     * @param run The run in which the agent action occurred.
     * @returns void
     */ onAgentAction(run) {
        const agentRun = run;
        const crumbs = this.getBreadcrumbs(run);
        console.log(`${wrap(color.blue, "[agent/action]")} [${crumbs}] Agent selected action: ${tryJsonStringify(agentRun.actions[agentRun.actions.length - 1], "[action]")}`);
    }
}

},{"ansi-styles":"cO8wT","./base.js":"5VkRj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cO8wT":[function(require,module,exports,__globalThis) {
'use strict';
const ANSI_BACKGROUND_OFFSET = 10;
const wrapAnsi256 = (offset = 0)=>(code)=>`\u001B[${38 + offset};5;${code}m`;
const wrapAnsi16m = (offset = 0)=>(red, green, blue)=>`\u001B[${38 + offset};2;${red};${green};${blue}m`;
function assembleStyles() {
    const codes = new Map();
    const styles = {
        modifier: {
            reset: [
                0,
                0
            ],
            // 21 isn't widely supported and 22 does the same thing
            bold: [
                1,
                22
            ],
            dim: [
                2,
                22
            ],
            italic: [
                3,
                23
            ],
            underline: [
                4,
                24
            ],
            overline: [
                53,
                55
            ],
            inverse: [
                7,
                27
            ],
            hidden: [
                8,
                28
            ],
            strikethrough: [
                9,
                29
            ]
        },
        color: {
            black: [
                30,
                39
            ],
            red: [
                31,
                39
            ],
            green: [
                32,
                39
            ],
            yellow: [
                33,
                39
            ],
            blue: [
                34,
                39
            ],
            magenta: [
                35,
                39
            ],
            cyan: [
                36,
                39
            ],
            white: [
                37,
                39
            ],
            // Bright color
            blackBright: [
                90,
                39
            ],
            redBright: [
                91,
                39
            ],
            greenBright: [
                92,
                39
            ],
            yellowBright: [
                93,
                39
            ],
            blueBright: [
                94,
                39
            ],
            magentaBright: [
                95,
                39
            ],
            cyanBright: [
                96,
                39
            ],
            whiteBright: [
                97,
                39
            ]
        },
        bgColor: {
            bgBlack: [
                40,
                49
            ],
            bgRed: [
                41,
                49
            ],
            bgGreen: [
                42,
                49
            ],
            bgYellow: [
                43,
                49
            ],
            bgBlue: [
                44,
                49
            ],
            bgMagenta: [
                45,
                49
            ],
            bgCyan: [
                46,
                49
            ],
            bgWhite: [
                47,
                49
            ],
            // Bright color
            bgBlackBright: [
                100,
                49
            ],
            bgRedBright: [
                101,
                49
            ],
            bgGreenBright: [
                102,
                49
            ],
            bgYellowBright: [
                103,
                49
            ],
            bgBlueBright: [
                104,
                49
            ],
            bgMagentaBright: [
                105,
                49
            ],
            bgCyanBright: [
                106,
                49
            ],
            bgWhiteBright: [
                107,
                49
            ]
        }
    };
    // Alias bright black as gray (and grey)
    styles.color.gray = styles.color.blackBright;
    styles.bgColor.bgGray = styles.bgColor.bgBlackBright;
    styles.color.grey = styles.color.blackBright;
    styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;
    for (const [groupName, group] of Object.entries(styles)){
        for (const [styleName, style] of Object.entries(group)){
            styles[styleName] = {
                open: `\u001B[${style[0]}m`,
                close: `\u001B[${style[1]}m`
            };
            group[styleName] = styles[styleName];
            codes.set(style[0], style[1]);
        }
        Object.defineProperty(styles, groupName, {
            value: group,
            enumerable: false
        });
    }
    Object.defineProperty(styles, 'codes', {
        value: codes,
        enumerable: false
    });
    styles.color.close = '\u001B[39m';
    styles.bgColor.close = '\u001B[49m';
    styles.color.ansi256 = wrapAnsi256();
    styles.color.ansi16m = wrapAnsi16m();
    styles.bgColor.ansi256 = wrapAnsi256(ANSI_BACKGROUND_OFFSET);
    styles.bgColor.ansi16m = wrapAnsi16m(ANSI_BACKGROUND_OFFSET);
    // From https://github.com/Qix-/color-convert/blob/3f0e0d4e92e235796ccb17f6e85c72094a651f49/conversions.js
    Object.defineProperties(styles, {
        rgbToAnsi256: {
            value: (red, green, blue)=>{
                // We use the extended greyscale palette here, with the exception of
                // black and white. normal palette only has 4 greyscale shades.
                if (red === green && green === blue) {
                    if (red < 8) return 16;
                    if (red > 248) return 231;
                    return Math.round((red - 8) / 247 * 24) + 232;
                }
                return 16 + 36 * Math.round(red / 255 * 5) + 6 * Math.round(green / 255 * 5) + Math.round(blue / 255 * 5);
            },
            enumerable: false
        },
        hexToRgb: {
            value: (hex)=>{
                const matches = /(?<colorString>[a-f\d]{6}|[a-f\d]{3})/i.exec(hex.toString(16));
                if (!matches) return [
                    0,
                    0,
                    0
                ];
                let { colorString } = matches.groups;
                if (colorString.length === 3) colorString = colorString.split('').map((character)=>character + character).join('');
                const integer = Number.parseInt(colorString, 16);
                return [
                    integer >> 16 & 0xFF,
                    integer >> 8 & 0xFF,
                    integer & 0xFF
                ];
            },
            enumerable: false
        },
        hexToAnsi256: {
            value: (hex)=>styles.rgbToAnsi256(...styles.hexToRgb(hex)),
            enumerable: false
        }
    });
    return styles;
}
// Make the export immutable
Object.defineProperty(module, 'exports', {
    enumerable: true,
    get: assembleStyles
});

},{}],"5VkRj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBaseTracer", ()=>isBaseTracer);
parcelHelpers.export(exports, "BaseTracer", ()=>BaseTracer);
var _baseJs = require("../callbacks/base.js");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _coerceToDict(value, defaultKey) {
    return value && !Array.isArray(value) && typeof value === "object" ? value : {
        [defaultKey]: value
    };
}
function stripNonAlphanumeric(input) {
    return input.replace(/[-:.]/g, "");
}
function convertToDottedOrderFormat(epoch, runId, executionOrder) {
    const paddedOrder = executionOrder.toFixed(0).slice(0, 3).padStart(3, "0");
    return stripNonAlphanumeric(`${new Date(epoch).toISOString().slice(0, -1)}${paddedOrder}Z`) + runId;
}
function isBaseTracer(x) {
    return typeof x._addRunToRunMap === "function";
}
class BaseTracer extends (0, _baseJs.BaseCallbackHandler) {
    constructor(_fields){
        super(...arguments);
        Object.defineProperty(this, "runMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    copy() {
        return this;
    }
    stringifyError(error) {
        // eslint-disable-next-line no-instanceof/no-instanceof
        if (error instanceof Error) return error.message + (error?.stack ? `\n\n${error.stack}` : "");
        if (typeof error === "string") return error;
        return `${error}`;
    }
    _addChildRun(parentRun, childRun) {
        parentRun.child_runs.push(childRun);
    }
    _addRunToRunMap(run) {
        const currentDottedOrder = convertToDottedOrderFormat(run.start_time, run.id, run.execution_order);
        const storedRun = {
            ...run
        };
        if (storedRun.parent_run_id !== undefined) {
            const parentRun = this.runMap.get(storedRun.parent_run_id);
            if (parentRun) {
                this._addChildRun(parentRun, storedRun);
                parentRun.child_execution_order = Math.max(parentRun.child_execution_order, storedRun.child_execution_order);
                storedRun.trace_id = parentRun.trace_id;
                if (parentRun.dotted_order !== undefined) storedRun.dotted_order = [
                    parentRun.dotted_order,
                    currentDottedOrder
                ].join(".");
            }
        } else {
            storedRun.trace_id = storedRun.id;
            storedRun.dotted_order = currentDottedOrder;
        }
        this.runMap.set(storedRun.id, storedRun);
        return storedRun;
    }
    async _endTrace(run) {
        const parentRun = run.parent_run_id !== undefined && this.runMap.get(run.parent_run_id);
        if (parentRun) parentRun.child_execution_order = Math.max(parentRun.child_execution_order, run.child_execution_order);
        else await this.persistRun(run);
        this.runMap.delete(run.id);
        await this.onRunUpdate?.(run);
    }
    _getExecutionOrder(parentRunId) {
        const parentRun = parentRunId !== undefined && this.runMap.get(parentRunId);
        // If a run has no parent then execution order is 1
        if (!parentRun) return 1;
        return parentRun.child_execution_order + 1;
    }
    /**
     * Create and add a run to the run map for LLM start events.
     * This must sometimes be done synchronously to avoid race conditions
     * when callbacks are backgrounded, so we expose it as a separate method here.
     */ _createRunForLLMStart(llm, prompts, runId, parentRunId, extraParams, tags, metadata, name) {
        const execution_order = this._getExecutionOrder(parentRunId);
        const start_time = Date.now();
        const finalExtraParams = metadata ? {
            ...extraParams,
            metadata
        } : extraParams;
        const run = {
            id: runId,
            name: name ?? llm.id[llm.id.length - 1],
            parent_run_id: parentRunId,
            start_time,
            serialized: llm,
            events: [
                {
                    name: "start",
                    time: new Date(start_time).toISOString()
                }
            ],
            inputs: {
                prompts
            },
            execution_order,
            child_runs: [],
            child_execution_order: execution_order,
            run_type: "llm",
            extra: finalExtraParams ?? {},
            tags: tags || []
        };
        return this._addRunToRunMap(run);
    }
    async handleLLMStart(llm, prompts, runId, parentRunId, extraParams, tags, metadata, name) {
        const run = this.runMap.get(runId) ?? this._createRunForLLMStart(llm, prompts, runId, parentRunId, extraParams, tags, metadata, name);
        await this.onRunCreate?.(run);
        await this.onLLMStart?.(run);
        return run;
    }
    /**
     * Create and add a run to the run map for chat model start events.
     * This must sometimes be done synchronously to avoid race conditions
     * when callbacks are backgrounded, so we expose it as a separate method here.
     */ _createRunForChatModelStart(llm, messages, runId, parentRunId, extraParams, tags, metadata, name) {
        const execution_order = this._getExecutionOrder(parentRunId);
        const start_time = Date.now();
        const finalExtraParams = metadata ? {
            ...extraParams,
            metadata
        } : extraParams;
        const run = {
            id: runId,
            name: name ?? llm.id[llm.id.length - 1],
            parent_run_id: parentRunId,
            start_time,
            serialized: llm,
            events: [
                {
                    name: "start",
                    time: new Date(start_time).toISOString()
                }
            ],
            inputs: {
                messages
            },
            execution_order,
            child_runs: [],
            child_execution_order: execution_order,
            run_type: "llm",
            extra: finalExtraParams ?? {},
            tags: tags || []
        };
        return this._addRunToRunMap(run);
    }
    async handleChatModelStart(llm, messages, runId, parentRunId, extraParams, tags, metadata, name) {
        const run = this.runMap.get(runId) ?? this._createRunForChatModelStart(llm, messages, runId, parentRunId, extraParams, tags, metadata, name);
        await this.onRunCreate?.(run);
        await this.onLLMStart?.(run);
        return run;
    }
    async handleLLMEnd(output, runId) {
        const run = this.runMap.get(runId);
        if (!run || run?.run_type !== "llm") throw new Error("No LLM run to end.");
        run.end_time = Date.now();
        run.outputs = output;
        run.events.push({
            name: "end",
            time: new Date(run.end_time).toISOString()
        });
        await this.onLLMEnd?.(run);
        await this._endTrace(run);
        return run;
    }
    async handleLLMError(error, runId) {
        const run = this.runMap.get(runId);
        if (!run || run?.run_type !== "llm") throw new Error("No LLM run to end.");
        run.end_time = Date.now();
        run.error = this.stringifyError(error);
        run.events.push({
            name: "error",
            time: new Date(run.end_time).toISOString()
        });
        await this.onLLMError?.(run);
        await this._endTrace(run);
        return run;
    }
    /**
     * Create and add a run to the run map for chain start events.
     * This must sometimes be done synchronously to avoid race conditions
     * when callbacks are backgrounded, so we expose it as a separate method here.
     */ _createRunForChainStart(chain, inputs, runId, parentRunId, tags, metadata, runType, name) {
        const execution_order = this._getExecutionOrder(parentRunId);
        const start_time = Date.now();
        const run = {
            id: runId,
            name: name ?? chain.id[chain.id.length - 1],
            parent_run_id: parentRunId,
            start_time,
            serialized: chain,
            events: [
                {
                    name: "start",
                    time: new Date(start_time).toISOString()
                }
            ],
            inputs,
            execution_order,
            child_execution_order: execution_order,
            run_type: runType ?? "chain",
            child_runs: [],
            extra: metadata ? {
                metadata
            } : {},
            tags: tags || []
        };
        return this._addRunToRunMap(run);
    }
    async handleChainStart(chain, inputs, runId, parentRunId, tags, metadata, runType, name) {
        const run = this.runMap.get(runId) ?? this._createRunForChainStart(chain, inputs, runId, parentRunId, tags, metadata, runType, name);
        await this.onRunCreate?.(run);
        await this.onChainStart?.(run);
        return run;
    }
    async handleChainEnd(outputs, runId, _parentRunId, _tags, kwargs) {
        const run = this.runMap.get(runId);
        if (!run) throw new Error("No chain run to end.");
        run.end_time = Date.now();
        run.outputs = _coerceToDict(outputs, "output");
        run.events.push({
            name: "end",
            time: new Date(run.end_time).toISOString()
        });
        if (kwargs?.inputs !== undefined) run.inputs = _coerceToDict(kwargs.inputs, "input");
        await this.onChainEnd?.(run);
        await this._endTrace(run);
        return run;
    }
    async handleChainError(error, runId, _parentRunId, _tags, kwargs) {
        const run = this.runMap.get(runId);
        if (!run) throw new Error("No chain run to end.");
        run.end_time = Date.now();
        run.error = this.stringifyError(error);
        run.events.push({
            name: "error",
            time: new Date(run.end_time).toISOString()
        });
        if (kwargs?.inputs !== undefined) run.inputs = _coerceToDict(kwargs.inputs, "input");
        await this.onChainError?.(run);
        await this._endTrace(run);
        return run;
    }
    /**
     * Create and add a run to the run map for tool start events.
     * This must sometimes be done synchronously to avoid race conditions
     * when callbacks are backgrounded, so we expose it as a separate method here.
     */ _createRunForToolStart(tool, input, runId, parentRunId, tags, metadata, name) {
        const execution_order = this._getExecutionOrder(parentRunId);
        const start_time = Date.now();
        const run = {
            id: runId,
            name: name ?? tool.id[tool.id.length - 1],
            parent_run_id: parentRunId,
            start_time,
            serialized: tool,
            events: [
                {
                    name: "start",
                    time: new Date(start_time).toISOString()
                }
            ],
            inputs: {
                input
            },
            execution_order,
            child_execution_order: execution_order,
            run_type: "tool",
            child_runs: [],
            extra: metadata ? {
                metadata
            } : {},
            tags: tags || []
        };
        return this._addRunToRunMap(run);
    }
    async handleToolStart(tool, input, runId, parentRunId, tags, metadata, name) {
        const run = this.runMap.get(runId) ?? this._createRunForToolStart(tool, input, runId, parentRunId, tags, metadata, name);
        await this.onRunCreate?.(run);
        await this.onToolStart?.(run);
        return run;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async handleToolEnd(output, runId) {
        const run = this.runMap.get(runId);
        if (!run || run?.run_type !== "tool") throw new Error("No tool run to end");
        run.end_time = Date.now();
        run.outputs = {
            output
        };
        run.events.push({
            name: "end",
            time: new Date(run.end_time).toISOString()
        });
        await this.onToolEnd?.(run);
        await this._endTrace(run);
        return run;
    }
    async handleToolError(error, runId) {
        const run = this.runMap.get(runId);
        if (!run || run?.run_type !== "tool") throw new Error("No tool run to end");
        run.end_time = Date.now();
        run.error = this.stringifyError(error);
        run.events.push({
            name: "error",
            time: new Date(run.end_time).toISOString()
        });
        await this.onToolError?.(run);
        await this._endTrace(run);
        return run;
    }
    async handleAgentAction(action, runId) {
        const run = this.runMap.get(runId);
        if (!run || run?.run_type !== "chain") return;
        const agentRun = run;
        agentRun.actions = agentRun.actions || [];
        agentRun.actions.push(action);
        agentRun.events.push({
            name: "agent_action",
            time: new Date().toISOString(),
            kwargs: {
                action
            }
        });
        await this.onAgentAction?.(run);
    }
    async handleAgentEnd(action, runId) {
        const run = this.runMap.get(runId);
        if (!run || run?.run_type !== "chain") return;
        run.events.push({
            name: "agent_end",
            time: new Date().toISOString(),
            kwargs: {
                action
            }
        });
        await this.onAgentEnd?.(run);
    }
    /**
     * Create and add a run to the run map for retriever start events.
     * This must sometimes be done synchronously to avoid race conditions
     * when callbacks are backgrounded, so we expose it as a separate method here.
     */ _createRunForRetrieverStart(retriever, query, runId, parentRunId, tags, metadata, name) {
        const execution_order = this._getExecutionOrder(parentRunId);
        const start_time = Date.now();
        const run = {
            id: runId,
            name: name ?? retriever.id[retriever.id.length - 1],
            parent_run_id: parentRunId,
            start_time,
            serialized: retriever,
            events: [
                {
                    name: "start",
                    time: new Date(start_time).toISOString()
                }
            ],
            inputs: {
                query
            },
            execution_order,
            child_execution_order: execution_order,
            run_type: "retriever",
            child_runs: [],
            extra: metadata ? {
                metadata
            } : {},
            tags: tags || []
        };
        return this._addRunToRunMap(run);
    }
    async handleRetrieverStart(retriever, query, runId, parentRunId, tags, metadata, name) {
        const run = this.runMap.get(runId) ?? this._createRunForRetrieverStart(retriever, query, runId, parentRunId, tags, metadata, name);
        await this.onRunCreate?.(run);
        await this.onRetrieverStart?.(run);
        return run;
    }
    async handleRetrieverEnd(documents, runId) {
        const run = this.runMap.get(runId);
        if (!run || run?.run_type !== "retriever") throw new Error("No retriever run to end");
        run.end_time = Date.now();
        run.outputs = {
            documents
        };
        run.events.push({
            name: "end",
            time: new Date(run.end_time).toISOString()
        });
        await this.onRetrieverEnd?.(run);
        await this._endTrace(run);
        return run;
    }
    async handleRetrieverError(error, runId) {
        const run = this.runMap.get(runId);
        if (!run || run?.run_type !== "retriever") throw new Error("No retriever run to end");
        run.end_time = Date.now();
        run.error = this.stringifyError(error);
        run.events.push({
            name: "error",
            time: new Date(run.end_time).toISOString()
        });
        await this.onRetrieverError?.(run);
        await this._endTrace(run);
        return run;
    }
    async handleText(text, runId) {
        const run = this.runMap.get(runId);
        if (!run || run?.run_type !== "chain") return;
        run.events.push({
            name: "text",
            time: new Date().toISOString(),
            kwargs: {
                text
            }
        });
        await this.onText?.(run);
    }
    async handleLLMNewToken(token, idx, runId, _parentRunId, _tags, fields) {
        const run = this.runMap.get(runId);
        if (!run || run?.run_type !== "llm") throw new Error(`Invalid "runId" provided to "handleLLMNewToken" callback.`);
        run.events.push({
            name: "new_token",
            time: new Date().toISOString(),
            kwargs: {
                token,
                idx,
                chunk: fields?.chunk
            }
        });
        await this.onLLMNewToken?.(run, token, {
            chunk: fields?.chunk
        });
        return run;
    }
}

},{"../callbacks/base.js":"kirBb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a7dBj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LangChainTracer", ()=>LangChainTracer);
var _runTrees = require("langsmith/run_trees");
var _traceable = require("langsmith/singletons/traceable");
var _envJs = require("../utils/env.js");
var _baseJs = require("./base.js");
var _tracerJs = require("../singletons/tracer.js");
class LangChainTracer extends (0, _baseJs.BaseTracer) {
    constructor(fields = {}){
        super(fields);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "langchain_tracer"
        });
        Object.defineProperty(this, "projectName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exampleId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const { exampleId, projectName, client } = fields;
        this.projectName = projectName ?? (0, _envJs.getEnvironmentVariable)("LANGCHAIN_PROJECT") ?? (0, _envJs.getEnvironmentVariable)("LANGCHAIN_SESSION");
        this.exampleId = exampleId;
        this.client = client ?? (0, _tracerJs.getDefaultLangChainClientSingleton)();
        const traceableTree = LangChainTracer.getTraceableRunTree();
        if (traceableTree) this.updateFromRunTree(traceableTree);
    }
    async _convertToCreate(run, example_id) {
        return {
            ...run,
            extra: {
                ...run.extra,
                runtime: await (0, _envJs.getRuntimeEnvironment)()
            },
            child_runs: undefined,
            session_name: this.projectName,
            reference_example_id: run.parent_run_id ? undefined : example_id
        };
    }
    async persistRun(_run) {}
    async onRunCreate(run) {
        const persistedRun = await this._convertToCreate(run, this.exampleId);
        await this.client.createRun(persistedRun);
    }
    async onRunUpdate(run) {
        const runUpdate = {
            end_time: run.end_time,
            error: run.error,
            outputs: run.outputs,
            events: run.events,
            inputs: run.inputs,
            trace_id: run.trace_id,
            dotted_order: run.dotted_order,
            parent_run_id: run.parent_run_id
        };
        await this.client.updateRun(run.id, runUpdate);
    }
    getRun(id) {
        return this.runMap.get(id);
    }
    updateFromRunTree(runTree) {
        let rootRun = runTree;
        const visited = new Set();
        while(rootRun.parent_run){
            if (visited.has(rootRun.id)) break;
            visited.add(rootRun.id);
            if (!rootRun.parent_run) break;
            rootRun = rootRun.parent_run;
        }
        visited.clear();
        const queue = [
            rootRun
        ];
        while(queue.length > 0){
            const current = queue.shift();
            if (!current || visited.has(current.id)) continue;
            visited.add(current.id);
            // @ts-expect-error Types of property 'events' are incompatible.
            this.runMap.set(current.id, current);
            if (current.child_runs) queue.push(...current.child_runs);
        }
        this.client = runTree.client ?? this.client;
        this.projectName = runTree.project_name ?? this.projectName;
        this.exampleId = runTree.reference_example_id ?? this.exampleId;
    }
    convertToRunTree(id) {
        const runTreeMap = {};
        const runTreeList = [];
        for (const [id, run] of this.runMap){
            // by converting the run map to a run tree, we are doing a copy
            // thus, any mutation performed on the run tree will not be reflected
            // back in the run map
            // TODO: Stop using `this.runMap` in favour of LangSmith's `RunTree`
            const runTree = new (0, _runTrees.RunTree)({
                ...run,
                child_runs: [],
                parent_run: undefined,
                // inherited properties
                client: this.client,
                project_name: this.projectName,
                reference_example_id: this.exampleId,
                tracingEnabled: true
            });
            runTreeMap[id] = runTree;
            runTreeList.push([
                id,
                run.dotted_order
            ]);
        }
        runTreeList.sort((a, b)=>{
            if (!a[1] || !b[1]) return 0;
            return a[1].localeCompare(b[1]);
        });
        for (const [id] of runTreeList){
            const run = this.runMap.get(id);
            const runTree = runTreeMap[id];
            if (!run || !runTree) continue;
            if (run.parent_run_id) {
                const parentRunTree = runTreeMap[run.parent_run_id];
                if (parentRunTree) {
                    parentRunTree.child_runs.push(runTree);
                    runTree.parent_run = parentRunTree;
                }
            }
        }
        return runTreeMap[id];
    }
    static getTraceableRunTree() {
        try {
            return (0, _traceable.getCurrentRunTree)();
        } catch  {
            return undefined;
        }
    }
}

},{"langsmith/run_trees":"jHhIJ","langsmith/singletons/traceable":"7bXzs","../utils/env.js":"4GIQu","./base.js":"5VkRj","../singletons/tracer.js":"8AOhE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jHhIJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _runTreesJs = require("./dist/run_trees.js");
parcelHelpers.exportAll(_runTreesJs, exports);

},{"./dist/run_trees.js":"7zAUE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7zAUE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertToDottedOrderFormat", ()=>convertToDottedOrderFormat);
parcelHelpers.export(exports, "RunTree", ()=>RunTree);
parcelHelpers.export(exports, "isRunTree", ()=>isRunTree);
parcelHelpers.export(exports, "isRunnableConfigLike", ()=>isRunnableConfigLike);
var _uuid = require("uuid");
var _envJs = require("./utils/env.js");
var _clientJs = require("./client.js");
var _envJs1 = require("./env.js");
var _warnJs = require("./utils/warn.js");
var _constantsJs = require("./singletons/constants.js");
function stripNonAlphanumeric(input) {
    return input.replace(/[-:.]/g, "");
}
function convertToDottedOrderFormat(epoch, runId, executionOrder = 1) {
    // Date only has millisecond precision, so we use the microseconds to break
    // possible ties, avoiding incorrect run order
    const paddedOrder = executionOrder.toFixed(0).slice(0, 3).padStart(3, "0");
    return stripNonAlphanumeric(`${new Date(epoch).toISOString().slice(0, -1)}${paddedOrder}Z`) + runId;
}
/**
 * Baggage header information
 */ class Baggage {
    constructor(metadata, tags){
        Object.defineProperty(this, "metadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.metadata = metadata;
        this.tags = tags;
    }
    static fromHeader(value) {
        const items = value.split(",");
        let metadata = {};
        let tags = [];
        for (const item of items){
            const [key, uriValue] = item.split("=");
            const value = decodeURIComponent(uriValue);
            if (key === "langsmith-metadata") metadata = JSON.parse(value);
            else if (key === "langsmith-tags") tags = value.split(",");
        }
        return new Baggage(metadata, tags);
    }
    toHeader() {
        const items = [];
        if (this.metadata && Object.keys(this.metadata).length > 0) items.push(`langsmith-metadata=${encodeURIComponent(JSON.stringify(this.metadata))}`);
        if (this.tags && this.tags.length > 0) items.push(`langsmith-tags=${encodeURIComponent(this.tags.join(","))}`);
        return items.join(",");
    }
}
class RunTree {
    constructor(originalConfig){
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "run_type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "project_name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "parent_run", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "child_runs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "start_time", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "end_time", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "extra", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "serialized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "inputs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "outputs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reference_example_id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "events", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "trace_id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dotted_order", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tracingEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "execution_order", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "child_execution_order", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Attachments associated with the run.
         * Each entry is a tuple of [mime_type, bytes]
         */ Object.defineProperty(this, "attachments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // If you pass in a run tree directly, return a shallow clone
        if (isRunTree(originalConfig)) {
            Object.assign(this, {
                ...originalConfig
            });
            return;
        }
        const defaultConfig = RunTree.getDefaultConfig();
        const { metadata, ...config } = originalConfig;
        const client = config.client ?? RunTree.getSharedClient();
        const dedupedMetadata = {
            ...metadata,
            ...config?.extra?.metadata
        };
        config.extra = {
            ...config.extra,
            metadata: dedupedMetadata
        };
        Object.assign(this, {
            ...defaultConfig,
            ...config,
            client
        });
        if (!this.trace_id) {
            if (this.parent_run) this.trace_id = this.parent_run.trace_id ?? this.id;
            else this.trace_id = this.id;
        }
        this.execution_order ??= 1;
        this.child_execution_order ??= 1;
        if (!this.dotted_order) {
            const currentDottedOrder = convertToDottedOrderFormat(this.start_time, this.id, this.execution_order);
            if (this.parent_run) this.dotted_order = this.parent_run.dotted_order + "." + currentDottedOrder;
            else this.dotted_order = currentDottedOrder;
        }
    }
    static getDefaultConfig() {
        return {
            id: _uuid.v4(),
            run_type: "chain",
            project_name: (0, _envJs.getEnvironmentVariable)("LANGCHAIN_PROJECT") ?? (0, _envJs.getEnvironmentVariable)("LANGCHAIN_SESSION") ?? // TODO: Deprecate
            "default",
            child_runs: [],
            api_url: (0, _envJs.getEnvironmentVariable)("LANGCHAIN_ENDPOINT") ?? "http://localhost:1984",
            api_key: (0, _envJs.getEnvironmentVariable)("LANGCHAIN_API_KEY"),
            caller_options: {},
            start_time: Date.now(),
            serialized: {},
            inputs: {},
            extra: {}
        };
    }
    static getSharedClient() {
        if (!RunTree.sharedClient) RunTree.sharedClient = new (0, _clientJs.Client)();
        return RunTree.sharedClient;
    }
    createChild(config) {
        const child_execution_order = this.child_execution_order + 1;
        const child = new RunTree({
            ...config,
            parent_run: this,
            project_name: this.project_name,
            client: this.client,
            tracingEnabled: this.tracingEnabled,
            execution_order: child_execution_order,
            child_execution_order: child_execution_order
        });
        // Copy context vars over into the new run tree.
        if ((0, _constantsJs._LC_CONTEXT_VARIABLES_KEY) in this) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        child[0, _constantsJs._LC_CONTEXT_VARIABLES_KEY] = this[0, _constantsJs._LC_CONTEXT_VARIABLES_KEY];
        const LC_CHILD = Symbol.for("lc:child_config");
        const presentConfig = config.extra?.[LC_CHILD] ?? this.extra[LC_CHILD];
        // tracing for LangChain is defined by the _parentRunId and runMap of the tracer
        if (isRunnableConfigLike(presentConfig)) {
            const newConfig = {
                ...presentConfig
            };
            const callbacks = isCallbackManagerLike(newConfig.callbacks) ? newConfig.callbacks.copy?.() : undefined;
            if (callbacks) {
                // update the parent run id
                Object.assign(callbacks, {
                    _parentRunId: child.id
                });
                // only populate if we're in a newer LC.JS version
                callbacks.handlers?.find(isLangChainTracerLike)?.updateFromRunTree?.(child);
                newConfig.callbacks = callbacks;
            }
            child.extra[LC_CHILD] = newConfig;
        }
        // propagate child_execution_order upwards
        const visited = new Set();
        let current = this;
        while(current != null && !visited.has(current.id)){
            visited.add(current.id);
            current.child_execution_order = Math.max(current.child_execution_order, child_execution_order);
            current = current.parent_run;
        }
        this.child_runs.push(child);
        return child;
    }
    async end(outputs, error, endTime = Date.now(), metadata) {
        this.outputs = this.outputs ?? outputs;
        this.error = this.error ?? error;
        this.end_time = this.end_time ?? endTime;
        if (metadata && Object.keys(metadata).length > 0) this.extra = this.extra ? {
            ...this.extra,
            metadata: {
                ...this.extra.metadata,
                ...metadata
            }
        } : {
            metadata
        };
    }
    _convertToCreate(run, runtimeEnv, excludeChildRuns = true) {
        const runExtra = run.extra ?? {};
        if (!runExtra.runtime) runExtra.runtime = {};
        if (runtimeEnv) {
            for (const [k, v] of Object.entries(runtimeEnv))if (!runExtra.runtime[k]) runExtra.runtime[k] = v;
        }
        let child_runs;
        let parent_run_id;
        if (!excludeChildRuns) {
            child_runs = run.child_runs.map((child_run)=>this._convertToCreate(child_run, runtimeEnv, excludeChildRuns));
            parent_run_id = undefined;
        } else {
            parent_run_id = run.parent_run?.id;
            child_runs = [];
        }
        const persistedRun = {
            id: run.id,
            name: run.name,
            start_time: run.start_time,
            end_time: run.end_time,
            run_type: run.run_type,
            reference_example_id: run.reference_example_id,
            extra: runExtra,
            serialized: run.serialized,
            error: run.error,
            inputs: run.inputs,
            outputs: run.outputs,
            session_name: run.project_name,
            child_runs: child_runs,
            parent_run_id: parent_run_id,
            trace_id: run.trace_id,
            dotted_order: run.dotted_order,
            tags: run.tags,
            attachments: run.attachments
        };
        return persistedRun;
    }
    async postRun(excludeChildRuns = true) {
        try {
            const runtimeEnv = (0, _envJs.getRuntimeEnvironment)();
            const runCreate = await this._convertToCreate(this, runtimeEnv, true);
            await this.client.createRun(runCreate);
            if (!excludeChildRuns) {
                (0, _warnJs.warnOnce)("Posting with excludeChildRuns=false is deprecated and will be removed in a future version.");
                for (const childRun of this.child_runs)await childRun.postRun(false);
            }
        } catch (error) {
            console.error(`Error in postRun for run ${this.id}:`, error);
        }
    }
    async patchRun() {
        try {
            const runUpdate = {
                end_time: this.end_time,
                error: this.error,
                inputs: this.inputs,
                outputs: this.outputs,
                parent_run_id: this.parent_run?.id,
                reference_example_id: this.reference_example_id,
                extra: this.extra,
                events: this.events,
                dotted_order: this.dotted_order,
                trace_id: this.trace_id,
                tags: this.tags,
                attachments: this.attachments
            };
            await this.client.updateRun(this.id, runUpdate);
        } catch (error) {
            console.error(`Error in patchRun for run ${this.id}`, error);
        }
    }
    toJSON() {
        return this._convertToCreate(this, undefined, false);
    }
    static fromRunnableConfig(parentConfig, props) {
        // We only handle the callback manager case for now
        const callbackManager = parentConfig?.callbacks;
        let parentRun;
        let projectName;
        let client;
        let tracingEnabled = (0, _envJs1.isTracingEnabled)();
        if (callbackManager) {
            const parentRunId = callbackManager?.getParentRunId?.() ?? "";
            const langChainTracer = callbackManager?.handlers?.find((handler)=>handler?.name == "langchain_tracer");
            parentRun = langChainTracer?.getRun?.(parentRunId);
            projectName = langChainTracer?.projectName;
            client = langChainTracer?.client;
            tracingEnabled = tracingEnabled || !!langChainTracer;
        }
        if (!parentRun) return new RunTree({
            ...props,
            client,
            tracingEnabled,
            project_name: projectName
        });
        const parentRunTree = new RunTree({
            name: parentRun.name,
            id: parentRun.id,
            trace_id: parentRun.trace_id,
            dotted_order: parentRun.dotted_order,
            client,
            tracingEnabled,
            project_name: projectName,
            tags: [
                ...new Set((parentRun?.tags ?? []).concat(parentConfig?.tags ?? []))
            ],
            extra: {
                metadata: {
                    ...parentRun?.extra?.metadata,
                    ...parentConfig?.metadata
                }
            }
        });
        return parentRunTree.createChild(props);
    }
    static fromDottedOrder(dottedOrder) {
        return this.fromHeaders({
            "langsmith-trace": dottedOrder
        });
    }
    static fromHeaders(headers, inheritArgs) {
        const rawHeaders = "get" in headers && typeof headers.get === "function" ? {
            "langsmith-trace": headers.get("langsmith-trace"),
            baggage: headers.get("baggage")
        } : headers;
        const headerTrace = rawHeaders["langsmith-trace"];
        if (!headerTrace || typeof headerTrace !== "string") return undefined;
        const parentDottedOrder = headerTrace.trim();
        const parsedDottedOrder = parentDottedOrder.split(".").map((part)=>{
            const [strTime, uuid] = part.split("Z");
            return {
                strTime,
                time: Date.parse(strTime + "Z"),
                uuid
            };
        });
        const traceId = parsedDottedOrder[0].uuid;
        const config = {
            ...inheritArgs,
            name: inheritArgs?.["name"] ?? "parent",
            run_type: inheritArgs?.["run_type"] ?? "chain",
            start_time: inheritArgs?.["start_time"] ?? Date.now(),
            id: parsedDottedOrder.at(-1)?.uuid,
            trace_id: traceId,
            dotted_order: parentDottedOrder
        };
        if (rawHeaders["baggage"] && typeof rawHeaders["baggage"] === "string") {
            const baggage = Baggage.fromHeader(rawHeaders["baggage"]);
            config.metadata = baggage.metadata;
            config.tags = baggage.tags;
        }
        return new RunTree(config);
    }
    toHeaders(headers) {
        const result = {
            "langsmith-trace": this.dotted_order,
            baggage: new Baggage(this.extra?.metadata, this.tags).toHeader()
        };
        if (headers) for (const [key, value] of Object.entries(result))headers.set(key, value);
        return result;
    }
}
Object.defineProperty(RunTree, "sharedClient", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: null
});
function isRunTree(x) {
    return x !== undefined && typeof x.createChild === "function" && typeof x.postRun === "function";
}
function isLangChainTracerLike(x) {
    return typeof x === "object" && x != null && typeof x.name === "string" && x.name === "langchain_tracer";
}
function containsLangChainTracerLike(x) {
    return Array.isArray(x) && x.some((callback)=>isLangChainTracerLike(callback));
}
function isCallbackManagerLike(x) {
    return typeof x === "object" && x != null && Array.isArray(x.handlers);
}
function isRunnableConfigLike(x) {
    // Check that it's an object with a callbacks arg
    // that has either a CallbackManagerLike object with a langchain tracer within it
    // or an array with a LangChainTracerLike object within it
    return x !== undefined && typeof x.callbacks === "object" && // Callback manager with a langchain tracer
    (containsLangChainTracerLike(x.callbacks?.handlers) || // Or it's an array with a LangChainTracerLike object within it
    containsLangChainTracerLike(x.callbacks));
}

},{"uuid":"klst7","./utils/env.js":"dzGHq","./client.js":"iJcNT","./env.js":"9TcpS","./utils/warn.js":"4roK2","./singletons/constants.js":"55M3D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dzGHq":[function(require,module,exports,__globalThis) {
// Inlined from https://github.com/flexdinesh/browser-or-node
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
parcelHelpers.export(exports, "isWebWorker", ()=>isWebWorker);
parcelHelpers.export(exports, "isJsDom", ()=>isJsDom);
parcelHelpers.export(exports, "isDeno", ()=>isDeno);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "getEnv", ()=>getEnv);
parcelHelpers.export(exports, "getRuntimeEnvironment", ()=>getRuntimeEnvironment);
/**
 * Retrieves the LangChain-specific environment variables from the current runtime environment.
 * Sensitive keys (containing the word "key", "token", or "secret") have their values redacted for security.
 *
 * @returns {Record<string, string>}
 *  - A record of LangChain-specific environment variables.
 */ parcelHelpers.export(exports, "getLangChainEnvVars", ()=>getLangChainEnvVars);
/**
 * Retrieves the LangChain-specific metadata from the current runtime environment.
 *
 * @returns {Record<string, string>}
 *  - A record of LangChain-specific metadata environment variables.
 */ parcelHelpers.export(exports, "getLangChainEnvVarsMetadata", ()=>getLangChainEnvVarsMetadata);
/**
 * Retrieves the environment variables from the current runtime environment.
 *
 * This function is designed to operate in a variety of JS environments,
 * including Node.js, Deno, browsers, etc.
 *
 * @returns {Record<string, string> | undefined}
 *  - A record of environment variables if available.
 *  - `undefined` if the environment does not support or allows access to environment variables.
 */ parcelHelpers.export(exports, "getEnvironmentVariables", ()=>getEnvironmentVariables);
parcelHelpers.export(exports, "getEnvironmentVariable", ()=>getEnvironmentVariable);
parcelHelpers.export(exports, "getLangSmithEnvironmentVariable", ()=>getLangSmithEnvironmentVariable);
parcelHelpers.export(exports, "setEnvironmentVariable", ()=>setEnvironmentVariable);
/**
 * Get the Git commit SHA from common environment variables
 * used by different CI/CD platforms.
 * @returns {string | undefined} The Git commit SHA or undefined if not found.
 */ parcelHelpers.export(exports, "getShas", ()=>getShas);
var _indexJs = require("../index.js");
var process = require("6a932e963f932781");
let globalEnv;
const isBrowser = ()=>typeof window !== "undefined" && typeof window.document !== "undefined";
const isWebWorker = ()=>typeof globalThis === "object" && globalThis.constructor && globalThis.constructor.name === "DedicatedWorkerGlobalScope";
const isJsDom = ()=>typeof window !== "undefined" && window.name === "nodejs" || typeof navigator !== "undefined" && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom"));
const isDeno = ()=>typeof Deno !== "undefined";
const isNode = ()=>typeof process !== "undefined" && typeof process.versions !== "undefined" && typeof process.versions.node !== "undefined" && !isDeno();
const getEnv = ()=>{
    if (globalEnv) return globalEnv;
    if (isBrowser()) globalEnv = "browser";
    else if (isNode()) globalEnv = "node";
    else if (isWebWorker()) globalEnv = "webworker";
    else if (isJsDom()) globalEnv = "jsdom";
    else if (isDeno()) globalEnv = "deno";
    else globalEnv = "other";
    return globalEnv;
};
let runtimeEnvironment;
function getRuntimeEnvironment() {
    if (runtimeEnvironment === undefined) {
        const env = getEnv();
        const releaseEnv = getShas();
        runtimeEnvironment = {
            library: "langsmith",
            runtime: env,
            sdk: "langsmith-js",
            sdk_version: (0, _indexJs.__version__),
            ...releaseEnv
        };
    }
    return runtimeEnvironment;
}
function getLangChainEnvVars() {
    const allEnvVars = getEnvironmentVariables() || {};
    const envVars = {};
    for (const [key, value] of Object.entries(allEnvVars))if (key.startsWith("LANGCHAIN_") && typeof value === "string") envVars[key] = value;
    for(const key in envVars)if ((key.toLowerCase().includes("key") || key.toLowerCase().includes("secret") || key.toLowerCase().includes("token")) && typeof envVars[key] === "string") {
        const value = envVars[key];
        envVars[key] = value.slice(0, 2) + "*".repeat(value.length - 4) + value.slice(-2);
    }
    return envVars;
}
function getLangChainEnvVarsMetadata() {
    const allEnvVars = getEnvironmentVariables() || {};
    const envVars = {};
    const excluded = [
        "LANGCHAIN_API_KEY",
        "LANGCHAIN_ENDPOINT",
        "LANGCHAIN_TRACING_V2",
        "LANGCHAIN_PROJECT",
        "LANGCHAIN_SESSION"
    ];
    for (const [key, value] of Object.entries(allEnvVars))if (key.startsWith("LANGCHAIN_") && typeof value === "string" && !excluded.includes(key) && !key.toLowerCase().includes("key") && !key.toLowerCase().includes("secret") && !key.toLowerCase().includes("token")) {
        if (key === "LANGCHAIN_REVISION_ID") envVars["revision_id"] = value;
        else envVars[key] = value;
    }
    return envVars;
}
function getEnvironmentVariables() {
    try {
        // Check for Node.js environment
        // eslint-disable-next-line no-process-env
        if (typeof process !== "undefined" && process.env) // eslint-disable-next-line no-process-env
        return Object.entries(process.env).reduce((acc, [key, value])=>{
            acc[key] = String(value);
            return acc;
        }, {});
        // For browsers and other environments, we may not have direct access to env variables
        // Return undefined or any other fallback as required.
        return undefined;
    } catch (e) {
        // Catch any errors that might occur while trying to access environment variables
        return undefined;
    }
}
function getEnvironmentVariable(name) {
    // Certain Deno setups will throw an error if you try to access environment variables
    // https://github.com/hwchase17/langchainjs/issues/1412
    try {
        return typeof process !== "undefined" ? process.env?.[name] : undefined;
    } catch (e) {
        return undefined;
    }
}
function getLangSmithEnvironmentVariable(name) {
    return getEnvironmentVariable(`LANGSMITH_${name}`) || getEnvironmentVariable(`LANGCHAIN_${name}`);
}
function setEnvironmentVariable(name, value) {
    if (typeof process !== "undefined") // eslint-disable-next-line no-process-env
    value;
}
let cachedCommitSHAs;
function getShas() {
    if (cachedCommitSHAs !== undefined) return cachedCommitSHAs;
    const common_release_envs = [
        "VERCEL_GIT_COMMIT_SHA",
        "NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA",
        "COMMIT_REF",
        "RENDER_GIT_COMMIT",
        "CI_COMMIT_SHA",
        "CIRCLE_SHA1",
        "CF_PAGES_COMMIT_SHA",
        "REACT_APP_GIT_SHA",
        "SOURCE_VERSION",
        "GITHUB_SHA",
        "TRAVIS_COMMIT",
        "GIT_COMMIT",
        "BUILD_VCS_NUMBER",
        "bamboo_planRepository_revision",
        "Build.SourceVersion",
        "BITBUCKET_COMMIT",
        "DRONE_COMMIT_SHA",
        "SEMAPHORE_GIT_SHA",
        "BUILDKITE_COMMIT"
    ];
    const shas = {};
    for (const env of common_release_envs){
        const envVar = getEnvironmentVariable(env);
        if (envVar !== undefined) shas[env] = envVar;
    }
    cachedCommitSHAs = shas;
    return shas;
}

},{"6a932e963f932781":"5QIF0","../index.js":"kaE6w","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kaE6w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", ()=>(0, _clientJs.Client));
parcelHelpers.export(exports, "RunTree", ()=>(0, _runTreesJs.RunTree));
parcelHelpers.export(exports, "overrideFetchImplementation", ()=>(0, _fetchJs.overrideFetchImplementation));
parcelHelpers.export(exports, "__version__", ()=>__version__);
var _clientJs = require("./client.js");
var _runTreesJs = require("./run_trees.js");
var _fetchJs = require("./singletons/fetch.js");
const __version__ = "0.2.4";

},{"./client.js":"iJcNT","./run_trees.js":"7zAUE","./singletons/fetch.js":"5gYkK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iJcNT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeRuntimeEnvIntoRunCreate", ()=>mergeRuntimeEnvIntoRunCreate);
parcelHelpers.export(exports, "AutoBatchQueue", ()=>AutoBatchQueue);
parcelHelpers.export(exports, "DEFAULT_BATCH_SIZE_LIMIT_BYTES", ()=>DEFAULT_BATCH_SIZE_LIMIT_BYTES);
parcelHelpers.export(exports, "Client", ()=>Client);
var _uuid = require("uuid");
var _asyncCallerJs = require("./utils/async_caller.js");
var _messagesJs = require("./utils/messages.js");
var _envJs = require("./utils/env.js");
var _indexJs = require("./index.js");
var _uuidJs = require("./utils/_uuid.js");
var _warnJs = require("./utils/warn.js");
var _promptsJs = require("./utils/prompts.js");
var _errorJs = require("./utils/error.js");
var _fetchJs = require("./singletons/fetch.js");
var _indexJs1 = require("./utils/fast-safe-stringify/index.js");
function mergeRuntimeEnvIntoRunCreate(run) {
    const runtimeEnv = (0, _envJs.getRuntimeEnvironment)();
    const envVars = (0, _envJs.getLangChainEnvVarsMetadata)();
    const extra = run.extra ?? {};
    const metadata = extra.metadata;
    run.extra = {
        ...extra,
        runtime: {
            ...runtimeEnv,
            ...extra?.runtime
        },
        metadata: {
            ...envVars,
            ...envVars.revision_id || run.revision_id ? {
                revision_id: run.revision_id ?? envVars.revision_id
            } : {},
            ...metadata
        }
    };
    return run;
}
const getTracingSamplingRate = ()=>{
    const samplingRateStr = (0, _envJs.getLangSmithEnvironmentVariable)("TRACING_SAMPLING_RATE");
    if (samplingRateStr === undefined) return undefined;
    const samplingRate = parseFloat(samplingRateStr);
    if (samplingRate < 0 || samplingRate > 1) throw new Error(`LANGSMITH_TRACING_SAMPLING_RATE must be between 0 and 1 if set. Got: ${samplingRate}`);
    return samplingRate;
};
// utility functions
const isLocalhost = (url)=>{
    const strippedUrl = url.replace("http://", "").replace("https://", "");
    const hostname = strippedUrl.split("/")[0].split(":")[0];
    return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
};
async function toArray(iterable) {
    const result = [];
    for await (const item of iterable)result.push(item);
    return result;
}
function trimQuotes(str) {
    if (str === undefined) return undefined;
    return str.trim().replace(/^"(.*)"$/, "$1").replace(/^'(.*)'$/, "$1");
}
const handle429 = async (response)=>{
    if (response?.status === 429) {
        const retryAfter = parseInt(response.headers.get("retry-after") ?? "30", 10) * 1000;
        if (retryAfter > 0) {
            await new Promise((resolve)=>setTimeout(resolve, retryAfter));
            // Return directly after calling this check
            return true;
        }
    }
    // Fall back to existing status checks
    return false;
};
class AutoBatchQueue {
    constructor(){
        Object.defineProperty(this, "items", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "sizeBytes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
    }
    peek() {
        return this.items[0];
    }
    push(item) {
        let itemPromiseResolve;
        const itemPromise = new Promise((resolve)=>{
            // Setting itemPromiseResolve is synchronous with promise creation:
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/Promise
            itemPromiseResolve = resolve;
        });
        const size = (0, _indexJs1.stringify)(item.item).length;
        this.items.push({
            action: item.action,
            payload: item.item,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            itemPromiseResolve: itemPromiseResolve,
            itemPromise,
            size
        });
        this.sizeBytes += size;
        return itemPromise;
    }
    pop(upToSizeBytes) {
        if (upToSizeBytes < 1) throw new Error("Number of bytes to pop off may not be less than 1.");
        const popped = [];
        let poppedSizeBytes = 0;
        // Pop items until we reach or exceed the size limit
        while(poppedSizeBytes + (this.peek()?.size ?? 0) < upToSizeBytes && this.items.length > 0){
            const item = this.items.shift();
            if (item) {
                popped.push(item);
                poppedSizeBytes += item.size;
                this.sizeBytes -= item.size;
            }
        }
        // If there is an item on the queue we were unable to pop,
        // just return it as a single batch.
        if (popped.length === 0 && this.items.length > 0) {
            const item = this.items.shift();
            popped.push(item);
            poppedSizeBytes += item.size;
            this.sizeBytes -= item.size;
        }
        return [
            popped.map((it)=>({
                    action: it.action,
                    item: it.payload
                })),
            ()=>popped.forEach((it)=>it.itemPromiseResolve())
        ];
    }
}
const DEFAULT_BATCH_SIZE_LIMIT_BYTES = 20971520;
const SERVER_INFO_REQUEST_TIMEOUT = 1000;
class Client {
    constructor(config = {}){
        Object.defineProperty(this, "apiKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apiUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "webUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "caller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "batchIngestCaller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "timeout_ms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_tenantId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "hideInputs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hideOutputs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tracingSampleRate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "filteredPostUuids", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, "autoBatchTracing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "autoBatchQueue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new AutoBatchQueue()
        });
        Object.defineProperty(this, "autoBatchTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "autoBatchAggregationDelayMs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 250
        });
        Object.defineProperty(this, "batchSizeBytesLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fetchOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "settings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "blockOnRootRunFinalization", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, _envJs.getEnvironmentVariable)("LANGSMITH_TRACING_BACKGROUND") === "false"
        });
        Object.defineProperty(this, "traceBatchConcurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 5
        });
        Object.defineProperty(this, "_serverInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "_getServerInfoPromise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const defaultConfig = Client.getDefaultClientConfig();
        this.tracingSampleRate = getTracingSamplingRate();
        this.apiUrl = trimQuotes(config.apiUrl ?? defaultConfig.apiUrl) ?? "";
        if (this.apiUrl.endsWith("/")) this.apiUrl = this.apiUrl.slice(0, -1);
        this.apiKey = trimQuotes(config.apiKey ?? defaultConfig.apiKey);
        this.webUrl = trimQuotes(config.webUrl ?? defaultConfig.webUrl);
        if (this.webUrl?.endsWith("/")) this.webUrl = this.webUrl.slice(0, -1);
        this.timeout_ms = config.timeout_ms ?? 90000;
        this.caller = new (0, _asyncCallerJs.AsyncCaller)(config.callerOptions ?? {});
        this.traceBatchConcurrency = config.traceBatchConcurrency ?? this.traceBatchConcurrency;
        if (this.traceBatchConcurrency < 1) throw new Error("Trace batch concurrency must be positive.");
        this.batchIngestCaller = new (0, _asyncCallerJs.AsyncCaller)({
            maxRetries: 2,
            maxConcurrency: this.traceBatchConcurrency,
            ...config.callerOptions ?? {},
            onFailedResponseHook: handle429
        });
        this.hideInputs = config.hideInputs ?? config.anonymizer ?? defaultConfig.hideInputs;
        this.hideOutputs = config.hideOutputs ?? config.anonymizer ?? defaultConfig.hideOutputs;
        this.autoBatchTracing = config.autoBatchTracing ?? this.autoBatchTracing;
        this.blockOnRootRunFinalization = config.blockOnRootRunFinalization ?? this.blockOnRootRunFinalization;
        this.batchSizeBytesLimit = config.batchSizeBytesLimit;
        this.fetchOptions = config.fetchOptions || {};
    }
    static getDefaultClientConfig() {
        const apiKey = (0, _envJs.getLangSmithEnvironmentVariable)("API_KEY");
        const apiUrl = (0, _envJs.getLangSmithEnvironmentVariable)("ENDPOINT") ?? "https://api.smith.langchain.com";
        const hideInputs = (0, _envJs.getLangSmithEnvironmentVariable)("HIDE_INPUTS") === "true";
        const hideOutputs = (0, _envJs.getLangSmithEnvironmentVariable)("HIDE_OUTPUTS") === "true";
        return {
            apiUrl: apiUrl,
            apiKey: apiKey,
            webUrl: undefined,
            hideInputs: hideInputs,
            hideOutputs: hideOutputs
        };
    }
    getHostUrl() {
        if (this.webUrl) return this.webUrl;
        else if (isLocalhost(this.apiUrl)) {
            this.webUrl = "http://localhost:3000";
            return this.webUrl;
        } else if (this.apiUrl.includes("/api") && !this.apiUrl.split(".", 1)[0].endsWith("api")) {
            this.webUrl = this.apiUrl.replace("/api", "");
            return this.webUrl;
        } else if (this.apiUrl.split(".", 1)[0].includes("dev")) {
            this.webUrl = "https://dev.smith.langchain.com";
            return this.webUrl;
        } else if (this.apiUrl.split(".", 1)[0].includes("eu")) {
            this.webUrl = "https://eu.smith.langchain.com";
            return this.webUrl;
        } else {
            this.webUrl = "https://smith.langchain.com";
            return this.webUrl;
        }
    }
    get headers() {
        const headers = {
            "User-Agent": `langsmith-js/${(0, _indexJs.__version__)}`
        };
        if (this.apiKey) headers["x-api-key"] = `${this.apiKey}`;
        return headers;
    }
    processInputs(inputs) {
        if (this.hideInputs === false) return inputs;
        if (this.hideInputs === true) return {};
        if (typeof this.hideInputs === "function") return this.hideInputs(inputs);
        return inputs;
    }
    processOutputs(outputs) {
        if (this.hideOutputs === false) return outputs;
        if (this.hideOutputs === true) return {};
        if (typeof this.hideOutputs === "function") return this.hideOutputs(outputs);
        return outputs;
    }
    prepareRunCreateOrUpdateInputs(run) {
        const runParams = {
            ...run
        };
        if (runParams.inputs !== undefined) runParams.inputs = this.processInputs(runParams.inputs);
        if (runParams.outputs !== undefined) runParams.outputs = this.processOutputs(runParams.outputs);
        return runParams;
    }
    async _getResponse(path, queryParams) {
        const paramsString = queryParams?.toString() ?? "";
        const url = `${this.apiUrl}${path}?${paramsString}`;
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), url, {
            method: "GET",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, `Failed to fetch ${path}`);
        return response;
    }
    async _get(path, queryParams) {
        const response = await this._getResponse(path, queryParams);
        return response.json();
    }
    async *_getPaginated(path, queryParams = new URLSearchParams(), transform) {
        let offset = Number(queryParams.get("offset")) || 0;
        const limit = Number(queryParams.get("limit")) || 100;
        while(true){
            queryParams.set("offset", String(offset));
            queryParams.set("limit", String(limit));
            const url = `${this.apiUrl}${path}?${queryParams}`;
            const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), url, {
                method: "GET",
                headers: this.headers,
                signal: AbortSignal.timeout(this.timeout_ms),
                ...this.fetchOptions
            });
            await (0, _errorJs.raiseForStatus)(response, `Failed to fetch ${path}`);
            const items = transform ? transform(await response.json()) : await response.json();
            if (items.length === 0) break;
            yield items;
            if (items.length < limit) break;
            offset += items.length;
        }
    }
    async *_getCursorPaginatedList(path, body = null, requestMethod = "POST", dataKey = "runs") {
        const bodyParams = body ? {
            ...body
        } : {};
        while(true){
            const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}${path}`, {
                method: requestMethod,
                headers: {
                    ...this.headers,
                    "Content-Type": "application/json"
                },
                signal: AbortSignal.timeout(this.timeout_ms),
                ...this.fetchOptions,
                body: JSON.stringify(bodyParams)
            });
            const responseBody = await response.json();
            if (!responseBody) break;
            if (!responseBody[dataKey]) break;
            yield responseBody[dataKey];
            const cursors = responseBody.cursors;
            if (!cursors) break;
            if (!cursors.next) break;
            bodyParams.cursor = cursors.next;
        }
    }
    _filterForSampling(runs, patch = false) {
        if (this.tracingSampleRate === undefined) return runs;
        if (patch) {
            const sampled = [];
            for (const run of runs)if (!this.filteredPostUuids.has(run.id)) sampled.push(run);
            else this.filteredPostUuids.delete(run.id);
            return sampled;
        } else {
            const sampled = [];
            for (const run of runs)if (run.id !== run.trace_id && !this.filteredPostUuids.has(run.trace_id) || Math.random() < this.tracingSampleRate) sampled.push(run);
            else this.filteredPostUuids.add(run.id);
            return sampled;
        }
    }
    async _getBatchSizeLimitBytes() {
        const serverInfo = await this._ensureServerInfo();
        return this.batchSizeBytesLimit ?? serverInfo.batch_ingest_config?.size_limit_bytes ?? DEFAULT_BATCH_SIZE_LIMIT_BYTES;
    }
    drainAutoBatchQueue(batchSizeLimit) {
        while(this.autoBatchQueue.items.length > 0){
            const [batch, done] = this.autoBatchQueue.pop(batchSizeLimit);
            if (!batch.length) {
                done();
                break;
            }
            this._processBatch(batch, done).catch(console.error);
        }
    }
    async _processBatch(batch, done) {
        if (!batch.length) {
            done();
            return;
        }
        try {
            const ingestParams = {
                runCreates: batch.filter((item)=>item.action === "create").map((item)=>item.item),
                runUpdates: batch.filter((item)=>item.action === "update").map((item)=>item.item)
            };
            const serverInfo = await this._ensureServerInfo();
            if (serverInfo?.batch_ingest_config?.use_multipart_endpoint) await this.multipartIngestRuns(ingestParams);
            else await this.batchIngestRuns(ingestParams);
        } finally{
            done();
        }
    }
    async processRunOperation(item) {
        clearTimeout(this.autoBatchTimeout);
        this.autoBatchTimeout = undefined;
        if (item.action === "create") item.item = mergeRuntimeEnvIntoRunCreate(item.item);
        const itemPromise = this.autoBatchQueue.push(item);
        const sizeLimitBytes = await this._getBatchSizeLimitBytes();
        if (this.autoBatchQueue.sizeBytes > sizeLimitBytes) this.drainAutoBatchQueue(sizeLimitBytes);
        if (this.autoBatchQueue.items.length > 0) this.autoBatchTimeout = setTimeout(()=>{
            this.autoBatchTimeout = undefined;
            this.drainAutoBatchQueue(sizeLimitBytes);
        }, this.autoBatchAggregationDelayMs);
        return itemPromise;
    }
    async _getServerInfo() {
        const response = await (0, _fetchJs._getFetchImplementation)()(`${this.apiUrl}/info`, {
            method: "GET",
            headers: {
                Accept: "application/json"
            },
            signal: AbortSignal.timeout(SERVER_INFO_REQUEST_TIMEOUT),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "get server info");
        return response.json();
    }
    async _ensureServerInfo() {
        if (this._getServerInfoPromise === undefined) this._getServerInfoPromise = (async ()=>{
            if (this._serverInfo === undefined) try {
                this._serverInfo = await this._getServerInfo();
            } catch (e) {
                console.warn(`[WARNING]: LangSmith failed to fetch info on supported operations. Falling back to single calls and default limits.`);
            }
            return this._serverInfo ?? {};
        })();
        return this._getServerInfoPromise.then((serverInfo)=>{
            if (this._serverInfo === undefined) this._getServerInfoPromise = undefined;
            return serverInfo;
        });
    }
    async _getSettings() {
        if (!this.settings) this.settings = this._get("/settings");
        return await this.settings;
    }
    async createRun(run) {
        if (!this._filterForSampling([
            run
        ]).length) return;
        const headers = {
            ...this.headers,
            "Content-Type": "application/json"
        };
        const session_name = run.project_name;
        delete run.project_name;
        const runCreate = this.prepareRunCreateOrUpdateInputs({
            session_name,
            ...run,
            start_time: run.start_time ?? Date.now()
        });
        if (this.autoBatchTracing && runCreate.trace_id !== undefined && runCreate.dotted_order !== undefined) {
            this.processRunOperation({
                action: "create",
                item: runCreate
            }).catch(console.error);
            return;
        }
        const mergedRunCreateParam = mergeRuntimeEnvIntoRunCreate(runCreate);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/runs`, {
            method: "POST",
            headers,
            body: (0, _indexJs1.stringify)(mergedRunCreateParam),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "create run", true);
    }
    /**
     * Batch ingest/upsert multiple runs in the Langsmith system.
     * @param runs
     */ async batchIngestRuns({ runCreates, runUpdates }) {
        if (runCreates === undefined && runUpdates === undefined) return;
        let preparedCreateParams = runCreates?.map((create)=>this.prepareRunCreateOrUpdateInputs(create)) ?? [];
        let preparedUpdateParams = runUpdates?.map((update)=>this.prepareRunCreateOrUpdateInputs(update)) ?? [];
        if (preparedCreateParams.length > 0 && preparedUpdateParams.length > 0) {
            const createById = preparedCreateParams.reduce((params, run)=>{
                if (!run.id) return params;
                params[run.id] = run;
                return params;
            }, {});
            const standaloneUpdates = [];
            for (const updateParam of preparedUpdateParams)if (updateParam.id !== undefined && createById[updateParam.id]) createById[updateParam.id] = {
                ...createById[updateParam.id],
                ...updateParam
            };
            else standaloneUpdates.push(updateParam);
            preparedCreateParams = Object.values(createById);
            preparedUpdateParams = standaloneUpdates;
        }
        const rawBatch = {
            post: this._filterForSampling(preparedCreateParams),
            patch: this._filterForSampling(preparedUpdateParams, true)
        };
        if (!rawBatch.post.length && !rawBatch.patch.length) return;
        const serverInfo = await this._ensureServerInfo();
        if (serverInfo.version === undefined) {
            this.autoBatchTracing = false;
            for (const preparedCreateParam of rawBatch.post)await this.createRun(preparedCreateParam);
            for (const preparedUpdateParam of rawBatch.patch)if (preparedUpdateParam.id !== undefined) await this.updateRun(preparedUpdateParam.id, preparedUpdateParam);
            return;
        }
        const batchChunks = {
            post: [],
            patch: []
        };
        for (const k of [
            "post",
            "patch"
        ]){
            const key = k;
            const batchItems = rawBatch[key].reverse();
            let batchItem = batchItems.pop();
            while(batchItem !== undefined){
                batchChunks[key].push(batchItem);
                batchItem = batchItems.pop();
            }
        }
        if (batchChunks.post.length > 0 || batchChunks.patch.length > 0) await this._postBatchIngestRuns((0, _indexJs1.stringify)(batchChunks));
    }
    async _postBatchIngestRuns(body) {
        const headers = {
            ...this.headers,
            "Content-Type": "application/json",
            Accept: "application/json"
        };
        const response = await this.batchIngestCaller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/runs/batch`, {
            method: "POST",
            headers,
            body: body,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "batch create run", true);
    }
    /**
     * Batch ingest/upsert multiple runs in the Langsmith system.
     * @param runs
     */ async multipartIngestRuns({ runCreates, runUpdates }) {
        if (runCreates === undefined && runUpdates === undefined) return;
        // transform and convert to dicts
        const allAttachments = {};
        let preparedCreateParams = [];
        for (const create of runCreates ?? []){
            const preparedCreate = this.prepareRunCreateOrUpdateInputs(create);
            if (preparedCreate.id !== undefined && preparedCreate.attachments !== undefined) allAttachments[preparedCreate.id] = preparedCreate.attachments;
            delete preparedCreate.attachments;
            preparedCreateParams.push(preparedCreate);
        }
        let preparedUpdateParams = [];
        for (const update of runUpdates ?? [])preparedUpdateParams.push(this.prepareRunCreateOrUpdateInputs(update));
        // require trace_id and dotted_order
        const invalidRunCreate = preparedCreateParams.find((runCreate)=>{
            return runCreate.trace_id === undefined || runCreate.dotted_order === undefined;
        });
        if (invalidRunCreate !== undefined) throw new Error(`Multipart ingest requires "trace_id" and "dotted_order" to be set when creating a run`);
        const invalidRunUpdate = preparedUpdateParams.find((runUpdate)=>{
            return runUpdate.trace_id === undefined || runUpdate.dotted_order === undefined;
        });
        if (invalidRunUpdate !== undefined) throw new Error(`Multipart ingest requires "trace_id" and "dotted_order" to be set when updating a run`);
        // combine post and patch dicts where possible
        if (preparedCreateParams.length > 0 && preparedUpdateParams.length > 0) {
            const createById = preparedCreateParams.reduce((params, run)=>{
                if (!run.id) return params;
                params[run.id] = run;
                return params;
            }, {});
            const standaloneUpdates = [];
            for (const updateParam of preparedUpdateParams)if (updateParam.id !== undefined && createById[updateParam.id]) createById[updateParam.id] = {
                ...createById[updateParam.id],
                ...updateParam
            };
            else standaloneUpdates.push(updateParam);
            preparedCreateParams = Object.values(createById);
            preparedUpdateParams = standaloneUpdates;
        }
        if (preparedCreateParams.length === 0 && preparedUpdateParams.length === 0) return;
        // send the runs in multipart requests
        const accumulatedContext = [];
        const accumulatedParts = [];
        for (const [method, payloads] of [
            [
                "post",
                preparedCreateParams
            ],
            [
                "patch",
                preparedUpdateParams
            ]
        ])for (const originalPayload of payloads){
            // collect fields to be sent as separate parts
            const { inputs, outputs, events, attachments, ...payload } = originalPayload;
            const fields = {
                inputs,
                outputs,
                events
            };
            // encode the main run payload
            const stringifiedPayload = (0, _indexJs1.stringify)(payload);
            accumulatedParts.push({
                name: `${method}.${payload.id}`,
                payload: new Blob([
                    stringifiedPayload
                ], {
                    type: `application/json; length=${stringifiedPayload.length}`
                })
            });
            // encode the fields we collected
            for (const [key, value] of Object.entries(fields)){
                if (value === undefined) continue;
                const stringifiedValue = (0, _indexJs1.stringify)(value);
                accumulatedParts.push({
                    name: `${method}.${payload.id}.${key}`,
                    payload: new Blob([
                        stringifiedValue
                    ], {
                        type: `application/json; length=${stringifiedValue.length}`
                    })
                });
            }
            // encode the attachments
            if (payload.id !== undefined) {
                const attachments = allAttachments[payload.id];
                if (attachments) {
                    delete allAttachments[payload.id];
                    for (const [name, [contentType, content]] of Object.entries(attachments)){
                        // Validate that the attachment name doesn't contain a '.'
                        if (name.includes(".")) {
                            console.warn(`Skipping attachment '${name}' for run ${payload.id}: Invalid attachment name. ` + `Attachment names must not contain periods ('.'). Please rename the attachment and try again.`);
                            continue;
                        }
                        accumulatedParts.push({
                            name: `attachment.${payload.id}.${name}`,
                            payload: new Blob([
                                content
                            ], {
                                type: `${contentType}; length=${content.byteLength}`
                            })
                        });
                    }
                }
            }
            // compute context
            accumulatedContext.push(`trace=${payload.trace_id},id=${payload.id}`);
        }
        await this._sendMultipartRequest(accumulatedParts, accumulatedContext.join("; "));
    }
    async _sendMultipartRequest(parts, context) {
        try {
            const formData = new FormData();
            for (const part of parts)formData.append(part.name, part.payload);
            // Log the form data
            await this.batchIngestCaller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/runs/multipart`, {
                method: "POST",
                headers: {
                    ...this.headers
                },
                body: formData,
                signal: AbortSignal.timeout(this.timeout_ms),
                ...this.fetchOptions
            });
        } catch (e) {
            let errorMessage = "Failed to multipart ingest runs";
            // eslint-disable-next-line no-instanceof/no-instanceof
            if (e instanceof Error) errorMessage += `: ${e.stack || e.message}`;
            else errorMessage += `: ${String(e)}`;
            console.warn(`${errorMessage.trim()}\n\nContext: ${context}`);
        }
    }
    async updateRun(runId, run) {
        (0, _uuidJs.assertUuid)(runId);
        if (run.inputs) run.inputs = this.processInputs(run.inputs);
        if (run.outputs) run.outputs = this.processOutputs(run.outputs);
        // TODO: Untangle types
        const data = {
            ...run,
            id: runId
        };
        if (!this._filterForSampling([
            data
        ], true).length) return;
        if (this.autoBatchTracing && data.trace_id !== undefined && data.dotted_order !== undefined) {
            if (run.end_time !== undefined && data.parent_run_id === undefined && this.blockOnRootRunFinalization) {
                // Trigger batches as soon as a root trace ends and wait to ensure trace finishes
                // in serverless environments.
                await this.processRunOperation({
                    action: "update",
                    item: data
                }).catch(console.error);
                return;
            } else this.processRunOperation({
                action: "update",
                item: data
            }).catch(console.error);
            return;
        }
        const headers = {
            ...this.headers,
            "Content-Type": "application/json"
        };
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/runs/${runId}`, {
            method: "PATCH",
            headers,
            body: (0, _indexJs1.stringify)(run),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "update run", true);
    }
    async readRun(runId, { loadChildRuns } = {
        loadChildRuns: false
    }) {
        (0, _uuidJs.assertUuid)(runId);
        let run = await this._get(`/runs/${runId}`);
        if (loadChildRuns && run.child_run_ids) run = await this._loadChildRuns(run);
        return run;
    }
    async getRunUrl({ runId, run, projectOpts }) {
        if (run !== undefined) {
            let sessionId;
            if (run.session_id) sessionId = run.session_id;
            else if (projectOpts?.projectName) sessionId = (await this.readProject({
                projectName: projectOpts?.projectName
            })).id;
            else if (projectOpts?.projectId) sessionId = projectOpts?.projectId;
            else {
                const project = await this.readProject({
                    projectName: (0, _envJs.getLangSmithEnvironmentVariable)("PROJECT") || "default"
                });
                sessionId = project.id;
            }
            const tenantId = await this._getTenantId();
            return `${this.getHostUrl()}/o/${tenantId}/projects/p/${sessionId}/r/${run.id}?poll=true`;
        } else if (runId !== undefined) {
            const run_ = await this.readRun(runId);
            if (!run_.app_path) throw new Error(`Run ${runId} has no app_path`);
            const baseUrl = this.getHostUrl();
            return `${baseUrl}${run_.app_path}`;
        } else throw new Error("Must provide either runId or run");
    }
    async _loadChildRuns(run) {
        const childRuns = await toArray(this.listRuns({
            id: run.child_run_ids
        }));
        const treemap = {};
        const runs = {};
        // TODO: make dotted order required when the migration finishes
        childRuns.sort((a, b)=>(a?.dotted_order ?? "").localeCompare(b?.dotted_order ?? ""));
        for (const childRun of childRuns){
            if (childRun.parent_run_id === null || childRun.parent_run_id === undefined) throw new Error(`Child run ${childRun.id} has no parent`);
            if (!(childRun.parent_run_id in treemap)) treemap[childRun.parent_run_id] = [];
            treemap[childRun.parent_run_id].push(childRun);
            runs[childRun.id] = childRun;
        }
        run.child_runs = treemap[run.id] || [];
        for(const runId in treemap)if (runId !== run.id) runs[runId].child_runs = treemap[runId];
        return run;
    }
    /**
     * List runs from the LangSmith server.
     * @param projectId - The ID of the project to filter by.
     * @param projectName - The name of the project to filter by.
     * @param parentRunId - The ID of the parent run to filter by.
     * @param traceId - The ID of the trace to filter by.
     * @param referenceExampleId - The ID of the reference example to filter by.
     * @param startTime - The start time to filter by.
     * @param isRoot - Indicates whether to only return root runs.
     * @param runType - The run type to filter by.
     * @param error - Indicates whether to filter by error runs.
     * @param id - The ID of the run to filter by.
     * @param query - The query string to filter by.
     * @param filter - The filter string to apply to the run spans.
     * @param traceFilter - The filter string to apply on the root run of the trace.
     * @param limit - The maximum number of runs to retrieve.
     * @returns {AsyncIterable<Run>} - The runs.
     *
     * @example
     * // List all runs in a project
     * const projectRuns = client.listRuns({ projectName: "<your_project>" });
     *
     * @example
     * // List LLM and Chat runs in the last 24 hours
     * const todaysLLMRuns = client.listRuns({
     *   projectName: "<your_project>",
     *   start_time: new Date(Date.now() - 24 * 60 * 60 * 1000),
     *   run_type: "llm",
     * });
     *
     * @example
     * // List traces in a project
     * const rootRuns = client.listRuns({
     *   projectName: "<your_project>",
     *   execution_order: 1,
     * });
     *
     * @example
     * // List runs without errors
     * const correctRuns = client.listRuns({
     *   projectName: "<your_project>",
     *   error: false,
     * });
     *
     * @example
     * // List runs by run ID
     * const runIds = [
     *   "a36092d2-4ad5-4fb4-9c0d-0dba9a2ed836",
     *   "9398e6be-964f-4aa4-8ae9-ad78cd4b7074",
     * ];
     * const selectedRuns = client.listRuns({ run_ids: runIds });
     *
     * @example
     * // List all "chain" type runs that took more than 10 seconds and had `total_tokens` greater than 5000
     * const chainRuns = client.listRuns({
     *   projectName: "<your_project>",
     *   filter: 'and(eq(run_type, "chain"), gt(latency, 10), gt(total_tokens, 5000))',
     * });
     *
     * @example
     * // List all runs called "extractor" whose root of the trace was assigned feedback "user_score" score of 1
     * const goodExtractorRuns = client.listRuns({
     *   projectName: "<your_project>",
     *   filter: 'eq(name, "extractor")',
     *   traceFilter: 'and(eq(feedback_key, "user_score"), eq(feedback_score, 1))',
     * });
     *
     * @example
     * // List all runs that started after a specific timestamp and either have "error" not equal to null or a "Correctness" feedback score equal to 0
     * const complexRuns = client.listRuns({
     *   projectName: "<your_project>",
     *   filter: 'and(gt(start_time, "2023-07-15T12:34:56Z"), or(neq(error, null), and(eq(feedback_key, "Correctness"), eq(feedback_score, 0.0))))',
     * });
     *
     * @example
     * // List all runs where `tags` include "experimental" or "beta" and `latency` is greater than 2 seconds
     * const taggedRuns = client.listRuns({
     *   projectName: "<your_project>",
     *   filter: 'and(or(has(tags, "experimental"), has(tags, "beta")), gt(latency, 2))',
     * });
     */ async *listRuns(props) {
        const { projectId, projectName, parentRunId, traceId, referenceExampleId, startTime, executionOrder, isRoot, runType, error, id, query, filter, traceFilter, treeFilter, limit, select } = props;
        let projectIds = [];
        if (projectId) projectIds = Array.isArray(projectId) ? projectId : [
            projectId
        ];
        if (projectName) {
            const projectNames = Array.isArray(projectName) ? projectName : [
                projectName
            ];
            const projectIds_ = await Promise.all(projectNames.map((name)=>this.readProject({
                    projectName: name
                }).then((project)=>project.id)));
            projectIds.push(...projectIds_);
        }
        const default_select = [
            "app_path",
            "child_run_ids",
            "completion_cost",
            "completion_tokens",
            "dotted_order",
            "end_time",
            "error",
            "events",
            "extra",
            "feedback_stats",
            "first_token_time",
            "id",
            "inputs",
            "name",
            "outputs",
            "parent_run_id",
            "parent_run_ids",
            "prompt_cost",
            "prompt_tokens",
            "reference_example_id",
            "run_type",
            "session_id",
            "start_time",
            "status",
            "tags",
            "total_cost",
            "total_tokens",
            "trace_id"
        ];
        const body = {
            session: projectIds.length ? projectIds : null,
            run_type: runType,
            reference_example: referenceExampleId,
            query,
            filter,
            trace_filter: traceFilter,
            tree_filter: treeFilter,
            execution_order: executionOrder,
            parent_run: parentRunId,
            start_time: startTime ? startTime.toISOString() : null,
            error,
            id,
            limit,
            trace: traceId,
            select: select ? select : default_select,
            is_root: isRoot
        };
        let runsYielded = 0;
        for await (const runs of this._getCursorPaginatedList("/runs/query", body))if (limit) {
            if (runsYielded >= limit) break;
            if (runs.length + runsYielded > limit) {
                const newRuns = runs.slice(0, limit - runsYielded);
                yield* newRuns;
                break;
            }
            runsYielded += runs.length;
            yield* runs;
        } else yield* runs;
    }
    async getRunStats({ id, trace, parentRun, runType, projectNames, projectIds, referenceExampleIds, startTime, endTime, error, query, filter, traceFilter, treeFilter, isRoot, dataSourceType }) {
        let projectIds_ = projectIds || [];
        if (projectNames) projectIds_ = [
            ...projectIds || [],
            ...await Promise.all(projectNames.map((name)=>this.readProject({
                    projectName: name
                }).then((project)=>project.id)))
        ];
        const payload = {
            id,
            trace,
            parent_run: parentRun,
            run_type: runType,
            session: projectIds_,
            reference_example: referenceExampleIds,
            start_time: startTime,
            end_time: endTime,
            error,
            query,
            filter,
            trace_filter: traceFilter,
            tree_filter: treeFilter,
            is_root: isRoot,
            data_source_type: dataSourceType
        };
        // Remove undefined values from the payload
        const filteredPayload = Object.fromEntries(Object.entries(payload).filter(([_, value])=>value !== undefined));
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/runs/stats`, {
            method: "POST",
            headers: this.headers,
            body: JSON.stringify(filteredPayload),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        const result = await response.json();
        return result;
    }
    async shareRun(runId, { shareId } = {}) {
        const data = {
            run_id: runId,
            share_token: shareId || _uuid.v4()
        };
        (0, _uuidJs.assertUuid)(runId);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/runs/${runId}/share`, {
            method: "PUT",
            headers: this.headers,
            body: JSON.stringify(data),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        const result = await response.json();
        if (result === null || !("share_token" in result)) throw new Error("Invalid response from server");
        return `${this.getHostUrl()}/public/${result["share_token"]}/r`;
    }
    async unshareRun(runId) {
        (0, _uuidJs.assertUuid)(runId);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/runs/${runId}/share`, {
            method: "DELETE",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "unshare run", true);
    }
    async readRunSharedLink(runId) {
        (0, _uuidJs.assertUuid)(runId);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/runs/${runId}/share`, {
            method: "GET",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        const result = await response.json();
        if (result === null || !("share_token" in result)) return undefined;
        return `${this.getHostUrl()}/public/${result["share_token"]}/r`;
    }
    async listSharedRuns(shareToken, { runIds } = {}) {
        const queryParams = new URLSearchParams({
            share_token: shareToken
        });
        if (runIds !== undefined) for (const runId of runIds)queryParams.append("id", runId);
        (0, _uuidJs.assertUuid)(shareToken);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/public/${shareToken}/runs${queryParams}`, {
            method: "GET",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        const runs = await response.json();
        return runs;
    }
    async readDatasetSharedSchema(datasetId, datasetName) {
        if (!datasetId && !datasetName) throw new Error("Either datasetId or datasetName must be given");
        if (!datasetId) {
            const dataset = await this.readDataset({
                datasetName
            });
            datasetId = dataset.id;
        }
        (0, _uuidJs.assertUuid)(datasetId);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/datasets/${datasetId}/share`, {
            method: "GET",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        const shareSchema = await response.json();
        shareSchema.url = `${this.getHostUrl()}/public/${shareSchema.share_token}/d`;
        return shareSchema;
    }
    async shareDataset(datasetId, datasetName) {
        if (!datasetId && !datasetName) throw new Error("Either datasetId or datasetName must be given");
        if (!datasetId) {
            const dataset = await this.readDataset({
                datasetName
            });
            datasetId = dataset.id;
        }
        const data = {
            dataset_id: datasetId
        };
        (0, _uuidJs.assertUuid)(datasetId);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/datasets/${datasetId}/share`, {
            method: "PUT",
            headers: this.headers,
            body: JSON.stringify(data),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        const shareSchema = await response.json();
        shareSchema.url = `${this.getHostUrl()}/public/${shareSchema.share_token}/d`;
        return shareSchema;
    }
    async unshareDataset(datasetId) {
        (0, _uuidJs.assertUuid)(datasetId);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/datasets/${datasetId}/share`, {
            method: "DELETE",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "unshare dataset", true);
    }
    async readSharedDataset(shareToken) {
        (0, _uuidJs.assertUuid)(shareToken);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/public/${shareToken}/datasets`, {
            method: "GET",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        const dataset = await response.json();
        return dataset;
    }
    /**
     * Get shared examples.
     *
     * @param {string} shareToken The share token to get examples for. A share token is the UUID (or LangSmith URL, including UUID) generated when explicitly marking an example as public.
     * @param {Object} [options] Additional options for listing the examples.
     * @param {string[] | undefined} [options.exampleIds] A list of example IDs to filter by.
     * @returns {Promise<Example[]>} The shared examples.
     */ async listSharedExamples(shareToken, options) {
        const params = {};
        if (options?.exampleIds) params.id = options.exampleIds;
        const urlParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value])=>{
            if (Array.isArray(value)) value.forEach((v)=>urlParams.append(key, v));
            else urlParams.append(key, value);
        });
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/public/${shareToken}/examples?${urlParams.toString()}`, {
            method: "GET",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        const result = await response.json();
        if (!response.ok) {
            if ("detail" in result) throw new Error(`Failed to list shared examples.\nStatus: ${response.status}\nMessage: ${result.detail.join("\n")}`);
            throw new Error(`Failed to list shared examples: ${response.status} ${response.statusText}`);
        }
        return result.map((example)=>({
                ...example,
                _hostUrl: this.getHostUrl()
            }));
    }
    async createProject({ projectName, description = null, metadata = null, upsert = false, projectExtra = null, referenceDatasetId = null }) {
        const upsert_ = upsert ? `?upsert=true` : "";
        const endpoint = `${this.apiUrl}/sessions${upsert_}`;
        const extra = projectExtra || {};
        if (metadata) extra["metadata"] = metadata;
        const body = {
            name: projectName,
            extra,
            description
        };
        if (referenceDatasetId !== null) body["reference_dataset_id"] = referenceDatasetId;
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), endpoint, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "create project");
        const result = await response.json();
        return result;
    }
    async updateProject(projectId, { name = null, description = null, metadata = null, projectExtra = null, endTime = null }) {
        const endpoint = `${this.apiUrl}/sessions/${projectId}`;
        let extra = projectExtra;
        if (metadata) extra = {
            ...extra || {},
            metadata
        };
        const body = {
            name,
            extra,
            description,
            end_time: endTime ? new Date(endTime).toISOString() : null
        };
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), endpoint, {
            method: "PATCH",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "update project");
        const result = await response.json();
        return result;
    }
    async hasProject({ projectId, projectName }) {
        // TODO: Add a head request
        let path = "/sessions";
        const params = new URLSearchParams();
        if (projectId !== undefined && projectName !== undefined) throw new Error("Must provide either projectName or projectId, not both");
        else if (projectId !== undefined) {
            (0, _uuidJs.assertUuid)(projectId);
            path += `/${projectId}`;
        } else if (projectName !== undefined) params.append("name", projectName);
        else throw new Error("Must provide projectName or projectId");
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}${path}?${params}`, {
            method: "GET",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        // consume the response body to release the connection
        // https://undici.nodejs.org/#/?id=garbage-collection
        try {
            const result = await response.json();
            if (!response.ok) return false;
            // If it's OK and we're querying by name, need to check the list is not empty
            if (Array.isArray(result)) return result.length > 0;
            // projectId querying
            return true;
        } catch (e) {
            return false;
        }
    }
    async readProject({ projectId, projectName, includeStats }) {
        let path = "/sessions";
        const params = new URLSearchParams();
        if (projectId !== undefined && projectName !== undefined) throw new Error("Must provide either projectName or projectId, not both");
        else if (projectId !== undefined) {
            (0, _uuidJs.assertUuid)(projectId);
            path += `/${projectId}`;
        } else if (projectName !== undefined) params.append("name", projectName);
        else throw new Error("Must provide projectName or projectId");
        if (includeStats !== undefined) params.append("include_stats", includeStats.toString());
        const response = await this._get(path, params);
        let result;
        if (Array.isArray(response)) {
            if (response.length === 0) throw new Error(`Project[id=${projectId}, name=${projectName}] not found`);
            result = response[0];
        } else result = response;
        return result;
    }
    async getProjectUrl({ projectId, projectName }) {
        if (projectId === undefined && projectName === undefined) throw new Error("Must provide either projectName or projectId");
        const project = await this.readProject({
            projectId,
            projectName
        });
        const tenantId = await this._getTenantId();
        return `${this.getHostUrl()}/o/${tenantId}/projects/p/${project.id}`;
    }
    async getDatasetUrl({ datasetId, datasetName }) {
        if (datasetId === undefined && datasetName === undefined) throw new Error("Must provide either datasetName or datasetId");
        const dataset = await this.readDataset({
            datasetId,
            datasetName
        });
        const tenantId = await this._getTenantId();
        return `${this.getHostUrl()}/o/${tenantId}/datasets/${dataset.id}`;
    }
    async _getTenantId() {
        if (this._tenantId !== null) return this._tenantId;
        const queryParams = new URLSearchParams({
            limit: "1"
        });
        for await (const projects of this._getPaginated("/sessions", queryParams)){
            this._tenantId = projects[0].tenant_id;
            return projects[0].tenant_id;
        }
        throw new Error("No projects found to resolve tenant.");
    }
    async *listProjects({ projectIds, name, nameContains, referenceDatasetId, referenceDatasetName, referenceFree, metadata } = {}) {
        const params = new URLSearchParams();
        if (projectIds !== undefined) for (const projectId of projectIds)params.append("id", projectId);
        if (name !== undefined) params.append("name", name);
        if (nameContains !== undefined) params.append("name_contains", nameContains);
        if (referenceDatasetId !== undefined) params.append("reference_dataset", referenceDatasetId);
        else if (referenceDatasetName !== undefined) {
            const dataset = await this.readDataset({
                datasetName: referenceDatasetName
            });
            params.append("reference_dataset", dataset.id);
        }
        if (referenceFree !== undefined) params.append("reference_free", referenceFree.toString());
        if (metadata !== undefined) params.append("metadata", JSON.stringify(metadata));
        for await (const projects of this._getPaginated("/sessions", params))yield* projects;
    }
    async deleteProject({ projectId, projectName }) {
        let projectId_;
        if (projectId === undefined && projectName === undefined) throw new Error("Must provide projectName or projectId");
        else if (projectId !== undefined && projectName !== undefined) throw new Error("Must provide either projectName or projectId, not both");
        else if (projectId === undefined) projectId_ = (await this.readProject({
            projectName
        })).id;
        else projectId_ = projectId;
        (0, _uuidJs.assertUuid)(projectId_);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/sessions/${projectId_}`, {
            method: "DELETE",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, `delete session ${projectId_} (${projectName})`, true);
    }
    async uploadCsv({ csvFile, fileName, inputKeys, outputKeys, description, dataType, name }) {
        const url = `${this.apiUrl}/datasets/upload`;
        const formData = new FormData();
        formData.append("file", csvFile, fileName);
        inputKeys.forEach((key)=>{
            formData.append("input_keys", key);
        });
        outputKeys.forEach((key)=>{
            formData.append("output_keys", key);
        });
        if (description) formData.append("description", description);
        if (dataType) formData.append("data_type", dataType);
        if (name) formData.append("name", name);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), url, {
            method: "POST",
            headers: this.headers,
            body: formData,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "upload CSV");
        const result = await response.json();
        return result;
    }
    async createDataset(name, { description, dataType, inputsSchema, outputsSchema, metadata } = {}) {
        const body = {
            name,
            description,
            extra: metadata ? {
                metadata
            } : undefined
        };
        if (dataType) body.data_type = dataType;
        if (inputsSchema) body.inputs_schema_definition = inputsSchema;
        if (outputsSchema) body.outputs_schema_definition = outputsSchema;
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/datasets`, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "create dataset");
        const result = await response.json();
        return result;
    }
    async readDataset({ datasetId, datasetName }) {
        let path = "/datasets";
        // limit to 1 result
        const params = new URLSearchParams({
            limit: "1"
        });
        if (datasetId !== undefined && datasetName !== undefined) throw new Error("Must provide either datasetName or datasetId, not both");
        else if (datasetId !== undefined) {
            (0, _uuidJs.assertUuid)(datasetId);
            path += `/${datasetId}`;
        } else if (datasetName !== undefined) params.append("name", datasetName);
        else throw new Error("Must provide datasetName or datasetId");
        const response = await this._get(path, params);
        let result;
        if (Array.isArray(response)) {
            if (response.length === 0) throw new Error(`Dataset[id=${datasetId}, name=${datasetName}] not found`);
            result = response[0];
        } else result = response;
        return result;
    }
    async hasDataset({ datasetId, datasetName }) {
        try {
            await this.readDataset({
                datasetId,
                datasetName
            });
            return true;
        } catch (e) {
            if (// eslint-disable-next-line no-instanceof/no-instanceof
            e instanceof Error && e.message.toLocaleLowerCase().includes("not found")) return false;
            throw e;
        }
    }
    async diffDatasetVersions({ datasetId, datasetName, fromVersion, toVersion }) {
        let datasetId_ = datasetId;
        if (datasetId_ === undefined && datasetName === undefined) throw new Error("Must provide either datasetName or datasetId");
        else if (datasetId_ !== undefined && datasetName !== undefined) throw new Error("Must provide either datasetName or datasetId, not both");
        else if (datasetId_ === undefined) {
            const dataset = await this.readDataset({
                datasetName
            });
            datasetId_ = dataset.id;
        }
        const urlParams = new URLSearchParams({
            from_version: typeof fromVersion === "string" ? fromVersion : fromVersion.toISOString(),
            to_version: typeof toVersion === "string" ? toVersion : toVersion.toISOString()
        });
        const response = await this._get(`/datasets/${datasetId_}/versions/diff`, urlParams);
        return response;
    }
    async readDatasetOpenaiFinetuning({ datasetId, datasetName }) {
        const path = "/datasets";
        if (datasetId !== undefined) ;
        else if (datasetName !== undefined) datasetId = (await this.readDataset({
            datasetName
        })).id;
        else throw new Error("Must provide datasetName or datasetId");
        const response = await this._getResponse(`${path}/${datasetId}/openai_ft`);
        const datasetText = await response.text();
        const dataset = datasetText.trim().split("\n").map((line)=>JSON.parse(line));
        return dataset;
    }
    async *listDatasets({ limit = 100, offset = 0, datasetIds, datasetName, datasetNameContains, metadata } = {}) {
        const path = "/datasets";
        const params = new URLSearchParams({
            limit: limit.toString(),
            offset: offset.toString()
        });
        if (datasetIds !== undefined) for (const id_ of datasetIds)params.append("id", id_);
        if (datasetName !== undefined) params.append("name", datasetName);
        if (datasetNameContains !== undefined) params.append("name_contains", datasetNameContains);
        if (metadata !== undefined) params.append("metadata", JSON.stringify(metadata));
        for await (const datasets of this._getPaginated(path, params))yield* datasets;
    }
    /**
     * Update a dataset
     * @param props The dataset details to update
     * @returns The updated dataset
     */ async updateDataset(props) {
        const { datasetId, datasetName, ...update } = props;
        if (!datasetId && !datasetName) throw new Error("Must provide either datasetName or datasetId");
        const _datasetId = datasetId ?? (await this.readDataset({
            datasetName
        })).id;
        (0, _uuidJs.assertUuid)(_datasetId);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/datasets/${_datasetId}`, {
            method: "PATCH",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(update),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "update dataset");
        return await response.json();
    }
    async deleteDataset({ datasetId, datasetName }) {
        let path = "/datasets";
        let datasetId_ = datasetId;
        if (datasetId !== undefined && datasetName !== undefined) throw new Error("Must provide either datasetName or datasetId, not both");
        else if (datasetName !== undefined) {
            const dataset = await this.readDataset({
                datasetName
            });
            datasetId_ = dataset.id;
        }
        if (datasetId_ !== undefined) {
            (0, _uuidJs.assertUuid)(datasetId_);
            path += `/${datasetId_}`;
        } else throw new Error("Must provide datasetName or datasetId");
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), this.apiUrl + path, {
            method: "DELETE",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, `delete ${path}`);
        await response.json();
    }
    async indexDataset({ datasetId, datasetName, tag }) {
        let datasetId_ = datasetId;
        if (!datasetId_ && !datasetName) throw new Error("Must provide either datasetName or datasetId");
        else if (datasetId_ && datasetName) throw new Error("Must provide either datasetName or datasetId, not both");
        else if (!datasetId_) {
            const dataset = await this.readDataset({
                datasetName
            });
            datasetId_ = dataset.id;
        }
        (0, _uuidJs.assertUuid)(datasetId_);
        const data = {
            tag: tag
        };
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/datasets/${datasetId_}/index`, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "index dataset");
        await response.json();
    }
    /**
     * Lets you run a similarity search query on a dataset.
     *
     * Requires the dataset to be indexed. Please see the `indexDataset` method to set up indexing.
     *
     * @param inputs      The input on which to run the similarity search. Must have the
     *                    same schema as the dataset.
     *
     * @param datasetId   The dataset to search for similar examples.
     *
     * @param limit       The maximum number of examples to return. Will return the top `limit` most
     *                    similar examples in order of most similar to least similar. If no similar
     *                    examples are found, random examples will be returned.
     *
     * @param filter      A filter string to apply to the search. Only examples will be returned that
     *                    match the filter string. Some examples of filters
     *
     *                    - eq(metadata.mykey, "value")
     *                    - and(neq(metadata.my.nested.key, "value"), neq(metadata.mykey, "value"))
     *                    - or(eq(metadata.mykey, "value"), eq(metadata.mykey, "othervalue"))
     *
     * @returns           A list of similar examples.
     *
     *
     * @example
     * dataset_id = "123e4567-e89b-12d3-a456-426614174000"
     * inputs = {"text": "How many people live in Berlin?"}
     * limit = 5
     * examples = await client.similarExamples(inputs, dataset_id, limit)
     */ async similarExamples(inputs, datasetId, limit, { filter } = {}) {
        const data = {
            limit: limit,
            inputs: inputs
        };
        if (filter !== undefined) data["filter"] = filter;
        (0, _uuidJs.assertUuid)(datasetId);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/datasets/${datasetId}/search`, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "fetch similar examples");
        const result = await response.json();
        return result["examples"];
    }
    async createExample(inputs, outputs, { datasetId, datasetName, createdAt, exampleId, metadata, split, sourceRunId }) {
        let datasetId_ = datasetId;
        if (datasetId_ === undefined && datasetName === undefined) throw new Error("Must provide either datasetName or datasetId");
        else if (datasetId_ !== undefined && datasetName !== undefined) throw new Error("Must provide either datasetName or datasetId, not both");
        else if (datasetId_ === undefined) {
            const dataset = await this.readDataset({
                datasetName
            });
            datasetId_ = dataset.id;
        }
        const createdAt_ = createdAt || new Date();
        const data = {
            dataset_id: datasetId_,
            inputs,
            outputs,
            created_at: createdAt_?.toISOString(),
            id: exampleId,
            metadata,
            split,
            source_run_id: sourceRunId
        };
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/examples`, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "create example");
        const result = await response.json();
        return result;
    }
    async createExamples(props) {
        const { inputs, outputs, metadata, sourceRunIds, exampleIds, datasetId, datasetName } = props;
        let datasetId_ = datasetId;
        if (datasetId_ === undefined && datasetName === undefined) throw new Error("Must provide either datasetName or datasetId");
        else if (datasetId_ !== undefined && datasetName !== undefined) throw new Error("Must provide either datasetName or datasetId, not both");
        else if (datasetId_ === undefined) {
            const dataset = await this.readDataset({
                datasetName
            });
            datasetId_ = dataset.id;
        }
        const formattedExamples = inputs.map((input, idx)=>{
            return {
                dataset_id: datasetId_,
                inputs: input,
                outputs: outputs ? outputs[idx] : undefined,
                metadata: metadata ? metadata[idx] : undefined,
                split: props.splits ? props.splits[idx] : undefined,
                id: exampleIds ? exampleIds[idx] : undefined,
                source_run_id: sourceRunIds ? sourceRunIds[idx] : undefined
            };
        });
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/examples/bulk`, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(formattedExamples),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "create examples");
        const result = await response.json();
        return result;
    }
    async createLLMExample(input, generation, options) {
        return this.createExample({
            input
        }, {
            output: generation
        }, options);
    }
    async createChatExample(input, generations, options) {
        const finalInput = input.map((message)=>{
            if ((0, _messagesJs.isLangChainMessage)(message)) return (0, _messagesJs.convertLangChainMessageToExample)(message);
            return message;
        });
        const finalOutput = (0, _messagesJs.isLangChainMessage)(generations) ? (0, _messagesJs.convertLangChainMessageToExample)(generations) : generations;
        return this.createExample({
            input: finalInput
        }, {
            output: finalOutput
        }, options);
    }
    async readExample(exampleId) {
        (0, _uuidJs.assertUuid)(exampleId);
        const path = `/examples/${exampleId}`;
        return await this._get(path);
    }
    async *listExamples({ datasetId, datasetName, exampleIds, asOf, splits, inlineS3Urls, metadata, limit, offset, filter } = {}) {
        let datasetId_;
        if (datasetId !== undefined && datasetName !== undefined) throw new Error("Must provide either datasetName or datasetId, not both");
        else if (datasetId !== undefined) datasetId_ = datasetId;
        else if (datasetName !== undefined) {
            const dataset = await this.readDataset({
                datasetName
            });
            datasetId_ = dataset.id;
        } else throw new Error("Must provide a datasetName or datasetId");
        const params = new URLSearchParams({
            dataset: datasetId_
        });
        const dataset_version = asOf ? typeof asOf === "string" ? asOf : asOf?.toISOString() : undefined;
        if (dataset_version) params.append("as_of", dataset_version);
        const inlineS3Urls_ = inlineS3Urls ?? true;
        params.append("inline_s3_urls", inlineS3Urls_.toString());
        if (exampleIds !== undefined) for (const id_ of exampleIds)params.append("id", id_);
        if (splits !== undefined) for (const split of splits)params.append("splits", split);
        if (metadata !== undefined) {
            const serializedMetadata = JSON.stringify(metadata);
            params.append("metadata", serializedMetadata);
        }
        if (limit !== undefined) params.append("limit", limit.toString());
        if (offset !== undefined) params.append("offset", offset.toString());
        if (filter !== undefined) params.append("filter", filter);
        let i = 0;
        for await (const examples of this._getPaginated("/examples", params)){
            for (const example of examples){
                yield example;
                i++;
            }
            if (limit !== undefined && i >= limit) break;
        }
    }
    async deleteExample(exampleId) {
        (0, _uuidJs.assertUuid)(exampleId);
        const path = `/examples/${exampleId}`;
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), this.apiUrl + path, {
            method: "DELETE",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, `delete ${path}`);
        await response.json();
    }
    async updateExample(exampleId, update) {
        (0, _uuidJs.assertUuid)(exampleId);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/examples/${exampleId}`, {
            method: "PATCH",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(update),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "update example");
        const result = await response.json();
        return result;
    }
    async updateExamples(update) {
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/examples/bulk`, {
            method: "PATCH",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(update),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "update examples");
        const result = await response.json();
        return result;
    }
    async listDatasetSplits({ datasetId, datasetName, asOf }) {
        let datasetId_;
        if (datasetId === undefined && datasetName === undefined) throw new Error("Must provide dataset name or ID");
        else if (datasetId !== undefined && datasetName !== undefined) throw new Error("Must provide either datasetName or datasetId, not both");
        else if (datasetId === undefined) {
            const dataset = await this.readDataset({
                datasetName
            });
            datasetId_ = dataset.id;
        } else datasetId_ = datasetId;
        (0, _uuidJs.assertUuid)(datasetId_);
        const params = new URLSearchParams();
        const dataset_version = asOf ? typeof asOf === "string" ? asOf : asOf?.toISOString() : undefined;
        if (dataset_version) params.append("as_of", dataset_version);
        const response = await this._get(`/datasets/${datasetId_}/splits`, params);
        return response;
    }
    async updateDatasetSplits({ datasetId, datasetName, splitName, exampleIds, remove = false }) {
        let datasetId_;
        if (datasetId === undefined && datasetName === undefined) throw new Error("Must provide dataset name or ID");
        else if (datasetId !== undefined && datasetName !== undefined) throw new Error("Must provide either datasetName or datasetId, not both");
        else if (datasetId === undefined) {
            const dataset = await this.readDataset({
                datasetName
            });
            datasetId_ = dataset.id;
        } else datasetId_ = datasetId;
        (0, _uuidJs.assertUuid)(datasetId_);
        const data = {
            split_name: splitName,
            examples: exampleIds.map((id)=>{
                (0, _uuidJs.assertUuid)(id);
                return id;
            }),
            remove
        };
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/datasets/${datasetId_}/splits`, {
            method: "PUT",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "update dataset splits", true);
    }
    /**
     * @deprecated This method is deprecated and will be removed in future LangSmith versions, use `evaluate` from `langsmith/evaluation` instead.
     */ async evaluateRun(run, evaluator, { sourceInfo, loadChildRuns, referenceExample } = {
        loadChildRuns: false
    }) {
        (0, _warnJs.warnOnce)("This method is deprecated and will be removed in future LangSmith versions, use `evaluate` from `langsmith/evaluation` instead.");
        let run_;
        if (typeof run === "string") run_ = await this.readRun(run, {
            loadChildRuns
        });
        else if (typeof run === "object" && "id" in run) run_ = run;
        else throw new Error(`Invalid run type: ${typeof run}`);
        if (run_.reference_example_id !== null && run_.reference_example_id !== undefined) referenceExample = await this.readExample(run_.reference_example_id);
        const feedbackResult = await evaluator.evaluateRun(run_, referenceExample);
        const [_, feedbacks] = await this._logEvaluationFeedback(feedbackResult, run_, sourceInfo);
        return feedbacks[0];
    }
    async createFeedback(runId, key, { score, value, correction, comment, sourceInfo, feedbackSourceType = "api", sourceRunId, feedbackId, feedbackConfig, projectId, comparativeExperimentId }) {
        if (!runId && !projectId) throw new Error("One of runId or projectId must be provided");
        if (runId && projectId) throw new Error("Only one of runId or projectId can be provided");
        const feedback_source = {
            type: feedbackSourceType ?? "api",
            metadata: sourceInfo ?? {}
        };
        if (sourceRunId !== undefined && feedback_source?.metadata !== undefined && !feedback_source.metadata["__run"]) feedback_source.metadata["__run"] = {
            run_id: sourceRunId
        };
        if (feedback_source?.metadata !== undefined && feedback_source.metadata["__run"]?.run_id !== undefined) (0, _uuidJs.assertUuid)(feedback_source.metadata["__run"].run_id);
        const feedback = {
            id: feedbackId ?? _uuid.v4(),
            run_id: runId,
            key,
            score,
            value,
            correction,
            comment,
            feedback_source: feedback_source,
            comparative_experiment_id: comparativeExperimentId,
            feedbackConfig,
            session_id: projectId
        };
        const url = `${this.apiUrl}/feedback`;
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), url, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(feedback),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "create feedback", true);
        return feedback;
    }
    async updateFeedback(feedbackId, { score, value, correction, comment }) {
        const feedbackUpdate = {};
        if (score !== undefined && score !== null) feedbackUpdate["score"] = score;
        if (value !== undefined && value !== null) feedbackUpdate["value"] = value;
        if (correction !== undefined && correction !== null) feedbackUpdate["correction"] = correction;
        if (comment !== undefined && comment !== null) feedbackUpdate["comment"] = comment;
        (0, _uuidJs.assertUuid)(feedbackId);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/feedback/${feedbackId}`, {
            method: "PATCH",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(feedbackUpdate),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "update feedback", true);
    }
    async readFeedback(feedbackId) {
        (0, _uuidJs.assertUuid)(feedbackId);
        const path = `/feedback/${feedbackId}`;
        const response = await this._get(path);
        return response;
    }
    async deleteFeedback(feedbackId) {
        (0, _uuidJs.assertUuid)(feedbackId);
        const path = `/feedback/${feedbackId}`;
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), this.apiUrl + path, {
            method: "DELETE",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, `delete ${path}`);
        await response.json();
    }
    async *listFeedback({ runIds, feedbackKeys, feedbackSourceTypes } = {}) {
        const queryParams = new URLSearchParams();
        if (runIds) queryParams.append("run", runIds.join(","));
        if (feedbackKeys) for (const key of feedbackKeys)queryParams.append("key", key);
        if (feedbackSourceTypes) for (const type of feedbackSourceTypes)queryParams.append("source", type);
        for await (const feedbacks of this._getPaginated("/feedback", queryParams))yield* feedbacks;
    }
    /**
     * Creates a presigned feedback token and URL.
     *
     * The token can be used to authorize feedback metrics without
     * needing an API key. This is useful for giving browser-based
     * applications the ability to submit feedback without needing
     * to expose an API key.
     *
     * @param runId - The ID of the run.
     * @param feedbackKey - The feedback key.
     * @param options - Additional options for the token.
     * @param options.expiration - The expiration time for the token.
     *
     * @returns A promise that resolves to a FeedbackIngestToken.
     */ async createPresignedFeedbackToken(runId, feedbackKey, { expiration, feedbackConfig } = {}) {
        const body = {
            run_id: runId,
            feedback_key: feedbackKey,
            feedback_config: feedbackConfig
        };
        if (expiration) {
            if (typeof expiration === "string") body["expires_at"] = expiration;
            else if (expiration?.hours || expiration?.minutes || expiration?.days) body["expires_in"] = expiration;
        } else body["expires_in"] = {
            hours: 3
        };
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/feedback/tokens`, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        const result = await response.json();
        return result;
    }
    async createComparativeExperiment({ name, experimentIds, referenceDatasetId, createdAt, description, metadata, id }) {
        if (experimentIds.length === 0) throw new Error("At least one experiment is required");
        if (!referenceDatasetId) referenceDatasetId = (await this.readProject({
            projectId: experimentIds[0]
        })).reference_dataset_id;
        if (!referenceDatasetId == null) throw new Error("A reference dataset is required");
        const body = {
            id,
            name,
            experiment_ids: experimentIds,
            reference_dataset_id: referenceDatasetId,
            description,
            created_at: (createdAt ?? new Date())?.toISOString(),
            extra: {}
        };
        if (metadata) body.extra["metadata"] = metadata;
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/datasets/comparative`, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        return await response.json();
    }
    /**
     * Retrieves a list of presigned feedback tokens for a given run ID.
     * @param runId The ID of the run.
     * @returns An async iterable of FeedbackIngestToken objects.
     */ async *listPresignedFeedbackTokens(runId) {
        (0, _uuidJs.assertUuid)(runId);
        const params = new URLSearchParams({
            run_id: runId
        });
        for await (const tokens of this._getPaginated("/feedback/tokens", params))yield* tokens;
    }
    _selectEvalResults(results) {
        let results_;
        if ("results" in results) results_ = results.results;
        else results_ = [
            results
        ];
        return results_;
    }
    async _logEvaluationFeedback(evaluatorResponse, run, sourceInfo) {
        const evalResults = this._selectEvalResults(evaluatorResponse);
        const feedbacks = [];
        for (const res of evalResults){
            let sourceInfo_ = sourceInfo || {};
            if (res.evaluatorInfo) sourceInfo_ = {
                ...res.evaluatorInfo,
                ...sourceInfo_
            };
            let runId_ = null;
            if (res.targetRunId) runId_ = res.targetRunId;
            else if (run) runId_ = run.id;
            feedbacks.push(await this.createFeedback(runId_, res.key, {
                score: res.score,
                value: res.value,
                comment: res.comment,
                correction: res.correction,
                sourceInfo: sourceInfo_,
                sourceRunId: res.sourceRunId,
                feedbackConfig: res.feedbackConfig,
                feedbackSourceType: "model"
            }));
        }
        return [
            evalResults,
            feedbacks
        ];
    }
    async logEvaluationFeedback(evaluatorResponse, run, sourceInfo) {
        const [results] = await this._logEvaluationFeedback(evaluatorResponse, run, sourceInfo);
        return results;
    }
    /**
     * API for managing annotation queues
     */ /**
     * List the annotation queues on the LangSmith API.
     * @param options - The options for listing annotation queues
     * @param options.queueIds - The IDs of the queues to filter by
     * @param options.name - The name of the queue to filter by
     * @param options.nameContains - The substring that the queue name should contain
     * @param options.limit - The maximum number of queues to return
     * @returns An iterator of AnnotationQueue objects
     */ async *listAnnotationQueues(options = {}) {
        const { queueIds, name, nameContains, limit } = options;
        const params = new URLSearchParams();
        if (queueIds) queueIds.forEach((id, i)=>{
            (0, _uuidJs.assertUuid)(id, `queueIds[${i}]`);
            params.append("ids", id);
        });
        if (name) params.append("name", name);
        if (nameContains) params.append("name_contains", nameContains);
        params.append("limit", (limit !== undefined ? Math.min(limit, 100) : 100).toString());
        let count = 0;
        for await (const queues of this._getPaginated("/annotation-queues", params)){
            yield* queues;
            count++;
            if (limit !== undefined && count >= limit) break;
        }
    }
    /**
     * Create an annotation queue on the LangSmith API.
     * @param options - The options for creating an annotation queue
     * @param options.name - The name of the annotation queue
     * @param options.description - The description of the annotation queue
     * @param options.queueId - The ID of the annotation queue
     * @returns The created AnnotationQueue object
     */ async createAnnotationQueue(options) {
        const { name, description, queueId } = options;
        const body = {
            name,
            description,
            id: queueId || _uuid.v4()
        };
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/annotation-queues`, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(Object.fromEntries(Object.entries(body).filter(([_, v])=>v !== undefined))),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "create annotation queue");
        const data = await response.json();
        return data;
    }
    /**
     * Read an annotation queue with the specified queue ID.
     * @param queueId - The ID of the annotation queue to read
     * @returns The AnnotationQueue object
     */ async readAnnotationQueue(queueId) {
        // TODO: Replace when actual endpoint is added
        const queueIteratorResult = await this.listAnnotationQueues({
            queueIds: [
                queueId
            ]
        }).next();
        if (queueIteratorResult.done) throw new Error(`Annotation queue with ID ${queueId} not found`);
        return queueIteratorResult.value;
    }
    /**
     * Update an annotation queue with the specified queue ID.
     * @param queueId - The ID of the annotation queue to update
     * @param options - The options for updating the annotation queue
     * @param options.name - The new name for the annotation queue
     * @param options.description - The new description for the annotation queue
     */ async updateAnnotationQueue(queueId, options) {
        const { name, description } = options;
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/annotation-queues/${(0, _uuidJs.assertUuid)(queueId, "queueId")}`, {
            method: "PATCH",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                name,
                description
            }),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "update annotation queue");
    }
    /**
     * Delete an annotation queue with the specified queue ID.
     * @param queueId - The ID of the annotation queue to delete
     */ async deleteAnnotationQueue(queueId) {
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/annotation-queues/${(0, _uuidJs.assertUuid)(queueId, "queueId")}`, {
            method: "DELETE",
            headers: {
                ...this.headers,
                Accept: "application/json"
            },
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "delete annotation queue");
    }
    /**
     * Add runs to an annotation queue with the specified queue ID.
     * @param queueId - The ID of the annotation queue
     * @param runIds - The IDs of the runs to be added to the annotation queue
     */ async addRunsToAnnotationQueue(queueId, runIds) {
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/annotation-queues/${(0, _uuidJs.assertUuid)(queueId, "queueId")}/runs`, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(runIds.map((id, i)=>(0, _uuidJs.assertUuid)(id, `runIds[${i}]`).toString())),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "add runs to annotation queue");
    }
    /**
     * Get a run from an annotation queue at the specified index.
     * @param queueId - The ID of the annotation queue
     * @param index - The index of the run to retrieve
     * @returns A Promise that resolves to a RunWithAnnotationQueueInfo object
     * @throws {Error} If the run is not found at the given index or for other API-related errors
     */ async getRunFromAnnotationQueue(queueId, index) {
        const baseUrl = `/annotation-queues/${(0, _uuidJs.assertUuid)(queueId, "queueId")}/run`;
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}${baseUrl}/${index}`, {
            method: "GET",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "get run from annotation queue");
        return await response.json();
    }
    async _currentTenantIsOwner(owner) {
        const settings = await this._getSettings();
        return owner == "-" || settings.tenant_handle === owner;
    }
    async _ownerConflictError(action, owner) {
        const settings = await this._getSettings();
        return new Error(`Cannot ${action} for another tenant.\n
      Current tenant: ${settings.tenant_handle}\n
      Requested tenant: ${owner}`);
    }
    async _getLatestCommitHash(promptOwnerAndName) {
        const res = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/commits/${promptOwnerAndName}/?limit=${1}&offset=${0}`, {
            method: "GET",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        const json = await res.json();
        if (!res.ok) {
            const detail = typeof json.detail === "string" ? json.detail : JSON.stringify(json.detail);
            const error = new Error(`Error ${res.status}: ${res.statusText}\n${detail}`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.statusCode = res.status;
            throw error;
        }
        if (json.commits.length === 0) return undefined;
        return json.commits[0].commit_hash;
    }
    async _likeOrUnlikePrompt(promptIdentifier, like) {
        const [owner, promptName, _] = (0, _promptsJs.parsePromptIdentifier)(promptIdentifier);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/likes/${owner}/${promptName}`, {
            method: "POST",
            body: JSON.stringify({
                like: like
            }),
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, `${like ? "like" : "unlike"} prompt`);
        return await response.json();
    }
    async _getPromptUrl(promptIdentifier) {
        const [owner, promptName, commitHash] = (0, _promptsJs.parsePromptIdentifier)(promptIdentifier);
        if (!await this._currentTenantIsOwner(owner)) {
            if (commitHash !== "latest") return `${this.getHostUrl()}/hub/${owner}/${promptName}/${commitHash.substring(0, 8)}`;
            else return `${this.getHostUrl()}/hub/${owner}/${promptName}`;
        } else {
            const settings = await this._getSettings();
            if (commitHash !== "latest") return `${this.getHostUrl()}/prompts/${promptName}/${commitHash.substring(0, 8)}?organizationId=${settings.id}`;
            else return `${this.getHostUrl()}/prompts/${promptName}?organizationId=${settings.id}`;
        }
    }
    async promptExists(promptIdentifier) {
        const prompt = await this.getPrompt(promptIdentifier);
        return !!prompt;
    }
    async likePrompt(promptIdentifier) {
        return this._likeOrUnlikePrompt(promptIdentifier, true);
    }
    async unlikePrompt(promptIdentifier) {
        return this._likeOrUnlikePrompt(promptIdentifier, false);
    }
    async *listCommits(promptOwnerAndName) {
        for await (const commits of this._getPaginated(`/commits/${promptOwnerAndName}/`, new URLSearchParams(), (res)=>res.commits))yield* commits;
    }
    async *listPrompts(options) {
        const params = new URLSearchParams();
        params.append("sort_field", options?.sortField ?? "updated_at");
        params.append("sort_direction", "desc");
        params.append("is_archived", (!!options?.isArchived).toString());
        if (options?.isPublic !== undefined) params.append("is_public", options.isPublic.toString());
        if (options?.query) params.append("query", options.query);
        for await (const prompts of this._getPaginated("/repos", params, (res)=>res.repos))yield* prompts;
    }
    async getPrompt(promptIdentifier) {
        const [owner, promptName, _] = (0, _promptsJs.parsePromptIdentifier)(promptIdentifier);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/repos/${owner}/${promptName}`, {
            method: "GET",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        if (response.status === 404) return null;
        await (0, _errorJs.raiseForStatus)(response, "get prompt");
        const result = await response.json();
        if (result.repo) return result.repo;
        else return null;
    }
    async createPrompt(promptIdentifier, options) {
        const settings = await this._getSettings();
        if (options?.isPublic && !settings.tenant_handle) throw new Error(`Cannot create a public prompt without first\n
        creating a LangChain Hub handle. 
        You can add a handle by creating a public prompt at:\n
        https://smith.langchain.com/prompts`);
        const [owner, promptName, _] = (0, _promptsJs.parsePromptIdentifier)(promptIdentifier);
        if (!await this._currentTenantIsOwner(owner)) throw await this._ownerConflictError("create a prompt", owner);
        const data = {
            repo_handle: promptName,
            ...options?.description && {
                description: options.description
            },
            ...options?.readme && {
                readme: options.readme
            },
            ...options?.tags && {
                tags: options.tags
            },
            is_public: !!options?.isPublic
        };
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/repos/`, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "create prompt");
        const { repo } = await response.json();
        return repo;
    }
    async createCommit(promptIdentifier, object, options) {
        if (!await this.promptExists(promptIdentifier)) throw new Error("Prompt does not exist, you must create it first.");
        const [owner, promptName, _] = (0, _promptsJs.parsePromptIdentifier)(promptIdentifier);
        const resolvedParentCommitHash = options?.parentCommitHash === "latest" || !options?.parentCommitHash ? await this._getLatestCommitHash(`${owner}/${promptName}`) : options?.parentCommitHash;
        const payload = {
            manifest: JSON.parse(JSON.stringify(object)),
            parent_commit: resolvedParentCommitHash
        };
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/commits/${owner}/${promptName}`, {
            method: "POST",
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload),
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "create commit");
        const result = await response.json();
        return this._getPromptUrl(`${owner}/${promptName}${result.commit_hash ? `:${result.commit_hash}` : ""}`);
    }
    async updatePrompt(promptIdentifier, options) {
        if (!await this.promptExists(promptIdentifier)) throw new Error("Prompt does not exist, you must create it first.");
        const [owner, promptName] = (0, _promptsJs.parsePromptIdentifier)(promptIdentifier);
        if (!await this._currentTenantIsOwner(owner)) throw await this._ownerConflictError("update a prompt", owner);
        const payload = {};
        if (options?.description !== undefined) payload.description = options.description;
        if (options?.readme !== undefined) payload.readme = options.readme;
        if (options?.tags !== undefined) payload.tags = options.tags;
        if (options?.isPublic !== undefined) payload.is_public = options.isPublic;
        if (options?.isArchived !== undefined) payload.is_archived = options.isArchived;
        // Check if payload is empty
        if (Object.keys(payload).length === 0) throw new Error("No valid update options provided");
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/repos/${owner}/${promptName}`, {
            method: "PATCH",
            body: JSON.stringify(payload),
            headers: {
                ...this.headers,
                "Content-Type": "application/json"
            },
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "update prompt");
        return response.json();
    }
    async deletePrompt(promptIdentifier) {
        if (!await this.promptExists(promptIdentifier)) throw new Error("Prompt does not exist, you must create it first.");
        const [owner, promptName, _] = (0, _promptsJs.parsePromptIdentifier)(promptIdentifier);
        if (!await this._currentTenantIsOwner(owner)) throw await this._ownerConflictError("delete a prompt", owner);
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/repos/${owner}/${promptName}`, {
            method: "DELETE",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        return await response.json();
    }
    async pullPromptCommit(promptIdentifier, options) {
        const [owner, promptName, commitHash] = (0, _promptsJs.parsePromptIdentifier)(promptIdentifier);
        const serverInfo = await this._getServerInfo();
        const useOptimization = (0, _promptsJs.isVersionGreaterOrEqual)(serverInfo.version, "0.5.23");
        let passedCommitHash = commitHash;
        if (!useOptimization && commitHash === "latest") {
            const latestCommitHash = await this._getLatestCommitHash(`${owner}/${promptName}`);
            if (!latestCommitHash) throw new Error("No commits found");
            else passedCommitHash = latestCommitHash;
        }
        const response = await this.caller.call((0, _fetchJs._getFetchImplementation)(), `${this.apiUrl}/commits/${owner}/${promptName}/${passedCommitHash}${options?.includeModel ? "?include_model=true" : ""}`, {
            method: "GET",
            headers: this.headers,
            signal: AbortSignal.timeout(this.timeout_ms),
            ...this.fetchOptions
        });
        await (0, _errorJs.raiseForStatus)(response, "pull prompt commit");
        const result = await response.json();
        return {
            owner,
            repo: promptName,
            commit_hash: result.commit_hash,
            manifest: result.manifest,
            examples: result.examples
        };
    }
    /**
     * This method should not be used directly, use `import { pull } from "langchain/hub"` instead.
     * Using this method directly returns the JSON string of the prompt rather than a LangChain object.
     * @private
     */ async _pullPrompt(promptIdentifier, options) {
        const promptObject = await this.pullPromptCommit(promptIdentifier, {
            includeModel: options?.includeModel
        });
        const prompt = JSON.stringify(promptObject.manifest);
        return prompt;
    }
    async pushPrompt(promptIdentifier, options) {
        // Create or update prompt metadata
        if (await this.promptExists(promptIdentifier)) {
            if (options && Object.keys(options).some((key)=>key !== "object")) await this.updatePrompt(promptIdentifier, {
                description: options?.description,
                readme: options?.readme,
                tags: options?.tags,
                isPublic: options?.isPublic
            });
        } else await this.createPrompt(promptIdentifier, {
            description: options?.description,
            readme: options?.readme,
            tags: options?.tags,
            isPublic: options?.isPublic
        });
        if (!options?.object) return await this._getPromptUrl(promptIdentifier);
        // Create a commit with the new manifest
        const url = await this.createCommit(promptIdentifier, options?.object, {
            parentCommitHash: options?.parentCommitHash
        });
        return url;
    }
    /**
     * Clone a public dataset to your own langsmith tenant.
     * This operation is idempotent. If you already have a dataset with the given name,
     * this function will do nothing.
  
     * @param {string} tokenOrUrl The token of the public dataset to clone.
     * @param {Object} [options] Additional options for cloning the dataset.
     * @param {string} [options.sourceApiUrl] The URL of the langsmith server where the data is hosted. Defaults to the API URL of your current client.
     * @param {string} [options.datasetName] The name of the dataset to create in your tenant. Defaults to the name of the public dataset.
     * @returns {Promise<void>}
     */ async clonePublicDataset(tokenOrUrl, options = {}) {
        const { sourceApiUrl = this.apiUrl, datasetName } = options;
        const [parsedApiUrl, tokenUuid] = this.parseTokenOrUrl(tokenOrUrl, sourceApiUrl);
        const sourceClient = new Client({
            apiUrl: parsedApiUrl,
            // Placeholder API key not needed anymore in most cases, but
            // some private deployments may have API key-based rate limiting
            // that would cause this to fail if we provide no value.
            apiKey: "placeholder"
        });
        const ds = await sourceClient.readSharedDataset(tokenUuid);
        const finalDatasetName = datasetName || ds.name;
        try {
            if (await this.hasDataset({
                datasetId: finalDatasetName
            })) {
                console.log(`Dataset ${finalDatasetName} already exists in your tenant. Skipping.`);
                return;
            }
        } catch (_) {
        // `.hasDataset` will throw an error if the dataset does not exist.
        // no-op in that case
        }
        // Fetch examples first, then create the dataset
        const examples = await sourceClient.listSharedExamples(tokenUuid);
        const dataset = await this.createDataset(finalDatasetName, {
            description: ds.description,
            dataType: ds.data_type || "kv",
            inputsSchema: ds.inputs_schema_definition ?? undefined,
            outputsSchema: ds.outputs_schema_definition ?? undefined
        });
        try {
            await this.createExamples({
                inputs: examples.map((e)=>e.inputs),
                outputs: examples.flatMap((e)=>e.outputs ? [
                        e.outputs
                    ] : []),
                datasetId: dataset.id
            });
        } catch (e) {
            console.error(`An error occurred while creating dataset ${finalDatasetName}. ` + "You should delete it manually.");
            throw e;
        }
    }
    parseTokenOrUrl(urlOrToken, apiUrl, numParts = 2, kind = "dataset") {
        // Try parsing as UUID
        try {
            (0, _uuidJs.assertUuid)(urlOrToken); // Will throw if it's not a UUID.
            return [
                apiUrl,
                urlOrToken
            ];
        } catch (_) {
        // no-op if it's not a uuid
        }
        // Parse as URL
        try {
            const parsedUrl = new URL(urlOrToken);
            const pathParts = parsedUrl.pathname.split("/").filter((part)=>part !== "");
            if (pathParts.length >= numParts) {
                const tokenUuid = pathParts[pathParts.length - numParts];
                return [
                    apiUrl,
                    tokenUuid
                ];
            } else throw new Error(`Invalid public ${kind} URL: ${urlOrToken}`);
        } catch (error) {
            throw new Error(`Invalid public ${kind} URL or token: ${urlOrToken}`);
        }
    }
    /**
     * Awaits all pending trace batches. Useful for environments where
     * you need to be sure that all tracing requests finish before execution ends,
     * such as serverless environments.
     *
     * @example
     * ```
     * import { Client } from "langsmith";
     *
     * const client = new Client();
     *
     * try {
     *   // Tracing happens here
     *   ...
     * } finally {
     *   await client.awaitPendingTraceBatches();
     * }
     * ```
     *
     * @returns A promise that resolves once all currently pending traces have sent.
     */ awaitPendingTraceBatches() {
        return Promise.all([
            ...this.autoBatchQueue.items.map(({ itemPromise })=>itemPromise),
            this.batchIngestCaller.queue.onIdle()
        ]);
    }
}

},{"uuid":"klst7","./utils/async_caller.js":"cvQPE","./utils/messages.js":"8ZusB","./utils/env.js":"dzGHq","./index.js":"kaE6w","./utils/_uuid.js":"14Ewv","./utils/warn.js":"4roK2","./utils/prompts.js":"61D0Z","./utils/error.js":"tCvU8","./singletons/fetch.js":"5gYkK","./utils/fast-safe-stringify/index.js":"eHrZD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cvQPE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class that can be used to make async calls with concurrency and retry logic.
 *
 * This is useful for making calls to any kind of "expensive" external resource,
 * be it because it's rate-limited, subject to network issues, etc.
 *
 * Concurrent calls are limited by the `maxConcurrency` parameter, which defaults
 * to `Infinity`. This means that by default, all calls will be made in parallel.
 *
 * Retries are limited by the `maxRetries` parameter, which defaults to 6. This
 * means that by default, each call will be retried up to 6 times, with an
 * exponential backoff between each attempt.
 */ parcelHelpers.export(exports, "AsyncCaller", ()=>AsyncCaller);
var _pRetry = require("p-retry");
var _pRetryDefault = parcelHelpers.interopDefault(_pRetry);
var _pQueue = require("p-queue");
var _pQueueDefault = parcelHelpers.interopDefault(_pQueue);
var _fetchJs = require("../singletons/fetch.js");
const STATUS_NO_RETRY = [
    400,
    401,
    403,
    404,
    405,
    406,
    407,
    408
];
const STATUS_IGNORE = [
    409
];
class AsyncCaller {
    constructor(params){
        Object.defineProperty(this, "maxConcurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxRetries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "queue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onFailedResponseHook", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxConcurrency = params.maxConcurrency ?? Infinity;
        this.maxRetries = params.maxRetries ?? 6;
        if ("default" in (0, _pQueueDefault.default)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.queue = new (0, _pQueueDefault.default).default({
            concurrency: this.maxConcurrency
        });
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.queue = new (0, _pQueueDefault.default)({
            concurrency: this.maxConcurrency
        });
        this.onFailedResponseHook = params?.onFailedResponseHook;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    call(callable, ...args) {
        const onFailedResponseHook = this.onFailedResponseHook;
        return this.queue.add(()=>(0, _pRetryDefault.default)(()=>callable(...args).catch((error)=>{
                    // eslint-disable-next-line no-instanceof/no-instanceof
                    if (error instanceof Error) throw error;
                    else throw new Error(error);
                }), {
                async onFailedAttempt (error) {
                    if (error.message.startsWith("Cancel") || error.message.startsWith("TimeoutError") || error.message.startsWith("AbortError")) throw error;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (error?.code === "ECONNABORTED") throw error;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const response = error?.response;
                    const status = response?.status;
                    if (status) {
                        if (STATUS_NO_RETRY.includes(+status)) throw error;
                        else if (STATUS_IGNORE.includes(+status)) return;
                        if (onFailedResponseHook) await onFailedResponseHook(response);
                    }
                },
                // If needed we can change some of the defaults here,
                // but they're quite sensible.
                retries: this.maxRetries,
                randomize: true
            }), {
            throwOnTimeout: true
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callWithOptions(options, callable, ...args) {
        // Note this doesn't cancel the underlying request,
        // when available prefer to use the signal option of the underlying call
        if (options.signal) return Promise.race([
            this.call(callable, ...args),
            new Promise((_, reject)=>{
                options.signal?.addEventListener("abort", ()=>{
                    reject(new Error("AbortError"));
                });
            })
        ]);
        return this.call(callable, ...args);
    }
    fetch(...args) {
        return this.call(()=>(0, _fetchJs._getFetchImplementation)()(...args).then((res)=>res.ok ? res : Promise.reject(res)));
    }
}

},{"p-retry":"jLLyx","p-queue":"5oyJ8","../singletons/fetch.js":"5gYkK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jLLyx":[function(require,module,exports,__globalThis) {
'use strict';
const retry = require("67f41b35420203c");
const networkErrorMsgs = [
    'Failed to fetch',
    'NetworkError when attempting to fetch resource.',
    'The Internet connection appears to be offline.',
    'Network request failed' // `cross-fetch`
];
class AbortError extends Error {
    constructor(message){
        super();
        if (message instanceof Error) {
            this.originalError = message;
            ({ message } = message);
        } else {
            this.originalError = new Error(message);
            this.originalError.stack = this.stack;
        }
        this.name = 'AbortError';
        this.message = message;
    }
}
const decorateErrorWithCounts = (error, attemptNumber, options)=>{
    // Minus 1 from attemptNumber because the first attempt does not count as a retry
    const retriesLeft = options.retries - (attemptNumber - 1);
    error.attemptNumber = attemptNumber;
    error.retriesLeft = retriesLeft;
    return error;
};
const isNetworkError = (errorMessage)=>networkErrorMsgs.includes(errorMessage);
const pRetry = (input, options)=>new Promise((resolve, reject)=>{
        options = {
            onFailedAttempt: ()=>{},
            retries: 10,
            ...options
        };
        const operation = retry.operation(options);
        operation.attempt(async (attemptNumber)=>{
            try {
                resolve(await input(attemptNumber));
            } catch (error) {
                if (!(error instanceof Error)) {
                    reject(new TypeError(`Non-error was thrown: "${error}". You should only throw errors.`));
                    return;
                }
                if (error instanceof AbortError) {
                    operation.stop();
                    reject(error.originalError);
                } else if (error instanceof TypeError && !isNetworkError(error.message)) {
                    operation.stop();
                    reject(error);
                } else {
                    decorateErrorWithCounts(error, attemptNumber, options);
                    try {
                        await options.onFailedAttempt(error);
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (!operation.retry(error)) reject(operation.mainError());
                }
            }
        });
    });
module.exports = pRetry;
// TODO: remove this in the next major version
module.exports.default = pRetry;
module.exports.AbortError = AbortError;

},{"67f41b35420203c":"dClU0"}],"dClU0":[function(require,module,exports,__globalThis) {
module.exports = require("4f22b206be44b97e");

},{"4f22b206be44b97e":"eOmER"}],"eOmER":[function(require,module,exports,__globalThis) {
var RetryOperation = require("a628df618ac3d4");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new RetryOperation(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

},{"a628df618ac3d4":"bnKNL"}],"bnKNL":[function(require,module,exports,__globalThis) {
function RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = RetryOperation;
RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
RetryOperation.prototype.start = RetryOperation.prototype.try;
RetryOperation.prototype.errors = function() {
    return this._errors;
};
RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

},{}],"5oyJ8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const EventEmitter = require("a178093eea54aebd");
const p_timeout_1 = require("d219d890bb7e8882");
const priority_queue_1 = require("4a792a8cd58e20a7");
// eslint-disable-next-line @typescript-eslint/no-empty-function
const empty = ()=>{};
const timeoutError = new p_timeout_1.TimeoutError();
/**
Promise queue with concurrency control.
*/ class PQueue extends EventEmitter {
    constructor(options){
        var _a, _b, _c, _d;
        super();
        this._intervalCount = 0;
        this._intervalEnd = 0;
        this._pendingCount = 0;
        this._resolveEmpty = empty;
        this._resolveIdle = empty;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        options = Object.assign({
            carryoverConcurrencyCount: false,
            intervalCap: Infinity,
            interval: 0,
            concurrency: Infinity,
            autoStart: true,
            queueClass: priority_queue_1.default
        }, options);
        if (!(typeof options.intervalCap === 'number' && options.intervalCap >= 1)) throw new TypeError(`Expected \`intervalCap\` to be a number from 1 and up, got \`${(_b = (_a = options.intervalCap) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : ''}\` (${typeof options.intervalCap})`);
        if (options.interval === undefined || !(Number.isFinite(options.interval) && options.interval >= 0)) throw new TypeError(`Expected \`interval\` to be a finite number >= 0, got \`${(_d = (_c = options.interval) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''}\` (${typeof options.interval})`);
        this._carryoverConcurrencyCount = options.carryoverConcurrencyCount;
        this._isIntervalIgnored = options.intervalCap === Infinity || options.interval === 0;
        this._intervalCap = options.intervalCap;
        this._interval = options.interval;
        this._queue = new options.queueClass();
        this._queueClass = options.queueClass;
        this.concurrency = options.concurrency;
        this._timeout = options.timeout;
        this._throwOnTimeout = options.throwOnTimeout === true;
        this._isPaused = options.autoStart === false;
    }
    get _doesIntervalAllowAnother() {
        return this._isIntervalIgnored || this._intervalCount < this._intervalCap;
    }
    get _doesConcurrentAllowAnother() {
        return this._pendingCount < this._concurrency;
    }
    _next() {
        this._pendingCount--;
        this._tryToStartAnother();
        this.emit('next');
    }
    _resolvePromises() {
        this._resolveEmpty();
        this._resolveEmpty = empty;
        if (this._pendingCount === 0) {
            this._resolveIdle();
            this._resolveIdle = empty;
            this.emit('idle');
        }
    }
    _onResumeInterval() {
        this._onInterval();
        this._initializeIntervalIfNeeded();
        this._timeoutId = undefined;
    }
    _isIntervalPaused() {
        const now = Date.now();
        if (this._intervalId === undefined) {
            const delay = this._intervalEnd - now;
            if (delay < 0) // Act as the interval was done
            // We don't need to resume it here because it will be resumed on line 160
            this._intervalCount = this._carryoverConcurrencyCount ? this._pendingCount : 0;
            else {
                // Act as the interval is pending
                if (this._timeoutId === undefined) this._timeoutId = setTimeout(()=>{
                    this._onResumeInterval();
                }, delay);
                return true;
            }
        }
        return false;
    }
    _tryToStartAnother() {
        if (this._queue.size === 0) {
            // We can clear the interval ("pause")
            // Because we can redo it later ("resume")
            if (this._intervalId) clearInterval(this._intervalId);
            this._intervalId = undefined;
            this._resolvePromises();
            return false;
        }
        if (!this._isPaused) {
            const canInitializeInterval = !this._isIntervalPaused();
            if (this._doesIntervalAllowAnother && this._doesConcurrentAllowAnother) {
                const job = this._queue.dequeue();
                if (!job) return false;
                this.emit('active');
                job();
                if (canInitializeInterval) this._initializeIntervalIfNeeded();
                return true;
            }
        }
        return false;
    }
    _initializeIntervalIfNeeded() {
        if (this._isIntervalIgnored || this._intervalId !== undefined) return;
        this._intervalId = setInterval(()=>{
            this._onInterval();
        }, this._interval);
        this._intervalEnd = Date.now() + this._interval;
    }
    _onInterval() {
        if (this._intervalCount === 0 && this._pendingCount === 0 && this._intervalId) {
            clearInterval(this._intervalId);
            this._intervalId = undefined;
        }
        this._intervalCount = this._carryoverConcurrencyCount ? this._pendingCount : 0;
        this._processQueue();
    }
    /**
    Executes all queued functions until it reaches the limit.
    */ _processQueue() {
        // eslint-disable-next-line no-empty
        while(this._tryToStartAnother());
    }
    get concurrency() {
        return this._concurrency;
    }
    set concurrency(newConcurrency) {
        if (!(typeof newConcurrency === 'number' && newConcurrency >= 1)) throw new TypeError(`Expected \`concurrency\` to be a number from 1 and up, got \`${newConcurrency}\` (${typeof newConcurrency})`);
        this._concurrency = newConcurrency;
        this._processQueue();
    }
    /**
    Adds a sync or async task to the queue. Always returns a promise.
    */ async add(fn, options = {}) {
        return new Promise((resolve, reject)=>{
            const run = async ()=>{
                this._pendingCount++;
                this._intervalCount++;
                try {
                    const operation = this._timeout === undefined && options.timeout === undefined ? fn() : p_timeout_1.default(Promise.resolve(fn()), options.timeout === undefined ? this._timeout : options.timeout, ()=>{
                        if (options.throwOnTimeout === undefined ? this._throwOnTimeout : options.throwOnTimeout) reject(timeoutError);
                        return undefined;
                    });
                    resolve(await operation);
                } catch (error) {
                    reject(error);
                }
                this._next();
            };
            this._queue.enqueue(run, options);
            this._tryToStartAnother();
            this.emit('add');
        });
    }
    /**
    Same as `.add()`, but accepts an array of sync or async functions.

    @returns A promise that resolves when all functions are resolved.
    */ async addAll(functions, options) {
        return Promise.all(functions.map(async (function_)=>this.add(function_, options)));
    }
    /**
    Start (or resume) executing enqueued tasks within concurrency limit. No need to call this if queue is not paused (via `options.autoStart = false` or by `.pause()` method.)
    */ start() {
        if (!this._isPaused) return this;
        this._isPaused = false;
        this._processQueue();
        return this;
    }
    /**
    Put queue execution on hold.
    */ pause() {
        this._isPaused = true;
    }
    /**
    Clear the queue.
    */ clear() {
        this._queue = new this._queueClass();
    }
    /**
    Can be called multiple times. Useful if you for example add additional items at a later time.

    @returns A promise that settles when the queue becomes empty.
    */ async onEmpty() {
        // Instantly resolve if the queue is empty
        if (this._queue.size === 0) return;
        return new Promise((resolve)=>{
            const existingResolve = this._resolveEmpty;
            this._resolveEmpty = ()=>{
                existingResolve();
                resolve();
            };
        });
    }
    /**
    The difference with `.onEmpty` is that `.onIdle` guarantees that all work from the queue has finished. `.onEmpty` merely signals that the queue is empty, but it could mean that some promises haven't completed yet.

    @returns A promise that settles when the queue becomes empty, and all promises have completed; `queue.size === 0 && queue.pending === 0`.
    */ async onIdle() {
        // Instantly resolve if none pending and if nothing else is queued
        if (this._pendingCount === 0 && this._queue.size === 0) return;
        return new Promise((resolve)=>{
            const existingResolve = this._resolveIdle;
            this._resolveIdle = ()=>{
                existingResolve();
                resolve();
            };
        });
    }
    /**
    Size of the queue.
    */ get size() {
        return this._queue.size;
    }
    /**
    Size of the queue, filtered by the given options.

    For example, this can be used to find the number of items remaining in the queue with a specific priority level.
    */ sizeBy(options) {
        // eslint-disable-next-line unicorn/no-fn-reference-in-iterator
        return this._queue.filter(options).length;
    }
    /**
    Number of pending promises.
    */ get pending() {
        return this._pendingCount;
    }
    /**
    Whether the queue is currently paused.
    */ get isPaused() {
        return this._isPaused;
    }
    get timeout() {
        return this._timeout;
    }
    /**
    Set the timeout for future operations.
    */ set timeout(milliseconds) {
        this._timeout = milliseconds;
    }
}
exports.default = PQueue;

},{"a178093eea54aebd":"6xgnM","d219d890bb7e8882":"h6iIL","4a792a8cd58e20a7":"bZAP7"}],"6xgnM":[function(require,module,exports,__globalThis) {
'use strict';
var has = Object.prototype.hasOwnProperty, prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"h6iIL":[function(require,module,exports,__globalThis) {
'use strict';
const pFinally = require("ed36938359c1cb6b");
class TimeoutError extends Error {
    constructor(message){
        super(message);
        this.name = 'TimeoutError';
    }
}
const pTimeout = (promise, milliseconds, fallback)=>new Promise((resolve, reject)=>{
        if (typeof milliseconds !== 'number' || milliseconds < 0) throw new TypeError('Expected `milliseconds` to be a positive number');
        if (milliseconds === Infinity) {
            resolve(promise);
            return;
        }
        const timer = setTimeout(()=>{
            if (typeof fallback === 'function') {
                try {
                    resolve(fallback());
                } catch (error) {
                    reject(error);
                }
                return;
            }
            const message = typeof fallback === 'string' ? fallback : `Promise timed out after ${milliseconds} milliseconds`;
            const timeoutError = fallback instanceof Error ? fallback : new TimeoutError(message);
            if (typeof promise.cancel === 'function') promise.cancel();
            reject(timeoutError);
        }, milliseconds);
        // TODO: Use native `finally` keyword when targeting Node.js 10
        pFinally(// eslint-disable-next-line promise/prefer-await-to-then
        promise.then(resolve, reject), ()=>{
            clearTimeout(timer);
        });
    });
module.exports = pTimeout;
// TODO: Remove this for the next major release
module.exports.default = pTimeout;
module.exports.TimeoutError = TimeoutError;

},{"ed36938359c1cb6b":"4fRUj"}],"4fRUj":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = (promise, onFinally)=>{
    onFinally = onFinally || (()=>{});
    return promise.then((val)=>new Promise((resolve)=>{
            resolve(onFinally());
        }).then(()=>val), (err)=>new Promise((resolve)=>{
            resolve(onFinally());
        }).then(()=>{
            throw err;
        }));
};

},{}],"bZAP7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const lower_bound_1 = require("9ebe1cec8dfae466");
class PriorityQueue {
    constructor(){
        this._queue = [];
    }
    enqueue(run, options) {
        options = Object.assign({
            priority: 0
        }, options);
        const element = {
            priority: options.priority,
            run
        };
        if (this.size && this._queue[this.size - 1].priority >= options.priority) {
            this._queue.push(element);
            return;
        }
        const index = lower_bound_1.default(this._queue, element, (a, b)=>b.priority - a.priority);
        this._queue.splice(index, 0, element);
    }
    dequeue() {
        const item = this._queue.shift();
        return item === null || item === void 0 ? void 0 : item.run;
    }
    filter(options) {
        return this._queue.filter((element)=>element.priority === options.priority).map((element)=>element.run);
    }
    get size() {
        return this._queue.length;
    }
}
exports.default = PriorityQueue;

},{"9ebe1cec8dfae466":"7qG79"}],"7qG79":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
// Port of lower_bound from https://en.cppreference.com/w/cpp/algorithm/lower_bound
// Used to compute insertion index to keep queue sorted after insertion
function lowerBound(array, value, comparator) {
    let first = 0;
    let count = array.length;
    while(count > 0){
        const step = count / 2 | 0;
        let it = first + step;
        if (comparator(array[it], value) <= 0) {
            first = ++it;
            count -= step + 1;
        } else count = step;
    }
    return first;
}
exports.default = lowerBound;

},{}],"5gYkK":[function(require,module,exports,__globalThis) {
// Wrap the default fetch call due to issues with illegal invocations
// in some environments:
// https://stackoverflow.com/questions/69876859/why-does-bind-fix-failed-to-execute-fetch-on-window-illegal-invocation-err
// @ts-expect-error Broad typing to support a range of fetch implementations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overrideFetchImplementation", ()=>overrideFetchImplementation);
parcelHelpers.export(exports, "_getFetchImplementation", ()=>_getFetchImplementation);
const DEFAULT_FETCH_IMPLEMENTATION = (...args)=>fetch(...args);
const LANGSMITH_FETCH_IMPLEMENTATION_KEY = Symbol.for("ls:fetch_implementation");
const overrideFetchImplementation = (fetch1)=>{
    globalThis[LANGSMITH_FETCH_IMPLEMENTATION_KEY] = fetch1;
};
const _getFetchImplementation = ()=>{
    return globalThis[LANGSMITH_FETCH_IMPLEMENTATION_KEY] ?? DEFAULT_FETCH_IMPLEMENTATION;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8ZusB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isLangChainMessage", ()=>isLangChainMessage);
parcelHelpers.export(exports, "convertLangChainMessageToExample", ()=>convertLangChainMessageToExample);
function isLangChainMessage(// eslint-disable-next-line @typescript-eslint/no-explicit-any
message) {
    return typeof message?._getType === "function";
}
function convertLangChainMessageToExample(message) {
    const converted = {
        type: message._getType(),
        data: {
            content: message.content
        }
    };
    // Check for presence of keys in additional_kwargs
    if (message?.additional_kwargs && Object.keys(message.additional_kwargs).length > 0) converted.data.additional_kwargs = {
        ...message.additional_kwargs
    };
    return converted;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"14Ewv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assertUuid", ()=>assertUuid);
var _uuid = require("uuid");
function assertUuid(str, which) {
    if (!_uuid.validate(str)) {
        const msg = which !== undefined ? `Invalid UUID for ${which}: ${str}` : `Invalid UUID: ${str}`;
        throw new Error(msg);
    }
    return str;
}

},{"uuid":"klst7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4roK2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warnOnce", ()=>warnOnce);
const warnedMessages = {};
function warnOnce(message) {
    if (!warnedMessages[message]) {
        console.warn(message);
        warnedMessages[message] = true;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"61D0Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isVersionGreaterOrEqual", ()=>isVersionGreaterOrEqual);
parcelHelpers.export(exports, "parsePromptIdentifier", ()=>parsePromptIdentifier);
var _semver = require("semver");
function isVersionGreaterOrEqual(current_version, target_version) {
    const current = (0, _semver.parse)(current_version);
    const target = (0, _semver.parse)(target_version);
    if (!current || !target) throw new Error("Invalid version format.");
    return current.compare(target) >= 0;
}
function parsePromptIdentifier(identifier) {
    if (!identifier || identifier.split("/").length > 2 || identifier.startsWith("/") || identifier.endsWith("/") || identifier.split(":").length > 2) throw new Error(`Invalid identifier format: ${identifier}`);
    const [ownerNamePart, commitPart] = identifier.split(":");
    const commit = commitPart || "latest";
    if (ownerNamePart.includes("/")) {
        const [owner, name] = ownerNamePart.split("/", 2);
        if (!owner || !name) throw new Error(`Invalid identifier format: ${identifier}`);
        return [
            owner,
            name,
            commit
        ];
    } else {
        if (!ownerNamePart) throw new Error(`Invalid identifier format: ${identifier}`);
        return [
            "-",
            ownerNamePart,
            commit
        ];
    }
}

},{"semver":"6irQz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6irQz":[function(require,module,exports,__globalThis) {
// just pre-load all the stuff that index.js lazily exports
const internalRe = require("2ef367e729437dbf");
const constants = require("15796d6f714ec7ac");
const SemVer = require("784948b06600d9b2");
const identifiers = require("70f963db887a798c");
const parse = require("3f445ade66470b21");
const valid = require("f44378b7de87a0b4");
const clean = require("7742c78cf22bae39");
const inc = require("a751dd1df28d6bbb");
const diff = require("e000803318fe9f2f");
const major = require("d290038a9a954b0a");
const minor = require("c5e4bbab325a5aae");
const patch = require("5c0bb8d32de60bb3");
const prerelease = require("323f12e5af5ebd1e");
const compare = require("29cf114a56181e64");
const rcompare = require("827db0815bb2f2cd");
const compareLoose = require("b644f26560ec8124");
const compareBuild = require("606d0e43dd66a24c");
const sort = require("1560ed361cfa42e6");
const rsort = require("f9e1f00918a8cfd7");
const gt = require("3694a9720f15d6ac");
const lt = require("4559dbda8a777185");
const eq = require("14a4b88a0b1fd3a5");
const neq = require("416d9b63c3df2ead");
const gte = require("d39630b19344a843");
const lte = require("3fb74c9a41c1cef6");
const cmp = require("3435ca1bbec7b99");
const coerce = require("d67409238c8fc031");
const Comparator = require("1d07035d00450bca");
const Range = require("b280ab3e26924ac1");
const satisfies = require("ba9d0d2a3e49b569");
const toComparators = require("e6b2802b2233287d");
const maxSatisfying = require("2bfdfb0adcbcb71b");
const minSatisfying = require("264df1ba0d261fad");
const minVersion = require("cd4980125683761f");
const validRange = require("a0319a4a98954087");
const outside = require("fc457e2bda4345b2");
const gtr = require("c885d2b556186a1a");
const ltr = require("58740c779f187b15");
const intersects = require("22421cf146448c92");
const simplifyRange = require("439ddbc649d6486");
const subset = require("f1e57a2c808f532d");
module.exports = {
    parse,
    valid,
    clean,
    inc,
    diff,
    major,
    minor,
    patch,
    prerelease,
    compare,
    rcompare,
    compareLoose,
    compareBuild,
    sort,
    rsort,
    gt,
    lt,
    eq,
    neq,
    gte,
    lte,
    cmp,
    coerce,
    Comparator,
    Range,
    satisfies,
    toComparators,
    maxSatisfying,
    minSatisfying,
    minVersion,
    validRange,
    outside,
    gtr,
    ltr,
    intersects,
    simplifyRange,
    subset,
    SemVer,
    re: internalRe.re,
    src: internalRe.src,
    tokens: internalRe.t,
    SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: constants.RELEASE_TYPES,
    compareIdentifiers: identifiers.compareIdentifiers,
    rcompareIdentifiers: identifiers.rcompareIdentifiers
};

},{"2ef367e729437dbf":"cVnFX","15796d6f714ec7ac":"bNg4X","784948b06600d9b2":"iExt4","70f963db887a798c":"fDw4D","3f445ade66470b21":"1Qia3","f44378b7de87a0b4":"foN7W","7742c78cf22bae39":"7poie","a751dd1df28d6bbb":"eLge8","e000803318fe9f2f":"fZf4a","d290038a9a954b0a":"aSoIo","c5e4bbab325a5aae":"dyL3Q","5c0bb8d32de60bb3":"k9uI8","323f12e5af5ebd1e":"jq92Y","29cf114a56181e64":"92MOU","827db0815bb2f2cd":"5AgOR","b644f26560ec8124":"7rJwR","606d0e43dd66a24c":"btW3m","1560ed361cfa42e6":"aYtcl","f9e1f00918a8cfd7":"7sJr5","3694a9720f15d6ac":"gliBF","4559dbda8a777185":"9DD6G","14a4b88a0b1fd3a5":"ka2Wz","416d9b63c3df2ead":"iHDMI","d39630b19344a843":"dV9pE","3fb74c9a41c1cef6":"4fM6f","3435ca1bbec7b99":"fNMWv","d67409238c8fc031":"aWc2O","1d07035d00450bca":"3U5ZJ","b280ab3e26924ac1":"fDrqB","ba9d0d2a3e49b569":"jo0r0","e6b2802b2233287d":"4tsEI","2bfdfb0adcbcb71b":"dYRRa","264df1ba0d261fad":"ioX9g","cd4980125683761f":"3LeuK","a0319a4a98954087":"7Mu8O","fc457e2bda4345b2":"3w3SZ","c885d2b556186a1a":"76jue","58740c779f187b15":"cliOw","22421cf146448c92":"it6iY","439ddbc649d6486":"fKGoS","f1e57a2c808f532d":"a2UoK"}],"cVnFX":[function(require,module,exports,__globalThis) {
const { MAX_SAFE_COMPONENT_LENGTH, MAX_SAFE_BUILD_LENGTH, MAX_LENGTH } = require("9328c2484f003df4");
const debug = require("9075cfb365332427");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = '[a-zA-Z0-9-]';
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        '\\s',
        1
    ],
    [
        '\\d',
        MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    debug(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? 'g' : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
createToken('NUMERICIDENTIFIERLOOSE', '\\d+');
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken('NONNUMERICIDENTIFIER', `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken('MAINVERSION', `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken('MAINVERSIONLOOSE', `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken('PRERELEASEIDENTIFIER', `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken('PRERELEASEIDENTIFIERLOOSE', `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken('PRERELEASE', `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken('PRERELEASELOOSE', `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken('BUILDIDENTIFIER', `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken('BUILD', `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken('FULLPLAIN', `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken('FULL', `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken('LOOSEPLAIN', `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken('LOOSE', `^${src[t.LOOSEPLAIN]}$`);
createToken('GTLT', '((?:<|>)?=?)');
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken('XRANGEIDENTIFIERLOOSE', `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken('XRANGEIDENTIFIER', `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken('XRANGEPLAIN', `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGEPLAINLOOSE', `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken('XRANGELOOSE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken('COERCEPLAIN', `${"(^|[^\\d])(\\d{1,"}${MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?`);
createToken('COERCE', `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
createToken('COERCEFULL', src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
createToken('COERCERTL', src[t.COERCE], true);
createToken('COERCERTLFULL', src[t.COERCEFULL], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken('LONETILDE', '(?:~>?)');
createToken('TILDETRIM', `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = '$1~';
createToken('TILDE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken('TILDELOOSE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken('LONECARET', '(?:\\^)');
createToken('CARETTRIM', `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = '$1^';
createToken('CARET', `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken('CARETLOOSE', `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken('COMPARATORLOOSE', `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken('COMPARATOR', `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken('COMPARATORTRIM', `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = '$1$2$3';
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken('HYPHENRANGE', `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken('HYPHENRANGELOOSE', `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken('STAR', '(<|>)?=?\\s*\\*');
// >=0.0.0 is like a star
createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$');

},{"9328c2484f003df4":"bNg4X","9075cfb365332427":"aGeZH"}],"bNg4X":[function(require,module,exports,__globalThis) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const SEMVER_SPEC_VERSION = '2.0.0';
const MAX_LENGTH = 256;
const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
const RELEASE_TYPES = [
    'major',
    'premajor',
    'minor',
    'preminor',
    'patch',
    'prepatch',
    'prerelease'
];
module.exports = {
    MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER,
    RELEASE_TYPES,
    SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

},{}],"aGeZH":[function(require,module,exports,__globalThis) {
var process = require("3e9ec50def946db3");
const debug = (typeof process === 'object' && process.env && undefined, ()=>{});
module.exports = debug;

},{"3e9ec50def946db3":"5QIF0"}],"iExt4":[function(require,module,exports,__globalThis) {
const debug = require("595c172e7d863d06");
const { MAX_LENGTH, MAX_SAFE_INTEGER } = require("bd8d57fbca62978a");
const { safeRe: re, t } = require("2b364a26e67d9817");
const parseOptions = require("f1a723539d6cc9b5");
const { compareIdentifiers } = require("2451a15946a38fcd");
class SemVer {
    constructor(version, options){
        options = parseOptions(options);
        if (version instanceof SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== 'string') throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > MAX_LENGTH) throw new TypeError(`version is longer than ${MAX_LENGTH} characters`);
        debug('SemVer', version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? re[t.LOOSE] : re[t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
        if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
        if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split('.').map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split('.') : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join('.')}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        debug('SemVer.compare', this.version, this.options, other);
        if (!(other instanceof SemVer)) {
            if (typeof other === 'string' && other === this.version) return 0;
            other = new SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            debug('prerelease compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            debug('build compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        switch(release){
            case 'premajor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'preminor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'prepatch':
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case 'prerelease':
                if (this.prerelease.length === 0) this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            case 'major':
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'minor':
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'patch':
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case 'pre':
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (!identifier && identifierBase === false) throw new Error('invalid increment argument: identifier is empty');
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join('.') && identifierBase === false) throw new Error('invalid increment argument: identifier already exists');
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if (compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join('.')}`;
        return this;
    }
}
module.exports = SemVer;

},{"595c172e7d863d06":"aGeZH","bd8d57fbca62978a":"bNg4X","2b364a26e67d9817":"cVnFX","f1a723539d6cc9b5":"5bhlH","2451a15946a38fcd":"fDw4D"}],"5bhlH":[function(require,module,exports,__globalThis) {
// parse out just the options we care about
const looseOption = Object.freeze({
    loose: true
});
const emptyOpts = Object.freeze({});
const parseOptions = (options)=>{
    if (!options) return emptyOpts;
    if (typeof options !== 'object') return looseOption;
    return options;
};
module.exports = parseOptions;

},{}],"fDw4D":[function(require,module,exports,__globalThis) {
const numeric = /^[0-9]+$/;
const compareIdentifiers = (a, b)=>{
    const anum = numeric.test(a);
    const bnum = numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const rcompareIdentifiers = (a, b)=>compareIdentifiers(b, a);
module.exports = {
    compareIdentifiers,
    rcompareIdentifiers
};

},{}],"1Qia3":[function(require,module,exports,__globalThis) {
const SemVer = require("575e97778d3944c0");
const parse = (version, options, throwErrors = false)=>{
    if (version instanceof SemVer) return version;
    try {
        return new SemVer(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
module.exports = parse;

},{"575e97778d3944c0":"iExt4"}],"foN7W":[function(require,module,exports,__globalThis) {
const parse = require("6a6e19c11f3ced24");
const valid = (version, options)=>{
    const v = parse(version, options);
    return v ? v.version : null;
};
module.exports = valid;

},{"6a6e19c11f3ced24":"1Qia3"}],"7poie":[function(require,module,exports,__globalThis) {
const parse = require("661ff2c6ff41830b");
const clean = (version, options)=>{
    const s = parse(version.trim().replace(/^[=v]+/, ''), options);
    return s ? s.version : null;
};
module.exports = clean;

},{"661ff2c6ff41830b":"1Qia3"}],"eLge8":[function(require,module,exports,__globalThis) {
const SemVer = require("9a4ed023da196604");
const inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === 'string') {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new SemVer(version instanceof SemVer ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
module.exports = inc;

},{"9a4ed023da196604":"iExt4"}],"fZf4a":[function(require,module,exports,__globalThis) {
const parse = require("3b6d0e3ec696b30a");
const diff = (version1, version2)=>{
    const v1 = parse(version1, null, true);
    const v2 = parse(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return 'major';
        // Otherwise it can be determined by checking the high version
        if (highVersion.patch) // anything higher than a patch bump would result in the wrong version
        return 'patch';
        if (highVersion.minor) // anything higher than a minor bump would result in the wrong version
        return 'minor';
        // bumping major/minor/patch all have same result
        return 'major';
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? 'pre' : '';
    if (v1.major !== v2.major) return prefix + 'major';
    if (v1.minor !== v2.minor) return prefix + 'minor';
    if (v1.patch !== v2.patch) return prefix + 'patch';
    // high and low are preleases
    return 'prerelease';
};
module.exports = diff;

},{"3b6d0e3ec696b30a":"1Qia3"}],"aSoIo":[function(require,module,exports,__globalThis) {
const SemVer = require("53a097ab5c27a647");
const major = (a, loose)=>new SemVer(a, loose).major;
module.exports = major;

},{"53a097ab5c27a647":"iExt4"}],"dyL3Q":[function(require,module,exports,__globalThis) {
const SemVer = require("f130a90acb01ac10");
const minor = (a, loose)=>new SemVer(a, loose).minor;
module.exports = minor;

},{"f130a90acb01ac10":"iExt4"}],"k9uI8":[function(require,module,exports,__globalThis) {
const SemVer = require("54b9ac3bbdf83b31");
const patch = (a, loose)=>new SemVer(a, loose).patch;
module.exports = patch;

},{"54b9ac3bbdf83b31":"iExt4"}],"jq92Y":[function(require,module,exports,__globalThis) {
const parse = require("ff5ab55da1933db3");
const prerelease = (version, options)=>{
    const parsed = parse(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
module.exports = prerelease;

},{"ff5ab55da1933db3":"1Qia3"}],"92MOU":[function(require,module,exports,__globalThis) {
const SemVer = require("f16c9f4397244ee0");
const compare = (a, b, loose)=>new SemVer(a, loose).compare(new SemVer(b, loose));
module.exports = compare;

},{"f16c9f4397244ee0":"iExt4"}],"5AgOR":[function(require,module,exports,__globalThis) {
const compare = require("4bfcc14a9711a47b");
const rcompare = (a, b, loose)=>compare(b, a, loose);
module.exports = rcompare;

},{"4bfcc14a9711a47b":"92MOU"}],"7rJwR":[function(require,module,exports,__globalThis) {
const compare = require("95c8404dc369c13b");
const compareLoose = (a, b)=>compare(a, b, true);
module.exports = compareLoose;

},{"95c8404dc369c13b":"92MOU"}],"btW3m":[function(require,module,exports,__globalThis) {
const SemVer = require("3659675d95d38f3");
const compareBuild = (a, b, loose)=>{
    const versionA = new SemVer(a, loose);
    const versionB = new SemVer(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
module.exports = compareBuild;

},{"3659675d95d38f3":"iExt4"}],"aYtcl":[function(require,module,exports,__globalThis) {
const compareBuild = require("7c22e552e691e157");
const sort = (list, loose)=>list.sort((a, b)=>compareBuild(a, b, loose));
module.exports = sort;

},{"7c22e552e691e157":"btW3m"}],"7sJr5":[function(require,module,exports,__globalThis) {
const compareBuild = require("468f4992c854a69a");
const rsort = (list, loose)=>list.sort((a, b)=>compareBuild(b, a, loose));
module.exports = rsort;

},{"468f4992c854a69a":"btW3m"}],"gliBF":[function(require,module,exports,__globalThis) {
const compare = require("85515ef2889f4f89");
const gt = (a, b, loose)=>compare(a, b, loose) > 0;
module.exports = gt;

},{"85515ef2889f4f89":"92MOU"}],"9DD6G":[function(require,module,exports,__globalThis) {
const compare = require("9d2d7734c37f90e6");
const lt = (a, b, loose)=>compare(a, b, loose) < 0;
module.exports = lt;

},{"9d2d7734c37f90e6":"92MOU"}],"ka2Wz":[function(require,module,exports,__globalThis) {
const compare = require("d6abf8ed12ec38c1");
const eq = (a, b, loose)=>compare(a, b, loose) === 0;
module.exports = eq;

},{"d6abf8ed12ec38c1":"92MOU"}],"iHDMI":[function(require,module,exports,__globalThis) {
const compare = require("5232df27c4c4faa9");
const neq = (a, b, loose)=>compare(a, b, loose) !== 0;
module.exports = neq;

},{"5232df27c4c4faa9":"92MOU"}],"dV9pE":[function(require,module,exports,__globalThis) {
const compare = require("9183f7fbecba58ae");
const gte = (a, b, loose)=>compare(a, b, loose) >= 0;
module.exports = gte;

},{"9183f7fbecba58ae":"92MOU"}],"4fM6f":[function(require,module,exports,__globalThis) {
const compare = require("e55eadc974580af5");
const lte = (a, b, loose)=>compare(a, b, loose) <= 0;
module.exports = lte;

},{"e55eadc974580af5":"92MOU"}],"fNMWv":[function(require,module,exports,__globalThis) {
const eq = require("bff7f16298b8dbaa");
const neq = require("6a1bb69c2d499261");
const gt = require("dca4b9c05150a919");
const gte = require("7b5dc70556970d6c");
const lt = require("a3a3bcc6e4d6bbdf");
const lte = require("5f1835ee4d0596f3");
const cmp = (a, op, b, loose)=>{
    switch(op){
        case '===':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a === b;
        case '!==':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a !== b;
        case '':
        case '=':
        case '==':
            return eq(a, b, loose);
        case '!=':
            return neq(a, b, loose);
        case '>':
            return gt(a, b, loose);
        case '>=':
            return gte(a, b, loose);
        case '<':
            return lt(a, b, loose);
        case '<=':
            return lte(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
module.exports = cmp;

},{"bff7f16298b8dbaa":"ka2Wz","6a1bb69c2d499261":"iHDMI","dca4b9c05150a919":"gliBF","7b5dc70556970d6c":"dV9pE","a3a3bcc6e4d6bbdf":"9DD6G","5f1835ee4d0596f3":"4fM6f"}],"aWc2O":[function(require,module,exports,__globalThis) {
const SemVer = require("25529d97ade3ccdf");
const parse = require("90724e3140f56906");
const { safeRe: re, t } = require("49971e907f1359e9");
const coerce = (version, options)=>{
    if (version instanceof SemVer) return version;
    if (typeof version === 'number') version = String(version);
    if (typeof version !== 'string') return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(options.includePrerelease ? re[t.COERCEFULL] : re[t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        // With includePrerelease option set, '1.2.3.4-rc' wants to coerce '2.3.4-rc', not '2.3.4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        const coerceRtlRegex = options.includePrerelease ? re[t.COERCERTLFULL] : re[t.COERCERTL];
        let next;
        while((next = coerceRtlRegex.exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        coerceRtlRegex.lastIndex = -1;
    }
    if (match === null) return null;
    const major = match[2];
    const minor = match[3] || '0';
    const patch = match[4] || '0';
    const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : '';
    const build = options.includePrerelease && match[6] ? `+${match[6]}` : '';
    return parse(`${major}.${minor}.${patch}${prerelease}${build}`, options);
};
module.exports = coerce;

},{"25529d97ade3ccdf":"iExt4","90724e3140f56906":"1Qia3","49971e907f1359e9":"cVnFX"}],"3U5ZJ":[function(require,module,exports,__globalThis) {
const ANY = Symbol('SemVer ANY');
// hoisted class for cyclic dependency
class Comparator {
    static get ANY() {
        return ANY;
    }
    constructor(comp, options){
        options = parseOptions(options);
        if (comp instanceof Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(' ');
        debug('comparator', comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === ANY) this.value = '';
        else this.value = this.operator + this.semver.version;
        debug('comp', this);
    }
    parse(comp) {
        const r = this.options.loose ? re[t.COMPARATORLOOSE] : re[t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : '';
        if (this.operator === '=') this.operator = '';
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = ANY;
        else this.semver = new SemVer(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        debug('Comparator.test', version, this.options.loose);
        if (this.semver === ANY || version === ANY) return true;
        if (typeof version === 'string') try {
            version = new SemVer(version, this.options);
        } catch (er) {
            return false;
        }
        return cmp(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof Comparator)) throw new TypeError('a Comparator is required');
        if (this.operator === '') {
            if (this.value === '') return true;
            return new Range(comp.value, options).test(this.value);
        } else if (comp.operator === '') {
            if (comp.value === '') return true;
            return new Range(this.value, options).test(comp.semver);
        }
        options = parseOptions(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === '<0.0.0-0' || comp.value === '<0.0.0-0')) return false;
        if (!options.includePrerelease && (this.value.startsWith('<0.0.0') || comp.value.startsWith('<0.0.0'))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith('>') && comp.operator.startsWith('>')) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith('<') && comp.operator.startsWith('<')) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes('=') && comp.operator.includes('=')) return true;
        // opposite directions less than
        if (cmp(this.semver, '<', comp.semver, options) && this.operator.startsWith('>') && comp.operator.startsWith('<')) return true;
        // opposite directions greater than
        if (cmp(this.semver, '>', comp.semver, options) && this.operator.startsWith('<') && comp.operator.startsWith('>')) return true;
        return false;
    }
}
module.exports = Comparator;
const parseOptions = require("b6563e9809bd921f");
const { safeRe: re, t } = require("f844ee6695e23038");
const cmp = require("e62b495d112b67cb");
const debug = require("13b490d953a8241f");
const SemVer = require("f688b7fbae163ad8");
const Range = require("b8839ba12a91a5c9");

},{"b6563e9809bd921f":"5bhlH","f844ee6695e23038":"cVnFX","e62b495d112b67cb":"fNMWv","13b490d953a8241f":"aGeZH","f688b7fbae163ad8":"iExt4","b8839ba12a91a5c9":"fDrqB"}],"fDrqB":[function(require,module,exports,__globalThis) {
const SPACE_CHARACTERS = /\s+/g;
// hoisted class for cyclic dependency
class Range {
    constructor(range, options){
        options = parseOptions(options);
        if (range instanceof Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new Range(range.raw, options);
        }
        if (range instanceof Comparator) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.formatted = undefined;
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().replace(SPACE_CHARACTERS, ' ');
        // First, split on ||
        this.set = this.raw.split('||')// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.formatted = undefined;
    }
    get range() {
        if (this.formatted === undefined) {
            this.formatted = '';
            for(let i = 0; i < this.set.length; i++){
                if (i > 0) this.formatted += '||';
                const comps = this.set[i];
                for(let k = 0; k < comps.length; k++){
                    if (k > 0) this.formatted += ' ';
                    this.formatted += comps[k].toString().trim();
                }
            }
        }
        return this.formatted;
    }
    format() {
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && FLAG_INCLUDE_PRERELEASE) | (this.options.loose && FLAG_LOOSE);
        const memoKey = memoOpts + ':' + range;
        const cached = cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? re[t.HYPHENRANGELOOSE] : re[t.HYPHENRANGE];
        range = range.replace(hr, hyphenReplace(this.options.includePrerelease));
        debug('hyphen replace', range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace(re[t.COMPARATORTRIM], comparatorTrimReplace);
        debug('comparator trim', range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace(re[t.TILDETRIM], tildeTrimReplace);
        debug('tilde trim', range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace(re[t.CARETTRIM], caretTrimReplace);
        debug('caret trim', range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(' ').map((comp)=>parseComparator(comp, this.options)).join(' ').split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            debug('loose invalid filter', comp, this.options);
            return !!comp.match(re[t.COMPARATORLOOSE]);
        });
        debug('range list', rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new Comparator(comp, this.options));
        for (const comp of comparators){
            if (isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has('')) rangeMap.delete('');
        const result = [
            ...rangeMap.values()
        ];
        cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof Range)) throw new TypeError('a Range is required');
        return this.set.some((thisComparators)=>{
            return isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === 'string') try {
            version = new SemVer(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if (testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
module.exports = Range;
const LRU = require("96f33215aad25ada");
const cache = new LRU();
const parseOptions = require("17bb122b9b0740d9");
const Comparator = require("df9131adcc191f91");
const debug = require("1c7c6c8abfe9bd3b");
const SemVer = require("d77fd978650b507f");
const { safeRe: re, t, comparatorTrimReplace, tildeTrimReplace, caretTrimReplace } = require("9bd5ca5276add1c4");
const { FLAG_INCLUDE_PRERELEASE, FLAG_LOOSE } = require("8c8074dc7fc46964");
const isNullSet = (c)=>c.value === '<0.0.0-0';
const isAny = (c)=>c.value === '';
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const parseComparator = (comp, options)=>{
    debug('comp', comp, options);
    comp = replaceCarets(comp, options);
    debug('caret', comp);
    comp = replaceTildes(comp, options);
    debug('tildes', comp);
    comp = replaceXRanges(comp, options);
    debug('xrange', comp);
    comp = replaceStars(comp, options);
    debug('stars', comp);
    return comp;
};
const isX = (id)=>!id || id.toLowerCase() === 'x' || id === '*';
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>replaceTilde(c, options)).join(' ');
};
const replaceTilde = (comp, options)=>{
    const r = options.loose ? re[t.TILDELOOSE] : re[t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        debug('tilde', comp, _, M, m, p, pr);
        let ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            debug('replaceTilde pr', pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        debug('tilde return', ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>replaceCaret(c, options)).join(' ');
};
const replaceCaret = (comp, options)=>{
    debug('caret', comp, options);
    const r = options.loose ? re[t.CARETLOOSE] : re[t.CARET];
    const z = options.includePrerelease ? '-0' : '';
    return comp.replace(r, (_, M, m, p, pr)=>{
        debug('caret', comp, _, M, m, p, pr);
        let ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if (isX(p)) {
            if (M === '0') ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            debug('replaceCaret pr', pr);
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            debug('no pr');
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        debug('caret return', ret);
        return ret;
    });
};
const replaceXRanges = (comp, options)=>{
    debug('replaceXRanges', comp, options);
    return comp.split(/\s+/).map((c)=>replaceXRange(c, options)).join(' ');
};
const replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? re[t.XRANGELOOSE] : re[t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        debug('xRange', comp, ret, gtlt, M, m, p, pr);
        const xM = isX(M);
        const xm = xM || isX(m);
        const xp = xm || isX(p);
        const anyX = xp;
        if (gtlt === '=' && anyX) gtlt = '';
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? '-0' : '';
        if (xM) {
            if (gtlt === '>' || gtlt === '<') // nothing is allowed
            ret = '<0.0.0-0';
            else // nothing is forbidden
            ret = '*';
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === '>') {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = '>=';
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === '<=') {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = '<';
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === '<') pr = '-0';
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        debug('xRange return', ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const replaceStars = (comp, options)=>{
    debug('replaceStars', comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace(re[t.STAR], '');
};
const replaceGTE0 = (comp, options)=>{
    debug('replaceGTE0', comp, options);
    return comp.trim().replace(re[options.includePrerelease ? t.GTE0PRE : t.GTE0], '');
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
// TODO build?
const hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr)=>{
        if (isX(fM)) from = '';
        else if (isX(fm)) from = `>=${fM}.0.0${incPr ? '-0' : ''}`;
        else if (isX(fp)) from = `>=${fM}.${fm}.0${incPr ? '-0' : ''}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? '-0' : ''}`;
        if (isX(tM)) to = '';
        else if (isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if (isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            debug(set[i].semver);
            if (set[i].semver === Comparator.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};

},{"96f33215aad25ada":"9zk51","17bb122b9b0740d9":"5bhlH","df9131adcc191f91":"3U5ZJ","1c7c6c8abfe9bd3b":"aGeZH","d77fd978650b507f":"iExt4","9bd5ca5276add1c4":"cVnFX","8c8074dc7fc46964":"bNg4X"}],"9zk51":[function(require,module,exports,__globalThis) {
class LRUCache {
    constructor(){
        this.max = 1000;
        this.map = new Map();
    }
    get(key) {
        const value = this.map.get(key);
        if (value === undefined) return undefined;
        else {
            // Remove the key from the map and add it to the end
            this.map.delete(key);
            this.map.set(key, value);
            return value;
        }
    }
    delete(key) {
        return this.map.delete(key);
    }
    set(key, value) {
        const deleted = this.delete(key);
        if (!deleted && value !== undefined) {
            // If cache is full, delete the least recently used item
            if (this.map.size >= this.max) {
                const firstKey = this.map.keys().next().value;
                this.delete(firstKey);
            }
            this.map.set(key, value);
        }
        return this;
    }
}
module.exports = LRUCache;

},{}],"jo0r0":[function(require,module,exports,__globalThis) {
const Range = require("b60a47303a13d107");
const satisfies = (version, range, options)=>{
    try {
        range = new Range(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
module.exports = satisfies;

},{"b60a47303a13d107":"fDrqB"}],"4tsEI":[function(require,module,exports,__globalThis) {
const Range = require("f497be9904aac7c0");
// Mostly just for testing and legacy API reasons
const toComparators = (range, options)=>new Range(range, options).set.map((comp)=>comp.map((c)=>c.value).join(' ').trim().split(' '));
module.exports = toComparators;

},{"f497be9904aac7c0":"fDrqB"}],"dYRRa":[function(require,module,exports,__globalThis) {
const SemVer = require("96d622a81d57358d");
const Range = require("f2865e94142488ab");
const maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new SemVer(max, options);
            }
        }
    });
    return max;
};
module.exports = maxSatisfying;

},{"96d622a81d57358d":"iExt4","f2865e94142488ab":"fDrqB"}],"ioX9g":[function(require,module,exports,__globalThis) {
const SemVer = require("fea3851ba09d8834");
const Range = require("9d2799b098b5c4c7");
const minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new SemVer(min, options);
            }
        }
    });
    return min;
};
module.exports = minSatisfying;

},{"fea3851ba09d8834":"iExt4","9d2799b098b5c4c7":"fDrqB"}],"3LeuK":[function(require,module,exports,__globalThis) {
const SemVer = require("4c531b1d555da497");
const Range = require("76327127dc36ed58");
const gt = require("a5ac47b45ae8684c");
const minVersion = (range, loose)=>{
    range = new Range(range, loose);
    let minver = new SemVer('0.0.0');
    if (range.test(minver)) return minver;
    minver = new SemVer('0.0.0-0');
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new SemVer(comparator.semver.version);
            switch(comparator.operator){
                case '>':
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case '':
                case '>=':
                    if (!setMin || gt(compver, setMin)) setMin = compver;
                    break;
                case '<':
                case '<=':
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || gt(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
module.exports = minVersion;

},{"4c531b1d555da497":"iExt4","76327127dc36ed58":"fDrqB","a5ac47b45ae8684c":"gliBF"}],"7Mu8O":[function(require,module,exports,__globalThis) {
const Range = require("fd2c35053245b1fd");
const validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new Range(range, options).range || '*';
    } catch (er) {
        return null;
    }
};
module.exports = validRange;

},{"fd2c35053245b1fd":"fDrqB"}],"3w3SZ":[function(require,module,exports,__globalThis) {
const SemVer = require("65977c6c7fab41e0");
const Comparator = require("8b0890ac7a0294ed");
const { ANY } = Comparator;
const Range = require("9baad77301d611e2");
const satisfies = require("1a3d276234841886");
const gt = require("8f784c6ef2cd1972");
const lt = require("3c234e2ddd9db68a");
const lte = require("88893a74cd9f934");
const gte = require("6cccfcce37ef6329");
const outside = (version, range, hilo, options)=>{
    version = new SemVer(version, options);
    range = new Range(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case '>':
            gtfn = gt;
            ltefn = lte;
            ltfn = lt;
            comp = '>';
            ecomp = '>=';
            break;
        case '<':
            gtfn = lt;
            ltefn = gte;
            ltfn = gt;
            comp = '<';
            ecomp = '<=';
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if (satisfies(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === ANY) comparator = new Comparator('>=0.0.0');
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
module.exports = outside;

},{"65977c6c7fab41e0":"iExt4","8b0890ac7a0294ed":"3U5ZJ","9baad77301d611e2":"fDrqB","1a3d276234841886":"jo0r0","8f784c6ef2cd1972":"gliBF","3c234e2ddd9db68a":"9DD6G","88893a74cd9f934":"4fM6f","6cccfcce37ef6329":"dV9pE"}],"76jue":[function(require,module,exports,__globalThis) {
// Determine if version is greater than all the versions possible in the range.
const outside = require("be5e984e16e512b9");
const gtr = (version, range, options)=>outside(version, range, '>', options);
module.exports = gtr;

},{"be5e984e16e512b9":"3w3SZ"}],"cliOw":[function(require,module,exports,__globalThis) {
const outside = require("b7f00e21a32b75a5");
// Determine if version is less than all the versions possible in the range
const ltr = (version, range, options)=>outside(version, range, '<', options);
module.exports = ltr;

},{"b7f00e21a32b75a5":"3w3SZ"}],"it6iY":[function(require,module,exports,__globalThis) {
const Range = require("5205f80872e81710");
const intersects = (r1, r2, options)=>{
    r1 = new Range(r1, options);
    r2 = new Range(r2, options);
    return r1.intersects(r2, options);
};
module.exports = intersects;

},{"5205f80872e81710":"fDrqB"}],"fKGoS":[function(require,module,exports,__globalThis) {
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.
const satisfies = require("e72123f17434788");
const compare = require("3eb9817061c82995");
module.exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>compare(a, b, options));
    for (const version of v){
        const included = satisfies(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push('*');
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(' || ');
    const original = typeof range.raw === 'string' ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};

},{"e72123f17434788":"jo0r0","3eb9817061c82995":"92MOU"}],"a2UoK":[function(require,module,exports,__globalThis) {
const Range = require("c141b0432e6ae71b");
const Comparator = require("94bed966a1054073");
const { ANY } = Comparator;
const satisfies = require("acfaf6445a9794b");
const compare = require("d9ed82a69c119cf4");
// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new Range(sub, options);
    dom = new Range(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const minimumVersionWithPreRelease = [
    new Comparator('>=0.0.0-0')
];
const minimumVersion = [
    new Comparator('>=0.0.0')
];
const simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === ANY) {
        if (dom.length === 1 && dom[0].semver === ANY) return true;
        else if (options.includePrerelease) sub = minimumVersionWithPreRelease;
        else sub = minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === ANY) {
        if (options.includePrerelease) return true;
        else dom = minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === '>' || c.operator === '>=') gt = higherGT(gt, c, options);
        else if (c.operator === '<' || c.operator === '<=') lt = lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = compare(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== '>=' || lt.operator !== '<=')) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !satisfies(eq, String(gt), options)) return null;
        if (lt && !satisfies(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!satisfies(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === '<' && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === '>' || c.operator === '>=';
        hasDomLT = hasDomLT || c.operator === '<' || c.operator === '<=';
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === '>' || c.operator === '>=') {
                higher = higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === '>=' && !satisfies(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === '<' || c.operator === '<=') {
                lower = lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === '<=' && !satisfies(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = compare(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === '>' && a.operator === '>=' ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = compare(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === '<' && a.operator === '<=' ? b : a;
};
module.exports = subset;

},{"c141b0432e6ae71b":"fDrqB","94bed966a1054073":"3U5ZJ","acfaf6445a9794b":"jo0r0","d9ed82a69c119cf4":"92MOU"}],"tCvU8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "printErrorStackTrace", ()=>printErrorStackTrace);
/**
 * LangSmithConflictError
 *
 * Represents an error that occurs when there's a conflict during an operation,
 * typically corresponding to HTTP 409 status code responses.
 *
 * This error is thrown when an attempt to create or modify a resource conflicts
 * with the current state of the resource on the server. Common scenarios include:
 * - Attempting to create a resource that already exists
 * - Trying to update a resource that has been modified by another process
 * - Violating a uniqueness constraint in the data
 *
 * @extends Error
 *
 * @example
 * try {
 *   await createProject("existingProject");
 * } catch (error) {
 *   if (error instanceof ConflictError) {
 *     console.log("A conflict occurred:", error.message);
 *     // Handle the conflict, e.g., by suggesting a different project name
 *   } else {
 *     // Handle other types of errors
 *   }
 * }
 *
 * @property {string} name - Always set to 'ConflictError' for easy identification
 * @property {string} message - Detailed error message including server response
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/409
 */ parcelHelpers.export(exports, "LangSmithConflictError", ()=>LangSmithConflictError);
/**
 * Throws an appropriate error based on the response status and body.
 *
 * @param response - The fetch Response object
 * @param context - Additional context to include in the error message (e.g., operation being performed)
 * @throws {LangSmithConflictError} When the response status is 409
 * @throws {Error} For all other non-ok responses
 */ parcelHelpers.export(exports, "raiseForStatus", ()=>raiseForStatus);
function getErrorStackTrace(e) {
    if (typeof e !== "object" || e == null) return undefined;
    if (!("stack" in e) || typeof e.stack !== "string") return undefined;
    let stack = e.stack;
    const prevLine = `${e}`;
    if (stack.startsWith(prevLine)) stack = stack.slice(prevLine.length);
    if (stack.startsWith("\n")) stack = stack.slice(1);
    return stack;
}
function printErrorStackTrace(e) {
    const stack = getErrorStackTrace(e);
    if (stack == null) return;
    console.error(stack);
}
class LangSmithConflictError extends Error {
    constructor(message){
        super(message);
        this.name = "LangSmithConflictError";
    }
}
async function raiseForStatus(response, context, consume) {
    // consume the response body to release the connection
    // https://undici.nodejs.org/#/?id=garbage-collection
    let errorBody;
    if (response.ok) {
        if (consume) errorBody = await response.text();
        return;
    }
    errorBody = await response.text();
    const fullMessage = `Failed to ${context}. Received status [${response.status}]: ${response.statusText}. Server response: ${errorBody}`;
    if (response.status === 409) throw new LangSmithConflictError(fullMessage);
    throw new Error(fullMessage);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eHrZD":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Regular stringify
parcelHelpers.export(exports, "stringify", ()=>stringify);
var LIMIT_REPLACE_NODE = "[...]";
var CIRCULAR_REPLACE_NODE = {
    result: "[Circular]"
};
var arr = [];
var replacerStack = [];
function defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
function stringify(obj, replacer, spacer, options) {
    try {
        return JSON.stringify(obj, replacer, spacer);
    } catch (e) {
        // Fall back to more complex stringify if circular reference
        if (!e.message?.includes("Converting circular structure to JSON")) {
            console.warn("[WARNING]: LangSmith received unserializable value.");
            return "[Unserializable]";
        }
        console.warn("[WARNING]: LangSmith received circular JSON. This will decrease tracer performance.");
        if (typeof options === "undefined") options = defaultOptions();
        decirc(obj, "", 0, [], undefined, 0, options);
        var res;
        try {
            if (replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
            else res = JSON.stringify(obj, replaceGetterValues(replacer), spacer);
        } catch (_) {
            return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
        } finally{
            while(arr.length !== 0){
                var part = arr.pop();
                if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
                else part[0][part[1]] = part[2];
            }
        }
        return res;
    }
}
function setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        arr.push([
            parent,
            k,
            val
        ]);
    }
}
function decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            setReplace(CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = defaultOptions();
    var tmp = deterministicDecirc(obj, "", 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if (replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        // Ensure that we restore the object as it was.
        while(arr.length !== 0){
            var part = arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            setReplace(CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === "function") return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort(compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== "undefined") {
                arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function replaceGetterValues(replacer) {
    replacer = typeof replacer !== "undefined" ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if (replacerStack.length > 0) for(var i = 0; i < replacerStack.length; i++){
            var part = replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9TcpS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTracingEnabled", ()=>isTracingEnabled);
var _envJs = require("./utils/env.js");
const isTracingEnabled = (tracingEnabled)=>{
    if (tracingEnabled !== undefined) return tracingEnabled;
    const envVars = [
        "TRACING_V2",
        "TRACING"
    ];
    return !!envVars.find((envVar)=>(0, _envJs.getLangSmithEnvironmentVariable)(envVar) === "true");
};

},{"./utils/env.js":"dzGHq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"55M3D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_LC_CONTEXT_VARIABLES_KEY", ()=>_LC_CONTEXT_VARIABLES_KEY);
const _LC_CONTEXT_VARIABLES_KEY = Symbol.for("lc:context_variables");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7bXzs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _traceableJs = require("../dist/singletons/traceable.js");
parcelHelpers.exportAll(_traceableJs, exports);

},{"../dist/singletons/traceable.js":"83HDO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"83HDO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncLocalStorageProviderSingleton", ()=>AsyncLocalStorageProviderSingleton);
parcelHelpers.export(exports, "getCurrentRunTree", ()=>getCurrentRunTree);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "withRunTree", ()=>withRunTree);
parcelHelpers.export(exports, "ROOT", ()=>ROOT);
parcelHelpers.export(exports, "isTraceableFunction", ()=>isTraceableFunction);
var _runTreesJs = require("../run_trees.js");
class MockAsyncLocalStorage {
    getStore() {
        return undefined;
    }
    run(_, callback) {
        return callback();
    }
}
const TRACING_ALS_KEY = Symbol.for("ls:tracing_async_local_storage");
const mockAsyncLocalStorage = new MockAsyncLocalStorage();
class AsyncLocalStorageProvider {
    getInstance() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return globalThis[TRACING_ALS_KEY] ?? mockAsyncLocalStorage;
    }
    initializeGlobalInstance(instance) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (globalThis[TRACING_ALS_KEY] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        globalThis[TRACING_ALS_KEY] = instance;
    }
}
const AsyncLocalStorageProviderSingleton = new AsyncLocalStorageProvider();
const getCurrentRunTree = ()=>{
    const runTree = AsyncLocalStorageProviderSingleton.getInstance().getStore();
    if (!(0, _runTreesJs.isRunTree)(runTree)) throw new Error([
        "Could not get the current run tree.",
        "",
        "Please make sure you are calling this method within a traceable function or the tracing is enabled."
    ].join("\n"));
    return runTree;
};
function withRunTree(runTree, fn) {
    const storage = AsyncLocalStorageProviderSingleton.getInstance();
    return new Promise((resolve, reject)=>{
        storage.run(runTree, ()=>void Promise.resolve(fn()).then(resolve).catch(reject));
    });
}
const ROOT = Symbol.for("langsmith:traceable:root");
function isTraceableFunction(x) {
    return typeof x === "function" && "langsmith:traceable" in x;
}

},{"../run_trees.js":"7zAUE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8AOhE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultLangChainClientSingleton", ()=>getDefaultLangChainClientSingleton);
var _langsmith = require("langsmith");
var _envJs = require("../utils/env.js");
let client;
const getDefaultLangChainClientSingleton = ()=>{
    if (client === undefined) {
        const clientParams = (0, _envJs.getEnvironmentVariable)("LANGCHAIN_CALLBACKS_BACKGROUND") === "false" ? {
            // LangSmith has its own backgrounding system
            blockOnRootRunFinalization: true
        } : {};
        client = new (0, _langsmith.Client)(clientParams);
    }
    return client;
};

},{"langsmith":"kaE6w","../utils/env.js":"4GIQu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9XPYi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "awaitAllCallbacks", ()=>(0, _callbacksJs.awaitAllCallbacks));
parcelHelpers.export(exports, "consumeCallback", ()=>(0, _callbacksJs.consumeCallback));
var _callbacksJs = require("../singletons/callbacks.js");

},{"../singletons/callbacks.js":"5xehn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5xehn":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-explicit-any */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getQueue", ()=>getQueue);
/**
 * Consume a promise, either adding it to the queue or waiting for it to resolve
 * @param promiseFn Promise to consume
 * @param wait Whether to wait for the promise to resolve or resolve immediately
 */ parcelHelpers.export(exports, "consumeCallback", ()=>consumeCallback);
/**
 * Waits for all promises in the queue to resolve. If the queue is
 * undefined, it immediately resolves a promise.
 */ parcelHelpers.export(exports, "awaitAllCallbacks", ()=>awaitAllCallbacks);
var _pQueue = require("p-queue");
var _pQueueDefault = parcelHelpers.interopDefault(_pQueue);
var _globalsJs = require("./async_local_storage/globals.js");
let queue;
/**
 * Creates a queue using the p-queue library. The queue is configured to
 * auto-start and has a concurrency of 1, meaning it will process tasks
 * one at a time.
 */ function createQueue() {
    const PQueue = "default" in (0, _pQueueDefault.default) ? (0, _pQueueDefault.default).default : (0, _pQueueDefault.default);
    return new PQueue({
        autoStart: true,
        concurrency: 1
    });
}
function getQueue() {
    if (typeof queue === "undefined") queue = createQueue();
    return queue;
}
async function consumeCallback(promiseFn, wait) {
    if (wait === true) {
        // Clear config since callbacks are not part of the root run
        // Avoid using global singleton due to circuluar dependency issues
        if ((0, _globalsJs.getGlobalAsyncLocalStorageInstance)() !== undefined) await (0, _globalsJs.getGlobalAsyncLocalStorageInstance)().run(undefined, async ()=>promiseFn());
        else await promiseFn();
    } else {
        queue = getQueue();
        queue.add(async ()=>{
            if ((0, _globalsJs.getGlobalAsyncLocalStorageInstance)() !== undefined) await (0, _globalsJs.getGlobalAsyncLocalStorageInstance)().run(undefined, async ()=>promiseFn());
            else await promiseFn();
        });
    }
}
function awaitAllCallbacks() {
    return typeof queue !== "undefined" ? queue.onIdle() : Promise.resolve();
}

},{"p-queue":"5oyJ8","./async_local_storage/globals.js":"gyJG4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gyJG4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACING_ALS_KEY", ()=>TRACING_ALS_KEY);
parcelHelpers.export(exports, "setGlobalAsyncLocalStorageInstance", ()=>setGlobalAsyncLocalStorageInstance);
parcelHelpers.export(exports, "getGlobalAsyncLocalStorageInstance", ()=>getGlobalAsyncLocalStorageInstance);
const TRACING_ALS_KEY = Symbol.for("ls:tracing_async_local_storage");
const setGlobalAsyncLocalStorageInstance = (instance)=>{
    globalThis[TRACING_ALS_KEY] = instance;
};
const getGlobalAsyncLocalStorageInstance = ()=>{
    return globalThis[TRACING_ALS_KEY];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"57o33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTracingEnabled", ()=>isTracingEnabled);
var _envJs = require("./env.js");
const isTracingEnabled = (tracingEnabled)=>{
    if (tracingEnabled !== undefined) return tracingEnabled;
    const envVars = [
        "LANGSMITH_TRACING_V2",
        "LANGCHAIN_TRACING_V2",
        "LANGSMITH_TRACING",
        "LANGCHAIN_TRACING"
    ];
    return !!envVars.find((envVar)=>(0, _envJs.getEnvironmentVariable)(envVar) === "true");
};

},{"./env.js":"4GIQu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1yk1a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// TODO: Combine into one class for 0.2
/**
 * Base class for all chat message histories. All chat message histories
 * should extend this class.
 */ parcelHelpers.export(exports, "BaseChatMessageHistory", ()=>BaseChatMessageHistory);
/**
 * Base class for all list chat message histories. All list chat message
 * histories should extend this class.
 */ parcelHelpers.export(exports, "BaseListChatMessageHistory", ()=>BaseListChatMessageHistory);
/**
 * Class for storing chat message history in-memory. It extends the
 * BaseListChatMessageHistory class and provides methods to get, add, and
 * clear messages.
 */ parcelHelpers.export(exports, "InMemoryChatMessageHistory", ()=>InMemoryChatMessageHistory);
var _serializableJs = require("./load/serializable.js");
var _indexJs = require("./messages/index.js");
class BaseChatMessageHistory extends (0, _serializableJs.Serializable) {
    /**
     * Add a list of messages.
     *
     * Implementations should override this method to handle bulk addition of messages
     * in an efficient manner to avoid unnecessary round-trips to the underlying store.
     *
     * @param messages - A list of BaseMessage objects to store.
     */ async addMessages(messages) {
        for (const message of messages)await this.addMessage(message);
    }
}
class BaseListChatMessageHistory extends (0, _serializableJs.Serializable) {
    /**
     * This is a convenience method for adding a human message string to the store.
     * Please note that this is a convenience method. Code should favor the
     * bulk addMessages interface instead to save on round-trips to the underlying
     * persistence layer.
     * This method may be deprecated in a future release.
     */ addUserMessage(message) {
        return this.addMessage(new (0, _indexJs.HumanMessage)(message));
    }
    /** @deprecated Use addAIMessage instead */ addAIChatMessage(message) {
        return this.addMessage(new (0, _indexJs.AIMessage)(message));
    }
    /**
     * This is a convenience method for adding an AI message string to the store.
     * Please note that this is a convenience method. Code should favor the bulk
     * addMessages interface instead to save on round-trips to the underlying
     * persistence layer.
     * This method may be deprecated in a future release.
     */ addAIMessage(message) {
        return this.addMessage(new (0, _indexJs.AIMessage)(message));
    }
    /**
     * Add a list of messages.
     *
     * Implementations should override this method to handle bulk addition of messages
     * in an efficient manner to avoid unnecessary round-trips to the underlying store.
     *
     * @param messages - A list of BaseMessage objects to store.
     */ async addMessages(messages) {
        for (const message of messages)await this.addMessage(message);
    }
    /**
     * Remove all messages from the store.
     */ clear() {
        throw new Error("Not implemented.");
    }
}
class InMemoryChatMessageHistory extends BaseListChatMessageHistory {
    constructor(messages){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain",
                "stores",
                "message",
                "in_memory"
            ]
        });
        Object.defineProperty(this, "messages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        this.messages = messages ?? [];
    }
    /**
     * Method to get all the messages stored in the ChatMessageHistory
     * instance.
     * @returns Array of stored BaseMessage instances.
     */ async getMessages() {
        return this.messages;
    }
    /**
     * Method to add a new message to the ChatMessageHistory instance.
     * @param message The BaseMessage instance to add.
     * @returns A promise that resolves when the message has been added.
     */ async addMessage(message) {
        this.messages.push(message);
    }
    /**
     * Method to clear all the messages from the ChatMessageHistory instance.
     * @returns A promise that resolves when all messages have been cleared.
     */ async clear() {
        this.messages = [];
    }
}

},{"./load/serializable.js":"2n7FI","./messages/index.js":"7XzBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7XzBK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// TODO: Use a star export when we deprecate the
// existing "ToolCall" type in "base.js".
parcelHelpers.export(exports, "ToolMessage", ()=>(0, _toolJs.ToolMessage));
parcelHelpers.export(exports, "ToolMessageChunk", ()=>(0, _toolJs.ToolMessageChunk));
parcelHelpers.export(exports, "isToolMessage", ()=>(0, _toolJs.isToolMessage));
parcelHelpers.export(exports, "isToolMessageChunk", ()=>(0, _toolJs.isToolMessageChunk));
var _aiJs = require("./ai.js");
parcelHelpers.exportAll(_aiJs, exports);
var _baseJs = require("./base.js");
parcelHelpers.exportAll(_baseJs, exports);
var _chatJs = require("./chat.js");
parcelHelpers.exportAll(_chatJs, exports);
var _functionJs = require("./function.js");
parcelHelpers.exportAll(_functionJs, exports);
var _humanJs = require("./human.js");
parcelHelpers.exportAll(_humanJs, exports);
var _systemJs = require("./system.js");
parcelHelpers.exportAll(_systemJs, exports);
var _utilsJs = require("./utils.js");
parcelHelpers.exportAll(_utilsJs, exports);
var _transformersJs = require("./transformers.js");
parcelHelpers.exportAll(_transformersJs, exports);
var _modifierJs = require("./modifier.js");
parcelHelpers.exportAll(_modifierJs, exports);
var _toolJs = require("./tool.js");

},{"./ai.js":"lkFVb","./base.js":"bWcpl","./chat.js":"ih7Pn","./function.js":"bia1q","./human.js":"2YgBC","./system.js":"8i8IV","./utils.js":"6vi0n","./transformers.js":"fpkuj","./modifier.js":"96Qr0","./tool.js":"04Rfb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fpkuj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterMessages", ()=>filterMessages);
parcelHelpers.export(exports, "mergeMessageRuns", ()=>mergeMessageRuns);
parcelHelpers.export(exports, "trimMessages", ()=>trimMessages);
/**
 * The default text splitter function that splits text by newlines.
 *
 * @param {string} text
 * @returns A promise that resolves to an array of strings split by newlines.
 */ parcelHelpers.export(exports, "defaultTextSplitter", ()=>defaultTextSplitter);
var _baseJs = require("../runnables/base.js");
var _aiJs = require("./ai.js");
var _chatJs = require("./chat.js");
var _functionJs = require("./function.js");
var _humanJs = require("./human.js");
var _modifierJs = require("./modifier.js");
var _systemJs = require("./system.js");
var _toolJs = require("./tool.js");
var _utilsJs = require("./utils.js");
const _isMessageType = (msg, types)=>{
    const typesAsStrings = [
        ...new Set(types?.map((t)=>{
            if (typeof t === "string") return t;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const instantiatedMsgClass = new t({});
            if (!("_getType" in instantiatedMsgClass) || typeof instantiatedMsgClass._getType !== "function") throw new Error("Invalid type provided.");
            return instantiatedMsgClass._getType();
        }))
    ];
    const msgType = msg._getType();
    return typesAsStrings.some((t)=>t === msgType);
};
function filterMessages(messagesOrOptions, options) {
    if (Array.isArray(messagesOrOptions)) return _filterMessages(messagesOrOptions, options);
    return (0, _baseJs.RunnableLambda).from((input)=>{
        return _filterMessages(input, messagesOrOptions);
    });
}
function _filterMessages(messages, options = {}) {
    const { includeNames, excludeNames, includeTypes, excludeTypes, includeIds, excludeIds } = options;
    const filtered = [];
    for (const msg of messages){
        if (excludeNames && msg.name && excludeNames.includes(msg.name)) continue;
        else if (excludeTypes && _isMessageType(msg, excludeTypes)) continue;
        else if (excludeIds && msg.id && excludeIds.includes(msg.id)) continue;
        // default to inclusion when no inclusion criteria given.
        if (!(includeTypes || includeIds || includeNames)) filtered.push(msg);
        else if (includeNames && msg.name && includeNames.some((iName)=>iName === msg.name)) filtered.push(msg);
        else if (includeTypes && _isMessageType(msg, includeTypes)) filtered.push(msg);
        else if (includeIds && msg.id && includeIds.some((id)=>id === msg.id)) filtered.push(msg);
    }
    return filtered;
}
function mergeMessageRuns(messages) {
    if (Array.isArray(messages)) return _mergeMessageRuns(messages);
    return (0, _baseJs.RunnableLambda).from(_mergeMessageRuns);
}
function _mergeMessageRuns(messages) {
    if (!messages.length) return [];
    const merged = [];
    for (const msg of messages){
        const curr = msg; // Create a shallow copy of the message
        const last = merged.pop();
        if (!last) merged.push(curr);
        else if (curr._getType() === "tool" || !(curr._getType() === last._getType())) merged.push(last, curr);
        else {
            const lastChunk = (0, _utilsJs.convertToChunk)(last);
            const currChunk = (0, _utilsJs.convertToChunk)(curr);
            const mergedChunks = lastChunk.concat(currChunk);
            if (typeof lastChunk.content === "string" && typeof currChunk.content === "string") mergedChunks.content = `${lastChunk.content}\n${currChunk.content}`;
            merged.push(_chunkToMsg(mergedChunks));
        }
    }
    return merged;
}
function trimMessages(messagesOrOptions, options) {
    if (Array.isArray(messagesOrOptions)) {
        const messages = messagesOrOptions;
        if (!options) throw new Error("Options parameter is required when providing messages.");
        return _trimMessagesHelper(messages, options);
    } else {
        const trimmerOptions = messagesOrOptions;
        return (0, _baseJs.RunnableLambda).from((input)=>_trimMessagesHelper(input, trimmerOptions));
    }
}
async function _trimMessagesHelper(messages, options) {
    const { maxTokens, tokenCounter, strategy = "last", allowPartial = false, endOn, startOn, includeSystem = false, textSplitter } = options;
    if (startOn && strategy === "first") throw new Error("`startOn` should only be specified if `strategy` is 'last'.");
    if (includeSystem && strategy === "first") throw new Error("`includeSystem` should only be specified if `strategy` is 'last'.");
    let listTokenCounter;
    if ("getNumTokens" in tokenCounter) listTokenCounter = async (msgs)=>{
        const tokenCounts = await Promise.all(msgs.map((msg)=>tokenCounter.getNumTokens(msg.content)));
        return tokenCounts.reduce((sum, count)=>sum + count, 0);
    };
    else listTokenCounter = async (msgs)=>tokenCounter(msgs);
    let textSplitterFunc = defaultTextSplitter;
    if (textSplitter) {
        if ("splitText" in textSplitter) textSplitterFunc = textSplitter.splitText;
        else textSplitterFunc = async (text)=>textSplitter(text);
    }
    if (strategy === "first") return _firstMaxTokens(messages, {
        maxTokens,
        tokenCounter: listTokenCounter,
        textSplitter: textSplitterFunc,
        partialStrategy: allowPartial ? "first" : undefined,
        endOn
    });
    else if (strategy === "last") return _lastMaxTokens(messages, {
        maxTokens,
        tokenCounter: listTokenCounter,
        textSplitter: textSplitterFunc,
        allowPartial,
        includeSystem,
        startOn,
        endOn
    });
    else throw new Error(`Unrecognized strategy: '${strategy}'. Must be one of 'first' or 'last'.`);
}
async function _firstMaxTokens(messages, options) {
    const { maxTokens, tokenCounter, textSplitter, partialStrategy, endOn } = options;
    let messagesCopy = [
        ...messages
    ];
    let idx = 0;
    for(let i = 0; i < messagesCopy.length; i += 1){
        const remainingMessages = i > 0 ? messagesCopy.slice(0, -i) : messagesCopy;
        if (await tokenCounter(remainingMessages) <= maxTokens) {
            idx = messagesCopy.length - i;
            break;
        }
    }
    if (idx < messagesCopy.length - 1 && partialStrategy) {
        let includedPartial = false;
        if (Array.isArray(messagesCopy[idx].content)) {
            const excluded = messagesCopy[idx];
            if (typeof excluded.content === "string") throw new Error("Expected content to be an array.");
            const numBlock = excluded.content.length;
            const reversedContent = partialStrategy === "last" ? [
                ...excluded.content
            ].reverse() : excluded.content;
            for(let i = 1; i <= numBlock; i += 1){
                const partialContent = partialStrategy === "first" ? reversedContent.slice(0, i) : reversedContent.slice(-i);
                const fields = Object.fromEntries(Object.entries(excluded).filter(([k])=>k !== "type" && !k.startsWith("lc_")));
                const updatedMessage = _switchTypeToMessage(excluded._getType(), {
                    ...fields,
                    content: partialContent
                });
                const slicedMessages = [
                    ...messagesCopy.slice(0, idx),
                    updatedMessage
                ];
                if (await tokenCounter(slicedMessages) <= maxTokens) {
                    messagesCopy = slicedMessages;
                    idx += 1;
                    includedPartial = true;
                } else break;
            }
            if (includedPartial && partialStrategy === "last") excluded.content = [
                ...reversedContent
            ].reverse();
        }
        if (!includedPartial) {
            const excluded = messagesCopy[idx];
            let text;
            if (Array.isArray(excluded.content) && excluded.content.some((block)=>typeof block === "string" || block.type === "text")) {
                const textBlock = excluded.content.find((block)=>block.type === "text" && block.text);
                text = textBlock?.text;
            } else if (typeof excluded.content === "string") text = excluded.content;
            if (text) {
                const splitTexts = await textSplitter(text);
                const numSplits = splitTexts.length;
                if (partialStrategy === "last") splitTexts.reverse();
                for(let _ = 0; _ < numSplits - 1; _ += 1){
                    splitTexts.pop();
                    excluded.content = splitTexts.join("");
                    if (await tokenCounter([
                        ...messagesCopy.slice(0, idx),
                        excluded
                    ]) <= maxTokens) {
                        if (partialStrategy === "last") excluded.content = [
                            ...splitTexts
                        ].reverse().join("");
                        messagesCopy = [
                            ...messagesCopy.slice(0, idx),
                            excluded
                        ];
                        idx += 1;
                        break;
                    }
                }
            }
        }
    }
    if (endOn) {
        const endOnArr = Array.isArray(endOn) ? endOn : [
            endOn
        ];
        while(idx > 0 && !_isMessageType(messagesCopy[idx - 1], endOnArr))idx -= 1;
    }
    return messagesCopy.slice(0, idx);
}
async function _lastMaxTokens(messages, options) {
    const { allowPartial = false, includeSystem = false, endOn, startOn, ...rest } = options;
    if (endOn) {
        const endOnArr = Array.isArray(endOn) ? endOn : [
            endOn
        ];
        while(messages && !_isMessageType(messages[messages.length - 1], endOnArr))messages.pop();
    }
    const swappedSystem = includeSystem && messages[0]._getType() === "system";
    let reversed_ = swappedSystem ? messages.slice(0, 1).concat(messages.slice(1).reverse()) : messages.reverse();
    reversed_ = await _firstMaxTokens(reversed_, {
        ...rest,
        partialStrategy: allowPartial ? "last" : undefined,
        endOn: startOn
    });
    if (swappedSystem) return [
        reversed_[0],
        ...reversed_.slice(1).reverse()
    ];
    else return reversed_.reverse();
}
const _MSG_CHUNK_MAP = {
    human: {
        message: (0, _humanJs.HumanMessage),
        messageChunk: (0, _humanJs.HumanMessageChunk)
    },
    ai: {
        message: (0, _aiJs.AIMessage),
        messageChunk: (0, _aiJs.AIMessageChunk)
    },
    system: {
        message: (0, _systemJs.SystemMessage),
        messageChunk: (0, _systemJs.SystemMessageChunk)
    },
    tool: {
        message: (0, _toolJs.ToolMessage),
        messageChunk: (0, _toolJs.ToolMessageChunk)
    },
    function: {
        message: (0, _functionJs.FunctionMessage),
        messageChunk: (0, _functionJs.FunctionMessageChunk)
    },
    generic: {
        message: (0, _chatJs.ChatMessage),
        messageChunk: (0, _chatJs.ChatMessageChunk)
    },
    remove: {
        message: (0, _modifierJs.RemoveMessage),
        messageChunk: (0, _modifierJs.RemoveMessage)
    }
};
function _switchTypeToMessage(messageType, fields, returnChunk) {
    let chunk;
    let msg;
    switch(messageType){
        case "human":
            if (returnChunk) chunk = new (0, _humanJs.HumanMessageChunk)(fields);
            else msg = new (0, _humanJs.HumanMessage)(fields);
            break;
        case "ai":
            if (returnChunk) {
                let aiChunkFields = {
                    ...fields
                };
                if ("tool_calls" in aiChunkFields) aiChunkFields = {
                    ...aiChunkFields,
                    tool_call_chunks: aiChunkFields.tool_calls?.map((tc)=>({
                            ...tc,
                            type: "tool_call_chunk",
                            index: undefined,
                            args: JSON.stringify(tc.args)
                        }))
                };
                chunk = new (0, _aiJs.AIMessageChunk)(aiChunkFields);
            } else msg = new (0, _aiJs.AIMessage)(fields);
            break;
        case "system":
            if (returnChunk) chunk = new (0, _systemJs.SystemMessageChunk)(fields);
            else msg = new (0, _systemJs.SystemMessage)(fields);
            break;
        case "tool":
            if ("tool_call_id" in fields) {
                if (returnChunk) chunk = new (0, _toolJs.ToolMessageChunk)(fields);
                else msg = new (0, _toolJs.ToolMessage)(fields);
            } else throw new Error("Can not convert ToolMessage to ToolMessageChunk if 'tool_call_id' field is not defined.");
            break;
        case "function":
            if (returnChunk) chunk = new (0, _functionJs.FunctionMessageChunk)(fields);
            else {
                if (!fields.name) throw new Error("FunctionMessage must have a 'name' field");
                msg = new (0, _functionJs.FunctionMessage)(fields);
            }
            break;
        case "generic":
            if ("role" in fields) {
                if (returnChunk) chunk = new (0, _chatJs.ChatMessageChunk)(fields);
                else msg = new (0, _chatJs.ChatMessage)(fields);
            } else throw new Error("Can not convert ChatMessage to ChatMessageChunk if 'role' field is not defined.");
            break;
        default:
            throw new Error(`Unrecognized message type ${messageType}`);
    }
    if (returnChunk && chunk) return chunk;
    if (msg) return msg;
    throw new Error(`Unrecognized message type ${messageType}`);
}
function _chunkToMsg(chunk) {
    const chunkType = chunk._getType();
    let msg;
    const fields = Object.fromEntries(Object.entries(chunk).filter(([k])=>![
            "type",
            "tool_call_chunks"
        ].includes(k) && !k.startsWith("lc_")));
    if (chunkType in _MSG_CHUNK_MAP) msg = _switchTypeToMessage(chunkType, fields);
    if (!msg) throw new Error(`Unrecognized message chunk class ${chunkType}. Supported classes are ${Object.keys(_MSG_CHUNK_MAP)}`);
    return msg;
}
function defaultTextSplitter(text) {
    const splits = text.split("\n");
    return Promise.resolve([
        ...splits.slice(0, -1).map((s)=>`${s}\n`),
        splits[splits.length - 1]
    ]);
}

},{"../runnables/base.js":"9xkzz","./ai.js":"lkFVb","./chat.js":"ih7Pn","./function.js":"bia1q","./human.js":"2YgBC","./modifier.js":"96Qr0","./system.js":"8i8IV","./tool.js":"04Rfb","./utils.js":"6vi0n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9xkzz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "_coerceToDict", ()=>_coerceToDict);
/**
 * A Runnable is a generic unit of work that can be invoked, batched, streamed, and/or
 * transformed.
 */ parcelHelpers.export(exports, "Runnable", ()=>Runnable);
/**
 * A runnable that delegates calls to another runnable with a set of kwargs.
 * @example
 * ```typescript
 * import {
 *   type RunnableConfig,
 *   RunnableLambda,
 * } from "@langchain/core/runnables";
 *
 * const enhanceProfile = (
 *   profile: Record<string, any>,
 *   config?: RunnableConfig
 * ) => {
 *   if (config?.configurable?.role) {
 *     return { ...profile, role: config.configurable.role };
 *   }
 *   return profile;
 * };
 *
 * const runnable = RunnableLambda.from(enhanceProfile);
 *
 * // Bind configuration to the runnable to set the user's role dynamically
 * const adminRunnable = runnable.bind({ configurable: { role: "Admin" } });
 * const userRunnable = runnable.bind({ configurable: { role: "User" } });
 *
 * const result1 = await adminRunnable.invoke({
 *   name: "Alice",
 *   email: "alice@example.com"
 * });
 *
 * // { name: "Alice", email: "alice@example.com", role: "Admin" }
 *
 * const result2 = await userRunnable.invoke({
 *   name: "Bob",
 *   email: "bob@example.com"
 * });
 *
 * // { name: "Bob", email: "bob@example.com", role: "User" }
 * ```
 */ parcelHelpers.export(exports, "RunnableBinding", ()=>RunnableBinding);
/**
 * A runnable that delegates calls to another runnable
 * with each element of the input sequence.
 * @example
 * ```typescript
 * import { RunnableEach, RunnableLambda } from "@langchain/core/runnables";
 *
 * const toUpperCase = (input: string): string => input.toUpperCase();
 * const addGreeting = (input: string): string => `Hello, ${input}!`;
 *
 * const upperCaseLambda = RunnableLambda.from(toUpperCase);
 * const greetingLambda = RunnableLambda.from(addGreeting);
 *
 * const chain = new RunnableEach({
 *   bound: upperCaseLambda.pipe(greetingLambda),
 * });
 *
 * const result = await chain.invoke(["alice", "bob", "carol"])
 *
 * // ["Hello, ALICE!", "Hello, BOB!", "Hello, CAROL!"]
 * ```
 */ parcelHelpers.export(exports, "RunnableEach", ()=>RunnableEach);
/**
 * Base class for runnables that can be retried a
 * specified number of times.
 * @example
 * ```typescript
 * import {
 *   RunnableLambda,
 *   RunnableRetry,
 * } from "@langchain/core/runnables";
 *
 * // Simulate an API call that fails
 * const simulateApiCall = (input: string): string => {
 *   console.log(`Attempting API call with input: ${input}`);
 *   throw new Error("API call failed due to network issue");
 * };
 *
 * const apiCallLambda = RunnableLambda.from(simulateApiCall);
 *
 * // Apply retry logic using the .withRetry() method
 * const apiCallWithRetry = apiCallLambda.withRetry({ stopAfterAttempt: 3 });
 *
 * // Alternatively, create a RunnableRetry instance manually
 * const manualRetry = new RunnableRetry({
 *   bound: apiCallLambda,
 *   maxAttemptNumber: 3,
 *   config: {},
 * });
 *
 * // Example invocation using the .withRetry() method
 * const res = await apiCallWithRetry
 *   .invoke("Request 1")
 *   .catch((error) => {
 *     console.error("Failed after multiple retries:", error.message);
 *   });
 *
 * // Example invocation using the manual retry instance
 * const res2 = await manualRetry
 *   .invoke("Request 2")
 *   .catch((error) => {
 *     console.error("Failed after multiple retries:", error.message);
 *   });
 * ```
 */ parcelHelpers.export(exports, "RunnableRetry", ()=>RunnableRetry);
/**
 * A sequence of runnables, where the output of each is the input of the next.
 * @example
 * ```typescript
 * const promptTemplate = PromptTemplate.fromTemplate(
 *   "Tell me a joke about {topic}",
 * );
 * const chain = RunnableSequence.from([promptTemplate, new ChatOpenAI({})]);
 * const result = await chain.invoke({ topic: "bears" });
 * ```
 */ parcelHelpers.export(exports, "RunnableSequence", ()=>RunnableSequence);
/**
 * A runnable that runs a mapping of runnables in parallel,
 * and returns a mapping of their outputs.
 * @example
 * ```typescript
 * const mapChain = RunnableMap.from({
 *   joke: PromptTemplate.fromTemplate("Tell me a joke about {topic}").pipe(
 *     new ChatAnthropic({}),
 *   ),
 *   poem: PromptTemplate.fromTemplate("write a 2-line poem about {topic}").pipe(
 *     new ChatAnthropic({}),
 *   ),
 * });
 * const result = await mapChain.invoke({ topic: "bear" });
 * ```
 */ parcelHelpers.export(exports, "RunnableMap", ()=>RunnableMap);
/**
 * A runnable that wraps a traced LangSmith function.
 */ parcelHelpers.export(exports, "RunnableTraceable", ()=>RunnableTraceable);
/**
 * A runnable that wraps an arbitrary function that takes a single argument.
 * @example
 * ```typescript
 * import { RunnableLambda } from "@langchain/core/runnables";
 *
 * const add = (input: { x: number; y: number }) => input.x + input.y;
 *
 * const multiply = (input: { value: number; multiplier: number }) =>
 *   input.value * input.multiplier;
 *
 * // Create runnables for the functions
 * const addLambda = RunnableLambda.from(add);
 * const multiplyLambda = RunnableLambda.from(multiply);
 *
 * // Chain the lambdas for a mathematical operation
 * const chainedLambda = addLambda.pipe((result) =>
 *   multiplyLambda.invoke({ value: result, multiplier: 2 })
 * );
 *
 * // Example invocation of the chainedLambda
 * const result = await chainedLambda.invoke({ x: 2, y: 3 });
 *
 * // Will log "10" (since (2 + 3) * 2 = 10)
 * ```
 */ parcelHelpers.export(exports, "RunnableLambda", ()=>RunnableLambda);
/**
 * A runnable that runs a mapping of runnables in parallel,
 * and returns a mapping of their outputs.
 * @example
 * ```typescript
 * import {
 *   RunnableLambda,
 *   RunnableParallel,
 * } from "@langchain/core/runnables";
 *
 * const addYears = (age: number): number => age + 5;
 * const yearsToFifty = (age: number): number => 50 - age;
 * const yearsToHundred = (age: number): number => 100 - age;
 *
 * const addYearsLambda = RunnableLambda.from(addYears);
 * const milestoneFiftyLambda = RunnableLambda.from(yearsToFifty);
 * const milestoneHundredLambda = RunnableLambda.from(yearsToHundred);
 *
 * // Pipe will coerce objects into RunnableParallel by default, but we
 * // explicitly instantiate one here to demonstrate
 * const sequence = addYearsLambda.pipe(
 *   RunnableParallel.from({
 *     years_to_fifty: milestoneFiftyLambda,
 *     years_to_hundred: milestoneHundredLambda,
 *   })
 * );
 *
 * // Invoke the sequence with a single age input
 * const res = sequence.invoke(25);
 *
 * // { years_to_fifty: 25, years_to_hundred: 75 }
 * ```
 */ parcelHelpers.export(exports, "RunnableParallel", ()=>RunnableParallel);
/**
 * A Runnable that can fallback to other Runnables if it fails.
 * External APIs (e.g., APIs for a language model) may at times experience
 * degraded performance or even downtime.
 *
 * In these cases, it can be useful to have a fallback Runnable that can be
 * used in place of the original Runnable (e.g., fallback to another LLM provider).
 *
 * Fallbacks can be defined at the level of a single Runnable, or at the level
 * of a chain of Runnables. Fallbacks are tried in order until one succeeds or
 * all fail.
 *
 * While you can instantiate a `RunnableWithFallbacks` directly, it is usually
 * more convenient to use the `withFallbacks` method on an existing Runnable.
 *
 * When streaming, fallbacks will only be called on failures during the initial
 * stream creation. Errors that occur after a stream starts will not fallback
 * to the next Runnable.
 *
 * @example
 * ```typescript
 * import {
 *   RunnableLambda,
 *   RunnableWithFallbacks,
 * } from "@langchain/core/runnables";
 *
 * const primaryOperation = (input: string): string => {
 *   if (input !== "safe") {
 *     throw new Error("Primary operation failed due to unsafe input");
 *   }
 *   return `Processed: ${input}`;
 * };
 *
 * // Define a fallback operation that processes the input differently
 * const fallbackOperation = (input: string): string =>
 *   `Fallback processed: ${input}`;
 *
 * const primaryRunnable = RunnableLambda.from(primaryOperation);
 * const fallbackRunnable = RunnableLambda.from(fallbackOperation);
 *
 * // Apply the fallback logic using the .withFallbacks() method
 * const runnableWithFallback = primaryRunnable.withFallbacks([fallbackRunnable]);
 *
 * // Alternatively, create a RunnableWithFallbacks instance manually
 * const manualFallbackChain = new RunnableWithFallbacks({
 *   runnable: primaryRunnable,
 *   fallbacks: [fallbackRunnable],
 * });
 *
 * // Example invocation using .withFallbacks()
 * const res = await runnableWithFallback
 *   .invoke("unsafe input")
 *   .catch((error) => {
 *     console.error("Failed after all attempts:", error.message);
 *   });
 *
 * // "Fallback processed: unsafe input"
 *
 * // Example invocation using manual instantiation
 * const res = await manualFallbackChain
 *   .invoke("safe")
 *   .catch((error) => {
 *     console.error("Failed after all attempts:", error.message);
 *   });
 *
 * // "Processed: safe"
 * ```
 */ parcelHelpers.export(exports, "RunnableWithFallbacks", ()=>RunnableWithFallbacks);
// TODO: Figure out why the compiler needs help eliminating Error as a RunOutput type
parcelHelpers.export(exports, "_coerceToRunnable", ()=>_coerceToRunnable);
/**
 * A runnable that assigns key-value pairs to inputs of type `Record<string, unknown>`.
 * @example
 * ```typescript
 * import {
 *   RunnableAssign,
 *   RunnableLambda,
 *   RunnableParallel,
 * } from "@langchain/core/runnables";
 *
 * const calculateAge = (x: { birthYear: number }): { age: number } => {
 *   const currentYear = new Date().getFullYear();
 *   return { age: currentYear - x.birthYear };
 * };
 *
 * const createGreeting = (x: { name: string }): { greeting: string } => {
 *   return { greeting: `Hello, ${x.name}!` };
 * };
 *
 * const mapper = RunnableParallel.from({
 *   age_step: RunnableLambda.from(calculateAge),
 *   greeting_step: RunnableLambda.from(createGreeting),
 * });
 *
 * const runnableAssign = new RunnableAssign({ mapper });
 *
 * const res = await runnableAssign.invoke({ name: "Alice", birthYear: 1990 });
 *
 * // { name: "Alice", birthYear: 1990, age_step: { age: 34 }, greeting_step: { greeting: "Hello, Alice!" } }
 * ```
 */ parcelHelpers.export(exports, "RunnableAssign", ()=>RunnableAssign);
/**
 * A runnable that assigns key-value pairs to inputs of type `Record<string, unknown>`.
 * Useful for streaming, can be automatically created and chained by calling `runnable.pick();`.
 * @example
 * ```typescript
 * import { RunnablePick } from "@langchain/core/runnables";
 *
 * const inputData = {
 *   name: "John",
 *   age: 30,
 *   city: "New York",
 *   country: "USA",
 *   email: "john.doe@example.com",
 *   phone: "+1234567890",
 * };
 *
 * const basicInfoRunnable = new RunnablePick(["name", "city"]);
 *
 * // Example invocation
 * const res = await basicInfoRunnable.invoke(inputData);
 *
 * // { name: 'John', city: 'New York' }
 * ```
 */ parcelHelpers.export(exports, "RunnablePick", ()=>RunnablePick);
parcelHelpers.export(exports, "RunnableToolLike", ()=>RunnableToolLike);
/**
 * Given a runnable and a Zod schema, convert the runnable to a tool.
 *
 * @template RunInput The input type for the runnable.
 * @template RunOutput The output type for the runnable.
 *
 * @param {Runnable<RunInput, RunOutput>} runnable The runnable to convert to a tool.
 * @param fields
 * @param {string | undefined} [fields.name] The name of the tool. If not provided, it will default to the name of the runnable.
 * @param {string | undefined} [fields.description] The description of the tool. Falls back to the description on the Zod schema if not provided, or undefined if neither are provided.
 * @param {z.ZodType<RunInput>} [fields.schema] The Zod schema for the input of the tool. Infers the Zod type from the input type of the runnable.
 * @returns {RunnableToolLike<z.ZodType<RunInput>, RunOutput>} An instance of `RunnableToolLike` which is a runnable that can be used as a tool.
 */ parcelHelpers.export(exports, "convertRunnableToTool", ()=>convertRunnableToTool);
var _zod = require("zod");
var _pRetry = require("p-retry");
var _pRetryDefault = parcelHelpers.interopDefault(_pRetry);
var _uuid = require("uuid");
var _traceable = require("langsmith/singletons/traceable");
var _logStreamJs = require("../tracers/log_stream.js");
var _eventStreamJs = require("../tracers/event_stream.js");
var _serializableJs = require("../load/serializable.js");
var _streamJs = require("../utils/stream.js");
var _signalJs = require("../utils/signal.js");
var _configJs = require("./config.js");
var _asyncCallerJs = require("../utils/async_caller.js");
var _rootListenerJs = require("../tracers/root_listener.js");
var _utilsJs = require("./utils.js");
var _indexJs = require("../singletons/index.js");
var _graphJs = require("./graph.js");
var _wrappersJs = require("./wrappers.js");
var _iterJs = require("./iter.js");
var _utilsJs1 = require("../tools/utils.js");
function _coerceToDict(value, defaultKey) {
    return value && !Array.isArray(value) && // eslint-disable-next-line no-instanceof/no-instanceof
    !(value instanceof Date) && typeof value === "object" ? value : {
        [defaultKey]: value
    };
}
class Runnable extends (0, _serializableJs.Serializable) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_runnable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    getName(suffix) {
        const name = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.name ?? this.constructor.lc_name() ?? this.constructor.name;
        return suffix ? `${name}${suffix}` : name;
    }
    /**
     * Bind arguments to a Runnable, returning a new Runnable.
     * @param kwargs
     * @returns A new RunnableBinding that, when invoked, will apply the bound args.
     */ bind(kwargs) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return new RunnableBinding({
            bound: this,
            kwargs,
            config: {}
        });
    }
    /**
     * Return a new Runnable that maps a list of inputs to a list of outputs,
     * by calling invoke() with each input.
     */ map() {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return new RunnableEach({
            bound: this
        });
    }
    /**
     * Add retry logic to an existing runnable.
     * @param kwargs
     * @returns A new RunnableRetry that, when invoked, will retry according to the parameters.
     */ withRetry(fields) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return new RunnableRetry({
            bound: this,
            kwargs: {},
            config: {},
            maxAttemptNumber: fields?.stopAfterAttempt,
            ...fields
        });
    }
    /**
     * Bind config to a Runnable, returning a new Runnable.
     * @param config New configuration parameters to attach to the new runnable.
     * @returns A new RunnableBinding with a config matching what's passed.
     */ withConfig(config) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return new RunnableBinding({
            bound: this,
            config,
            kwargs: {}
        });
    }
    /**
     * Create a new runnable from the current one that will try invoking
     * other passed fallback runnables if the initial invocation fails.
     * @param fields.fallbacks Other runnables to call if the runnable errors.
     * @returns A new RunnableWithFallbacks.
     */ withFallbacks(fields) {
        const fallbacks = Array.isArray(fields) ? fields : fields.fallbacks;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return new RunnableWithFallbacks({
            runnable: this,
            fallbacks
        });
    }
    _getOptionsList(options, length = 0) {
        if (Array.isArray(options) && options.length !== length) throw new Error(`Passed "options" must be an array with the same length as the inputs, but got ${options.length} options for ${length} inputs`);
        if (Array.isArray(options)) return options.map((0, _configJs.ensureConfig));
        if (length > 1 && !Array.isArray(options) && options.runId) {
            console.warn("Provided runId will be used only for the first element of the batch.");
            const subsequent = Object.fromEntries(Object.entries(options).filter(([key])=>key !== "runId"));
            return Array.from({
                length
            }, (_, i)=>(0, _configJs.ensureConfig)(i === 0 ? options : subsequent));
        }
        return Array.from({
            length
        }, ()=>(0, _configJs.ensureConfig)(options));
    }
    async batch(inputs, options, batchOptions) {
        const configList = this._getOptionsList(options ?? {}, inputs.length);
        const maxConcurrency = configList[0]?.maxConcurrency ?? batchOptions?.maxConcurrency;
        const caller = new (0, _asyncCallerJs.AsyncCaller)({
            maxConcurrency,
            onFailedAttempt: (e)=>{
                throw e;
            }
        });
        const batchCalls = inputs.map((input, i)=>caller.call(async ()=>{
                try {
                    const result = await this.invoke(input, configList[i]);
                    return result;
                } catch (e) {
                    if (batchOptions?.returnExceptions) return e;
                    throw e;
                }
            }));
        return Promise.all(batchCalls);
    }
    /**
     * Default streaming implementation.
     * Subclasses should override this method if they support streaming output.
     * @param input
     * @param options
     */ async *_streamIterator(input, options) {
        yield this.invoke(input, options);
    }
    /**
     * Stream output in chunks.
     * @param input
     * @param options
     * @returns A readable stream that is also an iterable.
     */ async stream(input, options) {
        // Buffer the first streamed chunk to allow for initial errors
        // to surface immediately.
        const config = (0, _configJs.ensureConfig)(options);
        const wrappedGenerator = new (0, _streamJs.AsyncGeneratorWithSetup)({
            generator: this._streamIterator(input, config),
            config
        });
        await wrappedGenerator.setup;
        return (0, _streamJs.IterableReadableStream).fromAsyncGenerator(wrappedGenerator);
    }
    _separateRunnableConfigFromCallOptions(options) {
        let runnableConfig;
        if (options === undefined) runnableConfig = (0, _configJs.ensureConfig)(options);
        else runnableConfig = (0, _configJs.ensureConfig)({
            callbacks: options.callbacks,
            tags: options.tags,
            metadata: options.metadata,
            runName: options.runName,
            configurable: options.configurable,
            recursionLimit: options.recursionLimit,
            maxConcurrency: options.maxConcurrency,
            runId: options.runId,
            timeout: options.timeout,
            signal: options.signal
        });
        const callOptions = {
            ...options
        };
        delete callOptions.callbacks;
        delete callOptions.tags;
        delete callOptions.metadata;
        delete callOptions.runName;
        delete callOptions.configurable;
        delete callOptions.recursionLimit;
        delete callOptions.maxConcurrency;
        delete callOptions.runId;
        delete callOptions.timeout;
        delete callOptions.signal;
        return [
            runnableConfig,
            callOptions
        ];
    }
    async _callWithConfig(func, input, options) {
        const config = (0, _configJs.ensureConfig)(options);
        const callbackManager_ = await (0, _configJs.getCallbackManagerForConfig)(config);
        const runManager = await callbackManager_?.handleChainStart(this.toJSON(), _coerceToDict(input, "input"), config.runId, config?.runType, undefined, undefined, config?.runName ?? this.getName());
        delete config.runId;
        let output;
        try {
            const promise = func.call(this, input, config, runManager);
            output = await (0, _signalJs.raceWithSignal)(promise, options?.signal);
        } catch (e) {
            await runManager?.handleChainError(e);
            throw e;
        }
        await runManager?.handleChainEnd(_coerceToDict(output, "output"));
        return output;
    }
    /**
     * Internal method that handles batching and configuration for a runnable
     * It takes a function, input values, and optional configuration, and
     * returns a promise that resolves to the output values.
     * @param func The function to be executed for each input value.
     * @param input The input values to be processed.
     * @param config Optional configuration for the function execution.
     * @returns A promise that resolves to the output values.
     */ async _batchWithConfig(func, inputs, options, batchOptions) {
        const optionsList = this._getOptionsList(options ?? {}, inputs.length);
        const callbackManagers = await Promise.all(optionsList.map((0, _configJs.getCallbackManagerForConfig)));
        const runManagers = await Promise.all(callbackManagers.map(async (callbackManager, i)=>{
            const handleStartRes = await callbackManager?.handleChainStart(this.toJSON(), _coerceToDict(inputs[i], "input"), optionsList[i].runId, optionsList[i].runType, undefined, undefined, optionsList[i].runName ?? this.getName());
            delete optionsList[i].runId;
            return handleStartRes;
        }));
        let outputs;
        try {
            const promise = func.call(this, inputs, optionsList, runManagers, batchOptions);
            outputs = await (0, _signalJs.raceWithSignal)(promise, optionsList?.[0]?.signal);
        } catch (e) {
            await Promise.all(runManagers.map((runManager)=>runManager?.handleChainError(e)));
            throw e;
        }
        await Promise.all(runManagers.map((runManager)=>runManager?.handleChainEnd(_coerceToDict(outputs, "output"))));
        return outputs;
    }
    /**
     * Helper method to transform an Iterator of Input values into an Iterator of
     * Output values, with callbacks.
     * Use this to implement `stream()` or `transform()` in Runnable subclasses.
     */ async *_transformStreamWithConfig(inputGenerator, transformer, options) {
        let finalInput;
        let finalInputSupported = true;
        let finalOutput;
        let finalOutputSupported = true;
        const config = (0, _configJs.ensureConfig)(options);
        const callbackManager_ = await (0, _configJs.getCallbackManagerForConfig)(config);
        async function* wrapInputForTracing() {
            for await (const chunk of inputGenerator){
                if (finalInputSupported) {
                    if (finalInput === undefined) finalInput = chunk;
                    else try {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        finalInput = (0, _streamJs.concat)(finalInput, chunk);
                    } catch  {
                        finalInput = undefined;
                        finalInputSupported = false;
                    }
                }
                yield chunk;
            }
        }
        let runManager;
        try {
            const pipe = await (0, _streamJs.pipeGeneratorWithSetup)(transformer.bind(this), wrapInputForTracing(), async ()=>callbackManager_?.handleChainStart(this.toJSON(), {
                    input: ""
                }, config.runId, config.runType, undefined, undefined, config.runName ?? this.getName()), options?.signal, config);
            delete config.runId;
            runManager = pipe.setup;
            const streamEventsHandler = runManager?.handlers.find((0, _eventStreamJs.isStreamEventsHandler));
            let iterator = pipe.output;
            if (streamEventsHandler !== undefined && runManager !== undefined) iterator = streamEventsHandler.tapOutputIterable(runManager.runId, iterator);
            const streamLogHandler = runManager?.handlers.find((0, _logStreamJs.isLogStreamHandler));
            if (streamLogHandler !== undefined && runManager !== undefined) iterator = streamLogHandler.tapOutputIterable(runManager.runId, iterator);
            for await (const chunk of iterator){
                yield chunk;
                if (finalOutputSupported) {
                    if (finalOutput === undefined) finalOutput = chunk;
                    else try {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        finalOutput = (0, _streamJs.concat)(finalOutput, chunk);
                    } catch  {
                        finalOutput = undefined;
                        finalOutputSupported = false;
                    }
                }
            }
        } catch (e) {
            await runManager?.handleChainError(e, undefined, undefined, undefined, {
                inputs: _coerceToDict(finalInput, "input")
            });
            throw e;
        }
        await runManager?.handleChainEnd(finalOutput ?? {}, undefined, undefined, undefined, {
            inputs: _coerceToDict(finalInput, "input")
        });
    }
    getGraph(_) {
        const graph = new (0, _graphJs.Graph)();
        // TODO: Add input schema for runnables
        const inputNode = graph.addNode({
            name: `${this.getName()}Input`,
            schema: (0, _zod.z).any()
        });
        const runnableNode = graph.addNode(this);
        // TODO: Add output schemas for runnables
        const outputNode = graph.addNode({
            name: `${this.getName()}Output`,
            schema: (0, _zod.z).any()
        });
        graph.addEdge(inputNode, runnableNode);
        graph.addEdge(runnableNode, outputNode);
        return graph;
    }
    /**
     * Create a new runnable sequence that runs each individual runnable in series,
     * piping the output of one runnable into another runnable or runnable-like.
     * @param coerceable A runnable, function, or object whose values are functions or runnables.
     * @returns A new runnable sequence.
     */ pipe(coerceable) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return new RunnableSequence({
            first: this,
            last: _coerceToRunnable(coerceable)
        });
    }
    /**
     * Pick keys from the dict output of this runnable. Returns a new runnable.
     */ pick(keys) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return this.pipe(new RunnablePick(keys));
    }
    /**
     * Assigns new fields to the dict output of this runnable. Returns a new runnable.
     */ assign(mapping) {
        return this.pipe(// eslint-disable-next-line @typescript-eslint/no-use-before-define
        new RunnableAssign(// eslint-disable-next-line @typescript-eslint/no-use-before-define
        new RunnableMap({
            steps: mapping
        })));
    }
    /**
     * Default implementation of transform, which buffers input and then calls stream.
     * Subclasses should override this method if they can start producing output while
     * input is still being generated.
     * @param generator
     * @param options
     */ async *transform(generator, options) {
        let finalChunk;
        for await (const chunk of generator)if (finalChunk === undefined) finalChunk = chunk;
        else // Make a best effort to gather, for any type that supports concat.
        // This method should throw an error if gathering fails.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        finalChunk = (0, _streamJs.concat)(finalChunk, chunk);
        yield* this._streamIterator(finalChunk, (0, _configJs.ensureConfig)(options));
    }
    /**
     * Stream all output from a runnable, as reported to the callback system.
     * This includes all inner runs of LLMs, Retrievers, Tools, etc.
     * Output is streamed as Log objects, which include a list of
     * jsonpatch ops that describe how the state of the run has changed in each
     * step, and the final state of the run.
     * The jsonpatch ops can be applied in order to construct state.
     * @param input
     * @param options
     * @param streamOptions
     */ async *streamLog(input, options, streamOptions) {
        const logStreamCallbackHandler = new (0, _logStreamJs.LogStreamCallbackHandler)({
            ...streamOptions,
            autoClose: false,
            _schemaFormat: "original"
        });
        const config = (0, _configJs.ensureConfig)(options);
        yield* this._streamLog(input, logStreamCallbackHandler, config);
    }
    async *_streamLog(input, logStreamCallbackHandler, config) {
        const { callbacks } = config;
        if (callbacks === undefined) // eslint-disable-next-line no-param-reassign
        config.callbacks = [
            logStreamCallbackHandler
        ];
        else if (Array.isArray(callbacks)) // eslint-disable-next-line no-param-reassign
        config.callbacks = callbacks.concat([
            logStreamCallbackHandler
        ]);
        else {
            const copiedCallbacks = callbacks.copy();
            copiedCallbacks.addHandler(logStreamCallbackHandler, true);
            // eslint-disable-next-line no-param-reassign
            config.callbacks = copiedCallbacks;
        }
        const runnableStreamPromise = this.stream(input, config);
        async function consumeRunnableStream() {
            try {
                const runnableStream = await runnableStreamPromise;
                for await (const chunk of runnableStream){
                    const patch = new (0, _logStreamJs.RunLogPatch)({
                        ops: [
                            {
                                op: "add",
                                path: "/streamed_output/-",
                                value: chunk
                            }
                        ]
                    });
                    await logStreamCallbackHandler.writer.write(patch);
                }
            } finally{
                await logStreamCallbackHandler.writer.close();
            }
        }
        const runnableStreamConsumePromise = consumeRunnableStream();
        try {
            for await (const log of logStreamCallbackHandler)yield log;
        } finally{
            await runnableStreamConsumePromise;
        }
    }
    streamEvents(input, options, streamOptions) {
        let stream;
        if (options.version === "v1") stream = this._streamEventsV1(input, options, streamOptions);
        else if (options.version === "v2") stream = this._streamEventsV2(input, options, streamOptions);
        else throw new Error(`Only versions "v1" and "v2" of the schema are currently supported.`);
        if (options.encoding === "text/event-stream") return (0, _wrappersJs.convertToHttpEventStream)(stream);
        else return (0, _streamJs.IterableReadableStream).fromAsyncGenerator(stream);
    }
    async *_streamEventsV2(input, options, streamOptions) {
        const eventStreamer = new (0, _eventStreamJs.EventStreamCallbackHandler)({
            ...streamOptions,
            autoClose: false
        });
        const config = (0, _configJs.ensureConfig)(options);
        const runId = config.runId ?? (0, _uuid.v4)();
        config.runId = runId;
        const callbacks = config.callbacks;
        if (callbacks === undefined) config.callbacks = [
            eventStreamer
        ];
        else if (Array.isArray(callbacks)) config.callbacks = callbacks.concat(eventStreamer);
        else {
            const copiedCallbacks = callbacks.copy();
            copiedCallbacks.addHandler(eventStreamer, true);
            // eslint-disable-next-line no-param-reassign
            config.callbacks = copiedCallbacks;
        }
        // Call the runnable in streaming mode,
        // add each chunk to the output stream
        const outerThis = this;
        async function consumeRunnableStream() {
            try {
                const runnableStream = await outerThis.stream(input, config);
                const tappedStream = eventStreamer.tapOutputIterable(runId, runnableStream);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                for await (const _ of tappedStream);
            } finally{
                await eventStreamer.finish();
            }
        }
        const runnableStreamConsumePromise = consumeRunnableStream();
        let firstEventSent = false;
        let firstEventRunId;
        try {
            for await (const event of eventStreamer){
                // This is a work-around an issue where the inputs into the
                // chain are not available until the entire input is consumed.
                // As a temporary solution, we'll modify the input to be the input
                // that was passed into the chain.
                if (!firstEventSent) {
                    event.data.input = input;
                    firstEventSent = true;
                    firstEventRunId = event.run_id;
                    yield event;
                    continue;
                }
                if (event.run_id === firstEventRunId && event.event.endsWith("_end")) // If it's the end event corresponding to the root runnable
                // we dont include the input in the event since it's guaranteed
                // to be included in the first event.
                {
                    if (event.data?.input) delete event.data.input;
                }
                yield event;
            }
        } finally{
            await runnableStreamConsumePromise;
        }
    }
    async *_streamEventsV1(input, options, streamOptions) {
        let runLog;
        let hasEncounteredStartEvent = false;
        const config = (0, _configJs.ensureConfig)(options);
        const rootTags = config.tags ?? [];
        const rootMetadata = config.metadata ?? {};
        const rootName = config.runName ?? this.getName();
        const logStreamCallbackHandler = new (0, _logStreamJs.LogStreamCallbackHandler)({
            ...streamOptions,
            autoClose: false,
            _schemaFormat: "streaming_events"
        });
        const rootEventFilter = new (0, _utilsJs._RootEventFilter)({
            ...streamOptions
        });
        const logStream = this._streamLog(input, logStreamCallbackHandler, config);
        for await (const log of logStream){
            if (!runLog) runLog = (0, _logStreamJs.RunLog).fromRunLogPatch(log);
            else runLog = runLog.concat(log);
            if (runLog.state === undefined) throw new Error(`Internal error: "streamEvents" state is missing. Please open a bug report.`);
            // Yield the start event for the root runnable if it hasn't been seen.
            // The root run is never filtered out
            if (!hasEncounteredStartEvent) {
                hasEncounteredStartEvent = true;
                const state = {
                    ...runLog.state
                };
                const event = {
                    run_id: state.id,
                    event: `on_${state.type}_start`,
                    name: rootName,
                    tags: rootTags,
                    metadata: rootMetadata,
                    data: {
                        input
                    }
                };
                if (rootEventFilter.includeEvent(event, state.type)) yield event;
            }
            const paths = log.ops.filter((op)=>op.path.startsWith("/logs/")).map((op)=>op.path.split("/")[2]);
            const dedupedPaths = [
                ...new Set(paths)
            ];
            for (const path of dedupedPaths){
                let eventType;
                let data = {};
                const logEntry = runLog.state.logs[path];
                if (logEntry.end_time === undefined) {
                    if (logEntry.streamed_output.length > 0) eventType = "stream";
                    else eventType = "start";
                } else eventType = "end";
                if (eventType === "start") // Include the inputs with the start event if they are available.
                // Usually they will NOT be available for components that operate
                // on streams, since those components stream the input and
                // don't know its final value until the end of the stream.
                {
                    if (logEntry.inputs !== undefined) data.input = logEntry.inputs;
                } else if (eventType === "end") {
                    if (logEntry.inputs !== undefined) data.input = logEntry.inputs;
                    data.output = logEntry.final_output;
                } else if (eventType === "stream") {
                    const chunkCount = logEntry.streamed_output.length;
                    if (chunkCount !== 1) throw new Error(`Expected exactly one chunk of streamed output, got ${chunkCount} instead. Encountered in: "${logEntry.name}"`);
                    data = {
                        chunk: logEntry.streamed_output[0]
                    };
                    // Clean up the stream, we don't need it anymore.
                    // And this avoids duplicates as well!
                    logEntry.streamed_output = [];
                }
                yield {
                    event: `on_${logEntry.type}_${eventType}`,
                    name: logEntry.name,
                    run_id: logEntry.id,
                    tags: logEntry.tags,
                    metadata: logEntry.metadata,
                    data
                };
            }
            // Finally, we take care of the streaming output from the root chain
            // if there is any.
            const { state } = runLog;
            if (state.streamed_output.length > 0) {
                const chunkCount = state.streamed_output.length;
                if (chunkCount !== 1) throw new Error(`Expected exactly one chunk of streamed output, got ${chunkCount} instead. Encountered in: "${state.name}"`);
                const data = {
                    chunk: state.streamed_output[0]
                };
                // Clean up the stream, we don't need it anymore.
                state.streamed_output = [];
                const event = {
                    event: `on_${state.type}_stream`,
                    run_id: state.id,
                    tags: rootTags,
                    metadata: rootMetadata,
                    name: rootName,
                    data
                };
                if (rootEventFilter.includeEvent(event, state.type)) yield event;
            }
        }
        const state = runLog?.state;
        if (state !== undefined) {
            // Finally, yield the end event for the root runnable.
            const event = {
                event: `on_${state.type}_end`,
                name: rootName,
                run_id: state.id,
                tags: rootTags,
                metadata: rootMetadata,
                data: {
                    output: state.final_output
                }
            };
            if (rootEventFilter.includeEvent(event, state.type)) yield event;
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isRunnable(thing) {
        return (0, _utilsJs.isRunnableInterface)(thing);
    }
    /**
     * Bind lifecycle listeners to a Runnable, returning a new Runnable.
     * The Run object contains information about the run, including its id,
     * type, input, output, error, startTime, endTime, and any tags or metadata
     * added to the run.
     *
     * @param {Object} params - The object containing the callback functions.
     * @param {(run: Run) => void} params.onStart - Called before the runnable starts running, with the Run object.
     * @param {(run: Run) => void} params.onEnd - Called after the runnable finishes running, with the Run object.
     * @param {(run: Run) => void} params.onError - Called if the runnable throws an error, with the Run object.
     */ withListeners({ onStart, onEnd, onError }) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return new RunnableBinding({
            bound: this,
            config: {},
            configFactories: [
                (config)=>({
                        callbacks: [
                            new (0, _rootListenerJs.RootListenersTracer)({
                                config,
                                onStart,
                                onEnd,
                                onError
                            })
                        ]
                    })
            ]
        });
    }
    /**
     * Convert a runnable to a tool. Return a new instance of `RunnableToolLike`
     * which contains the runnable, name, description and schema.
     *
     * @template {T extends RunInput = RunInput} RunInput - The input type of the runnable. Should be the same as the `RunInput` type of the runnable.
     *
     * @param fields
     * @param {string | undefined} [fields.name] The name of the tool. If not provided, it will default to the name of the runnable.
     * @param {string | undefined} [fields.description] The description of the tool. Falls back to the description on the Zod schema if not provided, or undefined if neither are provided.
     * @param {z.ZodType<T>} [fields.schema] The Zod schema for the input of the tool. Infers the Zod type from the input type of the runnable.
     * @returns {RunnableToolLike<z.ZodType<T>, RunOutput>} An instance of `RunnableToolLike` which is a runnable that can be used as a tool.
     */ asTool(fields) {
        return convertRunnableToTool(this, fields);
    }
}
class RunnableBinding extends Runnable {
    static lc_name() {
        return "RunnableBinding";
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "bound", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "kwargs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "configFactories", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.bound = fields.bound;
        this.kwargs = fields.kwargs;
        this.config = fields.config;
        this.configFactories = fields.configFactories;
    }
    getName(suffix) {
        return this.bound.getName(suffix);
    }
    async _mergeConfig(...options) {
        const config = (0, _configJs.mergeConfigs)(this.config, ...options);
        return (0, _configJs.mergeConfigs)(config, ...this.configFactories ? await Promise.all(this.configFactories.map(async (configFactory)=>await configFactory(config))) : []);
    }
    bind(kwargs) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new this.constructor({
            bound: this.bound,
            kwargs: {
                ...this.kwargs,
                ...kwargs
            },
            config: this.config
        });
    }
    withConfig(config) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new this.constructor({
            bound: this.bound,
            kwargs: this.kwargs,
            config: {
                ...this.config,
                ...config
            }
        });
    }
    withRetry(fields) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new this.constructor({
            bound: this.bound.withRetry(fields),
            kwargs: this.kwargs,
            config: this.config
        });
    }
    async invoke(input, options) {
        return this.bound.invoke(input, await this._mergeConfig((0, _configJs.ensureConfig)(options), this.kwargs));
    }
    async batch(inputs, options, batchOptions) {
        const mergedOptions = Array.isArray(options) ? await Promise.all(options.map(async (individualOption)=>this._mergeConfig((0, _configJs.ensureConfig)(individualOption), this.kwargs))) : await this._mergeConfig((0, _configJs.ensureConfig)(options), this.kwargs);
        return this.bound.batch(inputs, mergedOptions, batchOptions);
    }
    async *_streamIterator(input, options) {
        yield* this.bound._streamIterator(input, await this._mergeConfig((0, _configJs.ensureConfig)(options), this.kwargs));
    }
    async stream(input, options) {
        return this.bound.stream(input, await this._mergeConfig((0, _configJs.ensureConfig)(options), this.kwargs));
    }
    async *transform(generator, options) {
        yield* this.bound.transform(generator, await this._mergeConfig((0, _configJs.ensureConfig)(options), this.kwargs));
    }
    streamEvents(input, options, streamOptions) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const outerThis = this;
        const generator = async function*() {
            yield* outerThis.bound.streamEvents(input, {
                ...await outerThis._mergeConfig((0, _configJs.ensureConfig)(options), outerThis.kwargs),
                version: options.version
            }, streamOptions);
        };
        return (0, _streamJs.IterableReadableStream).fromAsyncGenerator(generator());
    }
    static isRunnableBinding(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    thing) {
        return thing.bound && Runnable.isRunnable(thing.bound);
    }
    /**
     * Bind lifecycle listeners to a Runnable, returning a new Runnable.
     * The Run object contains information about the run, including its id,
     * type, input, output, error, startTime, endTime, and any tags or metadata
     * added to the run.
     *
     * @param {Object} params - The object containing the callback functions.
     * @param {(run: Run) => void} params.onStart - Called before the runnable starts running, with the Run object.
     * @param {(run: Run) => void} params.onEnd - Called after the runnable finishes running, with the Run object.
     * @param {(run: Run) => void} params.onError - Called if the runnable throws an error, with the Run object.
     */ withListeners({ onStart, onEnd, onError }) {
        return new RunnableBinding({
            bound: this.bound,
            kwargs: this.kwargs,
            config: this.config,
            configFactories: [
                (config)=>({
                        callbacks: [
                            new (0, _rootListenerJs.RootListenersTracer)({
                                config,
                                onStart,
                                onEnd,
                                onError
                            })
                        ]
                    })
            ]
        });
    }
}
class RunnableEach extends Runnable {
    static lc_name() {
        return "RunnableEach";
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        Object.defineProperty(this, "bound", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.bound = fields.bound;
    }
    /**
     * Binds the runnable with the specified arguments.
     * @param kwargs The arguments to bind the runnable with.
     * @returns A new instance of the `RunnableEach` class that is bound with the specified arguments.
     */ bind(kwargs) {
        return new RunnableEach({
            bound: this.bound.bind(kwargs)
        });
    }
    /**
     * Invokes the runnable with the specified input and configuration.
     * @param input The input to invoke the runnable with.
     * @param config The configuration to invoke the runnable with.
     * @returns A promise that resolves to the output of the runnable.
     */ async invoke(inputs, config) {
        return this._callWithConfig(this._invoke.bind(this), inputs, config);
    }
    /**
     * A helper method that is used to invoke the runnable with the specified input and configuration.
     * @param input The input to invoke the runnable with.
     * @param config The configuration to invoke the runnable with.
     * @returns A promise that resolves to the output of the runnable.
     */ async _invoke(inputs, config, runManager) {
        return this.bound.batch(inputs, (0, _configJs.patchConfig)(config, {
            callbacks: runManager?.getChild()
        }));
    }
    /**
     * Bind lifecycle listeners to a Runnable, returning a new Runnable.
     * The Run object contains information about the run, including its id,
     * type, input, output, error, startTime, endTime, and any tags or metadata
     * added to the run.
     *
     * @param {Object} params - The object containing the callback functions.
     * @param {(run: Run) => void} params.onStart - Called before the runnable starts running, with the Run object.
     * @param {(run: Run) => void} params.onEnd - Called after the runnable finishes running, with the Run object.
     * @param {(run: Run) => void} params.onError - Called if the runnable throws an error, with the Run object.
     */ withListeners({ onStart, onEnd, onError }) {
        return new RunnableEach({
            bound: this.bound.withListeners({
                onStart,
                onEnd,
                onError
            })
        });
    }
}
class RunnableRetry extends RunnableBinding {
    static lc_name() {
        return "RunnableRetry";
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        Object.defineProperty(this, "maxAttemptNumber", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "onFailedAttempt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ()=>{}
        });
        this.maxAttemptNumber = fields.maxAttemptNumber ?? this.maxAttemptNumber;
        this.onFailedAttempt = fields.onFailedAttempt ?? this.onFailedAttempt;
    }
    _patchConfigForRetry(attempt, config, runManager) {
        const tag = attempt > 1 ? `retry:attempt:${attempt}` : undefined;
        return (0, _configJs.patchConfig)(config, {
            callbacks: runManager?.getChild(tag)
        });
    }
    async _invoke(input, config, runManager) {
        return (0, _pRetryDefault.default)((attemptNumber)=>super.invoke(input, this._patchConfigForRetry(attemptNumber, config, runManager)), {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onFailedAttempt: (error)=>this.onFailedAttempt(error, input),
            retries: Math.max(this.maxAttemptNumber - 1, 0),
            randomize: true
        });
    }
    /**
     * Method that invokes the runnable with the specified input, run manager,
     * and config. It handles the retry logic by catching any errors and
     * recursively invoking itself with the updated config for the next retry
     * attempt.
     * @param input The input for the runnable.
     * @param runManager The run manager for the runnable.
     * @param config The config for the runnable.
     * @returns A promise that resolves to the output of the runnable.
     */ async invoke(input, config) {
        return this._callWithConfig(this._invoke.bind(this), input, config);
    }
    async _batch(inputs, configs, runManagers, batchOptions) {
        const resultsMap = {};
        try {
            await (0, _pRetryDefault.default)(async (attemptNumber)=>{
                const remainingIndexes = inputs.map((_, i)=>i).filter((i)=>resultsMap[i.toString()] === undefined || // eslint-disable-next-line no-instanceof/no-instanceof
                    resultsMap[i.toString()] instanceof Error);
                const remainingInputs = remainingIndexes.map((i)=>inputs[i]);
                const patchedConfigs = remainingIndexes.map((i)=>this._patchConfigForRetry(attemptNumber, configs?.[i], runManagers?.[i]));
                const results = await super.batch(remainingInputs, patchedConfigs, {
                    ...batchOptions,
                    returnExceptions: true
                });
                let firstException;
                for(let i = 0; i < results.length; i += 1){
                    const result = results[i];
                    const resultMapIndex = remainingIndexes[i];
                    // eslint-disable-next-line no-instanceof/no-instanceof
                    if (result instanceof Error) {
                        if (firstException === undefined) {
                            firstException = result;
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            firstException.input = remainingInputs[i];
                        }
                    }
                    resultsMap[resultMapIndex.toString()] = result;
                }
                if (firstException) throw firstException;
                return results;
            }, {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onFailedAttempt: (error)=>this.onFailedAttempt(error, error.input),
                retries: Math.max(this.maxAttemptNumber - 1, 0),
                randomize: true
            });
        } catch (e) {
            if (batchOptions?.returnExceptions !== true) throw e;
        }
        return Object.keys(resultsMap).sort((a, b)=>parseInt(a, 10) - parseInt(b, 10)).map((key)=>resultsMap[parseInt(key, 10)]);
    }
    async batch(inputs, options, batchOptions) {
        return this._batchWithConfig(this._batch.bind(this), inputs, options, batchOptions);
    }
}
class RunnableSequence extends Runnable {
    static lc_name() {
        return "RunnableSequence";
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "first", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "middle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "last", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "omitSequenceTags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        this.first = fields.first;
        this.middle = fields.middle ?? this.middle;
        this.last = fields.last;
        this.name = fields.name;
        this.omitSequenceTags = fields.omitSequenceTags ?? this.omitSequenceTags;
    }
    get steps() {
        return [
            this.first,
            ...this.middle,
            this.last
        ];
    }
    async invoke(input, options) {
        const config = (0, _configJs.ensureConfig)(options);
        const callbackManager_ = await (0, _configJs.getCallbackManagerForConfig)(config);
        const runManager = await callbackManager_?.handleChainStart(this.toJSON(), _coerceToDict(input, "input"), config.runId, undefined, undefined, undefined, config?.runName);
        delete config.runId;
        let nextStepInput = input;
        let finalOutput;
        try {
            const initialSteps = [
                this.first,
                ...this.middle
            ];
            for(let i = 0; i < initialSteps.length; i += 1){
                const step = initialSteps[i];
                const promise = step.invoke(nextStepInput, (0, _configJs.patchConfig)(config, {
                    callbacks: runManager?.getChild(this.omitSequenceTags ? undefined : `seq:step:${i + 1}`)
                }));
                nextStepInput = await (0, _signalJs.raceWithSignal)(promise, options?.signal);
            }
            // TypeScript can't detect that the last output of the sequence returns RunOutput, so call it out of the loop here
            if (options?.signal?.aborted) throw new Error("Aborted");
            finalOutput = await this.last.invoke(nextStepInput, (0, _configJs.patchConfig)(config, {
                callbacks: runManager?.getChild(this.omitSequenceTags ? undefined : `seq:step:${this.steps.length}`)
            }));
        } catch (e) {
            await runManager?.handleChainError(e);
            throw e;
        }
        await runManager?.handleChainEnd(_coerceToDict(finalOutput, "output"));
        return finalOutput;
    }
    async batch(inputs, options, batchOptions) {
        const configList = this._getOptionsList(options ?? {}, inputs.length);
        const callbackManagers = await Promise.all(configList.map((0, _configJs.getCallbackManagerForConfig)));
        const runManagers = await Promise.all(callbackManagers.map(async (callbackManager, i)=>{
            const handleStartRes = await callbackManager?.handleChainStart(this.toJSON(), _coerceToDict(inputs[i], "input"), configList[i].runId, undefined, undefined, undefined, configList[i].runName);
            delete configList[i].runId;
            return handleStartRes;
        }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let nextStepInputs = inputs;
        try {
            for(let i = 0; i < this.steps.length; i += 1){
                const step = this.steps[i];
                const promise = step.batch(nextStepInputs, runManagers.map((runManager, j)=>{
                    const childRunManager = runManager?.getChild(this.omitSequenceTags ? undefined : `seq:step:${i + 1}`);
                    return (0, _configJs.patchConfig)(configList[j], {
                        callbacks: childRunManager
                    });
                }), batchOptions);
                nextStepInputs = await (0, _signalJs.raceWithSignal)(promise, configList[0]?.signal);
            }
        } catch (e) {
            await Promise.all(runManagers.map((runManager)=>runManager?.handleChainError(e)));
            throw e;
        }
        await Promise.all(runManagers.map((runManager)=>runManager?.handleChainEnd(_coerceToDict(nextStepInputs, "output"))));
        return nextStepInputs;
    }
    async *_streamIterator(input, options) {
        const callbackManager_ = await (0, _configJs.getCallbackManagerForConfig)(options);
        const { runId, ...otherOptions } = options ?? {};
        const runManager = await callbackManager_?.handleChainStart(this.toJSON(), _coerceToDict(input, "input"), runId, undefined, undefined, undefined, otherOptions?.runName);
        const steps = [
            this.first,
            ...this.middle,
            this.last
        ];
        let concatSupported = true;
        let finalOutput;
        async function* inputGenerator() {
            yield input;
        }
        try {
            let finalGenerator = steps[0].transform(inputGenerator(), (0, _configJs.patchConfig)(otherOptions, {
                callbacks: runManager?.getChild(this.omitSequenceTags ? undefined : `seq:step:1`)
            }));
            for(let i = 1; i < steps.length; i += 1){
                const step = steps[i];
                finalGenerator = await step.transform(finalGenerator, (0, _configJs.patchConfig)(otherOptions, {
                    callbacks: runManager?.getChild(this.omitSequenceTags ? undefined : `seq:step:${i + 1}`)
                }));
            }
            for await (const chunk of finalGenerator){
                options?.signal?.throwIfAborted();
                yield chunk;
                if (concatSupported) {
                    if (finalOutput === undefined) finalOutput = chunk;
                    else try {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        finalOutput = (0, _streamJs.concat)(finalOutput, chunk);
                    } catch (e) {
                        finalOutput = undefined;
                        concatSupported = false;
                    }
                }
            }
        } catch (e) {
            await runManager?.handleChainError(e);
            throw e;
        }
        await runManager?.handleChainEnd(_coerceToDict(finalOutput, "output"));
    }
    getGraph(config) {
        const graph = new (0, _graphJs.Graph)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let currentLastNode = null;
        this.steps.forEach((step, index)=>{
            const stepGraph = step.getGraph(config);
            if (index !== 0) stepGraph.trimFirstNode();
            if (index !== this.steps.length - 1) stepGraph.trimLastNode();
            graph.extend(stepGraph);
            const stepFirstNode = stepGraph.firstNode();
            if (!stepFirstNode) throw new Error(`Runnable ${step} has no first node`);
            if (currentLastNode) graph.addEdge(currentLastNode, stepFirstNode);
            currentLastNode = stepGraph.lastNode();
        });
        return graph;
    }
    pipe(coerceable) {
        if (RunnableSequence.isRunnableSequence(coerceable)) return new RunnableSequence({
            first: this.first,
            middle: this.middle.concat([
                this.last,
                coerceable.first,
                ...coerceable.middle
            ]),
            last: coerceable.last,
            name: this.name ?? coerceable.name
        });
        else return new RunnableSequence({
            first: this.first,
            middle: [
                ...this.middle,
                this.last
            ],
            last: _coerceToRunnable(coerceable),
            name: this.name
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isRunnableSequence(thing) {
        return Array.isArray(thing.middle) && Runnable.isRunnable(thing);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static from([first, ...runnables], nameOrFields) {
        let extra = {};
        if (typeof nameOrFields === "string") extra.name = nameOrFields;
        else if (nameOrFields !== undefined) extra = nameOrFields;
        return new RunnableSequence({
            ...extra,
            first: _coerceToRunnable(first),
            middle: runnables.slice(0, -1).map(_coerceToRunnable),
            last: _coerceToRunnable(runnables[runnables.length - 1])
        });
    }
}
class RunnableMap extends Runnable {
    static lc_name() {
        return "RunnableMap";
    }
    getStepsKeys() {
        return Object.keys(this.steps);
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "steps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.steps = {};
        for (const [key, value] of Object.entries(fields.steps))this.steps[key] = _coerceToRunnable(value);
    }
    static from(steps) {
        return new RunnableMap({
            steps
        });
    }
    async invoke(input, options) {
        const config = (0, _configJs.ensureConfig)(options);
        const callbackManager_ = await (0, _configJs.getCallbackManagerForConfig)(config);
        const runManager = await callbackManager_?.handleChainStart(this.toJSON(), {
            input
        }, config.runId, undefined, undefined, undefined, config?.runName);
        delete config.runId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const output = {};
        try {
            const promises = Object.entries(this.steps).map(async ([key, runnable])=>{
                output[key] = await runnable.invoke(input, (0, _configJs.patchConfig)(config, {
                    callbacks: runManager?.getChild(`map:key:${key}`)
                }));
            });
            await (0, _signalJs.raceWithSignal)(Promise.all(promises), options?.signal);
        } catch (e) {
            await runManager?.handleChainError(e);
            throw e;
        }
        await runManager?.handleChainEnd(output);
        return output;
    }
    async *_transform(generator, runManager, options) {
        // shallow copy steps to ignore changes while iterating
        const steps = {
            ...this.steps
        };
        // each step gets a copy of the input iterator
        const inputCopies = (0, _streamJs.atee)(generator, Object.keys(steps).length);
        // start the first iteration of each output iterator
        const tasks = new Map(Object.entries(steps).map(([key, runnable], i)=>{
            const gen = runnable.transform(inputCopies[i], (0, _configJs.patchConfig)(options, {
                callbacks: runManager?.getChild(`map:key:${key}`)
            }));
            return [
                key,
                gen.next().then((result)=>({
                        key,
                        gen,
                        result
                    }))
            ];
        }));
        // yield chunks as they become available,
        // starting new iterations as needed,
        // until all iterators are done
        while(tasks.size){
            const promise = Promise.race(tasks.values());
            const { key, result, gen } = await (0, _signalJs.raceWithSignal)(promise, options?.signal);
            tasks.delete(key);
            if (!result.done) {
                yield {
                    [key]: result.value
                };
                tasks.set(key, gen.next().then((result)=>({
                        key,
                        gen,
                        result
                    })));
            }
        }
    }
    transform(generator, options) {
        return this._transformStreamWithConfig(generator, this._transform.bind(this), options);
    }
    async stream(input, options) {
        async function* generator() {
            yield input;
        }
        const config = (0, _configJs.ensureConfig)(options);
        const wrappedGenerator = new (0, _streamJs.AsyncGeneratorWithSetup)({
            generator: this.transform(generator(), config),
            config
        });
        await wrappedGenerator.setup;
        return (0, _streamJs.IterableReadableStream).fromAsyncGenerator(wrappedGenerator);
    }
}
class RunnableTraceable extends Runnable {
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        Object.defineProperty(this, "func", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (!(0, _traceable.isTraceableFunction)(fields.func)) throw new Error("RunnableTraceable requires a function that is wrapped in traceable higher-order function");
        this.func = fields.func;
    }
    async invoke(input, options) {
        const [config] = this._getOptionsList(options ?? {}, 1);
        const callbacks = await (0, _configJs.getCallbackManagerForConfig)(config);
        const promise = this.func((0, _configJs.patchConfig)(config, {
            callbacks
        }), input);
        return (0, _signalJs.raceWithSignal)(promise, config?.signal);
    }
    async *_streamIterator(input, options) {
        const [config] = this._getOptionsList(options ?? {}, 1);
        const result = await this.invoke(input, options);
        if ((0, _iterJs.isAsyncIterable)(result)) {
            for await (const item of result){
                config?.signal?.throwIfAborted();
                yield item;
            }
            return;
        }
        if ((0, _iterJs.isIterator)(result)) {
            while(true){
                config?.signal?.throwIfAborted();
                const state = result.next();
                if (state.done) break;
                yield state.value;
            }
            return;
        }
        yield result;
    }
    static from(func) {
        return new RunnableTraceable({
            func
        });
    }
}
function assertNonTraceableFunction(func) {
    if ((0, _traceable.isTraceableFunction)(func)) throw new Error("RunnableLambda requires a function that is not wrapped in traceable higher-order function. This shouldn't happen.");
}
class RunnableLambda extends Runnable {
    static lc_name() {
        return "RunnableLambda";
    }
    constructor(fields){
        if ((0, _traceable.isTraceableFunction)(fields.func)) // eslint-disable-next-line no-constructor-return
        return RunnableTraceable.from(fields.func);
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        Object.defineProperty(this, "func", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        assertNonTraceableFunction(fields.func);
        this.func = fields.func;
    }
    static from(func) {
        return new RunnableLambda({
            func
        });
    }
    async _invoke(input, config, runManager) {
        return new Promise((resolve, reject)=>{
            const childConfig = (0, _configJs.patchConfig)(config, {
                callbacks: runManager?.getChild(),
                recursionLimit: (config?.recursionLimit ?? (0, _configJs.DEFAULT_RECURSION_LIMIT)) - 1
            });
            (0, _indexJs.AsyncLocalStorageProviderSingleton).runWithConfig(childConfig, async ()=>{
                try {
                    let output = await this.func(input, {
                        ...childConfig
                    });
                    if (output && Runnable.isRunnable(output)) {
                        if (config?.recursionLimit === 0) throw new Error("Recursion limit reached.");
                        output = await output.invoke(input, {
                            ...childConfig,
                            recursionLimit: (childConfig.recursionLimit ?? (0, _configJs.DEFAULT_RECURSION_LIMIT)) - 1
                        });
                    } else if ((0, _iterJs.isAsyncIterable)(output)) {
                        let finalOutput;
                        for await (const chunk of (0, _iterJs.consumeAsyncIterableInContext)(childConfig, output)){
                            config?.signal?.throwIfAborted();
                            if (finalOutput === undefined) finalOutput = chunk;
                            else // Make a best effort to gather, for any type that supports concat.
                            try {
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                finalOutput = (0, _streamJs.concat)(finalOutput, chunk);
                            } catch (e) {
                                finalOutput = chunk;
                            }
                        }
                        output = finalOutput;
                    } else if ((0, _iterJs.isIterableIterator)(output)) {
                        let finalOutput;
                        for (const chunk of (0, _iterJs.consumeIteratorInContext)(childConfig, output)){
                            config?.signal?.throwIfAborted();
                            if (finalOutput === undefined) finalOutput = chunk;
                            else // Make a best effort to gather, for any type that supports concat.
                            try {
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                finalOutput = (0, _streamJs.concat)(finalOutput, chunk);
                            } catch (e) {
                                finalOutput = chunk;
                            }
                        }
                        output = finalOutput;
                    }
                    resolve(output);
                } catch (e) {
                    reject(e);
                }
            });
        });
    }
    async invoke(input, options) {
        return this._callWithConfig(this._invoke.bind(this), input, options);
    }
    async *_transform(generator, runManager, config) {
        let finalChunk;
        for await (const chunk of generator){
            if (finalChunk === undefined) finalChunk = chunk;
            else // Make a best effort to gather, for any type that supports concat.
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                finalChunk = (0, _streamJs.concat)(finalChunk, chunk);
            } catch (e) {
                finalChunk = chunk;
            }
        }
        const childConfig = (0, _configJs.patchConfig)(config, {
            callbacks: runManager?.getChild(),
            recursionLimit: (config?.recursionLimit ?? (0, _configJs.DEFAULT_RECURSION_LIMIT)) - 1
        });
        const output = await new Promise((resolve, reject)=>{
            (0, _indexJs.AsyncLocalStorageProviderSingleton).runWithConfig(childConfig, async ()=>{
                try {
                    const res = await this.func(finalChunk, {
                        ...childConfig,
                        config: childConfig
                    });
                    resolve(res);
                } catch (e) {
                    reject(e);
                }
            });
        });
        if (output && Runnable.isRunnable(output)) {
            if (config?.recursionLimit === 0) throw new Error("Recursion limit reached.");
            const stream = await output.stream(finalChunk, childConfig);
            for await (const chunk of stream)yield chunk;
        } else if ((0, _iterJs.isAsyncIterable)(output)) for await (const chunk of (0, _iterJs.consumeAsyncIterableInContext)(childConfig, output)){
            config?.signal?.throwIfAborted();
            yield chunk;
        }
        else if ((0, _iterJs.isIterableIterator)(output)) for (const chunk of (0, _iterJs.consumeIteratorInContext)(childConfig, output)){
            config?.signal?.throwIfAborted();
            yield chunk;
        }
        else yield output;
    }
    transform(generator, options) {
        return this._transformStreamWithConfig(generator, this._transform.bind(this), options);
    }
    async stream(input, options) {
        async function* generator() {
            yield input;
        }
        const config = (0, _configJs.ensureConfig)(options);
        const wrappedGenerator = new (0, _streamJs.AsyncGeneratorWithSetup)({
            generator: this.transform(generator(), config),
            config
        });
        await wrappedGenerator.setup;
        return (0, _streamJs.IterableReadableStream).fromAsyncGenerator(wrappedGenerator);
    }
}
class RunnableParallel extends RunnableMap {
}
class RunnableWithFallbacks extends Runnable {
    static lc_name() {
        return "RunnableWithFallbacks";
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "runnable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fallbacks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.runnable = fields.runnable;
        this.fallbacks = fields.fallbacks;
    }
    *runnables() {
        yield this.runnable;
        for (const fallback of this.fallbacks)yield fallback;
    }
    async invoke(input, options) {
        const config = (0, _configJs.ensureConfig)(options);
        const callbackManager_ = await (0, _configJs.getCallbackManagerForConfig)(options);
        const { runId, ...otherConfigFields } = config;
        const runManager = await callbackManager_?.handleChainStart(this.toJSON(), _coerceToDict(input, "input"), runId, undefined, undefined, undefined, otherConfigFields?.runName);
        let firstError;
        for (const runnable of this.runnables()){
            config?.signal?.throwIfAborted();
            try {
                const output = await runnable.invoke(input, (0, _configJs.patchConfig)(otherConfigFields, {
                    callbacks: runManager?.getChild()
                }));
                await runManager?.handleChainEnd(_coerceToDict(output, "output"));
                return output;
            } catch (e) {
                if (firstError === undefined) firstError = e;
            }
        }
        if (firstError === undefined) throw new Error("No error stored at end of fallback.");
        await runManager?.handleChainError(firstError);
        throw firstError;
    }
    async *_streamIterator(input, options) {
        const config = (0, _configJs.ensureConfig)(options);
        const callbackManager_ = await (0, _configJs.getCallbackManagerForConfig)(options);
        const { runId, ...otherConfigFields } = config;
        const runManager = await callbackManager_?.handleChainStart(this.toJSON(), _coerceToDict(input, "input"), runId, undefined, undefined, undefined, otherConfigFields?.runName);
        let firstError;
        let stream;
        for (const runnable of this.runnables()){
            config?.signal?.throwIfAborted();
            const childConfig = (0, _configJs.patchConfig)(otherConfigFields, {
                callbacks: runManager?.getChild()
            });
            try {
                stream = await runnable.stream(input, childConfig);
                break;
            } catch (e) {
                if (firstError === undefined) firstError = e;
            }
        }
        if (stream === undefined) {
            const error = firstError ?? new Error("No error stored at end of fallback.");
            await runManager?.handleChainError(error);
            throw error;
        }
        let output;
        try {
            for await (const chunk of stream){
                yield chunk;
                try {
                    output = output === undefined ? output : (0, _streamJs.concat)(output, chunk);
                } catch (e) {
                    output = undefined;
                }
            }
        } catch (e) {
            await runManager?.handleChainError(e);
            throw e;
        }
        await runManager?.handleChainEnd(_coerceToDict(output, "output"));
    }
    async batch(inputs, options, batchOptions) {
        if (batchOptions?.returnExceptions) throw new Error("Not implemented.");
        const configList = this._getOptionsList(options ?? {}, inputs.length);
        const callbackManagers = await Promise.all(configList.map((config)=>(0, _configJs.getCallbackManagerForConfig)(config)));
        const runManagers = await Promise.all(callbackManagers.map(async (callbackManager, i)=>{
            const handleStartRes = await callbackManager?.handleChainStart(this.toJSON(), _coerceToDict(inputs[i], "input"), configList[i].runId, undefined, undefined, undefined, configList[i].runName);
            delete configList[i].runId;
            return handleStartRes;
        }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let firstError;
        for (const runnable of this.runnables()){
            configList[0].signal?.throwIfAborted();
            try {
                const outputs = await runnable.batch(inputs, runManagers.map((runManager, j)=>(0, _configJs.patchConfig)(configList[j], {
                        callbacks: runManager?.getChild()
                    })), batchOptions);
                await Promise.all(runManagers.map((runManager, i)=>runManager?.handleChainEnd(_coerceToDict(outputs[i], "output"))));
                return outputs;
            } catch (e) {
                if (firstError === undefined) firstError = e;
            }
        }
        if (!firstError) throw new Error("No error stored at end of fallbacks.");
        await Promise.all(runManagers.map((runManager)=>runManager?.handleChainError(firstError)));
        throw firstError;
    }
}
function _coerceToRunnable(coerceable) {
    if (typeof coerceable === "function") return new RunnableLambda({
        func: coerceable
    });
    else if (Runnable.isRunnable(coerceable)) return coerceable;
    else if (!Array.isArray(coerceable) && typeof coerceable === "object") {
        const runnables = {};
        for (const [key, value] of Object.entries(coerceable))runnables[key] = _coerceToRunnable(value);
        return new RunnableMap({
            steps: runnables
        });
    } else throw new Error(`Expected a Runnable, function or object.\nInstead got an unsupported type.`);
}
class RunnableAssign extends Runnable {
    static lc_name() {
        return "RunnableAssign";
    }
    constructor(fields){
        // eslint-disable-next-line no-instanceof/no-instanceof
        if (fields instanceof RunnableMap) // eslint-disable-next-line no-param-reassign
        fields = {
            mapper: fields
        };
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "mapper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.mapper = fields.mapper;
    }
    async invoke(input, options) {
        const mapperResult = await this.mapper.invoke(input, options);
        return {
            ...input,
            ...mapperResult
        };
    }
    async *_transform(generator, runManager, options) {
        // collect mapper keys
        const mapperKeys = this.mapper.getStepsKeys();
        // create two input gens, one for the mapper, one for the input
        const [forPassthrough, forMapper] = (0, _streamJs.atee)(generator);
        // create mapper output gen
        const mapperOutput = this.mapper.transform(forMapper, (0, _configJs.patchConfig)(options, {
            callbacks: runManager?.getChild()
        }));
        // start the mapper
        const firstMapperChunkPromise = mapperOutput.next();
        // yield the passthrough
        for await (const chunk of forPassthrough){
            if (typeof chunk !== "object" || Array.isArray(chunk)) throw new Error(`RunnableAssign can only be used with objects as input, got ${typeof chunk}`);
            const filtered = Object.fromEntries(Object.entries(chunk).filter(([key])=>!mapperKeys.includes(key)));
            if (Object.keys(filtered).length > 0) yield filtered;
        }
        // yield the mapper output
        yield (await firstMapperChunkPromise).value;
        for await (const chunk of mapperOutput)yield chunk;
    }
    transform(generator, options) {
        return this._transformStreamWithConfig(generator, this._transform.bind(this), options);
    }
    async stream(input, options) {
        async function* generator() {
            yield input;
        }
        const config = (0, _configJs.ensureConfig)(options);
        const wrappedGenerator = new (0, _streamJs.AsyncGeneratorWithSetup)({
            generator: this.transform(generator(), config),
            config
        });
        await wrappedGenerator.setup;
        return (0, _streamJs.IterableReadableStream).fromAsyncGenerator(wrappedGenerator);
    }
}
class RunnablePick extends Runnable {
    static lc_name() {
        return "RunnablePick";
    }
    constructor(fields){
        if (typeof fields === "string" || Array.isArray(fields)) // eslint-disable-next-line no-param-reassign
        fields = {
            keys: fields
        };
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "keys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.keys = fields.keys;
    }
    async _pick(input) {
        if (typeof this.keys === "string") return input[this.keys];
        else {
            const picked = this.keys.map((key)=>[
                    key,
                    input[key]
                ]).filter((v)=>v[1] !== undefined);
            return picked.length === 0 ? undefined : Object.fromEntries(picked);
        }
    }
    async invoke(input, options) {
        return this._callWithConfig(this._pick.bind(this), input, options);
    }
    async *_transform(generator) {
        for await (const chunk of generator){
            const picked = await this._pick(chunk);
            if (picked !== undefined) yield picked;
        }
    }
    transform(generator, options) {
        return this._transformStreamWithConfig(generator, this._transform.bind(this), options);
    }
    async stream(input, options) {
        async function* generator() {
            yield input;
        }
        const config = (0, _configJs.ensureConfig)(options);
        const wrappedGenerator = new (0, _streamJs.AsyncGeneratorWithSetup)({
            generator: this.transform(generator(), config),
            config
        });
        await wrappedGenerator.setup;
        return (0, _streamJs.IterableReadableStream).fromAsyncGenerator(wrappedGenerator);
    }
}
class RunnableToolLike extends RunnableBinding {
    constructor(fields){
        const sequence = RunnableSequence.from([
            RunnableLambda.from(async (input)=>{
                let toolInput;
                if ((0, _utilsJs1._isToolCall)(input)) try {
                    toolInput = await this.schema.parseAsync(input.args);
                } catch (e) {
                    throw new (0, _utilsJs1.ToolInputParsingException)(`Received tool input did not match expected schema`, JSON.stringify(input.args));
                }
                else toolInput = input;
                return toolInput;
            }).withConfig({
                runName: `${fields.name}:parse_input`
            }),
            fields.bound
        ]).withConfig({
            runName: fields.name
        });
        super({
            bound: sequence,
            config: fields.config ?? {}
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = fields.name;
        this.description = fields.description;
        this.schema = fields.schema;
    }
    static lc_name() {
        return "RunnableToolLike";
    }
}
function convertRunnableToTool(runnable, fields) {
    const name = fields.name ?? runnable.getName();
    const description = fields.description ?? fields.schema?.description;
    if (fields.schema.constructor === (0, _zod.z).ZodString) return new RunnableToolLike({
        name,
        description,
        schema: (0, _zod.z).object({
            input: (0, _zod.z).string()
        }).transform((input)=>input.input),
        bound: runnable
    });
    return new RunnableToolLike({
        name,
        description,
        schema: fields.schema,
        bound: runnable
    });
}

},{"zod":"juM82","p-retry":"jLLyx","uuid":"klst7","langsmith/singletons/traceable":"7bXzs","../tracers/log_stream.js":"icv9w","../tracers/event_stream.js":"5udSK","../load/serializable.js":"2n7FI","../utils/stream.js":"kAAca","../utils/signal.js":"hneUc","./config.js":"2gQun","../utils/async_caller.js":"9E8gp","../tracers/root_listener.js":"6w96a","./utils.js":"hG9iM","../singletons/index.js":"1O31N","./graph.js":"9F5Ur","./wrappers.js":"EXGD7","./iter.js":"ekoPe","../tools/utils.js":"vJeFM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"juM82":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BRAND", ()=>BRAND);
parcelHelpers.export(exports, "DIRTY", ()=>DIRTY);
parcelHelpers.export(exports, "EMPTY_PATH", ()=>EMPTY_PATH);
parcelHelpers.export(exports, "INVALID", ()=>INVALID);
parcelHelpers.export(exports, "NEVER", ()=>NEVER);
parcelHelpers.export(exports, "OK", ()=>OK);
parcelHelpers.export(exports, "ParseStatus", ()=>ParseStatus);
parcelHelpers.export(exports, "Schema", ()=>ZodType);
parcelHelpers.export(exports, "ZodAny", ()=>ZodAny);
parcelHelpers.export(exports, "ZodArray", ()=>ZodArray);
parcelHelpers.export(exports, "ZodBigInt", ()=>ZodBigInt);
parcelHelpers.export(exports, "ZodBoolean", ()=>ZodBoolean);
parcelHelpers.export(exports, "ZodBranded", ()=>ZodBranded);
parcelHelpers.export(exports, "ZodCatch", ()=>ZodCatch);
parcelHelpers.export(exports, "ZodDate", ()=>ZodDate);
parcelHelpers.export(exports, "ZodDefault", ()=>ZodDefault);
parcelHelpers.export(exports, "ZodDiscriminatedUnion", ()=>ZodDiscriminatedUnion);
parcelHelpers.export(exports, "ZodEffects", ()=>ZodEffects);
parcelHelpers.export(exports, "ZodEnum", ()=>ZodEnum);
parcelHelpers.export(exports, "ZodError", ()=>ZodError);
parcelHelpers.export(exports, "ZodFirstPartyTypeKind", ()=>ZodFirstPartyTypeKind);
parcelHelpers.export(exports, "ZodFunction", ()=>ZodFunction);
parcelHelpers.export(exports, "ZodIntersection", ()=>ZodIntersection);
parcelHelpers.export(exports, "ZodIssueCode", ()=>ZodIssueCode);
parcelHelpers.export(exports, "ZodLazy", ()=>ZodLazy);
parcelHelpers.export(exports, "ZodLiteral", ()=>ZodLiteral);
parcelHelpers.export(exports, "ZodMap", ()=>ZodMap);
parcelHelpers.export(exports, "ZodNaN", ()=>ZodNaN);
parcelHelpers.export(exports, "ZodNativeEnum", ()=>ZodNativeEnum);
parcelHelpers.export(exports, "ZodNever", ()=>ZodNever);
parcelHelpers.export(exports, "ZodNull", ()=>ZodNull);
parcelHelpers.export(exports, "ZodNullable", ()=>ZodNullable);
parcelHelpers.export(exports, "ZodNumber", ()=>ZodNumber);
parcelHelpers.export(exports, "ZodObject", ()=>ZodObject);
parcelHelpers.export(exports, "ZodOptional", ()=>ZodOptional);
parcelHelpers.export(exports, "ZodParsedType", ()=>ZodParsedType);
parcelHelpers.export(exports, "ZodPipeline", ()=>ZodPipeline);
parcelHelpers.export(exports, "ZodPromise", ()=>ZodPromise);
parcelHelpers.export(exports, "ZodReadonly", ()=>ZodReadonly);
parcelHelpers.export(exports, "ZodRecord", ()=>ZodRecord);
parcelHelpers.export(exports, "ZodSchema", ()=>ZodType);
parcelHelpers.export(exports, "ZodSet", ()=>ZodSet);
parcelHelpers.export(exports, "ZodString", ()=>ZodString);
parcelHelpers.export(exports, "ZodSymbol", ()=>ZodSymbol);
parcelHelpers.export(exports, "ZodTransformer", ()=>ZodEffects);
parcelHelpers.export(exports, "ZodTuple", ()=>ZodTuple);
parcelHelpers.export(exports, "ZodType", ()=>ZodType);
parcelHelpers.export(exports, "ZodUndefined", ()=>ZodUndefined);
parcelHelpers.export(exports, "ZodUnion", ()=>ZodUnion);
parcelHelpers.export(exports, "ZodUnknown", ()=>ZodUnknown);
parcelHelpers.export(exports, "ZodVoid", ()=>ZodVoid);
parcelHelpers.export(exports, "addIssueToContext", ()=>addIssueToContext);
parcelHelpers.export(exports, "any", ()=>anyType);
parcelHelpers.export(exports, "array", ()=>arrayType);
parcelHelpers.export(exports, "bigint", ()=>bigIntType);
parcelHelpers.export(exports, "boolean", ()=>booleanType);
parcelHelpers.export(exports, "coerce", ()=>coerce);
parcelHelpers.export(exports, "custom", ()=>custom);
parcelHelpers.export(exports, "date", ()=>dateType);
parcelHelpers.export(exports, "datetimeRegex", ()=>datetimeRegex);
parcelHelpers.export(exports, "default", ()=>z);
parcelHelpers.export(exports, "defaultErrorMap", ()=>errorMap);
parcelHelpers.export(exports, "discriminatedUnion", ()=>discriminatedUnionType);
parcelHelpers.export(exports, "effect", ()=>effectsType);
parcelHelpers.export(exports, "enum", ()=>enumType);
parcelHelpers.export(exports, "function", ()=>functionType);
parcelHelpers.export(exports, "getErrorMap", ()=>getErrorMap);
parcelHelpers.export(exports, "getParsedType", ()=>getParsedType);
parcelHelpers.export(exports, "instanceof", ()=>instanceOfType);
parcelHelpers.export(exports, "intersection", ()=>intersectionType);
parcelHelpers.export(exports, "isAborted", ()=>isAborted);
parcelHelpers.export(exports, "isAsync", ()=>isAsync);
parcelHelpers.export(exports, "isDirty", ()=>isDirty);
parcelHelpers.export(exports, "isValid", ()=>isValid);
parcelHelpers.export(exports, "late", ()=>late);
parcelHelpers.export(exports, "lazy", ()=>lazyType);
parcelHelpers.export(exports, "literal", ()=>literalType);
parcelHelpers.export(exports, "makeIssue", ()=>makeIssue);
parcelHelpers.export(exports, "map", ()=>mapType);
parcelHelpers.export(exports, "nan", ()=>nanType);
parcelHelpers.export(exports, "nativeEnum", ()=>nativeEnumType);
parcelHelpers.export(exports, "never", ()=>neverType);
parcelHelpers.export(exports, "null", ()=>nullType);
parcelHelpers.export(exports, "nullable", ()=>nullableType);
parcelHelpers.export(exports, "number", ()=>numberType);
parcelHelpers.export(exports, "object", ()=>objectType);
parcelHelpers.export(exports, "objectUtil", ()=>objectUtil);
parcelHelpers.export(exports, "oboolean", ()=>oboolean);
parcelHelpers.export(exports, "onumber", ()=>onumber);
parcelHelpers.export(exports, "optional", ()=>optionalType);
parcelHelpers.export(exports, "ostring", ()=>ostring);
parcelHelpers.export(exports, "pipeline", ()=>pipelineType);
parcelHelpers.export(exports, "preprocess", ()=>preprocessType);
parcelHelpers.export(exports, "promise", ()=>promiseType);
parcelHelpers.export(exports, "quotelessJson", ()=>quotelessJson);
parcelHelpers.export(exports, "record", ()=>recordType);
parcelHelpers.export(exports, "set", ()=>setType);
parcelHelpers.export(exports, "setErrorMap", ()=>setErrorMap);
parcelHelpers.export(exports, "strictObject", ()=>strictObjectType);
parcelHelpers.export(exports, "string", ()=>stringType);
parcelHelpers.export(exports, "symbol", ()=>symbolType);
parcelHelpers.export(exports, "transformer", ()=>effectsType);
parcelHelpers.export(exports, "tuple", ()=>tupleType);
parcelHelpers.export(exports, "undefined", ()=>undefinedType);
parcelHelpers.export(exports, "union", ()=>unionType);
parcelHelpers.export(exports, "unknown", ()=>unknownType);
parcelHelpers.export(exports, "util", ()=>util);
parcelHelpers.export(exports, "void", ()=>voidType);
parcelHelpers.export(exports, "z", ()=>z);
var util;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const getParsedType = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return ZodParsedType.array;
            if (data === null) return ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return ZodParsedType.date;
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};
const ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const quotelessJson = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof ZodError)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors,
            fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues)=>{
    const error = new ZodError(issues);
    return error;
};
const errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else util.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return {
        message
    };
};
let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}
const makeIssue = (params)=>{
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const overrideMap = getErrorMap();
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === errorMap ? undefined : errorMap
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return INVALID;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key,
                value
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key, value } = pair;
            if (key.status === "aborted") return INVALID;
            if (value.status === "aborted") return INVALID;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const INVALID = Object.freeze({
    status: "aborted"
});
const DIRTY = (value)=>({
        status: "dirty",
        value
    });
const OK = (value)=>({
        status: "valid",
        value
    });
const isAborted = (x)=>x.status === "aborted";
const isDirty = (x)=>x.status === "dirty";
const isValid = (x)=>x.status === "valid";
const isAsync = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));
var _ZodEnum_cache, _ZodNativeEnum_cache;
class ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result)=>{
    if (isValid(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function processCreateParams(params) {
    if (!params) return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description
    };
}
class ZodType {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data)
        };
        const result = this._parseSync({
            data,
            path: ctx.path,
            parent: ctx
        });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data)
        };
        const maybeAsyncResult = this._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
        const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: ZodIssueCode.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "refinement",
                refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this, this._def);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "transform",
                transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
// faster, simpler, safer
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) return true;
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!emojiRegex) emojiRegex = new RegExp(_emojiRegex, "u");
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "emoji",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "nanoid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid2",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ulid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                addIssueToContext(ctx, {
                    validation: "url",
                    code: ZodIssueCode.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "duration",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ip",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "base64",
                        code: ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params)=>{
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params)=>{
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params)
    });
};
class ZodBigInt extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.bigint,
                received: ctx.parsedType
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params)=>{
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params)
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params)=>{
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params)
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else util.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params)=>{
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params)
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.symbol,
                received: ctx.parsedType
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodSymbol.create = (params)=>{
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params)
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params)=>{
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params)
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params)=>{
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params)
    });
};
class ZodAny extends ZodType {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params)=>{
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params)
    });
};
class ZodUnknown extends ZodType {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params)=>{
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params)
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType
        });
        return INVALID;
    }
}
ZodNever.create = (params)=>{
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params)
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params)=>{
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params)
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType
            });
            return INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                addIssueToContext(ctx, {
                    code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return ParseStatus.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: {
                value: minLength,
                message: errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: {
                value: len,
                message: errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params)=>{
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params)
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof ZodArray) return new ZodArray({
        ...schema._def,
        type: deepPartialify(schema.element)
    });
    else if (schema instanceof ZodOptional) return ZodOptional.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodNullable) return ZodNullable.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodTuple) return ZodTuple.create(schema.items.map((item)=>deepPartialify(item)));
    else return schema;
}
class ZodObject extends ZodType {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        return this._cached = {
            shape,
            keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key,
                    value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return ParseStatus.mergeObjectSync(status, syncPairs);
        });
        else return ParseStatus.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: ZodFirstPartyTypeKind.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        util.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        util.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof ZodOptional)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return createZodEnum(util.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.strictCreate = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.lazycreate = (shape, params)=>{
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors
            });
            return INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params)=>{
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type)=>{
    if (type instanceof ZodLazy) return getDiscriminator(type.schema);
    else if (type instanceof ZodEffects) return getDiscriminator(type.innerType());
    else if (type instanceof ZodLiteral) return [
        type.value
    ];
    else if (type instanceof ZodEnum) return type.options;
    else if (type instanceof ZodNativeEnum) // eslint-disable-next-line ban/ban
    return util.objectValues(type.enum);
    else if (type instanceof ZodDefault) return getDiscriminator(type._def.innerType);
    else if (type instanceof ZodUndefined) return [
        undefined
    ];
    else if (type instanceof ZodNull) return [
        null
    ];
    else if (type instanceof ZodOptional) return [
        undefined,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodNullable) return [
        null,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodBranded) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodReadonly) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodCatch) return getDiscriminator(type._def.innerType);
    else return [];
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params)
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b);
        const sharedKeys = util.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if (isAborted(parsedLeft) || isAborted(parsedRight)) return INVALID;
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
ZodIntersection.create = (left, right, params)=>{
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params)
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return ParseStatus.mergeArray(status, results);
        });
        else return ParseStatus.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest
        });
    }
}
ZodTuple.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params)
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return ParseStatus.mergeObjectAsync(status, pairs);
        else return ParseStatus.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) return new ZodRecord({
            keyType: first,
            valueType: second,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(third)
        });
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second)
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
ZodMap.create = (keyType, valueType, params)=>{
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params)
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: {
                value: minSize,
                message: errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params)=>{
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params)
    });
};
class ZodFunction extends ZodType {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(async function(...args) {
                const error = new ZodError([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new ZodError([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new ZodError([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create())
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params)
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
ZodLazy.create = (getter, params)=>{
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params)
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value
            });
            return INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params)=>{
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params)
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params)
    });
}
class ZodEnum extends ZodType {
    constructor(){
        super(...arguments);
        _ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type
            });
            return INVALID;
        }
        if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f")) __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values), "f");
        if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return ZodEnum.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return ZodEnum.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
_ZodEnum_cache = new WeakMap();
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    constructor(){
        super(...arguments);
        _ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type
            });
            return INVALID;
        }
        if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f")) __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util.getValidEnumValues(this._def.values)), "f");
        if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
_ZodNativeEnum_cache = new WeakMap();
ZodNativeEnum.create = (values, params)=>{
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params)
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
        return OK(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
ZodPromise.create = (schema, params)=>{
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params)
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                addIssueToContext(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return INVALID;
                if (result.status === "dirty") return DIRTY(result.value);
                if (status.value === "dirty") return DIRTY(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return INVALID;
                if (result.status === "dirty") return DIRTY(result.value);
                if (status.value === "dirty") return DIRTY(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!isValid(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!isValid(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        util.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params)=>{
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params)
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params)=>{
    return new ZodEffects({
        schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params)
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) return OK(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params)=>{
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params)
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) return OK(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params)=>{
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params)
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params)=>{
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...processCreateParams(params)
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if (isAsync(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new ZodError(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new ZodError(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params)=>{
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...processCreateParams(params)
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType
            });
            return INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
ZodNaN.create = (params)=>{
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params)
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return DIRTY(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if (isValid(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return isAsync(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodReadonly.create = (type, params)=>{
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params)
    });
};
function custom(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return ZodAny.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return ZodAny.create();
}
const late = {
    object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>custom((data)=>data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = ()=>stringType().optional();
const onumber = ()=>numberType().optional();
const oboolean = ()=>booleanType().optional();
const coerce = {
    string: (arg)=>ZodString.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>ZodNumber.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>ZodBoolean.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>ZodBigInt.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>ZodDate.create({
            ...arg,
            coerce: true
        })
};
const NEVER = INVALID;
var z = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () {
        return util;
    },
    get objectUtil () {
        return objectUtil;
    },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    datetimeRegex: datetimeRegex,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () {
        return ZodFirstPartyTypeKind;
    },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"icv9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * List of jsonpatch JSONPatchOperations, which describe how to create the run state
 * from an empty dict. This is the minimal representation of the log, designed to
 * be serialized as JSON and sent over the wire to reconstruct the log on the other
 * side. Reconstruction of the state can be done with any jsonpatch-compliant library,
 * see https://jsonpatch.com for more information.
 */ parcelHelpers.export(exports, "RunLogPatch", ()=>RunLogPatch);
parcelHelpers.export(exports, "RunLog", ()=>RunLog);
parcelHelpers.export(exports, "isLogStreamHandler", ()=>isLogStreamHandler);
/**
 * Class that extends the `BaseTracer` class from the
 * `langchain.callbacks.tracers.base` module. It represents a callback
 * handler that logs the execution of runs and emits `RunLog` instances to a
 * `RunLogStream`.
 */ parcelHelpers.export(exports, "LogStreamCallbackHandler", ()=>LogStreamCallbackHandler);
var _indexJs = require("../utils/fast-json-patch/index.js");
var _baseJs = require("./base.js");
var _streamJs = require("../utils/stream.js");
var _aiJs = require("../messages/ai.js");
class RunLogPatch {
    constructor(fields){
        Object.defineProperty(this, "ops", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.ops = fields.ops ?? [];
    }
    concat(other) {
        const ops = this.ops.concat(other.ops);
        const states = (0, _indexJs.applyPatch)({}, ops);
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return new RunLog({
            ops,
            state: states[states.length - 1].newDocument
        });
    }
}
class RunLog extends RunLogPatch {
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.state = fields.state;
    }
    concat(other) {
        const ops = this.ops.concat(other.ops);
        const states = (0, _indexJs.applyPatch)(this.state, other.ops);
        return new RunLog({
            ops,
            state: states[states.length - 1].newDocument
        });
    }
    static fromRunLogPatch(patch) {
        const states = (0, _indexJs.applyPatch)({}, patch.ops);
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return new RunLog({
            ops: patch.ops,
            state: states[states.length - 1].newDocument
        });
    }
}
const isLogStreamHandler = (handler)=>handler.name === "log_stream_tracer";
/**
 * Extract standardized inputs from a run.
 *
 * Standardizes the inputs based on the type of the runnable used.
 *
 * @param run - Run object
 * @param schemaFormat - The schema format to use.
 *
 * @returns Valid inputs are only dict. By conventions, inputs always represented
 * invocation using named arguments.
 * A null means that the input is not yet known!
 */ async function _getStandardizedInputs(run, schemaFormat) {
    if (schemaFormat === "original") throw new Error("Do not assign inputs with original schema drop the key for now. When inputs are added to streamLog they should be added with standardized schema for streaming events.");
    const { inputs } = run;
    if ([
        "retriever",
        "llm",
        "prompt"
    ].includes(run.run_type)) return inputs;
    if (Object.keys(inputs).length === 1 && inputs?.input === "") return undefined;
    // new style chains
    // These nest an additional 'input' key inside the 'inputs' to make sure
    // the input is always a dict. We need to unpack and user the inner value.
    // We should try to fix this in Runnables and callbacks/tracers
    // Runnables should be using a null type here not a placeholder
    // dict.
    return inputs.input;
}
async function _getStandardizedOutputs(run, schemaFormat) {
    const { outputs } = run;
    if (schemaFormat === "original") // Return the old schema, without standardizing anything
    return outputs;
    if ([
        "retriever",
        "llm",
        "prompt"
    ].includes(run.run_type)) return outputs;
    // TODO: Remove this hacky check
    if (outputs !== undefined && Object.keys(outputs).length === 1 && outputs?.output !== undefined) return outputs.output;
    return outputs;
}
function isChatGenerationChunk(x) {
    return x !== undefined && x.message !== undefined;
}
class LogStreamCallbackHandler extends (0, _baseJs.BaseTracer) {
    constructor(fields){
        super({
            _awaitHandler: true,
            ...fields
        });
        Object.defineProperty(this, "autoClose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "includeNames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "includeTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "includeTags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "excludeNames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "excludeTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "excludeTags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_schemaFormat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "original"
        });
        Object.defineProperty(this, "rootId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "keyMapByRunId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "counterMapByRunName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "transformStream", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "writer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "receiveStream", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "log_stream_tracer"
        });
        this.autoClose = fields?.autoClose ?? true;
        this.includeNames = fields?.includeNames;
        this.includeTypes = fields?.includeTypes;
        this.includeTags = fields?.includeTags;
        this.excludeNames = fields?.excludeNames;
        this.excludeTypes = fields?.excludeTypes;
        this.excludeTags = fields?.excludeTags;
        this._schemaFormat = fields?._schemaFormat ?? this._schemaFormat;
        this.transformStream = new TransformStream();
        this.writer = this.transformStream.writable.getWriter();
        this.receiveStream = (0, _streamJs.IterableReadableStream).fromReadableStream(this.transformStream.readable);
    }
    [Symbol.asyncIterator]() {
        return this.receiveStream;
    }
    async persistRun(_run) {
    // This is a legacy method only called once for an entire run tree
    // and is therefore not useful here
    }
    _includeRun(run) {
        if (run.id === this.rootId) return false;
        const runTags = run.tags ?? [];
        let include = this.includeNames === undefined && this.includeTags === undefined && this.includeTypes === undefined;
        if (this.includeNames !== undefined) include = include || this.includeNames.includes(run.name);
        if (this.includeTypes !== undefined) include = include || this.includeTypes.includes(run.run_type);
        if (this.includeTags !== undefined) include = include || runTags.find((tag)=>this.includeTags?.includes(tag)) !== undefined;
        if (this.excludeNames !== undefined) include = include && !this.excludeNames.includes(run.name);
        if (this.excludeTypes !== undefined) include = include && !this.excludeTypes.includes(run.run_type);
        if (this.excludeTags !== undefined) include = include && runTags.every((tag)=>!this.excludeTags?.includes(tag));
        return include;
    }
    async *tapOutputIterable(runId, output) {
        // Tap an output async iterator to stream its values to the log.
        for await (const chunk of output){
            // root run is handled in .streamLog()
            if (runId !== this.rootId) {
                // if we can't find the run silently ignore
                // eg. because this run wasn't included in the log
                const key = this.keyMapByRunId[runId];
                if (key) await this.writer.write(new RunLogPatch({
                    ops: [
                        {
                            op: "add",
                            path: `/logs/${key}/streamed_output/-`,
                            value: chunk
                        }
                    ]
                }));
            }
            yield chunk;
        }
    }
    async onRunCreate(run) {
        if (this.rootId === undefined) {
            this.rootId = run.id;
            await this.writer.write(new RunLogPatch({
                ops: [
                    {
                        op: "replace",
                        path: "",
                        value: {
                            id: run.id,
                            name: run.name,
                            type: run.run_type,
                            streamed_output: [],
                            final_output: undefined,
                            logs: {}
                        }
                    }
                ]
            }));
        }
        if (!this._includeRun(run)) return;
        if (this.counterMapByRunName[run.name] === undefined) this.counterMapByRunName[run.name] = 0;
        this.counterMapByRunName[run.name] += 1;
        const count = this.counterMapByRunName[run.name];
        this.keyMapByRunId[run.id] = count === 1 ? run.name : `${run.name}:${count}`;
        const logEntry = {
            id: run.id,
            name: run.name,
            type: run.run_type,
            tags: run.tags ?? [],
            metadata: run.extra?.metadata ?? {},
            start_time: new Date(run.start_time).toISOString(),
            streamed_output: [],
            streamed_output_str: [],
            final_output: undefined,
            end_time: undefined
        };
        if (this._schemaFormat === "streaming_events") logEntry.inputs = await _getStandardizedInputs(run, this._schemaFormat);
        await this.writer.write(new RunLogPatch({
            ops: [
                {
                    op: "add",
                    path: `/logs/${this.keyMapByRunId[run.id]}`,
                    value: logEntry
                }
            ]
        }));
    }
    async onRunUpdate(run) {
        try {
            const runName = this.keyMapByRunId[run.id];
            if (runName === undefined) return;
            const ops = [];
            if (this._schemaFormat === "streaming_events") ops.push({
                op: "replace",
                path: `/logs/${runName}/inputs`,
                value: await _getStandardizedInputs(run, this._schemaFormat)
            });
            ops.push({
                op: "add",
                path: `/logs/${runName}/final_output`,
                value: await _getStandardizedOutputs(run, this._schemaFormat)
            });
            if (run.end_time !== undefined) ops.push({
                op: "add",
                path: `/logs/${runName}/end_time`,
                value: new Date(run.end_time).toISOString()
            });
            const patch = new RunLogPatch({
                ops
            });
            await this.writer.write(patch);
        } finally{
            if (run.id === this.rootId) {
                const patch = new RunLogPatch({
                    ops: [
                        {
                            op: "replace",
                            path: "/final_output",
                            value: await _getStandardizedOutputs(run, this._schemaFormat)
                        }
                    ]
                });
                await this.writer.write(patch);
                if (this.autoClose) await this.writer.close();
            }
        }
    }
    async onLLMNewToken(run, token, kwargs) {
        const runName = this.keyMapByRunId[run.id];
        if (runName === undefined) return;
        // TODO: Remove hack
        const isChatModel = run.inputs.messages !== undefined;
        let streamedOutputValue;
        if (isChatModel) {
            if (isChatGenerationChunk(kwargs?.chunk)) streamedOutputValue = kwargs?.chunk;
            else streamedOutputValue = new (0, _aiJs.AIMessageChunk)({
                id: `run-${run.id}`,
                content: token
            });
        } else streamedOutputValue = token;
        const patch = new RunLogPatch({
            ops: [
                {
                    op: "add",
                    path: `/logs/${runName}/streamed_output_str/-`,
                    value: token
                },
                {
                    op: "add",
                    path: `/logs/${runName}/streamed_output/-`,
                    value: streamedOutputValue
                }
            ]
        });
        await this.writer.write(patch);
    }
}

},{"../utils/fast-json-patch/index.js":"3yqxp","./base.js":"5VkRj","../utils/stream.js":"kAAca","../messages/ai.js":"lkFVb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3yqxp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JsonPatchError", ()=>(0, _helpersJs.PatchError));
parcelHelpers.export(exports, "deepClone", ()=>(0, _helpersJs._deepClone));
parcelHelpers.export(exports, "escapePathComponent", ()=>(0, _helpersJs.escapePathComponent));
parcelHelpers.export(exports, "unescapePathComponent", ()=>(0, _helpersJs.unescapePathComponent));
var _coreJs = require("./src/core.js");
parcelHelpers.exportAll(_coreJs, exports);
var _duplexJs = require("./src/duplex.js");
parcelHelpers.exportAll(_duplexJs, exports);
var _helpersJs = require("./src/helpers.js");
exports.default = {
    ..._coreJs,
    JsonPatchError: // ...duplex,
    (0, _helpersJs.PatchError),
    deepClone: (0, _helpersJs._deepClone),
    escapePathComponent: (0, _helpersJs.escapePathComponent),
    unescapePathComponent: (0, _helpersJs.unescapePathComponent)
};

},{"./src/core.js":"b99b0","./src/duplex.js":"b9a5H","./src/helpers.js":"fK1Sm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b99b0":[function(require,module,exports,__globalThis) {
// @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JsonPatchError", ()=>JsonPatchError);
parcelHelpers.export(exports, "deepClone", ()=>deepClone);
/**
 * Retrieves a value from a JSON document by a JSON pointer.
 * Returns the value.
 *
 * @param document The document to get the value from
 * @param pointer an escaped JSON pointer
 * @return The retrieved value
 */ parcelHelpers.export(exports, "getValueByPointer", ()=>getValueByPointer);
/**
 * Apply a single JSON Patch Operation on a JSON document.
 * Returns the {newDocument, result} of the operation.
 * It modifies the `document` and `operation` objects - it gets the values by reference.
 * If you would like to avoid touching your values, clone them:
 * `jsonpatch.applyOperation(document, jsonpatch._deepClone(operation))`.
 *
 * @param document The document to patch
 * @param operation The operation to apply
 * @param validateOperation `false` is without validation, `true` to use default jsonpatch's validation, or you can pass a `validateOperation` callback to be used for validation.
 * @param mutateDocument Whether to mutate the original document or clone it before applying
 * @param banPrototypeModifications Whether to ban modifications to `__proto__`, defaults to `true`.
 * @return `{newDocument, result}` after the operation
 */ parcelHelpers.export(exports, "applyOperation", ()=>applyOperation);
/**
 * Apply a full JSON Patch array on a JSON document.
 * Returns the {newDocument, result} of the patch.
 * It modifies the `document` object and `patch` - it gets the values by reference.
 * If you would like to avoid touching your values, clone them:
 * `jsonpatch.applyPatch(document, jsonpatch._deepClone(patch))`.
 *
 * @param document The document to patch
 * @param patch The patch to apply
 * @param validateOperation `false` is without validation, `true` to use default jsonpatch's validation, or you can pass a `validateOperation` callback to be used for validation.
 * @param mutateDocument Whether to mutate the original document or clone it before applying
 * @param banPrototypeModifications Whether to ban modifications to `__proto__`, defaults to `true`.
 * @return An array of `{newDocument, result}` after the patch
 */ parcelHelpers.export(exports, "applyPatch", ()=>applyPatch);
/**
 * Apply a single JSON Patch Operation on a JSON document.
 * Returns the updated document.
 * Suitable as a reducer.
 *
 * @param document The document to patch
 * @param operation The operation to apply
 * @return The updated document
 */ parcelHelpers.export(exports, "applyReducer", ()=>applyReducer);
/**
 * Validates a single operation. Called from `jsonpatch.validate`. Throws `JsonPatchError` in case of an error.
 * @param {object} operation - operation object (patch)
 * @param {number} index - index of operation in the sequence
 * @param {object} [document] - object where the operation is supposed to be applied
 * @param {string} [existingPathFragment] - comes along with `document`
 */ parcelHelpers.export(exports, "validator", ()=>validator);
/**
 * Validates a sequence of operations. If `document` parameter is provided, the sequence is additionally validated against the object document.
 * If error is encountered, returns a JsonPatchError object
 * @param sequence
 * @param document
 * @returns {JsonPatchError|undefined}
 */ parcelHelpers.export(exports, "validate", ()=>validate);
// based on https://github.com/epoberezkin/fast-deep-equal
// MIT License
// Copyright (c) 2017 Evgeny Poberezkin
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
parcelHelpers.export(exports, "_areEquals", ()=>_areEquals);
var _helpersJs = require("./helpers.js");
const JsonPatchError = (0, _helpersJs.PatchError);
const deepClone = (0, _helpersJs._deepClone);
/* We use a Javascript hash to store each
 function. Each hash entry (property) uses
 the operation identifiers specified in rfc6902.
 In this way, we can map each patch operation
 to its dedicated function in efficient way.
 */ /* The operations applicable to an object */ const objOps = {
    add: function(obj, key, document) {
        obj[key] = this.value;
        return {
            newDocument: document
        };
    },
    remove: function(obj, key, document) {
        var removed = obj[key];
        delete obj[key];
        return {
            newDocument: document,
            removed
        };
    },
    replace: function(obj, key, document) {
        var removed = obj[key];
        obj[key] = this.value;
        return {
            newDocument: document,
            removed
        };
    },
    move: function(obj, key, document) {
        /* in case move target overwrites an existing value,
        return the removed value, this can be taxing performance-wise,
        and is potentially unneeded */ let removed = getValueByPointer(document, this.path);
        if (removed) removed = (0, _helpersJs._deepClone)(removed);
        const originalValue = applyOperation(document, {
            op: "remove",
            path: this.from
        }).removed;
        applyOperation(document, {
            op: "add",
            path: this.path,
            value: originalValue
        });
        return {
            newDocument: document,
            removed
        };
    },
    copy: function(obj, key, document) {
        const valueToCopy = getValueByPointer(document, this.from);
        // enforce copy by value so further operations don't affect source (see issue #177)
        applyOperation(document, {
            op: "add",
            path: this.path,
            value: (0, _helpersJs._deepClone)(valueToCopy)
        });
        return {
            newDocument: document
        };
    },
    test: function(obj, key, document) {
        return {
            newDocument: document,
            test: _areEquals(obj[key], this.value)
        };
    },
    _get: function(obj, key, document) {
        this.value = obj[key];
        return {
            newDocument: document
        };
    }
};
/* The operations applicable to an array. Many are the same as for the object */ var arrOps = {
    add: function(arr, i, document) {
        if ((0, _helpersJs.isInteger)(i)) arr.splice(i, 0, this.value);
        else // array props
        arr[i] = this.value;
        // this may be needed when using '-' in an array
        return {
            newDocument: document,
            index: i
        };
    },
    remove: function(arr, i, document) {
        var removedList = arr.splice(i, 1);
        return {
            newDocument: document,
            removed: removedList[0]
        };
    },
    replace: function(arr, i, document) {
        var removed = arr[i];
        arr[i] = this.value;
        return {
            newDocument: document,
            removed
        };
    },
    move: objOps.move,
    copy: objOps.copy,
    test: objOps.test,
    _get: objOps._get
};
function getValueByPointer(document, pointer) {
    if (pointer == "") return document;
    var getOriginalDestination = {
        op: "_get",
        path: pointer
    };
    applyOperation(document, getOriginalDestination);
    return getOriginalDestination.value;
}
function applyOperation(document, operation, validateOperation = false, mutateDocument = true, banPrototypeModifications = true, index = 0) {
    if (validateOperation) {
        if (typeof validateOperation == "function") validateOperation(operation, 0, document, operation.path);
        else validator(operation, 0);
    }
    /* ROOT OPERATIONS */ if (operation.path === "") {
        let returnValue = {
            newDocument: document
        };
        if (operation.op === "add") {
            returnValue.newDocument = operation.value;
            return returnValue;
        } else if (operation.op === "replace") {
            returnValue.newDocument = operation.value;
            returnValue.removed = document; //document we removed
            return returnValue;
        } else if (operation.op === "move" || operation.op === "copy") {
            // it's a move or copy to root
            returnValue.newDocument = getValueByPointer(document, operation.from); // get the value by json-pointer in `from` field
            if (operation.op === "move") // report removed item
            returnValue.removed = document;
            return returnValue;
        } else if (operation.op === "test") {
            returnValue.test = _areEquals(document, operation.value);
            if (returnValue.test === false) throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", index, operation, document);
            returnValue.newDocument = document;
            return returnValue;
        } else if (operation.op === "remove") {
            // a remove on root
            returnValue.removed = document;
            returnValue.newDocument = null;
            return returnValue;
        } else if (operation.op === "_get") {
            operation.value = document;
            return returnValue;
        } else {
            /* bad operation */ if (validateOperation) throw new JsonPatchError("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", index, operation, document);
            else return returnValue;
        }
    } else {
        if (!mutateDocument) document = (0, _helpersJs._deepClone)(document);
        const path = operation.path || "";
        const keys = path.split("/");
        let obj = document;
        let t = 1; //skip empty element - http://jsperf.com/to-shift-or-not-to-shift
        let len = keys.length;
        let existingPathFragment = undefined;
        let key;
        let validateFunction;
        if (typeof validateOperation == "function") validateFunction = validateOperation;
        else validateFunction = validator;
        while(true){
            key = keys[t];
            if (key && key.indexOf("~") != -1) key = (0, _helpersJs.unescapePathComponent)(key);
            if (banPrototypeModifications && (key == "__proto__" || key == "prototype" && t > 0 && keys[t - 1] == "constructor")) throw new TypeError("JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
            if (validateOperation) {
                if (existingPathFragment === undefined) {
                    if (obj[key] === undefined) existingPathFragment = keys.slice(0, t).join("/");
                    else if (t == len - 1) existingPathFragment = operation.path;
                    if (existingPathFragment !== undefined) validateFunction(operation, 0, document, existingPathFragment);
                }
            }
            t++;
            if (Array.isArray(obj)) {
                if (key === "-") key = obj.length;
                else {
                    if (validateOperation && !(0, _helpersJs.isInteger)(key)) throw new JsonPatchError("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", index, operation, document);
                    else if ((0, _helpersJs.isInteger)(key)) key = ~~key;
                }
                if (t >= len) {
                    if (validateOperation && operation.op === "add" && key > obj.length) throw new JsonPatchError("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", index, operation, document);
                    const returnValue = arrOps[operation.op].call(operation, obj, key, document); // Apply patch
                    if (returnValue.test === false) throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", index, operation, document);
                    return returnValue;
                }
            } else if (t >= len) {
                const returnValue = objOps[operation.op].call(operation, obj, key, document); // Apply patch
                if (returnValue.test === false) throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", index, operation, document);
                return returnValue;
            }
            obj = obj[key];
            // If we have more keys in the path, but the next value isn't a non-null object,
            // throw an OPERATION_PATH_UNRESOLVABLE error instead of iterating again.
            if (validateOperation && t < len && (!obj || typeof obj !== "object")) throw new JsonPatchError("Cannot perform operation at the desired path", "OPERATION_PATH_UNRESOLVABLE", index, operation, document);
        }
    }
}
function applyPatch(document, patch, validateOperation, mutateDocument = true, banPrototypeModifications = true) {
    if (validateOperation) {
        if (!Array.isArray(patch)) throw new JsonPatchError("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    }
    if (!mutateDocument) document = (0, _helpersJs._deepClone)(document);
    const results = new Array(patch.length);
    for(let i = 0, length = patch.length; i < length; i++){
        // we don't need to pass mutateDocument argument because if it was true, we already deep cloned the object, we'll just pass `true`
        results[i] = applyOperation(document, patch[i], validateOperation, true, banPrototypeModifications, i);
        document = results[i].newDocument; // in case root was replaced
    }
    results.newDocument = document;
    return results;
}
function applyReducer(document, operation, index) {
    const operationResult = applyOperation(document, operation);
    if (operationResult.test === false) // failed test
    throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", index, operation, document);
    return operationResult.newDocument;
}
function validator(operation, index, document, existingPathFragment) {
    if (typeof operation !== "object" || operation === null || Array.isArray(operation)) throw new JsonPatchError("Operation is not an object", "OPERATION_NOT_AN_OBJECT", index, operation, document);
    else if (!objOps[operation.op]) throw new JsonPatchError("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", index, operation, document);
    else if (typeof operation.path !== "string") throw new JsonPatchError("Operation `path` property is not a string", "OPERATION_PATH_INVALID", index, operation, document);
    else if (operation.path.indexOf("/") !== 0 && operation.path.length > 0) // paths that aren't empty string should start with "/"
    throw new JsonPatchError('Operation `path` property must start with "/"', "OPERATION_PATH_INVALID", index, operation, document);
    else if ((operation.op === "move" || operation.op === "copy") && typeof operation.from !== "string") throw new JsonPatchError("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", index, operation, document);
    else if ((operation.op === "add" || operation.op === "replace" || operation.op === "test") && operation.value === undefined) throw new JsonPatchError("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", index, operation, document);
    else if ((operation.op === "add" || operation.op === "replace" || operation.op === "test") && (0, _helpersJs.hasUndefined)(operation.value)) throw new JsonPatchError("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", index, operation, document);
    else if (document) {
        if (operation.op == "add") {
            var pathLen = operation.path.split("/").length;
            var existingPathLen = existingPathFragment.split("/").length;
            if (pathLen !== existingPathLen + 1 && pathLen !== existingPathLen) throw new JsonPatchError("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", index, operation, document);
        } else if (operation.op === "replace" || operation.op === "remove" || operation.op === "_get") {
            if (operation.path !== existingPathFragment) throw new JsonPatchError("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", index, operation, document);
        } else if (operation.op === "move" || operation.op === "copy") {
            var existingValue = {
                op: "_get",
                path: operation.from,
                value: undefined
            };
            var error = validate([
                existingValue
            ], document);
            if (error && error.name === "OPERATION_PATH_UNRESOLVABLE") throw new JsonPatchError("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", index, operation, document);
        }
    }
}
function validate(sequence, document, externalValidator) {
    try {
        if (!Array.isArray(sequence)) throw new JsonPatchError("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
        if (document) //clone document and sequence so that we can safely try applying operations
        applyPatch((0, _helpersJs._deepClone)(document), (0, _helpersJs._deepClone)(sequence), externalValidator || true);
        else {
            externalValidator = externalValidator || validator;
            for(var i = 0; i < sequence.length; i++)externalValidator(sequence[i], i, document, undefined);
        }
    } catch (e) {
        if (e instanceof JsonPatchError) return e;
        else throw e;
    }
}
function _areEquals(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = Array.isArray(a), arrB = Array.isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!_areEquals(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!b.hasOwnProperty(keys[i])) return false;
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (!_areEquals(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}

},{"./helpers.js":"fK1Sm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fK1Sm":[function(require,module,exports,__globalThis) {
// @ts-nocheck
// Inlined because of ESM import issues
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2022 Joachim Wester
 * MIT licensed
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasOwnProperty", ()=>hasOwnProperty);
parcelHelpers.export(exports, "_objectKeys", ()=>_objectKeys);
/**
 * Deeply clone the object.
 * https://jsperf.com/deep-copy-vs-json-stringify-json-parse/25 (recursiveDeepCopy)
 * @param  {any} obj value to clone
 * @return {any} cloned obj
 */ parcelHelpers.export(exports, "_deepClone", ()=>_deepClone);
//3x faster than cached /^\d+$/.test(str)
parcelHelpers.export(exports, "isInteger", ()=>isInteger);
/**
 * Escapes a json pointer path
 * @param path The raw pointer
 * @return the Escaped path
 */ parcelHelpers.export(exports, "escapePathComponent", ()=>escapePathComponent);
/**
 * Unescapes a json pointer path
 * @param path The escaped pointer
 * @return The unescaped path
 */ parcelHelpers.export(exports, "unescapePathComponent", ()=>unescapePathComponent);
parcelHelpers.export(exports, "_getPathRecursive", ()=>_getPathRecursive);
parcelHelpers.export(exports, "getPath", ()=>getPath);
/**
 * Recursively checks whether an object has any undefined values inside.
 */ parcelHelpers.export(exports, "hasUndefined", ()=>hasUndefined);
parcelHelpers.export(exports, "PatchError", ()=>PatchError);
const _hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty(obj, key) {
    return _hasOwnProperty.call(obj, key);
}
function _objectKeys(obj) {
    if (Array.isArray(obj)) {
        const keys = new Array(obj.length);
        for(let k = 0; k < keys.length; k++)keys[k] = "" + k;
        return keys;
    }
    if (Object.keys) return Object.keys(obj);
    let keys = [];
    for(let i in obj)if (hasOwnProperty(obj, i)) keys.push(i);
    return keys;
}
function _deepClone(obj) {
    switch(typeof obj){
        case "object":
            return JSON.parse(JSON.stringify(obj)); //Faster than ES5 clone - http://jsperf.com/deep-cloning-of-objects/5
        case "undefined":
            return null; //this is how JSON.stringify behaves for array items
        default:
            return obj; //no need to clone primitives
    }
}
function isInteger(str) {
    let i = 0;
    const len = str.length;
    let charCode;
    while(i < len){
        charCode = str.charCodeAt(i);
        if (charCode >= 48 && charCode <= 57) {
            i++;
            continue;
        }
        return false;
    }
    return true;
}
function escapePathComponent(path) {
    if (path.indexOf("/") === -1 && path.indexOf("~") === -1) return path;
    return path.replace(/~/g, "~0").replace(/\//g, "~1");
}
function unescapePathComponent(path) {
    return path.replace(/~1/g, "/").replace(/~0/g, "~");
}
function _getPathRecursive(root, obj) {
    let found;
    for(let key in root)if (hasOwnProperty(root, key)) {
        if (root[key] === obj) return escapePathComponent(key) + "/";
        else if (typeof root[key] === "object") {
            found = _getPathRecursive(root[key], obj);
            if (found != "") return escapePathComponent(key) + "/" + found;
        }
    }
    return "";
}
function getPath(root, obj) {
    if (root === obj) return "/";
    const path = _getPathRecursive(root, obj);
    if (path === "") throw new Error("Object not found in root");
    return `/${path}`;
}
function hasUndefined(obj) {
    if (obj === undefined) return true;
    if (obj) {
        if (Array.isArray(obj)) for(let i = 0, len = obj.length; i < len; i++){
            if (hasUndefined(obj[i])) return true;
        }
        else if (typeof obj === "object") {
            const objKeys = _objectKeys(obj);
            const objKeysLength = objKeys.length;
            for(var i = 0; i < objKeysLength; i++){
                if (hasUndefined(obj[objKeys[i]])) return true;
            }
        }
    }
    return false;
}
function patchErrorMessageFormatter(message, args) {
    const messageParts = [
        message
    ];
    for(const key in args){
        const value = typeof args[key] === "object" ? JSON.stringify(args[key], null, 2) : args[key]; // pretty print
        if (typeof value !== "undefined") messageParts.push(`${key}: ${value}`);
    }
    return messageParts.join("\n");
}
class PatchError extends Error {
    constructor(message, name, index, operation, tree){
        super(patchErrorMessageFormatter(message, {
            name,
            index,
            operation,
            tree
        }));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: name
        });
        Object.defineProperty(this, "index", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: index
        });
        Object.defineProperty(this, "operation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: operation
        });
        Object.defineProperty(this, "tree", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: tree
        });
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain, see https://stackoverflow.com/a/48342359
        this.message = patchErrorMessageFormatter(message, {
            name,
            index,
            operation,
            tree
        });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b9a5H":[function(require,module,exports,__globalThis) {
// @ts-nocheck
// Inlined because of ESM import issues
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2013-2021 Joachim Wester
 * MIT license
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Detach an observer from an object
 */ parcelHelpers.export(exports, "unobserve", ()=>unobserve);
/**
 * Observes changes made to an object, which can then be retrieved using generate
 */ parcelHelpers.export(exports, "observe", ()=>observe);
/**
 * Generate an array of patches from an observer
 */ parcelHelpers.export(exports, "generate", ()=>generate);
/**
 * Create an array of patches from the differences in two objects
 */ parcelHelpers.export(exports, "compare", ()=>compare);
var _helpersJs = require("./helpers.js");
var _coreJs = require("./core.js");
var beforeDict = new WeakMap();
class Mirror {
    constructor(obj){
        Object.defineProperty(this, "obj", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "observers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.obj = obj;
    }
}
class ObserverInfo {
    constructor(callback, observer){
        Object.defineProperty(this, "callback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "observer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.callback = callback;
        this.observer = observer;
    }
}
function getMirror(obj) {
    return beforeDict.get(obj);
}
function getObserverFromMirror(mirror, callback) {
    return mirror.observers.get(callback);
}
function removeObserverFromMirror(mirror, observer) {
    mirror.observers.delete(observer.callback);
}
function unobserve(root, observer) {
    observer.unobserve();
}
function observe(obj, callback) {
    var patches = [];
    var observer;
    var mirror = getMirror(obj);
    if (!mirror) {
        mirror = new Mirror(obj);
        beforeDict.set(obj, mirror);
    } else {
        const observerInfo = getObserverFromMirror(mirror, callback);
        observer = observerInfo && observerInfo.observer;
    }
    if (observer) return observer;
    observer = {};
    mirror.value = (0, _helpersJs._deepClone)(obj);
    if (callback) {
        observer.callback = callback;
        observer.next = null;
        var dirtyCheck = ()=>{
            generate(observer);
        };
        var fastCheck = ()=>{
            clearTimeout(observer.next);
            observer.next = setTimeout(dirtyCheck);
        };
        if (typeof window !== "undefined") {
            //not Node
            window.addEventListener("mouseup", fastCheck);
            window.addEventListener("keyup", fastCheck);
            window.addEventListener("mousedown", fastCheck);
            window.addEventListener("keydown", fastCheck);
            window.addEventListener("change", fastCheck);
        }
    }
    observer.patches = patches;
    observer.object = obj;
    observer.unobserve = ()=>{
        generate(observer);
        clearTimeout(observer.next);
        removeObserverFromMirror(mirror, observer);
        if (typeof window !== "undefined") {
            window.removeEventListener("mouseup", fastCheck);
            window.removeEventListener("keyup", fastCheck);
            window.removeEventListener("mousedown", fastCheck);
            window.removeEventListener("keydown", fastCheck);
            window.removeEventListener("change", fastCheck);
        }
    };
    mirror.observers.set(callback, new ObserverInfo(callback, observer));
    return observer;
}
function generate(observer, invertible = false) {
    var mirror = beforeDict.get(observer.object);
    _generate(mirror.value, observer.object, observer.patches, "", invertible);
    if (observer.patches.length) (0, _coreJs.applyPatch)(mirror.value, observer.patches);
    var temp = observer.patches;
    if (temp.length > 0) {
        observer.patches = [];
        if (observer.callback) observer.callback(temp);
    }
    return temp;
}
// Dirty check if obj is different from mirror, generate patches and update mirror
function _generate(mirror, obj, patches, path, invertible) {
    if (obj === mirror) return;
    if (typeof obj.toJSON === "function") obj = obj.toJSON();
    var newKeys = (0, _helpersJs._objectKeys)(obj);
    var oldKeys = (0, _helpersJs._objectKeys)(mirror);
    var changed = false;
    var deleted = false;
    //if ever "move" operation is implemented here, make sure this test runs OK: "should not generate the same patch twice (move)"
    for(var t = oldKeys.length - 1; t >= 0; t--){
        var key = oldKeys[t];
        var oldVal = mirror[key];
        if ((0, _helpersJs.hasOwnProperty)(obj, key) && !(obj[key] === undefined && oldVal !== undefined && Array.isArray(obj) === false)) {
            var newVal = obj[key];
            if (typeof oldVal == "object" && oldVal != null && typeof newVal == "object" && newVal != null && Array.isArray(oldVal) === Array.isArray(newVal)) _generate(oldVal, newVal, patches, path + "/" + (0, _helpersJs.escapePathComponent)(key), invertible);
            else if (oldVal !== newVal) {
                changed = true;
                if (invertible) patches.push({
                    op: "test",
                    path: path + "/" + (0, _helpersJs.escapePathComponent)(key),
                    value: (0, _helpersJs._deepClone)(oldVal)
                });
                patches.push({
                    op: "replace",
                    path: path + "/" + (0, _helpersJs.escapePathComponent)(key),
                    value: (0, _helpersJs._deepClone)(newVal)
                });
            }
        } else if (Array.isArray(mirror) === Array.isArray(obj)) {
            if (invertible) patches.push({
                op: "test",
                path: path + "/" + (0, _helpersJs.escapePathComponent)(key),
                value: (0, _helpersJs._deepClone)(oldVal)
            });
            patches.push({
                op: "remove",
                path: path + "/" + (0, _helpersJs.escapePathComponent)(key)
            });
            deleted = true; // property has been deleted
        } else {
            if (invertible) patches.push({
                op: "test",
                path,
                value: mirror
            });
            patches.push({
                op: "replace",
                path,
                value: obj
            });
            changed = true;
        }
    }
    if (!deleted && newKeys.length == oldKeys.length) return;
    for(var t = 0; t < newKeys.length; t++){
        var key = newKeys[t];
        if (!(0, _helpersJs.hasOwnProperty)(mirror, key) && obj[key] !== undefined) patches.push({
            op: "add",
            path: path + "/" + (0, _helpersJs.escapePathComponent)(key),
            value: (0, _helpersJs._deepClone)(obj[key])
        });
    }
}
function compare(tree1, tree2, invertible = false) {
    var patches = [];
    _generate(tree1, tree2, patches, "", invertible);
    return patches;
}

},{"./helpers.js":"fK1Sm","./core.js":"b99b0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kAAca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
 * Support async iterator syntax for ReadableStreams in all environments.
 * Source: https://github.com/MattiasBuelens/web-streams-polyfill/pull/122#issuecomment-1627354490
 */ parcelHelpers.export(exports, "IterableReadableStream", ()=>IterableReadableStream);
parcelHelpers.export(exports, "atee", ()=>atee);
parcelHelpers.export(exports, "concat", ()=>concat);
parcelHelpers.export(exports, "AsyncGeneratorWithSetup", ()=>AsyncGeneratorWithSetup);
parcelHelpers.export(exports, "pipeGeneratorWithSetup", ()=>pipeGeneratorWithSetup);
var _indexJs = require("../singletons/index.js");
var _signalJs = require("./signal.js");
class IterableReadableStream extends ReadableStream {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "reader", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    ensureReader() {
        if (!this.reader) this.reader = this.getReader();
    }
    async next() {
        this.ensureReader();
        try {
            const result = await this.reader.read();
            if (result.done) {
                this.reader.releaseLock(); // release lock when stream becomes closed
                return {
                    done: true,
                    value: undefined
                };
            } else return {
                done: false,
                value: result.value
            };
        } catch (e) {
            this.reader.releaseLock(); // release lock when stream becomes errored
            throw e;
        }
    }
    async return() {
        this.ensureReader();
        // If wrapped in a Node stream, cancel is already called.
        if (this.locked) {
            const cancelPromise = this.reader.cancel(); // cancel first, but don't await yet
            this.reader.releaseLock(); // release lock first
            await cancelPromise; // now await it
        }
        return {
            done: true,
            value: undefined
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async throw(e) {
        this.ensureReader();
        if (this.locked) {
            const cancelPromise = this.reader.cancel(); // cancel first, but don't await yet
            this.reader.releaseLock(); // release lock first
            await cancelPromise; // now await it
        }
        throw e;
    }
    [Symbol.asyncIterator]() {
        return this;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore Not present in Node 18 types, required in latest Node 22
    async [Symbol.asyncDispose]() {
        await this.return();
    }
    static fromReadableStream(stream) {
        // From https://developer.mozilla.org/en-US/docs/Web/API/Streams_API/Using_readable_streams#reading_the_stream
        const reader = stream.getReader();
        return new IterableReadableStream({
            start (controller) {
                return pump();
                function pump() {
                    return reader.read().then(({ done, value })=>{
                        // When no more data needs to be consumed, close the stream
                        if (done) {
                            controller.close();
                            return;
                        }
                        // Enqueue the next data chunk into our target stream
                        controller.enqueue(value);
                        return pump();
                    });
                }
            },
            cancel () {
                reader.releaseLock();
            }
        });
    }
    static fromAsyncGenerator(generator) {
        return new IterableReadableStream({
            async pull (controller) {
                const { value, done } = await generator.next();
                // When no more data needs to be consumed, close the stream
                if (done) controller.close();
                // Fix: `else if (value)` will hang the streaming when nullish value (e.g. empty string) is pulled
                controller.enqueue(value);
            },
            async cancel (reason) {
                await generator.return(reason);
            }
        });
    }
}
function atee(iter, length = 2) {
    const buffers = Array.from({
        length
    }, ()=>[]);
    return buffers.map(async function* makeIter(buffer) {
        while(true){
            if (buffer.length === 0) {
                const result = await iter.next();
                for (const buffer of buffers)buffer.push(result);
            } else if (buffer[0].done) return;
            else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            yield buffer.shift().value;
        }
    });
}
function concat(first, second) {
    if (Array.isArray(first) && Array.isArray(second)) return first.concat(second);
    else if (typeof first === "string" && typeof second === "string") return first + second;
    else if (typeof first === "number" && typeof second === "number") return first + second;
    else if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
    "concat" in first && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof first.concat === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return first.concat(second);
    else if (typeof first === "object" && typeof second === "object") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const chunk = {
            ...first
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        for (const [key, value] of Object.entries(second))if (key in chunk && !Array.isArray(chunk[key])) chunk[key] = concat(chunk[key], value);
        else chunk[key] = value;
        return chunk;
    } else throw new Error(`Cannot concat ${typeof first} and ${typeof second}`);
}
class AsyncGeneratorWithSetup {
    constructor(params){
        Object.defineProperty(this, "generator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "firstResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "firstResultUsed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        this.generator = params.generator;
        this.config = params.config;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.signal = params.signal ?? this.config?.signal;
        // setup is a promise that resolves only after the first iterator value
        // is available. this is useful when setup of several piped generators
        // needs to happen in logical order, ie. in the order in which input to
        // to each generator is available.
        this.setup = new Promise((resolve, reject)=>{
            (0, _indexJs.AsyncLocalStorageProviderSingleton).runWithConfig(params.config, async ()=>{
                this.firstResult = params.generator.next();
                if (params.startSetup) this.firstResult.then(params.startSetup).then(resolve, reject);
                else this.firstResult.then((_result)=>resolve(undefined), reject);
            }, true);
        });
    }
    async next(...args) {
        this.signal?.throwIfAborted();
        if (!this.firstResultUsed) {
            this.firstResultUsed = true;
            return this.firstResult;
        }
        return (0, _indexJs.AsyncLocalStorageProviderSingleton).runWithConfig(this.config, this.signal ? async ()=>{
            return (0, _signalJs.raceWithSignal)(this.generator.next(...args), this.signal);
        } : async ()=>{
            return this.generator.next(...args);
        }, true);
    }
    async return(value) {
        return this.generator.return(value);
    }
    async throw(e) {
        return this.generator.throw(e);
    }
    [Symbol.asyncIterator]() {
        return this;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore Not present in Node 18 types, required in latest Node 22
    async [Symbol.asyncDispose]() {
        await this.return();
    }
}
async function pipeGeneratorWithSetup(to, generator, startSetup, signal, ...args) {
    const gen = new AsyncGeneratorWithSetup({
        generator,
        startSetup,
        signal
    });
    const setup = await gen.setup;
    return {
        output: to(gen, setup, ...args),
        setup
    };
}

},{"../singletons/index.js":"1O31N","./signal.js":"hneUc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1O31N":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-explicit-any */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncLocalStorageProviderSingleton", ()=>(0, _indexJs.AsyncLocalStorageProviderSingleton));
parcelHelpers.export(exports, "_CONTEXT_VARIABLES_KEY", ()=>(0, _indexJs._CONTEXT_VARIABLES_KEY));
parcelHelpers.export(exports, "MockAsyncLocalStorage", ()=>(0, _indexJs.MockAsyncLocalStorage));
var _indexJs = require("./async_local_storage/index.js");

},{"./async_local_storage/index.js":"jafSd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jafSd":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-explicit-any */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MockAsyncLocalStorage", ()=>MockAsyncLocalStorage);
parcelHelpers.export(exports, "_CONTEXT_VARIABLES_KEY", ()=>_CONTEXT_VARIABLES_KEY);
parcelHelpers.export(exports, "AsyncLocalStorageProviderSingleton", ()=>AsyncLocalStorageProviderSingleton);
var _langsmith = require("langsmith");
var _globalsJs = require("./globals.js");
var _managerJs = require("../../callbacks/manager.js");
class MockAsyncLocalStorage {
    getStore() {
        return undefined;
    }
    run(_store, callback) {
        return callback();
    }
    enterWith(_store) {
        return undefined;
    }
}
const mockAsyncLocalStorage = new MockAsyncLocalStorage();
const LC_CHILD_KEY = Symbol.for("lc:child_config");
const _CONTEXT_VARIABLES_KEY = Symbol.for("lc:context_variables");
class AsyncLocalStorageProvider {
    getInstance() {
        return (0, _globalsJs.getGlobalAsyncLocalStorageInstance)() ?? mockAsyncLocalStorage;
    }
    getRunnableConfig() {
        const storage = this.getInstance();
        // this has the runnable config
        // which means that we should also have an instance of a LangChainTracer
        // with the run map prepopulated
        return storage.getStore()?.extra?.[LC_CHILD_KEY];
    }
    runWithConfig(config, callback, avoidCreatingRootRunTree) {
        const callbackManager = (0, _managerJs.CallbackManager)._configureSync(config?.callbacks, undefined, config?.tags, undefined, config?.metadata);
        const storage = this.getInstance();
        const previousValue = storage.getStore();
        const parentRunId = callbackManager?.getParentRunId();
        const langChainTracer = callbackManager?.handlers?.find((handler)=>handler?.name === "langchain_tracer");
        let runTree;
        if (langChainTracer && parentRunId) runTree = langChainTracer.convertToRunTree(parentRunId);
        else if (!avoidCreatingRootRunTree) runTree = new (0, _langsmith.RunTree)({
            name: "<runnable_lambda>",
            tracingEnabled: false
        });
        if (runTree) runTree.extra = {
            ...runTree.extra,
            [LC_CHILD_KEY]: config
        };
        if (previousValue !== undefined && previousValue[_CONTEXT_VARIABLES_KEY] !== undefined) runTree[_CONTEXT_VARIABLES_KEY] = previousValue[_CONTEXT_VARIABLES_KEY];
        return storage.run(runTree, callback);
    }
    initializeGlobalInstance(instance) {
        if ((0, _globalsJs.getGlobalAsyncLocalStorageInstance)() === undefined) (0, _globalsJs.setGlobalAsyncLocalStorageInstance)(instance);
    }
}
const AsyncLocalStorageProviderSingleton = new AsyncLocalStorageProvider();

},{"langsmith":"kaE6w","./globals.js":"gyJG4","../../callbacks/manager.js":"bj69C","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hneUc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "raceWithSignal", ()=>raceWithSignal);
async function raceWithSignal(promise, signal) {
    if (signal === undefined) return promise;
    let listener;
    return Promise.race([
        promise.catch((err)=>{
            if (!signal?.aborted) throw err;
            else return undefined;
        }),
        new Promise((_, reject)=>{
            listener = ()=>{
                reject(new Error("Aborted"));
            };
            signal.addEventListener("abort", listener);
            // Must be here inside the promise to avoid a race condition
            if (signal.aborted) reject(new Error("Aborted"));
        })
    ]).finally(()=>signal.removeEventListener("abort", listener));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5udSK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isStreamEventsHandler", ()=>isStreamEventsHandler);
/**
 * Class that extends the `BaseTracer` class from the
 * `langchain.callbacks.tracers.base` module. It represents a callback
 * handler that logs the execution of runs and emits `RunLog` instances to a
 * `RunLogStream`.
 */ parcelHelpers.export(exports, "EventStreamCallbackHandler", ()=>EventStreamCallbackHandler);
var _baseJs = require("./base.js");
var _streamJs = require("../utils/stream.js");
var _aiJs = require("../messages/ai.js");
var _outputsJs = require("../outputs.js");
function assignName({ name, serialized }) {
    if (name !== undefined) return name;
    if (serialized?.name !== undefined) return serialized.name;
    else if (serialized?.id !== undefined && Array.isArray(serialized?.id)) return serialized.id[serialized.id.length - 1];
    return "Unnamed";
}
const isStreamEventsHandler = (handler)=>handler.name === "event_stream_tracer";
class EventStreamCallbackHandler extends (0, _baseJs.BaseTracer) {
    constructor(fields){
        super({
            _awaitHandler: true,
            ...fields
        });
        Object.defineProperty(this, "autoClose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "includeNames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "includeTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "includeTags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "excludeNames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "excludeTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "excludeTags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "runInfoMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "tappedPromises", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "transformStream", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "writer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "receiveStream", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "event_stream_tracer"
        });
        this.autoClose = fields?.autoClose ?? true;
        this.includeNames = fields?.includeNames;
        this.includeTypes = fields?.includeTypes;
        this.includeTags = fields?.includeTags;
        this.excludeNames = fields?.excludeNames;
        this.excludeTypes = fields?.excludeTypes;
        this.excludeTags = fields?.excludeTags;
        this.transformStream = new TransformStream();
        this.writer = this.transformStream.writable.getWriter();
        this.receiveStream = (0, _streamJs.IterableReadableStream).fromReadableStream(this.transformStream.readable);
    }
    [Symbol.asyncIterator]() {
        return this.receiveStream;
    }
    async persistRun(_run) {
    // This is a legacy method only called once for an entire run tree
    // and is therefore not useful here
    }
    _includeRun(run) {
        const runTags = run.tags ?? [];
        let include = this.includeNames === undefined && this.includeTags === undefined && this.includeTypes === undefined;
        if (this.includeNames !== undefined) include = include || this.includeNames.includes(run.name);
        if (this.includeTypes !== undefined) include = include || this.includeTypes.includes(run.runType);
        if (this.includeTags !== undefined) include = include || runTags.find((tag)=>this.includeTags?.includes(tag)) !== undefined;
        if (this.excludeNames !== undefined) include = include && !this.excludeNames.includes(run.name);
        if (this.excludeTypes !== undefined) include = include && !this.excludeTypes.includes(run.runType);
        if (this.excludeTags !== undefined) include = include && runTags.every((tag)=>!this.excludeTags?.includes(tag));
        return include;
    }
    async *tapOutputIterable(runId, outputStream) {
        const firstChunk = await outputStream.next();
        if (firstChunk.done) return;
        const runInfo = this.runInfoMap.get(runId);
        // Run has finished, don't issue any stream events.
        // An example of this is for runnables that use the default
        // implementation of .stream(), which delegates to .invoke()
        // and calls .onChainEnd() before passing it to the iterator.
        if (runInfo === undefined) {
            yield firstChunk.value;
            return;
        }
        // Match format from handlers below
        function _formatOutputChunk(eventType, data) {
            if (eventType === "llm" && typeof data === "string") return new (0, _outputsJs.GenerationChunk)({
                text: data
            });
            return data;
        }
        let tappedPromise = this.tappedPromises.get(runId);
        // if we are the first to tap, issue stream events
        if (tappedPromise === undefined) {
            let tappedPromiseResolver;
            tappedPromise = new Promise((resolve)=>{
                tappedPromiseResolver = resolve;
            });
            this.tappedPromises.set(runId, tappedPromise);
            try {
                const event = {
                    event: `on_${runInfo.runType}_stream`,
                    run_id: runId,
                    name: runInfo.name,
                    tags: runInfo.tags,
                    metadata: runInfo.metadata,
                    data: {}
                };
                await this.send({
                    ...event,
                    data: {
                        chunk: _formatOutputChunk(runInfo.runType, firstChunk.value)
                    }
                }, runInfo);
                yield firstChunk.value;
                for await (const chunk of outputStream){
                    // Don't yield tool and retriever stream events
                    if (runInfo.runType !== "tool" && runInfo.runType !== "retriever") await this.send({
                        ...event,
                        data: {
                            chunk: _formatOutputChunk(runInfo.runType, chunk)
                        }
                    }, runInfo);
                    yield chunk;
                }
            } finally{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                tappedPromiseResolver();
            // Don't delete from the promises map to keep track of which runs have been tapped.
            }
        } else {
            // otherwise just pass through
            yield firstChunk.value;
            for await (const chunk of outputStream)yield chunk;
        }
    }
    async send(payload, run) {
        if (this._includeRun(run)) await this.writer.write(payload);
    }
    async sendEndEvent(payload, run) {
        const tappedPromise = this.tappedPromises.get(payload.run_id);
        if (tappedPromise !== undefined) tappedPromise.then(()=>{
            this.send(payload, run);
        });
        else await this.send(payload, run);
    }
    async onLLMStart(run) {
        const runName = assignName(run);
        const runType = run.inputs.messages !== undefined ? "chat_model" : "llm";
        const runInfo = {
            tags: run.tags ?? [],
            metadata: run.extra?.metadata ?? {},
            name: runName,
            runType,
            inputs: run.inputs
        };
        this.runInfoMap.set(run.id, runInfo);
        const eventName = `on_${runType}_start`;
        await this.send({
            event: eventName,
            data: {
                input: run.inputs
            },
            name: runName,
            tags: run.tags ?? [],
            run_id: run.id,
            metadata: run.extra?.metadata ?? {}
        }, runInfo);
    }
    async onLLMNewToken(run, token, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    kwargs) {
        const runInfo = this.runInfoMap.get(run.id);
        let chunk;
        let eventName;
        if (runInfo === undefined) throw new Error(`onLLMNewToken: Run ID ${run.id} not found in run map.`);
        // Top-level streaming events are covered by tapOutputIterable
        if (this.runInfoMap.size === 1) return;
        if (runInfo.runType === "chat_model") {
            eventName = "on_chat_model_stream";
            if (kwargs?.chunk === undefined) chunk = new (0, _aiJs.AIMessageChunk)({
                content: token,
                id: `run-${run.id}`
            });
            else chunk = kwargs.chunk.message;
        } else if (runInfo.runType === "llm") {
            eventName = "on_llm_stream";
            if (kwargs?.chunk === undefined) chunk = new (0, _outputsJs.GenerationChunk)({
                text: token
            });
            else chunk = kwargs.chunk;
        } else throw new Error(`Unexpected run type ${runInfo.runType}`);
        await this.send({
            event: eventName,
            data: {
                chunk
            },
            run_id: run.id,
            name: runInfo.name,
            tags: runInfo.tags,
            metadata: runInfo.metadata
        }, runInfo);
    }
    async onLLMEnd(run) {
        const runInfo = this.runInfoMap.get(run.id);
        this.runInfoMap.delete(run.id);
        let eventName;
        if (runInfo === undefined) throw new Error(`onLLMEnd: Run ID ${run.id} not found in run map.`);
        const generations = run.outputs?.generations;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let output;
        if (runInfo.runType === "chat_model") {
            for (const generation of generations ?? []){
                if (output !== undefined) break;
                output = generation[0]?.message;
            }
            eventName = "on_chat_model_end";
        } else if (runInfo.runType === "llm") {
            output = {
                generations: generations?.map((generation)=>{
                    return generation.map((chunk)=>{
                        return {
                            text: chunk.text,
                            generationInfo: chunk.generationInfo
                        };
                    });
                }),
                llmOutput: run.outputs?.llmOutput ?? {}
            };
            eventName = "on_llm_end";
        } else throw new Error(`onLLMEnd: Unexpected run type: ${runInfo.runType}`);
        await this.sendEndEvent({
            event: eventName,
            data: {
                output,
                input: runInfo.inputs
            },
            run_id: run.id,
            name: runInfo.name,
            tags: runInfo.tags,
            metadata: runInfo.metadata
        }, runInfo);
    }
    async onChainStart(run) {
        const runName = assignName(run);
        const runType = run.run_type ?? "chain";
        const runInfo = {
            tags: run.tags ?? [],
            metadata: run.extra?.metadata ?? {},
            name: runName,
            runType: run.run_type
        };
        let eventData = {};
        // Workaround Runnable core code not sending input when transform streaming.
        if (run.inputs.input === "" && Object.keys(run.inputs).length === 1) {
            eventData = {};
            runInfo.inputs = {};
        } else if (run.inputs.input !== undefined) {
            eventData.input = run.inputs.input;
            runInfo.inputs = run.inputs.input;
        } else {
            eventData.input = run.inputs;
            runInfo.inputs = run.inputs;
        }
        this.runInfoMap.set(run.id, runInfo);
        await this.send({
            event: `on_${runType}_start`,
            data: eventData,
            name: runName,
            tags: run.tags ?? [],
            run_id: run.id,
            metadata: run.extra?.metadata ?? {}
        }, runInfo);
    }
    async onChainEnd(run) {
        const runInfo = this.runInfoMap.get(run.id);
        this.runInfoMap.delete(run.id);
        if (runInfo === undefined) throw new Error(`onChainEnd: Run ID ${run.id} not found in run map.`);
        const eventName = `on_${run.run_type}_end`;
        const inputs = run.inputs ?? runInfo.inputs ?? {};
        const outputs = run.outputs?.output ?? run.outputs;
        const data = {
            output: outputs,
            input: inputs
        };
        if (inputs.input && Object.keys(inputs).length === 1) {
            data.input = inputs.input;
            runInfo.inputs = inputs.input;
        }
        await this.sendEndEvent({
            event: eventName,
            data,
            run_id: run.id,
            name: runInfo.name,
            tags: runInfo.tags,
            metadata: runInfo.metadata ?? {}
        }, runInfo);
    }
    async onToolStart(run) {
        const runName = assignName(run);
        const runInfo = {
            tags: run.tags ?? [],
            metadata: run.extra?.metadata ?? {},
            name: runName,
            runType: "tool",
            inputs: run.inputs ?? {}
        };
        this.runInfoMap.set(run.id, runInfo);
        await this.send({
            event: "on_tool_start",
            data: {
                input: run.inputs ?? {}
            },
            name: runName,
            run_id: run.id,
            tags: run.tags ?? [],
            metadata: run.extra?.metadata ?? {}
        }, runInfo);
    }
    async onToolEnd(run) {
        const runInfo = this.runInfoMap.get(run.id);
        this.runInfoMap.delete(run.id);
        if (runInfo === undefined) throw new Error(`onToolEnd: Run ID ${run.id} not found in run map.`);
        if (runInfo.inputs === undefined) throw new Error(`onToolEnd: Run ID ${run.id} is a tool call, and is expected to have traced inputs.`);
        const output = run.outputs?.output === undefined ? run.outputs : run.outputs.output;
        await this.sendEndEvent({
            event: "on_tool_end",
            data: {
                output,
                input: runInfo.inputs
            },
            run_id: run.id,
            name: runInfo.name,
            tags: runInfo.tags,
            metadata: runInfo.metadata
        }, runInfo);
    }
    async onRetrieverStart(run) {
        const runName = assignName(run);
        const runType = "retriever";
        const runInfo = {
            tags: run.tags ?? [],
            metadata: run.extra?.metadata ?? {},
            name: runName,
            runType,
            inputs: {
                query: run.inputs.query
            }
        };
        this.runInfoMap.set(run.id, runInfo);
        await this.send({
            event: "on_retriever_start",
            data: {
                input: {
                    query: run.inputs.query
                }
            },
            name: runName,
            tags: run.tags ?? [],
            run_id: run.id,
            metadata: run.extra?.metadata ?? {}
        }, runInfo);
    }
    async onRetrieverEnd(run) {
        const runInfo = this.runInfoMap.get(run.id);
        this.runInfoMap.delete(run.id);
        if (runInfo === undefined) throw new Error(`onRetrieverEnd: Run ID ${run.id} not found in run map.`);
        await this.sendEndEvent({
            event: "on_retriever_end",
            data: {
                output: run.outputs?.documents ?? run.outputs,
                input: runInfo.inputs
            },
            run_id: run.id,
            name: runInfo.name,
            tags: runInfo.tags,
            metadata: runInfo.metadata
        }, runInfo);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async handleCustomEvent(eventName, data, runId) {
        const runInfo = this.runInfoMap.get(runId);
        if (runInfo === undefined) throw new Error(`handleCustomEvent: Run ID ${runId} not found in run map.`);
        await this.send({
            event: "on_custom_event",
            run_id: runId,
            name: eventName,
            tags: runInfo.tags,
            metadata: runInfo.metadata,
            data
        }, runInfo);
    }
    async finish() {
        const pendingPromises = [
            ...this.tappedPromises.values()
        ];
        Promise.all(pendingPromises).finally(()=>{
            this.writer.close();
        });
    }
}

},{"./base.js":"5VkRj","../utils/stream.js":"kAAca","../messages/ai.js":"lkFVb","../outputs.js":"4YkJk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4YkJk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RUN_KEY", ()=>RUN_KEY);
/**
 * Chunk of a single generation. Used for streaming.
 */ parcelHelpers.export(exports, "GenerationChunk", ()=>GenerationChunk);
parcelHelpers.export(exports, "ChatGenerationChunk", ()=>ChatGenerationChunk);
const RUN_KEY = "__run";
class GenerationChunk {
    constructor(fields){
        Object.defineProperty(this, "text", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "generationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.text = fields.text;
        this.generationInfo = fields.generationInfo;
    }
    concat(chunk) {
        return new GenerationChunk({
            text: this.text + chunk.text,
            generationInfo: {
                ...this.generationInfo,
                ...chunk.generationInfo
            }
        });
    }
}
class ChatGenerationChunk extends GenerationChunk {
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.message = fields.message;
    }
    concat(chunk) {
        return new ChatGenerationChunk({
            text: this.text + chunk.text,
            generationInfo: {
                ...this.generationInfo,
                ...chunk.generationInfo
            },
            message: this.message.concat(chunk.message)
        });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2gQun":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RECURSION_LIMIT", ()=>DEFAULT_RECURSION_LIMIT);
parcelHelpers.export(exports, "getCallbackManagerForConfig", ()=>getCallbackManagerForConfig);
parcelHelpers.export(exports, "mergeConfigs", ()=>mergeConfigs);
/**
 * Ensure that a passed config is an object with all required keys present.
 */ parcelHelpers.export(exports, "ensureConfig", ()=>ensureConfig);
/**
 * Helper function that patches runnable configs with updated properties.
 */ parcelHelpers.export(exports, "patchConfig", ()=>patchConfig);
var _managerJs = require("../callbacks/manager.js");
var _indexJs = require("../singletons/index.js");
const DEFAULT_RECURSION_LIMIT = 25;
async function getCallbackManagerForConfig(config) {
    return (0, _managerJs.CallbackManager)._configureSync(config?.callbacks, undefined, config?.tags, undefined, config?.metadata);
}
function mergeConfigs(...configs) {
    // We do not want to call ensureConfig on the empty state here as this may cause
    // double loading of callbacks if async local storage is being used.
    const copy = {};
    for (const options of configs.filter((c)=>!!c))for (const key of Object.keys(options)){
        if (key === "metadata") copy[key] = {
            ...copy[key],
            ...options[key]
        };
        else if (key === "tags") {
            const baseKeys = copy[key] ?? [];
            copy[key] = [
                ...new Set(baseKeys.concat(options[key] ?? []))
            ];
        } else if (key === "configurable") copy[key] = {
            ...copy[key],
            ...options[key]
        };
        else if (key === "timeout") {
            if (copy.timeout === undefined) copy.timeout = options.timeout;
            else if (options.timeout !== undefined) copy.timeout = Math.min(copy.timeout, options.timeout);
        } else if (key === "signal") {
            if (copy.signal === undefined) copy.signal = options.signal;
            else if (options.signal !== undefined) {
                if ("any" in AbortSignal) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                copy.signal = AbortSignal.any([
                    copy.signal,
                    options.signal
                ]);
                else copy.signal = options.signal;
            }
        } else if (key === "callbacks") {
            const baseCallbacks = copy.callbacks;
            const providedCallbacks = options.callbacks;
            // callbacks can be either undefined, Array<handler> or manager
            // so merging two callbacks values has 6 cases
            if (Array.isArray(providedCallbacks)) {
                if (!baseCallbacks) copy.callbacks = providedCallbacks;
                else if (Array.isArray(baseCallbacks)) copy.callbacks = baseCallbacks.concat(providedCallbacks);
                else {
                    // baseCallbacks is a manager
                    const manager = baseCallbacks.copy();
                    for (const callback of providedCallbacks)manager.addHandler((0, _managerJs.ensureHandler)(callback), true);
                    copy.callbacks = manager;
                }
            } else if (providedCallbacks) {
                // providedCallbacks is a manager
                if (!baseCallbacks) copy.callbacks = providedCallbacks;
                else if (Array.isArray(baseCallbacks)) {
                    const manager = providedCallbacks.copy();
                    for (const callback of baseCallbacks)manager.addHandler((0, _managerJs.ensureHandler)(callback), true);
                    copy.callbacks = manager;
                } else // baseCallbacks is also a manager
                copy.callbacks = new (0, _managerJs.CallbackManager)(providedCallbacks._parentRunId, {
                    handlers: baseCallbacks.handlers.concat(providedCallbacks.handlers),
                    inheritableHandlers: baseCallbacks.inheritableHandlers.concat(providedCallbacks.inheritableHandlers),
                    tags: Array.from(new Set(baseCallbacks.tags.concat(providedCallbacks.tags))),
                    inheritableTags: Array.from(new Set(baseCallbacks.inheritableTags.concat(providedCallbacks.inheritableTags))),
                    metadata: {
                        ...baseCallbacks.metadata,
                        ...providedCallbacks.metadata
                    }
                });
            }
        } else {
            const typedKey = key;
            copy[typedKey] = options[typedKey] ?? copy[typedKey];
        }
    }
    return copy;
}
const PRIMITIVES = new Set([
    "string",
    "number",
    "boolean"
]);
function ensureConfig(config) {
    const implicitConfig = (0, _indexJs.AsyncLocalStorageProviderSingleton).getRunnableConfig();
    let empty = {
        tags: [],
        metadata: {},
        recursionLimit: 25,
        runId: undefined
    };
    if (implicitConfig) {
        // Don't allow runId and runName to be loaded implicitly, as this can cause
        // child runs to improperly inherit their parents' run ids.
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { runId, runName, ...rest } = implicitConfig;
        empty = Object.entries(rest).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (currentConfig, [key, value])=>{
            if (value !== undefined) // eslint-disable-next-line no-param-reassign
            currentConfig[key] = value;
            return currentConfig;
        }, empty);
    }
    if (config) empty = Object.entries(config).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentConfig, [key, value])=>{
        if (value !== undefined) // eslint-disable-next-line no-param-reassign
        currentConfig[key] = value;
        return currentConfig;
    }, empty);
    if (empty?.configurable) {
        for (const key of Object.keys(empty.configurable))if (PRIMITIVES.has(typeof empty.configurable[key]) && !empty.metadata?.[key]) {
            if (!empty.metadata) empty.metadata = {};
            empty.metadata[key] = empty.configurable[key];
        }
    }
    if (empty.timeout !== undefined) {
        if (empty.timeout <= 0) throw new Error("Timeout must be a positive number");
        const timeoutSignal = AbortSignal.timeout(empty.timeout);
        if (empty.signal !== undefined) {
            if ("any" in AbortSignal) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            empty.signal = AbortSignal.any([
                empty.signal,
                timeoutSignal
            ]);
        } else empty.signal = timeoutSignal;
        delete empty.timeout;
    }
    return empty;
}
function patchConfig(config = {}, { callbacks, maxConcurrency, recursionLimit, runName, configurable, runId } = {}) {
    const newConfig = ensureConfig(config);
    if (callbacks !== undefined) {
        /**
         * If we're replacing callbacks we need to unset runName
         * since that should apply only to the same run as the original callbacks
         */ delete newConfig.runName;
        newConfig.callbacks = callbacks;
    }
    if (recursionLimit !== undefined) newConfig.recursionLimit = recursionLimit;
    if (maxConcurrency !== undefined) newConfig.maxConcurrency = maxConcurrency;
    if (runName !== undefined) newConfig.runName = runName;
    if (configurable !== undefined) newConfig.configurable = {
        ...newConfig.configurable,
        ...configurable
    };
    if (runId !== undefined) delete newConfig.runId;
    return newConfig;
}

},{"../callbacks/manager.js":"bj69C","../singletons/index.js":"1O31N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9E8gp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A class that can be used to make async calls with concurrency and retry logic.
 *
 * This is useful for making calls to any kind of "expensive" external resource,
 * be it because it's rate-limited, subject to network issues, etc.
 *
 * Concurrent calls are limited by the `maxConcurrency` parameter, which defaults
 * to `Infinity`. This means that by default, all calls will be made in parallel.
 *
 * Retries are limited by the `maxRetries` parameter, which defaults to 6. This
 * means that by default, each call will be retried up to 6 times, with an
 * exponential backoff between each attempt.
 */ parcelHelpers.export(exports, "AsyncCaller", ()=>AsyncCaller);
var _pRetry = require("p-retry");
var _pRetryDefault = parcelHelpers.interopDefault(_pRetry);
var _pQueue = require("p-queue");
var _pQueueDefault = parcelHelpers.interopDefault(_pQueue);
const STATUS_NO_RETRY = [
    400,
    401,
    402,
    403,
    404,
    405,
    406,
    407,
    409
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultFailedAttemptHandler = (error)=>{
    if (error.message.startsWith("Cancel") || error.message.startsWith("AbortError") || error.name === "AbortError") throw error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (error?.code === "ECONNABORTED") throw error;
    const status = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?.response?.status ?? error?.status;
    if (status && STATUS_NO_RETRY.includes(+status)) throw error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (error?.error?.code === "insufficient_quota") {
        const err = new Error(error?.message);
        err.name = "InsufficientQuotaError";
        throw err;
    }
};
class AsyncCaller {
    constructor(params){
        Object.defineProperty(this, "maxConcurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxRetries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onFailedAttempt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "queue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxConcurrency = params.maxConcurrency ?? Infinity;
        this.maxRetries = params.maxRetries ?? 6;
        this.onFailedAttempt = params.onFailedAttempt ?? defaultFailedAttemptHandler;
        const PQueue = "default" in (0, _pQueueDefault.default) ? (0, _pQueueDefault.default).default : (0, _pQueueDefault.default);
        this.queue = new PQueue({
            concurrency: this.maxConcurrency
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    call(callable, ...args) {
        return this.queue.add(()=>(0, _pRetryDefault.default)(()=>callable(...args).catch((error)=>{
                    // eslint-disable-next-line no-instanceof/no-instanceof
                    if (error instanceof Error) throw error;
                    else throw new Error(error);
                }), {
                onFailedAttempt: this.onFailedAttempt,
                retries: this.maxRetries,
                randomize: true
            }), {
            throwOnTimeout: true
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callWithOptions(options, callable, ...args) {
        // Note this doesn't cancel the underlying request,
        // when available prefer to use the signal option of the underlying call
        if (options.signal) return Promise.race([
            this.call(callable, ...args),
            new Promise((_, reject)=>{
                options.signal?.addEventListener("abort", ()=>{
                    reject(new Error("AbortError"));
                });
            })
        ]);
        return this.call(callable, ...args);
    }
    fetch(...args) {
        return this.call(()=>fetch(...args).then((res)=>res.ok ? res : Promise.reject(res)));
    }
}

},{"p-retry":"jLLyx","p-queue":"5oyJ8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6w96a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RootListenersTracer", ()=>RootListenersTracer);
var _baseJs = require("./base.js");
class RootListenersTracer extends (0, _baseJs.BaseTracer) {
    constructor({ config, onStart, onEnd, onError }){
        super({
            _awaitHandler: true
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "RootListenersTracer"
        });
        /** The Run's ID. Type UUID */ Object.defineProperty(this, "rootId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "argOnStart", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "argOnEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "argOnError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = config;
        this.argOnStart = onStart;
        this.argOnEnd = onEnd;
        this.argOnError = onError;
    }
    /**
     * This is a legacy method only called once for an entire run tree
     * therefore not useful here
     * @param {Run} _ Not used
     */ persistRun(_) {
        return Promise.resolve();
    }
    async onRunCreate(run) {
        if (this.rootId) return;
        this.rootId = run.id;
        if (this.argOnStart) await this.argOnStart(run, this.config);
    }
    async onRunUpdate(run) {
        if (run.id !== this.rootId) return;
        if (!run.error) {
            if (this.argOnEnd) await this.argOnEnd(run, this.config);
        } else if (this.argOnError) await this.argOnError(run, this.config);
    }
}

},{"./base.js":"5VkRj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hG9iM":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRunnableInterface", ()=>isRunnableInterface);
/**
 * Utility to filter the root event in the streamEvents implementation.
 * This is simply binding the arguments to the namespace to make save on
 * a bit of typing in the streamEvents implementation.
 *
 * TODO: Refactor and remove.
 */ parcelHelpers.export(exports, "_RootEventFilter", ()=>_RootEventFilter);
function isRunnableInterface(thing) {
    return thing ? thing.lc_runnable : false;
}
class _RootEventFilter {
    constructor(fields){
        Object.defineProperty(this, "includeNames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "includeTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "includeTags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "excludeNames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "excludeTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "excludeTags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.includeNames = fields.includeNames;
        this.includeTypes = fields.includeTypes;
        this.includeTags = fields.includeTags;
        this.excludeNames = fields.excludeNames;
        this.excludeTypes = fields.excludeTypes;
        this.excludeTags = fields.excludeTags;
    }
    includeEvent(event, rootType) {
        let include = this.includeNames === undefined && this.includeTypes === undefined && this.includeTags === undefined;
        const eventTags = event.tags ?? [];
        if (this.includeNames !== undefined) include = include || this.includeNames.includes(event.name);
        if (this.includeTypes !== undefined) include = include || this.includeTypes.includes(rootType);
        if (this.includeTags !== undefined) include = include || eventTags.some((tag)=>this.includeTags?.includes(tag));
        if (this.excludeNames !== undefined) include = include && !this.excludeNames.includes(event.name);
        if (this.excludeTypes !== undefined) include = include && !this.excludeTypes.includes(rootType);
        if (this.excludeTags !== undefined) include = include && eventTags.every((tag)=>!this.excludeTags?.includes(tag));
        return include;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9F5Ur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Graph", ()=>Graph);
var _zodToJsonSchema = require("zod-to-json-schema");
var _uuid = require("uuid");
var _utilsJs = require("./utils.js");
var _graphMermaidJs = require("./graph_mermaid.js");
function nodeDataStr(id, data) {
    if (id !== undefined && !(0, _uuid.validate)(id)) return id;
    else if ((0, _utilsJs.isRunnableInterface)(data)) try {
        let dataStr = data.getName();
        dataStr = dataStr.startsWith("Runnable") ? dataStr.slice(8) : dataStr;
        return dataStr;
    } catch (error) {
        return data.getName();
    }
    else return data.name ?? "UnknownSchema";
}
function nodeDataJson(node) {
    // if node.data implements Runnable
    if ((0, _utilsJs.isRunnableInterface)(node.data)) return {
        type: "runnable",
        data: {
            id: node.data.lc_id,
            name: node.data.getName()
        }
    };
    else return {
        type: "schema",
        data: {
            ...(0, _zodToJsonSchema.zodToJsonSchema)(node.data.schema),
            title: node.data.name
        }
    };
}
class Graph {
    constructor(params){
        Object.defineProperty(this, "nodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "edges", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        this.nodes = params?.nodes ?? this.nodes;
        this.edges = params?.edges ?? this.edges;
    }
    // Convert the graph to a JSON-serializable format.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    toJSON() {
        const stableNodeIds = {};
        Object.values(this.nodes).forEach((node, i)=>{
            stableNodeIds[node.id] = (0, _uuid.validate)(node.id) ? i : node.id;
        });
        return {
            nodes: Object.values(this.nodes).map((node)=>({
                    id: stableNodeIds[node.id],
                    ...nodeDataJson(node)
                })),
            edges: this.edges.map((edge)=>{
                const item = {
                    source: stableNodeIds[edge.source],
                    target: stableNodeIds[edge.target]
                };
                if (typeof edge.data !== "undefined") item.data = edge.data;
                if (typeof edge.conditional !== "undefined") item.conditional = edge.conditional;
                return item;
            })
        };
    }
    addNode(data, id, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    metadata) {
        if (id !== undefined && this.nodes[id] !== undefined) throw new Error(`Node with id ${id} already exists`);
        const nodeId = id ?? (0, _uuid.v4)();
        const node = {
            id: nodeId,
            data,
            name: nodeDataStr(id, data),
            metadata
        };
        this.nodes[nodeId] = node;
        return node;
    }
    removeNode(node) {
        // Remove the node from the nodes map
        delete this.nodes[node.id];
        // Filter out edges connected to the node
        this.edges = this.edges.filter((edge)=>edge.source !== node.id && edge.target !== node.id);
    }
    addEdge(source, target, data, conditional) {
        if (this.nodes[source.id] === undefined) throw new Error(`Source node ${source.id} not in graph`);
        if (this.nodes[target.id] === undefined) throw new Error(`Target node ${target.id} not in graph`);
        const edge = {
            source: source.id,
            target: target.id,
            data,
            conditional
        };
        this.edges.push(edge);
        return edge;
    }
    firstNode() {
        return _firstNode(this);
    }
    lastNode() {
        return _lastNode(this);
    }
    /**
     * Add all nodes and edges from another graph.
     * Note this doesn't check for duplicates, nor does it connect the graphs.
     */ extend(graph, prefix = "") {
        let finalPrefix = prefix;
        const nodeIds = Object.values(graph.nodes).map((node)=>node.id);
        if (nodeIds.every((0, _uuid.validate))) finalPrefix = "";
        const prefixed = (id)=>{
            return finalPrefix ? `${finalPrefix}:${id}` : id;
        };
        Object.entries(graph.nodes).forEach(([key, value])=>{
            this.nodes[prefixed(key)] = {
                ...value,
                id: prefixed(key)
            };
        });
        const newEdges = graph.edges.map((edge)=>{
            return {
                ...edge,
                source: prefixed(edge.source),
                target: prefixed(edge.target)
            };
        });
        // Add all edges from the other graph
        this.edges = [
            ...this.edges,
            ...newEdges
        ];
        const first = graph.firstNode();
        const last = graph.lastNode();
        return [
            first ? {
                id: prefixed(first.id),
                data: first.data
            } : undefined,
            last ? {
                id: prefixed(last.id),
                data: last.data
            } : undefined
        ];
    }
    trimFirstNode() {
        const firstNode = this.firstNode();
        if (firstNode && _firstNode(this, [
            firstNode.id
        ])) this.removeNode(firstNode);
    }
    trimLastNode() {
        const lastNode = this.lastNode();
        if (lastNode && _lastNode(this, [
            lastNode.id
        ])) this.removeNode(lastNode);
    }
    /**
     * Return a new graph with all nodes re-identified,
     * using their unique, readable names where possible.
     */ reid() {
        const nodeLabels = Object.fromEntries(Object.values(this.nodes).map((node)=>[
                node.id,
                node.name
            ]));
        const nodeLabelCounts = new Map();
        Object.values(nodeLabels).forEach((label)=>{
            nodeLabelCounts.set(label, (nodeLabelCounts.get(label) || 0) + 1);
        });
        const getNodeId = (nodeId)=>{
            const label = nodeLabels[nodeId];
            if ((0, _uuid.validate)(nodeId) && nodeLabelCounts.get(label) === 1) return label;
            else return nodeId;
        };
        return new Graph({
            nodes: Object.fromEntries(Object.entries(this.nodes).map(([id, node])=>[
                    getNodeId(id),
                    {
                        ...node,
                        id: getNodeId(id)
                    }
                ])),
            edges: this.edges.map((edge)=>({
                    ...edge,
                    source: getNodeId(edge.source),
                    target: getNodeId(edge.target)
                }))
        });
    }
    drawMermaid(params) {
        const { withStyles, curveStyle, nodeColors = {
            default: "fill:#f2f0ff,line-height:1.2",
            first: "fill-opacity:0",
            last: "fill:#bfb6fc"
        }, wrapLabelNWords } = params ?? {};
        const graph = this.reid();
        const firstNode = graph.firstNode();
        const lastNode = graph.lastNode();
        return (0, _graphMermaidJs.drawMermaid)(graph.nodes, graph.edges, {
            firstNode: firstNode?.id,
            lastNode: lastNode?.id,
            withStyles,
            curveStyle,
            nodeColors,
            wrapLabelNWords
        });
    }
    async drawMermaidPng(params) {
        const mermaidSyntax = this.drawMermaid(params);
        return (0, _graphMermaidJs.drawMermaidPng)(mermaidSyntax, {
            backgroundColor: params?.backgroundColor
        });
    }
}
/**
 * Find the single node that is not a target of any edge.
 * Exclude nodes/sources with ids in the exclude list.
 * If there is no such node, or there are multiple, return undefined.
 * When drawing the graph, this node would be the origin.
 */ function _firstNode(graph, exclude = []) {
    const targets = new Set(graph.edges.filter((edge)=>!exclude.includes(edge.source)).map((edge)=>edge.target));
    const found = [];
    for (const node of Object.values(graph.nodes))if (!exclude.includes(node.id) && !targets.has(node.id)) found.push(node);
    return found.length === 1 ? found[0] : undefined;
}
/**
 * Find the single node that is not a source of any edge.
 * Exclude nodes/targets with ids in the exclude list.
 * If there is no such node, or there are multiple, return undefined.
 * When drawing the graph, this node would be the destination.
 */ function _lastNode(graph, exclude = []) {
    const sources = new Set(graph.edges.filter((edge)=>!exclude.includes(edge.target)).map((edge)=>edge.source));
    const found = [];
    for (const node of Object.values(graph.nodes))if (!exclude.includes(node.id) && !sources.has(node.id)) found.push(node);
    return found.length === 1 ? found[0] : undefined;
}

},{"zod-to-json-schema":"3TbOj","uuid":"klst7","./utils.js":"hG9iM","./graph_mermaid.js":"e1kN9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3TbOj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _optionsJs = require("./Options.js");
parcelHelpers.exportAll(_optionsJs, exports);
var _refsJs = require("./Refs.js");
parcelHelpers.exportAll(_refsJs, exports);
var _errorMessagesJs = require("./errorMessages.js");
parcelHelpers.exportAll(_errorMessagesJs, exports);
var _parseDefJs = require("./parseDef.js");
parcelHelpers.exportAll(_parseDefJs, exports);
var _anyJs = require("./parsers/any.js");
parcelHelpers.exportAll(_anyJs, exports);
var _arrayJs = require("./parsers/array.js");
parcelHelpers.exportAll(_arrayJs, exports);
var _bigintJs = require("./parsers/bigint.js");
parcelHelpers.exportAll(_bigintJs, exports);
var _booleanJs = require("./parsers/boolean.js");
parcelHelpers.exportAll(_booleanJs, exports);
var _brandedJs = require("./parsers/branded.js");
parcelHelpers.exportAll(_brandedJs, exports);
var _catchJs = require("./parsers/catch.js");
parcelHelpers.exportAll(_catchJs, exports);
var _dateJs = require("./parsers/date.js");
parcelHelpers.exportAll(_dateJs, exports);
var _defaultJs = require("./parsers/default.js");
parcelHelpers.exportAll(_defaultJs, exports);
var _effectsJs = require("./parsers/effects.js");
parcelHelpers.exportAll(_effectsJs, exports);
var _enumJs = require("./parsers/enum.js");
parcelHelpers.exportAll(_enumJs, exports);
var _intersectionJs = require("./parsers/intersection.js");
parcelHelpers.exportAll(_intersectionJs, exports);
var _literalJs = require("./parsers/literal.js");
parcelHelpers.exportAll(_literalJs, exports);
var _mapJs = require("./parsers/map.js");
parcelHelpers.exportAll(_mapJs, exports);
var _nativeEnumJs = require("./parsers/nativeEnum.js");
parcelHelpers.exportAll(_nativeEnumJs, exports);
var _neverJs = require("./parsers/never.js");
parcelHelpers.exportAll(_neverJs, exports);
var _nullJs = require("./parsers/null.js");
parcelHelpers.exportAll(_nullJs, exports);
var _nullableJs = require("./parsers/nullable.js");
parcelHelpers.exportAll(_nullableJs, exports);
var _numberJs = require("./parsers/number.js");
parcelHelpers.exportAll(_numberJs, exports);
var _objectJs = require("./parsers/object.js");
parcelHelpers.exportAll(_objectJs, exports);
var _optionalJs = require("./parsers/optional.js");
parcelHelpers.exportAll(_optionalJs, exports);
var _pipelineJs = require("./parsers/pipeline.js");
parcelHelpers.exportAll(_pipelineJs, exports);
var _promiseJs = require("./parsers/promise.js");
parcelHelpers.exportAll(_promiseJs, exports);
var _readonlyJs = require("./parsers/readonly.js");
parcelHelpers.exportAll(_readonlyJs, exports);
var _recordJs = require("./parsers/record.js");
parcelHelpers.exportAll(_recordJs, exports);
var _setJs = require("./parsers/set.js");
parcelHelpers.exportAll(_setJs, exports);
var _stringJs = require("./parsers/string.js");
parcelHelpers.exportAll(_stringJs, exports);
var _tupleJs = require("./parsers/tuple.js");
parcelHelpers.exportAll(_tupleJs, exports);
var _undefinedJs = require("./parsers/undefined.js");
parcelHelpers.exportAll(_undefinedJs, exports);
var _unionJs = require("./parsers/union.js");
parcelHelpers.exportAll(_unionJs, exports);
var _unknownJs = require("./parsers/unknown.js");
parcelHelpers.exportAll(_unknownJs, exports);
var _zodToJsonSchemaJs = require("./zodToJsonSchema.js");
parcelHelpers.exportAll(_zodToJsonSchemaJs, exports);
exports.default = (0, _zodToJsonSchemaJs.zodToJsonSchema);

},{"./Options.js":"9DKDs","./Refs.js":"f8UtW","./errorMessages.js":"fWbE4","./parseDef.js":"lITpI","./parsers/any.js":"88fOL","./parsers/array.js":"eatsV","./parsers/bigint.js":"eq8En","./parsers/boolean.js":"kej2e","./parsers/branded.js":"jWJq7","./parsers/catch.js":"fjtK5","./parsers/date.js":"cdbSD","./parsers/default.js":"YZmOA","./parsers/effects.js":"lxKbr","./parsers/enum.js":"dOCf0","./parsers/intersection.js":"gwnRD","./parsers/literal.js":"1EesH","./parsers/map.js":"1HkYW","./parsers/nativeEnum.js":"3uJYe","./parsers/never.js":"j6kNB","./parsers/null.js":"6SQrN","./parsers/nullable.js":"29JX2","./parsers/number.js":"iJPBs","./parsers/object.js":"bMwwV","./parsers/optional.js":"7Bi8s","./parsers/pipeline.js":"hVGeD","./parsers/promise.js":"b2wk2","./parsers/readonly.js":"a51mf","./parsers/record.js":"2GPmH","./parsers/set.js":"hbdFJ","./parsers/string.js":"kvpuK","./parsers/tuple.js":"8zu3h","./parsers/undefined.js":"duwEn","./parsers/union.js":"8diMg","./parsers/unknown.js":"icITY","./zodToJsonSchema.js":"1vjNo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9DKDs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ignoreOverride", ()=>ignoreOverride);
parcelHelpers.export(exports, "defaultOptions", ()=>defaultOptions);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
const ignoreOverride = Symbol("Let zodToJsonSchema decide on which parser to use");
const defaultOptions = {
    name: undefined,
    $refStrategy: "root",
    basePath: [
        "#"
    ],
    effectStrategy: "input",
    pipeStrategy: "all",
    dateStrategy: "format:date-time",
    mapStrategy: "entries",
    removeAdditionalStrategy: "passthrough",
    definitionPath: "definitions",
    target: "jsonSchema7",
    strictUnions: false,
    definitions: {},
    errorMessages: false,
    markdownDescription: false,
    patternStrategy: "escape",
    applyRegexFlags: false,
    emailStrategy: "format:email",
    base64Strategy: "contentEncoding:base64",
    nameStrategy: "ref"
};
const getDefaultOptions = (options)=>typeof options === "string" ? {
        ...defaultOptions,
        name: options
    } : {
        ...defaultOptions,
        ...options
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f8UtW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRefs", ()=>getRefs);
var _optionsJs = require("./Options.js");
const getRefs = (options)=>{
    const _options = (0, _optionsJs.getDefaultOptions)(options);
    const currentPath = _options.name !== undefined ? [
        ..._options.basePath,
        _options.definitionPath,
        _options.name
    ] : _options.basePath;
    return {
        ..._options,
        currentPath: currentPath,
        propertyPath: undefined,
        seen: new Map(Object.entries(_options.definitions).map(([name, def])=>[
                def._def,
                {
                    def: def._def,
                    path: [
                        ..._options.basePath,
                        _options.definitionPath,
                        name
                    ],
                    // Resolution of references will be forced even though seen, so it's ok that the schema is undefined here for now.
                    jsonSchema: undefined
                }
            ]))
    };
};

},{"./Options.js":"9DKDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fWbE4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addErrorMessage", ()=>addErrorMessage);
parcelHelpers.export(exports, "setResponseValueAndErrors", ()=>setResponseValueAndErrors);
function addErrorMessage(res, key, errorMessage, refs) {
    if (!refs?.errorMessages) return;
    if (errorMessage) res.errorMessage = {
        ...res.errorMessage,
        [key]: errorMessage
    };
}
function setResponseValueAndErrors(res, key, value, errorMessage, refs) {
    res[key] = value;
    addErrorMessage(res, key, errorMessage, refs);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lITpI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseDef", ()=>parseDef);
var _zod = require("zod");
var _anyJs = require("./parsers/any.js");
var _arrayJs = require("./parsers/array.js");
var _bigintJs = require("./parsers/bigint.js");
var _booleanJs = require("./parsers/boolean.js");
var _brandedJs = require("./parsers/branded.js");
var _catchJs = require("./parsers/catch.js");
var _dateJs = require("./parsers/date.js");
var _defaultJs = require("./parsers/default.js");
var _effectsJs = require("./parsers/effects.js");
var _enumJs = require("./parsers/enum.js");
var _intersectionJs = require("./parsers/intersection.js");
var _literalJs = require("./parsers/literal.js");
var _mapJs = require("./parsers/map.js");
var _nativeEnumJs = require("./parsers/nativeEnum.js");
var _neverJs = require("./parsers/never.js");
var _nullJs = require("./parsers/null.js");
var _nullableJs = require("./parsers/nullable.js");
var _numberJs = require("./parsers/number.js");
var _objectJs = require("./parsers/object.js");
var _optionalJs = require("./parsers/optional.js");
var _pipelineJs = require("./parsers/pipeline.js");
var _promiseJs = require("./parsers/promise.js");
var _recordJs = require("./parsers/record.js");
var _setJs = require("./parsers/set.js");
var _stringJs = require("./parsers/string.js");
var _tupleJs = require("./parsers/tuple.js");
var _undefinedJs = require("./parsers/undefined.js");
var _unionJs = require("./parsers/union.js");
var _unknownJs = require("./parsers/unknown.js");
var _readonlyJs = require("./parsers/readonly.js");
var _optionsJs = require("./Options.js");
function parseDef(def, refs, forceResolution = false) {
    const seenItem = refs.seen.get(def);
    if (refs.override) {
        const overrideResult = refs.override?.(def, refs, seenItem, forceResolution);
        if (overrideResult !== (0, _optionsJs.ignoreOverride)) return overrideResult;
    }
    if (seenItem && !forceResolution) {
        const seenSchema = get$ref(seenItem, refs);
        if (seenSchema !== undefined) return seenSchema;
    }
    const newItem = {
        def,
        path: refs.currentPath,
        jsonSchema: undefined
    };
    refs.seen.set(def, newItem);
    const jsonSchema = selectParser(def, def.typeName, refs);
    if (jsonSchema) addMeta(def, refs, jsonSchema);
    newItem.jsonSchema = jsonSchema;
    return jsonSchema;
}
const get$ref = (item, refs)=>{
    switch(refs.$refStrategy){
        case "root":
            return {
                $ref: item.path.join("/")
            };
        case "relative":
            return {
                $ref: getRelativePath(refs.currentPath, item.path)
            };
        case "none":
        case "seen":
            if (item.path.length < refs.currentPath.length && item.path.every((value, index)=>refs.currentPath[index] === value)) {
                console.warn(`Recursive reference detected at ${refs.currentPath.join("/")}! Defaulting to any`);
                return {};
            }
            return refs.$refStrategy === "seen" ? {} : undefined;
    }
};
const getRelativePath = (pathA, pathB)=>{
    let i = 0;
    for(; i < pathA.length && i < pathB.length; i++){
        if (pathA[i] !== pathB[i]) break;
    }
    return [
        (pathA.length - i).toString(),
        ...pathB.slice(i)
    ].join("/");
};
const selectParser = (def, typeName, refs)=>{
    switch(typeName){
        case (0, _zod.ZodFirstPartyTypeKind).ZodString:
            return (0, _stringJs.parseStringDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodNumber:
            return (0, _numberJs.parseNumberDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodObject:
            return (0, _objectJs.parseObjectDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodBigInt:
            return (0, _bigintJs.parseBigintDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodBoolean:
            return (0, _booleanJs.parseBooleanDef)();
        case (0, _zod.ZodFirstPartyTypeKind).ZodDate:
            return (0, _dateJs.parseDateDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodUndefined:
            return (0, _undefinedJs.parseUndefinedDef)();
        case (0, _zod.ZodFirstPartyTypeKind).ZodNull:
            return (0, _nullJs.parseNullDef)(refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodArray:
            return (0, _arrayJs.parseArrayDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodUnion:
        case (0, _zod.ZodFirstPartyTypeKind).ZodDiscriminatedUnion:
            return (0, _unionJs.parseUnionDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodIntersection:
            return (0, _intersectionJs.parseIntersectionDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodTuple:
            return (0, _tupleJs.parseTupleDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodRecord:
            return (0, _recordJs.parseRecordDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodLiteral:
            return (0, _literalJs.parseLiteralDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodEnum:
            return (0, _enumJs.parseEnumDef)(def);
        case (0, _zod.ZodFirstPartyTypeKind).ZodNativeEnum:
            return (0, _nativeEnumJs.parseNativeEnumDef)(def);
        case (0, _zod.ZodFirstPartyTypeKind).ZodNullable:
            return (0, _nullableJs.parseNullableDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodOptional:
            return (0, _optionalJs.parseOptionalDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodMap:
            return (0, _mapJs.parseMapDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodSet:
            return (0, _setJs.parseSetDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodLazy:
            return parseDef(def.getter()._def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodPromise:
            return (0, _promiseJs.parsePromiseDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodNaN:
        case (0, _zod.ZodFirstPartyTypeKind).ZodNever:
            return (0, _neverJs.parseNeverDef)();
        case (0, _zod.ZodFirstPartyTypeKind).ZodEffects:
            return (0, _effectsJs.parseEffectsDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodAny:
            return (0, _anyJs.parseAnyDef)();
        case (0, _zod.ZodFirstPartyTypeKind).ZodUnknown:
            return (0, _unknownJs.parseUnknownDef)();
        case (0, _zod.ZodFirstPartyTypeKind).ZodDefault:
            return (0, _defaultJs.parseDefaultDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodBranded:
            return (0, _brandedJs.parseBrandedDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodReadonly:
            return (0, _readonlyJs.parseReadonlyDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodCatch:
            return (0, _catchJs.parseCatchDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodPipeline:
            return (0, _pipelineJs.parsePipelineDef)(def, refs);
        case (0, _zod.ZodFirstPartyTypeKind).ZodFunction:
        case (0, _zod.ZodFirstPartyTypeKind).ZodVoid:
        case (0, _zod.ZodFirstPartyTypeKind).ZodSymbol:
            return undefined;
        default:
            /* c8 ignore next */ return ((_)=>undefined)(typeName);
    }
};
const addMeta = (def, refs, jsonSchema)=>{
    if (def.description) {
        jsonSchema.description = def.description;
        if (refs.markdownDescription) jsonSchema.markdownDescription = def.description;
    }
    return jsonSchema;
};

},{"zod":"juM82","./parsers/any.js":"88fOL","./parsers/array.js":"eatsV","./parsers/bigint.js":"eq8En","./parsers/boolean.js":"kej2e","./parsers/branded.js":"jWJq7","./parsers/catch.js":"fjtK5","./parsers/date.js":"cdbSD","./parsers/default.js":"YZmOA","./parsers/effects.js":"lxKbr","./parsers/enum.js":"dOCf0","./parsers/intersection.js":"gwnRD","./parsers/literal.js":"1EesH","./parsers/map.js":"1HkYW","./parsers/nativeEnum.js":"3uJYe","./parsers/never.js":"j6kNB","./parsers/null.js":"6SQrN","./parsers/nullable.js":"29JX2","./parsers/number.js":"iJPBs","./parsers/object.js":"bMwwV","./parsers/optional.js":"7Bi8s","./parsers/pipeline.js":"hVGeD","./parsers/promise.js":"b2wk2","./parsers/record.js":"2GPmH","./parsers/set.js":"hbdFJ","./parsers/string.js":"kvpuK","./parsers/tuple.js":"8zu3h","./parsers/undefined.js":"duwEn","./parsers/union.js":"8diMg","./parsers/unknown.js":"icITY","./parsers/readonly.js":"a51mf","./Options.js":"9DKDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"88fOL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseAnyDef", ()=>parseAnyDef);
function parseAnyDef() {
    return {};
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eatsV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseArrayDef", ()=>parseArrayDef);
var _zod = require("zod");
var _errorMessagesJs = require("../errorMessages.js");
var _parseDefJs = require("../parseDef.js");
function parseArrayDef(def, refs) {
    const res = {
        type: "array"
    };
    if (def.type?._def && def.type?._def?.typeName !== (0, _zod.ZodFirstPartyTypeKind).ZodAny) res.items = (0, _parseDefJs.parseDef)(def.type._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            "items"
        ]
    });
    if (def.minLength) (0, _errorMessagesJs.setResponseValueAndErrors)(res, "minItems", def.minLength.value, def.minLength.message, refs);
    if (def.maxLength) (0, _errorMessagesJs.setResponseValueAndErrors)(res, "maxItems", def.maxLength.value, def.maxLength.message, refs);
    if (def.exactLength) {
        (0, _errorMessagesJs.setResponseValueAndErrors)(res, "minItems", def.exactLength.value, def.exactLength.message, refs);
        (0, _errorMessagesJs.setResponseValueAndErrors)(res, "maxItems", def.exactLength.value, def.exactLength.message, refs);
    }
    return res;
}

},{"zod":"juM82","../errorMessages.js":"fWbE4","../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eq8En":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseBigintDef", ()=>parseBigintDef);
var _errorMessagesJs = require("../errorMessages.js");
function parseBigintDef(def, refs) {
    const res = {
        type: "integer",
        format: "int64"
    };
    if (!def.checks) return res;
    for (const check of def.checks)switch(check.kind){
        case "min":
            if (refs.target === "jsonSchema7") {
                if (check.inclusive) (0, _errorMessagesJs.setResponseValueAndErrors)(res, "minimum", check.value, check.message, refs);
                else (0, _errorMessagesJs.setResponseValueAndErrors)(res, "exclusiveMinimum", check.value, check.message, refs);
            } else {
                if (!check.inclusive) res.exclusiveMinimum = true;
                (0, _errorMessagesJs.setResponseValueAndErrors)(res, "minimum", check.value, check.message, refs);
            }
            break;
        case "max":
            if (refs.target === "jsonSchema7") {
                if (check.inclusive) (0, _errorMessagesJs.setResponseValueAndErrors)(res, "maximum", check.value, check.message, refs);
                else (0, _errorMessagesJs.setResponseValueAndErrors)(res, "exclusiveMaximum", check.value, check.message, refs);
            } else {
                if (!check.inclusive) res.exclusiveMaximum = true;
                (0, _errorMessagesJs.setResponseValueAndErrors)(res, "maximum", check.value, check.message, refs);
            }
            break;
        case "multipleOf":
            (0, _errorMessagesJs.setResponseValueAndErrors)(res, "multipleOf", check.value, check.message, refs);
            break;
    }
    return res;
}

},{"../errorMessages.js":"fWbE4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kej2e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseBooleanDef", ()=>parseBooleanDef);
function parseBooleanDef() {
    return {
        type: "boolean"
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jWJq7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseBrandedDef", ()=>parseBrandedDef);
var _parseDefJs = require("../parseDef.js");
function parseBrandedDef(_def, refs) {
    return (0, _parseDefJs.parseDef)(_def.type._def, refs);
}

},{"../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fjtK5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseCatchDef", ()=>parseCatchDef);
var _parseDefJs = require("../parseDef.js");
const parseCatchDef = (def, refs)=>{
    return (0, _parseDefJs.parseDef)(def.innerType._def, refs);
};

},{"../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cdbSD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseDateDef", ()=>parseDateDef);
var _errorMessagesJs = require("../errorMessages.js");
function parseDateDef(def, refs, overrideDateStrategy) {
    const strategy = overrideDateStrategy ?? refs.dateStrategy;
    if (Array.isArray(strategy)) return {
        anyOf: strategy.map((item, i)=>parseDateDef(def, refs, item))
    };
    switch(strategy){
        case "string":
        case "format:date-time":
            return {
                type: "string",
                format: "date-time"
            };
        case "format:date":
            return {
                type: "string",
                format: "date"
            };
        case "integer":
            return integerDateParser(def, refs);
    }
}
const integerDateParser = (def, refs)=>{
    const res = {
        type: "integer",
        format: "unix-time"
    };
    if (refs.target === "openApi3") return res;
    for (const check of def.checks)switch(check.kind){
        case "min":
            (0, _errorMessagesJs.setResponseValueAndErrors)(res, "minimum", check.value, check.message, refs);
            break;
        case "max":
            (0, _errorMessagesJs.setResponseValueAndErrors)(res, "maximum", check.value, check.message, refs);
            break;
    }
    return res;
};

},{"../errorMessages.js":"fWbE4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"YZmOA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseDefaultDef", ()=>parseDefaultDef);
var _parseDefJs = require("../parseDef.js");
function parseDefaultDef(_def, refs) {
    return {
        ...(0, _parseDefJs.parseDef)(_def.innerType._def, refs),
        default: _def.defaultValue()
    };
}

},{"../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lxKbr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseEffectsDef", ()=>parseEffectsDef);
var _parseDefJs = require("../parseDef.js");
function parseEffectsDef(_def, refs) {
    return refs.effectStrategy === "input" ? (0, _parseDefJs.parseDef)(_def.schema._def, refs) : {};
}

},{"../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dOCf0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseEnumDef", ()=>parseEnumDef);
function parseEnumDef(def) {
    return {
        type: "string",
        enum: def.values
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gwnRD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseIntersectionDef", ()=>parseIntersectionDef);
var _parseDefJs = require("../parseDef.js");
const isJsonSchema7AllOfType = (type)=>{
    if ("type" in type && type.type === "string") return false;
    return "allOf" in type;
};
function parseIntersectionDef(def, refs) {
    const allOf = [
        (0, _parseDefJs.parseDef)(def.left._def, {
            ...refs,
            currentPath: [
                ...refs.currentPath,
                "allOf",
                "0"
            ]
        }),
        (0, _parseDefJs.parseDef)(def.right._def, {
            ...refs,
            currentPath: [
                ...refs.currentPath,
                "allOf",
                "1"
            ]
        })
    ].filter((x)=>!!x);
    let unevaluatedProperties = refs.target === "jsonSchema2019-09" ? {
        unevaluatedProperties: false
    } : undefined;
    const mergedAllOf = [];
    // If either of the schemas is an allOf, merge them into a single allOf
    allOf.forEach((schema)=>{
        if (isJsonSchema7AllOfType(schema)) {
            mergedAllOf.push(...schema.allOf);
            if (schema.unevaluatedProperties === undefined) // If one of the schemas has no unevaluatedProperties set,
            // the merged schema should also have no unevaluatedProperties set
            unevaluatedProperties = undefined;
        } else {
            let nestedSchema = schema;
            if ("additionalProperties" in schema && schema.additionalProperties === false) {
                const { additionalProperties, ...rest } = schema;
                nestedSchema = rest;
            } else // As soon as one of the schemas has additionalProperties set not to false, we allow unevaluatedProperties
            unevaluatedProperties = undefined;
            mergedAllOf.push(nestedSchema);
        }
    });
    return mergedAllOf.length ? {
        allOf: mergedAllOf,
        ...unevaluatedProperties
    } : undefined;
}

},{"../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1EesH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseLiteralDef", ()=>parseLiteralDef);
function parseLiteralDef(def, refs) {
    const parsedType = typeof def.value;
    if (parsedType !== "bigint" && parsedType !== "number" && parsedType !== "boolean" && parsedType !== "string") return {
        type: Array.isArray(def.value) ? "array" : "object"
    };
    if (refs.target === "openApi3") return {
        type: parsedType === "bigint" ? "integer" : parsedType,
        enum: [
            def.value
        ]
    };
    return {
        type: parsedType === "bigint" ? "integer" : parsedType,
        const: def.value
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1HkYW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseMapDef", ()=>parseMapDef);
var _parseDefJs = require("../parseDef.js");
var _recordJs = require("./record.js");
function parseMapDef(def, refs) {
    if (refs.mapStrategy === "record") return (0, _recordJs.parseRecordDef)(def, refs);
    const keys = (0, _parseDefJs.parseDef)(def.keyType._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            "items",
            "items",
            "0"
        ]
    }) || {};
    const values = (0, _parseDefJs.parseDef)(def.valueType._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            "items",
            "items",
            "1"
        ]
    }) || {};
    return {
        type: "array",
        maxItems: 125,
        items: {
            type: "array",
            items: [
                keys,
                values
            ],
            minItems: 2,
            maxItems: 2
        }
    };
}

},{"../parseDef.js":"lITpI","./record.js":"2GPmH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2GPmH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseRecordDef", ()=>parseRecordDef);
var _zod = require("zod");
var _parseDefJs = require("../parseDef.js");
var _stringJs = require("./string.js");
var _brandedJs = require("./branded.js");
function parseRecordDef(def, refs) {
    if (refs.target === "openApi3" && def.keyType?._def.typeName === (0, _zod.ZodFirstPartyTypeKind).ZodEnum) return {
        type: "object",
        required: def.keyType._def.values,
        properties: def.keyType._def.values.reduce((acc, key)=>({
                ...acc,
                [key]: (0, _parseDefJs.parseDef)(def.valueType._def, {
                    ...refs,
                    currentPath: [
                        ...refs.currentPath,
                        "properties",
                        key
                    ]
                }) ?? {}
            }), {}),
        additionalProperties: false
    };
    const schema = {
        type: "object",
        additionalProperties: (0, _parseDefJs.parseDef)(def.valueType._def, {
            ...refs,
            currentPath: [
                ...refs.currentPath,
                "additionalProperties"
            ]
        }) ?? {}
    };
    if (refs.target === "openApi3") return schema;
    if (def.keyType?._def.typeName === (0, _zod.ZodFirstPartyTypeKind).ZodString && def.keyType._def.checks?.length) {
        const { type, ...keyType } = (0, _stringJs.parseStringDef)(def.keyType._def, refs);
        return {
            ...schema,
            propertyNames: keyType
        };
    } else if (def.keyType?._def.typeName === (0, _zod.ZodFirstPartyTypeKind).ZodEnum) return {
        ...schema,
        propertyNames: {
            enum: def.keyType._def.values
        }
    };
    else if (def.keyType?._def.typeName === (0, _zod.ZodFirstPartyTypeKind).ZodBranded && def.keyType._def.type._def.typeName === (0, _zod.ZodFirstPartyTypeKind).ZodString && def.keyType._def.type._def.checks?.length) {
        const { type, ...keyType } = (0, _brandedJs.parseBrandedDef)(def.keyType._def, refs);
        return {
            ...schema,
            propertyNames: keyType
        };
    }
    return schema;
}

},{"zod":"juM82","../parseDef.js":"lITpI","./string.js":"kvpuK","./branded.js":"jWJq7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kvpuK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zodPatterns", ()=>zodPatterns);
parcelHelpers.export(exports, "parseStringDef", ()=>parseStringDef);
var _errorMessagesJs = require("../errorMessages.js");
let emojiRegex;
const zodPatterns = {
    /**
     * `c` was changed to `[cC]` to replicate /i flag
     */ cuid: /^[cC][^\s-]{8,}$/,
    cuid2: /^[0-9a-z]+$/,
    ulid: /^[0-9A-HJKMNP-TV-Z]{26}$/,
    /**
     * `a-z` was added to replicate /i flag
     */ email: /^(?!\.)(?!.*\.\.)([a-zA-Z0-9_'+\-\.]*)[a-zA-Z0-9_+-]@([a-zA-Z0-9][a-zA-Z0-9\-]*\.)+[a-zA-Z]{2,}$/,
    /**
     * Constructed a valid Unicode RegExp
     *
     * Lazily instantiate since this type of regex isn't supported
     * in all envs (e.g. React Native).
     *
     * See:
     * https://github.com/colinhacks/zod/issues/2433
     * Fix in Zod:
     * https://github.com/colinhacks/zod/commit/9340fd51e48576a75adc919bff65dbc4a5d4c99b
     */ emoji: ()=>{
        if (emojiRegex === undefined) emojiRegex = RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u");
        return emojiRegex;
    },
    /**
     * Unused
     */ uuid: /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/,
    /**
     * Unused
     */ ipv4: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,
    /**
     * Unused
     */ ipv6: /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/,
    base64: /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,
    nanoid: /^[a-zA-Z0-9_-]{21}$/
};
function parseStringDef(def, refs) {
    const res = {
        type: "string"
    };
    function processPattern(value) {
        return refs.patternStrategy === "escape" ? escapeNonAlphaNumeric(value) : value;
    }
    if (def.checks) for (const check of def.checks)switch(check.kind){
        case "min":
            (0, _errorMessagesJs.setResponseValueAndErrors)(res, "minLength", typeof res.minLength === "number" ? Math.max(res.minLength, check.value) : check.value, check.message, refs);
            break;
        case "max":
            (0, _errorMessagesJs.setResponseValueAndErrors)(res, "maxLength", typeof res.maxLength === "number" ? Math.min(res.maxLength, check.value) : check.value, check.message, refs);
            break;
        case "email":
            switch(refs.emailStrategy){
                case "format:email":
                    addFormat(res, "email", check.message, refs);
                    break;
                case "format:idn-email":
                    addFormat(res, "idn-email", check.message, refs);
                    break;
                case "pattern:zod":
                    addPattern(res, zodPatterns.email, check.message, refs);
                    break;
            }
            break;
        case "url":
            addFormat(res, "uri", check.message, refs);
            break;
        case "uuid":
            addFormat(res, "uuid", check.message, refs);
            break;
        case "regex":
            addPattern(res, check.regex, check.message, refs);
            break;
        case "cuid":
            addPattern(res, zodPatterns.cuid, check.message, refs);
            break;
        case "cuid2":
            addPattern(res, zodPatterns.cuid2, check.message, refs);
            break;
        case "startsWith":
            addPattern(res, RegExp(`^${processPattern(check.value)}`), check.message, refs);
            break;
        case "endsWith":
            addPattern(res, RegExp(`${processPattern(check.value)}$`), check.message, refs);
            break;
        case "datetime":
            addFormat(res, "date-time", check.message, refs);
            break;
        case "date":
            addFormat(res, "date", check.message, refs);
            break;
        case "time":
            addFormat(res, "time", check.message, refs);
            break;
        case "duration":
            addFormat(res, "duration", check.message, refs);
            break;
        case "length":
            (0, _errorMessagesJs.setResponseValueAndErrors)(res, "minLength", typeof res.minLength === "number" ? Math.max(res.minLength, check.value) : check.value, check.message, refs);
            (0, _errorMessagesJs.setResponseValueAndErrors)(res, "maxLength", typeof res.maxLength === "number" ? Math.min(res.maxLength, check.value) : check.value, check.message, refs);
            break;
        case "includes":
            addPattern(res, RegExp(processPattern(check.value)), check.message, refs);
            break;
        case "ip":
            if (check.version !== "v6") addFormat(res, "ipv4", check.message, refs);
            if (check.version !== "v4") addFormat(res, "ipv6", check.message, refs);
            break;
        case "emoji":
            addPattern(res, zodPatterns.emoji, check.message, refs);
            break;
        case "ulid":
            addPattern(res, zodPatterns.ulid, check.message, refs);
            break;
        case "base64":
            switch(refs.base64Strategy){
                case "format:binary":
                    addFormat(res, "binary", check.message, refs);
                    break;
                case "contentEncoding:base64":
                    (0, _errorMessagesJs.setResponseValueAndErrors)(res, "contentEncoding", "base64", check.message, refs);
                    break;
                case "pattern:zod":
                    addPattern(res, zodPatterns.base64, check.message, refs);
                    break;
            }
            break;
        case "nanoid":
            addPattern(res, zodPatterns.nanoid, check.message, refs);
        case "toLowerCase":
        case "toUpperCase":
        case "trim":
            break;
        default:
            /* c8 ignore next */ ((_)=>{})(check);
    }
    return res;
}
const escapeNonAlphaNumeric = (value)=>Array.from(value).map((c)=>/[a-zA-Z0-9]/.test(c) ? c : `\\${c}`).join("");
const addFormat = (schema, value, message, refs)=>{
    if (schema.format || schema.anyOf?.some((x)=>x.format)) {
        if (!schema.anyOf) schema.anyOf = [];
        if (schema.format) {
            schema.anyOf.push({
                format: schema.format,
                ...schema.errorMessage && refs.errorMessages && {
                    errorMessage: {
                        format: schema.errorMessage.format
                    }
                }
            });
            delete schema.format;
            if (schema.errorMessage) {
                delete schema.errorMessage.format;
                if (Object.keys(schema.errorMessage).length === 0) delete schema.errorMessage;
            }
        }
        schema.anyOf.push({
            format: value,
            ...message && refs.errorMessages && {
                errorMessage: {
                    format: message
                }
            }
        });
    } else (0, _errorMessagesJs.setResponseValueAndErrors)(schema, "format", value, message, refs);
};
const addPattern = (schema, regex, message, refs)=>{
    if (schema.pattern || schema.allOf?.some((x)=>x.pattern)) {
        if (!schema.allOf) schema.allOf = [];
        if (schema.pattern) {
            schema.allOf.push({
                pattern: schema.pattern,
                ...schema.errorMessage && refs.errorMessages && {
                    errorMessage: {
                        pattern: schema.errorMessage.pattern
                    }
                }
            });
            delete schema.pattern;
            if (schema.errorMessage) {
                delete schema.errorMessage.pattern;
                if (Object.keys(schema.errorMessage).length === 0) delete schema.errorMessage;
            }
        }
        schema.allOf.push({
            pattern: processRegExp(regex, refs),
            ...message && refs.errorMessages && {
                errorMessage: {
                    pattern: message
                }
            }
        });
    } else (0, _errorMessagesJs.setResponseValueAndErrors)(schema, "pattern", processRegExp(regex, refs), message, refs);
};
// Mutate z.string.regex() in a best attempt to accommodate for regex flags when applyRegexFlags is true
const processRegExp = (regexOrFunction, refs)=>{
    const regex = typeof regexOrFunction === "function" ? regexOrFunction() : regexOrFunction;
    if (!refs.applyRegexFlags || !regex.flags) return regex.source;
    // Currently handled flags
    const flags = {
        i: regex.flags.includes("i"),
        m: regex.flags.includes("m"),
        s: regex.flags.includes("s")
    };
    // The general principle here is to step through each character, one at a time, applying mutations as flags require. We keep track when the current character is escaped, and when it's inside a group /like [this]/ or (also) a range like /[a-z]/. The following is fairly brittle imperative code; edit at your peril!
    const source = flags.i ? regex.source.toLowerCase() : regex.source;
    let pattern = "";
    let isEscaped = false;
    let inCharGroup = false;
    let inCharRange = false;
    for(let i = 0; i < source.length; i++){
        if (isEscaped) {
            pattern += source[i];
            isEscaped = false;
            continue;
        }
        if (flags.i) {
            if (inCharGroup) {
                if (source[i].match(/[a-z]/)) {
                    if (inCharRange) {
                        pattern += source[i];
                        pattern += `${source[i - 2]}-${source[i]}`.toUpperCase();
                        inCharRange = false;
                    } else if (source[i + 1] === "-" && source[i + 2]?.match(/[a-z]/)) {
                        pattern += source[i];
                        inCharRange = true;
                    } else pattern += `${source[i]}${source[i].toUpperCase()}`;
                    continue;
                }
            } else if (source[i].match(/[a-z]/)) {
                pattern += `[${source[i]}${source[i].toUpperCase()}]`;
                continue;
            }
        }
        if (flags.m) {
            if (source[i] === "^") {
                pattern += `(^|(?<=[\r\n]))`;
                continue;
            } else if (source[i] === "$") {
                pattern += `($|(?=[\r\n]))`;
                continue;
            }
        }
        if (flags.s && source[i] === ".") {
            pattern += inCharGroup ? `${source[i]}\r\n` : `[${source[i]}\r\n]`;
            continue;
        }
        pattern += source[i];
        if (source[i] === "\\") isEscaped = true;
        else if (inCharGroup && source[i] === "]") inCharGroup = false;
        else if (!inCharGroup && source[i] === "[") inCharGroup = true;
    }
    try {
        const regexTest = new RegExp(pattern);
    } catch  {
        console.warn(`Could not convert regex pattern at ${refs.currentPath.join("/")} to a flag-independent form! Falling back to the flag-ignorant source`);
        return regex.source;
    }
    return pattern;
};

},{"../errorMessages.js":"fWbE4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3uJYe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseNativeEnumDef", ()=>parseNativeEnumDef);
function parseNativeEnumDef(def) {
    const object = def.values;
    const actualKeys = Object.keys(def.values).filter((key)=>{
        return typeof object[object[key]] !== "number";
    });
    const actualValues = actualKeys.map((key)=>object[key]);
    const parsedTypes = Array.from(new Set(actualValues.map((values)=>typeof values)));
    return {
        type: parsedTypes.length === 1 ? parsedTypes[0] === "string" ? "string" : "number" : [
            "string",
            "number"
        ],
        enum: actualValues
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j6kNB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseNeverDef", ()=>parseNeverDef);
function parseNeverDef() {
    return {
        not: {}
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6SQrN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseNullDef", ()=>parseNullDef);
function parseNullDef(refs) {
    return refs.target === "openApi3" ? {
        enum: [
            "null"
        ],
        nullable: true
    } : {
        type: "null"
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"29JX2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseNullableDef", ()=>parseNullableDef);
var _parseDefJs = require("../parseDef.js");
var _unionJs = require("./union.js");
function parseNullableDef(def, refs) {
    if ([
        "ZodString",
        "ZodNumber",
        "ZodBigInt",
        "ZodBoolean",
        "ZodNull"
    ].includes(def.innerType._def.typeName) && (!def.innerType._def.checks || !def.innerType._def.checks.length)) {
        if (refs.target === "openApi3") return {
            type: (0, _unionJs.primitiveMappings)[def.innerType._def.typeName],
            nullable: true
        };
        return {
            type: [
                (0, _unionJs.primitiveMappings)[def.innerType._def.typeName],
                "null"
            ]
        };
    }
    if (refs.target === "openApi3") {
        const base = (0, _parseDefJs.parseDef)(def.innerType._def, {
            ...refs,
            currentPath: [
                ...refs.currentPath
            ]
        });
        if (base && '$ref' in base) return {
            allOf: [
                base
            ],
            nullable: true
        };
        return base && {
            ...base,
            nullable: true
        };
    }
    const base = (0, _parseDefJs.parseDef)(def.innerType._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            "anyOf",
            "0"
        ]
    });
    return base && {
        anyOf: [
            base,
            {
                type: "null"
            }
        ]
    };
}

},{"../parseDef.js":"lITpI","./union.js":"8diMg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8diMg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "primitiveMappings", ()=>primitiveMappings);
parcelHelpers.export(exports, "parseUnionDef", ()=>parseUnionDef);
var _parseDefJs = require("../parseDef.js");
const primitiveMappings = {
    ZodString: "string",
    ZodNumber: "number",
    ZodBigInt: "integer",
    ZodBoolean: "boolean",
    ZodNull: "null"
};
function parseUnionDef(def, refs) {
    if (refs.target === "openApi3") return asAnyOf(def, refs);
    const options = def.options instanceof Map ? Array.from(def.options.values()) : def.options;
    // This blocks tries to look ahead a bit to produce nicer looking schemas with type array instead of anyOf.
    if (options.every((x)=>x._def.typeName in primitiveMappings && (!x._def.checks || !x._def.checks.length))) {
        // all types in union are primitive and lack checks, so might as well squash into {type: [...]}
        const types = options.reduce((types, x)=>{
            const type = primitiveMappings[x._def.typeName]; //Can be safely casted due to row 43
            return type && !types.includes(type) ? [
                ...types,
                type
            ] : types;
        }, []);
        return {
            type: types.length > 1 ? types : types[0]
        };
    } else if (options.every((x)=>x._def.typeName === "ZodLiteral" && !x.description)) {
        // all options literals
        const types = options.reduce((acc, x)=>{
            const type = typeof x._def.value;
            switch(type){
                case "string":
                case "number":
                case "boolean":
                    return [
                        ...acc,
                        type
                    ];
                case "bigint":
                    return [
                        ...acc,
                        "integer"
                    ];
                case "object":
                    if (x._def.value === null) return [
                        ...acc,
                        "null"
                    ];
                case "symbol":
                case "undefined":
                case "function":
                default:
                    return acc;
            }
        }, []);
        if (types.length === options.length) {
            // all the literals are primitive, as far as null can be considered primitive
            const uniqueTypes = types.filter((x, i, a)=>a.indexOf(x) === i);
            return {
                type: uniqueTypes.length > 1 ? uniqueTypes : uniqueTypes[0],
                enum: options.reduce((acc, x)=>{
                    return acc.includes(x._def.value) ? acc : [
                        ...acc,
                        x._def.value
                    ];
                }, [])
            };
        }
    } else if (options.every((x)=>x._def.typeName === "ZodEnum")) return {
        type: "string",
        enum: options.reduce((acc, x)=>[
                ...acc,
                ...x._def.values.filter((x)=>!acc.includes(x))
            ], [])
    };
    return asAnyOf(def, refs);
}
const asAnyOf = (def, refs)=>{
    const anyOf = (def.options instanceof Map ? Array.from(def.options.values()) : def.options).map((x, i)=>(0, _parseDefJs.parseDef)(x._def, {
            ...refs,
            currentPath: [
                ...refs.currentPath,
                "anyOf",
                `${i}`
            ]
        })).filter((x)=>!!x && (!refs.strictUnions || typeof x === "object" && Object.keys(x).length > 0));
    return anyOf.length ? {
        anyOf
    } : undefined;
};

},{"../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iJPBs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseNumberDef", ()=>parseNumberDef);
var _errorMessagesJs = require("../errorMessages.js");
function parseNumberDef(def, refs) {
    const res = {
        type: "number"
    };
    if (!def.checks) return res;
    for (const check of def.checks)switch(check.kind){
        case "int":
            res.type = "integer";
            (0, _errorMessagesJs.addErrorMessage)(res, "type", check.message, refs);
            break;
        case "min":
            if (refs.target === "jsonSchema7") {
                if (check.inclusive) (0, _errorMessagesJs.setResponseValueAndErrors)(res, "minimum", check.value, check.message, refs);
                else (0, _errorMessagesJs.setResponseValueAndErrors)(res, "exclusiveMinimum", check.value, check.message, refs);
            } else {
                if (!check.inclusive) res.exclusiveMinimum = true;
                (0, _errorMessagesJs.setResponseValueAndErrors)(res, "minimum", check.value, check.message, refs);
            }
            break;
        case "max":
            if (refs.target === "jsonSchema7") {
                if (check.inclusive) (0, _errorMessagesJs.setResponseValueAndErrors)(res, "maximum", check.value, check.message, refs);
                else (0, _errorMessagesJs.setResponseValueAndErrors)(res, "exclusiveMaximum", check.value, check.message, refs);
            } else {
                if (!check.inclusive) res.exclusiveMaximum = true;
                (0, _errorMessagesJs.setResponseValueAndErrors)(res, "maximum", check.value, check.message, refs);
            }
            break;
        case "multipleOf":
            (0, _errorMessagesJs.setResponseValueAndErrors)(res, "multipleOf", check.value, check.message, refs);
            break;
    }
    return res;
}

},{"../errorMessages.js":"fWbE4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bMwwV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseObjectDef", ()=>parseObjectDef);
var _parseDefJs = require("../parseDef.js");
function decideAdditionalProperties(def, refs) {
    if (refs.removeAdditionalStrategy === "strict") return def.catchall._def.typeName === "ZodNever" ? def.unknownKeys !== "strict" : (0, _parseDefJs.parseDef)(def.catchall._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            "additionalProperties"
        ]
    }) ?? true;
    else return def.catchall._def.typeName === "ZodNever" ? def.unknownKeys === "passthrough" : (0, _parseDefJs.parseDef)(def.catchall._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            "additionalProperties"
        ]
    }) ?? true;
}
function parseObjectDef(def, refs) {
    const result = {
        type: "object",
        ...Object.entries(def.shape()).reduce((acc, [propName, propDef])=>{
            if (propDef === undefined || propDef._def === undefined) return acc;
            const parsedDef = (0, _parseDefJs.parseDef)(propDef._def, {
                ...refs,
                currentPath: [
                    ...refs.currentPath,
                    "properties",
                    propName
                ],
                propertyPath: [
                    ...refs.currentPath,
                    "properties",
                    propName
                ]
            });
            if (parsedDef === undefined) return acc;
            return {
                properties: {
                    ...acc.properties,
                    [propName]: parsedDef
                },
                required: propDef.isOptional() ? acc.required : [
                    ...acc.required,
                    propName
                ]
            };
        }, {
            properties: {},
            required: []
        }),
        additionalProperties: decideAdditionalProperties(def, refs)
    };
    if (!result.required.length) delete result.required;
    return result;
}

},{"../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Bi8s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseOptionalDef", ()=>parseOptionalDef);
var _parseDefJs = require("../parseDef.js");
const parseOptionalDef = (def, refs)=>{
    if (refs.currentPath.toString() === refs.propertyPath?.toString()) return (0, _parseDefJs.parseDef)(def.innerType._def, refs);
    const innerSchema = (0, _parseDefJs.parseDef)(def.innerType._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            "anyOf",
            "1"
        ]
    });
    return innerSchema ? {
        anyOf: [
            {
                not: {}
            },
            innerSchema
        ]
    } : {};
};

},{"../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hVGeD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsePipelineDef", ()=>parsePipelineDef);
var _parseDefJs = require("../parseDef.js");
const parsePipelineDef = (def, refs)=>{
    if (refs.pipeStrategy === "input") return (0, _parseDefJs.parseDef)(def.in._def, refs);
    else if (refs.pipeStrategy === "output") return (0, _parseDefJs.parseDef)(def.out._def, refs);
    const a = (0, _parseDefJs.parseDef)(def.in._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            "allOf",
            "0"
        ]
    });
    const b = (0, _parseDefJs.parseDef)(def.out._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            "allOf",
            a ? "1" : "0"
        ]
    });
    return {
        allOf: [
            a,
            b
        ].filter((x)=>x !== undefined)
    };
};

},{"../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b2wk2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsePromiseDef", ()=>parsePromiseDef);
var _parseDefJs = require("../parseDef.js");
function parsePromiseDef(def, refs) {
    return (0, _parseDefJs.parseDef)(def.type._def, refs);
}

},{"../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hbdFJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseSetDef", ()=>parseSetDef);
var _errorMessagesJs = require("../errorMessages.js");
var _parseDefJs = require("../parseDef.js");
function parseSetDef(def, refs) {
    const items = (0, _parseDefJs.parseDef)(def.valueType._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            "items"
        ]
    });
    const schema = {
        type: "array",
        uniqueItems: true,
        items
    };
    if (def.minSize) (0, _errorMessagesJs.setResponseValueAndErrors)(schema, "minItems", def.minSize.value, def.minSize.message, refs);
    if (def.maxSize) (0, _errorMessagesJs.setResponseValueAndErrors)(schema, "maxItems", def.maxSize.value, def.maxSize.message, refs);
    return schema;
}

},{"../errorMessages.js":"fWbE4","../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8zu3h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseTupleDef", ()=>parseTupleDef);
var _parseDefJs = require("../parseDef.js");
function parseTupleDef(def, refs) {
    if (def.rest) return {
        type: "array",
        minItems: def.items.length,
        items: def.items.map((x, i)=>(0, _parseDefJs.parseDef)(x._def, {
                ...refs,
                currentPath: [
                    ...refs.currentPath,
                    "items",
                    `${i}`
                ]
            })).reduce((acc, x)=>x === undefined ? acc : [
                ...acc,
                x
            ], []),
        additionalItems: (0, _parseDefJs.parseDef)(def.rest._def, {
            ...refs,
            currentPath: [
                ...refs.currentPath,
                "additionalItems"
            ]
        })
    };
    else return {
        type: "array",
        minItems: def.items.length,
        maxItems: def.items.length,
        items: def.items.map((x, i)=>(0, _parseDefJs.parseDef)(x._def, {
                ...refs,
                currentPath: [
                    ...refs.currentPath,
                    "items",
                    `${i}`
                ]
            })).reduce((acc, x)=>x === undefined ? acc : [
                ...acc,
                x
            ], [])
    };
}

},{"../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"duwEn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUndefinedDef", ()=>parseUndefinedDef);
function parseUndefinedDef() {
    return {
        not: {}
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"icITY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUnknownDef", ()=>parseUnknownDef);
function parseUnknownDef() {
    return {};
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a51mf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseReadonlyDef", ()=>parseReadonlyDef);
var _parseDefJs = require("../parseDef.js");
const parseReadonlyDef = (def, refs)=>{
    return (0, _parseDefJs.parseDef)(def.innerType._def, refs);
};

},{"../parseDef.js":"lITpI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1vjNo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zodToJsonSchema", ()=>zodToJsonSchema);
var _parseDefJs = require("./parseDef.js");
var _refsJs = require("./Refs.js");
const zodToJsonSchema = (schema, options)=>{
    const refs = (0, _refsJs.getRefs)(options);
    const definitions = typeof options === "object" && options.definitions ? Object.entries(options.definitions).reduce((acc, [name, schema])=>({
            ...acc,
            [name]: (0, _parseDefJs.parseDef)(schema._def, {
                ...refs,
                currentPath: [
                    ...refs.basePath,
                    refs.definitionPath,
                    name
                ]
            }, true) ?? {}
        }), {}) : undefined;
    const name = typeof options === "string" ? options : options?.nameStrategy === "title" ? undefined : options?.name;
    const main = (0, _parseDefJs.parseDef)(schema._def, name === undefined ? refs : {
        ...refs,
        currentPath: [
            ...refs.basePath,
            refs.definitionPath,
            name
        ]
    }, false) ?? {};
    const title = typeof options === "object" && options.name !== undefined && options.nameStrategy === "title" ? options.name : undefined;
    if (title !== undefined) main.title = title;
    const combined = name === undefined ? definitions ? {
        ...main,
        [refs.definitionPath]: definitions
    } : main : {
        $ref: [
            ...refs.$refStrategy === "relative" ? [] : refs.basePath,
            refs.definitionPath,
            name
        ].join("/"),
        [refs.definitionPath]: {
            ...definitions,
            [name]: main
        }
    };
    if (refs.target === "jsonSchema7") combined.$schema = "http://json-schema.org/draft-07/schema#";
    else if (refs.target === "jsonSchema2019-09") combined.$schema = "https://json-schema.org/draft/2019-09/schema#";
    return combined;
};

},{"./parseDef.js":"lITpI","./Refs.js":"f8UtW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e1kN9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Draws a Mermaid graph using the provided graph data
 */ parcelHelpers.export(exports, "drawMermaid", ()=>drawMermaid);
/**
 * Renders Mermaid graph using the Mermaid.INK API.
 */ parcelHelpers.export(exports, "drawMermaidPng", ()=>drawMermaidPng);
function _escapeNodeLabel(nodeLabel) {
    // Escapes the node label for Mermaid syntax.
    return nodeLabel.replace(/[^a-zA-Z-_0-9]/g, "_");
}
const MARKDOWN_SPECIAL_CHARS = [
    "*",
    "_",
    "`"
];
function _generateMermaidGraphStyles(nodeColors) {
    let styles = "";
    for (const [className, color] of Object.entries(nodeColors))styles += `\tclassDef ${className} ${color};\n`;
    return styles;
}
function drawMermaid(nodes, edges, config) {
    const { firstNode, lastNode, nodeColors, withStyles = true, curveStyle = "linear", wrapLabelNWords = 9 } = config ?? {};
    // Initialize Mermaid graph configuration
    let mermaidGraph = withStyles ? `%%{init: {'flowchart': {'curve': '${curveStyle}'}}}%%\ngraph TD;\n` : "graph TD;\n";
    if (withStyles) {
        // Node formatting templates
        const defaultClassLabel = "default";
        const formatDict = {
            [defaultClassLabel]: "{0}({1})"
        };
        if (firstNode !== undefined) formatDict[firstNode] = "{0}([{1}]):::first";
        if (lastNode !== undefined) formatDict[lastNode] = "{0}([{1}]):::last";
        // Add nodes to the graph
        for (const [key, node] of Object.entries(nodes)){
            const nodeName = node.name.split(":").pop() ?? "";
            const label = MARKDOWN_SPECIAL_CHARS.some((char)=>nodeName.startsWith(char) && nodeName.endsWith(char)) ? `<p>${nodeName}</p>` : nodeName;
            let finalLabel = label;
            if (Object.keys(node.metadata ?? {}).length) finalLabel += `<hr/><small><em>${Object.entries(node.metadata ?? {}).map(([k, v])=>`${k} = ${v}`).join("\n")}</em></small>`;
            const nodeLabel = (formatDict[key] ?? formatDict[defaultClassLabel]).replace("{0}", _escapeNodeLabel(key)).replace("{1}", finalLabel);
            mermaidGraph += `\t${nodeLabel}\n`;
        }
    }
    // Group edges by their common prefixes
    const edgeGroups = {};
    for (const edge of edges){
        const srcParts = edge.source.split(":");
        const tgtParts = edge.target.split(":");
        const commonPrefix = srcParts.filter((src, i)=>src === tgtParts[i]).join(":");
        if (!edgeGroups[commonPrefix]) edgeGroups[commonPrefix] = [];
        edgeGroups[commonPrefix].push(edge);
    }
    const seenSubgraphs = new Set();
    function addSubgraph(edges, prefix) {
        const selfLoop = edges.length === 1 && edges[0].source === edges[0].target;
        if (prefix && !selfLoop) {
            const subgraph = prefix.split(":").pop();
            if (seenSubgraphs.has(subgraph)) throw new Error(`Found duplicate subgraph '${subgraph}' -- this likely means that ` + "you're reusing a subgraph node with the same name. " + "Please adjust your graph to have subgraph nodes with unique names.");
            seenSubgraphs.add(subgraph);
            mermaidGraph += `\tsubgraph ${subgraph}\n`;
        }
        for (const edge of edges){
            const { source, target, data, conditional } = edge;
            let edgeLabel = "";
            if (data !== undefined) {
                let edgeData = data;
                const words = edgeData.split(" ");
                if (words.length > wrapLabelNWords) edgeData = Array.from({
                    length: Math.ceil(words.length / wrapLabelNWords)
                }, (_, i)=>words.slice(i * wrapLabelNWords, (i + 1) * wrapLabelNWords).join(" ")).join("&nbsp;<br>&nbsp;");
                edgeLabel = conditional ? ` -. &nbsp;${edgeData}&nbsp; .-> ` : ` -- &nbsp;${edgeData}&nbsp; --> `;
            } else edgeLabel = conditional ? " -.-> " : " --> ";
            mermaidGraph += `\t${_escapeNodeLabel(source)}${edgeLabel}${_escapeNodeLabel(target)};\n`;
        }
        // Recursively add nested subgraphs
        for(const nestedPrefix in edgeGroups)if (nestedPrefix.startsWith(`${prefix}:`) && nestedPrefix !== prefix) addSubgraph(edgeGroups[nestedPrefix], nestedPrefix);
        if (prefix && !selfLoop) mermaidGraph += "\tend\n";
    }
    // Start with the top-level edges (no common prefix)
    addSubgraph(edgeGroups[""] ?? [], "");
    // Add remaining subgraphs
    for(const prefix in edgeGroups)if (!prefix.includes(":") && prefix !== "") addSubgraph(edgeGroups[prefix], prefix);
    // Add custom styles for nodes
    if (withStyles) mermaidGraph += _generateMermaidGraphStyles(nodeColors ?? {});
    return mermaidGraph;
}
async function drawMermaidPng(mermaidSyntax, config) {
    let { backgroundColor = "white" } = config ?? {};
    // Use btoa for compatibility, assume ASCII
    const mermaidSyntaxEncoded = btoa(mermaidSyntax);
    // Check if the background color is a hexadecimal color code using regex
    if (backgroundColor !== undefined) {
        const hexColorPattern = /^#(?:[0-9a-fA-F]{3}){1,2}$/;
        if (!hexColorPattern.test(backgroundColor)) backgroundColor = `!${backgroundColor}`;
    }
    const imageUrl = `https://mermaid.ink/img/${mermaidSyntaxEncoded}?bgColor=${backgroundColor}`;
    const res = await fetch(imageUrl);
    if (!res.ok) throw new Error([
        `Failed to render the graph using the Mermaid.INK API.`,
        `Status code: ${res.status}`,
        `Status text: ${res.statusText}`
    ].join("\n"));
    const content = await res.blob();
    return content;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"EXGD7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertToHttpEventStream", ()=>convertToHttpEventStream);
var _streamJs = require("../utils/stream.js");
function convertToHttpEventStream(stream) {
    const encoder = new TextEncoder();
    const finalStream = new ReadableStream({
        async start (controller) {
            for await (const chunk of stream)controller.enqueue(encoder.encode(`event: data\ndata: ${JSON.stringify(chunk)}\n\n`));
            controller.enqueue(encoder.encode("event: end\n\n"));
            controller.close();
        }
    });
    return (0, _streamJs.IterableReadableStream).fromReadableStream(finalStream);
}

},{"../utils/stream.js":"kAAca","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ekoPe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIterableIterator", ()=>isIterableIterator);
parcelHelpers.export(exports, "isIterator", ()=>isIterator);
parcelHelpers.export(exports, "isAsyncIterable", ()=>isAsyncIterable);
parcelHelpers.export(exports, "consumeIteratorInContext", ()=>consumeIteratorInContext);
parcelHelpers.export(exports, "consumeAsyncIterableInContext", ()=>consumeAsyncIterableInContext);
var _indexJs = require("../singletons/index.js");
function isIterableIterator(thing) {
    return typeof thing === "object" && thing !== null && typeof thing[Symbol.iterator] === "function" && // avoid detecting array/set as iterator
    typeof thing.next === "function";
}
const isIterator = (x)=>x != null && typeof x === "object" && "next" in x && typeof x.next === "function";
function isAsyncIterable(thing) {
    return typeof thing === "object" && thing !== null && typeof thing[Symbol.asyncIterator] === "function";
}
function* consumeIteratorInContext(context, iter) {
    while(true){
        const { value, done } = (0, _indexJs.AsyncLocalStorageProviderSingleton).runWithConfig(context, iter.next.bind(iter), true);
        if (done) break;
        else yield value;
    }
}
async function* consumeAsyncIterableInContext(context, iter) {
    const iterator = iter[Symbol.asyncIterator]();
    while(true){
        const { value, done } = await (0, _indexJs.AsyncLocalStorageProviderSingleton).runWithConfig(context, iterator.next.bind(iter), true);
        if (done) break;
        else yield value;
    }
}

},{"../singletons/index.js":"1O31N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"96Qr0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Message responsible for deleting other messages.
 */ parcelHelpers.export(exports, "RemoveMessage", ()=>RemoveMessage);
var _baseJs = require("./base.js");
class RemoveMessage extends (0, _baseJs.BaseMessage) {
    constructor(fields){
        super({
            ...fields,
            content: ""
        });
        /**
         * The ID of the message to remove.
         */ Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = fields.id;
    }
    _getType() {
        return "remove";
    }
    get _printableFields() {
        return {
            ...super._printableFields,
            id: this.id
        };
    }
}

},{"./base.js":"bWcpl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1rg9x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _documentJs = require("./document.js");
parcelHelpers.exportAll(_documentJs, exports);
var _transformersJs = require("./transformers.js");
parcelHelpers.exportAll(_transformersJs, exports);

},{"./document.js":"8svrY","./transformers.js":"iBccc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8svrY":[function(require,module,exports,__globalThis) {
/**
 * Interface for interacting with a document.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Document", ()=>Document);
class Document {
    constructor(fields){
        Object.defineProperty(this, "pageContent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // The ID field is optional at the moment.
        // It will likely become required in a future major release after
        // it has been adopted by enough vectorstore implementations.
        /**
         * An optional identifier for the document.
         *
         * Ideally this should be unique across the document collection and formatted
         * as a UUID, but this will not be enforced.
         */ Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.pageContent = fields.pageContent !== undefined ? fields.pageContent.toString() : "";
        this.metadata = fields.metadata ?? {};
        this.id = fields.id;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iBccc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Abstract base class for document transformation systems.
 *
 * A document transformation system takes an array of Documents and returns an
 * array of transformed Documents. These arrays do not necessarily have to have
 * the same length.
 *
 * One example of this is a text splitter that splits a large document into
 * many smaller documents.
 */ parcelHelpers.export(exports, "BaseDocumentTransformer", ()=>BaseDocumentTransformer);
/**
 * Class for document transformers that return exactly one transformed document
 * for each input document.
 */ parcelHelpers.export(exports, "MappingDocumentTransformer", ()=>MappingDocumentTransformer);
var _baseJs = require("../runnables/base.js");
class BaseDocumentTransformer extends (0, _baseJs.Runnable) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "documents",
                "transformers"
            ]
        });
    }
    /**
     * Method to invoke the document transformation. This method calls the
     * transformDocuments method with the provided input.
     * @param input The input documents to be transformed.
     * @param _options Optional configuration object to customize the behavior of callbacks.
     * @returns A Promise that resolves to the transformed documents.
     */ invoke(input, _options) {
        return this.transformDocuments(input);
    }
}
class MappingDocumentTransformer extends BaseDocumentTransformer {
    async transformDocuments(documents) {
        const newDocuments = [];
        for (const document of documents){
            const transformedDocument = await this._transformDocument(document);
            newDocuments.push(transformedDocument);
        }
        return newDocuments;
    }
}

},{"../runnables/base.js":"9xkzz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iP48n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An abstract class that provides methods for embedding documents and
 * queries using LangChain.
 */ parcelHelpers.export(exports, "Embeddings", ()=>Embeddings);
var _asyncCallerJs = require("./utils/async_caller.js");
class Embeddings {
    constructor(params){
        /**
         * The async caller should be used by subclasses to make any async calls,
         * which will thus benefit from the concurrency and retry logic.
         */ Object.defineProperty(this, "caller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.caller = new (0, _asyncCallerJs.AsyncCaller)(params ?? {});
    }
}

},{"./utils/async_caller.js":"9E8gp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7i9vW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseJs = require("./base.js");
parcelHelpers.exportAll(_baseJs, exports);
var _conditionalJs = require("./conditional.js");
parcelHelpers.exportAll(_conditionalJs, exports);
var _lengthBasedJs = require("./length_based.js");
parcelHelpers.exportAll(_lengthBasedJs, exports);
var _semanticSimilarityJs = require("./semantic_similarity.js");
parcelHelpers.exportAll(_semanticSimilarityJs, exports);

},{"./base.js":"3Gm5h","./conditional.js":"gAl9U","./length_based.js":"jK3Ql","./semantic_similarity.js":"fT13T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Gm5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Base class for example selectors.
 */ parcelHelpers.export(exports, "BaseExampleSelector", ()=>BaseExampleSelector);
var _serializableJs = require("../load/serializable.js");
class BaseExampleSelector extends (0, _serializableJs.Serializable) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "example_selectors",
                "base"
            ]
        });
    }
}

},{"../load/serializable.js":"2n7FI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gAl9U":[function(require,module,exports,__globalThis) {
/**
 * Abstract class that defines the interface for selecting a prompt for a
 * given language model.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BasePromptSelector", ()=>BasePromptSelector);
/**
 * Concrete implementation of `BasePromptSelector` that selects a prompt
 * based on a set of conditions. It has a default prompt that it returns
 * if none of the conditions are met.
 */ parcelHelpers.export(exports, "ConditionalPromptSelector", ()=>ConditionalPromptSelector);
/**
 * Type guard function that checks if a given language model is of type
 * `BaseLLM`.
 */ parcelHelpers.export(exports, "isLLM", ()=>isLLM);
/**
 * Type guard function that checks if a given language model is of type
 * `BaseChatModel`.
 */ parcelHelpers.export(exports, "isChatModel", ()=>isChatModel);
class BasePromptSelector {
    /**
     * Asynchronous version of `getPrompt` that also accepts an options object
     * for partial variables.
     * @param llm The language model for which to get a prompt.
     * @param options Optional object for partial variables.
     * @returns A Promise that resolves to a prompt template.
     */ async getPromptAsync(llm, options) {
        const prompt = this.getPrompt(llm);
        return prompt.partial(options?.partialVariables ?? {});
    }
}
class ConditionalPromptSelector extends BasePromptSelector {
    constructor(default_prompt, conditionals = []){
        super();
        Object.defineProperty(this, "defaultPrompt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "conditionals", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.defaultPrompt = default_prompt;
        this.conditionals = conditionals;
    }
    /**
     * Method that selects a prompt based on a set of conditions. If none of
     * the conditions are met, it returns the default prompt.
     * @param llm The language model for which to get a prompt.
     * @returns A prompt template.
     */ getPrompt(llm) {
        for (const [condition, prompt] of this.conditionals){
            if (condition(llm)) return prompt;
        }
        return this.defaultPrompt;
    }
}
function isLLM(llm) {
    return llm._modelType() === "base_llm";
}
function isChatModel(llm) {
    return llm._modelType() === "base_chat_model";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jK3Ql":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A specialized example selector that selects examples based on their
 * length, ensuring that the total length of the selected examples does
 * not exceed a specified maximum length.
 * @example
 * ```typescript
 * const exampleSelector = new LengthBasedExampleSelector(
 *   [
 *     { input: "happy", output: "sad" },
 *     { input: "tall", output: "short" },
 *     { input: "energetic", output: "lethargic" },
 *     { input: "sunny", output: "gloomy" },
 *     { input: "windy", output: "calm" },
 *   ],
 *   {
 *     examplePrompt: new PromptTemplate({
 *       inputVariables: ["input", "output"],
 *       template: "Input: {input}\nOutput: {output}",
 *     }),
 *     maxLength: 25,
 *   },
 * );
 * const dynamicPrompt = new FewShotPromptTemplate({
 *   exampleSelector,
 *   examplePrompt: new PromptTemplate({
 *     inputVariables: ["input", "output"],
 *     template: "Input: {input}\nOutput: {output}",
 *   }),
 *   prefix: "Give the antonym of every input",
 *   suffix: "Input: {adjective}\nOutput:",
 *   inputVariables: ["adjective"],
 * });
 * console.log(dynamicPrompt.format({ adjective: "big" }));
 * console.log(
 *   dynamicPrompt.format({
 *     adjective:
 *       "big and huge and massive and large and gigantic and tall and much much much much much bigger than everything else",
 *   }),
 * );
 * ```
 */ parcelHelpers.export(exports, "LengthBasedExampleSelector", ()=>LengthBasedExampleSelector);
var _baseJs = require("./base.js");
/**
 * Calculates the length of a text based on the number of words and lines.
 */ function getLengthBased(text) {
    return text.split(/\n| /).length;
}
class LengthBasedExampleSelector extends (0, _baseJs.BaseExampleSelector) {
    constructor(data){
        super(data);
        Object.defineProperty(this, "examples", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "examplePrompt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getTextLength", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: getLengthBased
        });
        Object.defineProperty(this, "maxLength", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 2048
        });
        Object.defineProperty(this, "exampleTextLengths", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        this.examplePrompt = data.examplePrompt;
        this.maxLength = data.maxLength ?? 2048;
        this.getTextLength = data.getTextLength ?? getLengthBased;
    }
    /**
     * Adds an example to the list of examples and calculates its length.
     * @param example The example to be added.
     * @returns Promise that resolves when the example has been added and its length calculated.
     */ async addExample(example) {
        this.examples.push(example);
        const stringExample = await this.examplePrompt.format(example);
        this.exampleTextLengths.push(this.getTextLength(stringExample));
    }
    /**
     * Calculates the lengths of the examples.
     * @param v Array of lengths of the examples.
     * @param values Instance of LengthBasedExampleSelector.
     * @returns Promise that resolves with an array of lengths of the examples.
     */ async calculateExampleTextLengths(v, values) {
        if (v.length > 0) return v;
        const { examples, examplePrompt } = values;
        const stringExamples = await Promise.all(examples.map((eg)=>examplePrompt.format(eg)));
        return stringExamples.map((eg)=>this.getTextLength(eg));
    }
    /**
     * Selects examples until the total length of the selected examples
     * reaches the maxLength.
     * @param inputVariables The input variables for the examples.
     * @returns Promise that resolves with an array of selected examples.
     */ async selectExamples(inputVariables) {
        const inputs = Object.values(inputVariables).join(" ");
        let remainingLength = this.maxLength - this.getTextLength(inputs);
        let i = 0;
        const examples = [];
        while(remainingLength > 0 && i < this.examples.length){
            const newLength = remainingLength - this.exampleTextLengths[i];
            if (newLength < 0) break;
            else {
                examples.push(this.examples[i]);
                remainingLength = newLength;
            }
            i += 1;
        }
        return examples;
    }
    /**
     * Creates a new instance of LengthBasedExampleSelector and adds a list of
     * examples to it.
     * @param examples Array of examples to be added.
     * @param args Input parameters for the LengthBasedExampleSelector.
     * @returns Promise that resolves with a new instance of LengthBasedExampleSelector with the examples added.
     */ static async fromExamples(examples, args) {
        const selector = new LengthBasedExampleSelector(args);
        await Promise.all(examples.map((eg)=>selector.addExample(eg)));
        return selector;
    }
}

},{"./base.js":"3Gm5h","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fT13T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Class that selects examples based on semantic similarity. It extends
 * the BaseExampleSelector class.
 * @example
 * ```typescript
 * const exampleSelector = await SemanticSimilarityExampleSelector.fromExamples(
 *   [
 *     { input: "happy", output: "sad" },
 *     { input: "tall", output: "short" },
 *     { input: "energetic", output: "lethargic" },
 *     { input: "sunny", output: "gloomy" },
 *     { input: "windy", output: "calm" },
 *   ],
 *   new OpenAIEmbeddings(),
 *   HNSWLib,
 *   { k: 1 },
 * );
 * const dynamicPrompt = new FewShotPromptTemplate({
 *   exampleSelector,
 *   examplePrompt: PromptTemplate.fromTemplate(
 *     "Input: {input}\nOutput: {output}",
 *   ),
 *   prefix: "Give the antonym of every input",
 *   suffix: "Input: {adjective}\nOutput:",
 *   inputVariables: ["adjective"],
 * });
 * console.log(await dynamicPrompt.format({ adjective: "rainy" }));
 * ```
 */ parcelHelpers.export(exports, "SemanticSimilarityExampleSelector", ()=>SemanticSimilarityExampleSelector);
var _documentJs = require("../documents/document.js");
var _baseJs = require("./base.js");
function sortedValues(values) {
    return Object.keys(values).sort().map((key)=>values[key]);
}
class SemanticSimilarityExampleSelector extends (0, _baseJs.BaseExampleSelector) {
    constructor(data){
        super(data);
        Object.defineProperty(this, "vectorStoreRetriever", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exampleKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "inputKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.exampleKeys = data.exampleKeys;
        this.inputKeys = data.inputKeys;
        if (data.vectorStore !== undefined) this.vectorStoreRetriever = data.vectorStore.asRetriever({
            k: data.k ?? 4,
            filter: data.filter
        });
        else if (data.vectorStoreRetriever) this.vectorStoreRetriever = data.vectorStoreRetriever;
        else throw new Error(`You must specify one of "vectorStore" and "vectorStoreRetriever".`);
    }
    /**
     * Method that adds a new example to the vectorStore. The example is
     * converted to a string and added to the vectorStore as a document.
     * @param example The example to be added to the vectorStore.
     * @returns Promise that resolves when the example has been added to the vectorStore.
     */ async addExample(example) {
        const inputKeys = this.inputKeys ?? Object.keys(example);
        const stringExample = sortedValues(inputKeys.reduce((acc, key)=>({
                ...acc,
                [key]: example[key]
            }), {})).join(" ");
        await this.vectorStoreRetriever.addDocuments([
            new (0, _documentJs.Document)({
                pageContent: stringExample,
                metadata: example
            })
        ]);
    }
    /**
     * Method that selects which examples to use based on semantic similarity.
     * It performs a similarity search in the vectorStore using the input
     * variables and returns the examples with the highest similarity.
     * @param inputVariables The input variables used for the similarity search.
     * @returns Promise that resolves with an array of the selected examples.
     */ async selectExamples(inputVariables) {
        const inputKeys = this.inputKeys ?? Object.keys(inputVariables);
        const query = sortedValues(inputKeys.reduce((acc, key)=>({
                ...acc,
                [key]: inputVariables[key]
            }), {})).join(" ");
        const exampleDocs = await this.vectorStoreRetriever.invoke(query);
        const examples = exampleDocs.map((doc)=>doc.metadata);
        if (this.exampleKeys) // If example keys are provided, filter examples to those keys.
        return examples.map((example)=>this.exampleKeys.reduce((acc, key)=>({
                    ...acc,
                    [key]: example[key]
                }), {}));
        return examples;
    }
    /**
     * Static method that creates a new instance of
     * SemanticSimilarityExampleSelector. It takes a list of examples, an
     * instance of Embeddings, a VectorStore class, and an options object as
     * parameters. It converts the examples to strings, creates a VectorStore
     * from the strings and the embeddings, and returns a new
     * SemanticSimilarityExampleSelector with the created VectorStore and the
     * options provided.
     * @param examples The list of examples to be used.
     * @param embeddings The instance of Embeddings to be used.
     * @param vectorStoreCls The VectorStore class to be used.
     * @param options The options object for the SemanticSimilarityExampleSelector.
     * @returns Promise that resolves with a new instance of SemanticSimilarityExampleSelector.
     */ static async fromExamples(examples, embeddings, vectorStoreCls, options = {}) {
        const inputKeys = options.inputKeys ?? null;
        const stringExamples = examples.map((example)=>sortedValues(inputKeys ? inputKeys.reduce((acc, key)=>({
                    ...acc,
                    [key]: example[key]
                }), {}) : example).join(" "));
        const vectorStore = await vectorStoreCls.fromTexts(stringExamples, examples, embeddings, options);
        return new SemanticSimilarityExampleSelector({
            vectorStore,
            k: options.k ?? 4,
            exampleKeys: options.exampleKeys,
            inputKeys: options.inputKeys
        });
    }
}

},{"../documents/document.js":"8svrY","./base.js":"3Gm5h","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"grvsA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getModelNameForTiktoken", ()=>getModelNameForTiktoken);
parcelHelpers.export(exports, "getEmbeddingContextSize", ()=>getEmbeddingContextSize);
parcelHelpers.export(exports, "getModelContextSize", ()=>getModelContextSize);
/**
 * Whether or not the input matches the OpenAI tool definition.
 * @param {unknown} tool The input to check.
 * @returns {boolean} Whether the input is an OpenAI tool definition.
 */ parcelHelpers.export(exports, "isOpenAITool", ()=>isOpenAITool);
parcelHelpers.export(exports, "calculateMaxTokens", ()=>calculateMaxTokens);
/**
 * Base class for language models, chains, tools.
 */ parcelHelpers.export(exports, "BaseLangChain", ()=>BaseLangChain);
/**
 * Base class for language models.
 */ parcelHelpers.export(exports, "BaseLanguageModel", ()=>BaseLanguageModel);
var _baseJs = require("../caches/base.js");
var _promptValuesJs = require("../prompt_values.js");
var _utilsJs = require("../messages/utils.js");
var _asyncCallerJs = require("../utils/async_caller.js");
var _tiktokenJs = require("../utils/tiktoken.js");
var _baseJs1 = require("../runnables/base.js");
const getModelNameForTiktoken = (modelName)=>{
    if (modelName.startsWith("gpt-3.5-turbo-16k")) return "gpt-3.5-turbo-16k";
    if (modelName.startsWith("gpt-3.5-turbo-")) return "gpt-3.5-turbo";
    if (modelName.startsWith("gpt-4-32k")) return "gpt-4-32k";
    if (modelName.startsWith("gpt-4-")) return "gpt-4";
    if (modelName.startsWith("gpt-4o")) return "gpt-4o";
    return modelName;
};
const getEmbeddingContextSize = (modelName)=>{
    switch(modelName){
        case "text-embedding-ada-002":
            return 8191;
        default:
            return 2046;
    }
};
const getModelContextSize = (modelName)=>{
    switch(getModelNameForTiktoken(modelName)){
        case "gpt-3.5-turbo-16k":
            return 16384;
        case "gpt-3.5-turbo":
            return 4096;
        case "gpt-4-32k":
            return 32768;
        case "gpt-4":
            return 8192;
        case "text-davinci-003":
            return 4097;
        case "text-curie-001":
            return 2048;
        case "text-babbage-001":
            return 2048;
        case "text-ada-001":
            return 2048;
        case "code-davinci-002":
            return 8000;
        case "code-cushman-001":
            return 2048;
        default:
            return 4097;
    }
};
function isOpenAITool(tool) {
    if (typeof tool !== "object" || !tool) return false;
    if ("type" in tool && tool.type === "function" && "function" in tool && typeof tool.function === "object" && tool.function && "name" in tool.function && "parameters" in tool.function) return true;
    return false;
}
const calculateMaxTokens = async ({ prompt, modelName })=>{
    let numTokens;
    try {
        numTokens = (await (0, _tiktokenJs.encodingForModel)(getModelNameForTiktoken(modelName))).encode(prompt).length;
    } catch (error) {
        console.warn("Failed to calculate number of tokens, falling back to approximate count");
        // fallback to approximate calculation if tiktoken is not available
        // each token is ~4 characters: https://help.openai.com/en/articles/4936856-what-are-tokens-and-how-to-count-them#
        numTokens = Math.ceil(prompt.length / 4);
    }
    const maxTokens = getModelContextSize(modelName);
    return maxTokens - numTokens;
};
const getVerbosity = ()=>false;
class BaseLangChain extends (0, _baseJs1.Runnable) {
    get lc_attributes() {
        return {
            callbacks: undefined,
            verbose: undefined
        };
    }
    constructor(params){
        super(params);
        /**
         * Whether to print out response text.
         */ Object.defineProperty(this, "verbose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "callbacks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.verbose = params.verbose ?? getVerbosity();
        this.callbacks = params.callbacks;
        this.tags = params.tags ?? [];
        this.metadata = params.metadata ?? {};
    }
}
class BaseLanguageModel extends BaseLangChain {
    /**
     * Keys that the language model accepts as call options.
     */ get callKeys() {
        return [
            "stop",
            "timeout",
            "signal",
            "tags",
            "metadata",
            "callbacks"
        ];
    }
    constructor({ callbacks, callbackManager, ...params }){
        const { cache, ...rest } = params;
        super({
            callbacks: callbacks ?? callbackManager,
            ...rest
        });
        /**
         * The async caller should be used by subclasses to make any async calls,
         * which will thus benefit from the concurrency and retry logic.
         */ Object.defineProperty(this, "caller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_encoding", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (typeof cache === "object") this.cache = cache;
        else if (cache) this.cache = (0, _baseJs.InMemoryCache).global();
        else this.cache = undefined;
        this.caller = new (0, _asyncCallerJs.AsyncCaller)(params ?? {});
    }
    async getNumTokens(content) {
        // TODO: Figure out correct value.
        if (typeof content !== "string") return 0;
        // fallback to approximate calculation if tiktoken is not available
        let numTokens = Math.ceil(content.length / 4);
        if (!this._encoding) try {
            this._encoding = await (0, _tiktokenJs.encodingForModel)("modelName" in this ? getModelNameForTiktoken(this.modelName) : "gpt2");
        } catch (error) {
            console.warn("Failed to calculate number of tokens, falling back to approximate count", error);
        }
        if (this._encoding) try {
            numTokens = this._encoding.encode(content).length;
        } catch (error) {
            console.warn("Failed to calculate number of tokens, falling back to approximate count", error);
        }
        return numTokens;
    }
    static _convertInputToPromptValue(input) {
        if (typeof input === "string") return new (0, _promptValuesJs.StringPromptValue)(input);
        else if (Array.isArray(input)) return new (0, _promptValuesJs.ChatPromptValue)(input.map((0, _utilsJs.coerceMessageLikeToMessage)));
        else return input;
    }
    /**
     * Get the identifying parameters of the LLM.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _identifyingParams() {
        return {};
    }
    /**
     * Create a unique cache key for a specific call to a specific language model.
     * @param callOptions Call options for the model
     * @returns A unique cache key.
     */ _getSerializedCacheKeyParametersForCall(// TODO: Fix when we remove the RunnableLambda backwards compatibility shim.
    { config, ...callOptions }) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const params = {
            ...this._identifyingParams(),
            ...callOptions,
            _type: this._llmType(),
            _model: this._modelType()
        };
        const filteredEntries = Object.entries(params).filter(([_, value])=>value !== undefined);
        const serializedEntries = filteredEntries.map(([key, value])=>`${key}:${JSON.stringify(value)}`).sort().join(",");
        return serializedEntries;
    }
    /**
     * @deprecated
     * Return a json-like object representing this LLM.
     */ serialize() {
        return {
            ...this._identifyingParams(),
            _type: this._llmType(),
            _model: this._modelType()
        };
    }
    /**
     * @deprecated
     * Load an LLM from a json-like object describing it.
     */ static async deserialize(_data) {
        throw new Error("Use .toJSON() instead");
    }
}

},{"../caches/base.js":"dmyRR","../prompt_values.js":"lY5Gs","../messages/utils.js":"6vi0n","../utils/async_caller.js":"9E8gp","../utils/tiktoken.js":"bMqbG","../runnables/base.js":"9xkzz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lY5Gs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Base PromptValue class. All prompt values should extend this class.
 */ parcelHelpers.export(exports, "BasePromptValue", ()=>BasePromptValue);
/**
 * Represents a prompt value as a string. It extends the BasePromptValue
 * class and overrides the toString and toChatMessages methods.
 */ parcelHelpers.export(exports, "StringPromptValue", ()=>StringPromptValue);
/**
 * Class that represents a chat prompt value. It extends the
 * BasePromptValue and includes an array of BaseMessage instances.
 */ parcelHelpers.export(exports, "ChatPromptValue", ()=>ChatPromptValue);
/**
 * Class that represents an image prompt value. It extends the
 * BasePromptValue and includes an ImageURL instance.
 */ parcelHelpers.export(exports, "ImagePromptValue", ()=>ImagePromptValue);
var _serializableJs = require("./load/serializable.js");
var _humanJs = require("./messages/human.js");
var _utilsJs = require("./messages/utils.js");
class BasePromptValue extends (0, _serializableJs.Serializable) {
}
class StringPromptValue extends BasePromptValue {
    static lc_name() {
        return "StringPromptValue";
    }
    constructor(value){
        super({
            value
        });
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "prompt_values"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.value = value;
    }
    toString() {
        return this.value;
    }
    toChatMessages() {
        return [
            new (0, _humanJs.HumanMessage)(this.value)
        ];
    }
}
class ChatPromptValue extends BasePromptValue {
    static lc_name() {
        return "ChatPromptValue";
    }
    constructor(fields){
        if (Array.isArray(fields)) // eslint-disable-next-line no-param-reassign
        fields = {
            messages: fields
        };
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "prompt_values"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "messages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.messages = fields.messages;
    }
    toString() {
        return (0, _utilsJs.getBufferString)(this.messages);
    }
    toChatMessages() {
        return this.messages;
    }
}
class ImagePromptValue extends BasePromptValue {
    static lc_name() {
        return "ImagePromptValue";
    }
    constructor(fields){
        if (!("imageUrl" in fields)) // eslint-disable-next-line no-param-reassign
        fields = {
            imageUrl: fields
        };
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "prompt_values"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "imageUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** @ignore */ Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.imageUrl = fields.imageUrl;
    }
    toString() {
        return this.imageUrl.url;
    }
    toChatMessages() {
        return [
            new (0, _humanJs.HumanMessage)({
                content: [
                    {
                        type: "image_url",
                        image_url: {
                            detail: this.imageUrl.detail,
                            url: this.imageUrl.url
                        }
                    }
                ]
            })
        ];
    }
}

},{"./load/serializable.js":"2n7FI","./messages/human.js":"2YgBC","./messages/utils.js":"6vi0n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bMqbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEncoding", ()=>getEncoding);
parcelHelpers.export(exports, "encodingForModel", ()=>encodingForModel);
var _lite = require("js-tiktoken/lite");
var _asyncCallerJs = require("./async_caller.js");
const cache = {};
const caller = /* #__PURE__ */ new (0, _asyncCallerJs.AsyncCaller)({});
async function getEncoding(encoding) {
    if (!(encoding in cache)) cache[encoding] = caller.fetch(`https://tiktoken.pages.dev/js/${encoding}.json`).then((res)=>res.json()).then((data)=>new (0, _lite.Tiktoken)(data)).catch((e)=>{
        delete cache[encoding];
        throw e;
    });
    return await cache[encoding];
}
async function encodingForModel(model) {
    return getEncoding((0, _lite.getEncodingNameForModel)(model));
}

},{"js-tiktoken/lite":"Cxfqc","./async_caller.js":"9E8gp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Cxfqc":[function(require,module,exports,__globalThis) {
module.exports = require("9f761b7b46612086");

},{"9f761b7b46612086":"kVhnd"}],"kVhnd":[function(require,module,exports,__globalThis) {
'use strict';
var base64 = require("aae8b8ca8c9fada6");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var base64__default = /*#__PURE__*/ _interopDefault(base64);
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __publicField = (obj, key, value)=>{
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/core.ts
function bytePairMerge(piece, ranks) {
    let parts = Array.from({
        length: piece.length
    }, (_, i)=>({
            start: i,
            end: i + 1
        }));
    while(parts.length > 1){
        let minRank = null;
        for(let i = 0; i < parts.length - 1; i++){
            const slice = piece.slice(parts[i].start, parts[i + 1].end);
            const rank = ranks.get(slice.join(","));
            if (rank == null) continue;
            if (minRank == null || rank < minRank[0]) minRank = [
                rank,
                i
            ];
        }
        if (minRank != null) {
            const i = minRank[1];
            parts[i] = {
                start: parts[i].start,
                end: parts[i + 1].end
            };
            parts.splice(i + 1, 1);
        } else break;
    }
    return parts;
}
function bytePairEncode(piece, ranks) {
    if (piece.length === 1) return [
        ranks.get(piece.join(","))
    ];
    return bytePairMerge(piece, ranks).map((p)=>ranks.get(piece.slice(p.start, p.end).join(","))).filter((x)=>x != null);
}
function escapeRegex(str) {
    return str.replace(/[\\^$*+?.()|[\]{}]/g, "\\$&");
}
var _Tiktoken = class {
    /** @internal */ specialTokens;
    /** @internal */ inverseSpecialTokens;
    /** @internal */ patStr;
    /** @internal */ textEncoder = new TextEncoder();
    /** @internal */ textDecoder = new TextDecoder("utf-8");
    /** @internal */ rankMap = /* @__PURE__ */ new Map();
    /** @internal */ textMap = /* @__PURE__ */ new Map();
    constructor(ranks, extendedSpecialTokens){
        this.patStr = ranks.pat_str;
        const uncompressed = ranks.bpe_ranks.split("\n").filter(Boolean).reduce((memo, x)=>{
            const [_, offsetStr, ...tokens] = x.split(" ");
            const offset = Number.parseInt(offsetStr, 10);
            tokens.forEach((token, i)=>memo[token] = offset + i);
            return memo;
        }, {});
        for (const [token, rank] of Object.entries(uncompressed)){
            const bytes = base64__default.default.toByteArray(token);
            this.rankMap.set(bytes.join(","), rank);
            this.textMap.set(rank, bytes);
        }
        this.specialTokens = {
            ...ranks.special_tokens,
            ...extendedSpecialTokens
        };
        this.inverseSpecialTokens = Object.entries(this.specialTokens).reduce((memo, [text, rank])=>{
            memo[rank] = this.textEncoder.encode(text);
            return memo;
        }, {});
    }
    encode(text, allowedSpecial = [], disallowedSpecial = "all") {
        const regexes = new RegExp(this.patStr, "ug");
        const specialRegex = _Tiktoken.specialTokenRegex(Object.keys(this.specialTokens));
        const ret = [];
        const allowedSpecialSet = new Set(allowedSpecial === "all" ? Object.keys(this.specialTokens) : allowedSpecial);
        const disallowedSpecialSet = new Set(disallowedSpecial === "all" ? Object.keys(this.specialTokens).filter((x)=>!allowedSpecialSet.has(x)) : disallowedSpecial);
        if (disallowedSpecialSet.size > 0) {
            const disallowedSpecialRegex = _Tiktoken.specialTokenRegex([
                ...disallowedSpecialSet
            ]);
            const specialMatch = text.match(disallowedSpecialRegex);
            if (specialMatch != null) throw new Error(`The text contains a special token that is not allowed: ${specialMatch[0]}`);
        }
        let start = 0;
        while(true){
            let nextSpecial = null;
            let startFind = start;
            while(true){
                specialRegex.lastIndex = startFind;
                nextSpecial = specialRegex.exec(text);
                if (nextSpecial == null || allowedSpecialSet.has(nextSpecial[0])) break;
                startFind = nextSpecial.index + 1;
            }
            const end = nextSpecial?.index ?? text.length;
            for (const match of text.substring(start, end).matchAll(regexes)){
                const piece = this.textEncoder.encode(match[0]);
                const token2 = this.rankMap.get(piece.join(","));
                if (token2 != null) {
                    ret.push(token2);
                    continue;
                }
                ret.push(...bytePairEncode(piece, this.rankMap));
            }
            if (nextSpecial == null) break;
            let token = this.specialTokens[nextSpecial[0]];
            ret.push(token);
            start = nextSpecial.index + nextSpecial[0].length;
        }
        return ret;
    }
    decode(tokens) {
        const res = [];
        let length = 0;
        for(let i2 = 0; i2 < tokens.length; ++i2){
            const token = tokens[i2];
            const bytes = this.textMap.get(token) ?? this.inverseSpecialTokens[token];
            if (bytes != null) {
                res.push(bytes);
                length += bytes.length;
            }
        }
        const mergedArray = new Uint8Array(length);
        let i = 0;
        for (const bytes of res){
            mergedArray.set(bytes, i);
            i += bytes.length;
        }
        return this.textDecoder.decode(mergedArray);
    }
};
var Tiktoken = _Tiktoken;
__publicField(Tiktoken, "specialTokenRegex", (tokens)=>{
    return new RegExp(tokens.map((i)=>escapeRegex(i)).join("|"), "g");
});
function getEncodingNameForModel(model) {
    switch(model){
        case "gpt2":
            return "gpt2";
        case "code-cushman-001":
        case "code-cushman-002":
        case "code-davinci-001":
        case "code-davinci-002":
        case "cushman-codex":
        case "davinci-codex":
        case "davinci-002":
        case "text-davinci-002":
        case "text-davinci-003":
            return "p50k_base";
        case "code-davinci-edit-001":
        case "text-davinci-edit-001":
            return "p50k_edit";
        case "ada":
        case "babbage":
        case "babbage-002":
        case "code-search-ada-code-001":
        case "code-search-babbage-code-001":
        case "curie":
        case "davinci":
        case "text-ada-001":
        case "text-babbage-001":
        case "text-curie-001":
        case "text-davinci-001":
        case "text-search-ada-doc-001":
        case "text-search-babbage-doc-001":
        case "text-search-curie-doc-001":
        case "text-search-davinci-doc-001":
        case "text-similarity-ada-001":
        case "text-similarity-babbage-001":
        case "text-similarity-curie-001":
        case "text-similarity-davinci-001":
            return "r50k_base";
        case "gpt-3.5-turbo-instruct-0914":
        case "gpt-3.5-turbo-instruct":
        case "gpt-3.5-turbo-16k-0613":
        case "gpt-3.5-turbo-16k":
        case "gpt-3.5-turbo-0613":
        case "gpt-3.5-turbo-0301":
        case "gpt-3.5-turbo":
        case "gpt-4-32k-0613":
        case "gpt-4-32k-0314":
        case "gpt-4-32k":
        case "gpt-4-0613":
        case "gpt-4-0314":
        case "gpt-4":
        case "gpt-3.5-turbo-1106":
        case "gpt-35-turbo":
        case "gpt-4-1106-preview":
        case "gpt-4-vision-preview":
        case "gpt-3.5-turbo-0125":
        case "gpt-4-turbo":
        case "gpt-4-turbo-2024-04-09":
        case "gpt-4-turbo-preview":
        case "gpt-4-0125-preview":
        case "text-embedding-ada-002":
        case "text-embedding-3-small":
        case "text-embedding-3-large":
            return "cl100k_base";
        case "gpt-4o":
        case "gpt-4o-2024-05-13":
        case "gpt-4o-2024-08-06":
        case "gpt-4o-mini-2024-07-18":
        case "gpt-4o-mini":
        case "o1-mini":
        case "o1-preview":
        case "o1-preview-2024-09-12":
        case "o1-mini-2024-09-12":
        case "chatgpt-4o-latest":
        case "gpt-4o-realtime":
        case "gpt-4o-realtime-preview-2024-10-01":
            return "o200k_base";
        default:
            throw new Error("Unknown model");
    }
}
exports.Tiktoken = Tiktoken;
exports.getEncodingNameForModel = getEncodingNameForModel;

},{"aae8b8ca8c9fada6":"6Pb1S"}],"6Pb1S":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"1XRQe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a transform stream for encoding chat message chunks.
 * @deprecated Use {@link BytesOutputParser} instead
 * @returns A TransformStream instance that encodes chat message chunks.
 */ parcelHelpers.export(exports, "createChatMessageChunkEncoderStream", ()=>createChatMessageChunkEncoderStream);
/**
 * Base class for chat models. It extends the BaseLanguageModel class and
 * provides methods for generating chat based on input messages.
 */ parcelHelpers.export(exports, "BaseChatModel", ()=>BaseChatModel);
/**
 * An abstract class that extends BaseChatModel and provides a simple
 * implementation of _generate.
 */ parcelHelpers.export(exports, "SimpleChatModel", ()=>SimpleChatModel);
var _zodToJsonSchema = require("zod-to-json-schema");
var _indexJs = require("../messages/index.js");
var _outputsJs = require("../outputs.js");
var _baseJs = require("./base.js");
var _managerJs = require("../callbacks/manager.js");
var _baseJs1 = require("../runnables/base.js");
var _eventStreamJs = require("../tracers/event_stream.js");
var _logStreamJs = require("../tracers/log_stream.js");
var _streamJs = require("../utils/stream.js");
var _passthroughJs = require("../runnables/passthrough.js");
var _isZodSchemaJs = require("../utils/types/is_zod_schema.js");
function createChatMessageChunkEncoderStream() {
    const textEncoder = new TextEncoder();
    return new TransformStream({
        transform (chunk, controller) {
            controller.enqueue(textEncoder.encode(typeof chunk.content === "string" ? chunk.content : JSON.stringify(chunk.content)));
        }
    });
}
class BaseChatModel extends (0, _baseJs.BaseLanguageModel) {
    constructor(fields){
        super(fields);
        // Only ever instantiated in main LangChain
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain",
                "chat_models",
                this._llmType()
            ]
        });
    }
    _separateRunnableConfigFromCallOptionsCompat(options) {
        // For backwards compat, keep `signal` in both runnableConfig and callOptions
        const [runnableConfig, callOptions] = super._separateRunnableConfigFromCallOptions(options);
        callOptions.signal = runnableConfig.signal;
        return [
            runnableConfig,
            callOptions
        ];
    }
    /**
     * Invokes the chat model with a single input.
     * @param input The input for the language model.
     * @param options The call options.
     * @returns A Promise that resolves to a BaseMessageChunk.
     */ async invoke(input, options) {
        const promptValue = BaseChatModel._convertInputToPromptValue(input);
        const result = await this.generatePrompt([
            promptValue
        ], options, options?.callbacks);
        const chatGeneration = result.generations[0][0];
        // TODO: Remove cast after figuring out inheritance
        return chatGeneration.message;
    }
    // eslint-disable-next-line require-yield
    async *_streamResponseChunks(_messages, _options, _runManager) {
        throw new Error("Not implemented.");
    }
    async *_streamIterator(input, options) {
        // Subclass check required to avoid double callbacks with default implementation
        if (this._streamResponseChunks === BaseChatModel.prototype._streamResponseChunks) yield this.invoke(input, options);
        else {
            const prompt = BaseChatModel._convertInputToPromptValue(input);
            const messages = prompt.toChatMessages();
            const [runnableConfig, callOptions] = this._separateRunnableConfigFromCallOptionsCompat(options);
            const inheritableMetadata = {
                ...runnableConfig.metadata,
                ...this.getLsParams(callOptions)
            };
            const callbackManager_ = await (0, _managerJs.CallbackManager).configure(runnableConfig.callbacks, this.callbacks, runnableConfig.tags, this.tags, inheritableMetadata, this.metadata, {
                verbose: this.verbose
            });
            const extra = {
                options: callOptions,
                invocation_params: this?.invocationParams(callOptions),
                batch_size: 1
            };
            const runManagers = await callbackManager_?.handleChatModelStart(this.toJSON(), [
                messages
            ], runnableConfig.runId, undefined, extra, undefined, undefined, runnableConfig.runName);
            let generationChunk;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let llmOutput;
            try {
                for await (const chunk of this._streamResponseChunks(messages, callOptions, runManagers?.[0])){
                    if (chunk.message.id == null) {
                        const runId = runManagers?.at(0)?.runId;
                        if (runId != null) chunk.message._updateId(`run-${runId}`);
                    }
                    chunk.message.response_metadata = {
                        ...chunk.generationInfo,
                        ...chunk.message.response_metadata
                    };
                    yield chunk.message;
                    if (!generationChunk) generationChunk = chunk;
                    else generationChunk = generationChunk.concat(chunk);
                    if ((0, _indexJs.isAIMessageChunk)(chunk.message) && chunk.message.usage_metadata !== undefined) llmOutput = {
                        tokenUsage: {
                            promptTokens: chunk.message.usage_metadata.input_tokens,
                            completionTokens: chunk.message.usage_metadata.output_tokens,
                            totalTokens: chunk.message.usage_metadata.total_tokens
                        }
                    };
                }
            } catch (err) {
                await Promise.all((runManagers ?? []).map((runManager)=>runManager?.handleLLMError(err)));
                throw err;
            }
            await Promise.all((runManagers ?? []).map((runManager)=>runManager?.handleLLMEnd({
                    // TODO: Remove cast after figuring out inheritance
                    generations: [
                        [
                            generationChunk
                        ]
                    ],
                    llmOutput
                })));
        }
    }
    getLsParams(options) {
        const providerName = this.getName().startsWith("Chat") ? this.getName().replace("Chat", "") : this.getName();
        return {
            ls_model_type: "chat",
            ls_stop: options.stop,
            ls_provider: providerName
        };
    }
    /** @ignore */ async _generateUncached(messages, parsedOptions, handledOptions) {
        const baseMessages = messages.map((messageList)=>messageList.map((0, _indexJs.coerceMessageLikeToMessage)));
        const inheritableMetadata = {
            ...handledOptions.metadata,
            ...this.getLsParams(parsedOptions)
        };
        // create callback manager and start run
        const callbackManager_ = await (0, _managerJs.CallbackManager).configure(handledOptions.callbacks, this.callbacks, handledOptions.tags, this.tags, inheritableMetadata, this.metadata, {
            verbose: this.verbose
        });
        const extra = {
            options: parsedOptions,
            invocation_params: this?.invocationParams(parsedOptions),
            batch_size: 1
        };
        const runManagers = await callbackManager_?.handleChatModelStart(this.toJSON(), baseMessages, handledOptions.runId, undefined, extra, undefined, undefined, handledOptions.runName);
        const generations = [];
        const llmOutputs = [];
        // Even if stream is not explicitly called, check if model is implicitly
        // called from streamEvents() or streamLog() to get all streamed events.
        // Bail out if _streamResponseChunks not overridden
        const hasStreamingHandler = !!runManagers?.[0].handlers.find((handler)=>{
            return (0, _eventStreamJs.isStreamEventsHandler)(handler) || (0, _logStreamJs.isLogStreamHandler)(handler);
        });
        if (hasStreamingHandler && baseMessages.length === 1 && this._streamResponseChunks !== BaseChatModel.prototype._streamResponseChunks) try {
            const stream = await this._streamResponseChunks(baseMessages[0], parsedOptions, runManagers?.[0]);
            let aggregated;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let llmOutput;
            for await (const chunk of stream){
                if (chunk.message.id == null) {
                    const runId = runManagers?.at(0)?.runId;
                    if (runId != null) chunk.message._updateId(`run-${runId}`);
                }
                if (aggregated === undefined) aggregated = chunk;
                else aggregated = (0, _streamJs.concat)(aggregated, chunk);
                if ((0, _indexJs.isAIMessageChunk)(chunk.message) && chunk.message.usage_metadata !== undefined) llmOutput = {
                    tokenUsage: {
                        promptTokens: chunk.message.usage_metadata.input_tokens,
                        completionTokens: chunk.message.usage_metadata.output_tokens,
                        totalTokens: chunk.message.usage_metadata.total_tokens
                    }
                };
            }
            if (aggregated === undefined) throw new Error("Received empty response from chat model call.");
            generations.push([
                aggregated
            ]);
            await runManagers?.[0].handleLLMEnd({
                generations,
                llmOutput
            });
        } catch (e) {
            await runManagers?.[0].handleLLMError(e);
            throw e;
        }
        else {
            // generate results
            const results = await Promise.allSettled(baseMessages.map((messageList, i)=>this._generate(messageList, {
                    ...parsedOptions,
                    promptIndex: i
                }, runManagers?.[i])));
            // handle results
            await Promise.all(results.map(async (pResult, i)=>{
                if (pResult.status === "fulfilled") {
                    const result = pResult.value;
                    for (const generation of result.generations){
                        if (generation.message.id == null) {
                            const runId = runManagers?.at(0)?.runId;
                            if (runId != null) generation.message._updateId(`run-${runId}`);
                        }
                        generation.message.response_metadata = {
                            ...generation.generationInfo,
                            ...generation.message.response_metadata
                        };
                    }
                    if (result.generations.length === 1) result.generations[0].message.response_metadata = {
                        ...result.llmOutput,
                        ...result.generations[0].message.response_metadata
                    };
                    generations[i] = result.generations;
                    llmOutputs[i] = result.llmOutput;
                    return runManagers?.[i]?.handleLLMEnd({
                        generations: [
                            result.generations
                        ],
                        llmOutput: result.llmOutput
                    });
                } else {
                    // status === "rejected"
                    await runManagers?.[i]?.handleLLMError(pResult.reason);
                    return Promise.reject(pResult.reason);
                }
            }));
        }
        // create combined output
        const output = {
            generations,
            llmOutput: llmOutputs.length ? this._combineLLMOutput?.(...llmOutputs) : undefined
        };
        Object.defineProperty(output, (0, _outputsJs.RUN_KEY), {
            value: runManagers ? {
                runIds: runManagers?.map((manager)=>manager.runId)
            } : undefined,
            configurable: true
        });
        return output;
    }
    async _generateCached({ messages, cache, llmStringKey, parsedOptions, handledOptions }) {
        const baseMessages = messages.map((messageList)=>messageList.map((0, _indexJs.coerceMessageLikeToMessage)));
        const inheritableMetadata = {
            ...handledOptions.metadata,
            ...this.getLsParams(parsedOptions)
        };
        // create callback manager and start run
        const callbackManager_ = await (0, _managerJs.CallbackManager).configure(handledOptions.callbacks, this.callbacks, handledOptions.tags, this.tags, inheritableMetadata, this.metadata, {
            verbose: this.verbose
        });
        const extra = {
            options: parsedOptions,
            invocation_params: this?.invocationParams(parsedOptions),
            batch_size: 1,
            cached: true
        };
        const runManagers = await callbackManager_?.handleChatModelStart(this.toJSON(), baseMessages, handledOptions.runId, undefined, extra, undefined, undefined, handledOptions.runName);
        // generate results
        const missingPromptIndices = [];
        const results = await Promise.allSettled(baseMessages.map(async (baseMessage, index)=>{
            // Join all content into one string for the prompt index
            const prompt = BaseChatModel._convertInputToPromptValue(baseMessage).toString();
            const result = await cache.lookup(prompt, llmStringKey);
            if (result == null) missingPromptIndices.push(index);
            return result;
        }));
        // Map run managers to the results before filtering out null results
        // Null results are just absent from the cache.
        const cachedResults = results.map((result, index)=>({
                result,
                runManager: runManagers?.[index]
            })).filter(({ result })=>result.status === "fulfilled" && result.value != null || result.status === "rejected");
        // Handle results and call run managers
        const generations = [];
        await Promise.all(cachedResults.map(async ({ result: promiseResult, runManager }, i)=>{
            if (promiseResult.status === "fulfilled") {
                const result = promiseResult.value;
                generations[i] = result;
                if (result.length) await runManager?.handleLLMNewToken(result[0].text);
                return runManager?.handleLLMEnd({
                    generations: [
                        result
                    ]
                });
            } else {
                // status === "rejected"
                await runManager?.handleLLMError(promiseResult.reason);
                return Promise.reject(promiseResult.reason);
            }
        }));
        const output = {
            generations,
            missingPromptIndices
        };
        // This defines RUN_KEY as a non-enumerable property on the output object
        // so that it is not serialized when the output is stringified, and so that
        // it isnt included when listing the keys of the output object.
        Object.defineProperty(output, (0, _outputsJs.RUN_KEY), {
            value: runManagers ? {
                runIds: runManagers?.map((manager)=>manager.runId)
            } : undefined,
            configurable: true
        });
        return output;
    }
    /**
     * Generates chat based on the input messages.
     * @param messages An array of arrays of BaseMessage instances.
     * @param options The call options or an array of stop sequences.
     * @param callbacks The callbacks for the language model.
     * @returns A Promise that resolves to an LLMResult.
     */ async generate(messages, options, callbacks) {
        // parse call options
        let parsedOptions;
        if (Array.isArray(options)) parsedOptions = {
            stop: options
        };
        else parsedOptions = options;
        const baseMessages = messages.map((messageList)=>messageList.map((0, _indexJs.coerceMessageLikeToMessage)));
        const [runnableConfig, callOptions] = this._separateRunnableConfigFromCallOptionsCompat(parsedOptions);
        runnableConfig.callbacks = runnableConfig.callbacks ?? callbacks;
        if (!this.cache) return this._generateUncached(baseMessages, callOptions, runnableConfig);
        const { cache } = this;
        const llmStringKey = this._getSerializedCacheKeyParametersForCall(callOptions);
        const { generations, missingPromptIndices } = await this._generateCached({
            messages: baseMessages,
            cache,
            llmStringKey,
            parsedOptions: callOptions,
            handledOptions: runnableConfig
        });
        let llmOutput = {};
        if (missingPromptIndices.length > 0) {
            const results = await this._generateUncached(missingPromptIndices.map((i)=>baseMessages[i]), callOptions, runnableConfig);
            await Promise.all(results.generations.map(async (generation, index)=>{
                const promptIndex = missingPromptIndices[index];
                generations[promptIndex] = generation;
                // Join all content into one string for the prompt index
                const prompt = BaseChatModel._convertInputToPromptValue(baseMessages[promptIndex]).toString();
                return cache.update(prompt, llmStringKey, generation);
            }));
            llmOutput = results.llmOutput ?? {};
        }
        return {
            generations,
            llmOutput
        };
    }
    /**
     * Get the parameters used to invoke the model
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    invocationParams(_options) {
        return {};
    }
    _modelType() {
        return "base_chat_model";
    }
    /**
     * @deprecated
     * Return a json-like object representing this LLM.
     */ serialize() {
        return {
            ...this.invocationParams(),
            _type: this._llmType(),
            _model: this._modelType()
        };
    }
    /**
     * Generates a prompt based on the input prompt values.
     * @param promptValues An array of BasePromptValue instances.
     * @param options The call options or an array of stop sequences.
     * @param callbacks The callbacks for the language model.
     * @returns A Promise that resolves to an LLMResult.
     */ async generatePrompt(promptValues, options, callbacks) {
        const promptMessages = promptValues.map((promptValue)=>promptValue.toChatMessages());
        return this.generate(promptMessages, options, callbacks);
    }
    /**
     * @deprecated Use .invoke() instead. Will be removed in 0.2.0.
     *
     * Makes a single call to the chat model.
     * @param messages An array of BaseMessage instances.
     * @param options The call options or an array of stop sequences.
     * @param callbacks The callbacks for the language model.
     * @returns A Promise that resolves to a BaseMessage.
     */ async call(messages, options, callbacks) {
        const result = await this.generate([
            messages.map((0, _indexJs.coerceMessageLikeToMessage))
        ], options, callbacks);
        const generations = result.generations;
        return generations[0][0].message;
    }
    /**
     * @deprecated Use .invoke() instead. Will be removed in 0.2.0.
     *
     * Makes a single call to the chat model with a prompt value.
     * @param promptValue The value of the prompt.
     * @param options The call options or an array of stop sequences.
     * @param callbacks The callbacks for the language model.
     * @returns A Promise that resolves to a BaseMessage.
     */ async callPrompt(promptValue, options, callbacks) {
        const promptMessages = promptValue.toChatMessages();
        return this.call(promptMessages, options, callbacks);
    }
    /**
     * @deprecated Use .invoke() instead. Will be removed in 0.2.0.
     *
     * Predicts the next message based on the input messages.
     * @param messages An array of BaseMessage instances.
     * @param options The call options or an array of stop sequences.
     * @param callbacks The callbacks for the language model.
     * @returns A Promise that resolves to a BaseMessage.
     */ async predictMessages(messages, options, callbacks) {
        return this.call(messages, options, callbacks);
    }
    /**
     * @deprecated Use .invoke() instead. Will be removed in 0.2.0.
     *
     * Predicts the next message based on a text input.
     * @param text The text input.
     * @param options The call options or an array of stop sequences.
     * @param callbacks The callbacks for the language model.
     * @returns A Promise that resolves to a string.
     */ async predict(text, options, callbacks) {
        const message = new (0, _indexJs.HumanMessage)(text);
        const result = await this.call([
            message
        ], options, callbacks);
        if (typeof result.content !== "string") throw new Error("Cannot use predict when output is not a string.");
        return result.content;
    }
    withStructuredOutput(outputSchema, config) {
        if (typeof this.bindTools !== "function") throw new Error(`Chat model must implement ".bindTools()" to use withStructuredOutput.`);
        if (config?.strict) throw new Error(`"strict" mode is not supported for this model by default.`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const schema = outputSchema;
        const name = config?.name;
        const description = schema.description ?? "A function available to call.";
        const method = config?.method;
        const includeRaw = config?.includeRaw;
        if (method === "jsonMode") throw new Error(`Base withStructuredOutput implementation only supports "functionCalling" as a method.`);
        let functionName = name ?? "extract";
        let tools;
        if ((0, _isZodSchemaJs.isZodSchema)(schema)) tools = [
            {
                type: "function",
                function: {
                    name: functionName,
                    description,
                    parameters: (0, _zodToJsonSchema.zodToJsonSchema)(schema)
                }
            }
        ];
        else {
            if ("name" in schema) functionName = schema.name;
            tools = [
                {
                    type: "function",
                    function: {
                        name: functionName,
                        description,
                        parameters: schema
                    }
                }
            ];
        }
        const llm = this.bindTools(tools);
        const outputParser = (0, _baseJs1.RunnableLambda).from((input)=>{
            if (!input.tool_calls || input.tool_calls.length === 0) throw new Error("No tool calls found in the response.");
            const toolCall = input.tool_calls.find((tc)=>tc.name === functionName);
            if (!toolCall) throw new Error(`No tool call found with name ${functionName}.`);
            return toolCall.args;
        });
        if (!includeRaw) return llm.pipe(outputParser).withConfig({
            runName: "StructuredOutput"
        });
        const parserAssign = (0, _passthroughJs.RunnablePassthrough).assign({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            parsed: (input, config)=>outputParser.invoke(input.raw, config)
        });
        const parserNone = (0, _passthroughJs.RunnablePassthrough).assign({
            parsed: ()=>null
        });
        const parsedWithFallback = parserAssign.withFallbacks({
            fallbacks: [
                parserNone
            ]
        });
        return (0, _baseJs1.RunnableSequence).from([
            {
                raw: llm
            },
            parsedWithFallback
        ]).withConfig({
            runName: "StructuredOutputRunnable"
        });
    }
}
class SimpleChatModel extends BaseChatModel {
    async _generate(messages, options, runManager) {
        const text = await this._call(messages, options, runManager);
        const message = new (0, _indexJs.AIMessage)(text);
        if (typeof message.content !== "string") throw new Error("Cannot generate with a simple chat model when output is not a string.");
        return {
            generations: [
                {
                    text: message.content,
                    message
                }
            ]
        };
    }
}

},{"zod-to-json-schema":"3TbOj","../messages/index.js":"7XzBK","../outputs.js":"4YkJk","./base.js":"grvsA","../callbacks/manager.js":"bj69C","../runnables/base.js":"9xkzz","../tracers/event_stream.js":"5udSK","../tracers/log_stream.js":"icv9w","../utils/stream.js":"kAAca","../runnables/passthrough.js":"giooZ","../utils/types/is_zod_schema.js":"3S7D5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"giooZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A runnable to passthrough inputs unchanged or with additional keys.
 *
 * This runnable behaves almost like the identity function, except that it
 * can be configured to add additional keys to the output, if the input is
 * an object.
 *
 * The example below demonstrates how to use `RunnablePassthrough to
 * passthrough the input from the `.invoke()`
 *
 * @example
 * ```typescript
 * const chain = RunnableSequence.from([
 *   {
 *     question: new RunnablePassthrough(),
 *     context: async () => loadContextFromStore(),
 *   },
 *   prompt,
 *   llm,
 *   outputParser,
 * ]);
 * const response = await chain.invoke(
 *   "I can pass a single string instead of an object since I'm using `RunnablePassthrough`."
 * );
 * ```
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "RunnablePassthrough", ()=>RunnablePassthrough);
var _streamJs = require("../utils/stream.js");
var _baseJs = require("./base.js");
var _configJs = require("./config.js");
class RunnablePassthrough extends (0, _baseJs.Runnable) {
    static lc_name() {
        return "RunnablePassthrough";
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "func", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (fields) this.func = fields.func;
    }
    async invoke(input, options) {
        const config = (0, _configJs.ensureConfig)(options);
        if (this.func) await this.func(input, config);
        return this._callWithConfig((input)=>Promise.resolve(input), input, config);
    }
    async *transform(generator, options) {
        const config = (0, _configJs.ensureConfig)(options);
        let finalOutput;
        let finalOutputSupported = true;
        for await (const chunk of this._transformStreamWithConfig(generator, (input)=>input, config)){
            yield chunk;
            if (finalOutputSupported) {
                if (finalOutput === undefined) finalOutput = chunk;
                else try {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    finalOutput = (0, _streamJs.concat)(finalOutput, chunk);
                } catch  {
                    finalOutput = undefined;
                    finalOutputSupported = false;
                }
            }
        }
        if (this.func && finalOutput !== undefined) await this.func(finalOutput, config);
    }
    /**
     * A runnable that assigns key-value pairs to the input.
     *
     * The example below shows how you could use it with an inline function.
     *
     * @example
     * ```typescript
     * const prompt =
     *   PromptTemplate.fromTemplate(`Write a SQL query to answer the question using the following schema: {schema}
     * Question: {question}
     * SQL Query:`);
     *
     * // The `RunnablePassthrough.assign()` is used here to passthrough the input from the `.invoke()`
     * // call (in this example it's the question), along with any inputs passed to the `.assign()` method.
     * // In this case, we're passing the schema.
     * const sqlQueryGeneratorChain = RunnableSequence.from([
     *   RunnablePassthrough.assign({
     *     schema: async () => db.getTableInfo(),
     *   }),
     *   prompt,
     *   new ChatOpenAI({}).bind({ stop: ["\nSQLResult:"] }),
     *   new StringOutputParser(),
     * ]);
     * const result = await sqlQueryGeneratorChain.invoke({
     *   question: "How many employees are there?",
     * });
     * ```
     */ static assign(mapping) {
        return new (0, _baseJs.RunnableAssign)(new (0, _baseJs.RunnableMap)({
            steps: mapping
        }));
    }
}

},{"../utils/stream.js":"kAAca","./base.js":"9xkzz","./config.js":"2gQun","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3S7D5":[function(require,module,exports,__globalThis) {
/**
 * Given either a Zod schema, or plain object, determine if the input is a Zod schema.
 *
 * @param {z.ZodType<RunOutput> | Record<string, any>} input
 * @returns {boolean} Whether or not the provided input is a Zod schema.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isZodSchema", ()=>isZodSchema);
function isZodSchema(// eslint-disable-next-line @typescript-eslint/no-explicit-any
input) {
    // Check for a characteristic method of Zod schemas
    return typeof input?.parse === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4h08k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * LLM Wrapper. Takes in a prompt (or prompts) and returns a string.
 */ parcelHelpers.export(exports, "BaseLLM", ()=>BaseLLM);
/**
 * LLM class that provides a simpler interface to subclass than {@link BaseLLM}.
 *
 * Requires only implementing a simpler {@link _call} method instead of {@link _generate}.
 *
 * @augments BaseLLM
 */ parcelHelpers.export(exports, "LLM", ()=>LLM);
var _indexJs = require("../messages/index.js");
var _outputsJs = require("../outputs.js");
var _managerJs = require("../callbacks/manager.js");
var _baseJs = require("./base.js");
var _eventStreamJs = require("../tracers/event_stream.js");
var _logStreamJs = require("../tracers/log_stream.js");
var _streamJs = require("../utils/stream.js");
class BaseLLM extends (0, _baseJs.BaseLanguageModel) {
    constructor({ concurrency, ...rest }){
        super(concurrency ? {
            maxConcurrency: concurrency,
            ...rest
        } : rest);
        // Only ever instantiated in main LangChain
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain",
                "llms",
                this._llmType()
            ]
        });
    }
    /**
     * This method takes an input and options, and returns a string. It
     * converts the input to a prompt value and generates a result based on
     * the prompt.
     * @param input Input for the LLM.
     * @param options Options for the LLM call.
     * @returns A string result based on the prompt.
     */ async invoke(input, options) {
        const promptValue = BaseLLM._convertInputToPromptValue(input);
        const result = await this.generatePrompt([
            promptValue
        ], options, options?.callbacks);
        return result.generations[0][0].text;
    }
    // eslint-disable-next-line require-yield
    async *_streamResponseChunks(_input, _options, _runManager) {
        throw new Error("Not implemented.");
    }
    _separateRunnableConfigFromCallOptionsCompat(options) {
        // For backwards compat, keep `signal` in both runnableConfig and callOptions
        const [runnableConfig, callOptions] = super._separateRunnableConfigFromCallOptions(options);
        callOptions.signal = runnableConfig.signal;
        return [
            runnableConfig,
            callOptions
        ];
    }
    async *_streamIterator(input, options) {
        // Subclass check required to avoid double callbacks with default implementation
        if (this._streamResponseChunks === BaseLLM.prototype._streamResponseChunks) yield this.invoke(input, options);
        else {
            const prompt = BaseLLM._convertInputToPromptValue(input);
            const [runnableConfig, callOptions] = this._separateRunnableConfigFromCallOptionsCompat(options);
            const callbackManager_ = await (0, _managerJs.CallbackManager).configure(runnableConfig.callbacks, this.callbacks, runnableConfig.tags, this.tags, runnableConfig.metadata, this.metadata, {
                verbose: this.verbose
            });
            const extra = {
                options: callOptions,
                invocation_params: this?.invocationParams(callOptions),
                batch_size: 1
            };
            const runManagers = await callbackManager_?.handleLLMStart(this.toJSON(), [
                prompt.toString()
            ], runnableConfig.runId, undefined, extra, undefined, undefined, runnableConfig.runName);
            let generation = new (0, _outputsJs.GenerationChunk)({
                text: ""
            });
            try {
                for await (const chunk of this._streamResponseChunks(prompt.toString(), callOptions, runManagers?.[0])){
                    if (!generation) generation = chunk;
                    else generation = generation.concat(chunk);
                    if (typeof chunk.text === "string") yield chunk.text;
                }
            } catch (err) {
                await Promise.all((runManagers ?? []).map((runManager)=>runManager?.handleLLMError(err)));
                throw err;
            }
            await Promise.all((runManagers ?? []).map((runManager)=>runManager?.handleLLMEnd({
                    generations: [
                        [
                            generation
                        ]
                    ]
                })));
        }
    }
    /**
     * This method takes prompt values, options, and callbacks, and generates
     * a result based on the prompts.
     * @param promptValues Prompt values for the LLM.
     * @param options Options for the LLM call.
     * @param callbacks Callbacks for the LLM call.
     * @returns An LLMResult based on the prompts.
     */ async generatePrompt(promptValues, options, callbacks) {
        const prompts = promptValues.map((promptValue)=>promptValue.toString());
        return this.generate(prompts, options, callbacks);
    }
    /**
     * Get the parameters used to invoke the model
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    invocationParams(_options) {
        return {};
    }
    _flattenLLMResult(llmResult) {
        const llmResults = [];
        for(let i = 0; i < llmResult.generations.length; i += 1){
            const genList = llmResult.generations[i];
            if (i === 0) llmResults.push({
                generations: [
                    genList
                ],
                llmOutput: llmResult.llmOutput
            });
            else {
                const llmOutput = llmResult.llmOutput ? {
                    ...llmResult.llmOutput,
                    tokenUsage: {}
                } : undefined;
                llmResults.push({
                    generations: [
                        genList
                    ],
                    llmOutput
                });
            }
        }
        return llmResults;
    }
    /** @ignore */ async _generateUncached(prompts, parsedOptions, handledOptions) {
        const callbackManager_ = await (0, _managerJs.CallbackManager).configure(handledOptions.callbacks, this.callbacks, handledOptions.tags, this.tags, handledOptions.metadata, this.metadata, {
            verbose: this.verbose
        });
        const extra = {
            options: parsedOptions,
            invocation_params: this?.invocationParams(parsedOptions),
            batch_size: prompts.length
        };
        const runManagers = await callbackManager_?.handleLLMStart(this.toJSON(), prompts, handledOptions.runId, undefined, extra, undefined, undefined, handledOptions?.runName);
        // Even if stream is not explicitly called, check if model is implicitly
        // called from streamEvents() or streamLog() to get all streamed events.
        // Bail out if _streamResponseChunks not overridden
        const hasStreamingHandler = !!runManagers?.[0].handlers.find((handler)=>{
            return (0, _eventStreamJs.isStreamEventsHandler)(handler) || (0, _logStreamJs.isLogStreamHandler)(handler);
        });
        let output;
        if (hasStreamingHandler && prompts.length === 1 && this._streamResponseChunks !== BaseLLM.prototype._streamResponseChunks) try {
            const stream = await this._streamResponseChunks(prompts[0], parsedOptions, runManagers?.[0]);
            let aggregated;
            for await (const chunk of stream)if (aggregated === undefined) aggregated = chunk;
            else aggregated = (0, _streamJs.concat)(aggregated, chunk);
            if (aggregated === undefined) throw new Error("Received empty response from chat model call.");
            output = {
                generations: [
                    [
                        aggregated
                    ]
                ],
                llmOutput: {}
            };
            await runManagers?.[0].handleLLMEnd(output);
        } catch (e) {
            await runManagers?.[0].handleLLMError(e);
            throw e;
        }
        else {
            try {
                output = await this._generate(prompts, parsedOptions, runManagers?.[0]);
            } catch (err) {
                await Promise.all((runManagers ?? []).map((runManager)=>runManager?.handleLLMError(err)));
                throw err;
            }
            const flattenedOutputs = this._flattenLLMResult(output);
            await Promise.all((runManagers ?? []).map((runManager, i)=>runManager?.handleLLMEnd(flattenedOutputs[i])));
        }
        const runIds = runManagers?.map((manager)=>manager.runId) || undefined;
        // This defines RUN_KEY as a non-enumerable property on the output object
        // so that it is not serialized when the output is stringified, and so that
        // it isnt included when listing the keys of the output object.
        Object.defineProperty(output, (0, _outputsJs.RUN_KEY), {
            value: runIds ? {
                runIds
            } : undefined,
            configurable: true
        });
        return output;
    }
    async _generateCached({ prompts, cache, llmStringKey, parsedOptions, handledOptions, runId }) {
        const callbackManager_ = await (0, _managerJs.CallbackManager).configure(handledOptions.callbacks, this.callbacks, handledOptions.tags, this.tags, handledOptions.metadata, this.metadata, {
            verbose: this.verbose
        });
        const extra = {
            options: parsedOptions,
            invocation_params: this?.invocationParams(parsedOptions),
            batch_size: prompts.length,
            cached: true
        };
        const runManagers = await callbackManager_?.handleLLMStart(this.toJSON(), prompts, runId, undefined, extra, undefined, undefined, handledOptions?.runName);
        // generate results
        const missingPromptIndices = [];
        const results = await Promise.allSettled(prompts.map(async (prompt, index)=>{
            const result = await cache.lookup(prompt, llmStringKey);
            if (result == null) missingPromptIndices.push(index);
            return result;
        }));
        // Map run managers to the results before filtering out null results
        // Null results are just absent from the cache.
        const cachedResults = results.map((result, index)=>({
                result,
                runManager: runManagers?.[index]
            })).filter(({ result })=>result.status === "fulfilled" && result.value != null || result.status === "rejected");
        // Handle results and call run managers
        const generations = [];
        await Promise.all(cachedResults.map(async ({ result: promiseResult, runManager }, i)=>{
            if (promiseResult.status === "fulfilled") {
                const result = promiseResult.value;
                generations[i] = result;
                if (result.length) await runManager?.handleLLMNewToken(result[0].text);
                return runManager?.handleLLMEnd({
                    generations: [
                        result
                    ]
                });
            } else {
                // status === "rejected"
                await runManager?.handleLLMError(promiseResult.reason);
                return Promise.reject(promiseResult.reason);
            }
        }));
        const output = {
            generations,
            missingPromptIndices
        };
        // This defines RUN_KEY as a non-enumerable property on the output object
        // so that it is not serialized when the output is stringified, and so that
        // it isnt included when listing the keys of the output object.
        Object.defineProperty(output, (0, _outputsJs.RUN_KEY), {
            value: runManagers ? {
                runIds: runManagers?.map((manager)=>manager.runId)
            } : undefined,
            configurable: true
        });
        return output;
    }
    /**
     * Run the LLM on the given prompts and input, handling caching.
     */ async generate(prompts, options, callbacks) {
        if (!Array.isArray(prompts)) throw new Error("Argument 'prompts' is expected to be a string[]");
        let parsedOptions;
        if (Array.isArray(options)) parsedOptions = {
            stop: options
        };
        else parsedOptions = options;
        const [runnableConfig, callOptions] = this._separateRunnableConfigFromCallOptionsCompat(parsedOptions);
        runnableConfig.callbacks = runnableConfig.callbacks ?? callbacks;
        if (!this.cache) return this._generateUncached(prompts, callOptions, runnableConfig);
        const { cache } = this;
        const llmStringKey = this._getSerializedCacheKeyParametersForCall(callOptions);
        const { generations, missingPromptIndices } = await this._generateCached({
            prompts,
            cache,
            llmStringKey,
            parsedOptions: callOptions,
            handledOptions: runnableConfig,
            runId: runnableConfig.runId
        });
        let llmOutput = {};
        if (missingPromptIndices.length > 0) {
            const results = await this._generateUncached(missingPromptIndices.map((i)=>prompts[i]), callOptions, runnableConfig);
            await Promise.all(results.generations.map(async (generation, index)=>{
                const promptIndex = missingPromptIndices[index];
                generations[promptIndex] = generation;
                return cache.update(prompts[promptIndex], llmStringKey, generation);
            }));
            llmOutput = results.llmOutput ?? {};
        }
        return {
            generations,
            llmOutput
        };
    }
    /**
     * @deprecated Use .invoke() instead. Will be removed in 0.2.0.
     * Convenience wrapper for {@link generate} that takes in a single string prompt and returns a single string output.
     */ async call(prompt, options, callbacks) {
        const { generations } = await this.generate([
            prompt
        ], options, callbacks);
        return generations[0][0].text;
    }
    /**
     * @deprecated Use .invoke() instead. Will be removed in 0.2.0.
     *
     * This method is similar to `call`, but it's used for making predictions
     * based on the input text.
     * @param text Input text for the prediction.
     * @param options Options for the LLM call.
     * @param callbacks Callbacks for the LLM call.
     * @returns A prediction based on the input text.
     */ async predict(text, options, callbacks) {
        return this.call(text, options, callbacks);
    }
    /**
     * @deprecated Use .invoke() instead. Will be removed in 0.2.0.
     *
     * This method takes a list of messages, options, and callbacks, and
     * returns a predicted message.
     * @param messages A list of messages for the prediction.
     * @param options Options for the LLM call.
     * @param callbacks Callbacks for the LLM call.
     * @returns A predicted message based on the list of messages.
     */ async predictMessages(messages, options, callbacks) {
        const text = (0, _indexJs.getBufferString)(messages);
        const prediction = await this.call(text, options, callbacks);
        return new (0, _indexJs.AIMessage)(prediction);
    }
    /**
     * Get the identifying parameters of the LLM.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _identifyingParams() {
        return {};
    }
    /**
     * @deprecated
     * Return a json-like object representing this LLM.
     */ serialize() {
        return {
            ...this._identifyingParams(),
            _type: this._llmType(),
            _model: this._modelType()
        };
    }
    _modelType() {
        return "base_llm";
    }
}
class LLM extends BaseLLM {
    async _generate(prompts, options, runManager) {
        const generations = await Promise.all(prompts.map((prompt, promptIndex)=>this._call(prompt, {
                ...options,
                promptIndex
            }, runManager).then((text)=>[
                    {
                        text
                    }
                ])));
        return {
            generations
        };
    }
}

},{"../messages/index.js":"7XzBK","../outputs.js":"4YkJk","../callbacks/manager.js":"bj69C","./base.js":"grvsA","../tracers/event_stream.js":"5udSK","../tracers/log_stream.js":"icv9w","../utils/stream.js":"kAAca","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cV7bQ":[function(require,module,exports,__globalThis) {
/**
 * Abstract base class for memory in LangChain's Chains. Memory refers to
 * the state in Chains. It can be used to store information about past
 * executions of a Chain and inject that information into the inputs of
 * future executions of the Chain.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseMemory", ()=>BaseMemory);
parcelHelpers.export(exports, "getInputValue", ()=>getInputValue);
parcelHelpers.export(exports, "getOutputValue", ()=>getOutputValue);
/**
 * Function used by memory classes to get the key of the prompt input,
 * excluding any keys that are memory variables or the "stop" key. If
 * there is not exactly one prompt input key, an error is thrown.
 */ parcelHelpers.export(exports, "getPromptInputKey", ()=>getPromptInputKey);
class BaseMemory {
}
const getValue = (values, key)=>{
    if (key !== undefined) return values[key];
    const keys = Object.keys(values);
    if (keys.length === 1) return values[keys[0]];
};
const getInputValue = (inputValues, inputKey)=>{
    const value = getValue(inputValues, inputKey);
    if (!value) {
        const keys = Object.keys(inputValues);
        throw new Error(`input values have ${keys.length} keys, you must specify an input key or pass only 1 key as input`);
    }
    return value;
};
const getOutputValue = (outputValues, outputKey)=>{
    const value = getValue(outputValues, outputKey);
    if (!value && value !== "") {
        const keys = Object.keys(outputValues);
        throw new Error(`output values have ${keys.length} keys, you must specify an output key or pass only 1 key as output`);
    }
    return value;
};
function getPromptInputKey(inputs, memoryVariables) {
    const promptInputKeys = Object.keys(inputs).filter((key)=>!memoryVariables.includes(key) && key !== "stop");
    if (promptInputKeys.length !== 1) throw new Error(`One input key expected, but got ${promptInputKeys.length}`);
    return promptInputKeys[0];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9SzCh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseJs = require("./base.js");
parcelHelpers.exportAll(_baseJs, exports);
var _bytesJs = require("./bytes.js");
parcelHelpers.exportAll(_bytesJs, exports);
var _listJs = require("./list.js");
parcelHelpers.exportAll(_listJs, exports);
var _stringJs = require("./string.js");
parcelHelpers.exportAll(_stringJs, exports);
var _structuredJs = require("./structured.js");
parcelHelpers.exportAll(_structuredJs, exports);
var _transformJs = require("./transform.js");
parcelHelpers.exportAll(_transformJs, exports);
var _jsonJs = require("./json.js");
parcelHelpers.exportAll(_jsonJs, exports);
var _xmlJs = require("./xml.js");
parcelHelpers.exportAll(_xmlJs, exports);

},{"./base.js":"lJpNd","./bytes.js":"gION6","./list.js":"6rmQk","./string.js":"8Pjk5","./structured.js":"keAXg","./transform.js":"4lsjz","./json.js":"3Q14p","./xml.js":"lp3DS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lJpNd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Abstract base class for parsing the output of a Large Language Model
 * (LLM) call. It provides methods for parsing the result of an LLM call
 * and invoking the parser with a given input.
 */ parcelHelpers.export(exports, "BaseLLMOutputParser", ()=>BaseLLMOutputParser);
/**
 * Class to parse the output of an LLM call.
 */ parcelHelpers.export(exports, "BaseOutputParser", ()=>BaseOutputParser);
/**
 * Exception that output parsers should raise to signify a parsing error.
 *
 * This exists to differentiate parsing errors from other code or execution errors
 * that also may arise inside the output parser. OutputParserExceptions will be
 * available to catch and handle in ways to fix the parsing error, while other
 * errors will be raised.
 *
 * @param message - The error that's being re-raised or an error message.
 * @param llmOutput - String model output which is error-ing.
 * @param observation - String explanation of error which can be passed to a
 *     model to try and remediate the issue.
 * @param sendToLLM - Whether to send the observation and llm_output back to an Agent
 *     after an OutputParserException has been raised. This gives the underlying
 *     model driving the agent the context that the previous output was improperly
 *     structured, in the hopes that it will update the output to the correct
 *     format.
 */ parcelHelpers.export(exports, "OutputParserException", ()=>OutputParserException);
var _indexJs = require("../runnables/index.js");
var _indexJs1 = require("../errors/index.js");
class BaseLLMOutputParser extends (0, _indexJs.Runnable) {
    /**
     * Parses the result of an LLM call with a given prompt. By default, it
     * simply calls `parseResult`.
     * @param generations The generations from an LLM call.
     * @param _prompt The prompt used in the LLM call.
     * @param callbacks Optional callbacks.
     * @returns A promise of the parsed output.
     */ parseResultWithPrompt(generations, _prompt, callbacks) {
        return this.parseResult(generations, callbacks);
    }
    _baseMessageToString(message) {
        return typeof message.content === "string" ? message.content : this._baseMessageContentToString(message.content);
    }
    _baseMessageContentToString(content) {
        return JSON.stringify(content);
    }
    /**
     * Calls the parser with a given input and optional configuration options.
     * If the input is a string, it creates a generation with the input as
     * text and calls `parseResult`. If the input is a `BaseMessage`, it
     * creates a generation with the input as a message and the content of the
     * input as text, and then calls `parseResult`.
     * @param input The input to the parser, which can be a string or a `BaseMessage`.
     * @param options Optional configuration options.
     * @returns A promise of the parsed output.
     */ async invoke(input, options) {
        if (typeof input === "string") return this._callWithConfig(async (input, options)=>this.parseResult([
                {
                    text: input
                }
            ], options?.callbacks), input, {
            ...options,
            runType: "parser"
        });
        else return this._callWithConfig(async (input, options)=>this.parseResult([
                {
                    message: input,
                    text: this._baseMessageToString(input)
                }
            ], options?.callbacks), input, {
            ...options,
            runType: "parser"
        });
    }
}
class BaseOutputParser extends BaseLLMOutputParser {
    parseResult(generations, callbacks) {
        return this.parse(generations[0].text, callbacks);
    }
    async parseWithPrompt(text, _prompt, callbacks) {
        return this.parse(text, callbacks);
    }
    /**
     * Return the string type key uniquely identifying this class of parser
     */ _type() {
        throw new Error("_type not implemented");
    }
}
class OutputParserException extends Error {
    constructor(message, llmOutput, observation, sendToLLM = false){
        super(message);
        Object.defineProperty(this, "llmOutput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "observation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sendToLLM", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.llmOutput = llmOutput;
        this.observation = observation;
        this.sendToLLM = sendToLLM;
        if (sendToLLM) {
            if (observation === undefined || llmOutput === undefined) throw new Error("Arguments 'observation' & 'llmOutput' are required if 'sendToLlm' is true");
        }
        (0, _indexJs1.addLangChainErrorFields)(this, "OUTPUT_PARSING_FAILURE");
    }
}

},{"../runnables/index.js":"cJ9j5","../errors/index.js":"cgnw3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cJ9j5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Runnable", ()=>(0, _baseJs.Runnable));
parcelHelpers.export(exports, "RunnableBinding", ()=>(0, _baseJs.RunnableBinding));
parcelHelpers.export(exports, "RunnableEach", ()=>(0, _baseJs.RunnableEach));
parcelHelpers.export(exports, "RunnableRetry", ()=>(0, _baseJs.RunnableRetry));
parcelHelpers.export(exports, "RunnableSequence", ()=>(0, _baseJs.RunnableSequence));
parcelHelpers.export(exports, "RunnableMap", ()=>(0, _baseJs.RunnableMap));
parcelHelpers.export(exports, "RunnableParallel", ()=>(0, _baseJs.RunnableParallel));
parcelHelpers.export(exports, "RunnableLambda", ()=>(0, _baseJs.RunnableLambda));
parcelHelpers.export(exports, "RunnableWithFallbacks", ()=>(0, _baseJs.RunnableWithFallbacks));
parcelHelpers.export(exports, "RunnableAssign", ()=>(0, _baseJs.RunnableAssign));
parcelHelpers.export(exports, "RunnablePick", ()=>(0, _baseJs.RunnablePick));
parcelHelpers.export(exports, "_coerceToRunnable", ()=>(0, _baseJs._coerceToRunnable));
parcelHelpers.export(exports, "RunnableToolLike", ()=>(0, _baseJs.RunnableToolLike));
parcelHelpers.export(exports, "getCallbackManagerForConfig", ()=>(0, _configJs.getCallbackManagerForConfig));
parcelHelpers.export(exports, "patchConfig", ()=>(0, _configJs.patchConfig));
parcelHelpers.export(exports, "ensureConfig", ()=>(0, _configJs.ensureConfig));
parcelHelpers.export(exports, "mergeConfigs", ()=>(0, _configJs.mergeConfigs));
parcelHelpers.export(exports, "RunnablePassthrough", ()=>(0, _passthroughJs.RunnablePassthrough));
parcelHelpers.export(exports, "RouterRunnable", ()=>(0, _routerJs.RouterRunnable));
parcelHelpers.export(exports, "RunnableBranch", ()=>(0, _branchJs.RunnableBranch));
parcelHelpers.export(exports, "RunnableWithMessageHistory", ()=>(0, _historyJs.RunnableWithMessageHistory));
var _baseJs = require("./base.js");
var _configJs = require("./config.js");
var _passthroughJs = require("./passthrough.js");
var _routerJs = require("./router.js");
var _branchJs = require("./branch.js");
var _historyJs = require("./history.js");

},{"./base.js":"9xkzz","./config.js":"2gQun","./passthrough.js":"giooZ","./router.js":"4p6Zk","./branch.js":"kFhZj","./history.js":"9mQCQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4p6Zk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A runnable that routes to a set of runnables based on Input['key'].
 * Returns the output of the selected runnable.
 * @example
 * ```typescript
 * import { RouterRunnable, RunnableLambda } from "@langchain/core/runnables";
 *
 * const router = new RouterRunnable({
 *   runnables: {
 *     toUpperCase: RunnableLambda.from((text: string) => text.toUpperCase()),
 *     reverseText: RunnableLambda.from((text: string) =>
 *       text.split("").reverse().join("")
 *     ),
 *   },
 * });
 *
 * // Invoke the 'reverseText' runnable
 * const result1 = router.invoke({ key: "reverseText", input: "Hello World" });
 *
 * // "dlroW olleH"
 *
 * // Invoke the 'toUpperCase' runnable
 * const result2 = router.invoke({ key: "toUpperCase", input: "Hello World" });
 *
 * // "HELLO WORLD"
 * ```
 */ parcelHelpers.export(exports, "RouterRunnable", ()=>RouterRunnable);
var _baseJs = require("./base.js");
var _configJs = require("./config.js");
class RouterRunnable extends (0, _baseJs.Runnable) {
    static lc_name() {
        return "RouterRunnable";
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "runnables", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.runnables = fields.runnables;
    }
    async invoke(input, options) {
        const { key, input: actualInput } = input;
        const runnable = this.runnables[key];
        if (runnable === undefined) throw new Error(`No runnable associated with key "${key}".`);
        return runnable.invoke(actualInput, (0, _configJs.ensureConfig)(options));
    }
    async batch(inputs, options, batchOptions) {
        const keys = inputs.map((input)=>input.key);
        const actualInputs = inputs.map((input)=>input.input);
        const missingKey = keys.find((key)=>this.runnables[key] === undefined);
        if (missingKey !== undefined) throw new Error(`One or more keys do not have a corresponding runnable.`);
        const runnables = keys.map((key)=>this.runnables[key]);
        const optionsList = this._getOptionsList(options ?? {}, inputs.length);
        const maxConcurrency = optionsList[0]?.maxConcurrency ?? batchOptions?.maxConcurrency;
        const batchSize = maxConcurrency && maxConcurrency > 0 ? maxConcurrency : inputs.length;
        const batchResults = [];
        for(let i = 0; i < actualInputs.length; i += batchSize){
            const batchPromises = actualInputs.slice(i, i + batchSize).map((actualInput, i)=>runnables[i].invoke(actualInput, optionsList[i]));
            const batchResult = await Promise.all(batchPromises);
            batchResults.push(batchResult);
        }
        return batchResults.flat();
    }
    async stream(input, options) {
        const { key, input: actualInput } = input;
        const runnable = this.runnables[key];
        if (runnable === undefined) throw new Error(`No runnable associated with key "${key}".`);
        return runnable.stream(actualInput, options);
    }
}

},{"./base.js":"9xkzz","./config.js":"2gQun","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kFhZj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Class that represents a runnable branch. The RunnableBranch is
 * initialized with an array of branches and a default branch. When invoked,
 * it evaluates the condition of each branch in order and executes the
 * corresponding branch if the condition is true. If none of the conditions
 * are true, it executes the default branch.
 * @example
 * ```typescript
 * const branch = RunnableBranch.from([
 *   [
 *     (x: { topic: string; question: string }) =>
 *       x.topic.toLowerCase().includes("anthropic"),
 *     anthropicChain,
 *   ],
 *   [
 *     (x: { topic: string; question: string }) =>
 *       x.topic.toLowerCase().includes("langchain"),
 *     langChainChain,
 *   ],
 *   generalChain,
 * ]);
 *
 * const fullChain = RunnableSequence.from([
 *   {
 *     topic: classificationChain,
 *     question: (input: { question: string }) => input.question,
 *   },
 *   branch,
 * ]);
 *
 * const result = await fullChain.invoke({
 *   question: "how do I use LangChain?",
 * });
 * ```
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "RunnableBranch", ()=>RunnableBranch);
var _baseJs = require("./base.js");
var _configJs = require("./config.js");
var _streamJs = require("../utils/stream.js");
class RunnableBranch extends (0, _baseJs.Runnable) {
    static lc_name() {
        return "RunnableBranch";
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "runnables"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "default", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "branches", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.branches = fields.branches;
        this.default = fields.default;
    }
    /**
     * Convenience method for instantiating a RunnableBranch from
     * RunnableLikes (objects, functions, or Runnables).
     *
     * Each item in the input except for the last one should be a
     * tuple with two items. The first is a "condition" RunnableLike that
     * returns "true" if the second RunnableLike in the tuple should run.
     *
     * The final item in the input should be a RunnableLike that acts as a
     * default branch if no other branches match.
     *
     * @example
     * ```ts
     * import { RunnableBranch } from "@langchain/core/runnables";
     *
     * const branch = RunnableBranch.from([
     *   [(x: number) => x > 0, (x: number) => x + 1],
     *   [(x: number) => x < 0, (x: number) => x - 1],
     *   (x: number) => x
     * ]);
     * ```
     * @param branches An array where the every item except the last is a tuple of [condition, runnable]
     *   pairs. The last item is a default runnable which is invoked if no other condition matches.
     * @returns A new RunnableBranch.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static from(branches) {
        if (branches.length < 1) throw new Error("RunnableBranch requires at least one branch");
        const branchLikes = branches.slice(0, -1);
        const coercedBranches = branchLikes.map(([condition, runnable])=>[
                (0, _baseJs._coerceToRunnable)(condition),
                (0, _baseJs._coerceToRunnable)(runnable)
            ]);
        const defaultBranch = (0, _baseJs._coerceToRunnable)(branches[branches.length - 1]);
        return new this({
            branches: coercedBranches,
            default: defaultBranch
        });
    }
    async _invoke(input, config, runManager) {
        let result;
        for(let i = 0; i < this.branches.length; i += 1){
            const [condition, branchRunnable] = this.branches[i];
            const conditionValue = await condition.invoke(input, (0, _configJs.patchConfig)(config, {
                callbacks: runManager?.getChild(`condition:${i + 1}`)
            }));
            if (conditionValue) {
                result = await branchRunnable.invoke(input, (0, _configJs.patchConfig)(config, {
                    callbacks: runManager?.getChild(`branch:${i + 1}`)
                }));
                break;
            }
        }
        if (!result) result = await this.default.invoke(input, (0, _configJs.patchConfig)(config, {
            callbacks: runManager?.getChild("branch:default")
        }));
        return result;
    }
    async invoke(input, config = {}) {
        return this._callWithConfig(this._invoke, input, config);
    }
    async *_streamIterator(input, config) {
        const callbackManager_ = await (0, _configJs.getCallbackManagerForConfig)(config);
        const runManager = await callbackManager_?.handleChainStart(this.toJSON(), (0, _baseJs._coerceToDict)(input, "input"), config?.runId, undefined, undefined, undefined, config?.runName);
        let finalOutput;
        let finalOutputSupported = true;
        let stream;
        try {
            for(let i = 0; i < this.branches.length; i += 1){
                const [condition, branchRunnable] = this.branches[i];
                const conditionValue = await condition.invoke(input, (0, _configJs.patchConfig)(config, {
                    callbacks: runManager?.getChild(`condition:${i + 1}`)
                }));
                if (conditionValue) {
                    stream = await branchRunnable.stream(input, (0, _configJs.patchConfig)(config, {
                        callbacks: runManager?.getChild(`branch:${i + 1}`)
                    }));
                    for await (const chunk of stream){
                        yield chunk;
                        if (finalOutputSupported) {
                            if (finalOutput === undefined) finalOutput = chunk;
                            else try {
                                finalOutput = (0, _streamJs.concat)(finalOutput, chunk);
                            } catch (e) {
                                finalOutput = undefined;
                                finalOutputSupported = false;
                            }
                        }
                    }
                    break;
                }
            }
            if (stream === undefined) {
                stream = await this.default.stream(input, (0, _configJs.patchConfig)(config, {
                    callbacks: runManager?.getChild("branch:default")
                }));
                for await (const chunk of stream){
                    yield chunk;
                    if (finalOutputSupported) {
                        if (finalOutput === undefined) finalOutput = chunk;
                        else try {
                            finalOutput = (0, _streamJs.concat)(finalOutput, chunk);
                        } catch (e) {
                            finalOutput = undefined;
                            finalOutputSupported = false;
                        }
                    }
                }
            }
        } catch (e) {
            await runManager?.handleChainError(e);
            throw e;
        }
        await runManager?.handleChainEnd(finalOutput ?? {});
    }
}

},{"./base.js":"9xkzz","./config.js":"2gQun","../utils/stream.js":"kAAca","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9mQCQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Wraps a LCEL chain and manages history. It appends input messages
 * and chain outputs as history, and adds the current history messages to
 * the chain input.
 * @example
 * ```typescript
 * // yarn add @langchain/anthropic @langchain/community @upstash/redis
 *
 * import {
 *   ChatPromptTemplate,
 *   MessagesPlaceholder,
 * } from "@langchain/core/prompts";
 * import { ChatAnthropic } from "@langchain/anthropic";
 * import { UpstashRedisChatMessageHistory } from "@langchain/community/stores/message/upstash_redis";
 * // For demos, you can also use an in-memory store:
 * // import { ChatMessageHistory } from "langchain/stores/message/in_memory";
 *
 * const prompt = ChatPromptTemplate.fromMessages([
 *   ["system", "You're an assistant who's good at {ability}"],
 *   new MessagesPlaceholder("history"),
 *   ["human", "{question}"],
 * ]);
 *
 * const chain = prompt.pipe(new ChatAnthropic({}));
 *
 * const chainWithHistory = new RunnableWithMessageHistory({
 *   runnable: chain,
 *   getMessageHistory: (sessionId) =>
 *     new UpstashRedisChatMessageHistory({
 *       sessionId,
 *       config: {
 *         url: process.env.UPSTASH_REDIS_REST_URL!,
 *         token: process.env.UPSTASH_REDIS_REST_TOKEN!,
 *       },
 *     }),
 *   inputMessagesKey: "question",
 *   historyMessagesKey: "history",
 * });
 *
 * const result = await chainWithHistory.invoke(
 *   {
 *     ability: "math",
 *     question: "What does cosine mean?",
 *   },
 *   {
 *     configurable: {
 *       sessionId: "some_string_identifying_a_user",
 *     },
 *   }
 * );
 *
 * const result2 = await chainWithHistory.invoke(
 *   {
 *     ability: "math",
 *     question: "What's its inverse?",
 *   },
 *   {
 *     configurable: {
 *       sessionId: "some_string_identifying_a_user",
 *     },
 *   }
 * );
 * ```
 */ parcelHelpers.export(exports, "RunnableWithMessageHistory", ()=>RunnableWithMessageHistory);
var _indexJs = require("../messages/index.js");
var _baseJs = require("./base.js");
var _passthroughJs = require("./passthrough.js");
class RunnableWithMessageHistory extends (0, _baseJs.RunnableBinding) {
    constructor(fields){
        let historyChain = (0, _baseJs.RunnableLambda).from((input, options)=>this._enterHistory(input, options ?? {})).withConfig({
            runName: "loadHistory"
        });
        const messagesKey = fields.historyMessagesKey ?? fields.inputMessagesKey;
        if (messagesKey) historyChain = (0, _passthroughJs.RunnablePassthrough).assign({
            [messagesKey]: historyChain
        }).withConfig({
            runName: "insertHistory"
        });
        const bound = historyChain.pipe(fields.runnable.withListeners({
            onEnd: (run, config)=>this._exitHistory(run, config ?? {})
        })).withConfig({
            runName: "RunnableWithMessageHistory"
        });
        const config = fields.config ?? {};
        super({
            ...fields,
            config,
            bound
        });
        Object.defineProperty(this, "runnable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "inputMessagesKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "outputMessagesKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "historyMessagesKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getMessageHistory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.runnable = fields.runnable;
        this.getMessageHistory = fields.getMessageHistory;
        this.inputMessagesKey = fields.inputMessagesKey;
        this.outputMessagesKey = fields.outputMessagesKey;
        this.historyMessagesKey = fields.historyMessagesKey;
    }
    _getInputMessages(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    inputValue) {
        let parsedInputValue;
        if (typeof inputValue === "object" && !Array.isArray(inputValue) && !(0, _indexJs.isBaseMessage)(inputValue)) {
            let key;
            if (this.inputMessagesKey) key = this.inputMessagesKey;
            else if (Object.keys(inputValue).length === 1) key = Object.keys(inputValue)[0];
            else key = "input";
            if (Array.isArray(inputValue[key]) && Array.isArray(inputValue[key][0])) parsedInputValue = inputValue[key][0];
            else parsedInputValue = inputValue[key];
        } else parsedInputValue = inputValue;
        if (typeof parsedInputValue === "string") return [
            new (0, _indexJs.HumanMessage)(parsedInputValue)
        ];
        else if (Array.isArray(parsedInputValue)) return parsedInputValue;
        else if ((0, _indexJs.isBaseMessage)(parsedInputValue)) return [
            parsedInputValue
        ];
        else throw new Error(`Expected a string, BaseMessage, or array of BaseMessages.\nGot ${JSON.stringify(parsedInputValue, null, 2)}`);
    }
    _getOutputMessages(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    outputValue) {
        let parsedOutputValue;
        if (!Array.isArray(outputValue) && !(0, _indexJs.isBaseMessage)(outputValue) && typeof outputValue !== "string") {
            let key;
            if (this.outputMessagesKey !== undefined) key = this.outputMessagesKey;
            else if (Object.keys(outputValue).length === 1) key = Object.keys(outputValue)[0];
            else key = "output";
            // If you are wrapping a chat model directly
            // The output is actually this weird generations object
            if (outputValue.generations !== undefined) parsedOutputValue = outputValue.generations[0][0].message;
            else parsedOutputValue = outputValue[key];
        } else parsedOutputValue = outputValue;
        if (typeof parsedOutputValue === "string") return [
            new (0, _indexJs.AIMessage)(parsedOutputValue)
        ];
        else if (Array.isArray(parsedOutputValue)) return parsedOutputValue;
        else if ((0, _indexJs.isBaseMessage)(parsedOutputValue)) return [
            parsedOutputValue
        ];
        else throw new Error(`Expected a string, BaseMessage, or array of BaseMessages. Received: ${JSON.stringify(parsedOutputValue, null, 2)}`);
    }
    async _enterHistory(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    input, kwargs) {
        const history = kwargs?.configurable?.messageHistory;
        const messages = await history.getMessages();
        if (this.historyMessagesKey === undefined) return messages.concat(this._getInputMessages(input));
        return messages;
    }
    async _exitHistory(run, config) {
        const history = config.configurable?.messageHistory;
        // Get input messages
        let inputs;
        // Chat model inputs are nested arrays
        if (Array.isArray(run.inputs) && Array.isArray(run.inputs[0])) inputs = run.inputs[0];
        else inputs = run.inputs;
        let inputMessages = this._getInputMessages(inputs);
        // If historic messages were prepended to the input messages, remove them to
        // avoid adding duplicate messages to history.
        if (this.historyMessagesKey === undefined) {
            const existingMessages = await history.getMessages();
            inputMessages = inputMessages.slice(existingMessages.length);
        }
        // Get output messages
        const outputValue = run.outputs;
        if (!outputValue) throw new Error(`Output values from 'Run' undefined. Run: ${JSON.stringify(run, null, 2)}`);
        const outputMessages = this._getOutputMessages(outputValue);
        await history.addMessages([
            ...inputMessages,
            ...outputMessages
        ]);
    }
    async _mergeConfig(...configs) {
        const config = await super._mergeConfig(...configs);
        // Extract sessionId
        if (!config.configurable || !config.configurable.sessionId) {
            const exampleInput = {
                [this.inputMessagesKey ?? "input"]: "foo"
            };
            const exampleConfig = {
                configurable: {
                    sessionId: "123"
                }
            };
            throw new Error(`sessionId is required. Pass it in as part of the config argument to .invoke() or .stream()\n` + `eg. chain.invoke(${JSON.stringify(exampleInput)}, ${JSON.stringify(exampleConfig)})`);
        }
        // attach messageHistory
        const { sessionId } = config.configurable;
        config.configurable.messageHistory = await this.getMessageHistory(sessionId);
        return config;
    }
}

},{"../messages/index.js":"7XzBK","./base.js":"9xkzz","./passthrough.js":"giooZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gION6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * OutputParser that parses LLMResult into the top likely string and
 * encodes it into bytes.
 */ parcelHelpers.export(exports, "BytesOutputParser", ()=>BytesOutputParser);
var _transformJs = require("./transform.js");
class BytesOutputParser extends (0, _transformJs.BaseTransformOutputParser) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "output_parsers",
                "bytes"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "textEncoder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new TextEncoder()
        });
    }
    static lc_name() {
        return "BytesOutputParser";
    }
    parse(text) {
        return Promise.resolve(this.textEncoder.encode(text));
    }
    getFormatInstructions() {
        return "";
    }
}

},{"./transform.js":"4lsjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4lsjz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Class to parse the output of an LLM call that also allows streaming inputs.
 */ parcelHelpers.export(exports, "BaseTransformOutputParser", ()=>BaseTransformOutputParser);
/**
 * A base class for output parsers that can handle streaming input. It
 * extends the `BaseTransformOutputParser` class and provides a method for
 * converting parsed outputs into a diff format.
 */ parcelHelpers.export(exports, "BaseCumulativeTransformOutputParser", ()=>BaseCumulativeTransformOutputParser);
var _baseJs = require("./base.js");
var _baseJs1 = require("../messages/base.js");
var _utilsJs = require("../messages/utils.js");
var _outputsJs = require("../outputs.js");
var _indexJs = require("../utils/@cfworker/json-schema/index.js");
class BaseTransformOutputParser extends (0, _baseJs.BaseOutputParser) {
    async *_transform(inputGenerator) {
        for await (const chunk of inputGenerator)if (typeof chunk === "string") yield this.parseResult([
            {
                text: chunk
            }
        ]);
        else yield this.parseResult([
            {
                message: chunk,
                text: this._baseMessageToString(chunk)
            }
        ]);
    }
    /**
     * Transforms an asynchronous generator of input into an asynchronous
     * generator of parsed output.
     * @param inputGenerator An asynchronous generator of input.
     * @param options A configuration object.
     * @returns An asynchronous generator of parsed output.
     */ async *transform(inputGenerator, options) {
        yield* this._transformStreamWithConfig(inputGenerator, this._transform.bind(this), {
            ...options,
            runType: "parser"
        });
    }
}
class BaseCumulativeTransformOutputParser extends BaseTransformOutputParser {
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "diff", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        this.diff = fields?.diff ?? this.diff;
    }
    async *_transform(inputGenerator) {
        let prevParsed;
        let accGen;
        for await (const chunk of inputGenerator){
            if (typeof chunk !== "string" && typeof chunk.content !== "string") throw new Error("Cannot handle non-string output.");
            let chunkGen;
            if ((0, _baseJs1.isBaseMessageChunk)(chunk)) {
                if (typeof chunk.content !== "string") throw new Error("Cannot handle non-string message output.");
                chunkGen = new (0, _outputsJs.ChatGenerationChunk)({
                    message: chunk,
                    text: chunk.content
                });
            } else if ((0, _baseJs1.isBaseMessage)(chunk)) {
                if (typeof chunk.content !== "string") throw new Error("Cannot handle non-string message output.");
                chunkGen = new (0, _outputsJs.ChatGenerationChunk)({
                    message: (0, _utilsJs.convertToChunk)(chunk),
                    text: chunk.content
                });
            } else chunkGen = new (0, _outputsJs.GenerationChunk)({
                text: chunk
            });
            if (accGen === undefined) accGen = chunkGen;
            else accGen = accGen.concat(chunkGen);
            const parsed = await this.parsePartialResult([
                accGen
            ]);
            if (parsed !== undefined && parsed !== null && !(0, _indexJs.deepCompareStrict)(parsed, prevParsed)) {
                if (this.diff) yield this._diff(prevParsed, parsed);
                else yield parsed;
                prevParsed = parsed;
            }
        }
    }
    getFormatInstructions() {
        return "";
    }
}

},{"./base.js":"lJpNd","../messages/base.js":"bWcpl","../messages/utils.js":"6vi0n","../outputs.js":"4YkJk","../utils/@cfworker/json-schema/index.js":"jvLfm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jvLfm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./src/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"./src/index.js":"aK25f","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aK25f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deepCompareStrictJs = require("./deep-compare-strict.js");
parcelHelpers.exportAll(_deepCompareStrictJs, exports);
var _dereferenceJs = require("./dereference.js");
parcelHelpers.exportAll(_dereferenceJs, exports);
var _formatJs = require("./format.js");
parcelHelpers.exportAll(_formatJs, exports);
var _pointerJs = require("./pointer.js");
parcelHelpers.exportAll(_pointerJs, exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _ucs2LengthJs = require("./ucs2-length.js");
parcelHelpers.exportAll(_ucs2LengthJs, exports);
var _validateJs = require("./validate.js");
parcelHelpers.exportAll(_validateJs, exports);
var _validatorJs = require("./validator.js");
parcelHelpers.exportAll(_validatorJs, exports);

},{"./deep-compare-strict.js":"cjMKm","./dereference.js":"6wOof","./format.js":"aAiu1","./pointer.js":"fxWMF","./types.js":"2RX33","./ucs2-length.js":"euReT","./validate.js":"cnppB","./validator.js":"51UEF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cjMKm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepCompareStrict", ()=>deepCompareStrict);
function deepCompareStrict(a, b) {
    const typeofa = typeof a;
    if (typeofa !== typeof b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false;
        const length = a.length;
        if (length !== b.length) return false;
        for(let i = 0; i < length; i++){
            if (!deepCompareStrict(a[i], b[i])) return false;
        }
        return true;
    }
    if (typeofa === "object") {
        if (!a || !b) return a === b;
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        const length = aKeys.length;
        if (length !== bKeys.length) return false;
        for (const k of aKeys){
            if (!deepCompareStrict(a[k], b[k])) return false;
        }
        return true;
    }
    return a === b;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6wOof":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemaKeyword", ()=>schemaKeyword);
parcelHelpers.export(exports, "schemaArrayKeyword", ()=>schemaArrayKeyword);
parcelHelpers.export(exports, "schemaMapKeyword", ()=>schemaMapKeyword);
parcelHelpers.export(exports, "ignoredKeyword", ()=>ignoredKeyword);
parcelHelpers.export(exports, "initialBaseURI", ()=>initialBaseURI);
parcelHelpers.export(exports, "dereference", ()=>dereference) // schema identification examples
 // https://json-schema.org/draft/2019-09/json-schema-core.html#rfc.appendix.A
 // $ref delegation
 // https://github.com/json-schema-org/json-schema-spec/issues/514
 // output format
 // https://json-schema.org/draft/2019-09/json-schema-core.html#output
 // JSON pointer
 // https://tools.ietf.org/html/rfc6901
 // JSON relative pointer
 // https://tools.ietf.org/html/draft-handrews-relative-json-pointer-01
;
var _pointerJs = require("./pointer.js");
const schemaKeyword = {
    additionalItems: true,
    unevaluatedItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    unevaluatedProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
const schemaArrayKeyword = {
    prefixItems: true,
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
const schemaMapKeyword = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependentSchemas: true
};
const ignoredKeyword = {
    id: true,
    $id: true,
    $ref: true,
    $schema: true,
    $anchor: true,
    $vocabulary: true,
    $comment: true,
    default: true,
    enum: true,
    const: true,
    required: true,
    type: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
let initialBaseURI = // @ts-ignore
typeof self !== "undefined" && self.location && self.location.origin !== "null" ? /* #__PURE__ */ new URL(self.location.origin + self.location.pathname + location.search) : /* #__PURE__ */ new URL("https://github.com/cfworker");
function dereference(schema, lookup = Object.create(null), baseURI = initialBaseURI, basePointer = "") {
    if (schema && typeof schema === "object" && !Array.isArray(schema)) {
        const id = schema.$id || schema.id;
        if (id) {
            const url = new URL(id, baseURI.href);
            if (url.hash.length > 1) lookup[url.href] = schema;
            else {
                url.hash = ""; // normalize hash https://url.spec.whatwg.org/#dom-url-hash
                if (basePointer === "") baseURI = url;
                else dereference(schema, lookup, baseURI);
            }
        }
    } else if (schema !== true && schema !== false) return lookup;
    // compute the schema's URI and add it to the mapping.
    const schemaURI = baseURI.href + (basePointer ? "#" + basePointer : "");
    if (lookup[schemaURI] !== undefined) throw new Error(`Duplicate schema URI "${schemaURI}".`);
    lookup[schemaURI] = schema;
    // exit early if this is a boolean schema.
    if (schema === true || schema === false) return lookup;
    // set the schema's absolute URI.
    if (schema.__absolute_uri__ === undefined) Object.defineProperty(schema, "__absolute_uri__", {
        enumerable: false,
        value: schemaURI
    });
    // if a $ref is found, resolve it's absolute URI.
    if (schema.$ref && schema.__absolute_ref__ === undefined) {
        const url = new URL(schema.$ref, baseURI.href);
        url.hash = url.hash; // normalize hash https://url.spec.whatwg.org/#dom-url-hash
        Object.defineProperty(schema, "__absolute_ref__", {
            enumerable: false,
            value: url.href
        });
    }
    // if a $recursiveRef is found, resolve it's absolute URI.
    if (schema.$recursiveRef && schema.__absolute_recursive_ref__ === undefined) {
        const url = new URL(schema.$recursiveRef, baseURI.href);
        url.hash = url.hash; // normalize hash https://url.spec.whatwg.org/#dom-url-hash
        Object.defineProperty(schema, "__absolute_recursive_ref__", {
            enumerable: false,
            value: url.href
        });
    }
    // if an $anchor is found, compute it's URI and add it to the mapping.
    if (schema.$anchor) {
        const url = new URL("#" + schema.$anchor, baseURI.href);
        lookup[url.href] = schema;
    }
    // process subschemas.
    for(let key in schema){
        if (ignoredKeyword[key]) continue;
        const keyBase = `${basePointer}/${(0, _pointerJs.encodePointer)(key)}`;
        const subSchema = schema[key];
        if (Array.isArray(subSchema)) {
            if (schemaArrayKeyword[key]) {
                const length = subSchema.length;
                for(let i = 0; i < length; i++)dereference(subSchema[i], lookup, baseURI, `${keyBase}/${i}`);
            }
        } else if (schemaMapKeyword[key]) for(let subKey in subSchema)dereference(subSchema[subKey], lookup, baseURI, `${keyBase}/${(0, _pointerJs.encodePointer)(subKey)}`);
        else dereference(subSchema, lookup, baseURI, keyBase);
    }
    return lookup;
}

},{"./pointer.js":"fxWMF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fxWMF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encodePointer", ()=>encodePointer);
parcelHelpers.export(exports, "escapePointer", ()=>escapePointer);
function encodePointer(p) {
    return encodeURI(escapePointer(p));
}
function escapePointer(p) {
    return p.replace(/~/g, "~0").replace(/\//g, "~1");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aAiu1":[function(require,module,exports,__globalThis) {
// based on https://github.com/epoberezkin/ajv/blob/master/lib/compile/formats.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fullFormat", ()=>fullFormat);
parcelHelpers.export(exports, "fastFormat", ()=>fastFormat);
const DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
const DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
const HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
// const URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
const URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
// uri-template: https://tools.ietf.org/html/rfc6570
const URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
// For the source: https://gist.github.com/dperini/729294
// For test cases: https://mathiasbynens.be/demo/url-regex
const URL_ = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
const UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
const JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
const JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
const RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
// date: http://tools.ietf.org/html/rfc3339#section-5.6
const FASTDATE = /^\d\d\d\d-[0-1]\d-[0-3]\d$/;
// date-time: http://tools.ietf.org/html/rfc3339#section-5.6
const FASTTIME = /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i;
const FASTDATETIME = /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i;
// uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
// const FASTURI = /^(?:[a-z][a-z0-9+-.]*:)(?:\/?\/)?[^\s]*$/i;
const FASTURIREFERENCE = /^(?:(?:[a-z][a-z0-9+-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i;
// https://github.com/ExodusMovement/schemasafe/blob/master/src/formats.js
const EMAIL = (input)=>{
    if (input[0] === '"') return false;
    const [name, host, ...rest] = input.split("@");
    if (!name || !host || rest.length !== 0 || name.length > 64 || host.length > 253) return false;
    if (name[0] === "." || name.endsWith(".") || name.includes("..")) return false;
    if (!/^[a-z0-9.-]+$/i.test(host) || !/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+$/i.test(name)) return false;
    return host.split(".").every((part)=>/^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/i.test(part));
};
// optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
const IPV4 = /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/;
// optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
const IPV6 = /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i;
// https://github.com/ExodusMovement/schemasafe/blob/master/src/formats.js
const DURATION = (input)=>input.length > 1 && input.length < 80 && (/^P\d+([.,]\d+)?W$/.test(input) || /^P[\dYMDTHS]*(\d[.,]\d+)?[YMDHS]$/.test(input) && /^P([.,\d]+Y)?([.,\d]+M)?([.,\d]+D)?(T([.,\d]+H)?([.,\d]+M)?([.,\d]+S)?)?$/.test(input));
function bind(r) {
    return r.test.bind(r);
}
const fullFormat = {
    date,
    time: /* #__PURE__ */ time.bind(undefined, false),
    "date-time": date_time,
    duration: DURATION,
    uri,
    "uri-reference": /* #__PURE__ */ bind(URIREF),
    "uri-template": /* #__PURE__ */ bind(URITEMPLATE),
    url: /* #__PURE__ */ bind(URL_),
    email: EMAIL,
    hostname: /* #__PURE__ */ bind(HOSTNAME),
    ipv4: /* #__PURE__ */ bind(IPV4),
    ipv6: /* #__PURE__ */ bind(IPV6),
    regex: regex,
    uuid: /* #__PURE__ */ bind(UUID),
    "json-pointer": /* #__PURE__ */ bind(JSON_POINTER),
    "json-pointer-uri-fragment": /* #__PURE__ */ bind(JSON_POINTER_URI_FRAGMENT),
    "relative-json-pointer": /* #__PURE__ */ bind(RELATIVE_JSON_POINTER)
};
const fastFormat = {
    ...fullFormat,
    date: /* #__PURE__ */ bind(FASTDATE),
    time: /* #__PURE__ */ bind(FASTTIME),
    "date-time": /* #__PURE__ */ bind(FASTDATETIME),
    "uri-reference": /* #__PURE__ */ bind(FASTURIREFERENCE)
};
function isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    const matches = str.match(DATE);
    if (!matches) return false;
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month == 2 && isLeapYear(year) ? 29 : DAYS[month]);
}
function time(full, str) {
    const matches = str.match(TIME);
    if (!matches) return false;
    const hour = +matches[1];
    const minute = +matches[2];
    const second = +matches[3];
    const timeZone = !!matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour == 23 && minute == 59 && second == 60) && (!full || timeZone);
}
const DATE_TIME_SEPARATOR = /t|\s/i;
function date_time(str) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    const dateTime = str.split(DATE_TIME_SEPARATOR);
    return dateTime.length == 2 && date(dateTime[0]) && time(true, dateTime[1]);
}
const NOT_URI_FRAGMENT = /\/|:/;
const URI_PATTERN = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
function uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return NOT_URI_FRAGMENT.test(str) && URI_PATTERN.test(str);
}
const Z_ANCHOR = /[^\\]\\Z/;
function regex(str) {
    if (Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str);
        return true;
    } catch (e) {
        return false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2RX33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"euReT":[function(require,module,exports,__globalThis) {
/**
 * Get UCS-2 length of a string
 * https://mathiasbynens.be/notes/javascript-encoding
 * https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ucs2length", ()=>ucs2length);
function ucs2length(s) {
    let result = 0;
    let length = s.length;
    let index = 0;
    let charCode;
    while(index < length){
        result++;
        charCode = s.charCodeAt(index++);
        if (charCode >= 0xd800 && charCode <= 0xdbff && index < length) {
            // high surrogate, and there is a next character
            charCode = s.charCodeAt(index);
            if ((charCode & 0xfc00) == 0xdc00) // low surrogate
            index++;
        }
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cnppB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validate", ()=>validate);
var _deepCompareStrictJs = require("./deep-compare-strict.js");
var _dereferenceJs = require("./dereference.js");
var _formatJs = require("./format.js");
var _pointerJs = require("./pointer.js");
var _ucs2LengthJs = require("./ucs2-length.js");
function validate(instance, schema, draft = "2019-09", lookup = (0, _dereferenceJs.dereference)(schema), shortCircuit = true, recursiveAnchor = null, instanceLocation = "#", schemaLocation = "#", evaluated = Object.create(null)) {
    if (schema === true) return {
        valid: true,
        errors: []
    };
    if (schema === false) return {
        valid: false,
        errors: [
            {
                instanceLocation,
                keyword: "false",
                keywordLocation: instanceLocation,
                error: "False boolean schema."
            }
        ]
    };
    const rawInstanceType = typeof instance;
    let instanceType;
    switch(rawInstanceType){
        case "boolean":
        case "number":
        case "string":
            instanceType = rawInstanceType;
            break;
        case "object":
            if (instance === null) instanceType = "null";
            else if (Array.isArray(instance)) instanceType = "array";
            else instanceType = "object";
            break;
        default:
            // undefined, bigint, function, symbol
            throw new Error(`Instances of "${rawInstanceType}" type are not supported.`);
    }
    const { $ref, $recursiveRef, $recursiveAnchor, type: $type, const: $const, enum: $enum, required: $required, not: $not, anyOf: $anyOf, allOf: $allOf, oneOf: $oneOf, if: $if, then: $then, else: $else, format: $format, properties: $properties, patternProperties: $patternProperties, additionalProperties: $additionalProperties, unevaluatedProperties: $unevaluatedProperties, minProperties: $minProperties, maxProperties: $maxProperties, propertyNames: $propertyNames, dependentRequired: $dependentRequired, dependentSchemas: $dependentSchemas, dependencies: $dependencies, prefixItems: $prefixItems, items: $items, additionalItems: $additionalItems, unevaluatedItems: $unevaluatedItems, contains: $contains, minContains: $minContains, maxContains: $maxContains, minItems: $minItems, maxItems: $maxItems, uniqueItems: $uniqueItems, minimum: $minimum, maximum: $maximum, exclusiveMinimum: $exclusiveMinimum, exclusiveMaximum: $exclusiveMaximum, multipleOf: $multipleOf, minLength: $minLength, maxLength: $maxLength, pattern: $pattern, __absolute_ref__, __absolute_recursive_ref__ } = schema;
    const errors = [];
    if ($recursiveAnchor === true && recursiveAnchor === null) recursiveAnchor = schema;
    if ($recursiveRef === "#") {
        const refSchema = recursiveAnchor === null ? lookup[__absolute_recursive_ref__] : recursiveAnchor;
        const keywordLocation = `${schemaLocation}/$recursiveRef`;
        const result = validate(instance, recursiveAnchor === null ? schema : recursiveAnchor, draft, lookup, shortCircuit, refSchema, instanceLocation, keywordLocation, evaluated);
        if (!result.valid) errors.push({
            instanceLocation,
            keyword: "$recursiveRef",
            keywordLocation,
            error: "A subschema had errors."
        }, ...result.errors);
    }
    if ($ref !== undefined) {
        const uri = __absolute_ref__ || $ref;
        const refSchema = lookup[uri];
        if (refSchema === undefined) {
            let message = `Unresolved $ref "${$ref}".`;
            if (__absolute_ref__ && __absolute_ref__ !== $ref) message += `  Absolute URI "${__absolute_ref__}".`;
            message += `\nKnown schemas:\n- ${Object.keys(lookup).join("\n- ")}`;
            throw new Error(message);
        }
        const keywordLocation = `${schemaLocation}/$ref`;
        const result = validate(instance, refSchema, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, keywordLocation, evaluated);
        if (!result.valid) errors.push({
            instanceLocation,
            keyword: "$ref",
            keywordLocation,
            error: "A subschema had errors."
        }, ...result.errors);
        if (draft === "4" || draft === "7") return {
            valid: errors.length === 0,
            errors
        };
    }
    if (Array.isArray($type)) {
        let length = $type.length;
        let valid = false;
        for(let i = 0; i < length; i++)if (instanceType === $type[i] || $type[i] === "integer" && instanceType === "number" && instance % 1 === 0 && instance === instance) {
            valid = true;
            break;
        }
        if (!valid) errors.push({
            instanceLocation,
            keyword: "type",
            keywordLocation: `${schemaLocation}/type`,
            error: `Instance type "${instanceType}" is invalid. Expected "${$type.join('", "')}".`
        });
    } else if ($type === "integer") {
        if (instanceType !== "number" || instance % 1 || instance !== instance) errors.push({
            instanceLocation,
            keyword: "type",
            keywordLocation: `${schemaLocation}/type`,
            error: `Instance type "${instanceType}" is invalid. Expected "${$type}".`
        });
    } else if ($type !== undefined && instanceType !== $type) errors.push({
        instanceLocation,
        keyword: "type",
        keywordLocation: `${schemaLocation}/type`,
        error: `Instance type "${instanceType}" is invalid. Expected "${$type}".`
    });
    if ($const !== undefined) {
        if (instanceType === "object" || instanceType === "array") {
            if (!(0, _deepCompareStrictJs.deepCompareStrict)(instance, $const)) errors.push({
                instanceLocation,
                keyword: "const",
                keywordLocation: `${schemaLocation}/const`,
                error: `Instance does not match ${JSON.stringify($const)}.`
            });
        } else if (instance !== $const) errors.push({
            instanceLocation,
            keyword: "const",
            keywordLocation: `${schemaLocation}/const`,
            error: `Instance does not match ${JSON.stringify($const)}.`
        });
    }
    if ($enum !== undefined) {
        if (instanceType === "object" || instanceType === "array") {
            if (!$enum.some((value)=>(0, _deepCompareStrictJs.deepCompareStrict)(instance, value))) errors.push({
                instanceLocation,
                keyword: "enum",
                keywordLocation: `${schemaLocation}/enum`,
                error: `Instance does not match any of ${JSON.stringify($enum)}.`
            });
        } else if (!$enum.some((value)=>instance === value)) errors.push({
            instanceLocation,
            keyword: "enum",
            keywordLocation: `${schemaLocation}/enum`,
            error: `Instance does not match any of ${JSON.stringify($enum)}.`
        });
    }
    if ($not !== undefined) {
        const keywordLocation = `${schemaLocation}/not`;
        const result = validate(instance, $not, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, keywordLocation /*,
        evaluated*/ );
        if (result.valid) errors.push({
            instanceLocation,
            keyword: "not",
            keywordLocation,
            error: 'Instance matched "not" schema.'
        });
    }
    let subEvaluateds = [];
    if ($anyOf !== undefined) {
        const keywordLocation = `${schemaLocation}/anyOf`;
        const errorsLength = errors.length;
        let anyValid = false;
        for(let i = 0; i < $anyOf.length; i++){
            const subSchema = $anyOf[i];
            const subEvaluated = Object.create(evaluated);
            const result = validate(instance, subSchema, draft, lookup, shortCircuit, $recursiveAnchor === true ? recursiveAnchor : null, instanceLocation, `${keywordLocation}/${i}`, subEvaluated);
            errors.push(...result.errors);
            anyValid = anyValid || result.valid;
            if (result.valid) subEvaluateds.push(subEvaluated);
        }
        if (anyValid) errors.length = errorsLength;
        else errors.splice(errorsLength, 0, {
            instanceLocation,
            keyword: "anyOf",
            keywordLocation,
            error: "Instance does not match any subschemas."
        });
    }
    if ($allOf !== undefined) {
        const keywordLocation = `${schemaLocation}/allOf`;
        const errorsLength = errors.length;
        let allValid = true;
        for(let i = 0; i < $allOf.length; i++){
            const subSchema = $allOf[i];
            const subEvaluated = Object.create(evaluated);
            const result = validate(instance, subSchema, draft, lookup, shortCircuit, $recursiveAnchor === true ? recursiveAnchor : null, instanceLocation, `${keywordLocation}/${i}`, subEvaluated);
            errors.push(...result.errors);
            allValid = allValid && result.valid;
            if (result.valid) subEvaluateds.push(subEvaluated);
        }
        if (allValid) errors.length = errorsLength;
        else errors.splice(errorsLength, 0, {
            instanceLocation,
            keyword: "allOf",
            keywordLocation,
            error: `Instance does not match every subschema.`
        });
    }
    if ($oneOf !== undefined) {
        const keywordLocation = `${schemaLocation}/oneOf`;
        const errorsLength = errors.length;
        const matches = $oneOf.filter((subSchema, i)=>{
            const subEvaluated = Object.create(evaluated);
            const result = validate(instance, subSchema, draft, lookup, shortCircuit, $recursiveAnchor === true ? recursiveAnchor : null, instanceLocation, `${keywordLocation}/${i}`, subEvaluated);
            errors.push(...result.errors);
            if (result.valid) subEvaluateds.push(subEvaluated);
            return result.valid;
        }).length;
        if (matches === 1) errors.length = errorsLength;
        else errors.splice(errorsLength, 0, {
            instanceLocation,
            keyword: "oneOf",
            keywordLocation,
            error: `Instance does not match exactly one subschema (${matches} matches).`
        });
    }
    if (instanceType === "object" || instanceType === "array") Object.assign(evaluated, ...subEvaluateds);
    if ($if !== undefined) {
        const keywordLocation = `${schemaLocation}/if`;
        const conditionResult = validate(instance, $if, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, keywordLocation, evaluated).valid;
        if (conditionResult) {
            if ($then !== undefined) {
                const thenResult = validate(instance, $then, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${schemaLocation}/then`, evaluated);
                if (!thenResult.valid) errors.push({
                    instanceLocation,
                    keyword: "if",
                    keywordLocation,
                    error: `Instance does not match "then" schema.`
                }, ...thenResult.errors);
            }
        } else if ($else !== undefined) {
            const elseResult = validate(instance, $else, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${schemaLocation}/else`, evaluated);
            if (!elseResult.valid) errors.push({
                instanceLocation,
                keyword: "if",
                keywordLocation,
                error: `Instance does not match "else" schema.`
            }, ...elseResult.errors);
        }
    }
    if (instanceType === "object") {
        if ($required !== undefined) {
            for (const key of $required)if (!(key in instance)) errors.push({
                instanceLocation,
                keyword: "required",
                keywordLocation: `${schemaLocation}/required`,
                error: `Instance does not have required property "${key}".`
            });
        }
        const keys = Object.keys(instance);
        if ($minProperties !== undefined && keys.length < $minProperties) errors.push({
            instanceLocation,
            keyword: "minProperties",
            keywordLocation: `${schemaLocation}/minProperties`,
            error: `Instance does not have at least ${$minProperties} properties.`
        });
        if ($maxProperties !== undefined && keys.length > $maxProperties) errors.push({
            instanceLocation,
            keyword: "maxProperties",
            keywordLocation: `${schemaLocation}/maxProperties`,
            error: `Instance does not have at least ${$maxProperties} properties.`
        });
        if ($propertyNames !== undefined) {
            const keywordLocation = `${schemaLocation}/propertyNames`;
            for(const key in instance){
                const subInstancePointer = `${instanceLocation}/${(0, _pointerJs.encodePointer)(key)}`;
                const result = validate(key, $propertyNames, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, keywordLocation);
                if (!result.valid) errors.push({
                    instanceLocation,
                    keyword: "propertyNames",
                    keywordLocation,
                    error: `Property name "${key}" does not match schema.`
                }, ...result.errors);
            }
        }
        if ($dependentRequired !== undefined) {
            const keywordLocation = `${schemaLocation}/dependantRequired`;
            for(const key in $dependentRequired)if (key in instance) {
                const required = $dependentRequired[key];
                for (const dependantKey of required)if (!(dependantKey in instance)) errors.push({
                    instanceLocation,
                    keyword: "dependentRequired",
                    keywordLocation,
                    error: `Instance has "${key}" but does not have "${dependantKey}".`
                });
            }
        }
        if ($dependentSchemas !== undefined) for(const key in $dependentSchemas){
            const keywordLocation = `${schemaLocation}/dependentSchemas`;
            if (key in instance) {
                const result = validate(instance, $dependentSchemas[key], draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${keywordLocation}/${(0, _pointerJs.encodePointer)(key)}`, evaluated);
                if (!result.valid) errors.push({
                    instanceLocation,
                    keyword: "dependentSchemas",
                    keywordLocation,
                    error: `Instance has "${key}" but does not match dependant schema.`
                }, ...result.errors);
            }
        }
        if ($dependencies !== undefined) {
            const keywordLocation = `${schemaLocation}/dependencies`;
            for(const key in $dependencies)if (key in instance) {
                const propsOrSchema = $dependencies[key];
                if (Array.isArray(propsOrSchema)) {
                    for (const dependantKey of propsOrSchema)if (!(dependantKey in instance)) errors.push({
                        instanceLocation,
                        keyword: "dependencies",
                        keywordLocation,
                        error: `Instance has "${key}" but does not have "${dependantKey}".`
                    });
                } else {
                    const result = validate(instance, propsOrSchema, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${keywordLocation}/${(0, _pointerJs.encodePointer)(key)}`);
                    if (!result.valid) errors.push({
                        instanceLocation,
                        keyword: "dependencies",
                        keywordLocation,
                        error: `Instance has "${key}" but does not match dependant schema.`
                    }, ...result.errors);
                }
            }
        }
        const thisEvaluated = Object.create(null);
        let stop = false;
        if ($properties !== undefined) {
            const keywordLocation = `${schemaLocation}/properties`;
            for(const key in $properties){
                if (!(key in instance)) continue;
                const subInstancePointer = `${instanceLocation}/${(0, _pointerJs.encodePointer)(key)}`;
                const result = validate(instance[key], $properties[key], draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, `${keywordLocation}/${(0, _pointerJs.encodePointer)(key)}`);
                if (result.valid) evaluated[key] = thisEvaluated[key] = true;
                else {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation,
                        keyword: "properties",
                        keywordLocation,
                        error: `Property "${key}" does not match schema.`
                    }, ...result.errors);
                    if (stop) break;
                }
            }
        }
        if (!stop && $patternProperties !== undefined) {
            const keywordLocation = `${schemaLocation}/patternProperties`;
            for(const pattern in $patternProperties){
                const regex = new RegExp(pattern);
                const subSchema = $patternProperties[pattern];
                for(const key in instance){
                    if (!regex.test(key)) continue;
                    const subInstancePointer = `${instanceLocation}/${(0, _pointerJs.encodePointer)(key)}`;
                    const result = validate(instance[key], subSchema, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, `${keywordLocation}/${(0, _pointerJs.encodePointer)(pattern)}`);
                    if (result.valid) evaluated[key] = thisEvaluated[key] = true;
                    else {
                        stop = shortCircuit;
                        errors.push({
                            instanceLocation,
                            keyword: "patternProperties",
                            keywordLocation,
                            error: `Property "${key}" matches pattern "${pattern}" but does not match associated schema.`
                        }, ...result.errors);
                    }
                }
            }
        }
        if (!stop && $additionalProperties !== undefined) {
            const keywordLocation = `${schemaLocation}/additionalProperties`;
            for(const key in instance){
                if (thisEvaluated[key]) continue;
                const subInstancePointer = `${instanceLocation}/${(0, _pointerJs.encodePointer)(key)}`;
                const result = validate(instance[key], $additionalProperties, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, keywordLocation);
                if (result.valid) evaluated[key] = true;
                else {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation,
                        keyword: "additionalProperties",
                        keywordLocation,
                        error: `Property "${key}" does not match additional properties schema.`
                    }, ...result.errors);
                }
            }
        } else if (!stop && $unevaluatedProperties !== undefined) {
            const keywordLocation = `${schemaLocation}/unevaluatedProperties`;
            for(const key in instance)if (!evaluated[key]) {
                const subInstancePointer = `${instanceLocation}/${(0, _pointerJs.encodePointer)(key)}`;
                const result = validate(instance[key], $unevaluatedProperties, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, keywordLocation);
                if (result.valid) evaluated[key] = true;
                else errors.push({
                    instanceLocation,
                    keyword: "unevaluatedProperties",
                    keywordLocation,
                    error: `Property "${key}" does not match unevaluated properties schema.`
                }, ...result.errors);
            }
        }
    } else if (instanceType === "array") {
        if ($maxItems !== undefined && instance.length > $maxItems) errors.push({
            instanceLocation,
            keyword: "maxItems",
            keywordLocation: `${schemaLocation}/maxItems`,
            error: `Array has too many items (${instance.length} > ${$maxItems}).`
        });
        if ($minItems !== undefined && instance.length < $minItems) errors.push({
            instanceLocation,
            keyword: "minItems",
            keywordLocation: `${schemaLocation}/minItems`,
            error: `Array has too few items (${instance.length} < ${$minItems}).`
        });
        const length = instance.length;
        let i = 0;
        let stop = false;
        if ($prefixItems !== undefined) {
            const keywordLocation = `${schemaLocation}/prefixItems`;
            const length2 = Math.min($prefixItems.length, length);
            for(; i < length2; i++){
                const result = validate(instance[i], $prefixItems[i], draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, `${keywordLocation}/${i}`);
                evaluated[i] = true;
                if (!result.valid) {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation,
                        keyword: "prefixItems",
                        keywordLocation,
                        error: `Items did not match schema.`
                    }, ...result.errors);
                    if (stop) break;
                }
            }
        }
        if ($items !== undefined) {
            const keywordLocation = `${schemaLocation}/items`;
            if (Array.isArray($items)) {
                const length2 = Math.min($items.length, length);
                for(; i < length2; i++){
                    const result = validate(instance[i], $items[i], draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, `${keywordLocation}/${i}`);
                    evaluated[i] = true;
                    if (!result.valid) {
                        stop = shortCircuit;
                        errors.push({
                            instanceLocation,
                            keyword: "items",
                            keywordLocation,
                            error: `Items did not match schema.`
                        }, ...result.errors);
                        if (stop) break;
                    }
                }
            } else for(; i < length; i++){
                const result = validate(instance[i], $items, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, keywordLocation);
                evaluated[i] = true;
                if (!result.valid) {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation,
                        keyword: "items",
                        keywordLocation,
                        error: `Items did not match schema.`
                    }, ...result.errors);
                    if (stop) break;
                }
            }
            if (!stop && $additionalItems !== undefined) {
                const keywordLocation = `${schemaLocation}/additionalItems`;
                for(; i < length; i++){
                    const result = validate(instance[i], $additionalItems, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, keywordLocation);
                    evaluated[i] = true;
                    if (!result.valid) {
                        stop = shortCircuit;
                        errors.push({
                            instanceLocation,
                            keyword: "additionalItems",
                            keywordLocation,
                            error: `Items did not match additional items schema.`
                        }, ...result.errors);
                    }
                }
            }
        }
        if ($contains !== undefined) {
            if (length === 0 && $minContains === undefined) errors.push({
                instanceLocation,
                keyword: "contains",
                keywordLocation: `${schemaLocation}/contains`,
                error: `Array is empty. It must contain at least one item matching the schema.`
            });
            else if ($minContains !== undefined && length < $minContains) errors.push({
                instanceLocation,
                keyword: "minContains",
                keywordLocation: `${schemaLocation}/minContains`,
                error: `Array has less items (${length}) than minContains (${$minContains}).`
            });
            else {
                const keywordLocation = `${schemaLocation}/contains`;
                const errorsLength = errors.length;
                let contained = 0;
                for(let j = 0; j < length; j++){
                    const result = validate(instance[j], $contains, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${j}`, keywordLocation);
                    if (result.valid) {
                        evaluated[j] = true;
                        contained++;
                    } else errors.push(...result.errors);
                }
                if (contained >= ($minContains || 0)) errors.length = errorsLength;
                if ($minContains === undefined && $maxContains === undefined && contained === 0) errors.splice(errorsLength, 0, {
                    instanceLocation,
                    keyword: "contains",
                    keywordLocation,
                    error: `Array does not contain item matching schema.`
                });
                else if ($minContains !== undefined && contained < $minContains) errors.push({
                    instanceLocation,
                    keyword: "minContains",
                    keywordLocation: `${schemaLocation}/minContains`,
                    error: `Array must contain at least ${$minContains} items matching schema. Only ${contained} items were found.`
                });
                else if ($maxContains !== undefined && contained > $maxContains) errors.push({
                    instanceLocation,
                    keyword: "maxContains",
                    keywordLocation: `${schemaLocation}/maxContains`,
                    error: `Array may contain at most ${$maxContains} items matching schema. ${contained} items were found.`
                });
            }
        }
        if (!stop && $unevaluatedItems !== undefined) {
            const keywordLocation = `${schemaLocation}/unevaluatedItems`;
            for(i; i < length; i++){
                if (evaluated[i]) continue;
                const result = validate(instance[i], $unevaluatedItems, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, keywordLocation);
                evaluated[i] = true;
                if (!result.valid) errors.push({
                    instanceLocation,
                    keyword: "unevaluatedItems",
                    keywordLocation,
                    error: `Items did not match unevaluated items schema.`
                }, ...result.errors);
            }
        }
        if ($uniqueItems) for(let j = 0; j < length; j++){
            const a = instance[j];
            const ao = typeof a === "object" && a !== null;
            for(let k = 0; k < length; k++){
                if (j === k) continue;
                const b = instance[k];
                const bo = typeof b === "object" && b !== null;
                if (a === b || ao && bo && (0, _deepCompareStrictJs.deepCompareStrict)(a, b)) {
                    errors.push({
                        instanceLocation,
                        keyword: "uniqueItems",
                        keywordLocation: `${schemaLocation}/uniqueItems`,
                        error: `Duplicate items at indexes ${j} and ${k}.`
                    });
                    j = Number.MAX_SAFE_INTEGER;
                    k = Number.MAX_SAFE_INTEGER;
                }
            }
        }
    } else if (instanceType === "number") {
        if (draft === "4") {
            if ($minimum !== undefined && ($exclusiveMinimum === true && instance <= $minimum || instance < $minimum)) errors.push({
                instanceLocation,
                keyword: "minimum",
                keywordLocation: `${schemaLocation}/minimum`,
                error: `${instance} is less than ${$exclusiveMinimum ? "or equal to " : ""} ${$minimum}.`
            });
            if ($maximum !== undefined && ($exclusiveMaximum === true && instance >= $maximum || instance > $maximum)) errors.push({
                instanceLocation,
                keyword: "maximum",
                keywordLocation: `${schemaLocation}/maximum`,
                error: `${instance} is greater than ${$exclusiveMaximum ? "or equal to " : ""} ${$maximum}.`
            });
        } else {
            if ($minimum !== undefined && instance < $minimum) errors.push({
                instanceLocation,
                keyword: "minimum",
                keywordLocation: `${schemaLocation}/minimum`,
                error: `${instance} is less than ${$minimum}.`
            });
            if ($maximum !== undefined && instance > $maximum) errors.push({
                instanceLocation,
                keyword: "maximum",
                keywordLocation: `${schemaLocation}/maximum`,
                error: `${instance} is greater than ${$maximum}.`
            });
            if ($exclusiveMinimum !== undefined && instance <= $exclusiveMinimum) errors.push({
                instanceLocation,
                keyword: "exclusiveMinimum",
                keywordLocation: `${schemaLocation}/exclusiveMinimum`,
                error: `${instance} is less than ${$exclusiveMinimum}.`
            });
            if ($exclusiveMaximum !== undefined && instance >= $exclusiveMaximum) errors.push({
                instanceLocation,
                keyword: "exclusiveMaximum",
                keywordLocation: `${schemaLocation}/exclusiveMaximum`,
                error: `${instance} is greater than or equal to ${$exclusiveMaximum}.`
            });
        }
        if ($multipleOf !== undefined) {
            const remainder = instance % $multipleOf;
            if (Math.abs(0 - remainder) >= 1.1920929e-7 && Math.abs($multipleOf - remainder) >= 1.1920929e-7) errors.push({
                instanceLocation,
                keyword: "multipleOf",
                keywordLocation: `${schemaLocation}/multipleOf`,
                error: `${instance} is not a multiple of ${$multipleOf}.`
            });
        }
    } else if (instanceType === "string") {
        const length = $minLength === undefined && $maxLength === undefined ? 0 : (0, _ucs2LengthJs.ucs2length)(instance);
        if ($minLength !== undefined && length < $minLength) errors.push({
            instanceLocation,
            keyword: "minLength",
            keywordLocation: `${schemaLocation}/minLength`,
            error: `String is too short (${length} < ${$minLength}).`
        });
        if ($maxLength !== undefined && length > $maxLength) errors.push({
            instanceLocation,
            keyword: "maxLength",
            keywordLocation: `${schemaLocation}/maxLength`,
            error: `String is too long (${length} > ${$maxLength}).`
        });
        if ($pattern !== undefined && !new RegExp($pattern).test(instance)) errors.push({
            instanceLocation,
            keyword: "pattern",
            keywordLocation: `${schemaLocation}/pattern`,
            error: `String does not match pattern.`
        });
        if ($format !== undefined && (0, _formatJs.fastFormat)[$format] && !(0, _formatJs.fastFormat)[$format](instance)) errors.push({
            instanceLocation,
            keyword: "format",
            keywordLocation: `${schemaLocation}/format`,
            error: `String does not match format "${$format}".`
        });
    }
    return {
        valid: errors.length === 0,
        errors
    };
}

},{"./deep-compare-strict.js":"cjMKm","./dereference.js":"6wOof","./format.js":"aAiu1","./pointer.js":"fxWMF","./ucs2-length.js":"euReT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"51UEF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Validator", ()=>Validator);
var _dereferenceJs = require("./dereference.js");
var _validateJs = require("./validate.js");
class Validator {
    constructor(schema, draft = "2019-09", shortCircuit = true){
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: schema
        });
        Object.defineProperty(this, "draft", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: draft
        });
        Object.defineProperty(this, "shortCircuit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: shortCircuit
        });
        Object.defineProperty(this, "lookup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.lookup = (0, _dereferenceJs.dereference)(schema);
    }
    validate(instance) {
        return (0, _validateJs.validate)(instance, this.schema, this.draft, this.lookup, this.shortCircuit);
    }
    addSchema(schema, id) {
        if (id) schema = {
            ...schema,
            $id: id
        };
        (0, _dereferenceJs.dereference)(schema, this.lookup);
    }
}

},{"./dereference.js":"6wOof","./validate.js":"cnppB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6rmQk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Class to parse the output of an LLM call to a list.
 * @augments BaseOutputParser
 */ parcelHelpers.export(exports, "ListOutputParser", ()=>ListOutputParser);
/**
 * Class to parse the output of an LLM call as a comma-separated list.
 * @augments ListOutputParser
 */ parcelHelpers.export(exports, "CommaSeparatedListOutputParser", ()=>CommaSeparatedListOutputParser);
/**
 * Class to parse the output of an LLM call to a list with a specific length and separator.
 * @augments ListOutputParser
 */ parcelHelpers.export(exports, "CustomListOutputParser", ()=>CustomListOutputParser);
parcelHelpers.export(exports, "NumberedListOutputParser", ()=>NumberedListOutputParser);
parcelHelpers.export(exports, "MarkdownListOutputParser", ()=>MarkdownListOutputParser);
var _baseJs = require("./base.js");
var _transformJs = require("./transform.js");
class ListOutputParser extends (0, _transformJs.BaseTransformOutputParser) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "re", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    async *_transform(inputGenerator) {
        let buffer = "";
        for await (const input of inputGenerator){
            if (typeof input === "string") // add current chunk to buffer
            buffer += input;
            else // extract message content and add to buffer
            buffer += input.content;
            // get parts in buffer
            if (!this.re) {
                const parts = await this.parse(buffer);
                if (parts.length > 1) {
                    // if there are multiple parts, yield all but the last one
                    for (const part of parts.slice(0, -1))yield [
                        part
                    ];
                    // keep the last part in the buffer
                    buffer = parts[parts.length - 1];
                }
            } else {
                // if there is a regex, get all matches
                const matches = [
                    ...buffer.matchAll(this.re)
                ];
                if (matches.length > 1) {
                    let doneIdx = 0;
                    // if there are multiple matches, yield all but the last one
                    for (const match of matches.slice(0, -1)){
                        yield [
                            match[1]
                        ];
                        doneIdx += (match.index ?? 0) + match[0].length;
                    }
                    // keep the last match in the buffer
                    buffer = buffer.slice(doneIdx);
                }
            }
        }
        // yield the last part
        for (const part of (await this.parse(buffer)))yield [
            part
        ];
    }
}
class CommaSeparatedListOutputParser extends ListOutputParser {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "output_parsers",
                "list"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
    }
    static lc_name() {
        return "CommaSeparatedListOutputParser";
    }
    /**
     * Parses the given text into an array of strings, using a comma as the
     * separator. If the parsing fails, throws an OutputParserException.
     * @param text The text to parse.
     * @returns An array of strings obtained by splitting the input text at each comma.
     */ async parse(text) {
        try {
            return text.trim().split(",").map((s)=>s.trim());
        } catch (e) {
            throw new (0, _baseJs.OutputParserException)(`Could not parse output: ${text}`, text);
        }
    }
    /**
     * Provides instructions on the expected format of the response for the
     * CommaSeparatedListOutputParser.
     * @returns A string containing instructions on the expected format of the response.
     */ getFormatInstructions() {
        return `Your response should be a list of comma separated values, eg: \`foo, bar, baz\``;
    }
}
class CustomListOutputParser extends ListOutputParser {
    constructor({ length, separator }){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "output_parsers",
                "list"
            ]
        });
        Object.defineProperty(this, "length", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "separator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.length = length;
        this.separator = separator || ",";
    }
    /**
     * Parses the given text into an array of strings, using the specified
     * separator. If the parsing fails or the number of items in the list
     * doesn't match the expected length, throws an OutputParserException.
     * @param text The text to parse.
     * @returns An array of strings obtained by splitting the input text at each occurrence of the specified separator.
     */ async parse(text) {
        try {
            const items = text.trim().split(this.separator).map((s)=>s.trim());
            if (this.length !== undefined && items.length !== this.length) throw new (0, _baseJs.OutputParserException)(`Incorrect number of items. Expected ${this.length}, got ${items.length}.`);
            return items;
        } catch (e) {
            if (Object.getPrototypeOf(e) === (0, _baseJs.OutputParserException).prototype) throw e;
            throw new (0, _baseJs.OutputParserException)(`Could not parse output: ${text}`);
        }
    }
    /**
     * Provides instructions on the expected format of the response for the
     * CustomListOutputParser, including the number of items and the
     * separator.
     * @returns A string containing instructions on the expected format of the response.
     */ getFormatInstructions() {
        return `Your response should be a list of ${this.length === undefined ? "" : `${this.length} `}items separated by "${this.separator}" (eg: \`foo${this.separator} bar${this.separator} baz\`)`;
    }
}
class NumberedListOutputParser extends ListOutputParser {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "output_parsers",
                "list"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "re", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: /\d+\.\s([^\n]+)/g
        });
    }
    static lc_name() {
        return "NumberedListOutputParser";
    }
    getFormatInstructions() {
        return `Your response should be a numbered list with each item on a new line. For example: \n\n1. foo\n\n2. bar\n\n3. baz`;
    }
    async parse(text) {
        return [
            ...text.matchAll(this.re) ?? []
        ].map((m)=>m[1]);
    }
}
class MarkdownListOutputParser extends ListOutputParser {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "output_parsers",
                "list"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "re", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: /^\s*[-*]\s([^\n]+)$/gm
        });
    }
    static lc_name() {
        return "NumberedListOutputParser";
    }
    getFormatInstructions() {
        return `Your response should be a numbered list with each item on a new line. For example: \n\n1. foo\n\n2. bar\n\n3. baz`;
    }
    async parse(text) {
        return [
            ...text.matchAll(this.re) ?? []
        ].map((m)=>m[1]);
    }
}

},{"./base.js":"lJpNd","./transform.js":"4lsjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Pjk5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * OutputParser that parses LLMResult into the top likely string.
 * @example
 * ```typescript
 * const promptTemplate = PromptTemplate.fromTemplate(
 *   "Tell me a joke about {topic}",
 * );
 *
 * const chain = RunnableSequence.from([
 *   promptTemplate,
 *   new ChatOpenAI({}),
 *   new StringOutputParser(),
 * ]);
 *
 * const result = await chain.invoke({ topic: "bears" });
 * console.log("What do you call a bear with no teeth? A gummy bear!");
 * ```
 */ parcelHelpers.export(exports, "StringOutputParser", ()=>StringOutputParser);
var _transformJs = require("./transform.js");
class StringOutputParser extends (0, _transformJs.BaseTransformOutputParser) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "output_parsers",
                "string"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
    }
    static lc_name() {
        return "StrOutputParser";
    }
    /**
     * Parses a string output from an LLM call. This method is meant to be
     * implemented by subclasses to define how a string output from an LLM
     * should be parsed.
     * @param text The string output from an LLM call.
     * @param callbacks Optional callbacks.
     * @returns A promise of the parsed output.
     */ parse(text) {
        return Promise.resolve(text);
    }
    getFormatInstructions() {
        return "";
    }
    _textContentToString(content) {
        return content.text;
    }
    _imageUrlContentToString(_content) {
        throw new Error(`Cannot coerce a multimodal "image_url" message part into a string.`);
    }
    _messageContentComplexToString(content) {
        switch(content.type){
            case "text":
            case "text_delta":
                if ("text" in content) // Type guard for MessageContentText
                return this._textContentToString(content);
                break;
            case "image_url":
                if ("image_url" in content) // Type guard for MessageContentImageUrl
                return this._imageUrlContentToString(content);
                break;
            default:
                throw new Error(`Cannot coerce "${content.type}" message part into a string.`);
        }
        throw new Error(`Invalid content type: ${content.type}`);
    }
    _baseMessageContentToString(content) {
        return content.reduce((acc, item)=>acc + this._messageContentComplexToString(item), "");
    }
}

},{"./transform.js":"4lsjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"keAXg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StructuredOutputParser", ()=>StructuredOutputParser);
/**
 * A specific type of `StructuredOutputParser` that parses JSON data
 * formatted as a markdown code snippet.
 */ parcelHelpers.export(exports, "JsonMarkdownStructuredOutputParser", ()=>JsonMarkdownStructuredOutputParser);
/**
 * A type of `StructuredOutputParser` that handles asymmetric input and
 * output schemas.
 */ parcelHelpers.export(exports, "AsymmetricStructuredOutputParser", ()=>AsymmetricStructuredOutputParser);
var _zod = require("zod");
var _zodToJsonSchema = require("zod-to-json-schema");
var _baseJs = require("./base.js");
class StructuredOutputParser extends (0, _baseJs.BaseOutputParser) {
    static lc_name() {
        return "StructuredOutputParser";
    }
    toJSON() {
        return this.toJSONNotImplemented();
    }
    constructor(schema){
        super(schema);
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: schema
        });
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain",
                "output_parsers",
                "structured"
            ]
        });
    }
    /**
     * Creates a new StructuredOutputParser from a Zod schema.
     * @param schema The Zod schema which the output should match
     * @returns A new instance of StructuredOutputParser.
     */ static fromZodSchema(schema) {
        return new this(schema);
    }
    /**
     * Creates a new StructuredOutputParser from a set of names and
     * descriptions.
     * @param schemas An object where each key is a name and each value is a description
     * @returns A new instance of StructuredOutputParser.
     */ static fromNamesAndDescriptions(schemas) {
        const zodSchema = (0, _zod.z).object(Object.fromEntries(Object.entries(schemas).map(([name, description])=>[
                name,
                (0, _zod.z).string().describe(description)
            ])));
        return new this(zodSchema);
    }
    /**
     * Returns a markdown code snippet with a JSON object formatted according
     * to the schema.
     * @param options Optional. The options for formatting the instructions
     * @returns A markdown code snippet with a JSON object formatted according to the schema.
     */ getFormatInstructions() {
        return `You must format your output as a JSON value that adheres to a given "JSON Schema" instance.

"JSON Schema" is a declarative language that allows you to annotate and validate JSON documents.

For example, the example "JSON Schema" instance {{"properties": {{"foo": {{"description": "a list of test words", "type": "array", "items": {{"type": "string"}}}}}}, "required": ["foo"]}}}}
would match an object with one required property, "foo". The "type" property specifies "foo" must be an "array", and the "description" property semantically describes it as "a list of test words". The items within "foo" must be strings.
Thus, the object {{"foo": ["bar", "baz"]}} is a well-formatted instance of this example "JSON Schema". The object {{"properties": {{"foo": ["bar", "baz"]}}}} is not well-formatted.

Your output will be parsed and type-checked according to the provided schema instance, so make sure all fields in your output match the schema exactly and there are no trailing commas!

Here is the JSON Schema instance your output must adhere to. Include the enclosing markdown codeblock:
\`\`\`json
${JSON.stringify((0, _zodToJsonSchema.zodToJsonSchema)(this.schema))}
\`\`\`
`;
    }
    /**
     * Parses the given text according to the schema.
     * @param text The text to parse
     * @returns The parsed output.
     */ async parse(text) {
        try {
            const json = text.includes("```") ? text.trim().split(/```(?:json)?/)[1] : text.trim();
            const escapedJson = json.replace(/"([^"\\]*(\\.[^"\\]*)*)"/g, (_match, capturedGroup)=>{
                const escapedInsideQuotes = capturedGroup.replace(/\n/g, "\\n");
                return `"${escapedInsideQuotes}"`;
            }).replace(/\n/g, "");
            return await this.schema.parseAsync(JSON.parse(escapedJson));
        } catch (e) {
            throw new (0, _baseJs.OutputParserException)(`Failed to parse. Text: "${text}". Error: ${e}`, text);
        }
    }
}
class JsonMarkdownStructuredOutputParser extends StructuredOutputParser {
    static lc_name() {
        return "JsonMarkdownStructuredOutputParser";
    }
    getFormatInstructions(options) {
        const interpolationDepth = options?.interpolationDepth ?? 1;
        if (interpolationDepth < 1) throw new Error("f string interpolation depth must be at least 1");
        return `Return a markdown code snippet with a JSON object formatted to look like:\n\`\`\`json\n${this._schemaToInstruction((0, _zodToJsonSchema.zodToJsonSchema)(this.schema)).replaceAll("{", "{".repeat(interpolationDepth)).replaceAll("}", "}".repeat(interpolationDepth))}\n\`\`\``;
    }
    _schemaToInstruction(schemaInput, indent = 2) {
        const schema = schemaInput;
        if ("type" in schema) {
            let nullable = false;
            let type;
            if (Array.isArray(schema.type)) {
                const nullIdx = schema.type.findIndex((type)=>type === "null");
                if (nullIdx !== -1) {
                    nullable = true;
                    schema.type.splice(nullIdx, 1);
                }
                type = schema.type.join(" | ");
            } else type = schema.type;
            if (schema.type === "object" && schema.properties) {
                const description = schema.description ? ` // ${schema.description}` : "";
                const properties = Object.entries(schema.properties).map(([key, value])=>{
                    const isOptional = schema.required?.includes(key) ? "" : " (optional)";
                    return `${" ".repeat(indent)}"${key}": ${this._schemaToInstruction(value, indent + 2)}${isOptional}`;
                }).join("\n");
                return `{\n${properties}\n${" ".repeat(indent - 2)}}${description}`;
            }
            if (schema.type === "array" && schema.items) {
                const description = schema.description ? ` // ${schema.description}` : "";
                return `array[\n${" ".repeat(indent)}${this._schemaToInstruction(schema.items, indent + 2)}\n${" ".repeat(indent - 2)}] ${description}`;
            }
            const isNullable = nullable ? " (nullable)" : "";
            const description = schema.description ? ` // ${schema.description}` : "";
            return `${type}${description}${isNullable}`;
        }
        if ("anyOf" in schema) return schema.anyOf.map((s)=>this._schemaToInstruction(s, indent)).join(`\n${" ".repeat(indent - 2)}`);
        throw new Error("unsupported schema type");
    }
    static fromZodSchema(schema) {
        return new this(schema);
    }
    static fromNamesAndDescriptions(schemas) {
        const zodSchema = (0, _zod.z).object(Object.fromEntries(Object.entries(schemas).map(([name, description])=>[
                name,
                (0, _zod.z).string().describe(description)
            ])));
        return new this(zodSchema);
    }
}
class AsymmetricStructuredOutputParser extends (0, _baseJs.BaseOutputParser) {
    constructor({ inputSchema }){
        super(...arguments);
        Object.defineProperty(this, "structuredInputParser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.structuredInputParser = new JsonMarkdownStructuredOutputParser(inputSchema);
    }
    async parse(text) {
        let parsedInput;
        try {
            parsedInput = await this.structuredInputParser.parse(text);
        } catch (e) {
            throw new (0, _baseJs.OutputParserException)(`Failed to parse. Text: "${text}". Error: ${e}`, text);
        }
        return this.outputProcessor(parsedInput);
    }
    getFormatInstructions() {
        return this.structuredInputParser.getFormatInstructions();
    }
}

},{"zod":"juM82","zod-to-json-schema":"3TbOj","./base.js":"lJpNd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Q14p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Class for parsing the output of an LLM into a JSON object.
 */ parcelHelpers.export(exports, "JsonOutputParser", ()=>JsonOutputParser);
parcelHelpers.export(exports, "parsePartialJson", ()=>(0, _jsonJs.parsePartialJson));
parcelHelpers.export(exports, "parseJsonMarkdown", ()=>(0, _jsonJs.parseJsonMarkdown));
var _transformJs = require("./transform.js");
var _jsonPatchJs = require("../utils/json_patch.js");
var _jsonJs = require("../utils/json.js");
class JsonOutputParser extends (0, _transformJs.BaseCumulativeTransformOutputParser) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "output_parsers"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
    }
    static lc_name() {
        return "JsonOutputParser";
    }
    _diff(prev, next) {
        if (!next) return undefined;
        if (!prev) return [
            {
                op: "replace",
                path: "",
                value: next
            }
        ];
        return (0, _jsonPatchJs.compare)(prev, next);
    }
    // This should actually return Partial<T>, but there's no way
    // to specify emitted chunks as instances separate from the main output type.
    async parsePartialResult(generations) {
        return (0, _jsonJs.parseJsonMarkdown)(generations[0].text);
    }
    async parse(text) {
        return (0, _jsonJs.parseJsonMarkdown)(text, JSON.parse);
    }
    getFormatInstructions() {
        return "";
    }
}

},{"./transform.js":"4lsjz","../utils/json_patch.js":"aSci2","../utils/json.js":"3dcBo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aSci2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compare", ()=>(0, _indexJs.compare));
parcelHelpers.export(exports, "applyPatch", ()=>(0, _indexJs.applyPatch));
var _indexJs = require("./fast-json-patch/index.js");

},{"./fast-json-patch/index.js":"3yqxp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lp3DS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XML_FORMAT_INSTRUCTIONS", ()=>XML_FORMAT_INSTRUCTIONS);
parcelHelpers.export(exports, "XMLOutputParser", ()=>XMLOutputParser);
parcelHelpers.export(exports, "parseXMLMarkdown", ()=>parseXMLMarkdown);
var _transformJs = require("./transform.js");
var _jsonPatchJs = require("../utils/json_patch.js");
var _saxJs = require("../utils/sax-js/sax.js");
const XML_FORMAT_INSTRUCTIONS = `The output should be formatted as a XML file.
1. Output should conform to the tags below. 
2. If tags are not given, make them on your own.
3. Remember to always open and close all the tags.

As an example, for the tags ["foo", "bar", "baz"]:
1. String "<foo>\n   <bar>\n      <baz></baz>\n   </bar>\n</foo>" is a well-formatted instance of the schema. 
2. String "<foo>\n   <bar>\n   </foo>" is a badly-formatted instance.
3. String "<foo>\n   <tag>\n   </tag>\n</foo>" is a badly-formatted instance.

Here are the output tags:
\`\`\`
{tags}
\`\`\``;
class XMLOutputParser extends (0, _transformJs.BaseCumulativeTransformOutputParser) {
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "tags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "output_parsers"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        this.tags = fields?.tags;
    }
    static lc_name() {
        return "XMLOutputParser";
    }
    _diff(prev, next) {
        if (!next) return undefined;
        if (!prev) return [
            {
                op: "replace",
                path: "",
                value: next
            }
        ];
        return (0, _jsonPatchJs.compare)(prev, next);
    }
    async parsePartialResult(generations) {
        return parseXMLMarkdown(generations[0].text);
    }
    async parse(text) {
        return parseXMLMarkdown(text);
    }
    getFormatInstructions() {
        const withTags = !!(this.tags && this.tags.length > 0);
        return withTags ? XML_FORMAT_INSTRUCTIONS.replace("{tags}", this.tags?.join(", ") ?? "") : XML_FORMAT_INSTRUCTIONS;
    }
}
const strip = (text)=>text.split("\n").map((line)=>line.replace(/^\s+/, "")).join("\n").trim();
const parseParsedResult = (input)=>{
    if (Object.keys(input).length === 0) return {};
    const result = {};
    if (input.children.length > 0) {
        result[input.name] = input.children.map(parseParsedResult);
        return result;
    } else {
        result[input.name] = input.text ?? undefined;
        return result;
    }
};
function parseXMLMarkdown(s) {
    const cleanedString = strip(s);
    const parser = (0, _saxJs.sax).parser(true);
    let parsedResult = {};
    const elementStack = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parser.onopentag = (node)=>{
        const element = {
            name: node.name,
            attributes: node.attributes,
            children: [],
            text: "",
            isSelfClosing: node.isSelfClosing
        };
        if (elementStack.length > 0) {
            const parentElement = elementStack[elementStack.length - 1];
            parentElement.children.push(element);
        } else parsedResult = element;
        if (!node.isSelfClosing) elementStack.push(element);
    };
    parser.onclosetag = ()=>{
        if (elementStack.length > 0) {
            const lastElement = elementStack.pop();
            if (elementStack.length === 0 && lastElement) parsedResult = lastElement;
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parser.ontext = (text)=>{
        if (elementStack.length > 0) {
            const currentElement = elementStack[elementStack.length - 1];
            currentElement.text += text;
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parser.onattribute = (attr)=>{
        if (elementStack.length > 0) {
            const currentElement = elementStack[elementStack.length - 1];
            currentElement.attributes[attr.name] = attr.value;
        }
    };
    // Try to find XML string within triple backticks.
    const match = /```(xml)?(.*)```/s.exec(cleanedString);
    const xmlString = match ? match[2] : cleanedString;
    parser.write(xmlString).close();
    // Remove the XML declaration if present
    if (parsedResult && parsedResult.name === "?xml") parsedResult = parsedResult.children[0];
    return parseParsedResult(parsedResult);
}

},{"./transform.js":"4lsjz","../utils/json_patch.js":"aSci2","../utils/sax-js/sax.js":"je5gw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"je5gw":[function(require,module,exports,__globalThis) {
// @ts-nocheck
// Inlined to deal with portability issues
// Originally from: https://github.com/isaacs/sax-js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sax", ()=>sax);
const initializeSax = function() {
    const sax = {};
    sax.parser = function(strict, opt) {
        return new SAXParser(strict, opt);
    };
    sax.SAXParser = SAXParser;
    sax.SAXStream = SAXStream;
    sax.createStream = createStream;
    // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
    // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
    // since that's the earliest that a buffer overrun could occur.  This way, checks are
    // as rare as required, but as often as necessary to ensure never crossing this bound.
    // Furthermore, buffers are only tested at most once per write(), so passing a very
    // large string into write() might have undesirable effects, but this is manageable by
    // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
    // edge case, result in creating at most one complete copy of the string passed in.
    // Set to Infinity to have unlimited buffers.
    sax.MAX_BUFFER_LENGTH = 65536;
    const buffers = [
        "comment",
        "sgmlDecl",
        "textNode",
        "tagName",
        "doctype",
        "procInstName",
        "procInstBody",
        "entity",
        "attribName",
        "attribValue",
        "cdata",
        "script"
    ];
    sax.EVENTS = [
        "text",
        "processinginstruction",
        "sgmldeclaration",
        "doctype",
        "comment",
        "opentagstart",
        "attribute",
        "opentag",
        "closetag",
        "opencdata",
        "cdata",
        "closecdata",
        "error",
        "end",
        "ready",
        "script",
        "opennamespace",
        "closenamespace"
    ];
    function SAXParser(strict, opt) {
        if (!(this instanceof SAXParser)) return new SAXParser(strict, opt);
        var parser = this;
        clearBuffers(parser);
        parser.q = parser.c = "";
        parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH;
        parser.opt = opt || {};
        parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
        parser.looseCase = parser.opt.lowercase ? "toLowerCase" : "toUpperCase";
        parser.tags = [];
        parser.closed = parser.closedRoot = parser.sawRoot = false;
        parser.tag = parser.error = null;
        parser.strict = !!strict;
        parser.noscript = !!(strict || parser.opt.noscript);
        parser.state = S.BEGIN;
        parser.strictEntities = parser.opt.strictEntities;
        parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES);
        parser.attribList = [];
        // namespaces form a prototype chain.
        // it always points at the current tag,
        // which protos to its parent tag.
        if (parser.opt.xmlns) parser.ns = Object.create(rootNS);
        // mostly just for error reporting
        parser.trackPosition = parser.opt.position !== false;
        if (parser.trackPosition) parser.position = parser.line = parser.column = 0;
        emit(parser, "onready");
    }
    if (!Object.create) Object.create = function(o) {
        function F() {}
        F.prototype = o;
        var newf = new F();
        return newf;
    };
    if (!Object.keys) Object.keys = function(o) {
        var a = [];
        for(var i in o)if (o.hasOwnProperty(i)) a.push(i);
        return a;
    };
    function checkBufferLength(parser) {
        var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10);
        var maxActual = 0;
        for(var i = 0, l = buffers.length; i < l; i++){
            var len = parser[buffers[i]].length;
            if (len > maxAllowed) // Text/cdata nodes can get big, and since they're buffered,
            // we can get here under normal conditions.
            // Avoid issues by emitting the text node now,
            // so at least it won't get any bigger.
            switch(buffers[i]){
                case "textNode":
                    closeText(parser);
                    break;
                case "cdata":
                    emitNode(parser, "oncdata", parser.cdata);
                    parser.cdata = "";
                    break;
                case "script":
                    emitNode(parser, "onscript", parser.script);
                    parser.script = "";
                    break;
                default:
                    error(parser, "Max buffer length exceeded: " + buffers[i]);
            }
            maxActual = Math.max(maxActual, len);
        }
        // schedule the next check for the earliest possible buffer overrun.
        var m = sax.MAX_BUFFER_LENGTH - maxActual;
        parser.bufferCheckPosition = m + parser.position;
    }
    function clearBuffers(parser) {
        for(var i = 0, l = buffers.length; i < l; i++)parser[buffers[i]] = "";
    }
    function flushBuffers(parser) {
        closeText(parser);
        if (parser.cdata !== "") {
            emitNode(parser, "oncdata", parser.cdata);
            parser.cdata = "";
        }
        if (parser.script !== "") {
            emitNode(parser, "onscript", parser.script);
            parser.script = "";
        }
    }
    SAXParser.prototype = {
        end: function() {
            end(this);
        },
        write: write,
        resume: function() {
            this.error = null;
            return this;
        },
        close: function() {
            return this.write(null);
        },
        flush: function() {
            flushBuffers(this);
        }
    };
    var Stream = ReadableStream;
    if (!Stream) Stream = function() {};
    var streamWraps = sax.EVENTS.filter(function(ev) {
        return ev !== "error" && ev !== "end";
    });
    function createStream(strict, opt) {
        return new SAXStream(strict, opt);
    }
    function SAXStream(strict, opt) {
        if (!(this instanceof SAXStream)) return new SAXStream(strict, opt);
        Stream.apply(this);
        this._parser = new SAXParser(strict, opt);
        this.writable = true;
        this.readable = true;
        var me = this;
        this._parser.onend = function() {
            me.emit("end");
        };
        this._parser.onerror = function(er) {
            me.emit("error", er);
            // if didn't throw, then means error was handled.
            // go ahead and clear error, so we can write again.
            me._parser.error = null;
        };
        this._decoder = null;
        streamWraps.forEach(function(ev) {
            Object.defineProperty(me, "on" + ev, {
                get: function() {
                    return me._parser["on" + ev];
                },
                set: function(h) {
                    if (!h) {
                        me.removeAllListeners(ev);
                        me._parser["on" + ev] = h;
                        return h;
                    }
                    me.on(ev, h);
                },
                enumerable: true,
                configurable: false
            });
        });
    }
    SAXStream.prototype = Object.create(Stream.prototype, {
        constructor: {
            value: SAXStream
        }
    });
    SAXStream.prototype.write = function(data) {
        this._parser.write(data.toString());
        this.emit("data", data);
        return true;
    };
    SAXStream.prototype.end = function(chunk) {
        if (chunk && chunk.length) this.write(chunk);
        this._parser.end();
        return true;
    };
    SAXStream.prototype.on = function(ev, handler) {
        var me = this;
        if (!me._parser["on" + ev] && streamWraps.indexOf(ev) !== -1) me._parser["on" + ev] = function() {
            var args = arguments.length === 1 ? [
                arguments[0]
            ] : Array.apply(null, arguments);
            args.splice(0, 0, ev);
            me.emit.apply(me, args);
        };
        return Stream.prototype.on.call(me, ev, handler);
    };
    // this really needs to be replaced with character classes.
    // XML allows all manner of ridiculous numbers and digits.
    var CDATA = "[CDATA[";
    var DOCTYPE = "DOCTYPE";
    var XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
    var XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
    var rootNS = {
        xml: XML_NAMESPACE,
        xmlns: XMLNS_NAMESPACE
    };
    // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
    // This implementation works on strings, a single character at a time
    // as such, it cannot ever support astral-plane characters (10000-EFFFF)
    // without a significant breaking change to either this  parser, or the
    // JavaScript language.  Implementation of an emoji-capable xml parser
    // is left as an exercise for the reader.
    var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
    var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
    var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    function isWhitespace(c) {
        return c === " " || c === "\n" || c === "\r" || c === "\t";
    }
    function isQuote(c) {
        return c === '"' || c === "'";
    }
    function isAttribEnd(c) {
        return c === ">" || isWhitespace(c);
    }
    function isMatch(regex, c) {
        return regex.test(c);
    }
    function notMatch(regex, c) {
        return !isMatch(regex, c);
    }
    var S = 0;
    sax.STATE = {
        BEGIN: S++,
        BEGIN_WHITESPACE: S++,
        TEXT: S++,
        TEXT_ENTITY: S++,
        OPEN_WAKA: S++,
        SGML_DECL: S++,
        SGML_DECL_QUOTED: S++,
        DOCTYPE: S++,
        DOCTYPE_QUOTED: S++,
        DOCTYPE_DTD: S++,
        DOCTYPE_DTD_QUOTED: S++,
        COMMENT_STARTING: S++,
        COMMENT: S++,
        COMMENT_ENDING: S++,
        COMMENT_ENDED: S++,
        CDATA: S++,
        CDATA_ENDING: S++,
        CDATA_ENDING_2: S++,
        PROC_INST: S++,
        PROC_INST_BODY: S++,
        PROC_INST_ENDING: S++,
        OPEN_TAG: S++,
        OPEN_TAG_SLASH: S++,
        ATTRIB: S++,
        ATTRIB_NAME: S++,
        ATTRIB_NAME_SAW_WHITE: S++,
        ATTRIB_VALUE: S++,
        ATTRIB_VALUE_QUOTED: S++,
        ATTRIB_VALUE_CLOSED: S++,
        ATTRIB_VALUE_UNQUOTED: S++,
        ATTRIB_VALUE_ENTITY_Q: S++,
        ATTRIB_VALUE_ENTITY_U: S++,
        CLOSE_TAG: S++,
        CLOSE_TAG_SAW_WHITE: S++,
        SCRIPT: S++,
        SCRIPT_ENDING: S++
    };
    sax.XML_ENTITIES = {
        amp: "&",
        gt: ">",
        lt: "<",
        quot: '"',
        apos: "'"
    };
    sax.ENTITIES = {
        amp: "&",
        gt: ">",
        lt: "<",
        quot: '"',
        apos: "'",
        AElig: 198,
        Aacute: 193,
        Acirc: 194,
        Agrave: 192,
        Aring: 197,
        Atilde: 195,
        Auml: 196,
        Ccedil: 199,
        ETH: 208,
        Eacute: 201,
        Ecirc: 202,
        Egrave: 200,
        Euml: 203,
        Iacute: 205,
        Icirc: 206,
        Igrave: 204,
        Iuml: 207,
        Ntilde: 209,
        Oacute: 211,
        Ocirc: 212,
        Ograve: 210,
        Oslash: 216,
        Otilde: 213,
        Ouml: 214,
        THORN: 222,
        Uacute: 218,
        Ucirc: 219,
        Ugrave: 217,
        Uuml: 220,
        Yacute: 221,
        aacute: 225,
        acirc: 226,
        aelig: 230,
        agrave: 224,
        aring: 229,
        atilde: 227,
        auml: 228,
        ccedil: 231,
        eacute: 233,
        ecirc: 234,
        egrave: 232,
        eth: 240,
        euml: 235,
        iacute: 237,
        icirc: 238,
        igrave: 236,
        iuml: 239,
        ntilde: 241,
        oacute: 243,
        ocirc: 244,
        ograve: 242,
        oslash: 248,
        otilde: 245,
        ouml: 246,
        szlig: 223,
        thorn: 254,
        uacute: 250,
        ucirc: 251,
        ugrave: 249,
        uuml: 252,
        yacute: 253,
        yuml: 255,
        copy: 169,
        reg: 174,
        nbsp: 160,
        iexcl: 161,
        cent: 162,
        pound: 163,
        curren: 164,
        yen: 165,
        brvbar: 166,
        sect: 167,
        uml: 168,
        ordf: 170,
        laquo: 171,
        not: 172,
        shy: 173,
        macr: 175,
        deg: 176,
        plusmn: 177,
        sup1: 185,
        sup2: 178,
        sup3: 179,
        acute: 180,
        micro: 181,
        para: 182,
        middot: 183,
        cedil: 184,
        ordm: 186,
        raquo: 187,
        frac14: 188,
        frac12: 189,
        frac34: 190,
        iquest: 191,
        times: 215,
        divide: 247,
        OElig: 338,
        oelig: 339,
        Scaron: 352,
        scaron: 353,
        Yuml: 376,
        fnof: 402,
        circ: 710,
        tilde: 732,
        Alpha: 913,
        Beta: 914,
        Gamma: 915,
        Delta: 916,
        Epsilon: 917,
        Zeta: 918,
        Eta: 919,
        Theta: 920,
        Iota: 921,
        Kappa: 922,
        Lambda: 923,
        Mu: 924,
        Nu: 925,
        Xi: 926,
        Omicron: 927,
        Pi: 928,
        Rho: 929,
        Sigma: 931,
        Tau: 932,
        Upsilon: 933,
        Phi: 934,
        Chi: 935,
        Psi: 936,
        Omega: 937,
        alpha: 945,
        beta: 946,
        gamma: 947,
        delta: 948,
        epsilon: 949,
        zeta: 950,
        eta: 951,
        theta: 952,
        iota: 953,
        kappa: 954,
        lambda: 955,
        mu: 956,
        nu: 957,
        xi: 958,
        omicron: 959,
        pi: 960,
        rho: 961,
        sigmaf: 962,
        sigma: 963,
        tau: 964,
        upsilon: 965,
        phi: 966,
        chi: 967,
        psi: 968,
        omega: 969,
        thetasym: 977,
        upsih: 978,
        piv: 982,
        ensp: 8194,
        emsp: 8195,
        thinsp: 8201,
        zwnj: 8204,
        zwj: 8205,
        lrm: 8206,
        rlm: 8207,
        ndash: 8211,
        mdash: 8212,
        lsquo: 8216,
        rsquo: 8217,
        sbquo: 8218,
        ldquo: 8220,
        rdquo: 8221,
        bdquo: 8222,
        dagger: 8224,
        Dagger: 8225,
        bull: 8226,
        hellip: 8230,
        permil: 8240,
        prime: 8242,
        Prime: 8243,
        lsaquo: 8249,
        rsaquo: 8250,
        oline: 8254,
        frasl: 8260,
        euro: 8364,
        image: 8465,
        weierp: 8472,
        real: 8476,
        trade: 8482,
        alefsym: 8501,
        larr: 8592,
        uarr: 8593,
        rarr: 8594,
        darr: 8595,
        harr: 8596,
        crarr: 8629,
        lArr: 8656,
        uArr: 8657,
        rArr: 8658,
        dArr: 8659,
        hArr: 8660,
        forall: 8704,
        part: 8706,
        exist: 8707,
        empty: 8709,
        nabla: 8711,
        isin: 8712,
        notin: 8713,
        ni: 8715,
        prod: 8719,
        sum: 8721,
        minus: 8722,
        lowast: 8727,
        radic: 8730,
        prop: 8733,
        infin: 8734,
        ang: 8736,
        and: 8743,
        or: 8744,
        cap: 8745,
        cup: 8746,
        int: 8747,
        there4: 8756,
        sim: 8764,
        cong: 8773,
        asymp: 8776,
        ne: 8800,
        equiv: 8801,
        le: 8804,
        ge: 8805,
        sub: 8834,
        sup: 8835,
        nsub: 8836,
        sube: 8838,
        supe: 8839,
        oplus: 8853,
        otimes: 8855,
        perp: 8869,
        sdot: 8901,
        lceil: 8968,
        rceil: 8969,
        lfloor: 8970,
        rfloor: 8971,
        lang: 9001,
        rang: 9002,
        loz: 9674,
        spades: 9824,
        clubs: 9827,
        hearts: 9829,
        diams: 9830
    };
    Object.keys(sax.ENTITIES).forEach(function(key) {
        var e = sax.ENTITIES[key];
        var s = typeof e === "number" ? String.fromCharCode(e) : e;
        sax.ENTITIES[key] = s;
    });
    for(var s in sax.STATE)sax.STATE[sax.STATE[s]] = s;
    // shorthand
    S = sax.STATE;
    function emit(parser, event, data) {
        parser[event] && parser[event](data);
    }
    function emitNode(parser, nodeType, data) {
        if (parser.textNode) closeText(parser);
        emit(parser, nodeType, data);
    }
    function closeText(parser) {
        parser.textNode = textopts(parser.opt, parser.textNode);
        if (parser.textNode) emit(parser, "ontext", parser.textNode);
        parser.textNode = "";
    }
    function textopts(opt, text) {
        if (opt.trim) text = text.trim();
        if (opt.normalize) text = text.replace(/\s+/g, " ");
        return text;
    }
    function error(parser, er) {
        closeText(parser);
        if (parser.trackPosition) er += "\nLine: " + parser.line + "\nColumn: " + parser.column + "\nChar: " + parser.c;
        er = new Error(er);
        parser.error = er;
        emit(parser, "onerror", er);
        return parser;
    }
    function end(parser) {
        if (parser.sawRoot && !parser.closedRoot) strictFail(parser, "Unclosed root tag");
        if (parser.state !== S.BEGIN && parser.state !== S.BEGIN_WHITESPACE && parser.state !== S.TEXT) error(parser, "Unexpected end");
        closeText(parser);
        parser.c = "";
        parser.closed = true;
        emit(parser, "onend");
        SAXParser.call(parser, parser.strict, parser.opt);
        return parser;
    }
    function strictFail(parser, message) {
        if (typeof parser !== "object" || !(parser instanceof SAXParser)) throw new Error("bad call to strictFail");
        if (parser.strict) error(parser, message);
    }
    function newTag(parser) {
        if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
        var parent = parser.tags[parser.tags.length - 1] || parser;
        var tag = parser.tag = {
            name: parser.tagName,
            attributes: {}
        };
        // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
        if (parser.opt.xmlns) tag.ns = parent.ns;
        parser.attribList.length = 0;
        emitNode(parser, "onopentagstart", tag);
    }
    function qname(name, attribute) {
        var i = name.indexOf(":");
        var qualName = i < 0 ? [
            "",
            name
        ] : name.split(":");
        var prefix = qualName[0];
        var local = qualName[1];
        // <x "xmlns"="http://foo">
        if (attribute && name === "xmlns") {
            prefix = "xmlns";
            local = "";
        }
        return {
            prefix: prefix,
            local: local
        };
    }
    function attrib(parser) {
        if (!parser.strict) parser.attribName = parser.attribName[parser.looseCase]();
        if (parser.attribList.indexOf(parser.attribName) !== -1 || parser.tag.attributes.hasOwnProperty(parser.attribName)) {
            parser.attribName = parser.attribValue = "";
            return;
        }
        if (parser.opt.xmlns) {
            var qn = qname(parser.attribName, true);
            var prefix = qn.prefix;
            var local = qn.local;
            if (prefix === "xmlns") {
                // namespace binding attribute. push the binding into scope
                if (local === "xml" && parser.attribValue !== XML_NAMESPACE) strictFail(parser, "xml: prefix must be bound to " + XML_NAMESPACE + "\n" + "Actual: " + parser.attribValue);
                else if (local === "xmlns" && parser.attribValue !== XMLNS_NAMESPACE) strictFail(parser, "xmlns: prefix must be bound to " + XMLNS_NAMESPACE + "\n" + "Actual: " + parser.attribValue);
                else {
                    var tag = parser.tag;
                    var parent = parser.tags[parser.tags.length - 1] || parser;
                    if (tag.ns === parent.ns) tag.ns = Object.create(parent.ns);
                    tag.ns[local] = parser.attribValue;
                }
            }
            // defer onattribute events until all attributes have been seen
            // so any new bindings can take effect. preserve attribute order
            // so deferred events can be emitted in document order
            parser.attribList.push([
                parser.attribName,
                parser.attribValue
            ]);
        } else {
            // in non-xmlns mode, we can emit the event right away
            parser.tag.attributes[parser.attribName] = parser.attribValue;
            emitNode(parser, "onattribute", {
                name: parser.attribName,
                value: parser.attribValue
            });
        }
        parser.attribName = parser.attribValue = "";
    }
    function openTag(parser, selfClosing) {
        if (parser.opt.xmlns) {
            // emit namespace binding events
            var tag = parser.tag;
            // add namespace info to tag
            var qn = qname(parser.tagName);
            tag.prefix = qn.prefix;
            tag.local = qn.local;
            tag.uri = tag.ns[qn.prefix] || "";
            if (tag.prefix && !tag.uri) {
                strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(parser.tagName));
                tag.uri = qn.prefix;
            }
            var parent = parser.tags[parser.tags.length - 1] || parser;
            if (tag.ns && parent.ns !== tag.ns) Object.keys(tag.ns).forEach(function(p) {
                emitNode(parser, "onopennamespace", {
                    prefix: p,
                    uri: tag.ns[p]
                });
            });
            // handle deferred onattribute events
            // Note: do not apply default ns to attributes:
            //   http://www.w3.org/TR/REC-xml-names/#defaulting
            for(var i = 0, l = parser.attribList.length; i < l; i++){
                var nv = parser.attribList[i];
                var name = nv[0];
                var value = nv[1];
                var qualName = qname(name, true);
                var prefix = qualName.prefix;
                var local = qualName.local;
                var uri = prefix === "" ? "" : tag.ns[prefix] || "";
                var a = {
                    name: name,
                    value: value,
                    prefix: prefix,
                    local: local,
                    uri: uri
                };
                // if there's any attributes with an undefined namespace,
                // then fail on them now.
                if (prefix && prefix !== "xmlns" && !uri) {
                    strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(prefix));
                    a.uri = prefix;
                }
                parser.tag.attributes[name] = a;
                emitNode(parser, "onattribute", a);
            }
            parser.attribList.length = 0;
        }
        parser.tag.isSelfClosing = !!selfClosing;
        // process the tag
        parser.sawRoot = true;
        parser.tags.push(parser.tag);
        emitNode(parser, "onopentag", parser.tag);
        if (!selfClosing) {
            // special case for <script> in non-strict mode.
            if (!parser.noscript && parser.tagName.toLowerCase() === "script") parser.state = S.SCRIPT;
            else parser.state = S.TEXT;
            parser.tag = null;
            parser.tagName = "";
        }
        parser.attribName = parser.attribValue = "";
        parser.attribList.length = 0;
    }
    function closeTag(parser) {
        if (!parser.tagName) {
            strictFail(parser, "Weird empty close tag.");
            parser.textNode += "</>";
            parser.state = S.TEXT;
            return;
        }
        if (parser.script) {
            if (parser.tagName !== "script") {
                parser.script += "</" + parser.tagName + ">";
                parser.tagName = "";
                parser.state = S.SCRIPT;
                return;
            }
            emitNode(parser, "onscript", parser.script);
            parser.script = "";
        }
        // first make sure that the closing tag actually exists.
        // <a><b></c></b></a> will close everything, otherwise.
        var t = parser.tags.length;
        var tagName = parser.tagName;
        if (!parser.strict) tagName = tagName[parser.looseCase]();
        var closeTo = tagName;
        while(t--){
            var close = parser.tags[t];
            if (close.name !== closeTo) // fail the first time in strict mode
            strictFail(parser, "Unexpected close tag");
            else break;
        }
        // didn't find it.  we already failed for strict, so just abort.
        if (t < 0) {
            strictFail(parser, "Unmatched closing tag: " + parser.tagName);
            parser.textNode += "</" + parser.tagName + ">";
            parser.state = S.TEXT;
            return;
        }
        parser.tagName = tagName;
        var s = parser.tags.length;
        while(s-- > t){
            var tag = parser.tag = parser.tags.pop();
            parser.tagName = parser.tag.name;
            emitNode(parser, "onclosetag", parser.tagName);
            var x = {};
            for(var i in tag.ns)x[i] = tag.ns[i];
            var parent = parser.tags[parser.tags.length - 1] || parser;
            if (parser.opt.xmlns && tag.ns !== parent.ns) // remove namespace bindings introduced by tag
            Object.keys(tag.ns).forEach(function(p) {
                var n = tag.ns[p];
                emitNode(parser, "onclosenamespace", {
                    prefix: p,
                    uri: n
                });
            });
        }
        if (t === 0) parser.closedRoot = true;
        parser.tagName = parser.attribValue = parser.attribName = "";
        parser.attribList.length = 0;
        parser.state = S.TEXT;
    }
    function parseEntity(parser) {
        var entity = parser.entity;
        var entityLC = entity.toLowerCase();
        var num;
        var numStr = "";
        if (parser.ENTITIES[entity]) return parser.ENTITIES[entity];
        if (parser.ENTITIES[entityLC]) return parser.ENTITIES[entityLC];
        entity = entityLC;
        if (entity.charAt(0) === "#") {
            if (entity.charAt(1) === "x") {
                entity = entity.slice(2);
                num = parseInt(entity, 16);
                numStr = num.toString(16);
            } else {
                entity = entity.slice(1);
                num = parseInt(entity, 10);
                numStr = num.toString(10);
            }
        }
        entity = entity.replace(/^0+/, "");
        if (isNaN(num) || numStr.toLowerCase() !== entity) {
            strictFail(parser, "Invalid character entity");
            return "&" + parser.entity + ";";
        }
        return String.fromCodePoint(num);
    }
    function beginWhiteSpace(parser, c) {
        if (c === "<") {
            parser.state = S.OPEN_WAKA;
            parser.startTagPosition = parser.position;
        } else if (!isWhitespace(c)) {
            // have to process this as a text node.
            // weird, but happens.
            strictFail(parser, "Non-whitespace before first tag.");
            parser.textNode = c;
            parser.state = S.TEXT;
        }
    }
    function charAt(chunk, i) {
        var result = "";
        if (i < chunk.length) result = chunk.charAt(i);
        return result;
    }
    function write(chunk) {
        var parser = this;
        if (this.error) throw this.error;
        if (parser.closed) return error(parser, "Cannot write after close. Assign an onready handler.");
        if (chunk === null) return end(parser);
        if (typeof chunk === "object") chunk = chunk.toString();
        var i = 0;
        var c = "";
        while(true){
            c = charAt(chunk, i++);
            parser.c = c;
            if (!c) break;
            if (parser.trackPosition) {
                parser.position++;
                if (c === "\n") {
                    parser.line++;
                    parser.column = 0;
                } else parser.column++;
            }
            switch(parser.state){
                case S.BEGIN:
                    parser.state = S.BEGIN_WHITESPACE;
                    if (c === "\uFEFF") continue;
                    beginWhiteSpace(parser, c);
                    continue;
                case S.BEGIN_WHITESPACE:
                    beginWhiteSpace(parser, c);
                    continue;
                case S.TEXT:
                    if (parser.sawRoot && !parser.closedRoot) {
                        var starti = i - 1;
                        while(c && c !== "<" && c !== "&"){
                            c = charAt(chunk, i++);
                            if (c && parser.trackPosition) {
                                parser.position++;
                                if (c === "\n") {
                                    parser.line++;
                                    parser.column = 0;
                                } else parser.column++;
                            }
                        }
                        parser.textNode += chunk.substring(starti, i - 1);
                    }
                    if (c === "<" && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
                        parser.state = S.OPEN_WAKA;
                        parser.startTagPosition = parser.position;
                    } else {
                        if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) strictFail(parser, "Text data outside of root node.");
                        if (c === "&") parser.state = S.TEXT_ENTITY;
                        else parser.textNode += c;
                    }
                    continue;
                case S.SCRIPT:
                    // only non-strict
                    if (c === "<") parser.state = S.SCRIPT_ENDING;
                    else parser.script += c;
                    continue;
                case S.SCRIPT_ENDING:
                    if (c === "/") parser.state = S.CLOSE_TAG;
                    else {
                        parser.script += "<" + c;
                        parser.state = S.SCRIPT;
                    }
                    continue;
                case S.OPEN_WAKA:
                    // either a /, ?, !, or text is coming next.
                    if (c === "!") {
                        parser.state = S.SGML_DECL;
                        parser.sgmlDecl = "";
                    } else if (isWhitespace(c)) ;
                    else if (isMatch(nameStart, c)) {
                        parser.state = S.OPEN_TAG;
                        parser.tagName = c;
                    } else if (c === "/") {
                        parser.state = S.CLOSE_TAG;
                        parser.tagName = "";
                    } else if (c === "?") {
                        parser.state = S.PROC_INST;
                        parser.procInstName = parser.procInstBody = "";
                    } else {
                        strictFail(parser, "Unencoded <");
                        // if there was some whitespace, then add that in.
                        if (parser.startTagPosition + 1 < parser.position) {
                            var pad = parser.position - parser.startTagPosition;
                            c = new Array(pad).join(" ") + c;
                        }
                        parser.textNode += "<" + c;
                        parser.state = S.TEXT;
                    }
                    continue;
                case S.SGML_DECL:
                    if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
                        emitNode(parser, "onopencdata");
                        parser.state = S.CDATA;
                        parser.sgmlDecl = "";
                        parser.cdata = "";
                    } else if (parser.sgmlDecl + c === "--") {
                        parser.state = S.COMMENT;
                        parser.comment = "";
                        parser.sgmlDecl = "";
                    } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
                        parser.state = S.DOCTYPE;
                        if (parser.doctype || parser.sawRoot) strictFail(parser, "Inappropriately located doctype declaration");
                        parser.doctype = "";
                        parser.sgmlDecl = "";
                    } else if (c === ">") {
                        emitNode(parser, "onsgmldeclaration", parser.sgmlDecl);
                        parser.sgmlDecl = "";
                        parser.state = S.TEXT;
                    } else if (isQuote(c)) {
                        parser.state = S.SGML_DECL_QUOTED;
                        parser.sgmlDecl += c;
                    } else parser.sgmlDecl += c;
                    continue;
                case S.SGML_DECL_QUOTED:
                    if (c === parser.q) {
                        parser.state = S.SGML_DECL;
                        parser.q = "";
                    }
                    parser.sgmlDecl += c;
                    continue;
                case S.DOCTYPE:
                    if (c === ">") {
                        parser.state = S.TEXT;
                        emitNode(parser, "ondoctype", parser.doctype);
                        parser.doctype = true; // just remember that we saw it.
                    } else {
                        parser.doctype += c;
                        if (c === "[") parser.state = S.DOCTYPE_DTD;
                        else if (isQuote(c)) {
                            parser.state = S.DOCTYPE_QUOTED;
                            parser.q = c;
                        }
                    }
                    continue;
                case S.DOCTYPE_QUOTED:
                    parser.doctype += c;
                    if (c === parser.q) {
                        parser.q = "";
                        parser.state = S.DOCTYPE;
                    }
                    continue;
                case S.DOCTYPE_DTD:
                    parser.doctype += c;
                    if (c === "]") parser.state = S.DOCTYPE;
                    else if (isQuote(c)) {
                        parser.state = S.DOCTYPE_DTD_QUOTED;
                        parser.q = c;
                    }
                    continue;
                case S.DOCTYPE_DTD_QUOTED:
                    parser.doctype += c;
                    if (c === parser.q) {
                        parser.state = S.DOCTYPE_DTD;
                        parser.q = "";
                    }
                    continue;
                case S.COMMENT:
                    if (c === "-") parser.state = S.COMMENT_ENDING;
                    else parser.comment += c;
                    continue;
                case S.COMMENT_ENDING:
                    if (c === "-") {
                        parser.state = S.COMMENT_ENDED;
                        parser.comment = textopts(parser.opt, parser.comment);
                        if (parser.comment) emitNode(parser, "oncomment", parser.comment);
                        parser.comment = "";
                    } else {
                        parser.comment += "-" + c;
                        parser.state = S.COMMENT;
                    }
                    continue;
                case S.COMMENT_ENDED:
                    if (c !== ">") {
                        strictFail(parser, "Malformed comment");
                        // allow <!-- blah -- bloo --> in non-strict mode,
                        // which is a comment of " blah -- bloo "
                        parser.comment += "--" + c;
                        parser.state = S.COMMENT;
                    } else parser.state = S.TEXT;
                    continue;
                case S.CDATA:
                    if (c === "]") parser.state = S.CDATA_ENDING;
                    else parser.cdata += c;
                    continue;
                case S.CDATA_ENDING:
                    if (c === "]") parser.state = S.CDATA_ENDING_2;
                    else {
                        parser.cdata += "]" + c;
                        parser.state = S.CDATA;
                    }
                    continue;
                case S.CDATA_ENDING_2:
                    if (c === ">") {
                        if (parser.cdata) emitNode(parser, "oncdata", parser.cdata);
                        emitNode(parser, "onclosecdata");
                        parser.cdata = "";
                        parser.state = S.TEXT;
                    } else if (c === "]") parser.cdata += "]";
                    else {
                        parser.cdata += "]]" + c;
                        parser.state = S.CDATA;
                    }
                    continue;
                case S.PROC_INST:
                    if (c === "?") parser.state = S.PROC_INST_ENDING;
                    else if (isWhitespace(c)) parser.state = S.PROC_INST_BODY;
                    else parser.procInstName += c;
                    continue;
                case S.PROC_INST_BODY:
                    if (!parser.procInstBody && isWhitespace(c)) continue;
                    else if (c === "?") parser.state = S.PROC_INST_ENDING;
                    else parser.procInstBody += c;
                    continue;
                case S.PROC_INST_ENDING:
                    if (c === ">") {
                        emitNode(parser, "onprocessinginstruction", {
                            name: parser.procInstName,
                            body: parser.procInstBody
                        });
                        parser.procInstName = parser.procInstBody = "";
                        parser.state = S.TEXT;
                    } else {
                        parser.procInstBody += "?" + c;
                        parser.state = S.PROC_INST_BODY;
                    }
                    continue;
                case S.OPEN_TAG:
                    if (isMatch(nameBody, c)) parser.tagName += c;
                    else {
                        newTag(parser);
                        if (c === ">") openTag(parser);
                        else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                        else {
                            if (!isWhitespace(c)) strictFail(parser, "Invalid character in tag name");
                            parser.state = S.ATTRIB;
                        }
                    }
                    continue;
                case S.OPEN_TAG_SLASH:
                    if (c === ">") {
                        openTag(parser, true);
                        closeTag(parser);
                    } else {
                        strictFail(parser, "Forward-slash in opening tag not followed by >");
                        parser.state = S.ATTRIB;
                    }
                    continue;
                case S.ATTRIB:
                    // haven't read the attribute name yet.
                    if (isWhitespace(c)) continue;
                    else if (c === ">") openTag(parser);
                    else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                    else if (isMatch(nameStart, c)) {
                        parser.attribName = c;
                        parser.attribValue = "";
                        parser.state = S.ATTRIB_NAME;
                    } else strictFail(parser, "Invalid attribute name");
                    continue;
                case S.ATTRIB_NAME:
                    if (c === "=") parser.state = S.ATTRIB_VALUE;
                    else if (c === ">") {
                        strictFail(parser, "Attribute without value");
                        parser.attribValue = parser.attribName;
                        attrib(parser);
                        openTag(parser);
                    } else if (isWhitespace(c)) parser.state = S.ATTRIB_NAME_SAW_WHITE;
                    else if (isMatch(nameBody, c)) parser.attribName += c;
                    else strictFail(parser, "Invalid attribute name");
                    continue;
                case S.ATTRIB_NAME_SAW_WHITE:
                    if (c === "=") parser.state = S.ATTRIB_VALUE;
                    else if (isWhitespace(c)) continue;
                    else {
                        strictFail(parser, "Attribute without value");
                        parser.tag.attributes[parser.attribName] = "";
                        parser.attribValue = "";
                        emitNode(parser, "onattribute", {
                            name: parser.attribName,
                            value: ""
                        });
                        parser.attribName = "";
                        if (c === ">") openTag(parser);
                        else if (isMatch(nameStart, c)) {
                            parser.attribName = c;
                            parser.state = S.ATTRIB_NAME;
                        } else {
                            strictFail(parser, "Invalid attribute name");
                            parser.state = S.ATTRIB;
                        }
                    }
                    continue;
                case S.ATTRIB_VALUE:
                    if (isWhitespace(c)) continue;
                    else if (isQuote(c)) {
                        parser.q = c;
                        parser.state = S.ATTRIB_VALUE_QUOTED;
                    } else {
                        strictFail(parser, "Unquoted attribute value");
                        parser.state = S.ATTRIB_VALUE_UNQUOTED;
                        parser.attribValue = c;
                    }
                    continue;
                case S.ATTRIB_VALUE_QUOTED:
                    if (c !== parser.q) {
                        if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_Q;
                        else parser.attribValue += c;
                        continue;
                    }
                    attrib(parser);
                    parser.q = "";
                    parser.state = S.ATTRIB_VALUE_CLOSED;
                    continue;
                case S.ATTRIB_VALUE_CLOSED:
                    if (isWhitespace(c)) parser.state = S.ATTRIB;
                    else if (c === ">") openTag(parser);
                    else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                    else if (isMatch(nameStart, c)) {
                        strictFail(parser, "No whitespace between attributes");
                        parser.attribName = c;
                        parser.attribValue = "";
                        parser.state = S.ATTRIB_NAME;
                    } else strictFail(parser, "Invalid attribute name");
                    continue;
                case S.ATTRIB_VALUE_UNQUOTED:
                    if (!isAttribEnd(c)) {
                        if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_U;
                        else parser.attribValue += c;
                        continue;
                    }
                    attrib(parser);
                    if (c === ">") openTag(parser);
                    else parser.state = S.ATTRIB;
                    continue;
                case S.CLOSE_TAG:
                    if (!parser.tagName) {
                        if (isWhitespace(c)) continue;
                        else if (notMatch(nameStart, c)) {
                            if (parser.script) {
                                parser.script += "</" + c;
                                parser.state = S.SCRIPT;
                            } else strictFail(parser, "Invalid tagname in closing tag.");
                        } else parser.tagName = c;
                    } else if (c === ">") closeTag(parser);
                    else if (isMatch(nameBody, c)) parser.tagName += c;
                    else if (parser.script) {
                        parser.script += "</" + parser.tagName;
                        parser.tagName = "";
                        parser.state = S.SCRIPT;
                    } else {
                        if (!isWhitespace(c)) strictFail(parser, "Invalid tagname in closing tag");
                        parser.state = S.CLOSE_TAG_SAW_WHITE;
                    }
                    continue;
                case S.CLOSE_TAG_SAW_WHITE:
                    if (isWhitespace(c)) continue;
                    if (c === ">") closeTag(parser);
                    else strictFail(parser, "Invalid characters in closing tag");
                    continue;
                case S.TEXT_ENTITY:
                case S.ATTRIB_VALUE_ENTITY_Q:
                case S.ATTRIB_VALUE_ENTITY_U:
                    var returnState;
                    var buffer;
                    switch(parser.state){
                        case S.TEXT_ENTITY:
                            returnState = S.TEXT;
                            buffer = "textNode";
                            break;
                        case S.ATTRIB_VALUE_ENTITY_Q:
                            returnState = S.ATTRIB_VALUE_QUOTED;
                            buffer = "attribValue";
                            break;
                        case S.ATTRIB_VALUE_ENTITY_U:
                            returnState = S.ATTRIB_VALUE_UNQUOTED;
                            buffer = "attribValue";
                            break;
                    }
                    if (c === ";") {
                        if (parser.opt.unparsedEntities) {
                            var parsedEntity = parseEntity(parser);
                            parser.entity = "";
                            parser.state = returnState;
                            parser.write(parsedEntity);
                        } else {
                            parser[buffer] += parseEntity(parser);
                            parser.entity = "";
                            parser.state = returnState;
                        }
                    } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) parser.entity += c;
                    else {
                        strictFail(parser, "Invalid character in entity name");
                        parser[buffer] += "&" + parser.entity + c;
                        parser.entity = "";
                        parser.state = returnState;
                    }
                    continue;
                default:
                    throw new Error(parser, "Unknown state: " + parser.state);
            }
        } // while
        if (parser.position >= parser.bufferCheckPosition) checkBufferLength(parser);
        return parser;
    }
    /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */ /* istanbul ignore next */ if (!String.fromCodePoint) (function() {
        var stringFromCharCode = String.fromCharCode;
        var floor = Math.floor;
        var fromCodePoint = function() {
            var MAX_SIZE = 0x4000;
            var codeUnits = [];
            var highSurrogate;
            var lowSurrogate;
            var index = -1;
            var length = arguments.length;
            if (!length) return "";
            var result = "";
            while(++index < length){
                var codePoint = Number(arguments[index]);
                if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                codePoint < 0 || // not a valid Unicode code point
                codePoint > 0x10ffff || // not a valid Unicode code point
                floor(codePoint) !== codePoint // not an integer
                ) throw RangeError("Invalid code point: " + codePoint);
                if (codePoint <= 0xffff) // BMP code point
                codeUnits.push(codePoint);
                else {
                    // Astral code point; split in surrogate halves
                    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    codePoint -= 0x10000;
                    highSurrogate = (codePoint >> 10) + 0xd800;
                    lowSurrogate = codePoint % 0x400 + 0xdc00;
                    codeUnits.push(highSurrogate, lowSurrogate);
                }
                if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                    result += stringFromCharCode.apply(null, codeUnits);
                    codeUnits.length = 0;
                }
            }
            return result;
        };
        /* istanbul ignore next */ if (Object.defineProperty) Object.defineProperty(String, "fromCodePoint", {
            value: fromCodePoint,
            configurable: true,
            writable: true
        });
        else String.fromCodePoint = fromCodePoint;
    })();
    return sax;
};
const sax = /** #__PURE__ */ initializeSax();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bdjua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseJs = require("./base.js");
parcelHelpers.exportAll(_baseJs, exports);
var _chatJs = require("./chat.js");
parcelHelpers.exportAll(_chatJs, exports);
var _fewShotJs = require("./few_shot.js");
parcelHelpers.exportAll(_fewShotJs, exports);
var _pipelineJs = require("./pipeline.js");
parcelHelpers.exportAll(_pipelineJs, exports);
var _promptJs = require("./prompt.js");
parcelHelpers.exportAll(_promptJs, exports);
var _serdeJs = require("./serde.js");
parcelHelpers.exportAll(_serdeJs, exports);
var _stringJs = require("./string.js");
parcelHelpers.exportAll(_stringJs, exports);
var _templateJs = require("./template.js");
parcelHelpers.exportAll(_templateJs, exports);
var _imageJs = require("./image.js");
parcelHelpers.exportAll(_imageJs, exports);
var _structuredJs = require("./structured.js");
parcelHelpers.exportAll(_structuredJs, exports);

},{"./base.js":"aJ9Ap","./chat.js":"9KL2r","./few_shot.js":"cxYFF","./pipeline.js":"f17cb","./prompt.js":"9hvf6","./serde.js":"aATNK","./string.js":"fMbzg","./template.js":"ii6yk","./image.js":"hRbX2","./structured.js":"8H0Lk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aJ9Ap":[function(require,module,exports,__globalThis) {
// Default generic "any" values are for backwards compatibility.
// Replace with "string" when we are comfortable with a breaking change.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Base class for prompt templates. Exposes a format method that returns a
 * string prompt given a set of input values.
 */ parcelHelpers.export(exports, "BasePromptTemplate", ()=>BasePromptTemplate);
var _baseJs = require("../runnables/base.js");
class BasePromptTemplate extends (0, _baseJs.Runnable) {
    get lc_attributes() {
        return {
            partialVariables: undefined
        };
    }
    constructor(input){
        super(input);
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "prompts",
                this._getPromptType()
            ]
        });
        Object.defineProperty(this, "inputVariables", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "outputParser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "partialVariables", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const { inputVariables } = input;
        if (inputVariables.includes("stop")) throw new Error("Cannot have an input variable named 'stop', as it is used internally, please rename.");
        Object.assign(this, input);
    }
    /**
     * Merges partial variables and user variables.
     * @param userVariables The user variables to merge with the partial variables.
     * @returns A Promise that resolves to an object containing the merged variables.
     */ async mergePartialAndUserVariables(userVariables) {
        const partialVariables = this.partialVariables ?? {};
        const partialValues = {};
        for (const [key, value] of Object.entries(partialVariables))if (typeof value === "string") partialValues[key] = value;
        else partialValues[key] = await value();
        const allKwargs = {
            ...partialValues,
            ...userVariables
        };
        return allKwargs;
    }
    /**
     * Invokes the prompt template with the given input and options.
     * @param input The input to invoke the prompt template with.
     * @param options Optional configuration for the callback.
     * @returns A Promise that resolves to the output of the prompt template.
     */ async invoke(input, options) {
        return this._callWithConfig((input)=>this.formatPromptValue(input), input, {
            ...options,
            runType: "prompt"
        });
    }
    /**
     * Return a json-like object representing this prompt template.
     * @deprecated
     */ serialize() {
        throw new Error("Use .toJSON() instead");
    }
    /**
     * @deprecated
     * Load a prompt template from a json-like object describing it.
     *
     * @remarks
     * Deserializing needs to be async because templates (e.g. {@link FewShotPromptTemplate}) can
     * reference remote resources that we read asynchronously with a web
     * request.
     */ static async deserialize(data) {
        switch(data._type){
            case "prompt":
                {
                    const { PromptTemplate } = await require("5074728d6eef1415");
                    return PromptTemplate.deserialize(data);
                }
            case undefined:
                {
                    const { PromptTemplate } = await require("5074728d6eef1415");
                    return PromptTemplate.deserialize({
                        ...data,
                        _type: "prompt"
                    });
                }
            case "few_shot":
                {
                    const { FewShotPromptTemplate } = await require("c2cac79ecf644e72");
                    return FewShotPromptTemplate.deserialize(data);
                }
            default:
                throw new Error(`Invalid prompt type in config: ${data._type}`);
        }
    }
}

},{"../runnables/base.js":"9xkzz","5074728d6eef1415":"eKNmO","c2cac79ecf644e72":"aVk4O","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eKNmO":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("9hvf6"));

},{}],"aVk4O":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("cxYFF"));

},{}],"9KL2r":[function(require,module,exports,__globalThis) {
// Default generic "any" values are for backwards compatibility.
// Replace with "string" when we are comfortable with a breaking change.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Abstract class that serves as a base for creating message prompt
 * templates. It defines how to format messages for different roles in a
 * conversation.
 */ parcelHelpers.export(exports, "BaseMessagePromptTemplate", ()=>BaseMessagePromptTemplate);
/**
 * Class that represents a placeholder for messages in a chat prompt. It
 * extends the BaseMessagePromptTemplate.
 */ parcelHelpers.export(exports, "MessagesPlaceholder", ()=>MessagesPlaceholder);
/**
 * Abstract class that serves as a base for creating message string prompt
 * templates. It extends the BaseMessagePromptTemplate.
 */ parcelHelpers.export(exports, "BaseMessageStringPromptTemplate", ()=>BaseMessageStringPromptTemplate);
/**
 * Abstract class that serves as a base for creating chat prompt
 * templates. It extends the BasePromptTemplate.
 */ parcelHelpers.export(exports, "BaseChatPromptTemplate", ()=>BaseChatPromptTemplate);
/**
 * Class that represents a chat message prompt template. It extends the
 * BaseMessageStringPromptTemplate.
 */ parcelHelpers.export(exports, "ChatMessagePromptTemplate", ()=>ChatMessagePromptTemplate);
/**
 * Class that represents a human message prompt template. It extends the
 * BaseMessageStringPromptTemplate.
 * @example
 * ```typescript
 * const message = HumanMessagePromptTemplate.fromTemplate("{text}");
 * const formatted = await message.format({ text: "Hello world!" });
 *
 * const chatPrompt = ChatPromptTemplate.fromMessages([message]);
 * const formattedChatPrompt = await chatPrompt.invoke({
 *   text: "Hello world!",
 * });
 * ```
 */ parcelHelpers.export(exports, "HumanMessagePromptTemplate", ()=>HumanMessagePromptTemplate);
/**
 * Class that represents an AI message prompt template. It extends the
 * BaseMessageStringPromptTemplate.
 */ parcelHelpers.export(exports, "AIMessagePromptTemplate", ()=>AIMessagePromptTemplate);
/**
 * Class that represents a system message prompt template. It extends the
 * BaseMessageStringPromptTemplate.
 * @example
 * ```typescript
 * const message = SystemMessagePromptTemplate.fromTemplate("{text}");
 * const formatted = await message.format({ text: "Hello world!" });
 *
 * const chatPrompt = ChatPromptTemplate.fromMessages([message]);
 * const formattedChatPrompt = await chatPrompt.invoke({
 *   text: "Hello world!",
 * });
 * ```
 */ parcelHelpers.export(exports, "SystemMessagePromptTemplate", ()=>SystemMessagePromptTemplate);
/**
 * Class that represents a chat prompt. It extends the
 * BaseChatPromptTemplate and uses an array of BaseMessagePromptTemplate
 * instances to format a series of messages for a conversation.
 * @example
 * ```typescript
 * const message = SystemMessagePromptTemplate.fromTemplate("{text}");
 * const chatPrompt = ChatPromptTemplate.fromMessages([
 *   ["ai", "You are a helpful assistant."],
 *   message,
 * ]);
 * const formattedChatPrompt = await chatPrompt.invoke({
 *   text: "Hello world!",
 * });
 * ```
 */ parcelHelpers.export(exports, "ChatPromptTemplate", ()=>ChatPromptTemplate);
var _indexJs = require("../messages/index.js");
var _promptValuesJs = require("../prompt_values.js");
var _baseJs = require("../runnables/base.js");
var _stringJs = require("./string.js");
var _baseJs1 = require("./base.js");
var _promptJs = require("./prompt.js");
var _imageJs = require("./image.js");
var _templateJs = require("./template.js");
var _indexJs1 = require("../errors/index.js");
class BaseMessagePromptTemplate extends (0, _baseJs.Runnable) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "prompts",
                "chat"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
    }
    /**
     * Calls the formatMessages method with the provided input and options.
     * @param input Input for the formatMessages method
     * @param options Optional BaseCallbackConfig
     * @returns Formatted output messages
     */ async invoke(input, options) {
        return this._callWithConfig((input)=>this.formatMessages(input), input, {
            ...options,
            runType: "prompt"
        });
    }
}
class MessagesPlaceholder extends BaseMessagePromptTemplate {
    static lc_name() {
        return "MessagesPlaceholder";
    }
    constructor(fields){
        if (typeof fields === "string") // eslint-disable-next-line no-param-reassign
        fields = {
            variableName: fields
        };
        super(fields);
        Object.defineProperty(this, "variableName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "optional", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.variableName = fields.variableName;
        this.optional = fields.optional ?? false;
    }
    get inputVariables() {
        return [
            this.variableName
        ];
    }
    async formatMessages(values) {
        const input = values[this.variableName];
        if (this.optional && !input) return [];
        else if (!input) {
            const error = new Error(`Field "${this.variableName}" in prompt uses a MessagesPlaceholder, which expects an array of BaseMessages as an input value. Received: undefined`);
            error.name = "InputFormatError";
            throw error;
        }
        let formattedMessages;
        try {
            if (Array.isArray(input)) formattedMessages = input.map((0, _indexJs.coerceMessageLikeToMessage));
            else formattedMessages = [
                (0, _indexJs.coerceMessageLikeToMessage)(input)
            ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            const readableInput = typeof input === "string" ? input : JSON.stringify(input, null, 2);
            const error = new Error([
                `Field "${this.variableName}" in prompt uses a MessagesPlaceholder, which expects an array of BaseMessages or coerceable values as input.`,
                `Received value: ${readableInput}`,
                `Additional message: ${e.message}`
            ].join("\n\n"));
            error.name = "InputFormatError";
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.lc_error_code = e.lc_error_code;
            throw error;
        }
        return formattedMessages;
    }
}
class BaseMessageStringPromptTemplate extends BaseMessagePromptTemplate {
    constructor(fields){
        if (!("prompt" in fields)) // eslint-disable-next-line no-param-reassign
        fields = {
            prompt: fields
        };
        super(fields);
        Object.defineProperty(this, "prompt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.prompt = fields.prompt;
    }
    get inputVariables() {
        return this.prompt.inputVariables;
    }
    async formatMessages(values) {
        return [
            await this.format(values)
        ];
    }
}
class BaseChatPromptTemplate extends (0, _baseJs1.BasePromptTemplate) {
    constructor(input){
        super(input);
    }
    async format(values) {
        return (await this.formatPromptValue(values)).toString();
    }
    async formatPromptValue(values) {
        const resultMessages = await this.formatMessages(values);
        return new (0, _promptValuesJs.ChatPromptValue)(resultMessages);
    }
}
class ChatMessagePromptTemplate extends BaseMessageStringPromptTemplate {
    static lc_name() {
        return "ChatMessagePromptTemplate";
    }
    constructor(fields, role){
        if (!("prompt" in fields)) // eslint-disable-next-line no-param-reassign, @typescript-eslint/no-non-null-assertion
        fields = {
            prompt: fields,
            role: role
        };
        super(fields);
        Object.defineProperty(this, "role", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.role = fields.role;
    }
    async format(values) {
        return new (0, _indexJs.ChatMessage)(await this.prompt.format(values), this.role);
    }
    static fromTemplate(template, role, options) {
        return new this((0, _promptJs.PromptTemplate).fromTemplate(template, {
            templateFormat: options?.templateFormat
        }), role);
    }
}
class _StringImageMessagePromptTemplate extends BaseMessagePromptTemplate {
    static _messageClass() {
        throw new Error("Can not invoke _messageClass from inside _StringImageMessagePromptTemplate");
    }
    constructor(/** @TODO When we come up with a better way to type prompt templates, fix this */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fields, additionalOptions){
        if (!("prompt" in fields)) // eslint-disable-next-line no-param-reassign
        fields = {
            prompt: fields
        };
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "prompts",
                "chat"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "inputVariables", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "additionalOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "prompt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "messageClass", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // ChatMessage contains role field, others don't.
        // Because of this, we have a separate class property for ChatMessage.
        Object.defineProperty(this, "chatMessageClass", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.prompt = fields.prompt;
        if (Array.isArray(this.prompt)) {
            let inputVariables = [];
            this.prompt.forEach((prompt)=>{
                if ("inputVariables" in prompt) inputVariables = inputVariables.concat(prompt.inputVariables);
            });
            this.inputVariables = inputVariables;
        } else this.inputVariables = this.prompt.inputVariables;
        this.additionalOptions = additionalOptions ?? this.additionalOptions;
    }
    createMessage(content) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const constructor = this.constructor;
        if (constructor._messageClass()) {
            const MsgClass = constructor._messageClass();
            return new MsgClass({
                content
            });
        } else if (constructor.chatMessageClass) {
            const MsgClass = constructor.chatMessageClass();
            // Assuming ChatMessage constructor also takes a content argument
            return new MsgClass({
                content,
                role: this.getRoleFromMessageClass(MsgClass.lc_name())
            });
        } else throw new Error("No message class defined");
    }
    getRoleFromMessageClass(name) {
        switch(name){
            case "HumanMessage":
                return "human";
            case "AIMessage":
                return "ai";
            case "SystemMessage":
                return "system";
            case "ChatMessage":
                return "chat";
            default:
                throw new Error("Invalid message class name");
        }
    }
    static fromTemplate(template, additionalOptions) {
        if (typeof template === "string") return new this((0, _promptJs.PromptTemplate).fromTemplate(template, additionalOptions));
        const prompt = [];
        for (const item of template){
            if (typeof item === "string" || typeof item === "object" && "text" in item) {
                let text = "";
                if (typeof item === "string") text = item;
                else if (typeof item.text === "string") text = item.text ?? "";
                const options = {
                    ...additionalOptions,
                    ...typeof item !== "string" ? {
                        additionalContentFields: item
                    } : {}
                };
                prompt.push((0, _promptJs.PromptTemplate).fromTemplate(text, options));
            } else if (typeof item === "object" && "image_url" in item) {
                let imgTemplate = item.image_url ?? "";
                let imgTemplateObject;
                let inputVariables = [];
                if (typeof imgTemplate === "string") {
                    let parsedTemplate;
                    if (additionalOptions?.templateFormat === "mustache") parsedTemplate = (0, _templateJs.parseMustache)(imgTemplate);
                    else parsedTemplate = (0, _templateJs.parseFString)(imgTemplate);
                    const variables = parsedTemplate.flatMap((item)=>item.type === "variable" ? [
                            item.name
                        ] : []);
                    if ((variables?.length ?? 0) > 0) {
                        if (variables.length > 1) throw new Error(`Only one format variable allowed per image template.\nGot: ${variables}\nFrom: ${imgTemplate}`);
                        inputVariables = [
                            variables[0]
                        ];
                    } else inputVariables = [];
                    imgTemplate = {
                        url: imgTemplate
                    };
                    imgTemplateObject = new (0, _imageJs.ImagePromptTemplate)({
                        template: imgTemplate,
                        inputVariables,
                        templateFormat: additionalOptions?.templateFormat,
                        additionalContentFields: item
                    });
                } else if (typeof imgTemplate === "object") {
                    if ("url" in imgTemplate) {
                        let parsedTemplate;
                        if (additionalOptions?.templateFormat === "mustache") parsedTemplate = (0, _templateJs.parseMustache)(imgTemplate.url);
                        else parsedTemplate = (0, _templateJs.parseFString)(imgTemplate.url);
                        inputVariables = parsedTemplate.flatMap((item)=>item.type === "variable" ? [
                                item.name
                            ] : []);
                    } else inputVariables = [];
                    imgTemplateObject = new (0, _imageJs.ImagePromptTemplate)({
                        template: imgTemplate,
                        inputVariables,
                        templateFormat: additionalOptions?.templateFormat,
                        additionalContentFields: item
                    });
                } else throw new Error("Invalid image template");
                prompt.push(imgTemplateObject);
            }
        }
        return new this({
            prompt,
            additionalOptions
        });
    }
    async format(input) {
        // eslint-disable-next-line no-instanceof/no-instanceof
        if (this.prompt instanceof (0, _stringJs.BaseStringPromptTemplate)) {
            const text = await this.prompt.format(input);
            return this.createMessage(text);
        } else {
            const content = [];
            for (const prompt of this.prompt){
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let inputs = {};
                if (!("inputVariables" in prompt)) throw new Error(`Prompt ${prompt} does not have inputVariables defined.`);
                for (const item of prompt.inputVariables){
                    if (!inputs) inputs = {
                        [item]: input[item]
                    };
                    inputs = {
                        ...inputs,
                        [item]: input[item]
                    };
                }
                // eslint-disable-next-line no-instanceof/no-instanceof
                if (prompt instanceof (0, _stringJs.BaseStringPromptTemplate)) {
                    const formatted = await prompt.format(inputs);
                    let additionalContentFields;
                    if ("additionalContentFields" in prompt) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    additionalContentFields = prompt.additionalContentFields;
                    content.push({
                        ...additionalContentFields,
                        type: "text",
                        text: formatted
                    });
                /** @TODO replace this */ // eslint-disable-next-line no-instanceof/no-instanceof
                } else if (prompt instanceof (0, _imageJs.ImagePromptTemplate)) {
                    const formatted = await prompt.format(inputs);
                    let additionalContentFields;
                    if ("additionalContentFields" in prompt) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    additionalContentFields = prompt.additionalContentFields;
                    content.push({
                        ...additionalContentFields,
                        type: "image_url",
                        image_url: formatted
                    });
                }
            }
            return this.createMessage(content);
        }
    }
    async formatMessages(values) {
        return [
            await this.format(values)
        ];
    }
}
class HumanMessagePromptTemplate extends _StringImageMessagePromptTemplate {
    static _messageClass() {
        return 0, _indexJs.HumanMessage;
    }
    static lc_name() {
        return "HumanMessagePromptTemplate";
    }
}
class AIMessagePromptTemplate extends _StringImageMessagePromptTemplate {
    static _messageClass() {
        return 0, _indexJs.AIMessage;
    }
    static lc_name() {
        return "AIMessagePromptTemplate";
    }
}
class SystemMessagePromptTemplate extends _StringImageMessagePromptTemplate {
    static _messageClass() {
        return 0, _indexJs.SystemMessage;
    }
    static lc_name() {
        return "SystemMessagePromptTemplate";
    }
}
function _isBaseMessagePromptTemplate(baseMessagePromptTemplateLike) {
    return typeof baseMessagePromptTemplateLike.formatMessages === "function";
}
function _coerceMessagePromptTemplateLike(messagePromptTemplateLike, extra) {
    if (_isBaseMessagePromptTemplate(messagePromptTemplateLike) || (0, _indexJs.isBaseMessage)(messagePromptTemplateLike)) return messagePromptTemplateLike;
    if (Array.isArray(messagePromptTemplateLike) && messagePromptTemplateLike[0] === "placeholder") {
        const messageContent = messagePromptTemplateLike[1];
        if (typeof messageContent !== "string" || messageContent[0] !== "{" || messageContent[messageContent.length - 1] !== "}") throw new Error(`Invalid placeholder template: "${messagePromptTemplateLike[1]}". Expected a variable name surrounded by curly braces.`);
        const variableName = messageContent.slice(1, -1);
        return new MessagesPlaceholder({
            variableName,
            optional: true
        });
    }
    const message = (0, _indexJs.coerceMessageLikeToMessage)(messagePromptTemplateLike);
    let templateData;
    if (typeof message.content === "string") templateData = message.content;
    else // Assuming message.content is an array of complex objects, transform it.
    templateData = message.content.map((item)=>{
        if ("text" in item) return {
            ...item,
            text: item.text
        };
        else if ("image_url" in item) return {
            ...item,
            image_url: item.image_url
        };
        else return item;
    });
    if (message._getType() === "human") return HumanMessagePromptTemplate.fromTemplate(templateData, extra);
    else if (message._getType() === "ai") return AIMessagePromptTemplate.fromTemplate(templateData, extra);
    else if (message._getType() === "system") return SystemMessagePromptTemplate.fromTemplate(templateData, extra);
    else if ((0, _indexJs.ChatMessage).isInstance(message)) return ChatMessagePromptTemplate.fromTemplate(message.content, message.role, extra);
    else throw new Error(`Could not coerce message prompt template from input. Received message type: "${message._getType()}".`);
}
function isMessagesPlaceholder(x) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return x.constructor.lc_name() === "MessagesPlaceholder";
}
class ChatPromptTemplate extends BaseChatPromptTemplate {
    static lc_name() {
        return "ChatPromptTemplate";
    }
    get lc_aliases() {
        return {
            promptMessages: "messages"
        };
    }
    constructor(input){
        super(input);
        Object.defineProperty(this, "promptMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "validateTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "templateFormat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "f-string"
        });
        // If input is mustache and validateTemplate is not defined, set it to false
        if (input.templateFormat === "mustache" && input.validateTemplate === undefined) this.validateTemplate = false;
        Object.assign(this, input);
        if (this.validateTemplate) {
            const inputVariablesMessages = new Set();
            for (const promptMessage of this.promptMessages){
                // eslint-disable-next-line no-instanceof/no-instanceof
                if (promptMessage instanceof (0, _indexJs.BaseMessage)) continue;
                for (const inputVariable of promptMessage.inputVariables)inputVariablesMessages.add(inputVariable);
            }
            const totalInputVariables = this.inputVariables;
            const inputVariablesInstance = new Set(this.partialVariables ? totalInputVariables.concat(Object.keys(this.partialVariables)) : totalInputVariables);
            const difference = new Set([
                ...inputVariablesInstance
            ].filter((x)=>!inputVariablesMessages.has(x)));
            if (difference.size > 0) throw new Error(`Input variables \`${[
                ...difference
            ]}\` are not used in any of the prompt messages.`);
            const otherDifference = new Set([
                ...inputVariablesMessages
            ].filter((x)=>!inputVariablesInstance.has(x)));
            if (otherDifference.size > 0) throw new Error(`Input variables \`${[
                ...otherDifference
            ]}\` are used in prompt messages but not in the prompt template.`);
        }
    }
    _getPromptType() {
        return "chat";
    }
    async _parseImagePrompts(message, inputValues) {
        if (typeof message.content === "string") return message;
        const formattedMessageContent = await Promise.all(message.content.map(async (item)=>{
            if (item.type !== "image_url") return item;
            let imageUrl = "";
            if (typeof item.image_url === "string") imageUrl = item.image_url;
            else imageUrl = item.image_url.url;
            const promptTemplatePlaceholder = (0, _promptJs.PromptTemplate).fromTemplate(imageUrl, {
                templateFormat: this.templateFormat
            });
            const formattedUrl = await promptTemplatePlaceholder.format(inputValues);
            if (typeof item.image_url !== "string" && "url" in item.image_url) // eslint-disable-next-line no-param-reassign
            item.image_url.url = formattedUrl;
            else // eslint-disable-next-line no-param-reassign
            item.image_url = formattedUrl;
            return item;
        }));
        // eslint-disable-next-line no-param-reassign
        message.content = formattedMessageContent;
        return message;
    }
    async formatMessages(values) {
        const allValues = await this.mergePartialAndUserVariables(values);
        let resultMessages = [];
        for (const promptMessage of this.promptMessages)// eslint-disable-next-line no-instanceof/no-instanceof
        if (promptMessage instanceof (0, _indexJs.BaseMessage)) resultMessages.push(await this._parseImagePrompts(promptMessage, allValues));
        else {
            const inputValues = promptMessage.inputVariables.reduce((acc, inputVariable)=>{
                if (!(inputVariable in allValues) && !(isMessagesPlaceholder(promptMessage) && promptMessage.optional)) {
                    const error = (0, _indexJs1.addLangChainErrorFields)(new Error(`Missing value for input variable \`${inputVariable.toString()}\``), "INVALID_PROMPT_INPUT");
                    throw error;
                }
                acc[inputVariable] = allValues[inputVariable];
                return acc;
            }, {});
            const message = await promptMessage.formatMessages(inputValues);
            resultMessages = resultMessages.concat(message);
        }
        return resultMessages;
    }
    async partial(values) {
        // This is implemented in a way it doesn't require making
        // BaseMessagePromptTemplate aware of .partial()
        const newInputVariables = this.inputVariables.filter((iv)=>!(iv in values));
        const newPartialVariables = {
            ...this.partialVariables ?? {},
            ...values
        };
        const promptDict = {
            ...this,
            inputVariables: newInputVariables,
            partialVariables: newPartialVariables
        };
        return new ChatPromptTemplate(promptDict);
    }
    static fromTemplate(template, options) {
        const prompt = (0, _promptJs.PromptTemplate).fromTemplate(template, options);
        const humanTemplate = new HumanMessagePromptTemplate({
            prompt
        });
        return this.fromMessages([
            humanTemplate
        ]);
    }
    /**
     * Create a chat model-specific prompt from individual chat messages
     * or message-like tuples.
     * @param promptMessages Messages to be passed to the chat model
     * @returns A new ChatPromptTemplate
     */ static fromMessages(promptMessages, extra) {
        const flattenedMessages = promptMessages.reduce((acc, promptMessage)=>acc.concat(// eslint-disable-next-line no-instanceof/no-instanceof
            promptMessage instanceof ChatPromptTemplate ? promptMessage.promptMessages : [
                _coerceMessagePromptTemplateLike(promptMessage, extra)
            ]), []);
        const flattenedPartialVariables = promptMessages.reduce((acc, promptMessage)=>// eslint-disable-next-line no-instanceof/no-instanceof
            promptMessage instanceof ChatPromptTemplate ? Object.assign(acc, promptMessage.partialVariables) : acc, Object.create(null));
        const inputVariables = new Set();
        for (const promptMessage of flattenedMessages){
            // eslint-disable-next-line no-instanceof/no-instanceof
            if (promptMessage instanceof (0, _indexJs.BaseMessage)) continue;
            for (const inputVariable of promptMessage.inputVariables){
                if (inputVariable in flattenedPartialVariables) continue;
                inputVariables.add(inputVariable);
            }
        }
        return new this({
            ...extra,
            inputVariables: [
                ...inputVariables
            ],
            promptMessages: flattenedMessages,
            partialVariables: flattenedPartialVariables,
            templateFormat: extra?.templateFormat
        });
    }
    /** @deprecated Renamed to .fromMessages */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static fromPromptMessages(promptMessages) {
        return this.fromMessages(promptMessages);
    }
}

},{"../messages/index.js":"7XzBK","../prompt_values.js":"lY5Gs","../runnables/base.js":"9xkzz","./string.js":"fMbzg","./base.js":"aJ9Ap","./prompt.js":"9hvf6","./image.js":"hRbX2","./template.js":"ii6yk","../errors/index.js":"cgnw3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fMbzg":[function(require,module,exports,__globalThis) {
// Default generic "any" values are for backwards compatibility.
// Replace with "string" when we are comfortable with a breaking change.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Base class for string prompt templates. It extends the
 * BasePromptTemplate class and overrides the formatPromptValue method to
 * return a StringPromptValue.
 */ parcelHelpers.export(exports, "BaseStringPromptTemplate", ()=>BaseStringPromptTemplate);
var _promptValuesJs = require("../prompt_values.js");
var _baseJs = require("./base.js");
class BaseStringPromptTemplate extends (0, _baseJs.BasePromptTemplate) {
    /**
     * Formats the prompt given the input values and returns a formatted
     * prompt value.
     * @param values The input values to format the prompt.
     * @returns A Promise that resolves to a formatted prompt value.
     */ async formatPromptValue(values) {
        const formattedPrompt = await this.format(values);
        return new (0, _promptValuesJs.StringPromptValue)(formattedPrompt);
    }
}

},{"../prompt_values.js":"lY5Gs","./base.js":"aJ9Ap","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9hvf6":[function(require,module,exports,__globalThis) {
// Default generic "any" values are for backwards compatibility.
// Replace with "string" when we are comfortable with a breaking change.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Schema to represent a basic prompt for an LLM.
 * @augments BasePromptTemplate
 * @augments PromptTemplateInput
 *
 * @example
 * ```ts
 * import { PromptTemplate } from "langchain/prompts";
 *
 * const prompt = new PromptTemplate({
 *   inputVariables: ["foo"],
 *   template: "Say {foo}",
 * });
 * ```
 */ parcelHelpers.export(exports, "PromptTemplate", ()=>PromptTemplate);
var _stringJs = require("./string.js");
var _templateJs = require("./template.js");
class PromptTemplate extends (0, _stringJs.BaseStringPromptTemplate) {
    static lc_name() {
        return "PromptTemplate";
    }
    constructor(input){
        super(input);
        Object.defineProperty(this, "template", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "templateFormat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "f-string"
        });
        Object.defineProperty(this, "validateTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        /**
         * Additional fields which should be included inside
         * the message content array if using a complex message
         * content.
         */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "additionalContentFields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // If input is mustache and validateTemplate is not defined, set it to false
        if (input.templateFormat === "mustache" && input.validateTemplate === undefined) this.validateTemplate = false;
        Object.assign(this, input);
        if (this.validateTemplate) {
            if (this.templateFormat === "mustache") throw new Error("Mustache templates cannot be validated.");
            let totalInputVariables = this.inputVariables;
            if (this.partialVariables) totalInputVariables = totalInputVariables.concat(Object.keys(this.partialVariables));
            (0, _templateJs.checkValidTemplate)(this.template, this.templateFormat, totalInputVariables);
        }
    }
    _getPromptType() {
        return "prompt";
    }
    /**
     * Formats the prompt template with the provided values.
     * @param values The values to be used to format the prompt template.
     * @returns A promise that resolves to a string which is the formatted prompt.
     */ async format(values) {
        const allValues = await this.mergePartialAndUserVariables(values);
        return (0, _templateJs.renderTemplate)(this.template, this.templateFormat, allValues);
    }
    /**
     * Take examples in list format with prefix and suffix to create a prompt.
     *
     * Intended to be used a a way to dynamically create a prompt from examples.
     *
     * @param examples - List of examples to use in the prompt.
     * @param suffix - String to go after the list of examples. Should generally set up the user's input.
     * @param inputVariables - A list of variable names the final prompt template will expect
     * @param exampleSeparator - The separator to use in between examples
     * @param prefix - String that should go before any examples. Generally includes examples.
     *
     * @returns The final prompt template generated.
     */ static fromExamples(examples, suffix, inputVariables, exampleSeparator = "\n\n", prefix = "") {
        const template = [
            prefix,
            ...examples,
            suffix
        ].join(exampleSeparator);
        return new PromptTemplate({
            inputVariables,
            template
        });
    }
    static fromTemplate(template, options) {
        const { templateFormat = "f-string", ...rest } = options ?? {};
        const names = new Set();
        (0, _templateJs.parseTemplate)(template, templateFormat).forEach((node)=>{
            if (node.type === "variable") names.add(node.name);
        });
        return new PromptTemplate({
            // Rely on extracted types
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            inputVariables: [
                ...names
            ],
            templateFormat,
            template,
            ...rest
        });
    }
    /**
     * Partially applies values to the prompt template.
     * @param values The values to be partially applied to the prompt template.
     * @returns A new instance of PromptTemplate with the partially applied values.
     */ async partial(values) {
        const newInputVariables = this.inputVariables.filter((iv)=>!(iv in values));
        const newPartialVariables = {
            ...this.partialVariables ?? {},
            ...values
        };
        const promptDict = {
            ...this,
            inputVariables: newInputVariables,
            partialVariables: newPartialVariables
        };
        return new PromptTemplate(promptDict);
    }
    serialize() {
        if (this.outputParser !== undefined) throw new Error("Cannot serialize a prompt template with an output parser");
        return {
            _type: this._getPromptType(),
            input_variables: this.inputVariables,
            template: this.template,
            template_format: this.templateFormat
        };
    }
    static async deserialize(data) {
        if (!data.template) throw new Error("Prompt template must have a template");
        const res = new PromptTemplate({
            inputVariables: data.input_variables,
            template: data.template,
            templateFormat: data.template_format
        });
        return res;
    }
}

},{"./string.js":"fMbzg","./template.js":"ii6yk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ii6yk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseFString", ()=>parseFString);
parcelHelpers.export(exports, "parseMustache", ()=>parseMustache);
parcelHelpers.export(exports, "interpolateFString", ()=>interpolateFString);
parcelHelpers.export(exports, "interpolateMustache", ()=>interpolateMustache);
parcelHelpers.export(exports, "DEFAULT_FORMATTER_MAPPING", ()=>DEFAULT_FORMATTER_MAPPING);
parcelHelpers.export(exports, "DEFAULT_PARSER_MAPPING", ()=>DEFAULT_PARSER_MAPPING);
parcelHelpers.export(exports, "renderTemplate", ()=>renderTemplate);
parcelHelpers.export(exports, "parseTemplate", ()=>parseTemplate);
parcelHelpers.export(exports, "checkValidTemplate", ()=>checkValidTemplate);
var _mustache = require("mustache");
var _mustacheDefault = parcelHelpers.interopDefault(_mustache);
var _indexJs = require("../errors/index.js");
function configureMustache() {
    // Use unescaped HTML
    // https://github.com/janl/mustache.js?tab=readme-ov-file#variables
    (0, _mustacheDefault.default).escape = (text)=>text;
}
const parseFString = (template)=>{
    // Core logic replicated from internals of pythons built in Formatter class.
    // https://github.com/python/cpython/blob/135ec7cefbaffd516b77362ad2b2ad1025af462e/Objects/stringlib/unicode_format.h#L700-L706
    const chars = template.split("");
    const nodes = [];
    const nextBracket = (bracket, start)=>{
        for(let i = start; i < chars.length; i += 1){
            if (bracket.includes(chars[i])) return i;
        }
        return -1;
    };
    let i = 0;
    while(i < chars.length){
        if (chars[i] === "{" && i + 1 < chars.length && chars[i + 1] === "{") {
            nodes.push({
                type: "literal",
                text: "{"
            });
            i += 2;
        } else if (chars[i] === "}" && i + 1 < chars.length && chars[i + 1] === "}") {
            nodes.push({
                type: "literal",
                text: "}"
            });
            i += 2;
        } else if (chars[i] === "{") {
            const j = nextBracket("}", i);
            if (j < 0) throw new Error("Unclosed '{' in template.");
            nodes.push({
                type: "variable",
                name: chars.slice(i + 1, j).join("")
            });
            i = j + 1;
        } else if (chars[i] === "}") throw new Error("Single '}' in template.");
        else {
            const next = nextBracket("{}", i);
            const text = (next < 0 ? chars.slice(i) : chars.slice(i, next)).join("");
            nodes.push({
                type: "literal",
                text
            });
            i = next < 0 ? chars.length : next;
        }
    }
    return nodes;
};
/**
 * Convert the result of mustache.parse into an array of ParsedTemplateNode,
 * to make it compatible with other LangChain string parsing template formats.
 *
 * @param {mustache.TemplateSpans} template The result of parsing a mustache template with the mustache.js library.
 * @returns {ParsedTemplateNode[]}
 */ const mustacheTemplateToNodes = (template)=>template.map((temp)=>{
        if (temp[0] === "name") {
            const name = temp[1].includes(".") ? temp[1].split(".")[0] : temp[1];
            return {
                type: "variable",
                name
            };
        } else if ([
            "#",
            "&",
            "^",
            ">"
        ].includes(temp[0])) // # represents a section, "&" represents an unescaped variable.
        // These should both be considered variables.
        return {
            type: "variable",
            name: temp[1]
        };
        else return {
            type: "literal",
            text: temp[1]
        };
    });
const parseMustache = (template)=>{
    configureMustache();
    const parsed = (0, _mustacheDefault.default).parse(template);
    return mustacheTemplateToNodes(parsed);
};
const interpolateFString = (template, values)=>{
    return parseFString(template).reduce((res, node)=>{
        if (node.type === "variable") {
            if (node.name in values) {
                const stringValue = typeof values[node.name] === "string" ? values[node.name] : JSON.stringify(values[node.name]);
                return res + stringValue;
            }
            throw new Error(`(f-string) Missing value for input ${node.name}`);
        }
        return res + node.text;
    }, "");
};
const interpolateMustache = (template, values)=>{
    configureMustache();
    return (0, _mustacheDefault.default).render(template, values);
};
const DEFAULT_FORMATTER_MAPPING = {
    "f-string": interpolateFString,
    mustache: interpolateMustache
};
const DEFAULT_PARSER_MAPPING = {
    "f-string": parseFString,
    mustache: parseMustache
};
const renderTemplate = (template, templateFormat, inputValues)=>{
    try {
        return DEFAULT_FORMATTER_MAPPING[templateFormat](template, inputValues);
    } catch (e) {
        const error = (0, _indexJs.addLangChainErrorFields)(e, "INVALID_PROMPT_INPUT");
        throw error;
    }
};
const parseTemplate = (template, templateFormat)=>DEFAULT_PARSER_MAPPING[templateFormat](template);
const checkValidTemplate = (template, templateFormat, inputVariables)=>{
    if (!(templateFormat in DEFAULT_FORMATTER_MAPPING)) {
        const validFormats = Object.keys(DEFAULT_FORMATTER_MAPPING);
        throw new Error(`Invalid template format. Got \`${templateFormat}\`;
                         should be one of ${validFormats}`);
    }
    try {
        const dummyInputs = inputVariables.reduce((acc, v)=>{
            acc[v] = "foo";
            return acc;
        }, {});
        if (Array.isArray(template)) template.forEach((message)=>{
            if (message.type === "text") renderTemplate(message.text, templateFormat, dummyInputs);
            else if (message.type === "image_url") {
                if (typeof message.image_url === "string") renderTemplate(message.image_url, templateFormat, dummyInputs);
                else {
                    const imageUrl = message.image_url.url;
                    renderTemplate(imageUrl, templateFormat, dummyInputs);
                }
            } else throw new Error(`Invalid message template received. ${JSON.stringify(message, null, 2)}`);
        });
        else renderTemplate(template, templateFormat, dummyInputs);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        throw new Error(`Invalid prompt schema: ${e.message}`);
    }
};

},{"mustache":"4fL8o","../errors/index.js":"cgnw3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4fL8o":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === '[object Array]';
    };
    function isFunction(object) {
        return typeof object === 'function';
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? 'array' : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === 'object' && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== 'object' && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ''; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === 'string') tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error('Invalid tags: ' + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
            closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += ' ';
                }
                tokens.push([
                    'text',
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === '\n') {
                    stripSpace();
                    indentation = '';
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || 'name';
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === '=') {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === '{') {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = '&';
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error('Unclosed tag at ' + scanner.pos);
            if (type == '>') token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === '#' || type === '^') sections.push(token);
            else if (type === '/') {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === 'name' || type === '{' || type === '&') nonSpace = true;
            else if (type === '=') // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case '#':
                case '^':
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case '/':
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === '';
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return '';
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = '';
                break;
            case 0:
                match = '';
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            '.': this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf('.') > 0) {
                    intermediateValue = context.view;
                    names = name.split('.');
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== 'undefined') this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ':' + (tags || mustache.tags).join(':');
        var isCacheEnabled = typeof cache1 !== 'undefined';
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = '';
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === '>') value = this.renderPartial(token, context, partials, config);
            else if (symbol === '&') value = this.unescapedValue(token, context);
            else if (symbol === 'name') value = this.escapedValue(token, context, config);
            else if (symbol === 'text') value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = '';
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== 'string') throw new Error('Cannot use higher-order sections without the original template');
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, '');
        var partialByNl = partial.split('\n');
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join('\n');
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === 'number' && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === 'object') return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === 'object' && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: 'mustache.js',
        version: '4.2.0',
        tags: [
            '{{',
            '}}'
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== 'string') throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + 'argument for mustache#render(template, view, partials)');
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});

},{}],"hRbX2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An image prompt template for a multimodal model.
 */ parcelHelpers.export(exports, "ImagePromptTemplate", ()=>ImagePromptTemplate);
var _promptValuesJs = require("../prompt_values.js");
var _baseJs = require("./base.js");
var _templateJs = require("./template.js");
class ImagePromptTemplate extends (0, _baseJs.BasePromptTemplate) {
    static lc_name() {
        return "ImagePromptTemplate";
    }
    constructor(input){
        super(input);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "prompts",
                "image"
            ]
        });
        Object.defineProperty(this, "template", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "templateFormat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "f-string"
        });
        Object.defineProperty(this, "validateTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        /**
         * Additional fields which should be included inside
         * the message content array if using a complex message
         * content.
         */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "additionalContentFields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.template = input.template;
        this.templateFormat = input.templateFormat ?? this.templateFormat;
        this.validateTemplate = input.validateTemplate ?? this.validateTemplate;
        this.additionalContentFields = input.additionalContentFields;
        if (this.validateTemplate) {
            let totalInputVariables = this.inputVariables;
            if (this.partialVariables) totalInputVariables = totalInputVariables.concat(Object.keys(this.partialVariables));
            (0, _templateJs.checkValidTemplate)([
                {
                    type: "image_url",
                    image_url: this.template
                }
            ], this.templateFormat, totalInputVariables);
        }
    }
    _getPromptType() {
        return "prompt";
    }
    /**
     * Partially applies values to the prompt template.
     * @param values The values to be partially applied to the prompt template.
     * @returns A new instance of ImagePromptTemplate with the partially applied values.
     */ async partial(values) {
        const newInputVariables = this.inputVariables.filter((iv)=>!(iv in values));
        const newPartialVariables = {
            ...this.partialVariables ?? {},
            ...values
        };
        const promptDict = {
            ...this,
            inputVariables: newInputVariables,
            partialVariables: newPartialVariables
        };
        return new ImagePromptTemplate(promptDict);
    }
    /**
     * Formats the prompt template with the provided values.
     * @param values The values to be used to format the prompt template.
     * @returns A promise that resolves to a string which is the formatted prompt.
     */ async format(values) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const formatted = {};
        for (const [key, value] of Object.entries(this.template))if (typeof value === "string") formatted[key] = (0, _templateJs.renderTemplate)(value, this.templateFormat, values);
        else formatted[key] = value;
        const url = values.url || formatted.url;
        const detail = values.detail || formatted.detail;
        if (!url) throw new Error("Must provide either an image URL.");
        if (typeof url !== "string") throw new Error("url must be a string.");
        const output = {
            url
        };
        if (detail) output.detail = detail;
        return output;
    }
    /**
     * Formats the prompt given the input values and returns a formatted
     * prompt value.
     * @param values The input values to format the prompt.
     * @returns A Promise that resolves to a formatted prompt value.
     */ async formatPromptValue(values) {
        const formattedPrompt = await this.format(values);
        return new (0, _promptValuesJs.ImagePromptValue)(formattedPrompt);
    }
}

},{"../prompt_values.js":"lY5Gs","./base.js":"aJ9Ap","./template.js":"ii6yk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cxYFF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Prompt template that contains few-shot examples.
 * @augments BasePromptTemplate
 * @augments FewShotPromptTemplateInput
 * @example
 * ```typescript
 * const examplePrompt = PromptTemplate.fromTemplate(
 *   "Input: {input}\nOutput: {output}",
 * );
 *
 * const exampleSelector = await SemanticSimilarityExampleSelector.fromExamples(
 *   [
 *     { input: "happy", output: "sad" },
 *     { input: "tall", output: "short" },
 *     { input: "energetic", output: "lethargic" },
 *     { input: "sunny", output: "gloomy" },
 *     { input: "windy", output: "calm" },
 *   ],
 *   new OpenAIEmbeddings(),
 *   HNSWLib,
 *   { k: 1 },
 * );
 *
 * const dynamicPrompt = new FewShotPromptTemplate({
 *   exampleSelector,
 *   examplePrompt,
 *   prefix: "Give the antonym of every input",
 *   suffix: "Input: {adjective}\nOutput:",
 *   inputVariables: ["adjective"],
 * });
 *
 * // Format the dynamic prompt with the input 'rainy'
 * console.log(await dynamicPrompt.format({ adjective: "rainy" }));
 *
 * ```
 */ parcelHelpers.export(exports, "FewShotPromptTemplate", ()=>FewShotPromptTemplate);
/**
 * Chat prompt template that contains few-shot examples.
 * @augments BasePromptTemplateInput
 * @augments FewShotChatMessagePromptTemplateInput
 */ parcelHelpers.export(exports, "FewShotChatMessagePromptTemplate", ()=>FewShotChatMessagePromptTemplate);
var _stringJs = require("./string.js");
var _templateJs = require("./template.js");
var _promptJs = require("./prompt.js");
var _chatJs = require("./chat.js");
class FewShotPromptTemplate extends (0, _stringJs.BaseStringPromptTemplate) {
    constructor(input){
        super(input);
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "examples", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exampleSelector", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "examplePrompt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "suffix", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "exampleSeparator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "\n\n"
        });
        Object.defineProperty(this, "prefix", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "templateFormat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "f-string"
        });
        Object.defineProperty(this, "validateTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.assign(this, input);
        if (this.examples !== undefined && this.exampleSelector !== undefined) throw new Error("Only one of 'examples' and 'example_selector' should be provided");
        if (this.examples === undefined && this.exampleSelector === undefined) throw new Error("One of 'examples' and 'example_selector' should be provided");
        if (this.validateTemplate) {
            let totalInputVariables = this.inputVariables;
            if (this.partialVariables) totalInputVariables = totalInputVariables.concat(Object.keys(this.partialVariables));
            (0, _templateJs.checkValidTemplate)(this.prefix + this.suffix, this.templateFormat, totalInputVariables);
        }
    }
    _getPromptType() {
        return "few_shot";
    }
    static lc_name() {
        return "FewShotPromptTemplate";
    }
    async getExamples(inputVariables) {
        if (this.examples !== undefined) return this.examples;
        if (this.exampleSelector !== undefined) return this.exampleSelector.selectExamples(inputVariables);
        throw new Error("One of 'examples' and 'example_selector' should be provided");
    }
    async partial(values) {
        const newInputVariables = this.inputVariables.filter((iv)=>!(iv in values));
        const newPartialVariables = {
            ...this.partialVariables ?? {},
            ...values
        };
        const promptDict = {
            ...this,
            inputVariables: newInputVariables,
            partialVariables: newPartialVariables
        };
        return new FewShotPromptTemplate(promptDict);
    }
    /**
     * Formats the prompt with the given values.
     * @param values The values to format the prompt with.
     * @returns A promise that resolves to a string representing the formatted prompt.
     */ async format(values) {
        const allValues = await this.mergePartialAndUserVariables(values);
        const examples = await this.getExamples(allValues);
        const exampleStrings = await Promise.all(examples.map((example)=>this.examplePrompt.format(example)));
        const template = [
            this.prefix,
            ...exampleStrings,
            this.suffix
        ].join(this.exampleSeparator);
        return (0, _templateJs.renderTemplate)(template, this.templateFormat, allValues);
    }
    serialize() {
        if (this.exampleSelector || !this.examples) throw new Error("Serializing an example selector is not currently supported");
        if (this.outputParser !== undefined) throw new Error("Serializing an output parser is not currently supported");
        return {
            _type: this._getPromptType(),
            input_variables: this.inputVariables,
            example_prompt: this.examplePrompt.serialize(),
            example_separator: this.exampleSeparator,
            suffix: this.suffix,
            prefix: this.prefix,
            template_format: this.templateFormat,
            examples: this.examples
        };
    }
    static async deserialize(data) {
        const { example_prompt } = data;
        if (!example_prompt) throw new Error("Missing example prompt");
        const examplePrompt = await (0, _promptJs.PromptTemplate).deserialize(example_prompt);
        let examples;
        if (Array.isArray(data.examples)) examples = data.examples;
        else throw new Error("Invalid examples format. Only list or string are supported.");
        return new FewShotPromptTemplate({
            inputVariables: data.input_variables,
            examplePrompt,
            examples,
            exampleSeparator: data.example_separator,
            prefix: data.prefix,
            suffix: data.suffix,
            templateFormat: data.template_format
        });
    }
}
class FewShotChatMessagePromptTemplate extends (0, _chatJs.BaseChatPromptTemplate) {
    _getPromptType() {
        return "few_shot_chat";
    }
    static lc_name() {
        return "FewShotChatMessagePromptTemplate";
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "examples", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exampleSelector", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "examplePrompt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "suffix", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "exampleSeparator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "\n\n"
        });
        Object.defineProperty(this, "prefix", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "templateFormat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "f-string"
        });
        Object.defineProperty(this, "validateTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        this.examples = fields.examples;
        this.examplePrompt = fields.examplePrompt;
        this.exampleSeparator = fields.exampleSeparator ?? "\n\n";
        this.exampleSelector = fields.exampleSelector;
        this.prefix = fields.prefix ?? "";
        this.suffix = fields.suffix ?? "";
        this.templateFormat = fields.templateFormat ?? "f-string";
        this.validateTemplate = fields.validateTemplate ?? true;
        if (this.examples !== undefined && this.exampleSelector !== undefined) throw new Error("Only one of 'examples' and 'example_selector' should be provided");
        if (this.examples === undefined && this.exampleSelector === undefined) throw new Error("One of 'examples' and 'example_selector' should be provided");
        if (this.validateTemplate) {
            let totalInputVariables = this.inputVariables;
            if (this.partialVariables) totalInputVariables = totalInputVariables.concat(Object.keys(this.partialVariables));
            (0, _templateJs.checkValidTemplate)(this.prefix + this.suffix, this.templateFormat, totalInputVariables);
        }
    }
    async getExamples(inputVariables) {
        if (this.examples !== undefined) return this.examples;
        if (this.exampleSelector !== undefined) return this.exampleSelector.selectExamples(inputVariables);
        throw new Error("One of 'examples' and 'example_selector' should be provided");
    }
    /**
     * Formats the list of values and returns a list of formatted messages.
     * @param values The values to format the prompt with.
     * @returns A promise that resolves to a string representing the formatted prompt.
     */ async formatMessages(values) {
        const allValues = await this.mergePartialAndUserVariables(values);
        let examples = await this.getExamples(allValues);
        examples = examples.map((example)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const result = {};
            this.examplePrompt.inputVariables.forEach((inputVariable)=>{
                result[inputVariable] = example[inputVariable];
            });
            return result;
        });
        const messages = [];
        for (const example of examples){
            const exampleMessages = await this.examplePrompt.formatMessages(example);
            messages.push(...exampleMessages);
        }
        return messages;
    }
    /**
     * Formats the prompt with the given values.
     * @param values The values to format the prompt with.
     * @returns A promise that resolves to a string representing the formatted prompt.
     */ async format(values) {
        const allValues = await this.mergePartialAndUserVariables(values);
        const examples = await this.getExamples(allValues);
        const exampleMessages = await Promise.all(examples.map((example)=>this.examplePrompt.formatMessages(example)));
        const exampleStrings = exampleMessages.flat().map((message)=>message.content);
        const template = [
            this.prefix,
            ...exampleStrings,
            this.suffix
        ].join(this.exampleSeparator);
        return (0, _templateJs.renderTemplate)(template, this.templateFormat, allValues);
    }
    /**
     * Partially formats the prompt with the given values.
     * @param values The values to partially format the prompt with.
     * @returns A promise that resolves to an instance of `FewShotChatMessagePromptTemplate` with the given values partially formatted.
     */ async partial(values) {
        const newInputVariables = this.inputVariables.filter((variable)=>!(variable in values));
        const newPartialVariables = {
            ...this.partialVariables ?? {},
            ...values
        };
        const promptDict = {
            ...this,
            inputVariables: newInputVariables,
            partialVariables: newPartialVariables
        };
        return new FewShotChatMessagePromptTemplate(promptDict);
    }
}

},{"./string.js":"fMbzg","./template.js":"ii6yk","./prompt.js":"9hvf6","./chat.js":"9KL2r","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f17cb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Class that handles a sequence of prompts, each of which may require
 * different input variables. Includes methods for formatting these
 * prompts, extracting required input values, and handling partial
 * prompts.
 * @example
 * ```typescript
 * const composedPrompt = new PipelinePromptTemplate({
 *   pipelinePrompts: [
 *     {
 *       name: "introduction",
 *       prompt: PromptTemplate.fromTemplate(`You are impersonating {person}.`),
 *     },
 *     {
 *       name: "example",
 *       prompt: PromptTemplate.fromTemplate(
 *         `Here's an example of an interaction:
 * Q: {example_q}
 * A: {example_a}`,
 *       ),
 *     },
 *     {
 *       name: "start",
 *       prompt: PromptTemplate.fromTemplate(
 *         `Now, do this for real!
 * Q: {input}
 * A:`,
 *       ),
 *     },
 *   ],
 *   finalPrompt: PromptTemplate.fromTemplate(
 *     `{introduction}
 * {example}
 * {start}`,
 *   ),
 * });
 *
 * const formattedPrompt = await composedPrompt.format({
 *   person: "Elon Musk",
 *   example_q: `What's your favorite car?`,
 *   example_a: "Tesla",
 *   input: `What's your favorite social media site?`,
 * });
 * ```
 */ parcelHelpers.export(exports, "PipelinePromptTemplate", ()=>PipelinePromptTemplate);
var _baseJs = require("./base.js");
var _chatJs = require("./chat.js");
class PipelinePromptTemplate extends (0, _baseJs.BasePromptTemplate) {
    static lc_name() {
        return "PipelinePromptTemplate";
    }
    constructor(input){
        super({
            ...input,
            inputVariables: []
        });
        Object.defineProperty(this, "pipelinePrompts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "finalPrompt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.pipelinePrompts = input.pipelinePrompts;
        this.finalPrompt = input.finalPrompt;
        this.inputVariables = this.computeInputValues();
    }
    /**
     * Computes the input values required by the pipeline prompts.
     * @returns Array of input values required by the pipeline prompts.
     */ computeInputValues() {
        const intermediateValues = this.pipelinePrompts.map((pipelinePrompt)=>pipelinePrompt.name);
        const inputValues = this.pipelinePrompts.map((pipelinePrompt)=>pipelinePrompt.prompt.inputVariables.filter((inputValue)=>!intermediateValues.includes(inputValue))).flat();
        return [
            ...new Set(inputValues)
        ];
    }
    static extractRequiredInputValues(allValues, requiredValueNames) {
        return requiredValueNames.reduce((requiredValues, valueName)=>{
            // eslint-disable-next-line no-param-reassign
            requiredValues[valueName] = allValues[valueName];
            return requiredValues;
        }, {});
    }
    /**
     * Formats the pipeline prompts based on the provided input values.
     * @param values Input values to format the pipeline prompts.
     * @returns Promise that resolves with the formatted input values.
     */ async formatPipelinePrompts(values) {
        const allValues = await this.mergePartialAndUserVariables(values);
        for (const { name: pipelinePromptName, prompt: pipelinePrompt } of this.pipelinePrompts){
            const pipelinePromptInputValues = PipelinePromptTemplate.extractRequiredInputValues(allValues, pipelinePrompt.inputVariables);
            // eslint-disable-next-line no-instanceof/no-instanceof
            if (pipelinePrompt instanceof (0, _chatJs.ChatPromptTemplate)) allValues[pipelinePromptName] = await pipelinePrompt.formatMessages(pipelinePromptInputValues);
            else allValues[pipelinePromptName] = await pipelinePrompt.format(pipelinePromptInputValues);
        }
        return PipelinePromptTemplate.extractRequiredInputValues(allValues, this.finalPrompt.inputVariables);
    }
    /**
     * Formats the final prompt value based on the provided input values.
     * @param values Input values to format the final prompt value.
     * @returns Promise that resolves with the formatted final prompt value.
     */ async formatPromptValue(values) {
        return this.finalPrompt.formatPromptValue(await this.formatPipelinePrompts(values));
    }
    async format(values) {
        return this.finalPrompt.format(await this.formatPipelinePrompts(values));
    }
    /**
     * Handles partial prompts, which are prompts that have been partially
     * filled with input values.
     * @param values Partial input values.
     * @returns Promise that resolves with a new PipelinePromptTemplate instance with updated input variables.
     */ async partial(values) {
        const promptDict = {
            ...this
        };
        promptDict.inputVariables = this.inputVariables.filter((iv)=>!(iv in values));
        promptDict.partialVariables = {
            ...this.partialVariables ?? {},
            ...values
        };
        return new PipelinePromptTemplate(promptDict);
    }
    serialize() {
        throw new Error("Not implemented.");
    }
    _getPromptType() {
        return "pipeline";
    }
}

},{"./base.js":"aJ9Ap","./chat.js":"9KL2r","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aATNK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8H0Lk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StructuredPrompt", ()=>StructuredPrompt);
var _chatJs = require("./chat.js");
function isWithStructuredOutput(x) {
    return typeof x === "object" && x != null && "withStructuredOutput" in x && typeof x.withStructuredOutput === "function";
}
function isRunnableBinding(x) {
    return typeof x === "object" && x != null && "lc_id" in x && Array.isArray(x.lc_id) && x.lc_id.join("/") === "langchain_core/runnables/RunnableBinding";
}
class StructuredPrompt extends (0, _chatJs.ChatPromptTemplate) {
    get lc_aliases() {
        return {
            ...super.lc_aliases,
            schema: "schema_"
        };
    }
    constructor(input){
        super(input);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "prompts",
                "structured"
            ]
        });
        this.schema = input.schema;
    }
    pipe(coerceable) {
        if (isWithStructuredOutput(coerceable)) return super.pipe(coerceable.withStructuredOutput(this.schema));
        if (isRunnableBinding(coerceable) && isWithStructuredOutput(coerceable.bound)) return super.pipe(coerceable.bound.withStructuredOutput(this.schema).bind(coerceable.kwargs ?? {}).withConfig(coerceable.config));
        throw new Error(`Structured prompts need to be piped to a language model that supports the "withStructuredOutput()" method.`);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static fromMessagesAndSchema(promptMessages, schema) {
        return StructuredPrompt.fromMessages(promptMessages, {
            schema
        });
    }
}

},{"./chat.js":"9KL2r","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"czwif":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Abstract base class for a document retrieval system, designed to
 * process string queries and return the most relevant documents from a source.
 *
 * `BaseRetriever` provides common properties and methods for derived retrievers,
 * such as callbacks, tagging, and verbose logging. Custom retrieval systems
 * should extend this class and implement `_getRelevantDocuments` to define
 * the specific retrieval logic.
 *
 * @template Metadata - The type of metadata associated with each document,
 *                      defaulting to `Record<string, any>`.
 */ parcelHelpers.export(exports, "BaseRetriever", ()=>BaseRetriever);
var _managerJs = require("../callbacks/manager.js");
var _baseJs = require("../runnables/base.js");
var _configJs = require("../runnables/config.js");
class BaseRetriever extends (0, _baseJs.Runnable) {
    /**
     * Constructs a new `BaseRetriever` instance with optional configuration fields.
     *
     * @param fields - Optional input configuration that can include `callbacks`,
     *                 `tags`, `metadata`, and `verbose` settings for custom retriever behavior.
     */ constructor(fields){
        super(fields);
        /**
         * Optional callbacks to handle various events in the retrieval process.
         */ Object.defineProperty(this, "callbacks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Tags to label or categorize the retrieval operation.
         */ Object.defineProperty(this, "tags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Metadata to provide additional context or information about the retrieval
         * operation.
         */ Object.defineProperty(this, "metadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * If set to `true`, enables verbose logging for the retrieval process.
         */ Object.defineProperty(this, "verbose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.callbacks = fields?.callbacks;
        this.tags = fields?.tags ?? [];
        this.metadata = fields?.metadata ?? {};
        this.verbose = fields?.verbose ?? false;
    }
    /**
     * TODO: This should be an abstract method, but we'd like to avoid breaking
     * changes to people currently using subclassed custom retrievers.
     * Change it on next major release.
     */ /**
     * Placeholder method for retrieving relevant documents based on a query.
     *
     * This method is intended to be implemented by subclasses and will be
     * converted to an abstract method in the next major release. Currently, it
     * throws an error if not implemented, ensuring that custom retrievers define
     * the specific retrieval logic.
     *
     * @param _query - The query string used to search for relevant documents.
     * @param _callbacks - (optional) Callback manager for managing callbacks
     *                     during retrieval.
     * @returns A promise resolving to an array of `DocumentInterface` instances relevant to the query.
     * @throws {Error} Throws an error indicating the method is not implemented.
     */ _getRelevantDocuments(_query, _callbacks) {
        throw new Error("Not implemented!");
    }
    /**
     * Executes a retrieval operation.
     *
     * @param input - The query string used to search for relevant documents.
     * @param options - (optional) Configuration options for the retrieval run,
     *                  which may include callbacks, tags, and metadata.
     * @returns A promise that resolves to an array of `DocumentInterface` instances
     *          representing the most relevant documents to the query.
     */ async invoke(input, options) {
        return this.getRelevantDocuments(input, (0, _configJs.ensureConfig)(options));
    }
    /**
     * @deprecated Use .invoke() instead. Will be removed in 0.3.0.
     *
     * Main method used to retrieve relevant documents. It takes a query
     * string and an optional configuration object, and returns a promise that
     * resolves to an array of `Document` objects. This method handles the
     * retrieval process, including starting and ending callbacks, and error
     * handling.
     * @param query The query string to retrieve relevant documents for.
     * @param config Optional configuration object for the retrieval process.
     * @returns A promise that resolves to an array of `Document` objects.
     */ async getRelevantDocuments(query, config) {
        const parsedConfig = (0, _configJs.ensureConfig)((0, _managerJs.parseCallbackConfigArg)(config));
        const callbackManager_ = await (0, _managerJs.CallbackManager).configure(parsedConfig.callbacks, this.callbacks, parsedConfig.tags, this.tags, parsedConfig.metadata, this.metadata, {
            verbose: this.verbose
        });
        const runManager = await callbackManager_?.handleRetrieverStart(this.toJSON(), query, parsedConfig.runId, undefined, undefined, undefined, parsedConfig.runName);
        try {
            const results = await this._getRelevantDocuments(query, runManager);
            await runManager?.handleRetrieverEnd(results);
            return results;
        } catch (error) {
            await runManager?.handleRetrieverError(error);
            throw error;
        }
    }
}

},{"../callbacks/manager.js":"bj69C","../runnables/base.js":"9xkzz","../runnables/config.js":"2gQun","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"167ig":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Abstract interface for a key-value store.
 */ parcelHelpers.export(exports, "BaseStore", ()=>BaseStore);
/**
 * In-memory implementation of the BaseStore using a dictionary. Used for
 * storing key-value pairs in memory.
 * @example
 * ```typescript
 * const store = new InMemoryStore<BaseMessage>();
 * await store.mset(
 *   Array.from({ length: 5 }).map((_, index) => [
 *     `message:id:${index}`,
 *     index % 2 === 0
 *       ? new AIMessage("ai stuff...")
 *       : new HumanMessage("human stuff..."),
 *   ]),
 * );
 *
 * const retrievedMessages = await store.mget(["message:id:0", "message:id:1"]);
 * await store.mdelete(await store.yieldKeys("message:id:").toArray());
 * ```
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "InMemoryStore", ()=>InMemoryStore);
var _serializableJs = require("./load/serializable.js");
class BaseStore extends (0, _serializableJs.Serializable) {
}
class InMemoryStore extends BaseStore {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain",
                "storage"
            ]
        });
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
    }
    /**
     * Retrieves the values associated with the given keys from the store.
     * @param keys Keys to retrieve values for.
     * @returns Array of values associated with the given keys.
     */ async mget(keys) {
        return keys.map((key)=>this.store[key]);
    }
    /**
     * Sets the values for the given keys in the store.
     * @param keyValuePairs Array of key-value pairs to set in the store.
     * @returns Promise that resolves when all key-value pairs have been set.
     */ async mset(keyValuePairs) {
        for (const [key, value] of keyValuePairs)this.store[key] = value;
    }
    /**
     * Deletes the given keys and their associated values from the store.
     * @param keys Keys to delete from the store.
     * @returns Promise that resolves when all keys have been deleted.
     */ async mdelete(keys) {
        for (const key of keys)delete this.store[key];
    }
    /**
     * Asynchronous generator that yields keys from the store. If a prefix is
     * provided, it only yields keys that start with the prefix.
     * @param prefix Optional prefix to filter keys.
     * @returns AsyncGenerator that yields keys from the store.
     */ async *yieldKeys(prefix) {
        const keys = Object.keys(this.store);
        for (const key of keys)if (prefix === undefined || key.startsWith(prefix)) yield key;
    }
}

},{"./load/serializable.js":"2n7FI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bXVFj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToolInputParsingException", ()=>(0, _utilsJs.ToolInputParsingException));
/**
 * Base class for Tools that accept input of any shape defined by a Zod schema.
 */ parcelHelpers.export(exports, "StructuredTool", ()=>StructuredTool);
/**
 * Base class for Tools that accept input as a string.
 */ parcelHelpers.export(exports, "Tool", ()=>Tool);
/**
 * A tool that can be created dynamically from a function, name, and description.
 */ parcelHelpers.export(exports, "DynamicTool", ()=>DynamicTool);
/**
 * A tool that can be created dynamically from a function, name, and
 * description, designed to work with structured data. It extends the
 * StructuredTool class and overrides the _call method to execute the
 * provided function when the tool is called.
 *
 * Schema can be passed as Zod or JSON schema. The tool will not validate
 * input if JSON schema is passed.
 */ parcelHelpers.export(exports, "DynamicStructuredTool", ()=>DynamicStructuredTool);
/**
 * Abstract base class for toolkits in LangChain. Toolkits are collections
 * of tools that agents can use. Subclasses must implement the `tools`
 * property to provide the specific tools for the toolkit.
 */ parcelHelpers.export(exports, "BaseToolkit", ()=>BaseToolkit);
parcelHelpers.export(exports, "tool", ()=>tool);
var _zod = require("zod");
var _managerJs = require("../callbacks/manager.js");
var _baseJs = require("../language_models/base.js");
var _configJs = require("../runnables/config.js");
var _toolJs = require("../messages/tool.js");
var _indexJs = require("../singletons/index.js");
var _utilsJs = require("./utils.js");
var _isZodSchemaJs = require("../utils/types/is_zod_schema.js");
class StructuredTool extends (0, _baseJs.BaseLangChain) {
    get lc_namespace() {
        return [
            "langchain",
            "tools"
        ];
    }
    constructor(fields){
        super(fields ?? {});
        Object.defineProperty(this, "returnDirect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        // TODO: Make default in 0.3
        Object.defineProperty(this, "verboseParsingErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        /**
         * The tool response format.
         *
         * If "content" then the output of the tool is interpreted as the contents of a
         * ToolMessage. If "content_and_artifact" then the output is expected to be a
         * two-tuple corresponding to the (content, artifact) of a ToolMessage.
         *
         * @default "content"
         */ Object.defineProperty(this, "responseFormat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "content"
        });
        this.verboseParsingErrors = fields?.verboseParsingErrors ?? this.verboseParsingErrors;
        this.responseFormat = fields?.responseFormat ?? this.responseFormat;
    }
    /**
     * Invokes the tool with the provided input and configuration.
     * @param input The input for the tool.
     * @param config Optional configuration for the tool.
     * @returns A Promise that resolves with a string.
     */ async invoke(input, config) {
        let tool_call_id;
        let toolInput;
        if ((0, _utilsJs._isToolCall)(input)) {
            tool_call_id = input.id;
            toolInput = input.args;
        } else toolInput = input;
        const ensuredConfig = (0, _configJs.ensureConfig)(config);
        return this.call(toolInput, {
            ...ensuredConfig,
            configurable: {
                ...ensuredConfig.configurable,
                tool_call_id
            }
        });
    }
    /**
     * @deprecated Use .invoke() instead. Will be removed in 0.3.0.
     *
     * Calls the tool with the provided argument, configuration, and tags. It
     * parses the input according to the schema, handles any errors, and
     * manages callbacks.
     * @param arg The input argument for the tool.
     * @param configArg Optional configuration or callbacks for the tool.
     * @param tags Optional tags for the tool.
     * @returns A Promise that resolves with a string.
     */ async call(arg, configArg, /** @deprecated */ tags) {
        let parsed;
        try {
            parsed = await this.schema.parseAsync(arg);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            let message = `Received tool input did not match expected schema`;
            if (this.verboseParsingErrors) message = `${message}\nDetails: ${e.message}`;
            throw new (0, _utilsJs.ToolInputParsingException)(message, JSON.stringify(arg));
        }
        const config = (0, _managerJs.parseCallbackConfigArg)(configArg);
        const callbackManager_ = await (0, _managerJs.CallbackManager).configure(config.callbacks, this.callbacks, config.tags || tags, this.tags, config.metadata, this.metadata, {
            verbose: this.verbose
        });
        const runManager = await callbackManager_?.handleToolStart(this.toJSON(), typeof parsed === "string" ? parsed : JSON.stringify(parsed), config.runId, undefined, undefined, undefined, config.runName);
        delete config.runId;
        let result;
        try {
            result = await this._call(parsed, runManager, config);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            await runManager?.handleToolError(e);
            throw e;
        }
        let content;
        let artifact;
        if (this.responseFormat === "content_and_artifact") {
            if (Array.isArray(result) && result.length === 2) [content, artifact] = result;
            else throw new Error(`Tool response format is "content_and_artifact" but the output was not a two-tuple.\nResult: ${JSON.stringify(result)}`);
        } else content = result;
        let toolCallId;
        if (config && "configurable" in config) toolCallId = config.configurable.tool_call_id;
        const formattedOutput = _formatToolOutput({
            content,
            artifact,
            toolCallId,
            name: this.name
        });
        await runManager?.handleToolEnd(formattedOutput);
        return formattedOutput;
    }
}
class Tool extends StructuredTool {
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, _zod.z).object({
                input: (0, _zod.z).string().optional()
            }).transform((obj)=>obj.input)
        });
    }
    /**
     * @deprecated Use .invoke() instead. Will be removed in 0.3.0.
     *
     * Calls the tool with the provided argument and callbacks. It handles
     * string inputs specifically.
     * @param arg The input argument for the tool, which can be a string, undefined, or an input of the tool's schema.
     * @param callbacks Optional callbacks for the tool.
     * @returns A Promise that resolves with a string.
     */ call(arg, callbacks) {
        return super.call(typeof arg === "string" || !arg ? {
            input: arg
        } : arg, callbacks);
    }
}
class DynamicTool extends Tool {
    static lc_name() {
        return "DynamicTool";
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "func", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = fields.name;
        this.description = fields.description;
        this.func = fields.func;
        this.returnDirect = fields.returnDirect ?? this.returnDirect;
    }
    /**
     * @deprecated Use .invoke() instead. Will be removed in 0.3.0.
     */ async call(arg, configArg) {
        const config = (0, _managerJs.parseCallbackConfigArg)(configArg);
        if (config.runName === undefined) config.runName = this.name;
        return super.call(arg, config);
    }
    /** @ignore */ async _call(input, runManager, parentConfig) {
        return this.func(input, runManager, parentConfig);
    }
}
class DynamicStructuredTool extends StructuredTool {
    static lc_name() {
        return "DynamicStructuredTool";
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "func", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = fields.name;
        this.description = fields.description;
        this.func = fields.func;
        this.returnDirect = fields.returnDirect ?? this.returnDirect;
        this.schema = (0, _isZodSchemaJs.isZodSchema)(fields.schema) ? fields.schema : (0, _zod.z).object({}).passthrough();
    }
    /**
     * @deprecated Use .invoke() instead. Will be removed in 0.3.0.
     */ async call(arg, configArg, /** @deprecated */ tags) {
        const config = (0, _managerJs.parseCallbackConfigArg)(configArg);
        if (config.runName === undefined) config.runName = this.name;
        return super.call(arg, config, tags);
    }
    _call(arg, runManager, parentConfig) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.func(arg, runManager, parentConfig);
    }
}
class BaseToolkit {
    getTools() {
        return this.tools;
    }
}
function tool(func, fields) {
    // If the schema is not provided, or it's a string schema, create a DynamicTool
    if (!fields.schema || (0, _isZodSchemaJs.isZodSchema)(fields.schema) && (!("shape" in fields.schema) || !fields.schema.shape)) return new DynamicTool({
        ...fields,
        description: fields.description ?? fields.schema?.description ?? `${fields.name} tool`,
        func: async (input, runManager, config)=>{
            return new Promise((resolve, reject)=>{
                const childConfig = (0, _configJs.patchConfig)(config, {
                    callbacks: runManager?.getChild()
                });
                (0, _indexJs.AsyncLocalStorageProviderSingleton).runWithConfig(childConfig, async ()=>{
                    try {
                        // TS doesn't restrict the type here based on the guard above
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        resolve(func(input, childConfig));
                    } catch (e) {
                        reject(e);
                    }
                });
            });
        }
    });
    const description = fields.description ?? fields.schema.description ?? `${fields.name} tool`;
    return new DynamicStructuredTool({
        ...fields,
        description,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        schema: fields.schema,
        // TODO: Consider moving into DynamicStructuredTool constructor
        func: async (input, runManager, config)=>{
            return new Promise((resolve, reject)=>{
                const childConfig = (0, _configJs.patchConfig)(config, {
                    callbacks: runManager?.getChild()
                });
                (0, _indexJs.AsyncLocalStorageProviderSingleton).runWithConfig(childConfig, async ()=>{
                    try {
                        // TS doesn't restrict the type here based on the guard above
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        resolve(func(input, childConfig));
                    } catch (e) {
                        reject(e);
                    }
                });
            });
        }
    });
}
function _formatToolOutput(params) {
    const { content, artifact, toolCallId } = params;
    if (toolCallId) {
        if (typeof content === "string" || Array.isArray(content) && content.every((item)=>typeof item === "object")) return new (0, _toolJs.ToolMessage)({
            content,
            artifact,
            tool_call_id: toolCallId,
            name: params.name
        });
        else return new (0, _toolJs.ToolMessage)({
            content: _stringify(content),
            artifact,
            tool_call_id: toolCallId,
            name: params.name
        });
    } else return content;
}
function _stringify(content) {
    try {
        return JSON.stringify(content, null, 2);
    } catch (_noOp) {
        return `${content}`;
    }
}

},{"zod":"juM82","../callbacks/manager.js":"bj69C","../language_models/base.js":"grvsA","../runnables/config.js":"2gQun","../messages/tool.js":"04Rfb","../singletons/index.js":"1O31N","./utils.js":"vJeFM","../utils/types/is_zod_schema.js":"3S7D5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"71Hde":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @deprecated Use the V2 handler instead.
 *
 * Function that returns an instance of `LangChainTracerV1`. If a session
 * is provided, it loads that session into the tracer; otherwise, it loads
 * a default session.
 * @param session Optional session to load into the tracer.
 * @returns An instance of `LangChainTracerV1`.
 */ parcelHelpers.export(exports, "getTracingCallbackHandler", ()=>getTracingCallbackHandler);
/**
 * @deprecated Instantiate directly using the LangChainTracer constructor.
 *
 * Function that returns an instance of `LangChainTracer`. It does not
 * load any session data.
 * @returns An instance of `LangChainTracer`.
 */ parcelHelpers.export(exports, "getTracingV2CallbackHandler", ()=>getTracingV2CallbackHandler);
var _tracerLangchainJs = require("./tracer_langchain.js");
var _tracerLangchainV1Js = require("./tracer_langchain_v1.js");
async function getTracingCallbackHandler(session) {
    const tracer = new (0, _tracerLangchainV1Js.LangChainTracerV1)();
    if (session) await tracer.loadSession(session);
    else await tracer.loadDefaultSession();
    return tracer;
}
async function getTracingV2CallbackHandler() {
    return new (0, _tracerLangchainJs.LangChainTracer)();
}

},{"./tracer_langchain.js":"a7dBj","./tracer_langchain_v1.js":"2KZBB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2KZBB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @deprecated Use LangChainTracer instead. */ parcelHelpers.export(exports, "LangChainTracerV1", ()=>LangChainTracerV1);
var _utilsJs = require("../messages/utils.js");
var _envJs = require("../utils/env.js");
var _baseJs = require("./base.js");
class LangChainTracerV1 extends (0, _baseJs.BaseTracer) {
    constructor(){
        super();
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "langchain_tracer"
        });
        Object.defineProperty(this, "endpoint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, _envJs.getEnvironmentVariable)("LANGCHAIN_ENDPOINT") || "http://localhost:1984"
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                "Content-Type": "application/json"
            }
        });
        Object.defineProperty(this, "session", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const apiKey = (0, _envJs.getEnvironmentVariable)("LANGCHAIN_API_KEY");
        if (apiKey) this.headers["x-api-key"] = apiKey;
    }
    async newSession(sessionName) {
        const sessionCreate = {
            start_time: Date.now(),
            name: sessionName
        };
        const session = await this.persistSession(sessionCreate);
        this.session = session;
        return session;
    }
    async loadSession(sessionName) {
        const endpoint = `${this.endpoint}/sessions?name=${sessionName}`;
        return this._handleSessionResponse(endpoint);
    }
    async loadDefaultSession() {
        const endpoint = `${this.endpoint}/sessions?name=default`;
        return this._handleSessionResponse(endpoint);
    }
    async convertV2RunToRun(run) {
        const session = this.session ?? await this.loadDefaultSession();
        const serialized = run.serialized;
        let runResult;
        if (run.run_type === "llm") {
            const prompts = run.inputs.prompts ? run.inputs.prompts : run.inputs.messages.map((x)=>(0, _utilsJs.getBufferString)(x));
            const llmRun = {
                uuid: run.id,
                start_time: run.start_time,
                end_time: run.end_time,
                execution_order: run.execution_order,
                child_execution_order: run.child_execution_order,
                serialized,
                type: run.run_type,
                session_id: session.id,
                prompts,
                response: run.outputs
            };
            runResult = llmRun;
        } else if (run.run_type === "chain") {
            const child_runs = await Promise.all(run.child_runs.map((child_run)=>this.convertV2RunToRun(child_run)));
            const chainRun = {
                uuid: run.id,
                start_time: run.start_time,
                end_time: run.end_time,
                execution_order: run.execution_order,
                child_execution_order: run.child_execution_order,
                serialized,
                type: run.run_type,
                session_id: session.id,
                inputs: run.inputs,
                outputs: run.outputs,
                child_llm_runs: child_runs.filter((child_run)=>child_run.type === "llm"),
                child_chain_runs: child_runs.filter((child_run)=>child_run.type === "chain"),
                child_tool_runs: child_runs.filter((child_run)=>child_run.type === "tool")
            };
            runResult = chainRun;
        } else if (run.run_type === "tool") {
            const child_runs = await Promise.all(run.child_runs.map((child_run)=>this.convertV2RunToRun(child_run)));
            const toolRun = {
                uuid: run.id,
                start_time: run.start_time,
                end_time: run.end_time,
                execution_order: run.execution_order,
                child_execution_order: run.child_execution_order,
                serialized,
                type: run.run_type,
                session_id: session.id,
                tool_input: run.inputs.input,
                output: run.outputs?.output,
                action: JSON.stringify(serialized),
                child_llm_runs: child_runs.filter((child_run)=>child_run.type === "llm"),
                child_chain_runs: child_runs.filter((child_run)=>child_run.type === "chain"),
                child_tool_runs: child_runs.filter((child_run)=>child_run.type === "tool")
            };
            runResult = toolRun;
        } else throw new Error(`Unknown run type: ${run.run_type}`);
        return runResult;
    }
    async persistRun(run) {
        let endpoint;
        let v1Run;
        if (run.run_type !== undefined) v1Run = await this.convertV2RunToRun(run);
        else v1Run = run;
        if (v1Run.type === "llm") endpoint = `${this.endpoint}/llm-runs`;
        else if (v1Run.type === "chain") endpoint = `${this.endpoint}/chain-runs`;
        else endpoint = `${this.endpoint}/tool-runs`;
        const response = await fetch(endpoint, {
            method: "POST",
            headers: this.headers,
            body: JSON.stringify(v1Run)
        });
        if (!response.ok) console.error(`Failed to persist run: ${response.status} ${response.statusText}`);
    }
    async persistSession(sessionCreate) {
        const endpoint = `${this.endpoint}/sessions`;
        const response = await fetch(endpoint, {
            method: "POST",
            headers: this.headers,
            body: JSON.stringify(sessionCreate)
        });
        if (!response.ok) {
            console.error(`Failed to persist session: ${response.status} ${response.statusText}, using default session.`);
            return {
                id: 1,
                ...sessionCreate
            };
        }
        return {
            id: (await response.json()).id,
            ...sessionCreate
        };
    }
    async _handleSessionResponse(endpoint) {
        const response = await fetch(endpoint, {
            method: "GET",
            headers: this.headers
        });
        let tracerSession;
        if (!response.ok) {
            console.error(`Failed to load session: ${response.status} ${response.statusText}`);
            tracerSession = {
                id: 1,
                start_time: Date.now()
            };
            this.session = tracerSession;
            return tracerSession;
        }
        const resp = await response.json();
        if (resp.length === 0) {
            tracerSession = {
                id: 1,
                start_time: Date.now()
            };
            this.session = tracerSession;
            return tracerSession;
        }
        [tracerSession] = resp;
        this.session = tracerSession;
        return tracerSession;
    }
}

},{"../messages/utils.js":"6vi0n","../utils/env.js":"4GIQu","./base.js":"5VkRj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"26xlp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A callback handler that collects traced runs and makes it easy to fetch the traced run object from calls through any langchain object.
 * For instance, it makes it easy to fetch the run ID and then do things with that, such as log feedback.
 */ parcelHelpers.export(exports, "RunCollectorCallbackHandler", ()=>RunCollectorCallbackHandler);
var _baseJs = require("./base.js");
class RunCollectorCallbackHandler extends (0, _baseJs.BaseTracer) {
    /**
     * Creates a new instance of the RunCollectorCallbackHandler class.
     * @param exampleId The ID of the example.
     */ constructor({ exampleId } = {}){
        super({
            _awaitHandler: true
        });
        /** The name of the callback handler. */ Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "run_collector"
        });
        /** The ID of the example. */ Object.defineProperty(this, "exampleId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** An array of traced runs. */ Object.defineProperty(this, "tracedRuns", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.exampleId = exampleId;
        this.tracedRuns = [];
    }
    /**
     * Persists the given run object.
     * @param run The run object to persist.
     */ async persistRun(run) {
        const run_ = {
            ...run
        };
        run_.reference_example_id = this.exampleId;
        this.tracedRuns.push(run_);
    }
}

},{"./base.js":"5VkRj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7oRM9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chunkArray", ()=>chunkArray);
const chunkArray = (arr, chunkSize)=>arr.reduce((chunks, elem, index)=>{
        const chunkIndex = Math.floor(index / chunkSize);
        const chunk = chunks[chunkIndex] || [];
        // eslint-disable-next-line no-param-reassign
        chunks[chunkIndex] = chunk.concat([
            elem
        ]);
        return chunks;
    }, []);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aj2Xs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats a `StructuredTool` or `RunnableToolLike` instance into a format
 * that is compatible with OpenAI function calling. It uses the `zodToJsonSchema`
 * function to convert the schema of the `StructuredTool` or `RunnableToolLike`
 * into a JSON schema, which is then used as the parameters for the OpenAI function.
 *
 * @param {StructuredToolInterface | RunnableToolLike} tool The tool to convert to an OpenAI function.
 * @returns {FunctionDefinition} The inputted tool in OpenAI function format.
 */ parcelHelpers.export(exports, "convertToOpenAIFunction", ()=>convertToOpenAIFunction);
/**
 * Formats a `StructuredTool` or `RunnableToolLike` instance into a
 * format that is compatible with OpenAI tool calling. It uses the
 * `zodToJsonSchema` function to convert the schema of the `StructuredTool`
 * or `RunnableToolLike` into a JSON schema, which is then used as the
 * parameters for the OpenAI tool.
 *
 * @param {StructuredToolInterface | Record<string, any> | RunnableToolLike} tool The tool to convert to an OpenAI tool.
 * @returns {ToolDefinition} The inputted tool in OpenAI tool format.
 */ parcelHelpers.export(exports, "convertToOpenAITool", ()=>convertToOpenAITool);
/**
 * Confirm whether the inputted tool is an instance of `StructuredToolInterface`.
 *
 * @param {StructuredToolInterface | Record<string, any> | undefined} tool The tool to check if it is an instance of `StructuredToolInterface`.
 * @returns {tool is StructuredToolInterface} Whether the inputted tool is an instance of `StructuredToolInterface`.
 */ parcelHelpers.export(exports, "isStructuredTool", ()=>isStructuredTool);
/**
 * Confirm whether the inputted tool is an instance of `RunnableToolLike`.
 *
 * @param {unknown | undefined} tool The tool to check if it is an instance of `RunnableToolLike`.
 * @returns {tool is RunnableToolLike} Whether the inputted tool is an instance of `RunnableToolLike`.
 */ parcelHelpers.export(exports, "isRunnableToolLike", ()=>isRunnableToolLike);
/**
 * Confirm whether or not the tool contains the necessary properties to be considered a `StructuredToolParams`.
 *
 * @param {unknown | undefined} tool The object to check if it is a `StructuredToolParams`.
 * @returns {tool is StructuredToolParams} Whether the inputted object is a `StructuredToolParams`.
 */ parcelHelpers.export(exports, "isStructuredToolParams", ()=>isStructuredToolParams);
/**
 * Whether or not the tool is one of StructuredTool, RunnableTool or StructuredToolParams.
 * It returns `is StructuredToolParams` since that is the most minimal interface of the three,
 * while still containing the necessary properties to be passed to a LLM for tool calling.
 *
 * @param {unknown | undefined} tool The tool to check if it is a LangChain tool.
 * @returns {tool is StructuredToolParams} Whether the inputted tool is a LangChain tool.
 */ parcelHelpers.export(exports, "isLangChainTool", ()=>isLangChainTool);
var _zodToJsonSchema = require("zod-to-json-schema");
var _baseJs = require("../runnables/base.js");
var _isZodSchemaJs = require("./types/is_zod_schema.js");
function convertToOpenAIFunction(tool, fields) {
    // @TODO 0.3.0 Remove the `number` typing
    const fieldsCopy = typeof fields === "number" ? undefined : fields;
    return {
        name: tool.name,
        description: tool.description,
        parameters: (0, _zodToJsonSchema.zodToJsonSchema)(tool.schema),
        // Do not include the `strict` field if it is `undefined`.
        ...fieldsCopy?.strict !== undefined ? {
            strict: fieldsCopy.strict
        } : {}
    };
}
function convertToOpenAITool(// eslint-disable-next-line @typescript-eslint/no-explicit-any
tool, fields) {
    // @TODO 0.3.0 Remove the `number` typing
    const fieldsCopy = typeof fields === "number" ? undefined : fields;
    let toolDef;
    if (isLangChainTool(tool)) toolDef = {
        type: "function",
        function: convertToOpenAIFunction(tool)
    };
    else toolDef = tool;
    if (fieldsCopy?.strict !== undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    toolDef.function.strict = fieldsCopy.strict;
    return toolDef;
}
function isStructuredTool(// eslint-disable-next-line @typescript-eslint/no-explicit-any
tool) {
    return tool !== undefined && Array.isArray(tool.lc_namespace);
}
function isRunnableToolLike(tool) {
    return tool !== undefined && (0, _baseJs.Runnable).isRunnable(tool) && "lc_name" in tool.constructor && typeof tool.constructor.lc_name === "function" && tool.constructor.lc_name() === "RunnableToolLike";
}
function isStructuredToolParams(tool) {
    return !!tool && typeof tool === "object" && "name" in tool && "schema" in tool && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, _isZodSchemaJs.isZodSchema)(tool.schema);
}
function isLangChainTool(tool) {
    return isStructuredToolParams(tool) || isRunnableToolLike(tool) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isStructuredTool(tool);
}

},{"zod-to-json-schema":"3TbOj","../runnables/base.js":"9xkzz","./types/is_zod_schema.js":"3S7D5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"43q9X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepCompareStrict", ()=>(0, _indexJs.deepCompareStrict));
parcelHelpers.export(exports, "Validator", ()=>(0, _indexJs.Validator));
var _indexJs = require("./@cfworker/json-schema/index.js");

},{"./@cfworker/json-schema/index.js":"jvLfm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bFJs7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Apply a row-wise function between two matrices with the same number of columns.
 *
 * @param {number[][]} X - The first matrix.
 * @param {number[][]} Y - The second matrix.
 * @param {VectorFunction} func - The function to apply.
 *
 * @throws {Error} If the number of columns in X and Y are not the same.
 *
 * @returns {number[][] | [[]]} A matrix where each row represents the result of applying the function between the corresponding rows of X and Y.
 */ parcelHelpers.export(exports, "matrixFunc", ()=>matrixFunc);
parcelHelpers.export(exports, "normalize", ()=>normalize);
/**
 * This function calculates the row-wise cosine similarity between two matrices with the same number of columns.
 *
 * @param {number[][]} X - The first matrix.
 * @param {number[][]} Y - The second matrix.
 *
 * @throws {Error} If the number of columns in X and Y are not the same.
 *
 * @returns {number[][] | [[]]} A matrix where each row represents the cosine similarity values between the corresponding rows of X and Y.
 */ parcelHelpers.export(exports, "cosineSimilarity", ()=>cosineSimilarity);
parcelHelpers.export(exports, "innerProduct", ()=>innerProduct);
parcelHelpers.export(exports, "euclideanDistance", ()=>euclideanDistance);
/**
 * This function implements the Maximal Marginal Relevance algorithm
 * to select a set of embeddings that maximizes the diversity and relevance to a query embedding.
 *
 * @param {number[]|number[][]} queryEmbedding - The query embedding.
 * @param {number[][]} embeddingList - The list of embeddings to select from.
 * @param {number} [lambda=0.5] - The trade-off parameter between relevance and diversity.
 * @param {number} [k=4] - The maximum number of embeddings to select.
 *
 * @returns {number[]} The indexes of the selected embeddings in the embeddingList.
 */ parcelHelpers.export(exports, "maximalMarginalRelevance", ()=>maximalMarginalRelevance);
var _similaritiesJs = require("./ml-distance/similarities.js");
var _distancesJs = require("./ml-distance/distances.js");
var _euclideanJs = require("./ml-distance-euclidean/euclidean.js");
function matrixFunc(X, Y, func) {
    if (X.length === 0 || X[0].length === 0 || Y.length === 0 || Y[0].length === 0) return [
        []
    ];
    if (X[0].length !== Y[0].length) throw new Error(`Number of columns in X and Y must be the same. X has shape ${[
        X.length,
        X[0].length
    ]} and Y has shape ${[
        Y.length,
        Y[0].length
    ]}.`);
    return X.map((xVector)=>Y.map((yVector)=>func(xVector, yVector)).map((similarity)=>Number.isNaN(similarity) ? 0 : similarity));
}
function normalize(M, similarity = false) {
    const max = matrixMaxVal(M);
    return M.map((row)=>row.map((val)=>similarity ? 1 - val / max : val / max));
}
function cosineSimilarity(X, Y) {
    return matrixFunc(X, Y, (0, _similaritiesJs.cosine));
}
function innerProduct(X, Y) {
    return matrixFunc(X, Y, (0, _distancesJs.innerProduct));
}
function euclideanDistance(X, Y) {
    return matrixFunc(X, Y, (0, _euclideanJs.euclidean));
}
function maximalMarginalRelevance(queryEmbedding, embeddingList, lambda = 0.5, k = 4) {
    if (Math.min(k, embeddingList.length) <= 0) return [];
    const queryEmbeddingExpanded = Array.isArray(queryEmbedding[0]) ? queryEmbedding : [
        queryEmbedding
    ];
    const similarityToQuery = cosineSimilarity(queryEmbeddingExpanded, embeddingList)[0];
    const mostSimilarEmbeddingIndex = argMax(similarityToQuery).maxIndex;
    const selectedEmbeddings = [
        embeddingList[mostSimilarEmbeddingIndex]
    ];
    const selectedEmbeddingsIndexes = [
        mostSimilarEmbeddingIndex
    ];
    while(selectedEmbeddingsIndexes.length < Math.min(k, embeddingList.length)){
        let bestScore = -Infinity;
        let bestIndex = -1;
        const similarityToSelected = cosineSimilarity(embeddingList, selectedEmbeddings);
        similarityToQuery.forEach((queryScore, queryScoreIndex)=>{
            if (selectedEmbeddingsIndexes.includes(queryScoreIndex)) return;
            const maxSimilarityToSelected = Math.max(...similarityToSelected[queryScoreIndex]);
            const score = lambda * queryScore - (1 - lambda) * maxSimilarityToSelected;
            if (score > bestScore) {
                bestScore = score;
                bestIndex = queryScoreIndex;
            }
        });
        selectedEmbeddings.push(embeddingList[bestIndex]);
        selectedEmbeddingsIndexes.push(bestIndex);
    }
    return selectedEmbeddingsIndexes;
}
/**
 * Finds the index of the maximum value in the given array.
 * @param {number[]} array - The input array.
 *
 * @returns {number} The index of the maximum value in the array. If the array is empty, returns -1.
 */ function argMax(array) {
    if (array.length === 0) return {
        maxIndex: -1,
        maxValue: NaN
    };
    let maxValue = array[0];
    let maxIndex = 0;
    for(let i = 1; i < array.length; i += 1)if (array[i] > maxValue) {
        maxIndex = i;
        maxValue = array[i];
    }
    return {
        maxIndex,
        maxValue
    };
}
function matrixMaxVal(arrays) {
    return arrays.reduce((acc, array)=>Math.max(acc, argMax(array).maxValue), 0);
}

},{"./ml-distance/similarities.js":"cueTR","./ml-distance/distances.js":"8pq3P","./ml-distance-euclidean/euclidean.js":"gemn0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cueTR":[function(require,module,exports,__globalThis) {
/**
 * Returns the average of cosine distances between vectors a and b
 * @param a - first vector
 * @param b - second vector
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cosine", ()=>cosine);
function cosine(a, b) {
    let p = 0;
    let p2 = 0;
    let q2 = 0;
    for(let i = 0; i < a.length; i++){
        p += a[i] * b[i];
        p2 += a[i] * a[i];
        q2 += b[i] * b[i];
    }
    return p / (Math.sqrt(p2) * Math.sqrt(q2));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8pq3P":[function(require,module,exports,__globalThis) {
/**
 *Returns the Inner Product similarity between vectors a and b
 * @link [Inner Product Similarity algorithm](https://www.naun.org/main/NAUN/ijmmas/mmmas-49.pdf)
 * @param a - first vector
 * @param b - second vector
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "innerProduct", ()=>innerProduct);
function innerProduct(a, b) {
    let ans = 0;
    for(let i = 0; i < a.length; i++)ans += a[i] * b[i];
    return ans;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gemn0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "squaredEuclidean", ()=>squaredEuclidean);
parcelHelpers.export(exports, "euclidean", ()=>euclidean);
function squaredEuclidean(p, q) {
    let d = 0;
    for(let i = 0; i < p.length; i++)d += (p[i] - q[i]) * (p[i] - q[i]);
    return d;
}
function euclidean(p, q) {
    return Math.sqrt(squaredEuclidean(p, q));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2FJMX":[function(require,module,exports,__globalThis) {
/* eslint-disable no-promise-executor-return */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unused-vars */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parser for comma-separated values. It splits the input text by commas
 * and trims the resulting values.
 */ parcelHelpers.export(exports, "FakeSplitIntoListParser", ()=>FakeSplitIntoListParser);
parcelHelpers.export(exports, "FakeRunnable", ()=>FakeRunnable);
parcelHelpers.export(exports, "FakeLLM", ()=>FakeLLM);
parcelHelpers.export(exports, "FakeStreamingLLM", ()=>FakeStreamingLLM);
parcelHelpers.export(exports, "FakeChatModel", ()=>FakeChatModel);
parcelHelpers.export(exports, "FakeStreamingChatModel", ()=>FakeStreamingChatModel);
parcelHelpers.export(exports, "FakeRetriever", ()=>FakeRetriever);
/**
 * A fake Chat Model that returns a predefined list of responses. It can be used
 * for testing purposes.
 * @example
 * ```typescript
 * const chat = new FakeListChatModel({
 *   responses: ["I'll callback later.", "You 'console' them!"]
 * });
 *
 * const firstMessage = new HumanMessage("You want to hear a JavaScript joke?");
 * const secondMessage = new HumanMessage("How do you cheer up a JavaScript developer?");
 *
 * // Call the chat model with a message and log the response
 * const firstResponse = await chat.call([firstMessage]);
 * console.log({ firstResponse });
 *
 * const secondResponse = await chat.call([secondMessage]);
 * console.log({ secondResponse });
 * ```
 */ parcelHelpers.export(exports, "FakeListChatModel", ()=>FakeListChatModel);
parcelHelpers.export(exports, "FakeChatMessageHistory", ()=>FakeChatMessageHistory);
parcelHelpers.export(exports, "FakeListChatMessageHistory", ()=>FakeListChatMessageHistory);
parcelHelpers.export(exports, "FakeTracer", ()=>FakeTracer);
parcelHelpers.export(exports, "FakeTool", ()=>FakeTool);
/**
 * A class that provides fake embeddings by overriding the embedDocuments
 * and embedQuery methods to return fixed values.
 */ parcelHelpers.export(exports, "FakeEmbeddings", ()=>FakeEmbeddings);
/**
 * A class that provides synthetic embeddings by overriding the
 * embedDocuments and embedQuery methods to generate embeddings based on
 * the input documents. The embeddings are generated by converting each
 * document into chunks, calculating a numerical value for each chunk, and
 * returning an array of these values as the embedding.
 */ parcelHelpers.export(exports, "SyntheticEmbeddings", ()=>SyntheticEmbeddings);
parcelHelpers.export(exports, "SingleRunExtractor", ()=>SingleRunExtractor);
/**
 * Class that extends `VectorStore` to store vectors in memory. Provides
 * methods for adding documents, performing similarity searches, and
 * creating instances from texts, documents, or an existing index.
 */ parcelHelpers.export(exports, "FakeVectorStore", ()=>FakeVectorStore);
var _chatHistoryJs = require("../../chat_history.js");
var _documentJs = require("../../documents/document.js");
var _chatModelsJs = require("../../language_models/chat_models.js");
var _llmsJs = require("../../language_models/llms.js");
var _indexJs = require("../../messages/index.js");
var _baseJs = require("../../output_parsers/base.js");
var _outputsJs = require("../../outputs.js");
var _indexJs1 = require("../../retrievers/index.js");
var _baseJs1 = require("../../runnables/base.js");
var _indexJs2 = require("../../tools/index.js");
var _baseJs2 = require("../../tracers/base.js");
var _embeddingsJs = require("../../embeddings.js");
var _vectorstoresJs = require("../../vectorstores.js");
var _similaritiesJs = require("../ml-distance/similarities.js");
class FakeSplitIntoListParser extends (0, _baseJs.BaseOutputParser) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "tests",
                "fake"
            ]
        });
    }
    getFormatInstructions() {
        return "";
    }
    async parse(text) {
        return text.split(",").map((value)=>value.trim());
    }
}
class FakeRunnable extends (0, _baseJs1.Runnable) {
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "tests",
                "fake"
            ]
        });
        Object.defineProperty(this, "returnOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.returnOptions = fields.returnOptions;
    }
    async invoke(input, options) {
        if (this.returnOptions) return options ?? {};
        return {
            input
        };
    }
}
class FakeLLM extends (0, _llmsJs.LLM) {
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "thrownErrorString", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.response = fields.response;
        this.thrownErrorString = fields.thrownErrorString;
    }
    _llmType() {
        return "fake";
    }
    async _call(prompt, _options, runManager) {
        if (this.thrownErrorString) throw new Error(this.thrownErrorString);
        const response = this.response ?? prompt;
        await runManager?.handleLLMNewToken(response);
        return response;
    }
}
class FakeStreamingLLM extends (0, _llmsJs.LLM) {
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "sleep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 50
        });
        Object.defineProperty(this, "responses", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "thrownErrorString", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.sleep = fields.sleep ?? this.sleep;
        this.responses = fields.responses;
        this.thrownErrorString = fields.thrownErrorString;
    }
    _llmType() {
        return "fake";
    }
    async _call(prompt) {
        if (this.thrownErrorString) throw new Error(this.thrownErrorString);
        const response = this.responses?.[0];
        this.responses = this.responses?.slice(1);
        return response ?? prompt;
    }
    async *_streamResponseChunks(input, _options, runManager) {
        if (this.thrownErrorString) throw new Error(this.thrownErrorString);
        const response = this.responses?.[0];
        this.responses = this.responses?.slice(1);
        for (const c of response ?? input){
            await new Promise((resolve)=>setTimeout(resolve, this.sleep));
            yield {
                text: c,
                generationInfo: {}
            };
            await runManager?.handleLLMNewToken(c);
        }
    }
}
class FakeChatModel extends (0, _chatModelsJs.BaseChatModel) {
    _combineLLMOutput() {
        return [];
    }
    _llmType() {
        return "fake";
    }
    async _generate(messages, options, runManager) {
        if (options?.stop?.length) return {
            generations: [
                {
                    message: new (0, _indexJs.AIMessage)(options.stop[0]),
                    text: options.stop[0]
                }
            ]
        };
        const text = messages.map((m)=>{
            if (typeof m.content === "string") return m.content;
            return JSON.stringify(m.content, null, 2);
        }).join("\n");
        await runManager?.handleLLMNewToken(text);
        return {
            generations: [
                {
                    message: new (0, _indexJs.AIMessage)(text),
                    text
                }
            ],
            llmOutput: {}
        };
    }
}
class FakeStreamingChatModel extends (0, _chatModelsJs.BaseChatModel) {
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "sleep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 50
        });
        Object.defineProperty(this, "responses", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "thrownErrorString", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.sleep = fields.sleep ?? this.sleep;
        this.responses = fields.responses;
        this.thrownErrorString = fields.thrownErrorString;
    }
    _llmType() {
        return "fake";
    }
    async _generate(messages, _options, _runManager) {
        if (this.thrownErrorString) throw new Error(this.thrownErrorString);
        const content = this.responses?.[0].content ?? messages[0].content;
        const generation = {
            generations: [
                {
                    text: "",
                    message: new (0, _indexJs.AIMessage)({
                        content
                    })
                }
            ]
        };
        return generation;
    }
    async *_streamResponseChunks(messages, _options, _runManager) {
        if (this.thrownErrorString) throw new Error(this.thrownErrorString);
        const content = this.responses?.[0].content ?? messages[0].content;
        if (typeof content !== "string") for (const _ of this.responses ?? messages)yield new (0, _outputsJs.ChatGenerationChunk)({
            text: "",
            message: new (0, _indexJs.AIMessageChunk)({
                content
            })
        });
        else for (const _ of this.responses ?? messages)yield new (0, _outputsJs.ChatGenerationChunk)({
            text: content,
            message: new (0, _indexJs.AIMessageChunk)({
                content
            })
        });
    }
}
class FakeRetriever extends (0, _indexJs1.BaseRetriever) {
    constructor(fields){
        super();
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "test",
                "fake"
            ]
        });
        Object.defineProperty(this, "output", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                new (0, _documentJs.Document)({
                    pageContent: "foo"
                }),
                new (0, _documentJs.Document)({
                    pageContent: "bar"
                })
            ]
        });
        this.output = fields?.output ?? this.output;
    }
    async _getRelevantDocuments(_query) {
        return this.output;
    }
}
class FakeListChatModel extends (0, _chatModelsJs.BaseChatModel) {
    static lc_name() {
        return "FakeListChatModel";
    }
    constructor(params){
        super(params);
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "responses", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "i", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "sleep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emitCustomEvent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        const { responses, sleep, emitCustomEvent } = params;
        this.responses = responses;
        this.sleep = sleep;
        this.emitCustomEvent = emitCustomEvent ?? this.emitCustomEvent;
    }
    _combineLLMOutput() {
        return [];
    }
    _llmType() {
        return "fake-list";
    }
    async _generate(_messages, options, runManager) {
        await this._sleepIfRequested();
        if (options?.thrownErrorString) throw new Error(options.thrownErrorString);
        if (this.emitCustomEvent) await runManager?.handleCustomEvent("some_test_event", {
            someval: true
        });
        if (options?.stop?.length) return {
            generations: [
                this._formatGeneration(options.stop[0])
            ]
        };
        else {
            const response = this._currentResponse();
            this._incrementResponse();
            return {
                generations: [
                    this._formatGeneration(response)
                ],
                llmOutput: {}
            };
        }
    }
    _formatGeneration(text) {
        return {
            message: new (0, _indexJs.AIMessage)(text),
            text
        };
    }
    async *_streamResponseChunks(_messages, options, runManager) {
        const response = this._currentResponse();
        this._incrementResponse();
        if (this.emitCustomEvent) await runManager?.handleCustomEvent("some_test_event", {
            someval: true
        });
        for await (const text of response){
            await this._sleepIfRequested();
            if (options?.thrownErrorString) throw new Error(options.thrownErrorString);
            const chunk = this._createResponseChunk(text);
            yield chunk;
            runManager?.handleLLMNewToken(text);
        }
    }
    async _sleepIfRequested() {
        if (this.sleep !== undefined) await this._sleep();
    }
    async _sleep() {
        return new Promise((resolve)=>{
            setTimeout(()=>resolve(), this.sleep);
        });
    }
    _createResponseChunk(text) {
        return new (0, _outputsJs.ChatGenerationChunk)({
            message: new (0, _indexJs.AIMessageChunk)({
                content: text
            }),
            text
        });
    }
    _currentResponse() {
        return this.responses[this.i];
    }
    _incrementResponse() {
        if (this.i < this.responses.length - 1) this.i += 1;
        else this.i = 0;
    }
    withStructuredOutput(_params, _config) {
        return (0, _baseJs1.RunnableLambda).from(async (input)=>{
            const message = await this.invoke(input);
            return JSON.parse(message.content);
        });
    }
}
class FakeChatMessageHistory extends (0, _chatHistoryJs.BaseChatMessageHistory) {
    constructor(){
        super();
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "message",
                "fake"
            ]
        });
        Object.defineProperty(this, "messages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    async getMessages() {
        return this.messages;
    }
    async addMessage(message) {
        this.messages.push(message);
    }
    async addUserMessage(message) {
        this.messages.push(new (0, _indexJs.HumanMessage)(message));
    }
    async addAIChatMessage(message) {
        this.messages.push(new (0, _indexJs.AIMessage)(message));
    }
    async clear() {
        this.messages = [];
    }
}
class FakeListChatMessageHistory extends (0, _chatHistoryJs.BaseListChatMessageHistory) {
    constructor(){
        super();
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain_core",
                "message",
                "fake"
            ]
        });
        Object.defineProperty(this, "messages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    async addMessage(message) {
        this.messages.push(message);
    }
    async getMessages() {
        return this.messages;
    }
}
class FakeTracer extends (0, _baseJs2.BaseTracer) {
    constructor(){
        super();
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "fake_tracer"
        });
        Object.defineProperty(this, "runs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    persistRun(run) {
        this.runs.push(run);
        return Promise.resolve();
    }
}
class FakeTool extends (0, _indexJs2.StructuredTool) {
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = fields.name;
        this.description = fields.description;
        this.schema = fields.schema;
    }
    async _call(arg, _runManager) {
        return JSON.stringify(arg);
    }
}
class FakeEmbeddings extends (0, _embeddingsJs.Embeddings) {
    constructor(params){
        super(params ?? {});
    }
    /**
     * Generates fixed embeddings for a list of documents.
     * @param documents List of documents to generate embeddings for.
     * @returns A promise that resolves with a list of fixed embeddings for each document.
     */ embedDocuments(documents) {
        return Promise.resolve(documents.map(()=>[
                0.1,
                0.2,
                0.3,
                0.4
            ]));
    }
    /**
     * Generates a fixed embedding for a query.
     * @param _ The query to generate an embedding for.
     * @returns A promise that resolves with a fixed embedding for the query.
     */ embedQuery(_) {
        return Promise.resolve([
            0.1,
            0.2,
            0.3,
            0.4
        ]);
    }
}
class SyntheticEmbeddings extends (0, _embeddingsJs.Embeddings) {
    constructor(params){
        super(params ?? {});
        Object.defineProperty(this, "vectorSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.vectorSize = params?.vectorSize ?? 4;
    }
    /**
     * Generates synthetic embeddings for a list of documents.
     * @param documents List of documents to generate embeddings for.
     * @returns A promise that resolves with a list of synthetic embeddings for each document.
     */ async embedDocuments(documents) {
        return Promise.all(documents.map((doc)=>this.embedQuery(doc)));
    }
    /**
     * Generates a synthetic embedding for a document. The document is
     * converted into chunks, a numerical value is calculated for each chunk,
     * and an array of these values is returned as the embedding.
     * @param document The document to generate an embedding for.
     * @returns A promise that resolves with a synthetic embedding for the document.
     */ async embedQuery(document) {
        let doc = document;
        // Only use the letters (and space) from the document, and make them lower case
        doc = doc.toLowerCase().replaceAll(/[^a-z ]/g, "");
        // Pad the document to make sure it has a divisible number of chunks
        const padMod = doc.length % this.vectorSize;
        const padGapSize = padMod === 0 ? 0 : this.vectorSize - padMod;
        const padSize = doc.length + padGapSize;
        doc = doc.padEnd(padSize, " ");
        // Break it into chunks
        const chunkSize = doc.length / this.vectorSize;
        const docChunk = [];
        for(let co = 0; co < doc.length; co += chunkSize)docChunk.push(doc.slice(co, co + chunkSize));
        // Turn each chunk into a number
        const ret = docChunk.map((s)=>{
            let sum = 0;
            // Get a total value by adding the value of each character in the string
            for(let co = 0; co < s.length; co += 1)sum += s === " " ? 0 : s.charCodeAt(co);
            // Reduce this to a number between 0 and 25 inclusive
            // Then get the fractional number by dividing it by 26
            const ret = sum % 26 / 26;
            return ret;
        });
        return ret;
    }
}
class SingleRunExtractor extends (0, _baseJs2.BaseTracer) {
    constructor(){
        super();
        Object.defineProperty(this, "runPromiseResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "runPromise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** The name of the callback handler. */ Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "single_run_extractor"
        });
        this.runPromise = new Promise((extract)=>{
            this.runPromiseResolver = extract;
        });
    }
    async persistRun(run) {
        this.runPromiseResolver(run);
    }
    async extract() {
        return this.runPromise;
    }
}
class FakeVectorStore extends (0, _vectorstoresJs.VectorStore) {
    _vectorstoreType() {
        return "memory";
    }
    constructor(embeddings, { similarity, ...rest } = {}){
        super(embeddings, rest);
        Object.defineProperty(this, "memoryVectors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "similarity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.similarity = similarity ?? (0, _similaritiesJs.cosine);
    }
    /**
     * Method to add documents to the memory vector store. It extracts the
     * text from each document, generates embeddings for them, and adds the
     * resulting vectors to the store.
     * @param documents Array of `Document` instances to be added to the store.
     * @returns Promise that resolves when all documents have been added.
     */ async addDocuments(documents) {
        const texts = documents.map(({ pageContent })=>pageContent);
        return this.addVectors(await this.embeddings.embedDocuments(texts), documents);
    }
    /**
     * Method to add vectors to the memory vector store. It creates
     * `MemoryVector` instances for each vector and document pair and adds
     * them to the store.
     * @param vectors Array of vectors to be added to the store.
     * @param documents Array of `Document` instances corresponding to the vectors.
     * @returns Promise that resolves when all vectors have been added.
     */ async addVectors(vectors, documents) {
        const memoryVectors = vectors.map((embedding, idx)=>({
                content: documents[idx].pageContent,
                embedding,
                metadata: documents[idx].metadata
            }));
        this.memoryVectors = this.memoryVectors.concat(memoryVectors);
    }
    /**
     * Method to perform a similarity search in the memory vector store. It
     * calculates the similarity between the query vector and each vector in
     * the store, sorts the results by similarity, and returns the top `k`
     * results along with their scores.
     * @param query Query vector to compare against the vectors in the store.
     * @param k Number of top results to return.
     * @param filter Optional filter function to apply to the vectors before performing the search.
     * @returns Promise that resolves with an array of tuples, each containing a `Document` and its similarity score.
     */ async similaritySearchVectorWithScore(query, k, filter) {
        const filterFunction = (memoryVector)=>{
            if (!filter) return true;
            const doc = new (0, _documentJs.Document)({
                metadata: memoryVector.metadata,
                pageContent: memoryVector.content
            });
            return filter(doc);
        };
        const filteredMemoryVectors = this.memoryVectors.filter(filterFunction);
        const searches = filteredMemoryVectors.map((vector, index)=>({
                similarity: this.similarity(query, vector.embedding),
                index
            })).sort((a, b)=>a.similarity > b.similarity ? -1 : 0).slice(0, k);
        const result = searches.map((search)=>[
                new (0, _documentJs.Document)({
                    metadata: filteredMemoryVectors[search.index].metadata,
                    pageContent: filteredMemoryVectors[search.index].content
                }),
                search.similarity
            ]);
        return result;
    }
    /**
     * Static method to create a `FakeVectorStore` instance from an array of
     * texts. It creates a `Document` for each text and metadata pair, and
     * adds them to the store.
     * @param texts Array of texts to be added to the store.
     * @param metadatas Array or single object of metadata corresponding to the texts.
     * @param embeddings `Embeddings` instance used to generate embeddings for the texts.
     * @param dbConfig Optional `FakeVectorStoreArgs` to configure the `FakeVectorStore` instance.
     * @returns Promise that resolves with a new `FakeVectorStore` instance.
     */ static async fromTexts(texts, metadatas, embeddings, dbConfig) {
        const docs = [];
        for(let i = 0; i < texts.length; i += 1){
            const metadata = Array.isArray(metadatas) ? metadatas[i] : metadatas;
            const newDoc = new (0, _documentJs.Document)({
                pageContent: texts[i],
                metadata
            });
            docs.push(newDoc);
        }
        return FakeVectorStore.fromDocuments(docs, embeddings, dbConfig);
    }
    /**
     * Static method to create a `FakeVectorStore` instance from an array of
     * `Document` instances. It adds the documents to the store.
     * @param docs Array of `Document` instances to be added to the store.
     * @param embeddings `Embeddings` instance used to generate embeddings for the documents.
     * @param dbConfig Optional `FakeVectorStoreArgs` to configure the `FakeVectorStore` instance.
     * @returns Promise that resolves with a new `FakeVectorStore` instance.
     */ static async fromDocuments(docs, embeddings, dbConfig) {
        const instance = new this(embeddings, dbConfig);
        await instance.addDocuments(docs);
        return instance;
    }
    /**
     * Static method to create a `FakeVectorStore` instance from an existing
     * index. It creates a new `FakeVectorStore` instance without adding any
     * documents or vectors.
     * @param embeddings `Embeddings` instance used to generate embeddings for the documents.
     * @param dbConfig Optional `FakeVectorStoreArgs` to configure the `FakeVectorStore` instance.
     * @returns Promise that resolves with a new `FakeVectorStore` instance.
     */ static async fromExistingIndex(embeddings, dbConfig) {
        const instance = new this(embeddings, dbConfig);
        return instance;
    }
}

},{"../../chat_history.js":"1yk1a","../../documents/document.js":"8svrY","../../language_models/chat_models.js":"1XRQe","../../language_models/llms.js":"4h08k","../../messages/index.js":"7XzBK","../../output_parsers/base.js":"lJpNd","../../outputs.js":"4YkJk","../../retrievers/index.js":"czwif","../../runnables/base.js":"9xkzz","../../tools/index.js":"bXVFj","../../tracers/base.js":"5VkRj","../../embeddings.js":"iP48n","../../vectorstores.js":"77SVX","../ml-distance/similarities.js":"cueTR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"77SVX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Class for retrieving documents from a `VectorStore` based on vector similarity
 * or maximal marginal relevance (MMR).
 *
 * `VectorStoreRetriever` extends `BaseRetriever`, implementing methods for
 * adding documents to the underlying vector store and performing document
 * retrieval with optional configurations.
 *
 * @class VectorStoreRetriever
 * @extends BaseRetriever
 * @implements VectorStoreRetrieverInterface
 * @template V - Type of vector store implementing `VectorStoreInterface`.
 */ parcelHelpers.export(exports, "VectorStoreRetriever", ()=>VectorStoreRetriever);
/**
 * Abstract class representing a vector storage system for performing
 * similarity searches on embedded documents.
 *
 * `VectorStore` provides methods for adding precomputed vectors or documents,
 * removing documents based on criteria, and performing similarity searches
 * with optional scoring. Subclasses are responsible for implementing specific
 * storage mechanisms and the exact behavior of certain abstract methods.
 *
 * @abstract
 * @extends Serializable
 * @implements VectorStoreInterface
 */ parcelHelpers.export(exports, "VectorStore", ()=>VectorStore);
/**
 * Abstract class extending `VectorStore` that defines a contract for saving
 * and loading vector store instances.
 *
 * The `SaveableVectorStore` class allows vector store implementations to
 * persist their data and retrieve it when needed.The format for saving and
 * loading data is left to the implementing subclass.
 *
 * Subclasses must implement the `save` method to handle their custom
 * serialization logic, while the `load` method enables reconstruction of a
 * vector store from saved data, requiring compatible embeddings through the
 * `EmbeddingsInterface`.
 *
 * @abstract
 * @extends VectorStore
 */ parcelHelpers.export(exports, "SaveableVectorStore", ()=>SaveableVectorStore);
var _indexJs = require("./retrievers/index.js");
var _serializableJs = require("./load/serializable.js");
class VectorStoreRetriever extends (0, _indexJs.BaseRetriever) {
    static lc_name() {
        return "VectorStoreRetriever";
    }
    get lc_namespace() {
        return [
            "langchain_core",
            "vectorstores"
        ];
    }
    /**
     * Returns the type of vector store, as defined by the `vectorStore` instance.
     *
     * @returns {string} The vector store type.
     */ _vectorstoreType() {
        return this.vectorStore._vectorstoreType();
    }
    /**
     * Initializes a new instance of `VectorStoreRetriever` with the specified configuration.
     *
     * This constructor configures the retriever to interact with a given `VectorStore`
     * and supports different retrieval strategies, including similarity search and maximal
     * marginal relevance (MMR) search. Various options allow customization of the number
     * of documents retrieved per query, filtering based on conditions, and fine-tuning
     * MMR-specific parameters.
     *
     * @param fields - Configuration options for setting up the retriever:
     *
     *   - `vectorStore` (required): The `VectorStore` instance implementing `VectorStoreInterface`
     *     that will be used to store and retrieve document embeddings. This is the core component
     *     of the retriever, enabling vector-based similarity and MMR searches.
     *
     *   - `k` (optional): Specifies the number of documents to retrieve per search query. If not
     *     provided, defaults to 4. This count determines the number of most relevant documents returned
     *     for each search operation, balancing performance with comprehensiveness.
     *
     *   - `searchType` (optional): Defines the search approach used by the retriever, allowing for
     *     flexibility between two methods:
     *       - `"similarity"` (default): A similarity-based search, retrieving documents with high vector
     *         similarity to the query. This type prioritizes relevance and is often used when diversity
     *         among results is less critical.
     *       - `"mmr"`: Maximal Marginal Relevance search, which combines relevance with diversity. MMR
     *         is useful for scenarios where varied content is essential, as it selects results that
     *         both match the query and introduce content diversity.
     *
     *   - `filter` (optional): A filter of type `FilterType`, defined by the vector store, that allows
     *     for refined and targeted search results. This filter applies specified conditions to limit
     *     which documents are eligible for retrieval, offering control over the scope of results.
     *
     *   - `searchKwargs` (optional, applicable only if `searchType` is `"mmr"`): Additional settings
     *     for configuring MMR-specific behavior. These parameters allow further tuning of the MMR
     *     search process:
     *       - `fetchK`: The initial number of documents fetched from the vector store before the MMR
     *         algorithm is applied. Fetching a larger set enables the algorithm to select a more
     *         diverse subset of documents.
     *       - `lambda`: A parameter controlling the relevance-diversity balance, where 0 emphasizes
     *         diversity and 1 prioritizes relevance. Intermediate values provide a blend of the two,
     *         allowing customization based on the importance of content variety relative to query relevance.
     */ constructor(fields){
        super(fields);
        /**
         * The instance of `VectorStore` used for storing and retrieving document embeddings.
         * This vector store must implement the `VectorStoreInterface` to be compatible
         * with the retriever’s operations.
         */ Object.defineProperty(this, "vectorStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Specifies the number of documents to retrieve for each search query.
         * Defaults to 4 if not specified, providing a basic result count for similarity or MMR searches.
         */ Object.defineProperty(this, "k", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 4
        });
        /**
         * Determines the type of search operation to perform on the vector store.
         *
         * - `"similarity"` (default): Conducts a similarity search based purely on vector similarity
         *   to the query.
         * - `"mmr"`: Executes a maximal marginal relevance (MMR) search, balancing relevance and
         *   diversity in the retrieved results.
         */ Object.defineProperty(this, "searchType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "similarity"
        });
        /**
         * Additional options specific to maximal marginal relevance (MMR) search, applicable
         * only if `searchType` is set to `"mmr"`.
         *
         * Includes:
         * - `fetchK`: The initial number of documents fetched before applying the MMR algorithm,
         *   allowing for a larger selection from which to choose the most diverse results.
         * - `lambda`: A parameter between 0 and 1 to adjust the relevance-diversity balance,
         *   where 0 prioritizes diversity and 1 prioritizes relevance.
         */ Object.defineProperty(this, "searchKwargs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Optional filter applied to search results, defined by the `FilterType` of the vector store.
         * Allows for refined, targeted results by restricting the returned documents based
         * on specified filter criteria.
         */ Object.defineProperty(this, "filter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.vectorStore = fields.vectorStore;
        this.k = fields.k ?? this.k;
        this.searchType = fields.searchType ?? this.searchType;
        this.filter = fields.filter;
        if (fields.searchType === "mmr") this.searchKwargs = fields.searchKwargs;
    }
    /**
     * Retrieves relevant documents based on the specified query, using either
     * similarity or maximal marginal relevance (MMR) search.
     *
     * If `searchType` is set to `"mmr"`, performs an MMR search to balance
     * similarity and diversity among results. If `searchType` is `"similarity"`,
     * retrieves results purely based on similarity to the query.
     *
     * @param query - The query string used to find relevant documents.
     * @param runManager - Optional callback manager for tracking retrieval progress.
     * @returns A promise that resolves to an array of `DocumentInterface` instances
     *          representing the most relevant documents to the query.
     * @throws {Error} Throws an error if MMR search is requested but not supported
     *                 by the vector store.
     * @protected
     */ async _getRelevantDocuments(query, runManager) {
        if (this.searchType === "mmr") {
            if (typeof this.vectorStore.maxMarginalRelevanceSearch !== "function") throw new Error(`The vector store backing this retriever, ${this._vectorstoreType()} does not support max marginal relevance search.`);
            return this.vectorStore.maxMarginalRelevanceSearch(query, {
                k: this.k,
                filter: this.filter,
                ...this.searchKwargs
            }, runManager?.getChild("vectorstore"));
        }
        return this.vectorStore.similaritySearch(query, this.k, this.filter, runManager?.getChild("vectorstore"));
    }
    /**
     * Adds an array of documents to the vector store, embedding them as part of
     * the storage process.
     *
     * This method delegates document embedding and storage to the `addDocuments`
     * method of the underlying vector store.
     *
     * @param documents - An array of documents to embed and add to the vector store.
     * @param options - Optional settings to customize document addition.
     * @returns A promise that resolves to an array of document IDs or `void`,
     *          depending on the vector store's implementation.
     */ async addDocuments(documents, options) {
        return this.vectorStore.addDocuments(documents, options);
    }
}
class VectorStore extends (0, _serializableJs.Serializable) {
    /**
     * Initializes a new vector store with embeddings and database configuration.
     *
     * @param embeddings - Instance of `EmbeddingsInterface` used to embed queries.
     * @param dbConfig - Configuration settings for the database or storage system.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(embeddings, dbConfig){
        super(dbConfig);
        /**
         * Namespace within LangChain to uniquely identify this vector store's
         * location, based on the vector store type.
         *
         * @internal
         */ // Only ever instantiated in main LangChain
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain",
                "vectorstores",
                this._vectorstoreType()
            ]
        });
        /**
         * Embeddings interface for generating vector embeddings from text queries,
         * enabling vector-based similarity searches.
         */ Object.defineProperty(this, "embeddings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.embeddings = embeddings;
    }
    /**
     * Deletes documents from the vector store based on the specified parameters.
     *
     * @param _params - Flexible key-value pairs defining conditions for document deletion.
     * @returns A promise that resolves once the deletion is complete.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async delete(_params) {
        throw new Error("Not implemented.");
    }
    /**
     * Searches for documents similar to a text query by embedding the query and
     * performing a similarity search on the resulting vector.
     *
     * @param query - Text query for finding similar documents.
     * @param k - Number of similar results to return. Defaults to 4.
     * @param filter - Optional filter based on `FilterType`.
     * @param _callbacks - Optional callbacks for monitoring search progress
     * @returns A promise resolving to an array of `DocumentInterface` instances representing similar documents.
     */ async similaritySearch(query, k = 4, filter, _callbacks// implement passing to embedQuery later
    ) {
        const results = await this.similaritySearchVectorWithScore(await this.embeddings.embedQuery(query), k, filter);
        return results.map((result)=>result[0]);
    }
    /**
     * Searches for documents similar to a text query by embedding the query,
     * and returns results with similarity scores.
     *
     * @param query - Text query for finding similar documents.
     * @param k - Number of similar results to return. Defaults to 4.
     * @param filter - Optional filter based on `FilterType`.
     * @param _callbacks - Optional callbacks for monitoring search progress
     * @returns A promise resolving to an array of tuples, each containing a
     *          document and its similarity score.
     */ async similaritySearchWithScore(query, k = 4, filter, _callbacks// implement passing to embedQuery later
    ) {
        return this.similaritySearchVectorWithScore(await this.embeddings.embedQuery(query), k, filter);
    }
    /**
     * Creates a `VectorStore` instance from an array of text strings and optional
     * metadata, using the specified embeddings and database configuration.
     *
     * Subclasses must implement this method to define how text and metadata
     * are embedded and stored in the vector store. Throws an error if not overridden.
     *
     * @param _texts - Array of strings representing the text documents to be stored.
     * @param _metadatas - Metadata for the texts, either as an array (one for each text)
     *                     or a single object (applied to all texts).
     * @param _embeddings - Instance of `EmbeddingsInterface` to embed the texts.
     * @param _dbConfig - Database configuration settings.
     * @returns A promise that resolves to a new `VectorStore` instance.
     * @throws {Error} Throws an error if this method is not overridden by a subclass.
     */ static fromTexts(_texts, _metadatas, _embeddings, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _dbConfig) {
        throw new Error("the Langchain vectorstore implementation you are using forgot to override this, please report a bug");
    }
    /**
     * Creates a `VectorStore` instance from an array of documents, using the specified
     * embeddings and database configuration.
     *
     * Subclasses must implement this method to define how documents are embedded
     * and stored. Throws an error if not overridden.
     *
     * @param _docs - Array of `DocumentInterface` instances representing the documents to be stored.
     * @param _embeddings - Instance of `EmbeddingsInterface` to embed the documents.
     * @param _dbConfig - Database configuration settings.
     * @returns A promise that resolves to a new `VectorStore` instance.
     * @throws {Error} Throws an error if this method is not overridden by a subclass.
     */ static fromDocuments(_docs, _embeddings, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _dbConfig) {
        throw new Error("the Langchain vectorstore implementation you are using forgot to override this, please report a bug");
    }
    /**
     * Creates a `VectorStoreRetriever` instance with flexible configuration options.
     *
     * @param kOrFields
     *    - If a number is provided, it sets the `k` parameter (number of items to retrieve).
     *    - If an object is provided, it should contain various configuration options.
     * @param filter
     *    - Optional filter criteria to limit the items retrieved based on the specified filter type.
     * @param callbacks
     *    - Optional callbacks that may be triggered at specific stages of the retrieval process.
     * @param tags
     *    - Tags to categorize or label the `VectorStoreRetriever`. Defaults to an empty array if not provided.
     * @param metadata
     *    - Additional metadata as key-value pairs to add contextual information for the retrieval process.
     * @param verbose
     *    - If `true`, enables detailed logging for the retrieval process. Defaults to `false`.
     *
     * @returns
     *    - A configured `VectorStoreRetriever` instance based on the provided parameters.
     *
     * @example
     * Basic usage with a `k` value:
     * ```typescript
     * const retriever = myVectorStore.asRetriever(5);
     * ```
     *
     * Usage with a configuration object:
     * ```typescript
     * const retriever = myVectorStore.asRetriever({
     *   k: 10,
     *   filter: myFilter,
     *   tags: ['example', 'test'],
     *   verbose: true,
     *   searchType: 'mmr',
     *   searchKwargs: { alpha: 0.5 },
     * });
     * ```
     */ asRetriever(kOrFields, filter, callbacks, tags, metadata, verbose) {
        if (typeof kOrFields === "number") return new VectorStoreRetriever({
            vectorStore: this,
            k: kOrFields,
            filter,
            tags: [
                ...tags ?? [],
                this._vectorstoreType()
            ],
            metadata,
            verbose,
            callbacks
        });
        else {
            const params = {
                vectorStore: this,
                k: kOrFields?.k,
                filter: kOrFields?.filter,
                tags: [
                    ...kOrFields?.tags ?? [],
                    this._vectorstoreType()
                ],
                metadata: kOrFields?.metadata,
                verbose: kOrFields?.verbose,
                callbacks: kOrFields?.callbacks,
                searchType: kOrFields?.searchType
            };
            if (kOrFields?.searchType === "mmr") return new VectorStoreRetriever({
                ...params,
                searchKwargs: kOrFields.searchKwargs
            });
            return new VectorStoreRetriever({
                ...params
            });
        }
    }
}
class SaveableVectorStore extends VectorStore {
    /**
     * Loads a vector store instance from the specified directory, using the
     * provided embeddings to ensure compatibility.
     *
     * This static method reconstructs a `SaveableVectorStore` from previously
     * saved data. Implementations should interpret the saved data format to
     * recreate the vector store instance.
     *
     * @param _directory - The directory path from which the vector store
     * data will be loaded.
     * @param _embeddings - An instance of `EmbeddingsInterface` to align
     * the embeddings with the loaded vector data.
     * @returns A promise that resolves to a `SaveableVectorStore` instance
     * constructed from the saved data.
     */ static load(_directory, _embeddings) {
        throw new Error("Not implemented");
    }
}

},{"./retrievers/index.js":"czwif","./load/serializable.js":"2n7FI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kUlzY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isZodSchemaJs = require("./is_zod_schema.js");
parcelHelpers.exportAll(_isZodSchemaJs, exports);

},{"./is_zod_schema.js":"3S7D5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i4Ulm":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // @ts-nocheck
// Stringify that can handle circular references.
// Inlined due to ESM import issues
// Source: https://www.npmjs.com/package/fast-safe-stringify
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Regular stringify
parcelHelpers.export(exports, "stringify", ()=>stringify);
var LIMIT_REPLACE_NODE = "[...]";
var CIRCULAR_REPLACE_NODE = "[Circular]";
var arr = [];
var replacerStack = [];
function defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
function stringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = defaultOptions();
    decirc(obj, "", 0, [], undefined, 0, options);
    var res;
    try {
        if (replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        while(arr.length !== 0){
            var part = arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        arr.push([
            parent,
            k,
            val
        ]);
    }
}
function decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            setReplace(CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = defaultOptions();
    var tmp = deterministicDecirc(obj, "", 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if (replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        // Ensure that we restore the object as it was.
        while(arr.length !== 0){
            var part = arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            setReplace(CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === "function") return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort(compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== "undefined") {
                arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function replaceGetterValues(replacer) {
    replacer = typeof replacer !== "undefined" ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if (replacerStack.length > 0) for(var i = 0; i < replacerStack.length; i++){
            var part = replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1DleB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7VUFX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c1Cbq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseJs = require("./base.js");
parcelHelpers.exportAll(_baseJs, exports);
var _batchJs = require("./batch.js");
parcelHelpers.exportAll(_batchJs, exports);
var _memoryJs = require("./memory.js");
parcelHelpers.exportAll(_memoryJs, exports);

},{"./base.js":"dq5pW","./batch.js":"hSnK5","./memory.js":"3tBRX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dq5pW":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Error thrown when an invalid namespace is provided.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InvalidNamespaceError", ()=>InvalidNamespaceError);
/**
 * Abstract base class for key-value stores.
 */ parcelHelpers.export(exports, "BaseStore", ()=>BaseStore);
class InvalidNamespaceError extends Error {
    constructor(message){
        super(message);
        this.name = "InvalidNamespaceError";
    }
}
/**
 * Validates the provided namespace.
 * @param namespace The namespace to validate.
 * @throws {InvalidNamespaceError} If the namespace is invalid.
 */ function validateNamespace(namespace) {
    if (namespace.length === 0) throw new InvalidNamespaceError("Namespace cannot be empty.");
    for (const label of namespace){
        if (typeof label !== "string") throw new InvalidNamespaceError(`Invalid namespace label '${label}' found in ${namespace}. Namespace labels ` + `must be strings, but got ${typeof label}.`);
        if (label.includes(".")) throw new InvalidNamespaceError(`Invalid namespace label '${label}' found in ${namespace}. Namespace labels cannot contain periods ('.').`);
        if (label === "") throw new InvalidNamespaceError(`Namespace labels cannot be empty strings. Got ${label} in ${namespace}`);
    }
    if (namespace[0] === "langgraph") throw new InvalidNamespaceError(`Root label for namespace cannot be "langgraph". Got: ${namespace}`);
}
class BaseStore {
    // convenience methods
    /**
     * Retrieve a single item.
     * @param namespace Hierarchical path for the item.
     * @param key Unique identifier within the namespace.
     * @returns A promise that resolves to the retrieved item or null if not found.
     */ async get(namespace, key) {
        const batchResult = await this.batch([
            {
                namespace,
                key
            }
        ]);
        return batchResult[0];
    }
    /**
     * Search for items within a namespace prefix.
     * @param namespacePrefix Hierarchical path prefix to search within.
     * @param options Search options.
     * @param options.filter Key-value pairs to filter results.
     * @param options.limit Maximum number of items to return (default: 10).
     * @param options.offset Number of items to skip before returning results (default: 0).
     * @returns A promise that resolves to a list of items matching the search criteria.
     */ async search(namespacePrefix, options) {
        const optionsWithDefaults = {
            limit: 10,
            offset: 0,
            ...options || {}
        };
        const batchResults = await this.batch([
            {
                namespacePrefix,
                ...optionsWithDefaults
            }
        ]);
        return batchResults[0];
    }
    /**
     * Store or update an item.
     * @param namespace Hierarchical path for the item.
     * @param key Unique identifier within the namespace.
     * @param value Object containing the item's data.
     */ async put(namespace, key, value) {
        validateNamespace(namespace);
        await this.batch([
            {
                namespace,
                key,
                value
            }
        ]);
    }
    /**
     * Delete an item.
     * @param namespace Hierarchical path for the item.
     * @param key Unique identifier within the namespace.
     */ async delete(namespace, key) {
        await this.batch([
            {
                namespace,
                key,
                value: null
            }
        ]);
    }
    /**
     * List and filter namespaces in the store.
     * @param options Options for listing namespaces.
     * @param options.prefix Filter namespaces that start with this path.
     * @param options.suffix Filter namespaces that end with this path.
     * @param options.maxDepth Return namespaces up to this depth in the hierarchy.
     * @param options.limit Maximum number of namespaces to return (default 100).
     * @param options.offset Number of namespaces to skip for pagination (default 0).
     * @returns A promise that resolves to a list of namespace arrays that match the criteria.
     */ async listNamespaces(options) {
        const { prefix, suffix, maxDepth, limit = 100, offset = 0 } = options;
        const matchConditions = [];
        if (prefix) matchConditions.push({
            matchType: "prefix",
            path: prefix
        });
        if (suffix) matchConditions.push({
            matchType: "suffix",
            path: suffix
        });
        const op = {
            matchConditions: matchConditions.length > 0 ? matchConditions : undefined,
            maxDepth,
            limit,
            offset
        };
        const batchResults = await this.batch([
            op
        ]);
        return batchResults[0];
    }
    /**
     * Stop the store. No-op if not implemented.
     */ stop() {
    // no-op if not implemented.
    }
    /**
     * Start the store. No-op if not implemented.
     */ start() {
    // no-op if not implemented.
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hSnK5":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-explicit-any */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncBatchedStore", ()=>AsyncBatchedStore);
var _baseJs = require("./base.js");
class AsyncBatchedStore extends (0, _baseJs.BaseStore) {
    constructor(store){
        super();
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "queue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "nextKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "running", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "processingTask", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.store = store;
    }
    get isRunning() {
        return this.running;
    }
    /**
     * @ignore
     * Batch is not implemented here as we're only extending `BaseStore`
     * to allow it to be passed where `BaseStore` is expected, and implement
     * the convenience methods (get, search, put, delete).
     */ async batch(_operations) {
        throw new Error("The `batch` method is not implemented on `AsyncBatchedStore`.\n Instead, it calls the `batch` method on the wrapped store.\n If you are seeing this error, something is wrong.");
    }
    async get(namespace, key) {
        return this.enqueueOperation({
            namespace,
            key
        });
    }
    async search(namespacePrefix, options) {
        const { filter, limit = 10, offset = 0 } = options || {};
        return this.enqueueOperation({
            namespacePrefix,
            filter,
            limit,
            offset
        });
    }
    async put(namespace, key, value) {
        return this.enqueueOperation({
            namespace,
            key,
            value
        });
    }
    async delete(namespace, key) {
        return this.enqueueOperation({
            namespace,
            key,
            value: null
        });
    }
    start() {
        if (!this.running) {
            this.running = true;
            this.processingTask = this.processBatchQueue();
        }
    }
    async stop() {
        this.running = false;
        if (this.processingTask) await this.processingTask;
    }
    enqueueOperation(operation) {
        return new Promise((resolve, reject)=>{
            const key = this.nextKey;
            this.nextKey += 1;
            this.queue.set(key, {
                operation,
                resolve,
                reject
            });
        });
    }
    async processBatchQueue() {
        while(this.running){
            await new Promise((resolve)=>{
                setTimeout(resolve, 0);
            });
            if (this.queue.size === 0) continue;
            const batch = new Map(this.queue);
            this.queue.clear();
            try {
                const operations = Array.from(batch.values()).map(({ operation })=>operation);
                const results = await this.store.batch(operations);
                batch.forEach(({ resolve }, key)=>{
                    const index = Array.from(batch.keys()).indexOf(key);
                    resolve(results[index]);
                });
            } catch (e) {
                batch.forEach(({ reject })=>{
                    reject(e);
                });
            }
        }
    }
}

},{"./base.js":"dq5pW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3tBRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InMemoryStore", ()=>InMemoryStore);
/** @deprecated Alias for InMemoryStore */ parcelHelpers.export(exports, "MemoryStore", ()=>MemoryStore);
var _baseJs = require("./base.js");
class InMemoryStore extends (0, _baseJs.BaseStore) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    async batch(operations) {
        const results = [];
        for (const op of operations){
            if ("key" in op && "namespace" in op && !("value" in op)) // GetOperation
            results.push(this.getOperation(op));
            else if ("namespacePrefix" in op) // SearchOperation
            results.push(this.searchOperation(op));
            else if ("value" in op) // PutOperation
            results.push(this.putOperation(op));
            else if ("matchConditions" in op) // ListNamespacesOperation
            results.push(this.listNamespacesOperation(op));
        }
        return Promise.resolve(results);
    }
    getOperation(op) {
        const namespaceKey = op.namespace.join(":");
        const item = this.data.get(namespaceKey)?.get(op.key);
        return item || null;
    }
    searchOperation(op) {
        const candidates = [];
        for (const [namespace, items] of this.data.entries())if (namespace.startsWith(op.namespacePrefix.join(":"))) candidates.push(...items.values());
        let filteredCandidates = candidates;
        if (op.filter) filteredCandidates = candidates.filter((item)=>Object.entries(op.filter).every(([key, value])=>item.value[key] === value));
        const searchResults = filteredCandidates.slice(op.offset || 0, (op.offset || 0) + (op.limit || 10));
        return searchResults;
    }
    putOperation(op) {
        const namespaceKey = op.namespace.join(":");
        if (!this.data.has(namespaceKey)) this.data.set(namespaceKey, new Map());
        const namespaceMap = this.data.get(namespaceKey);
        if (op.value === null) namespaceMap.delete(op.key);
        else {
            const now = new Date();
            if (namespaceMap.has(op.key)) {
                const item = namespaceMap.get(op.key);
                item.value = op.value;
                item.updatedAt = now;
            } else namespaceMap.set(op.key, {
                value: op.value,
                key: op.key,
                namespace: op.namespace,
                createdAt: now,
                updatedAt: now
            });
        }
    }
    listNamespacesOperation(op) {
        const allNamespaces = Array.from(this.data.keys()).map((ns)=>ns.split(":"));
        let namespaces = allNamespaces;
        if (op.matchConditions && op.matchConditions.length > 0) namespaces = namespaces.filter((ns)=>op.matchConditions.every((condition)=>this.doesMatch(condition, ns)));
        if (op.maxDepth !== undefined) namespaces = Array.from(new Set(namespaces.map((ns)=>ns.slice(0, op.maxDepth).join(":")))).map((ns)=>ns.split(":"));
        namespaces.sort((a, b)=>a.join(":").localeCompare(b.join(":")));
        const paginatedNamespaces = namespaces.slice(op.offset, op.offset + op.limit);
        return paginatedNamespaces;
    }
    doesMatch(matchCondition, key) {
        const { matchType, path } = matchCondition;
        if (key.length < path.length) return false;
        if (matchType === "prefix") return path.every((pElem, index)=>{
            const kElem = key[index];
            return pElem === "*" || kElem === pElem;
        });
        else if (matchType === "suffix") return [
            ...path
        ].reverse().every((pElem, index)=>{
            const kElem = key[key.length - 1 - index];
            return pElem === "*" || kElem === pElem;
        });
        throw new Error(`Unsupported match type: ${matchType}`);
    }
}
class MemoryStore extends InMemoryStore {
}

},{"./base.js":"dq5pW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kuySs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Stores the last value received, can receive at most one value per step.
 *
 * Since `update` is only called once per step and value can only be of length 1,
 * LastValue always stores the last value of a single node. If multiple nodes attempt to
 * write to this channel in a single step, an error will be thrown.
 * @internal
 */ parcelHelpers.export(exports, "LastValue", ()=>LastValue);
var _errorsJs = require("../errors.js");
var _baseJs = require("./base.js");
class LastValue extends (0, _baseJs.BaseChannel) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "lc_graph_name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "LastValue"
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    fromCheckpoint(checkpoint) {
        const empty = new LastValue();
        if (checkpoint) empty.value = checkpoint;
        return empty;
    }
    update(values) {
        if (values.length === 0) return false;
        if (values.length !== 1) throw new (0, _errorsJs.InvalidUpdateError)("LastValue can only receive one value per step.", {
            lc_error_code: "INVALID_CONCURRENT_GRAPH_UPDATE"
        });
        // eslint-disable-next-line prefer-destructuring
        this.value = values[values.length - 1];
        return true;
    }
    get() {
        if (this.value === undefined) throw new (0, _errorsJs.EmptyChannelError)();
        return this.value;
    }
    checkpoint() {
        if (this.value === undefined) throw new (0, _errorsJs.EmptyChannelError)();
        return this.value;
    }
}

},{"../errors.js":"jKiOM","./base.js":"UYQzM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4p0hG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "ManagedValue", ()=>ManagedValue);
parcelHelpers.export(exports, "WritableManagedValue", ()=>WritableManagedValue);
parcelHelpers.export(exports, "ChannelKeyPlaceholder", ()=>ChannelKeyPlaceholder);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "ManagedValueMapping", ()=>ManagedValueMapping);
parcelHelpers.export(exports, "isManagedValue", ()=>isManagedValue);
parcelHelpers.export(exports, "isConfiguredManagedValue", ()=>isConfiguredManagedValue);
/**
 * No-op class used when getting state values, as managed values should never be returned
 * in get state calls.
 */ parcelHelpers.export(exports, "NoopManagedValue", ()=>NoopManagedValue);
var _constantsJs = require("../constants.js");
class ManagedValue {
    constructor(config, _params){
        Object.defineProperty(this, "runtime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_promises", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "lg_is_managed_value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        this.config = config;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static async initialize(_config, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _args) {
        throw new Error("Not implemented");
    }
    async promises() {
        return Promise.all(this._promises);
    }
    addPromise(promise) {
        this._promises.push(promise);
    }
}
class WritableManagedValue extends ManagedValue {
}
const ChannelKeyPlaceholder = "__channel_key_placeholder__";
class ManagedValueMapping extends Map {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(entries){
        super(entries ? Array.from(entries) : undefined);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replaceRuntimeValues(step, values) {
        if (this.size === 0 || !values) return;
        if (Array.from(this.values()).every((mv)=>!mv.runtime)) return;
        if (typeof values === "object" && !Array.isArray(values)) for (const [key, value] of Object.entries(values)){
            for (const [chan, mv] of this.entries())if (mv.runtime && mv.call(step) === value) // eslint-disable-next-line no-param-reassign
            values[key] = {
                [(0, _constantsJs.RUNTIME_PLACEHOLDER)]: chan
            };
        }
        else if (typeof values === "object" && "constructor" in values) {
            for (const key of Object.getOwnPropertyNames(Object.getPrototypeOf(values)))try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const value = values[key];
                for (const [chan, mv] of this.entries())if (mv.runtime && mv.call(step) === value) // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-param-reassign
                values[key] = {
                    [(0, _constantsJs.RUNTIME_PLACEHOLDER)]: chan
                };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                // Ignore if TypeError
                if (error.name !== TypeError.name) throw error;
            }
        }
    }
    replaceRuntimePlaceholders(step, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    values) {
        if (this.size === 0 || !values) return;
        if (Array.from(this.values()).every((mv)=>!mv.runtime)) return;
        if (typeof values === "object" && !Array.isArray(values)) {
            for (const [key, value] of Object.entries(values))if (typeof value === "object" && value !== null && (0, _constantsJs.RUNTIME_PLACEHOLDER) in value) {
                const placeholder = value[0, _constantsJs.RUNTIME_PLACEHOLDER];
                if (typeof placeholder === "string") // eslint-disable-next-line no-param-reassign
                values[key] = this.get(placeholder)?.call(step);
            }
        } else if (typeof values === "object" && "constructor" in values) {
            for (const key of Object.getOwnPropertyNames(Object.getPrototypeOf(values)))try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const value = values[key];
                if (typeof value === "object" && value !== null && (0, _constantsJs.RUNTIME_PLACEHOLDER) in value) {
                    const managedValue = this.get(value[0, _constantsJs.RUNTIME_PLACEHOLDER]);
                    if (managedValue) // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-param-reassign
                    values[key] = managedValue.call(step);
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                // Ignore if TypeError
                if (error.name !== TypeError.name) throw error;
            }
        }
    }
}
function isManagedValue(value) {
    if (typeof value === "object" && value && "lg_is_managed_value" in value) return true;
    return false;
}
function isConfiguredManagedValue(value) {
    if (typeof value === "object" && value && "cls" in value && "params" in value) return true;
    return false;
}
class NoopManagedValue extends ManagedValue {
    call() {}
    static async initialize(config, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _args) {
        return Promise.resolve(new NoopManagedValue(config));
    }
}

},{"../constants.js":"1BFWS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1BFWS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INPUT", ()=>INPUT);
parcelHelpers.export(exports, "ERROR", ()=>ERROR);
parcelHelpers.export(exports, "CONFIG_KEY_SEND", ()=>CONFIG_KEY_SEND);
parcelHelpers.export(exports, "CONFIG_KEY_READ", ()=>CONFIG_KEY_READ);
parcelHelpers.export(exports, "CONFIG_KEY_CHECKPOINTER", ()=>CONFIG_KEY_CHECKPOINTER);
parcelHelpers.export(exports, "CONFIG_KEY_RESUMING", ()=>CONFIG_KEY_RESUMING);
parcelHelpers.export(exports, "CONFIG_KEY_TASK_ID", ()=>CONFIG_KEY_TASK_ID);
parcelHelpers.export(exports, "CONFIG_KEY_STREAM", ()=>CONFIG_KEY_STREAM);
parcelHelpers.export(exports, "CONFIG_KEY_CHECKPOINT_MAP", ()=>CONFIG_KEY_CHECKPOINT_MAP);
parcelHelpers.export(exports, "INTERRUPT", ()=>INTERRUPT);
parcelHelpers.export(exports, "RUNTIME_PLACEHOLDER", ()=>RUNTIME_PLACEHOLDER);
parcelHelpers.export(exports, "RECURSION_LIMIT_DEFAULT", ()=>RECURSION_LIMIT_DEFAULT);
parcelHelpers.export(exports, "TAG_HIDDEN", ()=>TAG_HIDDEN);
parcelHelpers.export(exports, "TAG_NOSTREAM", ()=>TAG_NOSTREAM);
parcelHelpers.export(exports, "TASKS", ()=>TASKS);
parcelHelpers.export(exports, "PUSH", ()=>PUSH);
parcelHelpers.export(exports, "PULL", ()=>PULL);
parcelHelpers.export(exports, "TASK_NAMESPACE", ()=>TASK_NAMESPACE);
parcelHelpers.export(exports, "RESERVED", ()=>RESERVED);
parcelHelpers.export(exports, "CHECKPOINT_NAMESPACE_SEPARATOR", ()=>CHECKPOINT_NAMESPACE_SEPARATOR);
parcelHelpers.export(exports, "CHECKPOINT_NAMESPACE_END", ()=>CHECKPOINT_NAMESPACE_END);
parcelHelpers.export(exports, "_isSendInterface", ()=>_isSendInterface);
/**
 *
 * A message or packet to send to a specific node in the graph.
 *
 * The `Send` class is used within a `StateGraph`'s conditional edges to
 * dynamically invoke a node with a custom state at the next step.
 *
 * Importantly, the sent state can differ from the core graph's state,
 * allowing for flexible and dynamic workflow management.
 *
 * One such example is a "map-reduce" workflow where your graph invokes
 * the same node multiple times in parallel with different states,
 * before aggregating the results back into the main graph's state.
 *
 * @example
 * ```typescript
 * import { Annotation, Send, StateGraph } from "@langchain/langgraph";
 *
 * const ChainState = Annotation.Root({
 *   subjects: Annotation<string[]>,
 *   jokes: Annotation<string[]>({
 *     reducer: (a, b) => a.concat(b),
 *   }),
 * });
 *
 * const continueToJokes = async (state: typeof ChainState.State) => {
 *   return state.subjects.map((subject) => {
 *     return new Send("generate_joke", { subjects: [subject] });
 *   });
 * };
 *
 * const graph = new StateGraph(ChainState)
 *   .addNode("generate_joke", (state) => ({
 *     jokes: [`Joke about ${state.subjects}`],
 *   }))
 *   .addConditionalEdges("__start__", continueToJokes)
 *   .addEdge("generate_joke", "__end__")
 *   .compile();
 *
 * const res = await graph.invoke({ subjects: ["cats", "dogs"] });
 * console.log(res);
 *
 * // Invoking with two subjects results in a generated joke for each
 * // { subjects: ["cats", "dogs"], jokes: [`Joke about cats`, `Joke about dogs`] }
 * ```
 */ parcelHelpers.export(exports, "Send", ()=>Send);
parcelHelpers.export(exports, "_isSend", ()=>_isSend);
const INPUT = "__input__";
const ERROR = "__error__";
const CONFIG_KEY_SEND = "__pregel_send";
const CONFIG_KEY_READ = "__pregel_read";
const CONFIG_KEY_CHECKPOINTER = "__pregel_checkpointer";
const CONFIG_KEY_RESUMING = "__pregel_resuming";
const CONFIG_KEY_TASK_ID = "__pregel_task_id";
const CONFIG_KEY_STREAM = "__pregel_stream";
const CONFIG_KEY_CHECKPOINT_MAP = "checkpoint_map";
const INTERRUPT = "__interrupt__";
const RUNTIME_PLACEHOLDER = "__pregel_runtime_placeholder__";
const RECURSION_LIMIT_DEFAULT = 25;
const TAG_HIDDEN = "langsmith:hidden";
const TAG_NOSTREAM = "langsmith:nostream";
const TASKS = "__pregel_tasks";
const PUSH = "__pregel_push";
const PULL = "__pregel_pull";
const TASK_NAMESPACE = "6ba7b831-9dad-11d1-80b4-00c04fd430c8";
const RESERVED = [
    INTERRUPT,
    ERROR,
    TASKS,
    CONFIG_KEY_SEND,
    CONFIG_KEY_READ,
    CONFIG_KEY_CHECKPOINTER,
    CONFIG_KEY_RESUMING,
    CONFIG_KEY_TASK_ID,
    CONFIG_KEY_STREAM,
    CONFIG_KEY_CHECKPOINT_MAP,
    INPUT
];
const CHECKPOINT_NAMESPACE_SEPARATOR = "|";
const CHECKPOINT_NAMESPACE_END = ":";
function _isSendInterface(x) {
    const operation = x;
    return typeof operation.node === "string" && operation.args !== undefined;
}
class Send {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(node, args){
        Object.defineProperty(this, "node", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: node
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: args
        });
        Object.defineProperty(this, "lg_name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Send"
        });
    }
}
function _isSend(x) {
    const operation = x;
    return operation.lg_name === "Send";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"20bEW":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-use-before-define */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "START", ()=>START);
parcelHelpers.export(exports, "END", ()=>END);
parcelHelpers.export(exports, "Branch", ()=>Branch);
parcelHelpers.export(exports, "Graph", ()=>Graph);
parcelHelpers.export(exports, "CompiledGraph", ()=>CompiledGraph);
var _runnables = require("@langchain/core/runnables");
var _graph = require("@langchain/core/runnables/graph");
var _zod = require("zod");
var _uuid = require("uuid");
var _readJs = require("../pregel/read.js");
var _indexJs = require("../pregel/index.js");
var _ephemeralValueJs = require("../channels/ephemeral_value.js");
var _writeJs = require("../pregel/write.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _errorsJs = require("../errors.js");
var _subgraphJs = require("../pregel/utils/subgraph.js");
const START = "__start__";
const END = "__end__";
class Branch {
    constructor(options){
        Object.defineProperty(this, "condition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ends", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.condition = options.path;
        this.ends = Array.isArray(options.pathMap) ? options.pathMap.reduce((acc, n)=>{
            acc[n] = n;
            return acc;
        }, {}) : options.pathMap;
    }
    compile(writer, reader) {
        return (0, _writeJs.ChannelWrite).registerWriter(new (0, _utilsJs.RunnableCallable)({
            trace: false,
            func: async (input, config)=>{
                try {
                    return await this._route(input, config, writer, reader);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    // Detect & warn if NodeInterrupt is thrown in a conditional edge
                    if (e.name === (0, _errorsJs.NodeInterrupt).unminifiable_name) console.warn("[WARN]: 'NodeInterrupt' thrown in conditional edge. This is likely a bug in your graph implementation.\nNodeInterrupt should only be thrown inside a node, not in edge conditions.");
                    throw e;
                }
            }
        }));
    }
    async _route(input, config, writer, reader) {
        let result = await this.condition(reader ? reader(config) : input, config);
        if (!Array.isArray(result)) result = [
            result
        ];
        let destinations;
        if (this.ends) destinations = result.map((r)=>(0, _constantsJs._isSend)(r) ? r : this.ends[r]);
        else destinations = result;
        if (destinations.some((dest)=>!dest)) throw new Error("Branch condition returned unknown or null destination");
        if (destinations.filter((0, _constantsJs._isSend)).some((packet)=>packet.node === END)) throw new (0, _errorsJs.InvalidUpdateError)("Cannot send a packet to the END node");
        return writer(destinations);
    }
}
class Graph {
    constructor(){
        Object.defineProperty(this, "nodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "edges", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "branches", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "entryPoint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "compiled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        this.nodes = {};
        this.edges = new Set();
        this.branches = {};
    }
    warnIfCompiled(message) {
        if (this.compiled) console.warn(message);
    }
    get allEdges() {
        return this.edges;
    }
    addNode(key, action, options) {
        for (const reservedChar of [
            (0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR),
            (0, _constantsJs.CHECKPOINT_NAMESPACE_END)
        ]){
            if (key.includes(reservedChar)) throw new Error(`"${reservedChar}" is a reserved character and is not allowed in node names.`);
        }
        this.warnIfCompiled(`Adding a node to a graph that has already been compiled. This will not be reflected in the compiled graph.`);
        if (key in this.nodes) throw new Error(`Node \`${key}\` already present.`);
        if (key === END) throw new Error(`Node \`${key}\` is reserved.`);
        const runnable = (0, _runnables._coerceToRunnable)(// Account for arbitrary state due to Send API
        action);
        this.nodes[key] = {
            runnable,
            metadata: options?.metadata,
            subgraphs: (0, _subgraphJs.isPregelLike)(runnable) ? [
                runnable
            ] : options?.subgraphs
        };
        return this;
    }
    addEdge(startKey, endKey) {
        this.warnIfCompiled(`Adding an edge to a graph that has already been compiled. This will not be reflected in the compiled graph.`);
        if (startKey === END) throw new Error("END cannot be a start node");
        if (endKey === START) throw new Error("START cannot be an end node");
        if (Array.from(this.edges).some(([start])=>start === startKey) && !("channels" in this)) throw new Error(`Already found path for ${startKey}. For multiple edges, use StateGraph.`);
        this.edges.add([
            startKey,
            endKey
        ]);
        return this;
    }
    addConditionalEdges(source, path, pathMap) {
        const options = typeof source === "object" ? source : {
            source,
            path: path,
            pathMap
        };
        this.warnIfCompiled("Adding an edge to a graph that has already been compiled. This will not be reflected in the compiled graph.");
        // find a name for condition
        const name = options.path.name || "condition";
        // validate condition
        if (this.branches[options.source] && this.branches[options.source][name]) throw new Error(`Condition \`${name}\` already present for node \`${source}\``);
        // save it
        if (!this.branches[options.source]) this.branches[options.source] = {};
        this.branches[options.source][name] = new Branch(options);
        return this;
    }
    /**
     * @deprecated use `addEdge(START, key)` instead
     */ setEntryPoint(key) {
        this.warnIfCompiled("Setting the entry point of a graph that has already been compiled. This will not be reflected in the compiled graph.");
        return this.addEdge(START, key);
    }
    /**
     * @deprecated use `addEdge(key, END)` instead
     */ setFinishPoint(key) {
        this.warnIfCompiled("Setting a finish point of a graph that has already been compiled. This will not be reflected in the compiled graph.");
        return this.addEdge(key, END);
    }
    compile({ checkpointer, interruptBefore, interruptAfter } = {}) {
        // validate the graph
        this.validate([
            ...Array.isArray(interruptBefore) ? interruptBefore : [],
            ...Array.isArray(interruptAfter) ? interruptAfter : []
        ]);
        // create empty compiled graph
        const compiled = new CompiledGraph({
            builder: this,
            checkpointer,
            interruptAfter,
            interruptBefore,
            autoValidate: false,
            nodes: {},
            channels: {
                [START]: new (0, _ephemeralValueJs.EphemeralValue)(),
                [END]: new (0, _ephemeralValueJs.EphemeralValue)()
            },
            inputChannels: START,
            outputChannels: END,
            streamChannels: [],
            streamMode: "values"
        });
        // attach nodes, edges and branches
        for (const [key, node] of Object.entries(this.nodes))compiled.attachNode(key, node);
        for (const [start, end] of this.edges)compiled.attachEdge(start, end);
        for (const [start, branches] of Object.entries(this.branches))for (const [name, branch] of Object.entries(branches))compiled.attachBranch(start, name, branch);
        return compiled.validate();
    }
    validate(interrupt) {
        // assemble sources
        const allSources = new Set([
            ...this.allEdges
        ].map(([src, _])=>src));
        for (const [start] of Object.entries(this.branches))allSources.add(start);
        for (const source of allSources){
            if (source !== START && !(source in this.nodes)) throw new Error(`Found edge starting at unknown node \`${source}\``);
        }
        // assemble targets
        const allTargets = new Set([
            ...this.allEdges
        ].map(([_, target])=>target));
        for (const [start, branches] of Object.entries(this.branches))for (const branch of Object.values(branches)){
            if (branch.ends) for (const end of Object.values(branch.ends))allTargets.add(end);
            else {
                allTargets.add(END);
                for (const node of Object.keys(this.nodes))if (node !== start) allTargets.add(node);
            }
        }
        // validate targets
        for (const node of Object.keys(this.nodes)){
            if (!allTargets.has(node)) throw new Error(`Node \`${node}\` is not reachable`);
        }
        for (const target of allTargets){
            if (target !== END && !(target in this.nodes)) throw new Error(`Found edge ending at unknown node \`${target}\``);
        }
        // validate interrupts
        if (interrupt) for (const node of interrupt){
            if (!(node in this.nodes)) throw new Error(`Interrupt node \`${node}\` is not present`);
        }
        this.compiled = true;
    }
}
class CompiledGraph extends (0, _indexJs.Pregel) {
    constructor({ builder, ...rest }){
        super(rest);
        Object.defineProperty(this, "builder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.builder = builder;
    }
    attachNode(key, node) {
        this.channels[key] = new (0, _ephemeralValueJs.EphemeralValue)();
        this.nodes[key] = new (0, _readJs.PregelNode)({
            channels: [],
            triggers: [],
            metadata: node.metadata,
            subgraphs: node.subgraphs
        }).pipe(node.runnable).pipe(new (0, _writeJs.ChannelWrite)([
            {
                channel: key,
                value: (0, _writeJs.PASSTHROUGH)
            }
        ], [
            (0, _constantsJs.TAG_HIDDEN)
        ]));
        this.streamChannels.push(key);
    }
    attachEdge(start, end) {
        if (end === END) {
            if (start === START) throw new Error("Cannot have an edge from START to END");
            this.nodes[start].writers.push(new (0, _writeJs.ChannelWrite)([
                {
                    channel: END,
                    value: (0, _writeJs.PASSTHROUGH)
                }
            ], [
                (0, _constantsJs.TAG_HIDDEN)
            ]));
        } else {
            this.nodes[end].triggers.push(start);
            this.nodes[end].channels.push(start);
        }
    }
    attachBranch(start, name, branch) {
        // add hidden start node
        if (start === START && this.nodes[START]) this.nodes[START] = (0, _indexJs.Channel).subscribeTo(START, {
            tags: [
                (0, _constantsJs.TAG_HIDDEN)
            ]
        });
        // attach branch writer
        this.nodes[start].pipe(branch.compile((dests)=>{
            const writes = dests.map((dest)=>{
                if ((0, _constantsJs._isSend)(dest)) return dest;
                return {
                    channel: dest === END ? END : `branch:${start}:${name}:${dest}`,
                    value: (0, _writeJs.PASSTHROUGH)
                };
            });
            return new (0, _writeJs.ChannelWrite)(writes, [
                (0, _constantsJs.TAG_HIDDEN)
            ]);
        }));
        // attach branch readers
        const ends = branch.ends ? Object.values(branch.ends) : Object.keys(this.nodes);
        for (const end of ends)if (end !== END) {
            const channelName = `branch:${start}:${name}:${end}`;
            this.channels[channelName] = new (0, _ephemeralValueJs.EphemeralValue)();
            this.nodes[end].triggers.push(channelName);
            this.nodes[end].channels.push(channelName);
        }
    }
    /**
     * Returns a drawable representation of the computation graph.
     */ async getGraphAsync(config) {
        const xray = config?.xray;
        const graph = new (0, _graph.Graph)();
        const startNodes = {
            [START]: graph.addNode({
                schema: (0, _zod.z).any()
            }, START)
        };
        const endNodes = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let subgraphs = {};
        if (xray) subgraphs = Object.fromEntries((await (0, _utilsJs.gatherIterator)(this.getSubgraphsAsync())).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (x)=>isCompiledGraph(x[1])));
        function addEdge(start, end, label, conditional = false) {
            if (end === END && endNodes[END] === undefined) endNodes[END] = graph.addNode({
                schema: (0, _zod.z).any()
            }, END);
            return graph.addEdge(startNodes[start], endNodes[end], label !== end ? label : undefined, conditional);
        }
        for (const [key, nodeSpec] of Object.entries(this.builder.nodes)){
            const displayKey = _escapeMermaidKeywords(key);
            const node = nodeSpec.runnable;
            const metadata = nodeSpec.metadata ?? {};
            if (this.interruptBefore?.includes(key) && this.interruptAfter?.includes(key)) metadata.__interrupt = "before,after";
            else if (this.interruptBefore?.includes(key)) metadata.__interrupt = "before";
            else if (this.interruptAfter?.includes(key)) metadata.__interrupt = "after";
            if (xray) {
                const newXrayValue = typeof xray === "number" ? xray - 1 : xray;
                const drawableSubgraph = subgraphs[key] !== undefined ? await subgraphs[key].getGraphAsync({
                    ...config,
                    xray: newXrayValue
                }) : node.getGraph(config);
                drawableSubgraph.trimFirstNode();
                drawableSubgraph.trimLastNode();
                if (Object.keys(drawableSubgraph.nodes).length > 1) {
                    const [e, s] = graph.extend(drawableSubgraph, displayKey);
                    if (e === undefined) throw new Error(`Could not extend subgraph "${key}" due to missing entrypoint.`);
                    // TODO: Remove default name once we stop supporting core 0.2.0
                    // eslint-disable-next-line no-inner-declarations
                    function _isRunnableInterface(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    thing) {
                        return thing ? thing.lc_runnable : false;
                    }
                    // eslint-disable-next-line no-inner-declarations
                    function _nodeDataStr(id, data) {
                        if (id !== undefined && !(0, _uuid.validate)(id)) return id;
                        else if (_isRunnableInterface(data)) try {
                            let dataStr = data.getName();
                            dataStr = dataStr.startsWith("Runnable") ? dataStr.slice(8) : dataStr;
                            return dataStr;
                        } catch (error) {
                            return data.getName();
                        }
                        else return data.name ?? "UnknownSchema";
                    }
                    // TODO: Remove casts when we stop supporting core 0.2.0
                    if (s !== undefined) startNodes[displayKey] = {
                        name: _nodeDataStr(s.id, s.data),
                        ...s
                    };
                    endNodes[displayKey] = {
                        name: _nodeDataStr(e.id, e.data),
                        ...e
                    };
                } else {
                    // TODO: Remove when we stop supporting core 0.2.0
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    const newNode = graph.addNode(node, displayKey, metadata);
                    startNodes[displayKey] = newNode;
                    endNodes[displayKey] = newNode;
                }
            } else {
                // TODO: Remove when we stop supporting core 0.2.0
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const newNode = graph.addNode(node, displayKey, metadata);
                startNodes[displayKey] = newNode;
                endNodes[displayKey] = newNode;
            }
        }
        const sortedEdges = [
            ...this.builder.allEdges
        ].sort(([a], [b])=>{
            if (a < b) return -1;
            else if (b > a) return 1;
            else return 0;
        });
        for (const [start, end] of sortedEdges)addEdge(_escapeMermaidKeywords(start), _escapeMermaidKeywords(end));
        for (const [start, branches] of Object.entries(this.builder.branches)){
            const defaultEnds = {
                ...Object.fromEntries(Object.keys(this.builder.nodes).filter((k)=>k !== start).map((k)=>[
                        _escapeMermaidKeywords(k),
                        _escapeMermaidKeywords(k)
                    ])),
                [END]: END
            };
            for (const branch of Object.values(branches)){
                let ends;
                if (branch.ends !== undefined) ends = branch.ends;
                else ends = defaultEnds;
                for (const [label, end] of Object.entries(ends))addEdge(_escapeMermaidKeywords(start), _escapeMermaidKeywords(end), label, true);
            }
        }
        return graph;
    }
    /**
     * Returns a drawable representation of the computation graph.
     *
     * @deprecated Use getGraphAsync instead. The async method will be the default in the next minor core release.
     */ getGraph(config) {
        const xray = config?.xray;
        const graph = new (0, _graph.Graph)();
        const startNodes = {
            [START]: graph.addNode({
                schema: (0, _zod.z).any()
            }, START)
        };
        const endNodes = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let subgraphs = {};
        if (xray) subgraphs = Object.fromEntries((0, _utilsJs.gatherIteratorSync)(this.getSubgraphs()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (x)=>isCompiledGraph(x[1])));
        function addEdge(start, end, label, conditional = false) {
            if (end === END && endNodes[END] === undefined) endNodes[END] = graph.addNode({
                schema: (0, _zod.z).any()
            }, END);
            return graph.addEdge(startNodes[start], endNodes[end], label !== end ? label : undefined, conditional);
        }
        for (const [key, nodeSpec] of Object.entries(this.builder.nodes)){
            const displayKey = _escapeMermaidKeywords(key);
            const node = nodeSpec.runnable;
            const metadata = nodeSpec.metadata ?? {};
            if (this.interruptBefore?.includes(key) && this.interruptAfter?.includes(key)) metadata.__interrupt = "before,after";
            else if (this.interruptBefore?.includes(key)) metadata.__interrupt = "before";
            else if (this.interruptAfter?.includes(key)) metadata.__interrupt = "after";
            if (xray) {
                const newXrayValue = typeof xray === "number" ? xray - 1 : xray;
                const drawableSubgraph = subgraphs[key] !== undefined ? subgraphs[key].getGraph({
                    ...config,
                    xray: newXrayValue
                }) : node.getGraph(config);
                drawableSubgraph.trimFirstNode();
                drawableSubgraph.trimLastNode();
                if (Object.keys(drawableSubgraph.nodes).length > 1) {
                    const [e, s] = graph.extend(drawableSubgraph, displayKey);
                    if (e === undefined) throw new Error(`Could not extend subgraph "${key}" due to missing entrypoint.`);
                    // TODO: Remove default name once we stop supporting core 0.2.0
                    // eslint-disable-next-line no-inner-declarations
                    function _isRunnableInterface(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    thing) {
                        return thing ? thing.lc_runnable : false;
                    }
                    // eslint-disable-next-line no-inner-declarations
                    function _nodeDataStr(id, data) {
                        if (id !== undefined && !(0, _uuid.validate)(id)) return id;
                        else if (_isRunnableInterface(data)) try {
                            let dataStr = data.getName();
                            dataStr = dataStr.startsWith("Runnable") ? dataStr.slice(8) : dataStr;
                            return dataStr;
                        } catch (error) {
                            return data.getName();
                        }
                        else return data.name ?? "UnknownSchema";
                    }
                    // TODO: Remove casts when we stop supporting core 0.2.0
                    if (s !== undefined) startNodes[displayKey] = {
                        name: _nodeDataStr(s.id, s.data),
                        ...s
                    };
                    endNodes[displayKey] = {
                        name: _nodeDataStr(e.id, e.data),
                        ...e
                    };
                } else {
                    // TODO: Remove when we stop supporting core 0.2.0
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    const newNode = graph.addNode(node, displayKey, metadata);
                    startNodes[displayKey] = newNode;
                    endNodes[displayKey] = newNode;
                }
            } else {
                // TODO: Remove when we stop supporting core 0.2.0
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const newNode = graph.addNode(node, displayKey, metadata);
                startNodes[displayKey] = newNode;
                endNodes[displayKey] = newNode;
            }
        }
        const sortedEdges = [
            ...this.builder.allEdges
        ].sort(([a], [b])=>{
            if (a < b) return -1;
            else if (b > a) return 1;
            else return 0;
        });
        for (const [start, end] of sortedEdges)addEdge(_escapeMermaidKeywords(start), _escapeMermaidKeywords(end));
        for (const [start, branches] of Object.entries(this.builder.branches)){
            const defaultEnds = {
                ...Object.fromEntries(Object.keys(this.builder.nodes).filter((k)=>k !== start).map((k)=>[
                        _escapeMermaidKeywords(k),
                        _escapeMermaidKeywords(k)
                    ])),
                [END]: END
            };
            for (const branch of Object.values(branches)){
                let ends;
                if (branch.ends !== undefined) ends = branch.ends;
                else ends = defaultEnds;
                for (const [label, end] of Object.entries(ends))addEdge(_escapeMermaidKeywords(start), _escapeMermaidKeywords(end), label, true);
            }
        }
        return graph;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isCompiledGraph(x) {
    return(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof x.attachNode === "function" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof x.attachEdge === "function");
}
function _escapeMermaidKeywords(key) {
    if (key === "subgraph") return `"${key}"`;
    return key;
}

},{"@langchain/core/runnables":"5B2I4","@langchain/core/runnables/graph":"dUhUy","zod":"juM82","uuid":"klst7","../pregel/read.js":"b7GRw","../pregel/index.js":"d3XGH","../channels/ephemeral_value.js":"8sLj2","../pregel/write.js":"hERuA","../constants.js":"1BFWS","../utils.js":"ge2lq","../errors.js":"jKiOM","../pregel/utils/subgraph.js":"b00W2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5B2I4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./dist/runnables/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"./dist/runnables/index.js":"cJ9j5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dUhUy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _graphJs = require("../dist/runnables/graph.js");
parcelHelpers.exportAll(_graphJs, exports);

},{"../dist/runnables/graph.js":"9F5Ur","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b7GRw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChannelRead", ()=>ChannelRead);
parcelHelpers.export(exports, "PregelNode", ()=>PregelNode);
var _runnables = require("@langchain/core/runnables");
var _constantsJs = require("../constants.js");
var _writeJs = require("./write.js");
var _utilsJs = require("../utils.js");
class ChannelRead extends (0, _utilsJs.RunnableCallable) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(channel, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapper, fresh = false){
        super({
            func: (_, config)=>ChannelRead.doRead(config, this.channel, this.fresh, this.mapper)
        });
        Object.defineProperty(this, "lc_graph_name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChannelRead"
        });
        Object.defineProperty(this, "channel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fresh", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "mapper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.fresh = fresh;
        this.mapper = mapper;
        this.channel = channel;
        this.name = Array.isArray(channel) ? `ChannelRead<${channel.join(",")}>` : `ChannelRead<${channel}>`;
    }
    static doRead(config, channel, fresh, mapper) {
        const read = config.configurable?.[0, _constantsJs.CONFIG_KEY_READ];
        if (!read) throw new Error(`Runnable ${this} is not configured with a read function. Make sure to call in the context of a Pregel process`);
        if (mapper) return mapper(read(channel, fresh));
        else return read(channel, fresh);
    }
}
const defaultRunnableBound = /* #__PURE__ */ new (0, _runnables.RunnablePassthrough)();
class PregelNode extends (0, _runnables.RunnableBinding) {
    constructor(fields){
        const { channels, triggers, mapper, writers, bound, kwargs, metadata, retryPolicy, tags, subgraphs } = fields;
        const mergedTags = [
            ...fields.config?.tags ? fields.config.tags : [],
            ...tags ?? []
        ];
        super({
            ...fields,
            bound: fields.bound ?? defaultRunnableBound,
            config: {
                ...fields.config ? fields.config : {},
                tags: mergedTags
            }
        });
        Object.defineProperty(this, "lc_graph_name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "PregelNode"
        });
        Object.defineProperty(this, "channels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "triggers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "mapper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "writers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "bound", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: defaultRunnableBound
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "kwargs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "metadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "tags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "retryPolicy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "subgraphs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.channels = channels;
        this.triggers = triggers;
        this.mapper = mapper;
        this.writers = writers ?? this.writers;
        this.bound = bound ?? this.bound;
        this.kwargs = kwargs ?? this.kwargs;
        this.metadata = metadata ?? this.metadata;
        this.tags = mergedTags;
        this.retryPolicy = retryPolicy;
        this.subgraphs = subgraphs;
    }
    getWriters() {
        const newWriters = [
            ...this.writers
        ];
        while(newWriters.length > 1 && // eslint-disable-next-line no-instanceof/no-instanceof
        newWriters[newWriters.length - 1] instanceof (0, _writeJs.ChannelWrite) && // eslint-disable-next-line no-instanceof/no-instanceof
        newWriters[newWriters.length - 2] instanceof (0, _writeJs.ChannelWrite)){
            // we can combine writes if they are consecutive
            // careful to not modify the original writers list or ChannelWrite
            const endWriters = newWriters.slice(-2);
            const combinedWrites = endWriters[0].writes.concat(endWriters[1].writes);
            newWriters[newWriters.length - 2] = new (0, _writeJs.ChannelWrite)(combinedWrites, endWriters[0].config?.tags);
            newWriters.pop();
        }
        return newWriters;
    }
    getNode() {
        const writers = this.getWriters();
        if (this.bound === defaultRunnableBound && writers.length === 0) return undefined;
        else if (this.bound === defaultRunnableBound && writers.length === 1) return writers[0];
        else if (this.bound === defaultRunnableBound) return new (0, _runnables.RunnableSequence)({
            first: writers[0],
            middle: writers.slice(1, writers.length - 1),
            last: writers[writers.length - 1],
            omitSequenceTags: true
        });
        else if (writers.length > 0) return new (0, _runnables.RunnableSequence)({
            first: this.bound,
            middle: writers.slice(0, writers.length - 1),
            last: writers[writers.length - 1],
            omitSequenceTags: true
        });
        else return this.bound;
    }
    join(channels) {
        if (!Array.isArray(channels)) throw new Error("channels must be a list");
        if (typeof this.channels !== "object") throw new Error("all channels must be named when using .join()");
        return new PregelNode({
            channels: {
                ...this.channels,
                ...Object.fromEntries(channels.map((chan)=>[
                        chan,
                        chan
                    ]))
            },
            triggers: this.triggers,
            mapper: this.mapper,
            writers: this.writers,
            bound: this.bound,
            kwargs: this.kwargs,
            config: this.config,
            retryPolicy: this.retryPolicy
        });
    }
    pipe(coerceable) {
        if ((0, _writeJs.ChannelWrite).isWriter(coerceable)) return new PregelNode({
            channels: this.channels,
            triggers: this.triggers,
            mapper: this.mapper,
            writers: [
                ...this.writers,
                coerceable
            ],
            bound: this.bound,
            config: this.config,
            kwargs: this.kwargs,
            retryPolicy: this.retryPolicy
        });
        else if (this.bound === defaultRunnableBound) return new PregelNode({
            channels: this.channels,
            triggers: this.triggers,
            mapper: this.mapper,
            writers: this.writers,
            bound: (0, _runnables._coerceToRunnable)(coerceable),
            config: this.config,
            kwargs: this.kwargs,
            retryPolicy: this.retryPolicy
        });
        else return new PregelNode({
            channels: this.channels,
            triggers: this.triggers,
            mapper: this.mapper,
            writers: this.writers,
            bound: this.bound.pipe(coerceable),
            config: this.config,
            kwargs: this.kwargs,
            retryPolicy: this.retryPolicy
        });
    }
}

},{"@langchain/core/runnables":"5B2I4","../constants.js":"1BFWS","./write.js":"hERuA","../utils.js":"ge2lq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hERuA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SKIP_WRITE", ()=>SKIP_WRITE);
parcelHelpers.export(exports, "PASSTHROUGH", ()=>PASSTHROUGH);
/**
 * Mapping of write channels to Runnables that return the value to be written,
 * or None to skip writing.
 */ parcelHelpers.export(exports, "ChannelWrite", ()=>ChannelWrite);
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _errorsJs = require("../errors.js");
const SKIP_WRITE = {
    [Symbol.for("LG_SKIP_WRITE")]: true
};
function _isSkipWrite(x) {
    return typeof x === "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    x?.[Symbol.for("LG_SKIP_WRITE")] !== undefined;
}
const PASSTHROUGH = {
    [Symbol.for("LG_PASSTHROUGH")]: true
};
function _isPassthrough(x) {
    return typeof x === "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    x?.[Symbol.for("LG_PASSTHROUGH")] !== undefined;
}
const IS_WRITER = Symbol("IS_WRITER");
class ChannelWrite extends (0, _utilsJs.RunnableCallable) {
    constructor(writes, tags){
        const name = `ChannelWrite<${writes.map((packet)=>{
            return (0, _constantsJs._isSend)(packet) ? packet.node : packet.channel;
        }).join(",")}>`;
        super({
            writes,
            name,
            tags,
            func: async (input, config)=>{
                return this._write(input, config ?? {});
            }
        });
        Object.defineProperty(this, "writes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.writes = writes;
    }
    async _getWriteValues(input, config) {
        const writes = this.writes.filter((0, _constantsJs._isSend)).map((packet)=>{
            return [
                (0, _constantsJs.TASKS),
                packet
            ];
        });
        const entries = this.writes.filter((write)=>{
            return !(0, _constantsJs._isSend)(write);
        });
        const invalidEntry = entries.find((write)=>{
            return write.channel === (0, _constantsJs.TASKS);
        });
        if (invalidEntry) throw new (0, _errorsJs.InvalidUpdateError)(`Cannot write to the reserved channel ${(0, _constantsJs.TASKS)}`);
        const values = await Promise.all(entries.map(async (write)=>{
            let value;
            if (_isPassthrough(write.value)) value = input;
            else value = write.value;
            const mappedValue = write.mapper ? await write.mapper.invoke(value, config) : value;
            return {
                ...write,
                value: mappedValue
            };
        })).then((writes)=>{
            return writes.filter((write)=>!write.skipNone || write.value !== null).map((write)=>{
                return [
                    write.channel,
                    write.value
                ];
            });
        });
        return [
            ...writes,
            ...values
        ];
    }
    async _write(input, config) {
        const values = await this._getWriteValues(input, config);
        ChannelWrite.doWrite(config, values);
        return input;
    }
    // TODO: Support requireAtLeastOneOf
    static doWrite(config, values) {
        const write = config.configurable?.[0, _constantsJs.CONFIG_KEY_SEND];
        const filtered = values.filter(([_, value])=>!_isSkipWrite(value));
        write(filtered);
    }
    static isWriter(runnable) {
        return(// eslint-disable-next-line no-instanceof/no-instanceof
        runnable instanceof ChannelWrite || IS_WRITER in runnable && !!runnable[IS_WRITER]);
    }
    static registerWriter(runnable) {
        return Object.defineProperty(runnable, IS_WRITER, {
            value: true
        });
    }
}

},{"../constants.js":"1BFWS","../utils.js":"ge2lq","../errors.js":"jKiOM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ge2lq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RunnableCallable", ()=>RunnableCallable);
parcelHelpers.export(exports, "prefixGenerator", ()=>prefixGenerator);
// https://github.com/tc39/proposal-array-from-async
parcelHelpers.export(exports, "gatherIterator", ()=>gatherIterator);
parcelHelpers.export(exports, "gatherIteratorSync", ()=>gatherIteratorSync);
parcelHelpers.export(exports, "patchConfigurable", ()=>patchConfigurable);
var _runnables = require("@langchain/core/runnables");
var _singletons = require("@langchain/core/singletons");
var _configJs = require("./pregel/utils/config.js");
class RunnableCallable extends (0, _runnables.Runnable) {
    constructor(fields){
        super();
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langgraph"
            ]
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "func", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "trace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "recurse", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        this.name = fields.name ?? fields.func.name;
        this.func = fields.func;
        this.config = fields.tags ? {
            tags: fields.tags
        } : undefined;
        this.trace = fields.trace ?? this.trace;
        this.recurse = fields.recurse ?? this.recurse;
    }
    async _tracedInvoke(input, config, runManager) {
        return new Promise((resolve, reject)=>{
            const childConfig = (0, _runnables.patchConfig)(config, {
                callbacks: runManager?.getChild()
            });
            (0, _singletons.AsyncLocalStorageProviderSingleton).runWithConfig(childConfig, async ()=>{
                try {
                    const output = await this.func(input, childConfig);
                    resolve(output);
                } catch (e) {
                    reject(e);
                }
            });
        });
    }
    async invoke(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    input, options) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let returnValue;
        const config = (0, _configJs.ensureLangGraphConfig)(options);
        const mergedConfig = (0, _runnables.mergeConfigs)(this.config, config);
        if (this.trace) returnValue = await this._callWithConfig(this._tracedInvoke, input, mergedConfig);
        else returnValue = await (0, _singletons.AsyncLocalStorageProviderSingleton).runWithConfig(mergedConfig, async ()=>this.func(input, mergedConfig));
        if ((0, _runnables.Runnable).isRunnable(returnValue) && this.recurse) return await (0, _singletons.AsyncLocalStorageProviderSingleton).runWithConfig(mergedConfig, async ()=>returnValue.invoke(input, mergedConfig));
        return returnValue;
    }
}
function* prefixGenerator(generator, prefix) {
    if (prefix === undefined) yield* generator;
    else for (const value of generator)yield [
        prefix,
        value
    ];
}
async function gatherIterator(i) {
    const out = [];
    for await (const item of (await i))out.push(item);
    return out;
}
function gatherIteratorSync(i) {
    const out = [];
    for (const item of i)out.push(item);
    return out;
}
function patchConfigurable(config, // eslint-disable-next-line @typescript-eslint/no-explicit-any
patch) {
    if (!config) return {
        configurable: patch
    };
    else if (!("configurable" in config)) return {
        ...config,
        configurable: patch
    };
    else return {
        ...config,
        configurable: {
            ...config.configurable,
            ...patch
        }
    };
}

},{"@langchain/core/runnables":"5B2I4","@langchain/core/singletons":"8ZZ06","./pregel/utils/config.js":"4g7pC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8ZZ06":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./dist/singletons/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"./dist/singletons/index.js":"1O31N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4g7pC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensureLangGraphConfig", ()=>ensureLangGraphConfig);
var _singletons = require("@langchain/core/singletons");
const COPIABLE_KEYS = [
    "tags",
    "metadata",
    "callbacks",
    "configurable"
];
const CONFIG_KEYS = [
    "tags",
    "metadata",
    "callbacks",
    "runName",
    "maxConcurrency",
    "recursionLimit",
    "configurable",
    "runId",
    "outputKeys",
    "streamMode",
    "store",
    "writer"
];
const DEFAULT_RECURSION_LIMIT = 25;
function ensureLangGraphConfig(...configs) {
    const empty = {
        tags: [],
        metadata: {},
        callbacks: undefined,
        recursionLimit: DEFAULT_RECURSION_LIMIT,
        configurable: {}
    };
    const implicitConfig = (0, _singletons.AsyncLocalStorageProviderSingleton).getRunnableConfig();
    if (implicitConfig !== undefined) {
        for (const [k, v] of Object.entries(implicitConfig))if (v !== undefined) {
            if (COPIABLE_KEYS.includes(k)) {
                let copiedValue;
                if (Array.isArray(v)) copiedValue = [
                    ...v
                ];
                else if (typeof v === "object") {
                    if (k === "callbacks" && "copy" in v && typeof v.copy === "function") copiedValue = v.copy();
                    else copiedValue = {
                        ...v
                    };
                } else copiedValue = v;
                empty[k] = copiedValue;
            } else empty[k] = v;
        }
    }
    for (const config of configs){
        if (config === undefined) continue;
        for (const [k, v] of Object.entries(config))if (v !== undefined && CONFIG_KEYS.includes(k)) empty[k] = v;
    }
    for (const [key, value] of Object.entries(empty.configurable)){
        empty.metadata = empty.metadata ?? {};
        if (!key.startsWith("__") && (typeof value === "string" || typeof value === "number" || typeof value === "boolean") && !(key in empty.metadata)) empty.metadata[key] = value;
    }
    return empty;
}

},{"@langchain/core/singletons":"8ZZ06","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d3XGH":[function(require,module,exports,__globalThis) {
/* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Channel", ()=>Channel);
parcelHelpers.export(exports, "Pregel", ()=>Pregel);
var _runnables = require("@langchain/core/runnables");
var _langgraphCheckpoint = require("@langchain/langgraph-checkpoint");
var _baseJs = require("../channels/base.js");
var _readJs = require("./read.js");
var _validateJs = require("./validate.js");
var _ioJs = require("./io.js");
var _debugJs = require("./debug.js");
var _writeJs = require("./write.js");
var _constantsJs = require("../constants.js");
var _errorsJs = require("../errors.js");
var _algoJs = require("./algo.js");
var _indexJs = require("./utils/index.js");
var _subgraphJs = require("./utils/subgraph.js");
var _loopJs = require("./loop.js");
var _retryJs = require("./retry.js");
var _baseJs1 = require("../managed/base.js");
var _utilsJs = require("../utils.js");
var _configJs = require("./utils/config.js");
var _messagesJs = require("./messages.js");
function isString(value) {
    return typeof value === "string";
}
class Channel {
    static subscribeTo(channels, options) {
        const { key, tags } = options ?? {};
        if (Array.isArray(channels) && key !== undefined) throw new Error("Can't specify a key when subscribing to multiple channels");
        let channelMappingOrArray;
        if (isString(channels)) {
            if (key) channelMappingOrArray = {
                [key]: channels
            };
            else channelMappingOrArray = [
                channels
            ];
        } else channelMappingOrArray = Object.fromEntries(channels.map((chan)=>[
                chan,
                chan
            ]));
        const triggers = Array.isArray(channels) ? channels : [
            channels
        ];
        return new (0, _readJs.PregelNode)({
            channels: channelMappingOrArray,
            triggers,
            tags
        });
    }
    static writeTo(channels, kwargs) {
        const channelWriteEntries = [];
        for (const channel of channels)channelWriteEntries.push({
            channel,
            value: (0, _writeJs.PASSTHROUGH),
            skipNone: false
        });
        for (const [key, value] of Object.entries(kwargs ?? {}))if ((0, _runnables.Runnable).isRunnable(value) || typeof value === "function") channelWriteEntries.push({
            channel: key,
            value: (0, _writeJs.PASSTHROUGH),
            skipNone: true,
            mapper: (0, _runnables._coerceToRunnable)(value)
        });
        else channelWriteEntries.push({
            channel: key,
            value,
            skipNone: false
        });
        return new (0, _writeJs.ChannelWrite)(channelWriteEntries);
    }
}
class Pregel extends (0, _runnables.Runnable) {
    static lc_name() {
        return "LangGraph";
    }
    constructor(fields){
        super(fields);
        // Because Pregel extends `Runnable`.
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langgraph",
                "pregel"
            ]
        });
        Object.defineProperty(this, "lg_is_pregel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "nodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "channels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "inputChannels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "outputChannels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "autoValidate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "streamMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "values"
            ]
        });
        Object.defineProperty(this, "streamChannels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "interruptAfter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "interruptBefore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "debug", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "checkpointer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "retryPolicy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        let { streamMode } = fields;
        if (streamMode != null && !Array.isArray(streamMode)) streamMode = [
            streamMode
        ];
        this.nodes = fields.nodes;
        this.channels = fields.channels;
        this.autoValidate = fields.autoValidate ?? this.autoValidate;
        this.streamMode = streamMode ?? this.streamMode;
        this.inputChannels = fields.inputChannels;
        this.outputChannels = fields.outputChannels;
        this.streamChannels = fields.streamChannels ?? this.streamChannels;
        this.interruptAfter = fields.interruptAfter;
        this.interruptBefore = fields.interruptBefore;
        this.stepTimeout = fields.stepTimeout ?? this.stepTimeout;
        this.debug = fields.debug ?? this.debug;
        this.checkpointer = fields.checkpointer;
        this.retryPolicy = fields.retryPolicy;
        this.config = fields.config;
        this.store = fields.store;
        if (this.autoValidate) this.validate();
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore Remove ignore when we remove support for 0.2 versions of core
    withConfig(config) {
        const mergedConfig = (0, _runnables.mergeConfigs)(this.config, config);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new this.constructor({
            ...this,
            config: mergedConfig
        });
    }
    validate() {
        (0, _validateJs.validateGraph)({
            nodes: this.nodes,
            channels: this.channels,
            outputChannels: this.outputChannels,
            inputChannels: this.inputChannels,
            streamChannels: this.streamChannels,
            interruptAfterNodes: this.interruptAfter,
            interruptBeforeNodes: this.interruptBefore
        });
        return this;
    }
    get streamChannelsList() {
        if (Array.isArray(this.streamChannels)) return this.streamChannels;
        else if (this.streamChannels) return [
            this.streamChannels
        ];
        else return Object.keys(this.channels);
    }
    get streamChannelsAsIs() {
        if (this.streamChannels) return this.streamChannels;
        else return Object.keys(this.channels);
    }
    async getGraphAsync(config) {
        return this.getGraph(config);
    }
    /** @deprecated Use getSubgraphsAsync instead. The async method will become the default in the next minor release. */ *getSubgraphs(namespace, recurse) {
        for (const [name, node] of Object.entries(this.nodes)){
            // filter by prefix
            if (namespace !== undefined) {
                if (!namespace.startsWith(name)) continue;
            }
            const candidates = node.subgraphs?.length ? node.subgraphs : [
                node.bound
            ];
            for (const candidate of candidates){
                const graph = (0, _subgraphJs.findSubgraphPregel)(candidate);
                if (graph !== undefined) {
                    if (name === namespace) {
                        yield [
                            name,
                            graph
                        ];
                        return;
                    }
                    if (namespace === undefined) yield [
                        name,
                        graph
                    ];
                    if (recurse) {
                        let newNamespace = namespace;
                        if (namespace !== undefined) newNamespace = namespace.slice(name.length + 1);
                        for (const [subgraphName, subgraph] of graph.getSubgraphs(newNamespace, recurse))yield [
                            `${name}${(0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR)}${subgraphName}`,
                            subgraph
                        ];
                    }
                }
            }
        }
    }
    async *getSubgraphsAsync(namespace, recurse) {
        yield* this.getSubgraphs(namespace, recurse);
    }
    async _prepareStateSnapshot({ config, saved, subgraphCheckpointer }) {
        if (saved === undefined) return {
            values: {},
            next: [],
            config,
            tasks: []
        };
        // Pass `skipManaged: true` as managed values should not be returned in get state calls.
        const { managed } = await this.prepareSpecs(config, {
            skipManaged: true
        });
        const channels = (0, _baseJs.emptyChannels)(this.channels, saved.checkpoint);
        const nextTasks = Object.values((0, _algoJs._prepareNextTasks)(saved.checkpoint, this.nodes, channels, managed, saved.config, false, {
            step: (saved.metadata?.step ?? -1) + 1
        }));
        const subgraphs = await (0, _utilsJs.gatherIterator)(this.getSubgraphsAsync());
        const parentNamespace = saved.config.configurable?.checkpoint_ns ?? "";
        const taskStates = {};
        for (const task of nextTasks){
            const matchingSubgraph = subgraphs.find(([name])=>name === task.name);
            if (!matchingSubgraph) continue;
            // assemble checkpoint_ns for this task
            let taskNs = `${task.name}${(0, _constantsJs.CHECKPOINT_NAMESPACE_END)}${task.id}`;
            if (parentNamespace) taskNs = `${parentNamespace}${0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR}${taskNs}`;
            if (subgraphCheckpointer === undefined) {
                // set config as signal that subgraph checkpoints exist
                const config = {
                    configurable: {
                        thread_id: saved.config.configurable?.thread_id,
                        checkpoint_ns: taskNs
                    }
                };
                taskStates[task.id] = config;
            } else {
                // get the state of the subgraph
                const config = {
                    configurable: {
                        [(0, _constantsJs.CONFIG_KEY_CHECKPOINTER)]: subgraphCheckpointer,
                        thread_id: saved.config.configurable?.thread_id,
                        checkpoint_ns: taskNs
                    }
                };
                taskStates[task.id] = await matchingSubgraph[1].getState(config, {
                    subgraphs: true
                });
            }
        }
        // assemble the state snapshot
        return {
            values: (0, _ioJs.readChannels)(channels, this.streamChannelsAsIs),
            next: nextTasks.map((task)=>task.name),
            tasks: (0, _debugJs.tasksWithWrites)(nextTasks, saved?.pendingWrites ?? [], taskStates),
            metadata: saved.metadata,
            config: (0, _indexJs.patchCheckpointMap)(saved.config, saved.metadata),
            createdAt: saved.checkpoint.ts,
            parentConfig: saved.parentConfig
        };
    }
    /**
     * Get the current state of the graph.
     */ async getState(config, options) {
        const checkpointer = config.configurable?.[0, _constantsJs.CONFIG_KEY_CHECKPOINTER] ?? this.checkpointer;
        if (!checkpointer) throw new (0, _errorsJs.GraphValueError)("No checkpointer set");
        const checkpointNamespace = config.configurable?.checkpoint_ns ?? "";
        if (checkpointNamespace !== "" && config.configurable?.[0, _constantsJs.CONFIG_KEY_CHECKPOINTER] === undefined) {
            // remove task_ids from checkpoint_ns
            const recastCheckpointNamespace = checkpointNamespace.split((0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR)).map((part)=>part.split((0, _constantsJs.CHECKPOINT_NAMESPACE_END))[0]).join((0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR));
            for await (const [name, subgraph] of this.getSubgraphsAsync(recastCheckpointNamespace, true)){
                if (name === recastCheckpointNamespace) return await subgraph.getState((0, _utilsJs.patchConfigurable)(config, {
                    [(0, _constantsJs.CONFIG_KEY_CHECKPOINTER)]: checkpointer
                }), {
                    subgraphs: options?.subgraphs
                });
            }
            throw new Error(`Subgraph with namespace "${recastCheckpointNamespace}" not found.`);
        }
        const mergedConfig = (0, _runnables.mergeConfigs)(this.config, config);
        const saved = await checkpointer.getTuple(config);
        const snapshot = await this._prepareStateSnapshot({
            config: mergedConfig,
            saved,
            subgraphCheckpointer: options?.subgraphs ? checkpointer : undefined
        });
        return snapshot;
    }
    /**
     * Get the history of the state of the graph.
     */ async *getStateHistory(config, options) {
        const checkpointer = config.configurable?.[0, _constantsJs.CONFIG_KEY_CHECKPOINTER] ?? this.checkpointer;
        if (!checkpointer) throw new Error("No checkpointer set");
        const checkpointNamespace = config.configurable?.checkpoint_ns ?? "";
        if (checkpointNamespace !== "" && config.configurable?.[0, _constantsJs.CONFIG_KEY_CHECKPOINTER] === undefined) {
            const recastCheckpointNamespace = checkpointNamespace.split((0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR)).map((part)=>part.split((0, _constantsJs.CHECKPOINT_NAMESPACE_END))[0]).join((0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR));
            // find the subgraph with the matching name
            for await (const [name, pregel] of this.getSubgraphsAsync(recastCheckpointNamespace, true))if (name === recastCheckpointNamespace) {
                yield* pregel.getStateHistory((0, _utilsJs.patchConfigurable)(config, {
                    [(0, _constantsJs.CONFIG_KEY_CHECKPOINTER)]: checkpointer
                }), options);
                return;
            }
            throw new Error(`Subgraph with namespace "${recastCheckpointNamespace}" not found.`);
        }
        const mergedConfig = (0, _runnables.mergeConfigs)(this.config, config, {
            configurable: {
                checkpoint_ns: checkpointNamespace
            }
        });
        for await (const checkpointTuple of checkpointer.list(mergedConfig, options))yield this._prepareStateSnapshot({
            config: checkpointTuple.config,
            saved: checkpointTuple
        });
    }
    /**
     * Update the state of the graph with the given values, as if they came from
     * node `as_node`. If `as_node` is not provided, it will be set to the last node
     * that updated the state, if not ambiguous.
     */ async updateState(inputConfig, values, asNode) {
        const checkpointer = inputConfig.configurable?.[0, _constantsJs.CONFIG_KEY_CHECKPOINTER] ?? this.checkpointer;
        if (!checkpointer) throw new (0, _errorsJs.GraphValueError)("No checkpointer set");
        // delegate to subgraph
        const checkpointNamespace = inputConfig.configurable?.checkpoint_ns ?? "";
        if (checkpointNamespace !== "" && inputConfig.configurable?.[0, _constantsJs.CONFIG_KEY_CHECKPOINTER] === undefined) {
            // remove task_ids from checkpoint_ns
            const recastCheckpointNamespace = checkpointNamespace.split((0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR)).map((part)=>{
                return part.split((0, _constantsJs.CHECKPOINT_NAMESPACE_END))[0];
            }).join((0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR));
            // find the subgraph with the matching name
            // eslint-disable-next-line no-unreachable-loop
            for await (const [, pregel] of this.getSubgraphsAsync(recastCheckpointNamespace, true))return await pregel.updateState((0, _utilsJs.patchConfigurable)(inputConfig, {
                [(0, _constantsJs.CONFIG_KEY_CHECKPOINTER)]: checkpointer
            }), values, asNode);
            throw new Error(`Subgraph "${recastCheckpointNamespace}" not found`);
        }
        // get last checkpoint
        const config = this.config ? (0, _runnables.mergeConfigs)(this.config, inputConfig) : inputConfig;
        const saved = await checkpointer.getTuple(config);
        const checkpoint = saved !== undefined ? (0, _langgraphCheckpoint.copyCheckpoint)(saved.checkpoint) : (0, _langgraphCheckpoint.emptyCheckpoint)();
        const checkpointPreviousVersions = {
            ...saved?.checkpoint.channel_versions
        };
        const step = saved?.metadata?.step ?? -1;
        // merge configurable fields with previous checkpoint config
        let checkpointConfig = (0, _utilsJs.patchConfigurable)(config, {
            checkpoint_ns: config.configurable?.checkpoint_ns ?? ""
        });
        if (saved) checkpointConfig = (0, _utilsJs.patchConfigurable)(config, saved.config.configurable);
        // Find last node that updated the state, if not provided
        if (values == null && asNode === undefined) {
            const nextConfig = await checkpointer.put(checkpointConfig, (0, _baseJs.createCheckpoint)(checkpoint, undefined, step), {
                source: "update",
                step,
                writes: {},
                parents: saved?.metadata?.parents ?? {}
            }, {});
            return (0, _indexJs.patchCheckpointMap)(nextConfig, saved ? saved.metadata : undefined);
        }
        const nonNullVersion = Object.values(checkpoint.versions_seen).map((seenVersions)=>{
            return Object.values(seenVersions);
        }).flat().find((v)=>!!v);
        if (asNode === undefined && nonNullVersion === undefined) {
            if (typeof this.inputChannels === "string" && this.nodes[this.inputChannels] !== undefined) asNode = this.inputChannels;
        } else if (asNode === undefined) {
            const lastSeenByNode = Object.entries(checkpoint.versions_seen).map(([n, seen])=>{
                return Object.values(seen).map((v)=>{
                    return [
                        v,
                        n
                    ];
                });
            }).flat().sort(([aNumber], [bNumber])=>(0, _langgraphCheckpoint.compareChannelVersions)(aNumber, bNumber));
            // if two nodes updated the state at the same time, it's ambiguous
            if (lastSeenByNode) {
                if (lastSeenByNode.length === 1) // eslint-disable-next-line prefer-destructuring
                asNode = lastSeenByNode[0][1];
                else if (lastSeenByNode[lastSeenByNode.length - 1][0] !== lastSeenByNode[lastSeenByNode.length - 2][0]) // eslint-disable-next-line prefer-destructuring
                asNode = lastSeenByNode[lastSeenByNode.length - 1][1];
            }
        }
        if (asNode === undefined) throw new (0, _errorsJs.InvalidUpdateError)(`Ambiguous update, specify "asNode"`);
        if (this.nodes[asNode] === undefined) throw new (0, _errorsJs.InvalidUpdateError)(`Node "${asNode.toString()}" does not exist`);
        // update channels
        const channels = (0, _baseJs.emptyChannels)(this.channels, checkpoint);
        // Pass `skipManaged: true` as managed values are not used/relevant in update state calls.
        const { managed } = await this.prepareSpecs(config, {
            skipManaged: true
        });
        // run all writers of the chosen node
        const writers = this.nodes[asNode].getWriters();
        if (!writers.length) throw new (0, _errorsJs.InvalidUpdateError)(`No writers found for node "${asNode.toString()}"`);
        const task = {
            name: asNode,
            input: values,
            proc: writers.length > 1 ? (0, _runnables.RunnableSequence).from(writers, {
                omitSequenceTags: true
            }) : writers[0],
            writes: [],
            triggers: [
                (0, _constantsJs.INTERRUPT)
            ],
            id: (0, _langgraphCheckpoint.uuid5)((0, _constantsJs.INTERRUPT), checkpoint.id)
        };
        // execute task
        await task.proc.invoke(task.input, (0, _runnables.patchConfig)({
            ...config,
            store: config?.store ?? this.store
        }, {
            runName: config.runName ?? `${this.getName()}UpdateState`,
            configurable: {
                [(0, _constantsJs.CONFIG_KEY_SEND)]: (items)=>task.writes.push(...items),
                [(0, _constantsJs.CONFIG_KEY_READ)]: (select_, fresh_ = false)=>(0, _algoJs._localRead)(step, checkpoint, channels, managed, // TODO: Why does keyof StrRecord allow number and symbol?
                    task, select_, fresh_)
            }
        }));
        // save task writes
        if (saved !== undefined) await checkpointer.putWrites(checkpointConfig, task.writes, task.id);
        // apply to checkpoint
        // TODO: Why does keyof StrRecord allow number and symbol?
        (0, _algoJs._applyWrites)(checkpoint, channels, [
            task
        ], checkpointer.getNextVersion.bind(this.checkpointer));
        const newVersions = (0, _indexJs.getNewChannelVersions)(checkpointPreviousVersions, checkpoint.channel_versions);
        const nextConfig = await checkpointer.put(checkpointConfig, (0, _baseJs.createCheckpoint)(checkpoint, channels, step + 1), {
            source: "update",
            step: step + 1,
            writes: {
                [asNode]: values
            },
            parents: saved?.metadata?.parents ?? {}
        }, newVersions);
        return (0, _indexJs.patchCheckpointMap)(nextConfig, saved ? saved.metadata : undefined);
    }
    _defaults(config) {
        const { debug, streamMode, inputKeys, outputKeys, interruptAfter, interruptBefore, ...rest } = config;
        let streamModeSingle = true;
        const defaultDebug = debug !== undefined ? debug : this.debug;
        let defaultOutputKeys = outputKeys;
        if (defaultOutputKeys === undefined) defaultOutputKeys = this.streamChannelsAsIs;
        else (0, _validateJs.validateKeys)(defaultOutputKeys, this.channels);
        let defaultInputKeys = inputKeys;
        if (defaultInputKeys === undefined) defaultInputKeys = this.inputChannels;
        else (0, _validateJs.validateKeys)(defaultInputKeys, this.channels);
        const defaultInterruptBefore = interruptBefore ?? this.interruptBefore ?? [];
        const defaultInterruptAfter = interruptAfter ?? this.interruptAfter ?? [];
        let defaultStreamMode;
        if (streamMode !== undefined) {
            defaultStreamMode = Array.isArray(streamMode) ? streamMode : [
                streamMode
            ];
            streamModeSingle = typeof streamMode === "string";
        } else {
            defaultStreamMode = this.streamMode;
            streamModeSingle = true;
        }
        // if being called as a node in another graph, always use values mode
        if (config.configurable?.[0, _constantsJs.CONFIG_KEY_TASK_ID] !== undefined) defaultStreamMode = [
            "values"
        ];
        let defaultCheckpointer;
        if (this.checkpointer === false) defaultCheckpointer = undefined;
        else if (config !== undefined && config.configurable?.[0, _constantsJs.CONFIG_KEY_CHECKPOINTER] !== undefined) defaultCheckpointer = config.configurable[0, _constantsJs.CONFIG_KEY_CHECKPOINTER];
        else defaultCheckpointer = this.checkpointer;
        const defaultStore = config.store ?? this.store;
        return [
            defaultDebug,
            defaultStreamMode,
            defaultInputKeys,
            defaultOutputKeys,
            rest,
            defaultInterruptBefore,
            defaultInterruptAfter,
            defaultCheckpointer,
            defaultStore,
            streamModeSingle
        ];
    }
    /**
     * Stream graph steps for a single input.
     * @param input The input to the graph.
     * @param options The configuration to use for the run.
     * @param options.streamMode The mode to stream output. Defaults to value set on initialization.
     *   Options are "values", "updates", and "debug". Default is "values".
     *     values: Emit the current values of the state for each step.
     *     updates: Emit only the updates to the state for each step.
     *         Output is a dict with the node name as key and the updated values as value.
     *     debug: Emit debug events for each step.
     * @param options.outputKeys The keys to stream. Defaults to all non-context channels.
     * @param options.interruptBefore Nodes to interrupt before.
     * @param options.interruptAfter Nodes to interrupt after.
     * @param options.debug Whether to print debug information during execution.
     */ async stream(input, options) {
        // The ensureConfig method called internally defaults recursionLimit to 25 if not
        // passed directly in `options`.
        // There is currently no way in _streamIterator to determine whether this was
        // set by by ensureConfig or manually by the user, so we specify the bound value here
        // and override if it is passed as an explicit param in `options`.
        const config = {
            recursionLimit: this.config?.recursionLimit,
            ...options
        };
        return super.stream(input, config);
    }
    async prepareSpecs(config, options) {
        const configForManaged = {
            ...config,
            store: this.store
        };
        const channelSpecs = {};
        const managedSpecs = {};
        for (const [name, spec] of Object.entries(this.channels)){
            if ((0, _baseJs.isBaseChannel)(spec)) channelSpecs[name] = spec;
            else if (options?.skipManaged) managedSpecs[name] = {
                cls: (0, _baseJs1.NoopManagedValue),
                params: {
                    config: {}
                }
            };
            else managedSpecs[name] = spec;
        }
        const managed = new (0, _baseJs1.ManagedValueMapping)(await Object.entries(managedSpecs).reduce(async (accPromise, [key, value])=>{
            const acc = await accPromise;
            let initializedValue;
            if ((0, _baseJs1.isConfiguredManagedValue)(value)) {
                if ("key" in value.params && value.params.key === (0, _baseJs1.ChannelKeyPlaceholder)) value.params.key = key;
                initializedValue = await value.cls.initialize(configForManaged, value.params);
            } else initializedValue = await value.initialize(configForManaged);
            if (initializedValue !== undefined) acc.push([
                key,
                initializedValue
            ]);
            return acc;
        }, Promise.resolve([])));
        return {
            channelSpecs,
            managed
        };
    }
    async *_streamIterator(input, options) {
        const streamSubgraphs = options?.subgraphs;
        const inputConfig = (0, _configJs.ensureLangGraphConfig)(this.config, options);
        if (inputConfig.recursionLimit === undefined || inputConfig.recursionLimit < 1) throw new Error(`Passed "recursionLimit" must be at least 1.`);
        if (this.checkpointer !== undefined && this.checkpointer !== false && inputConfig.configurable === undefined) throw new Error(`Checkpointer requires one or more of the following "configurable" keys: "thread_id", "checkpoint_ns", "checkpoint_id"`);
        const { runId, ...restConfig } = inputConfig;
        // assign defaults
        const [debug, streamMode, , outputKeys, config, interruptBefore, interruptAfter, checkpointer, store, streamModeSingle] = this._defaults(restConfig);
        const stream = new (0, _loopJs.IterableReadableWritableStream)({
            modes: new Set(streamMode)
        });
        // set up messages stream mode
        if (streamMode.includes("messages")) {
            const messageStreamer = new (0, _messagesJs.StreamMessagesHandler)((chunk)=>stream.push(chunk));
            const { callbacks } = config;
            if (callbacks === undefined) config.callbacks = [
                messageStreamer
            ];
            else if (Array.isArray(callbacks)) config.callbacks = callbacks.concat(messageStreamer);
            else {
                const copiedCallbacks = callbacks.copy();
                copiedCallbacks.addHandler(messageStreamer, true);
                config.callbacks = copiedCallbacks;
            }
        }
        // setup custom stream mode
        if (streamMode.includes("custom")) config.writer = (chunk)=>stream.push([
                [],
                "custom",
                chunk
            ]);
        const callbackManager = await (0, _runnables.getCallbackManagerForConfig)(config);
        const runManager = await callbackManager?.handleChainStart(this.toJSON(), (0, _indexJs._coerceToDict)(input, "input"), runId, undefined, undefined, undefined, config?.runName ?? this.getName());
        const { channelSpecs, managed } = await this.prepareSpecs(config);
        let loop;
        let loopError;
        const runLoop = async ()=>{
            try {
                loop = await (0, _loopJs.PregelLoop).initialize({
                    input,
                    config,
                    checkpointer,
                    nodes: this.nodes,
                    channelSpecs,
                    managed,
                    outputKeys,
                    streamKeys: this.streamChannelsAsIs,
                    store,
                    stream
                });
                if (options?.subgraphs) loop.config.configurable = {
                    ...loop.config.configurable,
                    [(0, _constantsJs.CONFIG_KEY_STREAM)]: loop.stream
                };
                while(await loop.tick({
                    inputKeys: this.inputChannels,
                    interruptAfter,
                    interruptBefore,
                    manager: runManager
                })){
                    if (debug) (0, _debugJs.printStepCheckpoint)(loop.checkpointMetadata.step, loop.channels, this.streamChannelsList);
                    if (debug) (0, _debugJs.printStepTasks)(loop.step, Object.values(loop.tasks));
                    // execute tasks, and wait for one to fail or all to finish.
                    // each task is independent from all other concurrent tasks
                    // yield updates/debug output as each task finishes
                    const taskStream = (0, _retryJs.executeTasksWithRetry)(Object.values(loop.tasks).filter((task)=>task.writes.length === 0), {
                        stepTimeout: this.stepTimeout,
                        signal: config.signal,
                        retryPolicy: this.retryPolicy
                    });
                    // Timeouts will be thrown
                    for await (const { task, error } of taskStream){
                        if (error !== undefined) {
                            if ((0, _errorsJs.isGraphInterrupt)(error)) {
                                if (loop.isNested) throw error;
                                if (error.interrupts.length) loop.putWrites(task.id, error.interrupts.map((interrupt)=>[
                                        (0, _constantsJs.INTERRUPT),
                                        interrupt
                                    ]));
                            } else loop.putWrites(task.id, [
                                [
                                    (0, _constantsJs.ERROR),
                                    {
                                        message: error.message,
                                        name: error.name
                                    }
                                ]
                            ]);
                        } else loop.putWrites(task.id, task.writes);
                        if (error !== undefined && !(0, _errorsJs.isGraphInterrupt)(error)) throw error;
                    }
                    if (debug) (0, _debugJs.printStepWrites)(loop.step, Object.values(loop.tasks).map((task)=>task.writes).flat(), this.streamChannelsList);
                }
                if (loop.status === "out_of_steps") throw new (0, _errorsJs.GraphRecursionError)([
                    `Recursion limit of ${config.recursionLimit} reached`,
                    "without hitting a stop condition. You can increase the",
                    `limit by setting the "recursionLimit" config key.`
                ].join(" "), {
                    lc_error_code: "GRAPH_RECURSION_LIMIT"
                });
            } catch (e) {
                loopError = e;
            } finally{
                try {
                    // Call `.stop()` again incase it was not called in the loop, e.g due to an error.
                    if (loop) await loop.store?.stop();
                    await Promise.all([
                        ...loop?.checkpointerPromises ?? [],
                        ...Array.from(managed.values()).map((mv)=>mv.promises())
                    ]);
                } catch (e) {
                    loopError = loopError ?? e;
                }
                if (loopError) // "Causes any future interactions with the associated stream to error".
                // Wraps ReadableStreamDefaultController#error:
                // https://developer.mozilla.org/en-US/docs/Web/API/ReadableStreamDefaultController/error
                stream.error(loopError);
                else // Will end the iterator outside of this method,
                // keeping previously enqueued chunks.
                // Wraps ReadableStreamDefaultController#close:
                // https://developer.mozilla.org/en-US/docs/Web/API/ReadableStreamDefaultController/close
                stream.close();
            }
        };
        const runLoopPromise = runLoop();
        try {
            for await (const chunk of stream){
                if (chunk === undefined) throw new Error("Data structure error.");
                const [namespace, mode, payload] = chunk;
                if (streamMode.includes(mode)) {
                    if (streamSubgraphs && !streamModeSingle) yield [
                        namespace,
                        mode,
                        payload
                    ];
                    else if (!streamModeSingle) yield [
                        mode,
                        payload
                    ];
                    else if (streamSubgraphs) yield [
                        namespace,
                        payload
                    ];
                    else yield payload;
                }
            }
        } catch (e) {
            await runManager?.handleChainError(loopError);
            throw e;
        } finally{
            await runLoopPromise;
        }
        await runManager?.handleChainEnd(loop?.output ?? {});
    }
    /**
     * Run the graph with a single input and config.
     * @param input The input to the graph.
     * @param options The configuration to use for the run.
     * @param options.streamMode The mode to stream output. Defaults to value set on initialization.
     *   Options are "values", "updates", and "debug". Default is "values".
     *     values: Emit the current values of the state for each step.
     *     updates: Emit only the updates to the state for each step.
     *         Output is a dict with the node name as key and the updated values as value.
     *     debug: Emit debug events for each step.
     * @param options.outputKeys The keys to stream. Defaults to all non-context channels.
     * @param options.interruptBefore Nodes to interrupt before.
     * @param options.interruptAfter Nodes to interrupt after.
     * @param options.debug Whether to print debug information during execution.
     */ async invoke(input, options) {
        const streamMode = options?.streamMode ?? "values";
        const config = {
            ...options,
            outputKeys: options?.outputKeys ?? this.outputChannels,
            streamMode
        };
        const chunks = [];
        const stream = await this.stream(input, config);
        for await (const chunk of stream)chunks.push(chunk);
        if (streamMode === "values") return chunks[chunks.length - 1];
        return chunks;
    }
}

},{"@langchain/core/runnables":"5B2I4","@langchain/langgraph-checkpoint":"jLOBB","../channels/base.js":"UYQzM","./read.js":"b7GRw","./validate.js":"1mO69","./io.js":"aHxh6","./debug.js":"5Cx3A","./write.js":"hERuA","../constants.js":"1BFWS","../errors.js":"jKiOM","./algo.js":"gwyOk","./utils/index.js":"lja7d","./utils/subgraph.js":"b00W2","./loop.js":"cM3K1","./retry.js":"iaE5K","../managed/base.js":"4p0hG","../utils.js":"ge2lq","./utils/config.js":"4g7pC","./messages.js":"lyblJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1mO69":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphValidationError", ()=>GraphValidationError);
parcelHelpers.export(exports, "validateGraph", ()=>validateGraph);
parcelHelpers.export(exports, "validateKeys", ()=>validateKeys);
var _constantsJs = require("../constants.js");
var _readJs = require("./read.js");
class GraphValidationError extends Error {
    constructor(message){
        super(message);
        this.name = "GraphValidationError";
    }
}
function validateGraph({ nodes, channels, inputChannels, outputChannels, streamChannels, interruptAfterNodes, interruptBeforeNodes }) {
    if (!channels) throw new GraphValidationError("Channels not provided");
    const subscribedChannels = new Set();
    const allOutputChannels = new Set();
    for (const [name, node] of Object.entries(nodes)){
        if (name === (0, _constantsJs.INTERRUPT)) throw new GraphValidationError(`"Node name ${(0, _constantsJs.INTERRUPT)} is reserved"`);
        if (node.constructor === (0, _readJs.PregelNode)) node.triggers.forEach((trigger)=>subscribedChannels.add(trigger));
        else throw new GraphValidationError(`Invalid node type ${typeof node}, expected PregelNode`);
    }
    // side effect: update channels
    for (const chan of subscribedChannels){
        if (!(chan in channels)) throw new GraphValidationError(`Subcribed channel '${String(chan)}' not in channels`);
    }
    if (!Array.isArray(inputChannels)) {
        if (!subscribedChannels.has(inputChannels)) throw new GraphValidationError(`Input channel ${String(inputChannels)} is not subscribed to by any node`);
    } else {
        if (inputChannels.every((channel)=>!subscribedChannels.has(channel))) throw new GraphValidationError(`None of the input channels ${inputChannels} are subscribed to by any node`);
    }
    if (!Array.isArray(outputChannels)) allOutputChannels.add(outputChannels);
    else outputChannels.forEach((chan)=>allOutputChannels.add(chan));
    if (streamChannels && !Array.isArray(streamChannels)) allOutputChannels.add(streamChannels);
    else if (Array.isArray(streamChannels)) streamChannels.forEach((chan)=>allOutputChannels.add(chan));
    for (const chan of allOutputChannels){
        if (!(chan in channels)) throw new GraphValidationError(`Output channel '${String(chan)}' not in channels`);
    }
    // validate interrupt before/after
    if (interruptAfterNodes && interruptAfterNodes !== "*") for (const node of interruptAfterNodes){
        if (!(node in nodes)) throw new GraphValidationError(`Node ${String(node)} not in nodes`);
    }
    if (interruptBeforeNodes && interruptBeforeNodes !== "*") for (const node of interruptBeforeNodes){
        if (!(node in nodes)) throw new GraphValidationError(`Node ${String(node)} not in nodes`);
    }
}
function validateKeys(keys, channels) {
    if (Array.isArray(keys)) for (const key of keys){
        if (!(key in channels)) throw new Error(`Key ${String(key)} not found in channels`);
    }
    else {
        if (!(keys in channels)) throw new Error(`Key ${String(keys)} not found in channels`);
    }
}

},{"../constants.js":"1BFWS","./read.js":"b7GRw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aHxh6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readChannel", ()=>readChannel);
parcelHelpers.export(exports, "readChannels", ()=>readChannels);
/**
 * Map input chunk to a sequence of pending writes in the form [channel, value].
 */ parcelHelpers.export(exports, "mapInput", ()=>mapInput);
/**
 * Map pending writes (a sequence of tuples (channel, value)) to output chunk.
 */ parcelHelpers.export(exports, "mapOutputValues", ()=>mapOutputValues);
/**
 * Map pending writes (a sequence of tuples (channel, value)) to output chunk.
 */ parcelHelpers.export(exports, "mapOutputUpdates", ()=>mapOutputUpdates);
parcelHelpers.export(exports, "single", ()=>single);
var _constantsJs = require("../constants.js");
var _errorsJs = require("../errors.js");
function readChannel(channels, chan, catchErrors = true, returnException = false) {
    try {
        return channels[chan].get();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (e.name === (0, _errorsJs.EmptyChannelError).unminifiable_name) {
            if (returnException) return e;
            else if (catchErrors) return null;
        }
        throw e;
    }
}
function readChannels(channels, select, skipEmpty = true) {
    if (Array.isArray(select)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const values = {};
        for (const k of select)try {
            values[k] = readChannel(channels, k, !skipEmpty);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.name === (0, _errorsJs.EmptyChannelError).unminifiable_name) continue;
        }
        return values;
    } else return readChannel(channels, select);
}
function* mapInput(inputChannels, // eslint-disable-next-line @typescript-eslint/no-explicit-any
chunk) {
    if (chunk !== undefined && chunk !== null) {
        if (Array.isArray(inputChannels) && typeof chunk === "object" && !Array.isArray(chunk)) {
            for(const k in chunk)if (inputChannels.includes(k)) yield [
                k,
                chunk[k]
            ];
        } else if (Array.isArray(inputChannels)) throw new Error(`Input chunk must be an object when "inputChannels" is an array`);
        else yield [
            inputChannels,
            chunk
        ];
    }
}
function* mapOutputValues(outputChannels, pendingWrites, channels) {
    if (Array.isArray(outputChannels)) {
        if (pendingWrites === true || pendingWrites.find(([chan, _])=>outputChannels.includes(chan))) yield readChannels(channels, outputChannels);
    } else if (pendingWrites === true || pendingWrites.some(([chan, _])=>chan === outputChannels)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    yield readChannel(channels, outputChannels);
}
function* mapOutputUpdates(outputChannels, tasks, cached) {
    const outputTasks = tasks.filter(([task])=>{
        return task.config === undefined || !task.config.tags?.includes((0, _constantsJs.TAG_HIDDEN));
    });
    if (!outputTasks.length) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let updated;
    if (!Array.isArray(outputChannels)) updated = outputTasks.flatMap(([task])=>task.writes.filter(([chan, _])=>chan === outputChannels)// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .map(([_, value])=>[
                task.name,
                value
            ]));
    else updated = outputTasks.filter(([task])=>task.writes.some(([chan])=>outputChannels.includes(chan))).map(([task])=>[
            task.name,
            Object.fromEntries(task.writes.filter(([chan])=>outputChannels.includes(chan)))
        ]);
    const grouped = Object.fromEntries(outputTasks.map(([t])=>[
            t.name,
            []
        ]));
    for (const [node, value] of updated)grouped[node].push(value);
    for (const [node, value] of Object.entries(grouped)){
        if (value.length === 0) delete grouped[node];
        else if (value.length === 1) // TODO: Fix incorrect cast here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        grouped[node] = value[0];
    }
    if (cached) grouped["__metadata__"] = {
        cached
    };
    yield grouped;
}
function single(iter) {
    // eslint-disable-next-line no-unreachable-loop
    for (const value of iter)return value;
    return null;
}

},{"../constants.js":"1BFWS","../errors.js":"jKiOM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Cx3A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "printCheckpoint", ()=>printCheckpoint);
parcelHelpers.export(exports, "mapDebugTasks", ()=>mapDebugTasks);
parcelHelpers.export(exports, "mapDebugTaskResults", ()=>mapDebugTaskResults);
parcelHelpers.export(exports, "mapDebugCheckpoint", ()=>mapDebugCheckpoint);
parcelHelpers.export(exports, "tasksWithWrites", ()=>tasksWithWrites);
parcelHelpers.export(exports, "printStepCheckpoint", ()=>printStepCheckpoint);
parcelHelpers.export(exports, "printStepTasks", ()=>printStepTasks);
parcelHelpers.export(exports, "printStepWrites", ()=>printStepWrites);
var _constantsJs = require("../constants.js");
var _errorsJs = require("../errors.js");
var _ioJs = require("./io.js");
var _subgraphJs = require("./utils/subgraph.js");
const COLORS_MAP = {
    blue: {
        start: "\x1b[34m",
        end: "\x1b[0m"
    },
    green: {
        start: "\x1b[32m",
        end: "\x1b[0m"
    },
    yellow: {
        start: "\x1b[33;1m",
        end: "\x1b[0m"
    }
};
/**
 * Wrap some text in a color for printing to the console.
 */ const wrap = (color, text)=>`${color.start}${text}${color.end}`;
function printCheckpoint(step, channels) {
    console.log([
        `${wrap(COLORS_MAP.blue, "[langgraph/checkpoint]")}`,
        `Finishing step ${step}. Channel values:\n`,
        `\n${JSON.stringify(Object.fromEntries(_readChannels(channels)), null, 2)}`
    ].join(""));
}
function* _readChannels(channels) {
    for (const [name, channel] of Object.entries(channels))try {
        yield [
            name,
            channel.get()
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.name === (0, _errorsJs.EmptyChannelError).unminifiable_name) continue;
        else throw error; // Re-throw the error if it's not an EmptyChannelError
    }
}
function* mapDebugTasks(step, tasks) {
    const ts = new Date().toISOString();
    for (const { id, name, input, config, triggers, writes } of tasks){
        if (config?.tags?.includes((0, _constantsJs.TAG_HIDDEN))) continue;
        const interrupts = writes.filter(([writeId, n])=>{
            return writeId === id && n === (0, _constantsJs.INTERRUPT);
        }).map(([, v])=>{
            return v;
        });
        yield {
            type: "task",
            timestamp: ts,
            step,
            payload: {
                id,
                name,
                input,
                triggers,
                interrupts
            }
        };
    }
}
function* mapDebugTaskResults(step, tasks, streamChannels) {
    const ts = new Date().toISOString();
    for (const [{ id, name, config }, writes] of tasks){
        if (config?.tags?.includes((0, _constantsJs.TAG_HIDDEN))) continue;
        yield {
            type: "task_result",
            timestamp: ts,
            step,
            payload: {
                id,
                name,
                result: writes.filter(([channel])=>{
                    return Array.isArray(streamChannels) ? streamChannels.includes(channel) : channel === streamChannels;
                }),
                interrupts: writes.filter(([channel])=>{
                    return channel === (0, _constantsJs.INTERRUPT);
                })
            }
        };
    }
}
function* mapDebugCheckpoint(step, config, channels, streamChannels, metadata, tasks, pendingWrites, parentConfig) {
    function formatConfig(config) {
        // make sure the config is consistent with Python
        const pyConfig = {};
        if (config.callbacks != null) pyConfig.callbacks = config.callbacks;
        if (config.configurable != null) pyConfig.configurable = config.configurable;
        if (config.maxConcurrency != null) pyConfig.max_concurrency = config.maxConcurrency;
        if (config.metadata != null) pyConfig.metadata = config.metadata;
        if (config.recursionLimit != null) pyConfig.recursion_limit = config.recursionLimit;
        if (config.runId != null) pyConfig.run_id = config.runId;
        if (config.runName != null) pyConfig.run_name = config.runName;
        if (config.tags != null) pyConfig.tags = config.tags;
        return pyConfig;
    }
    const parentNs = config.configurable?.checkpoint_ns;
    const taskStates = {};
    for (const task of tasks){
        const candidates = task.subgraphs?.length ? task.subgraphs : [
            task.proc
        ];
        if (!candidates.find((0, _subgraphJs.findSubgraphPregel))) continue;
        let taskNs = `${task.name}:${task.id}`;
        if (parentNs) taskNs = `${parentNs}|${taskNs}`;
        taskStates[task.id] = {
            configurable: {
                thread_id: config.configurable?.thread_id,
                checkpoint_ns: taskNs
            }
        };
    }
    const ts = new Date().toISOString();
    yield {
        type: "checkpoint",
        timestamp: ts,
        step,
        payload: {
            config: formatConfig(config),
            values: (0, _ioJs.readChannels)(channels, streamChannels),
            metadata,
            next: tasks.map((task)=>task.name),
            tasks: tasksWithWrites(tasks, pendingWrites, taskStates),
            parentConfig: parentConfig ? formatConfig(parentConfig) : undefined
        }
    };
}
function tasksWithWrites(tasks, pendingWrites, states) {
    return tasks.map((task)=>{
        const error = pendingWrites.find(([id, n])=>id === task.id && n === (0, _constantsJs.ERROR))?.[2];
        const interrupts = pendingWrites.filter(([id, n])=>{
            return id === task.id && n === (0, _constantsJs.INTERRUPT);
        }).map(([, , v])=>{
            return v;
        });
        if (error) return {
            id: task.id,
            name: task.name,
            path: task.path,
            error,
            interrupts
        };
        return {
            id: task.id,
            name: task.name,
            path: task.path,
            interrupts,
            state: states?.[task.id]
        };
    });
}
function printStepCheckpoint(step, channels, whitelist) {
    console.log([
        `${wrap(COLORS_MAP.blue, `[${step}:checkpoint]`)}`,
        `\x1b[1m State at the end of step ${step}:\x1b[0m\n`,
        JSON.stringify((0, _ioJs.readChannels)(channels, whitelist), null, 2)
    ].join(""));
}
function printStepTasks(step, nextTasks) {
    const nTasks = nextTasks.length;
    console.log([
        `${wrap(COLORS_MAP.blue, `[${step}:tasks]`)}`,
        `\x1b[1m Starting step ${step} with ${nTasks} task${nTasks === 1 ? "" : "s"}:\x1b[0m\n`,
        nextTasks.map((task)=>`- ${wrap(COLORS_MAP.green, String(task.name))} -> ${JSON.stringify(task.input, null, 2)}`).join("\n")
    ].join(""));
}
function printStepWrites(step, writes, whitelist) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const byChannel = {};
    for (const [channel, value] of writes)if (whitelist.includes(channel)) {
        if (!byChannel[channel]) byChannel[channel] = [];
        byChannel[channel].push(value);
    }
    console.log([
        `${wrap(COLORS_MAP.blue, `[${step}:writes]`)}`,
        `\x1b[1m Finished step ${step} with writes to ${Object.keys(byChannel).length} channel${Object.keys(byChannel).length !== 1 ? "s" : ""}:\x1b[0m\n`,
        Object.entries(byChannel).map(([name, vals])=>`- ${wrap(COLORS_MAP.yellow, name)} -> ${vals.map((v)=>JSON.stringify(v)).join(", ")}`).join("\n")
    ].join(""));
}

},{"../constants.js":"1BFWS","../errors.js":"jKiOM","./io.js":"aHxh6","./utils/subgraph.js":"b00W2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b00W2":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPregelLike", ()=>isPregelLike);
parcelHelpers.export(exports, "findSubgraphPregel", ()=>findSubgraphPregel);
function isRunnableSequence(x) {
    return "steps" in x && Array.isArray(x.steps);
}
function isPregelLike(// eslint-disable-next-line @typescript-eslint/no-explicit-any
x) {
    return "lg_is_pregel" in x && x.lg_is_pregel === true;
}
function findSubgraphPregel(candidate) {
    const candidates = [
        candidate
    ];
    for (const candidate of candidates){
        if (isPregelLike(candidate)) return candidate;
        else if (isRunnableSequence(candidate)) candidates.push(...candidate.steps);
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gwyOk":[function(require,module,exports,__globalThis) {
/* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "increment", ()=>increment);
parcelHelpers.export(exports, "shouldInterrupt", ()=>shouldInterrupt);
parcelHelpers.export(exports, "_localRead", ()=>_localRead);
parcelHelpers.export(exports, "_localWrite", ()=>_localWrite);
parcelHelpers.export(exports, "_applyWrites", ()=>_applyWrites);
parcelHelpers.export(exports, "_prepareNextTasks", ()=>_prepareNextTasks);
parcelHelpers.export(exports, "_prepareSingleTask", ()=>_prepareSingleTask);
var _runnables = require("@langchain/core/runnables");
var _langgraphCheckpoint = require("@langchain/langgraph-checkpoint");
var _baseJs = require("../channels/base.js");
var _ioJs = require("./io.js");
var _constantsJs = require("../constants.js");
var _errorsJs = require("../errors.js");
var _indexJs = require("./utils/index.js");
const increment = (current)=>{
    return current !== undefined ? current + 1 : 1;
};
function shouldInterrupt(checkpoint, interruptNodes, tasks) {
    const versionValues = Object.values(checkpoint.channel_versions);
    const versionType = versionValues.length > 0 ? typeof versionValues[0] : undefined;
    let nullVersion;
    if (versionType === "number") nullVersion = 0;
    else if (versionType === "string") nullVersion = "";
    const seen = checkpoint.versions_seen[0, _constantsJs.INTERRUPT] ?? {};
    const anyChannelUpdated = Object.entries(checkpoint.channel_versions).some(([chan, version])=>{
        return version > (seen[chan] ?? nullVersion);
    });
    const anyTriggeredNodeInInterruptNodes = tasks.some((task)=>interruptNodes === "*" ? !task.config?.tags?.includes((0, _constantsJs.TAG_HIDDEN)) : interruptNodes.includes(task.name));
    return anyChannelUpdated && anyTriggeredNodeInInterruptNodes;
}
function _localRead(step, checkpoint, channels, managed, task, select, fresh = false) {
    let managedKeys = [];
    let updated = new Set();
    if (!Array.isArray(select)) {
        for (const [c] of task.writes)if (c === select) {
            updated = new Set([
                c
            ]);
            break;
        }
        updated = updated || new Set();
    } else {
        managedKeys = select.filter((k)=>managed.get(k));
        select = select.filter((k)=>!managed.get(k));
        updated = new Set(select.filter((c)=>task.writes.some(([key, _])=>key === c)));
    }
    let values;
    if (fresh && updated.size > 0) {
        const localChannels = Object.fromEntries(Object.entries(channels).filter(([k, _])=>updated.has(k)));
        const newCheckpoint = (0, _baseJs.createCheckpoint)(checkpoint, localChannels, -1);
        const newChannels = (0, _baseJs.emptyChannels)(localChannels, newCheckpoint);
        _applyWrites((0, _langgraphCheckpoint.copyCheckpoint)(newCheckpoint), newChannels, [
            task
        ]);
        values = (0, _ioJs.readChannels)({
            ...channels,
            ...newChannels
        }, select);
    } else values = (0, _ioJs.readChannels)(channels, select);
    if (managedKeys.length > 0) for (const k of managedKeys){
        const managedValue = managed.get(k);
        if (managedValue) {
            const resultOfManagedCall = managedValue.call(step);
            values[k] = resultOfManagedCall;
        }
    }
    return values;
}
function _localWrite(step, // eslint-disable-next-line @typescript-eslint/no-explicit-any
commit, processes, channels, managed, // eslint-disable-next-line @typescript-eslint/no-explicit-any
writes) {
    for (const [chan, value] of writes){
        if (chan === (0, _constantsJs.TASKS)) {
            if (!(0, _constantsJs._isSend)(value)) throw new (0, _errorsJs.InvalidUpdateError)(`Invalid packet type, expected SendProtocol, got ${JSON.stringify(value)}`);
            if (!(value.node in processes)) throw new (0, _errorsJs.InvalidUpdateError)(`Invalid node name "${value.node}" in Send packet`);
            // replace any runtime values with placeholders
            managed.replaceRuntimeValues(step, value.args);
        } else if (!(chan in channels) && !managed.get(chan)) console.warn(`Skipping write for channel '${chan}' which has no readers`);
    }
    commit(writes);
}
function _applyWrites(checkpoint, channels, tasks, // eslint-disable-next-line @typescript-eslint/no-explicit-any
getNextVersion) {
    // Filter out non instances of BaseChannel
    const onlyChannels = Object.fromEntries(Object.entries(channels).filter(([_, value])=>(0, _baseJs.isBaseChannel)(value)));
    // Update seen versions
    for (const task of tasks){
        if (checkpoint.versions_seen[task.name] === undefined) checkpoint.versions_seen[task.name] = {};
        for (const chan of task.triggers)if (chan in checkpoint.channel_versions) checkpoint.versions_seen[task.name][chan] = checkpoint.channel_versions[chan];
    }
    // Find the highest version of all channels
    let maxVersion;
    if (Object.keys(checkpoint.channel_versions).length > 0) maxVersion = (0, _langgraphCheckpoint.maxChannelVersion)(...Object.values(checkpoint.channel_versions));
    // Consume all channels that were read
    const channelsToConsume = new Set(tasks.flatMap((task)=>task.triggers).filter((chan)=>!(0, _constantsJs.RESERVED).includes(chan)));
    for (const chan of channelsToConsume){
        if (chan in onlyChannels && onlyChannels[chan].consume()) {
            if (getNextVersion !== undefined) checkpoint.channel_versions[chan] = getNextVersion(maxVersion, onlyChannels[chan]);
        }
    }
    // Clear pending sends
    if (checkpoint.pending_sends) checkpoint.pending_sends = [];
    // Group writes by channel
    const pendingWriteValuesByChannel = {};
    const pendingWritesByManaged = {};
    for (const task of tasks)for (const [chan, val] of task.writes){
        if (chan === (0, _constantsJs.TASKS)) checkpoint.pending_sends.push({
            node: val.node,
            args: val.args
        });
        else if (chan in onlyChannels) {
            if (chan in pendingWriteValuesByChannel) pendingWriteValuesByChannel[chan].push(val);
            else pendingWriteValuesByChannel[chan] = [
                val
            ];
        } else if (chan in pendingWritesByManaged) pendingWritesByManaged[chan].push(val);
        else pendingWritesByManaged[chan] = [
            val
        ];
    }
    // find the highest version of all channels
    maxVersion = undefined;
    if (Object.keys(checkpoint.channel_versions).length > 0) maxVersion = (0, _langgraphCheckpoint.maxChannelVersion)(...Object.values(checkpoint.channel_versions));
    const updatedChannels = new Set();
    // Apply writes to channels
    for (const [chan, vals] of Object.entries(pendingWriteValuesByChannel))if (chan in onlyChannels) {
        let updated;
        try {
            updated = onlyChannels[chan].update(vals);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.name === (0, _errorsJs.InvalidUpdateError).unminifiable_name) {
                const wrappedError = new (0, _errorsJs.InvalidUpdateError)(`Invalid update for channel "${chan}" with values ${JSON.stringify(vals)}: ${e.message}`);
                wrappedError.lc_error_code = e.lc_error_code;
                throw wrappedError;
            } else throw e;
        }
        if (updated && getNextVersion !== undefined) checkpoint.channel_versions[chan] = getNextVersion(maxVersion, onlyChannels[chan]);
        updatedChannels.add(chan);
    }
    // Channels that weren't updated in this step are notified of a new step
    for (const chan of Object.keys(onlyChannels))if (!updatedChannels.has(chan)) {
        const updated = onlyChannels[chan].update([]);
        if (updated && getNextVersion !== undefined) checkpoint.channel_versions[chan] = getNextVersion(maxVersion, onlyChannels[chan]);
    }
    // Return managed values writes to be applied externally
    return pendingWritesByManaged;
}
function _prepareNextTasks(checkpoint, processes, channels, managed, config, forExecution, extra) {
    const tasks = {};
    // Consume pending packets
    for(let i = 0; i < checkpoint.pending_sends.length; i += 1){
        const task = _prepareSingleTask([
            (0, _constantsJs.PUSH),
            i
        ], checkpoint, processes, channels, managed, config, forExecution, extra);
        if (task !== undefined) tasks[task.id] = task;
    }
    // Check if any processes should be run in next step
    // If so, prepare the values to be passed to them
    for (const name of Object.keys(processes)){
        const task = _prepareSingleTask([
            (0, _constantsJs.PULL),
            name
        ], checkpoint, processes, channels, managed, config, forExecution, extra);
        if (task !== undefined) tasks[task.id] = task;
    }
    return tasks;
}
function _prepareSingleTask(taskPath, checkpoint, processes, channels, managed, config, forExecution, extra) {
    const { step, checkpointer, manager } = extra;
    const configurable = config.configurable ?? {};
    const parentNamespace = configurable.checkpoint_ns ?? "";
    if (taskPath[0] === (0, _constantsJs.PUSH)) {
        const index = typeof taskPath[1] === "number" ? taskPath[1] : parseInt(taskPath[1], 10);
        if (index >= checkpoint.pending_sends.length) return undefined;
        const packet = checkpoint.pending_sends[index];
        if (!(0, _constantsJs._isSendInterface)(packet)) {
            console.warn(`Ignoring invalid packet ${JSON.stringify(packet)} in pending sends.`);
            return undefined;
        }
        if (!(packet.node in processes)) {
            console.warn(`Ignoring unknown node name ${packet.node} in pending sends.`);
            return undefined;
        }
        const triggers = [
            (0, _constantsJs.PUSH)
        ];
        const checkpointNamespace = parentNamespace === "" ? packet.node : `${parentNamespace}${0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR}${packet.node}`;
        const taskId = (0, _langgraphCheckpoint.uuid5)(JSON.stringify([
            checkpointNamespace,
            step.toString(),
            packet.node,
            (0, _constantsJs.PUSH),
            index.toString()
        ]), checkpoint.id);
        const taskCheckpointNamespace = `${checkpointNamespace}${(0, _constantsJs.CHECKPOINT_NAMESPACE_END)}${taskId}`;
        let metadata = {
            langgraph_step: step,
            langgraph_node: packet.node,
            langgraph_triggers: triggers,
            langgraph_path: taskPath,
            langgraph_checkpoint_ns: taskCheckpointNamespace
        };
        if (forExecution) {
            const proc = processes[packet.node];
            const node = proc.getNode();
            if (node !== undefined) {
                managed.replaceRuntimePlaceholders(step, packet.args);
                if (proc.metadata !== undefined) metadata = {
                    ...metadata,
                    ...proc.metadata
                };
                const writes = [];
                return {
                    name: packet.node,
                    input: packet.args,
                    proc: node,
                    subgraphs: proc.subgraphs,
                    writes,
                    config: (0, _runnables.patchConfig)((0, _runnables.mergeConfigs)(config, {
                        metadata,
                        tags: proc.tags,
                        store: extra.store ?? config.store
                    }), {
                        runName: packet.node,
                        callbacks: manager?.getChild(`graph:step:${step}`),
                        configurable: {
                            [(0, _constantsJs.CONFIG_KEY_TASK_ID)]: taskId,
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            [(0, _constantsJs.CONFIG_KEY_SEND)]: (writes_)=>_localWrite(step, (items)=>writes.push(...items), processes, channels, managed, writes_),
                            [(0, _constantsJs.CONFIG_KEY_READ)]: (select_, fresh_ = false)=>_localRead(step, checkpoint, channels, managed, {
                                    name: packet.node,
                                    writes: writes,
                                    triggers
                                }, select_, fresh_),
                            [(0, _constantsJs.CONFIG_KEY_CHECKPOINTER)]: checkpointer ?? configurable[0, _constantsJs.CONFIG_KEY_CHECKPOINTER],
                            [(0, _constantsJs.CONFIG_KEY_CHECKPOINT_MAP)]: {
                                ...configurable[0, _constantsJs.CONFIG_KEY_CHECKPOINT_MAP],
                                [parentNamespace]: checkpoint.id
                            },
                            checkpoint_id: undefined,
                            checkpoint_ns: taskCheckpointNamespace
                        }
                    }),
                    triggers,
                    retry_policy: proc.retryPolicy,
                    id: taskId,
                    path: taskPath
                };
            }
        } else return {
            id: taskId,
            name: packet.node,
            interrupts: [],
            path: taskPath
        };
    } else if (taskPath[0] === (0, _constantsJs.PULL)) {
        const name = taskPath[1].toString();
        const proc = processes[name];
        if (proc === undefined) return undefined;
        const nullVersion = (0, _indexJs.getNullChannelVersion)(checkpoint.channel_versions);
        if (nullVersion === undefined) return undefined;
        const seen = checkpoint.versions_seen[name] ?? {};
        const triggers = proc.triggers.filter((chan)=>{
            const result = (0, _ioJs.readChannel)(channels, chan, false, true);
            const isEmptyChannelError = // eslint-disable-next-line no-instanceof/no-instanceof
            result instanceof Error && result.name === (0, _errorsJs.EmptyChannelError).unminifiable_name;
            return !isEmptyChannelError && (checkpoint.channel_versions[chan] ?? nullVersion) > (seen[chan] ?? nullVersion);
        }).sort();
        // If any of the channels read by this process were updated
        if (triggers.length > 0) {
            const val = _procInput(step, proc, managed, channels, forExecution);
            if (val === undefined) return undefined;
            const checkpointNamespace = parentNamespace === "" ? name : `${parentNamespace}${0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR}${name}`;
            const taskId = (0, _langgraphCheckpoint.uuid5)(JSON.stringify([
                checkpointNamespace,
                step.toString(),
                name,
                (0, _constantsJs.PULL),
                triggers
            ]), checkpoint.id);
            const taskCheckpointNamespace = `${checkpointNamespace}${(0, _constantsJs.CHECKPOINT_NAMESPACE_END)}${taskId}`;
            let metadata = {
                langgraph_step: step,
                langgraph_node: name,
                langgraph_triggers: triggers,
                langgraph_path: taskPath,
                langgraph_checkpoint_ns: taskCheckpointNamespace
            };
            if (forExecution) {
                const node = proc.getNode();
                if (node !== undefined) {
                    if (proc.metadata !== undefined) metadata = {
                        ...metadata,
                        ...proc.metadata
                    };
                    const writes = [];
                    const taskCheckpointNamespace = `${checkpointNamespace}${(0, _constantsJs.CHECKPOINT_NAMESPACE_END)}${taskId}`;
                    return {
                        name,
                        input: val,
                        proc: node,
                        subgraphs: proc.subgraphs,
                        writes,
                        config: (0, _runnables.patchConfig)((0, _runnables.mergeConfigs)(config, {
                            metadata,
                            tags: proc.tags,
                            store: extra.store ?? config.store
                        }), {
                            runName: name,
                            callbacks: manager?.getChild(`graph:step:${step}`),
                            configurable: {
                                [(0, _constantsJs.CONFIG_KEY_TASK_ID)]: taskId,
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                [(0, _constantsJs.CONFIG_KEY_SEND)]: (writes_)=>_localWrite(step, (items)=>{
                                        writes.push(...items);
                                    }, processes, channels, managed, writes_),
                                [(0, _constantsJs.CONFIG_KEY_READ)]: (select_, fresh_ = false)=>_localRead(step, checkpoint, channels, managed, {
                                        name,
                                        writes: writes,
                                        triggers
                                    }, select_, fresh_),
                                [(0, _constantsJs.CONFIG_KEY_CHECKPOINTER)]: checkpointer ?? configurable[0, _constantsJs.CONFIG_KEY_CHECKPOINTER],
                                [(0, _constantsJs.CONFIG_KEY_CHECKPOINT_MAP)]: {
                                    ...configurable[0, _constantsJs.CONFIG_KEY_CHECKPOINT_MAP],
                                    [parentNamespace]: checkpoint.id
                                },
                                checkpoint_id: undefined,
                                checkpoint_ns: taskCheckpointNamespace
                            }
                        }),
                        triggers,
                        retry_policy: proc.retryPolicy,
                        id: taskId,
                        path: taskPath
                    };
                }
            } else return {
                id: taskId,
                name,
                interrupts: [],
                path: taskPath
            };
        }
    }
    return undefined;
}
function _procInput(step, proc, managed, channels, forExecution) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let val;
    if (typeof proc.channels === "object" && !Array.isArray(proc.channels)) {
        val = {};
        for (const [k, chan] of Object.entries(proc.channels)){
            if (proc.triggers.includes(chan)) try {
                val[k] = (0, _ioJs.readChannel)(channels, chan, false);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                if (e.name === (0, _errorsJs.EmptyChannelError).unminifiable_name) return undefined;
                else throw e;
            }
            else if (chan in channels) try {
                val[k] = (0, _ioJs.readChannel)(channels, chan, true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                if (e.name === (0, _errorsJs.EmptyChannelError).unminifiable_name) continue;
                else throw e;
            }
            else val[k] = managed.get(k)?.call(step);
        }
    } else if (Array.isArray(proc.channels)) {
        let successfulRead = false;
        for (const chan of proc.channels)try {
            val = (0, _ioJs.readChannel)(channels, chan, false);
            successfulRead = true;
            break;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.name === (0, _errorsJs.EmptyChannelError).unminifiable_name) continue;
            else throw e;
        }
        if (!successfulRead) return undefined;
    } else throw new Error(`Invalid channels type, expected list or dict, got ${proc.channels}`);
    // If the process has a mapper, apply it to the value
    if (forExecution && proc.mapper !== undefined) val = proc.mapper(val);
    return val;
}

},{"@langchain/core/runnables":"5B2I4","@langchain/langgraph-checkpoint":"jLOBB","../channels/base.js":"UYQzM","./io.js":"aHxh6","../constants.js":"1BFWS","../errors.js":"jKiOM","./utils/index.js":"lja7d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lja7d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNullChannelVersion", ()=>getNullChannelVersion);
parcelHelpers.export(exports, "getNewChannelVersions", ()=>getNewChannelVersions);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "_coerceToDict", ()=>_coerceToDict);
parcelHelpers.export(exports, "patchConfigurable", ()=>patchConfigurable);
parcelHelpers.export(exports, "patchCheckpointMap", ()=>patchCheckpointMap);
var _constantsJs = require("../../constants.js");
function getNullChannelVersion(currentVersions) {
    const versionValues = Object.values(currentVersions);
    const versionType = versionValues.length > 0 ? typeof versionValues[0] : undefined;
    let nullVersion;
    if (versionType === "number") nullVersion = 0;
    else if (versionType === "string") nullVersion = "";
    return nullVersion;
}
function getNewChannelVersions(previousVersions, currentVersions) {
    // Get new channel versions
    if (Object.keys(previousVersions).length > 0) {
        const nullVersion = getNullChannelVersion(currentVersions);
        return Object.fromEntries(Object.entries(currentVersions).filter(([k, v])=>v > (previousVersions[k] ?? nullVersion)));
    } else return currentVersions;
}
function _coerceToDict(value, defaultKey) {
    return value && !Array.isArray(value) && // eslint-disable-next-line no-instanceof/no-instanceof
    !(value instanceof Date) && typeof value === "object" ? value : {
        [defaultKey]: value
    };
}
function patchConfigurable(config, // eslint-disable-next-line @typescript-eslint/no-explicit-any
patch) {
    if (config === null) return {
        configurable: patch
    };
    else if (config?.configurable === undefined) return {
        ...config,
        configurable: patch
    };
    else return {
        ...config,
        configurable: {
            ...config.configurable,
            ...patch
        }
    };
}
function patchCheckpointMap(config, metadata) {
    const parents = metadata?.parents ?? {};
    if (Object.keys(parents).length > 0) return patchConfigurable(config, {
        [(0, _constantsJs.CONFIG_KEY_CHECKPOINT_MAP)]: {
            ...parents,
            [config.configurable?.checkpoint_ns ?? ""]: config.configurable?.checkpoint_id
        }
    });
    else return config;
}

},{"../../constants.js":"1BFWS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cM3K1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IterableReadableWritableStream", ()=>IterableReadableWritableStream);
parcelHelpers.export(exports, "PregelLoop", ()=>PregelLoop);
var _stream = require("@langchain/core/utils/stream");
var _langgraphCheckpoint = require("@langchain/langgraph-checkpoint");
var _baseJs = require("../channels/base.js");
var _constantsJs = require("../constants.js");
var _algoJs = require("./algo.js");
var _utilsJs = require("../utils.js");
var _ioJs = require("./io.js");
var _errorsJs = require("../errors.js");
var _indexJs = require("./utils/index.js");
var _debugJs = require("./debug.js");
const INPUT_DONE = Symbol.for("INPUT_DONE");
const INPUT_RESUMING = Symbol.for("INPUT_RESUMING");
const DEFAULT_LOOP_LIMIT = 25;
const SPECIAL_CHANNELS = [
    (0, _constantsJs.ERROR),
    (0, _constantsJs.INTERRUPT)
];
class IterableReadableWritableStream extends (0, _stream.IterableReadableStream) {
    constructor(params){
        let streamControllerPromiseResolver;
        const streamControllerPromise = new Promise((resolve)=>{
            streamControllerPromiseResolver = resolve;
        });
        super({
            start: (controller)=>{
                streamControllerPromiseResolver(controller);
            }
        });
        Object.defineProperty(this, "modes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "controller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "passthroughFn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // .start() will always be called before the stream can be interacted
        // with anyway
        streamControllerPromise.then((controller)=>{
            this.controller = controller;
        });
        this.passthroughFn = params.passthroughFn;
        this.modes = params.modes;
    }
    push(chunk) {
        this.passthroughFn?.(chunk);
        this.controller.enqueue(chunk);
    }
    close() {
        try {
            this.controller.close();
        } catch (e) {
        // pass
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error(e) {
        this.controller.error(e);
    }
}
function createDuplexStream(...streams) {
    return new IterableReadableWritableStream({
        passthroughFn: (value)=>{
            for (const stream of streams)if (stream.modes.has(value[1])) stream.push(value);
        },
        modes: new Set(streams.flatMap((s)=>Array.from(s.modes)))
    });
}
class PregelLoop {
    constructor(params){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "input", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "output", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkpointer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkpointerGetNextVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "channels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "managed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkpoint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkpointConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkpointMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkpointNamespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkpointPendingWrites", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "checkpointPreviousVersions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "step", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stop", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "outputKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "streamKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "skipDoneTasks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "taskWritesLeft", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "prevCheckpointConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "pending"
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "tasks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.defineProperty(this, "stream", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkpointerPromises", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "isNested", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_checkpointerChainedPromise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Promise.resolve()
        });
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.input = params.input;
        this.checkpointer = params.checkpointer;
        // TODO: if managed values no longer needs graph we can replace with
        // managed_specs, channel_specs
        if (this.checkpointer !== undefined) this.checkpointerGetNextVersion = this.checkpointer.getNextVersion.bind(this.checkpointer);
        else this.checkpointerGetNextVersion = (0, _algoJs.increment);
        this.checkpoint = params.checkpoint;
        this.checkpointMetadata = params.checkpointMetadata;
        this.checkpointPreviousVersions = params.checkpointPreviousVersions;
        this.channels = params.channels;
        this.managed = params.managed;
        this.checkpointPendingWrites = params.checkpointPendingWrites;
        this.step = params.step;
        this.stop = params.stop;
        this.config = params.config;
        this.checkpointConfig = params.checkpointConfig;
        this.isNested = params.isNested;
        this.outputKeys = params.outputKeys;
        this.streamKeys = params.streamKeys;
        this.nodes = params.nodes;
        this.skipDoneTasks = params.skipDoneTasks;
        this.store = params.store;
        this.stream = params.stream;
        this.checkpointNamespace = params.checkpointNamespace;
        this.prevCheckpointConfig = params.prevCheckpointConfig;
    }
    static async initialize(params) {
        let { config, stream } = params;
        const { checkSubgraphs = true } = params;
        if (stream !== undefined && config.configurable?.[0, _constantsJs.CONFIG_KEY_STREAM] !== undefined) stream = createDuplexStream(stream, config.configurable[0, _constantsJs.CONFIG_KEY_STREAM]);
        const skipDoneTasks = config.configurable?.checkpoint_id === undefined;
        const isNested = (0, _constantsJs.CONFIG_KEY_READ) in (config.configurable ?? {});
        if (!isNested && config.configurable?.checkpoint_ns !== undefined && config.configurable?.checkpoint_ns !== "") config = (0, _indexJs.patchConfigurable)(config, {
            checkpoint_ns: "",
            checkpoint_id: undefined
        });
        let checkpointConfig = config;
        if (config.configurable?.[0, _constantsJs.CONFIG_KEY_CHECKPOINT_MAP] !== undefined && config.configurable?.[0, _constantsJs.CONFIG_KEY_CHECKPOINT_MAP]?.[config.configurable?.checkpoint_ns]) checkpointConfig = (0, _indexJs.patchConfigurable)(config, {
            checkpoint_id: config.configurable[0, _constantsJs.CONFIG_KEY_CHECKPOINT_MAP][config.configurable?.checkpoint_ns]
        });
        const checkpointNamespace = config.configurable?.checkpoint_ns?.split((0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR)) ?? [];
        const saved = await params.checkpointer?.getTuple(checkpointConfig) ?? {
            config,
            checkpoint: (0, _langgraphCheckpoint.emptyCheckpoint)(),
            metadata: {
                source: "input",
                step: -2,
                writes: null,
                parents: {}
            },
            pendingWrites: []
        };
        checkpointConfig = {
            ...config,
            ...saved.config,
            configurable: {
                checkpoint_ns: "",
                ...config.configurable,
                ...saved.config.configurable
            }
        };
        const prevCheckpointConfig = saved.parentConfig;
        const checkpoint = (0, _langgraphCheckpoint.copyCheckpoint)(saved.checkpoint);
        const checkpointMetadata = {
            ...saved.metadata
        };
        const checkpointPendingWrites = saved.pendingWrites ?? [];
        const channels = (0, _baseJs.emptyChannels)(params.channelSpecs, checkpoint);
        const step = (checkpointMetadata.step ?? 0) + 1;
        const stop = step + (config.recursionLimit ?? DEFAULT_LOOP_LIMIT) + 1;
        const checkpointPreviousVersions = {
            ...checkpoint.channel_versions
        };
        const store = params.store ? new (0, _langgraphCheckpoint.AsyncBatchedStore)(params.store) : undefined;
        if (store) // Start the store. This is a batch store, so it will run continuously
        store.start();
        if (checkSubgraphs && isNested && params.checkpointer !== undefined) {
            if ((0, _errorsJs.getSubgraphsSeenSet)().has(config.configurable?.checkpoint_ns)) throw new (0, _errorsJs.MultipleSubgraphsError)([
                "Detected the same subgraph called multiple times by the same node.",
                "This is not allowed if checkpointing is enabled.",
                "",
                `You can disable checkpointing for a subgraph by compiling it with ".compile({ checkpointer: false });"`
            ].join("\n"), {
                lc_error_code: "MULTIPLE_SUBGRAPHS"
            });
            else (0, _errorsJs.getSubgraphsSeenSet)().add(config.configurable?.checkpoint_ns);
        }
        return new PregelLoop({
            input: params.input,
            config,
            checkpointer: params.checkpointer,
            checkpoint,
            checkpointMetadata,
            checkpointConfig,
            prevCheckpointConfig,
            checkpointNamespace,
            channels,
            managed: params.managed,
            isNested,
            skipDoneTasks,
            step,
            stop,
            checkpointPreviousVersions,
            checkpointPendingWrites,
            outputKeys: params.outputKeys ?? [],
            streamKeys: params.streamKeys ?? [],
            nodes: params.nodes,
            stream,
            store
        });
    }
    _checkpointerPutAfterPrevious(input) {
        this._checkpointerChainedPromise = this._checkpointerChainedPromise.then(()=>{
            return this.checkpointer?.put(input.config, input.checkpoint, input.metadata, input.newVersions);
        });
        this.checkpointerPromises.push(this._checkpointerChainedPromise);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async updateManagedValues(key, values) {
        const mv = this.managed.get(key);
        if (mv && "update" in mv && typeof mv.update === "function") await mv.update(values);
    }
    /**
     * Put writes for a task, to be read by the next tick.
     * @param taskId
     * @param writes
     */ putWrites(taskId, writes) {
        if (writes.length === 0) return;
        // adjust taskWritesLeft
        const firstChannel = writes[0][0];
        const anyChannelIsSend = writes.find(([channel])=>channel === (0, _constantsJs.TASKS));
        const alwaysSave = anyChannelIsSend || SPECIAL_CHANNELS.includes(firstChannel);
        if (!alwaysSave && !this.taskWritesLeft) return this._outputWrites(taskId, writes);
        else if (firstChannel !== (0, _constantsJs.INTERRUPT)) // INTERRUPT makes us want to save the last task's writes
        // so we don't decrement tasksWritesLeft in that case
        this.taskWritesLeft -= 1;
        // save writes
        const pendingWrites = writes.map(([key, value])=>{
            return [
                taskId,
                key,
                value
            ];
        });
        this.checkpointPendingWrites.push(...pendingWrites);
        const putWritePromise = this.checkpointer?.putWrites({
            ...this.checkpointConfig,
            configurable: {
                ...this.checkpointConfig.configurable,
                checkpoint_ns: this.config.configurable?.checkpoint_ns ?? "",
                checkpoint_id: this.checkpoint.id
            }
        }, writes, taskId);
        if (putWritePromise !== undefined) this.checkpointerPromises.push(putWritePromise);
        this._outputWrites(taskId, writes);
    }
    _outputWrites(taskId, writes, cached = false) {
        const task = this.tasks[taskId];
        if (task !== undefined) {
            if (task.config !== undefined && (task.config.tags ?? []).includes((0, _constantsJs.TAG_HIDDEN))) return;
            if (writes.length > 0 && writes[0][0] !== (0, _constantsJs.ERROR) && writes[0][0] !== (0, _constantsJs.INTERRUPT)) this._emit((0, _utilsJs.gatherIteratorSync)((0, _utilsJs.prefixGenerator)((0, _ioJs.mapOutputUpdates)(this.outputKeys, [
                [
                    task,
                    writes
                ]
            ], cached), "updates")));
            if (!cached) this._emit((0, _utilsJs.gatherIteratorSync)((0, _utilsJs.prefixGenerator)((0, _debugJs.mapDebugTaskResults)(this.step, [
                [
                    task,
                    writes
                ]
            ], this.streamKeys), "debug")));
        }
    }
    /**
     * Execute a single iteration of the Pregel loop.
     * Returns true if more iterations are needed.
     * @param params
     */ async tick(params) {
        let tickError;
        try {
            if (this.store && !this.store.isRunning) this.store?.start();
            const { inputKeys = [], interruptAfter = [], interruptBefore = [], manager } = params;
            if (this.status !== "pending") throw new Error(`Cannot tick when status is no longer "pending". Current status: "${this.status}"`);
            if (![
                INPUT_DONE,
                INPUT_RESUMING
            ].includes(this.input)) await this._first(inputKeys);
            else if (Object.values(this.tasks).every((task)=>task.writes.length > 0)) {
                const writes = Object.values(this.tasks).flatMap((t)=>t.writes);
                // All tasks have finished
                const managedValueWrites = (0, _algoJs._applyWrites)(this.checkpoint, this.channels, Object.values(this.tasks), this.checkpointerGetNextVersion);
                for (const [key, values] of Object.entries(managedValueWrites))await this.updateManagedValues(key, values);
                // produce values output
                const valuesOutput = await (0, _utilsJs.gatherIterator)((0, _utilsJs.prefixGenerator)((0, _ioJs.mapOutputValues)(this.outputKeys, writes, this.channels), "values"));
                this._emit(valuesOutput);
                // clear pending writes
                this.checkpointPendingWrites = [];
                await this._putCheckpoint({
                    source: "loop",
                    writes: (0, _ioJs.mapOutputUpdates)(this.outputKeys, Object.values(this.tasks).map((task)=>[
                            task,
                            task.writes
                        ])).next().value ?? null
                });
                // after execution, check if we should interrupt
                if ((0, _algoJs.shouldInterrupt)(this.checkpoint, interruptAfter, Object.values(this.tasks))) {
                    this.status = "interrupt_after";
                    if (this.isNested) throw new (0, _errorsJs.GraphInterrupt)();
                    else return false;
                }
            } else return false;
            if (this.step > this.stop) {
                this.status = "out_of_steps";
                return false;
            }
            const nextTasks = (0, _algoJs._prepareNextTasks)(this.checkpoint, this.nodes, this.channels, this.managed, this.config, true, {
                step: this.step,
                checkpointer: this.checkpointer,
                isResuming: this.input === INPUT_RESUMING,
                manager,
                store: this.store
            });
            this.tasks = nextTasks;
            this.taskWritesLeft = Object.values(this.tasks).length - 1;
            // Produce debug output
            if (this.checkpointer) this._emit(await (0, _utilsJs.gatherIterator)((0, _utilsJs.prefixGenerator)((0, _debugJs.mapDebugCheckpoint)(this.step - 1, this.checkpointConfig, this.channels, this.streamKeys, this.checkpointMetadata, Object.values(this.tasks), this.checkpointPendingWrites, this.prevCheckpointConfig), "debug")));
            if (Object.values(this.tasks).length === 0) {
                this.status = "done";
                return false;
            }
            // if there are pending writes from a previous loop, apply them
            if (this.skipDoneTasks && this.checkpointPendingWrites.length > 0) {
                for (const [tid, k, v] of this.checkpointPendingWrites){
                    if (k === (0, _constantsJs.ERROR) || k === (0, _constantsJs.INTERRUPT)) continue;
                    const task = Object.values(this.tasks).find((t)=>t.id === tid);
                    if (task) task.writes.push([
                        k,
                        v
                    ]);
                }
                for (const task of Object.values(this.tasks))if (task.writes.length > 0) this._outputWrites(task.id, task.writes, true);
            }
            // if all tasks have finished, re-tick
            if (Object.values(this.tasks).every((task)=>task.writes.length > 0)) return this.tick({
                inputKeys,
                interruptAfter,
                interruptBefore,
                manager
            });
            // Before execution, check if we should interrupt
            if ((0, _algoJs.shouldInterrupt)(this.checkpoint, interruptBefore, Object.values(this.tasks))) {
                this.status = "interrupt_before";
                if (this.isNested) throw new (0, _errorsJs.GraphInterrupt)();
                else return false;
            }
            // Produce debug output
            const debugOutput = await (0, _utilsJs.gatherIterator)((0, _utilsJs.prefixGenerator)((0, _debugJs.mapDebugTasks)(this.step, Object.values(this.tasks)), "debug"));
            this._emit(debugOutput);
            return true;
        } catch (e) {
            tickError = e;
            if (!this._suppressInterrupt(tickError)) throw tickError;
            else this.output = (0, _ioJs.readChannels)(this.channels, this.outputKeys);
            return false;
        } finally{
            if (tickError === undefined) this.output = (0, _ioJs.readChannels)(this.channels, this.outputKeys);
        }
    }
    _suppressInterrupt(e) {
        return (0, _errorsJs.isGraphInterrupt)(e) && !this.isNested;
    }
    /**
     * Resuming from previous checkpoint requires
     * - finding a previous checkpoint
     * - receiving None input (outer graph) or RESUMING flag (subgraph)
     */ async _first(inputKeys) {
        const isResuming = Object.keys(this.checkpoint.channel_versions).length !== 0 && (this.config.configurable?.[0, _constantsJs.CONFIG_KEY_RESUMING] !== undefined || this.input === null);
        if (isResuming) {
            for (const channelName of Object.keys(this.channels))if (this.checkpoint.channel_versions[channelName] !== undefined) {
                const version = this.checkpoint.channel_versions[channelName];
                this.checkpoint.versions_seen[0, _constantsJs.INTERRUPT] = {
                    ...this.checkpoint.versions_seen[0, _constantsJs.INTERRUPT],
                    [channelName]: version
                };
            }
            // produce values output
            const valuesOutput = await (0, _utilsJs.gatherIterator)((0, _utilsJs.prefixGenerator)((0, _ioJs.mapOutputValues)(this.outputKeys, true, this.channels), "values"));
            this._emit(valuesOutput);
        // map inputs to channel updates
        } else {
            const inputWrites = await (0, _utilsJs.gatherIterator)((0, _ioJs.mapInput)(inputKeys, this.input));
            if (inputWrites.length === 0) throw new (0, _errorsJs.EmptyInputError)(`Received no input writes for ${JSON.stringify(inputKeys, null, 2)}`);
            const discardTasks = (0, _algoJs._prepareNextTasks)(this.checkpoint, this.nodes, this.channels, this.managed, this.config, true, {
                step: this.step
            });
            (0, _algoJs._applyWrites)(this.checkpoint, this.channels, Object.values(discardTasks).concat([
                {
                    name: (0, _constantsJs.INPUT),
                    writes: inputWrites,
                    triggers: []
                }
            ]), this.checkpointerGetNextVersion);
            // save input checkpoint
            await this._putCheckpoint({
                source: "input",
                writes: Object.fromEntries(inputWrites)
            });
        }
        // done with input
        this.input = isResuming ? INPUT_RESUMING : INPUT_DONE;
        if (!this.isNested) this.config = (0, _indexJs.patchConfigurable)(this.config, {
            [(0, _constantsJs.CONFIG_KEY_RESUMING)]: isResuming
        });
    }
    _emit(values) {
        for (const chunk of values)if (this.stream.modes.has(chunk[0])) this.stream.push([
            this.checkpointNamespace,
            ...chunk
        ]);
    }
    async _putCheckpoint(inputMetadata) {
        // Assign step
        const metadata = {
            ...inputMetadata,
            step: this.step,
            parents: this.config.configurable?.[0, _constantsJs.CONFIG_KEY_CHECKPOINT_MAP] ?? {}
        };
        // Bail if no checkpointer
        if (this.checkpointer !== undefined) {
            // store the previous checkpoint config for debug events
            this.prevCheckpointConfig = this.checkpointConfig?.configurable?.checkpoint_id ? this.checkpointConfig : undefined;
            // create new checkpoint
            this.checkpointMetadata = metadata;
            // child graphs keep at most one checkpoint per parent checkpoint
            // this is achieved by writing child checkpoints as progress is made
            // (so that error recovery / resuming from interrupt don't lose work)
            // but doing so always with an id equal to that of the parent checkpoint
            this.checkpoint = (0, _baseJs.createCheckpoint)(this.checkpoint, this.channels, this.step);
            this.checkpointConfig = {
                ...this.checkpointConfig,
                configurable: {
                    ...this.checkpointConfig.configurable,
                    checkpoint_ns: this.config.configurable?.checkpoint_ns ?? ""
                }
            };
            const channelVersions = {
                ...this.checkpoint.channel_versions
            };
            const newVersions = (0, _indexJs.getNewChannelVersions)(this.checkpointPreviousVersions, channelVersions);
            this.checkpointPreviousVersions = channelVersions;
            // save it, without blocking
            // if there's a previous checkpoint save in progress, wait for it
            // ensuring checkpointers receive checkpoints in order
            this._checkpointerPutAfterPrevious({
                config: {
                    ...this.checkpointConfig
                },
                checkpoint: (0, _langgraphCheckpoint.copyCheckpoint)(this.checkpoint),
                metadata: {
                    ...this.checkpointMetadata
                },
                newVersions
            });
            this.checkpointConfig = {
                ...this.checkpointConfig,
                configurable: {
                    ...this.checkpointConfig.configurable,
                    checkpoint_id: this.checkpoint.id
                }
            };
        }
        this.step += 1;
    }
}

},{"@langchain/core/utils/stream":"2QSx4","@langchain/langgraph-checkpoint":"jLOBB","../channels/base.js":"UYQzM","../constants.js":"1BFWS","./algo.js":"gwyOk","../utils.js":"ge2lq","./io.js":"aHxh6","../errors.js":"jKiOM","./utils/index.js":"lja7d","./debug.js":"5Cx3A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2QSx4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _streamJs = require("../dist/utils/stream.js");
parcelHelpers.exportAll(_streamJs, exports);

},{"../dist/utils/stream.js":"kAAca","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iaE5K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_INITIAL_INTERVAL", ()=>DEFAULT_INITIAL_INTERVAL);
parcelHelpers.export(exports, "DEFAULT_BACKOFF_FACTOR", ()=>DEFAULT_BACKOFF_FACTOR);
parcelHelpers.export(exports, "DEFAULT_MAX_INTERVAL", ()=>DEFAULT_MAX_INTERVAL);
parcelHelpers.export(exports, "DEFAULT_MAX_RETRIES", ()=>DEFAULT_MAX_RETRIES);
parcelHelpers.export(exports, "executeTasksWithRetry", ()=>executeTasksWithRetry);
var _errorsJs = require("../errors.js");
const DEFAULT_INITIAL_INTERVAL = 500;
const DEFAULT_BACKOFF_FACTOR = 2;
const DEFAULT_MAX_INTERVAL = 128000;
const DEFAULT_MAX_RETRIES = 3;
const DEFAULT_STATUS_NO_RETRY = [
    400,
    401,
    402,
    403,
    404,
    405,
    406,
    407,
    409
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DEFAULT_RETRY_ON_HANDLER = (error)=>{
    if (error.message.startsWith("Cancel") || error.message.startsWith("AbortError") || error.name === "AbortError") return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (error?.code === "ECONNABORTED") return false;
    const status = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?.response?.status ?? error?.status;
    if (status && DEFAULT_STATUS_NO_RETRY.includes(+status)) return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (error?.error?.code === "insufficient_quota") return false;
    return true;
};
async function* executeTasksWithRetry(// eslint-disable-next-line @typescript-eslint/no-explicit-any
tasks, options) {
    const { stepTimeout, retryPolicy } = options ?? {};
    let signal = options?.signal;
    // Start tasks
    const executingTasksMap = Object.fromEntries(tasks.map((pregelTask)=>{
        return [
            pregelTask.id,
            _runWithRetry(pregelTask, retryPolicy)
        ];
    }));
    if (stepTimeout && signal) {
        if ("any" in AbortSignal) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        signal = AbortSignal.any([
            signal,
            AbortSignal.timeout(stepTimeout)
        ]);
    } else if (stepTimeout) signal = AbortSignal.timeout(stepTimeout);
    // Abort if signal is aborted
    signal?.throwIfAborted();
    let listener;
    const signalPromise = new Promise((_resolve, reject)=>{
        listener = ()=>reject(new Error("Abort"));
        signal?.addEventListener("abort", listener);
    }).finally(()=>signal?.removeEventListener("abort", listener));
    while(Object.keys(executingTasksMap).length > 0){
        const settledTask = await Promise.race([
            ...Object.values(executingTasksMap),
            signalPromise
        ]);
        yield settledTask;
        delete executingTasksMap[settledTask.task.id];
    }
}
async function _runWithRetry(// eslint-disable-next-line @typescript-eslint/no-explicit-any
pregelTask, retryPolicy) {
    const resolvedRetryPolicy = pregelTask.retry_policy ?? retryPolicy;
    let interval = resolvedRetryPolicy !== undefined ? resolvedRetryPolicy.initialInterval ?? DEFAULT_INITIAL_INTERVAL : 0;
    let attempts = 0;
    let error;
    let result;
    // eslint-disable-next-line no-constant-condition
    while(true){
        // Modify writes in place to clear any previous retries
        while(pregelTask.writes.length > 0)pregelTask.writes.pop();
        error = undefined;
        try {
            result = await pregelTask.proc.invoke(pregelTask.input, pregelTask.config);
            break;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            error = e;
            error.pregelTaskId = pregelTask.id;
            if ((0, _errorsJs.isGraphInterrupt)(error)) break;
            if (resolvedRetryPolicy === undefined) break;
            attempts += 1;
            // check if we should give up
            if (attempts >= (resolvedRetryPolicy.maxAttempts ?? DEFAULT_MAX_RETRIES)) break;
            const retryOn = resolvedRetryPolicy.retryOn ?? DEFAULT_RETRY_ON_HANDLER;
            if (!retryOn(error)) break;
            interval = Math.min(resolvedRetryPolicy.maxInterval ?? DEFAULT_MAX_INTERVAL, interval * (resolvedRetryPolicy.backoffFactor ?? DEFAULT_BACKOFF_FACTOR));
            const intervalWithJitter = resolvedRetryPolicy.jitter ? Math.floor(interval + Math.random() * 1000) : interval;
            // sleep before retrying
            // eslint-disable-next-line no-promise-executor-return
            await new Promise((resolve)=>setTimeout(resolve, intervalWithJitter));
            // log the retry
            const errorName = error.name ?? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.constructor.unminifiable_name ?? error.constructor.name;
            console.log(`Retrying task "${pregelTask.name}" after ${interval.toFixed(2)}ms (attempt ${attempts}) after ${errorName}: ${error}`);
        } finally{
            // Clear checkpoint_ns seen (for subgraph detection)
            const checkpointNs = pregelTask.config?.configurable?.checkpoint_ns;
            if (checkpointNs) (0, _errorsJs.getSubgraphsSeenSet)().delete(checkpointNs);
        }
    }
    return {
        task: pregelTask,
        result,
        error
    };
}

},{"../errors.js":"jKiOM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lyblJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A callback handler that implements stream_mode=messages.
 * Collects messages from (1) chat model stream events and (2) node outputs.
 */ parcelHelpers.export(exports, "StreamMessagesHandler", ()=>StreamMessagesHandler);
var _uuid = require("uuid");
var _base = require("@langchain/core/callbacks/base");
var _messages = require("@langchain/core/messages");
var _constantsJs = require("../constants.js");
function isChatGenerationChunk(x) {
    return (0, _messages.isBaseMessage)(x?.message);
}
class StreamMessagesHandler extends (0, _base.BaseCallbackHandler) {
    constructor(streamFn){
        super();
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "StreamMessagesHandler"
        });
        Object.defineProperty(this, "streamFn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metadatas", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "seen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "emittedChatModelRunIds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        this.streamFn = streamFn;
    }
    _emit(meta, message, dedupe = false) {
        if (dedupe && message.id !== undefined && this.seen[message.id] !== undefined) return;
        if (message.id === undefined) {
            const id = (0, _uuid.v4)();
            // eslint-disable-next-line no-param-reassign
            message.id = id;
            // eslint-disable-next-line no-param-reassign
            message.lc_kwargs.id = id;
        }
        this.seen[message.id] = message;
        this.streamFn([
            meta[0],
            "messages",
            [
                message,
                meta[1]
            ]
        ]);
    }
    handleChatModelStart(_llm, _messages, runId, _parentRunId, _extraParams, tags, metadata, name) {
        if (metadata && // Include legacy LangGraph SDK tag
        (!tags || !(tags.includes((0, _constantsJs.TAG_NOSTREAM)) && tags.includes("nostream")))) this.metadatas[runId] = [
            metadata.langgraph_checkpoint_ns.split("NS_SEP"),
            {
                tags,
                name,
                ...metadata
            }
        ];
    }
    handleLLMNewToken(token, _idx, runId, _parentRunId, _tags, fields) {
        const chunk = fields?.chunk;
        this.emittedChatModelRunIds[runId] = true;
        if (isChatGenerationChunk(chunk) && this.metadatas[runId] !== undefined) this._emit(this.metadatas[runId], chunk.message);
        else this._emit(this.metadatas[runId], new (0, _messages.AIMessageChunk)({
            content: token
        }));
    }
    handleLLMEnd(output, runId) {
        // In JS, non-streaming runs do not call handleLLMNewToken at the model level
        if (!this.emittedChatModelRunIds[runId]) {
            const chatGeneration = output.generations?.[0]?.[0];
            if ((0, _messages.isBaseMessage)(chatGeneration?.message)) this._emit(this.metadatas[runId], chatGeneration?.message, true);
            delete this.emittedChatModelRunIds[runId];
        }
        delete this.metadatas[runId];
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleLLMError(_err, runId) {
        delete this.metadatas[runId];
    }
    handleChainStart(_chain, _inputs, runId, _parentRunId, tags, metadata, _runType, name) {
        if (metadata !== undefined && name === metadata.langgraph_node && (tags === undefined || !tags.includes((0, _constantsJs.TAG_HIDDEN)))) this.metadatas[runId] = [
            metadata.langgraph_checkpoint_ns.split("NS_SEP"),
            {
                tags,
                name,
                ...metadata
            }
        ];
    }
    handleChainEnd(outputs, runId) {
        const metadata = this.metadatas[runId];
        delete this.metadatas[runId];
        if (metadata !== undefined) {
            if ((0, _messages.isBaseMessage)(outputs)) this._emit(metadata, outputs, true);
            else if (Array.isArray(outputs)) {
                for (const value of outputs)if ((0, _messages.isBaseMessage)(value)) this._emit(metadata, value, true);
            } else if (outputs != null && typeof outputs === "object") for (const value of Object.values(outputs)){
                if ((0, _messages.isBaseMessage)(value)) this._emit(metadata, value, true);
                else if (Array.isArray(value)) {
                    for (const item of value)if ((0, _messages.isBaseMessage)(item)) this._emit(metadata, item, true);
                }
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleChainError(_err, runId) {
        delete this.metadatas[runId];
    }
}

},{"uuid":"klst7","@langchain/core/callbacks/base":"i3zl6","@langchain/core/messages":"ffAZz","../constants.js":"1BFWS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i3zl6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseJs = require("../dist/callbacks/base.js");
parcelHelpers.exportAll(_baseJs, exports);

},{"../dist/callbacks/base.js":"kirBb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ffAZz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./dist/messages/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"./dist/messages/index.js":"7XzBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8sLj2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Stores the value received in the step immediately preceding, clears after.
 * @internal
 */ parcelHelpers.export(exports, "EphemeralValue", ()=>EphemeralValue);
var _errorsJs = require("../errors.js");
var _indexJs = require("./index.js");
class EphemeralValue extends (0, _indexJs.BaseChannel) {
    constructor(guard = true){
        super();
        Object.defineProperty(this, "lc_graph_name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EphemeralValue"
        });
        Object.defineProperty(this, "guard", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.guard = guard;
    }
    fromCheckpoint(checkpoint) {
        const empty = new EphemeralValue(this.guard);
        if (checkpoint) empty.value = checkpoint;
        return empty;
    }
    update(values) {
        if (values.length === 0) {
            const updated = this.value !== undefined;
            // If there are no updates for this specific channel at the end of the step, wipe it.
            this.value = undefined;
            return updated;
        }
        if (values.length !== 1 && this.guard) throw new (0, _errorsJs.InvalidUpdateError)("EphemeralValue can only receive one value per step.");
        // eslint-disable-next-line prefer-destructuring
        this.value = values[values.length - 1];
        return true;
    }
    get() {
        if (this.value === undefined) throw new (0, _errorsJs.EmptyChannelError)();
        return this.value;
    }
    checkpoint() {
        if (this.value === undefined) throw new (0, _errorsJs.EmptyChannelError)();
        return this.value;
    }
}

},{"../errors.js":"jKiOM","./index.js":"eNDfC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eNDfC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseChannel", ()=>(0, _baseJs.BaseChannel));
parcelHelpers.export(exports, "createCheckpoint", ()=>(0, _baseJs.createCheckpoint));
parcelHelpers.export(exports, "empty", ()=>(0, _baseJs.emptyChannels));
parcelHelpers.export(exports, "BinaryOperatorAggregate", ()=>(0, _binopJs.BinaryOperatorAggregate));
var _baseJs = require("./base.js");
var _binopJs = require("./binop.js");

},{"./base.js":"UYQzM","./binop.js":"bYoJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l4IZ7":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-use-before-define */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A graph whose nodes communicate by reading and writing to a shared state.
 * Each node takes a defined `State` as input and returns a `Partial<State>`.
 *
 * Each state key can optionally be annotated with a reducer function that
 * will be used to aggregate the values of that key received from multiple nodes.
 * The signature of a reducer function is (left: Value, right: UpdateValue) => Value.
 *
 * See {@link Annotation} for more on defining state.
 *
 * After adding nodes and edges to your graph, you must call `.compile()` on it before
 * you can use it.
 *
 * @example
 * ```ts
 * import {
 *   type BaseMessage,
 *   AIMessage,
 *   HumanMessage,
 * } from "@langchain/core/messages";
 * import { StateGraph, Annotation } from "@langchain/langgraph";
 *
 * // Define a state with a single key named "messages" that will
 * // combine a returned BaseMessage or arrays of BaseMessages
 * const StateAnnotation = Annotation.Root({
 *   sentiment: Annotation<string>,
 *   messages: Annotation<BaseMessage[]>({
 *     reducer: (left: BaseMessage[], right: BaseMessage | BaseMessage[]) => {
 *       if (Array.isArray(right)) {
 *         return left.concat(right);
 *       }
 *       return left.concat([right]);
 *     },
 *     default: () => [],
 *   }),
 * });
 *
 * const graphBuilder = new StateGraph(StateAnnotation);
 *
 * // A node in the graph that returns an object with a "messages" key
 * // will update the state by combining the existing value with the returned one.
 * const myNode = (state: typeof StateAnnotation.State) => {
 *   return {
 *     messages: [new AIMessage("Some new response")],
 *     sentiment: "positive",
 *   };
 * };
 *
 * const graph = graphBuilder
 *   .addNode("myNode", myNode)
 *   .addEdge("__start__", "myNode")
 *   .addEdge("myNode", "__end__")
 *   .compile();
 *
 * await graph.invoke({ messages: [new HumanMessage("how are you?")] });
 *
 * // {
 * //   messages: [HumanMessage("how are you?"), AIMessage("Some new response")],
 * //   sentiment: "positive",
 * // }
 * ```
 */ parcelHelpers.export(exports, "StateGraph", ()=>StateGraph);
/**
 * Final result from building and compiling a {@link StateGraph}.
 * Should not be instantiated directly, only using the StateGraph `.compile()`
 * instance method.
 */ parcelHelpers.export(exports, "CompiledStateGraph", ()=>CompiledStateGraph);
var _runnables = require("@langchain/core/runnables");
var _baseJs = require("../channels/base.js");
var _graphJs = require("./graph.js");
var _writeJs = require("../pregel/write.js");
var _readJs = require("../pregel/read.js");
var _namedBarrierValueJs = require("../channels/named_barrier_value.js");
var _ephemeralValueJs = require("../channels/ephemeral_value.js");
var _utilsJs = require("../utils.js");
var _constantsJs = require("../constants.js");
var _errorsJs = require("../errors.js");
var _annotationJs = require("./annotation.js");
var _baseJs1 = require("../managed/base.js");
var _subgraphJs = require("../pregel/utils/subgraph.js");
const ROOT = "__root__";
class StateGraph extends (0, _graphJs.Graph) {
    constructor(fields, configSchema){
        super();
        Object.defineProperty(this, "channels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        // TODO: this doesn't dedupe edges as in py, so worth fixing at some point
        Object.defineProperty(this, "waitingEdges", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Set()
        });
        /** @internal */ Object.defineProperty(this, "_schemaDefinition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** @internal */ Object.defineProperty(this, "_inputDefinition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** @internal */ Object.defineProperty(this, "_outputDefinition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Map schemas to managed values
         * @internal
         */ Object.defineProperty(this, "_schemaDefinitions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        /** @internal Used only for typing. */ Object.defineProperty(this, "_configSchema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (isStateGraphArgsWithInputOutputSchemas(fields)) {
            this._schemaDefinition = fields.input.spec;
            this._inputDefinition = fields.input.spec;
            this._outputDefinition = fields.output.spec;
        } else if (isStateGraphArgsWithStateSchema(fields)) {
            this._schemaDefinition = fields.stateSchema.spec;
            this._inputDefinition = fields.input?.spec ?? this._schemaDefinition;
            this._outputDefinition = fields.output?.spec ?? this._schemaDefinition;
        } else if (isStateDefinition(fields) || isAnnotationRoot(fields)) {
            const spec = isAnnotationRoot(fields) ? fields.spec : fields;
            this._schemaDefinition = spec;
        } else if (isStateGraphArgs(fields)) {
            const spec = _getChannels(fields.channels);
            this._schemaDefinition = spec;
        } else throw new Error("Invalid StateGraph input.");
        this._inputDefinition = this._inputDefinition ?? this._schemaDefinition;
        this._outputDefinition = this._outputDefinition ?? this._schemaDefinition;
        this._addSchema(this._schemaDefinition);
        this._addSchema(this._inputDefinition);
        this._addSchema(this._outputDefinition);
        this._configSchema = configSchema?.spec;
    }
    get allEdges() {
        return new Set([
            ...this.edges,
            ...Array.from(this.waitingEdges).flatMap(([starts, end])=>starts.map((start)=>[
                        start,
                        end
                    ]))
        ]);
    }
    _addSchema(stateDefinition) {
        if (this._schemaDefinitions.has(stateDefinition)) return;
        // TODO: Support managed values
        this._schemaDefinitions.set(stateDefinition, stateDefinition);
        for (const [key, val] of Object.entries(stateDefinition)){
            let channel;
            if (typeof val === "function") channel = val();
            else channel = val;
            if (this.channels[key] !== undefined) {
                if (this.channels[key] !== channel) {
                    if (!(0, _baseJs1.isConfiguredManagedValue)(channel) && channel.lc_graph_name !== "LastValue") throw new Error(`Channel "${key}" already exists with a different type.`);
                }
            } else this.channels[key] = channel;
        }
    }
    addNode(key, action, options) {
        if (key in this.channels) throw new Error(`${key} is already being used as a state attribute (a.k.a. a channel), cannot also be used as a node name.`);
        for (const reservedChar of [
            (0, _constantsJs.CHECKPOINT_NAMESPACE_SEPARATOR),
            (0, _constantsJs.CHECKPOINT_NAMESPACE_END)
        ]){
            if (key.includes(reservedChar)) throw new Error(`"${reservedChar}" is a reserved character and is not allowed in node names.`);
        }
        this.warnIfCompiled(`Adding a node to a graph that has already been compiled. This will not be reflected in the compiled graph.`);
        if (key in this.nodes) throw new Error(`Node \`${key}\` already present.`);
        if (key === (0, _graphJs.END) || key === (0, _graphJs.START)) throw new Error(`Node \`${key}\` is reserved.`);
        if (options?.input !== undefined) this._addSchema(options.input.spec);
        let runnable;
        if ((0, _runnables.Runnable).isRunnable(action)) runnable = action;
        else if (typeof action === "function") runnable = new (0, _utilsJs.RunnableCallable)({
            func: action,
            name: key,
            trace: false
        });
        else runnable = (0, _runnables._coerceToRunnable)(action);
        const nodeSpec = {
            runnable: runnable,
            retryPolicy: options?.retryPolicy,
            metadata: options?.metadata,
            input: options?.input?.spec ?? this._schemaDefinition,
            subgraphs: (0, _subgraphJs.isPregelLike)(runnable) ? [
                runnable
            ] : options?.subgraphs
        };
        this.nodes[key] = nodeSpec;
        return this;
    }
    addEdge(startKey, endKey) {
        if (typeof startKey === "string") return super.addEdge(startKey, endKey);
        if (this.compiled) console.warn("Adding an edge to a graph that has already been compiled. This will not be reflected in the compiled graph.");
        for (const start of startKey){
            if (start === (0, _graphJs.END)) throw new Error("END cannot be a start node");
            if (!Object.keys(this.nodes).some((node)=>node === start)) throw new Error(`Need to add a node named "${start}" first`);
        }
        if (endKey === (0, _graphJs.END)) throw new Error("END cannot be an end node");
        if (!Object.keys(this.nodes).some((node)=>node === endKey)) throw new Error(`Need to add a node named "${endKey}" first`);
        this.waitingEdges.add([
            startKey,
            endKey
        ]);
        return this;
    }
    compile({ checkpointer, store, interruptBefore, interruptAfter } = {}) {
        // validate the graph
        this.validate([
            ...Array.isArray(interruptBefore) ? interruptBefore : [],
            ...Array.isArray(interruptAfter) ? interruptAfter : []
        ]);
        // prepare output channels
        const outputKeys = Object.keys(this._schemaDefinitions.get(this._outputDefinition));
        const outputChannels = outputKeys.length === 1 && outputKeys[0] === ROOT ? ROOT : outputKeys;
        const streamKeys = Object.keys(this.channels);
        const streamChannels = streamKeys.length === 1 && streamKeys[0] === ROOT ? ROOT : streamKeys;
        // create empty compiled graph
        const compiled = new CompiledStateGraph({
            builder: this,
            checkpointer,
            interruptAfter,
            interruptBefore,
            autoValidate: false,
            nodes: {},
            channels: {
                ...this.channels,
                [(0, _graphJs.START)]: new (0, _ephemeralValueJs.EphemeralValue)()
            },
            inputChannels: (0, _graphJs.START),
            outputChannels,
            streamChannels,
            streamMode: "updates",
            store
        });
        // attach nodes, edges and branches
        compiled.attachNode((0, _graphJs.START));
        for (const [key, node] of Object.entries(this.nodes))compiled.attachNode(key, node);
        for (const [start, end] of this.edges)compiled.attachEdge(start, end);
        for (const [starts, end] of this.waitingEdges)compiled.attachEdge(starts, end);
        for (const [start, branches] of Object.entries(this.branches))for (const [name, branch] of Object.entries(branches))compiled.attachBranch(start, name, branch);
        return compiled.validate();
    }
}
function _getChannels(schema) {
    const channels = {};
    for (const [name, val] of Object.entries(schema))if (name === ROOT) channels[name] = (0, _annotationJs.getChannel)(val);
    else {
        const key = name;
        channels[name] = (0, _annotationJs.getChannel)(val);
    }
    return channels;
}
class CompiledStateGraph extends (0, _graphJs.CompiledGraph) {
    attachNode(key, node) {
        const stateKeys = Object.keys(this.builder.channels);
        function getStateKey(key, input) {
            if (!input) return 0, _writeJs.SKIP_WRITE;
            else if (typeof input !== "object" || Array.isArray(input)) {
                const typeofInput = Array.isArray(input) ? "array" : typeof input;
                throw new (0, _errorsJs.InvalidUpdateError)(`Expected node "${key.toString()}" to return an object, received ${typeofInput}`, {
                    lc_error_code: "INVALID_GRAPH_NODE_RETURN_VALUE"
                });
            } else return key in input ? input[key] : (0, _writeJs.SKIP_WRITE);
        }
        // state updaters
        const stateWriteEntries = stateKeys.map((key)=>key === ROOT ? {
                channel: key,
                value: (0, _writeJs.PASSTHROUGH),
                skipNone: true
            } : {
                channel: key,
                value: (0, _writeJs.PASSTHROUGH),
                mapper: new (0, _utilsJs.RunnableCallable)({
                    func: getStateKey.bind(null, key),
                    trace: false,
                    recurse: false
                })
            });
        // add node and output channel
        if (key === (0, _graphJs.START)) this.nodes[key] = new (0, _readJs.PregelNode)({
            tags: [
                (0, _constantsJs.TAG_HIDDEN)
            ],
            triggers: [
                (0, _graphJs.START)
            ],
            channels: [
                (0, _graphJs.START)
            ],
            writers: [
                new (0, _writeJs.ChannelWrite)(stateWriteEntries, [
                    (0, _constantsJs.TAG_HIDDEN)
                ])
            ]
        });
        else {
            const inputDefinition = node?.input ?? this.builder._schemaDefinition;
            const inputValues = Object.fromEntries(Object.keys(this.builder._schemaDefinitions.get(inputDefinition)).map((k)=>[
                    k,
                    k
                ]));
            const isSingleInput = Object.keys(inputValues).length === 1 && ROOT in inputValues;
            this.channels[key] = new (0, _ephemeralValueJs.EphemeralValue)(false);
            this.nodes[key] = new (0, _readJs.PregelNode)({
                triggers: [],
                // read state keys
                channels: isSingleInput ? Object.keys(inputValues) : inputValues,
                // publish to this channel and state keys
                writers: [
                    new (0, _writeJs.ChannelWrite)(stateWriteEntries.concat({
                        channel: key,
                        value: key
                    }), [
                        (0, _constantsJs.TAG_HIDDEN)
                    ])
                ],
                mapper: isSingleInput ? undefined : (input)=>{
                    return Object.fromEntries(Object.entries(input).filter(([k])=>k in inputValues));
                },
                bound: node?.runnable,
                metadata: node?.metadata,
                retryPolicy: node?.retryPolicy,
                subgraphs: node?.subgraphs
            });
        }
    }
    attachEdge(start, end) {
        if (end === (0, _graphJs.END)) return;
        if (Array.isArray(start)) {
            const channelName = `join:${start.join("+")}:${end}`;
            // register channel
            this.channels[channelName] = new (0, _namedBarrierValueJs.NamedBarrierValue)(new Set(start));
            // subscribe to channel
            this.nodes[end].triggers.push(channelName);
            // publish to channel
            for (const s of start)this.nodes[s].writers.push(new (0, _writeJs.ChannelWrite)([
                {
                    channel: channelName,
                    value: s
                }
            ], [
                (0, _constantsJs.TAG_HIDDEN)
            ]));
        } else if (start === (0, _graphJs.START)) {
            const channelName = `${(0, _graphJs.START)}:${end}`;
            // register channel
            this.channels[channelName] = new (0, _ephemeralValueJs.EphemeralValue)();
            // subscribe to channel
            this.nodes[end].triggers.push(channelName);
            // publish to channel
            this.nodes[0, _graphJs.START].writers.push(new (0, _writeJs.ChannelWrite)([
                {
                    channel: channelName,
                    value: (0, _graphJs.START)
                }
            ], [
                (0, _constantsJs.TAG_HIDDEN)
            ]));
        } else this.nodes[end].triggers.push(start);
    }
    attachBranch(start, name, branch) {
        // attach branch publisher
        this.nodes[start].writers.push(branch.compile(// writer
        (dests)=>{
            const filteredDests = dests.filter((dest)=>dest !== (0, _graphJs.END));
            if (!filteredDests.length) return;
            const writes = filteredDests.map((dest)=>{
                if ((0, _constantsJs._isSend)(dest)) return dest;
                return {
                    channel: `branch:${start}:${name}:${dest}`,
                    value: start
                };
            });
            return new (0, _writeJs.ChannelWrite)(writes, [
                (0, _constantsJs.TAG_HIDDEN)
            ]);
        }, // reader
        (config)=>(0, _readJs.ChannelRead).doRead(config, this.streamChannels ?? this.outputChannels, true)));
        // attach branch subscribers
        const ends = branch.ends ? Object.values(branch.ends) : Object.keys(this.builder.nodes);
        for (const end of ends){
            if (end === (0, _graphJs.END)) continue;
            const channelName = `branch:${start}:${name}:${end}`;
            this.channels[channelName] = new (0, _ephemeralValueJs.EphemeralValue)(false);
            this.nodes[end].triggers.push(channelName);
        }
    }
}
function isStateDefinition(obj) {
    return typeof obj === "object" && obj !== null && !Array.isArray(obj) && Object.keys(obj).length > 0 && Object.values(obj).every((v)=>typeof v === "function" || (0, _baseJs.isBaseChannel)(v));
}
function isAnnotationRoot(obj) {
    return typeof obj === "object" && obj !== null && "lc_graph_name" in obj && obj.lc_graph_name === "AnnotationRoot";
}
function isStateGraphArgs(obj) {
    return typeof obj === "object" && obj !== null && obj.channels !== undefined;
}
function isStateGraphArgsWithStateSchema(obj) {
    return typeof obj === "object" && obj !== null && obj.stateSchema !== undefined;
}
function isStateGraphArgsWithInputOutputSchemas(obj) {
    return typeof obj === "object" && obj !== null && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    obj.stateSchema === undefined && obj.input !== undefined && obj.output !== undefined;
}

},{"@langchain/core/runnables":"5B2I4","../channels/base.js":"UYQzM","./graph.js":"20bEW","../pregel/write.js":"hERuA","../pregel/read.js":"b7GRw","../channels/named_barrier_value.js":"4b35n","../channels/ephemeral_value.js":"8sLj2","../utils.js":"ge2lq","../constants.js":"1BFWS","../errors.js":"jKiOM","./annotation.js":"kRFZA","../managed/base.js":"4p0hG","../pregel/utils/subgraph.js":"b00W2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4b35n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areSetsEqual", ()=>areSetsEqual);
/**
 * A channel that waits until all named values are received before making the value available.
 *
 * This ensures that if node N and node M both write to channel C, the value of C will not be updated
 * until N and M have completed updating.
 * @internal
 */ parcelHelpers.export(exports, "NamedBarrierValue", ()=>NamedBarrierValue);
var _errorsJs = require("../errors.js");
var _baseJs = require("./base.js");
const areSetsEqual = (a, b)=>a.size === b.size && [
        ...a
    ].every((value)=>b.has(value));
class NamedBarrierValue extends (0, _baseJs.BaseChannel) {
    constructor(names){
        super();
        Object.defineProperty(this, "lc_graph_name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NamedBarrierValue"
        });
        Object.defineProperty(this, "names", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // Names of nodes that we want to wait for.
        Object.defineProperty(this, "seen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.names = names;
        this.seen = new Set();
    }
    fromCheckpoint(checkpoint) {
        const empty = new NamedBarrierValue(this.names);
        if (checkpoint) empty.seen = new Set(checkpoint);
        return empty;
    }
    update(values) {
        let updated = false;
        for (const nodeName of values){
            if (this.names.has(nodeName)) {
                if (!this.seen.has(nodeName)) {
                    this.seen.add(nodeName);
                    updated = true;
                }
            } else throw new (0, _errorsJs.InvalidUpdateError)(`Value ${JSON.stringify(nodeName)} not in names ${JSON.stringify(this.names)}`);
        }
        return updated;
    }
    // If we have not yet seen all the node names we want to wait for,
    // throw an error to prevent continuing.
    get() {
        if (!areSetsEqual(this.names, this.seen)) throw new (0, _errorsJs.EmptyChannelError)();
        return undefined;
    }
    checkpoint() {
        return [
            ...this.seen
        ];
    }
    consume() {
        if (this.seen && this.names && areSetsEqual(this.seen, this.names)) {
            this.seen = new Set();
            return true;
        }
        return false;
    }
}

},{"../errors.js":"jKiOM","./base.js":"UYQzM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3KDDa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Prebuilt reducer that combines returned messages.
 * Can handle standard messages and special modifiers like {@link RemoveMessage}
 * instances.
 */ parcelHelpers.export(exports, "messagesStateReducer", ()=>messagesStateReducer);
/** @ignore */ parcelHelpers.export(exports, "MessageGraph", ()=>MessageGraph);
var _messages = require("@langchain/core/messages");
var _uuid = require("uuid");
var _stateJs = require("./state.js");
function messagesStateReducer(left, right) {
    const leftArray = Array.isArray(left) ? left : [
        left
    ];
    const rightArray = Array.isArray(right) ? right : [
        right
    ];
    // coerce to message
    const leftMessages = leftArray.map((0, _messages.coerceMessageLikeToMessage));
    const rightMessages = rightArray.map((0, _messages.coerceMessageLikeToMessage));
    // assign missing ids
    for (const m of leftMessages)if (m.id === null || m.id === undefined) {
        m.id = (0, _uuid.v4)();
        m.lc_kwargs.id = m.id;
    }
    for (const m of rightMessages)if (m.id === null || m.id === undefined) {
        m.id = (0, _uuid.v4)();
        m.lc_kwargs.id = m.id;
    }
    // merge
    const leftIdxById = new Map(leftMessages.map((m, i)=>[
            m.id,
            i
        ]));
    const merged = [
        ...leftMessages
    ];
    const idsToRemove = new Set();
    for (const m of rightMessages){
        const existingIdx = leftIdxById.get(m.id);
        if (existingIdx !== undefined) {
            if (m._getType() === "remove") idsToRemove.add(m.id);
            else merged[existingIdx] = m;
        } else {
            if (m._getType() === "remove") throw new Error(`Attempting to delete a message with an ID that doesn't exist ('${m.id}')`);
            merged.push(m);
        }
    }
    return merged.filter((m)=>!idsToRemove.has(m.id));
}
class MessageGraph extends (0, _stateJs.StateGraph) {
    constructor(){
        super({
            channels: {
                __root__: {
                    reducer: messagesStateReducer,
                    default: ()=>[]
                }
            }
        });
    }
}

},{"@langchain/core/messages":"ffAZz","uuid":"klst7","./state.js":"l4IZ7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1WGxa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseJs = require("./base.js");
parcelHelpers.exportAll(_baseJs, exports);
var _isLastStepJs = require("./is_last_step.js");
parcelHelpers.exportAll(_isLastStepJs, exports);
var _sharedValueJs = require("./shared_value.js");
parcelHelpers.exportAll(_sharedValueJs, exports);

},{"./base.js":"4p0hG","./is_last_step.js":"cN1pm","./shared_value.js":"4rbiI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cN1pm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsLastStepManager", ()=>IsLastStepManager);
var _constantsJs = require("../constants.js");
var _baseJs = require("./base.js");
class IsLastStepManager extends (0, _baseJs.ManagedValue) {
    call(step) {
        return step === (this.config.recursionLimit ?? (0, _constantsJs.RECURSION_LIMIT_DEFAULT)) - 1;
    }
}

},{"../constants.js":"1BFWS","./base.js":"4p0hG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4rbiI":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-explicit-any */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SharedValue", ()=>SharedValue);
var _baseJs = require("./base.js");
var _errorsJs = require("../errors.js");
class SharedValue extends (0, _baseJs.WritableManagedValue) {
    constructor(config, params){
        super(config, params);
        Object.defineProperty(this, "scope", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ns", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        this.scope = params.scope;
        this.store = config.store || null;
        if (!this.store) this.ns = null;
        else if (config.configurable?.[this.scope]) {
            const scopeValue = config.configurable[this.scope];
            const scopedValueString = typeof scopeValue === "string" ? scopeValue : JSON.stringify(scopeValue);
            this.ns = [
                "scoped",
                this.scope,
                params.key,
                scopedValueString
            ];
        } else throw new Error(`Required scope "${this.scope}" for shared state key was not passed in "config.configurable".`);
    }
    static async initialize(config, args) {
        const instance = new this(config, args);
        await instance.loadStore();
        return instance;
    }
    static on(scope) {
        return {
            cls: SharedValue,
            params: {
                scope,
                key: (0, _baseJs.ChannelKeyPlaceholder)
            }
        };
    }
    call(_step) {
        return {
            ...this.value
        };
    }
    processUpdate(values) {
        const writes = [];
        for (const vv of values)for (const [k, v] of Object.entries(vv)){
            if (v === null) {
                if (k in this.value) {
                    delete this.value[k];
                    if (this.ns) writes.push({
                        namespace: this.ns,
                        key: k,
                        value: null
                    });
                }
            } else if (typeof v !== "object" || v === null) throw new (0, _errorsJs.InvalidUpdateError)("Received a non-object value");
            else {
                this.value[k] = v;
                if (this.ns) writes.push({
                    namespace: this.ns,
                    key: k,
                    value: v
                });
            }
        }
        return writes;
    }
    async update(values) {
        if (!this.store) this.processUpdate(values);
        else await this.store.batch(this.processUpdate(values));
    }
    async loadStore() {
        if (this.store && this.ns) {
            const saved = await this.store.search(this.ns);
            this.value = saved.reduce((acc, item)=>{
                acc[item.key] = item.value;
                return acc;
            }, {});
        }
        return false;
    }
}

},{"./base.js":"4p0hG","../errors.js":"jKiOM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7F7Og":[function(require,module,exports,__globalThis) {
/* __LC_ALLOW_ENTRYPOINT_SIDE_EFFECTS__ */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MessagesAnnotation", ()=>MessagesAnnotation);
var _annotationJs = require("./annotation.js");
var _messageJs = require("./message.js");
const MessagesAnnotation = (0, _annotationJs.Annotation).Root({
    messages: (0, _annotationJs.Annotation)({
        reducer: (0, _messageJs.messagesStateReducer),
        default: ()=>[]
    })
});

},{"./annotation.js":"kRFZA","./message.js":"3KDDa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2qirM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./dist/prompts/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"./dist/prompts/index.js":"bdjua","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ilsHK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./dist/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"./dist/index.js":"o86R3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"o86R3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenAIClient", ()=>(0, _openai.OpenAI));
parcelHelpers.export(exports, "toFile", ()=>(0, _openai.toFile));
parcelHelpers.export(exports, "convertPromptToOpenAI", ()=>(0, _promptsJs.convertPromptToOpenAI));
var _openai = require("openai");
var _chatModelsJs = require("./chat_models.js");
parcelHelpers.exportAll(_chatModelsJs, exports);
var _chatModelsJs1 = require("./azure/chat_models.js");
parcelHelpers.exportAll(_chatModelsJs1, exports);
var _llmsJs = require("./llms.js");
parcelHelpers.exportAll(_llmsJs, exports);
var _llmsJs1 = require("./azure/llms.js");
parcelHelpers.exportAll(_llmsJs1, exports);
var _embeddingsJs = require("./azure/embeddings.js");
parcelHelpers.exportAll(_embeddingsJs, exports);
var _embeddingsJs1 = require("./embeddings.js");
parcelHelpers.exportAll(_embeddingsJs1, exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _openaiJs = require("./utils/openai.js");
parcelHelpers.exportAll(_openaiJs, exports);
var _azureJs = require("./utils/azure.js");
parcelHelpers.exportAll(_azureJs, exports);
var _indexJs = require("./tools/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var _promptsJs = require("./utils/prompts.js");

},{"openai":false,"./chat_models.js":"1Wv2V","./azure/chat_models.js":"cmPLb","./llms.js":"3PGFR","./azure/llms.js":"1GZwA","./azure/embeddings.js":"bR7PR","./embeddings.js":"fja9U","./types.js":"j0PfE","./utils/openai.js":"7jhsd","./utils/azure.js":"ASDZZ","./tools/index.js":"2pwYt","./utils/prompts.js":"jCUjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"xOLuj":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AzureOpenAI = exports.fileFromPath = exports.toFile = exports.UnprocessableEntityError = exports.PermissionDeniedError = exports.InternalServerError = exports.AuthenticationError = exports.BadRequestError = exports.RateLimitError = exports.ConflictError = exports.NotFoundError = exports.APIUserAbortError = exports.APIConnectionTimeoutError = exports.APIConnectionError = exports.APIError = exports.OpenAIError = exports.OpenAI = void 0;
const qs = __importStar(require("325e82cfa6c96e3c"));
const Core = __importStar(require("b2532de701e2d347"));
const Errors = __importStar(require("d9709efe1d5aeb55"));
const Pagination = __importStar(require("f0e27e36bcaf5db9"));
const Uploads = __importStar(require("766331169fa70c1d"));
const API = __importStar(require("8c4c71835b3db0c1"));
const batches_1 = require("b3c4339798368c1b");
const completions_1 = require("78c256d6ecaffc36");
const embeddings_1 = require("2035042f9308aca8");
const files_1 = require("92998fbf88c5ae97");
const images_1 = require("f8fdb8050ee8df4d");
const models_1 = require("5a687293bb5a1a90");
const moderations_1 = require("7d1311e6ec1de953");
const audio_1 = require("7fc0dbcfe4d671a2");
const beta_1 = require("803b09213e7de984");
const chat_1 = require("97ccbfa63f55a9d1");
const fine_tuning_1 = require("e2f9e502351de2c7");
const uploads_1 = require("4fe6d5dc83b0d6");
/**
 * API Client for interfacing with the OpenAI API.
 */ class OpenAI extends Core.APIClient {
    /**
     * API Client for interfacing with the OpenAI API.
     *
     * @param {string | undefined} [opts.apiKey=process.env['OPENAI_API_KEY'] ?? undefined]
     * @param {string | null | undefined} [opts.organization=process.env['OPENAI_ORG_ID'] ?? null]
     * @param {string | null | undefined} [opts.project=process.env['OPENAI_PROJECT_ID'] ?? null]
     * @param {string} [opts.baseURL=process.env['OPENAI_BASE_URL'] ?? https://api.openai.com/v1] - Override the default base URL for the API.
     * @param {number} [opts.timeout=10 minutes] - The maximum amount of time (in milliseconds) the client will wait for a response before timing out.
     * @param {number} [opts.httpAgent] - An HTTP agent used to manage HTTP(s) connections.
     * @param {Core.Fetch} [opts.fetch] - Specify a custom `fetch` function implementation.
     * @param {number} [opts.maxRetries=2] - The maximum number of times the client will retry a request.
     * @param {Core.Headers} opts.defaultHeaders - Default headers to include with every request to the API.
     * @param {Core.DefaultQuery} opts.defaultQuery - Default query parameters to include with every request to the API.
     * @param {boolean} [opts.dangerouslyAllowBrowser=false] - By default, client-side use of this library is not allowed, as it risks exposing your secret API credentials to attackers.
     */ constructor({ baseURL = Core.readEnv('OPENAI_BASE_URL'), apiKey = Core.readEnv('OPENAI_API_KEY'), organization = Core.readEnv('OPENAI_ORG_ID') ?? null, project = Core.readEnv('OPENAI_PROJECT_ID') ?? null, ...opts } = {}){
        if (apiKey === undefined) throw new Errors.OpenAIError("The OPENAI_API_KEY environment variable is missing or empty; either provide it, or instantiate the OpenAI client with an apiKey option, like new OpenAI({ apiKey: 'My API Key' }).");
        const options = {
            apiKey,
            organization,
            project,
            ...opts,
            baseURL: baseURL || `https://api.openai.com/v1`
        };
        if (!options.dangerouslyAllowBrowser && Core.isRunningInBrowser()) throw new Errors.OpenAIError("It looks like you're running in a browser-like environment.\n\nThis is disabled by default, as it risks exposing your secret API credentials to attackers.\nIf you understand the risks and have appropriate mitigations in place,\nyou can set the `dangerouslyAllowBrowser` option to `true`, e.g.,\n\nnew OpenAI({ apiKey, dangerouslyAllowBrowser: true });\n\nhttps://help.openai.com/en/articles/5112595-best-practices-for-api-key-safety\n");
        super({
            baseURL: options.baseURL,
            timeout: options.timeout ?? 600000 /* 10 minutes */ ,
            httpAgent: options.httpAgent,
            maxRetries: options.maxRetries,
            fetch: options.fetch
        });
        this.completions = new API.Completions(this);
        this.chat = new API.Chat(this);
        this.embeddings = new API.Embeddings(this);
        this.files = new API.Files(this);
        this.images = new API.Images(this);
        this.audio = new API.Audio(this);
        this.moderations = new API.Moderations(this);
        this.models = new API.Models(this);
        this.fineTuning = new API.FineTuning(this);
        this.beta = new API.Beta(this);
        this.batches = new API.Batches(this);
        this.uploads = new API.Uploads(this);
        this._options = options;
        this.apiKey = apiKey;
        this.organization = organization;
        this.project = project;
    }
    defaultQuery() {
        return this._options.defaultQuery;
    }
    defaultHeaders(opts) {
        return {
            ...super.defaultHeaders(opts),
            'OpenAI-Organization': this.organization,
            'OpenAI-Project': this.project,
            ...this._options.defaultHeaders
        };
    }
    authHeaders(opts) {
        return {
            Authorization: `Bearer ${this.apiKey}`
        };
    }
    stringifyQuery(query) {
        return qs.stringify(query, {
            arrayFormat: 'brackets'
        });
    }
}
exports.OpenAI = OpenAI;
_a = OpenAI;
OpenAI.OpenAI = _a;
OpenAI.DEFAULT_TIMEOUT = 600000; // 10 minutes
OpenAI.OpenAIError = Errors.OpenAIError;
OpenAI.APIError = Errors.APIError;
OpenAI.APIConnectionError = Errors.APIConnectionError;
OpenAI.APIConnectionTimeoutError = Errors.APIConnectionTimeoutError;
OpenAI.APIUserAbortError = Errors.APIUserAbortError;
OpenAI.NotFoundError = Errors.NotFoundError;
OpenAI.ConflictError = Errors.ConflictError;
OpenAI.RateLimitError = Errors.RateLimitError;
OpenAI.BadRequestError = Errors.BadRequestError;
OpenAI.AuthenticationError = Errors.AuthenticationError;
OpenAI.InternalServerError = Errors.InternalServerError;
OpenAI.PermissionDeniedError = Errors.PermissionDeniedError;
OpenAI.UnprocessableEntityError = Errors.UnprocessableEntityError;
OpenAI.toFile = Uploads.toFile;
OpenAI.fileFromPath = Uploads.fileFromPath;
var error_1 = require("d9709efe1d5aeb55");
Object.defineProperty(exports, "OpenAIError", {
    enumerable: true,
    get: function() {
        return error_1.OpenAIError;
    }
});
Object.defineProperty(exports, "APIError", {
    enumerable: true,
    get: function() {
        return error_1.APIError;
    }
});
Object.defineProperty(exports, "APIConnectionError", {
    enumerable: true,
    get: function() {
        return error_1.APIConnectionError;
    }
});
Object.defineProperty(exports, "APIConnectionTimeoutError", {
    enumerable: true,
    get: function() {
        return error_1.APIConnectionTimeoutError;
    }
});
Object.defineProperty(exports, "APIUserAbortError", {
    enumerable: true,
    get: function() {
        return error_1.APIUserAbortError;
    }
});
Object.defineProperty(exports, "NotFoundError", {
    enumerable: true,
    get: function() {
        return error_1.NotFoundError;
    }
});
Object.defineProperty(exports, "ConflictError", {
    enumerable: true,
    get: function() {
        return error_1.ConflictError;
    }
});
Object.defineProperty(exports, "RateLimitError", {
    enumerable: true,
    get: function() {
        return error_1.RateLimitError;
    }
});
Object.defineProperty(exports, "BadRequestError", {
    enumerable: true,
    get: function() {
        return error_1.BadRequestError;
    }
});
Object.defineProperty(exports, "AuthenticationError", {
    enumerable: true,
    get: function() {
        return error_1.AuthenticationError;
    }
});
Object.defineProperty(exports, "InternalServerError", {
    enumerable: true,
    get: function() {
        return error_1.InternalServerError;
    }
});
Object.defineProperty(exports, "PermissionDeniedError", {
    enumerable: true,
    get: function() {
        return error_1.PermissionDeniedError;
    }
});
Object.defineProperty(exports, "UnprocessableEntityError", {
    enumerable: true,
    get: function() {
        return error_1.UnprocessableEntityError;
    }
});
exports.toFile = Uploads.toFile;
exports.fileFromPath = Uploads.fileFromPath;
OpenAI.Completions = completions_1.Completions;
OpenAI.Chat = chat_1.Chat;
OpenAI.Embeddings = embeddings_1.Embeddings;
OpenAI.Files = files_1.Files;
OpenAI.FileObjectsPage = files_1.FileObjectsPage;
OpenAI.Images = images_1.Images;
OpenAI.Audio = audio_1.Audio;
OpenAI.Moderations = moderations_1.Moderations;
OpenAI.Models = models_1.Models;
OpenAI.ModelsPage = models_1.ModelsPage;
OpenAI.FineTuning = fine_tuning_1.FineTuning;
OpenAI.Beta = beta_1.Beta;
OpenAI.Batches = batches_1.Batches;
OpenAI.BatchesPage = batches_1.BatchesPage;
OpenAI.Uploads = uploads_1.Uploads;
/** API Client for interfacing with the Azure OpenAI API. */ class AzureOpenAI extends OpenAI {
    /**
     * API Client for interfacing with the Azure OpenAI API.
     *
     * @param {string | undefined} [opts.apiVersion=process.env['OPENAI_API_VERSION'] ?? undefined]
     * @param {string | undefined} [opts.endpoint=process.env['AZURE_OPENAI_ENDPOINT'] ?? undefined] - Your Azure endpoint, including the resource, e.g. `https://example-resource.azure.openai.com/`
     * @param {string | undefined} [opts.apiKey=process.env['AZURE_OPENAI_API_KEY'] ?? undefined]
     * @param {string | undefined} opts.deployment - A model deployment, if given, sets the base client URL to include `/deployments/{deployment}`.
     * @param {string | null | undefined} [opts.organization=process.env['OPENAI_ORG_ID'] ?? null]
     * @param {string} [opts.baseURL=process.env['OPENAI_BASE_URL']] - Sets the base URL for the API, e.g. `https://example-resource.azure.openai.com/openai/`.
     * @param {number} [opts.timeout=10 minutes] - The maximum amount of time (in milliseconds) the client will wait for a response before timing out.
     * @param {number} [opts.httpAgent] - An HTTP agent used to manage HTTP(s) connections.
     * @param {Core.Fetch} [opts.fetch] - Specify a custom `fetch` function implementation.
     * @param {number} [opts.maxRetries=2] - The maximum number of times the client will retry a request.
     * @param {Core.Headers} opts.defaultHeaders - Default headers to include with every request to the API.
     * @param {Core.DefaultQuery} opts.defaultQuery - Default query parameters to include with every request to the API.
     * @param {boolean} [opts.dangerouslyAllowBrowser=false] - By default, client-side use of this library is not allowed, as it risks exposing your secret API credentials to attackers.
     */ constructor({ baseURL = Core.readEnv('OPENAI_BASE_URL'), apiKey = Core.readEnv('AZURE_OPENAI_API_KEY'), apiVersion = Core.readEnv('OPENAI_API_VERSION'), endpoint, deployment, azureADTokenProvider, dangerouslyAllowBrowser, ...opts } = {}){
        if (!apiVersion) throw new Errors.OpenAIError("The OPENAI_API_VERSION environment variable is missing or empty; either provide it, or instantiate the AzureOpenAI client with an apiVersion option, like new AzureOpenAI({ apiVersion: 'My API Version' }).");
        if (typeof azureADTokenProvider === 'function') dangerouslyAllowBrowser = true;
        if (!azureADTokenProvider && !apiKey) throw new Errors.OpenAIError('Missing credentials. Please pass one of `apiKey` and `azureADTokenProvider`, or set the `AZURE_OPENAI_API_KEY` environment variable.');
        if (azureADTokenProvider && apiKey) throw new Errors.OpenAIError('The `apiKey` and `azureADTokenProvider` arguments are mutually exclusive; only one can be passed at a time.');
        // define a sentinel value to avoid any typing issues
        apiKey ?? (apiKey = API_KEY_SENTINEL);
        opts.defaultQuery = {
            ...opts.defaultQuery,
            'api-version': apiVersion
        };
        if (!baseURL) {
            if (!endpoint) endpoint = undefined;
            if (!endpoint) throw new Errors.OpenAIError('Must provide one of the `baseURL` or `endpoint` arguments, or the `AZURE_OPENAI_ENDPOINT` environment variable');
            baseURL = `${endpoint}/openai`;
        } else {
            if (endpoint) throw new Errors.OpenAIError('baseURL and endpoint are mutually exclusive');
        }
        super({
            apiKey,
            baseURL,
            ...opts,
            ...dangerouslyAllowBrowser !== undefined ? {
                dangerouslyAllowBrowser
            } : {}
        });
        this.apiVersion = '';
        this._azureADTokenProvider = azureADTokenProvider;
        this.apiVersion = apiVersion;
        this._deployment = deployment;
    }
    buildRequest(options) {
        if (_deployments_endpoints.has(options.path) && options.method === 'post' && options.body !== undefined) {
            if (!Core.isObj(options.body)) throw new Error('Expected request body to be an object');
            const model = this._deployment || options.body['model'];
            if (model !== undefined && !this.baseURL.includes('/deployments')) options.path = `/deployments/${model}${options.path}`;
        }
        return super.buildRequest(options);
    }
    async _getAzureADToken() {
        if (typeof this._azureADTokenProvider === 'function') {
            const token = await this._azureADTokenProvider();
            if (!token || typeof token !== 'string') throw new Errors.OpenAIError(`Expected 'azureADTokenProvider' argument to return a string but it returned ${token}`);
            return token;
        }
        return undefined;
    }
    authHeaders(opts) {
        return {};
    }
    async prepareOptions(opts) {
        /**
         * The user should provide a bearer token provider if they want
         * to use Azure AD authentication. The user shouldn't set the
         * Authorization header manually because the header is overwritten
         * with the Azure AD token if a bearer token provider is provided.
         */ if (opts.headers?.['api-key']) return super.prepareOptions(opts);
        const token = await this._getAzureADToken();
        opts.headers ?? (opts.headers = {});
        if (token) opts.headers['Authorization'] = `Bearer ${token}`;
        else if (this.apiKey !== API_KEY_SENTINEL) opts.headers['api-key'] = this.apiKey;
        else throw new Errors.OpenAIError('Unable to handle auth');
        return super.prepareOptions(opts);
    }
}
exports.AzureOpenAI = AzureOpenAI;
const _deployments_endpoints = new Set([
    '/completions',
    '/chat/completions',
    '/embeddings',
    '/audio/transcriptions',
    '/audio/translations',
    '/audio/speech',
    '/images/generations'
]);
const API_KEY_SENTINEL = '<Missing Key>';
// ---------------------- End Azure ----------------------
exports = module.exports = OpenAI;
module.exports.AzureOpenAI = AzureOpenAI;
exports.default = OpenAI;

},{"325e82cfa6c96e3c":"ZQ5iV","b2532de701e2d347":"SlwjS","d9709efe1d5aeb55":"eZWCP","f0e27e36bcaf5db9":"ksr30","766331169fa70c1d":"j0F04","8c4c71835b3db0c1":"erfMj","b3c4339798368c1b":"gK1jM","78c256d6ecaffc36":"eRjoN","2035042f9308aca8":"FW9ea","92998fbf88c5ae97":"1J1vk","f8fdb8050ee8df4d":"avguL","5a687293bb5a1a90":"4Wm3Z","7d1311e6ec1de953":"cAV1c","7fc0dbcfe4d671a2":"iKRuh","803b09213e7de984":"kSu5D","97ccbfa63f55a9d1":"4zH4G","e2f9e502351de2c7":"ibFA3","4fe6d5dc83b0d6":"fROuZ"}],"ZQ5iV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formats = exports.stringify = void 0;
const formats_1 = require("c610fa9674da8a7f");
const formats = {
    formatters: formats_1.formatters,
    RFC1738: formats_1.RFC1738,
    RFC3986: formats_1.RFC3986,
    default: formats_1.default_format
};
exports.formats = formats;
var stringify_1 = require("4b742f7a05e35864");
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return stringify_1.stringify;
    }
});

},{"c610fa9674da8a7f":"clQMB","4b742f7a05e35864":"fVl8M"}],"clQMB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RFC3986 = exports.RFC1738 = exports.formatters = exports.default_format = void 0;
exports.default_format = 'RFC3986';
exports.formatters = {
    RFC1738: (v)=>String(v).replace(/%20/g, '+'),
    RFC3986: (v)=>String(v)
};
exports.RFC1738 = 'RFC1738';
exports.RFC3986 = 'RFC3986';

},{}],"fVl8M":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stringify = void 0;
const utils_1 = require("e6fca6f703be456c");
const formats_1 = require("d9fe3d00f41bf6e9");
const has = Object.prototype.hasOwnProperty;
const array_prefix_generators = {
    brackets (prefix) {
        return String(prefix) + '[]';
    },
    comma: 'comma',
    indices (prefix, key) {
        return String(prefix) + '[' + key + ']';
    },
    repeat (prefix) {
        return String(prefix);
    }
};
const is_array = Array.isArray;
const push = Array.prototype.push;
const push_to_array = function(arr, value_or_array) {
    push.apply(arr, is_array(value_or_array) ? value_or_array : [
        value_or_array
    ]);
};
const to_ISO = Date.prototype.toISOString;
const defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils_1.encode,
    encodeValuesOnly: false,
    format: formats_1.default_format,
    formatter: formats_1.formatters[formats_1.default_format],
    /** @deprecated */ indices: false,
    serializeDate (date) {
        return to_ISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
function is_non_nullish_primitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
}
const sentinel = {};
function inner_stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    let obj = object;
    let tmp_sc = sideChannel;
    let step = 0;
    let find_flag = false;
    while((tmp_sc = tmp_sc.get(sentinel)) !== void 0 && !find_flag){
        // Where object last appeared in the ref tree
        const pos = tmp_sc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else find_flag = true; // Break while
        }
        if (typeof tmp_sc.get(sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate?.(obj);
    else if (generateArrayPrefix === 'comma' && is_array(obj)) obj = (0, utils_1.maybe_map)(obj, function(value) {
        if (value instanceof Date) return serializeDate?.(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? // @ts-expect-error
        encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if (is_non_nullish_primitive(obj) || (0, utils_1.is_buffer)(obj)) {
        if (encoder) {
            const key_value = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [
                formatter?.(key_value) + '=' + // @ts-expect-error
                formatter?.(encoder(obj, defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter?.(prefix) + '=' + formatter?.(String(obj))
        ];
    }
    const values = [];
    if (typeof obj === 'undefined') return values;
    let obj_keys;
    if (generateArrayPrefix === 'comma' && is_array(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) // @ts-expect-error values only
        obj = (0, utils_1.maybe_map)(obj, encoder);
        obj_keys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if (is_array(filter)) obj_keys = filter;
    else {
        const keys = Object.keys(obj);
        obj_keys = sort ? keys.sort(sort) : keys;
    }
    const encoded_prefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    const adjusted_prefix = commaRoundTrip && is_array(obj) && obj.length === 1 ? encoded_prefix + '[]' : encoded_prefix;
    if (allowEmptyArrays && is_array(obj) && obj.length === 0) return adjusted_prefix + '[]';
    for(let j = 0; j < obj_keys.length; ++j){
        const key = obj_keys[j];
        const value = // @ts-ignore
        typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        // @ts-ignore
        const encoded_key = allowDots && encodeDotInKeys ? key.replace(/\./g, '%2E') : key;
        const key_prefix = is_array(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjusted_prefix, encoded_key) : adjusted_prefix : adjusted_prefix + (allowDots ? '.' + encoded_key : '[' + encoded_key + ']');
        sideChannel.set(object, step);
        const valueSideChannel = new WeakMap();
        valueSideChannel.set(sentinel, sideChannel);
        push_to_array(values, inner_stringify(value, key_prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, // @ts-ignore
        generateArrayPrefix === 'comma' && encodeValuesOnly && is_array(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
}
function normalize_stringify_options(opts = defaults) {
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    const charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    let format = formats_1.default_format;
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats_1.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    const formatter = formats_1.formatters[format];
    let filter = defaults.filter;
    if (typeof opts.filter === 'function' || is_array(opts.filter)) filter = opts.filter;
    let arrayFormat;
    if (opts.arrayFormat && opts.arrayFormat in array_prefix_generators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    const allowDots = typeof opts.allowDots === 'undefined' ? !!opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        // @ts-ignore
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        // @ts-ignore
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
}
function stringify(object, opts = {}) {
    let obj = object;
    const options = normalize_stringify_options(opts);
    let obj_keys;
    let filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (is_array(options.filter)) {
        filter = options.filter;
        obj_keys = filter;
    }
    const keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    const generateArrayPrefix = array_prefix_generators[options.arrayFormat];
    const commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!obj_keys) obj_keys = Object.keys(obj);
    if (options.sort) obj_keys.sort(options.sort);
    const sideChannel = new WeakMap();
    for(let i = 0; i < obj_keys.length; ++i){
        const key = obj_keys[i];
        if (options.skipNulls && obj[key] === null) continue;
        push_to_array(keys, inner_stringify(obj[key], key, // @ts-expect-error
        generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    const joined = keys.join(options.delimiter);
    let prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
}
exports.stringify = stringify;

},{"e6fca6f703be456c":"f9pWW","d9fe3d00f41bf6e9":"clQMB"}],"f9pWW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.maybe_map = exports.combine = exports.is_buffer = exports.is_regexp = exports.compact = exports.encode = exports.decode = exports.assign_single_source = exports.merge = void 0;
const formats_1 = require("1cc37db3d8f98ba");
const has = Object.prototype.hasOwnProperty;
const is_array = Array.isArray;
const hex_table = (()=>{
    const array = [];
    for(let i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
})();
function compact_queue(queue) {
    while(queue.length > 1){
        const item = queue.pop();
        if (!item) continue;
        const obj = item.obj[item.prop];
        if (is_array(obj)) {
            const compacted = [];
            for(let j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            // @ts-ignore
            item.obj[item.prop] = compacted;
        }
    }
}
function array_to_object(source, options) {
    const obj = options && options.plainObjects ? Object.create(null) : {};
    for(let i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
}
function merge(target, source, options = {}) {
    if (!source) return target;
    if (typeof source !== 'object') {
        if (is_array(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    let mergeTarget = target;
    if (is_array(target) && !is_array(source)) // @ts-ignore
    mergeTarget = array_to_object(target, options);
    if (is_array(target) && is_array(source)) {
        source.forEach(function(item, i) {
            if (has.call(target, i)) {
                const targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        const value = source[key];
        if (has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
}
exports.merge = merge;
function assign_single_source(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
}
exports.assign_single_source = assign_single_source;
function decode(str, _, charset) {
    const strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
}
exports.decode = decode;
const limit = 1024;
const encode = (str, _defaultEncoder, charset, _kind, format)=>{
    // This code was originally written by Brian White for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    let string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    let out = '';
    for(let j = 0; j < string.length; j += limit){
        const segment = string.length >= limit ? string.slice(j, j + limit) : string;
        const arr = [];
        for(let i = 0; i < segment.length; ++i){
            let c = segment.charCodeAt(i);
            if (c === 0x2d || // -
            c === 0x2e || // .
            c === 0x5f || // _
            c === 0x7e || // ~
            c >= 0x30 && c <= 0x39 || // 0-9
            c >= 0x41 && c <= 0x5a || // a-z
            c >= 0x61 && c <= 0x7a || // A-Z
            format === formats_1.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = hex_table[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = hex_table[0xc0 | c >> 6] + hex_table[0x80 | c & 0x3f];
                continue;
            }
            if (c < 0xd800 || c >= 0xe000) {
                arr[arr.length] = hex_table[0xe0 | c >> 12] + hex_table[0x80 | c >> 6 & 0x3f] + hex_table[0x80 | c & 0x3f];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3ff) << 10 | segment.charCodeAt(i) & 0x3ff);
            arr[arr.length] = hex_table[0xf0 | c >> 18] + hex_table[0x80 | c >> 12 & 0x3f] + hex_table[0x80 | c >> 6 & 0x3f] + hex_table[0x80 | c & 0x3f];
        }
        out += arr.join('');
    }
    return out;
};
exports.encode = encode;
function compact(value) {
    const queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    const refs = [];
    for(let i = 0; i < queue.length; ++i){
        const item = queue[i];
        // @ts-ignore
        const obj = item.obj[item.prop];
        const keys = Object.keys(obj);
        for(let j = 0; j < keys.length; ++j){
            const key = keys[j];
            const val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    compact_queue(queue);
    return value;
}
exports.compact = compact;
function is_regexp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
}
exports.is_regexp = is_regexp;
function is_buffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
}
exports.is_buffer = is_buffer;
function combine(a, b) {
    return [].concat(a, b);
}
exports.combine = combine;
function maybe_map(val, fn) {
    if (is_array(val)) {
        const mapped = [];
        for(let i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
}
exports.maybe_map = maybe_map;

},{"1cc37db3d8f98ba":"clQMB"}],"SlwjS":[function(require,module,exports,__globalThis) {
var Buffer = require("31d6bf55516590d9").Buffer;
var process = require("fb4de7ad07f6de68");
"use strict";
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AbstractPage_client;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isObj = exports.toBase64 = exports.getHeader = exports.getRequiredHeader = exports.isHeadersProtocol = exports.isRunningInBrowser = exports.debug = exports.hasOwn = exports.isEmptyObj = exports.maybeCoerceBoolean = exports.maybeCoerceFloat = exports.maybeCoerceInteger = exports.coerceBoolean = exports.coerceFloat = exports.coerceInteger = exports.readEnv = exports.ensurePresent = exports.castToError = exports.sleep = exports.safeJSON = exports.isRequestOptions = exports.createResponseHeaders = exports.PagePromise = exports.AbstractPage = exports.APIClient = exports.APIPromise = exports.createForm = exports.multipartFormRequestOptions = exports.maybeMultipartFormRequestOptions = void 0;
const version_1 = require("b0256790d8e603c7");
const streaming_1 = require("47bb96a4f222954c");
const error_1 = require("87a70cbc43c14d1a");
const index_1 = require("18a02ad669aa835c");
const uploads_1 = require("e1f0fe6ce9ed9848");
var uploads_2 = require("e1f0fe6ce9ed9848");
Object.defineProperty(exports, "maybeMultipartFormRequestOptions", {
    enumerable: true,
    get: function() {
        return uploads_2.maybeMultipartFormRequestOptions;
    }
});
Object.defineProperty(exports, "multipartFormRequestOptions", {
    enumerable: true,
    get: function() {
        return uploads_2.multipartFormRequestOptions;
    }
});
Object.defineProperty(exports, "createForm", {
    enumerable: true,
    get: function() {
        return uploads_2.createForm;
    }
});
async function defaultParseResponse(props) {
    const { response } = props;
    if (props.options.stream) {
        debug('response', response.status, response.url, response.headers, response.body);
        // Note: there is an invariant here that isn't represented in the type system
        // that if you set `stream: true` the response type must also be `Stream<T>`
        if (props.options.__streamClass) return props.options.__streamClass.fromSSEResponse(response, props.controller);
        return streaming_1.Stream.fromSSEResponse(response, props.controller);
    }
    // fetch refuses to read the body when the status code is 204.
    if (response.status === 204) return null;
    if (props.options.__binaryResponse) return response;
    const contentType = response.headers.get('content-type');
    const isJSON = contentType?.includes('application/json') || contentType?.includes('application/vnd.api+json');
    if (isJSON) {
        const json = await response.json();
        debug('response', response.status, response.url, response.headers, json);
        return _addRequestID(json, response);
    }
    const text = await response.text();
    debug('response', response.status, response.url, response.headers, text);
    // TODO handle blob, arraybuffer, other content types, etc.
    return text;
}
function _addRequestID(value, response) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return value;
    return Object.defineProperty(value, '_request_id', {
        value: response.headers.get('x-request-id'),
        enumerable: false
    });
}
/**
 * A subclass of `Promise` providing additional helper methods
 * for interacting with the SDK.
 */ class APIPromise extends Promise {
    constructor(responsePromise, parseResponse = defaultParseResponse){
        super((resolve)=>{
            // this is maybe a bit weird but this has to be a no-op to not implicitly
            // parse the response body; instead .then, .catch, .finally are overridden
            // to parse the response
            resolve(null);
        });
        this.responsePromise = responsePromise;
        this.parseResponse = parseResponse;
    }
    _thenUnwrap(transform) {
        return new APIPromise(this.responsePromise, async (props)=>_addRequestID(transform(await this.parseResponse(props), props), props.response));
    }
    /**
     * Gets the raw `Response` instance instead of parsing the response
     * data.
     *
     * If you want to parse the response body but still get the `Response`
     * instance, you can use {@link withResponse()}.
     *
     * 👋 Getting the wrong TypeScript type for `Response`?
     * Try setting `"moduleResolution": "NodeNext"` if you can,
     * or add one of these imports before your first `import … from 'openai'`:
     * - `import 'openai/shims/node'` (if you're running on Node)
     * - `import 'openai/shims/web'` (otherwise)
     */ asResponse() {
        return this.responsePromise.then((p)=>p.response);
    }
    /**
     * Gets the parsed response data, the raw `Response` instance and the ID of the request,
     * returned via the X-Request-ID header which is useful for debugging requests and reporting
     * issues to OpenAI.
     *
     * If you just want to get the raw `Response` instance without parsing it,
     * you can use {@link asResponse()}.
     *
     *
     * 👋 Getting the wrong TypeScript type for `Response`?
     * Try setting `"moduleResolution": "NodeNext"` if you can,
     * or add one of these imports before your first `import … from 'openai'`:
     * - `import 'openai/shims/node'` (if you're running on Node)
     * - `import 'openai/shims/web'` (otherwise)
     */ async withResponse() {
        const [data, response] = await Promise.all([
            this.parse(),
            this.asResponse()
        ]);
        return {
            data,
            response,
            request_id: response.headers.get('x-request-id')
        };
    }
    parse() {
        if (!this.parsedPromise) this.parsedPromise = this.responsePromise.then(this.parseResponse);
        return this.parsedPromise;
    }
    then(onfulfilled, onrejected) {
        return this.parse().then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.parse().catch(onrejected);
    }
    finally(onfinally) {
        return this.parse().finally(onfinally);
    }
}
exports.APIPromise = APIPromise;
class APIClient {
    constructor({ baseURL, maxRetries = 2, timeout = 600000, httpAgent, fetch: overridenFetch }){
        this.baseURL = baseURL;
        this.maxRetries = validatePositiveInteger('maxRetries', maxRetries);
        this.timeout = validatePositiveInteger('timeout', timeout);
        this.httpAgent = httpAgent;
        this.fetch = overridenFetch ?? index_1.fetch;
    }
    authHeaders(opts) {
        return {};
    }
    /**
     * Override this to add your own default headers, for example:
     *
     *  {
     *    ...super.defaultHeaders(),
     *    Authorization: 'Bearer 123',
     *  }
     */ defaultHeaders(opts) {
        return {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'User-Agent': this.getUserAgent(),
            ...getPlatformHeaders(),
            ...this.authHeaders(opts)
        };
    }
    /**
     * Override this to add your own headers validation:
     */ validateHeaders(headers, customHeaders) {}
    defaultIdempotencyKey() {
        return `stainless-node-retry-${uuid4()}`;
    }
    get(path, opts) {
        return this.methodRequest('get', path, opts);
    }
    post(path, opts) {
        return this.methodRequest('post', path, opts);
    }
    patch(path, opts) {
        return this.methodRequest('patch', path, opts);
    }
    put(path, opts) {
        return this.methodRequest('put', path, opts);
    }
    delete(path, opts) {
        return this.methodRequest('delete', path, opts);
    }
    methodRequest(method, path, opts) {
        return this.request(Promise.resolve(opts).then(async (opts)=>{
            const body = opts && (0, uploads_1.isBlobLike)(opts?.body) ? new DataView(await opts.body.arrayBuffer()) : opts?.body instanceof DataView ? opts.body : opts?.body instanceof ArrayBuffer ? new DataView(opts.body) : opts && ArrayBuffer.isView(opts?.body) ? new DataView(opts.body.buffer) : opts?.body;
            return {
                method,
                path,
                ...opts,
                body
            };
        }));
    }
    getAPIList(path, Page, opts) {
        return this.requestAPIList(Page, {
            method: 'get',
            path,
            ...opts
        });
    }
    calculateContentLength(body) {
        if (typeof body === 'string') {
            if (typeof Buffer !== 'undefined') return Buffer.byteLength(body, 'utf8').toString();
            if (typeof TextEncoder !== 'undefined') {
                const encoder = new TextEncoder();
                const encoded = encoder.encode(body);
                return encoded.length.toString();
            }
        } else if (ArrayBuffer.isView(body)) return body.byteLength.toString();
        return null;
    }
    buildRequest(options, { retryCount = 0 } = {}) {
        const { method, path, query, headers: headers = {} } = options;
        const body = ArrayBuffer.isView(options.body) || options.__binaryRequest && typeof options.body === 'string' ? options.body : (0, uploads_1.isMultipartBody)(options.body) ? options.body.body : options.body ? JSON.stringify(options.body, null, 2) : null;
        const contentLength = this.calculateContentLength(body);
        const url = this.buildURL(path, query);
        if ('timeout' in options) validatePositiveInteger('timeout', options.timeout);
        const timeout = options.timeout ?? this.timeout;
        const httpAgent = options.httpAgent ?? this.httpAgent ?? (0, index_1.getDefaultAgent)(url);
        const minAgentTimeout = timeout + 1000;
        if (typeof httpAgent?.options?.timeout === 'number' && minAgentTimeout > (httpAgent.options.timeout ?? 0)) // Allow any given request to bump our agent active socket timeout.
        // This may seem strange, but leaking active sockets should be rare and not particularly problematic,
        // and without mutating agent we would need to create more of them.
        // This tradeoff optimizes for performance.
        httpAgent.options.timeout = minAgentTimeout;
        if (this.idempotencyHeader && method !== 'get') {
            if (!options.idempotencyKey) options.idempotencyKey = this.defaultIdempotencyKey();
            headers[this.idempotencyHeader] = options.idempotencyKey;
        }
        const reqHeaders = this.buildHeaders({
            options,
            headers,
            contentLength,
            retryCount
        });
        const req = {
            method,
            ...body && {
                body: body
            },
            headers: reqHeaders,
            ...httpAgent && {
                agent: httpAgent
            },
            // @ts-ignore node-fetch uses a custom AbortSignal type that is
            // not compatible with standard web types
            signal: options.signal ?? null
        };
        return {
            req,
            url,
            timeout
        };
    }
    buildHeaders({ options, headers, contentLength, retryCount }) {
        const reqHeaders = {};
        if (contentLength) reqHeaders['content-length'] = contentLength;
        const defaultHeaders = this.defaultHeaders(options);
        applyHeadersMut(reqHeaders, defaultHeaders);
        applyHeadersMut(reqHeaders, headers);
        // let builtin fetch set the Content-Type for multipart bodies
        if ((0, uploads_1.isMultipartBody)(options.body) && index_1.kind !== 'node') delete reqHeaders['content-type'];
        // Don't set the retry count header if it was already set or removed through default headers or by the
        // caller. We check `defaultHeaders` and `headers`, which can contain nulls, instead of `reqHeaders` to
        // account for the removal case.
        if ((0, exports.getHeader)(defaultHeaders, 'x-stainless-retry-count') === undefined && (0, exports.getHeader)(headers, 'x-stainless-retry-count') === undefined) reqHeaders['x-stainless-retry-count'] = String(retryCount);
        this.validateHeaders(reqHeaders, headers);
        return reqHeaders;
    }
    /**
     * Used as a callback for mutating the given `FinalRequestOptions` object.
     */ async prepareOptions(options) {}
    /**
     * Used as a callback for mutating the given `RequestInit` object.
     *
     * This is useful for cases where you want to add certain headers based off of
     * the request properties, e.g. `method` or `url`.
     */ async prepareRequest(request, { url, options }) {}
    parseHeaders(headers) {
        return !headers ? {} : Symbol.iterator in headers ? Object.fromEntries(Array.from(headers).map((header)=>[
                ...header
            ])) : {
            ...headers
        };
    }
    makeStatusError(status, error, message, headers) {
        return error_1.APIError.generate(status, error, message, headers);
    }
    request(options, remainingRetries = null) {
        return new APIPromise(this.makeRequest(options, remainingRetries));
    }
    async makeRequest(optionsInput, retriesRemaining) {
        const options = await optionsInput;
        const maxRetries = options.maxRetries ?? this.maxRetries;
        if (retriesRemaining == null) retriesRemaining = maxRetries;
        await this.prepareOptions(options);
        const { req, url, timeout } = this.buildRequest(options, {
            retryCount: maxRetries - retriesRemaining
        });
        await this.prepareRequest(req, {
            url,
            options
        });
        debug('request', url, options, req.headers);
        if (options.signal?.aborted) throw new error_1.APIUserAbortError();
        const controller = new AbortController();
        const response = await this.fetchWithTimeout(url, req, timeout, controller).catch(exports.castToError);
        if (response instanceof Error) {
            if (options.signal?.aborted) throw new error_1.APIUserAbortError();
            if (retriesRemaining) return this.retryRequest(options, retriesRemaining);
            if (response.name === 'AbortError') throw new error_1.APIConnectionTimeoutError();
            throw new error_1.APIConnectionError({
                cause: response
            });
        }
        const responseHeaders = (0, exports.createResponseHeaders)(response.headers);
        if (!response.ok) {
            if (retriesRemaining && this.shouldRetry(response)) {
                const retryMessage = `retrying, ${retriesRemaining} attempts remaining`;
                debug(`response (error; ${retryMessage})`, response.status, url, responseHeaders);
                return this.retryRequest(options, retriesRemaining, responseHeaders);
            }
            const errText = await response.text().catch((e)=>(0, exports.castToError)(e).message);
            const errJSON = (0, exports.safeJSON)(errText);
            const errMessage = errJSON ? undefined : errText;
            const retryMessage = retriesRemaining ? `(error; no more retries left)` : `(error; not retryable)`;
            debug(`response (error; ${retryMessage})`, response.status, url, responseHeaders, errMessage);
            const err = this.makeStatusError(response.status, errJSON, errMessage, responseHeaders);
            throw err;
        }
        return {
            response,
            options,
            controller
        };
    }
    requestAPIList(Page, options) {
        const request = this.makeRequest(options, null);
        return new PagePromise(this, request, Page);
    }
    buildURL(path, query) {
        const url = isAbsoluteURL(path) ? new URL(path) : new URL(this.baseURL + (this.baseURL.endsWith('/') && path.startsWith('/') ? path.slice(1) : path));
        const defaultQuery = this.defaultQuery();
        if (!isEmptyObj(defaultQuery)) query = {
            ...defaultQuery,
            ...query
        };
        if (typeof query === 'object' && query && !Array.isArray(query)) url.search = this.stringifyQuery(query);
        return url.toString();
    }
    stringifyQuery(query) {
        return Object.entries(query).filter(([_, value])=>typeof value !== 'undefined').map(([key, value])=>{
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            if (value === null) return `${encodeURIComponent(key)}=`;
            throw new error_1.OpenAIError(`Cannot stringify type ${typeof value}; Expected string, number, boolean, or null. If you need to pass nested query parameters, you can manually encode them, e.g. { query: { 'foo[key1]': value1, 'foo[key2]': value2 } }, and please open a GitHub issue requesting better support for your use case.`);
        }).join('&');
    }
    async fetchWithTimeout(url, init, ms, controller) {
        const { signal, ...options } = init || {};
        if (signal) signal.addEventListener('abort', ()=>controller.abort());
        const timeout = setTimeout(()=>controller.abort(), ms);
        return this.getRequestClient()// use undefined this binding; fetch errors if bound to something else in browser/cloudflare
        .fetch.call(undefined, url, {
            signal: controller.signal,
            ...options
        }).finally(()=>{
            clearTimeout(timeout);
        });
    }
    getRequestClient() {
        return {
            fetch: this.fetch
        };
    }
    shouldRetry(response) {
        // Note this is not a standard header.
        const shouldRetryHeader = response.headers.get('x-should-retry');
        // If the server explicitly says whether or not to retry, obey.
        if (shouldRetryHeader === 'true') return true;
        if (shouldRetryHeader === 'false') return false;
        // Retry on request timeouts.
        if (response.status === 408) return true;
        // Retry on lock timeouts.
        if (response.status === 409) return true;
        // Retry on rate limits.
        if (response.status === 429) return true;
        // Retry internal errors.
        if (response.status >= 500) return true;
        return false;
    }
    async retryRequest(options, retriesRemaining, responseHeaders) {
        let timeoutMillis;
        // Note the `retry-after-ms` header may not be standard, but is a good idea and we'd like proactive support for it.
        const retryAfterMillisHeader = responseHeaders?.['retry-after-ms'];
        if (retryAfterMillisHeader) {
            const timeoutMs = parseFloat(retryAfterMillisHeader);
            if (!Number.isNaN(timeoutMs)) timeoutMillis = timeoutMs;
        }
        // About the Retry-After header: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After
        const retryAfterHeader = responseHeaders?.['retry-after'];
        if (retryAfterHeader && !timeoutMillis) {
            const timeoutSeconds = parseFloat(retryAfterHeader);
            if (!Number.isNaN(timeoutSeconds)) timeoutMillis = timeoutSeconds * 1000;
            else timeoutMillis = Date.parse(retryAfterHeader) - Date.now();
        }
        // If the API asks us to wait a certain amount of time (and it's a reasonable amount),
        // just do what it says, but otherwise calculate a default
        if (!(timeoutMillis && 0 <= timeoutMillis && timeoutMillis < 60000)) {
            const maxRetries = options.maxRetries ?? this.maxRetries;
            timeoutMillis = this.calculateDefaultRetryTimeoutMillis(retriesRemaining, maxRetries);
        }
        await (0, exports.sleep)(timeoutMillis);
        return this.makeRequest(options, retriesRemaining - 1);
    }
    calculateDefaultRetryTimeoutMillis(retriesRemaining, maxRetries) {
        const initialRetryDelay = 0.5;
        const maxRetryDelay = 8.0;
        const numRetries = maxRetries - retriesRemaining;
        // Apply exponential backoff, but not more than the max.
        const sleepSeconds = Math.min(initialRetryDelay * Math.pow(2, numRetries), maxRetryDelay);
        // Apply some jitter, take up to at most 25 percent of the retry time.
        const jitter = 1 - Math.random() * 0.25;
        return sleepSeconds * jitter * 1000;
    }
    getUserAgent() {
        return `${this.constructor.name}/JS ${version_1.VERSION}`;
    }
}
exports.APIClient = APIClient;
class AbstractPage {
    constructor(client, response, body, options){
        _AbstractPage_client.set(this, void 0);
        __classPrivateFieldSet(this, _AbstractPage_client, client, "f");
        this.options = options;
        this.response = response;
        this.body = body;
    }
    hasNextPage() {
        const items = this.getPaginatedItems();
        if (!items.length) return false;
        return this.nextPageInfo() != null;
    }
    async getNextPage() {
        const nextInfo = this.nextPageInfo();
        if (!nextInfo) throw new error_1.OpenAIError('No next page expected; please check `.hasNextPage()` before calling `.getNextPage()`.');
        const nextOptions = {
            ...this.options
        };
        if ('params' in nextInfo && typeof nextOptions.query === 'object') nextOptions.query = {
            ...nextOptions.query,
            ...nextInfo.params
        };
        else if ('url' in nextInfo) {
            const params = [
                ...Object.entries(nextOptions.query || {}),
                ...nextInfo.url.searchParams.entries()
            ];
            for (const [key, value] of params)nextInfo.url.searchParams.set(key, value);
            nextOptions.query = undefined;
            nextOptions.path = nextInfo.url.toString();
        }
        return await __classPrivateFieldGet(this, _AbstractPage_client, "f").requestAPIList(this.constructor, nextOptions);
    }
    async *iterPages() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let page = this;
        yield page;
        while(page.hasNextPage()){
            page = await page.getNextPage();
            yield page;
        }
    }
    async *[(_AbstractPage_client = new WeakMap(), Symbol.asyncIterator)]() {
        for await (const page of this.iterPages())for (const item of page.getPaginatedItems())yield item;
    }
}
exports.AbstractPage = AbstractPage;
/**
 * This subclass of Promise will resolve to an instantiated Page once the request completes.
 *
 * It also implements AsyncIterable to allow auto-paginating iteration on an unawaited list call, eg:
 *
 *    for await (const item of client.items.list()) {
 *      console.log(item)
 *    }
 */ class PagePromise extends APIPromise {
    constructor(client, request, Page){
        super(request, async (props)=>new Page(client, props.response, await defaultParseResponse(props), props.options));
    }
    /**
     * Allow auto-paginating iteration on an unawaited list call, eg:
     *
     *    for await (const item of client.items.list()) {
     *      console.log(item)
     *    }
     */ async *[Symbol.asyncIterator]() {
        const page = await this;
        for await (const item of page)yield item;
    }
}
exports.PagePromise = PagePromise;
const createResponseHeaders = (headers)=>{
    return new Proxy(Object.fromEntries(// @ts-ignore
    headers.entries()), {
        get (target, name) {
            const key = name.toString();
            return target[key.toLowerCase()] || target[key];
        }
    });
};
exports.createResponseHeaders = createResponseHeaders;
// This is required so that we can determine if a given object matches the RequestOptions
// type at runtime. While this requires duplication, it is enforced by the TypeScript
// compiler such that any missing / extraneous keys will cause an error.
const requestOptionsKeys = {
    method: true,
    path: true,
    query: true,
    body: true,
    headers: true,
    maxRetries: true,
    stream: true,
    timeout: true,
    httpAgent: true,
    signal: true,
    idempotencyKey: true,
    __binaryRequest: true,
    __binaryResponse: true,
    __streamClass: true
};
const isRequestOptions = (obj)=>{
    return typeof obj === 'object' && obj !== null && !isEmptyObj(obj) && Object.keys(obj).every((k)=>hasOwn(requestOptionsKeys, k));
};
exports.isRequestOptions = isRequestOptions;
const getPlatformProperties = ()=>{
    if (typeof Deno !== 'undefined' && Deno.build != null) return {
        'X-Stainless-Lang': 'js',
        'X-Stainless-Package-Version': version_1.VERSION,
        'X-Stainless-OS': normalizePlatform(Deno.build.os),
        'X-Stainless-Arch': normalizeArch(Deno.build.arch),
        'X-Stainless-Runtime': 'deno',
        'X-Stainless-Runtime-Version': typeof Deno.version === 'string' ? Deno.version : Deno.version?.deno ?? 'unknown'
    };
    if (typeof EdgeRuntime !== 'undefined') return {
        'X-Stainless-Lang': 'js',
        'X-Stainless-Package-Version': version_1.VERSION,
        'X-Stainless-OS': 'Unknown',
        'X-Stainless-Arch': `other:${EdgeRuntime}`,
        'X-Stainless-Runtime': 'edge',
        'X-Stainless-Runtime-Version': process.version
    };
    // Check if Node.js
    if (Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]') return {
        'X-Stainless-Lang': 'js',
        'X-Stainless-Package-Version': version_1.VERSION,
        'X-Stainless-OS': normalizePlatform(process.platform),
        'X-Stainless-Arch': normalizeArch(process.arch),
        'X-Stainless-Runtime': 'node',
        'X-Stainless-Runtime-Version': process.version
    };
    const browserInfo = getBrowserInfo();
    if (browserInfo) return {
        'X-Stainless-Lang': 'js',
        'X-Stainless-Package-Version': version_1.VERSION,
        'X-Stainless-OS': 'Unknown',
        'X-Stainless-Arch': 'unknown',
        'X-Stainless-Runtime': `browser:${browserInfo.browser}`,
        'X-Stainless-Runtime-Version': browserInfo.version
    };
    // TODO add support for Cloudflare workers, etc.
    return {
        'X-Stainless-Lang': 'js',
        'X-Stainless-Package-Version': version_1.VERSION,
        'X-Stainless-OS': 'Unknown',
        'X-Stainless-Arch': 'unknown',
        'X-Stainless-Runtime': 'unknown',
        'X-Stainless-Runtime-Version': 'unknown'
    };
};
// Note: modified from https://github.com/JS-DevTools/host-environment/blob/b1ab79ecde37db5d6e163c050e54fe7d287d7c92/src/isomorphic.browser.ts
function getBrowserInfo() {
    if (typeof navigator === 'undefined' || !navigator) return null;
    // NOTE: The order matters here!
    const browserPatterns = [
        {
            key: 'edge',
            pattern: /Edge(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: 'ie',
            pattern: /MSIE(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: 'ie',
            pattern: /Trident(?:.*rv\:(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: 'chrome',
            pattern: /Chrome(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: 'firefox',
            pattern: /Firefox(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: 'safari',
            pattern: /(?:Version\W+(\d+)\.(\d+)(?:\.(\d+))?)?(?:\W+Mobile\S*)?\W+Safari/
        }
    ];
    // Find the FIRST matching browser
    for (const { key, pattern } of browserPatterns){
        const match = pattern.exec(navigator.userAgent);
        if (match) {
            const major = match[1] || 0;
            const minor = match[2] || 0;
            const patch = match[3] || 0;
            return {
                browser: key,
                version: `${major}.${minor}.${patch}`
            };
        }
    }
    return null;
}
const normalizeArch = (arch)=>{
    // Node docs:
    // - https://nodejs.org/api/process.html#processarch
    // Deno docs:
    // - https://doc.deno.land/deno/stable/~/Deno.build
    if (arch === 'x32') return 'x32';
    if (arch === 'x86_64' || arch === 'x64') return 'x64';
    if (arch === 'arm') return 'arm';
    if (arch === 'aarch64' || arch === 'arm64') return 'arm64';
    if (arch) return `other:${arch}`;
    return 'unknown';
};
const normalizePlatform = (platform)=>{
    // Node platforms:
    // - https://nodejs.org/api/process.html#processplatform
    // Deno platforms:
    // - https://doc.deno.land/deno/stable/~/Deno.build
    // - https://github.com/denoland/deno/issues/14799
    platform = platform.toLowerCase();
    // NOTE: this iOS check is untested and may not work
    // Node does not work natively on IOS, there is a fork at
    // https://github.com/nodejs-mobile/nodejs-mobile
    // however it is unknown at the time of writing how to detect if it is running
    if (platform.includes('ios')) return 'iOS';
    if (platform === 'android') return 'Android';
    if (platform === 'darwin') return 'MacOS';
    if (platform === 'win32') return 'Windows';
    if (platform === 'freebsd') return 'FreeBSD';
    if (platform === 'openbsd') return 'OpenBSD';
    if (platform === 'linux') return 'Linux';
    if (platform) return `Other:${platform}`;
    return 'Unknown';
};
let _platformHeaders;
const getPlatformHeaders = ()=>{
    return _platformHeaders ?? (_platformHeaders = getPlatformProperties());
};
const safeJSON = (text)=>{
    try {
        return JSON.parse(text);
    } catch (err) {
        return undefined;
    }
};
exports.safeJSON = safeJSON;
// https://stackoverflow.com/a/19709846
const startsWithSchemeRegexp = new RegExp('^(?:[a-z]+:)?//', 'i');
const isAbsoluteURL = (url)=>{
    return startsWithSchemeRegexp.test(url);
};
const sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
exports.sleep = sleep;
const validatePositiveInteger = (name, n)=>{
    if (typeof n !== 'number' || !Number.isInteger(n)) throw new error_1.OpenAIError(`${name} must be an integer`);
    if (n < 0) throw new error_1.OpenAIError(`${name} must be a positive integer`);
    return n;
};
const castToError = (err)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'object' && err !== null) try {
        return new Error(JSON.stringify(err));
    } catch  {}
    return new Error(err);
};
exports.castToError = castToError;
const ensurePresent = (value)=>{
    if (value == null) throw new error_1.OpenAIError(`Expected a value to be given but received ${value} instead.`);
    return value;
};
exports.ensurePresent = ensurePresent;
/**
 * Read an environment variable.
 *
 * Trims beginning and trailing whitespace.
 *
 * Will return undefined if the environment variable doesn't exist or cannot be accessed.
 */ const readEnv = (env)=>{
    if (typeof process !== 'undefined') return process.env?.[env]?.trim() ?? undefined;
    if (typeof Deno !== 'undefined') return Deno.env?.get?.(env)?.trim();
    return undefined;
};
exports.readEnv = readEnv;
const coerceInteger = (value)=>{
    if (typeof value === 'number') return Math.round(value);
    if (typeof value === 'string') return parseInt(value, 10);
    throw new error_1.OpenAIError(`Could not coerce ${value} (type: ${typeof value}) into a number`);
};
exports.coerceInteger = coerceInteger;
const coerceFloat = (value)=>{
    if (typeof value === 'number') return value;
    if (typeof value === 'string') return parseFloat(value);
    throw new error_1.OpenAIError(`Could not coerce ${value} (type: ${typeof value}) into a number`);
};
exports.coerceFloat = coerceFloat;
const coerceBoolean = (value)=>{
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') return value === 'true';
    return Boolean(value);
};
exports.coerceBoolean = coerceBoolean;
const maybeCoerceInteger = (value)=>{
    if (value === undefined) return undefined;
    return (0, exports.coerceInteger)(value);
};
exports.maybeCoerceInteger = maybeCoerceInteger;
const maybeCoerceFloat = (value)=>{
    if (value === undefined) return undefined;
    return (0, exports.coerceFloat)(value);
};
exports.maybeCoerceFloat = maybeCoerceFloat;
const maybeCoerceBoolean = (value)=>{
    if (value === undefined) return undefined;
    return (0, exports.coerceBoolean)(value);
};
exports.maybeCoerceBoolean = maybeCoerceBoolean;
// https://stackoverflow.com/a/34491287
function isEmptyObj(obj) {
    if (!obj) return true;
    for(const _k in obj)return false;
    return true;
}
exports.isEmptyObj = isEmptyObj;
// https://eslint.org/docs/latest/rules/no-prototype-builtins
function hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
exports.hasOwn = hasOwn;
/**
 * Copies headers from "newHeaders" onto "targetHeaders",
 * using lower-case for all properties,
 * ignoring any keys with undefined values,
 * and deleting any keys with null values.
 */ function applyHeadersMut(targetHeaders, newHeaders) {
    for(const k in newHeaders){
        if (!hasOwn(newHeaders, k)) continue;
        const lowerKey = k.toLowerCase();
        if (!lowerKey) continue;
        const val = newHeaders[k];
        if (val === null) delete targetHeaders[lowerKey];
        else if (val !== undefined) targetHeaders[lowerKey] = val;
    }
}
function debug(action, ...args) {
    if (typeof process !== 'undefined' && process?.env?.['DEBUG'] === 'true') console.log(`OpenAI:DEBUG:${action}`, ...args);
}
exports.debug = debug;
/**
 * https://stackoverflow.com/a/2117523
 */ const uuid4 = ()=>{
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
const isRunningInBrowser = ()=>{
    return(// @ts-ignore
    typeof window !== 'undefined' && // @ts-ignore
    typeof window.document !== 'undefined' && // @ts-ignore
    typeof navigator !== 'undefined');
};
exports.isRunningInBrowser = isRunningInBrowser;
const isHeadersProtocol = (headers)=>{
    return typeof headers?.get === 'function';
};
exports.isHeadersProtocol = isHeadersProtocol;
const getRequiredHeader = (headers, header)=>{
    const foundHeader = (0, exports.getHeader)(headers, header);
    if (foundHeader === undefined) throw new Error(`Could not find ${header} header`);
    return foundHeader;
};
exports.getRequiredHeader = getRequiredHeader;
const getHeader = (headers, header)=>{
    const lowerCasedHeader = header.toLowerCase();
    if ((0, exports.isHeadersProtocol)(headers)) {
        // to deal with the case where the header looks like Stainless-Event-Id
        const intercapsHeader = header[0]?.toUpperCase() + header.substring(1).replace(/([^\w])(\w)/g, (_m, g1, g2)=>g1 + g2.toUpperCase());
        for (const key of [
            header,
            lowerCasedHeader,
            header.toUpperCase(),
            intercapsHeader
        ]){
            const value = headers.get(key);
            if (value) return value;
        }
    }
    for (const [key, value] of Object.entries(headers))if (key.toLowerCase() === lowerCasedHeader) {
        if (Array.isArray(value)) {
            if (value.length <= 1) return value[0];
            console.warn(`Received ${value.length} entries for the ${header} header, using the first entry.`);
            return value[0];
        }
        return value;
    }
    return undefined;
};
exports.getHeader = getHeader;
/**
 * Encodes a string to Base64 format.
 */ const toBase64 = (str)=>{
    if (!str) return '';
    if (typeof Buffer !== 'undefined') return Buffer.from(str).toString('base64');
    if (typeof btoa !== 'undefined') return btoa(str);
    throw new error_1.OpenAIError('Cannot generate b64 string; Expected `Buffer` or `btoa` to be defined');
};
exports.toBase64 = toBase64;
function isObj(obj) {
    return obj != null && typeof obj === 'object' && !Array.isArray(obj);
}
exports.isObj = isObj;

},{"31d6bf55516590d9":"l5Twm","fb4de7ad07f6de68":"5QIF0","b0256790d8e603c7":"7YRbV","47bb96a4f222954c":"d2aDf","87a70cbc43c14d1a":"eZWCP","18a02ad669aa835c":"2Uwcc","e1f0fe6ce9ed9848":"j0F04"}],"l5Twm":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

},{"9c62938f1dccc73c":"6Pb1S","aceacb6a4531a9d2":"6ifNR"}],"6ifNR":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"7YRbV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VERSION = void 0;
exports.VERSION = '4.72.0'; // x-release-please-version

},{}],"d2aDf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.readableStreamAsyncIterable = exports._decodeChunks = exports._iterSSEMessages = exports.Stream = void 0;
const index_1 = require("9bd53aa11eecfd70");
const error_1 = require("fe8b513380654374");
const line_1 = require("3d176cc1197c2200");
const error_2 = require("fe8b513380654374");
class Stream {
    constructor(iterator, controller){
        this.iterator = iterator;
        this.controller = controller;
    }
    static fromSSEResponse(response, controller) {
        let consumed = false;
        async function* iterator() {
            if (consumed) throw new Error('Cannot iterate over a consumed stream, use `.tee()` to split the stream.');
            consumed = true;
            let done = false;
            try {
                for await (const sse of _iterSSEMessages(response, controller)){
                    if (done) continue;
                    if (sse.data.startsWith('[DONE]')) {
                        done = true;
                        continue;
                    }
                    if (sse.event === null) {
                        let data;
                        try {
                            data = JSON.parse(sse.data);
                        } catch (e) {
                            console.error(`Could not parse message into JSON:`, sse.data);
                            console.error(`From chunk:`, sse.raw);
                            throw e;
                        }
                        if (data && data.error) throw new error_2.APIError(undefined, data.error, undefined, undefined);
                        yield data;
                    } else {
                        let data;
                        try {
                            data = JSON.parse(sse.data);
                        } catch (e) {
                            console.error(`Could not parse message into JSON:`, sse.data);
                            console.error(`From chunk:`, sse.raw);
                            throw e;
                        }
                        // TODO: Is this where the error should be thrown?
                        if (sse.event == 'error') throw new error_2.APIError(undefined, data.error, data.message, undefined);
                        yield {
                            event: sse.event,
                            data: data
                        };
                    }
                }
                done = true;
            } catch (e) {
                // If the user calls `stream.controller.abort()`, we should exit without throwing.
                if (e instanceof Error && e.name === 'AbortError') return;
                throw e;
            } finally{
                // If the user `break`s, abort the ongoing request.
                if (!done) controller.abort();
            }
        }
        return new Stream(iterator, controller);
    }
    /**
     * Generates a Stream from a newline-separated ReadableStream
     * where each item is a JSON value.
     */ static fromReadableStream(readableStream, controller) {
        let consumed = false;
        async function* iterLines() {
            const lineDecoder = new line_1.LineDecoder();
            const iter = readableStreamAsyncIterable(readableStream);
            for await (const chunk of iter)for (const line of lineDecoder.decode(chunk))yield line;
            for (const line of lineDecoder.flush())yield line;
        }
        async function* iterator() {
            if (consumed) throw new Error('Cannot iterate over a consumed stream, use `.tee()` to split the stream.');
            consumed = true;
            let done = false;
            try {
                for await (const line of iterLines()){
                    if (done) continue;
                    if (line) yield JSON.parse(line);
                }
                done = true;
            } catch (e) {
                // If the user calls `stream.controller.abort()`, we should exit without throwing.
                if (e instanceof Error && e.name === 'AbortError') return;
                throw e;
            } finally{
                // If the user `break`s, abort the ongoing request.
                if (!done) controller.abort();
            }
        }
        return new Stream(iterator, controller);
    }
    [Symbol.asyncIterator]() {
        return this.iterator();
    }
    /**
     * Splits the stream into two streams which can be
     * independently read from at different speeds.
     */ tee() {
        const left = [];
        const right = [];
        const iterator = this.iterator();
        const teeIterator = (queue)=>{
            return {
                next: ()=>{
                    if (queue.length === 0) {
                        const result = iterator.next();
                        left.push(result);
                        right.push(result);
                    }
                    return queue.shift();
                }
            };
        };
        return [
            new Stream(()=>teeIterator(left), this.controller),
            new Stream(()=>teeIterator(right), this.controller)
        ];
    }
    /**
     * Converts this stream to a newline-separated ReadableStream of
     * JSON stringified values in the stream
     * which can be turned back into a Stream with `Stream.fromReadableStream()`.
     */ toReadableStream() {
        const self = this;
        let iter;
        const encoder = new TextEncoder();
        return new index_1.ReadableStream({
            async start () {
                iter = self[Symbol.asyncIterator]();
            },
            async pull (ctrl) {
                try {
                    const { value, done } = await iter.next();
                    if (done) return ctrl.close();
                    const bytes = encoder.encode(JSON.stringify(value) + '\n');
                    ctrl.enqueue(bytes);
                } catch (err) {
                    ctrl.error(err);
                }
            },
            async cancel () {
                await iter.return?.();
            }
        });
    }
}
exports.Stream = Stream;
async function* _iterSSEMessages(response, controller) {
    if (!response.body) {
        controller.abort();
        throw new error_1.OpenAIError(`Attempted to iterate over a response with no body`);
    }
    const sseDecoder = new SSEDecoder();
    const lineDecoder = new line_1.LineDecoder();
    const iter = readableStreamAsyncIterable(response.body);
    for await (const sseChunk of iterSSEChunks(iter))for (const line of lineDecoder.decode(sseChunk)){
        const sse = sseDecoder.decode(line);
        if (sse) yield sse;
    }
    for (const line of lineDecoder.flush()){
        const sse = sseDecoder.decode(line);
        if (sse) yield sse;
    }
}
exports._iterSSEMessages = _iterSSEMessages;
/**
 * Given an async iterable iterator, iterates over it and yields full
 * SSE chunks, i.e. yields when a double new-line is encountered.
 */ async function* iterSSEChunks(iterator) {
    let data = new Uint8Array();
    for await (const chunk of iterator){
        if (chunk == null) continue;
        const binaryChunk = chunk instanceof ArrayBuffer ? new Uint8Array(chunk) : typeof chunk === 'string' ? new TextEncoder().encode(chunk) : chunk;
        let newData = new Uint8Array(data.length + binaryChunk.length);
        newData.set(data);
        newData.set(binaryChunk, data.length);
        data = newData;
        let patternIndex;
        while((patternIndex = findDoubleNewlineIndex(data)) !== -1){
            yield data.slice(0, patternIndex);
            data = data.slice(patternIndex);
        }
    }
    if (data.length > 0) yield data;
}
function findDoubleNewlineIndex(buffer) {
    // This function searches the buffer for the end patterns (\r\r, \n\n, \r\n\r\n)
    // and returns the index right after the first occurrence of any pattern,
    // or -1 if none of the patterns are found.
    const newline = 0x0a; // \n
    const carriage = 0x0d; // \r
    for(let i = 0; i < buffer.length - 2; i++){
        if (buffer[i] === newline && buffer[i + 1] === newline) // \n\n
        return i + 2;
        if (buffer[i] === carriage && buffer[i + 1] === carriage) // \r\r
        return i + 2;
        if (buffer[i] === carriage && buffer[i + 1] === newline && i + 3 < buffer.length && buffer[i + 2] === carriage && buffer[i + 3] === newline) // \r\n\r\n
        return i + 4;
    }
    return -1;
}
class SSEDecoder {
    constructor(){
        this.event = null;
        this.data = [];
        this.chunks = [];
    }
    decode(line) {
        if (line.endsWith('\r')) line = line.substring(0, line.length - 1);
        if (!line) {
            // empty line and we didn't previously encounter any messages
            if (!this.event && !this.data.length) return null;
            const sse = {
                event: this.event,
                data: this.data.join('\n'),
                raw: this.chunks
            };
            this.event = null;
            this.data = [];
            this.chunks = [];
            return sse;
        }
        this.chunks.push(line);
        if (line.startsWith(':')) return null;
        let [fieldname, _, value] = partition(line, ':');
        if (value.startsWith(' ')) value = value.substring(1);
        if (fieldname === 'event') this.event = value;
        else if (fieldname === 'data') this.data.push(value);
        return null;
    }
}
/** This is an internal helper function that's just used for testing */ function _decodeChunks(chunks) {
    const decoder = new line_1.LineDecoder();
    const lines = [];
    for (const chunk of chunks)lines.push(...decoder.decode(chunk));
    return lines;
}
exports._decodeChunks = _decodeChunks;
function partition(str, delimiter) {
    const index = str.indexOf(delimiter);
    if (index !== -1) return [
        str.substring(0, index),
        delimiter,
        str.substring(index + delimiter.length)
    ];
    return [
        str,
        '',
        ''
    ];
}
/**
 * Most browsers don't yet have async iterable support for ReadableStream,
 * and Node has a very different way of reading bytes from its "ReadableStream".
 *
 * This polyfill was pulled from https://github.com/MattiasBuelens/web-streams-polyfill/pull/122#issuecomment-1627354490
 */ function readableStreamAsyncIterable(stream) {
    if (stream[Symbol.asyncIterator]) return stream;
    const reader = stream.getReader();
    return {
        async next () {
            try {
                const result = await reader.read();
                if (result?.done) reader.releaseLock(); // release lock when stream becomes closed
                return result;
            } catch (e) {
                reader.releaseLock(); // release lock when stream becomes errored
                throw e;
            }
        },
        async return () {
            const cancelPromise = reader.cancel();
            reader.releaseLock();
            await cancelPromise;
            return {
                done: true,
                value: undefined
            };
        },
        [Symbol.asyncIterator] () {
            return this;
        }
    };
}
exports.readableStreamAsyncIterable = readableStreamAsyncIterable;

},{"9bd53aa11eecfd70":"2Uwcc","fe8b513380654374":"eZWCP","3d176cc1197c2200":"aXM9W"}],"2Uwcc":[function(require,module,exports,__globalThis) {
/**
 * Disclaimer: modules in _shims aren't intended to be imported by SDK users.
 */ const shims = require("d1179e5e38feae2b");
const auto = require("66f73694c80f1c49");
if (!shims.kind) shims.setShims(auto.getRuntime(), {
    auto: true
});
for (const property of Object.keys(shims))Object.defineProperty(exports, property, {
    get () {
        return shims[property];
    }
});

},{"d1179e5e38feae2b":"jV2vB","66f73694c80f1c49":"b950T"}],"jV2vB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setShims = exports.isFsReadStream = exports.fileFromPath = exports.getDefaultAgent = exports.getMultipartRequestOptions = exports.ReadableStream = exports.File = exports.Blob = exports.FormData = exports.Headers = exports.Response = exports.Request = exports.fetch = exports.kind = exports.auto = void 0;
exports.auto = false;
exports.kind = undefined;
exports.fetch = undefined;
exports.Request = undefined;
exports.Response = undefined;
exports.Headers = undefined;
exports.FormData = undefined;
exports.Blob = undefined;
exports.File = undefined;
exports.ReadableStream = undefined;
exports.getMultipartRequestOptions = undefined;
exports.getDefaultAgent = undefined;
exports.fileFromPath = undefined;
exports.isFsReadStream = undefined;
function setShims(shims, options = {
    auto: false
}) {
    if (exports.auto) throw new Error(`you must \`import 'openai/shims/${shims.kind}'\` before importing anything else from openai`);
    if (exports.kind) throw new Error(`can't \`import 'openai/shims/${shims.kind}'\` after \`import 'openai/shims/${exports.kind}'\``);
    exports.auto = options.auto;
    exports.kind = shims.kind;
    exports.fetch = shims.fetch;
    exports.Request = shims.Request;
    exports.Response = shims.Response;
    exports.Headers = shims.Headers;
    exports.FormData = shims.FormData;
    exports.Blob = shims.Blob;
    exports.File = shims.File;
    exports.ReadableStream = shims.ReadableStream;
    exports.getMultipartRequestOptions = shims.getMultipartRequestOptions;
    exports.getDefaultAgent = shims.getDefaultAgent;
    exports.fileFromPath = shims.fileFromPath;
    exports.isFsReadStream = shims.isFsReadStream;
}
exports.setShims = setShims;

},{}],"b950T":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Disclaimer: modules in _shims aren't intended to be imported by SDK users.
 */ __exportStar(require("3766c6d390d76e30"), exports);

},{"3766c6d390d76e30":"dYQMr"}],"dYQMr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRuntime = void 0;
/**
 * Disclaimer: modules in _shims aren't intended to be imported by SDK users.
 */ const MultipartBody_1 = require("eb7448caada0e9c8");
function getRuntime({ manuallyImported } = {}) {
    const recommendation = manuallyImported ? `You may need to use polyfills` : `Add one of these imports before your first \`import \u{2026} from 'openai'\`:
- \`import 'openai/shims/node'\` (if you're running on Node)
- \`import 'openai/shims/web'\` (otherwise)
`;
    let _fetch, _Request, _Response, _Headers;
    try {
        // @ts-ignore
        _fetch = fetch;
        // @ts-ignore
        _Request = Request;
        // @ts-ignore
        _Response = Response;
        // @ts-ignore
        _Headers = Headers;
    } catch (error) {
        throw new Error(`this environment is missing the following Web Fetch API type: ${error.message}. ${recommendation}`);
    }
    return {
        kind: 'web',
        fetch: _fetch,
        Request: _Request,
        Response: _Response,
        Headers: _Headers,
        FormData: // @ts-ignore
        typeof FormData !== 'undefined' ? FormData : class FormData1 {
            // @ts-ignore
            constructor(){
                throw new Error(`file uploads aren't supported in this environment yet as 'FormData' is undefined. ${recommendation}`);
            }
        },
        Blob: typeof Blob !== 'undefined' ? Blob : class Blob1 {
            constructor(){
                throw new Error(`file uploads aren't supported in this environment yet as 'Blob' is undefined. ${recommendation}`);
            }
        },
        File: // @ts-ignore
        typeof File !== 'undefined' ? File : class File1 {
            // @ts-ignore
            constructor(){
                throw new Error(`file uploads aren't supported in this environment yet as 'File' is undefined. ${recommendation}`);
            }
        },
        ReadableStream: // @ts-ignore
        typeof ReadableStream !== 'undefined' ? ReadableStream : class ReadableStream1 {
            // @ts-ignore
            constructor(){
                throw new Error(`streaming isn't supported in this environment yet as 'ReadableStream' is undefined. ${recommendation}`);
            }
        },
        getMultipartRequestOptions: async (// @ts-ignore
        form, opts)=>({
                ...opts,
                body: new MultipartBody_1.MultipartBody(form)
            }),
        getDefaultAgent: (url)=>undefined,
        fileFromPath: ()=>{
            throw new Error('The `fileFromPath` function is only supported in Node. See the README for more details: https://www.github.com/openai/openai-node#file-uploads');
        },
        isFsReadStream: (value)=>false
    };
}
exports.getRuntime = getRuntime;

},{"eb7448caada0e9c8":"3PrRZ"}],"3PrRZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MultipartBody = void 0;
/**
 * Disclaimer: modules in _shims aren't intended to be imported by SDK users.
 */ class MultipartBody {
    constructor(body){
        this.body = body;
    }
    get [Symbol.toStringTag]() {
        return 'MultipartBody';
    }
}
exports.MultipartBody = MultipartBody;

},{}],"eZWCP":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ContentFilterFinishReasonError = exports.LengthFinishReasonError = exports.InternalServerError = exports.RateLimitError = exports.UnprocessableEntityError = exports.ConflictError = exports.NotFoundError = exports.PermissionDeniedError = exports.AuthenticationError = exports.BadRequestError = exports.APIConnectionTimeoutError = exports.APIConnectionError = exports.APIUserAbortError = exports.APIError = exports.OpenAIError = void 0;
const core_1 = require("f2afcf7da896f8b4");
class OpenAIError extends Error {
}
exports.OpenAIError = OpenAIError;
class APIError extends OpenAIError {
    constructor(status, error, message, headers){
        super(`${APIError.makeMessage(status, error, message)}`);
        this.status = status;
        this.headers = headers;
        this.request_id = headers?.['x-request-id'];
        const data = error;
        this.error = data;
        this.code = data?.['code'];
        this.param = data?.['param'];
        this.type = data?.['type'];
    }
    static makeMessage(status, error, message) {
        const msg = error?.message ? typeof error.message === 'string' ? error.message : JSON.stringify(error.message) : error ? JSON.stringify(error) : message;
        if (status && msg) return `${status} ${msg}`;
        if (status) return `${status} status code (no body)`;
        if (msg) return msg;
        return '(no status code or body)';
    }
    static generate(status, errorResponse, message, headers) {
        if (!status) return new APIConnectionError({
            message,
            cause: (0, core_1.castToError)(errorResponse)
        });
        const error = errorResponse?.['error'];
        if (status === 400) return new BadRequestError(status, error, message, headers);
        if (status === 401) return new AuthenticationError(status, error, message, headers);
        if (status === 403) return new PermissionDeniedError(status, error, message, headers);
        if (status === 404) return new NotFoundError(status, error, message, headers);
        if (status === 409) return new ConflictError(status, error, message, headers);
        if (status === 422) return new UnprocessableEntityError(status, error, message, headers);
        if (status === 429) return new RateLimitError(status, error, message, headers);
        if (status >= 500) return new InternalServerError(status, error, message, headers);
        return new APIError(status, error, message, headers);
    }
}
exports.APIError = APIError;
class APIUserAbortError extends APIError {
    constructor({ message } = {}){
        super(undefined, undefined, message || 'Request was aborted.', undefined);
        this.status = undefined;
    }
}
exports.APIUserAbortError = APIUserAbortError;
class APIConnectionError extends APIError {
    constructor({ message, cause }){
        super(undefined, undefined, message || 'Connection error.', undefined);
        this.status = undefined;
        // in some environments the 'cause' property is already declared
        // @ts-ignore
        if (cause) this.cause = cause;
    }
}
exports.APIConnectionError = APIConnectionError;
class APIConnectionTimeoutError extends APIConnectionError {
    constructor({ message } = {}){
        super({
            message: message ?? 'Request timed out.'
        });
    }
}
exports.APIConnectionTimeoutError = APIConnectionTimeoutError;
class BadRequestError extends APIError {
    constructor(){
        super(...arguments);
        this.status = 400;
    }
}
exports.BadRequestError = BadRequestError;
class AuthenticationError extends APIError {
    constructor(){
        super(...arguments);
        this.status = 401;
    }
}
exports.AuthenticationError = AuthenticationError;
class PermissionDeniedError extends APIError {
    constructor(){
        super(...arguments);
        this.status = 403;
    }
}
exports.PermissionDeniedError = PermissionDeniedError;
class NotFoundError extends APIError {
    constructor(){
        super(...arguments);
        this.status = 404;
    }
}
exports.NotFoundError = NotFoundError;
class ConflictError extends APIError {
    constructor(){
        super(...arguments);
        this.status = 409;
    }
}
exports.ConflictError = ConflictError;
class UnprocessableEntityError extends APIError {
    constructor(){
        super(...arguments);
        this.status = 422;
    }
}
exports.UnprocessableEntityError = UnprocessableEntityError;
class RateLimitError extends APIError {
    constructor(){
        super(...arguments);
        this.status = 429;
    }
}
exports.RateLimitError = RateLimitError;
class InternalServerError extends APIError {
}
exports.InternalServerError = InternalServerError;
class LengthFinishReasonError extends OpenAIError {
    constructor(){
        super(`Could not parse response content as the length limit was reached`);
    }
}
exports.LengthFinishReasonError = LengthFinishReasonError;
class ContentFilterFinishReasonError extends OpenAIError {
    constructor(){
        super(`Could not parse response content as the request was rejected by the content filter`);
    }
}
exports.ContentFilterFinishReasonError = ContentFilterFinishReasonError;

},{"f2afcf7da896f8b4":"SlwjS"}],"aXM9W":[function(require,module,exports,__globalThis) {
var Buffer = require("2ee39b924adb6ad4").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LineDecoder = void 0;
const error_1 = require("bb3a4eee6c6836e8");
/**
 * A re-implementation of httpx's `LineDecoder` in Python that handles incrementally
 * reading lines from text.
 *
 * https://github.com/encode/httpx/blob/920333ea98118e9cf617f246905d7b202510941c/httpx/_decoders.py#L258
 */ class LineDecoder {
    constructor(){
        this.buffer = [];
        this.trailingCR = false;
    }
    decode(chunk) {
        let text = this.decodeText(chunk);
        if (this.trailingCR) {
            text = '\r' + text;
            this.trailingCR = false;
        }
        if (text.endsWith('\r')) {
            this.trailingCR = true;
            text = text.slice(0, -1);
        }
        if (!text) return [];
        const trailingNewline = LineDecoder.NEWLINE_CHARS.has(text[text.length - 1] || '');
        let lines = text.split(LineDecoder.NEWLINE_REGEXP);
        // if there is a trailing new line then the last entry will be an empty
        // string which we don't care about
        if (trailingNewline) lines.pop();
        if (lines.length === 1 && !trailingNewline) {
            this.buffer.push(lines[0]);
            return [];
        }
        if (this.buffer.length > 0) {
            lines = [
                this.buffer.join('') + lines[0],
                ...lines.slice(1)
            ];
            this.buffer = [];
        }
        if (!trailingNewline) this.buffer = [
            lines.pop() || ''
        ];
        return lines;
    }
    decodeText(bytes) {
        if (bytes == null) return '';
        if (typeof bytes === 'string') return bytes;
        // Node:
        if (typeof Buffer !== 'undefined') {
            if (bytes instanceof Buffer) return bytes.toString();
            if (bytes instanceof Uint8Array) return Buffer.from(bytes).toString();
            throw new error_1.OpenAIError(`Unexpected: received non-Uint8Array (${bytes.constructor.name}) stream chunk in an environment with a global "Buffer" defined, which this library assumes to be Node. Please report this error.`);
        }
        // Browser
        if (typeof TextDecoder !== 'undefined') {
            if (bytes instanceof Uint8Array || bytes instanceof ArrayBuffer) {
                this.textDecoder ?? (this.textDecoder = new TextDecoder('utf8'));
                return this.textDecoder.decode(bytes);
            }
            throw new error_1.OpenAIError(`Unexpected: received non-Uint8Array/ArrayBuffer (${bytes.constructor.name}) in a web platform. Please report this error.`);
        }
        throw new error_1.OpenAIError(`Unexpected: neither Buffer nor TextDecoder are available as globals. Please report this error.`);
    }
    flush() {
        if (!this.buffer.length && !this.trailingCR) return [];
        const lines = [
            this.buffer.join('')
        ];
        this.buffer = [];
        this.trailingCR = false;
        return lines;
    }
}
exports.LineDecoder = LineDecoder;
// prettier-ignore
LineDecoder.NEWLINE_CHARS = new Set([
    '\n',
    '\r'
]);
LineDecoder.NEWLINE_REGEXP = /\r\n|[\n\r]/g;

},{"2ee39b924adb6ad4":"l5Twm","bb3a4eee6c6836e8":"eZWCP"}],"j0F04":[function(require,module,exports,__globalThis) {
var Buffer = require("c36b36da7e5ab93").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createForm = exports.multipartFormRequestOptions = exports.maybeMultipartFormRequestOptions = exports.isMultipartBody = exports.toFile = exports.isUploadable = exports.isBlobLike = exports.isFileLike = exports.isResponseLike = exports.fileFromPath = void 0;
const index_1 = require("ca38cd3b898920cd");
var index_2 = require("ca38cd3b898920cd");
Object.defineProperty(exports, "fileFromPath", {
    enumerable: true,
    get: function() {
        return index_2.fileFromPath;
    }
});
const isResponseLike = (value)=>value != null && typeof value === 'object' && typeof value.url === 'string' && typeof value.blob === 'function';
exports.isResponseLike = isResponseLike;
const isFileLike = (value)=>value != null && typeof value === 'object' && typeof value.name === 'string' && typeof value.lastModified === 'number' && (0, exports.isBlobLike)(value);
exports.isFileLike = isFileLike;
/**
 * The BlobLike type omits arrayBuffer() because @types/node-fetch@^2.6.4 lacks it; but this check
 * adds the arrayBuffer() method type because it is available and used at runtime
 */ const isBlobLike = (value)=>value != null && typeof value === 'object' && typeof value.size === 'number' && typeof value.type === 'string' && typeof value.text === 'function' && typeof value.slice === 'function' && typeof value.arrayBuffer === 'function';
exports.isBlobLike = isBlobLike;
const isUploadable = (value)=>{
    return (0, exports.isFileLike)(value) || (0, exports.isResponseLike)(value) || (0, index_1.isFsReadStream)(value);
};
exports.isUploadable = isUploadable;
/**
 * Helper for creating a {@link File} to pass to an SDK upload method from a variety of different data formats
 * @param value the raw content of the file.  Can be an {@link Uploadable}, {@link BlobLikePart}, or {@link AsyncIterable} of {@link BlobLikePart}s
 * @param {string=} name the name of the file. If omitted, toFile will try to determine a file name from bits if possible
 * @param {Object=} options additional properties
 * @param {string=} options.type the MIME type of the content
 * @param {number=} options.lastModified the last modified timestamp
 * @returns a {@link File} with the given properties
 */ async function toFile(value, name, options) {
    // If it's a promise, resolve it.
    value = await value;
    // If we've been given a `File` we don't need to do anything
    if ((0, exports.isFileLike)(value)) return value;
    if ((0, exports.isResponseLike)(value)) {
        const blob = await value.blob();
        name || (name = new URL(value.url).pathname.split(/[\\/]/).pop() ?? 'unknown_file');
        // we need to convert the `Blob` into an array buffer because the `Blob` class
        // that `node-fetch` defines is incompatible with the web standard which results
        // in `new File` interpreting it as a string instead of binary data.
        const data = (0, exports.isBlobLike)(blob) ? [
            await blob.arrayBuffer()
        ] : [
            blob
        ];
        return new index_1.File(data, name, options);
    }
    const bits = await getBytes(value);
    name || (name = getName(value) ?? 'unknown_file');
    if (!options?.type) {
        const type = bits[0]?.type;
        if (typeof type === 'string') options = {
            ...options,
            type
        };
    }
    return new index_1.File(bits, name, options);
}
exports.toFile = toFile;
async function getBytes(value) {
    let parts = [];
    if (typeof value === 'string' || ArrayBuffer.isView(value) || // includes Uint8Array, Buffer, etc.
    value instanceof ArrayBuffer) parts.push(value);
    else if ((0, exports.isBlobLike)(value)) parts.push(await value.arrayBuffer());
    else if (isAsyncIterableIterator(value) // includes Readable, ReadableStream, etc.
    ) for await (const chunk of value)parts.push(chunk); // TODO, consider validating?
    else throw new Error(`Unexpected data type: ${typeof value}; constructor: ${value?.constructor?.name}; props: ${propsForError(value)}`);
    return parts;
}
function propsForError(value) {
    const props = Object.getOwnPropertyNames(value);
    return `[${props.map((p)=>`"${p}"`).join(', ')}]`;
}
function getName(value) {
    return getStringFromMaybeBuffer(value.name) || getStringFromMaybeBuffer(value.filename) || // For fs.ReadStream
    getStringFromMaybeBuffer(value.path)?.split(/[\\/]/).pop();
}
const getStringFromMaybeBuffer = (x)=>{
    if (typeof x === 'string') return x;
    if (typeof Buffer !== 'undefined' && x instanceof Buffer) return String(x);
    return undefined;
};
const isAsyncIterableIterator = (value)=>value != null && typeof value === 'object' && typeof value[Symbol.asyncIterator] === 'function';
const isMultipartBody = (body)=>body && typeof body === 'object' && body.body && body[Symbol.toStringTag] === 'MultipartBody';
exports.isMultipartBody = isMultipartBody;
/**
 * Returns a multipart/form-data request if any part of the given request body contains a File / Blob value.
 * Otherwise returns the request as is.
 */ const maybeMultipartFormRequestOptions = async (opts)=>{
    if (!hasUploadableValue(opts.body)) return opts;
    const form = await (0, exports.createForm)(opts.body);
    return (0, index_1.getMultipartRequestOptions)(form, opts);
};
exports.maybeMultipartFormRequestOptions = maybeMultipartFormRequestOptions;
const multipartFormRequestOptions = async (opts)=>{
    const form = await (0, exports.createForm)(opts.body);
    return (0, index_1.getMultipartRequestOptions)(form, opts);
};
exports.multipartFormRequestOptions = multipartFormRequestOptions;
const createForm = async (body)=>{
    const form = new index_1.FormData();
    await Promise.all(Object.entries(body || {}).map(([key, value])=>addFormValue(form, key, value)));
    return form;
};
exports.createForm = createForm;
const hasUploadableValue = (value)=>{
    if ((0, exports.isUploadable)(value)) return true;
    if (Array.isArray(value)) return value.some(hasUploadableValue);
    if (value && typeof value === 'object') for(const k in value){
        if (hasUploadableValue(value[k])) return true;
    }
    return false;
};
const addFormValue = async (form, key, value)=>{
    if (value === undefined) return;
    if (value == null) throw new TypeError(`Received null for "${key}"; to pass null in FormData, you must use the string 'null'`);
    // TODO: make nested formats configurable
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') form.append(key, String(value));
    else if ((0, exports.isUploadable)(value)) {
        const file = await toFile(value);
        form.append(key, file);
    } else if (Array.isArray(value)) await Promise.all(value.map((entry)=>addFormValue(form, key + '[]', entry)));
    else if (typeof value === 'object') await Promise.all(Object.entries(value).map(([name, prop])=>addFormValue(form, `${key}[${name}]`, prop)));
    else throw new TypeError(`Invalid value given to form, expected a string, number, boolean, object, Array, File or Blob but got ${value} instead`);
};

},{"c36b36da7e5ab93":"l5Twm","ca38cd3b898920cd":"2Uwcc"}],"ksr30":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CursorPage = exports.Page = void 0;
const core_1 = require("a38ae428231f51d7");
/**
 * Note: no pagination actually occurs yet, this is for forwards-compatibility.
 */ class Page extends core_1.AbstractPage {
    constructor(client, response, body, options){
        super(client, response, body, options);
        this.data = body.data || [];
        this.object = body.object;
    }
    getPaginatedItems() {
        return this.data ?? [];
    }
    // @deprecated Please use `nextPageInfo()` instead
    /**
     * This page represents a response that isn't actually paginated at the API level
     * so there will never be any next page params.
     */ nextPageParams() {
        return null;
    }
    nextPageInfo() {
        return null;
    }
}
exports.Page = Page;
class CursorPage extends core_1.AbstractPage {
    constructor(client, response, body, options){
        super(client, response, body, options);
        this.data = body.data || [];
    }
    getPaginatedItems() {
        return this.data ?? [];
    }
    // @deprecated Please use `nextPageInfo()` instead
    nextPageParams() {
        const info = this.nextPageInfo();
        if (!info) return null;
        if ('params' in info) return info.params;
        const params = Object.fromEntries(info.url.searchParams);
        if (!Object.keys(params).length) return null;
        return params;
    }
    nextPageInfo() {
        const data = this.getPaginatedItems();
        if (!data.length) return null;
        const id = data[data.length - 1]?.id;
        if (!id) return null;
        return {
            params: {
                after: id
            }
        };
    }
}
exports.CursorPage = CursorPage;

},{"a38ae428231f51d7":"SlwjS"}],"erfMj":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Uploads = exports.Moderations = exports.Models = exports.ModelsPage = exports.Images = exports.FineTuning = exports.Files = exports.FileObjectsPage = exports.Embeddings = exports.Completions = exports.Beta = exports.Batches = exports.BatchesPage = exports.Audio = void 0;
__exportStar(require("db5d3f46926db1e"), exports);
__exportStar(require("8d56f186c9937308"), exports);
var audio_1 = require("e9d5d4827ddce03f");
Object.defineProperty(exports, "Audio", {
    enumerable: true,
    get: function() {
        return audio_1.Audio;
    }
});
var batches_1 = require("5b56a759c4dfb62d");
Object.defineProperty(exports, "BatchesPage", {
    enumerable: true,
    get: function() {
        return batches_1.BatchesPage;
    }
});
Object.defineProperty(exports, "Batches", {
    enumerable: true,
    get: function() {
        return batches_1.Batches;
    }
});
var beta_1 = require("46a4dba1ae7eedd7");
Object.defineProperty(exports, "Beta", {
    enumerable: true,
    get: function() {
        return beta_1.Beta;
    }
});
var completions_1 = require("cef4ba4fe9ff9765");
Object.defineProperty(exports, "Completions", {
    enumerable: true,
    get: function() {
        return completions_1.Completions;
    }
});
var embeddings_1 = require("f12c849f81a42b81");
Object.defineProperty(exports, "Embeddings", {
    enumerable: true,
    get: function() {
        return embeddings_1.Embeddings;
    }
});
var files_1 = require("6e52071044c45f56");
Object.defineProperty(exports, "FileObjectsPage", {
    enumerable: true,
    get: function() {
        return files_1.FileObjectsPage;
    }
});
Object.defineProperty(exports, "Files", {
    enumerable: true,
    get: function() {
        return files_1.Files;
    }
});
var fine_tuning_1 = require("a24aa51ebba8c7c6");
Object.defineProperty(exports, "FineTuning", {
    enumerable: true,
    get: function() {
        return fine_tuning_1.FineTuning;
    }
});
var images_1 = require("a7ed61e46373ac5");
Object.defineProperty(exports, "Images", {
    enumerable: true,
    get: function() {
        return images_1.Images;
    }
});
var models_1 = require("b0389608b66e2ec9");
Object.defineProperty(exports, "ModelsPage", {
    enumerable: true,
    get: function() {
        return models_1.ModelsPage;
    }
});
Object.defineProperty(exports, "Models", {
    enumerable: true,
    get: function() {
        return models_1.Models;
    }
});
var moderations_1 = require("267f9aea607efa7b");
Object.defineProperty(exports, "Moderations", {
    enumerable: true,
    get: function() {
        return moderations_1.Moderations;
    }
});
var uploads_1 = require("e9f29bec3c13872e");
Object.defineProperty(exports, "Uploads", {
    enumerable: true,
    get: function() {
        return uploads_1.Uploads;
    }
});

},{"db5d3f46926db1e":"gbJnI","8d56f186c9937308":"e0SMS","e9d5d4827ddce03f":"iKRuh","5b56a759c4dfb62d":"gK1jM","46a4dba1ae7eedd7":"kSu5D","cef4ba4fe9ff9765":"eRjoN","f12c849f81a42b81":"FW9ea","6e52071044c45f56":"1J1vk","a24aa51ebba8c7c6":"ibFA3","a7ed61e46373ac5":"avguL","b0389608b66e2ec9":"4Wm3Z","267f9aea607efa7b":"cAV1c","e9f29bec3c13872e":"fROuZ"}],"gbJnI":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Completions = exports.Chat = void 0;
var chat_1 = require("a046273e7b6e1ea3");
Object.defineProperty(exports, "Chat", {
    enumerable: true,
    get: function() {
        return chat_1.Chat;
    }
});
var completions_1 = require("bea33376eae390b");
Object.defineProperty(exports, "Completions", {
    enumerable: true,
    get: function() {
        return completions_1.Completions;
    }
});

},{"a046273e7b6e1ea3":"4zH4G","bea33376eae390b":"aPabp"}],"4zH4G":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Chat = void 0;
const resource_1 = require("1a28e00a0944884f");
const CompletionsAPI = __importStar(require("f29c47e632002179"));
const completions_1 = require("f29c47e632002179");
class Chat extends resource_1.APIResource {
    constructor(){
        super(...arguments);
        this.completions = new CompletionsAPI.Completions(this._client);
    }
}
exports.Chat = Chat;
Chat.Completions = completions_1.Completions;

},{"1a28e00a0944884f":"jx5FL","f29c47e632002179":"aPabp"}],"jx5FL":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.APIResource = void 0;
class APIResource {
    constructor(client){
        this._client = client;
    }
}
exports.APIResource = APIResource;

},{}],"aPabp":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Completions = void 0;
const resource_1 = require("c8884e2f6e1da60e");
class Completions extends resource_1.APIResource {
    create(body, options) {
        return this._client.post('/chat/completions', {
            body,
            ...options,
            stream: body.stream ?? false
        });
    }
}
exports.Completions = Completions;

},{"c8884e2f6e1da60e":"jx5FL"}],"e0SMS":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"iKRuh":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Audio = void 0;
const resource_1 = require("dfb731ecc1f82f92");
const SpeechAPI = __importStar(require("ac19f3db1f8fd0ee"));
const speech_1 = require("ac19f3db1f8fd0ee");
const TranscriptionsAPI = __importStar(require("b20775e3c803ba90"));
const transcriptions_1 = require("b20775e3c803ba90");
const TranslationsAPI = __importStar(require("d44d4341ed12b7cf"));
const translations_1 = require("d44d4341ed12b7cf");
class Audio extends resource_1.APIResource {
    constructor(){
        super(...arguments);
        this.transcriptions = new TranscriptionsAPI.Transcriptions(this._client);
        this.translations = new TranslationsAPI.Translations(this._client);
        this.speech = new SpeechAPI.Speech(this._client);
    }
}
exports.Audio = Audio;
Audio.Transcriptions = transcriptions_1.Transcriptions;
Audio.Translations = translations_1.Translations;
Audio.Speech = speech_1.Speech;

},{"dfb731ecc1f82f92":"jx5FL","ac19f3db1f8fd0ee":"hPlth","b20775e3c803ba90":"6TwxL","d44d4341ed12b7cf":"5a3DT"}],"hPlth":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Speech = void 0;
const resource_1 = require("aec390f02bbb0223");
class Speech extends resource_1.APIResource {
    /**
     * Generates audio from the input text.
     */ create(body, options) {
        return this._client.post('/audio/speech', {
            body,
            ...options,
            __binaryResponse: true
        });
    }
}
exports.Speech = Speech;

},{"aec390f02bbb0223":"jx5FL"}],"6TwxL":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Transcriptions = void 0;
const resource_1 = require("f3f926130cfec2f6");
const Core = __importStar(require("fae742b648cb18d4"));
class Transcriptions extends resource_1.APIResource {
    create(body, options) {
        return this._client.post('/audio/transcriptions', Core.multipartFormRequestOptions({
            body,
            ...options
        }));
    }
}
exports.Transcriptions = Transcriptions;

},{"f3f926130cfec2f6":"jx5FL","fae742b648cb18d4":"SlwjS"}],"5a3DT":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Translations = void 0;
const resource_1 = require("5fc7fcae8666332");
const Core = __importStar(require("8be6480449074f16"));
class Translations extends resource_1.APIResource {
    create(body, options) {
        return this._client.post('/audio/translations', Core.multipartFormRequestOptions({
            body,
            ...options
        }));
    }
}
exports.Translations = Translations;

},{"5fc7fcae8666332":"jx5FL","8be6480449074f16":"SlwjS"}],"gK1jM":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BatchesPage = exports.Batches = void 0;
const resource_1 = require("82235ffda2195b13");
const core_1 = require("a3de6ce932b7d3c1");
const pagination_1 = require("e6a6b913369be19e");
class Batches extends resource_1.APIResource {
    /**
     * Creates and executes a batch from an uploaded file of requests
     */ create(body, options) {
        return this._client.post('/batches', {
            body,
            ...options
        });
    }
    /**
     * Retrieves a batch.
     */ retrieve(batchId, options) {
        return this._client.get(`/batches/${batchId}`, options);
    }
    list(query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.list({}, query);
        return this._client.getAPIList('/batches', BatchesPage, {
            query,
            ...options
        });
    }
    /**
     * Cancels an in-progress batch. The batch will be in status `cancelling` for up to
     * 10 minutes, before changing to `cancelled`, where it will have partial results
     * (if any) available in the output file.
     */ cancel(batchId, options) {
        return this._client.post(`/batches/${batchId}/cancel`, options);
    }
}
exports.Batches = Batches;
class BatchesPage extends pagination_1.CursorPage {
}
exports.BatchesPage = BatchesPage;
Batches.BatchesPage = BatchesPage;

},{"82235ffda2195b13":"jx5FL","a3de6ce932b7d3c1":"SlwjS","e6a6b913369be19e":"ksr30"}],"kSu5D":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Beta = void 0;
const resource_1 = require("939b58fda1e6aacd");
const AssistantsAPI = __importStar(require("6c6a7be4af63c9a7"));
const ChatAPI = __importStar(require("756121247d1b456"));
const assistants_1 = require("6c6a7be4af63c9a7");
const ThreadsAPI = __importStar(require("d9b62b34f4f2cad2"));
const threads_1 = require("d9b62b34f4f2cad2");
const VectorStoresAPI = __importStar(require("6ddd8517a1f23f80"));
const vector_stores_1 = require("6ddd8517a1f23f80");
const chat_1 = require("756121247d1b456");
class Beta extends resource_1.APIResource {
    constructor(){
        super(...arguments);
        this.vectorStores = new VectorStoresAPI.VectorStores(this._client);
        this.chat = new ChatAPI.Chat(this._client);
        this.assistants = new AssistantsAPI.Assistants(this._client);
        this.threads = new ThreadsAPI.Threads(this._client);
    }
}
exports.Beta = Beta;
Beta.VectorStores = vector_stores_1.VectorStores;
Beta.VectorStoresPage = vector_stores_1.VectorStoresPage;
Beta.Assistants = assistants_1.Assistants;
Beta.AssistantsPage = assistants_1.AssistantsPage;
Beta.Threads = threads_1.Threads;

},{"939b58fda1e6aacd":"jx5FL","6c6a7be4af63c9a7":"42n11","756121247d1b456":"aP4AR","d9b62b34f4f2cad2":"gUYwX","6ddd8517a1f23f80":"4WhRT"}],"42n11":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AssistantsPage = exports.Assistants = void 0;
const resource_1 = require("e3a59108f5ab9a4c");
const core_1 = require("3d608d4299650018");
const pagination_1 = require("f063ea69006300f9");
class Assistants extends resource_1.APIResource {
    /**
     * Create an assistant with a model and instructions.
     */ create(body, options) {
        return this._client.post('/assistants', {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Retrieves an assistant.
     */ retrieve(assistantId, options) {
        return this._client.get(`/assistants/${assistantId}`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Modifies an assistant.
     */ update(assistantId, body, options) {
        return this._client.post(`/assistants/${assistantId}`, {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    list(query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.list({}, query);
        return this._client.getAPIList('/assistants', AssistantsPage, {
            query,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Delete an assistant.
     */ del(assistantId, options) {
        return this._client.delete(`/assistants/${assistantId}`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
}
exports.Assistants = Assistants;
class AssistantsPage extends pagination_1.CursorPage {
}
exports.AssistantsPage = AssistantsPage;
Assistants.AssistantsPage = AssistantsPage;

},{"e3a59108f5ab9a4c":"jx5FL","3d608d4299650018":"SlwjS","f063ea69006300f9":"ksr30"}],"aP4AR":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Chat = void 0;
const resource_1 = require("6fdbda68af8fd193");
const CompletionsAPI = __importStar(require("83c180094f5f2448"));
class Chat extends resource_1.APIResource {
    constructor(){
        super(...arguments);
        this.completions = new CompletionsAPI.Completions(this._client);
    }
}
exports.Chat = Chat;
(function(Chat) {
    Chat.Completions = CompletionsAPI.Completions;
})(Chat = exports.Chat || (exports.Chat = {}));

},{"6fdbda68af8fd193":"jx5FL","83c180094f5f2448":"3nQfe"}],"3nQfe":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Completions = exports.ChatCompletionRunner = exports.ChatCompletionStream = exports.ParsingToolFunction = exports.ParsingFunction = exports.ChatCompletionStreamingRunner = void 0;
const resource_1 = require("60b229b9e8d62f6c");
const ChatCompletionRunner_1 = require("bd1709770a117b5b");
const ChatCompletionStreamingRunner_1 = require("6a8af0be2bb53b63");
const ChatCompletionStream_1 = require("b089ea201a13fc20");
const parser_1 = require("471f8ad19861ab31");
var ChatCompletionStreamingRunner_2 = require("6a8af0be2bb53b63");
Object.defineProperty(exports, "ChatCompletionStreamingRunner", {
    enumerable: true,
    get: function() {
        return ChatCompletionStreamingRunner_2.ChatCompletionStreamingRunner;
    }
});
var RunnableFunction_1 = require("29358d3ea6dcd5ea");
Object.defineProperty(exports, "ParsingFunction", {
    enumerable: true,
    get: function() {
        return RunnableFunction_1.ParsingFunction;
    }
});
Object.defineProperty(exports, "ParsingToolFunction", {
    enumerable: true,
    get: function() {
        return RunnableFunction_1.ParsingToolFunction;
    }
});
var ChatCompletionStream_2 = require("b089ea201a13fc20");
Object.defineProperty(exports, "ChatCompletionStream", {
    enumerable: true,
    get: function() {
        return ChatCompletionStream_2.ChatCompletionStream;
    }
});
var ChatCompletionRunner_2 = require("bd1709770a117b5b");
Object.defineProperty(exports, "ChatCompletionRunner", {
    enumerable: true,
    get: function() {
        return ChatCompletionRunner_2.ChatCompletionRunner;
    }
});
class Completions extends resource_1.APIResource {
    parse(body, options) {
        (0, parser_1.validateInputTools)(body.tools);
        return this._client.chat.completions.create(body, {
            ...options,
            headers: {
                ...options?.headers,
                'X-Stainless-Helper-Method': 'beta.chat.completions.parse'
            }
        })._thenUnwrap((completion)=>(0, parser_1.parseChatCompletion)(completion, body));
    }
    runFunctions(body, options) {
        if (body.stream) return ChatCompletionStreamingRunner_1.ChatCompletionStreamingRunner.runFunctions(this._client, body, options);
        return ChatCompletionRunner_1.ChatCompletionRunner.runFunctions(this._client, body, options);
    }
    runTools(body, options) {
        if (body.stream) return ChatCompletionStreamingRunner_1.ChatCompletionStreamingRunner.runTools(this._client, body, options);
        return ChatCompletionRunner_1.ChatCompletionRunner.runTools(this._client, body, options);
    }
    /**
     * Creates a chat completion stream
     */ stream(body, options) {
        return ChatCompletionStream_1.ChatCompletionStream.createChatCompletion(this._client, body, options);
    }
}
exports.Completions = Completions;

},{"60b229b9e8d62f6c":"jx5FL","bd1709770a117b5b":"kyg88","6a8af0be2bb53b63":"9ptVl","b089ea201a13fc20":"no6hD","471f8ad19861ab31":"2rHDe","29358d3ea6dcd5ea":"3nYHd"}],"kyg88":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChatCompletionRunner = void 0;
const AbstractChatCompletionRunner_1 = require("2647c005cf948bd9");
const chatCompletionUtils_1 = require("89f381d1f373f6b6");
class ChatCompletionRunner extends AbstractChatCompletionRunner_1.AbstractChatCompletionRunner {
    /** @deprecated - please use `runTools` instead. */ static runFunctions(client, params, options) {
        const runner = new ChatCompletionRunner();
        const opts = {
            ...options,
            headers: {
                ...options?.headers,
                'X-Stainless-Helper-Method': 'runFunctions'
            }
        };
        runner._run(()=>runner._runFunctions(client, params, opts));
        return runner;
    }
    static runTools(client, params, options) {
        const runner = new ChatCompletionRunner();
        const opts = {
            ...options,
            headers: {
                ...options?.headers,
                'X-Stainless-Helper-Method': 'runTools'
            }
        };
        runner._run(()=>runner._runTools(client, params, opts));
        return runner;
    }
    _addMessage(message, emit = true) {
        super._addMessage(message, emit);
        if ((0, chatCompletionUtils_1.isAssistantMessage)(message) && message.content) this._emit('content', message.content);
    }
}
exports.ChatCompletionRunner = ChatCompletionRunner;

},{"2647c005cf948bd9":"24Ue2","89f381d1f373f6b6":"jO4bO"}],"24Ue2":[function(require,module,exports,__globalThis) {
"use strict";
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AbstractChatCompletionRunner_instances, _AbstractChatCompletionRunner_getFinalContent, _AbstractChatCompletionRunner_getFinalMessage, _AbstractChatCompletionRunner_getFinalFunctionCall, _AbstractChatCompletionRunner_getFinalFunctionCallResult, _AbstractChatCompletionRunner_calculateTotalUsage, _AbstractChatCompletionRunner_validateParams, _AbstractChatCompletionRunner_stringifyFunctionCallResult;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AbstractChatCompletionRunner = void 0;
const error_1 = require("abe062b849aaeac6");
const RunnableFunction_1 = require("34515f0daf0a04dd");
const chatCompletionUtils_1 = require("cd0bbc7e1184dd6b");
const EventStream_1 = require("68d604f97454765f");
const parser_1 = require("bd01c7dadda87c65");
const DEFAULT_MAX_CHAT_COMPLETIONS = 10;
class AbstractChatCompletionRunner extends EventStream_1.EventStream {
    constructor(){
        super(...arguments);
        _AbstractChatCompletionRunner_instances.add(this);
        this._chatCompletions = [];
        this.messages = [];
    }
    _addChatCompletion(chatCompletion) {
        this._chatCompletions.push(chatCompletion);
        this._emit('chatCompletion', chatCompletion);
        const message = chatCompletion.choices[0]?.message;
        if (message) this._addMessage(message);
        return chatCompletion;
    }
    _addMessage(message, emit = true) {
        if (!('content' in message)) message.content = null;
        this.messages.push(message);
        if (emit) {
            this._emit('message', message);
            if (((0, chatCompletionUtils_1.isFunctionMessage)(message) || (0, chatCompletionUtils_1.isToolMessage)(message)) && message.content) // Note, this assumes that {role: 'tool', content: …} is always the result of a call of tool of type=function.
            this._emit('functionCallResult', message.content);
            else if ((0, chatCompletionUtils_1.isAssistantMessage)(message) && message.function_call) this._emit('functionCall', message.function_call);
            else if ((0, chatCompletionUtils_1.isAssistantMessage)(message) && message.tool_calls) {
                for (const tool_call of message.tool_calls)if (tool_call.type === 'function') this._emit('functionCall', tool_call.function);
            }
        }
    }
    /**
     * @returns a promise that resolves with the final ChatCompletion, or rejects
     * if an error occurred or the stream ended prematurely without producing a ChatCompletion.
     */ async finalChatCompletion() {
        await this.done();
        const completion = this._chatCompletions[this._chatCompletions.length - 1];
        if (!completion) throw new error_1.OpenAIError('stream ended without producing a ChatCompletion');
        return completion;
    }
    /**
     * @returns a promise that resolves with the content of the final ChatCompletionMessage, or rejects
     * if an error occurred or the stream ended prematurely without producing a ChatCompletionMessage.
     */ async finalContent() {
        await this.done();
        return __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_getFinalContent).call(this);
    }
    /**
     * @returns a promise that resolves with the the final assistant ChatCompletionMessage response,
     * or rejects if an error occurred or the stream ended prematurely without producing a ChatCompletionMessage.
     */ async finalMessage() {
        await this.done();
        return __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_getFinalMessage).call(this);
    }
    /**
     * @returns a promise that resolves with the content of the final FunctionCall, or rejects
     * if an error occurred or the stream ended prematurely without producing a ChatCompletionMessage.
     */ async finalFunctionCall() {
        await this.done();
        return __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_getFinalFunctionCall).call(this);
    }
    async finalFunctionCallResult() {
        await this.done();
        return __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_getFinalFunctionCallResult).call(this);
    }
    async totalUsage() {
        await this.done();
        return __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_calculateTotalUsage).call(this);
    }
    allChatCompletions() {
        return [
            ...this._chatCompletions
        ];
    }
    _emitFinal() {
        const completion = this._chatCompletions[this._chatCompletions.length - 1];
        if (completion) this._emit('finalChatCompletion', completion);
        const finalMessage = __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_getFinalMessage).call(this);
        if (finalMessage) this._emit('finalMessage', finalMessage);
        const finalContent = __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_getFinalContent).call(this);
        if (finalContent) this._emit('finalContent', finalContent);
        const finalFunctionCall = __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_getFinalFunctionCall).call(this);
        if (finalFunctionCall) this._emit('finalFunctionCall', finalFunctionCall);
        const finalFunctionCallResult = __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_getFinalFunctionCallResult).call(this);
        if (finalFunctionCallResult != null) this._emit('finalFunctionCallResult', finalFunctionCallResult);
        if (this._chatCompletions.some((c)=>c.usage)) this._emit('totalUsage', __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_calculateTotalUsage).call(this));
    }
    async _createChatCompletion(client, params, options) {
        const signal = options?.signal;
        if (signal) {
            if (signal.aborted) this.controller.abort();
            signal.addEventListener('abort', ()=>this.controller.abort());
        }
        __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_validateParams).call(this, params);
        const chatCompletion = await client.chat.completions.create({
            ...params,
            stream: false
        }, {
            ...options,
            signal: this.controller.signal
        });
        this._connected();
        return this._addChatCompletion((0, parser_1.parseChatCompletion)(chatCompletion, params));
    }
    async _runChatCompletion(client, params, options) {
        for (const message of params.messages)this._addMessage(message, false);
        return await this._createChatCompletion(client, params, options);
    }
    async _runFunctions(client, params, options) {
        const role = 'function';
        const { function_call = 'auto', stream, ...restParams } = params;
        const singleFunctionToCall = typeof function_call !== 'string' && function_call?.name;
        const { maxChatCompletions = DEFAULT_MAX_CHAT_COMPLETIONS } = options || {};
        const functionsByName = {};
        for (const f of params.functions)functionsByName[f.name || f.function.name] = f;
        const functions = params.functions.map((f)=>({
                name: f.name || f.function.name,
                parameters: f.parameters,
                description: f.description
            }));
        for (const message of params.messages)this._addMessage(message, false);
        for(let i = 0; i < maxChatCompletions; ++i){
            const chatCompletion = await this._createChatCompletion(client, {
                ...restParams,
                function_call,
                functions,
                messages: [
                    ...this.messages
                ]
            }, options);
            const message = chatCompletion.choices[0]?.message;
            if (!message) throw new error_1.OpenAIError(`missing message in ChatCompletion response`);
            if (!message.function_call) return;
            const { name, arguments: args } = message.function_call;
            const fn = functionsByName[name];
            if (!fn) {
                const content = `Invalid function_call: ${JSON.stringify(name)}. Available options are: ${functions.map((f)=>JSON.stringify(f.name)).join(', ')}. Please try again`;
                this._addMessage({
                    role,
                    name,
                    content
                });
                continue;
            } else if (singleFunctionToCall && singleFunctionToCall !== name) {
                const content = `Invalid function_call: ${JSON.stringify(name)}. ${JSON.stringify(singleFunctionToCall)} requested. Please try again`;
                this._addMessage({
                    role,
                    name,
                    content
                });
                continue;
            }
            let parsed;
            try {
                parsed = (0, RunnableFunction_1.isRunnableFunctionWithParse)(fn) ? await fn.parse(args) : args;
            } catch (error) {
                this._addMessage({
                    role,
                    name,
                    content: error instanceof Error ? error.message : String(error)
                });
                continue;
            }
            // @ts-expect-error it can't rule out `never` type.
            const rawContent = await fn.function(parsed, this);
            const content = __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_stringifyFunctionCallResult).call(this, rawContent);
            this._addMessage({
                role,
                name,
                content
            });
            if (singleFunctionToCall) return;
        }
    }
    async _runTools(client, params, options) {
        const role = 'tool';
        const { tool_choice = 'auto', stream, ...restParams } = params;
        const singleFunctionToCall = typeof tool_choice !== 'string' && tool_choice?.function?.name;
        const { maxChatCompletions = DEFAULT_MAX_CHAT_COMPLETIONS } = options || {};
        // TODO(someday): clean this logic up
        const inputTools = params.tools.map((tool)=>{
            if ((0, parser_1.isAutoParsableTool)(tool)) {
                if (!tool.$callback) throw new error_1.OpenAIError('Tool given to `.runTools()` that does not have an associated function');
                return {
                    type: 'function',
                    function: {
                        function: tool.$callback,
                        name: tool.function.name,
                        description: tool.function.description || '',
                        parameters: tool.function.parameters,
                        parse: tool.$parseRaw,
                        strict: true
                    }
                };
            }
            return tool;
        });
        const functionsByName = {};
        for (const f of inputTools)if (f.type === 'function') functionsByName[f.function.name || f.function.function.name] = f.function;
        const tools = 'tools' in params ? inputTools.map((t)=>t.type === 'function' ? {
                type: 'function',
                function: {
                    name: t.function.name || t.function.function.name,
                    parameters: t.function.parameters,
                    description: t.function.description,
                    strict: t.function.strict
                }
            } : t) : undefined;
        for (const message of params.messages)this._addMessage(message, false);
        for(let i = 0; i < maxChatCompletions; ++i){
            const chatCompletion = await this._createChatCompletion(client, {
                ...restParams,
                tool_choice,
                tools,
                messages: [
                    ...this.messages
                ]
            }, options);
            const message = chatCompletion.choices[0]?.message;
            if (!message) throw new error_1.OpenAIError(`missing message in ChatCompletion response`);
            if (!message.tool_calls?.length) return;
            for (const tool_call of message.tool_calls){
                if (tool_call.type !== 'function') continue;
                const tool_call_id = tool_call.id;
                const { name, arguments: args } = tool_call.function;
                const fn = functionsByName[name];
                if (!fn) {
                    const content = `Invalid tool_call: ${JSON.stringify(name)}. Available options are: ${Object.keys(functionsByName).map((name)=>JSON.stringify(name)).join(', ')}. Please try again`;
                    this._addMessage({
                        role,
                        tool_call_id,
                        content
                    });
                    continue;
                } else if (singleFunctionToCall && singleFunctionToCall !== name) {
                    const content = `Invalid tool_call: ${JSON.stringify(name)}. ${JSON.stringify(singleFunctionToCall)} requested. Please try again`;
                    this._addMessage({
                        role,
                        tool_call_id,
                        content
                    });
                    continue;
                }
                let parsed;
                try {
                    parsed = (0, RunnableFunction_1.isRunnableFunctionWithParse)(fn) ? await fn.parse(args) : args;
                } catch (error) {
                    const content = error instanceof Error ? error.message : String(error);
                    this._addMessage({
                        role,
                        tool_call_id,
                        content
                    });
                    continue;
                }
                // @ts-expect-error it can't rule out `never` type.
                const rawContent = await fn.function(parsed, this);
                const content = __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_stringifyFunctionCallResult).call(this, rawContent);
                this._addMessage({
                    role,
                    tool_call_id,
                    content
                });
                if (singleFunctionToCall) return;
            }
        }
        return;
    }
}
exports.AbstractChatCompletionRunner = AbstractChatCompletionRunner;
_AbstractChatCompletionRunner_instances = new WeakSet(), _AbstractChatCompletionRunner_getFinalContent = function _AbstractChatCompletionRunner_getFinalContent() {
    return __classPrivateFieldGet(this, _AbstractChatCompletionRunner_instances, "m", _AbstractChatCompletionRunner_getFinalMessage).call(this).content ?? null;
}, _AbstractChatCompletionRunner_getFinalMessage = function _AbstractChatCompletionRunner_getFinalMessage() {
    let i = this.messages.length;
    while(i-- > 0){
        const message = this.messages[i];
        if ((0, chatCompletionUtils_1.isAssistantMessage)(message)) {
            const { function_call, ...rest } = message;
            // TODO: support audio here
            const ret = {
                ...rest,
                content: message.content ?? null,
                refusal: message.refusal ?? null
            };
            if (function_call) ret.function_call = function_call;
            return ret;
        }
    }
    throw new error_1.OpenAIError('stream ended without producing a ChatCompletionMessage with role=assistant');
}, _AbstractChatCompletionRunner_getFinalFunctionCall = function _AbstractChatCompletionRunner_getFinalFunctionCall() {
    for(let i = this.messages.length - 1; i >= 0; i--){
        const message = this.messages[i];
        if ((0, chatCompletionUtils_1.isAssistantMessage)(message) && message?.function_call) return message.function_call;
        if ((0, chatCompletionUtils_1.isAssistantMessage)(message) && message?.tool_calls?.length) return message.tool_calls.at(-1)?.function;
    }
    return;
}, _AbstractChatCompletionRunner_getFinalFunctionCallResult = function _AbstractChatCompletionRunner_getFinalFunctionCallResult() {
    for(let i = this.messages.length - 1; i >= 0; i--){
        const message = this.messages[i];
        if ((0, chatCompletionUtils_1.isFunctionMessage)(message) && message.content != null) return message.content;
        if ((0, chatCompletionUtils_1.isToolMessage)(message) && message.content != null && typeof message.content === 'string' && this.messages.some((x)=>x.role === 'assistant' && x.tool_calls?.some((y)=>y.type === 'function' && y.id === message.tool_call_id))) return message.content;
    }
    return;
}, _AbstractChatCompletionRunner_calculateTotalUsage = function _AbstractChatCompletionRunner_calculateTotalUsage() {
    const total = {
        completion_tokens: 0,
        prompt_tokens: 0,
        total_tokens: 0
    };
    for (const { usage } of this._chatCompletions)if (usage) {
        total.completion_tokens += usage.completion_tokens;
        total.prompt_tokens += usage.prompt_tokens;
        total.total_tokens += usage.total_tokens;
    }
    return total;
}, _AbstractChatCompletionRunner_validateParams = function _AbstractChatCompletionRunner_validateParams(params) {
    if (params.n != null && params.n > 1) throw new error_1.OpenAIError('ChatCompletion convenience helpers only support n=1 at this time. To use n>1, please use chat.completions.create() directly.');
}, _AbstractChatCompletionRunner_stringifyFunctionCallResult = function _AbstractChatCompletionRunner_stringifyFunctionCallResult(rawContent) {
    return typeof rawContent === 'string' ? rawContent : rawContent === undefined ? 'undefined' : JSON.stringify(rawContent);
};

},{"abe062b849aaeac6":"eZWCP","34515f0daf0a04dd":"3nYHd","cd0bbc7e1184dd6b":"jO4bO","68d604f97454765f":"bWb4j","bd01c7dadda87c65":"2rHDe"}],"3nYHd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ParsingToolFunction = exports.ParsingFunction = exports.isRunnableFunctionWithParse = void 0;
function isRunnableFunctionWithParse(fn) {
    return typeof fn.parse === 'function';
}
exports.isRunnableFunctionWithParse = isRunnableFunctionWithParse;
/**
 * This is helper class for passing a `function` and `parse` where the `function`
 * argument type matches the `parse` return type.
 *
 * @deprecated - please use ParsingToolFunction instead.
 */ class ParsingFunction {
    constructor(input){
        this.function = input.function;
        this.parse = input.parse;
        this.parameters = input.parameters;
        this.description = input.description;
        this.name = input.name;
    }
}
exports.ParsingFunction = ParsingFunction;
/**
 * This is helper class for passing a `function` and `parse` where the `function`
 * argument type matches the `parse` return type.
 */ class ParsingToolFunction {
    constructor(input){
        this.type = 'function';
        this.function = input;
    }
}
exports.ParsingToolFunction = ParsingToolFunction;

},{}],"jO4bO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isPresent = exports.isToolMessage = exports.isFunctionMessage = exports.isAssistantMessage = void 0;
const isAssistantMessage = (message)=>{
    return message?.role === 'assistant';
};
exports.isAssistantMessage = isAssistantMessage;
const isFunctionMessage = (message)=>{
    return message?.role === 'function';
};
exports.isFunctionMessage = isFunctionMessage;
const isToolMessage = (message)=>{
    return message?.role === 'tool';
};
exports.isToolMessage = isToolMessage;
function isPresent(obj) {
    return obj != null;
}
exports.isPresent = isPresent;

},{}],"bWb4j":[function(require,module,exports,__globalThis) {
"use strict";
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _EventStream_instances, _EventStream_connectedPromise, _EventStream_resolveConnectedPromise, _EventStream_rejectConnectedPromise, _EventStream_endPromise, _EventStream_resolveEndPromise, _EventStream_rejectEndPromise, _EventStream_listeners, _EventStream_ended, _EventStream_errored, _EventStream_aborted, _EventStream_catchingPromiseCreated, _EventStream_handleError;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventStream = void 0;
const error_1 = require("f21ad7dd9589da8e");
class EventStream {
    constructor(){
        _EventStream_instances.add(this);
        this.controller = new AbortController();
        _EventStream_connectedPromise.set(this, void 0);
        _EventStream_resolveConnectedPromise.set(this, ()=>{});
        _EventStream_rejectConnectedPromise.set(this, ()=>{});
        _EventStream_endPromise.set(this, void 0);
        _EventStream_resolveEndPromise.set(this, ()=>{});
        _EventStream_rejectEndPromise.set(this, ()=>{});
        _EventStream_listeners.set(this, {});
        _EventStream_ended.set(this, false);
        _EventStream_errored.set(this, false);
        _EventStream_aborted.set(this, false);
        _EventStream_catchingPromiseCreated.set(this, false);
        __classPrivateFieldSet(this, _EventStream_connectedPromise, new Promise((resolve, reject)=>{
            __classPrivateFieldSet(this, _EventStream_resolveConnectedPromise, resolve, "f");
            __classPrivateFieldSet(this, _EventStream_rejectConnectedPromise, reject, "f");
        }), "f");
        __classPrivateFieldSet(this, _EventStream_endPromise, new Promise((resolve, reject)=>{
            __classPrivateFieldSet(this, _EventStream_resolveEndPromise, resolve, "f");
            __classPrivateFieldSet(this, _EventStream_rejectEndPromise, reject, "f");
        }), "f");
        // Don't let these promises cause unhandled rejection errors.
        // we will manually cause an unhandled rejection error later
        // if the user hasn't registered any error listener or called
        // any promise-returning method.
        __classPrivateFieldGet(this, _EventStream_connectedPromise, "f").catch(()=>{});
        __classPrivateFieldGet(this, _EventStream_endPromise, "f").catch(()=>{});
    }
    _run(executor) {
        // Unfortunately if we call `executor()` immediately we get runtime errors about
        // references to `this` before the `super()` constructor call returns.
        setTimeout(()=>{
            executor().then(()=>{
                this._emitFinal();
                this._emit('end');
            }, __classPrivateFieldGet(this, _EventStream_instances, "m", _EventStream_handleError).bind(this));
        }, 0);
    }
    _connected() {
        if (this.ended) return;
        __classPrivateFieldGet(this, _EventStream_resolveConnectedPromise, "f").call(this);
        this._emit('connect');
    }
    get ended() {
        return __classPrivateFieldGet(this, _EventStream_ended, "f");
    }
    get errored() {
        return __classPrivateFieldGet(this, _EventStream_errored, "f");
    }
    get aborted() {
        return __classPrivateFieldGet(this, _EventStream_aborted, "f");
    }
    abort() {
        this.controller.abort();
    }
    /**
     * Adds the listener function to the end of the listeners array for the event.
     * No checks are made to see if the listener has already been added. Multiple calls passing
     * the same combination of event and listener will result in the listener being added, and
     * called, multiple times.
     * @returns this ChatCompletionStream, so that calls can be chained
     */ on(event, listener) {
        const listeners = __classPrivateFieldGet(this, _EventStream_listeners, "f")[event] || (__classPrivateFieldGet(this, _EventStream_listeners, "f")[event] = []);
        listeners.push({
            listener
        });
        return this;
    }
    /**
     * Removes the specified listener from the listener array for the event.
     * off() will remove, at most, one instance of a listener from the listener array. If any single
     * listener has been added multiple times to the listener array for the specified event, then
     * off() must be called multiple times to remove each instance.
     * @returns this ChatCompletionStream, so that calls can be chained
     */ off(event, listener) {
        const listeners = __classPrivateFieldGet(this, _EventStream_listeners, "f")[event];
        if (!listeners) return this;
        const index = listeners.findIndex((l)=>l.listener === listener);
        if (index >= 0) listeners.splice(index, 1);
        return this;
    }
    /**
     * Adds a one-time listener function for the event. The next time the event is triggered,
     * this listener is removed and then invoked.
     * @returns this ChatCompletionStream, so that calls can be chained
     */ once(event, listener) {
        const listeners = __classPrivateFieldGet(this, _EventStream_listeners, "f")[event] || (__classPrivateFieldGet(this, _EventStream_listeners, "f")[event] = []);
        listeners.push({
            listener,
            once: true
        });
        return this;
    }
    /**
     * This is similar to `.once()`, but returns a Promise that resolves the next time
     * the event is triggered, instead of calling a listener callback.
     * @returns a Promise that resolves the next time given event is triggered,
     * or rejects if an error is emitted.  (If you request the 'error' event,
     * returns a promise that resolves with the error).
     *
     * Example:
     *
     *   const message = await stream.emitted('message') // rejects if the stream errors
     */ emitted(event) {
        return new Promise((resolve, reject)=>{
            __classPrivateFieldSet(this, _EventStream_catchingPromiseCreated, true, "f");
            if (event !== 'error') this.once('error', reject);
            this.once(event, resolve);
        });
    }
    async done() {
        __classPrivateFieldSet(this, _EventStream_catchingPromiseCreated, true, "f");
        await __classPrivateFieldGet(this, _EventStream_endPromise, "f");
    }
    _emit(event, ...args) {
        // make sure we don't emit any events after end
        if (__classPrivateFieldGet(this, _EventStream_ended, "f")) return;
        if (event === 'end') {
            __classPrivateFieldSet(this, _EventStream_ended, true, "f");
            __classPrivateFieldGet(this, _EventStream_resolveEndPromise, "f").call(this);
        }
        const listeners = __classPrivateFieldGet(this, _EventStream_listeners, "f")[event];
        if (listeners) {
            __classPrivateFieldGet(this, _EventStream_listeners, "f")[event] = listeners.filter((l)=>!l.once);
            listeners.forEach(({ listener })=>listener(...args));
        }
        if (event === 'abort') {
            const error = args[0];
            if (!__classPrivateFieldGet(this, _EventStream_catchingPromiseCreated, "f") && !listeners?.length) Promise.reject(error);
            __classPrivateFieldGet(this, _EventStream_rejectConnectedPromise, "f").call(this, error);
            __classPrivateFieldGet(this, _EventStream_rejectEndPromise, "f").call(this, error);
            this._emit('end');
            return;
        }
        if (event === 'error') {
            // NOTE: _emit('error', error) should only be called from #handleError().
            const error = args[0];
            if (!__classPrivateFieldGet(this, _EventStream_catchingPromiseCreated, "f") && !listeners?.length) // Trigger an unhandled rejection if the user hasn't registered any error handlers.
            // If you are seeing stack traces here, make sure to handle errors via either:
            // - runner.on('error', () => ...)
            // - await runner.done()
            // - await runner.finalChatCompletion()
            // - etc.
            Promise.reject(error);
            __classPrivateFieldGet(this, _EventStream_rejectConnectedPromise, "f").call(this, error);
            __classPrivateFieldGet(this, _EventStream_rejectEndPromise, "f").call(this, error);
            this._emit('end');
        }
    }
    _emitFinal() {}
}
exports.EventStream = EventStream;
_EventStream_connectedPromise = new WeakMap(), _EventStream_resolveConnectedPromise = new WeakMap(), _EventStream_rejectConnectedPromise = new WeakMap(), _EventStream_endPromise = new WeakMap(), _EventStream_resolveEndPromise = new WeakMap(), _EventStream_rejectEndPromise = new WeakMap(), _EventStream_listeners = new WeakMap(), _EventStream_ended = new WeakMap(), _EventStream_errored = new WeakMap(), _EventStream_aborted = new WeakMap(), _EventStream_catchingPromiseCreated = new WeakMap(), _EventStream_instances = new WeakSet(), _EventStream_handleError = function _EventStream_handleError(error) {
    __classPrivateFieldSet(this, _EventStream_errored, true, "f");
    if (error instanceof Error && error.name === 'AbortError') error = new error_1.APIUserAbortError();
    if (error instanceof error_1.APIUserAbortError) {
        __classPrivateFieldSet(this, _EventStream_aborted, true, "f");
        return this._emit('abort', error);
    }
    if (error instanceof error_1.OpenAIError) return this._emit('error', error);
    if (error instanceof Error) {
        const openAIError = new error_1.OpenAIError(error.message);
        // @ts-ignore
        openAIError.cause = error;
        return this._emit('error', openAIError);
    }
    return this._emit('error', new error_1.OpenAIError(String(error)));
};

},{"f21ad7dd9589da8e":"eZWCP"}],"2rHDe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateInputTools = exports.hasAutoParseableInput = exports.shouldParseToolCall = exports.parseChatCompletion = exports.maybeParseChatCompletion = exports.isAutoParsableTool = exports.makeParseableTool = exports.isAutoParsableResponseFormat = exports.makeParseableResponseFormat = void 0;
const error_1 = require("c26c7aca5a8dd13e");
function makeParseableResponseFormat(response_format, parser) {
    const obj = {
        ...response_format
    };
    Object.defineProperties(obj, {
        $brand: {
            value: 'auto-parseable-response-format',
            enumerable: false
        },
        $parseRaw: {
            value: parser,
            enumerable: false
        }
    });
    return obj;
}
exports.makeParseableResponseFormat = makeParseableResponseFormat;
function isAutoParsableResponseFormat(response_format) {
    return response_format?.['$brand'] === 'auto-parseable-response-format';
}
exports.isAutoParsableResponseFormat = isAutoParsableResponseFormat;
function makeParseableTool(tool, { parser, callback }) {
    const obj = {
        ...tool
    };
    Object.defineProperties(obj, {
        $brand: {
            value: 'auto-parseable-tool',
            enumerable: false
        },
        $parseRaw: {
            value: parser,
            enumerable: false
        },
        $callback: {
            value: callback,
            enumerable: false
        }
    });
    return obj;
}
exports.makeParseableTool = makeParseableTool;
function isAutoParsableTool(tool) {
    return tool?.['$brand'] === 'auto-parseable-tool';
}
exports.isAutoParsableTool = isAutoParsableTool;
function maybeParseChatCompletion(completion, params) {
    if (!params || !hasAutoParseableInput(params)) return {
        ...completion,
        choices: completion.choices.map((choice)=>({
                ...choice,
                message: {
                    ...choice.message,
                    parsed: null,
                    tool_calls: choice.message.tool_calls ?? []
                }
            }))
    };
    return parseChatCompletion(completion, params);
}
exports.maybeParseChatCompletion = maybeParseChatCompletion;
function parseChatCompletion(completion, params) {
    const choices = completion.choices.map((choice)=>{
        if (choice.finish_reason === 'length') throw new error_1.LengthFinishReasonError();
        if (choice.finish_reason === 'content_filter') throw new error_1.ContentFilterFinishReasonError();
        return {
            ...choice,
            message: {
                ...choice.message,
                tool_calls: choice.message.tool_calls?.map((toolCall)=>parseToolCall(params, toolCall)) ?? [],
                parsed: choice.message.content && !choice.message.refusal ? parseResponseFormat(params, choice.message.content) : null
            }
        };
    });
    return {
        ...completion,
        choices
    };
}
exports.parseChatCompletion = parseChatCompletion;
function parseResponseFormat(params, content) {
    if (params.response_format?.type !== 'json_schema') return null;
    if (params.response_format?.type === 'json_schema') {
        if ('$parseRaw' in params.response_format) {
            const response_format = params.response_format;
            return response_format.$parseRaw(content);
        }
        return JSON.parse(content);
    }
    return null;
}
function parseToolCall(params, toolCall) {
    const inputTool = params.tools?.find((inputTool)=>inputTool.function?.name === toolCall.function.name);
    return {
        ...toolCall,
        function: {
            ...toolCall.function,
            parsed_arguments: isAutoParsableTool(inputTool) ? inputTool.$parseRaw(toolCall.function.arguments) : inputTool?.function.strict ? JSON.parse(toolCall.function.arguments) : null
        }
    };
}
function shouldParseToolCall(params, toolCall) {
    if (!params) return false;
    const inputTool = params.tools?.find((inputTool)=>inputTool.function?.name === toolCall.function.name);
    return isAutoParsableTool(inputTool) || inputTool?.function.strict || false;
}
exports.shouldParseToolCall = shouldParseToolCall;
function hasAutoParseableInput(params) {
    if (isAutoParsableResponseFormat(params.response_format)) return true;
    return params.tools?.some((t)=>isAutoParsableTool(t) || t.type === 'function' && t.function.strict === true) ?? false;
}
exports.hasAutoParseableInput = hasAutoParseableInput;
function validateInputTools(tools) {
    for (const tool of tools ?? []){
        if (tool.type !== 'function') throw new error_1.OpenAIError(`Currently only \`function\` tool types support auto-parsing; Received \`${tool.type}\``);
        if (tool.function.strict !== true) throw new error_1.OpenAIError(`The \`${tool.function.name}\` tool is not marked with \`strict: true\`. Only strict function tools can be auto-parsed`);
    }
}
exports.validateInputTools = validateInputTools;

},{"c26c7aca5a8dd13e":"eZWCP"}],"9ptVl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChatCompletionStreamingRunner = void 0;
const ChatCompletionStream_1 = require("d9dde4bc4fd281e4");
class ChatCompletionStreamingRunner extends ChatCompletionStream_1.ChatCompletionStream {
    static fromReadableStream(stream) {
        const runner = new ChatCompletionStreamingRunner(null);
        runner._run(()=>runner._fromReadableStream(stream));
        return runner;
    }
    /** @deprecated - please use `runTools` instead. */ static runFunctions(client, params, options) {
        const runner = new ChatCompletionStreamingRunner(null);
        const opts = {
            ...options,
            headers: {
                ...options?.headers,
                'X-Stainless-Helper-Method': 'runFunctions'
            }
        };
        runner._run(()=>runner._runFunctions(client, params, opts));
        return runner;
    }
    static runTools(client, params, options) {
        const runner = new ChatCompletionStreamingRunner(// @ts-expect-error TODO these types are incompatible
        params);
        const opts = {
            ...options,
            headers: {
                ...options?.headers,
                'X-Stainless-Helper-Method': 'runTools'
            }
        };
        runner._run(()=>runner._runTools(client, params, opts));
        return runner;
    }
}
exports.ChatCompletionStreamingRunner = ChatCompletionStreamingRunner;

},{"d9dde4bc4fd281e4":"no6hD"}],"no6hD":[function(require,module,exports,__globalThis) {
"use strict";
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ChatCompletionStream_instances, _ChatCompletionStream_params, _ChatCompletionStream_choiceEventStates, _ChatCompletionStream_currentChatCompletionSnapshot, _ChatCompletionStream_beginRequest, _ChatCompletionStream_getChoiceEventState, _ChatCompletionStream_addChunk, _ChatCompletionStream_emitToolCallDoneEvent, _ChatCompletionStream_emitContentDoneEvents, _ChatCompletionStream_endRequest, _ChatCompletionStream_getAutoParseableResponseFormat, _ChatCompletionStream_accumulateChatCompletion;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChatCompletionStream = void 0;
const error_1 = require("c23b89db1ca3adc7");
const AbstractChatCompletionRunner_1 = require("9249f57561228160");
const streaming_1 = require("7051e3bc8f64bc33");
const parser_1 = require("32da66fb364c1e28");
const parser_2 = require("5e7310de94d6a3e2");
class ChatCompletionStream extends AbstractChatCompletionRunner_1.AbstractChatCompletionRunner {
    constructor(params){
        super();
        _ChatCompletionStream_instances.add(this);
        _ChatCompletionStream_params.set(this, void 0);
        _ChatCompletionStream_choiceEventStates.set(this, void 0);
        _ChatCompletionStream_currentChatCompletionSnapshot.set(this, void 0);
        __classPrivateFieldSet(this, _ChatCompletionStream_params, params, "f");
        __classPrivateFieldSet(this, _ChatCompletionStream_choiceEventStates, [], "f");
    }
    get currentChatCompletionSnapshot() {
        return __classPrivateFieldGet(this, _ChatCompletionStream_currentChatCompletionSnapshot, "f");
    }
    /**
     * Intended for use on the frontend, consuming a stream produced with
     * `.toReadableStream()` on the backend.
     *
     * Note that messages sent to the model do not appear in `.on('message')`
     * in this context.
     */ static fromReadableStream(stream) {
        const runner = new ChatCompletionStream(null);
        runner._run(()=>runner._fromReadableStream(stream));
        return runner;
    }
    static createChatCompletion(client, params, options) {
        const runner = new ChatCompletionStream(params);
        runner._run(()=>runner._runChatCompletion(client, {
                ...params,
                stream: true
            }, {
                ...options,
                headers: {
                    ...options?.headers,
                    'X-Stainless-Helper-Method': 'stream'
                }
            }));
        return runner;
    }
    async _createChatCompletion(client, params, options) {
        super._createChatCompletion;
        const signal = options?.signal;
        if (signal) {
            if (signal.aborted) this.controller.abort();
            signal.addEventListener('abort', ()=>this.controller.abort());
        }
        __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_beginRequest).call(this);
        const stream = await client.chat.completions.create({
            ...params,
            stream: true
        }, {
            ...options,
            signal: this.controller.signal
        });
        this._connected();
        for await (const chunk of stream)__classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_addChunk).call(this, chunk);
        if (stream.controller.signal?.aborted) throw new error_1.APIUserAbortError();
        return this._addChatCompletion(__classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_endRequest).call(this));
    }
    async _fromReadableStream(readableStream, options) {
        const signal = options?.signal;
        if (signal) {
            if (signal.aborted) this.controller.abort();
            signal.addEventListener('abort', ()=>this.controller.abort());
        }
        __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_beginRequest).call(this);
        this._connected();
        const stream = streaming_1.Stream.fromReadableStream(readableStream, this.controller);
        let chatId;
        for await (const chunk of stream){
            if (chatId && chatId !== chunk.id) // A new request has been made.
            this._addChatCompletion(__classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_endRequest).call(this));
            __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_addChunk).call(this, chunk);
            chatId = chunk.id;
        }
        if (stream.controller.signal?.aborted) throw new error_1.APIUserAbortError();
        return this._addChatCompletion(__classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_endRequest).call(this));
    }
    [(_ChatCompletionStream_params = new WeakMap(), _ChatCompletionStream_choiceEventStates = new WeakMap(), _ChatCompletionStream_currentChatCompletionSnapshot = new WeakMap(), _ChatCompletionStream_instances = new WeakSet(), _ChatCompletionStream_beginRequest = function _ChatCompletionStream_beginRequest() {
        if (this.ended) return;
        __classPrivateFieldSet(this, _ChatCompletionStream_currentChatCompletionSnapshot, undefined, "f");
    }, _ChatCompletionStream_getChoiceEventState = function _ChatCompletionStream_getChoiceEventState(choice) {
        let state = __classPrivateFieldGet(this, _ChatCompletionStream_choiceEventStates, "f")[choice.index];
        if (state) return state;
        state = {
            content_done: false,
            refusal_done: false,
            logprobs_content_done: false,
            logprobs_refusal_done: false,
            done_tool_calls: new Set(),
            current_tool_call_index: null
        };
        __classPrivateFieldGet(this, _ChatCompletionStream_choiceEventStates, "f")[choice.index] = state;
        return state;
    }, _ChatCompletionStream_addChunk = function _ChatCompletionStream_addChunk(chunk) {
        if (this.ended) return;
        const completion = __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_accumulateChatCompletion).call(this, chunk);
        this._emit('chunk', chunk, completion);
        for (const choice of chunk.choices){
            const choiceSnapshot = completion.choices[choice.index];
            if (choice.delta.content != null && choiceSnapshot.message?.role === 'assistant' && choiceSnapshot.message?.content) {
                this._emit('content', choice.delta.content, choiceSnapshot.message.content);
                this._emit('content.delta', {
                    delta: choice.delta.content,
                    snapshot: choiceSnapshot.message.content,
                    parsed: choiceSnapshot.message.parsed
                });
            }
            if (choice.delta.refusal != null && choiceSnapshot.message?.role === 'assistant' && choiceSnapshot.message?.refusal) this._emit('refusal.delta', {
                delta: choice.delta.refusal,
                snapshot: choiceSnapshot.message.refusal
            });
            if (choice.logprobs?.content != null && choiceSnapshot.message?.role === 'assistant') this._emit('logprobs.content.delta', {
                content: choice.logprobs?.content,
                snapshot: choiceSnapshot.logprobs?.content ?? []
            });
            if (choice.logprobs?.refusal != null && choiceSnapshot.message?.role === 'assistant') this._emit('logprobs.refusal.delta', {
                refusal: choice.logprobs?.refusal,
                snapshot: choiceSnapshot.logprobs?.refusal ?? []
            });
            const state = __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_getChoiceEventState).call(this, choiceSnapshot);
            if (choiceSnapshot.finish_reason) {
                __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_emitContentDoneEvents).call(this, choiceSnapshot);
                if (state.current_tool_call_index != null) __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_emitToolCallDoneEvent).call(this, choiceSnapshot, state.current_tool_call_index);
            }
            for (const toolCall of choice.delta.tool_calls ?? []){
                if (state.current_tool_call_index !== toolCall.index) {
                    __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_emitContentDoneEvents).call(this, choiceSnapshot);
                    // new tool call started, the previous one is done
                    if (state.current_tool_call_index != null) __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_emitToolCallDoneEvent).call(this, choiceSnapshot, state.current_tool_call_index);
                }
                state.current_tool_call_index = toolCall.index;
            }
            for (const toolCallDelta of choice.delta.tool_calls ?? []){
                const toolCallSnapshot = choiceSnapshot.message.tool_calls?.[toolCallDelta.index];
                if (!toolCallSnapshot?.type) continue;
                if (toolCallSnapshot?.type === 'function') this._emit('tool_calls.function.arguments.delta', {
                    name: toolCallSnapshot.function?.name,
                    index: toolCallDelta.index,
                    arguments: toolCallSnapshot.function.arguments,
                    parsed_arguments: toolCallSnapshot.function.parsed_arguments,
                    arguments_delta: toolCallDelta.function?.arguments ?? ''
                });
                else assertNever(toolCallSnapshot?.type);
            }
        }
    }, _ChatCompletionStream_emitToolCallDoneEvent = function _ChatCompletionStream_emitToolCallDoneEvent(choiceSnapshot, toolCallIndex) {
        const state = __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_getChoiceEventState).call(this, choiceSnapshot);
        if (state.done_tool_calls.has(toolCallIndex)) // we've already fired the done event
        return;
        const toolCallSnapshot = choiceSnapshot.message.tool_calls?.[toolCallIndex];
        if (!toolCallSnapshot) throw new Error('no tool call snapshot');
        if (!toolCallSnapshot.type) throw new Error('tool call snapshot missing `type`');
        if (toolCallSnapshot.type === 'function') {
            const inputTool = __classPrivateFieldGet(this, _ChatCompletionStream_params, "f")?.tools?.find((tool)=>tool.type === 'function' && tool.function.name === toolCallSnapshot.function.name);
            this._emit('tool_calls.function.arguments.done', {
                name: toolCallSnapshot.function.name,
                index: toolCallIndex,
                arguments: toolCallSnapshot.function.arguments,
                parsed_arguments: (0, parser_1.isAutoParsableTool)(inputTool) ? inputTool.$parseRaw(toolCallSnapshot.function.arguments) : inputTool?.function.strict ? JSON.parse(toolCallSnapshot.function.arguments) : null
            });
        } else assertNever(toolCallSnapshot.type);
    }, _ChatCompletionStream_emitContentDoneEvents = function _ChatCompletionStream_emitContentDoneEvents(choiceSnapshot) {
        const state = __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_getChoiceEventState).call(this, choiceSnapshot);
        if (choiceSnapshot.message.content && !state.content_done) {
            state.content_done = true;
            const responseFormat = __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_getAutoParseableResponseFormat).call(this);
            this._emit('content.done', {
                content: choiceSnapshot.message.content,
                parsed: responseFormat ? responseFormat.$parseRaw(choiceSnapshot.message.content) : null
            });
        }
        if (choiceSnapshot.message.refusal && !state.refusal_done) {
            state.refusal_done = true;
            this._emit('refusal.done', {
                refusal: choiceSnapshot.message.refusal
            });
        }
        if (choiceSnapshot.logprobs?.content && !state.logprobs_content_done) {
            state.logprobs_content_done = true;
            this._emit('logprobs.content.done', {
                content: choiceSnapshot.logprobs.content
            });
        }
        if (choiceSnapshot.logprobs?.refusal && !state.logprobs_refusal_done) {
            state.logprobs_refusal_done = true;
            this._emit('logprobs.refusal.done', {
                refusal: choiceSnapshot.logprobs.refusal
            });
        }
    }, _ChatCompletionStream_endRequest = function _ChatCompletionStream_endRequest() {
        if (this.ended) throw new error_1.OpenAIError(`stream has ended, this shouldn't happen`);
        const snapshot = __classPrivateFieldGet(this, _ChatCompletionStream_currentChatCompletionSnapshot, "f");
        if (!snapshot) throw new error_1.OpenAIError(`request ended without sending any chunks`);
        __classPrivateFieldSet(this, _ChatCompletionStream_currentChatCompletionSnapshot, undefined, "f");
        __classPrivateFieldSet(this, _ChatCompletionStream_choiceEventStates, [], "f");
        return finalizeChatCompletion(snapshot, __classPrivateFieldGet(this, _ChatCompletionStream_params, "f"));
    }, _ChatCompletionStream_getAutoParseableResponseFormat = function _ChatCompletionStream_getAutoParseableResponseFormat() {
        const responseFormat = __classPrivateFieldGet(this, _ChatCompletionStream_params, "f")?.response_format;
        if ((0, parser_1.isAutoParsableResponseFormat)(responseFormat)) return responseFormat;
        return null;
    }, _ChatCompletionStream_accumulateChatCompletion = function _ChatCompletionStream_accumulateChatCompletion(chunk) {
        var _a, _b, _c, _d;
        let snapshot = __classPrivateFieldGet(this, _ChatCompletionStream_currentChatCompletionSnapshot, "f");
        const { choices, ...rest } = chunk;
        if (!snapshot) snapshot = __classPrivateFieldSet(this, _ChatCompletionStream_currentChatCompletionSnapshot, {
            ...rest,
            choices: []
        }, "f");
        else Object.assign(snapshot, rest);
        for (const { delta, finish_reason, index, logprobs = null, ...other } of chunk.choices){
            let choice = snapshot.choices[index];
            if (!choice) choice = snapshot.choices[index] = {
                finish_reason,
                index,
                message: {},
                logprobs,
                ...other
            };
            if (logprobs) {
                if (!choice.logprobs) choice.logprobs = Object.assign({}, logprobs);
                else {
                    const { content, refusal, ...rest } = logprobs;
                    assertIsEmpty(rest);
                    Object.assign(choice.logprobs, rest);
                    if (content) {
                        (_a = choice.logprobs).content ?? (_a.content = []);
                        choice.logprobs.content.push(...content);
                    }
                    if (refusal) {
                        (_b = choice.logprobs).refusal ?? (_b.refusal = []);
                        choice.logprobs.refusal.push(...refusal);
                    }
                }
            }
            if (finish_reason) {
                choice.finish_reason = finish_reason;
                if (__classPrivateFieldGet(this, _ChatCompletionStream_params, "f") && (0, parser_1.hasAutoParseableInput)(__classPrivateFieldGet(this, _ChatCompletionStream_params, "f"))) {
                    if (finish_reason === 'length') throw new error_1.LengthFinishReasonError();
                    if (finish_reason === 'content_filter') throw new error_1.ContentFilterFinishReasonError();
                }
            }
            Object.assign(choice, other);
            if (!delta) continue; // Shouldn't happen; just in case.
            const { content, refusal, function_call, role, tool_calls, ...rest } = delta;
            assertIsEmpty(rest);
            Object.assign(choice.message, rest);
            if (refusal) choice.message.refusal = (choice.message.refusal || '') + refusal;
            if (role) choice.message.role = role;
            if (function_call) {
                if (!choice.message.function_call) choice.message.function_call = function_call;
                else {
                    if (function_call.name) choice.message.function_call.name = function_call.name;
                    if (function_call.arguments) {
                        (_c = choice.message.function_call).arguments ?? (_c.arguments = '');
                        choice.message.function_call.arguments += function_call.arguments;
                    }
                }
            }
            if (content) {
                choice.message.content = (choice.message.content || '') + content;
                if (!choice.message.refusal && __classPrivateFieldGet(this, _ChatCompletionStream_instances, "m", _ChatCompletionStream_getAutoParseableResponseFormat).call(this)) choice.message.parsed = (0, parser_2.partialParse)(choice.message.content);
            }
            if (tool_calls) {
                if (!choice.message.tool_calls) choice.message.tool_calls = [];
                for (const { index, id, type, function: fn, ...rest } of tool_calls){
                    const tool_call = (_d = choice.message.tool_calls)[index] ?? (_d[index] = {});
                    Object.assign(tool_call, rest);
                    if (id) tool_call.id = id;
                    if (type) tool_call.type = type;
                    if (fn) tool_call.function ?? (tool_call.function = {
                        name: fn.name ?? '',
                        arguments: ''
                    });
                    if (fn?.name) tool_call.function.name = fn.name;
                    if (fn?.arguments) {
                        tool_call.function.arguments += fn.arguments;
                        if ((0, parser_1.shouldParseToolCall)(__classPrivateFieldGet(this, _ChatCompletionStream_params, "f"), tool_call)) tool_call.function.parsed_arguments = (0, parser_2.partialParse)(tool_call.function.arguments);
                    }
                }
            }
        }
        return snapshot;
    }, Symbol.asyncIterator)]() {
        const pushQueue = [];
        const readQueue = [];
        let done = false;
        this.on('chunk', (chunk)=>{
            const reader = readQueue.shift();
            if (reader) reader.resolve(chunk);
            else pushQueue.push(chunk);
        });
        this.on('end', ()=>{
            done = true;
            for (const reader of readQueue)reader.resolve(undefined);
            readQueue.length = 0;
        });
        this.on('abort', (err)=>{
            done = true;
            for (const reader of readQueue)reader.reject(err);
            readQueue.length = 0;
        });
        this.on('error', (err)=>{
            done = true;
            for (const reader of readQueue)reader.reject(err);
            readQueue.length = 0;
        });
        return {
            next: async ()=>{
                if (!pushQueue.length) {
                    if (done) return {
                        value: undefined,
                        done: true
                    };
                    return new Promise((resolve, reject)=>readQueue.push({
                            resolve,
                            reject
                        })).then((chunk)=>chunk ? {
                            value: chunk,
                            done: false
                        } : {
                            value: undefined,
                            done: true
                        });
                }
                const chunk = pushQueue.shift();
                return {
                    value: chunk,
                    done: false
                };
            },
            return: async ()=>{
                this.abort();
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    toReadableStream() {
        const stream = new streaming_1.Stream(this[Symbol.asyncIterator].bind(this), this.controller);
        return stream.toReadableStream();
    }
}
exports.ChatCompletionStream = ChatCompletionStream;
function finalizeChatCompletion(snapshot, params) {
    const { id, choices, created, model, system_fingerprint, ...rest } = snapshot;
    const completion = {
        ...rest,
        id,
        choices: choices.map(({ message, finish_reason, index, logprobs, ...choiceRest })=>{
            if (!finish_reason) throw new error_1.OpenAIError(`missing finish_reason for choice ${index}`);
            const { content = null, function_call, tool_calls, ...messageRest } = message;
            const role = message.role; // this is what we expect; in theory it could be different which would make our types a slight lie but would be fine.
            if (!role) throw new error_1.OpenAIError(`missing role for choice ${index}`);
            if (function_call) {
                const { arguments: args, name } = function_call;
                if (args == null) throw new error_1.OpenAIError(`missing function_call.arguments for choice ${index}`);
                if (!name) throw new error_1.OpenAIError(`missing function_call.name for choice ${index}`);
                return {
                    ...choiceRest,
                    message: {
                        content,
                        function_call: {
                            arguments: args,
                            name
                        },
                        role,
                        refusal: message.refusal ?? null
                    },
                    finish_reason,
                    index,
                    logprobs
                };
            }
            if (tool_calls) return {
                ...choiceRest,
                index,
                finish_reason,
                logprobs,
                message: {
                    ...messageRest,
                    role,
                    content,
                    refusal: message.refusal ?? null,
                    tool_calls: tool_calls.map((tool_call, i)=>{
                        const { function: fn, type, id, ...toolRest } = tool_call;
                        const { arguments: args, name, ...fnRest } = fn || {};
                        if (id == null) throw new error_1.OpenAIError(`missing choices[${index}].tool_calls[${i}].id\n${str(snapshot)}`);
                        if (type == null) throw new error_1.OpenAIError(`missing choices[${index}].tool_calls[${i}].type\n${str(snapshot)}`);
                        if (name == null) throw new error_1.OpenAIError(`missing choices[${index}].tool_calls[${i}].function.name\n${str(snapshot)}`);
                        if (args == null) throw new error_1.OpenAIError(`missing choices[${index}].tool_calls[${i}].function.arguments\n${str(snapshot)}`);
                        return {
                            ...toolRest,
                            id,
                            type,
                            function: {
                                ...fnRest,
                                name,
                                arguments: args
                            }
                        };
                    })
                }
            };
            return {
                ...choiceRest,
                message: {
                    ...messageRest,
                    content,
                    role,
                    refusal: message.refusal ?? null
                },
                finish_reason,
                index,
                logprobs
            };
        }),
        created,
        model,
        object: 'chat.completion',
        ...system_fingerprint ? {
            system_fingerprint
        } : {}
    };
    return (0, parser_1.maybeParseChatCompletion)(completion, params);
}
function str(x) {
    return JSON.stringify(x);
}
/**
 * Ensures the given argument is an empty object, useful for
 * asserting that all known properties on an object have been
 * destructured.
 */ function assertIsEmpty(obj) {
    return;
}
function assertNever(_x) {}

},{"c23b89db1ca3adc7":"eZWCP","9249f57561228160":"24Ue2","7051e3bc8f64bc33":"d2aDf","32da66fb364c1e28":"2rHDe","5e7310de94d6a3e2":"hwiJX"}],"hwiJX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MalformedJSON = exports.PartialJSON = exports.partialParse = void 0;
const STR = 1;
const NUM = 2;
const ARR = 4;
const OBJ = 8;
const NULL = 16;
const BOOL = 32;
const NAN = 64;
const INFINITY = 128;
const MINUS_INFINITY = 256;
const INF = INFINITY | MINUS_INFINITY;
const SPECIAL = NULL | BOOL | INF | NAN;
const ATOM = STR | NUM | SPECIAL;
const COLLECTION = ARR | OBJ;
const ALL = ATOM | COLLECTION;
const Allow = {
    STR,
    NUM,
    ARR,
    OBJ,
    NULL,
    BOOL,
    NAN,
    INFINITY,
    MINUS_INFINITY,
    INF,
    SPECIAL,
    ATOM,
    COLLECTION,
    ALL
};
// The JSON string segment was unable to be parsed completely
class PartialJSON extends Error {
}
exports.PartialJSON = PartialJSON;
class MalformedJSON extends Error {
}
exports.MalformedJSON = MalformedJSON;
/**
 * Parse incomplete JSON
 * @param {string} jsonString Partial JSON to be parsed
 * @param {number} allowPartial Specify what types are allowed to be partial, see {@link Allow} for details
 * @returns The parsed JSON
 * @throws {PartialJSON} If the JSON is incomplete (related to the `allow` parameter)
 * @throws {MalformedJSON} If the JSON is malformed
 */ function parseJSON(jsonString, allowPartial = Allow.ALL) {
    if (typeof jsonString !== 'string') throw new TypeError(`expecting str, got ${typeof jsonString}`);
    if (!jsonString.trim()) throw new Error(`${jsonString} is empty`);
    return _parseJSON(jsonString.trim(), allowPartial);
}
const _parseJSON = (jsonString, allow)=>{
    const length = jsonString.length;
    let index = 0;
    const markPartialJSON = (msg)=>{
        throw new PartialJSON(`${msg} at position ${index}`);
    };
    const throwMalformedError = (msg)=>{
        throw new MalformedJSON(`${msg} at position ${index}`);
    };
    const parseAny = ()=>{
        skipBlank();
        if (index >= length) markPartialJSON('Unexpected end of input');
        if (jsonString[index] === '"') return parseStr();
        if (jsonString[index] === '{') return parseObj();
        if (jsonString[index] === '[') return parseArr();
        if (jsonString.substring(index, index + 4) === 'null' || Allow.NULL & allow && length - index < 4 && 'null'.startsWith(jsonString.substring(index))) {
            index += 4;
            return null;
        }
        if (jsonString.substring(index, index + 4) === 'true' || Allow.BOOL & allow && length - index < 4 && 'true'.startsWith(jsonString.substring(index))) {
            index += 4;
            return true;
        }
        if (jsonString.substring(index, index + 5) === 'false' || Allow.BOOL & allow && length - index < 5 && 'false'.startsWith(jsonString.substring(index))) {
            index += 5;
            return false;
        }
        if (jsonString.substring(index, index + 8) === 'Infinity' || Allow.INFINITY & allow && length - index < 8 && 'Infinity'.startsWith(jsonString.substring(index))) {
            index += 8;
            return Infinity;
        }
        if (jsonString.substring(index, index + 9) === '-Infinity' || Allow.MINUS_INFINITY & allow && 1 < length - index && length - index < 9 && '-Infinity'.startsWith(jsonString.substring(index))) {
            index += 9;
            return -Infinity;
        }
        if (jsonString.substring(index, index + 3) === 'NaN' || Allow.NAN & allow && length - index < 3 && 'NaN'.startsWith(jsonString.substring(index))) {
            index += 3;
            return NaN;
        }
        return parseNum();
    };
    const parseStr = ()=>{
        const start = index;
        let escape = false;
        index++; // skip initial quote
        while(index < length && (jsonString[index] !== '"' || escape && jsonString[index - 1] === '\\')){
            escape = jsonString[index] === '\\' ? !escape : false;
            index++;
        }
        if (jsonString.charAt(index) == '"') try {
            return JSON.parse(jsonString.substring(start, ++index - Number(escape)));
        } catch (e) {
            throwMalformedError(String(e));
        }
        else if (Allow.STR & allow) try {
            return JSON.parse(jsonString.substring(start, index - Number(escape)) + '"');
        } catch (e) {
            // SyntaxError: Invalid escape sequence
            return JSON.parse(jsonString.substring(start, jsonString.lastIndexOf('\\')) + '"');
        }
        markPartialJSON('Unterminated string literal');
    };
    const parseObj = ()=>{
        index++; // skip initial brace
        skipBlank();
        const obj = {};
        try {
            while(jsonString[index] !== '}'){
                skipBlank();
                if (index >= length && Allow.OBJ & allow) return obj;
                const key = parseStr();
                skipBlank();
                index++; // skip colon
                try {
                    const value = parseAny();
                    Object.defineProperty(obj, key, {
                        value,
                        writable: true,
                        enumerable: true,
                        configurable: true
                    });
                } catch (e) {
                    if (Allow.OBJ & allow) return obj;
                    else throw e;
                }
                skipBlank();
                if (jsonString[index] === ',') index++; // skip comma
            }
        } catch (e) {
            if (Allow.OBJ & allow) return obj;
            else markPartialJSON("Expected '}' at end of object");
        }
        index++; // skip final brace
        return obj;
    };
    const parseArr = ()=>{
        index++; // skip initial bracket
        const arr = [];
        try {
            while(jsonString[index] !== ']'){
                arr.push(parseAny());
                skipBlank();
                if (jsonString[index] === ',') index++; // skip comma
            }
        } catch (e) {
            if (Allow.ARR & allow) return arr;
            markPartialJSON("Expected ']' at end of array");
        }
        index++; // skip final bracket
        return arr;
    };
    const parseNum = ()=>{
        if (index === 0) {
            if (jsonString === '-' && Allow.NUM & allow) markPartialJSON("Not sure what '-' is");
            try {
                return JSON.parse(jsonString);
            } catch (e) {
                if (Allow.NUM & allow) try {
                    if ('.' === jsonString[jsonString.length - 1]) return JSON.parse(jsonString.substring(0, jsonString.lastIndexOf('.')));
                    return JSON.parse(jsonString.substring(0, jsonString.lastIndexOf('e')));
                } catch (e) {}
                throwMalformedError(String(e));
            }
        }
        const start = index;
        if (jsonString[index] === '-') index++;
        while(jsonString[index] && !',]}'.includes(jsonString[index]))index++;
        if (index == length && !(Allow.NUM & allow)) markPartialJSON('Unterminated number literal');
        try {
            return JSON.parse(jsonString.substring(start, index));
        } catch (e) {
            if (jsonString.substring(start, index) === '-' && Allow.NUM & allow) markPartialJSON("Not sure what '-' is");
            try {
                return JSON.parse(jsonString.substring(start, jsonString.lastIndexOf('e')));
            } catch (e) {
                throwMalformedError(String(e));
            }
        }
    };
    const skipBlank = ()=>{
        while(index < length && ' \n\r\t'.includes(jsonString[index]))index++;
    };
    return parseAny();
};
// using this function with malformed JSON is undefined behavior
const partialParse = (input)=>parseJSON(input, Allow.ALL ^ Allow.NUM);
exports.partialParse = partialParse;

},{}],"gUYwX":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Threads = void 0;
const resource_1 = require("3255d3d2c9989c7d");
const core_1 = require("3044ea6c3051ba9e");
const AssistantStream_1 = require("792b307e20aaaaa7");
const MessagesAPI = __importStar(require("56a81e319684dd15"));
const messages_1 = require("56a81e319684dd15");
const RunsAPI = __importStar(require("c1e8e1f4c6465bec"));
const runs_1 = require("c1e8e1f4c6465bec");
class Threads extends resource_1.APIResource {
    constructor(){
        super(...arguments);
        this.runs = new RunsAPI.Runs(this._client);
        this.messages = new MessagesAPI.Messages(this._client);
    }
    create(body = {}, options) {
        if ((0, core_1.isRequestOptions)(body)) return this.create({}, body);
        return this._client.post('/threads', {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Retrieves a thread.
     */ retrieve(threadId, options) {
        return this._client.get(`/threads/${threadId}`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Modifies a thread.
     */ update(threadId, body, options) {
        return this._client.post(`/threads/${threadId}`, {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Delete a thread.
     */ del(threadId, options) {
        return this._client.delete(`/threads/${threadId}`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    createAndRun(body, options) {
        return this._client.post('/threads/runs', {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            },
            stream: body.stream ?? false
        });
    }
    /**
     * A helper to create a thread, start a run and then poll for a terminal state.
     * More information on Run lifecycles can be found here:
     * https://platform.openai.com/docs/assistants/how-it-works/runs-and-run-steps
     */ async createAndRunPoll(body, options) {
        const run = await this.createAndRun(body, options);
        return await this.runs.poll(run.thread_id, run.id, options);
    }
    /**
     * Create a thread and stream the run back
     */ createAndRunStream(body, options) {
        return AssistantStream_1.AssistantStream.createThreadAssistantStream(body, this._client.beta.threads, options);
    }
}
exports.Threads = Threads;
Threads.Runs = runs_1.Runs;
Threads.RunsPage = runs_1.RunsPage;
Threads.Messages = messages_1.Messages;
Threads.MessagesPage = messages_1.MessagesPage;

},{"3255d3d2c9989c7d":"jx5FL","3044ea6c3051ba9e":"SlwjS","792b307e20aaaaa7":"jVwbt","56a81e319684dd15":"NdZGs","c1e8e1f4c6465bec":"cBGPF"}],"jVwbt":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _AssistantStream_instances, _AssistantStream_events, _AssistantStream_runStepSnapshots, _AssistantStream_messageSnapshots, _AssistantStream_messageSnapshot, _AssistantStream_finalRun, _AssistantStream_currentContentIndex, _AssistantStream_currentContent, _AssistantStream_currentToolCallIndex, _AssistantStream_currentToolCall, _AssistantStream_currentEvent, _AssistantStream_currentRunSnapshot, _AssistantStream_currentRunStepSnapshot, _AssistantStream_addEvent, _AssistantStream_endRequest, _AssistantStream_handleMessage, _AssistantStream_handleRunStep, _AssistantStream_handleEvent, _AssistantStream_accumulateRunStep, _AssistantStream_accumulateMessage, _AssistantStream_accumulateContent, _AssistantStream_handleRun;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AssistantStream = void 0;
const Core = __importStar(require("d6cd8ed7023bf9e8"));
const streaming_1 = require("fc24bb6d749c8827");
const error_1 = require("2feae34d7197ea81");
const EventStream_1 = require("26d128d2dfdae8a1");
class AssistantStream extends EventStream_1.EventStream {
    constructor(){
        super(...arguments);
        _AssistantStream_instances.add(this);
        //Track all events in a single list for reference
        _AssistantStream_events.set(this, []);
        //Used to accumulate deltas
        //We are accumulating many types so the value here is not strict
        _AssistantStream_runStepSnapshots.set(this, {});
        _AssistantStream_messageSnapshots.set(this, {});
        _AssistantStream_messageSnapshot.set(this, void 0);
        _AssistantStream_finalRun.set(this, void 0);
        _AssistantStream_currentContentIndex.set(this, void 0);
        _AssistantStream_currentContent.set(this, void 0);
        _AssistantStream_currentToolCallIndex.set(this, void 0);
        _AssistantStream_currentToolCall.set(this, void 0);
        //For current snapshot methods
        _AssistantStream_currentEvent.set(this, void 0);
        _AssistantStream_currentRunSnapshot.set(this, void 0);
        _AssistantStream_currentRunStepSnapshot.set(this, void 0);
    }
    [(_AssistantStream_events = new WeakMap(), _AssistantStream_runStepSnapshots = new WeakMap(), _AssistantStream_messageSnapshots = new WeakMap(), _AssistantStream_messageSnapshot = new WeakMap(), _AssistantStream_finalRun = new WeakMap(), _AssistantStream_currentContentIndex = new WeakMap(), _AssistantStream_currentContent = new WeakMap(), _AssistantStream_currentToolCallIndex = new WeakMap(), _AssistantStream_currentToolCall = new WeakMap(), _AssistantStream_currentEvent = new WeakMap(), _AssistantStream_currentRunSnapshot = new WeakMap(), _AssistantStream_currentRunStepSnapshot = new WeakMap(), _AssistantStream_instances = new WeakSet(), Symbol.asyncIterator)]() {
        const pushQueue = [];
        const readQueue = [];
        let done = false;
        //Catch all for passing along all events
        this.on('event', (event)=>{
            const reader = readQueue.shift();
            if (reader) reader.resolve(event);
            else pushQueue.push(event);
        });
        this.on('end', ()=>{
            done = true;
            for (const reader of readQueue)reader.resolve(undefined);
            readQueue.length = 0;
        });
        this.on('abort', (err)=>{
            done = true;
            for (const reader of readQueue)reader.reject(err);
            readQueue.length = 0;
        });
        this.on('error', (err)=>{
            done = true;
            for (const reader of readQueue)reader.reject(err);
            readQueue.length = 0;
        });
        return {
            next: async ()=>{
                if (!pushQueue.length) {
                    if (done) return {
                        value: undefined,
                        done: true
                    };
                    return new Promise((resolve, reject)=>readQueue.push({
                            resolve,
                            reject
                        })).then((chunk)=>chunk ? {
                            value: chunk,
                            done: false
                        } : {
                            value: undefined,
                            done: true
                        });
                }
                const chunk = pushQueue.shift();
                return {
                    value: chunk,
                    done: false
                };
            },
            return: async ()=>{
                this.abort();
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    static fromReadableStream(stream) {
        const runner = new AssistantStream();
        runner._run(()=>runner._fromReadableStream(stream));
        return runner;
    }
    async _fromReadableStream(readableStream, options) {
        const signal = options?.signal;
        if (signal) {
            if (signal.aborted) this.controller.abort();
            signal.addEventListener('abort', ()=>this.controller.abort());
        }
        this._connected();
        const stream = streaming_1.Stream.fromReadableStream(readableStream, this.controller);
        for await (const event of stream)__classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_addEvent).call(this, event);
        if (stream.controller.signal?.aborted) throw new error_1.APIUserAbortError();
        return this._addRun(__classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_endRequest).call(this));
    }
    toReadableStream() {
        const stream = new streaming_1.Stream(this[Symbol.asyncIterator].bind(this), this.controller);
        return stream.toReadableStream();
    }
    static createToolAssistantStream(threadId, runId, runs, params, options) {
        const runner = new AssistantStream();
        runner._run(()=>runner._runToolAssistantStream(threadId, runId, runs, params, {
                ...options,
                headers: {
                    ...options?.headers,
                    'X-Stainless-Helper-Method': 'stream'
                }
            }));
        return runner;
    }
    async _createToolAssistantStream(run, threadId, runId, params, options) {
        const signal = options?.signal;
        if (signal) {
            if (signal.aborted) this.controller.abort();
            signal.addEventListener('abort', ()=>this.controller.abort());
        }
        const body = {
            ...params,
            stream: true
        };
        const stream = await run.submitToolOutputs(threadId, runId, body, {
            ...options,
            signal: this.controller.signal
        });
        this._connected();
        for await (const event of stream)__classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_addEvent).call(this, event);
        if (stream.controller.signal?.aborted) throw new error_1.APIUserAbortError();
        return this._addRun(__classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_endRequest).call(this));
    }
    static createThreadAssistantStream(params, thread, options) {
        const runner = new AssistantStream();
        runner._run(()=>runner._threadAssistantStream(params, thread, {
                ...options,
                headers: {
                    ...options?.headers,
                    'X-Stainless-Helper-Method': 'stream'
                }
            }));
        return runner;
    }
    static createAssistantStream(threadId, runs, params, options) {
        const runner = new AssistantStream();
        runner._run(()=>runner._runAssistantStream(threadId, runs, params, {
                ...options,
                headers: {
                    ...options?.headers,
                    'X-Stainless-Helper-Method': 'stream'
                }
            }));
        return runner;
    }
    currentEvent() {
        return __classPrivateFieldGet(this, _AssistantStream_currentEvent, "f");
    }
    currentRun() {
        return __classPrivateFieldGet(this, _AssistantStream_currentRunSnapshot, "f");
    }
    currentMessageSnapshot() {
        return __classPrivateFieldGet(this, _AssistantStream_messageSnapshot, "f");
    }
    currentRunStepSnapshot() {
        return __classPrivateFieldGet(this, _AssistantStream_currentRunStepSnapshot, "f");
    }
    async finalRunSteps() {
        await this.done();
        return Object.values(__classPrivateFieldGet(this, _AssistantStream_runStepSnapshots, "f"));
    }
    async finalMessages() {
        await this.done();
        return Object.values(__classPrivateFieldGet(this, _AssistantStream_messageSnapshots, "f"));
    }
    async finalRun() {
        await this.done();
        if (!__classPrivateFieldGet(this, _AssistantStream_finalRun, "f")) throw Error('Final run was not received.');
        return __classPrivateFieldGet(this, _AssistantStream_finalRun, "f");
    }
    async _createThreadAssistantStream(thread, params, options) {
        const signal = options?.signal;
        if (signal) {
            if (signal.aborted) this.controller.abort();
            signal.addEventListener('abort', ()=>this.controller.abort());
        }
        const body = {
            ...params,
            stream: true
        };
        const stream = await thread.createAndRun(body, {
            ...options,
            signal: this.controller.signal
        });
        this._connected();
        for await (const event of stream)__classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_addEvent).call(this, event);
        if (stream.controller.signal?.aborted) throw new error_1.APIUserAbortError();
        return this._addRun(__classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_endRequest).call(this));
    }
    async _createAssistantStream(run, threadId, params, options) {
        const signal = options?.signal;
        if (signal) {
            if (signal.aborted) this.controller.abort();
            signal.addEventListener('abort', ()=>this.controller.abort());
        }
        const body = {
            ...params,
            stream: true
        };
        const stream = await run.create(threadId, body, {
            ...options,
            signal: this.controller.signal
        });
        this._connected();
        for await (const event of stream)__classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_addEvent).call(this, event);
        if (stream.controller.signal?.aborted) throw new error_1.APIUserAbortError();
        return this._addRun(__classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_endRequest).call(this));
    }
    static accumulateDelta(acc, delta) {
        for (const [key, deltaValue] of Object.entries(delta)){
            if (!acc.hasOwnProperty(key)) {
                acc[key] = deltaValue;
                continue;
            }
            let accValue = acc[key];
            if (accValue === null || accValue === undefined) {
                acc[key] = deltaValue;
                continue;
            }
            // We don't accumulate these special properties
            if (key === 'index' || key === 'type') {
                acc[key] = deltaValue;
                continue;
            }
            // Type-specific accumulation logic
            if (typeof accValue === 'string' && typeof deltaValue === 'string') accValue += deltaValue;
            else if (typeof accValue === 'number' && typeof deltaValue === 'number') accValue += deltaValue;
            else if (Core.isObj(accValue) && Core.isObj(deltaValue)) accValue = this.accumulateDelta(accValue, deltaValue);
            else if (Array.isArray(accValue) && Array.isArray(deltaValue)) {
                if (accValue.every((x)=>typeof x === 'string' || typeof x === 'number')) {
                    accValue.push(...deltaValue); // Use spread syntax for efficient addition
                    continue;
                }
                for (const deltaEntry of deltaValue){
                    if (!Core.isObj(deltaEntry)) throw new Error(`Expected array delta entry to be an object but got: ${deltaEntry}`);
                    const index = deltaEntry['index'];
                    if (index == null) {
                        console.error(deltaEntry);
                        throw new Error('Expected array delta entry to have an `index` property');
                    }
                    if (typeof index !== 'number') throw new Error(`Expected array delta entry \`index\` property to be a number but got ${index}`);
                    const accEntry = accValue[index];
                    if (accEntry == null) accValue.push(deltaEntry);
                    else accValue[index] = this.accumulateDelta(accEntry, deltaEntry);
                }
                continue;
            } else throw Error(`Unhandled record type: ${key}, deltaValue: ${deltaValue}, accValue: ${accValue}`);
            acc[key] = accValue;
        }
        return acc;
    }
    _addRun(run) {
        return run;
    }
    async _threadAssistantStream(params, thread, options) {
        return await this._createThreadAssistantStream(thread, params, options);
    }
    async _runAssistantStream(threadId, runs, params, options) {
        return await this._createAssistantStream(runs, threadId, params, options);
    }
    async _runToolAssistantStream(threadId, runId, runs, params, options) {
        return await this._createToolAssistantStream(runs, threadId, runId, params, options);
    }
}
exports.AssistantStream = AssistantStream;
_AssistantStream_addEvent = function _AssistantStream_addEvent(event) {
    if (this.ended) return;
    __classPrivateFieldSet(this, _AssistantStream_currentEvent, event, "f");
    __classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_handleEvent).call(this, event);
    switch(event.event){
        case 'thread.created':
            break;
        case 'thread.run.created':
        case 'thread.run.queued':
        case 'thread.run.in_progress':
        case 'thread.run.requires_action':
        case 'thread.run.completed':
        case 'thread.run.failed':
        case 'thread.run.cancelling':
        case 'thread.run.cancelled':
        case 'thread.run.expired':
            __classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_handleRun).call(this, event);
            break;
        case 'thread.run.step.created':
        case 'thread.run.step.in_progress':
        case 'thread.run.step.delta':
        case 'thread.run.step.completed':
        case 'thread.run.step.failed':
        case 'thread.run.step.cancelled':
        case 'thread.run.step.expired':
            __classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_handleRunStep).call(this, event);
            break;
        case 'thread.message.created':
        case 'thread.message.in_progress':
        case 'thread.message.delta':
        case 'thread.message.completed':
        case 'thread.message.incomplete':
            __classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_handleMessage).call(this, event);
            break;
        case 'error':
            //This is included for completeness, but errors are processed in the SSE event processing so this should not occur
            throw new Error('Encountered an error event in event processing - errors should be processed earlier');
    }
}, _AssistantStream_endRequest = function _AssistantStream_endRequest() {
    if (this.ended) throw new error_1.OpenAIError(`stream has ended, this shouldn't happen`);
    if (!__classPrivateFieldGet(this, _AssistantStream_finalRun, "f")) throw Error('Final run has not been received');
    return __classPrivateFieldGet(this, _AssistantStream_finalRun, "f");
}, _AssistantStream_handleMessage = function _AssistantStream_handleMessage(event) {
    const [accumulatedMessage, newContent] = __classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_accumulateMessage).call(this, event, __classPrivateFieldGet(this, _AssistantStream_messageSnapshot, "f"));
    __classPrivateFieldSet(this, _AssistantStream_messageSnapshot, accumulatedMessage, "f");
    __classPrivateFieldGet(this, _AssistantStream_messageSnapshots, "f")[accumulatedMessage.id] = accumulatedMessage;
    for (const content of newContent){
        const snapshotContent = accumulatedMessage.content[content.index];
        if (snapshotContent?.type == 'text') this._emit('textCreated', snapshotContent.text);
    }
    switch(event.event){
        case 'thread.message.created':
            this._emit('messageCreated', event.data);
            break;
        case 'thread.message.in_progress':
            break;
        case 'thread.message.delta':
            this._emit('messageDelta', event.data.delta, accumulatedMessage);
            if (event.data.delta.content) for (const content of event.data.delta.content){
                //If it is text delta, emit a text delta event
                if (content.type == 'text' && content.text) {
                    let textDelta = content.text;
                    let snapshot = accumulatedMessage.content[content.index];
                    if (snapshot && snapshot.type == 'text') this._emit('textDelta', textDelta, snapshot.text);
                    else throw Error('The snapshot associated with this text delta is not text or missing');
                }
                if (content.index != __classPrivateFieldGet(this, _AssistantStream_currentContentIndex, "f")) {
                    //See if we have in progress content
                    if (__classPrivateFieldGet(this, _AssistantStream_currentContent, "f")) switch(__classPrivateFieldGet(this, _AssistantStream_currentContent, "f").type){
                        case 'text':
                            this._emit('textDone', __classPrivateFieldGet(this, _AssistantStream_currentContent, "f").text, __classPrivateFieldGet(this, _AssistantStream_messageSnapshot, "f"));
                            break;
                        case 'image_file':
                            this._emit('imageFileDone', __classPrivateFieldGet(this, _AssistantStream_currentContent, "f").image_file, __classPrivateFieldGet(this, _AssistantStream_messageSnapshot, "f"));
                            break;
                    }
                    __classPrivateFieldSet(this, _AssistantStream_currentContentIndex, content.index, "f");
                }
                __classPrivateFieldSet(this, _AssistantStream_currentContent, accumulatedMessage.content[content.index], "f");
            }
            break;
        case 'thread.message.completed':
        case 'thread.message.incomplete':
            //We emit the latest content we were working on on completion (including incomplete)
            if (__classPrivateFieldGet(this, _AssistantStream_currentContentIndex, "f") !== undefined) {
                const currentContent = event.data.content[__classPrivateFieldGet(this, _AssistantStream_currentContentIndex, "f")];
                if (currentContent) switch(currentContent.type){
                    case 'image_file':
                        this._emit('imageFileDone', currentContent.image_file, __classPrivateFieldGet(this, _AssistantStream_messageSnapshot, "f"));
                        break;
                    case 'text':
                        this._emit('textDone', currentContent.text, __classPrivateFieldGet(this, _AssistantStream_messageSnapshot, "f"));
                        break;
                }
            }
            if (__classPrivateFieldGet(this, _AssistantStream_messageSnapshot, "f")) this._emit('messageDone', event.data);
            __classPrivateFieldSet(this, _AssistantStream_messageSnapshot, undefined, "f");
    }
}, _AssistantStream_handleRunStep = function _AssistantStream_handleRunStep(event) {
    const accumulatedRunStep = __classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_accumulateRunStep).call(this, event);
    __classPrivateFieldSet(this, _AssistantStream_currentRunStepSnapshot, accumulatedRunStep, "f");
    switch(event.event){
        case 'thread.run.step.created':
            this._emit('runStepCreated', event.data);
            break;
        case 'thread.run.step.delta':
            const delta = event.data.delta;
            if (delta.step_details && delta.step_details.type == 'tool_calls' && delta.step_details.tool_calls && accumulatedRunStep.step_details.type == 'tool_calls') {
                for (const toolCall of delta.step_details.tool_calls)if (toolCall.index == __classPrivateFieldGet(this, _AssistantStream_currentToolCallIndex, "f")) this._emit('toolCallDelta', toolCall, accumulatedRunStep.step_details.tool_calls[toolCall.index]);
                else {
                    if (__classPrivateFieldGet(this, _AssistantStream_currentToolCall, "f")) this._emit('toolCallDone', __classPrivateFieldGet(this, _AssistantStream_currentToolCall, "f"));
                    __classPrivateFieldSet(this, _AssistantStream_currentToolCallIndex, toolCall.index, "f");
                    __classPrivateFieldSet(this, _AssistantStream_currentToolCall, accumulatedRunStep.step_details.tool_calls[toolCall.index], "f");
                    if (__classPrivateFieldGet(this, _AssistantStream_currentToolCall, "f")) this._emit('toolCallCreated', __classPrivateFieldGet(this, _AssistantStream_currentToolCall, "f"));
                }
            }
            this._emit('runStepDelta', event.data.delta, accumulatedRunStep);
            break;
        case 'thread.run.step.completed':
        case 'thread.run.step.failed':
        case 'thread.run.step.cancelled':
        case 'thread.run.step.expired':
            __classPrivateFieldSet(this, _AssistantStream_currentRunStepSnapshot, undefined, "f");
            const details = event.data.step_details;
            if (details.type == 'tool_calls') {
                if (__classPrivateFieldGet(this, _AssistantStream_currentToolCall, "f")) {
                    this._emit('toolCallDone', __classPrivateFieldGet(this, _AssistantStream_currentToolCall, "f"));
                    __classPrivateFieldSet(this, _AssistantStream_currentToolCall, undefined, "f");
                }
            }
            this._emit('runStepDone', event.data, accumulatedRunStep);
            break;
        case 'thread.run.step.in_progress':
            break;
    }
}, _AssistantStream_handleEvent = function _AssistantStream_handleEvent(event) {
    __classPrivateFieldGet(this, _AssistantStream_events, "f").push(event);
    this._emit('event', event);
}, _AssistantStream_accumulateRunStep = function _AssistantStream_accumulateRunStep(event) {
    switch(event.event){
        case 'thread.run.step.created':
            __classPrivateFieldGet(this, _AssistantStream_runStepSnapshots, "f")[event.data.id] = event.data;
            return event.data;
        case 'thread.run.step.delta':
            let snapshot = __classPrivateFieldGet(this, _AssistantStream_runStepSnapshots, "f")[event.data.id];
            if (!snapshot) throw Error('Received a RunStepDelta before creation of a snapshot');
            let data = event.data;
            if (data.delta) {
                const accumulated = AssistantStream.accumulateDelta(snapshot, data.delta);
                __classPrivateFieldGet(this, _AssistantStream_runStepSnapshots, "f")[event.data.id] = accumulated;
            }
            return __classPrivateFieldGet(this, _AssistantStream_runStepSnapshots, "f")[event.data.id];
        case 'thread.run.step.completed':
        case 'thread.run.step.failed':
        case 'thread.run.step.cancelled':
        case 'thread.run.step.expired':
        case 'thread.run.step.in_progress':
            __classPrivateFieldGet(this, _AssistantStream_runStepSnapshots, "f")[event.data.id] = event.data;
            break;
    }
    if (__classPrivateFieldGet(this, _AssistantStream_runStepSnapshots, "f")[event.data.id]) return __classPrivateFieldGet(this, _AssistantStream_runStepSnapshots, "f")[event.data.id];
    throw new Error('No snapshot available');
}, _AssistantStream_accumulateMessage = function _AssistantStream_accumulateMessage(event, snapshot) {
    let newContent = [];
    switch(event.event){
        case 'thread.message.created':
            //On creation the snapshot is just the initial message
            return [
                event.data,
                newContent
            ];
        case 'thread.message.delta':
            if (!snapshot) throw Error('Received a delta with no existing snapshot (there should be one from message creation)');
            let data = event.data;
            //If this delta does not have content, nothing to process
            if (data.delta.content) {
                for (const contentElement of data.delta.content)if (contentElement.index in snapshot.content) {
                    let currentContent = snapshot.content[contentElement.index];
                    snapshot.content[contentElement.index] = __classPrivateFieldGet(this, _AssistantStream_instances, "m", _AssistantStream_accumulateContent).call(this, contentElement, currentContent);
                } else {
                    snapshot.content[contentElement.index] = contentElement;
                    // This is a new element
                    newContent.push(contentElement);
                }
            }
            return [
                snapshot,
                newContent
            ];
        case 'thread.message.in_progress':
        case 'thread.message.completed':
        case 'thread.message.incomplete':
            //No changes on other thread events
            if (snapshot) return [
                snapshot,
                newContent
            ];
            else throw Error('Received thread message event with no existing snapshot');
    }
    throw Error('Tried to accumulate a non-message event');
}, _AssistantStream_accumulateContent = function _AssistantStream_accumulateContent(contentElement, currentContent) {
    return AssistantStream.accumulateDelta(currentContent, contentElement);
}, _AssistantStream_handleRun = function _AssistantStream_handleRun(event) {
    __classPrivateFieldSet(this, _AssistantStream_currentRunSnapshot, event.data, "f");
    switch(event.event){
        case 'thread.run.created':
            break;
        case 'thread.run.queued':
            break;
        case 'thread.run.in_progress':
            break;
        case 'thread.run.requires_action':
        case 'thread.run.cancelled':
        case 'thread.run.failed':
        case 'thread.run.completed':
        case 'thread.run.expired':
            __classPrivateFieldSet(this, _AssistantStream_finalRun, event.data, "f");
            if (__classPrivateFieldGet(this, _AssistantStream_currentToolCall, "f")) {
                this._emit('toolCallDone', __classPrivateFieldGet(this, _AssistantStream_currentToolCall, "f"));
                __classPrivateFieldSet(this, _AssistantStream_currentToolCall, undefined, "f");
            }
            break;
        case 'thread.run.cancelling':
            break;
    }
};

},{"d6cd8ed7023bf9e8":"SlwjS","fc24bb6d749c8827":"d2aDf","2feae34d7197ea81":"eZWCP","26d128d2dfdae8a1":"bWb4j"}],"NdZGs":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MessagesPage = exports.Messages = void 0;
const resource_1 = require("ccacdb25c4bc0c8d");
const core_1 = require("27a73dd6d6e6dd12");
const pagination_1 = require("73d51f1cdf77b7c7");
class Messages extends resource_1.APIResource {
    /**
     * Create a message.
     */ create(threadId, body, options) {
        return this._client.post(`/threads/${threadId}/messages`, {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Retrieve a message.
     */ retrieve(threadId, messageId, options) {
        return this._client.get(`/threads/${threadId}/messages/${messageId}`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Modifies a message.
     */ update(threadId, messageId, body, options) {
        return this._client.post(`/threads/${threadId}/messages/${messageId}`, {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    list(threadId, query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.list(threadId, {}, query);
        return this._client.getAPIList(`/threads/${threadId}/messages`, MessagesPage, {
            query,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Deletes a message.
     */ del(threadId, messageId, options) {
        return this._client.delete(`/threads/${threadId}/messages/${messageId}`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
}
exports.Messages = Messages;
class MessagesPage extends pagination_1.CursorPage {
}
exports.MessagesPage = MessagesPage;
Messages.MessagesPage = MessagesPage;

},{"ccacdb25c4bc0c8d":"jx5FL","27a73dd6d6e6dd12":"SlwjS","73d51f1cdf77b7c7":"ksr30"}],"cBGPF":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RunsPage = exports.Runs = void 0;
const resource_1 = require("c1810b898216bffd");
const core_1 = require("9f4ca446a480969");
const AssistantStream_1 = require("5e9128308d9d51f7");
const core_2 = require("9f4ca446a480969");
const StepsAPI = __importStar(require("5c5e592d26603751"));
const steps_1 = require("5c5e592d26603751");
const pagination_1 = require("a9d078c622ff2554");
class Runs extends resource_1.APIResource {
    constructor(){
        super(...arguments);
        this.steps = new StepsAPI.Steps(this._client);
    }
    create(threadId, params, options) {
        const { include, ...body } = params;
        return this._client.post(`/threads/${threadId}/runs`, {
            query: {
                include
            },
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            },
            stream: params.stream ?? false
        });
    }
    /**
     * Retrieves a run.
     */ retrieve(threadId, runId, options) {
        return this._client.get(`/threads/${threadId}/runs/${runId}`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Modifies a run.
     */ update(threadId, runId, body, options) {
        return this._client.post(`/threads/${threadId}/runs/${runId}`, {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    list(threadId, query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.list(threadId, {}, query);
        return this._client.getAPIList(`/threads/${threadId}/runs`, RunsPage, {
            query,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Cancels a run that is `in_progress`.
     */ cancel(threadId, runId, options) {
        return this._client.post(`/threads/${threadId}/runs/${runId}/cancel`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * A helper to create a run an poll for a terminal state. More information on Run
     * lifecycles can be found here:
     * https://platform.openai.com/docs/assistants/how-it-works/runs-and-run-steps
     */ async createAndPoll(threadId, body, options) {
        const run = await this.create(threadId, body, options);
        return await this.poll(threadId, run.id, options);
    }
    /**
     * Create a Run stream
     *
     * @deprecated use `stream` instead
     */ createAndStream(threadId, body, options) {
        return AssistantStream_1.AssistantStream.createAssistantStream(threadId, this._client.beta.threads.runs, body, options);
    }
    /**
     * A helper to poll a run status until it reaches a terminal state. More
     * information on Run lifecycles can be found here:
     * https://platform.openai.com/docs/assistants/how-it-works/runs-and-run-steps
     */ async poll(threadId, runId, options) {
        const headers = {
            ...options?.headers,
            'X-Stainless-Poll-Helper': 'true'
        };
        if (options?.pollIntervalMs) headers['X-Stainless-Custom-Poll-Interval'] = options.pollIntervalMs.toString();
        while(true){
            const { data: run, response } = await this.retrieve(threadId, runId, {
                ...options,
                headers: {
                    ...options?.headers,
                    ...headers
                }
            }).withResponse();
            switch(run.status){
                //If we are in any sort of intermediate state we poll
                case 'queued':
                case 'in_progress':
                case 'cancelling':
                    let sleepInterval = 5000;
                    if (options?.pollIntervalMs) sleepInterval = options.pollIntervalMs;
                    else {
                        const headerInterval = response.headers.get('openai-poll-after-ms');
                        if (headerInterval) {
                            const headerIntervalMs = parseInt(headerInterval);
                            if (!isNaN(headerIntervalMs)) sleepInterval = headerIntervalMs;
                        }
                    }
                    await (0, core_2.sleep)(sleepInterval);
                    break;
                //We return the run in any terminal state.
                case 'requires_action':
                case 'incomplete':
                case 'cancelled':
                case 'completed':
                case 'failed':
                case 'expired':
                    return run;
            }
        }
    }
    /**
     * Create a Run stream
     */ stream(threadId, body, options) {
        return AssistantStream_1.AssistantStream.createAssistantStream(threadId, this._client.beta.threads.runs, body, options);
    }
    submitToolOutputs(threadId, runId, body, options) {
        return this._client.post(`/threads/${threadId}/runs/${runId}/submit_tool_outputs`, {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            },
            stream: body.stream ?? false
        });
    }
    /**
     * A helper to submit a tool output to a run and poll for a terminal run state.
     * More information on Run lifecycles can be found here:
     * https://platform.openai.com/docs/assistants/how-it-works/runs-and-run-steps
     */ async submitToolOutputsAndPoll(threadId, runId, body, options) {
        const run = await this.submitToolOutputs(threadId, runId, body, options);
        return await this.poll(threadId, run.id, options);
    }
    /**
     * Submit the tool outputs from a previous run and stream the run to a terminal
     * state. More information on Run lifecycles can be found here:
     * https://platform.openai.com/docs/assistants/how-it-works/runs-and-run-steps
     */ submitToolOutputsStream(threadId, runId, body, options) {
        return AssistantStream_1.AssistantStream.createToolAssistantStream(threadId, runId, this._client.beta.threads.runs, body, options);
    }
}
exports.Runs = Runs;
class RunsPage extends pagination_1.CursorPage {
}
exports.RunsPage = RunsPage;
Runs.RunsPage = RunsPage;
Runs.Steps = steps_1.Steps;
Runs.RunStepsPage = steps_1.RunStepsPage;

},{"c1810b898216bffd":"jx5FL","9f4ca446a480969":"SlwjS","5e9128308d9d51f7":"jVwbt","5c5e592d26603751":"7im4B","a9d078c622ff2554":"ksr30"}],"7im4B":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RunStepsPage = exports.Steps = void 0;
const resource_1 = require("4da65600b8482b85");
const core_1 = require("c00329c98d9058a7");
const pagination_1 = require("6c6be1d28e7761f2");
class Steps extends resource_1.APIResource {
    retrieve(threadId, runId, stepId, query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.retrieve(threadId, runId, stepId, {}, query);
        return this._client.get(`/threads/${threadId}/runs/${runId}/steps/${stepId}`, {
            query,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    list(threadId, runId, query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.list(threadId, runId, {}, query);
        return this._client.getAPIList(`/threads/${threadId}/runs/${runId}/steps`, RunStepsPage, {
            query,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
}
exports.Steps = Steps;
class RunStepsPage extends pagination_1.CursorPage {
}
exports.RunStepsPage = RunStepsPage;
Steps.RunStepsPage = RunStepsPage;

},{"4da65600b8482b85":"jx5FL","c00329c98d9058a7":"SlwjS","6c6be1d28e7761f2":"ksr30"}],"4WhRT":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VectorStoresPage = exports.VectorStores = void 0;
const resource_1 = require("375a5cdb57c792a6");
const core_1 = require("fe648b0a7d306610");
const FileBatchesAPI = __importStar(require("61e83ba5369c23e8"));
const file_batches_1 = require("61e83ba5369c23e8");
const FilesAPI = __importStar(require("a8100cdcb6d76901"));
const files_1 = require("a8100cdcb6d76901");
const pagination_1 = require("36d83c0f00c9fd55");
class VectorStores extends resource_1.APIResource {
    constructor(){
        super(...arguments);
        this.files = new FilesAPI.Files(this._client);
        this.fileBatches = new FileBatchesAPI.FileBatches(this._client);
    }
    /**
     * Create a vector store.
     */ create(body, options) {
        return this._client.post('/vector_stores', {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Retrieves a vector store.
     */ retrieve(vectorStoreId, options) {
        return this._client.get(`/vector_stores/${vectorStoreId}`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Modifies a vector store.
     */ update(vectorStoreId, body, options) {
        return this._client.post(`/vector_stores/${vectorStoreId}`, {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    list(query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.list({}, query);
        return this._client.getAPIList('/vector_stores', VectorStoresPage, {
            query,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Delete a vector store.
     */ del(vectorStoreId, options) {
        return this._client.delete(`/vector_stores/${vectorStoreId}`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
}
exports.VectorStores = VectorStores;
class VectorStoresPage extends pagination_1.CursorPage {
}
exports.VectorStoresPage = VectorStoresPage;
VectorStores.VectorStoresPage = VectorStoresPage;
VectorStores.Files = files_1.Files;
VectorStores.VectorStoreFilesPage = files_1.VectorStoreFilesPage;
VectorStores.FileBatches = file_batches_1.FileBatches;

},{"375a5cdb57c792a6":"jx5FL","fe648b0a7d306610":"SlwjS","61e83ba5369c23e8":"hkY0d","a8100cdcb6d76901":"1OCRn","36d83c0f00c9fd55":"ksr30"}],"hkY0d":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VectorStoreFilesPage = exports.FileBatches = void 0;
const resource_1 = require("a0e67baab8d956c4");
const core_1 = require("94a17d2d22a1cf5a");
const core_2 = require("94a17d2d22a1cf5a");
const Util_1 = require("36f7ac26f76a8d45");
const files_1 = require("d2a9efdde12b8f91");
Object.defineProperty(exports, "VectorStoreFilesPage", {
    enumerable: true,
    get: function() {
        return files_1.VectorStoreFilesPage;
    }
});
class FileBatches extends resource_1.APIResource {
    /**
     * Create a vector store file batch.
     */ create(vectorStoreId, body, options) {
        return this._client.post(`/vector_stores/${vectorStoreId}/file_batches`, {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Retrieves a vector store file batch.
     */ retrieve(vectorStoreId, batchId, options) {
        return this._client.get(`/vector_stores/${vectorStoreId}/file_batches/${batchId}`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Cancel a vector store file batch. This attempts to cancel the processing of
     * files in this batch as soon as possible.
     */ cancel(vectorStoreId, batchId, options) {
        return this._client.post(`/vector_stores/${vectorStoreId}/file_batches/${batchId}/cancel`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Create a vector store batch and poll until all files have been processed.
     */ async createAndPoll(vectorStoreId, body, options) {
        const batch = await this.create(vectorStoreId, body);
        return await this.poll(vectorStoreId, batch.id, options);
    }
    listFiles(vectorStoreId, batchId, query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.listFiles(vectorStoreId, batchId, {}, query);
        return this._client.getAPIList(`/vector_stores/${vectorStoreId}/file_batches/${batchId}/files`, files_1.VectorStoreFilesPage, {
            query,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Wait for the given file batch to be processed.
     *
     * Note: this will return even if one of the files failed to process, you need to
     * check batch.file_counts.failed_count to handle this case.
     */ async poll(vectorStoreId, batchId, options) {
        const headers = {
            ...options?.headers,
            'X-Stainless-Poll-Helper': 'true'
        };
        if (options?.pollIntervalMs) headers['X-Stainless-Custom-Poll-Interval'] = options.pollIntervalMs.toString();
        while(true){
            const { data: batch, response } = await this.retrieve(vectorStoreId, batchId, {
                ...options,
                headers
            }).withResponse();
            switch(batch.status){
                case 'in_progress':
                    let sleepInterval = 5000;
                    if (options?.pollIntervalMs) sleepInterval = options.pollIntervalMs;
                    else {
                        const headerInterval = response.headers.get('openai-poll-after-ms');
                        if (headerInterval) {
                            const headerIntervalMs = parseInt(headerInterval);
                            if (!isNaN(headerIntervalMs)) sleepInterval = headerIntervalMs;
                        }
                    }
                    await (0, core_2.sleep)(sleepInterval);
                    break;
                case 'failed':
                case 'cancelled':
                case 'completed':
                    return batch;
            }
        }
    }
    /**
     * Uploads the given files concurrently and then creates a vector store file batch.
     *
     * The concurrency limit is configurable using the `maxConcurrency` parameter.
     */ async uploadAndPoll(vectorStoreId, { files, fileIds = [] }, options) {
        if (files == null || files.length == 0) throw new Error(`No \`files\` provided to process. If you've already uploaded files you should use \`.createAndPoll()\` instead`);
        const configuredConcurrency = options?.maxConcurrency ?? 5;
        // We cap the number of workers at the number of files (so we don't start any unnecessary workers)
        const concurrencyLimit = Math.min(configuredConcurrency, files.length);
        const client = this._client;
        const fileIterator = files.values();
        const allFileIds = [
            ...fileIds
        ];
        // This code is based on this design. The libraries don't accommodate our environment limits.
        // https://stackoverflow.com/questions/40639432/what-is-the-best-way-to-limit-concurrency-when-using-es6s-promise-all
        async function processFiles(iterator) {
            for (let item of iterator){
                const fileObj = await client.files.create({
                    file: item,
                    purpose: 'assistants'
                }, options);
                allFileIds.push(fileObj.id);
            }
        }
        // Start workers to process results
        const workers = Array(concurrencyLimit).fill(fileIterator).map(processFiles);
        // Wait for all processing to complete.
        await (0, Util_1.allSettledWithThrow)(workers);
        return await this.createAndPoll(vectorStoreId, {
            file_ids: allFileIds
        });
    }
}
exports.FileBatches = FileBatches;

},{"a0e67baab8d956c4":"jx5FL","94a17d2d22a1cf5a":"SlwjS","36f7ac26f76a8d45":"9mdJQ","d2a9efdde12b8f91":"1OCRn"}],"9mdJQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.allSettledWithThrow = void 0;
/**
 * Like `Promise.allSettled()` but throws an error if any promises are rejected.
 */ const allSettledWithThrow = async (promises)=>{
    const results = await Promise.allSettled(promises);
    const rejected = results.filter((result)=>result.status === 'rejected');
    if (rejected.length) {
        for (const result of rejected)console.error(result.reason);
        throw new Error(`${rejected.length} promise(s) failed - see the above errors`);
    }
    // Note: TS was complaining about using `.filter().map()` here for some reason
    const values = [];
    for (const result of results)if (result.status === 'fulfilled') values.push(result.value);
    return values;
};
exports.allSettledWithThrow = allSettledWithThrow;

},{}],"1OCRn":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VectorStoreFilesPage = exports.Files = void 0;
const resource_1 = require("73f47f71045eeadc");
const core_1 = require("cf92c3d22ba9a85b");
const pagination_1 = require("fa9bcb7f23976f8c");
class Files extends resource_1.APIResource {
    /**
     * Create a vector store file by attaching a
     * [File](https://platform.openai.com/docs/api-reference/files) to a
     * [vector store](https://platform.openai.com/docs/api-reference/vector-stores/object).
     */ create(vectorStoreId, body, options) {
        return this._client.post(`/vector_stores/${vectorStoreId}/files`, {
            body,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Retrieves a vector store file.
     */ retrieve(vectorStoreId, fileId, options) {
        return this._client.get(`/vector_stores/${vectorStoreId}/files/${fileId}`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    list(vectorStoreId, query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.list(vectorStoreId, {}, query);
        return this._client.getAPIList(`/vector_stores/${vectorStoreId}/files`, VectorStoreFilesPage, {
            query,
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Delete a vector store file. This will remove the file from the vector store but
     * the file itself will not be deleted. To delete the file, use the
     * [delete file](https://platform.openai.com/docs/api-reference/files/delete)
     * endpoint.
     */ del(vectorStoreId, fileId, options) {
        return this._client.delete(`/vector_stores/${vectorStoreId}/files/${fileId}`, {
            ...options,
            headers: {
                'OpenAI-Beta': 'assistants=v2',
                ...options?.headers
            }
        });
    }
    /**
     * Attach a file to the given vector store and wait for it to be processed.
     */ async createAndPoll(vectorStoreId, body, options) {
        const file = await this.create(vectorStoreId, body, options);
        return await this.poll(vectorStoreId, file.id, options);
    }
    /**
     * Wait for the vector store file to finish processing.
     *
     * Note: this will return even if the file failed to process, you need to check
     * file.last_error and file.status to handle these cases
     */ async poll(vectorStoreId, fileId, options) {
        const headers = {
            ...options?.headers,
            'X-Stainless-Poll-Helper': 'true'
        };
        if (options?.pollIntervalMs) headers['X-Stainless-Custom-Poll-Interval'] = options.pollIntervalMs.toString();
        while(true){
            const fileResponse = await this.retrieve(vectorStoreId, fileId, {
                ...options,
                headers
            }).withResponse();
            const file = fileResponse.data;
            switch(file.status){
                case 'in_progress':
                    let sleepInterval = 5000;
                    if (options?.pollIntervalMs) sleepInterval = options.pollIntervalMs;
                    else {
                        const headerInterval = fileResponse.response.headers.get('openai-poll-after-ms');
                        if (headerInterval) {
                            const headerIntervalMs = parseInt(headerInterval);
                            if (!isNaN(headerIntervalMs)) sleepInterval = headerIntervalMs;
                        }
                    }
                    await (0, core_1.sleep)(sleepInterval);
                    break;
                case 'failed':
                case 'completed':
                    return file;
            }
        }
    }
    /**
     * Upload a file to the `files` API and then attach it to the given vector store.
     *
     * Note the file will be asynchronously processed (you can use the alternative
     * polling helper method to wait for processing to complete).
     */ async upload(vectorStoreId, file, options) {
        const fileInfo = await this._client.files.create({
            file: file,
            purpose: 'assistants'
        }, options);
        return this.create(vectorStoreId, {
            file_id: fileInfo.id
        }, options);
    }
    /**
     * Add a file to a vector store and poll until processing is complete.
     */ async uploadAndPoll(vectorStoreId, file, options) {
        const fileInfo = await this.upload(vectorStoreId, file, options);
        return await this.poll(vectorStoreId, fileInfo.id, options);
    }
}
exports.Files = Files;
class VectorStoreFilesPage extends pagination_1.CursorPage {
}
exports.VectorStoreFilesPage = VectorStoreFilesPage;
Files.VectorStoreFilesPage = VectorStoreFilesPage;

},{"73f47f71045eeadc":"jx5FL","cf92c3d22ba9a85b":"SlwjS","fa9bcb7f23976f8c":"ksr30"}],"eRjoN":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Completions = void 0;
const resource_1 = require("a01b44df83810392");
class Completions extends resource_1.APIResource {
    create(body, options) {
        return this._client.post('/completions', {
            body,
            ...options,
            stream: body.stream ?? false
        });
    }
}
exports.Completions = Completions;

},{"a01b44df83810392":"jx5FL"}],"FW9ea":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Embeddings = void 0;
const resource_1 = require("a09530080d1baa01");
class Embeddings extends resource_1.APIResource {
    /**
     * Creates an embedding vector representing the input text.
     */ create(body, options) {
        return this._client.post('/embeddings', {
            body,
            ...options
        });
    }
}
exports.Embeddings = Embeddings;

},{"a09530080d1baa01":"jx5FL"}],"1J1vk":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FileObjectsPage = exports.Files = void 0;
const resource_1 = require("6f1730549106d008");
const core_1 = require("65729fe5ab38e7fc");
const core_2 = require("65729fe5ab38e7fc");
const error_1 = require("a87ec1f6d0991d08");
const Core = __importStar(require("65729fe5ab38e7fc"));
const pagination_1 = require("cfcb0bab8a7abd2d");
class Files extends resource_1.APIResource {
    /**
     * Upload a file that can be used across various endpoints. Individual files can be
     * up to 512 MB, and the size of all files uploaded by one organization can be up
     * to 100 GB.
     *
     * The Assistants API supports files up to 2 million tokens and of specific file
     * types. See the
     * [Assistants Tools guide](https://platform.openai.com/docs/assistants/tools) for
     * details.
     *
     * The Fine-tuning API only supports `.jsonl` files. The input also has certain
     * required formats for fine-tuning
     * [chat](https://platform.openai.com/docs/api-reference/fine-tuning/chat-input) or
     * [completions](https://platform.openai.com/docs/api-reference/fine-tuning/completions-input)
     * models.
     *
     * The Batch API only supports `.jsonl` files up to 100 MB in size. The input also
     * has a specific required
     * [format](https://platform.openai.com/docs/api-reference/batch/request-input).
     *
     * Please [contact us](https://help.openai.com/) if you need to increase these
     * storage limits.
     */ create(body, options) {
        return this._client.post('/files', Core.multipartFormRequestOptions({
            body,
            ...options
        }));
    }
    /**
     * Returns information about a specific file.
     */ retrieve(fileId, options) {
        return this._client.get(`/files/${fileId}`, options);
    }
    list(query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.list({}, query);
        return this._client.getAPIList('/files', FileObjectsPage, {
            query,
            ...options
        });
    }
    /**
     * Delete a file.
     */ del(fileId, options) {
        return this._client.delete(`/files/${fileId}`, options);
    }
    /**
     * Returns the contents of the specified file.
     */ content(fileId, options) {
        return this._client.get(`/files/${fileId}/content`, {
            ...options,
            __binaryResponse: true
        });
    }
    /**
     * Returns the contents of the specified file.
     *
     * @deprecated The `.content()` method should be used instead
     */ retrieveContent(fileId, options) {
        return this._client.get(`/files/${fileId}/content`, {
            ...options,
            headers: {
                Accept: 'application/json',
                ...options?.headers
            }
        });
    }
    /**
     * Waits for the given file to be processed, default timeout is 30 mins.
     */ async waitForProcessing(id, { pollInterval = 5000, maxWait = 1800000 } = {}) {
        const TERMINAL_STATES = new Set([
            'processed',
            'error',
            'deleted'
        ]);
        const start = Date.now();
        let file = await this.retrieve(id);
        while(!file.status || !TERMINAL_STATES.has(file.status)){
            await (0, core_2.sleep)(pollInterval);
            file = await this.retrieve(id);
            if (Date.now() - start > maxWait) throw new error_1.APIConnectionTimeoutError({
                message: `Giving up on waiting for file ${id} to finish processing after ${maxWait} milliseconds.`
            });
        }
        return file;
    }
}
exports.Files = Files;
class FileObjectsPage extends pagination_1.CursorPage {
}
exports.FileObjectsPage = FileObjectsPage;
Files.FileObjectsPage = FileObjectsPage;

},{"6f1730549106d008":"jx5FL","65729fe5ab38e7fc":"SlwjS","a87ec1f6d0991d08":"eZWCP","cfcb0bab8a7abd2d":"ksr30"}],"ibFA3":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FineTuning = void 0;
const resource_1 = require("d7629eaadbae503f");
const JobsAPI = __importStar(require("408eafe0e6034d76"));
const jobs_1 = require("408eafe0e6034d76");
class FineTuning extends resource_1.APIResource {
    constructor(){
        super(...arguments);
        this.jobs = new JobsAPI.Jobs(this._client);
    }
}
exports.FineTuning = FineTuning;
FineTuning.Jobs = jobs_1.Jobs;
FineTuning.FineTuningJobsPage = jobs_1.FineTuningJobsPage;
FineTuning.FineTuningJobEventsPage = jobs_1.FineTuningJobEventsPage;

},{"d7629eaadbae503f":"jx5FL","408eafe0e6034d76":"a5EIO"}],"a5EIO":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FineTuningJobEventsPage = exports.FineTuningJobsPage = exports.Jobs = void 0;
const resource_1 = require("e50e5a2b3aa51cf3");
const core_1 = require("847322b3490dd21d");
const CheckpointsAPI = __importStar(require("e8ada2d7fff634eb"));
const checkpoints_1 = require("e8ada2d7fff634eb");
const pagination_1 = require("7c1d882729b3fc14");
class Jobs extends resource_1.APIResource {
    constructor(){
        super(...arguments);
        this.checkpoints = new CheckpointsAPI.Checkpoints(this._client);
    }
    /**
     * Creates a fine-tuning job which begins the process of creating a new model from
     * a given dataset.
     *
     * Response includes details of the enqueued job including job status and the name
     * of the fine-tuned models once complete.
     *
     * [Learn more about fine-tuning](https://platform.openai.com/docs/guides/fine-tuning)
     */ create(body, options) {
        return this._client.post('/fine_tuning/jobs', {
            body,
            ...options
        });
    }
    /**
     * Get info about a fine-tuning job.
     *
     * [Learn more about fine-tuning](https://platform.openai.com/docs/guides/fine-tuning)
     */ retrieve(fineTuningJobId, options) {
        return this._client.get(`/fine_tuning/jobs/${fineTuningJobId}`, options);
    }
    list(query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.list({}, query);
        return this._client.getAPIList('/fine_tuning/jobs', FineTuningJobsPage, {
            query,
            ...options
        });
    }
    /**
     * Immediately cancel a fine-tune job.
     */ cancel(fineTuningJobId, options) {
        return this._client.post(`/fine_tuning/jobs/${fineTuningJobId}/cancel`, options);
    }
    listEvents(fineTuningJobId, query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.listEvents(fineTuningJobId, {}, query);
        return this._client.getAPIList(`/fine_tuning/jobs/${fineTuningJobId}/events`, FineTuningJobEventsPage, {
            query,
            ...options
        });
    }
}
exports.Jobs = Jobs;
class FineTuningJobsPage extends pagination_1.CursorPage {
}
exports.FineTuningJobsPage = FineTuningJobsPage;
class FineTuningJobEventsPage extends pagination_1.CursorPage {
}
exports.FineTuningJobEventsPage = FineTuningJobEventsPage;
Jobs.FineTuningJobsPage = FineTuningJobsPage;
Jobs.FineTuningJobEventsPage = FineTuningJobEventsPage;
Jobs.Checkpoints = checkpoints_1.Checkpoints;
Jobs.FineTuningJobCheckpointsPage = checkpoints_1.FineTuningJobCheckpointsPage;

},{"e50e5a2b3aa51cf3":"jx5FL","847322b3490dd21d":"SlwjS","e8ada2d7fff634eb":"8auij","7c1d882729b3fc14":"ksr30"}],"8auij":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FineTuningJobCheckpointsPage = exports.Checkpoints = void 0;
const resource_1 = require("c9c867f5295fd282");
const core_1 = require("95647c2743b9ac5f");
const pagination_1 = require("fee9049062ecf242");
class Checkpoints extends resource_1.APIResource {
    list(fineTuningJobId, query = {}, options) {
        if ((0, core_1.isRequestOptions)(query)) return this.list(fineTuningJobId, {}, query);
        return this._client.getAPIList(`/fine_tuning/jobs/${fineTuningJobId}/checkpoints`, FineTuningJobCheckpointsPage, {
            query,
            ...options
        });
    }
}
exports.Checkpoints = Checkpoints;
class FineTuningJobCheckpointsPage extends pagination_1.CursorPage {
}
exports.FineTuningJobCheckpointsPage = FineTuningJobCheckpointsPage;
Checkpoints.FineTuningJobCheckpointsPage = FineTuningJobCheckpointsPage;

},{"c9c867f5295fd282":"jx5FL","95647c2743b9ac5f":"SlwjS","fee9049062ecf242":"ksr30"}],"avguL":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Images = void 0;
const resource_1 = require("4b95f2195e7761b7");
const Core = __importStar(require("7a4d610f1d4aeca7"));
class Images extends resource_1.APIResource {
    /**
     * Creates a variation of a given image.
     */ createVariation(body, options) {
        return this._client.post('/images/variations', Core.multipartFormRequestOptions({
            body,
            ...options
        }));
    }
    /**
     * Creates an edited or extended image given an original image and a prompt.
     */ edit(body, options) {
        return this._client.post('/images/edits', Core.multipartFormRequestOptions({
            body,
            ...options
        }));
    }
    /**
     * Creates an image given a prompt.
     */ generate(body, options) {
        return this._client.post('/images/generations', {
            body,
            ...options
        });
    }
}
exports.Images = Images;

},{"4b95f2195e7761b7":"jx5FL","7a4d610f1d4aeca7":"SlwjS"}],"4Wm3Z":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModelsPage = exports.Models = void 0;
const resource_1 = require("e44d8e4e404e03fb");
const pagination_1 = require("9f7a6a65ccb9331");
class Models extends resource_1.APIResource {
    /**
     * Retrieves a model instance, providing basic information about the model such as
     * the owner and permissioning.
     */ retrieve(model, options) {
        return this._client.get(`/models/${model}`, options);
    }
    /**
     * Lists the currently available models, and provides basic information about each
     * one such as the owner and availability.
     */ list(options) {
        return this._client.getAPIList('/models', ModelsPage, options);
    }
    /**
     * Delete a fine-tuned model. You must have the Owner role in your organization to
     * delete a model.
     */ del(model, options) {
        return this._client.delete(`/models/${model}`, options);
    }
}
exports.Models = Models;
/**
 * Note: no pagination actually occurs yet, this is for forwards-compatibility.
 */ class ModelsPage extends pagination_1.Page {
}
exports.ModelsPage = ModelsPage;
Models.ModelsPage = ModelsPage;

},{"e44d8e4e404e03fb":"jx5FL","9f7a6a65ccb9331":"ksr30"}],"cAV1c":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Moderations = void 0;
const resource_1 = require("62d6cbca07213bc7");
class Moderations extends resource_1.APIResource {
    /**
     * Classifies if text and/or image inputs are potentially harmful. Learn more in
     * the [moderation guide](https://platform.openai.com/docs/guides/moderation).
     */ create(body, options) {
        return this._client.post('/moderations', {
            body,
            ...options
        });
    }
}
exports.Moderations = Moderations;

},{"62d6cbca07213bc7":"jx5FL"}],"fROuZ":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Uploads = void 0;
const resource_1 = require("b6c9cce4509c8373");
const PartsAPI = __importStar(require("d4ffafc165e19174"));
const parts_1 = require("d4ffafc165e19174");
class Uploads extends resource_1.APIResource {
    constructor(){
        super(...arguments);
        this.parts = new PartsAPI.Parts(this._client);
    }
    /**
     * Creates an intermediate
     * [Upload](https://platform.openai.com/docs/api-reference/uploads/object) object
     * that you can add
     * [Parts](https://platform.openai.com/docs/api-reference/uploads/part-object) to.
     * Currently, an Upload can accept at most 8 GB in total and expires after an hour
     * after you create it.
     *
     * Once you complete the Upload, we will create a
     * [File](https://platform.openai.com/docs/api-reference/files/object) object that
     * contains all the parts you uploaded. This File is usable in the rest of our
     * platform as a regular File object.
     *
     * For certain `purpose`s, the correct `mime_type` must be specified. Please refer
     * to documentation for the supported MIME types for your use case:
     *
     * - [Assistants](https://platform.openai.com/docs/assistants/tools/file-search#supported-files)
     *
     * For guidance on the proper filename extensions for each purpose, please follow
     * the documentation on
     * [creating a File](https://platform.openai.com/docs/api-reference/files/create).
     */ create(body, options) {
        return this._client.post('/uploads', {
            body,
            ...options
        });
    }
    /**
     * Cancels the Upload. No Parts may be added after an Upload is cancelled.
     */ cancel(uploadId, options) {
        return this._client.post(`/uploads/${uploadId}/cancel`, options);
    }
    /**
     * Completes the
     * [Upload](https://platform.openai.com/docs/api-reference/uploads/object).
     *
     * Within the returned Upload object, there is a nested
     * [File](https://platform.openai.com/docs/api-reference/files/object) object that
     * is ready to use in the rest of the platform.
     *
     * You can specify the order of the Parts by passing in an ordered list of the Part
     * IDs.
     *
     * The number of bytes uploaded upon completion must match the number of bytes
     * initially specified when creating the Upload object. No Parts may be added after
     * an Upload is completed.
     */ complete(uploadId, body, options) {
        return this._client.post(`/uploads/${uploadId}/complete`, {
            body,
            ...options
        });
    }
}
exports.Uploads = Uploads;
Uploads.Parts = parts_1.Parts;

},{"b6c9cce4509c8373":"jx5FL","d4ffafc165e19174":"gs9ux"}],"gs9ux":[function(require,module,exports,__globalThis) {
"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Parts = void 0;
const resource_1 = require("f5b5da0e04072a79");
const Core = __importStar(require("be97891ccbbd6b8f"));
class Parts extends resource_1.APIResource {
    /**
     * Adds a
     * [Part](https://platform.openai.com/docs/api-reference/uploads/part-object) to an
     * [Upload](https://platform.openai.com/docs/api-reference/uploads/object) object.
     * A Part represents a chunk of bytes from the file you are trying to upload.
     *
     * Each Part can be at most 64 MB, and you can add Parts until you hit the Upload
     * maximum of 8 GB.
     *
     * It is possible to add multiple Parts in parallel. You can decide the intended
     * order of the Parts when you
     * [complete the Upload](https://platform.openai.com/docs/api-reference/uploads/complete).
     */ create(uploadId, body, options) {
        return this._client.post(`/uploads/${uploadId}/parts`, Core.multipartFormRequestOptions({
            body,
            ...options
        }));
    }
}
exports.Parts = Parts;

},{"f5b5da0e04072a79":"jx5FL","be97891ccbbd6b8f":"SlwjS"}],"1Wv2V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "messageToOpenAIRole", ()=>messageToOpenAIRole);
// Used in LangSmith, export is important here
parcelHelpers.export(exports, "_convertMessagesToOpenAIParams", ()=>_convertMessagesToOpenAIParams);
/**
 * OpenAI chat model integration.
 *
 * Setup:
 * Install `@langchain/openai` and set an environment variable named `OPENAI_API_KEY`.
 *
 * ```bash
 * npm install @langchain/openai
 * export OPENAI_API_KEY="your-api-key"
 * ```
 *
 * ## [Constructor args](https://api.js.langchain.com/classes/langchain_openai.ChatOpenAI.html#constructor)
 *
 * ## [Runtime args](https://api.js.langchain.com/interfaces/langchain_openai.ChatOpenAICallOptions.html)
 *
 * Runtime args can be passed as the second argument to any of the base runnable methods `.invoke`. `.stream`, `.batch`, etc.
 * They can also be passed via `.bind`, or the second arg in `.bindTools`, like shown in the examples below:
 *
 * ```typescript
 * // When calling `.bind`, call options should be passed via the first argument
 * const llmWithArgsBound = llm.bind({
 *   stop: ["\n"],
 *   tools: [...],
 * });
 *
 * // When calling `.bindTools`, call options should be passed via the second argument
 * const llmWithTools = llm.bindTools(
 *   [...],
 *   {
 *     tool_choice: "auto",
 *   }
 * );
 * ```
 *
 * ## Examples
 *
 * <details open>
 * <summary><strong>Instantiate</strong></summary>
 *
 * ```typescript
 * import { ChatOpenAI } from '@langchain/openai';
 *
 * const llm = new ChatOpenAI({
 *   model: "gpt-4o",
 *   temperature: 0,
 *   maxTokens: undefined,
 *   timeout: undefined,
 *   maxRetries: 2,
 *   // apiKey: "...",
 *   // baseUrl: "...",
 *   // organization: "...",
 *   // other params...
 * });
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Invoking</strong></summary>
 *
 * ```typescript
 * const input = `Translate "I love programming" into French.`;
 *
 * // Models also accept a list of chat messages or a formatted prompt
 * const result = await llm.invoke(input);
 * console.log(result);
 * ```
 *
 * ```txt
 * AIMessage {
 *   "id": "chatcmpl-9u4Mpu44CbPjwYFkTbeoZgvzB00Tz",
 *   "content": "J'adore la programmation.",
 *   "response_metadata": {
 *     "tokenUsage": {
 *       "completionTokens": 5,
 *       "promptTokens": 28,
 *       "totalTokens": 33
 *     },
 *     "finish_reason": "stop",
 *     "system_fingerprint": "fp_3aa7262c27"
 *   },
 *   "usage_metadata": {
 *     "input_tokens": 28,
 *     "output_tokens": 5,
 *     "total_tokens": 33
 *   }
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Streaming Chunks</strong></summary>
 *
 * ```typescript
 * for await (const chunk of await llm.stream(input)) {
 *   console.log(chunk);
 * }
 * ```
 *
 * ```txt
 * AIMessageChunk {
 *   "id": "chatcmpl-9u4NWB7yUeHCKdLr6jP3HpaOYHTqs",
 *   "content": ""
 * }
 * AIMessageChunk {
 *   "content": "J"
 * }
 * AIMessageChunk {
 *   "content": "'adore"
 * }
 * AIMessageChunk {
 *   "content": " la"
 * }
 * AIMessageChunk {
 *   "content": " programmation",,
 * }
 * AIMessageChunk {
 *   "content": ".",,
 * }
 * AIMessageChunk {
 *   "content": "",
 *   "response_metadata": {
 *     "finish_reason": "stop",
 *     "system_fingerprint": "fp_c9aa9c0491"
 *   },
 * }
 * AIMessageChunk {
 *   "content": "",
 *   "usage_metadata": {
 *     "input_tokens": 28,
 *     "output_tokens": 5,
 *     "total_tokens": 33
 *   }
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Aggregate Streamed Chunks</strong></summary>
 *
 * ```typescript
 * import { AIMessageChunk } from '@langchain/core/messages';
 * import { concat } from '@langchain/core/utils/stream';
 *
 * const stream = await llm.stream(input);
 * let full: AIMessageChunk | undefined;
 * for await (const chunk of stream) {
 *   full = !full ? chunk : concat(full, chunk);
 * }
 * console.log(full);
 * ```
 *
 * ```txt
 * AIMessageChunk {
 *   "id": "chatcmpl-9u4PnX6Fy7OmK46DASy0bH6cxn5Xu",
 *   "content": "J'adore la programmation.",
 *   "response_metadata": {
 *     "prompt": 0,
 *     "completion": 0,
 *     "finish_reason": "stop",
 *   },
 *   "usage_metadata": {
 *     "input_tokens": 28,
 *     "output_tokens": 5,
 *     "total_tokens": 33
 *   }
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Bind tools</strong></summary>
 *
 * ```typescript
 * import { z } from 'zod';
 *
 * const GetWeather = {
 *   name: "GetWeather",
 *   description: "Get the current weather in a given location",
 *   schema: z.object({
 *     location: z.string().describe("The city and state, e.g. San Francisco, CA")
 *   }),
 * }
 *
 * const GetPopulation = {
 *   name: "GetPopulation",
 *   description: "Get the current population in a given location",
 *   schema: z.object({
 *     location: z.string().describe("The city and state, e.g. San Francisco, CA")
 *   }),
 * }
 *
 * const llmWithTools = llm.bindTools(
 *   [GetWeather, GetPopulation],
 *   {
 *     // strict: true  // enforce tool args schema is respected
 *   }
 * );
 * const aiMsg = await llmWithTools.invoke(
 *   "Which city is hotter today and which is bigger: LA or NY?"
 * );
 * console.log(aiMsg.tool_calls);
 * ```
 *
 * ```txt
 * [
 *   {
 *     name: 'GetWeather',
 *     args: { location: 'Los Angeles, CA' },
 *     type: 'tool_call',
 *     id: 'call_uPU4FiFzoKAtMxfmPnfQL6UK'
 *   },
 *   {
 *     name: 'GetWeather',
 *     args: { location: 'New York, NY' },
 *     type: 'tool_call',
 *     id: 'call_UNkEwuQsHrGYqgDQuH9nPAtX'
 *   },
 *   {
 *     name: 'GetPopulation',
 *     args: { location: 'Los Angeles, CA' },
 *     type: 'tool_call',
 *     id: 'call_kL3OXxaq9OjIKqRTpvjaCH14'
 *   },
 *   {
 *     name: 'GetPopulation',
 *     args: { location: 'New York, NY' },
 *     type: 'tool_call',
 *     id: 'call_s9KQB1UWj45LLGaEnjz0179q'
 *   }
 * ]
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Structured Output</strong></summary>
 *
 * ```typescript
 * import { z } from 'zod';
 *
 * const Joke = z.object({
 *   setup: z.string().describe("The setup of the joke"),
 *   punchline: z.string().describe("The punchline to the joke"),
 *   rating: z.number().optional().describe("How funny the joke is, from 1 to 10")
 * }).describe('Joke to tell user.');
 *
 * const structuredLlm = llm.withStructuredOutput(Joke, {
 *   name: "Joke",
 *   strict: true, // Optionally enable OpenAI structured outputs
 * });
 * const jokeResult = await structuredLlm.invoke("Tell me a joke about cats");
 * console.log(jokeResult);
 * ```
 *
 * ```txt
 * {
 *   setup: 'Why was the cat sitting on the computer?',
 *   punchline: 'Because it wanted to keep an eye on the mouse!',
 *   rating: 7
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>JSON Object Response Format</strong></summary>
 *
 * ```typescript
 * const jsonLlm = llm.bind({ response_format: { type: "json_object" } });
 * const jsonLlmAiMsg = await jsonLlm.invoke(
 *   "Return a JSON object with key 'randomInts' and a value of 10 random ints in [0-99]"
 * );
 * console.log(jsonLlmAiMsg.content);
 * ```
 *
 * ```txt
 * {
 *   "randomInts": [23, 87, 45, 12, 78, 34, 56, 90, 11, 67]
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Multimodal</strong></summary>
 *
 * ```typescript
 * import { HumanMessage } from '@langchain/core/messages';
 *
 * const imageUrl = "https://example.com/image.jpg";
 * const imageData = await fetch(imageUrl).then(res => res.arrayBuffer());
 * const base64Image = Buffer.from(imageData).toString('base64');
 *
 * const message = new HumanMessage({
 *   content: [
 *     { type: "text", text: "describe the weather in this image" },
 *     {
 *       type: "image_url",
 *       image_url: { url: `data:image/jpeg;base64,${base64Image}` },
 *     },
 *   ]
 * });
 *
 * const imageDescriptionAiMsg = await llm.invoke([message]);
 * console.log(imageDescriptionAiMsg.content);
 * ```
 *
 * ```txt
 * The weather in the image appears to be clear and sunny. The sky is mostly blue with a few scattered white clouds, indicating fair weather. The bright sunlight is casting shadows on the green, grassy hill, suggesting it is a pleasant day with good visibility. There are no signs of rain or stormy conditions.
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Usage Metadata</strong></summary>
 *
 * ```typescript
 * const aiMsgForMetadata = await llm.invoke(input);
 * console.log(aiMsgForMetadata.usage_metadata);
 * ```
 *
 * ```txt
 * { input_tokens: 28, output_tokens: 5, total_tokens: 33 }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Logprobs</strong></summary>
 *
 * ```typescript
 * const logprobsLlm = new ChatOpenAI({ logprobs: true });
 * const aiMsgForLogprobs = await logprobsLlm.invoke(input);
 * console.log(aiMsgForLogprobs.response_metadata.logprobs);
 * ```
 *
 * ```txt
 * {
 *   content: [
 *     {
 *       token: 'J',
 *       logprob: -0.000050616763,
 *       bytes: [Array],
 *       top_logprobs: []
 *     },
 *     {
 *       token: "'",
 *       logprob: -0.01868736,
 *       bytes: [Array],
 *       top_logprobs: []
 *     },
 *     {
 *       token: 'ad',
 *       logprob: -0.0000030545007,
 *       bytes: [Array],
 *       top_logprobs: []
 *     },
 *     { token: 'ore', logprob: 0, bytes: [Array], top_logprobs: [] },
 *     {
 *       token: ' la',
 *       logprob: -0.515404,
 *       bytes: [Array],
 *       top_logprobs: []
 *     },
 *     {
 *       token: ' programm',
 *       logprob: -0.0000118755715,
 *       bytes: [Array],
 *       top_logprobs: []
 *     },
 *     { token: 'ation', logprob: 0, bytes: [Array], top_logprobs: [] },
 *     {
 *       token: '.',
 *       logprob: -0.0000037697225,
 *       bytes: [Array],
 *       top_logprobs: []
 *     }
 *   ],
 *   refusal: null
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Response Metadata</strong></summary>
 *
 * ```typescript
 * const aiMsgForResponseMetadata = await llm.invoke(input);
 * console.log(aiMsgForResponseMetadata.response_metadata);
 * ```
 *
 * ```txt
 * {
 *   tokenUsage: { completionTokens: 5, promptTokens: 28, totalTokens: 33 },
 *   finish_reason: 'stop',
 *   system_fingerprint: 'fp_3aa7262c27'
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>JSON Schema Structured Output</strong></summary>
 *
 * ```typescript
 * const llmForJsonSchema = new ChatOpenAI({
 *   model: "gpt-4o-2024-08-06",
 * }).withStructuredOutput(
 *   z.object({
 *     command: z.string().describe("The command to execute"),
 *     expectedOutput: z.string().describe("The expected output of the command"),
 *     options: z
 *       .array(z.string())
 *       .describe("The options you can pass to the command"),
 *   }),
 *   {
 *     method: "jsonSchema",
 *     strict: true, // Optional when using the `jsonSchema` method
 *   }
 * );
 *
 * const jsonSchemaRes = await llmForJsonSchema.invoke(
 *   "What is the command to list files in a directory?"
 * );
 * console.log(jsonSchemaRes);
 * ```
 *
 * ```txt
 * {
 *   command: 'ls',
 *   expectedOutput: 'A list of files and subdirectories within the specified directory.',
 *   options: [
 *     '-a: include directory entries whose names begin with a dot (.).',
 *     '-l: use a long listing format.',
 *     '-h: with -l, print sizes in human readable format (e.g., 1K, 234M, 2G).',
 *     '-t: sort by time, newest first.',
 *     '-r: reverse order while sorting.',
 *     '-S: sort by file size, largest first.',
 *     '-R: list subdirectories recursively.'
 *   ]
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Audio Outputs</strong></summary>
 *
 * ```typescript
 * import { ChatOpenAI } from "@langchain/openai";
 *
 * const modelWithAudioOutput = new ChatOpenAI({
 *   model: "gpt-4o-audio-preview",
 *   // You may also pass these fields to `.bind` as a call argument.
 *   modalities: ["text", "audio"], // Specifies that the model should output audio.
 *   audio: {
 *     voice: "alloy",
 *     format: "wav",
 *   },
 * });
 *
 * const audioOutputResult = await modelWithAudioOutput.invoke("Tell me a joke about cats.");
 * const castMessageContent = audioOutputResult.content[0] as Record<string, any>;
 *
 * console.log({
 *   ...castMessageContent,
 *   data: castMessageContent.data.slice(0, 100) // Sliced for brevity
 * })
 * ```
 *
 * ```txt
 * {
 *   id: 'audio_67117718c6008190a3afad3e3054b9b6',
 *   data: 'UklGRqYwBgBXQVZFZm10IBAAAAABAAEAwF0AAIC7AAACABAATElTVBoAAABJTkZPSVNGVA4AAABMYXZmNTguMjkuMTAwAGRhdGFg',
 *   expires_at: 1729201448,
 *   transcript: 'Sure! Why did the cat sit on the computer? Because it wanted to keep an eye on the mouse!'
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Audio Outputs</strong></summary>
 *
 * ```typescript
 * import { ChatOpenAI } from "@langchain/openai";
 *
 * const modelWithAudioOutput = new ChatOpenAI({
 *   model: "gpt-4o-audio-preview",
 *   // You may also pass these fields to `.bind` as a call argument.
 *   modalities: ["text", "audio"], // Specifies that the model should output audio.
 *   audio: {
 *     voice: "alloy",
 *     format: "wav",
 *   },
 * });
 *
 * const audioOutputResult = await modelWithAudioOutput.invoke("Tell me a joke about cats.");
 * const castAudioContent = audioOutputResult.additional_kwargs.audio as Record<string, any>;
 *
 * console.log({
 *   ...castAudioContent,
 *   data: castAudioContent.data.slice(0, 100) // Sliced for brevity
 * })
 * ```
 *
 * ```txt
 * {
 *   id: 'audio_67117718c6008190a3afad3e3054b9b6',
 *   data: 'UklGRqYwBgBXQVZFZm10IBAAAAABAAEAwF0AAIC7AAACABAATElTVBoAAABJTkZPSVNGVA4AAABMYXZmNTguMjkuMTAwAGRhdGFg',
 *   expires_at: 1729201448,
 *   transcript: 'Sure! Why did the cat sit on the computer? Because it wanted to keep an eye on the mouse!'
 * }
 * ```
 * </details>
 *
 * <br />
 */ parcelHelpers.export(exports, "ChatOpenAI", ()=>ChatOpenAI);
var _openai = require("openai");
var _messages = require("@langchain/core/messages");
var _outputs = require("@langchain/core/outputs");
var _env = require("@langchain/core/utils/env");
var _chatModels = require("@langchain/core/language_models/chat_models");
var _base = require("@langchain/core/language_models/base");
var _runnables = require("@langchain/core/runnables");
var _outputParsers = require("@langchain/core/output_parsers");
var _openaiTools = require("@langchain/core/output_parsers/openai_tools");
var _zodToJsonSchema = require("zod-to-json-schema");
var _zod = require("openai/helpers/zod");
var _azureJs = require("./utils/azure.js");
var _openaiJs = require("./utils/openai.js");
var _openaiFormatFndefJs = require("./utils/openai-format-fndef.js");
var _toolsJs = require("./utils/tools.js");
function extractGenericMessageCustomRole(message) {
    if (message.role !== "system" && message.role !== "assistant" && message.role !== "user" && message.role !== "function" && message.role !== "tool") console.warn(`Unknown message role: ${message.role}`);
    return message.role;
}
function messageToOpenAIRole(message) {
    const type = message._getType();
    switch(type){
        case "system":
            return "system";
        case "ai":
            return "assistant";
        case "human":
            return "user";
        case "function":
            return "function";
        case "tool":
            return "tool";
        case "generic":
            if (!(0, _messages.ChatMessage).isInstance(message)) throw new Error("Invalid generic chat message");
            return extractGenericMessageCustomRole(message);
        default:
            throw new Error(`Unknown message type: ${type}`);
    }
}
function openAIResponseToChatMessage(message, rawResponse, includeRawResponse) {
    const rawToolCalls = message.tool_calls;
    switch(message.role){
        case "assistant":
            {
                const toolCalls = [];
                const invalidToolCalls = [];
                for (const rawToolCall of rawToolCalls ?? [])try {
                    toolCalls.push((0, _openaiTools.parseToolCall)(rawToolCall, {
                        returnId: true
                    }));
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    invalidToolCalls.push((0, _openaiTools.makeInvalidToolCall)(rawToolCall, e.message));
                }
                const additional_kwargs = {
                    function_call: message.function_call,
                    tool_calls: rawToolCalls
                };
                if (includeRawResponse !== undefined) additional_kwargs.__raw_response = rawResponse;
                let response_metadata;
                if (rawResponse.system_fingerprint) response_metadata = {
                    usage: {
                        ...rawResponse.usage
                    },
                    system_fingerprint: rawResponse.system_fingerprint
                };
                if (message.audio) additional_kwargs.audio = message.audio;
                return new (0, _messages.AIMessage)({
                    content: message.content || "",
                    tool_calls: toolCalls,
                    invalid_tool_calls: invalidToolCalls,
                    additional_kwargs,
                    response_metadata,
                    id: rawResponse.id
                });
            }
        default:
            return new (0, _messages.ChatMessage)(message.content || "", message.role ?? "unknown");
    }
}
function _convertDeltaToMessageChunk(// eslint-disable-next-line @typescript-eslint/no-explicit-any
delta, rawResponse, defaultRole, includeRawResponse) {
    const role = delta.role ?? defaultRole;
    const content = delta.content ?? "";
    let additional_kwargs;
    if (delta.function_call) additional_kwargs = {
        function_call: delta.function_call
    };
    else if (delta.tool_calls) additional_kwargs = {
        tool_calls: delta.tool_calls
    };
    else additional_kwargs = {};
    if (includeRawResponse) additional_kwargs.__raw_response = rawResponse;
    if (delta.audio) additional_kwargs.audio = {
        ...delta.audio,
        index: rawResponse.choices[0].index
    };
    const response_metadata = {
        usage: {
            ...rawResponse.usage
        }
    };
    if (role === "user") return new (0, _messages.HumanMessageChunk)({
        content,
        response_metadata
    });
    else if (role === "assistant") {
        const toolCallChunks = [];
        if (Array.isArray(delta.tool_calls)) for (const rawToolCall of delta.tool_calls)toolCallChunks.push({
            name: rawToolCall.function?.name,
            args: rawToolCall.function?.arguments,
            id: rawToolCall.id,
            index: rawToolCall.index,
            type: "tool_call_chunk"
        });
        return new (0, _messages.AIMessageChunk)({
            content,
            tool_call_chunks: toolCallChunks,
            additional_kwargs,
            id: rawResponse.id,
            response_metadata
        });
    } else if (role === "system") return new (0, _messages.SystemMessageChunk)({
        content,
        response_metadata
    });
    else if (role === "function") return new (0, _messages.FunctionMessageChunk)({
        content,
        additional_kwargs,
        name: delta.name,
        response_metadata
    });
    else if (role === "tool") return new (0, _messages.ToolMessageChunk)({
        content,
        additional_kwargs,
        tool_call_id: delta.tool_call_id,
        response_metadata
    });
    else return new (0, _messages.ChatMessageChunk)({
        content,
        role,
        response_metadata
    });
}
function _convertMessagesToOpenAIParams(messages) {
    // TODO: Function messages do not support array content, fix cast
    return messages.flatMap((message)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const completionParam = {
            role: messageToOpenAIRole(message),
            content: message.content
        };
        if (message.name != null) completionParam.name = message.name;
        if (message.additional_kwargs.function_call != null) {
            completionParam.function_call = message.additional_kwargs.function_call;
            completionParam.content = null;
        }
        if ((0, _messages.isAIMessage)(message) && !!message.tool_calls?.length) {
            completionParam.tool_calls = message.tool_calls.map((0, _openaiTools.convertLangChainToolCallToOpenAI));
            completionParam.content = null;
        } else {
            if (message.additional_kwargs.tool_calls != null) completionParam.tool_calls = message.additional_kwargs.tool_calls;
            if (message.tool_call_id != null) completionParam.tool_call_id = message.tool_call_id;
        }
        if (message.additional_kwargs.audio && typeof message.additional_kwargs.audio === "object" && "id" in message.additional_kwargs.audio) {
            const audioMessage = {
                role: "assistant",
                audio: {
                    id: message.additional_kwargs.audio.id
                }
            };
            return [
                completionParam,
                audioMessage
            ];
        }
        return completionParam;
    });
}
function _convertChatOpenAIToolTypeToOpenAITool(tool, fields) {
    if ((0, _base.isOpenAITool)(tool)) {
        if (fields?.strict !== undefined) return {
            ...tool,
            function: {
                ...tool.function,
                strict: fields.strict
            }
        };
        return tool;
    }
    return (0, _toolsJs._convertToOpenAITool)(tool, fields);
}
class ChatOpenAI extends (0, _chatModels.BaseChatModel) {
    static lc_name() {
        return "ChatOpenAI";
    }
    get callKeys() {
        return [
            ...super.callKeys,
            "options",
            "function_call",
            "functions",
            "tools",
            "tool_choice",
            "promptIndex",
            "response_format",
            "seed"
        ];
    }
    get lc_secrets() {
        return {
            openAIApiKey: "OPENAI_API_KEY",
            apiKey: "OPENAI_API_KEY",
            azureOpenAIApiKey: "AZURE_OPENAI_API_KEY",
            organization: "OPENAI_ORGANIZATION"
        };
    }
    get lc_aliases() {
        return {
            modelName: "model",
            openAIApiKey: "openai_api_key",
            apiKey: "openai_api_key",
            azureOpenAIApiVersion: "azure_openai_api_version",
            azureOpenAIApiKey: "azure_openai_api_key",
            azureOpenAIApiInstanceName: "azure_openai_api_instance_name",
            azureOpenAIApiDeploymentName: "azure_openai_api_deployment_name"
        };
    }
    constructor(fields, /** @deprecated */ configuration){
        super(fields ?? {});
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "temperature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "topP", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "frequencyPenalty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "presencePenalty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "n", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "logitBias", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "modelName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "gpt-3.5-turbo"
        });
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "gpt-3.5-turbo"
        });
        Object.defineProperty(this, "modelKwargs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stop", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stopSequences", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "timeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "streaming", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "streamUsage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "maxTokens", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "logprobs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "topLogprobs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "openAIApiKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apiKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureADTokenProvider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiInstanceName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiDeploymentName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIBasePath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIEndpoint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "organization", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "__includeRawResponse", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "clientConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Whether the model supports the `strict` argument when passing in tools.
         * If `undefined` the `strict` argument will not be passed to OpenAI.
         */ Object.defineProperty(this, "supportsStrictToolCalling", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "audio", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "modalities", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.openAIApiKey = fields?.apiKey ?? fields?.openAIApiKey ?? fields?.configuration?.apiKey ?? (0, _env.getEnvironmentVariable)("OPENAI_API_KEY");
        this.apiKey = this.openAIApiKey;
        this.azureOpenAIApiKey = fields?.azureOpenAIApiKey ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_KEY");
        this.azureADTokenProvider = fields?.azureADTokenProvider ?? undefined;
        if (!this.azureOpenAIApiKey && !this.apiKey && !this.azureADTokenProvider) throw new Error("OpenAI or Azure OpenAI API key or Token Provider not found");
        this.azureOpenAIApiInstanceName = fields?.azureOpenAIApiInstanceName ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_INSTANCE_NAME");
        this.azureOpenAIApiDeploymentName = fields?.azureOpenAIApiDeploymentName ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_DEPLOYMENT_NAME");
        this.azureOpenAIApiVersion = fields?.azureOpenAIApiVersion ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_VERSION");
        this.azureOpenAIBasePath = fields?.azureOpenAIBasePath ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_BASE_PATH");
        this.organization = fields?.configuration?.organization ?? (0, _env.getEnvironmentVariable)("OPENAI_ORGANIZATION");
        this.azureOpenAIEndpoint = fields?.azureOpenAIEndpoint ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_ENDPOINT");
        this.modelName = fields?.model ?? fields?.modelName ?? this.model;
        this.model = this.modelName;
        this.modelKwargs = fields?.modelKwargs ?? {};
        this.timeout = fields?.timeout;
        this.temperature = fields?.temperature ?? this.temperature;
        this.topP = fields?.topP ?? this.topP;
        this.frequencyPenalty = fields?.frequencyPenalty ?? this.frequencyPenalty;
        this.presencePenalty = fields?.presencePenalty ?? this.presencePenalty;
        this.maxTokens = fields?.maxTokens;
        this.logprobs = fields?.logprobs;
        this.topLogprobs = fields?.topLogprobs;
        this.n = fields?.n ?? this.n;
        this.logitBias = fields?.logitBias;
        this.stop = fields?.stopSequences ?? fields?.stop;
        this.stopSequences = this?.stop;
        this.user = fields?.user;
        this.__includeRawResponse = fields?.__includeRawResponse;
        this.audio = fields?.audio;
        this.modalities = fields?.modalities;
        if (this.azureOpenAIApiKey || this.azureADTokenProvider) {
            if (!this.azureOpenAIApiInstanceName && !this.azureOpenAIBasePath && !this.azureOpenAIEndpoint) throw new Error("Azure OpenAI API instance name not found");
            if (!this.azureOpenAIApiDeploymentName && this.azureOpenAIBasePath) {
                const parts = this.azureOpenAIBasePath.split("/openai/deployments/");
                if (parts.length === 2) {
                    const [, deployment] = parts;
                    this.azureOpenAIApiDeploymentName = deployment;
                }
            }
            if (!this.azureOpenAIApiDeploymentName) throw new Error("Azure OpenAI API deployment name not found");
            if (!this.azureOpenAIApiVersion) throw new Error("Azure OpenAI API version not found");
            this.apiKey = this.apiKey ?? "";
            // Streaming usage is not supported by Azure deployments, so default to false
            this.streamUsage = false;
        }
        this.streaming = fields?.streaming ?? false;
        this.streamUsage = fields?.streamUsage ?? this.streamUsage;
        this.clientConfig = {
            apiKey: this.apiKey,
            organization: this.organization,
            baseURL: configuration?.basePath ?? fields?.configuration?.basePath,
            dangerouslyAllowBrowser: true,
            defaultHeaders: configuration?.baseOptions?.headers ?? fields?.configuration?.baseOptions?.headers,
            defaultQuery: configuration?.baseOptions?.params ?? fields?.configuration?.baseOptions?.params,
            ...configuration,
            ...fields?.configuration
        };
        // If `supportsStrictToolCalling` is explicitly set, use that value.
        // Else leave undefined so it's not passed to OpenAI.
        if (fields?.supportsStrictToolCalling !== undefined) this.supportsStrictToolCalling = fields.supportsStrictToolCalling;
    }
    getLsParams(options) {
        const params = this.invocationParams(options);
        return {
            ls_provider: "openai",
            ls_model_name: this.model,
            ls_model_type: "chat",
            ls_temperature: params.temperature ?? undefined,
            ls_max_tokens: params.max_tokens ?? undefined,
            ls_stop: options.stop
        };
    }
    bindTools(tools, kwargs) {
        let strict;
        if (kwargs?.strict !== undefined) strict = kwargs.strict;
        else if (this.supportsStrictToolCalling !== undefined) strict = this.supportsStrictToolCalling;
        return this.bind({
            tools: tools.map((tool)=>_convertChatOpenAIToolTypeToOpenAITool(tool, {
                    strict
                })),
            ...kwargs
        });
    }
    createResponseFormat(resFormat) {
        if (resFormat && resFormat.type === "json_schema" && resFormat.json_schema.schema && isZodSchema(resFormat.json_schema.schema)) return (0, _zod.zodResponseFormat)(resFormat.json_schema.schema, resFormat.json_schema.name, {
            description: resFormat.json_schema.description
        });
        return resFormat;
    }
    /**
     * Get the parameters used to invoke the model
     */ invocationParams(options, extra) {
        let strict;
        if (options?.strict !== undefined) strict = options.strict;
        else if (this.supportsStrictToolCalling !== undefined) strict = this.supportsStrictToolCalling;
        let streamOptionsConfig = {};
        if (options?.stream_options !== undefined) streamOptionsConfig = {
            stream_options: options.stream_options
        };
        else if (this.streamUsage && (this.streaming || extra?.streaming)) streamOptionsConfig = {
            stream_options: {
                include_usage: true
            }
        };
        const params = {
            model: this.model,
            temperature: this.temperature,
            top_p: this.topP,
            frequency_penalty: this.frequencyPenalty,
            presence_penalty: this.presencePenalty,
            max_tokens: this.maxTokens === -1 ? undefined : this.maxTokens,
            logprobs: this.logprobs,
            top_logprobs: this.topLogprobs,
            n: this.n,
            logit_bias: this.logitBias,
            stop: options?.stop ?? this.stopSequences,
            user: this.user,
            // if include_usage is set or streamUsage then stream must be set to true.
            stream: this.streaming,
            functions: options?.functions,
            function_call: options?.function_call,
            tools: options?.tools?.length ? options.tools.map((tool)=>_convertChatOpenAIToolTypeToOpenAITool(tool, {
                    strict
                })) : undefined,
            tool_choice: (0, _openaiJs.formatToOpenAIToolChoice)(options?.tool_choice),
            response_format: this.createResponseFormat(options?.response_format),
            seed: options?.seed,
            ...streamOptionsConfig,
            parallel_tool_calls: options?.parallel_tool_calls,
            ...this.audio || options?.audio ? {
                audio: this.audio || options?.audio
            } : {},
            ...this.modalities || options?.modalities ? {
                modalities: this.modalities || options?.modalities
            } : {},
            ...this.modelKwargs
        };
        if (options?.prediction !== undefined) params.prediction = options.prediction;
        return params;
    }
    /** @ignore */ _identifyingParams() {
        return {
            model_name: this.model,
            ...this.invocationParams(),
            ...this.clientConfig
        };
    }
    async *_streamResponseChunks(messages, options, runManager) {
        const messagesMapped = _convertMessagesToOpenAIParams(messages);
        const params = {
            ...this.invocationParams(options, {
                streaming: true
            }),
            messages: messagesMapped,
            stream: true
        };
        let defaultRole;
        const streamIterable = await this.completionWithRetry(params, options);
        let usage;
        for await (const data of streamIterable){
            const choice = data?.choices?.[0];
            if (data.usage) usage = data.usage;
            if (!choice) continue;
            const { delta } = choice;
            if (!delta) continue;
            const chunk = _convertDeltaToMessageChunk(delta, data, defaultRole, this.__includeRawResponse);
            defaultRole = delta.role ?? defaultRole;
            const newTokenIndices = {
                prompt: options.promptIndex ?? 0,
                completion: choice.index ?? 0
            };
            if (typeof chunk.content !== "string") {
                console.log("[WARNING]: Received non-string content from OpenAI. This is currently not supported.");
                continue;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const generationInfo = {
                ...newTokenIndices
            };
            if (choice.finish_reason != null) {
                generationInfo.finish_reason = choice.finish_reason;
                // Only include system fingerprint in the last chunk for now
                // to avoid concatenation issues
                generationInfo.system_fingerprint = data.system_fingerprint;
            }
            if (this.logprobs) generationInfo.logprobs = choice.logprobs;
            const generationChunk = new (0, _outputs.ChatGenerationChunk)({
                message: chunk,
                text: chunk.content,
                generationInfo
            });
            yield generationChunk;
            await runManager?.handleLLMNewToken(generationChunk.text ?? "", newTokenIndices, undefined, undefined, undefined, {
                chunk: generationChunk
            });
        }
        if (usage) {
            const inputTokenDetails = {
                ...usage.prompt_tokens_details?.audio_tokens !== null && {
                    audio: usage.prompt_tokens_details?.audio_tokens
                },
                ...usage.prompt_tokens_details?.cached_tokens !== null && {
                    cache_read: usage.prompt_tokens_details?.cached_tokens
                }
            };
            const outputTokenDetails = {
                ...usage.completion_tokens_details?.audio_tokens !== null && {
                    audio: usage.completion_tokens_details?.audio_tokens
                },
                ...usage.completion_tokens_details?.reasoning_tokens !== null && {
                    reasoning: usage.completion_tokens_details?.reasoning_tokens
                }
            };
            const generationChunk = new (0, _outputs.ChatGenerationChunk)({
                message: new (0, _messages.AIMessageChunk)({
                    content: "",
                    response_metadata: {
                        usage: {
                            ...usage
                        }
                    },
                    usage_metadata: {
                        input_tokens: usage.prompt_tokens,
                        output_tokens: usage.completion_tokens,
                        total_tokens: usage.total_tokens,
                        ...Object.keys(inputTokenDetails).length > 0 && {
                            input_token_details: inputTokenDetails
                        },
                        ...Object.keys(outputTokenDetails).length > 0 && {
                            output_token_details: outputTokenDetails
                        }
                    }
                }),
                text: ""
            });
            yield generationChunk;
        }
        if (options.signal?.aborted) throw new Error("AbortError");
    }
    /**
     * Get the identifying parameters for the model
     *
     */ identifyingParams() {
        return this._identifyingParams();
    }
    /** @ignore */ async _generate(messages, options, runManager) {
        const usageMetadata = {};
        const params = this.invocationParams(options);
        const messagesMapped = _convertMessagesToOpenAIParams(messages);
        if (params.stream) {
            const stream = this._streamResponseChunks(messages, options, runManager);
            const finalChunks = {};
            for await (const chunk of stream){
                chunk.message.response_metadata = {
                    ...chunk.generationInfo,
                    ...chunk.message.response_metadata
                };
                const index = chunk.generationInfo?.completion ?? 0;
                if (finalChunks[index] === undefined) finalChunks[index] = chunk;
                else finalChunks[index] = finalChunks[index].concat(chunk);
            }
            const generations = Object.entries(finalChunks).sort(([aKey], [bKey])=>parseInt(aKey, 10) - parseInt(bKey, 10)).map(([_, value])=>value);
            const { functions, function_call } = this.invocationParams(options);
            // OpenAI does not support token usage report under stream mode,
            // fallback to estimation.
            const promptTokenUsage = await this.getEstimatedTokenCountFromPrompt(messages, functions, function_call);
            const completionTokenUsage = await this.getNumTokensFromGenerations(generations);
            usageMetadata.input_tokens = promptTokenUsage;
            usageMetadata.output_tokens = completionTokenUsage;
            usageMetadata.total_tokens = promptTokenUsage + completionTokenUsage;
            return {
                generations,
                llmOutput: {
                    estimatedTokenUsage: {
                        promptTokens: usageMetadata.input_tokens,
                        completionTokens: usageMetadata.output_tokens,
                        totalTokens: usageMetadata.total_tokens
                    }
                }
            };
        } else {
            let data;
            if (options.response_format && options.response_format.type === "json_schema") data = await this.betaParsedCompletionWithRetry({
                ...params,
                stream: false,
                messages: messagesMapped
            }, {
                signal: options?.signal,
                ...options?.options
            });
            else data = await this.completionWithRetry({
                ...params,
                stream: false,
                messages: messagesMapped
            }, {
                signal: options?.signal,
                ...options?.options
            });
            const { completion_tokens: completionTokens, prompt_tokens: promptTokens, total_tokens: totalTokens, prompt_tokens_details: promptTokensDetails, completion_tokens_details: completionTokensDetails } = data?.usage ?? {};
            if (completionTokens) usageMetadata.output_tokens = (usageMetadata.output_tokens ?? 0) + completionTokens;
            if (promptTokens) usageMetadata.input_tokens = (usageMetadata.input_tokens ?? 0) + promptTokens;
            if (totalTokens) usageMetadata.total_tokens = (usageMetadata.total_tokens ?? 0) + totalTokens;
            if (promptTokensDetails?.audio_tokens !== null || promptTokensDetails?.cached_tokens !== null) usageMetadata.input_token_details = {
                ...promptTokensDetails?.audio_tokens !== null && {
                    audio: promptTokensDetails?.audio_tokens
                },
                ...promptTokensDetails?.cached_tokens !== null && {
                    cache_read: promptTokensDetails?.cached_tokens
                }
            };
            if (completionTokensDetails?.audio_tokens !== null || completionTokensDetails?.reasoning_tokens !== null) usageMetadata.output_token_details = {
                ...completionTokensDetails?.audio_tokens !== null && {
                    audio: completionTokensDetails?.audio_tokens
                },
                ...completionTokensDetails?.reasoning_tokens !== null && {
                    reasoning: completionTokensDetails?.reasoning_tokens
                }
            };
            const generations = [];
            for (const part of data?.choices ?? []){
                const text = part.message?.content ?? "";
                const generation = {
                    text,
                    message: openAIResponseToChatMessage(part.message ?? {
                        role: "assistant"
                    }, data, this.__includeRawResponse)
                };
                generation.generationInfo = {
                    ...part.finish_reason ? {
                        finish_reason: part.finish_reason
                    } : {},
                    ...part.logprobs ? {
                        logprobs: part.logprobs
                    } : {}
                };
                if ((0, _messages.isAIMessage)(generation.message)) generation.message.usage_metadata = usageMetadata;
                // Fields are not serialized unless passed to the constructor
                // Doing this ensures all fields on the message are serialized
                generation.message = new (0, _messages.AIMessage)({
                    ...generation.message
                });
                generations.push(generation);
            }
            return {
                generations,
                llmOutput: {
                    tokenUsage: {
                        promptTokens: usageMetadata.input_tokens,
                        completionTokens: usageMetadata.output_tokens,
                        totalTokens: usageMetadata.total_tokens
                    }
                }
            };
        }
    }
    /**
     * Estimate the number of tokens a prompt will use.
     * Modified from: https://github.com/hmarr/openai-chat-tokens/blob/main/src/index.ts
     */ async getEstimatedTokenCountFromPrompt(messages, functions, function_call) {
        // It appears that if functions are present, the first system message is padded with a trailing newline. This
        // was inferred by trying lots of combinations of messages and functions and seeing what the token counts were.
        let tokens = (await this.getNumTokensFromMessages(messages)).totalCount;
        // If there are functions, add the function definitions as they count towards token usage
        if (functions && function_call !== "auto") {
            const promptDefinitions = (0, _openaiFormatFndefJs.formatFunctionDefinitions)(functions);
            tokens += await this.getNumTokens(promptDefinitions);
            tokens += 9; // Add nine per completion
        }
        // If there's a system message _and_ functions are present, subtract four tokens. I assume this is because
        // functions typically add a system message, but reuse the first one if it's already there. This offsets
        // the extra 9 tokens added by the function definitions.
        if (functions && messages.find((m)=>m._getType() === "system")) tokens -= 4;
        // If function_call is 'none', add one token.
        // If it's a FunctionCall object, add 4 + the number of tokens in the function name.
        // If it's undefined or 'auto', don't add anything.
        if (function_call === "none") tokens += 1;
        else if (typeof function_call === "object") tokens += await this.getNumTokens(function_call.name) + 4;
        return tokens;
    }
    /**
     * Estimate the number of tokens an array of generations have used.
     */ async getNumTokensFromGenerations(generations) {
        const generationUsages = await Promise.all(generations.map(async (generation)=>{
            if (generation.message.additional_kwargs?.function_call) return (await this.getNumTokensFromMessages([
                generation.message
            ])).countPerMessage[0];
            else return await this.getNumTokens(generation.message.content);
        }));
        return generationUsages.reduce((a, b)=>a + b, 0);
    }
    async getNumTokensFromMessages(messages) {
        let totalCount = 0;
        let tokensPerMessage = 0;
        let tokensPerName = 0;
        // From: https://github.com/openai/openai-cookbook/blob/main/examples/How_to_format_inputs_to_ChatGPT_models.ipynb
        if (this.model === "gpt-3.5-turbo-0301") {
            tokensPerMessage = 4;
            tokensPerName = -1;
        } else {
            tokensPerMessage = 3;
            tokensPerName = 1;
        }
        const countPerMessage = await Promise.all(messages.map(async (message)=>{
            const textCount = await this.getNumTokens(message.content);
            const roleCount = await this.getNumTokens(messageToOpenAIRole(message));
            const nameCount = message.name !== undefined ? tokensPerName + await this.getNumTokens(message.name) : 0;
            let count = textCount + tokensPerMessage + roleCount + nameCount;
            // From: https://github.com/hmarr/openai-chat-tokens/blob/main/src/index.ts messageTokenEstimate
            const openAIMessage = message;
            if (openAIMessage._getType() === "function") count -= 2;
            if (openAIMessage.additional_kwargs?.function_call) count += 3;
            if (openAIMessage?.additional_kwargs.function_call?.name) count += await this.getNumTokens(openAIMessage.additional_kwargs.function_call?.name);
            if (openAIMessage.additional_kwargs.function_call?.arguments) try {
                count += await this.getNumTokens(// Remove newlines and spaces
                JSON.stringify(JSON.parse(openAIMessage.additional_kwargs.function_call?.arguments)));
            } catch (error) {
                console.error("Error parsing function arguments", error, JSON.stringify(openAIMessage.additional_kwargs.function_call));
                count += await this.getNumTokens(openAIMessage.additional_kwargs.function_call?.arguments);
            }
            totalCount += count;
            return count;
        }));
        totalCount += 3; // every reply is primed with <|start|>assistant<|message|>
        return {
            totalCount,
            countPerMessage
        };
    }
    async completionWithRetry(request, options) {
        const requestOptions = this._getClientOptions(options);
        return this.caller.call(async ()=>{
            try {
                const res = await this.client.chat.completions.create(request, requestOptions);
                return res;
            } catch (e) {
                const error = (0, _openaiJs.wrapOpenAIClientError)(e);
                throw error;
            }
        });
    }
    /**
     * Call the beta chat completions parse endpoint. This should only be called if
     * response_format is set to "json_object".
     * @param {OpenAIClient.Chat.ChatCompletionCreateParamsNonStreaming} request
     * @param {OpenAICoreRequestOptions | undefined} options
     */ async betaParsedCompletionWithRetry(request, options) {
        const requestOptions = this._getClientOptions(options);
        return this.caller.call(async ()=>{
            try {
                const res = await this.client.beta.chat.completions.parse(request, requestOptions);
                return res;
            } catch (e) {
                const error = (0, _openaiJs.wrapOpenAIClientError)(e);
                throw error;
            }
        });
    }
    _getClientOptions(options) {
        if (!this.client) {
            const openAIEndpointConfig = {
                azureOpenAIApiDeploymentName: this.azureOpenAIApiDeploymentName,
                azureOpenAIApiInstanceName: this.azureOpenAIApiInstanceName,
                azureOpenAIApiKey: this.azureOpenAIApiKey,
                azureOpenAIBasePath: this.azureOpenAIBasePath,
                baseURL: this.clientConfig.baseURL,
                azureOpenAIEndpoint: this.azureOpenAIEndpoint
            };
            const endpoint = (0, _azureJs.getEndpoint)(openAIEndpointConfig);
            const params = {
                ...this.clientConfig,
                baseURL: endpoint,
                timeout: this.timeout,
                maxRetries: 0
            };
            if (!params.baseURL) delete params.baseURL;
            this.client = new (0, _openai.OpenAI)(params);
        }
        const requestOptions = {
            ...this.clientConfig,
            ...options
        };
        if (this.azureOpenAIApiKey) {
            requestOptions.headers = {
                "api-key": this.azureOpenAIApiKey,
                ...requestOptions.headers
            };
            requestOptions.query = {
                "api-version": this.azureOpenAIApiVersion,
                ...requestOptions.query
            };
        }
        return requestOptions;
    }
    _llmType() {
        return "openai";
    }
    /** @ignore */ _combineLLMOutput(...llmOutputs) {
        return llmOutputs.reduce((acc, llmOutput)=>{
            if (llmOutput && llmOutput.tokenUsage) {
                acc.tokenUsage.completionTokens += llmOutput.tokenUsage.completionTokens ?? 0;
                acc.tokenUsage.promptTokens += llmOutput.tokenUsage.promptTokens ?? 0;
                acc.tokenUsage.totalTokens += llmOutput.tokenUsage.totalTokens ?? 0;
            }
            return acc;
        }, {
            tokenUsage: {
                completionTokens: 0,
                promptTokens: 0,
                totalTokens: 0
            }
        });
    }
    withStructuredOutput(outputSchema, config) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let schema;
        let name;
        let method;
        let includeRaw;
        if (isStructuredOutputMethodParams(outputSchema)) {
            schema = outputSchema.schema;
            name = outputSchema.name;
            method = outputSchema.method;
            includeRaw = outputSchema.includeRaw;
        } else {
            schema = outputSchema;
            name = config?.name;
            method = config?.method;
            includeRaw = config?.includeRaw;
        }
        let llm;
        let outputParser;
        if (config?.strict !== undefined && method === "jsonMode") throw new Error("Argument `strict` is only supported for `method` = 'function_calling'");
        if (method === "jsonMode") {
            llm = this.bind({
                response_format: {
                    type: "json_object"
                }
            });
            if (isZodSchema(schema)) outputParser = (0, _outputParsers.StructuredOutputParser).fromZodSchema(schema);
            else outputParser = new (0, _outputParsers.JsonOutputParser)();
        } else if (method === "jsonSchema") {
            llm = this.bind({
                response_format: {
                    type: "json_schema",
                    json_schema: {
                        name: name ?? "extract",
                        description: schema.description,
                        schema,
                        strict: config?.strict
                    }
                }
            });
            if (isZodSchema(schema)) outputParser = (0, _outputParsers.StructuredOutputParser).fromZodSchema(schema);
            else outputParser = new (0, _outputParsers.JsonOutputParser)();
        } else {
            let functionName = name ?? "extract";
            // Is function calling
            if (isZodSchema(schema)) {
                const asJsonSchema = (0, _zodToJsonSchema.zodToJsonSchema)(schema);
                llm = this.bind({
                    tools: [
                        {
                            type: "function",
                            function: {
                                name: functionName,
                                description: asJsonSchema.description,
                                parameters: asJsonSchema
                            }
                        }
                    ],
                    tool_choice: {
                        type: "function",
                        function: {
                            name: functionName
                        }
                    },
                    // Do not pass `strict` argument to OpenAI if `config.strict` is undefined
                    ...config?.strict !== undefined ? {
                        strict: config.strict
                    } : {}
                });
                outputParser = new (0, _openaiTools.JsonOutputKeyToolsParser)({
                    returnSingle: true,
                    keyName: functionName,
                    zodSchema: schema
                });
            } else {
                let openAIFunctionDefinition;
                if (typeof schema.name === "string" && typeof schema.parameters === "object" && schema.parameters != null) {
                    openAIFunctionDefinition = schema;
                    functionName = schema.name;
                } else {
                    functionName = schema.title ?? functionName;
                    openAIFunctionDefinition = {
                        name: functionName,
                        description: schema.description ?? "",
                        parameters: schema
                    };
                }
                llm = this.bind({
                    tools: [
                        {
                            type: "function",
                            function: openAIFunctionDefinition
                        }
                    ],
                    tool_choice: {
                        type: "function",
                        function: {
                            name: functionName
                        }
                    },
                    // Do not pass `strict` argument to OpenAI if `config.strict` is undefined
                    ...config?.strict !== undefined ? {
                        strict: config.strict
                    } : {}
                });
                outputParser = new (0, _openaiTools.JsonOutputKeyToolsParser)({
                    returnSingle: true,
                    keyName: functionName
                });
            }
        }
        if (!includeRaw) return llm.pipe(outputParser);
        const parserAssign = (0, _runnables.RunnablePassthrough).assign({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            parsed: (input, config)=>outputParser.invoke(input.raw, config)
        });
        const parserNone = (0, _runnables.RunnablePassthrough).assign({
            parsed: ()=>null
        });
        const parsedWithFallback = parserAssign.withFallbacks({
            fallbacks: [
                parserNone
            ]
        });
        return (0, _runnables.RunnableSequence).from([
            {
                raw: llm
            },
            parsedWithFallback
        ]);
    }
}
function isZodSchema(// eslint-disable-next-line @typescript-eslint/no-explicit-any
input) {
    // Check for a characteristic method of Zod schemas
    return typeof input?.parse === "function";
}
function isStructuredOutputMethodParams(x) {
    return x !== undefined && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof x.schema === "object";
}

},{"openai":"xOLuj","@langchain/core/messages":"ffAZz","@langchain/core/outputs":"bm0qz","@langchain/core/utils/env":"4REmP","@langchain/core/language_models/chat_models":"nBhIp","@langchain/core/language_models/base":"2mnvi","@langchain/core/runnables":"5B2I4","@langchain/core/output_parsers":"5EipE","@langchain/core/output_parsers/openai_tools":"b1niQ","zod-to-json-schema":"3TbOj","openai/helpers/zod":"gYwRu","./utils/azure.js":"ASDZZ","./utils/openai.js":"7jhsd","./utils/openai-format-fndef.js":"1iK7r","./utils/tools.js":"b4Y2v","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bm0qz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _outputsJs = require("./dist/outputs.js");
parcelHelpers.exportAll(_outputsJs, exports);

},{"./dist/outputs.js":"4YkJk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4REmP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _envJs = require("../dist/utils/env.js");
parcelHelpers.exportAll(_envJs, exports);

},{"../dist/utils/env.js":"4GIQu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"nBhIp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _chatModelsJs = require("../dist/language_models/chat_models.js");
parcelHelpers.exportAll(_chatModelsJs, exports);

},{"../dist/language_models/chat_models.js":"1XRQe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2mnvi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseJs = require("../dist/language_models/base.js");
parcelHelpers.exportAll(_baseJs, exports);

},{"../dist/language_models/base.js":"grvsA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5EipE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./dist/output_parsers/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"./dist/output_parsers/index.js":"9SzCh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b1niQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../dist/output_parsers/openai_tools/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"../dist/output_parsers/openai_tools/index.js":"h5frz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h5frz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonOutputToolsParsersJs = require("./json_output_tools_parsers.js");
parcelHelpers.exportAll(_jsonOutputToolsParsersJs, exports);

},{"./json_output_tools_parsers.js":"h8uro","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h8uro":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseToolCall", ()=>parseToolCall);
parcelHelpers.export(exports, "convertLangChainToolCallToOpenAI", ()=>convertLangChainToolCallToOpenAI);
parcelHelpers.export(exports, "makeInvalidToolCall", ()=>makeInvalidToolCall);
/**
 * Class for parsing the output of a tool-calling LLM into a JSON object.
 */ parcelHelpers.export(exports, "JsonOutputToolsParser", ()=>JsonOutputToolsParser);
/**
 * Class for parsing the output of a tool-calling LLM into a JSON object if you are
 * expecting only a single tool to be called.
 */ parcelHelpers.export(exports, "JsonOutputKeyToolsParser", ()=>JsonOutputKeyToolsParser);
var _baseJs = require("../base.js");
var _jsonJs = require("../json.js");
var _transformJs = require("../transform.js");
var _aiJs = require("../../messages/ai.js");
function parseToolCall(// eslint-disable-next-line @typescript-eslint/no-explicit-any
rawToolCall, options) {
    if (rawToolCall.function === undefined) return undefined;
    let functionArgs;
    if (options?.partial) try {
        functionArgs = (0, _jsonJs.parsePartialJson)(rawToolCall.function.arguments ?? "{}");
    } catch (e) {
        return undefined;
    }
    else try {
        functionArgs = JSON.parse(rawToolCall.function.arguments);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        throw new (0, _baseJs.OutputParserException)([
            `Function "${rawToolCall.function.name}" arguments:`,
            ``,
            rawToolCall.function.arguments,
            ``,
            `are not valid JSON.`,
            `Error: ${e.message}`
        ].join("\n"));
    }
    const parsedToolCall = {
        name: rawToolCall.function.name,
        args: functionArgs,
        type: "tool_call"
    };
    if (options?.returnId) parsedToolCall.id = rawToolCall.id;
    return parsedToolCall;
}
function convertLangChainToolCallToOpenAI(toolCall) {
    if (toolCall.id === undefined) throw new Error(`All OpenAI tool calls must have an "id" field.`);
    return {
        id: toolCall.id,
        type: "function",
        function: {
            name: toolCall.name,
            arguments: JSON.stringify(toolCall.args)
        }
    };
}
function makeInvalidToolCall(// eslint-disable-next-line @typescript-eslint/no-explicit-any
rawToolCall, errorMsg) {
    return {
        name: rawToolCall.function?.name,
        args: rawToolCall.function?.arguments,
        id: rawToolCall.id,
        error: errorMsg,
        type: "invalid_tool_call"
    };
}
class JsonOutputToolsParser extends (0, _transformJs.BaseCumulativeTransformOutputParser) {
    static lc_name() {
        return "JsonOutputToolsParser";
    }
    constructor(fields){
        super(fields);
        Object.defineProperty(this, "returnId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain",
                "output_parsers",
                "openai_tools"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        this.returnId = fields?.returnId ?? this.returnId;
    }
    _diff() {
        throw new Error("Not supported.");
    }
    async parse() {
        throw new Error("Not implemented.");
    }
    async parseResult(generations) {
        const result = await this.parsePartialResult(generations, false);
        return result;
    }
    /**
     * Parses the output and returns a JSON object. If `argsOnly` is true,
     * only the arguments of the function call are returned.
     * @param generations The output of the LLM to parse.
     * @returns A JSON object representation of the function call or its arguments.
     */ async parsePartialResult(generations, partial = true) {
        const message = generations[0].message;
        let toolCalls;
        if ((0, _aiJs.isAIMessage)(message) && message.tool_calls?.length) toolCalls = message.tool_calls.map((toolCall)=>{
            const { id, ...rest } = toolCall;
            if (!this.returnId) return rest;
            return {
                id,
                ...rest
            };
        });
        else if (message.additional_kwargs.tool_calls !== undefined) {
            const rawToolCalls = JSON.parse(JSON.stringify(message.additional_kwargs.tool_calls));
            toolCalls = rawToolCalls.map((rawToolCall)=>{
                return parseToolCall(rawToolCall, {
                    returnId: this.returnId,
                    partial
                });
            });
        }
        if (!toolCalls) return [];
        const parsedToolCalls = [];
        for (const toolCall of toolCalls)if (toolCall !== undefined) {
            const backwardsCompatibleToolCall = {
                type: toolCall.name,
                args: toolCall.args,
                id: toolCall.id
            };
            parsedToolCalls.push(backwardsCompatibleToolCall);
        }
        return parsedToolCalls;
    }
}
class JsonOutputKeyToolsParser extends JsonOutputToolsParser {
    static lc_name() {
        return "JsonOutputKeyToolsParser";
    }
    constructor(params){
        super(params);
        Object.defineProperty(this, "lc_namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                "langchain",
                "output_parsers",
                "openai_tools"
            ]
        });
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "returnId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        /** The type of tool calls to return. */ Object.defineProperty(this, "keyName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** Whether to return only the first tool call. */ Object.defineProperty(this, "returnSingle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "zodSchema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.keyName = params.keyName;
        this.returnSingle = params.returnSingle ?? this.returnSingle;
        this.zodSchema = params.zodSchema;
    }
    async _validateResult(result) {
        if (this.zodSchema === undefined) return result;
        const zodParsedResult = await this.zodSchema.safeParseAsync(result);
        if (zodParsedResult.success) return zodParsedResult.data;
        else throw new (0, _baseJs.OutputParserException)(`Failed to parse. Text: "${JSON.stringify(result, null, 2)}". Error: ${JSON.stringify(zodParsedResult.error.errors)}`, JSON.stringify(result, null, 2));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async parsePartialResult(generations) {
        const results = await super.parsePartialResult(generations);
        const matchingResults = results.filter((result)=>result.type === this.keyName);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let returnedValues = matchingResults;
        if (!matchingResults.length) return undefined;
        if (!this.returnId) returnedValues = matchingResults.map((result)=>result.args);
        if (this.returnSingle) return returnedValues[0];
        return returnedValues;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async parseResult(generations) {
        const results = await super.parsePartialResult(generations, false);
        const matchingResults = results.filter((result)=>result.type === this.keyName);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let returnedValues = matchingResults;
        if (!matchingResults.length) return undefined;
        if (!this.returnId) returnedValues = matchingResults.map((result)=>result.args);
        if (this.returnSingle) return this._validateResult(returnedValues[0]);
        const toolCallResults = await Promise.all(returnedValues.map((value)=>this._validateResult(value)));
        return toolCallResults;
    }
}

},{"../base.js":"lJpNd","../json.js":"3Q14p","../transform.js":"4lsjz","../../messages/ai.js":"lkFVb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gYwRu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.zodFunction = exports.zodResponseFormat = void 0;
const parser_1 = require("22b9794a2c18cf0f");
const zod_to_json_schema_1 = require("18118dc71868ad46");
function zodToJsonSchema(schema, options) {
    return (0, zod_to_json_schema_1.zodToJsonSchema)(schema, {
        openaiStrictMode: true,
        name: options.name,
        nameStrategy: 'duplicate-ref',
        $refStrategy: 'extract-to-root',
        nullableStrategy: 'property'
    });
}
/**
 * Creates a chat completion `JSONSchema` response format object from
 * the given Zod schema.
 *
 * If this is passed to the `.parse()`, `.stream()` or `.runTools()`
 * chat completion methods then the response message will contain a
 * `.parsed` property that is the result of parsing the content with
 * the given Zod object.
 *
 * ```ts
 * const completion = await client.beta.chat.completions.parse({
 *    model: 'gpt-4o-2024-08-06',
 *    messages: [
 *      { role: 'system', content: 'You are a helpful math tutor.' },
 *      { role: 'user', content: 'solve 8x + 31 = 2' },
 *    ],
 *    response_format: zodResponseFormat(
 *      z.object({
 *        steps: z.array(z.object({
 *          explanation: z.string(),
 *          answer: z.string(),
 *        })),
 *        final_answer: z.string(),
 *      }),
 *      'math_answer',
 *    ),
 *  });
 *  const message = completion.choices[0]?.message;
 *  if (message?.parsed) {
 *    console.log(message.parsed);
 *    console.log(message.parsed.final_answer);
 * }
 * ```
 *
 * This can be passed directly to the `.create()` method but will not
 * result in any automatic parsing, you'll have to parse the response yourself.
 */ function zodResponseFormat(zodObject, name, props) {
    return (0, parser_1.makeParseableResponseFormat)({
        type: 'json_schema',
        json_schema: {
            ...props,
            name,
            strict: true,
            schema: zodToJsonSchema(zodObject, {
                name
            })
        }
    }, (content)=>zodObject.parse(JSON.parse(content)));
}
exports.zodResponseFormat = zodResponseFormat;
/**
 * Creates a chat completion `function` tool that can be invoked
 * automatically by the chat completion `.runTools()` method or automatically
 * parsed by `.parse()` / `.stream()`.
 */ function zodFunction(options) {
    // @ts-expect-error TODO
    return (0, parser_1.makeParseableTool)({
        type: 'function',
        function: {
            name: options.name,
            parameters: zodToJsonSchema(options.parameters, {
                name: options.name
            }),
            strict: true,
            ...options.description ? {
                description: options.description
            } : undefined
        }
    }, {
        callback: options.function,
        parser: (args)=>options.parameters.parse(JSON.parse(args))
    });
}
exports.zodFunction = zodFunction;

},{"22b9794a2c18cf0f":"2rHDe","18118dc71868ad46":"7eJxA"}],"7eJxA":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("e1fcdd5f4994723e"), exports);
__exportStar(require("65f87faf46ced552"), exports);
__exportStar(require("7742d2758612371c"), exports);
__exportStar(require("3c302ee864e844ab"), exports);
__exportStar(require("b3eb700242ae18ba"), exports);
__exportStar(require("4faea38bf7591c68"), exports);
__exportStar(require("fa0612b68fcaf62c"), exports);
__exportStar(require("dc406f9f4ba19b42"), exports);
__exportStar(require("701e5b426d9f349b"), exports);
__exportStar(require("a85de879526476ff"), exports);
__exportStar(require("b02351419bb764f6"), exports);
__exportStar(require("cc945780efedfc7c"), exports);
__exportStar(require("3027ae590ee7953d"), exports);
__exportStar(require("f3f9f2f9065b5064"), exports);
__exportStar(require("dd9c90776e38caa9"), exports);
__exportStar(require("ebb4a144b5210968"), exports);
__exportStar(require("48fe5cfba8701257"), exports);
__exportStar(require("ca886bf29c22af53"), exports);
__exportStar(require("b3fd3615944f074a"), exports);
__exportStar(require("bcd63c46ddd431b3"), exports);
__exportStar(require("bdaa121188baee31"), exports);
__exportStar(require("9f41ef482f9defbb"), exports);
__exportStar(require("893a0584947926db"), exports);
__exportStar(require("52a2dab289874630"), exports);
__exportStar(require("e81404dd45c3383b"), exports);
__exportStar(require("25770c3f7a7fce0d"), exports);
__exportStar(require("8d7d6e6beb5c0eae"), exports);
__exportStar(require("8bd212e3fc0b5b0e"), exports);
__exportStar(require("5d388af4884ee4e2"), exports);
__exportStar(require("b5779898746b73be"), exports);
__exportStar(require("dc3426907523c937"), exports);
__exportStar(require("c1a4a48a00276e52"), exports);
__exportStar(require("d8210f01b32c630"), exports);
__exportStar(require("ad0504fbdc50b71b"), exports);
__exportStar(require("a5720160e8c1c66e"), exports);
const zodToJsonSchema_1 = require("a5720160e8c1c66e");
exports.default = zodToJsonSchema_1.zodToJsonSchema;

},{"e1fcdd5f4994723e":"jFtiB","65f87faf46ced552":"eX2lC","7742d2758612371c":"fdWgY","3c302ee864e844ab":"81hwe","b3eb700242ae18ba":"lOXrW","4faea38bf7591c68":"ij0Bv","fa0612b68fcaf62c":"izcWI","dc406f9f4ba19b42":"4utc7","701e5b426d9f349b":"a90BZ","a85de879526476ff":"drSBs","b02351419bb764f6":"ePJCQ","cc945780efedfc7c":"hSCHp","3027ae590ee7953d":"jh6tz","f3f9f2f9065b5064":"1iuPE","dd9c90776e38caa9":"j6KmH","ebb4a144b5210968":"044Qk","48fe5cfba8701257":"itGes","ca886bf29c22af53":"c8Uq2","b3fd3615944f074a":"5JSFm","bcd63c46ddd431b3":"bX97e","bdaa121188baee31":"5vAgP","9f41ef482f9defbb":"6gnCy","893a0584947926db":"aufl3","52a2dab289874630":"kPkJ2","e81404dd45c3383b":"4SpLe","25770c3f7a7fce0d":"5nkWf","8d7d6e6beb5c0eae":"4hTGp","8bd212e3fc0b5b0e":"6dzBT","5d388af4884ee4e2":"kKzum","b5779898746b73be":"kuExM","dc3426907523c937":"jsYXI","c1a4a48a00276e52":"6zrLB","d8210f01b32c630":"gITwo","ad0504fbdc50b71b":"jRLwB","a5720160e8c1c66e":"jF6bS"}],"jFtiB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultOptions = exports.ignoreOverride = void 0;
exports.ignoreOverride = Symbol('Let zodToJsonSchema decide on which parser to use');
const defaultOptions = {
    name: undefined,
    $refStrategy: 'root',
    effectStrategy: 'input',
    pipeStrategy: 'all',
    dateStrategy: 'format:date-time',
    mapStrategy: 'entries',
    nullableStrategy: 'from-target',
    removeAdditionalStrategy: 'passthrough',
    definitionPath: 'definitions',
    target: 'jsonSchema7',
    strictUnions: false,
    errorMessages: false,
    markdownDescription: false,
    patternStrategy: 'escape',
    applyRegexFlags: false,
    emailStrategy: 'format:email',
    base64Strategy: 'contentEncoding:base64',
    nameStrategy: 'ref'
};
const getDefaultOptions = (options)=>{
    // We need to add `definitions` here as we may mutate it
    return typeof options === 'string' ? {
        ...defaultOptions,
        basePath: [
            '#'
        ],
        definitions: {},
        name: options
    } : {
        ...defaultOptions,
        basePath: [
            '#'
        ],
        definitions: {},
        ...options
    };
};
exports.getDefaultOptions = getDefaultOptions;

},{}],"eX2lC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRefs = void 0;
const Options_1 = require("6c2668d45821e8fd");
const util_1 = require("8086a3bb82fff651");
const getRefs = (options)=>{
    const _options = (0, Options_1.getDefaultOptions)(options);
    const currentPath = _options.name !== undefined ? [
        ..._options.basePath,
        _options.definitionPath,
        _options.name
    ] : _options.basePath;
    return {
        ..._options,
        currentPath: currentPath,
        propertyPath: undefined,
        seenRefs: new Set(),
        seen: new Map(Object.entries(_options.definitions).map(([name, def])=>[
                (0, util_1.zodDef)(def),
                {
                    def: (0, util_1.zodDef)(def),
                    path: [
                        ..._options.basePath,
                        _options.definitionPath,
                        name
                    ],
                    // Resolution of references will be forced even though seen, so it's ok that the schema is undefined here for now.
                    jsonSchema: undefined
                }
            ]))
    };
};
exports.getRefs = getRefs;

},{"6c2668d45821e8fd":"jFtiB","8086a3bb82fff651":"g6RPG"}],"g6RPG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyObj = exports.zodDef = void 0;
const zodDef = (zodSchema)=>{
    return '_def' in zodSchema ? zodSchema._def : zodSchema;
};
exports.zodDef = zodDef;
function isEmptyObj(obj) {
    if (!obj) return true;
    for(const _k in obj)return false;
    return true;
}
exports.isEmptyObj = isEmptyObj;

},{}],"fdWgY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setResponseValueAndErrors = exports.addErrorMessage = void 0;
function addErrorMessage(res, key, errorMessage, refs) {
    if (!refs?.errorMessages) return;
    if (errorMessage) res.errorMessage = {
        ...res.errorMessage,
        [key]: errorMessage
    };
}
exports.addErrorMessage = addErrorMessage;
function setResponseValueAndErrors(res, key, value, errorMessage, refs) {
    res[key] = value;
    addErrorMessage(res, key, errorMessage, refs);
}
exports.setResponseValueAndErrors = setResponseValueAndErrors;

},{}],"81hwe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseDef = void 0;
const zod_1 = require("b0255a581e0fbe39");
const any_1 = require("d92c36158f200d23");
const array_1 = require("177652deba99ec2b");
const bigint_1 = require("56088cdb3f7a913a");
const boolean_1 = require("a72a05efdb14e059");
const branded_1 = require("cd059cec22626ac6");
const catch_1 = require("da4b43568219d9c");
const date_1 = require("d1b2fa8193896f13");
const default_1 = require("a456a8fe8aff36a4");
const effects_1 = require("2f88012a2a51005a");
const enum_1 = require("73428a853d514bf");
const intersection_1 = require("2c54afb8b8b6be6a");
const literal_1 = require("3c3dd3cc0ecf829d");
const map_1 = require("9c607b1c616453d0");
const nativeEnum_1 = require("f806ca19203cbb50");
const never_1 = require("60b5ea1264b1f565");
const null_1 = require("9b3c7692414fa001");
const nullable_1 = require("d3aac7136e46dba");
const number_1 = require("bb990da768f2c135");
const object_1 = require("5ff5979e9ed17a8b");
const optional_1 = require("7e38d725b233468");
const pipeline_1 = require("c98f433a759a8a83");
const promise_1 = require("7ea84024aee0f9db");
const record_1 = require("9fd66a35f42a6e68");
const set_1 = require("80375244ed4e0142");
const string_1 = require("13812555ce9258e7");
const tuple_1 = require("11541aaf917cd461");
const undefined_1 = require("9301154087dd8904");
const union_1 = require("ca65cf1e8e90a0ce");
const unknown_1 = require("21aea82ce39df7c4");
const readonly_1 = require("94b002a53ae01d77");
const Options_1 = require("21b779846d4a2726");
function parseDef(def, refs, forceResolution = false) {
    const seenItem = refs.seen.get(def);
    if (refs.override) {
        const overrideResult = refs.override?.(def, refs, seenItem, forceResolution);
        if (overrideResult !== Options_1.ignoreOverride) return overrideResult;
    }
    if (seenItem && !forceResolution) {
        const seenSchema = get$ref(seenItem, refs);
        if (seenSchema !== undefined) {
            if ('$ref' in seenSchema) refs.seenRefs.add(seenSchema.$ref);
            return seenSchema;
        }
    }
    const newItem = {
        def,
        path: refs.currentPath,
        jsonSchema: undefined
    };
    refs.seen.set(def, newItem);
    const jsonSchema = selectParser(def, def.typeName, refs, forceResolution);
    if (jsonSchema) addMeta(def, refs, jsonSchema);
    newItem.jsonSchema = jsonSchema;
    return jsonSchema;
}
exports.parseDef = parseDef;
const get$ref = (item, refs)=>{
    switch(refs.$refStrategy){
        case 'root':
            return {
                $ref: item.path.join('/')
            };
        // this case is needed as OpenAI strict mode doesn't support top-level `$ref`s, i.e.
        // the top-level schema *must* be `{"type": "object", "properties": {...}}` but if we ever
        // need to define a `$ref`, relative `$ref`s aren't supported, so we need to extract
        // the schema to `#/definitions/` and reference that.
        //
        // e.g. if we need to reference a schema at
        // `["#","definitions","contactPerson","properties","person1","properties","name"]`
        // then we'll extract it out to `contactPerson_properties_person1_properties_name`
        case 'extract-to-root':
            const name = item.path.slice(refs.basePath.length + 1).join('_');
            // we don't need to extract the root schema in this case, as it's already
            // been added to the definitions
            if (name !== refs.name && refs.nameStrategy === 'duplicate-ref') refs.definitions[name] = item.def;
            return {
                $ref: [
                    ...refs.basePath,
                    refs.definitionPath,
                    name
                ].join('/')
            };
        case 'relative':
            return {
                $ref: getRelativePath(refs.currentPath, item.path)
            };
        case 'none':
        case 'seen':
            if (item.path.length < refs.currentPath.length && item.path.every((value, index)=>refs.currentPath[index] === value)) {
                console.warn(`Recursive reference detected at ${refs.currentPath.join('/')}! Defaulting to any`);
                return {};
            }
            return refs.$refStrategy === 'seen' ? {} : undefined;
    }
};
const getRelativePath = (pathA, pathB)=>{
    let i = 0;
    for(; i < pathA.length && i < pathB.length; i++){
        if (pathA[i] !== pathB[i]) break;
    }
    return [
        (pathA.length - i).toString(),
        ...pathB.slice(i)
    ].join('/');
};
const selectParser = (def, typeName, refs, forceResolution)=>{
    switch(typeName){
        case zod_1.ZodFirstPartyTypeKind.ZodString:
            return (0, string_1.parseStringDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodNumber:
            return (0, number_1.parseNumberDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodObject:
            return (0, object_1.parseObjectDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodBigInt:
            return (0, bigint_1.parseBigintDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodBoolean:
            return (0, boolean_1.parseBooleanDef)();
        case zod_1.ZodFirstPartyTypeKind.ZodDate:
            return (0, date_1.parseDateDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodUndefined:
            return (0, undefined_1.parseUndefinedDef)();
        case zod_1.ZodFirstPartyTypeKind.ZodNull:
            return (0, null_1.parseNullDef)(refs);
        case zod_1.ZodFirstPartyTypeKind.ZodArray:
            return (0, array_1.parseArrayDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodUnion:
        case zod_1.ZodFirstPartyTypeKind.ZodDiscriminatedUnion:
            return (0, union_1.parseUnionDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodIntersection:
            return (0, intersection_1.parseIntersectionDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodTuple:
            return (0, tuple_1.parseTupleDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodRecord:
            return (0, record_1.parseRecordDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodLiteral:
            return (0, literal_1.parseLiteralDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodEnum:
            return (0, enum_1.parseEnumDef)(def);
        case zod_1.ZodFirstPartyTypeKind.ZodNativeEnum:
            return (0, nativeEnum_1.parseNativeEnumDef)(def);
        case zod_1.ZodFirstPartyTypeKind.ZodNullable:
            return (0, nullable_1.parseNullableDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodOptional:
            return (0, optional_1.parseOptionalDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodMap:
            return (0, map_1.parseMapDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodSet:
            return (0, set_1.parseSetDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodLazy:
            return parseDef(def.getter()._def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodPromise:
            return (0, promise_1.parsePromiseDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodNaN:
        case zod_1.ZodFirstPartyTypeKind.ZodNever:
            return (0, never_1.parseNeverDef)();
        case zod_1.ZodFirstPartyTypeKind.ZodEffects:
            return (0, effects_1.parseEffectsDef)(def, refs, forceResolution);
        case zod_1.ZodFirstPartyTypeKind.ZodAny:
            return (0, any_1.parseAnyDef)();
        case zod_1.ZodFirstPartyTypeKind.ZodUnknown:
            return (0, unknown_1.parseUnknownDef)();
        case zod_1.ZodFirstPartyTypeKind.ZodDefault:
            return (0, default_1.parseDefaultDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodBranded:
            return (0, branded_1.parseBrandedDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodReadonly:
            return (0, readonly_1.parseReadonlyDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodCatch:
            return (0, catch_1.parseCatchDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodPipeline:
            return (0, pipeline_1.parsePipelineDef)(def, refs);
        case zod_1.ZodFirstPartyTypeKind.ZodFunction:
        case zod_1.ZodFirstPartyTypeKind.ZodVoid:
        case zod_1.ZodFirstPartyTypeKind.ZodSymbol:
            return undefined;
        default:
            return ((_)=>undefined)(typeName);
    }
};
const addMeta = (def, refs, jsonSchema)=>{
    if (def.description) {
        jsonSchema.description = def.description;
        if (refs.markdownDescription) jsonSchema.markdownDescription = def.description;
    }
    return jsonSchema;
};

},{"b0255a581e0fbe39":"juM82","d92c36158f200d23":"lOXrW","177652deba99ec2b":"ij0Bv","56088cdb3f7a913a":"izcWI","a72a05efdb14e059":"4utc7","cd059cec22626ac6":"a90BZ","da4b43568219d9c":"drSBs","d1b2fa8193896f13":"ePJCQ","a456a8fe8aff36a4":"hSCHp","2f88012a2a51005a":"jh6tz","73428a853d514bf":"1iuPE","2c54afb8b8b6be6a":"j6KmH","3c3dd3cc0ecf829d":"044Qk","9c607b1c616453d0":"itGes","f806ca19203cbb50":"c8Uq2","60b5ea1264b1f565":"5JSFm","9b3c7692414fa001":"bX97e","d3aac7136e46dba":"5vAgP","bb990da768f2c135":"6gnCy","5ff5979e9ed17a8b":"aufl3","7e38d725b233468":"kPkJ2","c98f433a759a8a83":"4SpLe","7ea84024aee0f9db":"5nkWf","9fd66a35f42a6e68":"6dzBT","80375244ed4e0142":"kKzum","13812555ce9258e7":"kuExM","11541aaf917cd461":"jsYXI","9301154087dd8904":"6zrLB","ca65cf1e8e90a0ce":"gITwo","21aea82ce39df7c4":"jRLwB","94b002a53ae01d77":"4hTGp","21b779846d4a2726":"jFtiB"}],"lOXrW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseAnyDef = void 0;
function parseAnyDef() {
    return {};
}
exports.parseAnyDef = parseAnyDef;

},{}],"ij0Bv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseArrayDef = void 0;
const zod_1 = require("742e060909a4b81c");
const errorMessages_1 = require("c4ec9ec8796bc5b1");
const parseDef_1 = require("de9cfae0277dd59b");
function parseArrayDef(def, refs) {
    const res = {
        type: 'array'
    };
    if (def.type?._def?.typeName !== zod_1.ZodFirstPartyTypeKind.ZodAny) res.items = (0, parseDef_1.parseDef)(def.type._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            'items'
        ]
    });
    if (def.minLength) (0, errorMessages_1.setResponseValueAndErrors)(res, 'minItems', def.minLength.value, def.minLength.message, refs);
    if (def.maxLength) (0, errorMessages_1.setResponseValueAndErrors)(res, 'maxItems', def.maxLength.value, def.maxLength.message, refs);
    if (def.exactLength) {
        (0, errorMessages_1.setResponseValueAndErrors)(res, 'minItems', def.exactLength.value, def.exactLength.message, refs);
        (0, errorMessages_1.setResponseValueAndErrors)(res, 'maxItems', def.exactLength.value, def.exactLength.message, refs);
    }
    return res;
}
exports.parseArrayDef = parseArrayDef;

},{"742e060909a4b81c":"juM82","c4ec9ec8796bc5b1":"fdWgY","de9cfae0277dd59b":"81hwe"}],"izcWI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBigintDef = void 0;
const errorMessages_1 = require("8667d8eb3a738da7");
function parseBigintDef(def, refs) {
    const res = {
        type: 'integer',
        format: 'int64'
    };
    if (!def.checks) return res;
    for (const check of def.checks)switch(check.kind){
        case 'min':
            if (refs.target === 'jsonSchema7') {
                if (check.inclusive) (0, errorMessages_1.setResponseValueAndErrors)(res, 'minimum', check.value, check.message, refs);
                else (0, errorMessages_1.setResponseValueAndErrors)(res, 'exclusiveMinimum', check.value, check.message, refs);
            } else {
                if (!check.inclusive) res.exclusiveMinimum = true;
                (0, errorMessages_1.setResponseValueAndErrors)(res, 'minimum', check.value, check.message, refs);
            }
            break;
        case 'max':
            if (refs.target === 'jsonSchema7') {
                if (check.inclusive) (0, errorMessages_1.setResponseValueAndErrors)(res, 'maximum', check.value, check.message, refs);
                else (0, errorMessages_1.setResponseValueAndErrors)(res, 'exclusiveMaximum', check.value, check.message, refs);
            } else {
                if (!check.inclusive) res.exclusiveMaximum = true;
                (0, errorMessages_1.setResponseValueAndErrors)(res, 'maximum', check.value, check.message, refs);
            }
            break;
        case 'multipleOf':
            (0, errorMessages_1.setResponseValueAndErrors)(res, 'multipleOf', check.value, check.message, refs);
            break;
    }
    return res;
}
exports.parseBigintDef = parseBigintDef;

},{"8667d8eb3a738da7":"fdWgY"}],"4utc7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBooleanDef = void 0;
function parseBooleanDef() {
    return {
        type: 'boolean'
    };
}
exports.parseBooleanDef = parseBooleanDef;

},{}],"a90BZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBrandedDef = void 0;
const parseDef_1 = require("66b49f5e681ddc87");
function parseBrandedDef(_def, refs) {
    return (0, parseDef_1.parseDef)(_def.type._def, refs);
}
exports.parseBrandedDef = parseBrandedDef;

},{"66b49f5e681ddc87":"81hwe"}],"drSBs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseCatchDef = void 0;
const parseDef_1 = require("8450f2809496465e");
const parseCatchDef = (def, refs)=>{
    return (0, parseDef_1.parseDef)(def.innerType._def, refs);
};
exports.parseCatchDef = parseCatchDef;

},{"8450f2809496465e":"81hwe"}],"ePJCQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseDateDef = void 0;
const errorMessages_1 = require("24c232cc2ccff32b");
function parseDateDef(def, refs, overrideDateStrategy) {
    const strategy = overrideDateStrategy ?? refs.dateStrategy;
    if (Array.isArray(strategy)) return {
        anyOf: strategy.map((item, i)=>parseDateDef(def, refs, item))
    };
    switch(strategy){
        case 'string':
        case 'format:date-time':
            return {
                type: 'string',
                format: 'date-time'
            };
        case 'format:date':
            return {
                type: 'string',
                format: 'date'
            };
        case 'integer':
            return integerDateParser(def, refs);
    }
}
exports.parseDateDef = parseDateDef;
const integerDateParser = (def, refs)=>{
    const res = {
        type: 'integer',
        format: 'unix-time'
    };
    if (refs.target === 'openApi3') return res;
    for (const check of def.checks)switch(check.kind){
        case 'min':
            (0, errorMessages_1.setResponseValueAndErrors)(res, 'minimum', check.value, check.message, refs);
            break;
        case 'max':
            (0, errorMessages_1.setResponseValueAndErrors)(res, 'maximum', check.value, check.message, refs);
            break;
    }
    return res;
};

},{"24c232cc2ccff32b":"fdWgY"}],"hSCHp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseDefaultDef = void 0;
const parseDef_1 = require("80296e4ce11a0915");
function parseDefaultDef(_def, refs) {
    return {
        ...(0, parseDef_1.parseDef)(_def.innerType._def, refs),
        default: _def.defaultValue()
    };
}
exports.parseDefaultDef = parseDefaultDef;

},{"80296e4ce11a0915":"81hwe"}],"jh6tz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseEffectsDef = void 0;
const parseDef_1 = require("286cf22a28ca6bf9");
function parseEffectsDef(_def, refs, forceResolution) {
    return refs.effectStrategy === 'input' ? (0, parseDef_1.parseDef)(_def.schema._def, refs, forceResolution) : {};
}
exports.parseEffectsDef = parseEffectsDef;

},{"286cf22a28ca6bf9":"81hwe"}],"1iuPE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseEnumDef = void 0;
function parseEnumDef(def) {
    return {
        type: 'string',
        enum: [
            ...def.values
        ]
    };
}
exports.parseEnumDef = parseEnumDef;

},{}],"j6KmH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseIntersectionDef = void 0;
const parseDef_1 = require("f851325605a4fb0c");
const isJsonSchema7AllOfType = (type)=>{
    if ('type' in type && type.type === 'string') return false;
    return 'allOf' in type;
};
function parseIntersectionDef(def, refs) {
    const allOf = [
        (0, parseDef_1.parseDef)(def.left._def, {
            ...refs,
            currentPath: [
                ...refs.currentPath,
                'allOf',
                '0'
            ]
        }),
        (0, parseDef_1.parseDef)(def.right._def, {
            ...refs,
            currentPath: [
                ...refs.currentPath,
                'allOf',
                '1'
            ]
        })
    ].filter((x)=>!!x);
    let unevaluatedProperties = refs.target === 'jsonSchema2019-09' ? {
        unevaluatedProperties: false
    } : undefined;
    const mergedAllOf = [];
    // If either of the schemas is an allOf, merge them into a single allOf
    allOf.forEach((schema)=>{
        if (isJsonSchema7AllOfType(schema)) {
            mergedAllOf.push(...schema.allOf);
            if (schema.unevaluatedProperties === undefined) // If one of the schemas has no unevaluatedProperties set,
            // the merged schema should also have no unevaluatedProperties set
            unevaluatedProperties = undefined;
        } else {
            let nestedSchema = schema;
            if ('additionalProperties' in schema && schema.additionalProperties === false) {
                const { additionalProperties, ...rest } = schema;
                nestedSchema = rest;
            } else // As soon as one of the schemas has additionalProperties set not to false, we allow unevaluatedProperties
            unevaluatedProperties = undefined;
            mergedAllOf.push(nestedSchema);
        }
    });
    return mergedAllOf.length ? {
        allOf: mergedAllOf,
        ...unevaluatedProperties
    } : undefined;
}
exports.parseIntersectionDef = parseIntersectionDef;

},{"f851325605a4fb0c":"81hwe"}],"044Qk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseLiteralDef = void 0;
function parseLiteralDef(def, refs) {
    const parsedType = typeof def.value;
    if (parsedType !== 'bigint' && parsedType !== 'number' && parsedType !== 'boolean' && parsedType !== 'string') return {
        type: Array.isArray(def.value) ? 'array' : 'object'
    };
    if (refs.target === 'openApi3') return {
        type: parsedType === 'bigint' ? 'integer' : parsedType,
        enum: [
            def.value
        ]
    };
    return {
        type: parsedType === 'bigint' ? 'integer' : parsedType,
        const: def.value
    };
}
exports.parseLiteralDef = parseLiteralDef;

},{}],"itGes":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseMapDef = void 0;
const parseDef_1 = require("ca7ce592a88a5b73");
const record_1 = require("94cb4ebcda4d0e58");
function parseMapDef(def, refs) {
    if (refs.mapStrategy === 'record') return (0, record_1.parseRecordDef)(def, refs);
    const keys = (0, parseDef_1.parseDef)(def.keyType._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            'items',
            'items',
            '0'
        ]
    }) || {};
    const values = (0, parseDef_1.parseDef)(def.valueType._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            'items',
            'items',
            '1'
        ]
    }) || {};
    return {
        type: 'array',
        maxItems: 125,
        items: {
            type: 'array',
            items: [
                keys,
                values
            ],
            minItems: 2,
            maxItems: 2
        }
    };
}
exports.parseMapDef = parseMapDef;

},{"ca7ce592a88a5b73":"81hwe","94cb4ebcda4d0e58":"6dzBT"}],"6dzBT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseRecordDef = void 0;
const zod_1 = require("c683005a364eb109");
const parseDef_1 = require("4c4ac568f7c5cc94");
const string_1 = require("5468102eb75134bc");
function parseRecordDef(def, refs) {
    if (refs.target === 'openApi3' && def.keyType?._def.typeName === zod_1.ZodFirstPartyTypeKind.ZodEnum) return {
        type: 'object',
        required: def.keyType._def.values,
        properties: def.keyType._def.values.reduce((acc, key)=>({
                ...acc,
                [key]: (0, parseDef_1.parseDef)(def.valueType._def, {
                    ...refs,
                    currentPath: [
                        ...refs.currentPath,
                        'properties',
                        key
                    ]
                }) ?? {}
            }), {}),
        additionalProperties: false
    };
    const schema = {
        type: 'object',
        additionalProperties: (0, parseDef_1.parseDef)(def.valueType._def, {
            ...refs,
            currentPath: [
                ...refs.currentPath,
                'additionalProperties'
            ]
        }) ?? {}
    };
    if (refs.target === 'openApi3') return schema;
    if (def.keyType?._def.typeName === zod_1.ZodFirstPartyTypeKind.ZodString && def.keyType._def.checks?.length) {
        const keyType = Object.entries((0, string_1.parseStringDef)(def.keyType._def, refs)).reduce((acc, [key, value])=>key === 'type' ? acc : {
                ...acc,
                [key]: value
            }, {});
        return {
            ...schema,
            propertyNames: keyType
        };
    } else if (def.keyType?._def.typeName === zod_1.ZodFirstPartyTypeKind.ZodEnum) return {
        ...schema,
        propertyNames: {
            enum: def.keyType._def.values
        }
    };
    return schema;
}
exports.parseRecordDef = parseRecordDef;

},{"c683005a364eb109":"juM82","4c4ac568f7c5cc94":"81hwe","5468102eb75134bc":"kuExM"}],"kuExM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseStringDef = exports.zodPatterns = void 0;
const errorMessages_1 = require("7d3628939bab1b14");
let emojiRegex;
/**
 * Generated from the regular expressions found here as of 2024-05-22:
 * https://github.com/colinhacks/zod/blob/master/src/types.ts.
 *
 * Expressions with /i flag have been changed accordingly.
 */ exports.zodPatterns = {
    /**
     * `c` was changed to `[cC]` to replicate /i flag
     */ cuid: /^[cC][^\s-]{8,}$/,
    cuid2: /^[0-9a-z]+$/,
    ulid: /^[0-9A-HJKMNP-TV-Z]{26}$/,
    /**
     * `a-z` was added to replicate /i flag
     */ email: /^(?!\.)(?!.*\.\.)([a-zA-Z0-9_'+\-\.]*)[a-zA-Z0-9_+-]@([a-zA-Z0-9][a-zA-Z0-9\-]*\.)+[a-zA-Z]{2,}$/,
    /**
     * Constructed a valid Unicode RegExp
     *
     * Lazily instantiate since this type of regex isn't supported
     * in all envs (e.g. React Native).
     *
     * See:
     * https://github.com/colinhacks/zod/issues/2433
     * Fix in Zod:
     * https://github.com/colinhacks/zod/commit/9340fd51e48576a75adc919bff65dbc4a5d4c99b
     */ emoji: ()=>{
        if (emojiRegex === undefined) emojiRegex = RegExp('^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$', 'u');
        return emojiRegex;
    },
    /**
     * Unused
     */ uuid: /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/,
    /**
     * Unused
     */ ipv4: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,
    /**
     * Unused
     */ ipv6: /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/,
    base64: /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,
    nanoid: /^[a-zA-Z0-9_-]{21}$/
};
function parseStringDef(def, refs) {
    const res = {
        type: 'string'
    };
    function processPattern(value) {
        return refs.patternStrategy === 'escape' ? escapeNonAlphaNumeric(value) : value;
    }
    if (def.checks) for (const check of def.checks)switch(check.kind){
        case 'min':
            (0, errorMessages_1.setResponseValueAndErrors)(res, 'minLength', typeof res.minLength === 'number' ? Math.max(res.minLength, check.value) : check.value, check.message, refs);
            break;
        case 'max':
            (0, errorMessages_1.setResponseValueAndErrors)(res, 'maxLength', typeof res.maxLength === 'number' ? Math.min(res.maxLength, check.value) : check.value, check.message, refs);
            break;
        case 'email':
            switch(refs.emailStrategy){
                case 'format:email':
                    addFormat(res, 'email', check.message, refs);
                    break;
                case 'format:idn-email':
                    addFormat(res, 'idn-email', check.message, refs);
                    break;
                case 'pattern:zod':
                    addPattern(res, exports.zodPatterns.email, check.message, refs);
                    break;
            }
            break;
        case 'url':
            addFormat(res, 'uri', check.message, refs);
            break;
        case 'uuid':
            addFormat(res, 'uuid', check.message, refs);
            break;
        case 'regex':
            addPattern(res, check.regex, check.message, refs);
            break;
        case 'cuid':
            addPattern(res, exports.zodPatterns.cuid, check.message, refs);
            break;
        case 'cuid2':
            addPattern(res, exports.zodPatterns.cuid2, check.message, refs);
            break;
        case 'startsWith':
            addPattern(res, RegExp(`^${processPattern(check.value)}`), check.message, refs);
            break;
        case 'endsWith':
            addPattern(res, RegExp(`${processPattern(check.value)}$`), check.message, refs);
            break;
        case 'datetime':
            addFormat(res, 'date-time', check.message, refs);
            break;
        case 'date':
            addFormat(res, 'date', check.message, refs);
            break;
        case 'time':
            addFormat(res, 'time', check.message, refs);
            break;
        case 'duration':
            addFormat(res, 'duration', check.message, refs);
            break;
        case 'length':
            (0, errorMessages_1.setResponseValueAndErrors)(res, 'minLength', typeof res.minLength === 'number' ? Math.max(res.minLength, check.value) : check.value, check.message, refs);
            (0, errorMessages_1.setResponseValueAndErrors)(res, 'maxLength', typeof res.maxLength === 'number' ? Math.min(res.maxLength, check.value) : check.value, check.message, refs);
            break;
        case 'includes':
            addPattern(res, RegExp(processPattern(check.value)), check.message, refs);
            break;
        case 'ip':
            if (check.version !== 'v6') addFormat(res, 'ipv4', check.message, refs);
            if (check.version !== 'v4') addFormat(res, 'ipv6', check.message, refs);
            break;
        case 'emoji':
            addPattern(res, exports.zodPatterns.emoji, check.message, refs);
            break;
        case 'ulid':
            addPattern(res, exports.zodPatterns.ulid, check.message, refs);
            break;
        case 'base64':
            switch(refs.base64Strategy){
                case 'format:binary':
                    addFormat(res, 'binary', check.message, refs);
                    break;
                case 'contentEncoding:base64':
                    (0, errorMessages_1.setResponseValueAndErrors)(res, 'contentEncoding', 'base64', check.message, refs);
                    break;
                case 'pattern:zod':
                    addPattern(res, exports.zodPatterns.base64, check.message, refs);
                    break;
            }
            break;
        case 'nanoid':
            addPattern(res, exports.zodPatterns.nanoid, check.message, refs);
        case 'toLowerCase':
        case 'toUpperCase':
        case 'trim':
            break;
        default:
            ((_)=>{})(check);
    }
    return res;
}
exports.parseStringDef = parseStringDef;
const escapeNonAlphaNumeric = (value)=>Array.from(value).map((c)=>/[a-zA-Z0-9]/.test(c) ? c : `\\${c}`).join('');
const addFormat = (schema, value, message, refs)=>{
    if (schema.format || schema.anyOf?.some((x)=>x.format)) {
        if (!schema.anyOf) schema.anyOf = [];
        if (schema.format) {
            schema.anyOf.push({
                format: schema.format,
                ...schema.errorMessage && refs.errorMessages && {
                    errorMessage: {
                        format: schema.errorMessage.format
                    }
                }
            });
            delete schema.format;
            if (schema.errorMessage) {
                delete schema.errorMessage.format;
                if (Object.keys(schema.errorMessage).length === 0) delete schema.errorMessage;
            }
        }
        schema.anyOf.push({
            format: value,
            ...message && refs.errorMessages && {
                errorMessage: {
                    format: message
                }
            }
        });
    } else (0, errorMessages_1.setResponseValueAndErrors)(schema, 'format', value, message, refs);
};
const addPattern = (schema, regex, message, refs)=>{
    if (schema.pattern || schema.allOf?.some((x)=>x.pattern)) {
        if (!schema.allOf) schema.allOf = [];
        if (schema.pattern) {
            schema.allOf.push({
                pattern: schema.pattern,
                ...schema.errorMessage && refs.errorMessages && {
                    errorMessage: {
                        pattern: schema.errorMessage.pattern
                    }
                }
            });
            delete schema.pattern;
            if (schema.errorMessage) {
                delete schema.errorMessage.pattern;
                if (Object.keys(schema.errorMessage).length === 0) delete schema.errorMessage;
            }
        }
        schema.allOf.push({
            pattern: processRegExp(regex, refs),
            ...message && refs.errorMessages && {
                errorMessage: {
                    pattern: message
                }
            }
        });
    } else (0, errorMessages_1.setResponseValueAndErrors)(schema, 'pattern', processRegExp(regex, refs), message, refs);
};
// Mutate z.string.regex() in a best attempt to accommodate for regex flags when applyRegexFlags is true
const processRegExp = (regexOrFunction, refs)=>{
    const regex = typeof regexOrFunction === 'function' ? regexOrFunction() : regexOrFunction;
    if (!refs.applyRegexFlags || !regex.flags) return regex.source;
    // Currently handled flags
    const flags = {
        i: regex.flags.includes('i'),
        m: regex.flags.includes('m'),
        s: regex.flags.includes('s')
    };
    // The general principle here is to step through each character, one at a time, applying mutations as flags require. We keep track when the current character is escaped, and when it's inside a group /like [this]/ or (also) a range like /[a-z]/. The following is fairly brittle imperative code; edit at your peril!
    const source = flags.i ? regex.source.toLowerCase() : regex.source;
    let pattern = '';
    let isEscaped = false;
    let inCharGroup = false;
    let inCharRange = false;
    for(let i = 0; i < source.length; i++){
        if (isEscaped) {
            pattern += source[i];
            isEscaped = false;
            continue;
        }
        if (flags.i) {
            if (inCharGroup) {
                if (source[i].match(/[a-z]/)) {
                    if (inCharRange) {
                        pattern += source[i];
                        pattern += `${source[i - 2]}-${source[i]}`.toUpperCase();
                        inCharRange = false;
                    } else if (source[i + 1] === '-' && source[i + 2]?.match(/[a-z]/)) {
                        pattern += source[i];
                        inCharRange = true;
                    } else pattern += `${source[i]}${source[i].toUpperCase()}`;
                    continue;
                }
            } else if (source[i].match(/[a-z]/)) {
                pattern += `[${source[i]}${source[i].toUpperCase()}]`;
                continue;
            }
        }
        if (flags.m) {
            if (source[i] === '^') {
                pattern += `(^|(?<=[\r\n]))`;
                continue;
            } else if (source[i] === '$') {
                pattern += `($|(?=[\r\n]))`;
                continue;
            }
        }
        if (flags.s && source[i] === '.') {
            pattern += inCharGroup ? `${source[i]}\r\n` : `[${source[i]}\r\n]`;
            continue;
        }
        pattern += source[i];
        if (source[i] === '\\') isEscaped = true;
        else if (inCharGroup && source[i] === ']') inCharGroup = false;
        else if (!inCharGroup && source[i] === '[') inCharGroup = true;
    }
    try {
        const regexTest = new RegExp(pattern);
    } catch  {
        console.warn(`Could not convert regex pattern at ${refs.currentPath.join('/')} to a flag-independent form! Falling back to the flag-ignorant source`);
        return regex.source;
    }
    return pattern;
};

},{"7d3628939bab1b14":"fdWgY"}],"c8Uq2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseNativeEnumDef = void 0;
function parseNativeEnumDef(def) {
    const object = def.values;
    const actualKeys = Object.keys(def.values).filter((key)=>{
        return typeof object[object[key]] !== 'number';
    });
    const actualValues = actualKeys.map((key)=>object[key]);
    const parsedTypes = Array.from(new Set(actualValues.map((values)=>typeof values)));
    return {
        type: parsedTypes.length === 1 ? parsedTypes[0] === 'string' ? 'string' : 'number' : [
            'string',
            'number'
        ],
        enum: actualValues
    };
}
exports.parseNativeEnumDef = parseNativeEnumDef;

},{}],"5JSFm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseNeverDef = void 0;
function parseNeverDef() {
    return {
        not: {}
    };
}
exports.parseNeverDef = parseNeverDef;

},{}],"bX97e":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseNullDef = void 0;
function parseNullDef(refs) {
    return refs.target === 'openApi3' ? {
        enum: [
            'null'
        ],
        nullable: true
    } : {
        type: 'null'
    };
}
exports.parseNullDef = parseNullDef;

},{}],"5vAgP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseNullableDef = void 0;
const parseDef_1 = require("a1b6d61db7891045");
const union_1 = require("46e8f989e250c3ce");
function parseNullableDef(def, refs) {
    if ([
        'ZodString',
        'ZodNumber',
        'ZodBigInt',
        'ZodBoolean',
        'ZodNull'
    ].includes(def.innerType._def.typeName) && (!def.innerType._def.checks || !def.innerType._def.checks.length)) {
        if (refs.target === 'openApi3' || refs.nullableStrategy === 'property') return {
            type: union_1.primitiveMappings[def.innerType._def.typeName],
            nullable: true
        };
        return {
            type: [
                union_1.primitiveMappings[def.innerType._def.typeName],
                'null'
            ]
        };
    }
    if (refs.target === 'openApi3') {
        const base = (0, parseDef_1.parseDef)(def.innerType._def, {
            ...refs,
            currentPath: [
                ...refs.currentPath
            ]
        });
        if (base && '$ref' in base) return {
            allOf: [
                base
            ],
            nullable: true
        };
        return base && {
            ...base,
            nullable: true
        };
    }
    const base = (0, parseDef_1.parseDef)(def.innerType._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            'anyOf',
            '0'
        ]
    });
    return base && {
        anyOf: [
            base,
            {
                type: 'null'
            }
        ]
    };
}
exports.parseNullableDef = parseNullableDef;

},{"a1b6d61db7891045":"81hwe","46e8f989e250c3ce":"gITwo"}],"gITwo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseUnionDef = exports.primitiveMappings = void 0;
const parseDef_1 = require("77b9fe1b0f69e9f2");
exports.primitiveMappings = {
    ZodString: 'string',
    ZodNumber: 'number',
    ZodBigInt: 'integer',
    ZodBoolean: 'boolean',
    ZodNull: 'null'
};
function parseUnionDef(def, refs) {
    if (refs.target === 'openApi3') return asAnyOf(def, refs);
    const options = def.options instanceof Map ? Array.from(def.options.values()) : def.options;
    // This blocks tries to look ahead a bit to produce nicer looking schemas with type array instead of anyOf.
    if (options.every((x)=>x._def.typeName in exports.primitiveMappings && (!x._def.checks || !x._def.checks.length))) {
        // all types in union are primitive and lack checks, so might as well squash into {type: [...]}
        const types = options.reduce((types, x)=>{
            const type = exports.primitiveMappings[x._def.typeName]; //Can be safely casted due to row 43
            return type && !types.includes(type) ? [
                ...types,
                type
            ] : types;
        }, []);
        return {
            type: types.length > 1 ? types : types[0]
        };
    } else if (options.every((x)=>x._def.typeName === 'ZodLiteral' && !x.description)) {
        // all options literals
        const types = options.reduce((acc, x)=>{
            const type = typeof x._def.value;
            switch(type){
                case 'string':
                case 'number':
                case 'boolean':
                    return [
                        ...acc,
                        type
                    ];
                case 'bigint':
                    return [
                        ...acc,
                        'integer'
                    ];
                case 'object':
                    if (x._def.value === null) return [
                        ...acc,
                        'null'
                    ];
                case 'symbol':
                case 'undefined':
                case 'function':
                default:
                    return acc;
            }
        }, []);
        if (types.length === options.length) {
            // all the literals are primitive, as far as null can be considered primitive
            const uniqueTypes = types.filter((x, i, a)=>a.indexOf(x) === i);
            return {
                type: uniqueTypes.length > 1 ? uniqueTypes : uniqueTypes[0],
                enum: options.reduce((acc, x)=>{
                    return acc.includes(x._def.value) ? acc : [
                        ...acc,
                        x._def.value
                    ];
                }, [])
            };
        }
    } else if (options.every((x)=>x._def.typeName === 'ZodEnum')) return {
        type: 'string',
        enum: options.reduce((acc, x)=>[
                ...acc,
                ...x._def.values.filter((x)=>!acc.includes(x))
            ], [])
    };
    return asAnyOf(def, refs);
}
exports.parseUnionDef = parseUnionDef;
const asAnyOf = (def, refs)=>{
    const anyOf = (def.options instanceof Map ? Array.from(def.options.values()) : def.options).map((x, i)=>(0, parseDef_1.parseDef)(x._def, {
            ...refs,
            currentPath: [
                ...refs.currentPath,
                'anyOf',
                `${i}`
            ]
        })).filter((x)=>!!x && (!refs.strictUnions || typeof x === 'object' && Object.keys(x).length > 0));
    return anyOf.length ? {
        anyOf
    } : undefined;
};

},{"77b9fe1b0f69e9f2":"81hwe"}],"6gnCy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseNumberDef = void 0;
const errorMessages_1 = require("82539368519943c3");
function parseNumberDef(def, refs) {
    const res = {
        type: 'number'
    };
    if (!def.checks) return res;
    for (const check of def.checks)switch(check.kind){
        case 'int':
            res.type = 'integer';
            (0, errorMessages_1.addErrorMessage)(res, 'type', check.message, refs);
            break;
        case 'min':
            if (refs.target === 'jsonSchema7') {
                if (check.inclusive) (0, errorMessages_1.setResponseValueAndErrors)(res, 'minimum', check.value, check.message, refs);
                else (0, errorMessages_1.setResponseValueAndErrors)(res, 'exclusiveMinimum', check.value, check.message, refs);
            } else {
                if (!check.inclusive) res.exclusiveMinimum = true;
                (0, errorMessages_1.setResponseValueAndErrors)(res, 'minimum', check.value, check.message, refs);
            }
            break;
        case 'max':
            if (refs.target === 'jsonSchema7') {
                if (check.inclusive) (0, errorMessages_1.setResponseValueAndErrors)(res, 'maximum', check.value, check.message, refs);
                else (0, errorMessages_1.setResponseValueAndErrors)(res, 'exclusiveMaximum', check.value, check.message, refs);
            } else {
                if (!check.inclusive) res.exclusiveMaximum = true;
                (0, errorMessages_1.setResponseValueAndErrors)(res, 'maximum', check.value, check.message, refs);
            }
            break;
        case 'multipleOf':
            (0, errorMessages_1.setResponseValueAndErrors)(res, 'multipleOf', check.value, check.message, refs);
            break;
    }
    return res;
}
exports.parseNumberDef = parseNumberDef;

},{"82539368519943c3":"fdWgY"}],"aufl3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseObjectDef = void 0;
const parseDef_1 = require("3863d001eccec329");
function decideAdditionalProperties(def, refs) {
    if (refs.removeAdditionalStrategy === 'strict') return def.catchall._def.typeName === 'ZodNever' ? def.unknownKeys !== 'strict' : (0, parseDef_1.parseDef)(def.catchall._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            'additionalProperties'
        ]
    }) ?? true;
    else return def.catchall._def.typeName === 'ZodNever' ? def.unknownKeys === 'passthrough' : (0, parseDef_1.parseDef)(def.catchall._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            'additionalProperties'
        ]
    }) ?? true;
}
function parseObjectDef(def, refs) {
    const result = {
        type: 'object',
        ...Object.entries(def.shape()).reduce((acc, [propName, propDef])=>{
            if (propDef === undefined || propDef._def === undefined) return acc;
            const parsedDef = (0, parseDef_1.parseDef)(propDef._def, {
                ...refs,
                currentPath: [
                    ...refs.currentPath,
                    'properties',
                    propName
                ],
                propertyPath: [
                    ...refs.currentPath,
                    'properties',
                    propName
                ]
            });
            if (parsedDef === undefined) return acc;
            return {
                properties: {
                    ...acc.properties,
                    [propName]: parsedDef
                },
                required: propDef.isOptional() && !refs.openaiStrictMode ? acc.required : [
                    ...acc.required,
                    propName
                ]
            };
        }, {
            properties: {},
            required: []
        }),
        additionalProperties: decideAdditionalProperties(def, refs)
    };
    if (!result.required.length) delete result.required;
    return result;
}
exports.parseObjectDef = parseObjectDef;

},{"3863d001eccec329":"81hwe"}],"kPkJ2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseOptionalDef = void 0;
const parseDef_1 = require("9c321709aad4662");
const parseOptionalDef = (def, refs)=>{
    if (refs.currentPath.toString() === refs.propertyPath?.toString()) return (0, parseDef_1.parseDef)(def.innerType._def, refs);
    const innerSchema = (0, parseDef_1.parseDef)(def.innerType._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            'anyOf',
            '1'
        ]
    });
    return innerSchema ? {
        anyOf: [
            {
                not: {}
            },
            innerSchema
        ]
    } : {};
};
exports.parseOptionalDef = parseOptionalDef;

},{"9c321709aad4662":"81hwe"}],"4SpLe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parsePipelineDef = void 0;
const parseDef_1 = require("4edd7c6950d646c0");
const parsePipelineDef = (def, refs)=>{
    if (refs.pipeStrategy === 'input') return (0, parseDef_1.parseDef)(def.in._def, refs);
    else if (refs.pipeStrategy === 'output') return (0, parseDef_1.parseDef)(def.out._def, refs);
    const a = (0, parseDef_1.parseDef)(def.in._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            'allOf',
            '0'
        ]
    });
    const b = (0, parseDef_1.parseDef)(def.out._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            'allOf',
            a ? '1' : '0'
        ]
    });
    return {
        allOf: [
            a,
            b
        ].filter((x)=>x !== undefined)
    };
};
exports.parsePipelineDef = parsePipelineDef;

},{"4edd7c6950d646c0":"81hwe"}],"5nkWf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parsePromiseDef = void 0;
const parseDef_1 = require("dc8540b8cc31b67c");
function parsePromiseDef(def, refs) {
    return (0, parseDef_1.parseDef)(def.type._def, refs);
}
exports.parsePromiseDef = parsePromiseDef;

},{"dc8540b8cc31b67c":"81hwe"}],"kKzum":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseSetDef = void 0;
const errorMessages_1 = require("9f79242f75091779");
const parseDef_1 = require("13a40f29e9ed22ba");
function parseSetDef(def, refs) {
    const items = (0, parseDef_1.parseDef)(def.valueType._def, {
        ...refs,
        currentPath: [
            ...refs.currentPath,
            'items'
        ]
    });
    const schema = {
        type: 'array',
        uniqueItems: true,
        items
    };
    if (def.minSize) (0, errorMessages_1.setResponseValueAndErrors)(schema, 'minItems', def.minSize.value, def.minSize.message, refs);
    if (def.maxSize) (0, errorMessages_1.setResponseValueAndErrors)(schema, 'maxItems', def.maxSize.value, def.maxSize.message, refs);
    return schema;
}
exports.parseSetDef = parseSetDef;

},{"9f79242f75091779":"fdWgY","13a40f29e9ed22ba":"81hwe"}],"jsYXI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTupleDef = void 0;
const parseDef_1 = require("cf281fdb0b6d8ef0");
function parseTupleDef(def, refs) {
    if (def.rest) return {
        type: 'array',
        minItems: def.items.length,
        items: def.items.map((x, i)=>(0, parseDef_1.parseDef)(x._def, {
                ...refs,
                currentPath: [
                    ...refs.currentPath,
                    'items',
                    `${i}`
                ]
            })).reduce((acc, x)=>x === undefined ? acc : [
                ...acc,
                x
            ], []),
        additionalItems: (0, parseDef_1.parseDef)(def.rest._def, {
            ...refs,
            currentPath: [
                ...refs.currentPath,
                'additionalItems'
            ]
        })
    };
    else return {
        type: 'array',
        minItems: def.items.length,
        maxItems: def.items.length,
        items: def.items.map((x, i)=>(0, parseDef_1.parseDef)(x._def, {
                ...refs,
                currentPath: [
                    ...refs.currentPath,
                    'items',
                    `${i}`
                ]
            })).reduce((acc, x)=>x === undefined ? acc : [
                ...acc,
                x
            ], [])
    };
}
exports.parseTupleDef = parseTupleDef;

},{"cf281fdb0b6d8ef0":"81hwe"}],"6zrLB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseUndefinedDef = void 0;
function parseUndefinedDef() {
    return {
        not: {}
    };
}
exports.parseUndefinedDef = parseUndefinedDef;

},{}],"jRLwB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseUnknownDef = void 0;
function parseUnknownDef() {
    return {};
}
exports.parseUnknownDef = parseUnknownDef;

},{}],"4hTGp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseReadonlyDef = void 0;
const parseDef_1 = require("7d8419127dbbe673");
const parseReadonlyDef = (def, refs)=>{
    return (0, parseDef_1.parseDef)(def.innerType._def, refs);
};
exports.parseReadonlyDef = parseReadonlyDef;

},{"7d8419127dbbe673":"81hwe"}],"jF6bS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.zodToJsonSchema = void 0;
const parseDef_1 = require("23737ab452c1aa94");
const Refs_1 = require("143da5e99f59aaef");
const util_1 = require("2e5f57ff52b5db86");
const zodToJsonSchema = (schema, options)=>{
    const refs = (0, Refs_1.getRefs)(options);
    const name = typeof options === 'string' ? options : options?.nameStrategy === 'title' ? undefined : options?.name;
    const main = (0, parseDef_1.parseDef)(schema._def, name === undefined ? refs : {
        ...refs,
        currentPath: [
            ...refs.basePath,
            refs.definitionPath,
            name
        ]
    }, false) ?? {};
    const title = typeof options === 'object' && options.name !== undefined && options.nameStrategy === 'title' ? options.name : undefined;
    if (title !== undefined) main.title = title;
    const definitions = (()=>{
        if ((0, util_1.isEmptyObj)(refs.definitions)) return undefined;
        const definitions = {};
        const processedDefinitions = new Set();
        // the call to `parseDef()` here might itself add more entries to `.definitions`
        // so we need to continually evaluate definitions until we've resolved all of them
        //
        // we have a generous iteration limit here to avoid blowing up the stack if there
        // are any bugs that would otherwise result in us iterating indefinitely
        for(let i = 0; i < 500; i++){
            const newDefinitions = Object.entries(refs.definitions).filter(([key])=>!processedDefinitions.has(key));
            if (newDefinitions.length === 0) break;
            for (const [key, schema] of newDefinitions){
                definitions[key] = (0, parseDef_1.parseDef)((0, util_1.zodDef)(schema), {
                    ...refs,
                    currentPath: [
                        ...refs.basePath,
                        refs.definitionPath,
                        key
                    ]
                }, true) ?? {};
                processedDefinitions.add(key);
            }
        }
        return definitions;
    })();
    const combined = name === undefined ? definitions ? {
        ...main,
        [refs.definitionPath]: definitions
    } : main : refs.nameStrategy === 'duplicate-ref' ? {
        ...main,
        ...definitions || refs.seenRefs.size ? {
            [refs.definitionPath]: {
                ...definitions,
                // only actually duplicate the schema definition if it was ever referenced
                // otherwise the duplication is completely pointless
                ...refs.seenRefs.size ? {
                    [name]: main
                } : undefined
            }
        } : undefined
    } : {
        $ref: [
            ...refs.$refStrategy === 'relative' ? [] : refs.basePath,
            refs.definitionPath,
            name
        ].join('/'),
        [refs.definitionPath]: {
            ...definitions,
            [name]: main
        }
    };
    if (refs.target === 'jsonSchema7') combined.$schema = 'http://json-schema.org/draft-07/schema#';
    else if (refs.target === 'jsonSchema2019-09') combined.$schema = 'https://json-schema.org/draft/2019-09/schema#';
    return combined;
};
exports.zodToJsonSchema = zodToJsonSchema;

},{"23737ab452c1aa94":"81hwe","143da5e99f59aaef":"eX2lC","2e5f57ff52b5db86":"g6RPG"}],"ASDZZ":[function(require,module,exports,__globalThis) {
/**
 * This function generates an endpoint URL for (Azure) OpenAI
 * based on the configuration parameters provided.
 *
 * @param {OpenAIEndpointConfig} config - The configuration object for the (Azure) endpoint.
 *
 * @property {string} config.azureOpenAIApiDeploymentName - The deployment name of Azure OpenAI.
 * @property {string} config.azureOpenAIApiInstanceName - The instance name of Azure OpenAI, e.g. `example-resource`.
 * @property {string} config.azureOpenAIApiKey - The API Key for Azure OpenAI.
 * @property {string} config.azureOpenAIBasePath - The base path for Azure OpenAI, e.g. `https://example-resource.azure.openai.com/openai/deployments/`.
 * @property {string} config.baseURL - Some other custom base path URL.
 * @property {string} config.azureOpenAIEndpoint - The endpoint for the Azure OpenAI instance, e.g. `https://example-resource.azure.openai.com/`.
 *
 * The function operates as follows:
 * - If both `azureOpenAIBasePath` and `azureOpenAIApiDeploymentName` (plus `azureOpenAIApiKey`) are provided, it returns an URL combining these two parameters (`${azureOpenAIBasePath}/${azureOpenAIApiDeploymentName}`).
 * - If both `azureOpenAIEndpoint` and `azureOpenAIApiDeploymentName` (plus `azureOpenAIApiKey`) are provided, it returns an URL combining these two parameters (`${azureOpenAIEndpoint}/openai/deployments/${azureOpenAIApiDeploymentName}`).
 * - If `azureOpenAIApiKey` is provided, it checks for `azureOpenAIApiInstanceName` and `azureOpenAIApiDeploymentName` and throws an error if any of these is missing. If both are provided, it generates an URL incorporating these parameters.
 * - If none of the above conditions are met, return any custom `baseURL`.
 * - The function returns the generated URL as a string, or undefined if no custom paths are specified.
 *
 * @throws Will throw an error if the necessary parameters for generating the URL are missing.
 *
 * @returns {string | undefined} The generated (Azure) OpenAI endpoint URL.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndpoint", ()=>getEndpoint);
function getEndpoint(config) {
    const { azureOpenAIApiDeploymentName, azureOpenAIApiInstanceName, azureOpenAIApiKey, azureOpenAIBasePath, baseURL, azureADTokenProvider, azureOpenAIEndpoint } = config;
    if ((azureOpenAIApiKey || azureADTokenProvider) && azureOpenAIBasePath && azureOpenAIApiDeploymentName) return `${azureOpenAIBasePath}/${azureOpenAIApiDeploymentName}`;
    if ((azureOpenAIApiKey || azureADTokenProvider) && azureOpenAIEndpoint && azureOpenAIApiDeploymentName) return `${azureOpenAIEndpoint}/openai/deployments/${azureOpenAIApiDeploymentName}`;
    if (azureOpenAIApiKey || azureADTokenProvider) {
        if (!azureOpenAIApiInstanceName) throw new Error("azureOpenAIApiInstanceName is required when using azureOpenAIApiKey");
        if (!azureOpenAIApiDeploymentName) throw new Error("azureOpenAIApiDeploymentName is a required parameter when using azureOpenAIApiKey");
        return `https://${azureOpenAIApiInstanceName}.openai.azure.com/openai/deployments/${azureOpenAIApiDeploymentName}`;
    }
    return baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7jhsd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "wrapOpenAIClientError", ()=>wrapOpenAIClientError);
parcelHelpers.export(exports, "formatToOpenAIFunction", ()=>(0, _functionCalling.convertToOpenAIFunction));
parcelHelpers.export(exports, "formatToOpenAITool", ()=>(0, _functionCalling.convertToOpenAITool));
parcelHelpers.export(exports, "formatToOpenAIAssistantTool", ()=>formatToOpenAIAssistantTool);
parcelHelpers.export(exports, "formatToOpenAIToolChoice", ()=>formatToOpenAIToolChoice);
var _openai = require("openai");
var _zodToJsonSchema = require("zod-to-json-schema");
var _functionCalling = require("@langchain/core/utils/function_calling");
var _errorsJs = require("./errors.js");
function wrapOpenAIClientError(e) {
    let error;
    if (e.constructor.name === (0, _openai.APIConnectionTimeoutError).name) {
        error = new Error(e.message);
        error.name = "TimeoutError";
    } else if (e.constructor.name === (0, _openai.APIUserAbortError).name) {
        error = new Error(e.message);
        error.name = "AbortError";
    } else if (e.status === 400 && e.message.includes("tool_calls")) error = (0, _errorsJs.addLangChainErrorFields)(e, "INVALID_TOOL_RESULTS");
    else if (e.status === 401) error = (0, _errorsJs.addLangChainErrorFields)(e, "MODEL_AUTHENTICATION");
    else if (e.status === 429) error = (0, _errorsJs.addLangChainErrorFields)(e, "MODEL_RATE_LIMIT");
    else if (e.status === 404) error = (0, _errorsJs.addLangChainErrorFields)(e, "MODEL_NOT_FOUND");
    else error = e;
    return error;
}
function formatToOpenAIAssistantTool(tool) {
    return {
        type: "function",
        function: {
            name: tool.name,
            description: tool.description,
            parameters: (0, _zodToJsonSchema.zodToJsonSchema)(tool.schema)
        }
    };
}
function formatToOpenAIToolChoice(toolChoice) {
    if (!toolChoice) return undefined;
    else if (toolChoice === "any" || toolChoice === "required") return "required";
    else if (toolChoice === "auto") return "auto";
    else if (toolChoice === "none") return "none";
    else if (typeof toolChoice === "string") return {
        type: "function",
        function: {
            name: toolChoice
        }
    };
    else return toolChoice;
}

},{"openai":"xOLuj","zod-to-json-schema":"3TbOj","@langchain/core/utils/function_calling":"jsusB","./errors.js":"cVfPk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jsusB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _functionCallingJs = require("../dist/utils/function_calling.js");
parcelHelpers.exportAll(_functionCallingJs, exports);

},{"../dist/utils/function_calling.js":"aj2Xs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cVfPk":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addLangChainErrorFields", ()=>addLangChainErrorFields);
function addLangChainErrorFields(error, lc_error_code) {
    error.lc_error_code = lc_error_code;
    error.message = `${error.message}\n\nTroubleshooting URL: https://js.langchain.com/docs/troubleshooting/errors/${lc_error_code}/\n`;
    return error;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1iK7r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// When OpenAI use functions in the prompt, they format them as TypeScript definitions rather than OpenAPI JSON schemas.
// This function converts the JSON schemas into TypeScript definitions.
parcelHelpers.export(exports, "formatFunctionDefinitions", ()=>formatFunctionDefinitions);
function isAnyOfProp(prop) {
    return prop.anyOf !== undefined && Array.isArray(prop.anyOf);
}
function formatFunctionDefinitions(functions) {
    const lines = [
        "namespace functions {",
        ""
    ];
    for (const f of functions){
        if (f.description) lines.push(`// ${f.description}`);
        if (Object.keys(f.parameters.properties ?? {}).length > 0) {
            lines.push(`type ${f.name} = (_: {`);
            lines.push(formatObjectProperties(f.parameters, 0));
            lines.push("}) => any;");
        } else lines.push(`type ${f.name} = () => any;`);
        lines.push("");
    }
    lines.push("} // namespace functions");
    return lines.join("\n");
}
// Format just the properties of an object (not including the surrounding braces)
function formatObjectProperties(obj, indent) {
    const lines = [];
    for (const [name, param] of Object.entries(obj.properties ?? {})){
        if (param.description && indent < 2) lines.push(`// ${param.description}`);
        if (obj.required?.includes(name)) lines.push(`${name}: ${formatType(param, indent)},`);
        else lines.push(`${name}?: ${formatType(param, indent)},`);
    }
    return lines.map((line)=>" ".repeat(indent) + line).join("\n");
}
// Format a single property type
function formatType(param, indent) {
    if (isAnyOfProp(param)) return param.anyOf.map((v)=>formatType(v, indent)).join(" | ");
    switch(param.type){
        case "string":
            if (param.enum) return param.enum.map((v)=>`"${v}"`).join(" | ");
            return "string";
        case "number":
            if (param.enum) return param.enum.map((v)=>`${v}`).join(" | ");
            return "number";
        case "integer":
            if (param.enum) return param.enum.map((v)=>`${v}`).join(" | ");
            return "number";
        case "boolean":
            return "boolean";
        case "null":
            return "null";
        case "object":
            return [
                "{",
                formatObjectProperties(param, indent + 2),
                "}"
            ].join("\n");
        case "array":
            if (param.items) return `${formatType(param.items, indent)}[]`;
            return "any[]";
        default:
            return "";
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b4Y2v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Formats a tool in either OpenAI format, or LangChain structured tool format
 * into an OpenAI tool format. If the tool is already in OpenAI format, return without
 * any changes. If it is in LangChain structured tool format, convert it to OpenAI tool format
 * using OpenAI's `zodFunction` util, falling back to `convertToOpenAIFunction` if the parameters
 * returned from the `zodFunction` util are not defined.
 *
 * @param {BindToolsInput} tool The tool to convert to an OpenAI tool.
 * @param {Object} [fields] Additional fields to add to the OpenAI tool.
 * @returns {ToolDefinition} The inputted tool in OpenAI tool format.
 */ parcelHelpers.export(exports, "_convertToOpenAITool", ()=>_convertToOpenAITool);
var _functionCalling = require("@langchain/core/utils/function_calling");
var _zod = require("openai/helpers/zod");
function _convertToOpenAITool(// eslint-disable-next-line @typescript-eslint/no-explicit-any
tool, fields) {
    let toolDef;
    if ((0, _functionCalling.isLangChainTool)(tool)) {
        const oaiToolDef = (0, _zod.zodFunction)({
            name: tool.name,
            parameters: tool.schema,
            description: tool.description
        });
        if (!oaiToolDef.function.parameters) // Fallback to the `convertToOpenAIFunction` util if the parameters are not defined.
        toolDef = {
            type: "function",
            function: (0, _functionCalling.convertToOpenAIFunction)(tool, fields)
        };
        else toolDef = {
            type: oaiToolDef.type,
            function: {
                name: oaiToolDef.function.name,
                description: oaiToolDef.function.description,
                parameters: oaiToolDef.function.parameters,
                ...fields?.strict !== undefined ? {
                    strict: fields.strict
                } : {}
            }
        };
    } else toolDef = tool;
    if (fields?.strict !== undefined) toolDef.function.strict = fields.strict;
    return toolDef;
}

},{"@langchain/core/utils/function_calling":"jsusB","openai/helpers/zod":"gYwRu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cmPLb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Azure OpenAI chat model integration.
 *
 * Setup:
 * Install `@langchain/openai` and set the following environment variables:
 *
 * ```bash
 * npm install @langchain/openai
 * export AZURE_OPENAI_API_KEY="your-api-key"
 * export AZURE_OPENAI_API_DEPLOYMENT_NAME="your-deployment-name"
 * export AZURE_OPENAI_API_VERSION="your-version"
 * export AZURE_OPENAI_BASE_PATH="your-base-path"
 * ```
 *
 * ## [Constructor args](https://api.js.langchain.com/classes/langchain_openai.AzureChatOpenAI.html#constructor)
 *
 * ## [Runtime args](https://api.js.langchain.com/interfaces/langchain_openai.ChatOpenAICallOptions.html)
 *
 * Runtime args can be passed as the second argument to any of the base runnable methods `.invoke`. `.stream`, `.batch`, etc.
 * They can also be passed via `.bind`, or the second arg in `.bindTools`, like shown in the examples below:
 *
 * ```typescript
 * // When calling `.bind`, call options should be passed via the first argument
 * const llmWithArgsBound = llm.bind({
 *   stop: ["\n"],
 *   tools: [...],
 * });
 *
 * // When calling `.bindTools`, call options should be passed via the second argument
 * const llmWithTools = llm.bindTools(
 *   [...],
 *   {
 *     tool_choice: "auto",
 *   }
 * );
 * ```
 *
 * ## Examples
 *
 * <details open>
 * <summary><strong>Instantiate</strong></summary>
 *
 * ```typescript
 * import { AzureChatOpenAI } from '@langchain/openai';
 *
 * const llm = new AzureChatOpenAI({
 *   azureOpenAIApiKey: process.env.AZURE_OPENAI_API_KEY, // In Node.js defaults to process.env.AZURE_OPENAI_API_KEY
 *   azureOpenAIApiInstanceName: process.env.AZURE_OPENAI_API_INSTANCE_NAME, // In Node.js defaults to process.env.AZURE_OPENAI_API_INSTANCE_NAME
 *   azureOpenAIApiDeploymentName: process.env.AZURE_OPENAI_API_DEPLOYMENT_NAME, // In Node.js defaults to process.env.AZURE_OPENAI_API_DEPLOYMENT_NAME
 *   azureOpenAIApiVersion: process.env.AZURE_OPENAI_API_VERSION, // In Node.js defaults to process.env.AZURE_OPENAI_API_VERSION
 *   temperature: 0,
 *   maxTokens: undefined,
 *   timeout: undefined,
 *   maxRetries: 2,
 *   // apiKey: "...",
 *   // baseUrl: "...",
 *   // other params...
 * });
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Invoking</strong></summary>
 *
 * ```typescript
 * const input = `Translate "I love programming" into French.`;
 *
 * // Models also accept a list of chat messages or a formatted prompt
 * const result = await llm.invoke(input);
 * console.log(result);
 * ```
 *
 * ```txt
 * AIMessage {
 *   "id": "chatcmpl-9u4Mpu44CbPjwYFkTbeoZgvzB00Tz",
 *   "content": "J'adore la programmation.",
 *   "response_metadata": {
 *     "tokenUsage": {
 *       "completionTokens": 5,
 *       "promptTokens": 28,
 *       "totalTokens": 33
 *     },
 *     "finish_reason": "stop",
 *     "system_fingerprint": "fp_3aa7262c27"
 *   },
 *   "usage_metadata": {
 *     "input_tokens": 28,
 *     "output_tokens": 5,
 *     "total_tokens": 33
 *   }
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Streaming Chunks</strong></summary>
 *
 * ```typescript
 * for await (const chunk of await llm.stream(input)) {
 *   console.log(chunk);
 * }
 * ```
 *
 * ```txt
 * AIMessageChunk {
 *   "id": "chatcmpl-9u4NWB7yUeHCKdLr6jP3HpaOYHTqs",
 *   "content": ""
 * }
 * AIMessageChunk {
 *   "content": "J"
 * }
 * AIMessageChunk {
 *   "content": "'adore"
 * }
 * AIMessageChunk {
 *   "content": " la"
 * }
 * AIMessageChunk {
 *   "content": " programmation",,
 * }
 * AIMessageChunk {
 *   "content": ".",,
 * }
 * AIMessageChunk {
 *   "content": "",
 *   "response_metadata": {
 *     "finish_reason": "stop",
 *     "system_fingerprint": "fp_c9aa9c0491"
 *   },
 * }
 * AIMessageChunk {
 *   "content": "",
 *   "usage_metadata": {
 *     "input_tokens": 28,
 *     "output_tokens": 5,
 *     "total_tokens": 33
 *   }
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Aggregate Streamed Chunks</strong></summary>
 *
 * ```typescript
 * import { AIMessageChunk } from '@langchain/core/messages';
 * import { concat } from '@langchain/core/utils/stream';
 *
 * const stream = await llm.stream(input);
 * let full: AIMessageChunk | undefined;
 * for await (const chunk of stream) {
 *   full = !full ? chunk : concat(full, chunk);
 * }
 * console.log(full);
 * ```
 *
 * ```txt
 * AIMessageChunk {
 *   "id": "chatcmpl-9u4PnX6Fy7OmK46DASy0bH6cxn5Xu",
 *   "content": "J'adore la programmation.",
 *   "response_metadata": {
 *     "prompt": 0,
 *     "completion": 0,
 *     "finish_reason": "stop",
 *   },
 *   "usage_metadata": {
 *     "input_tokens": 28,
 *     "output_tokens": 5,
 *     "total_tokens": 33
 *   }
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Bind tools</strong></summary>
 *
 * ```typescript
 * import { z } from 'zod';
 *
 * const GetWeather = {
 *   name: "GetWeather",
 *   description: "Get the current weather in a given location",
 *   schema: z.object({
 *     location: z.string().describe("The city and state, e.g. San Francisco, CA")
 *   }),
 * }
 *
 * const GetPopulation = {
 *   name: "GetPopulation",
 *   description: "Get the current population in a given location",
 *   schema: z.object({
 *     location: z.string().describe("The city and state, e.g. San Francisco, CA")
 *   }),
 * }
 *
 * const llmWithTools = llm.bindTools([GetWeather, GetPopulation]);
 * const aiMsg = await llmWithTools.invoke(
 *   "Which city is hotter today and which is bigger: LA or NY?"
 * );
 * console.log(aiMsg.tool_calls);
 * ```
 *
 * ```txt
 * [
 *   {
 *     name: 'GetWeather',
 *     args: { location: 'Los Angeles, CA' },
 *     type: 'tool_call',
 *     id: 'call_uPU4FiFzoKAtMxfmPnfQL6UK'
 *   },
 *   {
 *     name: 'GetWeather',
 *     args: { location: 'New York, NY' },
 *     type: 'tool_call',
 *     id: 'call_UNkEwuQsHrGYqgDQuH9nPAtX'
 *   },
 *   {
 *     name: 'GetPopulation',
 *     args: { location: 'Los Angeles, CA' },
 *     type: 'tool_call',
 *     id: 'call_kL3OXxaq9OjIKqRTpvjaCH14'
 *   },
 *   {
 *     name: 'GetPopulation',
 *     args: { location: 'New York, NY' },
 *     type: 'tool_call',
 *     id: 'call_s9KQB1UWj45LLGaEnjz0179q'
 *   }
 * ]
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Structured Output</strong></summary>
 *
 * ```typescript
 * import { z } from 'zod';
 *
 * const Joke = z.object({
 *   setup: z.string().describe("The setup of the joke"),
 *   punchline: z.string().describe("The punchline to the joke"),
 *   rating: z.number().optional().describe("How funny the joke is, from 1 to 10")
 * }).describe('Joke to tell user.');
 *
 * const structuredLlm = llm.withStructuredOutput(Joke, { name: "Joke" });
 * const jokeResult = await structuredLlm.invoke("Tell me a joke about cats");
 * console.log(jokeResult);
 * ```
 *
 * ```txt
 * {
 *   setup: 'Why was the cat sitting on the computer?',
 *   punchline: 'Because it wanted to keep an eye on the mouse!',
 *   rating: 7
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>JSON Object Response Format</strong></summary>
 *
 * ```typescript
 * const jsonLlm = llm.bind({ response_format: { type: "json_object" } });
 * const jsonLlmAiMsg = await jsonLlm.invoke(
 *   "Return a JSON object with key 'randomInts' and a value of 10 random ints in [0-99]"
 * );
 * console.log(jsonLlmAiMsg.content);
 * ```
 *
 * ```txt
 * {
 *   "randomInts": [23, 87, 45, 12, 78, 34, 56, 90, 11, 67]
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Multimodal</strong></summary>
 *
 * ```typescript
 * import { HumanMessage } from '@langchain/core/messages';
 *
 * const imageUrl = "https://example.com/image.jpg";
 * const imageData = await fetch(imageUrl).then(res => res.arrayBuffer());
 * const base64Image = Buffer.from(imageData).toString('base64');
 *
 * const message = new HumanMessage({
 *   content: [
 *     { type: "text", text: "describe the weather in this image" },
 *     {
 *       type: "image_url",
 *       image_url: { url: `data:image/jpeg;base64,${base64Image}` },
 *     },
 *   ]
 * });
 *
 * const imageDescriptionAiMsg = await llm.invoke([message]);
 * console.log(imageDescriptionAiMsg.content);
 * ```
 *
 * ```txt
 * The weather in the image appears to be clear and sunny. The sky is mostly blue with a few scattered white clouds, indicating fair weather. The bright sunlight is casting shadows on the green, grassy hill, suggesting it is a pleasant day with good visibility. There are no signs of rain or stormy conditions.
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Usage Metadata</strong></summary>
 *
 * ```typescript
 * const aiMsgForMetadata = await llm.invoke(input);
 * console.log(aiMsgForMetadata.usage_metadata);
 * ```
 *
 * ```txt
 * { input_tokens: 28, output_tokens: 5, total_tokens: 33 }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Logprobs</strong></summary>
 *
 * ```typescript
 * const logprobsLlm = new ChatOpenAI({ logprobs: true });
 * const aiMsgForLogprobs = await logprobsLlm.invoke(input);
 * console.log(aiMsgForLogprobs.response_metadata.logprobs);
 * ```
 *
 * ```txt
 * {
 *   content: [
 *     {
 *       token: 'J',
 *       logprob: -0.000050616763,
 *       bytes: [Array],
 *       top_logprobs: []
 *     },
 *     {
 *       token: "'",
 *       logprob: -0.01868736,
 *       bytes: [Array],
 *       top_logprobs: []
 *     },
 *     {
 *       token: 'ad',
 *       logprob: -0.0000030545007,
 *       bytes: [Array],
 *       top_logprobs: []
 *     },
 *     { token: 'ore', logprob: 0, bytes: [Array], top_logprobs: [] },
 *     {
 *       token: ' la',
 *       logprob: -0.515404,
 *       bytes: [Array],
 *       top_logprobs: []
 *     },
 *     {
 *       token: ' programm',
 *       logprob: -0.0000118755715,
 *       bytes: [Array],
 *       top_logprobs: []
 *     },
 *     { token: 'ation', logprob: 0, bytes: [Array], top_logprobs: [] },
 *     {
 *       token: '.',
 *       logprob: -0.0000037697225,
 *       bytes: [Array],
 *       top_logprobs: []
 *     }
 *   ],
 *   refusal: null
 * }
 * ```
 * </details>
 *
 * <br />
 *
 * <details>
 * <summary><strong>Response Metadata</strong></summary>
 *
 * ```typescript
 * const aiMsgForResponseMetadata = await llm.invoke(input);
 * console.log(aiMsgForResponseMetadata.response_metadata);
 * ```
 *
 * ```txt
 * {
 *   tokenUsage: { completionTokens: 5, promptTokens: 28, totalTokens: 33 },
 *   finish_reason: 'stop',
 *   system_fingerprint: 'fp_3aa7262c27'
 * }
 * ```
 * </details>
 */ parcelHelpers.export(exports, "AzureChatOpenAI", ()=>AzureChatOpenAI);
var _openai = require("openai");
var _chatModelsJs = require("../chat_models.js");
var _azureJs = require("../utils/azure.js");
class AzureChatOpenAI extends (0, _chatModelsJs.ChatOpenAI) {
    _llmType() {
        return "azure_openai";
    }
    get lc_aliases() {
        return {
            openAIApiKey: "openai_api_key",
            openAIApiVersion: "openai_api_version",
            openAIBasePath: "openai_api_base",
            deploymentName: "deployment_name",
            azureOpenAIEndpoint: "azure_endpoint",
            azureOpenAIApiVersion: "openai_api_version",
            azureOpenAIBasePath: "openai_api_base",
            azureOpenAIApiDeploymentName: "deployment_name"
        };
    }
    constructor(fields){
        const newFields = fields ? {
            ...fields
        } : fields;
        if (newFields) {
            // don't rewrite the fields if they are already set
            newFields.azureOpenAIApiDeploymentName = newFields.azureOpenAIApiDeploymentName ?? newFields.deploymentName;
            newFields.azureOpenAIApiKey = newFields.azureOpenAIApiKey ?? newFields.openAIApiKey;
            newFields.azureOpenAIApiVersion = newFields.azureOpenAIApiVersion ?? newFields.openAIApiVersion;
        }
        super(newFields);
    }
    getLsParams(options) {
        const params = super.getLsParams(options);
        params.ls_provider = "azure";
        return params;
    }
    _getClientOptions(options) {
        if (!this.client) {
            const openAIEndpointConfig = {
                azureOpenAIApiDeploymentName: this.azureOpenAIApiDeploymentName,
                azureOpenAIApiInstanceName: this.azureOpenAIApiInstanceName,
                azureOpenAIApiKey: this.azureOpenAIApiKey,
                azureOpenAIBasePath: this.azureOpenAIBasePath,
                azureADTokenProvider: this.azureADTokenProvider,
                baseURL: this.clientConfig.baseURL,
                azureOpenAIEndpoint: this.azureOpenAIEndpoint
            };
            const endpoint = (0, _azureJs.getEndpoint)(openAIEndpointConfig);
            const params = {
                ...this.clientConfig,
                baseURL: endpoint,
                timeout: this.timeout,
                maxRetries: 0
            };
            if (!this.azureADTokenProvider) params.apiKey = openAIEndpointConfig.azureOpenAIApiKey;
            if (!params.baseURL) delete params.baseURL;
            params.defaultHeaders = {
                ...params.defaultHeaders,
                "User-Agent": params.defaultHeaders?.["User-Agent"] ? `${params.defaultHeaders["User-Agent"]}: langchainjs-azure-openai-v2` : `langchainjs-azure-openai-v2`
            };
            this.client = new (0, _openai.AzureOpenAI)({
                apiVersion: this.azureOpenAIApiVersion,
                azureADTokenProvider: this.azureADTokenProvider,
                deployment: this.azureOpenAIApiDeploymentName,
                ...params
            });
        }
        const requestOptions = {
            ...this.clientConfig,
            ...options
        };
        if (this.azureOpenAIApiKey) {
            requestOptions.headers = {
                "api-key": this.azureOpenAIApiKey,
                ...requestOptions.headers
            };
            requestOptions.query = {
                "api-version": this.azureOpenAIApiVersion,
                ...requestOptions.query
            };
        }
        return requestOptions;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    toJSON() {
        const json = super.toJSON();
        function isRecord(obj) {
            return typeof obj === "object" && obj != null;
        }
        if (isRecord(json) && isRecord(json.kwargs)) {
            delete json.kwargs.azure_openai_base_path;
            delete json.kwargs.azure_openai_api_deployment_name;
            delete json.kwargs.azure_openai_api_key;
            delete json.kwargs.azure_openai_api_version;
            delete json.kwargs.azure_open_ai_base_path;
            if (!json.kwargs.azure_endpoint && this.azureOpenAIEndpoint) json.kwargs.azure_endpoint = this.azureOpenAIEndpoint;
            if (!json.kwargs.azure_endpoint && this.azureOpenAIBasePath) {
                const parts = this.azureOpenAIBasePath.split("/openai/deployments/");
                if (parts.length === 2 && parts[0].startsWith("http")) {
                    const [endpoint] = parts;
                    json.kwargs.azure_endpoint = endpoint;
                }
            }
            if (!json.kwargs.azure_endpoint && this.azureOpenAIApiInstanceName) json.kwargs.azure_endpoint = `https://${this.azureOpenAIApiInstanceName}.openai.azure.com/`;
            if (!json.kwargs.deployment_name && this.azureOpenAIApiDeploymentName) json.kwargs.deployment_name = this.azureOpenAIApiDeploymentName;
            if (!json.kwargs.deployment_name && this.azureOpenAIBasePath) {
                const parts = this.azureOpenAIBasePath.split("/openai/deployments/");
                if (parts.length === 2) {
                    const [, deployment] = parts;
                    json.kwargs.deployment_name = deployment;
                }
            }
            if (json.kwargs.azure_endpoint && json.kwargs.deployment_name && json.kwargs.openai_api_base) delete json.kwargs.openai_api_base;
            if (json.kwargs.azure_openai_api_instance_name && json.kwargs.azure_endpoint) delete json.kwargs.azure_openai_api_instance_name;
        }
        return json;
    }
}

},{"openai":"xOLuj","../chat_models.js":"1Wv2V","../utils/azure.js":"ASDZZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3PGFR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenAIChat", ()=>(0, _legacyJs.OpenAIChat));
/**
 * Wrapper around OpenAI large language models.
 *
 * To use you should have the `openai` package installed, with the
 * `OPENAI_API_KEY` environment variable set.
 *
 * To use with Azure you should have the `openai` package installed, with the
 * `AZURE_OPENAI_API_KEY`,
 * `AZURE_OPENAI_API_INSTANCE_NAME`,
 * `AZURE_OPENAI_API_DEPLOYMENT_NAME`
 * and `AZURE_OPENAI_API_VERSION` environment variable set.
 *
 * @remarks
 * Any parameters that are valid to be passed to {@link
 * https://platform.openai.com/docs/api-reference/completions/create |
 * `openai.createCompletion`} can be passed through {@link modelKwargs}, even
 * if not explicitly available on this class.
 * @example
 * ```typescript
 * const model = new OpenAI({
 *   modelName: "gpt-4",
 *   temperature: 0.7,
 *   maxTokens: 1000,
 *   maxRetries: 5,
 * });
 *
 * const res = await model.invoke(
 *   "Question: What would be a good company name for a company that makes colorful socks?\nAnswer:"
 * );
 * console.log({ res });
 * ```
 */ parcelHelpers.export(exports, "OpenAI", ()=>OpenAI);
var _openai = require("openai");
var _base = require("@langchain/core/language_models/base");
var _outputs = require("@langchain/core/outputs");
var _env = require("@langchain/core/utils/env");
var _llms = require("@langchain/core/language_models/llms");
var _chunkArray = require("@langchain/core/utils/chunk_array");
var _azureJs = require("./utils/azure.js");
var _legacyJs = require("./legacy.js");
var _openaiJs = require("./utils/openai.js");
class OpenAI extends (0, _llms.BaseLLM) {
    static lc_name() {
        return "OpenAI";
    }
    get callKeys() {
        return [
            ...super.callKeys,
            "options"
        ];
    }
    get lc_secrets() {
        return {
            openAIApiKey: "OPENAI_API_KEY",
            apiKey: "OPENAI_API_KEY",
            azureOpenAIApiKey: "AZURE_OPENAI_API_KEY",
            organization: "OPENAI_ORGANIZATION"
        };
    }
    get lc_aliases() {
        return {
            modelName: "model",
            openAIApiKey: "openai_api_key",
            apiKey: "openai_api_key",
            azureOpenAIApiVersion: "azure_openai_api_version",
            azureOpenAIApiKey: "azure_openai_api_key",
            azureOpenAIApiInstanceName: "azure_openai_api_instance_name",
            azureOpenAIApiDeploymentName: "azure_openai_api_deployment_name"
        };
    }
    constructor(fields, /** @deprecated */ configuration){
        let model = fields?.model ?? fields?.modelName;
        if ((model?.startsWith("gpt-3.5-turbo") || model?.startsWith("gpt-4")) && !model?.includes("-instruct")) {
            console.warn([
                `Your chosen OpenAI model, "${model}", is a chat model and not a text-in/text-out LLM.`,
                `Passing it into the "OpenAI" class is deprecated and only permitted for backwards-compatibility. You may experience odd behavior.`,
                `Please use the "ChatOpenAI" class instead.`,
                "",
                `See this page for more information:`,
                "|",
                `\u{2514}> https://js.langchain.com/docs/integrations/chat/openai`
            ].join("\n"));
            // eslint-disable-next-line no-constructor-return
            return new (0, _legacyJs.OpenAIChat)(fields, configuration);
        }
        super(fields ?? {});
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "temperature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0.7
        });
        Object.defineProperty(this, "maxTokens", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 256
        });
        Object.defineProperty(this, "topP", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "frequencyPenalty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "presencePenalty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "n", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "bestOf", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "logitBias", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "modelName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "gpt-3.5-turbo-instruct"
        });
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "gpt-3.5-turbo-instruct"
        });
        Object.defineProperty(this, "modelKwargs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "batchSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 20
        });
        Object.defineProperty(this, "timeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stop", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stopSequences", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "streaming", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "openAIApiKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apiKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureADTokenProvider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiInstanceName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiDeploymentName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIBasePath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "organization", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "clientConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        model = model ?? this.model;
        this.openAIApiKey = fields?.apiKey ?? fields?.openAIApiKey ?? (0, _env.getEnvironmentVariable)("OPENAI_API_KEY");
        this.apiKey = this.openAIApiKey;
        this.azureOpenAIApiKey = fields?.azureOpenAIApiKey ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_KEY");
        this.azureADTokenProvider = fields?.azureADTokenProvider ?? undefined;
        if (!this.azureOpenAIApiKey && !this.apiKey && !this.azureADTokenProvider) throw new Error("OpenAI or Azure OpenAI API key or Token Provider not found");
        this.azureOpenAIApiInstanceName = fields?.azureOpenAIApiInstanceName ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_INSTANCE_NAME");
        this.azureOpenAIApiDeploymentName = (fields?.azureOpenAIApiCompletionsDeploymentName || fields?.azureOpenAIApiDeploymentName) ?? ((0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_COMPLETIONS_DEPLOYMENT_NAME") || (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_DEPLOYMENT_NAME"));
        this.azureOpenAIApiVersion = fields?.azureOpenAIApiVersion ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_VERSION");
        this.azureOpenAIBasePath = fields?.azureOpenAIBasePath ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_BASE_PATH");
        this.organization = fields?.configuration?.organization ?? (0, _env.getEnvironmentVariable)("OPENAI_ORGANIZATION");
        this.modelName = model;
        this.model = model;
        this.modelKwargs = fields?.modelKwargs ?? {};
        this.batchSize = fields?.batchSize ?? this.batchSize;
        this.timeout = fields?.timeout;
        this.temperature = fields?.temperature ?? this.temperature;
        this.maxTokens = fields?.maxTokens ?? this.maxTokens;
        this.topP = fields?.topP ?? this.topP;
        this.frequencyPenalty = fields?.frequencyPenalty ?? this.frequencyPenalty;
        this.presencePenalty = fields?.presencePenalty ?? this.presencePenalty;
        this.n = fields?.n ?? this.n;
        this.bestOf = fields?.bestOf ?? this.bestOf;
        this.logitBias = fields?.logitBias;
        this.stop = fields?.stopSequences ?? fields?.stop;
        this.stopSequences = fields?.stopSequences;
        this.user = fields?.user;
        this.streaming = fields?.streaming ?? false;
        if (this.streaming && this.bestOf && this.bestOf > 1) throw new Error("Cannot stream results when bestOf > 1");
        if (this.azureOpenAIApiKey || this.azureADTokenProvider) {
            if (!this.azureOpenAIApiInstanceName && !this.azureOpenAIBasePath) throw new Error("Azure OpenAI API instance name not found");
            if (!this.azureOpenAIApiDeploymentName) throw new Error("Azure OpenAI API deployment name not found");
            if (!this.azureOpenAIApiVersion) throw new Error("Azure OpenAI API version not found");
            this.apiKey = this.apiKey ?? "";
        }
        this.clientConfig = {
            apiKey: this.apiKey,
            organization: this.organization,
            baseURL: configuration?.basePath ?? fields?.configuration?.basePath,
            dangerouslyAllowBrowser: true,
            defaultHeaders: configuration?.baseOptions?.headers ?? fields?.configuration?.baseOptions?.headers,
            defaultQuery: configuration?.baseOptions?.params ?? fields?.configuration?.baseOptions?.params,
            ...configuration,
            ...fields?.configuration
        };
    }
    /**
     * Get the parameters used to invoke the model
     */ invocationParams(options) {
        return {
            model: this.model,
            temperature: this.temperature,
            max_tokens: this.maxTokens,
            top_p: this.topP,
            frequency_penalty: this.frequencyPenalty,
            presence_penalty: this.presencePenalty,
            n: this.n,
            best_of: this.bestOf,
            logit_bias: this.logitBias,
            stop: options?.stop ?? this.stopSequences,
            user: this.user,
            stream: this.streaming,
            ...this.modelKwargs
        };
    }
    /** @ignore */ _identifyingParams() {
        return {
            model_name: this.model,
            ...this.invocationParams(),
            ...this.clientConfig
        };
    }
    /**
     * Get the identifying parameters for the model
     */ identifyingParams() {
        return this._identifyingParams();
    }
    /**
     * Call out to OpenAI's endpoint with k unique prompts
     *
     * @param [prompts] - The prompts to pass into the model.
     * @param [options] - Optional list of stop words to use when generating.
     * @param [runManager] - Optional callback manager to use when generating.
     *
     * @returns The full LLM output.
     *
     * @example
     * ```ts
     * import { OpenAI } from "langchain/llms/openai";
     * const openai = new OpenAI();
     * const response = await openai.generate(["Tell me a joke."]);
     * ```
     */ async _generate(prompts, options, runManager) {
        const subPrompts = (0, _chunkArray.chunkArray)(prompts, this.batchSize);
        const choices = [];
        const tokenUsage = {};
        const params = this.invocationParams(options);
        if (params.max_tokens === -1) {
            if (prompts.length !== 1) throw new Error("max_tokens set to -1 not supported for multiple inputs");
            params.max_tokens = await (0, _base.calculateMaxTokens)({
                prompt: prompts[0],
                // Cast here to allow for other models that may not fit the union
                modelName: this.model
            });
        }
        for(let i = 0; i < subPrompts.length; i += 1){
            const data = params.stream ? await (async ()=>{
                const choices = [];
                let response;
                const stream = await this.completionWithRetry({
                    ...params,
                    stream: true,
                    prompt: subPrompts[i]
                }, options);
                for await (const message of stream){
                    // on the first message set the response properties
                    if (!response) response = {
                        id: message.id,
                        object: message.object,
                        created: message.created,
                        model: message.model
                    };
                    // on all messages, update choice
                    for (const part of message.choices){
                        if (!choices[part.index]) choices[part.index] = part;
                        else {
                            const choice = choices[part.index];
                            choice.text += part.text;
                            choice.finish_reason = part.finish_reason;
                            choice.logprobs = part.logprobs;
                        }
                        runManager?.handleLLMNewToken(part.text, {
                            prompt: Math.floor(part.index / this.n),
                            completion: part.index % this.n
                        });
                    }
                }
                if (options.signal?.aborted) throw new Error("AbortError");
                return {
                    ...response,
                    choices
                };
            })() : await this.completionWithRetry({
                ...params,
                stream: false,
                prompt: subPrompts[i]
            }, {
                signal: options.signal,
                ...options.options
            });
            choices.push(...data.choices);
            const { completion_tokens: completionTokens, prompt_tokens: promptTokens, total_tokens: totalTokens } = data.usage ? data.usage : {
                completion_tokens: undefined,
                prompt_tokens: undefined,
                total_tokens: undefined
            };
            if (completionTokens) tokenUsage.completionTokens = (tokenUsage.completionTokens ?? 0) + completionTokens;
            if (promptTokens) tokenUsage.promptTokens = (tokenUsage.promptTokens ?? 0) + promptTokens;
            if (totalTokens) tokenUsage.totalTokens = (tokenUsage.totalTokens ?? 0) + totalTokens;
        }
        const generations = (0, _chunkArray.chunkArray)(choices, this.n).map((promptChoices)=>promptChoices.map((choice)=>({
                    text: choice.text ?? "",
                    generationInfo: {
                        finishReason: choice.finish_reason,
                        logprobs: choice.logprobs
                    }
                })));
        return {
            generations,
            llmOutput: {
                tokenUsage
            }
        };
    }
    // TODO(jacoblee): Refactor with _generate(..., {stream: true}) implementation?
    async *_streamResponseChunks(input, options, runManager) {
        const params = {
            ...this.invocationParams(options),
            prompt: input,
            stream: true
        };
        const stream = await this.completionWithRetry(params, options);
        for await (const data of stream){
            const choice = data?.choices[0];
            if (!choice) continue;
            const chunk = new (0, _outputs.GenerationChunk)({
                text: choice.text,
                generationInfo: {
                    finishReason: choice.finish_reason
                }
            });
            yield chunk;
            // eslint-disable-next-line no-void
            runManager?.handleLLMNewToken(chunk.text ?? "");
        }
        if (options.signal?.aborted) throw new Error("AbortError");
    }
    async completionWithRetry(request, options) {
        const requestOptions = this._getClientOptions(options);
        return this.caller.call(async ()=>{
            try {
                const res = await this.client.completions.create(request, requestOptions);
                return res;
            } catch (e) {
                const error = (0, _openaiJs.wrapOpenAIClientError)(e);
                throw error;
            }
        });
    }
    /**
     * Calls the OpenAI API with retry logic in case of failures.
     * @param request The request to send to the OpenAI API.
     * @param options Optional configuration for the API call.
     * @returns The response from the OpenAI API.
     */ _getClientOptions(options) {
        if (!this.client) {
            const openAIEndpointConfig = {
                azureOpenAIApiDeploymentName: this.azureOpenAIApiDeploymentName,
                azureOpenAIApiInstanceName: this.azureOpenAIApiInstanceName,
                azureOpenAIApiKey: this.azureOpenAIApiKey,
                azureOpenAIBasePath: this.azureOpenAIBasePath,
                baseURL: this.clientConfig.baseURL
            };
            const endpoint = (0, _azureJs.getEndpoint)(openAIEndpointConfig);
            const params = {
                ...this.clientConfig,
                baseURL: endpoint,
                timeout: this.timeout,
                maxRetries: 0
            };
            if (!params.baseURL) delete params.baseURL;
            this.client = new (0, _openai.OpenAI)(params);
        }
        const requestOptions = {
            ...this.clientConfig,
            ...options
        };
        if (this.azureOpenAIApiKey) {
            requestOptions.headers = {
                "api-key": this.azureOpenAIApiKey,
                ...requestOptions.headers
            };
            requestOptions.query = {
                "api-version": this.azureOpenAIApiVersion,
                ...requestOptions.query
            };
        }
        return requestOptions;
    }
    _llmType() {
        return "openai";
    }
}

},{"openai":"xOLuj","@langchain/core/language_models/base":"2mnvi","@langchain/core/outputs":"bm0qz","@langchain/core/utils/env":"4REmP","@langchain/core/language_models/llms":"lJyYj","@langchain/core/utils/chunk_array":"3EMKU","./utils/azure.js":"ASDZZ","./legacy.js":"lQ07i","./utils/openai.js":"7jhsd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lJyYj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _llmsJs = require("../dist/language_models/llms.js");
parcelHelpers.exportAll(_llmsJs, exports);

},{"../dist/language_models/llms.js":"4h08k","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3EMKU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _chunkArrayJs = require("../dist/utils/chunk_array.js");
parcelHelpers.exportAll(_chunkArrayJs, exports);

},{"../dist/utils/chunk_array.js":"7oRM9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lQ07i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @deprecated For legacy compatibility. Use ChatOpenAI instead.
 *
 * Wrapper around OpenAI large language models that use the Chat endpoint.
 *
 * To use you should have the `openai` package installed, with the
 * `OPENAI_API_KEY` environment variable set.
 *
 * To use with Azure you should have the `openai` package installed, with the
 * `AZURE_OPENAI_API_KEY`,
 * `AZURE_OPENAI_API_INSTANCE_NAME`,
 * `AZURE_OPENAI_API_DEPLOYMENT_NAME`
 * and `AZURE_OPENAI_API_VERSION` environment variable set.
 *
 * @remarks
 * Any parameters that are valid to be passed to {@link
 * https://platform.openai.com/docs/api-reference/chat/create |
 * `openai.createCompletion`} can be passed through {@link modelKwargs}, even
 * if not explicitly available on this class.
 *
 * @augments BaseLLM
 * @augments OpenAIInput
 * @augments AzureOpenAIChatInput
 * @example
 * ```typescript
 * const model = new OpenAIChat({
 *   prefixMessages: [
 *     {
 *       role: "system",
 *       content: "You are a helpful assistant that answers in pirate language",
 *     },
 *   ],
 *   maxTokens: 50,
 * });
 *
 * const res = await model.invoke(
 *   "What would be a good company name for a company that makes colorful socks?"
 * );
 * console.log({ res });
 * ```
 */ parcelHelpers.export(exports, "OpenAIChat", ()=>OpenAIChat);
var _openai = require("openai");
var _outputs = require("@langchain/core/outputs");
var _env = require("@langchain/core/utils/env");
var _llms = require("@langchain/core/language_models/llms");
var _azureJs = require("./utils/azure.js");
var _openaiJs = require("./utils/openai.js");
class OpenAIChat extends (0, _llms.LLM) {
    static lc_name() {
        return "OpenAIChat";
    }
    get callKeys() {
        return [
            ...super.callKeys,
            "options",
            "promptIndex"
        ];
    }
    get lc_secrets() {
        return {
            openAIApiKey: "OPENAI_API_KEY",
            azureOpenAIApiKey: "AZURE_OPENAI_API_KEY",
            organization: "OPENAI_ORGANIZATION"
        };
    }
    get lc_aliases() {
        return {
            modelName: "model",
            openAIApiKey: "openai_api_key",
            azureOpenAIApiVersion: "azure_openai_api_version",
            azureOpenAIApiKey: "azure_openai_api_key",
            azureOpenAIApiInstanceName: "azure_openai_api_instance_name",
            azureOpenAIApiDeploymentName: "azure_openai_api_deployment_name"
        };
    }
    constructor(fields, /** @deprecated */ configuration){
        super(fields ?? {});
        Object.defineProperty(this, "lc_serializable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "temperature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "topP", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "frequencyPenalty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "presencePenalty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "n", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "logitBias", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxTokens", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "modelName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "gpt-3.5-turbo"
        });
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "gpt-3.5-turbo"
        });
        Object.defineProperty(this, "prefixMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "modelKwargs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "timeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stop", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "streaming", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "openAIApiKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiInstanceName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiDeploymentName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIBasePath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "organization", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "clientConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.openAIApiKey = fields?.apiKey ?? fields?.openAIApiKey ?? (0, _env.getEnvironmentVariable)("OPENAI_API_KEY");
        this.azureOpenAIApiKey = fields?.azureOpenAIApiKey ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_KEY");
        if (!this.azureOpenAIApiKey && !this.openAIApiKey) throw new Error("OpenAI or Azure OpenAI API key not found");
        this.azureOpenAIApiInstanceName = fields?.azureOpenAIApiInstanceName ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_INSTANCE_NAME");
        this.azureOpenAIApiDeploymentName = (fields?.azureOpenAIApiCompletionsDeploymentName || fields?.azureOpenAIApiDeploymentName) ?? ((0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_COMPLETIONS_DEPLOYMENT_NAME") || (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_DEPLOYMENT_NAME"));
        this.azureOpenAIApiVersion = fields?.azureOpenAIApiVersion ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_VERSION");
        this.azureOpenAIBasePath = fields?.azureOpenAIBasePath ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_BASE_PATH");
        this.organization = fields?.configuration?.organization ?? (0, _env.getEnvironmentVariable)("OPENAI_ORGANIZATION");
        this.modelName = fields?.model ?? fields?.modelName ?? this.modelName;
        this.prefixMessages = fields?.prefixMessages ?? this.prefixMessages;
        this.modelKwargs = fields?.modelKwargs ?? {};
        this.timeout = fields?.timeout;
        this.temperature = fields?.temperature ?? this.temperature;
        this.topP = fields?.topP ?? this.topP;
        this.frequencyPenalty = fields?.frequencyPenalty ?? this.frequencyPenalty;
        this.presencePenalty = fields?.presencePenalty ?? this.presencePenalty;
        this.n = fields?.n ?? this.n;
        this.logitBias = fields?.logitBias;
        this.maxTokens = fields?.maxTokens;
        this.stop = fields?.stop;
        this.user = fields?.user;
        this.streaming = fields?.streaming ?? false;
        if (this.n > 1) throw new Error("Cannot use n > 1 in OpenAIChat LLM. Use ChatOpenAI Chat Model instead.");
        if (this.azureOpenAIApiKey) {
            if (!this.azureOpenAIApiInstanceName && !this.azureOpenAIBasePath) throw new Error("Azure OpenAI API instance name not found");
            if (!this.azureOpenAIApiDeploymentName) throw new Error("Azure OpenAI API deployment name not found");
            if (!this.azureOpenAIApiVersion) throw new Error("Azure OpenAI API version not found");
            this.openAIApiKey = this.openAIApiKey ?? "";
        }
        this.clientConfig = {
            apiKey: this.openAIApiKey,
            organization: this.organization,
            baseURL: configuration?.basePath ?? fields?.configuration?.basePath,
            dangerouslyAllowBrowser: true,
            defaultHeaders: configuration?.baseOptions?.headers ?? fields?.configuration?.baseOptions?.headers,
            defaultQuery: configuration?.baseOptions?.params ?? fields?.configuration?.baseOptions?.params,
            ...configuration,
            ...fields?.configuration
        };
    }
    /**
     * Get the parameters used to invoke the model
     */ invocationParams(options) {
        return {
            model: this.modelName,
            temperature: this.temperature,
            top_p: this.topP,
            frequency_penalty: this.frequencyPenalty,
            presence_penalty: this.presencePenalty,
            n: this.n,
            logit_bias: this.logitBias,
            max_tokens: this.maxTokens === -1 ? undefined : this.maxTokens,
            stop: options?.stop ?? this.stop,
            user: this.user,
            stream: this.streaming,
            ...this.modelKwargs
        };
    }
    /** @ignore */ _identifyingParams() {
        return {
            model_name: this.modelName,
            ...this.invocationParams(),
            ...this.clientConfig
        };
    }
    /**
     * Get the identifying parameters for the model
     */ identifyingParams() {
        return {
            model_name: this.modelName,
            ...this.invocationParams(),
            ...this.clientConfig
        };
    }
    /**
     * Formats the messages for the OpenAI API.
     * @param prompt The prompt to be formatted.
     * @returns Array of formatted messages.
     */ formatMessages(prompt) {
        const message = {
            role: "user",
            content: prompt
        };
        return this.prefixMessages ? [
            ...this.prefixMessages,
            message
        ] : [
            message
        ];
    }
    async *_streamResponseChunks(prompt, options, runManager) {
        const params = {
            ...this.invocationParams(options),
            messages: this.formatMessages(prompt),
            stream: true
        };
        const stream = await this.completionWithRetry(params, options);
        for await (const data of stream){
            const choice = data?.choices[0];
            if (!choice) continue;
            const { delta } = choice;
            const generationChunk = new (0, _outputs.GenerationChunk)({
                text: delta.content ?? ""
            });
            yield generationChunk;
            const newTokenIndices = {
                prompt: options.promptIndex ?? 0,
                completion: choice.index ?? 0
            };
            // eslint-disable-next-line no-void
            runManager?.handleLLMNewToken(generationChunk.text ?? "", newTokenIndices);
        }
        if (options.signal?.aborted) throw new Error("AbortError");
    }
    /** @ignore */ async _call(prompt, options, runManager) {
        const params = this.invocationParams(options);
        if (params.stream) {
            const stream = await this._streamResponseChunks(prompt, options, runManager);
            let finalChunk;
            for await (const chunk of stream)if (finalChunk === undefined) finalChunk = chunk;
            else finalChunk = finalChunk.concat(chunk);
            return finalChunk?.text ?? "";
        } else {
            const response = await this.completionWithRetry({
                ...params,
                stream: false,
                messages: this.formatMessages(prompt)
            }, {
                signal: options.signal,
                ...options.options
            });
            return response?.choices[0]?.message?.content ?? "";
        }
    }
    async completionWithRetry(request, options) {
        const requestOptions = this._getClientOptions(options);
        return this.caller.call(async ()=>{
            try {
                const res = await this.client.chat.completions.create(request, requestOptions);
                return res;
            } catch (e) {
                const error = (0, _openaiJs.wrapOpenAIClientError)(e);
                throw error;
            }
        });
    }
    /** @ignore */ _getClientOptions(options) {
        if (!this.client) {
            const openAIEndpointConfig = {
                azureOpenAIApiDeploymentName: this.azureOpenAIApiDeploymentName,
                azureOpenAIApiInstanceName: this.azureOpenAIApiInstanceName,
                azureOpenAIApiKey: this.azureOpenAIApiKey,
                azureOpenAIBasePath: this.azureOpenAIBasePath,
                baseURL: this.clientConfig.baseURL
            };
            const endpoint = (0, _azureJs.getEndpoint)(openAIEndpointConfig);
            const params = {
                ...this.clientConfig,
                baseURL: endpoint,
                timeout: this.timeout,
                maxRetries: 0
            };
            if (!params.baseURL) delete params.baseURL;
            this.client = new (0, _openai.OpenAI)(params);
        }
        const requestOptions = {
            ...this.clientConfig,
            ...options
        };
        if (this.azureOpenAIApiKey) {
            requestOptions.headers = {
                "api-key": this.azureOpenAIApiKey,
                ...requestOptions.headers
            };
            requestOptions.query = {
                "api-version": this.azureOpenAIApiVersion,
                ...requestOptions.query
            };
        }
        return requestOptions;
    }
    _llmType() {
        return "openai";
    }
}

},{"openai":"xOLuj","@langchain/core/outputs":"bm0qz","@langchain/core/utils/env":"4REmP","@langchain/core/language_models/llms":"lJyYj","./utils/azure.js":"ASDZZ","./utils/openai.js":"7jhsd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1GZwA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AzureOpenAI", ()=>AzureOpenAI);
var _openai = require("openai");
var _llmsJs = require("../llms.js");
var _azureJs = require("../utils/azure.js");
class AzureOpenAI extends (0, _llmsJs.OpenAI) {
    get lc_aliases() {
        return {
            openAIApiKey: "openai_api_key",
            openAIApiVersion: "openai_api_version",
            openAIBasePath: "openai_api_base"
        };
    }
    constructor(fields){
        const newFields = fields ? {
            ...fields
        } : fields;
        if (newFields) {
            // don't rewrite the fields if they are already set
            newFields.azureOpenAIApiDeploymentName = newFields.azureOpenAIApiDeploymentName ?? newFields.deploymentName;
            newFields.azureOpenAIApiKey = newFields.azureOpenAIApiKey ?? newFields.openAIApiKey;
            newFields.azureOpenAIApiVersion = newFields.azureOpenAIApiVersion ?? newFields.openAIApiVersion;
        }
        super(newFields);
    }
    _getClientOptions(options) {
        if (!this.client) {
            const openAIEndpointConfig = {
                azureOpenAIApiDeploymentName: this.azureOpenAIApiDeploymentName,
                azureOpenAIApiInstanceName: this.azureOpenAIApiInstanceName,
                azureOpenAIApiKey: this.azureOpenAIApiKey,
                azureOpenAIBasePath: this.azureOpenAIBasePath,
                azureADTokenProvider: this.azureADTokenProvider,
                baseURL: this.clientConfig.baseURL
            };
            const endpoint = (0, _azureJs.getEndpoint)(openAIEndpointConfig);
            const params = {
                ...this.clientConfig,
                baseURL: endpoint,
                timeout: this.timeout,
                maxRetries: 0
            };
            if (!this.azureADTokenProvider) params.apiKey = openAIEndpointConfig.azureOpenAIApiKey;
            if (!params.baseURL) delete params.baseURL;
            params.defaultHeaders = {
                ...params.defaultHeaders,
                "User-Agent": params.defaultHeaders?.["User-Agent"] ? `${params.defaultHeaders["User-Agent"]}: langchainjs-azure-openai-v2` : `langchainjs-azure-openai-v2`
            };
            this.client = new (0, _openai.AzureOpenAI)({
                apiVersion: this.azureOpenAIApiVersion,
                azureADTokenProvider: this.azureADTokenProvider,
                ...params
            });
        }
        const requestOptions = {
            ...this.clientConfig,
            ...options
        };
        if (this.azureOpenAIApiKey) {
            requestOptions.headers = {
                "api-key": this.azureOpenAIApiKey,
                ...requestOptions.headers
            };
            requestOptions.query = {
                "api-version": this.azureOpenAIApiVersion,
                ...requestOptions.query
            };
        }
        return requestOptions;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    toJSON() {
        const json = super.toJSON();
        function isRecord(obj) {
            return typeof obj === "object" && obj != null;
        }
        if (isRecord(json) && isRecord(json.kwargs)) {
            delete json.kwargs.azure_openai_base_path;
            delete json.kwargs.azure_openai_api_deployment_name;
            delete json.kwargs.azure_openai_api_key;
            delete json.kwargs.azure_openai_api_version;
            delete json.kwargs.azure_open_ai_base_path;
        }
        return json;
    }
}

},{"openai":"xOLuj","../llms.js":"3PGFR","../utils/azure.js":"ASDZZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bR7PR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AzureOpenAIEmbeddings", ()=>AzureOpenAIEmbeddings);
var _openai = require("openai");
var _embeddingsJs = require("../embeddings.js");
var _azureJs = require("../utils/azure.js");
var _openaiJs = require("../utils/openai.js");
class AzureOpenAIEmbeddings extends (0, _embeddingsJs.OpenAIEmbeddings) {
    constructor(fields, configuration){
        const newFields = {
            ...fields
        };
        if (Object.entries(newFields).length) {
            // don't rewrite the fields if they are already set
            newFields.azureOpenAIApiDeploymentName = newFields.azureOpenAIApiDeploymentName ?? newFields.deploymentName;
            newFields.azureOpenAIApiKey = newFields.azureOpenAIApiKey ?? newFields.apiKey;
            newFields.azureOpenAIApiVersion = newFields.azureOpenAIApiVersion ?? newFields.openAIApiVersion;
        }
        super(newFields, configuration);
    }
    async embeddingWithRetry(request) {
        if (!this.client) {
            const openAIEndpointConfig = {
                azureOpenAIApiDeploymentName: this.azureOpenAIApiDeploymentName,
                azureOpenAIApiInstanceName: this.azureOpenAIApiInstanceName,
                azureOpenAIApiKey: this.azureOpenAIApiKey,
                azureOpenAIBasePath: this.azureOpenAIBasePath,
                azureADTokenProvider: this.azureADTokenProvider,
                baseURL: this.clientConfig.baseURL
            };
            const endpoint = (0, _azureJs.getEndpoint)(openAIEndpointConfig);
            const params = {
                ...this.clientConfig,
                baseURL: endpoint,
                timeout: this.timeout,
                maxRetries: 0
            };
            if (!this.azureADTokenProvider) params.apiKey = openAIEndpointConfig.azureOpenAIApiKey;
            if (!params.baseURL) delete params.baseURL;
            params.defaultHeaders = {
                ...params.defaultHeaders,
                "User-Agent": params.defaultHeaders?.["User-Agent"] ? `${params.defaultHeaders["User-Agent"]}: langchainjs-azure-openai-v2` : `langchainjs-azure-openai-v2`
            };
            this.client = new (0, _openai.AzureOpenAI)({
                apiVersion: this.azureOpenAIApiVersion,
                azureADTokenProvider: this.azureADTokenProvider,
                deployment: this.azureOpenAIApiDeploymentName,
                ...params
            });
        }
        const requestOptions = {};
        if (this.azureOpenAIApiKey) {
            requestOptions.headers = {
                "api-key": this.azureOpenAIApiKey,
                ...requestOptions.headers
            };
            requestOptions.query = {
                "api-version": this.azureOpenAIApiVersion,
                ...requestOptions.query
            };
        }
        return this.caller.call(async ()=>{
            try {
                const res = await this.client.embeddings.create(request, requestOptions);
                return res;
            } catch (e) {
                const error = (0, _openaiJs.wrapOpenAIClientError)(e);
                throw error;
            }
        });
    }
}

},{"openai":"xOLuj","../embeddings.js":"fja9U","../utils/azure.js":"ASDZZ","../utils/openai.js":"7jhsd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fja9U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Class for generating embeddings using the OpenAI API. Extends the
 * Embeddings class and implements OpenAIEmbeddingsParams and
 * AzureOpenAIInput.
 * @example
 * ```typescript
 * // Embed a query using OpenAIEmbeddings to generate embeddings for a given text
 * const model = new OpenAIEmbeddings();
 * const res = await model.embedQuery(
 *   "What would be a good company name for a company that makes colorful socks?",
 * );
 * console.log({ res });
 *
 * ```
 */ parcelHelpers.export(exports, "OpenAIEmbeddings", ()=>OpenAIEmbeddings);
var _openai = require("openai");
var _env = require("@langchain/core/utils/env");
var _embeddings = require("@langchain/core/embeddings");
var _chunkArray = require("@langchain/core/utils/chunk_array");
var _azureJs = require("./utils/azure.js");
var _openaiJs = require("./utils/openai.js");
class OpenAIEmbeddings extends (0, _embeddings.Embeddings) {
    constructor(fields, configuration){
        const fieldsWithDefaults = {
            maxConcurrency: 2,
            ...fields
        };
        super(fieldsWithDefaults);
        Object.defineProperty(this, "modelName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "text-embedding-ada-002"
        });
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "text-embedding-ada-002"
        });
        Object.defineProperty(this, "batchSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 512
        });
        // TODO: Update to `false` on next minor release (see: https://github.com/langchain-ai/langchainjs/pull/3612)
        Object.defineProperty(this, "stripNewLines", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        /**
         * The number of dimensions the resulting output embeddings should have.
         * Only supported in `text-embedding-3` and later models.
         */ Object.defineProperty(this, "dimensions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "timeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureADTokenProvider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiInstanceName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIApiDeploymentName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "azureOpenAIBasePath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "organization", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "clientConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        let apiKey = fieldsWithDefaults?.apiKey ?? fieldsWithDefaults?.openAIApiKey ?? (0, _env.getEnvironmentVariable)("OPENAI_API_KEY");
        const azureApiKey = fieldsWithDefaults?.azureOpenAIApiKey ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_KEY");
        this.azureADTokenProvider = fields?.azureADTokenProvider ?? undefined;
        if (!azureApiKey && !apiKey && !this.azureADTokenProvider) throw new Error("OpenAI or Azure OpenAI API key or Token Provider not found");
        const azureApiInstanceName = fieldsWithDefaults?.azureOpenAIApiInstanceName ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_INSTANCE_NAME");
        const azureApiDeploymentName = (fieldsWithDefaults?.azureOpenAIApiEmbeddingsDeploymentName || fieldsWithDefaults?.azureOpenAIApiDeploymentName) ?? ((0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_EMBEDDINGS_DEPLOYMENT_NAME") || (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_DEPLOYMENT_NAME"));
        const azureApiVersion = fieldsWithDefaults?.azureOpenAIApiVersion ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_API_VERSION");
        this.azureOpenAIBasePath = fieldsWithDefaults?.azureOpenAIBasePath ?? (0, _env.getEnvironmentVariable)("AZURE_OPENAI_BASE_PATH");
        this.organization = fieldsWithDefaults?.configuration?.organization ?? (0, _env.getEnvironmentVariable)("OPENAI_ORGANIZATION");
        this.modelName = fieldsWithDefaults?.model ?? fieldsWithDefaults?.modelName ?? this.model;
        this.model = this.modelName;
        this.batchSize = fieldsWithDefaults?.batchSize ?? (azureApiKey ? 1 : this.batchSize);
        this.stripNewLines = fieldsWithDefaults?.stripNewLines ?? this.stripNewLines;
        this.timeout = fieldsWithDefaults?.timeout;
        this.dimensions = fieldsWithDefaults?.dimensions;
        this.azureOpenAIApiVersion = azureApiVersion;
        this.azureOpenAIApiKey = azureApiKey;
        this.azureOpenAIApiInstanceName = azureApiInstanceName;
        this.azureOpenAIApiDeploymentName = azureApiDeploymentName;
        if (this.azureOpenAIApiKey || this.azureADTokenProvider) {
            if (!this.azureOpenAIApiInstanceName && !this.azureOpenAIBasePath) throw new Error("Azure OpenAI API instance name not found");
            if (!this.azureOpenAIApiDeploymentName) throw new Error("Azure OpenAI API deployment name not found");
            if (!this.azureOpenAIApiVersion) throw new Error("Azure OpenAI API version not found");
            apiKey = apiKey ?? "";
        }
        this.clientConfig = {
            apiKey,
            organization: this.organization,
            baseURL: configuration?.basePath,
            dangerouslyAllowBrowser: true,
            defaultHeaders: configuration?.baseOptions?.headers,
            defaultQuery: configuration?.baseOptions?.params,
            ...configuration,
            ...fields?.configuration
        };
    }
    /**
     * Method to generate embeddings for an array of documents. Splits the
     * documents into batches and makes requests to the OpenAI API to generate
     * embeddings.
     * @param texts Array of documents to generate embeddings for.
     * @returns Promise that resolves to a 2D array of embeddings for each document.
     */ async embedDocuments(texts) {
        const batches = (0, _chunkArray.chunkArray)(this.stripNewLines ? texts.map((t)=>t.replace(/\n/g, " ")) : texts, this.batchSize);
        const batchRequests = batches.map((batch)=>{
            const params = {
                model: this.model,
                input: batch
            };
            if (this.dimensions) params.dimensions = this.dimensions;
            return this.embeddingWithRetry(params);
        });
        const batchResponses = await Promise.all(batchRequests);
        const embeddings = [];
        for(let i = 0; i < batchResponses.length; i += 1){
            const batch = batches[i];
            const { data: batchResponse } = batchResponses[i];
            for(let j = 0; j < batch.length; j += 1)embeddings.push(batchResponse[j].embedding);
        }
        return embeddings;
    }
    /**
     * Method to generate an embedding for a single document. Calls the
     * embeddingWithRetry method with the document as the input.
     * @param text Document to generate an embedding for.
     * @returns Promise that resolves to an embedding for the document.
     */ async embedQuery(text) {
        const params = {
            model: this.model,
            input: this.stripNewLines ? text.replace(/\n/g, " ") : text
        };
        if (this.dimensions) params.dimensions = this.dimensions;
        const { data } = await this.embeddingWithRetry(params);
        return data[0].embedding;
    }
    /**
     * Private method to make a request to the OpenAI API to generate
     * embeddings. Handles the retry logic and returns the response from the
     * API.
     * @param request Request to send to the OpenAI API.
     * @returns Promise that resolves to the response from the API.
     */ async embeddingWithRetry(request) {
        if (!this.client) {
            const openAIEndpointConfig = {
                azureOpenAIApiDeploymentName: this.azureOpenAIApiDeploymentName,
                azureOpenAIApiInstanceName: this.azureOpenAIApiInstanceName,
                azureOpenAIApiKey: this.azureOpenAIApiKey,
                azureOpenAIBasePath: this.azureOpenAIBasePath,
                baseURL: this.clientConfig.baseURL
            };
            const endpoint = (0, _azureJs.getEndpoint)(openAIEndpointConfig);
            const params = {
                ...this.clientConfig,
                baseURL: endpoint,
                timeout: this.timeout,
                maxRetries: 0
            };
            if (!params.baseURL) delete params.baseURL;
            this.client = new (0, _openai.OpenAI)(params);
        }
        const requestOptions = {};
        if (this.azureOpenAIApiKey) {
            requestOptions.headers = {
                "api-key": this.azureOpenAIApiKey,
                ...requestOptions.headers
            };
            requestOptions.query = {
                "api-version": this.azureOpenAIApiVersion,
                ...requestOptions.query
            };
        }
        return this.caller.call(async ()=>{
            try {
                const res = await this.client.embeddings.create(request, requestOptions);
                return res;
            } catch (e) {
                const error = (0, _openaiJs.wrapOpenAIClientError)(e);
                throw error;
            }
        });
    }
}

},{"openai":"xOLuj","@langchain/core/utils/env":"4REmP","@langchain/core/embeddings":"it5tk","@langchain/core/utils/chunk_array":"3EMKU","./utils/azure.js":"ASDZZ","./utils/openai.js":"7jhsd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"it5tk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _embeddingsJs = require("./dist/embeddings.js");
parcelHelpers.exportAll(_embeddingsJs, exports);

},{"./dist/embeddings.js":"iP48n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j0PfE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2pwYt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dalleJs = require("./dalle.js");
parcelHelpers.exportAll(_dalleJs, exports);

},{"./dalle.js":"efrUo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"efrUo":[function(require,module,exports,__globalThis) {
/* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A tool for generating images with Open AIs Dall-E 2 or 3 API.
 */ parcelHelpers.export(exports, "DallEAPIWrapper", ()=>DallEAPIWrapper);
var _env = require("@langchain/core/utils/env");
var _openai = require("openai");
var _tools = require("@langchain/core/tools");
class DallEAPIWrapper extends (0, _tools.Tool) {
    static lc_name() {
        return "DallEAPIWrapper";
    }
    constructor(fields){
        // Shim for new base tool param name
        if (fields?.responseFormat !== undefined && [
            "url",
            "b64_json"
        ].includes(fields.responseFormat)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            fields.dallEResponseFormat = fields.responseFormat;
            fields.responseFormat = "content";
        }
        super(fields);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "dalle_api_wrapper"
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "A wrapper around OpenAI DALL-E API. Useful for when you need to generate images from a text description. Input should be an image description."
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "dall-e-3"
        });
        Object.defineProperty(this, "style", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "vivid"
        });
        Object.defineProperty(this, "quality", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "standard"
        });
        Object.defineProperty(this, "n", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "1024x1024"
        });
        Object.defineProperty(this, "dallEResponseFormat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "url"
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const openAIApiKey = fields?.apiKey ?? fields?.openAIApiKey ?? (0, _env.getEnvironmentVariable)("OPENAI_API_KEY");
        const organization = fields?.organization ?? (0, _env.getEnvironmentVariable)("OPENAI_ORGANIZATION");
        const clientConfig = {
            apiKey: openAIApiKey,
            organization,
            dangerouslyAllowBrowser: true,
            baseUrl: fields?.baseUrl
        };
        this.client = new (0, _openai.OpenAI)(clientConfig);
        this.model = fields?.model ?? fields?.modelName ?? this.model;
        this.style = fields?.style ?? this.style;
        this.quality = fields?.quality ?? this.quality;
        this.n = fields?.n ?? this.n;
        this.size = fields?.size ?? this.size;
        this.dallEResponseFormat = fields?.dallEResponseFormat ?? this.dallEResponseFormat;
        this.user = fields?.user;
    }
    /**
     * Processes the API response if multiple images are generated.
     * Returns a list of MessageContentImageUrl objects. If the response
     * format is `url`, then the `image_url` field will contain the URL.
     * If it is `b64_json`, then the `image_url` field will contain an object
     * with a `url` field with the base64 encoded image.
     *
     * @param {OpenAIClient.Images.ImagesResponse[]} response The API response
     * @returns {MessageContentImageUrl[]}
     */ processMultipleGeneratedUrls(response) {
        if (this.dallEResponseFormat === "url") return response.flatMap((res)=>{
            const imageUrlContent = res.data.flatMap((item)=>{
                if (!item.url) return [];
                return {
                    type: "image_url",
                    image_url: item.url
                };
            }).filter((item)=>item !== undefined && item.type === "image_url" && typeof item.image_url === "string" && item.image_url !== undefined);
            return imageUrlContent;
        });
        else return response.flatMap((res)=>{
            const b64Content = res.data.flatMap((item)=>{
                if (!item.b64_json) return [];
                return {
                    type: "image_url",
                    image_url: {
                        url: item.b64_json
                    }
                };
            }).filter((item)=>item !== undefined && item.type === "image_url" && typeof item.image_url === "object" && "url" in item.image_url && typeof item.image_url.url === "string" && item.image_url.url !== undefined);
            return b64Content;
        });
    }
    /** @ignore */ async _call(input) {
        const generateImageFields = {
            model: this.model,
            prompt: input,
            n: 1,
            size: this.size,
            response_format: this.dallEResponseFormat,
            style: this.style,
            quality: this.quality,
            user: this.user
        };
        if (this.n > 1) {
            const results = await Promise.all(Array.from({
                length: this.n
            }).map(()=>this.client.images.generate(generateImageFields)));
            return this.processMultipleGeneratedUrls(results);
        }
        const response = await this.client.images.generate(generateImageFields);
        let data = "";
        if (this.dallEResponseFormat === "url") [data] = response.data.map((item)=>item.url).filter((url)=>url !== "undefined");
        else [data] = response.data.map((item)=>item.b64_json).filter((b64_json)=>b64_json !== "undefined");
        return data;
    }
}
Object.defineProperty(DallEAPIWrapper, "toolName", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: "dalle_api_wrapper"
});

},{"@langchain/core/utils/env":"4REmP","openai":"xOLuj","@langchain/core/tools":"85wUY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"85wUY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./dist/tools/index.js");
parcelHelpers.exportAll(_indexJs, exports);

},{"./dist/tools/index.js":"bXVFj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jCUjR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Convert a formatted LangChain prompt (e.g. pulled from the hub) into
 * a format expected by OpenAI's JS SDK.
 *
 * Requires the "@langchain/openai" package to be installed in addition
 * to the OpenAI SDK.
 *
 * @example
 * ```ts
 * import { convertPromptToOpenAI } from "langsmith/utils/hub/openai";
 * import { pull } from "langchain/hub";
 *
 * import OpenAI from 'openai';
 *
 * const prompt = await pull("jacob/joke-generator");
 * const formattedPrompt = await prompt.invoke({
 *   topic: "cats",
 * });
 *
 * const { messages } = convertPromptToOpenAI(formattedPrompt);
 *
 * const openAIClient = new OpenAI();
 *
 * const openaiResponse = await openAIClient.chat.completions.create({
 *   model: "gpt-4o",
 *   messages,
 * });
 * ```
 * @param formattedPrompt
 * @returns A partial OpenAI payload.
 */ parcelHelpers.export(exports, "convertPromptToOpenAI", ()=>convertPromptToOpenAI);
var _chatModelsJs = require("../chat_models.js");
function convertPromptToOpenAI(formattedPrompt) {
    const messages = formattedPrompt.toChatMessages();
    return {
        messages: (0, _chatModelsJs._convertMessagesToOpenAIParams)(messages)
    };
}

},{"../chat_models.js":"1Wv2V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9XZHq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AssemblyAI", ()=>AssemblyAI);
parcelHelpers.export(exports, "FileService", ()=>FileService);
parcelHelpers.export(exports, "LemurService", ()=>LemurService);
parcelHelpers.export(exports, "RealtimeService", ()=>RealtimeService);
parcelHelpers.export(exports, "RealtimeServiceFactory", ()=>RealtimeServiceFactory);
parcelHelpers.export(exports, "RealtimeTranscriber", ()=>RealtimeTranscriber);
parcelHelpers.export(exports, "RealtimeTranscriberFactory", ()=>RealtimeTranscriberFactory);
parcelHelpers.export(exports, "TranscriptService", ()=>TranscriptService);
var process = require("8f11172148485186");
var global = arguments[3];
const DEFAULT_FETCH_INIT = {
    cache: "no-store"
};
const buildUserAgent = (userAgent)=>defaultUserAgentString + (userAgent === false ? "" : " AssemblyAI/1.0 (" + Object.entries({
        ...defaultUserAgent,
        ...userAgent
    }).map(([key, item])=>item ? `${key}=${item.name}/${item.version}` : "").join(" ") + ")");
let defaultUserAgentString = "";
if (typeof navigator !== "undefined" && navigator.userAgent) defaultUserAgentString += navigator.userAgent;
const defaultUserAgent = {
    sdk: {
        name: "JavaScript",
        version: "4.8.0"
    }
};
if (typeof process !== "undefined") {
    if (process.versions.node && defaultUserAgentString.indexOf("Node") === -1) defaultUserAgent.runtime_env = {
        name: "Node",
        version: process.versions.node
    };
    if (process.versions.bun && defaultUserAgentString.indexOf("Bun") === -1) defaultUserAgent.runtime_env = {
        name: "Bun",
        version: process.versions.bun
    };
}
if (typeof Deno !== "undefined") {
    if (process.versions.bun && defaultUserAgentString.indexOf("Deno") === -1) defaultUserAgent.runtime_env = {
        name: "Deno",
        version: Deno.version.deno
    };
}
/**
 * Base class for services that communicate with the API.
 */ class BaseService {
    /**
     * Create a new service.
     * @param params - The parameters to use for the service.
     */ constructor(params){
        this.params = params;
        if (params.userAgent === false) this.userAgent = undefined;
        else this.userAgent = buildUserAgent(params.userAgent || {});
    }
    async fetch(input, init) {
        init = {
            ...DEFAULT_FETCH_INIT,
            ...init
        };
        let headers = {
            Authorization: this.params.apiKey,
            "Content-Type": "application/json"
        };
        if (DEFAULT_FETCH_INIT?.headers) headers = {
            ...headers,
            ...DEFAULT_FETCH_INIT.headers
        };
        if (init?.headers) headers = {
            ...headers,
            ...init.headers
        };
        if (this.userAgent) {
            headers["User-Agent"] = this.userAgent;
            // chromium browsers have a bug where the user agent can't be modified
            if (typeof window !== "undefined" && "chrome" in window) headers["AssemblyAI-Agent"] = this.userAgent;
        }
        init.headers = headers;
        if (!input.startsWith("http")) input = this.params.baseUrl + input;
        const response = await fetch(input, init);
        if (response.status >= 400) {
            let json;
            const text = await response.text();
            if (text) {
                try {
                    json = JSON.parse(text);
                } catch  {
                /* empty */ }
                if (json?.error) throw new Error(json.error);
                throw new Error(text);
            }
            throw new Error(`HTTP Error: ${response.status} ${response.statusText}`);
        }
        return response;
    }
    async fetchJson(input, init) {
        const response = await this.fetch(input, init);
        return response.json();
    }
}
class LemurService extends BaseService {
    summary(params) {
        return this.fetchJson("/lemur/v3/generate/summary", {
            method: "POST",
            body: JSON.stringify(params)
        });
    }
    questionAnswer(params) {
        return this.fetchJson("/lemur/v3/generate/question-answer", {
            method: "POST",
            body: JSON.stringify(params)
        });
    }
    actionItems(params) {
        return this.fetchJson("/lemur/v3/generate/action-items", {
            method: "POST",
            body: JSON.stringify(params)
        });
    }
    task(params) {
        return this.fetchJson("/lemur/v3/generate/task", {
            method: "POST",
            body: JSON.stringify(params)
        });
    }
    getResponse(id) {
        return this.fetchJson(`/lemur/v3/${id}`);
    }
    /**
     * Delete the data for a previously submitted LeMUR request.
     * @param id - ID of the LeMUR request
     */ purgeRequestData(id) {
        return this.fetchJson(`/lemur/v3/${id}`, {
            method: "DELETE"
        });
    }
}
const { WritableStream } = typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : globalThis;
const PolyfillWebSocket = WebSocket ?? global?.WebSocket ?? window?.WebSocket ?? self?.WebSocket;
const factory = (url, params)=>{
    if (params) return new PolyfillWebSocket(url, params);
    return new PolyfillWebSocket(url);
};
const RealtimeErrorType = {
    BadSampleRate: 4000,
    AuthFailed: 4001,
    /**
     * @deprecated Use InsufficientFunds or FreeTierUser instead
     */ InsufficientFundsOrFreeAccount: 4002,
    InsufficientFunds: 4002,
    FreeTierUser: 4003,
    NonexistentSessionId: 4004,
    SessionExpired: 4008,
    ClosedSession: 4010,
    RateLimited: 4029,
    UniqueSessionViolation: 4030,
    SessionTimeout: 4031,
    AudioTooShort: 4032,
    AudioTooLong: 4033,
    AudioTooSmallToTranscode: 4034,
    /**
     * @deprecated Don't use
     */ BadJson: 4100,
    BadSchema: 4101,
    TooManyStreams: 4102,
    Reconnected: 4103,
    /**
     * @deprecated Don't use
     */ ReconnectAttemptsExhausted: 1013,
    WordBoostParameterParsingFailed: 4104
};
const RealtimeErrorMessages = {
    [RealtimeErrorType.BadSampleRate]: "Sample rate must be a positive integer",
    [RealtimeErrorType.AuthFailed]: "Not Authorized",
    [RealtimeErrorType.InsufficientFunds]: "Insufficient funds",
    [RealtimeErrorType.FreeTierUser]: "This feature is paid-only and requires you to add a credit card. Please visit https://app.assemblyai.com/ to add a credit card to your account.",
    [RealtimeErrorType.NonexistentSessionId]: "Session ID does not exist",
    [RealtimeErrorType.SessionExpired]: "Session has expired",
    [RealtimeErrorType.ClosedSession]: "Session is closed",
    [RealtimeErrorType.RateLimited]: "Rate limited",
    [RealtimeErrorType.UniqueSessionViolation]: "Unique session violation",
    [RealtimeErrorType.SessionTimeout]: "Session Timeout",
    [RealtimeErrorType.AudioTooShort]: "Audio too short",
    [RealtimeErrorType.AudioTooLong]: "Audio too long",
    [RealtimeErrorType.AudioTooSmallToTranscode]: "Audio too small to transcode",
    [RealtimeErrorType.BadJson]: "Bad JSON",
    [RealtimeErrorType.BadSchema]: "Bad schema",
    [RealtimeErrorType.TooManyStreams]: "Too many streams",
    [RealtimeErrorType.Reconnected]: "This session has been reconnected. This WebSocket is no longer valid.",
    [RealtimeErrorType.ReconnectAttemptsExhausted]: "Reconnect attempts exhausted",
    [RealtimeErrorType.WordBoostParameterParsingFailed]: "Could not parse word boost parameter"
};
class RealtimeError extends Error {
}
const defaultRealtimeUrl = "wss://api.assemblyai.com/v2/realtime/ws";
const forceEndOfUtteranceMessage = `{"force_end_utterance":true}`;
const terminateSessionMessage = `{"terminate_session":true}`;
/**
 * RealtimeTranscriber connects to the Streaming Speech-to-Text API and lets you transcribe audio in real-time.
 */ class RealtimeTranscriber {
    /**
     * Create a new RealtimeTranscriber.
     * @param params - Parameters to configure the RealtimeTranscriber
     */ constructor(params){
        this.listeners = {};
        this.realtimeUrl = params.realtimeUrl ?? defaultRealtimeUrl;
        this.sampleRate = params.sampleRate ?? 16000;
        this.wordBoost = params.wordBoost;
        this.encoding = params.encoding;
        this.endUtteranceSilenceThreshold = params.endUtteranceSilenceThreshold;
        this.disablePartialTranscripts = params.disablePartialTranscripts;
        if ("token" in params && params.token) this.token = params.token;
        if ("apiKey" in params && params.apiKey) this.apiKey = params.apiKey;
        if (!(this.token || this.apiKey)) throw new Error("API key or temporary token is required.");
    }
    connectionUrl() {
        const url = new URL(this.realtimeUrl);
        if (url.protocol !== "wss:") throw new Error("Invalid protocol, must be wss");
        const searchParams = new URLSearchParams();
        if (this.token) searchParams.set("token", this.token);
        searchParams.set("sample_rate", this.sampleRate.toString());
        if (this.wordBoost && this.wordBoost.length > 0) searchParams.set("word_boost", JSON.stringify(this.wordBoost));
        if (this.encoding) searchParams.set("encoding", this.encoding);
        searchParams.set("enable_extra_session_information", "true");
        if (this.disablePartialTranscripts) searchParams.set("disable_partial_transcripts", this.disablePartialTranscripts.toString());
        url.search = searchParams.toString();
        return url;
    }
    /**
     * Add a listener for an event.
     * @param event - The event to listen for.
     * @param listener - The function to call when the event is emitted.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        this.listeners[event] = listener;
    }
    /**
     * Connect to the server and begin a new session.
     * @returns A promise that resolves when the connection is established and the session begins.
     */ connect() {
        return new Promise((resolve)=>{
            if (this.socket) throw new Error("Already connected");
            const url = this.connectionUrl();
            if (this.token) this.socket = factory(url.toString());
            else {
                console.warn(`API key authentication is not supported for the RealtimeTranscriber in browser environment. Use temporary token authentication instead.
Learn more at https://github.com/AssemblyAI/assemblyai-node-sdk/blob/main/docs/compat.md#browser-compatibility.`);
                this.socket = factory(url.toString(), {
                    headers: {
                        Authorization: this.apiKey
                    }
                });
            }
            this.socket.binaryType = "arraybuffer";
            this.socket.onopen = ()=>{
                if (this.endUtteranceSilenceThreshold === undefined || this.endUtteranceSilenceThreshold === null) return;
                this.configureEndUtteranceSilenceThreshold(this.endUtteranceSilenceThreshold);
            };
            this.socket.onclose = ({ code, reason })=>{
                if (!reason) {
                    if (code in RealtimeErrorMessages) reason = RealtimeErrorMessages[code];
                }
                this.listeners.close?.(code, reason);
            };
            this.socket.onerror = (event)=>{
                if (event.error) this.listeners.error?.(event.error);
                else this.listeners.error?.(new Error(event.message));
            };
            this.socket.onmessage = ({ data })=>{
                const message = JSON.parse(data.toString());
                if ("error" in message) {
                    this.listeners.error?.(new RealtimeError(message.error));
                    return;
                }
                switch(message.message_type){
                    case "SessionBegins":
                        {
                            const openObject = {
                                sessionId: message.session_id,
                                expiresAt: new Date(message.expires_at)
                            };
                            resolve(openObject);
                            this.listeners.open?.(openObject);
                            break;
                        }
                    case "PartialTranscript":
                        // message.created is actually a string when coming from the socket
                        message.created = new Date(message.created);
                        this.listeners.transcript?.(message);
                        this.listeners["transcript.partial"]?.(message);
                        break;
                    case "FinalTranscript":
                        // message.created is actually a string when coming from the socket
                        message.created = new Date(message.created);
                        this.listeners.transcript?.(message);
                        this.listeners["transcript.final"]?.(message);
                        break;
                    case "SessionInformation":
                        this.listeners.session_information?.(message);
                        break;
                    case "SessionTerminated":
                        this.sessionTerminatedResolve?.();
                        break;
                }
            };
        });
    }
    /**
     * Send audio data to the server.
     * @param audio - The audio data to send to the server.
     */ sendAudio(audio) {
        this.send(audio);
    }
    /**
     * Create a writable stream that can be used to send audio data to the server.
     * @returns A writable stream that can be used to send audio data to the server.
     */ stream() {
        return new WritableStream({
            write: (chunk)=>{
                this.sendAudio(chunk);
            }
        });
    }
    /**
     * Manually end an utterance
     */ forceEndUtterance() {
        this.send(forceEndOfUtteranceMessage);
    }
    /**
     * Configure the threshold for how long to wait before ending an utterance. Default is 700ms.
     * @param threshold - The duration of the end utterance silence threshold in milliseconds.
     * This value must be an integer between 0 and 20_000.
     */ configureEndUtteranceSilenceThreshold(threshold) {
        this.send(`{"end_utterance_silence_threshold":${threshold}}`);
    }
    send(data) {
        if (!this.socket || this.socket.readyState !== this.socket.OPEN) throw new Error("Socket is not open for communication");
        this.socket.send(data);
    }
    /**
     * Close the connection to the server.
     * @param waitForSessionTermination - If true, the method will wait for the session to be terminated before closing the connection.
     * While waiting for the session to be terminated, you will receive the final transcript and session information.
     */ async close(waitForSessionTermination = true) {
        if (this.socket) {
            if (this.socket.readyState === this.socket.OPEN) {
                if (waitForSessionTermination) {
                    const sessionTerminatedPromise = new Promise((resolve)=>{
                        this.sessionTerminatedResolve = resolve;
                    });
                    this.socket.send(terminateSessionMessage);
                    await sessionTerminatedPromise;
                } else this.socket.send(terminateSessionMessage);
            }
            if (this.socket?.removeAllListeners) this.socket.removeAllListeners();
            this.socket.close();
        }
        this.listeners = {};
        this.socket = undefined;
    }
}
/**
 * @deprecated Use RealtimeTranscriber instead
 */ class RealtimeService extends RealtimeTranscriber {
}
class RealtimeTranscriberFactory extends BaseService {
    constructor(params){
        super(params);
        this.rtFactoryParams = params;
    }
    /**
     * @deprecated Use transcriber(...) instead
     */ createService(params) {
        return this.transcriber(params);
    }
    transcriber(params) {
        const serviceParams = {
            ...params
        };
        if (!serviceParams.token && !serviceParams.apiKey) serviceParams.apiKey = this.rtFactoryParams.apiKey;
        return new RealtimeTranscriber(serviceParams);
    }
    async createTemporaryToken(params) {
        const data = await this.fetchJson("/v2/realtime/token", {
            method: "POST",
            body: JSON.stringify(params)
        });
        return data.token;
    }
}
/**
 * @deprecated Use RealtimeTranscriberFactory instead
 */ class RealtimeServiceFactory extends RealtimeTranscriberFactory {
}
function getPath(path) {
    if (path.startsWith("http")) return null;
    if (path.startsWith("https")) return null;
    if (path.startsWith("data:")) return null;
    if (path.startsWith("file://")) return path.substring(7);
    if (path.startsWith("file:")) return path.substring(5);
    return path;
}
class TranscriptService extends BaseService {
    constructor(params, files){
        super(params);
        this.files = files;
    }
    /**
     * Transcribe an audio file. This will create a transcript and wait until the transcript status is "completed" or "error".
     * @param params - The parameters to transcribe an audio file.
     * @param options - The options to transcribe an audio file.
     * @returns A promise that resolves to the transcript. The transcript status is "completed" or "error".
     */ async transcribe(params, options) {
        const transcript = await this.submit(params);
        return await this.waitUntilReady(transcript.id, options);
    }
    /**
     * Submits a transcription job for an audio file. This will not wait until the transcript status is "completed" or "error".
     * @param params - The parameters to start the transcription of an audio file.
     * @returns A promise that resolves to the queued transcript.
     */ async submit(params) {
        let audioUrl;
        let transcriptParams = undefined;
        if ("audio" in params) {
            const { audio, ...audioTranscriptParams } = params;
            if (typeof audio === "string") {
                const path = getPath(audio);
                if (path !== null) // audio is local path, upload local file
                audioUrl = await this.files.upload(path);
                else if (audio.startsWith("data:")) audioUrl = await this.files.upload(audio);
                else // audio is not a local path, and not a data-URI, assume it's a normal URL
                audioUrl = audio;
            } else // audio is of uploadable type
            audioUrl = await this.files.upload(audio);
            transcriptParams = {
                ...audioTranscriptParams,
                audio_url: audioUrl
            };
        } else transcriptParams = params;
        const data = await this.fetchJson("/v2/transcript", {
            method: "POST",
            body: JSON.stringify(transcriptParams)
        });
        return data;
    }
    /**
     * Create a transcript.
     * @param params - The parameters to create a transcript.
     * @param options - The options used for creating the new transcript.
     * @returns A promise that resolves to the transcript.
     * @deprecated Use `transcribe` instead to transcribe a audio file that includes polling, or `submit` to transcribe a audio file without polling.
     */ async create(params, options) {
        const path = getPath(params.audio_url);
        if (path !== null) {
            const uploadUrl = await this.files.upload(path);
            params.audio_url = uploadUrl;
        }
        const data = await this.fetchJson("/v2/transcript", {
            method: "POST",
            body: JSON.stringify(params)
        });
        if (options?.poll ?? true) return await this.waitUntilReady(data.id, options);
        return data;
    }
    /**
     * Wait until the transcript ready, either the status is "completed" or "error".
     * @param transcriptId - The ID of the transcript.
     * @param options - The options to wait until the transcript is ready.
     * @returns A promise that resolves to the transcript. The transcript status is "completed" or "error".
     */ async waitUntilReady(transcriptId, options) {
        const pollingInterval = options?.pollingInterval ?? 3000;
        const pollingTimeout = options?.pollingTimeout ?? -1;
        const startTime = Date.now();
        // eslint-disable-next-line no-constant-condition
        while(true){
            const transcript = await this.get(transcriptId);
            if (transcript.status === "completed" || transcript.status === "error") return transcript;
            else if (pollingTimeout > 0 && Date.now() - startTime > pollingTimeout) throw new Error("Polling timeout");
            else await new Promise((resolve)=>setTimeout(resolve, pollingInterval));
        }
    }
    /**
     * Retrieve a transcript.
     * @param id - The identifier of the transcript.
     * @returns A promise that resolves to the transcript.
     */ get(id) {
        return this.fetchJson(`/v2/transcript/${id}`);
    }
    /**
     * Retrieves a page of transcript listings.
     * @param params - The parameters to filter the transcript list by, or the URL to retrieve the transcript list from.
     */ async list(params) {
        let url = "/v2/transcript";
        if (typeof params === "string") url = params;
        else if (params) url = `${url}?${new URLSearchParams(Object.keys(params).map((key)=>[
                key,
                params[key]?.toString() || ""
            ]))}`;
        const data = await this.fetchJson(url);
        for (const transcriptListItem of data.transcripts){
            transcriptListItem.created = new Date(transcriptListItem.created);
            if (transcriptListItem.completed) transcriptListItem.completed = new Date(transcriptListItem.completed);
        }
        return data;
    }
    /**
     * Delete a transcript
     * @param id - The identifier of the transcript.
     * @returns A promise that resolves to the transcript.
     */ delete(id) {
        return this.fetchJson(`/v2/transcript/${id}`, {
            method: "DELETE"
        });
    }
    /**
     * Search through the transcript for a specific set of keywords.
     * You can search for individual words, numbers, or phrases containing up to five words or numbers.
     * @param id - The identifier of the transcript.
     * @param words - Keywords to search for.
     * @returns A promise that resolves to the sentences.
     */ wordSearch(id, words) {
        const params = new URLSearchParams({
            words: words.join(",")
        });
        return this.fetchJson(`/v2/transcript/${id}/word-search?${params.toString()}`);
    }
    /**
     * Retrieve all sentences of a transcript.
     * @param id - The identifier of the transcript.
     * @returns A promise that resolves to the sentences.
     */ sentences(id) {
        return this.fetchJson(`/v2/transcript/${id}/sentences`);
    }
    /**
     * Retrieve all paragraphs of a transcript.
     * @param id - The identifier of the transcript.
     * @returns A promise that resolves to the paragraphs.
     */ paragraphs(id) {
        return this.fetchJson(`/v2/transcript/${id}/paragraphs`);
    }
    /**
     * Retrieve subtitles of a transcript.
     * @param id - The identifier of the transcript.
     * @param format - The format of the subtitles.
     * @param chars_per_caption - The maximum number of characters per caption.
     * @returns A promise that resolves to the subtitles text.
     */ async subtitles(id, format = "srt", chars_per_caption) {
        let url = `/v2/transcript/${id}/${format}`;
        if (chars_per_caption) {
            const params = new URLSearchParams();
            params.set("chars_per_caption", chars_per_caption.toString());
            url += `?${params.toString()}`;
        }
        const response = await this.fetch(url);
        return await response.text();
    }
    /**
     * Retrieve the redacted audio URL of a transcript.
     * @param id - The identifier of the transcript.
     * @returns A promise that resolves to the details of the redacted audio.
     * @deprecated Use `redactedAudio` instead.
     */ redactions(id) {
        return this.redactedAudio(id);
    }
    /**
     * Retrieve the redacted audio URL of a transcript.
     * @param id - The identifier of the transcript.
     * @returns A promise that resolves to the details of the redacted audio.
     */ redactedAudio(id) {
        return this.fetchJson(`/v2/transcript/${id}/redacted-audio`);
    }
    /**
     * Retrieve the redacted audio file of a transcript.
     * @param id - The identifier of the transcript.
     * @returns A promise that resolves to the fetch HTTP response of the redacted audio file.
     */ async redactedAudioFile(id) {
        const { redacted_audio_url, status } = await this.redactedAudio(id);
        if (status !== "redacted_audio_ready") throw new Error(`Redacted audio status is ${status}`);
        const response = await fetch(redacted_audio_url);
        if (!response.ok) throw new Error(`Failed to fetch redacted audio: ${response.statusText}`);
        return {
            arrayBuffer: response.arrayBuffer.bind(response),
            blob: response.blob.bind(response),
            body: response.body,
            bodyUsed: response.bodyUsed
        };
    }
}
const readFile = async function(// eslint-disable-next-line @typescript-eslint/no-unused-vars
path) {
    throw new Error("Interacting with the file system is not supported in this environment.");
};
class FileService extends BaseService {
    /**
     * Upload a local file to AssemblyAI.
     * @param input - The local file path to upload, or a stream or buffer of the file to upload.
     * @returns A promise that resolves to the uploaded file URL.
     */ async upload(input) {
        let fileData;
        if (typeof input === "string") {
            if (input.startsWith("data:")) fileData = dataUrlToBlob(input);
            else fileData = await readFile();
        } else fileData = input;
        const data = await this.fetchJson("/v2/upload", {
            method: "POST",
            body: fileData,
            headers: {
                "Content-Type": "application/octet-stream"
            },
            duplex: "half"
        });
        return data.upload_url;
    }
}
function dataUrlToBlob(dataUrl) {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while(n--)u8arr[n] = bstr.charCodeAt(n);
    return new Blob([
        u8arr
    ], {
        type: mime
    });
}
const defaultBaseUrl = "https://api.assemblyai.com";
class AssemblyAI {
    /**
     * Create a new AssemblyAI client.
     * @param params - The parameters for the service, including the API key and base URL, if any.
     */ constructor(params){
        params.baseUrl = params.baseUrl || defaultBaseUrl;
        if (params.baseUrl && params.baseUrl.endsWith("/")) params.baseUrl = params.baseUrl.slice(0, -1);
        this.files = new FileService(params);
        this.transcripts = new TranscriptService(params, this.files);
        this.lemur = new LemurService(params);
        this.realtime = new RealtimeTranscriberFactory(params);
    }
}

},{"8f11172148485186":"5QIF0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lNf0p":[function(require,module,exports,__globalThis) {
module.exports = "Analyze the following conversation and extract the key points discussed.\nOrganize them into categories such as ‘Main Topics’, ‘Subtopics’ and ‘Details’.\nEnsure that the structure is suitable for creating a mindmap.\n\nConversation:\n{transcript}";

},{}],"fmkmc":[function(require,module,exports,__globalThis) {
module.exports = "Analyze the following conversation and extract the key points discussed.\nOrganize them into categories such as ‘Main Topics’, ‘Subtopics’ and ‘Details’.\nEnsure that the structure is suitable for creating a mindmap.\n";

},{}],"hZSyP":[function(require,module,exports,__globalThis) {
module.exports = "as my Mermaid.js expert, analyze the following structured conversation summary and transform it in a mindmap using the Mermaid.js specific syntax.\nThe expected output must be:\n- only a valid Mermaid.js mindmad no markdown is accepted\n- remove all characters that are not acceptable by mermaid \n- every element must be indented under one root node with name Summary\n\nSummary:\n{summary}";

},{}],"yJT1d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TextUploader);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lucideReact = require("lucide-react");
var _appContext = require("../AppContext");
function TextUploader() {
    const [textFile, setTextFile] = (0, _react.useState)(null);
    const { input: transcript, setInput: setTranscript } = (0, _reactDefault.default).useContext((0, _appContext.AppContext));
    const handleFileChange = async (event)=>{
        const file = event.target.files?.[0];
        if (file && file.type === 'text/plain') {
            setTextFile(file);
            const content = await file.text();
            setTranscript(content);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col items-center justify-center w-full h-full bg-gray-50 p-8",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "w-full max-w-md",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "mb-8 text-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "text-2xl font-bold text-gray-800 mb-2",
                            children: "Text File Upload"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-gray-600",
                            children: "Upload and view your text files"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "bg-white rounded-lg shadow-md p-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            className: "flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col items-center justify-center pt-5 pb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Upload), {
                                            className: "w-10 h-10 mb-3 text-gray-400"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "mb-2 text-sm text-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-semibold",
                                                    children: "Click to upload"
                                                }),
                                                " or drag and drop"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-xs text-gray-500",
                                            children: "Text files (.txt)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "file",
                                    className: "hidden",
                                    accept: ".txt",
                                    onChange: handleFileChange
                                })
                            ]
                        }),
                        textFile && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mt-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex items-center justify-between bg-gray-100 p-4 rounded-lg",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center space-x-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileText), {
                                                className: "w-5 h-5 text-gray-600"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-sm font-medium text-gray-700 truncate",
                                                children: textFile.name
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mt-4 p-4 bg-gray-50 border border-gray-300 rounded-lg overflow-auto max-h-64",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                        className: "text-sm text-gray-700 whitespace-pre-wrap",
                                        children: typeof transcript === 'string' ? transcript : ''
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","lucide-react":"62Bzb","../AppContext":"fiPIn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iHwsN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressModal", ()=>ProgressModal);
var _jsxRuntime = require("react/jsx-runtime");
function ProgressModal({ visible, progress }) {
    if (!visible) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "bg-white p-6 rounded shadow-lg flex flex-col items-center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "loader mb-4"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-center text-lg font-medium",
                    children: progress
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jOnKa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TextView = ({ text: transcript })=>{
    const [copied, setCopied] = (0, _react.useState)(false);
    const handleCopy = ()=>{
        navigator.clipboard.writeText(transcript).then(()=>{
            setCopied(true);
            setTimeout(()=>setCopied(false), 2000); // Reset copied status after 2 seconds
        }).catch((err)=>{
            console.error("Failed to copy text: ", err);
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `flex flex-col items-center w-full h-full p-6 border border-gray-300 rounded-lg bg-gray-50 shadow-md`,
        onClick: handleCopy,
        style: {
            cursor: "pointer"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `w-full h-full overflow-y-auto p-4 border border-gray-300 rounded-md bg-white ${copied ? "ring-2 ring-green-500" : ""}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                    className: "whitespace-pre-wrap break-words text-sm font-mono text-gray-800",
                    children: transcript
                })
            }),
            copied && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "mt-2 text-xs text-green-600",
                children: "Copied to clipboard!"
            })
        ]
    });
};
exports.default = TextView;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c6iN7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _appContext = require("../AppContext");
function SettingsPanel() {
    const { openAIApiKey: openAIKey, setOpenAIApiKey: setOpenAIKey, assemblyAIApiKey, setAssemblyAIApiKey: setAssemblyAIKey } = (0, _react.useContext)((0, _appContext.AppContext));
    const [saved, setSaved] = (0, _react.useState)(false);
    const handleSave = ()=>{
        // Implement your save logic here (e.g., localStorage, API call)
        console.log('OpenAI Key:', openAIKey);
        console.log('AssemblyAI Key:', assemblyAIApiKey);
        setSaved(true);
        setTimeout(()=>setSaved(false), 2000); // Reset saved notification
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-full max-w-2xl bg-white p-6 rounded shadow-md",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "text-2xl font-bold mb-4 text-center",
                children: "\u2699\uFE0F Application Settings"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        className: "block text-gray-700 mb-1",
                        htmlFor: "assemblyAIKey",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: "AssemblyAI"
                            }),
                            " API Key"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "password",
                        id: "assemblyAIKey",
                        value: assemblyAIApiKey,
                        onChange: (e)=>setAssemblyAIKey(e.target.value),
                        className: "w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400",
                        placeholder: "Enter your AssemblyAI API key"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        className: "block text-gray-700 mb-1",
                        htmlFor: "openAIKey",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: "OpenAI"
                            }),
                            " API Key"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "password",
                        id: "openAIKey",
                        value: openAIKey,
                        onChange: (e)=>setOpenAIKey(e.target.value),
                        className: "w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400",
                        placeholder: "Enter your OpenAI API key"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: handleSave,
                className: "w-full py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition",
                children: "Save Settings"
            }),
            saved && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-4 text-green-600 font-semibold text-center",
                children: "Settings saved successfully!"
            })
        ]
    });
}
exports.default = SettingsPanel;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../AppContext":"fiPIn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dgic7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const SwitchButton = ({ index, label, active = false, disabled = false, onClick })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
        className: `flex items-center cursor-pointer space-x-2 ${disabled ? "opacity-50 cursor-not-allowed" : ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-sm",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `relative w-10 h-5 rounded-full transition-colors ${active ? "bg-blue-500" : "bg-gray-400"}`,
                onClick: ()=>{
                    if (!disabled) onClick(index, !active);
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow-md transition-transform ${active ? "transform translate-x-5" : ""}`
                })
            })
        ]
    }, index);
};
exports.default = SwitchButton;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fW8RG":[function() {},{}]},["91UBy","5pMYn"], "5pMYn", "parcelRequire94c2")

//# sourceMappingURL=index.fd0f485b.js.map
